import { GrowthBook, useFeature } from '@growthbook/growthbook-react';
import Cookies from 'universal-cookie';
import i18next from 'i18next';
import { withTranslation, useTranslation, initReactI18next, withSSR } from 'react-i18next';
import HTTPApi from 'i18next-http-backend';
import { combineReducers, compose, createStore, applyMiddleware } from 'redux';
import axios from 'axios';
import http from 'http';
import https from 'https';
import React, { memo, useCallback, useState, useEffect, createElement, createContext, useMemo, useRef, useLayoutEffect, PureComponent, useReducer, useContext, Fragment, Suspense, useImperativeHandle } from 'react';
import { useSelector, useDispatch, Provider } from 'react-redux';
import { createSelector } from 'reselect';
import { Card, Box, Sticker, Flex, Image, customStyled, Text, Button as Button$1, Checkbox, Select, Accordion, Tooltip, Modal, Input, LinearProgress, ButtonGroup, ButtonGroupItem, Carousel, Notification, Drawer, Switch, BASE_THEME, RadioGroup, RadioButton, SearchableListView, Tabs, Types, Pills, Capsule, ScrollableListView, ImageCircleContainer, CoachMarkList } from '@mafc/trolly';
export { BASE_THEME } from '@mafc/trolly';
import { variant, space, margin, padding, background, style, typography } from 'styled-system';
import { YouTube, Instagram, Twitter, Facebook, ChevronDown, Warning, Star, CloseIcon, Check, ArrowLeft, DrawerCloseIcon, MapOverlay, PonPin, UpLeftArrow, UpRightArrow, CarrefourNewLogoMobile, CarrefourNewLogo, GeorgiaFlag, KenyaFlag, KSAFlag, QatarFlag, PakistanFlag, OmanFlag, LebanonFlag, KuwaitFlag, JordanFlag, EgyptFlag, BahrainFlag, UAEFlag, CarrefourLogo, Edit, Phone, MafLogoEn, MafLogoAr, TrashAlt, Minus, Trash, Plus, Cross, Bell, NowExpressIconEn, ExpressNow, ExpressNowNew, RightArrow as RightArrow$2, HintIcon, Search as Search$2, CancelDark, WarningOctagon, InformationDark, WhatsApp, ArrowDown, ArrowDark, MinusAlt, ShareLoyalty, MyClub, User, ShopNow, QuickBuy as QuickBuy$1, BackArrow, SharePointsProfile, MyClubLogo, UserInverse, CartInverse, MagnifyGlass, AreaChangeLocationNew, FourSquares, PlusAlt, WarningAlt, Information, Telephone, SingleUsageIcon, StandardTabIcon, NowTabIcon, BusyHour, NoDelivery, PlayIcon } from '@mafc/icon';
import { useBreakpoints, usePrevious, useDfpSlot, useBambuser, useOnClickOutside, useCookieConsentScript, useInView as useInView$1, useMount } from '@mafc/hooks';
import styled from '@emotion/styled';
import { useInView } from 'react-intersection-observer';
import { useForm, Controller } from 'react-hook-form';
import { AddressMap, parseLocationCoordinates, DeliveryLocationSheet, AddressForm } from '@c4c-web/bridge-kit';
import SmartBanner from 'react-smartbanner';
import { areEqual, FixedSizeList } from 'react-window';
import memoize from 'memoize-one';
import reactIs from 'react-is';
import crypto from 'crypto';
import { animated } from 'react-spring';
import { useTheme } from 'emotion-theming';
import useInView$2 from 'react-cool-inview';
import TagManager from 'react-gtm-module';
import raf from 'raf';
import ContentLoader from 'react-content-loader';
import { css } from '@emotion/core';
import { GoogleApiWrapper, Map as Map$1 } from 'google-maps-react';
import { PhoneNumberUtil } from 'google-libphonenumber';
import Geocode from 'react-geocode';



var index = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var index$1 = Object.freeze({
    __proto__: null
});
var extendStatics$1 = function(d, b) {
    extendStatics$1 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics$1(d, b);
};
function __extends$1(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics$1(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator$1(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __values$1(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read$1(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread$1() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read$1(arguments[i]));
    return ar;
}
function __makeTemplateObject$1(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
var isServer = function () { return typeof window === 'undefined'; };
var createGrowthBookInstance = function (_a, state) {
    var features = _a.features, attributes = _a.attributes;
    var growthbook = new GrowthBook({
        trackingCallback: function (experiment, result) {
            var _a = state === null || state === void 0 ? void 0 : state.appConfig, _b = _a.userCredentials, userCredentials = _b === void 0 ? {} : _b, _c = _a.storeId, storeId = _c === void 0 ? '' : _c, _d = _a.currency, currency = _d === void 0 ? '' : _d, _e = _a.language, language = _e === void 0 ? '' : _e;
            var featureId = result.featureId, variationId = result.variationId, value = result.value;
            if (!isServer()) {
                dataLayer.push({
                    event: 'viewed_experiment',
                    feature_id: featureId,
                    experiment_key: experiment.key,
                    variation_id: variationId,
                    variation_value: value,
                    screen_type: CookieUtils.getPageType(),
                    hashed_email: CookieUtils.getCustomCookie('maf-user-id'),
                    market: storeId,
                    currency: currency,
                    logged_in_status: !!(userCredentials === null || userCredentials === void 0 ? void 0 : userCredentials.userId) || false,
                    language: language,
                });
            }
        },
    });
    growthbook.setFeatures(features);
    growthbook.setAttributes(attributes);
    return growthbook;
};
var getGrowthBookFeatureValueViaInstance = function (state, featureName) {
    var _a = ((state === null || state === void 0 ? void 0 : state.appConfig) || {}).growthBook, growthBook = _a === void 0 ? {} : _a;
    var growthbook = createGrowthBookInstance(growthBook, state);
    return growthbook.feature(featureName);
};
var growthbook_util = Object.freeze({
    __proto__: null,
    isServer: isServer,
    createGrowthBookInstance: createGrowthBookInstance,
    getGrowthBookFeatureValueViaInstance: getGrowthBookFeatureValueViaInstance
});
var isExisty = function (target) { return !isUndefined(target) && !isNull(target); };
var isNull = function (target) { return target === null || target === ''; };
var isEmptyObject = function (target) {
    if (target === void 0) { target = {}; }
    return !Object.keys(target).length;
};
var isNumber = function (target) { return typeof target === 'number' || target instanceof Number; };
var isObject = function (target) { return target === Object(target); };
var isString = function (target) { return typeof target === 'string'; };
var isBoolean = function (target) { return typeof target === 'boolean'; };
var isUndefined = function (target) { return target === undefined; };
var isNonEmptyArray = function (target) { return target && target.length > 0; };
var setDecimalPoint = function (target, decimalPoint) {
    if (decimalPoint === void 0) { decimalPoint = 2; }
    return isNumber(target) ? target.toFixed(decimalPoint) : target;
};
var getProperNoun = function (target, singularNoun, pluralNoun) {
    return target < 2 ? singularNoun : pluralNoun;
};
var countObjectProperties = function (target) { return Object.keys(target).length; };
var subsets = function (array, offset) {
    if (offset === void 0) { offset = 1; }
    var subset = [];
    var tempArray = [];
    array.forEach(function (item, index) {
        var i = index % offset;
        tempArray[i] = item;
        if ((index + 1) % offset === 0) {
            subset.push(tempArray);
            tempArray = [];
        }
        else if (index === array.length - 1 && tempArray.length > 0) {
            subset.push(tempArray);
            tempArray = [];
        }
    });
    return subset;
};
var isBrowser = function () { return typeof window !== 'undefined'; };
var qs = function (params) {
    return Object.entries(params)
        .map(function (_a) {
        var _b = __read$1(_a, 2), key = _b[0], val = _b[1];
        return key + "=" + encodeURIComponent(val);
    })
        .join('&');
};
var limitStr = function (str, n) {
    return str.length > n ? str.substr(0, n) + '...' : str;
};
var decodeStr = function (str) {
    if (str === void 0) { str = ''; }
    if (!str) {
        return '';
    }
    try {
        return decodeURIComponent(str);
    }
    catch (_a) {
        return unescape(str);
    }
};
var encodeStr = function (str) {
    if (str === void 0) { str = ''; }
    return encodeURIComponent(str);
};
var getFloorApartment = function (str, floorKey, flatKey) {
    if (str === void 0) { str = ''; }
    if (str.indexOf(floorKey) > -1) {
        return str.replace(floorKey, '').split(flatKey);
    }
    return null;
};
var getFloorFlat = function (appartment, floorKey, flatKey) {
    var data = getFloorApartment(appartment, floorKey, flatKey);
    if (data) {
        var _a = __read$1(data, 2), floor = _a[0], flat = _a[1];
        return "\n        " + (floor ? floor + "," : '') + "\n        " + (flat ? flat + "," : '') + "\n      ";
    }
    else {
        return "" + (appartment ? appartment + "," : '');
    }
};
var transformPhoneNo = function (phoneNumber, language) {
    if (phoneNumber === void 0) { phoneNumber = ''; }
    if (language === void 0) { language = ''; }
    if (!phoneNumber) {
        return '';
    }
    return language === 'ar' ? (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.slice(1)) + "+" : phoneNumber;
};
var isDefaultArea = function (areaCode, defaultAreaCode) {
    return decodeURI(areaCode || '').toLowerCase() === decodeURI(defaultAreaCode || '').toLowerCase();
};
var isEventExist = function (dataLayer, event, event_label) {
    var eventIndex = dataLayer.findIndex(function (item) { return item.event === event && item.event_label === event_label; });
    return eventIndex !== -1;
};
var isMobileDevice = function (userAgent) {
    return Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));
};
var generateUuid = function () {
    var result, i, j;
    result = '';
    for (j = 0; j < 32; j++) {
        if (j === 8 || j === 12 || j === 16 || j === 20)
            result = result + '-';
        i = Math.floor(Math.random() * 16)
            .toString(16)
            .toUpperCase();
        result = result + i;
    }
    return result;
};
var getMessagesForBusyOrOfflineScreen = function (deliverySlot) {
    var _a = deliverySlot || {}, nextAvailableSlot = _a.nextAvailableSlot, _b = _a.busyStatus, busyStatus = _b === void 0 ? {} : _b;
    var _c = nextAvailableSlot || {}, _d = _c.title, offlineTitle = _d === void 0 ? '' : _d, _e = _c.subTitle, offlineSubtitle = _e === void 0 ? '' : _e;
    var _f = busyStatus.title, busyTitle = _f === void 0 ? '' : _f, _g = busyStatus.subTitle, busySubtitle = _g === void 0 ? '' : _g;
    var _h = busyStatus.isBusy, isBusyState = _h === void 0 ? false : _h;
    return { offlineTitle: offlineTitle, offlineSubtitle: offlineSubtitle, busyTitle: busyTitle, busySubtitle: busySubtitle, isBusyState: isBusyState };
};
var renderOtherTabsText = function (pageStructure, selectedTabId, t) {
    if (selectedTabId === void 0) { selectedTabId = -1; }
    var tabLabels = pageStructure.reduce(function (acc, component) {
        if (component.title && component.id !== selectedTabId) {
            acc.push(component.title);
        }
        return acc;
    }, []);
    var tabCount = tabLabels.length;
    if (tabCount === 0) {
        return null;
    }
    var otherTabs = '';
    if (tabCount === 1) {
        otherTabs = "'" + tabLabels[0] + "'";
    }
    else if (tabCount === 2) {
        otherTabs = "'" + tabLabels[0] + "' " + t('otherTabsText.or') + " '" + tabLabels[1] + "'";
    }
    else {
        otherTabs = tabLabels
            .slice(0, -1)
            .map(function (label) { return "'" + label + "'"; })
            .join(', ') + " " + t('otherTabsText.or') + " '" + tabLabels[tabCount - 1] + "'";
    }
    return otherTabs;
};
var shouldAlwaysShowOlderAddressJourney = function () {
    if (isServer())
        return false;
    var path = window.location.pathname;
    return path.includes('/app') || path.includes('/my-account');
};
var helpers_util = Object.freeze({
    __proto__: null,
    isExisty: isExisty,
    isNull: isNull,
    isEmptyObject: isEmptyObject,
    isNumber: isNumber,
    isObject: isObject,
    isString: isString,
    isBoolean: isBoolean,
    isUndefined: isUndefined,
    isNonEmptyArray: isNonEmptyArray,
    setDecimalPoint: setDecimalPoint,
    getProperNoun: getProperNoun,
    countObjectProperties: countObjectProperties,
    subsets: subsets,
    isBrowser: isBrowser,
    qs: qs,
    limitStr: limitStr,
    decodeStr: decodeStr,
    encodeStr: encodeStr,
    getFloorApartment: getFloorApartment,
    getFloorFlat: getFloorFlat,
    transformPhoneNo: transformPhoneNo,
    isDefaultArea: isDefaultArea,
    isEventExist: isEventExist,
    isMobileDevice: isMobileDevice,
    generateUuid: generateUuid,
    getMessagesForBusyOrOfflineScreen: getMessagesForBusyOrOfflineScreen,
    renderOtherTabsText: renderOtherTabsText,
    shouldAlwaysShowOlderAddressJourney: shouldAlwaysShowOlderAddressJourney
});
var KG_VALUE = 1000;
var KG_LABEL = 'KG';
var CQtyDefault =  (function () {
    function CQtyDefault(_a) {
        var incrementBy = _a.incrementBy, soldByWeight = _a.soldByWeight, max = _a.max, min = _a.min, price = _a.price, currencyDecimal = _a.currencyDecimal;
        this.incrementBy = isUndefined(incrementBy) ? 1 : incrementBy;
        this.soldByWeight = isUndefined(soldByWeight) ? false : soldByWeight;
        this.max = isUndefined(max) ? 10 : max;
        this.min = isUndefined(min) ? 1 : min;
        this.price = isUndefined(price) ? 0 : price;
        this.currencyDecimal = currencyDecimal || 2;
    }
    return CQtyDefault;
}());
var formatQuantityKG = function (quantity, soldByWeight) {
    if (soldByWeight === void 0) { soldByWeight = false; }
    return soldByWeight ? setDecimalPoint(quantity) : quantity;
};
var convertQuantityToKG = function (quantity, soldByWeight) {
    if (soldByWeight === void 0) { soldByWeight = false; }
    return soldByWeight ? parseFloat(setDecimalPoint(quantity / KG_VALUE)) : quantity;
};
var addKGLabel = function (quantity) { return quantity + " " + KG_LABEL; };
var generateOptionObj = function (qtyRaw, soldByWeight, price, currencyDecimal) {
    if (soldByWeight === void 0) { soldByWeight = false; }
    var qty = formatQuantityKG(qtyRaw, soldByWeight);
    var value = parseFloat(qty);
    return {
        id: "qty-" + value,
        value: value,
        label: soldByWeight ? addKGLabel(qty) : qty,
        price: price ? (price * value).toFixed(currencyDecimal) : '',
    };
};
var generateQuantityList = function (params) {
    var _a = new CQtyDefault(params), incrementBy = _a.incrementBy, soldByWeight = _a.soldByWeight, _b = _a.max, max = _b === void 0 ? 10 : _b, _c = _a.min, min = _c === void 0 ? 1 : _c, price = _a.price, currencyDecimal = _a.currencyDecimal;
    var quantityList = [];
    var quantityOption = min;
    while (quantityOption <= max) {
        var optionObj = generateOptionObj(quantityOption, soldByWeight, price, currencyDecimal);
        quantityList.push(optionObj);
        quantityOption = optionObj.value + incrementBy;
        if (optionObj.value < max && quantityOption > max) {
            quantityOption = max;
        }
    }
    return quantityList;
};
var quantity_util = Object.freeze({
    __proto__: null,
    KG_LABEL: KG_LABEL,
    CQtyDefault: CQtyDefault,
    formatQuantityKG: formatQuantityKG,
    convertQuantityToKG: convertQuantityToKG,
    addKGLabel: addKGLabel,
    generateOptionObj: generateOptionObj,
    generateQuantityList: generateQuantityList
});
var E_SOLD_BY_MESSAGE_TYPE;
(function (E_SOLD_BY_MESSAGE_TYPE) {
    E_SOLD_BY_MESSAGE_TYPE["SFC"] = "SFC";
    E_SOLD_BY_MESSAGE_TYPE["SSDC"] = "SSDC";
    E_SOLD_BY_MESSAGE_TYPE["SSFS"] = "SSFS";
    E_SOLD_BY_MESSAGE_TYPE["SSFBC"] = "SSFBC";
})(E_SOLD_BY_MESSAGE_TYPE || (E_SOLD_BY_MESSAGE_TYPE = {}));
var E_TRIGGER_TYPE;
(function (E_TRIGGER_TYPE) {
    E_TRIGGER_TYPE["OPEN"] = "open";
    E_TRIGGER_TYPE["CLOSE"] = "close";
})(E_TRIGGER_TYPE || (E_TRIGGER_TYPE = {}));
var constants = {
    userToken: 'authToken',
    userId: 'userId',
    guestToken: "mafuae-cart",
    guestSessionToken: 'guest-session-token',
    guestUserID: 'anonymous',
    guidUnavailable: 'bucket-id-not-present',
    rrSessionId: 'maf-session-id',
    rrUserId: 'maf-user-id',
    deliveryArea: 'preferred-delivery-area',
    prevAreaCode: 'prevAreaCode',
    cookieBannerAcceptance: 'maf-cookie-banner-accepted',
    expressDeliveryMessage: 'expressDeliveryMessage',
    expressPos: 'expressPos',
    selectedLat: 'lat',
    selectedLng: 'long',
    refreshToken: 'refreshToken',
    hybrisTokenExpiration: 'hybrisTokenExpiration',
    expiresIn: 'expiresIn',
    hybrisToken: 'reactUserToken',
    posIds: 'posIds',
    selectedAddressID: 'selectedAddressID',
    categorySearch: 'categorySearch',
    productSearch: 'productsearch',
    product_details: 'product_details',
    category: 'category',
    refreshTokenCallTimeStamp: 'refreshTokenCallTimeStamp',
    productDetails: 'product-details',
    categoryLandingPage: 'category_landing_page',
    brandLandingPage: 'brand_landing_page',
    home: 'home',
    actionField: 'actionField',
    needhelp: 'needHelp',
    deals: 'Deals',
    quickBuy: 'Buy Again',
    packageFreeDelivery: 'pkgFreeDlvry',
    defaultAreaCode: 'web-preferred-delivery-area',
    multiLevelCarousel: 'multi_level_carousel',
    sponsoredListing: 'sponsored_listing',
    cart: 'cart',
    reOrder: 'REORDER',
    isNowJourney: 'isNowJourney',
    pageName: 'page_type',
    categoryName: 'category_name',
    noName: 'no_name',
    isExpressServiceType: 'isExpressServiceType',
    profile: 'profile',
    customerId: 'customerId',
};
var FLOOR_KEY = 'Floor#';
var FLAT_KEY = '|Flat#';
var GROWTHBOOK_FLAGS = {
    adtechCriteo: 'criteo_ad_enabled',
    adtechCriteo2ndPhase: 'criteo_ad_phase_2_enabled',
    flagshipEnabled: 'flagship_enabled',
    adtech_plp: 'adtech_plp',
    adtech_slp: 'adtech_slp',
    non_food_v2: 'dynamic_page_structure.experiment',
    listing_page: 'flutter.listing_page.enabled',
    address_new_journey: 'flutter.address_revamp.enabled',
    common_whitelisted_service_type_config: 'common.whitelisted_service_type.config',
    store_closure_enabled: 'common.store_close_services.enabled',
};
var FLAGSHIP_KEYS = {
    envKey: process.env.REACT_APP_FLAGSHIP_ENV_KEY,
    apiKey: process.env.REACT_APP_FLAGSHIP_API_KEY,
};
var getApiInfoCookie = function () { return new Cookies().get(APP_CONFIG.__cookie__.cartApiCookie) || ''; };
var getStoreInfoCookie = function () {
    return (new Cookies().get(APP_CONFIG.__cookie__.storeInfoCookieName) || '').split('|');
};
var extractStoreInfoCookieValue = function (indexPosition, propertyKey) { return APP_CONFIG.__cookie__.storeInfoCookieValue[indexPosition] || APP_CONFIG.__defaults__[propertyKey]; };
var extractCookieValue = function (key) { return new Cookies().get(key) || ''; };
var EStoreID;
(function (EStoreID) {
    EStoreID["MAFEGY"] = "mafegy";
    EStoreID["MAFJOR"] = "mafjor";
    EStoreID["MAFLBN"] = "maflbn";
    EStoreID["MAFQAT"] = "mafqat";
    EStoreID["MAFSAU"] = "mafsau";
    EStoreID["MAFUAE"] = "mafuae";
    EStoreID["MAFPAK"] = "mafpak";
    EStoreID["MAFKEN"] = "mafken";
    EStoreID["MAFBHR"] = "mafbhr";
    EStoreID["MAFOMN"] = "mafomn";
    EStoreID["MAFKWT"] = "mafkwt";
    EStoreID["MAFGEO"] = "mafgeo";
    EStoreID["MAFUZB"] = "mafuzb";
    EStoreID["MAFARM"] = "mafarm";
    EStoreID["MAFUGA"] = "mafuga";
    EStoreID["MAFIRQ"] = "mafirq";
})(EStoreID || (EStoreID = {}));
var APP_CONFIG = {
    __defaults__: {
        currency: 'AED',
        language: '',
        storeId: 'mafuae',
    },
    config: {},
    __inialize__: function (config) {
        this.current = config;
    },
    __cookie__: {
        cartApiCookie: 'cart_api',
        get appInfoCookieValue() {
            return getApiInfoCookie();
        },
        storeInfoCookieName: 'storeInfo',
        posListCookieName: 'posIds',
        get storeInfoCookieValue() {
            return getStoreInfoCookie();
        },
    },
    get isPolygonChange() {
        return this.config.isPolygonChange || false;
    },
    get adtech_plp() {
        return this.config.adtech_plp || false;
    },
    get: function () {
        return this.config.posInfoConfig || [''];
    },
    get adtech_slp() {
        return this.config.adtech_slp || false;
    },
    get nonFoodUIDs() {
        return this.config.nonFoodUIDs || {};
    },
    get currency() {
        return this.config.currency || extractStoreInfoCookieValue(2, 'currency');
    },
    get language() {
        return this.config.language || extractStoreInfoCookieValue(1, 'language');
    },
    get storeId() {
        return this.config.storeId || extractStoreInfoCookieValue(0, 'storeId');
    },
    get latitude() {
        return this.config.latitude || extractCookieValue(constants.selectedLat) || '';
    },
    get longitude() {
        return this.config.longitude || extractCookieValue(constants.selectedLng) || '';
    },
    get sessionId() {
        return this.config.sessionId || extractCookieValue(constants.rrSessionId);
    },
    get areaCode() {
        return this.config.areaCode || extractCookieValue(this.storeId + "-" + constants.deliveryArea);
    },
    get userId() {
        return this.config.userId || extractCookieValue(constants.userId);
    },
    get expressDeliveryMessage() {
        return this.config.expressDeliveryMessage || extractCookieValue(constants.expressDeliveryMessage);
    },
    get expressPos() {
        return this.config.expressPos || extractCookieValue(constants.expressPos);
    },
    get isLBN() {
        return APP_CONFIG.storeId === EStoreID.MAFLBN;
    },
    set current(config) {
        this.config = config;
    },
    get customerCareNumber() {
        return this.config.customerCareNumber || '';
    },
    get isNewEndpoint() {
        return this.__cookie__.appInfoCookieValue === 'v2' ? true : false;
    },
    get decimalPlaces() {
        return this.storeId === EStoreID.MAFBHR || this.storeId === EStoreID.MAFKWT ? 3 : 2;
    },
    userCredentials: {},
    get pageName() {
        return this.config.pageName || extractCookieValue(constants.pageName) || '';
    },
};
var prettifyPrice = function (target) {
    var _a = __read$1(target.toFixed(APP_CONFIG.decimalPlaces).split('.'), 2), wholeNum = _a[0], decimalNum = _a[1];
    return APP_CONFIG.isLBN
        ? Number(wholeNum).toLocaleString() + " "
        : Number(wholeNum).toLocaleString() + "." + decimalNum;
};
var getFormattedPrice = function (_a, showPerKG) {
    var value = _a.value, _b = _a.currencyIso, currencyIso = _b === void 0 ? '' : _b, soldByWeight = _a.soldByWeight;
    if (showPerKG === void 0) { showPerKG = false; }
    return (prettifyPrice(value) + " " + currencyIso + (showPerKG && soldByWeight ? "/" + KG_LABEL : '')).trim();
};
var getWasPrice = function (price) {
    var discountPrice = price.discountPrice, finalPrice = price.finalPrice, originalPrice = price.originalPrice, value = price.value;
    if (discountPrice && originalPrice && originalPrice.value !== value) {
        return getFormattedPrice(originalPrice);
    }
    if (finalPrice && finalPrice.value !== value) {
        return getFormattedPrice(finalPrice);
    }
    return null;
};
var price_util = Object.freeze({
    __proto__: null,
    prettifyPrice: prettifyPrice,
    getFormattedPrice: getFormattedPrice,
    getWasPrice: getWasPrice
});
var hydrateCustomMemory = function () {
    var memorySnapshot = {};
    return memorySnapshot;
};
var customMemory = hydrateCustomMemory();
function initStorageManager(targetStorage) {
    var isCompatible = function (candidateStorage) {
        try {
            var testKeyString = '__test_custom_storage_key__';
            candidateStorage.setItem(testKeyString, testKeyString);
            candidateStorage.removeItem(testKeyString);
            return true;
        }
        catch (e) {
            return false;
        }
    };
    var storage = targetStorage();
    var isStorageCompatible = isCompatible(storage);
    var getItem = function (itemKey) {
        if (isStorageCompatible) {
            var stringified = storage.getItem(itemKey);
            var parsed = stringified ? JSON.parse(stringified) : null;
            return parsed;
        }
        if (customMemory.hasOwnProperty(itemKey)) {
            return customMemory[itemKey];
        }
        return null;
    };
    var setItem = function (itemKey, value) {
        if (isStorageCompatible) {
            var stringify = JSON === null || JSON === void 0 ? void 0 : JSON.stringify(value);
            storage.setItem(itemKey, stringify);
        }
        else {
            customMemory[itemKey] = String(value);
        }
    };
    var removeItem = function (itemKey) {
        if (isStorageCompatible) {
            storage.removeItem(itemKey);
        }
        else {
            delete customMemory[itemKey];
        }
    };
    var clear = function () {
        if (isStorageCompatible) {
            storage.clear();
        }
        else {
            customMemory = {};
        }
    };
    return {
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem,
        clear: clear,
    };
}
var customStorage_util = Object.freeze({
    __proto__: null,
    initStorageManager: initStorageManager
});
var EApiActionTypes;
(function (EApiActionTypes) {
    EApiActionTypes["API"] = "API";
    EApiActionTypes["API_ERROR"] = "API_ERROR";
    EApiActionTypes["ACCESS_DENIED"] = "ACCESS_DENIED";
    EApiActionTypes["API_START"] = "_START";
    EApiActionTypes["API_END"] = "_END";
    EApiActionTypes["API_SUCCESS"] = "_SUCCESS";
    EApiActionTypes["API_FAIL"] = "_FAIL";
})(EApiActionTypes || (EApiActionTypes = {}));
var EApiActionTypes$1 = EApiActionTypes;
var UserTypes;
(function (UserTypes) {
    UserTypes["USER_SET_SELECTED_ADDRESSES"] = "USER/USER_SET_SELECTED_ADDRESSES";
    UserTypes["USER_SET_ADDRESS_CHANGE"] = "USER/USER_SET_ADDRESS_CHANGE";
    UserTypes["USER_SET_ADDRESSES_LOADING"] = "USER/SET_ADDRESSES_LOADING";
    UserTypes["USER_SET_ADDRESSES_ERROR"] = "USER/SET_ADDRESSES_ERROR";
    UserTypes["USER_GET_DATA"] = "USER/GET_DATA";
    UserTypes["USER_GET_LOYALTY_DATA"] = "USER/GET_LOYALTY_DATA";
    UserTypes["USER_GET_DATA_START"] = "USER/GET_DATA_START";
    UserTypes["USER_GET_DATA_END"] = "USER/GET_DATA_END";
    UserTypes["USER_GET_LOYALTY_DATA_SUCCESS"] = "USER/GET_LOYALTY_DATA_SUCCESS";
    UserTypes["USER_GET_LOYALTY_DATA_END"] = "USER/GET_LOYALTY_DATA_END";
    UserTypes["USER_FETCH_ADDRESSES"] = "USER/FETCH_ADDRESSES";
    UserTypes["USER_UPDATE_DELIVERY_ADDRESS"] = "USER/UPDATE_DELIVERY_ADDRESS";
    UserTypes["USER_UPDATE_NEWLY_ADDED_ADDRESS"] = "USER/UPDATE_NEWLY_ADDED_ADDRESS";
    UserTypes["USER_COUNTRY_CONFIG"] = "USER/USER_COUNTRY_CONFIG";
    UserTypes["USER_CHECK_AREA_SUPPORT"] = "USER/USER_CHECK_AREA_SUPPORT";
    UserTypes["USER_GET_DELIVERY_AREAS"] = "USER/USER_GET_DELIVERY_AREAS";
    UserTypes["USER_ADD_ADDRESS"] = "USER/USER_ADD_ADDRESS";
    UserTypes["USER_UPDATE_ADDRESS"] = "USER/USER_UPDATE_ADDRESS";
    UserTypes["USER_ADDRESS_PHONE_VERIFIED"] = "USER/USER_ADDRESS_PHONE_VERIFIED";
    UserTypes["USER_PROFILE_DATA"] = "USER/GET_USER_PROFILE_DATA";
    UserTypes["USER_PROFILE_DATA_SUCCESS"] = "USER/GET_USER_PROFILE_DATA_SUCCESS";
    UserTypes["USER_UPDATE_PROFILE"] = "USER/USER_UPDATE_PROFILE";
    UserTypes["USER_UPDATE_PROFILE_START"] = "USER/USER_UPDATE_PROFILE_START";
    UserTypes["USER_UPDATE_PROFILE_END"] = "USER/USER_UPDATE_PROFILE_END";
    UserTypes["USER_PROFILE_PHONE_UPDATE"] = "USER/USER_PROFILE_PHONE_UPDATE";
    UserTypes["USER_GET_PHONE_EXIST_SUCCESS"] = "USER/GET_PHONE_EXIST_SUCCESS";
    UserTypes["UPDATE_USER_CONTACT"] = "USER/UPDATE_USER_CONTACT";
    UserTypes["UPDATE_USER_CONTACT_SUCCESS"] = "USER/UPDATE_USER_CONTACT_SUCCESS";
    UserTypes["UPDATE_USER_CONTACT_ERROR"] = "USER/UPDATE_USER_CONTACT_ERROR";
    UserTypes["USER_CREATE_LOYALTY_ACCOUNT"] = "USER/USER_CREATE_LOYALTY_ACCOUNT";
    UserTypes["USER_GET_LOYALTY_SUMMARY"] = "USER/USER_GET_LOYALTY_SUMMARY";
    UserTypes["USER_GET_LOYALTY_SUMMARY_SUCCESS"] = "USER/USER_GET_LOYALTY_SUMMARY_SUCCESS";
})(UserTypes || (UserTypes = {}));
var USER_FETCH_ADDRESSES_SUCCESS = "" + UserTypes.USER_FETCH_ADDRESSES + EApiActionTypes$1.API_SUCCESS;
var USER_ADD_ADDRESS_SUCCESS = "" + UserTypes.USER_ADD_ADDRESS + EApiActionTypes$1.API_SUCCESS;
var USER_COUNTRY_CONFIG_SUCCESS = "" + UserTypes.USER_COUNTRY_CONFIG + EApiActionTypes$1.API_SUCCESS;
var USER_CHECK_AREA_SUPPORT_SUCCESS = "" + UserTypes.USER_CHECK_AREA_SUPPORT + EApiActionTypes$1.API_SUCCESS;
var USER_CHECK_AREA_SUPPORT_FAIL = "" + UserTypes.USER_CHECK_AREA_SUPPORT + EApiActionTypes$1.API_FAIL;
var USER_GET_DELIVERY_AREAS_SUCCESS = "" + UserTypes.USER_GET_DELIVERY_AREAS + EApiActionTypes$1.API_SUCCESS;
var UserTypes$1 = UserTypes;
var EApiMiddlewareMethod;
(function (EApiMiddlewareMethod) {
    EApiMiddlewareMethod["DELETE"] = "DELETE";
    EApiMiddlewareMethod["GET"] = "GET";
    EApiMiddlewareMethod["POST"] = "POST";
    EApiMiddlewareMethod["PUT"] = "PUT";
    EApiMiddlewareMethod["PATCH"] = "PATCH";
})(EApiMiddlewareMethod || (EApiMiddlewareMethod = {}));
var EApiMiddlewareMethod$1 = EApiMiddlewareMethod;
var USER_API_BASE = 'users/{{StoreId}}/{{language}}';
var CLOUDFLARE_API = process.env.BASE_PERS_HOST || '';
var APIGEE_ENDPOINT = process.env.APIGEE_ENDPOINT || '';
var HOME_BFF_BASE_URL = process.env.HOME_BFF__K8S_BASE_URL || '';
var REACT_APP_APIGEE_ENDPOINT = process.env.REACT_APP_RETAIL_SSO_BASE || '';
var BASE_URI = CLOUDFLARE_API + "/api/v1";
var BASE_URI_V2 = CLOUDFLARE_API + "/api/v2";
var BASE_URI_V4 = CLOUDFLARE_API + "/api/v4";
var BASE_URI_V5 = CLOUDFLARE_API + "/api/v5";
var BASE_RELEVANCE_PRODUCT = BASE_URI_V4 + "/relevance";
var BASE_PRODUCT_V2 = BASE_URI_V2 + "/products";
var BASE_PRODUCT_V4 = BASE_URI_V4 + "/products";
var GET_USER_COUNTRY_CONFIG = USER_API_BASE + "/switchingOfCountry?displayCurr={{Currency}}";
var CHECK_USER_COVERAGE_AREA_SUPPORT = 'polygon/{{StoreId}}/{{language}}/coverageArea/isSupported?displayCurr={{Currency}}';
var GET_USER_DELIVERY_AREAS = 'stores/{{StoreId}}/{{language}}/deliveryAreas?areaCode={{areaCode}}&displayCurr={{Currency}}';
var USER_ADDRESSES_API = 'addresses/{{StoreId}}/{{language}}';
var GET_RELEVANCE_PRODUCTS_KEYWORD = BASE_RELEVANCE_PRODUCT + "/keyword?keyword={{keyword}}&lang={{lang}}&placements={{placements}}&displayCurr={{Currency}}&areaCode={{areaCode}}&needOOSProducts={{needOOSProducts}}";
var GET_RELEVANCE_PRODUCTS_FOR_OOS_ITEM = APIGEE_ENDPOINT + "/v1/relevance/{{storeId}}/{{lang}}/products/{{id}}?placements={{placements}}&appId={{appId}}&lang={{lang}}&latitude={{latitude}}&longitude={{longitude}}&needOOSProducts=false";
var GET_RELEVANCE_PRODUCTS_KEYWORD_HOME = CLOUDFLARE_API + "/v1/relevance/mafuae/en/keyword?keyword={{keyword}}&lang={{lang}}&placements={{placements}}&areaCode={{areaCode}}";
var GET_RELEVANCE_PRODUCTS_ID = BASE_RELEVANCE_PRODUCT + "/products/{{id}}?lang={{lang}}&placements={{placements}}&displayCurr={{Currency}}&areaCode={{areaCode}}";
var GET_PRODUCTS_BY_IDS_WITH_OFFSET = BASE_PRODUCT_V2 + "?ids=[{{ids}}]&lang={{lang}}&areaCode={{areaCode}}&nextOffset={{nextPageOffset}}&displayCurr={{Currency}}";
var GET_MENU_NAVIGATION = BASE_URI + "/menu?areaCode={{areaCode}}&lang={{lang}}&displayCurr={{Currency}}";
var GET_DELIVERY_AREAS = 'stores/{{StoreId}}/{{language}}/delivery-areas?displayCurr={{Currency}}';
var SET_DELIVERY_AREA = CLOUDFLARE_API + "/api/v1/session/area/{{areaCode}}?lang={{lang}}&displayCurr={{Currency}}";
var NEW_CART_API_BASE = 'carts/{{StoreId}}/{{language}}/STANDARD';
var GET_CART_V3 = NEW_CART_API_BASE + "/getCart?areaCode={{areaCode}}&nsp={{nsp}}";
var NEW_REMOVE_FROM_CART = NEW_CART_API_BASE + "/deleteItem?isCartRequired={{isCartRequired}}&areaCode={{areaCode}}&stopCartResponse=true&displayCurr={{Currency}}&nsp={{nsp}}";
var ADD_TO_CART_V3 = NEW_CART_API_BASE + "/addItem?isCartRequired={{isCartRequired}}&areaCode={{areaCode}}&lm={{lm}}";
var UPDATE_CART_V3 = NEW_CART_API_BASE + "/updateItem?isCartRequired={{isCartRequired}}&areaCode={{areaCode}}&lm={{lm}}";
var OTP_API_BASE = "/customers/otp";
var SEND_OTP_API = "" + OTP_API_BASE;
var SEND_PHONE_CALL_OTP_API = OTP_API_BASE + "/voice-call";
var OTP_VERIFICATION_API = APIGEE_ENDPOINT + "/v3" + OTP_API_BASE + "/verification";
var GET_PRODUCTS_BY_IDS_V4 = BASE_PRODUCT_V4 + "?ids=[{{ids}}]&lang={{lang}}&areaCode={{areaCode}}&displayCurr={{Currency}}";
var GET_PRODUCTS_BY_FILTERS_V4 = BASE_URI_V5 + "/products";
var GET_NAVBAR_DELIVERY = (APIGEE_ENDPOINT ? APIGEE_ENDPOINT : REACT_APP_APIGEE_ENDPOINT) + "/v2/stores/{{storeId}}/{{language}}/deliveryTime?areacode={{areaCode}}";
var GET_NAVBAR_DELIVERY_NEW = (HOME_BFF_BASE_URL ? HOME_BFF_BASE_URL : REACT_APP_APIGEE_ENDPOINT) + "/v1/home/deliveryInfo";
var GET_HEADER = APIGEE_ENDPOINT + "/v1/frame/stores/{{storeId}}/headers";
var GET_COACHMARK_DETAILS = APIGEE_ENDPOINT + "/v1/frame/coach-marks/{{coachMarksUid}}";
var GOOGLE_MAP_API_URL = 'https://maps.googleapis.com/maps/api/geocode/json?key=' + process.env.REACT_APP_GOOGLE_MAP_API_KEY;
var GET_ADDRESS_CITIES_ZONE_AREAS = "content/address/areas?country={{code}}";
var GET_COUNTRIES_API = "unmannedstore/countryphonecodes";
var REFRESH_TOKEN_API_URL = "oauth/token?grantType=refresh_token";
var VERIFY_ADDRESS_PHONE = "users/{{StoreId}}/{{language}}/checkPhoneNumber";
var USER_PROFILE_API = "users/{{StoreId}}/{{language}}";
var CHECK_PHONE_EXISTS = "/customers/check";
var GET_WHATSAPP_OTP_API_URL = '/customers/otp/whatsapp';
var UPDATE_USER_CONTACT = APIGEE_ENDPOINT + "/v1/users/{{StoreId}}/{{language}}/contacts";
var FETCH_GROWTHBOOK = APIGEE_ENDPOINT + "/abtest/api/features/" + process.env.REACT_APP_GROWTHBOOK_API_KEY;
var CREATE_SHARE_ACCOUNT = "/customers/loyalty-membership";
var CREATE_MYCLUB_ACCOUNT = "/loyalty/{{storeId}}/{{lang}}/cards?cardExist=false";
var GET_PAGE_STRUCTURE = APIGEE_ENDPOINT + "/v1/frame/page-structures/main-page";
var GET_PAGE_STRUCTURE_V2 = APIGEE_ENDPOINT + "/v1/frame/v2/page-structures/{{pageStructureUid}}";
var TRACKING_ALGOLIA_URL = BASE_URI_V2 + "/search/reporting/{{clickType}}?pageType={{pageType}}&products=[{{products}}]&lang={{lang}}";
var ADD_TO_CART_TRACKING = "/adtech/rmp/track-event/add-to-cart";
var GET_COUNTRY_DETAILS_API = APIGEE_ENDPOINT + "/v1/frame/stores/country-details";
var UPDATE_CART_RELEVANCE = BASE_RELEVANCE_PRODUCT + "/cart/update?placements=cart_page";
var EAppConfigTypes;
(function (EAppConfigTypes) {
    EAppConfigTypes["INIT"] = "APP_CONFIG/INIT";
    EAppConfigTypes["SUCCESS"] = "APP_CONFIG/SUCCESS";
    EAppConfigTypes["SET_AREA_CODE"] = "APP_CONFIG/SET_AREA_CODE";
    EAppConfigTypes["SET_LANGUAGE_CODE"] = "APP_CONFIG/SET_LANGUAGE_CODE";
    EAppConfigTypes["REFRESH_TOKEN"] = "APP_CONFIG/REFRESH_TOKEN";
    EAppConfigTypes["REFRESH_TOKEN_SUCCESS"] = "APP_CONFIG/REFRESH_TOKEN_SUCCESS";
    EAppConfigTypes["GTM_INITIALIZED"] = "APP_CONFIG/GTM_INITIALISED";
    EAppConfigTypes["BRAZE_INITIALIZED"] = "APP_CONFIG/BRAZE_INITIALIZED";
    EAppConfigTypes["GROWTHBOOK_INITIALIZED"] = "APP_CONFIG/GROWTHBOOK_INITIALIZED";
    EAppConfigTypes["SET_PAGE_INTENT"] = "APP_CONFIG/SET_PAGE_INTENT";
    EAppConfigTypes["SET_PAGE_NAME"] = "SET_PAGE_NAME";
    EAppConfigTypes["FLAGSHIP_INITIALIZED"] = "APP_CONFIG/FLAGSHIP_INITIALIZED";
    EAppConfigTypes["SET_SELECTED_TAB"] = "SET_SELECTED_TAB";
})(EAppConfigTypes || (EAppConfigTypes = {}));
var EAppConfigTypes$1 = EAppConfigTypes;
var qat = {
    en: {
        qatar: 'Qatar',
        loyaltyPoints: 'MyCLUB Pts.',
        language: 'العربية',
        languageToggle: 'English',
        smartBannerText: {
            buttonText: 'OPEN',
            discountValue: '40%',
            discountTitle: 'OFF your first order',
            subtitle1: 'Use code: ',
            subtitle2: ', On orders above 75 QAR.',
            subtitle3: ' Max disc',
            code: 'HEY40',
            discCode: ' 30 QAR',
        },
    },
    ar: {
        qatar: 'نعم',
        loyaltyPoints: 'MyCLUB Pts.',
        language: 'English',
        languageToggle: 'العربية',
        smartBannerText: {
            buttonText: 'افتح',
            discountValue: 'وفــّر 40%',
            discountTitle: 'على طلبك الأول',
            subtitle1: 'استخدم الرمز: ',
            subtitle2: ' للطلبات التي تزيد عن 75 ريال.',
            subtitle3: ' الحد الأقصى للتوفير',
            code: 'HEY40',
            discCode: ' 30 ريال',
        },
    },
};
var uae = {
    en: {
        loyalty: 'SHARE',
        points: '$t(loyalty) Points',
        loyaltyPoints: '$t(loyalty) pts.',
        smartBannerText: {
            buttonText: 'OPEN',
            discountValue: '40% OFF',
            discountTitle: 'your first order',
            subtitle1: 'Use code: ',
            subtitle2: ', on orders above 75 AED. Max disc 30 AED',
            code: 'HEY40',
        },
        language: 'العربية',
        languageToggle: 'English',
    },
    ar: {
        loyalty: 'SHARE',
        points: 'نقاط شير',
        loyaltyPoints: '$t(loyalty) pts.',
        smartBannerText: {
            buttonText: 'افتح',
            discountValue: ' ',
            discountTitle: 'خصم 40٪ على طلبك الأول',
            subtitle1: 'أستخدم الرمز:',
            subtitle2: 'على الطلبات التي تزيد عن 75 درهماً. الحد الأقصى للخصم 30 درهم',
            code: ' HEY40 ',
        },
        language: 'English',
        languageToggle: 'العربية',
    },
};
var lbn = {
    en: {
        loyalty: 'Cashback',
        points: '$t(loyalty)',
        loyaltyPoints: '$t(loyalty)',
        language: 'العربية',
        languageToggle: 'English',
    },
    ar: {
        points: 'كاشباك',
        loyalty: '$t(loyalty)',
        loyaltyPoints: '$t(loyalty)',
        language: 'English',
        languageToggle: 'العربية',
    },
};
var egy = {
    en: {
        loyaltyPoints: 'MyCLUB Pts.',
        language: 'العربية',
        languageToggle: 'English',
    },
    ar: {
        loyaltyPoints: 'MyCLUB Pts.',
        language: 'English',
        languageToggle: 'العربية',
        buyAgain: 'اشتري_مره أخري',
        Quick: 'سريعا',
        expressDeliveryTitle: 'منتجات تصلك في ساعة',
        expressDeliverySubTitle: 'اشتري',
        footer: {
            extendedWarrantyRetail: 'الضمان الممتد',
        },
    },
};
var jor = {
    en: {
        loyaltyPoints: 'MyCLUB Pts.',
        language: 'العربية',
        languageToggle: 'English',
    },
    ar: {
        loyaltyPoints: 'MyCLUB Pts.',
        language: 'English',
        languageToggle: 'العربية',
        expressDeliveryTitle: 'منتجات للتوصيل',
        expressDeliverySubTitle: 'خلال 60 دقيقة',
    },
};
var sau = {
    en: {
        loyaltyPoints: 'MyCLUB Pts.',
        smartBannerText: {
            buttonText: 'OPEN',
            discountValue: '30%',
            discountTitle: 'OFF your first order',
            subtitle1: 'USE code: ',
            subtitle2: ', on orders above 50 SAR',
            subtitle3: ' Max disc',
            code: 'NEW30',
            discCode: ' 30 SAR',
        },
        language: 'العربية',
        languageToggle: 'English',
        authenticationCode: 'Authentication code 0000123973',
    },
    ar: {
        loyaltyPoints: 'MyCLUB Pts.',
        smartBannerText: {
            buttonText: 'افتح',
            discountValue: 'وفــّر 30%',
            discountTitle: 'على طلبك الأول',
            subtitle1: 'أستخدم الرمز: ',
            subtitle2: ' للطلبات التي تزيد عن 50 ريال',
            subtitle3: ' الحد الأعلى للتوفير',
            code: 'NEW30',
            discCode: ' 30 ريال',
        },
        language: 'English',
        languageToggle: 'العربية',
        authenticationCode: 'رمز التحقق: 0000123973',
    },
};
var geo = {
    en: {
        language: 'ინგლისური',
        languageToggle: 'English',
    },
    ka: {
        language: 'English',
        languageToggle: 'ინგლისური',
    },
};
var kwt = {
    en: {
        language: 'العربية',
        languageToggle: 'English',
    },
    ar: {
        language: 'English',
        languageToggle: 'العربية',
    },
};
var uzb = {
    en: {
        language: "o'zbekcha",
        languageToggle: 'English',
    },
    uz: {
        language: 'English',
        languageToggle: "o'zbekcha",
    },
    ru: {
        language: 'English',
        languageToggle: 'русский',
    },
};
var countries = {
    qat: qat,
    uae: uae,
    lbn: lbn,
    egy: egy,
    jor: jor,
    sau: sau,
    geo: geo,
    kwt: kwt,
    uzb: uzb,
};
var _a;
var commonLanguages = ['en', 'ar'];
var SUPPORTED_LANGUAGES = (_a = {},
    _a[EStoreID.MAFUAE] = commonLanguages,
    _a[EStoreID.MAFBHR] = commonLanguages,
    _a[EStoreID.MAFEGY] = commonLanguages,
    _a[EStoreID.MAFJOR] = commonLanguages,
    _a[EStoreID.MAFGEO] = ['en', 'ka'],
    _a[EStoreID.MAFPAK] = ['en'],
    _a[EStoreID.MAFKWT] = commonLanguages,
    _a[EStoreID.MAFOMN] = commonLanguages,
    _a[EStoreID.MAFLBN] = ['en'],
    _a[EStoreID.MAFKEN] = ['en'],
    _a[EStoreID.MAFQAT] = commonLanguages,
    _a[EStoreID.MAFSAU] = commonLanguages,
    _a[EStoreID.MAFUZB] = ['en', 'uz', 'ru'],
    _a[EStoreID.MAFARM] = ['en', 'hy'],
    _a[EStoreID.MAFUGA] = ['en'],
    _a[EStoreID.MAFIRQ] = commonLanguages,
    _a);
var EN = 'en';
var AR = 'ar';
var getBrowserLanguage = function () {
    return APP_CONFIG.language;
};
var commonOption = {
    lng: getBrowserLanguage(),
    fallbackLng: EN,
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
        escapeValue: false,
    },
    react: {
        wait: true,
    },
};
var isRTL = function () { return i18next.language === 'ar'; };
var languageSettings = function (lang) {
    if (isBrowser()) {
        window.document.dir = lang === AR ? 'rtl' : 'ltr';
        localStorage.setItem('language', lang);
    }
};
var setLanguage = function (lang) {
    i18next.changeLanguage(lang);
    languageSettings(lang);
};
var isLocaleStrEqual = function (first, second) {
    var collator = new Intl.Collator(i18next.language);
    var order = collator.compare(first, second);
    if (!order) {
        return true;
    }
    else {
        return false;
    }
};
var initApp = function (payload) {
    if (payload === void 0) { payload = {}; }
    return function (dispatch) { return __awaiter$1(void 0, void 0, void 0, function () {
        var latitude, longitude, areaCode;
        return __generator$1(this, function (_a) {
            latitude = payload.latitude, longitude = payload.longitude, areaCode = payload.areaCode;
            dispatch(init({ selectNewLocation: false }));
            if (isBrowser()) {
                setSelectedLat(latitude);
                setSelectedLng(longitude);
                setDeliveryArea(encodeStr(areaCode));
                setCustomCookie(constants.prevAreaCode, encodeStr(areaCode));
            }
            dispatch(init({ latitude: latitude, longitude: longitude, areaCode: areaCode }));
            if (isBrowser()) {
                if (window.innerWidth < 767) {
                    window.location.reload();
                }
                dispatch(userSetAddressChange(true));
            }
            return [2 ];
        });
    }); };
};
var init = function (payload) {
    if (payload === void 0) { payload = {}; }
    APP_CONFIG.__inialize__(payload);
    return {
        type: EAppConfigTypes$1.SUCCESS,
        payload: payload,
    };
};
var setAreaCode = function (areaCode) {
    APP_CONFIG.current = __assign$1(__assign$1({}, APP_CONFIG), { areaCode: areaCode });
    return {
        type: EAppConfigTypes$1.SET_AREA_CODE,
        payload: areaCode,
    };
};
var setLanguageCode = function (language) {
    APP_CONFIG.__defaults__.language = language;
    APP_CONFIG.current = __assign$1(__assign$1({}, APP_CONFIG), { language: language });
    setLanguage(language);
    return {
        type: EAppConfigTypes$1.SET_LANGUAGE_CODE,
        payload: language,
    };
};
var setCurrency = function (currency) {
    APP_CONFIG.current = __assign$1(__assign$1({}, APP_CONFIG), { currency: currency });
    return {
        type: EAppConfigTypes$1.SUCCESS,
        payload: { currency: currency },
    };
};
var userSetAddressesSuccess = function (_a) {
    var addresses = _a.addresses, defaultAreaCode = _a.defaultAreaCode;
    return ({
        type: USER_FETCH_ADDRESSES_SUCCESS,
        payload: { addresses: addresses, defaultAreaCode: defaultAreaCode },
    });
};
var userSetAddressesError = function (isError) { return ({
    type: UserTypes$1.USER_SET_ADDRESSES_ERROR,
    payload: isError,
}); };
var userSetAddressesLoading = function (state) { return ({
    type: UserTypes$1.USER_SET_ADDRESSES_LOADING,
    payload: state,
}); };
var userSetSelectedAddress = function (address) { return ({
    type: UserTypes$1.USER_SET_SELECTED_ADDRESSES,
    payload: address,
}); };
var userSetAddressChange = function (payload) { return ({
    type: UserTypes$1.USER_SET_ADDRESS_CHANGE,
    payload: payload,
}); };
var showNewAddressJourney = function (addressNewJourney) {
    var showOldAddressJourney = shouldAlwaysShowOlderAddressJourney();
    return showOldAddressJourney ? false : addressNewJourney;
};
var fetchUserAddresses = function () { return function (dispatch, getState) {
    var _a;
    dispatch(userSetAddressesLoading(true));
    dispatch(userSetAddressesError(false));
    var _b = getState().appConfig.defaultAreaCode, defaultAreaCode = _b === void 0 ? '' : _b;
    var addressNewJourney = (_a = getGrowthBookFeatureValueViaInstance(getState(), GROWTHBOOK_FLAGS.address_new_journey)) === null || _a === void 0 ? void 0 : _a.on;
    var showUnverfiiedAddresses = showNewAddressJourney(addressNewJourney);
    var url = USER_ADDRESSES_API + '?displayCurr={{Currency}}' + '&includeUnverifiedAddresses=' + showUnverfiiedAddresses;
    dispatch({
        type: UserTypes$1.USER_FETCH_ADDRESSES,
        payload: {
            method: EApiMiddlewareMethod$1.GET,
            url: url,
            onSuccess: function (_a) {
                var addresses = _a.addresses;
                dispatch(userSetAddressesSuccess({ addresses: addresses, defaultAreaCode: defaultAreaCode }));
            },
            onFailure: function () {
                dispatch(userSetAddressesError(true));
            },
            onFinally: function () {
                dispatch(userSetAddressesLoading(false));
            },
        },
    });
}; };
var fetchUserCountryConfig = function () { return function (dispatch) {
    dispatch({
        type: UserTypes$1.USER_COUNTRY_CONFIG,
        payload: {
            method: EApiMiddlewareMethod$1.GET,
            url: GET_USER_COUNTRY_CONFIG,
            apiVersion: 1,
            excludeFromDefaultHeaders: ['token'],
        },
    });
}; };
var fetchUserDeliveryAreas = function () { return function (dispatch) {
    dispatch({
        type: UserTypes$1.USER_GET_DELIVERY_AREAS,
        payload: {
            method: EApiMiddlewareMethod$1.GET,
            url: GET_USER_DELIVERY_AREAS,
        },
    });
}; };
var getBuilding = function (building) {
    if (building != null) {
        var buildingValue = building === null || building === void 0 ? void 0 : building.replace('|', ':');
        var buildingList = buildingValue === null || buildingValue === void 0 ? void 0 : buildingValue.split(':');
        if (buildingList != null && buildingList.length >= 2) {
            return buildingList[0];
        }
        else {
            return building;
        }
    }
    else {
        return building;
    }
};
var getApartment = function (apartment) {
    if (apartment != null) {
        var apartmentValue = apartment === null || apartment === void 0 ? void 0 : apartment.replace('|', ':');
        var apartmentList = apartmentValue.split(':');
        if (apartmentList != null && apartmentList.length >= 2) {
            return apartmentList[1].replace('Flat#', '');
        }
        else {
            return apartment;
        }
    }
    else {
        return apartment;
    }
};
var setLocationCXDetail = function (addressData) { return function (dispatch) {
    var _a = addressData || {}, latitude = _a.latitude, longitude = _a.longitude;
    var lat = Number(latitude);
    var long = Number(longitude);
    if (!isNaN(lat) && !isNaN(long)) {
        var _b = addressData || {}, addressLabel = _b.addressLabel, building = _b.building, appartment = _b.appartment;
        var address = [addressLabel, getBuilding(building), getApartment(appartment)].filter(function (ele) { return ele; }).join(' - ');
        dispatch(updateGeoArea(address || '', lat, long));
    }
}; };
var updateGeoArea = function (address, latitude, longitude) { return function (dispatch) {
    dispatch(initApp({ latitude: latitude, longitude: longitude, features: { isLocationCXEnable: true }, areaCode: address }));
}; };
var checkUserCoverageAreaSupport = function (lat, lng) { return function (dispatch) {
    dispatch({
        type: UserTypes$1.USER_CHECK_AREA_SUPPORT,
        payload: {
            method: EApiMiddlewareMethod$1.GET,
            url: CHECK_USER_COVERAGE_AREA_SUPPORT + "&latitude=" + lat + "&longitude=" + lng,
            apiVersion: 1,
        },
    });
}; };
var userAddNEditAddress = function (address, editInfo, setIsSubmitBtnDisabled) { return function (dispatch) {
    var appartment = address.appartment, landmark = address.landmark, addressLabel = address.addressLabel, fullName = address.fullName, phone = address.phone, defaultAddress = address.defaultAddress, countryIso = address.countryIso, areaCode = address.areaCode, onSuccess = address.onSuccess, latitude = address.latitude, longitude = address.longitude, deliveryInstructions = address.deliveryInstructions, streetName = address.streetName, town = address.town, country = address.country, building = address.building, addressVerificationRefId = address.addressVerificationRefId, isSetSelectedAddress = address.isSetSelectedAddress, makani = address.makani, emirate = address.emirate, isQatarAddressFields = address.isQatarAddressFields, isUAEAddressFields = address.isUAEAddressFields;
    var params = {
        appartment: appartment,
        landmark: landmark || '',
        firstName: fullName,
        phone: phone,
        town: town || areaCode,
        'country.isocode': country || countryIso,
        streetName: streetName,
        emirate: emirate,
        defaultAddress: defaultAddress,
        shippingAddress: true,
        latitude: latitude,
        longitude: longitude,
        deliveryInstructions: deliveryInstructions,
        building: building,
    };
    if (editInfo) {
        params.ssoType = editInfo.ssoType;
    }
    if (addressLabel) {
        params.addressLabel = addressLabel;
    }
    if (addressVerificationRefId) {
        params.addressVerificationRefId = addressVerificationRefId;
    }
    if (isQatarAddressFields || isUAEAddressFields) {
        params.makani = makani;
    }
    dispatch({
        type: editInfo ? UserTypes$1.USER_UPDATE_ADDRESS : UserTypes$1.USER_ADD_ADDRESS,
        payload: {
            data: qs(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            },
            method: editInfo ? EApiMiddlewareMethod$1.PUT : EApiMiddlewareMethod$1.POST,
            onSuccess: function (apiResponse) {
                params.id = (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) || (apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.id);
                onSuccess && onSuccess(params);
                if (isSetSelectedAddress || defaultAddress) {
                    setSelectedAddressID(params.id);
                    setSelectedAddressIDCookie(params.id);
                    dispatch(userSetSelectedAddress(params));
                }
                if (defaultAddress) {
                    dispatch(setLocationCXDetail(params));
                }
                dispatch(fetchUserAddresses());
            },
            onFailure: function () {
                dispatch(userSetAddressesError(true));
                setIsSubmitBtnDisabled && setIsSubmitBtnDisabled(false);
            },
            url: editInfo
                ? USER_ADDRESSES_API + ("/" + editInfo.id + "?displayCurr={{Currency}}")
                : USER_ADDRESSES_API + '?displayCurr={{Currency}}',
        },
    });
}; };
var userAddNEditAddressWithArea = function (address, editInfo) { return function (dispatch) {
    var appartment = address.appartment, landmark = address.landmark, addressLabel = address.addressLabel, fullName = address.fullName, phone = address.phone, defaultAddress = address.defaultAddress, onSuccess = address.onSuccess, streetName = address.streetName, area = address.area, city = address.city, addressVerificationRefId = address.addressVerificationRefId, deliveryInstructions = address.deliveryInstructions, emirate = address.emirate, building = address.building, zone = address.zone, isQatarAddressFields = address.isQatarAddressFields;
    var params = {
        firstName: fullName,
        lastName: '',
        phone: phone,
        town: area.code,
        'country.isocode': city.countryIso,
        'region.isocode': city.isocode,
        streetName: streetName,
        emirate: emirate,
        appartment: appartment,
        landmark: landmark || '',
        defaultAddress: defaultAddress,
        shippingAddress: true,
        deliveryInstructions: deliveryInstructions,
        building: building,
    };
    if (addressVerificationRefId) {
        params.addressVerificationRefId = addressVerificationRefId;
    }
    if (editInfo) {
        params.ssoType = editInfo.ssoType;
    }
    if (isQatarAddressFields) {
        params.makani = zone.zoneNo;
    }
    if (addressLabel) {
        params.addressLabel = addressLabel;
    }
    dispatch({
        type: editInfo ? UserTypes$1.USER_UPDATE_ADDRESS : UserTypes$1.USER_ADD_ADDRESS,
        payload: {
            data: qs(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            },
            method: editInfo ? EApiMiddlewareMethod$1.PUT : EApiMiddlewareMethod$1.POST,
            onSuccess: function (apiResponse) {
                params.id = (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) || (apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.id);
                onSuccess && onSuccess(params);
                if (defaultAddress && apiResponse && apiResponse.id) {
                    setSelectedAddressID(apiResponse.id);
                    setSelectedAddressIDCookie(apiResponse.id);
                    dispatch(userSetSelectedAddress(apiResponse));
                }
                dispatch(fetchUserAddresses());
            },
            onFailure: function () {
                dispatch(userSetAddressesError(true));
            },
            url: editInfo
                ? USER_ADDRESSES_API + ("/" + editInfo.id + "?displayCurr={{Currency}}")
                : USER_ADDRESSES_API + '?displayCurr={{Currency}}',
        },
    });
}; };
var userAddressPhoneVerify = function (phoneNumber, callback) { return function (dispatch) {
    dispatch({
        type: UserTypes$1.USER_ADDRESS_PHONE_VERIFIED,
        payload: {
            data: { phoneNumber: phoneNumber },
            method: EApiMiddlewareMethod$1.POST,
            headers: {
                'Content-Type': 'application/json',
            },
            onSuccess: function (apiResponse) {
                callback && callback(apiResponse);
            },
            onFailure: function () {
                callback && callback(false);
            },
            url: VERIFY_ADDRESS_PHONE,
            apiVersion: 1,
        },
    });
}; };
var userProfileUpdate = function (profile, handleResponse) { return function (dispatch) {
    dispatch({
        type: UserTypes$1.USER_UPDATE_PROFILE,
        payload: {
            data: profile,
            method: EApiMiddlewareMethod$1.PUT,
            apiVersion: 1,
            headers: {
                'Content-Type': 'application/json',
            },
            onSuccess: function (apiResponse) {
                handleResponse && handleResponse(apiResponse);
            },
            onFailure: function (_errMessage, _a) {
                var data = (_a === void 0 ? {} : _a).response.data;
                return handleResponse && handleResponse(data);
            },
            url: USER_PROFILE_API,
        },
    });
}; };
var verifyUserPhoneNumber = function (phoneNumber, handleResponse) { return function (dispatch) {
    dispatch({
        type: UserTypes$1.USER_GET_PHONE_EXIST_SUCCESS,
        payload: {
            method: EApiMiddlewareMethod$1.GET,
            onSuccess: function (apiResponse) {
                handleResponse(apiResponse);
            },
            onFailure: function (_errMessage, _a) {
                var data = (_a === void 0 ? {} : _a).response.data;
                return handleResponse(data);
            },
            url: CHECK_PHONE_EXISTS + "?phone=" + phoneNumber,
        },
    });
}; };
var updateUserContact = function (number, handleResponse) { return function (dispatch) {
    dispatch({
        type: UserTypes$1.UPDATE_USER_CONTACT,
        payload: {
            apiVersion: 1,
            data: { number: number },
            method: EApiMiddlewareMethod$1.PATCH,
            onSuccess: function (apiResponse) {
                handleResponse(apiResponse);
            },
            onFailure: function (_errMessage, _a) {
                var data = _a.response.data;
                return handleResponse(data);
            },
            url: UPDATE_USER_CONTACT,
        },
    });
}; };
var createLoyaltyAccount = function (data, type) { return function (dispatch) {
    dispatch({
        type: UserTypes$1.USER_CREATE_LOYALTY_ACCOUNT,
        payload: {
            data: data,
            method: EApiMiddlewareMethod$1.POST,
            apiVersion: type === 'share' ? 2 : 1,
            headers: {
                'Content-Type': 'application/json',
            },
            url: type === 'share' ? CREATE_SHARE_ACCOUNT : CREATE_MYCLUB_ACCOUNT,
        },
    });
}; };
var refreshToken = function (onSuccess) { return function (dispatch) {
    dispatch({
        type: EAppConfigTypes$1.REFRESH_TOKEN,
        payload: {
            data: {
                refreshToken: getRefreshTokenFromCookie(),
                loginType: 'normal',
            },
            method: EApiMiddlewareMethod$1.POST,
            url: REFRESH_TOKEN_API_URL,
            onSuccess: function (apiResponse) {
                onSuccess && onSuccess(apiResponse);
            },
        },
    });
}; };
var cookies = new Cookies();
var DeliveryHeaders;
(function (DeliveryHeaders) {
    DeliveryHeaders["POS_INFO"] = "posInfo";
})(DeliveryHeaders || (DeliveryHeaders = {}));
var setAppVersion = function (version) {
    if (version === void 0) { version = 'v1'; }
    return cookies.set('app_version', version, { path: '/' });
};
var getAppVersion = function () {
    return cookies.get('app_version');
};
var getUserTokenFromCookie = function () {
    return cookies.get(constants.userToken) || cookies.get(constants.hybrisToken);
};
var getUserEmailFromCookie = function () {
    var emailID = cookies.get(constants.userId);
    if (emailID && emailID.length > 0) {
        return emailID.toLowerCase();
    }
    return emailID;
};
var getGUID = function () {
    return cookies.get(APP_CONFIG.storeId + "-cart");
};
var setGUID = function (guid) {
    return cookies.set(APP_CONFIG.storeId + "-cart", guid, {
        path: '/',
        maxAge: 360000000,
        secure: true,
    });
};
var getRefreshTokenFromCookie = function () {
    return cookies.get(constants.refreshToken);
};
var removeGUIDFromCookie = function () {
    cookies.remove(APP_CONFIG.storeId + "-cart");
};
var getGuestSessionToken = function () {
    return cookies.get(constants.guestSessionToken);
};
var setSearchTypeCookie = function (searchType) {
    cookies.set('search_type', searchType, { path: '/' });
};
var setSelectedAddressID = function (addressID) {
    isBrowser() && localStorage.setItem(constants.selectedAddressID, addressID);
};
var getSelectedAddressID = function () {
    return isBrowser() && localStorage.getItem(constants.selectedAddressID);
};
var setSelectedAddressIDCookie = function (addressID) {
    return cookies.set(constants.selectedAddressID, addressID, { path: '/' });
};
var getSelectedAddressIDCookie = function () {
    return cookies.get(constants.selectedAddressID);
};
var setRefreshTokenCallTime = function () {
    isBrowser() && localStorage.setItem(constants.refreshTokenCallTimeStamp, Date.now().toString());
};
var getRefreshTokenCallTime = function () {
    return isBrowser() && localStorage.getItem(constants.refreshTokenCallTimeStamp);
};
var getSearchTypeCookie = function () {
    return cookies.get('search_type');
};
var setPageType = function (pageType) {
    return cookies.set('page_type', pageType, { path: '/' });
};
var getPageType = function () {
    return cookies.get('page_type');
};
var setCategoryName = function (category) {
    return cookies.set(constants.categoryName, category, { path: '/' });
};
var getCategoryName = function () {
    return cookies.get(constants.categoryName);
};
var setGuestSessionToken = function (token, expiresIn) {
    return cookies.set(constants.guestSessionToken, token, { maxAge: expiresIn, path: '/' });
};
var setUserTokenFromCookie = function (token) {
    return cookies.set(constants.userToken, token, { path: '/' });
};
var removeCookie = function (cookieName) {
    cookies.remove(cookieName);
};
var setRRSessionId = function (value, expiry) {
    setCustomCookie(constants.rrSessionId, value, expiry);
};
var setRRUserId = function (value, expiry) {
    setCustomCookie(constants.rrUserId, value, expiry);
};
var setDeliveryArea = function (value, expiry) {
    var getAddressText = value.split('-');
    var deliveryArea = getAddressText[0] + "-" + getBuilding(getAddressText[1]) + " - " + getApartment(getAddressText[2]);
    setCustomCookie(APP_CONFIG.storeId + "-" + constants.deliveryArea, deliveryArea, expiry);
};
var getRRSessionId = function () {
    return cookies.get(constants.rrSessionId);
};
var getRRUserId = function () {
    return cookies.get(constants.rrUserId);
};
var getDeliveryArea = function () {
    return cookies.get(APP_CONFIG.storeId + "-" + constants.deliveryArea);
};
var setSelectedLat = function (seletedLat, expiresIn) {
    if (expiresIn === void 0) { expiresIn = 2630000; }
    return cookies.set(constants.selectedLat, seletedLat, { maxAge: expiresIn, path: '/' });
};
var setSelectedLng = function (seletedLng, expiresIn) {
    if (expiresIn === void 0) { expiresIn = 2630000; }
    return cookies.set(constants.selectedLng, seletedLng, { maxAge: expiresIn, path: '/' });
};
var getSelectedLat = function () {
    return cookies.get(constants.selectedLat);
};
var getSelectedLng = function () {
    return cookies.get(constants.selectedLng);
};
var setPackageFreeDelivery = function (data, expiresIn) {
    if (expiresIn === void 0) { expiresIn = 2630000; }
    return cookies.set(constants.packageFreeDelivery, data, { maxAge: expiresIn, path: '/' });
};
var getPackageFreeDelivery = function () {
    return cookies.get(constants.packageFreeDelivery);
};
var removeLocalStorage = function (key) {
    isBrowser() && localStorage.removeItem(key);
};
var setStoreInfoCookie = function (_a) {
    var storeId = _a.storeId, language = _a.language, currency = _a.currency;
    return cookies.set('storeInfo', (storeId || APP_CONFIG.storeId) + "|" + (language || APP_CONFIG.language) + "|" + (currency || APP_CONFIG.currency), {
        path: '/',
        maxAge: 2630000,
        encode: function (value) { return value; },
    });
};
var getCustomCookie = function (key) { return cookies.get(key); };
var setCustomCookie = function (key, value, expiry) {
    if (expiry === void 0) { expiry = 86400; }
    return cookies.set(key, value, { path: '/', maxAge: expiry, encode: function (value) { return value; } });
};
var removeCookies = function (params) {
    params.forEach(function (cookieName) {
        cookies.remove(cookieName);
    });
};
var setNowJourneyCookie = function () {
    return cookies.set(constants.isNowJourney, true, { path: '/', maxAge: 31536000 });
};
var getNowJourneyCookie = function () {
    return cookies.get(constants.isNowJourney);
};
var removeNowJourneyCookie = function () {
    return cookies.set(constants.isNowJourney, false, { path: '/', maxAge: 0 });
};
var removeDeliveryAreaInfoCookie = function (ssrCookie) {
    var cookie = ssrCookie || cookies;
    cookie.set(DeliveryHeaders.POS_INFO, '', { path: '/', maxAge: 0, httpOnly: false });
};
var getPosInfo = function (deliveryAreaInfo) {
    var posInfo = '';
    deliveryAreaInfo === null || deliveryAreaInfo === void 0 ? void 0 : deliveryAreaInfo.forEach(function (item, index) {
        var isComma = index < deliveryAreaInfo.length - 1;
        posInfo += item.serviceType + "=" + item.pos + "_" + item.identifier;
        if (isComma) {
            posInfo += ',';
        }
    });
    return posInfo;
};
var setDeliveryAreaInfo = function (deliveryAreaInfo, ssrCookie) {
    var cookie = ssrCookie || cookies;
    var posInfo = getPosInfo(deliveryAreaInfo);
    cookie.set(DeliveryHeaders.POS_INFO, posInfo, {
        path: '/',
        maxAge: 3600000000,
        httpOnly: false,
        encode: function (value) { return value; },
    });
};
var setDeliveryAreaInHeaders = function (deliveryAreaInfo) {
    var extraHeaders = {};
    var posInfo = getPosInfo(deliveryAreaInfo);
    if (posInfo.length) {
        extraHeaders.posInfo = posInfo;
        return extraHeaders;
    }
    if (cookies.get(DeliveryHeaders.POS_INFO)) {
        extraHeaders.posInfo = cookies.get(DeliveryHeaders.POS_INFO);
    }
    return extraHeaders;
};
var setSelectedTabData = function (selectedTabData) {
    return cookies.set('selectedTabData', selectedTabData, { path: '/', maxAge: 3600000000 });
};
var getSelectedTabData = function () {
    return cookies.get('selectedTabData') || '{}';
};
var removeSelectedTabData = function () {
    return cookies.remove('selectedTabData', { path: '/' });
};
var removeIsExpressServiceType = function () { return cookies.remove(constants.isExpressServiceType, { path: '/' }); };
var getIsExpressServiceType = function () { return cookies.get(constants.isExpressServiceType); };
var CookieUtils = Object.freeze({
    __proto__: null,
    get DeliveryHeaders () { return DeliveryHeaders; },
    setAppVersion: setAppVersion,
    getAppVersion: getAppVersion,
    getUserTokenFromCookie: getUserTokenFromCookie,
    getUserEmailFromCookie: getUserEmailFromCookie,
    getGUID: getGUID,
    setGUID: setGUID,
    getRefreshTokenFromCookie: getRefreshTokenFromCookie,
    removeGUIDFromCookie: removeGUIDFromCookie,
    getGuestSessionToken: getGuestSessionToken,
    setSearchTypeCookie: setSearchTypeCookie,
    setSelectedAddressID: setSelectedAddressID,
    getSelectedAddressID: getSelectedAddressID,
    setSelectedAddressIDCookie: setSelectedAddressIDCookie,
    getSelectedAddressIDCookie: getSelectedAddressIDCookie,
    setRefreshTokenCallTime: setRefreshTokenCallTime,
    getRefreshTokenCallTime: getRefreshTokenCallTime,
    getSearchTypeCookie: getSearchTypeCookie,
    setPageType: setPageType,
    getPageType: getPageType,
    setCategoryName: setCategoryName,
    getCategoryName: getCategoryName,
    setGuestSessionToken: setGuestSessionToken,
    setUserTokenFromCookie: setUserTokenFromCookie,
    removeCookie: removeCookie,
    setRRSessionId: setRRSessionId,
    setRRUserId: setRRUserId,
    setDeliveryArea: setDeliveryArea,
    getRRSessionId: getRRSessionId,
    getRRUserId: getRRUserId,
    getDeliveryArea: getDeliveryArea,
    setSelectedLat: setSelectedLat,
    setSelectedLng: setSelectedLng,
    getSelectedLat: getSelectedLat,
    getSelectedLng: getSelectedLng,
    setPackageFreeDelivery: setPackageFreeDelivery,
    getPackageFreeDelivery: getPackageFreeDelivery,
    removeLocalStorage: removeLocalStorage,
    setStoreInfoCookie: setStoreInfoCookie,
    getCustomCookie: getCustomCookie,
    setCustomCookie: setCustomCookie,
    removeCookies: removeCookies,
    setNowJourneyCookie: setNowJourneyCookie,
    getNowJourneyCookie: getNowJourneyCookie,
    removeNowJourneyCookie: removeNowJourneyCookie,
    removeDeliveryAreaInfoCookie: removeDeliveryAreaInfoCookie,
    getPosInfo: getPosInfo,
    setDeliveryAreaInfo: setDeliveryAreaInfo,
    setDeliveryAreaInHeaders: setDeliveryAreaInHeaders,
    setSelectedTabData: setSelectedTabData,
    getSelectedTabData: getSelectedTabData,
    removeSelectedTabData: removeSelectedTabData,
    removeIsExpressServiceType: removeIsExpressServiceType,
    getIsExpressServiceType: getIsExpressServiceType
});
var EPageSturctureTypes;
(function (EPageSturctureTypes) {
    EPageSturctureTypes["SET_PAGE_STRUCTURE"] = "SET_PAGE_STRUCTURE";
})(EPageSturctureTypes || (EPageSturctureTypes = {}));
var EDeliveryTimeTypes;
(function (EDeliveryTimeTypes) {
    EDeliveryTimeTypes["SET_DELIVERY_TIME"] = "SET_DELIVERY_TIME";
    EDeliveryTimeTypes["SET_COACHMARKS"] = "SET_COACHMARKS";
})(EDeliveryTimeTypes || (EDeliveryTimeTypes = {}));
var Constants;
(function (Constants) {
    Constants["STATIC"] = "STATIC";
    Constants["DELIVERY_TIME_STANDARD"] = "DELIVERY_TIME_STANDARD";
    Constants["DELIVERY_TIME_EXPRESS"] = "DELIVERY_TIME_EXPRESS";
})(Constants || (Constants = {}));
var slots = [
    {
        key: 'expressSlot',
        busyHourKey: 'isNowBusyHour',
        offlineHourKey: 'isNowOfflineHour',
        nextSlotKey: 'nextAvailableSlotForNow',
        disclaimerKey: 'nowBusyHourDisclaimer',
        unavailableHourKey: 'isNowUnavailableHour',
        available: 'isNowAvailable',
        nextSlot: 'isNowNextSlot',
    },
    {
        key: 'qcommSlot',
        busyHourKey: 'isQcommBusyHour',
        offlineHourKey: 'isQcommOfflineHour',
        nextSlotKey: 'nextAvailableSlotForQcomm',
        disclaimerKey: 'qCommBusyHourDisclaimer',
        unavailableHourKey: 'isQcommUnavailableHour',
        available: 'isQCommAvailable',
        nextSlot: 'isQcommNextSlot',
    },
];
var EPageSturctureTypes$1 = EPageSturctureTypes;
var STORE;
var __REDUX_STORE__ = '__REDUX_STORE__';
var getStore = function () {
    return isBrowser() ? window[__REDUX_STORE__] || STORE : STORE;
};
var initialApiState = {};
var apiReducer = function (state, action) {
    if (state === void 0) { state = initialApiState; }
    switch (action.type) {
        case EApiActionTypes$1.API_ERROR:
            return __assign$1(__assign$1({}, state), { error: action.payload });
        case EApiActionTypes$1.ACCESS_DENIED:
            return __assign$1(__assign$1({}, state), { accessDenied: action.payload });
        default:
            return state;
    }
};
var EMiniCartTypes;
(function (EMiniCartTypes) {
    EMiniCartTypes["MINI_CART_ADD_TO_CART"] = "MiniCart/ADD_TO_CART";
    EMiniCartTypes["MINI_CART_ADD_TO_ENTRIES"] = "MiniCart/ADD_TO_ENTRIES";
    EMiniCartTypes["MINI_CART_GET"] = "MiniCart/GET";
    EMiniCartTypes["MINI_CART_REMOVE_FROM_CART"] = "MiniCart/REMOVE_FROM_CART";
    EMiniCartTypes["MINI_CART_REMOVE_FROM_ENTRIES"] = "MiniCart/REMOVE_FROM_ENTRIES";
    EMiniCartTypes["MINI_CART_SET_DATA"] = "MiniCart/SET_DATA";
    EMiniCartTypes["MINI_CART_UPDATE_CART"] = "MiniCart/UPDATE_CART";
    EMiniCartTypes["MINI_CART_ADD_TO_CART_TRACKING"] = "MiniCart/ADD_TO_CART_TRACKING";
})(EMiniCartTypes || (EMiniCartTypes = {}));
var EMiniCartTypes$1 = EMiniCartTypes;
var initialMiniCartState = {
    entries: {},
    totalUnitCount: 0,
    updatedCart: null,
    statusCode: '',
};
var miniCartReducer = function (state, action) {
    if (state === void 0) { state = initialMiniCartState; }
    switch (action.type) {
        case EMiniCartTypes$1.MINI_CART_SET_DATA:
            return __assign$1(__assign$1({}, state), action.payload);
        case EMiniCartTypes$1.MINI_CART_ADD_TO_ENTRIES: {
            var _a = action.payload, entry = _a.entry, totalUnitCount = _a.totalUnitCount, updatedCart = _a.updatedCart, statusCode = _a.statusCode, offerEntries = _a.offerEntries;
            return __assign$1(__assign$1({}, state), { totalUnitCount: totalUnitCount,
                updatedCart: updatedCart,
                statusCode: statusCode, entries: __assign$1(__assign$1({}, state.entries), entry), offerEntries: offerEntries });
        }
        case EMiniCartTypes$1.MINI_CART_REMOVE_FROM_ENTRIES: {
            var entries_1 = state.entries;
            var _b = action.payload, totalUnitCount = _b.totalUnitCount, uniqueEntryId = _b.uniqueEntryId;
            var deletedProductKey_1 = uniqueEntryId;
            var filteredEntries = Object.keys(entries_1).filter(function (key) { return key !== deletedProductKey_1.toString(); });
            var newEntries_1 = {};
            filteredEntries.forEach(function (val) {
                newEntries_1[val] = __assign$1({}, entries_1[val]);
            });
            return __assign$1(__assign$1({}, state), { totalUnitCount: totalUnitCount, entries: newEntries_1 });
        }
    }
    return state;
};
var EProductCardTypes;
(function (EProductCardTypes) {
    EProductCardTypes["SET_ERROR"] = "ProductCard/SET_ERROR";
    EProductCardTypes["SET_LOADING"] = "ProductCard/SET_LOADING";
    EProductCardTypes["SET_TRACKING"] = "ProductCard/ALGOLIA_TRACKING";
})(EProductCardTypes || (EProductCardTypes = {}));
var EProductCardTypes$1 = EProductCardTypes;
var initialProductCardState = {};
var productCardReducer = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initialProductCardState; }
    switch (action.type) {
        case EProductCardTypes$1.SET_ERROR:
            return __assign$1(__assign$1({}, state), (_a = {}, _a[action.payload.productId] = __assign$1(__assign$1(__assign$1({}, state[action.payload.productId]), { error: action.payload.error, errDetail: action.payload.errDetail }), (action.payload.persistent && {
                persistentError: {
                    error: action.payload.error,
                    errDetail: action.payload.errDetail,
                },
            })), _a));
        case EProductCardTypes$1.SET_LOADING:
            return __assign$1(__assign$1({}, state), (_b = {}, _b[action.payload.productId] = __assign$1(__assign$1({}, state[action.payload.productId]), { loading: action.payload.loading }), _b));
        default:
            return state;
    }
};
var EProductCardCarouselTypes;
(function (EProductCardCarouselTypes) {
    EProductCardCarouselTypes["GET_PRODUCTS"] = "CAROUSEL/GET_PRODUCTS";
    EProductCardCarouselTypes["SET_PRODUCTS"] = "CAROUSEL/SET_PRODUCTS";
})(EProductCardCarouselTypes || (EProductCardCarouselTypes = {}));
var EProductCardCarouselTypes$1 = EProductCardCarouselTypes;
var initialProductCardCarouselState = {
    strategy: {},
};
var ProductCardCarouselReducer = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initialProductCardCarouselState; }
    switch (action.type) {
        case EProductCardCarouselTypes$1.GET_PRODUCTS:
            var payload = action.payload;
            return __assign$1(__assign$1({}, state), { strategy: __assign$1(__assign$1({}, state.strategy), (_a = {}, _a[payload] = {
                    isLoading: true,
                }, _a)) });
        case EProductCardCarouselTypes$1.SET_PRODUCTS:
            var _c = action.payload, key = _c.key, products = _c.products;
            return __assign$1(__assign$1({}, state), { strategy: __assign$1(__assign$1({}, state.strategy), (_b = {}, _b[key] = {
                    data: products,
                    isLoading: false,
                }, _b)) });
        default:
            return state;
    }
};
var EProductListTypes;
(function (EProductListTypes) {
    EProductListTypes["SET_DISABLED"] = "ProductList/SET_DISABLED";
    EProductListTypes["SET_RELEVANT_PRODUCT_ID"] = "ProductList/SET_RELEVANT_PRODUCT_ID";
    EProductListTypes["SET_PRODUCTS"] = "ProductList/SET_PRODUCTS";
    EProductListTypes["SET_EXPANDED_QTY_SELECTOR_PRODUCT_ID"] = "ProductList/SET_EXPAND_QTY_SELECTOR";
})(EProductListTypes || (EProductListTypes = {}));
var EProductListTypes$1 = EProductListTypes;
var initialProductListState = {
    disabled: false,
    relevantProductId: '',
    products: [],
    totalProducts: 0,
};
var ProductListReducer = function (state, action) {
    if (state === void 0) { state = initialProductListState; }
    switch (action.type) {
        case EProductListTypes$1.SET_DISABLED:
            return __assign$1(__assign$1({}, state), { disabled: action.payload });
        case EProductListTypes$1.SET_RELEVANT_PRODUCT_ID:
            return __assign$1(__assign$1({}, state), { relevantProductId: action.payload });
        case EProductListTypes$1.SET_PRODUCTS:
            var _a = action.payload, products = _a.products, totalProducts = _a.totalProducts;
            return __assign$1(__assign$1({}, state), { relevantProductId: '', products: products,
                totalProducts: totalProducts });
        case EProductListTypes$1.SET_EXPANDED_QTY_SELECTOR_PRODUCT_ID:
            var productId = action.payload;
            return __assign$1(__assign$1({}, state), { expandedQtySelectorProductId: productId });
        default:
            return state;
    }
};
var ESearchBoxTypes;
(function (ESearchBoxTypes) {
    ESearchBoxTypes["GET_AUTOCOMPLETE"] = "SEARCH_BOX/GET_AUTOCOMPLETE";
    ESearchBoxTypes["SUCCESS_AUTOCOMPLETE"] = "SEARCH_BOX/SUCCESS_AUTOCOMPLETE";
    ESearchBoxTypes["ERROR_AUTOCOMPLETE"] = "SEARCH_BOX/ERROR_AUTOCOMPLETE";
    ESearchBoxTypes["SET_SEARCH_TYPE"] = "SEARCH_BOX/SET_SEARCH_TYPE";
    ESearchBoxTypes["GET_TRENDING_SEARCH"] = "SEARCH_BOX/GET_TRENDING_SEARCH";
    ESearchBoxTypes["GET_TRENDING_SEARCH_SUCCESS"] = "SEARCH_BOX/GET_TRENDING_SEARCH_SUCCESS";
    ESearchBoxTypes["GET_TRENDING_SEARCH_FAILURE"] = "SEARCH_BOX/GET_TRENDING_SEARCH_FAILURE";
    ESearchBoxTypes["CLEAR_AUTOCOMPLETE"] = "SEARCH_BOX/CLEAR_AUTOCOMPLETE";
    ESearchBoxTypes["FETCH_BANNER_DETAILS"] = "SEARCH/FETCH_BANNER_DETAILS";
})(ESearchBoxTypes || (ESearchBoxTypes = {}));
var initialSearchBoxState = {
    isLoading: false,
    searchItems: [
        {
            asg_docId: '',
            asg_text_type: '',
            asg_text: '',
            asg_text_category: '',
            asg_text_category_id: '',
        },
    ],
    trendingSearch: [],
    wishlistSuggestion: [],
    searchKeyword: '',
};
var SearchBoxReducer = function (state, action) {
    if (state === void 0) { state = initialSearchBoxState; }
    switch (action.type) {
        case ESearchBoxTypes.GET_AUTOCOMPLETE:
            var params = action.payload.params;
            return __assign$1(__assign$1({}, state), { searchKeyword: params.query, isLoading: true });
        case ESearchBoxTypes.SUCCESS_AUTOCOMPLETE:
            var searchItems = state.searchKeyword === '' ? [] : __spread$1(action.payload);
            return __assign$1(__assign$1({}, state), { searchItems: searchItems, isLoading: false });
        case ESearchBoxTypes.ERROR_AUTOCOMPLETE:
            return __assign$1(__assign$1({}, state), { searchItems: [], isLoading: false, error: action.payload });
        case ESearchBoxTypes.GET_TRENDING_SEARCH:
            return __assign$1(__assign$1({}, state), { isLoading: true });
        case ESearchBoxTypes.GET_TRENDING_SEARCH_SUCCESS:
            var trendingSearchPayload = action.payload.trendingSearchResults;
            var trendingSearch = trendingSearchPayload ? trendingSearchPayload.slice(0, 5) : [];
            var wishlistSuggestion = trendingSearchPayload ? trendingSearchPayload : [];
            return __assign$1(__assign$1({}, state), { isLoading: false, trendingSearch: trendingSearch,
                wishlistSuggestion: wishlistSuggestion });
        case ESearchBoxTypes.CLEAR_AUTOCOMPLETE:
            return __assign$1(__assign$1({}, state), { searchItems: [], searchKeyword: '' });
        default:
            return state;
    }
};
var initialUserState = {
    isLoyaltyFetched: false,
    isProfileUpdating: false,
    addresses: {
        error: false,
        isLoading: false,
        list: [],
        deliveryAreas: [],
        coverageArea: {
            isChecking: false,
            isSupported: false,
        },
        showLoader: false,
    },
    defaultAddress: null,
    isLoading: false,
    addressChanged: false,
};
var userReducer = function (state, action) {
    var e_1, _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28;
    if (state === void 0) { state = initialUserState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case UserTypes$1.USER_GET_DATA_START:
            return __assign$1(__assign$1({}, state), { isLoading: true });
        case UserTypes$1.USER_GET_DATA_END:
            return __assign$1(__assign$1({}, state), { isLoading: false });
        case UserTypes$1.USER_UPDATE_PROFILE_START:
            return __assign$1(__assign$1({}, state), { isProfileUpdating: true });
        case UserTypes$1.USER_UPDATE_PROFILE_END:
            return __assign$1(__assign$1({}, state), { isProfileUpdating: false });
        case UserTypes$1.USER_PROFILE_DATA_SUCCESS:
            return __assign$1(__assign$1({}, state), { firstName: (_c = (_b = payload === null || payload === void 0 ? void 0 : payload.data) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.first_name, lastName: (_e = (_d = payload === null || payload === void 0 ? void 0 : payload.data) === null || _d === void 0 ? void 0 : _d.profile) === null || _e === void 0 ? void 0 : _e.last_name, birthday: (_h = (_g = (_f = payload === null || payload === void 0 ? void 0 : payload.data) === null || _f === void 0 ? void 0 : _f.profile) === null || _g === void 0 ? void 0 : _g.birthday) === null || _h === void 0 ? void 0 : _h.split('T')[0], nationality: (_k = (_j = payload === null || payload === void 0 ? void 0 : payload.data) === null || _j === void 0 ? void 0 : _j.profile) === null || _k === void 0 ? void 0 : _k.nationality, title: (_m = (_l = payload === null || payload === void 0 ? void 0 : payload.data) === null || _l === void 0 ? void 0 : _l.profile) === null || _m === void 0 ? void 0 : _m.title, contact_number: (_p = (_o = payload === null || payload === void 0 ? void 0 : payload.data) === null || _o === void 0 ? void 0 : _o.profile) === null || _p === void 0 ? void 0 : _p.contact_number, fullName: ((_r = (_q = payload === null || payload === void 0 ? void 0 : payload.data) === null || _q === void 0 ? void 0 : _q.profile) === null || _r === void 0 ? void 0 : _r.first_name) + ' ' + ((_t = (_s = payload === null || payload === void 0 ? void 0 : payload.data) === null || _s === void 0 ? void 0 : _s.profile) === null || _t === void 0 ? void 0 : _t.last_name), phone: (_w = (_v = (_u = payload === null || payload === void 0 ? void 0 : payload.data) === null || _u === void 0 ? void 0 : _u.profile) === null || _v === void 0 ? void 0 : _v.contact_number[0]) === null || _w === void 0 ? void 0 : _w.number, isPhoneVerified: (_y = (_x = payload === null || payload === void 0 ? void 0 : payload.data) === null || _x === void 0 ? void 0 : _x.profile) === null || _y === void 0 ? void 0 : _y.isPhoneVerified, isNewUser: (_0 = (_z = payload === null || payload === void 0 ? void 0 : payload.data) === null || _z === void 0 ? void 0 : _z.profile) === null || _0 === void 0 ? void 0 : _0.isNewUser, cardNumber: ((_3 = (_2 = (_1 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _1 === void 0 ? void 0 : _1.profile) === null || _2 === void 0 ? void 0 : _2.loyalty) === null || _3 === void 0 ? void 0 : _3.card_number) || '', email: (_5 = (_4 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _4 === void 0 ? void 0 : _4.profile) === null || _5 === void 0 ? void 0 : _5.username, id: (_7 = (_6 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _6 === void 0 ? void 0 : _6.profile) === null || _7 === void 0 ? void 0 : _7.id });
        case UserTypes$1.USER_PROFILE_PHONE_UPDATE:
            return __assign$1(__assign$1({}, state), payload);
        case UserTypes$1.USER_GET_LOYALTY_DATA_SUCCESS:
            if (payload === null || payload === void 0 ? void 0 : payload.data) {
                return __assign$1(__assign$1({}, state), { cardNumber: (_9 = (_8 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _8 === void 0 ? void 0 : _8.points) === null || _9 === void 0 ? void 0 : _9.card_number, isShare: ((_11 = (_10 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _10 === void 0 ? void 0 : _10.points) === null || _11 === void 0 ? void 0 : _11.loyalty_program) === 'share' ? true : false, totalPoints: ((_13 = (_12 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _12 === void 0 ? void 0 : _12.points) === null || _13 === void 0 ? void 0 : _13.points) ? parseFloat((_15 = (_14 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _14 === void 0 ? void 0 : _14.points) === null || _15 === void 0 ? void 0 : _15.points).toFixed(2) : 0.0, totalPointsValue: ((_17 = (_16 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _16 === void 0 ? void 0 : _16.points) === null || _17 === void 0 ? void 0 : _17.converted_points) ? parseFloat((_19 = (_18 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _18 === void 0 ? void 0 : _18.points) === null || _19 === void 0 ? void 0 : _19.converted_points).toFixed(2)
                        : 0.0 });
            }
            else {
                return __assign$1(__assign$1({}, state), { cardNumber: payload.cardNumber, isShare: payload.isShare, totalPoints: payload.totalPoints, totalPointsValue: payload.totalPointsValue });
            }
        case UserTypes$1.USER_GET_LOYALTY_DATA_END:
            return __assign$1(__assign$1({}, state), { isLoyaltyFetched: true });
        case UserTypes$1.USER_SET_ADDRESSES_ERROR:
            return __assign$1(__assign$1({}, state), { addresses: __assign$1(__assign$1({}, state.addresses), { error: action.payload }) });
        case UserTypes$1.USER_SET_ADDRESSES_LOADING:
            return __assign$1(__assign$1({}, state), { addresses: __assign$1(__assign$1({}, state.addresses), { loading: action.payload , isLoading: action.payload }) });
        case USER_FETCH_ADDRESSES_SUCCESS:
            var _29 = payload, addresses = _29.addresses, defaultAreaCode = _29.defaultAreaCode;
            var userDefaultAddress = state.selectedAddress;
            var selectedAddress = state.selectedAddress;
            if (!userDefaultAddress) {
                try {
                    for (var addresses_1 = __values$1(addresses), addresses_1_1 = addresses_1.next(); !addresses_1_1.done; addresses_1_1 = addresses_1.next()) {
                        var address = addresses_1_1.value;
                        var isAddressDefault = address.defaultAddress, addressID = address.id;
                        if (isAddressDefault) {
                            userDefaultAddress = address;
                        }
                        if (addressID === getSelectedAddressID()) {
                            selectedAddress = address;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (addresses_1_1 && !addresses_1_1.done && (_a = addresses_1.return)) _a.call(addresses_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            userDefaultAddress = userDefaultAddress || {};
            selectedAddress = selectedAddress || userDefaultAddress;
            if (Object.keys(selectedAddress).length > 0) {
                var deliverText = (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.addressLabel) + " - " + (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.building) + " - " + (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.appartment);
                setSelectedAddressID(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.id);
                setSelectedAddressIDCookie(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.id);
                setSelectedLat(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.latitude);
                setSelectedLng(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.longitude);
                setDeliveryArea(deliverText);
            }
            else {
                setDeliveryArea(defaultAreaCode);
            }
            return __assign$1(__assign$1({}, state), { addresses: __assign$1(__assign$1({}, state.addresses), { list: addresses }), selectedAddress: selectedAddress, defaultAddress: userDefaultAddress });
        case UserTypes$1.USER_SET_SELECTED_ADDRESSES: {
            return __assign$1(__assign$1({}, state), { selectedAddress: action.payload });
        }
        case UserTypes$1.USER_SET_ADDRESS_CHANGE: {
            return __assign$1(__assign$1({}, state), { addressChanged: action.payload });
        }
        case "" + UserTypes$1.USER_COUNTRY_CONFIG + EApiActionTypes$1.API_START: {
            return __assign$1(__assign$1({}, state), { countryConfig: __assign$1(__assign$1({}, state.countryConfig), { isLoading: true }) });
        }
        case USER_COUNTRY_CONFIG_SUCCESS: {
            var _30 = action.payload.data, countryConfiguration = _30.countryConfiguration, sharedConfig = _30.sharedConfig, unSupportedFeatures = _30.unSupportedFeatures;
            var countryFlagIcon = countryConfiguration.countryFlagIcon, defaultLatitude = countryConfiguration.defaultLatitude, defaultLongitude = countryConfiguration.defaultLongitude, phoneCountryCode = countryConfiguration.phoneCountryCode, phoneNumberLength = countryConfiguration.phoneNumberLength, countryOfOperationID = countryConfiguration.countryOfOperationID, storeId_1 = countryConfiguration.storeId;
            var countryCodePhoneNumber = sharedConfig.countryCodePhoneNumber;
            var countryPhoneConfig_1 = {
                expression: undefined,
            };
            countryCodePhoneNumber.some(function (conConfig) {
                if (conConfig.storeId === storeId_1) {
                    countryPhoneConfig_1 = conConfig;
                    return true;
                }
                return false;
            });
            return __assign$1(__assign$1({}, state), { countryConfig: {
                    countryFlagIcon: countryFlagIcon,
                    defaultLatitude: defaultLatitude,
                    defaultLongitude: defaultLongitude,
                    phoneCountryCode: phoneCountryCode,
                    phoneNumberLength: phoneNumberLength,
                    countryOfOperationID: countryOfOperationID,
                    phoneExpression: countryPhoneConfig_1.expression,
                    unSupportedFeatures: unSupportedFeatures,
                    sharedConfig: sharedConfig,
                } });
        }
        case "" + UserTypes$1.USER_COUNTRY_CONFIG + EApiActionTypes$1.API_END: {
            return __assign$1(__assign$1({}, state), { countryConfig: __assign$1(__assign$1({}, state.countryConfig), { isLoading: false }) });
        }
        case USER_GET_DELIVERY_AREAS_SUCCESS: {
            var data = action.payload.data;
            return __assign$1(__assign$1({}, state), { addresses: __assign$1(__assign$1({}, state.addresses), { deliveryAreas: data }) });
        }
        case "" + UserTypes$1.USER_CHECK_AREA_SUPPORT + EApiActionTypes$1.API_START: {
            return __assign$1(__assign$1({}, state), { addresses: __assign$1(__assign$1({}, state.addresses), { coverageArea: __assign$1(__assign$1({}, state.addresses.coverageArea), { isChecking: true }) }) });
        }
        case USER_CHECK_AREA_SUPPORT_SUCCESS: {
            return __assign$1(__assign$1({}, state), { addresses: __assign$1(__assign$1({}, state.addresses), { coverageArea: __assign$1(__assign$1(__assign$1({}, state.addresses.coverageArea), action.payload), { isSupported: (_20 = action.payload) === null || _20 === void 0 ? void 0 : _20.isSupported }) }) });
        }
        case USER_CHECK_AREA_SUPPORT_FAIL: {
            return __assign$1(__assign$1({}, state), { addresses: __assign$1(__assign$1({}, state.addresses), { coverageArea: __assign$1(__assign$1({}, state.addresses.coverageArea), { isSupported: false }) }) });
        }
        case "" + UserTypes$1.USER_CHECK_AREA_SUPPORT + EApiActionTypes$1.API_END: {
            return __assign$1(__assign$1({}, state), { addresses: __assign$1(__assign$1({}, state.addresses), { coverageArea: __assign$1(__assign$1({}, state.addresses.coverageArea), { isChecking: false }) }) });
        }
        case "" + UserTypes$1.USER_ADD_ADDRESS + EApiActionTypes$1.API_START:
        case "" + UserTypes$1.USER_UPDATE_ADDRESS + EApiActionTypes$1.API_START:
            return __assign$1(__assign$1({}, state), { addresses: __assign$1(__assign$1({}, state.addresses), { showLoader: true }) });
        case "" + UserTypes$1.USER_ADD_ADDRESS + EApiActionTypes$1.API_END:
        case "" + UserTypes$1.USER_UPDATE_ADDRESS + EApiActionTypes$1.API_END:
            return __assign$1(__assign$1({}, state), { addresses: __assign$1(__assign$1({}, state.addresses), { showLoader: false }) });
        case USER_ADD_ADDRESS_SUCCESS: {
            var newAddressesList = __spread$1(action.payload, state.addresses.list);
            return __assign$1(__assign$1({}, state), { addresses: __assign$1(__assign$1({}, state.addresses), { list: newAddressesList }) });
        }
        case UserTypes$1.USER_UPDATE_DELIVERY_ADDRESS:
            return __assign$1(__assign$1({}, state), { selectedAddress: payload.updatedDeliveryAddress });
        case UserTypes$1.USER_UPDATE_NEWLY_ADDED_ADDRESS: {
            return __assign$1(__assign$1({}, state), { selectedAddress: payload, addresses: __assign$1(__assign$1({}, state.addresses), { list: __spread$1([payload], state.addresses.list) }) });
        }
        case UserTypes$1.UPDATE_USER_CONTACT:
            return __assign$1(__assign$1({}, state), { userContactLoading: true });
        case UserTypes$1.UPDATE_USER_CONTACT_SUCCESS:
            return __assign$1(__assign$1({}, state), { userContactLoading: false });
        case UserTypes$1.UPDATE_USER_CONTACT_ERROR:
            return __assign$1(__assign$1({}, state), { userContactLoading: false });
        case UserTypes$1.USER_GET_LOYALTY_SUMMARY_SUCCESS:
            return __assign$1(__assign$1({}, state), { totalPoints: ((_22 = (_21 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _21 === void 0 ? void 0 : _21.points) === null || _22 === void 0 ? void 0 : _22.points) ? parseFloat((_24 = (_23 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _23 === void 0 ? void 0 : _23.points) === null || _24 === void 0 ? void 0 : _24.points).toFixed(2) : 0.0, totalPointsValue: ((_26 = (_25 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _25 === void 0 ? void 0 : _25.points) === null || _26 === void 0 ? void 0 : _26.converted_points) ? parseFloat((_28 = (_27 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _27 === void 0 ? void 0 : _27.points) === null || _28 === void 0 ? void 0 : _28.converted_points).toFixed(2)
                    : 0.0 });
    }
    return state;
};
var initialAppConfigState = {
    language: APP_CONFIG.language,
    currency: APP_CONFIG.currency,
    storeId: APP_CONFIG.storeId,
    areaCode: APP_CONFIG.areaCode,
    sessionId: APP_CONFIG.sessionId,
    userId: APP_CONFIG.userId,
    expressDeliveryMessage: APP_CONFIG.expressDeliveryMessage,
    expressPos: APP_CONFIG.expressPos,
    latitude: APP_CONFIG.latitude,
    longitude: APP_CONFIG.longitude,
    isLoading: false,
    gtmInitialized: false,
    brazeInitialized: false,
    features: {},
    userCredentials: {},
    growthBook: {},
    flagShip: {},
    pageIntent: false,
    pageName: APP_CONFIG.pageName,
};
var appConfigReducer = function (state, action) {
    if (state === void 0) { state = initialAppConfigState; }
    switch (action.type) {
        case EAppConfigTypes$1.INIT:
            return {
                isLoading: true,
            };
        case EAppConfigTypes$1.SUCCESS:
            return __assign$1(__assign$1(__assign$1({}, state), action.payload), { isLoading: false });
        case EAppConfigTypes$1.SET_AREA_CODE:
            return __assign$1(__assign$1({}, state), { areaCode: action.payload, isLoading: false });
        case EAppConfigTypes$1.SET_LANGUAGE_CODE:
            return __assign$1(__assign$1({}, state), { language: action.payload, isLoading: false });
        case EAppConfigTypes$1.REFRESH_TOKEN_SUCCESS: {
            var _a = action.payload.data, authToken = _a.accessToken, expiresIn = _a.expiresIn;
            setCustomCookie(constants.userToken, authToken, expiresIn);
            return __assign$1(__assign$1({}, state), { userCredentials: __assign$1(__assign$1({}, state.userCredentials), { authToken: authToken }) });
        }
        case EAppConfigTypes$1.GTM_INITIALIZED: {
            var isInitialized = action.payload;
            return __assign$1(__assign$1({}, state), { gtmInitialized: isInitialized });
        }
        case EAppConfigTypes$1.BRAZE_INITIALIZED: {
            var isInitialized = action.payload;
            return __assign$1(__assign$1({}, state), { brazeInitialized: isInitialized });
        }
        case EAppConfigTypes$1.GROWTHBOOK_INITIALIZED: {
            var payload = action.payload;
            return __assign$1(__assign$1({}, state), { growthBook: __assign$1(__assign$1({}, state.growthBook), payload) });
        }
        case EAppConfigTypes$1.FLAGSHIP_INITIALIZED: {
            var payload = action.payload;
            return __assign$1(__assign$1({}, state), { flagShip: __assign$1(__assign$1({}, state.flagShip), payload) });
        }
        case EAppConfigTypes$1.SET_PAGE_INTENT: {
            var payload = action.payload;
            return __assign$1(__assign$1({}, state), { pageIntent: payload });
        }
        case EAppConfigTypes$1.SET_PAGE_NAME: {
            var payload = action.payload;
            return __assign$1(__assign$1({}, state), { pageName: payload });
        }
        case EAppConfigTypes$1.SET_SELECTED_TAB: {
            var payload = action.payload;
            return __assign$1(__assign$1({}, state), { selectedTabId: payload });
        }
        default:
            return state;
    }
};
var EMenuNavigation;
(function (EMenuNavigation) {
    EMenuNavigation["MENU_INIT"] = "MENU_NAVIGATION/INIT";
    EMenuNavigation["MENU_SUCCESS"] = "MENU_NAVIGATION/SUCCESS";
})(EMenuNavigation || (EMenuNavigation = {}));
var EMenuNavigation$1 = EMenuNavigation;
var NOW_FEED = {
    children: [],
    styleAttribute: 'now',
    title: 'Now',
    url: '/c/now',
};
var initialMenuNavigationState = {
    isLoading: false,
    menuFeed: [],
};
var menuNavigationReducers = function (state, action) {
    if (state === void 0) { state = initialMenuNavigationState; }
    switch (action.type) {
        case EMenuNavigation$1.MENU_INIT:
            return __assign$1(__assign$1({}, state), { isLoading: true, menuFeed: [] });
        case EMenuNavigation$1.MENU_SUCCESS:
            var nowUrl_1 = '';
            var menuFeed = action.payload.response.filter(function (item) {
                if (item.styleAttribute === 'now') {
                    nowUrl_1 = item.url;
                }
                return item !== undefined && item.styleAttribute !== 'now';
            });
            var nowMenuItem = __assign$1(__assign$1({}, NOW_FEED), { url: nowUrl_1 || NOW_FEED.url });
            return __assign$1(__assign$1({}, state), { isLoading: false, menuFeed: action.payload.isDesktop
                    ? __spread$1(menuFeed, [nowMenuItem]) : __spread$1(menuFeed.slice(0, 1), [nowMenuItem], menuFeed.slice(1)) });
        default:
            return state;
    }
};
var EArea;
(function (EArea) {
    EArea["FETCH_AREAS_GET"] = "Area/FETCH_AREAS_GET";
    EArea["FETCH_AREAS_SET"] = "Area/FETCH_AREAS_SET";
    EArea["SET_AREA"] = "Area/SET_SELECTED_AREA";
    EArea["FETCH_AREAS_GET_QATAR"] = "Area/FETCH_AREAS_GET_QATAR";
    EArea["FETCH_AREAS_SET_QATAR"] = "Area/FETCH_AREAS_SET_QATAR";
})(EArea || (EArea = {}));
var TOGGLE_ADDRESS_LIST = 'Area/TOGGLE_ADDRESS_LIST';
var EArea$1 = EArea;
var areaInitialState = {
    error: false,
    isLoading: false,
    regions: [],
    isExpressDelivery: false,
    selectedCity: '',
    qatarCities: null,
    showAddressList: false,
};
var areaReducer = function (state, action) {
    if (state === void 0) { state = areaInitialState; }
    switch (action.type) {
        case EArea$1.FETCH_AREAS_GET:
            return __assign$1(__assign$1({}, state), { regions: [], error: false, isLoading: true, selectedArea: {} });
        case EArea$1.FETCH_AREAS_SET: {
            var _a = action.payload, regions = _a.regions, selectedArea = _a.selectedArea, selectedCity = _a.selectedCity;
            var isExpressDelivery = selectedArea && selectedArea.posExpressName ? true : false;
            return __assign$1(__assign$1({}, state), { regions: regions, selectedArea: selectedArea, isExpressDelivery: isExpressDelivery, selectedCity: selectedCity });
        }
        case EArea$1.FETCH_AREAS_SET_QATAR: {
            return __assign$1(__assign$1({}, state), { qatarCities: action.payload });
        }
        case "" + EArea$1.FETCH_AREAS_GET + EApiActionTypes$1.API_ERROR:
            return __assign$1(__assign$1({}, state), { error: true });
        case "" + EArea$1.FETCH_AREAS_GET + EApiActionTypes$1.API_END:
            return __assign$1(__assign$1({}, state), { isLoading: false });
        case EArea$1.SET_AREA:
            return __assign$1(__assign$1({}, state), { loading: true });
        case "" + EArea$1.SET_AREA + EApiActionTypes$1.API_ERROR:
            return __assign$1(__assign$1({}, state), { loading: false, error: true });
        case "" + EArea$1.SET_AREA + EApiActionTypes$1.API_END:
            return __assign$1(__assign$1({}, state), { loading: false });
        case TOGGLE_ADDRESS_LIST:
            return __assign$1(__assign$1({}, state), { showAddressList: action.payload });
        default:
            return state;
    }
};
var ENotificationTypes;
(function (ENotificationTypes) {
    ENotificationTypes["NOTIFICATION_SHOW"] = "Notification/SHOW_NOTIFICATION";
    ENotificationTypes["NOTIFICATION_HIDE"] = "Notification/HIDE_NOTIFICATION";
})(ENotificationTypes || (ENotificationTypes = {}));
var ENotificationTypes$1 = ENotificationTypes;
var initialNotificationState = {};
var notificationReducer = function (state, action) {
    if (state === void 0) { state = initialNotificationState; }
    switch (action.type) {
        case ENotificationTypes$1.NOTIFICATION_SHOW:
            return action.payload;
        case ENotificationTypes$1.NOTIFICATION_HIDE:
            return initialNotificationState;
    }
    return state;
};
var EAddToListTypes;
(function (EAddToListTypes) {
    EAddToListTypes["ADD_TO_LIST_FETCH_LIST"] = "AddToList/FETCH_LIST";
    EAddToListTypes["ADD_TO_LIST_FETCH_LIST_SUCCESS"] = "AddToList/FETCH_LIST_SUCCESS";
    EAddToListTypes["ADD_PRODUCT_ONLY"] = "AddToList/ADD_PRODUCT_ONLY";
    EAddToListTypes["ADD_PRODUCT_AND_NEW_LIST"] = "AddToList/ADD_PRODUCT_AND_NEW_LIST";
    EAddToListTypes["ADD_TO_LIST_TOGGLE_LOADING"] = "AddToList/TOGGLE_LOADING";
    EAddToListTypes["ADD_TO_LIST_SET_ERROR"] = "AddToList/SET_ERROR";
    EAddToListTypes["ADD_TO_LIST_SET_SUCCESS"] = "AddToList/ADD_TO_LIST_SET_SUCCESS";
    EAddToListTypes["ADD_TO_LIST_CLEAR_ERROR_AND_SUCCESS"] = "AddToList/CLEAR_ERROR_AND_SUCCESS";
})(EAddToListTypes || (EAddToListTypes = {}));
var EAddToListTypes$1 = EAddToListTypes;
var initialAddToListState = { loading: false };
var addToListReducer = function (state, action) {
    if (state === void 0) { state = initialAddToListState; }
    switch (action.type) {
        case EAddToListTypes$1.ADD_TO_LIST_SET_ERROR:
            return __assign$1(__assign$1({}, state), { error: action.payload });
        case EAddToListTypes$1.ADD_TO_LIST_TOGGLE_LOADING:
            return __assign$1(__assign$1({}, state), { loading: action.payload });
        case EAddToListTypes$1.ADD_TO_LIST_FETCH_LIST_SUCCESS:
            return __assign$1(__assign$1({}, state), { list: action.payload });
        case EAddToListTypes$1.ADD_TO_LIST_SET_SUCCESS:
            return __assign$1(__assign$1({}, state), { success: action.payload });
        case EAddToListTypes$1.ADD_TO_LIST_CLEAR_ERROR_AND_SUCCESS:
            return __assign$1(__assign$1({}, state), { error: null, success: null });
    }
    return state;
};
var ECurrencies;
(function (ECurrencies) {
    ECurrencies["GET_CURRENCIES"] = "FETCH_CURRENCIES_GET";
    ECurrencies["SET_CURRENCIES"] = "FETCH_CURRENCIES_SET";
})(ECurrencies || (ECurrencies = {}));
var ECurrencies$1 = ECurrencies;
var currencyInitialState = {
    currencies: [],
};
var currencyReducer = function (state, action) {
    if (state === void 0) { state = currencyInitialState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case ECurrencies$1.SET_CURRENCIES:
            return __assign$1(__assign$1({}, state), { currencies: payload });
        default:
            return state;
    }
};
var initialPageStructureState = [];
var PageStructureReducer = function (state, action) {
    if (state === void 0) { state = initialPageStructureState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case EPageSturctureTypes$1.SET_PAGE_STRUCTURE:
            return __spread$1(payload);
        default:
            return state;
    }
};
var IServiceInfo;
(function (IServiceInfo) {
    IServiceInfo["STANDARD"] = "STANDARD";
    IServiceInfo["EXPRESS"] = "EXPRESS";
    IServiceInfo["ANY"] = "ANY";
    IServiceInfo["QCOMM"] = "QCOMM";
})(IServiceInfo || (IServiceInfo = {}));
var initialDeliveryTimeState = {
    posNo: '',
    standardSlot: {},
    expressSlot: {},
    qcommSlot: {},
    deliveryAreaInfo: [],
    coachMarks: [],
};
var DeliveryTimeReducer = function (state, action) {
    if (state === void 0) { state = initialDeliveryTimeState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case EDeliveryTimeTypes.SET_DELIVERY_TIME:
            return __assign$1(__assign$1({}, state), payload);
        case EDeliveryTimeTypes.SET_COACHMARKS:
            return __assign$1(__assign$1({}, state), { coachMarks: payload });
        default:
            return state;
    }
};
var UPDATE_COOKIE_VISIBILITY = 'COOKIE_VISIBILITY/UPDATE';
var hasUserClosedCookieBanner = function () { return getCustomCookie(constants.cookieBannerAcceptance) === 'true'; };
var initialCookieVisibilityState = { cookieVisibility: !hasUserClosedCookieBanner() };
var cookieBanner = function (state, action) {
    if (state === void 0) { state = initialCookieVisibilityState; }
    if (action.type === UPDATE_COOKIE_VISIBILITY) {
        return __assign$1(__assign$1({}, state), { cookieVisibility: action.payload });
    }
    return state;
};
var VerifyOTPTypes;
(function (VerifyOTPTypes) {
    VerifyOTPTypes["SEND_OTP"] = "OTP/SEND_OTP";
    VerifyOTPTypes["SEND_OTP_SUCCESS"] = "OTP/SEND_OTP_SUCCESS";
    VerifyOTPTypes["SEND_OTP_ERROR"] = "OTP/SEND_OTP_ERROR";
    VerifyOTPTypes["SEND_OTP_LOADING"] = "OTP/SEND_OTP_LOADING";
    VerifyOTPTypes["OTP_VERIFICATION"] = "OTP/OTP_VERIFICATION";
    VerifyOTPTypes["OTP_VERIFICATION_SUCCESS"] = "OTP/OTP_VERIFICATION_SUCCESS";
    VerifyOTPTypes["OTP_VERIFICATION_ERROR"] = "OTP/OTP_VERIFICATION_ERROR";
    VerifyOTPTypes["OTP_VERIFICATION_LOADING"] = "OTP/OTP_VERIFICATION_LOADING";
})(VerifyOTPTypes || (VerifyOTPTypes = {}));
var SEND_OTP_SUCCESS = "" + VerifyOTPTypes.SEND_OTP_SUCCESS + EApiActionTypes$1.API_SUCCESS;
var OTP_VERIFICATION_SUCCESS = "" + VerifyOTPTypes.OTP_VERIFICATION_SUCCESS + EApiActionTypes$1.API_SUCCESS;
var VerifyOTPTypes$1 = VerifyOTPTypes;
var initialVerifyOTPState = {
    sendOTP: {
        otpData: null,
        isLoading: false,
        error: '',
    },
    verifyOTP: {
        verificationData: null,
        isLoading: false,
        error: '',
    },
};
var verifyOTPReducer = function (state, action) {
    if (state === void 0) { state = initialVerifyOTPState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case VerifyOTPTypes$1.SEND_OTP_SUCCESS:
            return __assign$1(__assign$1({}, state), { sendOTP: __assign$1(__assign$1({}, state.sendOTP), { otpData: payload.otpResponse }) });
        case VerifyOTPTypes$1.SEND_OTP_ERROR:
            return __assign$1(__assign$1({}, state), { sendOTP: __assign$1(__assign$1({}, state.sendOTP), { error: payload }) });
        case VerifyOTPTypes$1.SEND_OTP_LOADING:
            return __assign$1(__assign$1({}, state), { sendOTP: __assign$1(__assign$1({}, state.sendOTP), { isLoading: payload }) });
        case VerifyOTPTypes$1.OTP_VERIFICATION_SUCCESS:
            return __assign$1(__assign$1({}, state), { verifyOTP: __assign$1(__assign$1({}, state.verifyOTP), { verificationData: payload.otpVerificationResponse }) });
        case VerifyOTPTypes$1.OTP_VERIFICATION_ERROR:
            return __assign$1(__assign$1({}, state), { verifyOTP: __assign$1(__assign$1({}, state.verifyOTP), { error: payload }) });
        case VerifyOTPTypes$1.OTP_VERIFICATION_LOADING:
            return __assign$1(__assign$1({}, state), { verifyOTP: __assign$1(__assign$1({}, state.verifyOTP), { isLoading: payload }) });
    }
    return state;
};
var VerifyOTPSMSTypes;
(function (VerifyOTPSMSTypes) {
    VerifyOTPSMSTypes["VERIFY_SMS_OTP"] = "SMS/VERIFY_OTP";
    VerifyOTPSMSTypes["ERROR_SMS_OTP"] = "SMS/ERROR_OTP";
    VerifyOTPSMSTypes["SUCCESS_SMS_OTP"] = "SMS/SUCCESS_OTP";
})(VerifyOTPSMSTypes || (VerifyOTPSMSTypes = {}));
var VerifyOTPSMSTypes$1 = VerifyOTPSMSTypes;
var initialState = {
    loyaltyCardNumber: '',
    smsToken: '',
    response: '',
    errorMessage: '',
};
var verifyOTPSMSReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case VerifyOTPSMSTypes$1.VERIFY_SMS_OTP:
            return __assign$1(__assign$1({}, state), payload.data);
        case VerifyOTPSMSTypes$1.ERROR_SMS_OTP:
            return __assign$1(__assign$1({}, state), { errorMessage: payload });
        case VerifyOTPSMSTypes$1.SUCCESS_SMS_OTP:
            return __assign$1(__assign$1({}, state), { response: payload });
        default:
            return state;
    }
};
var HeaderTypes;
(function (HeaderTypes) {
    HeaderTypes["HEADER_GET"] = "HEADER/GET";
})(HeaderTypes || (HeaderTypes = {}));
var HeaderTypes$1 = HeaderTypes;
var initialHeaderState = {};
var headerReducer = function (state, action) {
    if (state === void 0) { state = initialHeaderState; }
    switch (action.type) {
        case "" + HeaderTypes$1.HEADER_GET + EApiActionTypes$1.API_START:
            return __assign$1(__assign$1({}, state), { loading: true });
        case "" + HeaderTypes$1.HEADER_GET + EApiActionTypes$1.API_SUCCESS:
            return __assign$1(__assign$1({}, state), action.payload);
        case "" + HeaderTypes$1.HEADER_GET + EApiActionTypes$1.API_END:
            return __assign$1(__assign$1({}, state), { loading: false });
        default:
            return state;
    }
};
var VerifyWhatsAppTypes;
(function (VerifyWhatsAppTypes) {
    VerifyWhatsAppTypes["WHATSAPP_OTP_VERIFICATION"] = "WHATSAPP_OTP/WHATSAPP_OTP_VERIFICATION";
    VerifyWhatsAppTypes["WHATSAPP_OTP_LOADING"] = "WHATSAPP_OTP/WHATSAPP_OTP_LOADING";
    VerifyWhatsAppTypes["WHATSAPP_OTP_SUCCESS"] = "WHATSAPP_OTP/WHATSAPP_OTP_SUCCESS";
    VerifyWhatsAppTypes["WHATSAPP_OTP_ERROR"] = "WHATSAPP_OTP/WHATSAPP_OTP_ERROR";
})(VerifyWhatsAppTypes || (VerifyWhatsAppTypes = {}));
var WHATSAPP_OTP_SUCCESS = "" + VerifyWhatsAppTypes.WHATSAPP_OTP_SUCCESS + EApiActionTypes$1.API_SUCCESS;
var VerifyWhatsAppTypes$1 = VerifyWhatsAppTypes;
var initialWhatsAppOtpState = {
    isWhatAppOtpLoading: false,
    whatsAppOtpSuccess: '',
    whatsAppOtpError: '',
};
var whatsAppOTPReducer = function (state, action) {
    if (state === void 0) { state = initialWhatsAppOtpState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case VerifyWhatsAppTypes$1.WHATSAPP_OTP_LOADING:
            return __assign$1(__assign$1({}, state), { isWhatAppOtpLoading: payload });
        case VerifyWhatsAppTypes$1.WHATSAPP_OTP_SUCCESS:
            return __assign$1(__assign$1({}, state), { whatsAppOtpSuccess: payload });
        case VerifyWhatsAppTypes$1.WHATSAPP_OTP_ERROR:
            return __assign$1(__assign$1({}, state), { whatsAppOtpError: payload });
        default:
            return state;
    }
};
var FooterTypes;
(function (FooterTypes) {
    FooterTypes["FOOTER_GET"] = "FOOTER/GET";
})(FooterTypes || (FooterTypes = {}));
var FooterTypes$1 = FooterTypes;
var initialFooterState = {};
var footerReducer = function (state, action) {
    if (state === void 0) { state = initialFooterState; }
    switch (action.type) {
        case "" + FooterTypes$1.FOOTER_GET + EApiActionTypes$1.API_START:
            return __assign$1(__assign$1({}, state), { loading: true });
        case "" + FooterTypes$1.FOOTER_GET + EApiActionTypes$1.API_SUCCESS:
            return __assign$1(__assign$1(__assign$1({}, state), action.payload), { loading: false });
        default:
            return state;
    }
};
var initialFBCSheetState = {
    isOpen: false,
    fbcSheetType: '',
};
var FBCSheetReducers = function (state, action) {
    if (state === void 0) { state = initialFBCSheetState; }
    switch (action.type) {
        case E_SOLD_BY_MESSAGE_TYPE.SFC:
        case E_SOLD_BY_MESSAGE_TYPE.SSDC:
        case E_SOLD_BY_MESSAGE_TYPE.SSFS:
        case E_SOLD_BY_MESSAGE_TYPE.SSFBC:
            return __assign$1(__assign$1({}, state), { fbcSheetType: action.type, isOpen: true });
        default:
            return __assign$1({}, initialFBCSheetState);
    }
};
var AdtechActionTypes;
(function (AdtechActionTypes) {
    AdtechActionTypes["SET_CRITEO_BANNERS"] = "adtech/SET_CRITEO_BANNERS";
    AdtechActionTypes["SET_CRITEO_CAROUSELS"] = "adtech/SET_CRITEO_CAROUSELS";
    AdtechActionTypes["RESET_CRITEO_CAROUSELS"] = "adtech/RESET_CRITEO_CAROUSELS";
    AdtechActionTypes["RESET_ADTECH_REDUCER"] = "adtech/RESET_ADTECH_REDUCER";
    AdtechActionTypes["SET_CRITEO_CAROUSELS_HEADER"] = "adtech/SET_CRITEO_CAROUSELS_HEADER";
})(AdtechActionTypes || (AdtechActionTypes = {}));
var AdtechActionTypes$1 = AdtechActionTypes;
var initialAdtechState = {
    criteoBanners: {},
    criteoCarousels: {},
    criteoCarouselsHeader: {},
};
var adtechReducer = function (state, action) {
    if (state === void 0) { state = initialAdtechState; }
    switch (action.type) {
        case AdtechActionTypes$1.SET_CRITEO_BANNERS:
            return __assign$1(__assign$1({}, state), { criteoBanners: __assign$1(__assign$1({}, state === null || state === void 0 ? void 0 : state.criteoBanners), action === null || action === void 0 ? void 0 : action.payload) });
        case AdtechActionTypes$1.SET_CRITEO_CAROUSELS:
            return __assign$1(__assign$1({}, state), { criteoCarousels: __assign$1({}, action === null || action === void 0 ? void 0 : action.payload) });
        case AdtechActionTypes$1.RESET_CRITEO_CAROUSELS:
            return __assign$1(__assign$1({}, state), { criteoCarousels: initialAdtechState.criteoCarousels });
        case AdtechActionTypes$1.RESET_ADTECH_REDUCER:
            return __assign$1({}, initialAdtechState);
        case AdtechActionTypes$1.SET_CRITEO_CAROUSELS_HEADER:
            return __assign$1(__assign$1({}, initialAdtechState), { criteoCarouselsHeader: __assign$1({}, action === null || action === void 0 ? void 0 : action.payload) });
        default:
            return state;
    }
};
var NewAddressType;
(function (NewAddressType) {
    NewAddressType["FETCH_CITIES_AND_AREAS"] = "ADDRESS/FETCH_CITIES_AND_AREAS";
    NewAddressType["FETCH_ADDRESS_LAT_LNG"] = "ADDRESS/FETCH_CITIES_AND_AREAS";
    NewAddressType["UPDATE_LOCAION_DATA"] = "ADDRESS/UPDATE_LOCATION_DATA";
    NewAddressType["COUNTRIES_GET"] = "COUNTRIES/GET";
    NewAddressType["COUNTRIES_SET_ERROR"] = "COUNTRIES/SET_ERROR";
})(NewAddressType || (NewAddressType = {}));
var NewAddressType$1 = NewAddressType;
var FETCH_CITIES_AND_AREAS_START = "" + NewAddressType.FETCH_CITIES_AND_AREAS + EApiActionTypes$1.API_START;
var FETCH_CITIES_AND_AREAS_SUCCESS = "" + NewAddressType.FETCH_CITIES_AND_AREAS + EApiActionTypes$1.API_SUCCESS;
var FETCH_CITIES_AND_AREAS_END = "" + NewAddressType.FETCH_CITIES_AND_AREAS + EApiActionTypes$1.API_END;
var initialCountriesState = {
    allCountries: [],
};
var countriesReducer = function (state, action) {
    if (state === void 0) { state = initialCountriesState; }
    var type = action.type;
    switch (type) {
        case NewAddressType$1.COUNTRIES_GET: {
            return __assign$1(__assign$1({}, state), { allCountries: action.payload });
        }
    }
    return state;
};
var reducers = {
    api: apiReducer,
    area: areaReducer,
    currency: currencyReducer,
    countries: countriesReducer,
    appMenu: menuNavigationReducers,
    miniCart: miniCartReducer,
    productCard: productCardReducer,
    productCardCarousel: ProductCardCarouselReducer,
    productList: ProductListReducer,
    searchBox: SearchBoxReducer,
    appConfig: appConfigReducer,
    userData: userReducer,
    notification: notificationReducer,
    addToList: addToListReducer,
    cookieBanner: cookieBanner,
    verifyOTP: verifyOTPReducer,
    verifyOTPSMS: verifyOTPSMSReducer,
    headerData: headerReducer,
    verifyWhatsAppOTP: whatsAppOTPReducer,
    footerData: footerReducer,
    fbcSheet: FBCSheetReducers,
    pageStructure: PageStructureReducer,
    deliveryTime: DeliveryTimeReducer,
    adtech: adtechReducer,
};
var rootReducer = combineReducers(reducers);
var showNotification = function (payload) { return ({
    type: ENotificationTypes$1.NOTIFICATION_SHOW,
    payload: payload,
}); };
var _a$1 = process.env, REACT_APP_API_ENDPOINT_V1 = _a$1.REACT_APP_API_ENDPOINT_V1, REACT_APP_API_ENDPOINT = _a$1.REACT_APP_API_ENDPOINT, _b = _a$1.REACT_APP_ID, REACT_APP_ID = _b === void 0 ? 'Reactweb' : _b, REACT_APP_ENV = _a$1.REACT_APP_ENV;
var API_CONFIG = {
    baseURL: { v1: REACT_APP_API_ENDPOINT_V1, v2: REACT_APP_API_ENDPOINT },
    appId: REACT_APP_ID,
};
var API_HEADERS_COMMON_CONFIG = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    userId: getUserEmailFromCookie(),
    appId: REACT_APP_ID,
    env: REACT_APP_ENV,
};
var replaceUrlVariables = function (url, params) {
    var latitude = params.latitude, longitude = params.longitude, _a = params.isLocationCXEnable, isLocationCXEnable = _a === void 0 ? false : _a;
    var _b = params.areaCode, areaCode = _b === void 0 ? '' : _b;
    areaCode = areaCode.split('&').join('%26');
    var regex = /[^{{}]+(?=}})/g;
    var matches = url.match(regex);
    var updatedParams = __assign$1(__assign$1({}, params), { areaCode: areaCode });
    var modifiedURL = url;
    if (matches) {
        matches.forEach(function (item) {
            var value = updatedParams[item];
            modifiedURL = modifiedURL.replace(new RegExp('{{' + item + '}}'), isExisty(value) || value === '' ? value : '');
        });
    }
    if (isLocationCXEnable || (latitude && longitude)) {
        var regExpEscape = function (url) {
            return url.replace(/[-[\]{}()*+!<=:?.\/\\^$|#\s,]/g, '\\$&');
        };
        var areaCodeRegex = new RegExp(regExpEscape('areaCode=' + areaCode), 'ig');
        var lat = getCustomCookie('lat');
        var long = getCustomCookie('long');
        modifiedURL = modifiedURL.replace(areaCodeRegex, "latitude=" + (lat || latitude) + "&longitude=" + (long || longitude));
    }
    return modifiedURL;
};
var updateURLForGuestSession = function (url, guid) {
    var updatedURL = url;
    updatedURL = updatedURL.replace('current', guid);
    return updatedURL;
};
var httpAgent = new http.Agent({ keepAlive: true });
var httpsAgent = new https.Agent({ keepAlive: true });
var updateRequestParamURL = function (requestUrl) {
    var guid = getGUID();
    if (guid) {
        return updateURLForGuestSession(requestUrl, guid);
    }
    return requestUrl;
};
var replaceApigeeBaseUrl = function (requestUrl) {
    var apigeeUrls = ['api-test.retailsso.com', 'api-prod.retailsso.com', 'api-dev.retailsso.com'];
    var isBaseApigeeurl = apigeeUrls.some(function (url) { return requestUrl.includes(url); });
    if (!isServer() && isBaseApigeeurl) {
        requestUrl = requestUrl.replace(/api-(test|dev|prod)\.retailsso\.com/, window.location.hostname);
    }
    return requestUrl;
};
var getApiBaseUrl = function (apiVersion) {
    if (apiVersion && isNumber(apiVersion)) {
        return "/v" + apiVersion;
    }
    return '/v2';
};
var networkRequest = (function (_a) {
    var requestUrl = _a.requestUrl, _b = _a.isAbsUrl, isAbsUrl = _b === void 0 ? false : _b, apiOptions = _a.apiOptions, _c = _a.apiVersion, apiVersion = _c === void 0 ? 2 : _c, excludeFromDefaultHeaders = _a.excludeFromDefaultHeaders, _d = _a.headers, headers = _d === void 0 ? {} : _d;
    return __awaiter$1(void 0, void 0, void 0, function () {
        var apiRequestURL, baseUrl, store, appConfig, userCredentials, language, storeId, isPolygonChange, guestAccessToken, _e, _f, authToken, _g, token, _h, userId, userToken, extraHeaders, deliveryAreaHeaders, posInfoConfig_1, deliveryTime, updatedDeliveryInfo, appStage, defaultCommonHeaders, isReplaceApigeeUrlEnabled, _j, data, exception_1;
        var _k, _l, _m, _o;
        return __generator$1(this, function (_p) {
            switch (_p.label) {
                case 0:
                    apiRequestURL = requestUrl;
                    if (!isAbsUrl) {
                        baseUrl = getApiBaseUrl(apiVersion);
                        axios.defaults.baseURL = process.env.STORYBOOK ? "" + process.env.APIGEE_ENDPOINT + baseUrl : baseUrl;
                    }
                    else {
                        axios.defaults.baseURL = '';
                    }
                    store = getStore();
                    appConfig = APP_CONFIG;
                    if (store) {
                        appConfig = store.getState().appConfig;
                    }
                    userCredentials = appConfig.userCredentials, language = appConfig.language, storeId = appConfig.storeId, isPolygonChange = appConfig.isPolygonChange;
                    guestAccessToken = appConfig.accessToken;
                    _e = userCredentials || {}, _f = _e.authToken, authToken = _f === void 0 ? '' : _f, _g = _e.token, token = _g === void 0 ? '' : _g, _h = _e.userId, userId = _h === void 0 ? '' : _h;
                    userToken = authToken || token;
                    userToken = userToken || getUserTokenFromCookie();
                    guestAccessToken = guestAccessToken || getGuestSessionToken();
                    extraHeaders = {};
                    deliveryAreaHeaders = {};
                    if (isPolygonChange) {
                        posInfoConfig_1 = ((_l = (_k = store.getState()) === null || _k === void 0 ? void 0 : _k.appConfig) === null || _l === void 0 ? void 0 : _l.posInfoConfig) || [''];
                        deliveryTime = (_m = store.getState()) === null || _m === void 0 ? void 0 : _m.deliveryTime;
                        updatedDeliveryInfo = deliveryTime === null || deliveryTime === void 0 ? void 0 : deliveryTime.deliveryAreaInfo.filter(function (item) {
                            return posInfoConfig_1.includes(item === null || item === void 0 ? void 0 : item.serviceType);
                        });
                        deliveryAreaHeaders = setDeliveryAreaInHeaders(updatedDeliveryInfo);
                    }
                    if (authToken || getUserTokenFromCookie()) {
                        extraHeaders = {
                            token: "Bearer " + (authToken || getUserTokenFromCookie()),
                        };
                    }
                    else {
                        extraHeaders = { token: userToken || guestAccessToken || '' };
                    }
                    appStage = process.env.APP_STAGE;
                    axios.defaults.headers.common = __assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1({}, API_HEADERS_COMMON_CONFIG), extraHeaders), { storeId: storeId, langCode: language || '', lang: language || '', userId: decodeStr(userId || getUserEmailFromCookie() || constants.guestUserID.toLowerCase()) }), headers), deliveryAreaHeaders), (appStage ? { 'x-maf-env': appStage } : {}));
                    if (!getUserTokenFromCookie()) {
                        apiRequestURL = updateRequestParamURL(requestUrl);
                    }
                    defaultCommonHeaders = axios.defaults.headers.common;
                    if (excludeFromDefaultHeaders) {
                        defaultCommonHeaders = Object.assign({}, defaultCommonHeaders);
                        excludeFromDefaultHeaders.forEach(function (key) {
                            delete defaultCommonHeaders[key];
                        });
                    }
                    axios.defaults.headers.common = defaultCommonHeaders;
                    isReplaceApigeeUrlEnabled = ((_o = getGrowthBookFeatureValueViaInstance(store.getState(), 'isapigeebaseurlenabled')) === null || _o === void 0 ? void 0 : _o.on) || false;
                    if (isReplaceApigeeUrlEnabled) {
                        apiRequestURL = replaceApigeeBaseUrl(apiRequestURL);
                    }
                    _p.label = 1;
                case 1:
                    _p.trys.push([1, 3, , 4]);
                    return [4 , axios.request(__assign$1({ url: apiRequestURL, timeout: 1000 * 15,
                            httpAgent: httpAgent,
                            httpsAgent: httpsAgent }, apiOptions))];
                case 2:
                    _j = (_p.sent()).data, data = _j === void 0 ? {} : _j;
                    return [2 , Promise.resolve({ data: data })];
                case 3:
                    exception_1 = _p.sent();
                    console.error('exception ', exception_1);
                    return [2 , Promise.reject(exception_1)];
                case 4: return [2 ];
            }
        });
    });
});
var GUEST_AUTH_TOKEN = "stores/{{StoreId}}/{{language}}/oauth/token";
var fetchGuestSessionToken = function () { return __awaiter$1(void 0, void 0, void 0, function () {
    var baseURL, StoreId, language, requestUrl, _a, access_token, expires_in, error_1;
    return __generator$1(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                baseURL = API_CONFIG.baseURL;
                StoreId = APP_CONFIG.storeId, language = APP_CONFIG.language;
                requestUrl = replaceUrlVariables(GUEST_AUTH_TOKEN, { StoreId: StoreId, language: language });
                axios.defaults.baseURL = process.env.STORYBOOK ? "" + process.env.APIGEE_ENDPOINT + baseURL.v2 : baseURL.v2;
                axios.defaults.headers.common = {
                    env: API_HEADERS_COMMON_CONFIG.env,
                    appId: API_HEADERS_COMMON_CONFIG.appId,
                };
                return [4 , axios.get(requestUrl)];
            case 1:
                _a = (_b.sent()).data, access_token = _a.access_token, expires_in = _a.expires_in;
                setGuestSessionToken(access_token, expires_in);
                return [3 , 3];
            case 2:
                error_1 = _b.sent();
                return [2 ];
            case 3: return [2 ];
        }
    });
}); };
var handleGuestSession = function () { return __awaiter$1(void 0, void 0, void 0, function () {
    return __generator$1(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(!getUserTokenFromCookie() && !getGuestSessionToken())) return [3 , 2];
                return [4 , fetchGuestSessionToken()];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 ];
        }
    });
}); };
var URLS_CONFIG = Object.freeze({
    get urlPrefix() {
        return "/" + APP_CONFIG.storeId + "/" + APP_CONFIG.language;
    },
});
var COOKIE_BANNER_PRIVACY_POLICY = URLS_CONFIG.urlPrefix + "/privacypolicy";
var PROFILE_PAGE = URLS_CONFIG.urlPrefix + "/profile";
var CART_PAGE = URLS_CONFIG.urlPrefix + "/cart";
var MY_ACCOUNT_BUY_AGAIN_PAGE = URLS_CONFIG.urlPrefix + "/buyAgain";
var EUrlParams;
(function (EUrlParams) {
    EUrlParams["EXPRESS"] = "express";
})(EUrlParams || (EUrlParams = {}));
var GTMEvents;
(function (GTMEvents) {
    GTMEvents["custom_event"] = "custom_event";
    GTMEvents["add_to_cart"] = "add_to_cart";
    GTMEvents["remove_from_cart"] = "remove_from_cart";
    GTMEvents["product_click"] = "product_click";
    GTMEvents["virtual_page_event"] = "virtual_page_event";
    GTMEvents["category_page_event"] = "category_page_event";
    GTMEvents["product_impressions"] = "product_impressions";
    GTMEvents["promotion_click"] = "promotion_click";
    GTMEvents["promotion_impressions"] = "promotion_impressions";
    GTMEvents["product_impression"] = "product_impression";
    GTMEvents["right_click"] = "right_click";
    GTMEvents["select_item"] = "select_item";
    GTMEvents["view_item_list"] = "view_item_list";
    GTMEvents["now_journey_custom_events"] = "now_journey_custom_events";
    GTMEvents["algolia_custom_events"] = "algolia_custom_events";
    GTMEvents["change_the_quantity"] = "change_the_quantity";
    GTMEvents["platform"] = "web";
    GTMEvents["viewed_experiment"] = "viewed_experiment";
})(GTMEvents || (GTMEvents = {}));
var BrazeEvents;
(function (BrazeEvents) {
    BrazeEvents["cart_count"] = "cart_count";
    BrazeEvents["add_to_cart"] = "add_to_cart";
    BrazeEvents["pdp_view"] = "pdp_view";
    BrazeEvents["search"] = "search";
    BrazeEvents["search_term"] = "search_term";
    BrazeEvents["search_type"] = "search_type";
    BrazeEvents["search_native"] = "search_native";
    BrazeEvents["trending_search"] = "trending_search";
    BrazeEvents["history_search"] = "history_search";
    BrazeEvents["search_suggested"] = "search_suggested";
    BrazeEvents["category_interaction"] = "category_interaction";
    BrazeEvents["category_id"] = "category_id";
    BrazeEvents["category_name"] = "category_name";
    BrazeEvents["all_categories"] = "All Categories";
    BrazeEvents["search_results"] = "search_results";
})(BrazeEvents || (BrazeEvents = {}));
var PromotionEvents;
(function (PromotionEvents) {
    PromotionEvents["promotion_click"] = "promotion_click";
    PromotionEvents["promotion_impressions"] = "promotion_impressions";
    PromotionEvents["view_promotion"] = "view_promotion";
    PromotionEvents["select_promotion"] = "select_promotion";
})(PromotionEvents || (PromotionEvents = {}));
var Events;
(function (Events) {
    Events["product_click"] = "product_click";
    Events["add_to_cart"] = "add_to_cart";
    Events["product_impression"] = "product_impression";
    Events["right_click"] = "right_click";
})(Events || (Events = {}));
var GTMEventCategories;
(function (GTMEventCategories) {
    GTMEventCategories["user_engagement"] = "user_engagement";
    GTMEventCategories["enhanced_ecommerce"] = "enhanced_ecommerce";
    GTMEventCategories["sign_up"] = "signup_flow";
    GTMEventCategories["user_authentication"] = "user_authentication";
})(GTMEventCategories || (GTMEventCategories = {}));
var GTMEventActions;
(function (GTMEventActions) {
    GTMEventActions["search_results"] = "search_results";
    GTMEventActions["search_no_results"] = "search_no_results";
    GTMEventActions["product_gallery_viewed"] = "product_gallery_viewed";
    GTMEventActions["listing_filters"] = "listing_filters";
    GTMEventActions["listing_sort"] = "listing_sort";
    GTMEventActions["reorder_click"] = "reorder_click";
    GTMEventActions["category_interaction"] = "category_interaction";
    GTMEventActions["header_interaction"] = "header_interaction";
    GTMEventActions["announcement_interaction"] = "announcement_interaction";
    GTMEventActions["category_results"] = "category_results";
    GTMEventActions["category_no_results"] = "category_no_results";
    GTMEventActions["component_interaction"] = "component_interaction";
    GTMEventActions["search_facets"] = "search_facets";
    GTMEventActions["category_facets"] = "category_facets";
    GTMEventActions["reorder_search"] = "reorder_search";
    GTMEventActions["reorder_category"] = "reorder_category";
    GTMEventActions["login"] = "login";
    GTMEventActions["inline_filter"] = "inline_filter";
    GTMEventActions["marketing_strip_impression"] = "strip_header_impression";
    GTMEventActions["share_clicked"] = "share_clicked";
    GTMEventActions["product_click_notify_later"] = "product_click_notify_later";
    GTMEventActions["add_to_cart"] = "add_to_cart";
    GTMEventActions["remove_from_cart"] = "remove_from_cart";
    GTMEventActions["product_click"] = "product_click";
    GTMEventActions["product_impressions"] = "product_impressions";
    GTMEventActions["value_proposition_click"] = "value_proposition_click";
    GTMEventActions["got_it_click"] = "got_it_click";
    GTMEventActions["shop_now_click"] = "shop_now_click";
    GTMEventActions["shop_all_items_clicked"] = "shop_all_items_clicked";
    GTMEventActions["search_initiate"] = "search_initiate";
    GTMEventActions["first_user_coupon_banner_clicked"] = "first_user_coupon_banner_clicked";
    GTMEventActions["registration"] = "registration";
    GTMEventActions["fyc_icon_interaction"] = "fyc_icon_interaction";
    GTMEventActions["journey_selection_tab"] = "journey_selection_tab";
    GTMEventActions["address_icon_interaction"] = "address_icon_interaction";
    GTMEventActions["see_all_click"] = "see_all_click";
    GTMEventActions["change_address_done"] = "change_address_done";
    GTMEventActions["authentication"] = "authentication";
    GTMEventActions["email_login_password"] = "email_login_password";
    GTMEventActions["email_login_otp"] = "email_login_otp";
    GTMEventActions["signup"] = "signup";
    GTMEventActions["profile_interaction"] = "profile_interaction";
})(GTMEventActions || (GTMEventActions = {}));
var GTMNowJourneyEventTypes;
(function (GTMNowJourneyEventTypes) {
    GTMNowJourneyEventTypes["interaction"] = "interaction";
    GTMNowJourneyEventTypes["non_interaction"] = "non-interaction";
})(GTMNowJourneyEventTypes || (GTMNowJourneyEventTypes = {}));
var GTMEventLabels;
(function (GTMEventLabels) {
    GTMEventLabels["change_address_click"] = "change_address_click";
})(GTMEventLabels || (GTMEventLabels = {}));
var GTMBusyStateLabels;
(function (GTMBusyStateLabels) {
    GTMBusyStateLabels["busy_state_cta"] = "busy_state_cta";
    GTMBusyStateLabels["offline_state_cta"] = "offline_state_cta";
    GTMBusyStateLabels["busy_state"] = "busy_state";
    GTMBusyStateLabels["offline_state"] = "offline_state";
})(GTMBusyStateLabels || (GTMBusyStateLabels = {}));
var GTMNowJourneyLabels;
(function (GTMNowJourneyLabels) {
    GTMNowJourneyLabels["now_delivery"] = "now_delivery";
    GTMNowJourneyLabels["standard_delivery"] = "standard_delivery";
    GTMNowJourneyLabels["all_items"] = "all_items";
    GTMNowJourneyLabels["now_items"] = "now_items";
    GTMNowJourneyLabels["native_search"] = "Native Search";
    GTMNowJourneyLabels["both_tab_shown"] = "both_tab_shown";
    GTMNowJourneyLabels["not_shown"] = "not_shown";
    GTMNowJourneyLabels["new_journey_tab_impression"] = "new_journey_tab_impression";
})(GTMNowJourneyLabels || (GTMNowJourneyLabels = {}));
var LoggedInStatusVariants;
(function (LoggedInStatusVariants) {
    LoggedInStatusVariants["true"] = "1";
    LoggedInStatusVariants["false"] = "0";
})(LoggedInStatusVariants || (LoggedInStatusVariants = {}));
var NavigationMenuTypes;
(function (NavigationMenuTypes) {
    NavigationMenuTypes["horizontal_menu"] = "horizontal_menu";
    NavigationMenuTypes["all_category_menu"] = "all_category_menu";
})(NavigationMenuTypes || (NavigationMenuTypes = {}));
var debounce = (function (func, wait, immediate) {
    if (immediate === void 0) { immediate = false; }
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        var later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
});
var snakeCaseRegex = /\s+/g;
var productImpressions = {
    uaItemsList: [],
    ga4ItemsList: [],
};
var cashedproductImpressions = {
    uaItemsList: [],
    ga4ItemsList: [],
};
var promotionImpressions = {
    uaPromotionItemsList: [],
    ga4PromotionItemsList: [],
};
var cashedPromotionImpressions = {
    uaPromotionItemsList: [],
    ga4PromotionItemsList: [],
};
var previousJourneySelection = '';
var cachedImpressions = [];
var toSnakeCase = function (str) { return str.trim().replace(snakeCaseRegex, '_'); };
var gtmSnakeCase = function (data) {
    if (isBoolean(data)) {
        if (data) {
            return 1;
        }
        return 0;
    }
    if (!isObject(data) && !isString(data)) {
        return data;
    }
    if (isString(data)) {
        return toSnakeCase(data);
    }
    if (data instanceof Array) {
        return data.map(function (obj) { return gtmSnakeCase(obj); });
    }
    var snakeCaseObj = {};
    if (data) {
        Object.keys(data).forEach(function (key) {
            var currentValue = data[key];
            if (key === 'currencyCode') {
                snakeCaseObj[key] = currentValue;
            }
            else {
                snakeCaseObj[key] = isString(currentValue) ? toSnakeCase(currentValue) : gtmSnakeCase(currentValue);
            }
        });
    }
    return snakeCaseObj;
};
var gtmAddToCart = function (data, sharedData, ga4) {
    if (ga4 === void 0) { ga4 = false; }
    if (!ga4) {
        dataLayer.push(__assign$1(__assign$1({ event: GTMEvents.add_to_cart }, sharedData), { ecommerce: {
                add: {
                    actionField: {
                        list: (sharedData === null || sharedData === void 0 ? void 0 : sharedData.screen_type) + "|" + (data === null || data === void 0 ? void 0 : data.dimension103),
                        position: data === null || data === void 0 ? void 0 : data.position,
                    },
                    products: [gtmSnakeCase(data)],
                },
            } }));
    }
    else {
        dataLayer.push(__assign$1(__assign$1({ event: GTMEvents.add_to_cart }, sharedData), { ecommerce: {
                items: [gtmSnakeCase(data)],
            } }));
    }
};
var gtmRemoveToCart = function (data, sharedData, ga4) {
    if (ga4 === void 0) { ga4 = false; }
    if (!ga4) {
        dataLayer.push(__assign$1(__assign$1({ event: GTMEvents.remove_from_cart }, sharedData), { ecommerce: {
                remove: {
                    actionField: {
                        list: (sharedData === null || sharedData === void 0 ? void 0 : sharedData.screen_type) + "|" + (data === null || data === void 0 ? void 0 : data.dimension103),
                        position: data === null || data === void 0 ? void 0 : data.position,
                    },
                    products: [gtmSnakeCase(data)],
                },
            } }));
    }
    else {
        dataLayer.push(__assign$1(__assign$1({ event: GTMEvents.remove_from_cart }, sharedData), { ecommerce: {
                items: [gtmSnakeCase(data)],
            } }));
    }
};
var gtmCustomEvent = function (eventCategory, eventAction, eventLabel, extraObj, sharedData, pageData, pos_code, event_type, journey_selection, customEventNonFoodJourneyParams, ga4) {
    if (eventCategory === void 0) { eventCategory = GTMEventCategories.user_engagement; }
    dataLayer.push(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1({ event: GTMEvents.custom_event, event_category: eventCategory, event_action: eventAction, event_label: eventLabel }, sharedData), gtmSnakeCase(extraObj)), pageData), { pos_code: pos_code,
        event_type: event_type,
        journey_selection: journey_selection }), customEventNonFoodJourneyParams), { ga4: ga4 }));
};
var gtmPromotionClick = function (eventType, sharedData, promotionData, ga4) {
    if (ga4) {
        dataLayer.push(__assign$1(__assign$1({ event: PromotionEvents.select_promotion }, sharedData), { ga4: ga4, ecommerce: {
                items: [
                    __assign$1({}, promotionData),
                ],
            } }));
    }
    else {
        dataLayer.push(__assign$1(__assign$1({ event: eventType }, sharedData), { ga4: ga4, ecommerce: {
                promoView: __assign$1({}, promotionData),
            } }));
    }
};
var gtmProductClick = function (data, actionField, sharedData, ga4) {
    if (ga4 === void 0) { ga4 = false; }
    if (data && actionField && !ga4) {
        var snakeCaseData = gtmSnakeCase(data);
        dataLayer.push(__assign$1(__assign$1({ event: GTMEvents.product_click }, sharedData), { ecommerce: {
                click: {
                    actionField: __assign$1(__assign$1({}, actionField), { list: snakeCaseData === null || snakeCaseData === void 0 ? void 0 : snakeCaseData.list }) || '',
                    products: [snakeCaseData],
                },
            } }));
    }
    else {
        dataLayer.push(__assign$1(__assign$1({ event: GTMEvents.select_item }, sharedData), { ecommerce: {
                items: [gtmSnakeCase(data)],
            } }));
    }
};
var gtmVirtualPage = function (pageTitle, sharedData) {
    dataLayer.push(__assign$1({ event: GTMEvents.virtual_page_event, virtual_page_url: typeof window !== 'undefined' ? window.location.href : '', virtual_page_title: pageTitle || '' }, sharedData));
};
var gtmCategoryPage = function (l1Category, l2Category, l3Category, sharedData) {
    dataLayer.push(__assign$1({ event: GTMEvents.category_page_event, L1_category: l1Category || '', L2_category: l2Category || '', L3_category: l3Category || '' }, sharedData));
};
var gtmPromotionImpression = function (eventType, sharedData, promotionData, ga4) {
    if (promotionData) {
        if (ga4) {
            var passedData = promotionImpressions.ga4PromotionItemsList.filter(function (promotion) { return promotion.id === promotionData.id; });
            var cashedData = cashedPromotionImpressions.ga4PromotionItemsList.filter(function (promotion) { return promotion.id === promotionData.id; });
            if (passedData.length === 0 && cashedData.length === 0) {
                promotionImpressions.ga4PromotionItemsList.push(promotionData);
            }
            pushGAPromotionImpression(sharedData);
        }
        else {
            var passedData = promotionImpressions.uaPromotionItemsList.filter(function (promotion) { return promotion.id === promotionData.id; });
            var cashedData = cashedPromotionImpressions.uaPromotionItemsList.filter(function (promotion) { return promotion.id === promotionData.id; });
            if (passedData.length === 0 && cashedData.length === 0) {
                promotionImpressions.uaPromotionItemsList.push(promotionData);
            }
            pushUAPromotionImpression(eventType, sharedData);
        }
    }
};
var pushUAPromotionImpression = function (eventType, sharedData) {
    debounce(function () {
        var _a;
        while (promotionImpressions.uaPromotionItemsList.length > 0) {
            dataLayer.push(__assign$1(__assign$1({ event: eventType }, sharedData), { ga4: 'false', ecommerce: {
                    promoView: {
                        promotions: promotionImpressions.uaPromotionItemsList.slice(0, 25),
                    },
                } }));
            (_a = cashedPromotionImpressions.uaPromotionItemsList).push.apply(_a, __spread$1(promotionImpressions.uaPromotionItemsList.slice(0, 25)));
            promotionImpressions.uaPromotionItemsList.splice(0, 25);
        }
    }, 1000)();
};
var pushGAPromotionImpression = function (sharedData) {
    debounce(function (sharedData) {
        var _a;
        while (promotionImpressions.ga4PromotionItemsList.length > 0) {
            var items = promotionImpressions.ga4PromotionItemsList.slice(0, 25).map(function (item) { return ({
                creative_name: item.creative,
                creative_slot: item.position || '',
                index: item.position,
                item_list_name: '',
                promotion_id: item.id,
                promotion_name: item.name,
            }); });
            dataLayer.push(__assign$1(__assign$1({ event: PromotionEvents.view_promotion, ga4: 'true' }, sharedData), { ecommerce: {
                    items: items,
                } }));
            (_a = cashedPromotionImpressions.ga4PromotionItemsList).push.apply(_a, __spread$1(promotionImpressions.ga4PromotionItemsList.slice(0, 25)));
            promotionImpressions.ga4PromotionItemsList.splice(0, 25);
        }
    }, 1000)(sharedData);
};
var gtmProductImpression = function (data, sharedData, ga4) {
    if (ga4 === void 0) { ga4 = false; }
    var currentJourneySelection = sharedData && (sharedData === null || sharedData === void 0 ? void 0 : sharedData.journey_selection) ? sharedData.journey_selection : '';
    if (data) {
        if (ga4) {
            var passedData = productImpressions.ga4ItemsList.filter(function (product) { return product.item_id === data.item_id; });
            var cashedData = cashedproductImpressions.ga4ItemsList.filter(function (product) {
                return product.item_id === data.item_id && previousJourneySelection === currentJourneySelection;
            });
            if (passedData.length === 0 && cashedData.length === 0) {
                productImpressions.ga4ItemsList.push(gtmSnakeCase(data));
            }
            pushGA4ProductImpression(sharedData, currentJourneySelection);
        }
        else {
            var passedData = productImpressions.uaItemsList.filter(function (product) { return product.id === data.id; });
            var cashedData = cashedproductImpressions.uaItemsList.filter(function (product) { return product.id === data.id && previousJourneySelection === currentJourneySelection; });
            if (passedData.length === 0 && cashedData.length === 0) {
                productImpressions.uaItemsList.push(gtmSnakeCase(data));
            }
            pushUAProductImpression(sharedData, currentJourneySelection);
        }
    }
};
var pushUAProductImpression = function (sharedData, currentJourneySelection) {
    debounce(function () {
        while (productImpressions.uaItemsList.length > 0) {
            previousJourneySelection = currentJourneySelection;
            dataLayer.push(__assign$1(__assign$1({ event: GTMEvents.product_impressions }, sharedData), { ecommerce: {
                    impressions: productImpressions.uaItemsList.slice(0, 25),
                } }));
            cashedproductImpressions.uaItemsList.push(productImpressions.uaItemsList.slice(0, 25));
            productImpressions.uaItemsList.splice(0, 25);
        }
    }, 1000)();
};
var pushGA4ProductImpression = function (sharedData, currentJourneySelection) {
    debounce(function (sharedData) {
        while (productImpressions.ga4ItemsList.length > 0) {
            previousJourneySelection = currentJourneySelection;
            dataLayer.push(__assign$1(__assign$1({ event: GTMEvents.view_item_list }, sharedData), { ecommerce: {
                    items: productImpressions.ga4ItemsList.slice(0, 25),
                } }));
            cashedproductImpressions.ga4ItemsList.push(productImpressions.ga4ItemsList.slice(0, 25));
            productImpressions.ga4ItemsList.splice(0, 25);
        }
    }, 1000)(sharedData);
};
var isImpressionTracked = function (productCard) {
    var cachedData = cachedImpressions.filter(function (product) { return product.sponsorID === productCard.sponsorID; });
    if (cachedData.length === 0) {
        cachedImpressions.push(productCard);
        return false;
    }
    return true;
};
var nowJourneyCustomEvents = function (eventCategory, eventAction, eventLabel, event_type, journey_selection, pageData) {
    if (eventCategory === void 0) { eventCategory = GTMEventCategories.user_engagement; }
    dataLayer.push(__assign$1(__assign$1({}, pageData), { event: GTMEvents.custom_event, event_category: eventCategory, event_action: eventAction, event_label: eventLabel, event_type: event_type,
        journey_selection: journey_selection }));
};
var algoliaServiceGAEvent = function (experiment_key, variation_id, pageData) {
    dataLayer.push({
        event: 'viewed_experiment',
        params: {
            experiment_key: experiment_key,
            variation_value: '',
            variation_id: variation_id,
            currency: pageData === null || pageData === void 0 ? void 0 : pageData.currency,
            language: pageData === null || pageData === void 0 ? void 0 : pageData.language,
        },
    });
};
var getSearchIntent = function (pageIntent, deliveryTime, selectedTabIndex, isSearchPage) {
    var _a, _b, _c, _d;
    if (isSearchPage === void 0) { isSearchPage = false; }
    var intent = '';
    if (pageIntent) {
        var isNowJourney = isBrowser() && getNowJourneyCookie() === 'true' && !!(deliveryTime === null || deliveryTime === void 0 ? void 0 : deliveryTime.expressSlot);
        var nowSelected = selectedTabIndex === 1 || isNowJourney;
        var isOfflineHours = ((_b = (_a = deliveryTime === null || deliveryTime === void 0 ? void 0 : deliveryTime.expressSlot) === null || _a === void 0 ? void 0 : _a.busyStatus) === null || _b === void 0 ? void 0 : _b.isBusy) ||
            (!((_c = deliveryTime === null || deliveryTime === void 0 ? void 0 : deliveryTime.expressSlot) === null || _c === void 0 ? void 0 : _c.isAvailable) && ((_d = deliveryTime === null || deliveryTime === void 0 ? void 0 : deliveryTime.expressSlot) === null || _d === void 0 ? void 0 : _d.nextAvailableSlot));
        if (nowSelected && (isSearchPage || !isOfflineHours)) {
            intent = 'NOW';
        }
        else {
            intent = 'STANDARD';
        }
    }
    return intent;
};
var extractServiceInfoFromCookie = function () {
    var _a = getSelectedTabData(), serviceType = _a.serviceType, productType = _a.productType;
    return { serviceType: serviceType, productType: productType };
};
var extractSelectedTabFromCookie = function () {
    var selectedTabId = getSelectedTabData().selectedTabId;
    return Number(selectedTabId) || -1;
};
var isServiceTypeAny = function (pageStructure, selectedTab) {
    if (pageStructure === void 0) { pageStructure = []; }
    if (selectedTab === void 0) { selectedTab = -1; }
    var selectedId = selectedTab;
    if (typeof selectedTab === undefined) {
        selectedId = extractSelectedTabFromCookie();
    }
    return pageStructure.some(function (_a) {
        var _b = _a.serviceType, serviceType = _b === void 0 ? '' : _b, id = _a.id;
        return serviceType === IServiceInfo.ANY && id === selectedId;
    });
};
var getIntentAndServiceType = function (pageStructure, selectedTab) {
    if (pageStructure === void 0) { pageStructure = []; }
    var intentHeaders = {};
    if (!isBrowser() && selectedTab) {
        var _a = (pageStructure === null || pageStructure === void 0 ? void 0 : pageStructure.find(function (navigation) { return navigation.id === selectedTab; })) || (pageStructure === null || pageStructure === void 0 ? void 0 : pageStructure[0]), _b = _a.serviceType, serviceType = _b === void 0 ? '' : _b, _c = _a.productType, productType = _c === void 0 ? '' : _c;
        intentHeaders = { intent: serviceType, productType: productType };
    }
    else {
        var _d = extractServiceInfoFromCookie() || pageStructure, serviceType = _d.serviceType, productType = _d.productType;
        intentHeaders = { intent: serviceType, productType: productType };
    }
    return intentHeaders;
};
var getBasketIntentOnCookieBasis = function (isOfflineHours) {
    var isNowJourney = getNowJourneyCookie();
    return isNowJourney === 'true' && !isOfflineHours ? 'EXPRESS' : '';
};
var evaluateBasketIntent = function (shouldSendIntent, isOfflineHours) {
    var intent = {};
    if (shouldSendIntent) {
        var intentValue = getBasketIntentOnCookieBasis(isOfflineHours);
        intent = intentValue
            ? {
                intent: intentValue,
            }
            : {};
    }
    return intent;
};
var getBasketIntent = function (state, selectedIntent) {
    var _a, _b;
    if (selectedIntent) {
        return { intent: selectedIntent };
    }
    var shouldSendIntent = !!state.appConfig.pageIntent;
    var isOfflineHours = !!((_b = (_a = state === null || state === void 0 ? void 0 : state.deliveryTime) === null || _a === void 0 ? void 0 : _a.expressSlot) === null || _b === void 0 ? void 0 : _b.nextAvailableSlot) || false;
    return evaluateBasketIntent(shouldSendIntent, isOfflineHours);
};
var isNewC4Journey = function (state) {
    var _a;
    var newJourney = getGrowthBookFeatureValueViaInstance(state, 'new_carrefour_journey');
    return ((_a = newJourney === null || newJourney === void 0 ? void 0 : newJourney.value) === null || _a === void 0 ? void 0 : _a.new_journey) || false;
};
var isAdTechCriteoEnabled = function (state) {
    var adTechCretio = getGrowthBookFeatureValueViaInstance(state, GROWTHBOOK_FLAGS.adtechCriteo);
    return (adTechCretio === null || adTechCretio === void 0 ? void 0 : adTechCretio.on) || false;
};
var isNonFoodV2Enabled = function (state) {
    var _a;
    var _b = (((_a = getGrowthBookFeatureValueViaInstance(state, GROWTHBOOK_FLAGS.non_food_v2)) === null || _a === void 0 ? void 0 : _a.value) || {}).pageStructureUid, pageStructureUid = _b === void 0 ? '' : _b;
    return { value: !!pageStructureUid || false, pageStructureUid: pageStructureUid };
};
var isStoreClosureEnabled = function (state) {
    var _a;
    return ((_a = getGrowthBookFeatureValueViaInstance(state, GROWTHBOOK_FLAGS.store_closure_enabled)) === null || _a === void 0 ? void 0 : _a.on) || false;
};
var newC4Journey_util = Object.freeze({
    __proto__: null,
    getSearchIntent: getSearchIntent,
    extractServiceInfoFromCookie: extractServiceInfoFromCookie,
    extractSelectedTabFromCookie: extractSelectedTabFromCookie,
    isServiceTypeAny: isServiceTypeAny,
    getIntentAndServiceType: getIntentAndServiceType,
    getBasketIntent: getBasketIntent,
    isNewC4Journey: isNewC4Journey,
    isAdTechCriteoEnabled: isAdTechCriteoEnabled,
    isNonFoodV2Enabled: isNonFoodV2Enabled,
    isStoreClosureEnabled: isStoreClosureEnabled
});
var getListName = function (listName, currentPageType, category) {
    var listData = listName === null || listName === void 0 ? void 0 : listName.split('|')[1];
    if (listName === null || listName === void 0 ? void 0 : listName.includes(constants.sponsoredListing)) {
        return listName;
    }
    if (currentPageType === constants.productSearch) {
        return "productSearch|" + listData;
    }
    if (currentPageType === constants.categorySearch) {
        return "category|" + category;
    }
    if (currentPageType === constants.home) {
        return (listName === null || listName === void 0 ? void 0 : listName.includes(constants.multiLevelCarousel)) ? listName : "carousel|" + listName;
    }
    if (currentPageType === constants.productDetails) {
        return "product_details|" + listName;
    }
    if (currentPageType === constants.cart) {
        return "cart|" + listName;
    }
    if (currentPageType === constants.reOrder) {
        return listName || 'BuyAgain';
    }
    return '';
};
var getJourneySelectionParams = function (journey_selection, prefix) {
    var _a, _b;
    if (journey_selection === void 0) { journey_selection = ''; }
    if (prefix === void 0) { prefix = ''; }
    var _c = extractServiceInfoFromCookie(), serviceType = _c.serviceType, productType = _c.productType;
    if (serviceType || productType) {
        return _a = {},
            _a[prefix + "product_type"] = productType.toLowerCase(),
            _a[prefix + "service_type"] = serviceType.toLowerCase(),
            _a[prefix + "journey_selection"] = (serviceType + "_" + productType).toLowerCase(),
            _a;
    }
    else
        return _b = {},
            _b[prefix + "journey_selection"] = journey_selection,
            _b;
};
var cookies$1 = new Cookies();
var GTMDataTransformer =  (function () {
    function GTMDataTransformer() {
        this.pageGTMData = function (pageData) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var market = pageData.market, language = pageData.language, currency = pageData.currency, areaCode = pageData.areaCode, selectedCity = pageData.selectedCity, loggedInStatus = pageData.loggedInStatus,
            userHashedEmail = pageData.userHashedEmail, userLoyaltyPoint = pageData.userLoyaltyPoint, myClubId = pageData.myClubId, email = pageData.email, defaultAddress = pageData.defaultAddress,
            userFirstTransaction = pageData.userFirstTransaction, storeId = pageData.storeId;
            var pageType = getPageType();
            var pathname = (typeof window !== 'undefined' && window.location.pathname) || '';
            var clpId = pathname.split('/').find(function (ele) { return ele.includes('clp_'); });
            var blpId = pathname.split('/').pop();
            var isLoggedIn = loggedInStatus === LoggedInStatusVariants.true;
            var isPdpPlpClpHome = [
                constants.home,
                constants.categoryLandingPage,
                constants.brandLandingPage,
                constants.productSearch,
                constants.categorySearch,
                constants.productDetails,
            ].includes(pageType);
            var pageInfo = {};
            if (pageType === constants.categorySearch && isBrowser()) {
                var bredCrumb = (_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.__NEXT_DATA__) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.initialState) === null || _c === void 0 ? void 0 : _c.search) === null || _d === void 0 ? void 0 : _d.breadCrumb;
                if (Array.isArray(bredCrumb)) {
                    pageInfo.l1_category = ((_e = bredCrumb[0]) === null || _e === void 0 ? void 0 : _e.name) || '';
                    pageInfo.l2_category = ((_f = bredCrumb[1]) === null || _f === void 0 ? void 0 : _f.name) || '';
                    pageInfo.l3_category = ((_g = bredCrumb[2]) === null || _g === void 0 ? void 0 : _g.name) || '';
                }
            }
            return __assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1({ market: market || storeId, language: language,
                currency: currency, business_type: 'B2C', logged_in_status: isLoggedIn ? 'true' : 'false', first_transaction: userFirstTransaction || 'false', delivery_city: selectedCity || ((_h = defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.country) === null || _h === void 0 ? void 0 : _h.name), delivery_area_code: areaCode, page_url: typeof window !== 'undefined' ? window.location.href : '', screen_type: GTMDataTransformer.getPageType(pageType), screen_name: GTMDataTransformer.getScreenName(pageType) }, (isLoggedIn && { my_club_member_id: myClubId || '' })), (isLoggedIn && { loyalty_point: userLoyaltyPoint || '' })), (isLoggedIn && { hashed_email: cookies$1.get(constants.rrUserId) || email || userHashedEmail })), (isPdpPlpClpHome && { screen_type_sessionDimension: GTMDataTransformer.getPageType(pageType) })), (pageType === constants.home && { home_pageview: 1 })), (pageType === constants.categoryLandingPage && { clp_pageview: 1 })), (pageType === constants.brandLandingPage && { blp_pageview: 1 })), ((pageType === constants.categorySearch || pageType === constants.productSearch) && { plp_pageview: 1 })), (pageType === constants.productDetails && { pdp_pageview: 1 })), (pageType === constants.categoryLandingPage && { clp: clpId })), (pageType === constants.brandLandingPage && { blp: blpId })), pageInfo);
        };
        this.getGTMData = function (eventType, eventData) {
            var _a, _b, _c, _d, _e, _f, _g;
            var productState = eventData.productState, otherData = eventData.otherData;
            var countryCode = eventData.otherData.countryCode;
            var _h = __assign$1(__assign$1({}, productState), otherData), productId = _h.productId, _j = _h.listName, listName = _j === void 0 ? '' : _j, eventAction = _h.eventAction, searchKeyword = _h.searchKeyword, searchCount = _h.searchCount, categoryId = _h.categoryId, pageTitle = _h.pageTitle, l1Category = _h.l1Category, l2Category = _h.l2Category, l3Category = _h.l3Category, quantity = _h.quantity, sortValue = _h.sortValue, _k = _h.searchType, searchType = _k === void 0 ? '' : _k, filterValue = _h.filterValue, inlineFilterData = _h.inlineFilterData, productTitle = _h.productTitle, listingFilterData = _h.listingFilterData,
            superCategory = _h.superCategory, mainCategory = _h.mainCategory, subCategory = _h.subCategory,
            componentPosition = _h.componentPosition, componentName = _h.componentName, componentSlot = _h.componentSlot, _l = _h.eventLabel, eventLabel = _l === void 0 ? '' : _l, _m = _h.pageData, pageData = _m === void 0 ? {} : _m, pageType = _h.pageType, posInfo = _h.posInfo, ga4 = _h.ga4, isAvailable = _h.isAvailable, isScalable = _h.isScalable, event_type = _h.event_type, _o = _h.category, category = _o === void 0 ? '' : _o, _p = _h.experiment_key, experiment_key = _p === void 0 ? '' : _p, _q = _h.variation_id, variation_id = _q === void 0 ? '' : _q, _r = _h.discount, discount = _r === void 0 ? '' : _r, _s = _h.value, value = _s === void 0 ? '' : _s, _t = _h.price, price = _t === void 0 ? '' : _t, _u = _h.scalable_weight, scalable_weight = _u === void 0 ? '' : _u;
            var GTMData = {};
            var pageUrl = typeof window !== 'undefined' ? window.location.href : '';
            var searchTypeVals = ['search_suggested', 'trending_search', 'search_history'];
            var search_type_value = searchTypeVals.includes(searchType) ? 'suggested' : 'native';
            var decodeSearchKeyword = decodeStr(searchKeyword);
            var _v = __read$1(APP_CONFIG.__cookie__.storeInfoCookieValue, 3), storeid = _v[0], language = _v[1], currency = _v[2];
            var pathname = (typeof window !== 'undefined' && window.location.pathname) || '';
            var clpId = pathname.split('/').find(function (ele) { return ele.includes('clp_'); }) || '';
            var search;
            GTMData.eventData = {};
            GTMData.customEventNonFoodJourneyParams = {};
            if (pageType === 'productsearch' && isBrowser()) {
                search = window.localStorage.getItem('searchKeyword') || '';
            }
            var sharedData = __assign$1(__assign$1({ market: storeid, page_url: pageUrl, screen_type: GTMDataTransformer.getPageType(pageType || ''), screen_name: GTMDataTransformer.getScreenName(pageType || '') }, (search && {
                search_keyword: JSON.parse(search),
            })), { ga4: ga4 ? 'true' : 'false' });
            if (ga4) {
                GTMData.eventData.stock_status = isAvailable ? 'true' : 'false';
                GTMData.eventData.currency = currency;
                GTMData.eventData.module_name = 'c4_main';
                GTMData.eventData.language = language;
            }
            if (pageType === constants.categorySearch && isBrowser()) {
                var bredCrumb = (_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.__NEXT_DATA__) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.initialState) === null || _c === void 0 ? void 0 : _c.search) === null || _d === void 0 ? void 0 : _d.breadCrumb;
                if (Array.isArray(bredCrumb)) {
                    GTMData.eventData.l1_category = ((_e = bredCrumb[0]) === null || _e === void 0 ? void 0 : _e.name) || '';
                    GTMData.eventData.l2_category = ((_f = bredCrumb[1]) === null || _f === void 0 ? void 0 : _f.name) || '';
                    GTMData.eventData.l3_category = ((_g = bredCrumb[2]) === null || _g === void 0 ? void 0 : _g.name) || '';
                }
            }
            if (pageType === constants.categorySearch) {
                if (l1Category)
                    GTMData.eventData.l1_category = l1Category;
                if (l2Category)
                    GTMData.eventData.l2_category = l2Category;
                if (l3Category)
                    GTMData.eventData.l3_category = l3Category;
            }
            if (decodeSearchKeyword)
                GTMData.eventData.search_keyword = decodeSearchKeyword;
            var new_journey_selection = getNowJourneyCookie()
                ? GTMNowJourneyLabels.now_items
                : GTMNowJourneyLabels.all_items;
            GTMData.eventData.journey_selection = new_journey_selection;
            GTMData.eventData.screen_name = GTMDataTransformer.getScreenName(pageType || '');
            GTMData.eventData.screen_type = GTMDataTransformer.getPageType(pageType || '');
            if (ga4 && eventType !== GTMEvents.add_to_cart && eventType !== GTMEvents.remove_from_cart) {
                GTMData.eventData.scalable_weights = isScalable ? quantity + "gms" : '';
            }
            switch (eventType) {
                case GTMEvents.product_click:
                    if (!ga4) {
                        GTMData.actionField = { list: listName || '', action: 'click' };
                        GTMData.data = GTMDataTransformer.productGTMData(productState, eventType);
                        GTMData.eventData = __assign$1(__assign$1(__assign$1({ event_category: GTMEventCategories.enhanced_ecommerce, event_action: GTMEventActions.product_click, event_label: listName }, sharedData), GTMData.eventData), { journey_selection: new_journey_selection, event_type: GTMNowJourneyEventTypes.interaction });
                    }
                    else {
                        GTMData.data = __assign$1(__assign$1({}, GTMDataTransformer.productGTMData(productState, eventType, ga4, countryCode)), { quantity: quantity });
                        GTMData.eventData = __assign$1(__assign$1(__assign$1(__assign$1({ event_category: GTMEventCategories.enhanced_ecommerce, event_action: GTMEventActions.product_click, event_label: !ga4 ? productId : productId + "_" + countryCode }, sharedData), GTMData.eventData), getJourneySelectionParams(new_journey_selection)), { event_type: GTMNowJourneyEventTypes.interaction });
                    }
                    break;
                case GTMEvents.product_impressions:
                    if (ga4) {
                        GTMData.data = GTMDataTransformer.productGTMData(productState, eventType, ga4, countryCode);
                        GTMData.eventData = __assign$1(__assign$1(__assign$1(__assign$1({ event_category: GTMEventCategories.enhanced_ecommerce, event_action: GTMEventActions.product_impressions, event_label: getListName(listName, pageType, category) }, sharedData), GTMData.eventData), getJourneySelectionParams(new_journey_selection)), { event_type: GTMNowJourneyEventTypes.non_interaction });
                    }
                    else {
                        GTMData.data = GTMDataTransformer.productGTMData(productState, eventType);
                        GTMData.eventData = __assign$1(__assign$1(__assign$1({ event_category: GTMEventCategories.enhanced_ecommerce, event_action: GTMEventActions.product_impressions, event_label: listName }, sharedData), GTMData.eventData), { journey_selection: new_journey_selection, event_type: GTMNowJourneyEventTypes.non_interaction });
                    }
                    break;
                case GTMEvents.virtual_page_event:
                    GTMData.pageTitle = pageTitle || '';
                    break;
                case GTMEvents.category_page_event:
                    GTMData.l1Category = l1Category || '';
                    GTMData.l2Category = l2Category || '';
                    GTMData.l3Category = l3Category || '';
                    break;
                case GTMEvents.add_to_cart:
                    GTMData.data = __assign$1(__assign$1({}, GTMDataTransformer.productGTMData(productState, eventType, ga4, countryCode)), { quantity: quantity,
                        discount: discount,
                        price: price,
                        scalable_weight: scalable_weight });
                    GTMData.eventData = __assign$1(__assign$1(__assign$1(__assign$1({ value: value, event_category: GTMEventCategories.enhanced_ecommerce, event_action: GTMEventActions.add_to_cart, event_label: !ga4 ? productId : productId + "_" + countryCode }, sharedData), GTMData.eventData), getJourneySelectionParams(new_journey_selection)), { currency: currency, event_type: GTMNowJourneyEventTypes.interaction });
                    break;
                case GTMEvents.remove_from_cart:
                    GTMData.data = __assign$1(__assign$1({}, GTMDataTransformer.productGTMData(productState, eventType, ga4, countryCode)), { quantity: quantity,
                        discount: discount,
                        price: price,
                        scalable_weight: scalable_weight });
                    GTMData.eventData = __assign$1(__assign$1(__assign$1(__assign$1({ event_category: GTMEventCategories.enhanced_ecommerce, value: value, event_action: GTMEventActions.remove_from_cart, event_label: !ga4 ? productId : productId + "_" + countryCode }, sharedData), GTMData.eventData), getJourneySelectionParams(new_journey_selection)), { event_type: GTMNowJourneyEventTypes.interaction, currency: currency });
                    break;
                case GTMEvents.custom_event:
                    switch (eventAction) {
                        case GTMEventActions.search_results:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = decodeSearchKeyword || '';
                            GTMData.customEventNonFoodJourneyParams = getJourneySelectionParams(new_journey_selection);
                            GTMData.event_type = GTMNowJourneyEventTypes.interaction;
                            GTMData.extraObj = {
                                search_results_count: searchCount,
                                search_results_pageview: 1,
                                search_type: search_type_value,
                                market: storeid,
                                language: language,
                            };
                            GTMData.pageData = {
                                search_keyword: decodeSearchKeyword || '',
                                screen_name: document.title,
                                screen_type: constants.productSearch,
                                page_url: pageUrl,
                            };
                            GTMData.posInfo = ((posInfo === null || posInfo === void 0 ? void 0 : posInfo.foodPos) || '0') + " | " + ((posInfo === null || posInfo === void 0 ? void 0 : posInfo.expressPos) || '0') + " | " + ((posInfo === null || posInfo === void 0 ? void 0 : posInfo.nonFoodPos) || '0');
                            break;
                        case GTMEventActions.search_no_results:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = decodeSearchKeyword || '';
                            GTMData.customEventNonFoodJourneyParams = getJourneySelectionParams(new_journey_selection);
                            GTMData.event_type = GTMNowJourneyEventTypes.interaction;
                            GTMData.extraObj = {
                                search_results_count: 0,
                                search_results_pageview: 1,
                                search_type: search_type_value,
                                market: storeid,
                                language: language,
                            };
                            GTMData.pageData = {
                                screen_name: document.title,
                                screen_type: constants.productSearch,
                                page_url: pageUrl,
                                search_keyword: decodeSearchKeyword || '',
                            };
                            GTMData.posInfo = ((posInfo === null || posInfo === void 0 ? void 0 : posInfo.foodPos) || '0') + " | " + ((posInfo === null || posInfo === void 0 ? void 0 : posInfo.expressPos) || '0') + " | " + ((posInfo === null || posInfo === void 0 ? void 0 : posInfo.nonFoodPos) || '0');
                            break;
                        case GTMEventActions.component_interaction:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = componentPosition;
                            GTMData.extraObj = {
                                component_name: componentName,
                                component_slot: componentSlot,
                                component_position: componentPosition,
                            };
                            break;
                        case GTMEventActions.listing_sort:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = sortValue;
                            GTMData.extraObj = {
                                dimension9: searchType || '',
                            };
                            break;
                        case GTMEventActions.listing_filters:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = listingFilterData || '';
                            GTMData.pageData = __assign$1(__assign$1({ filter_selected: listingFilterData || '', screen_name: document.title, page_url: pageUrl }, (l1Category && { screen_type: constants.category })), (searchKeyword && { screen_type: constants.productSearch, search_keyword: decodeSearchKeyword || '' }));
                            GTMData.extraObj = __assign$1(__assign$1({ filter_events: 1, market: storeid, language: language }, (l1Category && {
                                L1_category: l1Category,
                                L2_category: l2Category || '',
                                L3_category: l3Category || '',
                            })), (searchKeyword && {
                                search_type: search_type_value,
                                search_results_pageview: 1,
                            }));
                            break;
                        case GTMEventActions.search_facets:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = filterValue;
                            break;
                        case GTMEventActions.category_facets:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = filterValue;
                            break;
                        case GTMEventActions.category_interaction:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel =
                                eventLabel ||
                                    (superCategory && "L1_category_" + categoryId) ||
                                    (mainCategory && "L2_category_" + categoryId) ||
                                    "L3_category_" + categoryId;
                            GTMData.extraObj = __assign$1(__assign$1(__assign$1({}, sharedData), { l1_category: superCategory, l2_category: mainCategory || '', l3_category: subCategory || '', nav_type: 'category', category_nav: 1 }), (clpId && { clp: clpId }));
                            break;
                        case GTMEventActions.header_interaction:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.eventData = __assign$1(__assign$1(__assign$1(__assign$1({}, sharedData), GTMData.eventData), { nav_type: 'header', header_nav: 1 }), (clpId && { clp: clpId }));
                            break;
                        case GTMEventActions.marketing_strip_impression:
                        case GTMEventActions.announcement_interaction:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            break;
                        case GTMEventActions.category_results:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = categoryId || '';
                            GTMData.extraObj = {
                                search_count: searchCount,
                            };
                            break;
                        case GTMEventActions.category_no_results:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = categoryId || '';
                            GTMData.extraObj = {
                                search_count: 0,
                            };
                            break;
                        case GTMEventActions.reorder_search:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = searchKeyword || '';
                            GTMData.extraObj = {
                                search_count: searchCount,
                            };
                            break;
                        case GTMEventActions.reorder_category:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = categoryId || '';
                            break;
                        case GTMEventActions.login:
                            GTMData.eventCategory = GTMEventCategories.sign_up;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel || '';
                            GTMData.pageData = pageData;
                            break;
                        case GTMEventActions.inline_filter:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = inlineFilterData || '';
                            GTMData.pageData = __assign$1(__assign$1(__assign$1({ filter_selected: inlineFilterData || '', screen_name: document.title }, (l1Category && { screen_type: constants.category })), (searchKeyword && { screen_type: constants.productSearch, search_keyword: decodeSearchKeyword || '' })), { page_url: pageUrl });
                            GTMData.extraObj = __assign$1(__assign$1({ filter_events: 1, market: storeid, language: language }, (l1Category && {
                                L1_category: l1Category,
                                L2_category: l2Category || '',
                                L3_category: l3Category || '',
                            })), (searchKeyword && {
                                search_type: search_type_value,
                                search_results_pageview: 1,
                            }));
                            break;
                        case GTMEventActions.share_clicked:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = productTitle;
                            break;
                        case GTMEventActions.product_click_notify_later:
                            GTMData.eventData = GTMDataTransformer.productGTMData(productState);
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            break;
                        case GTMEventActions.first_user_coupon_banner_clicked:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.customEventNonFoodJourneyParams = getJourneySelectionParams(new_journey_selection);
                            GTMData.event_type = GTMNowJourneyEventTypes.interaction;
                            GTMData.extraObj = __assign$1(__assign$1({}, pageData), { language: language });
                            break;
                        case GTMEventActions.registration:
                            GTMData.eventCategory = GTMEventCategories.sign_up;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.pageData = pageData;
                            break;
                        case GTMEventActions.shop_all_items_clicked:
                        case GTMEventActions.see_all_click:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.pageData = pageData;
                            GTMData.customEventNonFoodJourneyParams = getJourneySelectionParams(new_journey_selection);
                            GTMData.event_type = GTMNowJourneyEventTypes.interaction;
                            break;
                        case GTMEventActions.fyc_icon_interaction:
                        case GTMEventActions.journey_selection_tab:
                        case GTMEventActions.address_icon_interaction:
                        case GTMEventActions.change_address_done:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.event_type = GTMNowJourneyEventTypes.interaction;
                            GTMData.customEventNonFoodJourneyParams = getJourneySelectionParams(new_journey_selection || '');
                            GTMData.pageData = pageData;
                            break;
                        case GTMEventActions.authentication:
                            GTMData.eventCategory = GTMEventCategories.user_authentication;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.pageData = pageData;
                            GTMData.journey_selection = new_journey_selection;
                            break;
                        case GTMEventActions.email_login_password:
                            GTMData.eventCategory = GTMEventCategories.user_authentication;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.pageData = pageData;
                            GTMData.journey_selection = new_journey_selection;
                            break;
                        case GTMEventActions.email_login_otp:
                            GTMData.eventCategory = GTMEventCategories.user_authentication;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.pageData = pageData;
                            GTMData.journey_selection = new_journey_selection;
                            break;
                        case GTMEventActions.signup:
                            GTMData.eventCategory = GTMEventCategories.user_authentication;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.pageData = pageData;
                            GTMData.journey_selection = new_journey_selection;
                            break;
                        case GTMEventActions.profile_interaction:
                            GTMData.eventCategory = GTMEventCategories.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.journey_selection = new_journey_selection;
                            GTMData.pageData = {
                                screen_name: constants.profile,
                                screen_type: constants.profile,
                                page_url: pageUrl,
                            };
                            break;
                    }
                    break;
                case GTMEvents.now_journey_custom_events:
                    GTMData.eventCategory = GTMEventCategories.user_engagement;
                    GTMData.eventAction = eventAction;
                    GTMData.eventLabel = eventLabel || '';
                    GTMData.pageData = pageData;
                    GTMData.event_type = event_type;
                    GTMData.customEventNonFoodJourneyParams = getJourneySelectionParams(new_journey_selection);
                    break;
                case GTMEvents.algolia_custom_events:
                    GTMData.experiment_key = experiment_key || '';
                    GTMData.variation_id = variation_id;
                    GTMData.pageData = pageData;
                    break;
            }
            return GTMData;
        };
    }
    GTMDataTransformer.productGTMData = function (data, eventType, ga4, countryCode) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (ga4 === void 0) { ga4 = false; }
        if (countryCode === void 0) { countryCode = ''; }
        if (data) {
            var bulkMessage = data.bulkMessage, name_1 = data.name, productId = data.productId, originalPrice = data.originalPrice, brand = data.brand, _h = data.category, category = _h === void 0 ? '' : _h, position = data.position, _j = data.listName, listName = _j === void 0 ? '' : _j, discount = data.discount, offers = data.offers, isExpress = data.isExpress, isScalable = data.isScalable, _k = data.quantity, quantity = _k === void 0 ? 0 : _k, type = data.type, isAvailable = data.isAvailable, productColor = data.productColor, size = data.size, isWarranty = data.isWarranty, productOrigin = data.productOrigin, foodType = data.foodType, supplier = data.supplier, isMarketPlace = data.isMarketPlace, categories = data.categories, parentID = data.parentID, selectedVariant = data.selectedVariant, isSponsored = data.isSponsored, selectedVariantCode = data.selectedVariantCode, adtechCarouselId = data.adtechCarouselId, campaignId = data.campaignId, campaignName = data.campaignName;
            var itemVariant = '';
            var sellerName = '';
            var offerId = '';
            var l1Category = void 0, l2Category = void 0, l3Category = void 0, l4Category = void 0;
            var _l = __read$1(APP_CONFIG.__cookie__.storeInfoCookieValue, 3), currency = _l[2];
            if (supplier !== 'Carrefour') {
                itemVariant = 'market_place|';
            }
            if (bulkMessage !== '') {
                itemVariant = ''.concat(itemVariant, 'bulk|');
            }
            if ((discount && discount.type !== 'none') || offers) {
                itemVariant = ''.concat(itemVariant, 'online_deals|');
            }
            if (isExpress) {
                itemVariant = ''.concat(itemVariant, 'express|');
            }
            if (offers && offers.length) {
                offerId = offers[0].id || '';
                sellerName = offers[0].sellerName || '';
            }
            itemVariant = itemVariant ? itemVariant.slice(0, -1) : itemVariant;
            var stockStatus = isAvailable ? 'inStock' : 'outOfStock';
            var productPosition = "" + (position || '');
            var id = isMarketPlace && offers && offers.length
                ? getPageType() === constants.productDetails
                    ? parentID + "_" + offerId
                    : productId + "_" + offerId
                : "" + productId;
            var Productprice = discount && discount.type !== 'none' ? discount.price : originalPrice;
            var offer_type = discount && discount.type !== 'none' ? discount.value + '%_discount' : '';
            var pageType = getPageType();
            var isPLP = [constants.categorySearch, constants.productSearch].includes(pageType);
            if (pageType === constants.productSearch && isBrowser()) {
                var breadCrumb = (_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.__NEXT_DATA__) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.initialState) === null || _c === void 0 ? void 0 : _c.search) === null || _d === void 0 ? void 0 : _d.breadCrumb;
                if (Array.isArray(breadCrumb)) {
                    l1Category = ((_e = breadCrumb[0]) === null || _e === void 0 ? void 0 : _e.name) || '';
                    l2Category = ((_f = breadCrumb[1]) === null || _f === void 0 ? void 0 : _f.name) || '';
                }
            }
            var categoryEnabledPages = [
                constants.categorySearch,
                constants.home,
                constants.category,
                constants.productDetails,
                constants.cart,
                constants.reOrder,
            ];
            if (categories && categories.length && categoryEnabledPages.includes(getPageType())) {
                var labelArray = categories.map(function (labelValue) {
                    return labelValue.name;
                });
                l1Category = labelArray[0];
                l2Category = labelArray[1];
                l3Category = labelArray[2];
                l4Category = labelArray[3];
            }
            var searchKeyword = getPageType() === constants.productSearch ? listName === null || listName === void 0 ? void 0 : listName.split('|')[1] : '';
            var pathname = (typeof window !== 'undefined' && window.location.pathname) || '';
            var clpId = pathname.split('/').find(function (ele) { return ele.includes('clp_'); }) || '';
            var list = (listName === null || listName === void 0 ? void 0 : listName.split('|')) || [];
            var page = GTMDataTransformer.getPageType(pageType);
            var dimension103 = list[0] + "|" + list[1];
            var trimString = function (str) { return (str === null || str === void 0 ? void 0 : str.substring(0, 100)) || ''; };
            var currentPageType = getPageType();
            var new_journey_selection = getNowJourneyCookie()
                ? GTMNowJourneyLabels.now_items
                : GTMNowJourneyLabels.all_items;
            var common = {};
            var productCommon = {};
            var commonData = {};
            if (!ga4) {
                common = __assign$1(__assign$1(__assign$1(__assign$1(__assign$1({ name: name_1,
                    id: id, brand: brand || '', category: category, position: productPosition,
                    variant: itemVariant, dimension7: type || '', dimension14: stockStatus || '', dimension23: offers && offers.length ? 'true' : 'false' }, (offer_type && { dimension51: offer_type })), { dimension52: isMarketPlace ? 'true' : 'false' }), (isMarketPlace && { dimension53: supplier })), (isScalable && { dimension96: size })), (clpId && { clp: clpId }));
                productCommon = __assign$1(__assign$1({ dimension54: "" + offerId, dimension93: id }, (list && { dimension103: dimension103 })), { dimension108: String(!!isExpress), metric17: originalPrice });
                commonData = {
                    price: Productprice,
                    quantity: quantity,
                };
            }
            else {
                var price = isScalable && originalPrice && quantity ? ((quantity / 1000) * originalPrice).toFixed(2) : originalPrice;
                var discountPrice = discount && discount.type !== 'none' && originalPrice
                    ? parseFloat((originalPrice - discount.price).toFixed(2))
                    : 0;
                var item_list_name = trimString(getListName(listName, currentPageType, category));
                var adtechData = {};
                if (currentPageType === constants.cart && campaignId) {
                    var listName_1 = gtmSnakeCase(item_list_name || '');
                    adtechData = {
                        sponsored_ad_type: 'rail',
                        sponsored_ad_info: "" + adtechCarouselId,
                        sponsored_campaign_info: campaignName + "|" + campaignId,
                        item_list_name: listName_1,
                        item_list_id: listName_1,
                    };
                }
                common = __assign$1(__assign$1(__assign$1({ item_name: name_1 && trimString(name_1), item_id: productId + "_" + countryCode, item_brand: (type === 'FOOD' ? 'Food' : 'NonFood') + "_" + brand, item_category: trimString(l1Category), item_category2: trimString(l2Category), item_category3: trimString(l3Category), item_category4: trimString(l4Category), item_category5: "" + (type === 'FOOD' ? 'food' : 'non_food') }, getJourneySelectionParams(new_journey_selection, 'item_level_')), { item_variant: "now=" + (isExpress ? true : false) + "_spon=" + (isSponsored ? true : false) + (selectedVariant ? '_var=' + selectedVariantCode : '') + "_end", item_list_name: item_list_name, item_list_id: item_list_name, index: position, affiliation: isMarketPlace ? trimString(offerId + "|" + sellerName) : 'Carrefour', is_sponsored: isSponsored ? 'true' : 'false' }), adtechData);
                commonData = {
                    price: price,
                    currency: currency,
                    discount: discountPrice,
                    value: discountPrice ? (_g = discount === null || discount === void 0 ? void 0 : discount.price) === null || _g === void 0 ? void 0 : _g.toFixed(2) : price,
                };
            }
            switch (eventType) {
                case GTMEvents.product_impressions:
                    if (ga4) {
                        return __assign$1(__assign$1(__assign$1(__assign$1({}, common), productCommon), commonData), (isMarketPlace && { metric25: '1' }));
                    }
                    return __assign$1(__assign$1(__assign$1(__assign$1(__assign$1({}, common), productCommon), commonData), { list: page + "|" + dimension103 }), (isMarketPlace && { metric25: '1' }));
                case GTMEvents.product_click:
                    if (!ga4) {
                        return __assign$1(__assign$1(__assign$1(__assign$1(__assign$1({}, common), productCommon), { list: page + "| " + dimension103, nav_type: 'product list click' }), (isMarketPlace && { metric41: '1' })), (isPLP && { search_results_click_thru: '1' }));
                    }
                    else {
                        return __assign$1(__assign$1({}, common), productCommon);
                    }
                case GTMEvents.add_to_cart:
                    return __assign$1(__assign$1({}, common), productCommon);
                case GTMEvents.remove_from_cart:
                    return __assign$1(__assign$1({}, common), productCommon);
            }
            return __assign$1(__assign$1(__assign$1({}, common), commonData), { dimension18: productColor || '', dimension19: productOrigin || '', dimension20: isWarranty ? 'true' : 'false', dimension27: size || '', dimension39: foodType || '', dimension51: offer_type || '', dimension54: offerId, dimension53: sellerName, dimension56: productPosition, dimension89: originalPrice, dimension40: l1Category || '', dimension41: l2Category || '', dimension57: l3Category || '', dimension58: l4Category || '', dimension60: isExpress ? 'express' : 'standard', dimension65: itemVariant || '', dimension81: searchKeyword });
        }
    };
    GTMDataTransformer.getPageType = function (pageType) {
        switch (pageType) {
            case constants.home:
                return 'home';
            case constants.categoryLandingPage:
                return constants.categoryLandingPage;
            case constants.productSearch:
                return 'productsearch';
            case constants.categorySearch:
                return 'category';
            case constants.brandLandingPage:
                return constants.brandLandingPage;
            case constants.productDetails:
                return constants.product_details;
            default:
                return pageType;
        }
    };
    GTMDataTransformer.getScreenName = function (pageType, productName) {
        if (productName === void 0) { productName = ''; }
        var category_name = getCategoryName() || constants.noName;
        switch (pageType) {
            case constants.home:
                return 'home';
            case constants.categoryLandingPage:
                return constants.categoryLandingPage + "|" + category_name;
            case constants.categorySearch:
                return constants.category + "|" + category_name;
            case constants.brandLandingPage:
                return constants.brandLandingPage + "|" + category_name;
            case constants.productDetails:
                return constants.product_details + "|" + localStorage.getItem('pdpProductName');
            default:
                return productName || pageType;
        }
    };
    return GTMDataTransformer;
}());
var toSnakeCase$1 = function (str) { return str && str.toLocaleLowerCase().split(' ').join('_'); };
var overridesUserIdHeader = function (mafSessionId) {
    if (mafSessionId === void 0) { mafSessionId = ''; }
    if (!getCustomCookie('maf-user-id')) {
        return { userId: mafSessionId };
    }
    return {};
};
var BrazeDataTransformer =  (function () {
    function BrazeDataTransformer() {
        var _this = this;
        this.getOfferType = function (bulkMessage, isExpress, sellerName) {
            var offerType = '';
            if ((sellerName === null || sellerName === void 0 ? void 0 : sellerName.toLowerCase()) !== 'carrefour') {
                offerType = 'market_place|';
            }
            if (bulkMessage !== '') {
                offerType = ''.concat(offerType, 'bulk|');
            }
            if (isExpress) {
                offerType = ''.concat(offerType, 'express|');
            }
            return (offerType === null || offerType === void 0 ? void 0 : offerType.slice(0, -1)) || '';
        };
        this.getBrazeData = function (eventType, eventData) {
            var _a, _b, _c, _d;
            var BrazeData = {};
            var _e = eventData.name, name = _e === void 0 ? '' : _e, _f = eventData.productId, productId = _f === void 0 ? '' : _f, _g = eventData.category, category = _g === void 0 ? '' : _g, _h = eventData.brand, brand = _h === void 0 ? '' : _h, _j = eventData.currency, currency = _j === void 0 ? '' : _j, _k = eventData.quantity, quantity = _k === void 0 ? '' : _k, _l = eventData.quantityType, quantityType = _l === void 0 ? '' : _l, discount = eventData.discount, originalPrice = eventData.originalPrice, isMarketplaceOffer = eventData.isMarketplaceOffer, isMainOffer = eventData.isMainOffer, _m = eventData.offerId, offerId = _m === void 0 ? '' : _m, _o = eventData.shop, shop = _o === void 0 ? '' : _o, _p = eventData.isFBC, isFBC = _p === void 0 ? '' : _p, _q = eventData.deliveryPromise, deliveryPromise = _q === void 0 ? '' : _q, _r = eventData.deliverySolution, deliverySolution = _r === void 0 ? '' : _r, _s = eventData.isMarketPlace, isMarketPlace = _s === void 0 ? '' : _s, _t = eventData.isExpress, isExpress = _t === void 0 ? '' : _t, _u = eventData.bulkMessage, bulkMessage = _u === void 0 ? '' : _u, _v = eventData.offers, offers = _v === void 0 ? '' : _v, _w = eventData.supplier, supplier = _w === void 0 ? '' : _w, _x = eventData.min, min = _x === void 0 ? '' : _x, _y = eventData.isScalable, isScalable = _y === void 0 ? '' : _y;
            switch (eventType) {
                case BrazeEvents.add_to_cart:
                    var mkpData_cart = isMarketPlace
                        ? {
                            isMainOffer: ((_a = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _a === void 0 ? void 0 : _a.type) === 'main',
                            offer_id: toSnakeCase$1((_b = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _b === void 0 ? void 0 : _b.id),
                            shop: toSnakeCase$1((_c = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _c === void 0 ? void 0 : _c.sellerName),
                            isFBC: supplier === 'Carrefour',
                            deliveryPromise: toSnakeCase$1(deliveryPromise),
                            deliverySolution: toSnakeCase$1(deliverySolution),
                        }
                        : {};
                    var itemPrice = (discount === null || discount === void 0 ? void 0 : discount.price) > 0 ? discount.price : originalPrice;
                    BrazeData = __assign$1({ item_name: toSnakeCase$1(name), item_id: toSnakeCase$1(productId), item_category: toSnakeCase$1(category), item_brand: toSnakeCase$1(brand), price: itemPrice, currency: toSnakeCase$1(currency), quantity: min, quantity_type: isScalable ? 'kilo' : 'pieces', offer_type: _this.getOfferType(bulkMessage, isExpress, (_d = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _d === void 0 ? void 0 : _d.sellerName) }, mkpData_cart);
                    break;
                case BrazeEvents.pdp_view:
                    var mkpData_pdp = isMarketplaceOffer
                        ? {
                            isMainOffer: isMainOffer,
                            offer_id: offerId,
                            shop: shop,
                            isFBC: isFBC,
                            deliveryPromise: deliveryPromise,
                            deliverySolution: deliverySolution,
                        }
                        : {};
                    var pdpPrice = (discount === null || discount === void 0 ? void 0 : discount.price) > 0 ? discount.price : originalPrice;
                    BrazeData = __assign$1({ item_name: name, item_id: productId, item_category: category, item_brand: brand, price: pdpPrice, currency: currency, quantity: quantity, quantity_type: quantityType, offer_type: _this.getOfferType(bulkMessage, isExpress, shop) }, mkpData_pdp);
                    break;
                default:
                    BrazeData = eventData;
            }
            return BrazeData;
        };
    }
    return BrazeDataTransformer;
}());
var brazeSetCustomUserAttribute = function (pairs) {
    var appboy = window.appboy;
    Object.entries(pairs).forEach(function (item) {
        appboy && appboy.getUser().setCustomUserAttribute(item[0], item[1]);
    });
};
var brazeLogCustomEvent = function (type, properties) {
    var appboy = window.appboy;
    var transformer = new BrazeDataTransformer();
    var BrazeData = transformer.getBrazeData(type, properties);
    appboy && appboy.logCustomEvent(type, BrazeData);
};
var setAppLanguageAndCountry = function (appConfig, appboy) {
    setCustomUserAttribute(appboy, {
        app_language: appConfig.language,
        app_country: appConfig.storeId,
    });
};
var setCustomUserAttribute = function (appboy, pairs) {
    Object.entries(pairs).forEach(function (item) {
        appboy && appboy.getUser().setCustomUserAttribute(item[0], item[1]);
    });
};
var BaseService =  (function () {
    function BaseService() {
    }
    BaseService.prototype.doGet = function (url, params, isAbsUrl, apiOptions) {
        if (isAbsUrl === void 0) { isAbsUrl = true; }
        if (apiOptions === void 0) { apiOptions = {}; }
        return __awaiter$1(this, void 0, void 0, function () {
            var requestUrl, headers, storeId, data, err_1;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestUrl = this.replaceVariables(url, params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        headers = {};
                        storeId = (params || {}).storeId;
                        if (params === null || params === void 0 ? void 0 : params.headers) {
                            headers = params === null || params === void 0 ? void 0 : params.headers;
                        }
                        if (storeId) {
                            headers.storeId = storeId;
                        }
                        return [4 , networkRequest(__assign$1({ requestUrl: requestUrl,
                                isAbsUrl: isAbsUrl, apiOptions: __assign$1({}, apiOptions), headers: headers }, params))];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 , data];
                    case 3:
                        err_1 = _a.sent();
                        console.error('DO_GET_ERROR', requestUrl, err_1);
                        console.error('DO_GET_ERROR_PARAMS', requestUrl, params);
                        return [2 , { statusCode: 400, err: err_1 }];
                    case 4: return [2 ];
                }
            });
        });
    };
    BaseService.prototype.doSafeGet = function (url, params, isAbsUrl) {
        if (isAbsUrl === void 0) { isAbsUrl = true; }
        return __awaiter$1(this, void 0, void 0, function () {
            var requestUrl, headers, storeId, data, err_2;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestUrl = this.replaceVariables(url, params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        headers = {};
                        storeId = (params || {}).storeId;
                        if (params === null || params === void 0 ? void 0 : params.headers) {
                            headers = params === null || params === void 0 ? void 0 : params.headers;
                        }
                        if (storeId) {
                            headers.storeId = storeId;
                        }
                        return [4 , networkRequest({
                                requestUrl: requestUrl,
                                isAbsUrl: isAbsUrl,
                                apiOptions: {},
                                apiVersion: (params === null || params === void 0 ? void 0 : params.apiVersion) || 2,
                                headers: headers,
                            })];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 , data];
                    case 3:
                        err_2 = _a.sent();
                        console.error('DO_GET_SAFE_ERROR', requestUrl, err_2);
                        console.error('DO_GET_SAFE_ERROR_PARAMS', requestUrl, params);
                        return [2 , { statusCode: 400, err: err_2 }];
                    case 4: return [2 ];
                }
            });
        });
    };
    BaseService.prototype.getSessionToken = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 , handleGuestSession()];
                    case 1:
                        _a.sent();
                        return [2 , getUserTokenFromCookie() || getGuestSessionToken()];
                }
            });
        });
    };
    BaseService.prototype.doPut = function (url, params, isAbsUrl) {
        if (isAbsUrl === void 0) { isAbsUrl = true; }
        return __awaiter$1(this, void 0, void 0, function () {
            var requestUrl, data;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestUrl = this.replaceVariables(url, params);
                        return [4 , networkRequest({
                                requestUrl: requestUrl,
                                isAbsUrl: isAbsUrl,
                                apiOptions: {
                                    method: 'PUT',
                                },
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 , data];
                }
            });
        });
    };
    BaseService.prototype.replaceVariables = function (url, params) {
        if (params === void 0) { params = {}; }
        var store = getStore();
        var appConfig = store ? store.getState().appConfig : {};
        var _a = __assign$1(__assign$1({}, APP_CONFIG), appConfig), areaCode = _a.areaCode,
        lang = _a.language, latitude = _a.latitude, longitude = _a.longitude, currency = _a.currency, storeId = _a.storeId, _b = _a.features, isLocationCXEnable = (_b === void 0 ? { isLocationCXEnable: false } : _b).isLocationCXEnable,
        expressPos = _a.expressPos;
        return replaceUrlVariables(url, __assign$1({
            lang: lang, language: lang, latitude: latitude,
            longitude: longitude,
            areaCode: areaCode,
            isLocationCXEnable: isLocationCXEnable,
            storeId: storeId, StoreId: storeId, Currency: params.currency || currency,
            expressPos: expressPos }, params));
    };
    return BaseService;
}());
var AnalyticsManager =  (function () {
    function AnalyticsManager() {
    }
    AnalyticsManager.prototype.getGTMPageData = function (pageData) {
        var transformer = new GTMDataTransformer();
        return transformer.pageGTMData(pageData);
    };
    AnalyticsManager.prototype.trackGTMEvent = function (eventType, eventData) {
        var transformer = new GTMDataTransformer();
        var GTMData = transformer.getGTMData(eventType, eventData);
        var ga4 = (eventData.otherData || false).ga4;
        if (GTMData) {
            switch (eventType) {
                case GTMEvents.product_click:
                    return gtmProductClick(GTMData.data, GTMData.actionField, GTMData.eventData, ga4);
                case GTMEvents.product_impressions:
                    return gtmProductImpression(GTMData.data, GTMData.eventData, ga4);
                case GTMEvents.virtual_page_event:
                    return gtmVirtualPage(GTMData.pageTitle, GTMData.eventData);
                case GTMEvents.category_page_event:
                    return gtmCategoryPage(GTMData.l1Category, GTMData.l2Category, GTMData.l3Category, GTMData.eventData);
                case GTMEvents.custom_event:
                    return gtmCustomEvent(GTMData.eventCategory, GTMData.eventAction, GTMData.eventLabel, GTMData.extraObj, GTMData.eventData, GTMData.pageData || {}, GTMData.posInfo, GTMData.event_type, GTMData.journey_selection, GTMData.customEventNonFoodJourneyParams, ga4);
                case GTMEvents.add_to_cart:
                    return gtmAddToCart(GTMData.data, GTMData.eventData, ga4);
                case GTMEvents.remove_from_cart:
                    return gtmRemoveToCart(GTMData.data, GTMData.eventData, ga4);
                case GTMEvents.now_journey_custom_events:
                    return nowJourneyCustomEvents(GTMData.eventCategory, GTMData.eventAction, GTMData.eventLabel, GTMData.event_type, GTMData.journey_selection, GTMData.pageData || {});
                case GTMEvents.algolia_custom_events:
                    return algoliaServiceGAEvent(GTMData.experiment_key, GTMData.variation_id, GTMData.pageData || {});
            }
        }
    };
    AnalyticsManager.prototype.trackBrazeEvent = function (eventType, eventData) {
        brazeLogCustomEvent(eventType, eventData);
    };
    AnalyticsManager.prototype.trackBrazeSetCustomUserAttribute = function (attributes) {
        brazeSetCustomUserAttribute(attributes);
    };
    AnalyticsManager.prototype.trackPromotionEvent = function (eventType, sharedData, promotionData, ga4) {
        var GTMData = eventType && sharedData && promotionData;
        if (GTMData) {
            switch (eventType) {
                case PromotionEvents.promotion_impressions:
                    return gtmPromotionImpression(eventType, sharedData, promotionData, ga4);
                case PromotionEvents.promotion_click:
                    return gtmPromotionClick(eventType, sharedData, promotionData, ga4);
            }
        }
    };
    AnalyticsManager.prototype.trackEvent = function (URI, useFetch) {
        if (useFetch === void 0) { useFetch = false; }
        if (isBrowser()) {
            var bs = new BaseService();
            return useFetch
                ? fetch(URI)
                : bs.doGet(URI, {}, true, {
                    headers: {
                        Connection: 'Keep-Alive',
                    },
                });
        }
    };
    return AnalyticsManager;
}());
var useAnalytic = function () {
    var _a, _b;
    var Analytics = useMemo(function () { return new AnalyticsManager(); }, []);
    var isNewJouney = ((_b = (_a = useFeature('new_carrefour_journey')) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.new_journey) || false;
    var _c = useSelector(function (state) {
        return __assign$1(__assign$1(__assign$1(__assign$1({}, state.userData), state.appConfig), state.area), state.miniCart);
    }), currency = _c.currency, areaCode = _c.areaCode, language = _c.language, sessionId = _c.sessionId, storeId = _c.storeId, selectedCity = _c.selectedCity, cardNumber = _c.cardNumber, totalPoints = _c.totalPoints, isLoyaltyFetched = _c.isLoyaltyFetched, _d = _c.userId, userHashedEmail = _d === void 0 ? 'anonymous' : _d, _e = _c.updatedCart, updatedCart = _e === void 0 ? {} : _e, brazeInitialized = _c.brazeInitialized, email = _c.email, defaultAddress = _c.defaultAddress, userCredentials = _c.userCredentials;
    var searchType = useMemo(function () {
        if (typeof document !== 'undefined') {
            return getSearchTypeCookie();
        }
    }, []);
    var cartId = useMemo(function () {
        if (typeof document !== 'undefined') {
            var token = getUserTokenFromCookie();
            if (token) {
                return getUserTokenFromCookie();
            }
            return getGUID() || (updatedCart ? updatedCart.guid : '');
        }
    }, [updatedCart]);
    var isLoggedIn = useMemo(function () {
        if (typeof document !== 'undefined') {
            var token = getUserTokenFromCookie();
            if (token) {
                return true;
            }
            return false;
        }
    }, []);
    var getAreaCode = useCallback(function () {
        try {
            return areaCode && JSON.parse(areaCode);
        }
        catch (error) {
            return areaCode;
        }
    }, [areaCode]);
    var pageType = getPageType();
    var getGTMPageData = useCallback(function (pageData) {
        var getData = pageData === null || pageData === void 0 ? void 0 : pageData.getData;
        pageData === null || pageData === void 0 ? true : delete pageData.getData;
        var loggedInStatus = (userCredentials === null || userCredentials === void 0 ? void 0 : userCredentials.authToken) ? '1'
            : '0';
        var areaCodeParsed = getAreaCode();
        var eventData = __assign$1({ loggedInStatus: loggedInStatus,
            language: language, market: storeId, currency: currency,
            sessionId: sessionId, areaCode: areaCodeParsed, selectedCity: selectedCity || (areaCodeParsed ? areaCodeParsed.split(' - ')[1] : ''), userId: userCredentials === null || userCredentials === void 0 ? void 0 : userCredentials.userId, pageType: pageType,
            userHashedEmail: userHashedEmail,
            email: email,
            defaultAddress: defaultAddress, userLoyaltyPoint: totalPoints || '', myClubId: cardNumber || '' }, pageData);
        if (isLoggedIn && (userCredentials === null || userCredentials === void 0 ? void 0 : userCredentials.authToken) && areaCode) {
            return Analytics.getGTMPageData(eventData);
        }
        else if (!isLoggedIn || getData) {
            return Analytics.getGTMPageData(eventData);
        }
        return null;
    }, [
        getAreaCode,
        language,
        storeId,
        currency,
        sessionId,
        selectedCity,
        pageType,
        userHashedEmail,
        email,
        defaultAddress,
        totalPoints,
        cardNumber,
        isLoggedIn,
        areaCode,
        Analytics,
        userCredentials,
    ]);
    var GTMEventCall = useCallback(function (eventType, otherData) {
        if (otherData === void 0) { otherData = {}; }
        var quantity = otherData.quantity;
        var eventData = __assign$1(__assign$1({}, otherData), { pageType: pageType,
            searchType: searchType,
            cartId: cartId,
            isNewJouney: isNewJouney });
        if (storeId && language && currency && pageType && areaCode) {
            var product = otherData.product, position = otherData.position;
            var listName = product ? product.gaListName : '';
            Analytics.trackGTMEvent(eventType, {
                productState: __assign$1(__assign$1({}, product), { position: position, listName: listName, quantity: quantity }),
                otherData: eventData,
            });
        }
    }, [Analytics, searchType, storeId, language, currency, cartId, pageType, areaCode, isNewJouney]);
    var EventCall = useCallback(function (eventType, productDetail) {
        var URIs = [];
        if (productDetail) {
            var _a = productDetail.addToCartTrackingUrl, addToCartTrackingUrl = _a === void 0 ? [] : _a, _b = productDetail.clickTrackingUrl, clickTrackingUrl = _b === void 0 ? [] : _b, _c = productDetail.viewTrackingUrl, viewTrackingUrl = _c === void 0 ? [] : _c, _d = productDetail.rightClickTrackingURL, rightClickTrackingURL = _d === void 0 ? [] : _d, _e = productDetail.updateCartTrackingURL, updateCartTrackingURL = _e === void 0 ? [] : _e;
            switch (eventType) {
                case GTMEvents.add_to_cart:
                    URIs = addToCartTrackingUrl.map(function (trackingURL) { return trackingURL + "&quantity=" + (productDetail === null || productDetail === void 0 ? void 0 : productDetail.quantity); });
                    break;
                case GTMEvents.change_the_quantity:
                    URIs = updateCartTrackingURL.map(function (trackingURL) { return trackingURL + "&quantity=" + (productDetail === null || productDetail === void 0 ? void 0 : productDetail.quantity); });
                    break;
                case GTMEvents.product_click:
                    URIs = clickTrackingUrl;
                    break;
                case GTMEvents.product_impression:
                    URIs = viewTrackingUrl;
                    break;
                case GTMEvents.right_click:
                    URIs = rightClickTrackingURL;
                    break;
            }
        }
        if (URIs) {
            if (isNonEmptyArray(URIs)) {
                URIs.map(function (URI) { return Analytics.trackEvent(URI, true); });
            }
        }
    }, [Analytics]);
    var PromotionEventCall = useCallback(function (eventType, sharedData, promotionData, ga4) {
        sharedData.journey_selection = getNowJourneyCookie()
            ? GTMNowJourneyLabels.now_items
            : GTMNowJourneyLabels.all_items;
        sharedData.event_type = 'non-interaction';
        if ((isLoyaltyFetched || !isLoggedIn) && areaCode) {
            Analytics.trackPromotionEvent(eventType, sharedData, promotionData, ga4);
        }
    }, [Analytics, isLoyaltyFetched, isLoggedIn, areaCode]);
    var BrazeEventCall = useCallback(function (eventType, product) {
        if (brazeInitialized) {
            Analytics.trackBrazeEvent(eventType, product);
        }
    }, [Analytics, brazeInitialized]);
    var BrazeSetCustomUserAttribute = useCallback(function (attributes) {
        Analytics.trackBrazeSetCustomUserAttribute(attributes);
    }, [Analytics]);
    return {
        GTMEventCall: GTMEventCall,
        EventCall: EventCall,
        PromotionEventCall: PromotionEventCall,
        getGTMPageData: getGTMPageData,
        BrazeEventCall: BrazeEventCall,
        BrazeSetCustomUserAttribute: BrazeSetCustomUserAttribute,
    };
};
var composeEnhancers = process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    })
    : compose;
var EMPTY_LINK = {
    href: '',
    kind: '',
    rel: '',
    type: '',
};
var ProductTransformer =  (function () {
    function ProductTransformer(products) {
        this.products = products;
    }
    ProductTransformer.prototype.getTrackingFromLinks = function (links, kind) {
        if (links === void 0) { links = []; }
        var results = links.filter(function (link) { return link.rel === 'tracking' && link.kind === kind; });
        return results.map(function (result) { return result.href; });
    };
    ProductTransformer.prototype.getCurrencyPosition = function (currency) {
        if (currency === void 0) { currency = ''; }
        var curr = currency.toUpperCase();
        return curr === 'USD' || curr === 'LBP' ? 'left' : 'right';
    };
    ProductTransformer.prototype.getProductImage = function (links, altTextFallback) {
        if (links === void 0) { links = []; }
        var results = [];
        if (links.length > 0) {
            links.forEach(function (link) {
                if (link.rel === 'assets' && link.properties) {
                    var _a = link, href = _a.href, _b = _a.properties, altText = _b.altText, format = _b.format;
                    var isPlp = format === 'plpThumbnail';
                    var image = { href: href, altText: altText || altTextFallback };
                    if (isPlp) {
                        results.push(image);
                    }
                }
            });
        }
        return results || [];
    };
    ProductTransformer.prototype.getTrackingUrl = function (id, productsWithTracking, key) {
        if (productsWithTracking) {
            var productWithTracking = productsWithTracking.find(function (product) { return product.id === id; });
            var trackingLink = productWithTracking ? productWithTracking.links.find(function (link) { return link.kind === key; }) : '';
            return trackingLink ? trackingLink.href : EMPTY_LINK;
        }
        return '';
    };
    ProductTransformer.prototype.getUnitOfMeasure = function (unitOfMeasure) {
        switch (unitOfMeasure) {
            case 'Kilo':
                return 'KG';
            case 'piece':
            default:
                return '';
        }
    };
    ProductTransformer.prototype.getProductUrl = function (links) {
        var result = links.find(function (link) { return link.rel === 'self'; });
        return result ? result.href : '';
    };
    ProductTransformer.prototype.getProductDiscountPrice = function (originalPrice, discountPrice) {
        return originalPrice === discountPrice ? 0 : discountPrice;
    };
    ProductTransformer.prototype.getProductCards = function (productsWithTracking) {
        var _this = this;
        var productCards = this.products
            .filter(function (p) {
            return Object.keys(p.price).length > 0;
        })
            .map(function (p) {
            var _a = p.availability, isAvailable = _a.isAvailable, max = _a.max, brandName = p.brand.name, bulkMessage = p.bulkMessage, _b = p.category, category = _b === void 0 ? [] : _b, _c = p.categories, categories = _c === void 0 ? [] : _c, extraLoyaltyPointsEarned = p.extraLoyaltyPointsEarned, foodType = p.foodType, id = p.id, isExpress = p.isExpress, isMarketPlace = p.isMarketPlace, isWarranty = p.isWarranty, links = p.links, _d = p.listName, listName = _d === void 0 ? '' : _d, name = p.name, offers = p.offers, _e = p.position, position = _e === void 0 ? null : _e, _f = p.price, currency = _f.currency, _g = _f.discount, discount = _g === void 0 ? { price: 0, type: 'none', value: 0 } : _g, originalPrice = _f.price, productColor = p.productColor, productOrigin = p.productOrigin, _h = p.size, size = _h === void 0 ? '' : _h, supplier = p.supplier, type = p.type, _j = p.unit, unitOfMeasure = _j.unitOfMeasure, incrementBy = _j.incrementBy, itemsPerUnit = _j.itemsPerUnit, min = _j.min, _k = p.variants, variants = _k === void 0 ? [] : _k, _l = p.promoVoucher, promoVoucher = _l === void 0 ? {} : _l, _m = p.isLebanon, isLebanon = _m === void 0 ? false : _m;
            var images = _this.getProductImage(links, name);
            var filteredCategory = (category || categories).filter(function (obj) { return obj.name; });
            var categoryName;
            if (filteredCategory && filteredCategory.length > 0) {
                categoryName = filteredCategory[filteredCategory.length - 1].name;
            }
            var clickTrackingUrl = _this.getTrackingFromLinks(links, 'clickTrackingUrl');
            var addToCartTrackingUrl = _this.getTrackingFromLinks(links, 'addToCartTrackingUrl');
            return {
                addToCartTrackingUrl: addToCartTrackingUrl || _this.getTrackingUrl(id, productsWithTracking, 'addToCartTrackingUrl'),
                brand: brandName,
                bulkMessage: bulkMessage,
                category: categoryName,
                clickTrackingUrl: clickTrackingUrl || _this.getTrackingUrl(id, productsWithTracking, 'clickTrackingUrl'),
                currency: currency,
                currencyPosition: _this.getCurrencyPosition(currency),
                discount: {
                    price: _this.getProductDiscountPrice(originalPrice, discount.price),
                    type: discount.type,
                    value: discount.value,
                },
                foodType: foodType,
                image: images[0] || {},
                imageLibrary: images,
                incrementBy: incrementBy,
                isAvailable: isAvailable,
                isExpress: isExpress,
                isLebanon: isLebanon,
                isMarketPlace: isMarketPlace,
                isWarranty: isWarranty,
                itemsPerUnit: itemsPerUnit,
                listName: listName,
                max: max,
                min: min,
                name: name,
                offers: offers,
                originalPrice: originalPrice,
                points: extraLoyaltyPointsEarned ? extraLoyaltyPointsEarned : 0,
                position: position,
                productColor: productColor,
                productId: id,
                productOrigin: productOrigin,
                size: size,
                supplier: supplier,
                type: type,
                unitOfMeasure: _this.getUnitOfMeasure(unitOfMeasure),
                url: _this.getProductUrl(links),
                productVariants: variants,
                promoVoucher: promoVoucher,
            };
        });
        return productCards;
    };
    return ProductTransformer;
}());
var PromoBadges = function (state) { return state; };
var PromoBadgesAreaA = createSelector(PromoBadges, function (items) {
    return items.filter(function (_a) {
        var placement = _a.placement;
        return placement === 'AREA-A';
    });
});
var PromoBadgesAreaB = createSelector(PromoBadges, function (items) {
    return items.filter(function (_a) {
        var placement = _a.placement;
        return placement === 'AREA-B';
    });
});
var ProductTransformerV2 =  (function (_super) {
    __extends$1(ProductTransformerV2, _super);
    function ProductTransformerV2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductTransformerV2.prototype.getTrackingUrl = function (id, productsWithTracking, key) {
        if (productsWithTracking) {
            var productWithTracking = productsWithTracking.find(function (product) { return product.id === id; });
            var trackingLink = productWithTracking
                ? productWithTracking.links.tracking.find(function (link) { return link.kind === key; })
                : '';
            return trackingLink ? trackingLink.href : EMPTY_LINK;
        }
        return '';
    };
    ProductTransformerV2.prototype.onLoadTrackingCall = function (links) {
        if (links === void 0) { links = []; }
        links.map(function (link) {
            if (link.rel === 'tracking' && link.kind === 'loadTrackingUrl') {
                fetch(link === null || link === void 0 ? void 0 : link.href);
            }
        });
    };
    ProductTransformerV2.prototype.getApplicablePrice = function (price) {
        var discount = price.discount;
        return (discount === null || discount === void 0 ? void 0 : discount.minBuyingValue) || (discount === null || discount === void 0 ? void 0 : discount.price) || (price === null || price === void 0 ? void 0 : price.minBuyingValue) || (price === null || price === void 0 ? void 0 : price.price);
    };
    ProductTransformerV2.prototype.getProductCards = function (productsWithTracking, adtechCarouselId) {
        var _this = this;
        var productCards = this.products
            .filter(function (p) {
            return Object.keys(p.price || {}).length > 0;
        })
            .map(function (p) {
            var _a, _b, _c, _d;
            var dietary = p.dietary, _e = p.availability, isAvailable = _e.isAvailable, max = _e.max, brandName = p.brand.name, bulkMessage = p.bulkMessage, _f = p.category, category = _f === void 0 ? [] : _f, extraLoyaltyPointsEarned = p.extraLoyaltyPointsEarned, foodType = p.foodType, id = p.id, isExpress = p.isExpress, isMarketPlace = p.isMarketPlace, isWarranty = p.isWarranty, _g = p.links, newProductCardImages = _g.defaultImages, productImages = _g.images, productUrl = _g.productUrl, tracking = _g.tracking, _h = p.listName, listName = _h === void 0 ? '' : _h, name = p.name, offers = p.offers, _j = p.position, position = _j === void 0 ? null : _j, price = p.price, productColor = p.productColor, productOrigin = p.productOrigin, _k = p.size, size = _k === void 0 ? '' : _k, supplier = p.supplier, type = p.type, _l = p.unit, unitOfMeasure = _l.unitOfMeasure, incrementBy = _l.incrementBy, itemsPerUnit = _l.itemsPerUnit, min = _l.min, _m = _l.unitItem, unitItem = _m === void 0 ? '' : _m, variants = p.variants, _o = p.promoVoucher, promoVoucher = _o === void 0 ? {} : _o, _p = p.promoBadges, promoBadges = _p === void 0 ? [] : _p, _q = p.isLebanon, isLebanon = _q === void 0 ? false : _q, _r = p.isSponsored, isSponsored = _r === void 0 ? false : _r, _s = p.sponsorID, sponsorID = _s === void 0 ? '' : _s, _t = p.sponsorId, sponsorId = _t === void 0 ? '' : _t, _u = p.availableVariants, availableVariants = _u === void 0 ? [] : _u, selectedVariant = p.selectedVariant, _v = p.isScalable, isScalable = _v === void 0 ? false : _v, _w = p.preorder, preorder = _w === void 0 ? false : _w, _x = p.isFBC, isFBC = _x === void 0 ? false : _x, _y = p.delivery, delivery = _y === void 0 ? [] : _y, deliveryFees = p.deliveryFees, soldByWeight = p.soldByWeight, _z = p.campaignName, campaignName = _z === void 0 ? '' : _z, _0 = p.campaignId, campaignId = _0 === void 0 ? '' : _0;
            var currency = price.currency, minBuyingValue = price.minBuyingValue, _1 = price.discount, discount = _1 === void 0 ? { price: 0, type: 'none', value: 0, minBuyingValue: '' } : _1, originalPrice = price.price;
            var applicablePrice = _this.getApplicablePrice(price);
            var images = _this.getProductImage(productImages, name);
            var filteredCategory = category.filter(function (obj) { return obj.name; });
            var categoryName;
            if (filteredCategory && filteredCategory.length > 0) {
                categoryName = filteredCategory[filteredCategory.length - 1].name;
            }
            var clickTrackingUrl = _this.getTrackingFromLinks(tracking, 'clickTrackingUrl');
            var addToCartTrackingUrl = _this.getTrackingFromLinks(tracking, 'addToCartTrackingUrl');
            var viewTrackingUrl = _this.getTrackingFromLinks(tracking, 'viewTrackingUrl');
            var rightClickTrackingURL = _this.getTrackingFromLinks(tracking, 'rightClickTrackingURL');
            var updateCartTrackingURL = _this.getTrackingFromLinks(tracking, 'updateCartTrackingUrl');
            _this.onLoadTrackingCall(tracking);
            var getSelectedVariant = (_b = (_a = variants === null || variants === void 0 ? void 0 : variants[0]) === null || _a === void 0 ? void 0 : _a.childElements) === null || _b === void 0 ? void 0 : _b.find(function (ele) { return ele.selected; });
            var selectedVariantQualifier = (_c = getSelectedVariant === null || getSelectedVariant === void 0 ? void 0 : getSelectedVariant.variantData) === null || _c === void 0 ? void 0 : _c.variantOptionQualifiers[0];
            var selectedVariantCode = ((_d = getSelectedVariant === null || getSelectedVariant === void 0 ? void 0 : getSelectedVariant.variantData) === null || _d === void 0 ? void 0 : _d.code) || '';
            return {
                addToCartTrackingUrl: addToCartTrackingUrl || _this.getTrackingUrl(id, productsWithTracking, 'addToCartTrackingUrl'),
                brand: brandName,
                bulkMessage: bulkMessage,
                category: categoryName,
                clickTrackingUrl: clickTrackingUrl || _this.getTrackingUrl(id, productsWithTracking, 'clickTrackingUrl'),
                viewTrackingUrl: viewTrackingUrl || _this.getTrackingUrl(id, productsWithTracking, 'viewTrackingUrl'),
                updateCartTrackingURL: updateCartTrackingURL,
                rightClickTrackingURL: rightClickTrackingURL || _this.getTrackingUrl(id, productsWithTracking, 'rightClickTrackingURL'),
                currency: currency,
                currencyPosition: _this.getCurrencyPosition(currency),
                discount: {
                    price: _this.getProductDiscountPrice(originalPrice, discount.price),
                    type: discount.type,
                    value: discount.value,
                    minBuyingValue: discount.minBuyingValue,
                },
                foodType: foodType,
                image: images[0] || {},
                newProductCardImage: newProductCardImages ? newProductCardImages[0] : '',
                imageLibrary: images,
                newProductCardImageLibrary: newProductCardImages,
                incrementBy: incrementBy,
                isAvailable: isAvailable,
                isExpress: isExpress,
                isLebanon: isLebanon,
                isSponsored: isSponsored,
                isMarketPlace: isMarketPlace,
                isWarranty: isWarranty,
                itemsPerUnit: itemsPerUnit,
                listName: listName,
                max: max,
                min: min,
                minBuyingValue: minBuyingValue,
                name: name,
                offers: offers,
                originalPrice: originalPrice,
                applicablePrice: applicablePrice,
                points: extraLoyaltyPointsEarned ? extraLoyaltyPointsEarned : 0,
                position: position,
                productColor: productColor,
                productId: id,
                productOrigin: productOrigin,
                size: size,
                supplier: supplier,
                type: type,
                unitOfMeasure: _this.getUnitOfMeasure(unitOfMeasure),
                url: productUrl.href,
                productVariants: variants || '',
                promoVoucher: promoVoucher,
                promoBadges: promoBadges,
                promoBadgesAreaA: PromoBadgesAreaA(promoBadges),
                promoBadgesAreaB: PromoBadgesAreaB(promoBadges),
                categories: category,
                sponsorID: sponsorID || sponsorId,
                availableVariants: availableVariants,
                selectedVariant: selectedVariant || selectedVariantQualifier || '',
                unitItem: unitItem,
                isScalable: isScalable,
                selectedVariantCode: selectedVariantCode,
                preorder: preorder,
                isFBC: isFBC,
                delivery: delivery,
                dietary: dietary,
                deliveryFees: deliveryFees,
                soldByWeight: soldByWeight,
                campaignId: campaignId,
                campaignName: campaignName,
                adtechCarouselId: adtechCarouselId,
            };
        });
        return productCards;
    };
    return ProductTransformerV2;
}(ProductTransformer));
var ProductServices =  (function (_super) {
    __extends$1(ProductServices, _super);
    function ProductServices() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductServices.prototype.getRelevanceByKeyword = function (keyword, placements) {
        return __awaiter$1(this, void 0, void 0, function () {
            var relevantProducts;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 , this.doGet(GET_RELEVANCE_PRODUCTS_KEYWORD, {
                            keyword: keyword,
                            placements: placements,
                        })];
                    case 1:
                        relevantProducts = _a.sent();
                        if (relevantProducts && relevantProducts.placements) {
                            return [2 , this.getRelevantProductCards(relevantProducts)];
                        }
                        return [2 ];
                }
            });
        });
    };
    ProductServices.prototype.getRelevanceById = function (id, placements) {
        return __awaiter$1(this, void 0, void 0, function () {
            var relevantProducts;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 , this.doGet(GET_RELEVANCE_PRODUCTS_ID, {
                            id: id,
                            placements: placements,
                        })];
                    case 1:
                        relevantProducts = _a.sent();
                        if (relevantProducts && relevantProducts.placements) {
                            return [2 , this.getRelevantProductCards(relevantProducts)];
                        }
                        return [2 ];
                }
            });
        });
    };
    ProductServices.prototype.getRelevanceByKeywordV2 = function (keyword, placements) {
        return __awaiter$1(this, void 0, void 0, function () {
            var store, _a, _b, appConfig, _c, deliveryTime, _d, pageStructure, _e, pageIntent, intent, nonFoodV2GbValue, intentHeaders, relevantProducts;
            return __generator$1(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        store = getStore();
                        _a = (store === null || store === void 0 ? void 0 : store.getState()) || {}, _b = _a.appConfig, appConfig = _b === void 0 ? {} : _b, _c = _a.deliveryTime, deliveryTime = _c === void 0 ? {} : _c, _d = _a.pageStructure, pageStructure = _d === void 0 ? [] : _d;
                        _e = appConfig.pageIntent, pageIntent = _e === void 0 ? false : _e;
                        intent = getSearchIntent(pageIntent, deliveryTime);
                        nonFoodV2GbValue = isNonFoodV2Enabled((store === null || store === void 0 ? void 0 : store.getState()) || {});
                        intentHeaders = {};
                        if (nonFoodV2GbValue.value) {
                            intentHeaders = getIntentAndServiceType(pageStructure);
                        }
                        return [4 , this.doGet(GET_RELEVANCE_PRODUCTS_KEYWORD, {
                                keyword: keyword,
                                placements: placements,
                                headers: __assign$1({ intent: intent }, intentHeaders),
                            })];
                    case 1:
                        relevantProducts = _f.sent();
                        return [2 , this.mapRelvantProductCards(relevantProducts)];
                }
            });
        });
    };
    ProductServices.prototype.getRelevanceByIdV2 = function (id, placements) {
        return __awaiter$1(this, void 0, void 0, function () {
            var relevantProducts;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 , this.doGet(GET_RELEVANCE_PRODUCTS_ID, {
                            id: id,
                            placements: placements,
                        })];
                    case 1:
                        relevantProducts = _a.sent();
                        return [2 , this.mapRelvantProductCards(relevantProducts)];
                }
            });
        });
    };
    ProductServices.prototype.getProductCardsByIdV2 = function (ids, recommendedProducts) {
        return __awaiter$1(this, void 0, void 0, function () {
            var store, _a, _b, appConfig, _c, deliveryTime, _d, pageStructure, _e, pageIntent, intent, nonFoodV2GbValue, intentHeaders, _f, products, transformer, formattedProducts;
            return __generator$1(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        store = getStore();
                        _a = (store === null || store === void 0 ? void 0 : store.getState()) || {}, _b = _a.appConfig, appConfig = _b === void 0 ? {} : _b, _c = _a.deliveryTime, deliveryTime = _c === void 0 ? {} : _c, _d = _a.pageStructure, pageStructure = _d === void 0 ? [] : _d;
                        _e = appConfig.pageIntent, pageIntent = _e === void 0 ? false : _e;
                        intent = getSearchIntent(pageIntent, deliveryTime);
                        nonFoodV2GbValue = isNonFoodV2Enabled((store === null || store === void 0 ? void 0 : store.getState()) || {});
                        intentHeaders = {};
                        if (nonFoodV2GbValue.value) {
                            intentHeaders = getIntentAndServiceType(pageStructure);
                        }
                        return [4 , this.doGet(GET_PRODUCTS_BY_IDS_V4, { ids: ids, headers: __assign$1({ intent: intent }, intentHeaders) })];
                    case 1:
                        _f = (_g.sent()).products, products = _f === void 0 ? [] : _f;
                        transformer = new ProductTransformerV2(products);
                        formattedProducts = transformer.getProductCards(recommendedProducts);
                        return [2 , formattedProducts];
                }
            });
        });
    };
    ProductServices.prototype.getProductCardsByFilters = function (productsFilterPayload, recommendedProducts) {
        return __awaiter$1(this, void 0, void 0, function () {
            var store, _a, _b, appConfig, _c, deliveryTime, _d, pageStructure, _e, pageIntent, _f, latitude, _g, longitude, _h, lang, intent, nonFoodV2GbValue, intentHeaders, transformedProducts, _j, data, transformer, formattedProducts;
            return __generator$1(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        store = getStore();
                        _a = (store === null || store === void 0 ? void 0 : store.getState()) || {}, _b = _a.appConfig, appConfig = _b === void 0 ? {} : _b, _c = _a.deliveryTime, deliveryTime = _c === void 0 ? {} : _c, _d = _a.pageStructure, pageStructure = _d === void 0 ? [] : _d;
                        _e = appConfig.pageIntent, pageIntent = _e === void 0 ? false : _e, _f = appConfig.latitude, latitude = _f === void 0 ? '' : _f, _g = appConfig.longitude, longitude = _g === void 0 ? '' : _g, _h = appConfig.language, lang = _h === void 0 ? '' : _h;
                        intent = getSearchIntent(pageIntent, deliveryTime);
                        nonFoodV2GbValue = isNonFoodV2Enabled((store === null || store === void 0 ? void 0 : store.getState()) || {});
                        intentHeaders = {};
                        if (nonFoodV2GbValue.value) {
                            intentHeaders = getIntentAndServiceType(pageStructure);
                        }
                        transformedProducts = productsFilterPayload.map(function (product) { return (__assign$1({ id: product.productId }, (product.filters && { filters: product.filters }))); });
                        return [4 , this.doGet(GET_PRODUCTS_BY_FILTERS_V4, { headers: __assign$1({ intent: intent }, intentHeaders) }, true, {
                                method: EApiMiddlewareMethod$1.POST,
                                data: {
                                    products: transformedProducts,
                                    locationParams: {
                                        latitude: latitude,
                                        longitude: longitude,
                                    },
                                    lang: lang,
                                },
                            })];
                    case 1:
                        _j = (_k.sent()).data, data = _j === void 0 ? {} : _j;
                        transformer = new ProductTransformerV2(data === null || data === void 0 ? void 0 : data.products);
                        formattedProducts = transformer.getProductCards(recommendedProducts);
                        return [2 , formattedProducts];
                }
            });
        });
    };
    ProductServices.prototype.getProductCardsWithOffset = function (ids, recommendedProducts, nextPageOffset) {
        if (nextPageOffset === void 0) { nextPageOffset = 0; }
        return __awaiter$1(this, void 0, void 0, function () {
            var _a, products, nextOffset, transformer, formattedProducts;
            return __generator$1(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 , this.doGet(GET_PRODUCTS_BY_IDS_WITH_OFFSET, {
                            ids: ids,
                            nextPageOffset: nextPageOffset,
                        })];
                    case 1:
                        _a = _b.sent(), products = _a.products, nextOffset = _a.nextOffset;
                        transformer = new ProductTransformer(products);
                        formattedProducts = transformer.getProductCards(recommendedProducts);
                        return [2 , { products: formattedProducts, nextOffset: nextOffset }];
                }
            });
        });
    };
    ProductServices.prototype.mapRelvantProductCards = function (relevantProducts) {
        if (relevantProducts && relevantProducts.placements) {
            return relevantProducts.placements.map(function (placement) {
                var _a = placement.recommendedProducts, recommendedProducts = _a === void 0 ? [] : _a, strategyMessage = placement.strategyMessage, strategyName = placement.strategyName;
                var transformer = new ProductTransformerV2(recommendedProducts);
                return {
                    strategyMessage: strategyMessage,
                    strategyName: strategyName,
                    productCards: transformer.getProductCards(),
                };
            });
        }
    };
    ProductServices.prototype.getRelevantProductCards = function (relevantProducts) {
        return __awaiter$1(this, void 0, void 0, function () {
            var placementData;
            var _this = this;
            return __generator$1(this, function (_a) {
                placementData = relevantProducts.placements;
                return [2 , Promise.all(placementData.map(function (placement) { return __awaiter$1(_this, void 0, void 0, function () {
                        var ids, productCards;
                        return __generator$1(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    ids = placement.recommendedProducts.map(function (product) {
                                        return product.id.toString();
                                    });
                                    return [4 , this.getProductCardsByIdV2(ids, placement.recommendedProducts)];
                                case 1:
                                    productCards = _a.sent();
                                    return [2 , {
                                            strategyMessage: placement.strategyMessage,
                                            strategyName: placement.strategyName,
                                            productCards: productCards,
                                        }];
                            }
                        });
                    }); }))];
            });
        });
    };
    ProductServices.prototype.getRelevance = function (_a, isSponsoredFbt, productL1Category) {
        if (isSponsoredFbt === void 0) { isSponsoredFbt = false; }
        if (productL1Category === void 0) { productL1Category = ''; }
        var id = _a.id, keyword = _a.keyword, placements = _a.placements, extraParams = __rest$1(_a, ["id", "keyword", "placements"]);
        return __awaiter$1(this, void 0, void 0, function () {
            var store, _b, _c, appConfig, _d, deliveryTime, _e, pageStructure, _f, storeId, _g, pageIntent, API, param, intent, nonFoodV2GbValue, intentHeaders, eParams, relevantProducts;
            return __generator$1(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        store = getStore();
                        _b = (store === null || store === void 0 ? void 0 : store.getState()) || {}, _c = _b.appConfig, appConfig = _c === void 0 ? {} : _c, _d = _b.deliveryTime, deliveryTime = _d === void 0 ? {} : _d, _e = _b.pageStructure, pageStructure = _e === void 0 ? [] : _e;
                        _f = appConfig || {}, storeId = _f.storeId, _g = _f.pageIntent, pageIntent = _g === void 0 ? false : _g;
                        API = GET_RELEVANCE_PRODUCTS_KEYWORD;
                        param = { keyword: keyword };
                        if (id) {
                            API = isSponsoredFbt
                                ? GET_RELEVANCE_PRODUCTS_ID + "&requireSponsProducts=true&categoryId=" + productL1Category
                                : GET_RELEVANCE_PRODUCTS_ID;
                            param = { id: id };
                        }
                        if (storeId === 'mafuae' && placements.includes('home_page')) {
                            API = GET_RELEVANCE_PRODUCTS_KEYWORD_HOME;
                        }
                        if (placements.includes('buy_again_alternatives')) {
                            API = GET_RELEVANCE_PRODUCTS_FOR_OOS_ITEM;
                        }
                        intent = getSearchIntent(pageIntent, deliveryTime);
                        nonFoodV2GbValue = isNonFoodV2Enabled((store === null || store === void 0 ? void 0 : store.getState()) || {});
                        intentHeaders = {};
                        if (nonFoodV2GbValue.value) {
                            intentHeaders = getIntentAndServiceType(pageStructure);
                        }
                        eParams = __assign$1(__assign$1({}, extraParams), { headers: __assign$1(__assign$1(__assign$1({}, extraParams.headers), { intent: intent }), intentHeaders) });
                        return [4 , this.doGet(API, __assign$1(__assign$1({ placements: placements }, param), eParams))];
                    case 1:
                        relevantProducts = _h.sent();
                        if (relevantProducts === null || relevantProducts === void 0 ? void 0 : relevantProducts.placements) {
                            return [2 , relevantProducts.placements.map(function (placement) {
                                    var _a = placement.recommendedProducts, recommendedProducts = _a === void 0 ? [] : _a;
                                    return __assign$1(__assign$1({}, placement), { recommendedProducts: new ProductTransformerV2(recommendedProducts).getProductCards() });
                                })];
                        }
                        else {
                            return [2 , []];
                        }
                }
            });
        });
    };
    return ProductServices;
}(BaseService));
var ProductServices$1 = new ProductServices();
var AppConfigService =  (function (_super) {
    __extends$1(AppConfigService, _super);
    function AppConfigService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppConfigService.prototype.getAppCountryConfig = function (params) {
        return __awaiter$1(this, void 0, void 0, function () {
            var isAbsUrl, url;
            return __generator$1(this, function (_a) {
                isAbsUrl = process.env.APIGEE_ENDPOINT ? true : false;
                url = isAbsUrl ? process.env.APIGEE_ENDPOINT + "/v1/" + GET_USER_COUNTRY_CONFIG : GET_USER_COUNTRY_CONFIG;
                return [2 , this.doSafeGet(url, __assign$1(__assign$1({}, params), { apiVersion: 1 }), isAbsUrl)];
            });
        });
    };
    AppConfigService.prototype.getHeaderDetails = function (params) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 , this.doGet(GET_HEADER, params, true)];
            });
        });
    };
    AppConfigService.prototype.getFeatureDetails = function (params) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 , this.doSafeGet(FETCH_GROWTHBOOK, params, true)];
            });
        });
    };
    AppConfigService.prototype.getAppMenu = function (params) {
        if (params === void 0) { params = {}; }
        return this.doGet(GET_MENU_NAVIGATION, params, true);
    };
    AppConfigService.prototype.setAreaCode = function (areaCode, params) {
        return this.doPut(SET_DELIVERY_AREA, __assign$1({ areaCode: areaCode }, params));
    };
    AppConfigService.prototype.getCoachMarkDetails = function (params) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 , this.doGet(GET_COACHMARK_DETAILS, params, true)];
            });
        });
    };
    AppConfigService.prototype.getAppDeliveryMenu = function (areaCode, storeId, language, latitude, longitude, addressId, guid, isStoreClosureEnabled) {
        var apiUrl = isStoreClosureEnabled ? GET_NAVBAR_DELIVERY_NEW : GET_NAVBAR_DELIVERY;
        var headers = isStoreClosureEnabled
            ? __assign$1({ latitude: latitude, longitude: longitude, addressId: addressId, lang: language }, (guid && { guid: guid })) : {};
        if (latitude && longitude) {
            return this.doGet(apiUrl, { areaCode: areaCode, storeId: storeId, language: language, latitude: latitude, longitude: longitude, headers: headers });
        }
        return this.doGet(apiUrl, { areaCode: areaCode, storeId: storeId, language: language, headers: headers }, false);
    };
    AppConfigService.prototype.getCountryConfig = function (params) {
        return this.getAppCountryConfig(params);
    };
    AppConfigService.prototype.getPageStructure = function (storeId, lang, serviceInfo, nonFoodV2GbValue) {
        return __awaiter$1(this, void 0, void 0, function () {
            var isNonFoodV2Enabled, pageStructureUid;
            return __generator$1(this, function (_a) {
                isNonFoodV2Enabled = nonFoodV2GbValue.value, pageStructureUid = nonFoodV2GbValue.pageStructureUid;
                return [2 , this.doGet(isNonFoodV2Enabled ? GET_PAGE_STRUCTURE_V2 : GET_PAGE_STRUCTURE, {
                        storeId: storeId,
                        headers: {
                            lang: lang,
                            storeId: storeId,
                            langCode: lang,
                            serviceInfo: serviceInfo,
                        },
                        pageStructureUid: pageStructureUid,
                    }, !isServer() ? true : false)];
            });
        });
    };
    AppConfigService.prototype.getCountryDetailsApi = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 , this.doGet(GET_COUNTRY_DETAILS_API, {}, true)];
            });
        });
    };
    return AppConfigService;
}(BaseService));
var AppConfigService$1 = new AppConfigService();
var getBusyHourStatus = function (slot) { var _a; return !!((_a = slot === null || slot === void 0 ? void 0 : slot.busyStatus) === null || _a === void 0 ? void 0 : _a.isBusy); };
var getOfflineHourStatus = function (slot) { return !!(!(slot === null || slot === void 0 ? void 0 : slot.isAvailable) && (slot === null || slot === void 0 ? void 0 : slot.nextAvailableSlot)); };
var getNextAvailableSlot = function (slot, isOfflineHour) {
    return isOfflineHour ? slot === null || slot === void 0 ? void 0 : slot.nextAvailableSlot : undefined;
};
var getBusyHourDisclaimer = function (slot, isBusyHour) { var _a, _b; return isBusyHour ? (_b = (_a = slot === null || slot === void 0 ? void 0 : slot.busyStatus) === null || _a === void 0 ? void 0 : _a.disclaimerMessage) !== null && _b !== void 0 ? _b : '' : ''; };
var headTabActions = function () { return function (dispatch, getState, cookies) { return __awaiter$1(void 0, void 0, void 0, function () {
    var store, appConfig, deliveryTime, _a, areaCode, _b, language, _c, storeId, _d, latitude, _e, longitude, isPolygonChange, lat, long, addressId, token, guid, guidHeader, responsePageStructure, responseDeliveryTime, nonFoodV2GbValue, isStoreClosureEnabled$1, err_1, _f, _g, standardSlot, _h, expressSlot, _j, qcommSlot, _k, availableServices, serviceInfo, err_2, _l, topNavigations, navigations, expressPos, e_1;
    var _m, _o, _p;
    return __generator$1(this, function (_q) {
        switch (_q.label) {
            case 0:
                store = getState();
                appConfig = store.appConfig, deliveryTime = store.deliveryTime;
                _a = appConfig.areaCode, areaCode = _a === void 0 ? '' : _a, _b = appConfig.language, language = _b === void 0 ? 'en' : _b, _c = appConfig.storeId, storeId = _c === void 0 ? 'mafuae' : _c, _d = appConfig.latitude, latitude = _d === void 0 ? '' : _d, _e = appConfig.longitude, longitude = _e === void 0 ? '' : _e, isPolygonChange = appConfig.isPolygonChange;
                _q.label = 1;
            case 1:
                _q.trys.push([1, 10, , 11]);
                lat = (cookies === null || cookies === void 0 ? void 0 : cookies.get('lat')) || latitude;
                long = (cookies === null || cookies === void 0 ? void 0 : cookies.get('long')) || longitude;
                addressId = (cookies === null || cookies === void 0 ? void 0 : cookies.get('selectedAddressID')) || '';
                token = (cookies === null || cookies === void 0 ? void 0 : cookies.get('authToken')) || '';
                guid = cookies === null || cookies === void 0 ? void 0 : cookies.get(storeId + "-cart");
                guidHeader = !token && guid ? guid : '';
                responsePageStructure = [];
                responseDeliveryTime = (deliveryTime || {});
                nonFoodV2GbValue = isNonFoodV2Enabled(store);
                isStoreClosureEnabled$1 = isStoreClosureEnabled(store);
                if (!!isPolygonChange) return [3 , 5];
                _q.label = 2;
            case 2:
                _q.trys.push([2, 4, , 5]);
                return [4 , AppConfigService$1.getAppDeliveryMenu(areaCode, storeId, language || 'en', lat, long, addressId, guidHeader, isStoreClosureEnabled$1)];
            case 3:
                responseDeliveryTime = _q.sent();
                return [3 , 5];
            case 4:
                err_1 = _q.sent();
                console.error('deliveryTime API failed', err_1);
                return [3 , 5];
            case 5:
                _f = responseDeliveryTime || {}, _g = _f.standardSlot, standardSlot = _g === void 0 ? {} : _g, _h = _f.expressSlot, expressSlot = _h === void 0 ? {} : _h, _j = _f.qcommSlot, qcommSlot = _j === void 0 ? {} : _j, _k = _f.availableServices, availableServices = _k === void 0 ? '' : _k;
                serviceInfo = availableServices;
                if (!availableServices) {
                    console.info('Empty Available service', JSON.stringify({ responseDeliveryTime: responseDeliveryTime, lat: lat, long: long, areaCode: areaCode }));
                }
                _q.label = 6;
            case 6:
                _q.trys.push([6, 8, , 9]);
                return [4 , AppConfigService$1.getPageStructure(storeId, language, serviceInfo, nonFoodV2GbValue)];
            case 7:
                responsePageStructure = _q.sent();
                return [3 , 9];
            case 8:
                err_2 = _q.sent();
                console.error('Page Structure API failed', err_2);
                return [3 , 9];
            case 9:
                _l = responsePageStructure.topNavigations, topNavigations = _l === void 0 ? [] : _l;
                navigations = responseDeliveryTime
                    ? populatePageStructure({
                        deliveryTime: responseDeliveryTime,
                        topNavigations: topNavigations,
                        isNonFoodV2Enabled: (nonFoodV2GbValue === null || nonFoodV2GbValue === void 0 ? void 0 : nonFoodV2GbValue.value) || false,
                    })
                    : topNavigations;
                dispatch({
                    type: EPageSturctureTypes$1.SET_PAGE_STRUCTURE,
                    payload: navigations,
                });
                dispatch({
                    type: EDeliveryTimeTypes.SET_DELIVERY_TIME,
                    payload: responseDeliveryTime,
                });
                expressPos = responseDeliveryTime.expressSlot || ((_m = responseDeliveryTime === null || responseDeliveryTime === void 0 ? void 0 : responseDeliveryTime.expressSlot) === null || _m === void 0 ? void 0 : _m.nextAvailableSlot);
                dispatch(init({
                    expressPos: expressPos,
                }));
                return [2 , {
                        isNowAvailable: (expressSlot === null || expressSlot === void 0 ? void 0 : expressSlot.isAvailable) || (expressSlot === null || expressSlot === void 0 ? void 0 : expressSlot.nextAvailableSlot) ? true : false,
                        isQuickCommerceAvailable: (qcommSlot === null || qcommSlot === void 0 ? void 0 : qcommSlot.isAvailable) || (qcommSlot === null || qcommSlot === void 0 ? void 0 : qcommSlot.nextAvailableSlot),
                        isQuickCommerceNextSlot: (qcommSlot === null || qcommSlot === void 0 ? void 0 : qcommSlot.nextAvailableSlot) ? true : false,
                        isNowNextSlot: (expressSlot === null || expressSlot === void 0 ? void 0 : expressSlot.nextAvailableSlot) ? true : false,
                        isNowBusyHour: (_o = expressSlot === null || expressSlot === void 0 ? void 0 : expressSlot.busyStatus) === null || _o === void 0 ? void 0 : _o.isBusy,
                        isQcommBusyHour: (_p = qcommSlot === null || qcommSlot === void 0 ? void 0 : qcommSlot.busyStatus) === null || _p === void 0 ? void 0 : _p.isBusy,
                        topNavigations: navigations,
                        isStandardAvailable: (standardSlot === null || standardSlot === void 0 ? void 0 : standardSlot.isAvailable) || false,
                    }];
            case 10:
                e_1 = _q.sent();
                console.error(e_1);
                return [2 , {
                        isNowAvailable: false,
                        isQuickCommerceAvailable: false,
                        isNowNextSlot: false,
                        isQuickCommerceNextSlot: false,
                        isNowBusyHour: false,
                        isQcommBusyHour: false,
                        topNavigations: [],
                        isStandardAvailable: false,
                    }];
            case 11: return [2 ];
        }
    });
}); }; };
function populatePageStructure(_a) {
    var deliveryTime = _a.deliveryTime, topNavigations = _a.topNavigations, isNonFoodV2Enabled = _a.isNonFoodV2Enabled;
    var _b = deliveryTime.standardSlot, standardSlot = _b === void 0 ? {} : _b, _c = deliveryTime.expressSlot, expressSlot = _c === void 0 ? {} : _c, _d = deliveryTime.dynamicPlaceHolders, dynamicPlaceHolders = _d === void 0 ? {} : _d;
    if (isNonFoodV2Enabled) {
        topNavigations.map(function (navigation) {
            navigation.components.forEach(function (item) {
                var _a;
                if ((item === null || item === void 0 ? void 0 : item.type) !== Constants.STATIC) {
                    for (var key in dynamicPlaceHolders) {
                        if (dynamicPlaceHolders[key])
                            item.title = ((_a = item.title) === null || _a === void 0 ? void 0 : _a.replace(new RegExp("{{" + key + "}}", 'g'), dynamicPlaceHolders[key])) || '';
                    }
                    var pattern = /{{[^{}]*}}/;
                    if (pattern.test(item.title)) {
                        item.title = '';
                    }
                }
            });
        });
    }
    else {
        if (topNavigations && topNavigations.length > 1) {
            if (expressSlot) {
                var _e = expressSlot.formattedSlot, formattedSlot_1 = _e === void 0 ? '' : _e, _f = expressSlot.isAvailable, isAvailable = _f === void 0 ? false : _f, nextAvailableSlot_1 = expressSlot.nextAvailableSlot;
                var _g = topNavigations[1].components, components = _g === void 0 ? [] : _g;
                if (components.length > 0) {
                    components.forEach(function (item) {
                        if (item.type !== Constants.STATIC) {
                            item.subTitle = formattedSlot_1 || (nextAvailableSlot_1 === null || nextAvailableSlot_1 === void 0 ? void 0 : nextAvailableSlot_1.description) || '';
                        }
                    });
                }
                topNavigations[1].isAvailable = isAvailable;
                topNavigations[1].isHide = nextAvailableSlot_1 || isAvailable ? false : true;
            }
            else {
                topNavigations[1].isAvailable = false;
                topNavigations[1].isHide = true;
            }
        }
        if (topNavigations && topNavigations.length > 0) {
            if (standardSlot) {
                var _h = standardSlot.formattedSlot, formattedSlot_2 = _h === void 0 ? '' : _h, _j = standardSlot.isAvailable, isAvailable = _j === void 0 ? false : _j;
                var _k = topNavigations[0].components, components = _k === void 0 ? [] : _k;
                if (components.length > 0) {
                    components.forEach(function (item) {
                        var _a;
                        if (item.type !== Constants.STATIC) {
                            item.subTitle =
                                formattedSlot_2 || (expressSlot === null || expressSlot === void 0 ? void 0 : expressSlot.formattedSlot) || ((_a = expressSlot === null || expressSlot === void 0 ? void 0 : expressSlot.nextAvailableSlot) === null || _a === void 0 ? void 0 : _a.description) || '';
                        }
                    });
                }
                topNavigations[0].isAvailable = isAvailable;
                topNavigations[0].isHide = formattedSlot_2 ? false : true;
            }
            else {
                topNavigations[0].isAvailable = false;
                topNavigations[0].isHide = false;
            }
        }
    }
    return topNavigations;
}
var getDeliveryTime = function () { return function (dispatch, store, cookies, isPolygonChange) { return __awaiter$1(void 0, void 0, void 0, function () {
    var appConfig, _a, pageStructure, _b, areaCode, _c, language, _d, storeId, latitude, longitude, defaultCountryLat, _e, posInfoConfig, defaultCountryLng, lat, lng, addressId, token, guid, guidHeader, shouldNotFetchCoachMark, isStoreClosureEnabled$1, responseDeliveryTime, expressPos, nonFoodV2GbValue, pageType, navigations, updatedDeliveryInfo, e_2;
    var _f;
    return __generator$1(this, function (_g) {
        switch (_g.label) {
            case 0:
                appConfig = store.appConfig, _a = store.pageStructure, pageStructure = _a === void 0 ? [] : _a;
                _b = appConfig.areaCode, areaCode = _b === void 0 ? '' : _b, _c = appConfig.language, language = _c === void 0 ? 'en' : _c, _d = appConfig.storeId, storeId = _d === void 0 ? 'mafuae' : _d, latitude = appConfig.latitude, longitude = appConfig.longitude, defaultCountryLat = appConfig.defaultCountryLat, _e = appConfig.posInfoConfig, posInfoConfig = _e === void 0 ? [] : _e, defaultCountryLng = appConfig.defaultCountryLng;
                if (isPolygonChange) {
                    removeDeliveryAreaInfoCookie(cookies);
                }
                lat = latitude || (cookies === null || cookies === void 0 ? void 0 : cookies.get('lat')) || defaultCountryLat || '';
                lng = longitude || (cookies === null || cookies === void 0 ? void 0 : cookies.get('long')) || defaultCountryLng || '';
                addressId = (cookies === null || cookies === void 0 ? void 0 : cookies.get('selectedAddressID')) || '';
                token = (cookies === null || cookies === void 0 ? void 0 : cookies.get('authToken')) || '';
                guid = cookies === null || cookies === void 0 ? void 0 : cookies.get(storeId + "-cart");
                guidHeader = !token && guid ? guid : '';
                shouldNotFetchCoachMark = cookies === null || cookies === void 0 ? void 0 : cookies.get('hideCoachMark');
                isStoreClosureEnabled$1 = isStoreClosureEnabled(store);
                _g.label = 1;
            case 1:
                _g.trys.push([1, 6, , 7]);
                return [4 , AppConfigService$1.getAppDeliveryMenu(areaCode, storeId, language || 'en', lat, lng, addressId, guidHeader, isStoreClosureEnabled$1)];
            case 2:
                responseDeliveryTime = _g.sent();
                expressPos = responseDeliveryTime.expressSlot || ((_f = responseDeliveryTime === null || responseDeliveryTime === void 0 ? void 0 : responseDeliveryTime.expressSlot) === null || _f === void 0 ? void 0 : _f.nextAvailableSlot);
                nonFoodV2GbValue = isNonFoodV2Enabled(store);
                pageType = (cookies === null || cookies === void 0 ? void 0 : cookies.get('page_type')) || 'home';
                if (pageStructure.length > 0) {
                    navigations = populatePageStructure({
                        deliveryTime: responseDeliveryTime,
                        topNavigations: pageStructure,
                        isNonFoodV2Enabled: nonFoodV2GbValue === null || nonFoodV2GbValue === void 0 ? void 0 : nonFoodV2GbValue.value,
                    });
                    dispatch({
                        type: EPageSturctureTypes$1.SET_PAGE_STRUCTURE,
                        payload: navigations,
                    });
                }
                return [4 , dispatch({
                        type: EDeliveryTimeTypes.SET_DELIVERY_TIME,
                        payload: responseDeliveryTime,
                    })];
            case 3:
                _g.sent();
                if (!((nonFoodV2GbValue === null || nonFoodV2GbValue === void 0 ? void 0 : nonFoodV2GbValue.value) && !shouldNotFetchCoachMark && pageType === 'home')) return [3 , 5];
                return [4 , getCoachMarksDetails()(dispatch, store, language, storeId)];
            case 4:
                _g.sent();
                _g.label = 5;
            case 5:
                if (responseDeliveryTime.deliveryAreaInfo && isPolygonChange) {
                    updatedDeliveryInfo = responseDeliveryTime.deliveryAreaInfo.filter(function (item) {
                        return posInfoConfig.includes(item === null || item === void 0 ? void 0 : item.serviceType);
                    });
                    setDeliveryAreaInfo(updatedDeliveryInfo, cookies);
                }
                if (!responseDeliveryTime.expressSlot) {
                    removeNowJourneyCookie();
                }
                if (appConfig === null || appConfig === void 0 ? void 0 : appConfig.changingLocation) {
                    dispatch(init({
                        expressPos: expressPos,
                        changingLocation: false,
                        isPolygonChange: isPolygonChange,
                    }));
                }
                else {
                    dispatch(init({
                        expressPos: expressPos,
                        isPolygonChange: isPolygonChange,
                    }));
                }
                return [2 , responseDeliveryTime];
            case 6:
                e_2 = _g.sent();
                if (isPolygonChange) {
                    removeDeliveryAreaInfoCookie();
                }
                console.error(e_2);
                return [3 , 7];
            case 7: return [2 ];
        }
    });
}); }; };
var getCoachMarksDetails = function () { return function (dispatch, store, lang, storeId) { return __awaiter$1(void 0, void 0, void 0, function () {
    var _a, _b, coachMarksUid, _c, components, e_3;
    return __generator$1(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 3, , 4]);
                _a = ((store === null || store === void 0 ? void 0 : store.appConfig) || { coachMarksUid: '' }).nonFoodUIDs, _b = (_a === void 0 ? {} : _a).coachMarksUid, coachMarksUid = _b === void 0 ? '' : _b;
                return [4 , AppConfigService$1.getCoachMarkDetails({
                        coachMarksUid: coachMarksUid,
                        headers: { storeId: storeId, lang: lang },
                    })];
            case 1:
                _c = (_d.sent()).components, components = _c === void 0 ? [] : _c;
                return [4 , dispatch({
                        type: EDeliveryTimeTypes.SET_COACHMARKS,
                        payload: components,
                    })];
            case 2:
                _d.sent();
                return [3 , 4];
            case 3:
                e_3 = _d.sent();
                console.error(e_3);
                return [3 , 4];
            case 4: return [2 ];
        }
    });
}); }; };
var userJourneyActions = function (dispatch, getState, cookies) { return __awaiter$1(void 0, void 0, void 0, function () {
    var _a, _b, pageStructure, deliveryTime, result, tabsResponse;
    var _c;
    return __generator$1(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = getState(), _b = _a.pageStructure, pageStructure = _b === void 0 ? [] : _b, deliveryTime = _a.deliveryTime;
                result = {};
                if (!(pageStructure.length && deliveryTime)) return [3 , 1];
                result.isStandardAvailable = ((_c = deliveryTime.standardSlot) === null || _c === void 0 ? void 0 : _c.isAvailable) || false;
                slots.forEach(function (_a) {
                    var key = _a.key, busyHourKey = _a.busyHourKey, offlineHourKey = _a.offlineHourKey, nextSlotKey = _a.nextSlotKey, disclaimerKey = _a.disclaimerKey, unavailableHourKey = _a.unavailableHourKey, nextSlot = _a.nextSlot;
                    var slotData = deliveryTime[key];
                    var isBusyHour = getBusyHourStatus(slotData);
                    var isOfflineHour = getOfflineHourStatus(slotData);
                    result[busyHourKey] = isBusyHour;
                    result[offlineHourKey] = isOfflineHour;
                    result[nextSlotKey] = getNextAvailableSlot(slotData, isOfflineHour);
                    result[disclaimerKey] = getBusyHourDisclaimer(slotData, isBusyHour);
                    result[unavailableHourKey] = isBusyHour || isOfflineHour;
                    result[nextSlot] = !!slotData.nextAvailableSlot;
                });
                return [2 , __assign$1(__assign$1({}, result), { topNavigations: pageStructure })];
            case 1: return [4 , headTabActions()(dispatch, getState, cookies)];
            case 2:
                tabsResponse = _d.sent();
                return [2 , tabsResponse];
        }
    });
}); };
var headTab_actions = Object.freeze({
    __proto__: null,
    headTabActions: headTabActions,
    getDeliveryTime: getDeliveryTime,
    getCoachMarksDetails: getCoachMarksDetails,
    userJourneyActions: userJourneyActions
});
var addRedirection = function (url, redirection) {
    return url + "?redirect=" + redirection;
};
var updateQueryStringParamter = function (uri, key, value) {
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + encodeURIComponent(value) + '$2');
    }
    else {
        return uri + separator + key + '=' + encodeURIComponent(value);
    }
};
var url_util = Object.freeze({
    __proto__: null,
    addRedirection: addRedirection,
    updateQueryStringParamter: updateQueryStringParamter
});
var getImageUrl = function (product) {
    return product.images && product.images.length > 0 ? product.images[product.images.length - 1].url : '';
};
var updateImageResizeInUrl = function (url, resizeValue) {
    var resizePattern = /\?im=Resize=\d+/;
    var match = url.match(resizePattern);
    if (match && resizeValue) {
        return url.replace(resizePattern, "?im=Resize=" + resizeValue);
    }
    else if (!match && resizeValue) {
        var separator = url.includes('?') ? '&' : '?';
        return "" + url + separator + "im=Resize=" + resizeValue;
    }
    else {
        return url;
    }
};
var image_util = Object.freeze({
    __proto__: null,
    getImageUrl: getImageUrl,
    updateImageResizeInUrl: updateImageResizeInUrl
});
var setDisabled = function (state) { return ({
    type: EProductListTypes$1.SET_DISABLED,
    payload: state,
}); };
var setRelevantProductId = function (id) { return ({
    type: EProductListTypes$1.SET_RELEVANT_PRODUCT_ID,
    payload: id,
}); };
var setExpandedQtySelectorProductId = function (productId) {
    if (productId === void 0) { productId = ''; }
    return ({
        type: EProductListTypes$1.SET_EXPANDED_QTY_SELECTOR_PRODUCT_ID,
        payload: productId,
    });
};
var setLoading = function (productId, loading) { return ({
    type: EProductCardTypes$1.SET_LOADING,
    payload: { productId: productId, loading: loading },
}); };
var setError = function (productId, error, errDetail, persistent) {
    if (errDetail === void 0) { errDetail = ''; }
    if (persistent === void 0) { persistent = true; }
    return ({
        type: EProductCardTypes$1.SET_ERROR,
        payload: { productId: productId, error: error, errDetail: errDetail, persistent: persistent },
    });
};
var getAlgoliaUrl = function (url, params) {
    var _a = params.productPositions, productPositions = _a === void 0 ? '' : _a, _b = params.searchQueryID, searchQueryID = _b === void 0 ? '' : _b, _c = params.sortBy, sortBy = _c === void 0 ? '' : _c;
    var urlParams = [];
    if (productPositions) {
        urlParams.push('productPositions=[{{productPositions}}]');
    }
    if (searchQueryID) {
        urlParams.push('searchQueryID={{searchQueryID}}');
    }
    if (sortBy) {
        urlParams.push('sortBy={{sortBy}}');
    }
    if (urlParams.length > 0) {
        url = url + '&';
    }
    url = url + urlParams.join('&');
    return url;
};
var algoliaTracking = function (trackingParams) { return function (dispatch, getState) {
    var _a = getState().appConfig, language = _a.language, _b = _a.sessionId, sessionId = _b === void 0 ? '' : _b;
    var url = getAlgoliaUrl(TRACKING_ALGOLIA_URL, trackingParams);
    dispatch({
        type: EProductCardTypes$1.SET_TRACKING,
        payload: {
            headers: __assign$1({}, overridesUserIdHeader(sessionId)),
            isAbsUrl: true,
            url: url,
            method: EApiMiddlewareMethod$1.GET,
            params: __assign$1(__assign$1({}, trackingParams), { lang: language }),
        },
    });
}; };
var EProductCardBorderType;
(function (EProductCardBorderType) {
    EProductCardBorderType["DISCOUNT"] = "DISCOUNT";
    EProductCardBorderType["IN_CART"] = "IN_CART";
    EProductCardBorderType["ORIGINAL"] = "ORIGINAL";
    EProductCardBorderType["SPONSORED_LISTING"] = "SPONSORED_LISTING";
})(EProductCardBorderType || (EProductCardBorderType = {}));
var eventTypeEnum;
(function (eventTypeEnum) {
    eventTypeEnum["add_to_cart"] = "add_to_cart";
    eventTypeEnum["remove_from_cart"] = "remove_from_cart";
    eventTypeEnum["change_the_quantity"] = "change_the_quantity";
})(eventTypeEnum || (eventTypeEnum = {}));
var CLICK_EVENT = 'click';
var ATC_EVENT = 'atc';
var STOCK_ALERT = 5;
var QTY_SELECTOR_TIMER = 5000;
var DiscountType;
(function (DiscountType) {
    DiscountType["PERCENTAGE"] = "percentage";
})(DiscountType || (DiscountType = {}));
var ATC_EVENTS_TYPE;
(function (ATC_EVENTS_TYPE) {
    ATC_EVENTS_TYPE["PDP"] = "PDP";
    ATC_EVENTS_TYPE["PLP"] = "PLP";
})(ATC_EVENTS_TYPE || (ATC_EVENTS_TYPE = {}));
var ProductType;
(function (ProductType) {
    ProductType["FOOD"] = "FOOD";
    ProductType["NONFOOD"] = "NONFOOD";
})(ProductType || (ProductType = {}));
var EProductCardVariants;
(function (EProductCardVariants) {
    EProductCardVariants["REGULAR"] = "regular";
    EProductCardVariants["REGULAR_WIDE"] = "regular_wide";
    EProductCardVariants["PDP"] = "pdp";
    EProductCardVariants["SIMPLE"] = "simple";
    EProductCardVariants["LIST"] = "list";
    EProductCardVariants["PLP"] = "plp";
    EProductCardVariants["FBT"] = "fbt";
    EProductCardVariants["MINI"] = "mini";
    EProductCardVariants["COMPACT"] = "compact";
})(EProductCardVariants || (EProductCardVariants = {}));
var CustomStyled = customStyled;
var COLORS = {
    ALTO: '#cfcfcf',
    BODY: '#FAFAFA',
    BLUE: '#0e5aa7',
    BROWN: '#31261D',
    DARK_RED: '#dd2326',
    GREEN: '#009688',
    LIGHT_GREEN: '#019840',
    MERCURY: '#e6e6e6',
    MINE_SHAFT: '#252525',
    MYCLUB: '#690A4F',
    RED: '#ee2527',
    THUNDORA: '#4d4d4d',
    SILVER_CHALICE: '#b2b2b2',
    WHITE: '#fff',
    WILD_SAND: '#f5f5f5',
    YELLOW: '#ffdf28',
    BLUE_500: '#0B4C8E',
    TRANSPARENT_BLUE: 'rgba(14,90,167,0.2)',
    LIGHT_BORDER: '#f5f5f5',
    DARK_GREY: '#4D4D4D',
    LIGHT_GRAY: '#EAEAEA',
    ORANGE: '#E3870F',
    CHERRY: '#8F1639',
    LIGHT_SILVER: 'hsla(0, 0%, 69.8%, 0.2)',
    SEARCH_SILVER: 'rgba(178, 178, 178, 0.2)',
    MEDIUM_GRAY: '#666666',
    LIGHT_BLUE: '#f0f5f8',
    PURPLE: '#0a437c',
    DARK_BLUE: '#0a437c',
    ANCHOR_BLUE: '#0E5AA7',
    LAVENDOR: '#e8eef7',
    BLACK: '#000000',
    VENICEBLUE: '#0C4E91',
    LIGHT_GREY: '#F2F5F8',
    TAUPE_GRAY: '#888888',
    CLARET: '#8A1538',
    LIGHT_RED: '#F34041',
    LIGHT_BROWN: '#5B5030',
    GRAYSCALE: '#F4F4F4',
    SLIMY_GREEN: '#29A71A',
    WHITE_GREEN: '#29a',
    GRAY_800: '#141414',
    GRAY_500: '#747474',
    GRAY_700: '#686868',
    GRAY_100: '#dcdcdc',
    BLUE_25: '#F4FBFE',
    BLUE_800: '#F4FBFE',
    LIGHT_OPAC_BLUE: 'rgba(14,90,167,0.05)',
    SILVER: '#C3C3C3',
    COFFEE_BLACK: '#1F1F1F',
    LIGHT_GREY_100: '#FAFAFB',
    GRAY_900: '#979797',
    HIGHLIGHT_COLOR: '#EBF0F5',
    VIDEO_BG_COLOR: '#173d48',
    ERROR_RED_25: '#FDF4F4',
    ERROR_RED_50: '#FBCFCF',
    ERROR_RED_500: '#CE3637',
};
var SPACINGS = {
    2: '2px',
    4: '4px',
    6: '6px',
    8: '8px',
    10: '10px',
    12: '12px',
    14: '14px',
    16: '16px',
    24: '24px',
    32: '32px',
    40: '40px',
};
var TYPOGRAPHY = {
    SIZE: {
        10: '10px',
        11: '11px',
        12: '12px',
        13: '13px',
        14: '14px',
        16: '16px',
        18: '18px',
        20: '20px',
        22: '22px',
        24: '24px',
        32: '32px',
    },
    WEIGHT: {
        400: 400,
        500: 500,
        600: 600,
        700: 700,
    },
};
var ProductCardWrapper = CustomStyled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject$1(["\n  position: relative;\n  box-shadow: none;\n  border: 1px solid #efefef;\n  font-family: Montserrat;\n  ", "\n\n  ", "\n"], ["\n  position: relative;\n  box-shadow: none;\n  border: 1px solid #efefef;\n  font-family: Montserrat;\n  ",
    "\n\n  ",
    "\n"])), function (props) {
    return props.hasProductVariants
        ? "\n      padding-bottom: 32px;\n    "
        : '';
}, function (props) {
    return variant({
        variants: {
            regular: {
                width: props.isSponsoredListing
                    ? ['auto', null, null, 'auto']
                    : ['auto', null, null, props.carousel ? 'auto' : 223],
                height: props.isSponsoredListing
                    ? [283, null, null, 303]
                    : [props.carousel ? 283 : 303, null, null, props.carousel ? 303 : 381],
                padding: props.isSponsoredListing && ['8px', null, null, '8px'],
            },
            mini: {
                width: ['auto', null, null, 147],
                height: 284,
                padding: ['8px', null, null, '6px'],
            },
            list: {
                height: 116,
                display: 'flex',
                alignItems: 'center',
                borderRadius: '4px',
                padding: '4px !important',
            },
            regular_wide: {
                width: 320,
                height: 120,
            },
            compact: {
                height: 168,
                width: 112,
                padding: '4px !important',
            },
        },
    });
});
ProductCardWrapper.defaultProps = {
    p: ['8px', null, null, 12],
};
var ProductCardHeaderWrapper = CustomStyled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject$1(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  ", "\n\n  ", "\n  \n  & > span, div {\n    ", "\n  }\n\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  ",
    "\n\n  ",
    "\n  \n  & > span, div {\n    ", "\n  }\n\n"])), variant({
    variants: {
        list: {
            position: 'absolute',
            top: '4px',
            height: '28px !important',
            zIndex: 1,
        },
        compact: {
            position: 'absolute',
            height: '14px !important',
            zIndex: 1,
        },
    },
}), function (props) {
    return props.isSponsored &&
        "\n    left: 28px; \n    @media (min-width: props.theme.breakpoints[3]) {\n      left: 32px;\n    }\n  ";
}, function (props) { return props.isSponsored && "border-radius: 2px 2px 12px;"; });
ProductCardHeaderWrapper.defaultProps = {
    height: '28px',
};
var FBCContainer = CustomStyled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject$1(["\nmargin-top: 9px;\nimg {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n}\nspan {\n  margin-left: 8px;\n  font-size: 12px;\n  display: inline-block;\n}\n\n@media (max-width: ", ") {\n  span {\n    font-size: 10px;\n  }\n}\n"], ["\nmargin-top: 9px;\nimg {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n}\nspan {\n  margin-left: 8px;\n  font-size: 12px;\n  display: inline-block;\n}\n\n@media (max-width: ", ") {\n  span {\n    font-size: 10px;\n  }\n}\n"])), function (props) { return props.theme.breakpoints[1]; });
var WishlistIconWrapper = CustomStyled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject$1(["\n  display: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 18px;\n  padding: 0;\n  border: 0;\n  background: none;\n  z-index: 2;\n  & > svg {\n    height: 18px;\n    width: 20px;\n  }\n"], ["\n  display: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 18px;\n  padding: 0;\n  border: 0;\n  background: none;\n  z-index: 2;\n  & > svg {\n    height: 18px;\n    width: 20px;\n  }\n"])));
var HeaderStickerContainer = CustomStyled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject$1(["\n  position: relative;\n  top: -9px;\n  left: -9px;\n\n  @media (min-width: ", ") {\n    top: -13px;\n    left: -13px;\n  }\n"], ["\n  position: relative;\n  top: -9px;\n  left: -9px;\n\n  @media (min-width: ", ") {\n    top: -13px;\n    left: -13px;\n  }\n"])), function (props) { return props.theme.breakpoints[3]; });
var ProductCardNewHeaderSticker = CustomStyled(Sticker)(templateObject_6 || (templateObject_6 = __makeTemplateObject$1(["\n  background: none;\n  border: 0.5px solid;\n  border-color: ", ";\n  padding: 0 4px;\n  height:18px;\n  border-radius: 2px;\n  color: ", ";\n  font-family: Montserrat;\n  font-weight: ", ";\n  font-size: ", "px;\n  position: relative;\n  z-index: 1;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  vertical-align: top;\n   ", "\n     \n     ", "\n"], ["\n  background: none;\n  border: 0.5px solid;\n  border-color: ", ";\n  padding: 0 4px;\n  height:18px;\n  border-radius: 2px;\n  color: ", ";\n  font-family: Montserrat;\n  font-weight: ", ";\n  font-size: ", "px;\n  position: relative;\n  z-index: 1;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  vertical-align: top;\n   ",
    "\n     \n     ",
    "\n"])), COLORS.RED, COLORS.RED, function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.fontSizes[0]; }, function (props) {
    return variant({
        prop: 'type',
        variants: {
            promo: {
                fontWeight: 500,
                background: props.theme.colors.peach,
                padding: '4px 10px',
                borderRadius: '12px 2px',
                color: props.theme.colors.darkRed,
                display: 'block',
                fontSize: props.theme.fontSizes[0] + "px",
                border: 'none',
            },
            discount: {
                border: 0,
            },
            discountThresholdBadge: {
                width: '42px',
                height: '44px',
                fontWeight: 700,
                background: props.theme.colors.peach,
                padding: '10px 5px',
                borderRadius: '12px 2px',
                color: props.theme.colors.darkRed,
                display: 'block',
                fontSize: props.theme.fontSizes[1] + "px",
                border: 'none',
                whiteSpace: 'unset',
            },
        },
    });
}, function (props) {
    return props.dir == 'ltr' &&
        "\n        borderRadius: '2px 12px',\n    ";
});
ProductCardNewHeaderSticker.defaultProps = {
    maxWidth: ['110px', null, null, '120px'],
};
var ProductCardHeaderSticker = CustomStyled(Sticker)(templateObject_7 || (templateObject_7 = __makeTemplateObject$1(["\n  font-weight: 500;\n  text-align: center;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  padding: 4px 10px;\n  background-color: none;\n  color: #EE2527;\n  border-radius: 12px 2px;\n  z-index: 1;\n  position: relative;\n  min-width: auto;\n  max-width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  display: block;\n  ", "\n  ", "\n\n    ", "\n"], ["\n  font-weight: 500;\n  text-align: center;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  padding: 4px 10px;\n  background-color: none;\n  color: #EE2527;\n  border-radius: 12px 2px;\n  z-index: 1;\n  position: relative;\n  min-width: auto;\n  max-width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  display: block;\n  ",
    "\n  ",
    "\n\n    ",
    "\n"])), variant({
    prop: 'productCardType',
    variants: {
        list: {
            padding: '2px 5px',
            maxWidth: 116,
        },
        compact: {
            marginBottom: 0,
        },
    },
}), function (props) {
    return variant({
        prop: 'type',
        variants: {
            cashback: {
                fontSize: props.productCardType === EProductCardVariants.REGULAR ||
                    props.productCardType === EProductCardVariants.REGULAR_WIDE
                    ? 2
                    : 1,
            },
            discount: {
                fontSize: [
                    '8px',
                    null,
                    null,
                    props.productCardType === EProductCardVariants.REGULAR ||
                        props.productCardType === EProductCardVariants.REGULAR_WIDE
                        ? 0
                        : '8px',
                ],
            },
            share: {
                backgroundColor: props.theme.colors.purple,
                borderColor: props.theme.colors.purple,
                borderRadius: 0,
                color: 'white',
                fontSize: 1,
                minWidth: '60%',
            },
            promo: {
                fontSize: [
                    '8px',
                    null,
                    null,
                    props.productCardType === EProductCardVariants.REGULAR ||
                        props.productCardType === EProductCardVariants.REGULAR_WIDE
                        ? 0
                        : '8px',
                ],
            },
        },
    });
}, function (props) {
    return props.dir == 'ltr' &&
        "\n        borderRadius: '2px 12px',\n    ";
});
ProductCardHeaderSticker.defaultProps = {
    maxWidth: ['110px', null, null, '120px'],
};
var ProductCardContentElevation = CustomStyled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject$1(["\n  position: relative;\n  ", "\n"], ["\n  position: relative;\n  ",
    "\n"])), variant({
    variants: {
        list: {
            display: 'flex',
        },
        regular_wide: {
            display: 'flex',
            justifyContent: 'space-around',
            height: '100%',
        },
    },
}));
var ProductCardImageWrapper = CustomStyled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject$1(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var ProductCardImageContainer = CustomStyled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject$1(["\n  margin: 0 auto;\n  padding: 0 10px;\n  position: relative;\n  text-align: center;\n\n  @media (min-width: ", ") {\n    padding: 0;\n  }\n\n  ", "\n\n  a {\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    max-width: 100%;\n\n    img {\n      height: auto;\n      max-height: 100%;\n      max-width: 100%;\n      width: auto;\n    }\n  }\n"], ["\n  margin: 0 auto;\n  padding: 0 10px;\n  position: relative;\n  text-align: center;\n\n  @media (min-width: ", ") {\n    padding: 0;\n  }\n\n  ",
    "\n\n  a {\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    max-width: 100%;\n\n    img {\n      height: auto;\n      max-height: 100%;\n      max-width: 100%;\n      width: auto;\n    }\n  }\n"])), function (props) { return props.theme.breakpoints[0]; }, variant({
    variants: {
        mini: {
            height: 91,
            width: 140,
        },
        regular: {
            height: [91, null, null, 144],
            width: [140, null, null, 211],
        },
    },
}));
var ProductCardExpressWrapper = CustomStyled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject$1(["\n  bottom: 18px;\n  left: 50%;\n  position: absolute;\n  transform: translateX(-50%);\n  z-index: 1;\n"], ["\n  bottom: 18px;\n  left: 50%;\n  position: absolute;\n  transform: translateX(-50%);\n  z-index: 1;\n"])));
var ProductCardTagSticker = CustomStyled(Sticker)(templateObject_12 || (templateObject_12 = __makeTemplateObject$1(["\n  border-width: 1px;\n  bottom: 0;\n  font-size: 11px;\n  left: 50%;\n  padding-top: 5px;\n  position: absolute;\n  text-transform: uppercase;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  z-index: 2;\n\n  ", "\n"], ["\n  border-width: 1px;\n  bottom: 0;\n  font-size: 11px;\n  left: 50%;\n  padding-top: 5px;\n  position: absolute;\n  text-transform: uppercase;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  z-index: 2;\n\n  ",
    "\n"])), function (props) {
    return variant({
        prop: 'type',
        variants: {
            bundlePromo: {
                backgroundColor: props.theme.colors.white,
                borderColor: props.theme.colors.blue,
                color: props.theme.colors.blue,
            },
            clearance: {
                backgroundColor: props.theme.colors.yellow,
                borderColor: props.theme.colors.yellow,
                color: props.theme.colors.red,
            },
            eol: {
                backgroundColor: props.theme.colors.magenta,
                borderColor: props.theme.colors.magenta,
                color: props.theme.colors.alabaster,
            },
            homeDelivery: {
                backgroundColor: props.theme.colors.poloBlue,
                borderColor: props.theme.colors.poloBlue,
                color: props.theme.colors.alabaster,
            },
            new: {
                backgroundColor: props.theme.colors.persiangreen,
                borderColor: props.theme.colors.persiangreen,
                color: props.theme.colors.alabaster,
            },
            onlineExclusive: {
                backgroundColor: props.theme.colors.white,
                borderColor: props.theme.colors.red,
                color: props.theme.colors.red,
                padding: '2px 8px 2px 2px',
            },
            preOrder: {
                backgroundColor: props.theme.colors.deepazure,
                borderColor: props.theme.colors.deepazure,
                color: props.theme.colors.alabaster,
            },
            web: {
                backgroundColor: props.theme.colors.goldenBell,
                borderColor: props.theme.colors.goldenBell,
                color: props.theme.colors.alabaster,
            },
        },
    });
});
var ProductCardName = CustomStyled(Box)(templateObject_13 || (templateObject_13 = __makeTemplateObject$1(["\n  ", "\n\n  > a {\n    color: ", ";\n    display: -webkit-box;\n    line-height: normal;\n    overflow: hidden;\n    text-decoration: none;\n    -webkit-box-orient: vertical;\n    font-size: ", "px;\n    line-height: 16px;\n    ", "\n  }\n"], ["\n  ",
    "\n\n  > a {\n    color: ", ";\n    display: -webkit-box;\n    line-height: normal;\n    overflow: hidden;\n    text-decoration: none;\n    -webkit-box-orient: vertical;\n    font-size: ", "px;\n    line-height: 16px;\n    ",
    "\n  }\n"])), variant({
    variants: {
        list: {
            height: ['26px', null, null, '26px'],
            marginTop: 0,
        },
        regular_wide: {
            height: ['32px', null, null, 'auto'],
        },
        compact: {
            height: ['27px', null, null, '27px'],
        },
        regular: {
            height: ['32px', null, null, 'auto'],
        },
    },
}), function (props) { return props.theme.colors.black; }, function (props) { return props.theme.fontSizes[1]; }, function (props) {
    return variant({
        variants: {
            mini: {
                fontSize: 1,
                WebkitLineClamp: 2,
            },
            regular: {
                fontSize: ['12px', null, null, props.isSponsoredListing ? '12px' : '14px'],
                lineHeight: ['16px', null, null, props.isSponsoredListing ? '16px' : '18px'],
                WebkitLineClamp: 2,
            },
            regular_wide: {
                fontSize: '14px',
                lineHeight: '16px',
                WebkitLineClamp: 2,
            },
            list: {
                fontSize: '11px',
                WebkitLineClamp: 2,
                height: ['26px', null, null, '26px'],
                marginTop: 0,
                lineHeight: '13px',
            },
            compact: {
                fontSize: '11px',
                WebkitLineClamp: 2,
            },
        },
    });
});
ProductCardName.defaultProps = {
    height: ['32px', null, null, '36px'],
};
var ProductCardNote = CustomStyled(Box)(templateObject_14 || (templateObject_14 = __makeTemplateObject$1(["\n  display: -webkit-box;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  ", "\n  @media (screen, min-width: ", ") {\n    font-size: ", "px;\n    height: ", ";\n  }  \n  ", "\n"], ["\n  display: -webkit-box;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  ",
    "\n  @media (screen, min-width: ", ") {\n    font-size: ", "px;\n    height: ", ";\n  }  \n  ",
    "\n"])), variant({
    variants: {
        regular_wide: {
            '-webkit-box-orient': 'horizontal',
            height: '11px',
        },
    },
}), function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.fontSizes[props.isSponsoredListing ? 0 : 1]; }, function (props) { return (props.variant === EProductCardVariants.REGULAR_WIDE ? '25px' : '16px'); }, function (props) { return "\n    color: #686868;\n    font-weight: " + props.theme.fontWeights[2] + ";\n  "; });
ProductCardNote.defaultProps = {
    fontSize: ['10px', null, null, '12px'],
    marginTop: ['2px', null, null, null],
};
var ProductCardStockIndicator = CustomStyled(Box)(templateObject_15 || (templateObject_15 = __makeTemplateObject$1(["\n  font-size: ", "px;\n  line-height: 16px;\n  color: ", ";\n  min-height: 16px;\n"], ["\n  font-size: ", "px;\n  line-height: 16px;\n  color: ", ";\n  min-height: 16px;\n"])), function (props) { return props.theme.fontSizes[1]; }, COLORS.LIGHT_RED);
var ProductCardPricesWrapper = CustomStyled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject$1(["\n  display: flex;\n  align-items: center;\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  ",
    "\n"])), variant({
    variants: {
        list: {
            marginTop: '6px',
        },
    },
}));
var ProductCardPrice = CustomStyled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject$1(["\n", "\n\n  ", "\n"], ["\n",
    "\n\n  ",
    "\n"])), function (props) {
    return variant({
        variants: {
            mini: {
                fontSize: 1,
            },
            simple: {
                fontSize: props.isSponsoredListing && 1,
            },
            list: {
                fontSize: 1,
            },
            compact: {
                fontSize: 1,
            },
        },
    });
}, function (props) {
    return variant({
        prop: 'type',
        variants: {
            original: {
                color: props.hasDiscount ? "" + COLORS.GRAY_700 : props.theme.colors.black,
                fontWeight: props.hasDiscount ? 'normal' : 4,
                fontSize: ['11px', null, null, props.hasDiscount ? props.theme.fontSizes[0] + "px" : '15px'],
                textDecoration: props.hasDiscount && 'line-through',
            },
            discount: {
                color: props.theme.colors.black,
                fontWeight: 4,
            },
        },
    });
});
var ProductCardPriceValueWrapper = CustomStyled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject$1(["\n    display: inline-block;\n    text-decoration: inherit;\n"], ["\n    display: inline-block;\n    text-decoration: inherit;\n"])));
var ProductCardActionsWrapper = CustomStyled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject$1(["\n  box-sizing: border-box;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n\n  button {\n    flex-shrink: 0;\n  }\n  ", "\n"], ["\n  box-sizing: border-box;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n\n  button {\n    flex-shrink: 0;\n  }\n  ",
    "\n"])), variant({
    variants: {
        list: {
            width: '100px',
            right: '4px',
            bottom: '4px',
            left: 'auto',
        },
        mini: {
            bottom: '6px',
            left: '6px',
            right: '6px',
        },
        compact: {
            bottom: '4px',
            left: '4px',
            right: '4px',
        },
        regular_wide: {
            width: 160,
            left: 'auto',
        },
        simple: {
            position: 'relative',
            bottom: 'unset',
            left: 'unset',
            right: 'unset',
            alignSelf: 'flex-end',
            paddingTop: '8px',
            paddingBottom: '8px',
            width: '100%',
        },
    },
}));
var ProductCardCurrency = CustomStyled.span(templateObject_20 || (templateObject_20 = __makeTemplateObject$1(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) { return props.discount && props.theme.colors.black; });
var ProductCardUnitOfMeasure = CustomStyled.span(templateObject_21 || (templateObject_21 = __makeTemplateObject$1(["\n  color: ", ";\n  font-size: ", "px;\n"], ["\n  color: ", ";\n  font-size: ", "px;\n"])), function (props) { return (props.hasDiscount ? props.theme.colors.red : props.theme.colors.black); }, function (props) { return props.theme.fontSizes[1]; });
var ProductCardSimple = CustomStyled(Flex)(templateObject_22 || (templateObject_22 = __makeTemplateObject$1(["\n  align-items: center;\n  justify-content: center;\n  border-radius: ", ";\n  background: ", ";\n  padding: ", ";\n  border: 1px solid ", ";\n  \n"], ["\n  align-items: center;\n  justify-content: center;\n  border-radius: ", ";\n  background: ",
    ";\n  padding: ", ";\n  border: 1px solid ",
    ";\n  \n"])), function (props) { return (props.isSponsoredListing ? 'unset' : SPACINGS[12]); }, function (props) {
    if (props.isCart) {
        return '#fff';
    }
    return props.theme.colors.white;
}, SPACINGS[12], function (props) {
    if (props.isSponsoredListing) {
        return props.theme.colors.whiteSmoke;
    }
    if (props.isCart) {
        return 'rgba(14, 90, 167, 0.15)';
    }
    return props.theme.colors.wildSand;
});
var ProductCardSimpleContent = CustomStyled(Flex)(templateObject_23 || (templateObject_23 = __makeTemplateObject$1(["\n  flex-direction: column;\n"], ["\n  flex-direction: column;\n"])));
var ProductCardSimpleImageContainer = CustomStyled.div(templateObject_24 || (templateObject_24 = __makeTemplateObject$1(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  border-radius: 5px;\n  \n  \n  width: ", ";\n  height: ", ";\n\n  @media (min-width: ", ") {\n    margin: ", ";\n    width: ", ";\n    height: ", ";\n  }\n\n  img {\n    height: auto;\n    max-height: 100%;\n    max-width: 100%;\n    width: auto;\n  }\n  svg {\n    position: absolute;\n    \n    left: '22px';\n    width: ", ";\n    height: ", ";\n\n    @media (min-width: ", ") {\n      top: ", ";\n      left: ", ";\n    }\n    ", ";\n  }\n  @media (min-width: ", ") {\n    svg{\n\n      top: ", ";\n      left: ", ";\n    }  \n  }\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  border-radius: 5px;\n  \n  \n  width: ", ";\n  height: ", ";\n\n  @media (min-width: ", ") {\n    margin: ", ";\n    width: ", ";\n    height: ", ";\n  }\n\n  img {\n    height: auto;\n    max-height: 100%;\n    max-width: 100%;\n    width: auto;\n  }\n  svg {\n    position: absolute;\n    \n    left: '22px';\n    width: ", ";\n    height: ", ";\n\n    @media (min-width: ", ") {\n      top: ", ";\n      left: ", ";\n    }\n    ", ";\n  }\n  @media (min-width: ", ") {\n    svg{\n\n      top: ", ";\n      left: ", ";\n    }  \n  }\n"])), function (props) { return (props.isCart ? '58px' : '56px'); }, function (props) { return (props.isCart ? '64px' : '56px'); }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return (props.isCart ? '0' : '0 auto'); }, function (props) { return (props.isCart ? '58px' : '72px'); }, function (props) { return (props.isCart ? '64px' : '72px'); }, function (props) { return (props.isCart ? '40px' : 'auto'); }, function (props) { return (props.isCart ? '12px' : 'auto'); }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return (props.isCart ? '0' : '60px'); }, function (props) { return (props.isCart ? '0' : '22px'); }, function (props) { return (props.isCart ? 'bottom: 30px' : ''); }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return (props.isCart ? '64px' : '68px'); }, function (props) { return (props.isCart ? '25px' : '12px'); });
var ProductCardSimpleHeader = CustomStyled(Box)(templateObject_25 || (templateObject_25 = __makeTemplateObject$1(["\n  width: 118px;\n  height: 28px;\n\n  color: ", ";\n  font-size: ", ";\n  letter-spacing: 0;\n  line-height: ", ";\n\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  font-weight: ", ";\n  margin-top: ", "px;\n"], ["\n  width: 118px;\n  height: 28px;\n\n  color: ", ";\n  font-size: ", ";\n  letter-spacing: 0;\n  line-height: ", ";\n\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  font-weight: ", ";\n  margin-top: ", "px;\n"])), function (props) { return (props.isSponsoredListing ? '#444444' : COLORS.MINE_SHAFT); }, function (props) { return (props.isSponsoredListing ? TYPOGRAPHY.SIZE[10] : TYPOGRAPHY.SIZE[12]); }, TYPOGRAPHY.SIZE[14], function (props) { return (props.isSponsoredListing ? 500 : 400); }, function (props) { return (props.isSponsoredListing ? 5 : 0); });
var ProductCardSimplePrice = CustomStyled(Box)(templateObject_26 || (templateObject_26 = __makeTemplateObject$1(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: ", ";\n  padding-top: ", ";\n"], ["\n  color: ", ";\n  font-size: ", ";\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: ", ";\n  padding-top: ", ";\n"])), COLORS.MINE_SHAFT, TYPOGRAPHY.SIZE[12], TYPOGRAPHY.SIZE[14], SPACINGS[6]);
var ProductCardSimpleSeperator = CustomStyled(Box)(templateObject_27 || (templateObject_27 = __makeTemplateObject$1(["\n  height: 1px;\n  background-color: ", ";\n  margin-top: ", ";\n"], ["\n  height: 1px;\n  background-color: ", ";\n  margin-top: ", ";\n"])), function (props) { return props.theme.colors.wildSand; }, SPACINGS[8]);
var productCtaCss = "\n  cursor: pointer;\n  font-size: " + TYPOGRAPHY.SIZE[14] + ";\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: " + TYPOGRAPHY.SIZE[16] + ";\n  padding-top: " + SPACINGS[6] + ";\n  padding-left: 0;\n  border: none;\n  background: none;\n";
var ProductCardSimpleCTA = CustomStyled.button(templateObject_28 || (templateObject_28 = __makeTemplateObject$1(["\n  color: ", ";\n  ", "\n"], ["\n  color: ", ";\n  ", "\n"])), function (props) { return props.theme.colors.redCta; }, productCtaCss);
var ProductCardSimpleCartCTA = CustomStyled.button(templateObject_29 || (templateObject_29 = __makeTemplateObject$1(["\n  ", "\n  color: ", ";\n  font-size: ", ";\n  padding: 0;\n"], ["\n  ", "\n  color: ", ";\n  font-size: ", ";\n  padding: 0;\n"])), productCtaCss, function (props) { return props.theme.colors.blue; }, TYPOGRAPHY.SIZE[12]);
var SponseredProduct = CustomStyled(Flex)(templateObject_30 || (templateObject_30 = __makeTemplateObject$1(["\n  color: ", ";\n  font-weight: 400;\n  border-radius: 12px 2px;\n  background-color: ", ";\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px 2px;\n  padding: 4px 10px;\n\n  ", "\n"], ["\n  color: ", ";\n  font-weight: 400;\n  border-radius: 12px 2px;\n  background-color: ", ";\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px 2px;\n  padding: 4px 10px;\n\n  ", "\n"])), COLORS.GRAY_500, function (props) { return props.theme.colors.GRAY_100; }, function (props) { return props.isAreaABadge && "border-radius: 12px 2px 2px;"; });
SponseredProduct.defaultProps = {
    fontSize: ['7px', null, null, '9px'],
    height: ['18px', null, null, '18px'],
    width: ['fit-content', null, null, 'fit-content'],
};
var BulkSaving = CustomStyled.div(templateObject_31 || (templateObject_31 = __makeTemplateObject$1(["\n  background-color: #FEF2F2;\n  padding: 4px 6px;\n  display: inline-box;\n "], ["\n  background-color: #FEF2F2;\n  padding: 4px 6px;\n  display: inline-box;\n "])));
var ProductItems = CustomStyled.div(templateObject_32 || (templateObject_32 = __makeTemplateObject$1(["\n  ", "\n "], ["\n  ",
    "\n "])), variant({
    variants: {
        list: {
            width: '150px',
        },
        regular_wide: {
            width: '210px',
            display: 'flex',
            flexDirection: 'column',
            rowGap: '3px',
            height: '100%',
        },
    },
}));
var FreeDelivery = CustomStyled.span(templateObject_33 || (templateObject_33 = __makeTemplateObject$1(["\n line-height: 14px;\n font-size: ", "px;\n margin-left: 8px;\n"], ["\n line-height: 14px;\n font-size: ", "px;\n margin-left: 8px;\n"])), function (props) { return props.theme.fontSizes[0]; });
var ProductDeliveryInfo = CustomStyled(Box)(templateObject_34 || (templateObject_34 = __makeTemplateObject$1(["\n    \n    color: #000;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    color: ", ";\n    ", "\n    @media screen and (min-width: ", ") {\n        font-size: ", "px;\n    }\n "], ["\n    \n    color: #000;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    color: ", ";\n    ",
    "\n    @media screen and (min-width: ", ") {\n        font-size: ", "px;\n    }\n "])), COLORS.GRAY_700, variant({
    variants: {
        list: {
            fontSize: '9px',
        },
    },
}), function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.fontSizes[1]; });
ProductDeliveryInfo.defaultProps = {
    fontSize: ['9px', null, null, 0],
};
var ProductPriceLeft = CustomStyled(Box)(templateObject_35 || (templateObject_35 = __makeTemplateObject$1(["\n  font-size: ", "px;\n  line-height: 28px; \n  display: inline-block;\n  font-weight: 700;\n"], ["\n  font-size: ", "px;\n  line-height: 28px; \n  display: inline-block;\n  font-weight: 700;\n"])), function (props) { return props.theme.fontSizes[5]; });
var ProductPriceRight = CustomStyled(Box)(templateObject_36 || (templateObject_36 = __makeTemplateObject$1(["\n  display: inline-block;\n  margin-left: 4px;\n  vertical-align: top;\n  margin-top: 5px;\n"], ["\n  display: inline-block;\n  margin-left: 4px;\n  vertical-align: top;\n  margin-top: 5px;\n"])));
var ProductPriceDecimal = CustomStyled(Box)(templateObject_37 || (templateObject_37 = __makeTemplateObject$1(["\n  font-size: 10px;\n  line-height: 10px;\n  font-weight: 700;\n"], ["\n  font-size: 10px;\n  line-height: 10px;\n  font-weight: 700;\n"])));
var ProductPriceCurrency = CustomStyled(Box)(templateObject_38 || (templateObject_38 = __makeTemplateObject$1(["\n  font-size: 7px;\n  line-height: 7px;\n  font-weight: ", ";\n"], ["\n  font-size: 7px;\n  line-height: 7px;\n  font-weight: ", ";\n"])), function (props) { return props.theme.fontWeights[3]; });
var EmptyDiscountedPrice = CustomStyled(Box)(templateObject_39 || (templateObject_39 = __makeTemplateObject$1(["\n  min-height: 18px;\n"], ["\n  min-height: 18px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39;
var BREAKPOINTS = [576, 768, 992, 1200];
var MQ = BREAKPOINTS.map(function (bp) { return "@media (min-width: " + bp + "px)"; });
var SIZES = {
    CONTAINER_SIZE: '1232px',
    BADGE_SIZE: '17px',
    BORDER_RADIUS: '2px',
    BUTTON_SIZE: '40px',
    ICON_SIZE: '27px',
};
var PreorderContainer = CustomStyled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject$1(["\n    display: inline-block;\n    box-sizing: border-box;\n    margin: 0;\n    min-width: 0;\n    font-size: ", "px;\n    min-width: auto;\n    border-radius: 2px;\n    color: ", ";\n    height:18px;\n    background-color: ", ";\n    padding: 4px 10px;\n    border-radius: 12px 2px;\n\n    ", "\n"], ["\n    display: inline-block;\n    box-sizing: border-box;\n    margin: 0;\n    min-width: 0;\n    font-size: ", "px;\n    min-width: auto;\n    border-radius: 2px;\n    color: ", ";\n    height:18px;\n    background-color: ", ";\n    padding: 4px 10px;\n    border-radius: 12px 2px;\n\n    ",
    "\n"])), function (props) { return props.theme.fontSizes[0]; }, function (props) { return props.theme.colors.blue; }, COLORS.BLUE_25, function (props) {
    return props.dir == 'ltr' &&
        "\n       borderRadius: '2px 12px',\n    ";
});
var PreOrderTextContainerNew = CustomStyled.span(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject$1(["\nfont-family: Montserrat;\nfont-weight: 700;\n\n"], ["\nfont-family: Montserrat;\nfont-weight: 700;\n\n"])));
var BoldText = CustomStyled.span(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject$1(["\n    font-weight: 700;\n"], ["\n    font-weight: 700;\n"])));
var BestSellerContainer = CustomStyled(Flex)(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject$1(["\nposition: relative;\nz-index: 1;\n"], ["\nposition: relative;\nz-index: 1;\n"])));
var BestSellerWrapper = CustomStyled.span(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject$1(["  \ncolor: ", ";\nbackground-color: ", ";\nborder-radius: 12px 2px;\nmax-width: 150px;\ntext-align: center;\ndisplay: flex;\nalign-items: center;\njustify-content: space-around;\nfont-size: ", "px;\nheight: 18px;\npadding: 4px 10px;\ntext-overflow: ellipsis;\noverflow: hidden;\nwhite-space: nowrap;\n@media (max-width: ", "px) {\n  max-width:110px;\n}\n\n", "\n"], ["  \ncolor: ", ";\nbackground-color: ", ";\nborder-radius: 12px 2px;\nmax-width: 150px;\ntext-align: center;\ndisplay: flex;\nalign-items: center;\njustify-content: space-around;\nfont-size: ", "px;\nheight: 18px;\npadding: 4px 10px;\ntext-overflow: ellipsis;\noverflow: hidden;\nwhite-space: nowrap;\n@media (max-width: ", "px) {\n  max-width:110px;\n}\n\n",
    "\n"])), function (props) { return props.theme.colors.blue; }, COLORS.BLUE_25, function (props) { return props.theme.fontSizes[0]; }, BREAKPOINTS[1], function (props) {
    return props.dir == 'ltr' &&
        "\n   borderRadius: '2px 12px',\n";
});
var PromoBadgesAreaBBox = CustomStyled.div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject$1(["\nposition: absolute;\nbottom: 5px;\n", "\n    ", " \n"], ["\nposition: absolute;\nbottom: 5px;\n",
    "\n    ",
    " \n"])), function (props) {
    return props.dir == 'ltr'
        ? "\n  left: 0;\n"
        : " right: 0";
}, function () {
    return variant({
        variants: {
            regular_wide: {
                left: '20px',
                bottom: '10px',
            },
        },
    });
});
var PromoBadgesAreaBContainerNew = CustomStyled.div(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject$1(["\nborder-radius: 12px 2px;\nfont-size: ", "px;\nheight:18px;\ndisplay: inline-block;\npadding: 4px 10px;\ntext-overflow: ellipsis;\noverflow: hidden;\nwhite-space: nowrap;\nmax-width: 120px;\n@media (max-width: ", "px) {\n  max-width: 80px;\n}\n", "\n\n", "\n\n"], ["\nborder-radius: 12px 2px;\nfont-size: ", "px;\nheight:18px;\ndisplay: inline-block;\npadding: 4px 10px;\ntext-overflow: ellipsis;\noverflow: hidden;\nwhite-space: nowrap;\nmax-width: 120px;\n@media (max-width: ", "px) {\n  max-width: 80px;\n}\n",
    "\n\n",
    "\n\n"])), function (props) { return props.theme.fontSizes[0]; }, BREAKPOINTS[1], function (props) {
    return variant({
        prop: 'type',
        variants: {
            Info: {
                background: "" + COLORS.BLUE_25,
                color: "" + COLORS.BLUE,
            },
            Policy: {
                background: "" + COLORS.BLUE_25,
                color: "" + COLORS.BLUE,
            },
            Green: {
                background: props.theme.colors.lightGreen,
                color: props.theme.colors.green,
            },
            Highlight: {
                background: props.theme.colors.lightPurple,
                color: props.theme.colors.purple,
            },
        },
    });
}, function (props) {
    return props.dir == 'ltr' &&
        "\n    borderRadius: '2px 12px',\n";
});
var PromoBadgesAreaBTextNew = CustomStyled.span(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject$1(["\n  font-family: Montserrat;\n  font-weight: 700;\n  ", "\n"], ["\n  font-family: Montserrat;\n  font-weight: 700;\n  ",
    "\n"])), variant({
    prop: 'type',
    variants: {
        Info: {
            color: '#1A4F9B',
        },
        Policy: {
            fontWeight: 700,
            color: '#1A4F9B',
        },
        Green: {
            color: '#009639',
        },
        Highlight: {
            color: '#A32699',
        },
    },
}));
var PromoBadgesAreaBTextLightNew = CustomStyled(PromoBadgesAreaBTextNew)(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject$1(["\n  font-weight: 500;\n"], ["\n  font-weight: 500;\n"])));
var PromoBadgesAreaBContainer = CustomStyled.div(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject$1(["\n  padding: 2px 4px;\n  background: #EFF3F8;\n  border-radius: 2px;\n  width: auto;\n  display: inline-block;\n}\n"], ["\n  padding: 2px 4px;\n  background: #EFF3F8;\n  border-radius: 2px;\n  width: auto;\n  display: inline-block;\n}\n"])));
var PromoBadgesAreaBText = CustomStyled.span(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject$1(["\n  font-family: Montserrat;\n  font-weight: 700;\n  font-size: 8px;\n  /* identical to box height */\n  color: #1A4F9B;\n"], ["\n  font-family: Montserrat;\n  font-weight: 700;\n  font-size: 8px;\n  /* identical to box height */\n  color: #1A4F9B;\n"])));
var PromoBadgesAreaBTextLight = CustomStyled(PromoBadgesAreaBText)(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject$1(["\n  font-weight: 500;\n  font-size: 10px;\n"], ["\n  font-weight: 500;\n  font-size: 10px;\n"])));
var ProductCardImageWrapper$1 = CustomStyled.div(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject$1(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var ProductCardImage = CustomStyled(Image)(templateObject_14$1 || (templateObject_14$1 = __makeTemplateObject$1(["\n  display: ", ";\n  width: auto;\n  ", " \n"], ["\n  display: ", ";\n  width: auto;\n  ",
    " \n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'block' : _b;
    return display;
}, function (props) {
    return variant({
        variants: {
            mini: {
                maxHeight: 91,
                maxWidth: 140,
            },
            regular: {
                maxHeight: props.isSponsoredListing
                    ? [136, null, null, 156]
                    : [props.carousel ? 136 : 156, null, null, props.carousel ? 156 : 220],
                maxWidth: props.isSponsoredListing
                    ? [128, null, null, 156]
                    : [props.carousel ? 128 : 156, null, null, props.carousel ? 156 : 211],
            },
            regular_wide: {
                maxHeight: 56,
                maxWidth: 56,
            },
            list: {
                maxHeight: 60,
                maxWidth: 60,
            },
            compact: {
                maxHeight: 64,
                maxWidth: 64,
            },
        },
    });
});
var Dot = CustomStyled.span(templateObject_15$1 || (templateObject_15$1 = __makeTemplateObject$1(["\n    display: block;\n    transform: scale(", ");\n    background-color:  ", ";\n    border-radius: 50%;\n    width: 3px;\n    height: 3px;\n    margin: 3px;\n"], ["\n    display: block;\n    transform: scale(", ");\n    background-color:  ", ";\n    border-radius: 50%;\n    width: 3px;\n    height: 3px;\n    margin: 3px;\n"])), function (_a) {
    var selected = _a.selected;
    return (selected ? 2 : 1);
}, function (_a) {
    var selected = _a.selected, theme = _a.theme;
    return (selected ? theme.colors.blue : theme.colors.babyBlue);
});
var ImageSlide = CustomStyled.div(templateObject_16$1 || (templateObject_16$1 = __makeTemplateObject$1(["\n    flex: 0 0 auto;\n    position: relative;\n    width: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"], ["\n    flex: 0 0 auto;\n    position: relative;\n    width: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"])), function (props) { return props.widthPerSlide; });
var CarousalImage = CustomStyled(ProductCardImage)(templateObject_17$1 || (templateObject_17$1 = __makeTemplateObject$1(["\n  flex: 0 0 auto;\n  position: relative;\n"], ["\n  flex: 0 0 auto;\n  position: relative;\n"])));
CarousalImage.defaultProps = {
    display: 'block',
};
var ProductCardImageContainer$1 = CustomStyled.div(templateObject_18$1 || (templateObject_18$1 = __makeTemplateObject$1(["\n  position: relative;\n  text-align: center;\n  ", "\n"], ["\n  position: relative;\n  text-align: center;\n  ",
    "\n"])), variant({
    variants: {
        list: {
            display: 'flex',
            width: '120px',
        },
        regular_wide: {
            width: '85px',
        },
    },
}));
var ProductcardImageContainerInner = customStyled.div(templateObject_19$1 || (templateObject_19$1 = __makeTemplateObject$1(["\n  margin: 0 auto;\n  ", "\n\n  a {\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    max-width: 100%;\n  }\n"], ["\n  margin: 0 auto;\n  ",
    "\n\n  a {\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    max-width: 100%;\n  }\n"])), function (props) {
    return variant({
        variants: {
            mini: {
                height: 91,
                maxWidth: 140,
            },
            regular: {
                height: !props.isSponsoredListing
                    ? [props.carousel ? 136 : 156, null, null, props.carousel ? 156 : 220]
                    : [136, null, null, 156],
                maxWidth: !props.isSponsoredListing
                    ? [props.carousel ? 128 : 148, null, null, props.carousel ? 148 : 211]
                    : [128, null, null, 148],
            },
            regular_wide: {
                height: 60,
                maxWidth: 56,
            },
        },
    });
});
var ProductCardExpressWrapper$1 = CustomStyled(Box)(templateObject_20$1 || (templateObject_20$1 = __makeTemplateObject$1(["\n  ", "\n"], ["\n  ",
    "\n"])), variant({
    variants: {
        list: {
            position: 'absolute',
            bottom: 0,
        },
        compact: {
            position: 'absolute',
            bottom: 0,
            left: 0,
        },
    },
}));
ProductCardExpressWrapper$1.defaultProps = {
    height: ['auto', null, null, 'auto'],
};
var OutOfStockText = CustomStyled.span(templateObject_21$1 || (templateObject_21$1 = __makeTemplateObject$1(["\n  background-color: #FEF2F2;\n  padding: 2px 6px;\n  border-radius: 2px;\n  color: ", ";\n  font-family: Montserrat;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 12px;\n  text-transform: capitalize;\n"], ["\n  background-color: #FEF2F2;\n  padding: 2px 6px;\n  border-radius: 2px;\n  color: ", ";\n  font-family: Montserrat;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 12px;\n  text-transform: capitalize;\n"])), COLORS.RED);
var ProductCardAttributeIcon = CustomStyled.div(templateObject_22$1 || (templateObject_22$1 = __makeTemplateObject$1(["\n.attributeIcon2{\n  height:16px;\n  width:16px;\n  float:right;\n}\n.attributeIcon1{\n  height: 16px;\n  width: 16px;\n  position: absolute;\n  margin-left: 58px;\n}\n"], ["\n.attributeIcon2{\n  height:16px;\n  width:16px;\n  float:right;\n}\n.attributeIcon1{\n  height: 16px;\n  width: 16px;\n  position: absolute;\n  margin-left: 58px;\n}\n"])));
var templateObject_1$1, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10$1, templateObject_11$1, templateObject_12$1, templateObject_13$1, templateObject_14$1, templateObject_15$1, templateObject_16$1, templateObject_17$1, templateObject_18$1, templateObject_19$1, templateObject_20$1, templateObject_21$1, templateObject_22$1;
var getHeaderSticker = function (content, type, stickerVariant, productCardVariant, key, isNew) {
    var HeaderSticker = isNew ? ProductCardNewHeaderSticker : ProductCardHeaderSticker;
    return (React.createElement(HeaderSticker, { "data-testid": key, productCardType: productCardVariant, key: key, type: type, variant: stickerVariant, isNew: isNew, dir: isNew ? 'ltr' : '' }, content));
};
var getBadges = function (points, productCardVariant, promoVoucher, language, t, badges, bulkMessage, discount, isLebanon, preorder) {
    var _a, _b, _c, _d, _e;
    var isOnlyBadgeB = true;
    var hasPoints = points && points > 0;
    var badgesAB = [];
    var preorderText = 'Pre Order';
    var promoSticker = language === 'en' && promoVoucher.messageEN
        ? promoVoucher.messageEN
        : promoVoucher.messageAR || promoVoucher.messageEN;
    var textPresent = function (boldText, normalText) {
        return !!(boldText.trim() || normalText.trim());
    };
    if (preorder) {
        isOnlyBadgeB = false;
        badgesAB.push(React.createElement(PreorderContainer, { dir: "ltr" },
            React.createElement(PreOrderTextContainerNew, null, preorderText )));
    }
    var promoStickerValue = React.createElement("span", { dangerouslySetInnerHTML: { __html: "" + promoSticker } });
    if (badges && (badges === null || badges === void 0 ? void 0 : badges.length) > 0 && ((_a = badges === null || badges === void 0 ? void 0 : badges[0]) === null || _a === void 0 ? void 0 : _a.type) === 'BestSeller') {
        var _f = badges[0].text || {}, _g = _f.boldText, boldText = _g === void 0 ? '' : _g, _h = _f.normalText, normalText = _h === void 0 ? '' : _h;
        if (textPresent(boldText, normalText)) {
            isOnlyBadgeB = false;
            badgesAB.push(React.createElement(BestSellerContainer, null,
                React.createElement(BestSellerWrapper, { dir: "ltr" }, boldText.trim() && React.createElement(BoldText, null, boldText + " " + normalText))));
        }
        badges = badges.slice(1);
    }
    if (badges && badges.length > 0 && ((_b = badges[0]) === null || _b === void 0 ? void 0 : _b.type) === 'promoBadges') {
        var _j = badges[0].text || {}, _k = _j.boldText, boldText_1 = _k === void 0 ? '' : _k, _l = _j.normalText, normalText_1 = _l === void 0 ? '' : _l;
        var promoBadges = function () {
            if (textPresent(boldText_1, normalText_1)) {
                isOnlyBadgeB = false;
                badgesAB.push(getHeaderSticker(React.createElement(React.Fragment, null, boldText_1.trim() && React.createElement(BoldText, null, boldText_1 + " " + normalText_1)), 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker', true));
            }
            badges = badges === null || badges === void 0 ? void 0 : badges.slice(1);
        };
        promoBadges();
    }
    if (hasPoints && isLebanon) {
        isOnlyBadgeB = false;
        badgesAB.push(getHeaderSticker(React.createElement(React.Fragment, null,
            React.createElement(BoldText, null, "+ " + points + " " + t('productCard.points'))), 'promo', 'filledPromo', productCardVariant, "promo-sub-header-sticker-" + points, true));
    }
    if (badges && (badges === null || badges === void 0 ? void 0 : badges.length) > 0 && ((_c = badges[0]) === null || _c === void 0 ? void 0 : _c.type) === 'BuyOneGetOne') {
        var _m = badges[0].text || {}, _o = _m.boldText, boldText = _o === void 0 ? '' : _o, _p = _m.normalText, normalText = _p === void 0 ? '' : _p;
        if (textPresent(boldText, normalText)) {
            isOnlyBadgeB = false;
            badgesAB.push(getHeaderSticker(React.createElement(React.Fragment, null, boldText.trim() && React.createElement(BoldText, null, boldText + " " + normalText)), 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker', true));
        }
        badges = badges.slice(1);
    }
    if (!isLebanon && hasPoints) {
        isOnlyBadgeB = false;
        badgesAB.push(getHeaderSticker(React.createElement(React.Fragment, null,
            React.createElement(BoldText, null, "+ " + points + " " + t('productCard.points'))), 'promo', 'filledPromo', productCardVariant, "promo-sub-header-sticker-" + points, true));
    }
    if (badges && (badges === null || badges === void 0 ? void 0 : badges.length) > 0 && ((_d = badges[0]) === null || _d === void 0 ? void 0 : _d.type) === 'Bundle') {
        var _q = badges[0].text || {}, _r = _q.boldText, boldText = _r === void 0 ? '' : _r, _s = _q.normalText, normalText = _s === void 0 ? '' : _s;
        if (textPresent(boldText, normalText)) {
            isOnlyBadgeB = false;
            badgesAB.push(getHeaderSticker(React.createElement(React.Fragment, null, boldText.trim() && React.createElement(BoldText, null, boldText + " " + normalText)), 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker', true));
        }
        badges = badges.slice(1);
    }
    if (promoVoucher === null || promoVoucher === void 0 ? void 0 : promoVoucher.hasPromoVoucher) {
        isOnlyBadgeB = false;
        badgesAB.push(getHeaderSticker(promoStickerValue, 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker', true));
    }
    if (bulkMessage && (!discount || (discount === null || discount === void 0 ? void 0 : discount.value) < 1) && !hasPoints) {
        isOnlyBadgeB = false;
        badgesAB.push(getHeaderSticker(React.createElement(React.Fragment, null,
            React.createElement(BoldText, null, t('productCard.bulk') + " " + t('productCard.save') + " " + bulkMessage)), 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker', true));
    }
    if (badges && (badges === null || badges === void 0 ? void 0 : badges.length) > 0 && ((_e = badges[0]) === null || _e === void 0 ? void 0 : _e.type) === 'Campaign') {
        var _t = badges[0].text || {}, _u = _t.boldText, boldText = _u === void 0 ? '' : _u, _v = _t.normalText, normalText = _v === void 0 ? '' : _v;
        if (textPresent(boldText, normalText)) {
            isOnlyBadgeB = false;
            badgesAB.push(getHeaderSticker(React.createElement(React.Fragment, null, boldText.trim() && React.createElement(BoldText, null, boldText + " " + normalText)), 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker', true));
        }
        badges = badges.slice(1);
    }
    badges === null || badges === void 0 ? void 0 : badges.forEach(function (el) {
        if (badgesAB.length < 3 && ['Info', 'Policy', 'Green', 'Highlight'].includes(el === null || el === void 0 ? void 0 : el.type)) {
            var _a = el || {}, type = _a.type, text = _a.text;
            var _b = text || {}, _c = _b.boldText, boldText = _c === void 0 ? '' : _c, _d = _b.normalText, normalText = _d === void 0 ? '' : _d;
            if (textPresent(boldText, normalText)) {
                badgesAB.push(React.createElement(PromoBadgesAreaBContainerNew, { dir: "ltr", type: type }, boldText.trim() && (React.createElement(PromoBadgesAreaBTextNew, { type: type }, boldText + " " + normalText))));
            }
        }
    });
    if (isOnlyBadgeB && badgesAB.length === 1) {
        return [, badgesAB[0]];
    }
    return badgesAB;
};
var renderHeaderSticker = function (currency, points, isLebanon, productCardVariant, promoVoucher, language, t, promoBadgesAreaA, bulkMessage) {
    var header;
    var subHeader;
    var promoHeader = null;
    var hasPoints = points && points > 0;
    if (bulkMessage) {
        return (React.createElement(BulkSaving, { "data-testid": "bulk-save" },
            React.createElement(Text, { fontSize: 0, fontWeight: 700, color: COLORS.RED }, t('productCard.bulkSave') + " " + bulkMessage)));
    }
    var promoSticker = language === 'en' && promoVoucher.messageEN
        ? promoVoucher.messageEN
        : promoVoucher.messageAR || promoVoucher.messageEN;
    var promoStickerValue = React.createElement("div", { dangerouslySetInnerHTML: { __html: "" + promoSticker } });
    if (promoVoucher === null || promoVoucher === void 0 ? void 0 : promoVoucher.hasPromoVoucher) {
        promoHeader = getHeaderSticker(promoStickerValue, 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker');
    }
    if (isLebanon && hasPoints) {
        header = getHeaderSticker(React.createElement(React.Fragment, null,
            React.createElement(BoldText, null, currency + " " + points + " " + t('productCard.cashback') + " ")), 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker');
    }
    else if (promoBadgesAreaA.length > 0) {
        subHeader = getHeaderSticker(React.createElement(React.Fragment, null,
            React.createElement(BoldText, null, promoBadgesAreaA[0].text.boldText + " " + promoBadgesAreaA[0].text.normalText)), 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker');
        if (promoHeader)
            promoHeader = '';
    }
    else if (!isLebanon && hasPoints) {
        subHeader = getHeaderSticker(React.createElement(React.Fragment, null,
            React.createElement(BoldText, null, "+ " + points + " " + t('productCard.points'))), 'promo', 'filledPromo', productCardVariant, "promo-sub-header-sticker-" + points);
    }
    return [header, subHeader, promoHeader];
};
var formatPrice = function (price, currency, currencyPos, withCurrencyElement, priceType, variant, hasDiscount, isNewCarrefourJourney) {
    if (withCurrencyElement === void 0) { withCurrencyElement = false; }
    var formattedPrice = prettifyPrice(price);
    var isLeft = currencyPos === 'left';
    var currencyRenderer = withCurrencyElement ? (React.createElement(ProductCardCurrency, { hasDiscount: hasDiscount, variant: variant, priceType: priceType, key: priceType }, currency)) : (currency);
    var formattedDiscountPrice = formattedPrice.replace(/,/g, '');
    var result = [
        currencyRenderer,
        priceType === 'discount' && !hasDiscount ? parseInt(formattedDiscountPrice) : formattedPrice,
    ];
    var newFormatPrice = result.join('').match(/^(\D*)(\d{1,3}(?:[,]\d{1,3})*)(\.\d+)?/) || [];
    if (isNewCarrefourJourney && newFormatPrice.length > 3) {
        if (variant === EProductCardVariants.REGULAR_WIDE || variant === EProductCardVariants.REGULAR) {
            if (currency == 'KWD') {
                return (React.createElement(ProductCardPriceValueWrapper, { dir: "ltr", key: result.join('') },
                    React.createElement(ProductPriceLeft, null, newFormatPrice[2] + newFormatPrice[3]),
                    React.createElement(ProductPriceRight, null,
                        React.createElement(ProductPriceCurrency, null,
                            React.createElement(ProductCardCurrency, { hasDiscount: hasDiscount, variant: variant, priceType: priceType, key: priceType }, currency)))));
            }
            else {
                return (React.createElement(ProductCardPriceValueWrapper, { dir: "ltr", key: result.join('') },
                    React.createElement(ProductPriceLeft, null, newFormatPrice[2]),
                    React.createElement(ProductPriceRight, null,
                        React.createElement(ProductPriceDecimal, null, newFormatPrice[3]),
                        React.createElement(ProductPriceCurrency, null,
                            React.createElement(ProductCardCurrency, { hasDiscount: hasDiscount, variant: variant, priceType: priceType, key: priceType }, currency)))));
            }
        }
    }
    else {
        return (React.createElement(ProductCardPriceValueWrapper, { key: result.join('') }, isLeft ? result.reverse() : result));
    }
};
var renderUnitOfMeasure = function (unitOfMeasure, hasDiscount) {
    if (hasDiscount === void 0) { hasDiscount = false; }
    return (React.createElement(ProductCardUnitOfMeasure, { hasDiscount: hasDiscount },
        ' ',
        React.createElement("span", null,
            "/",
            unitOfMeasure)));
};
var renderProductPrice = function (price, priceType, currency, currencyPos, unitOfMeasure, isDiscount, variant, t, testId, isSponsoredListing, unitItem, discount, isNewCarrefourJourney) {
    var formattedPrice = formatPrice(price, currency, currencyPos, true, priceType, variant, isDiscount, isNewCarrefourJourney);
    var measure = unitOfMeasure === 'KG' ? t("KG_LABEL") : '';
    var measureWithDiscount = priceType === 'discount' && isDiscount && unitOfMeasure;
    var measureWithoutDiscount = !isDiscount && unitOfMeasure;
    return (React.createElement(ProductCardPrice, { "data-testid": testId, variant: variant, type: priceType, hasDiscount: isDiscount, isSponsoredListing: isSponsoredListing },
        formattedPrice,
        !isNewCarrefourJourney && (React.createElement(React.Fragment, null,
            measureWithDiscount && renderUnitOfMeasure(measure, true),
            measureWithoutDiscount && renderUnitOfMeasure(measure),
            unitItem !== undefined && !measure && typeof unitItem === 'number' && !isDiscount && (React.createElement("span", null, unitItem === 0 ? "/" + t('piece') : "/" + t('pack'))))),
        discount &&
            discount.price > 0 &&
            getHeaderSticker(discount.type === DiscountType.PERCENTAGE ? (discount.value + "% " + t('productCard.discount')) : (React.createElement("span", null,
                React.createElement("span", null, formatPrice(discount.value, currency, currencyPos, false, 'discount')),
                " OFF")), 'discount', 'filled', variant, 'headerStickerId', true)));
};
var getProductNote = function (itemsPerUnit, t) {
    if (itemsPerUnit && itemsPerUnit > 0) {
        return t('productCard.approxPerKg', {
            0: itemsPerUnit + " " + (itemsPerUnit > 1 ? t('productCard.pieces') : t('productCard.piece')),
        });
    }
    return null;
};
var getAlgoliaTrackingParams = function (productId, productPosition, sortBy, algoliaQueryID, clickType) {
    var page_type = getPageType();
    var productInfo = !(page_type === 'product-details')
        ? {
            searchQueryID: algoliaQueryID,
            pageType: ATC_EVENTS_TYPE.PLP,
            products: productId,
            productPositions: algoliaQueryID !== '' ? productPosition : '',
            sortBy: sortBy,
            clickType: clickType,
        }
        : {
            pageType: clickType === ATC_EVENT ? ATC_EVENTS_TYPE.PDP : ATC_EVENTS_TYPE.PLP,
            products: productId,
            searchQueryID: clickType === ATC_EVENT && window.location.href.includes(productId) ? sessionStorage.getItem('queryId') : '',
            clickType: clickType,
        };
    return productInfo;
};
var clickAlgoliaOperation = function (params, dispatch) {
    if (params === void 0) { params = {}; }
    var productId = params.productId, productPosition = params.productPosition, _a = params.searchQueryID, searchQueryID = _a === void 0 ? '' : _a, sortBy = params.sortBy;
    var algoliaParams = getAlgoliaTrackingParams(productId, productPosition, sortBy, searchQueryID, CLICK_EVENT);
    dispatch(algoliaTracking(algoliaParams));
};
var getProductPosition = function (rowIndex, position, isDesktop, isMobile) {
    var totalProductInRow = 3;
    if (isDesktop || isMobile) {
        totalProductInRow = isDesktop ? 4 : 2;
    }
    return rowIndex * totalProductInRow + position;
};
var getGa4AlgoliaEventsParams = function () {
    return JSON.parse(localStorage.getItem('ga4-algolia-event-data') || '{}');
};
var DisplayDiscountTemplateNew = function (_a) {
    var originalPrice = _a.originalPrice, discount = _a.discount, minBuyingValue = _a.minBuyingValue, variant = _a.variant, currency = _a.currency, currencyPos = _a.currencyPos, unitOfMeasure = _a.unitOfMeasure, isSponsoredListing = _a.isSponsoredListing, unitItem = _a.unitItem, isNewCarrefourJourney = _a.isNewCarrefourJourney;
    var t = useTranslation().t;
    if (discount) {
        return (React.createElement(React.Fragment, null, renderProductPrice(minBuyingValue ? parseFloat(minBuyingValue) : originalPrice, 'original', currency, currencyPos, unitOfMeasure, discount.price > 0, variant, t, 'product-card-original-price', isSponsoredListing, unitItem, discount, isNewCarrefourJourney)));
    }
    return React.createElement(React.Fragment, null);
};
var timeOutValue;
var timer = function (dispatch) {
    timeOutValue = setTimeout(function () {
        dispatch(setExpandedQtySelectorProductId(''));
    }, QTY_SELECTOR_TIMER);
};
var setTimerForQTYSeclector = function (dispatch) {
    timer(dispatch);
};
var clearTimerForQTYSeclector = function () {
    if (timeOutValue) {
        clearTimeout(timeOutValue);
    }
};
var formatFoodWeight = function (min, unitOfMeasure) {
    if (min < 1) {
        return min * 1000 + "g";
    }
    else {
        return min + unitOfMeasure;
    }
};
var getCommonGtmData = function (props) {
    var _a, _b;
    var selectedQuantity = props.selectedQuantity, quantity = props.quantity, incrementBy = props.incrementBy, min = props.min, minBuyValue = props.minBuyValue, priceDetails = props.priceDetails, soldByWeight = props.soldByWeight, productDiscount = props.productDiscount;
    var deltaQtyInUnit = convertDeltaQtyInoUnit(selectedQuantity, quantity, incrementBy);
    var minQntyInUnits = Number(min / incrementBy);
    var minBuyingValue = ((minBuyValue || ((_a = priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.original) === null || _a === void 0 ? void 0 : _a.minBuyingValue)) / minQntyInUnits).toFixed(2);
    var discountOfMinBuyingValue = (Number((productDiscount === null || productDiscount === void 0 ? void 0 : productDiscount.minBuyingValue) || ((_b = priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.discount) === null || _b === void 0 ? void 0 : _b.minBuyingValue) || '0') / minQntyInUnits).toFixed(2);
    var changedQuantity = Math.abs(Math.floor(deltaQtyInUnit));
    var price = parseFloat(minBuyingValue);
    var discount = parseFloat(discountOfMinBuyingValue);
    var gtmData = {
        price: price,
        value: Number((changedQuantity * price).toFixed(2)),
        discount: discount > 0 ? parseFloat((price - discount).toFixed(2)) : 0,
        quantity: changedQuantity,
    };
    var changedInWeight = Math.abs(selectedQuantity - quantity) * 1000;
    var scalableWeight = Math.round(changedInWeight * 100) / 100;
    scalableWeight = Math.floor(scalableWeight);
    return __assign$1(__assign$1({}, gtmData), { scalable_weight: soldByWeight ? scalableWeight + 'g' : 'not_applicable' });
};
var algoliaTrackingOnATC = function (algoliaParams, dispatch) {
    dispatch(algoliaTracking(__assign$1(__assign$1({}, algoliaParams), { productPositions: '' })));
};
var atcAlgoliaOperations = function (state, algoliaParams, dispatch) {
    if (algoliaParams === void 0) { algoliaParams = {}; }
    var _a = ((state === null || state === void 0 ? void 0 : state.search) || {}).algoliaQueryID, algoliaQueryID = _a === void 0 ? '' : _a;
    var productId = algoliaParams.productId, productPosition = algoliaParams.productPosition, sortBy = algoliaParams.sortBy;
    var trackingParams = getAlgoliaTrackingParams(productId, productPosition, sortBy, algoliaQueryID, ATC_EVENT);
    algoliaTrackingOnATC(trackingParams, dispatch);
};
var convertQtyIntoUnit = function (quantity, incrementBy) { var _a; return (_a = (quantity / incrementBy)) === null || _a === void 0 ? void 0 : _a.toString(); };
var convertDeltaQtyInoUnit = function (updatedQuantity, currentQuantity, incrementBy) {
    return parseInt((convertQtyIntoUnit(updatedQuantity, incrementBy) - convertQtyIntoUnit(currentQuantity, incrementBy)).toFixed(1));
};
var isUserShareMember = function (store) {
    var _a, _b, _c;
    return !!(((_b = (_a = store === null || store === void 0 ? void 0 : store.appConfig) === null || _a === void 0 ? void 0 : _a.features) === null || _b === void 0 ? void 0 : _b.share) && ((_c = store === null || store === void 0 ? void 0 : store.userData) === null || _c === void 0 ? void 0 : _c.cardNumber));
};
var onCartUpdate = function (productId, state) {
    var areaCode = state.appConfig.areaCode, entries = state.miniCart.entries;
    var productIds = Object.values(entries).map(function (obj) { return obj.entry; });
    productIds.push(productId);
    var analytics = new AnalyticsManager();
    var url = UPDATE_CART_RELEVANCE + "&productId=" + productIds.join('|');
    if (areaCode) {
        url += "&areaCode=" + areaCode;
    }
    analytics.trackEvent(url);
};
var setMiniCartData = function (payload) { return ({
    type: EMiniCartTypes$1.MINI_CART_SET_DATA,
    payload: payload,
}); };
var getCartEntries = function (data) {
    var _a = data.shipments, shipments = _a === void 0 ? [] : _a;
    if (shipments && !shipments.length) {
        return data;
    }
    data.entries = shipments.reduce(function (accumulator, item) {
        if (item.entries)
            return __spread$1(accumulator, item.entries);
        if (item.sellersEntries) {
            var sellerEntry = item.sellersEntries.reduce(function (accum, sellerItem) {
                return __spread$1(accum, sellerItem.entries);
            }, []);
            return __spread$1(accumulator, sellerEntry);
        }
        return [];
    }, []);
    return data;
};
var getCartData = function () { return function (dispatch, getState) {
    var guid = getGUID();
    var _a = getState().appConfig, areaCode = _a.areaCode, _b = _a.posInfoConfig, posInfoConfig = _b === void 0 ? [] : _b;
    var isLoggedIn = getUserTokenFromCookie();
    var nsp = posInfoConfig.join(',');
    if (isLoggedIn) {
        removeGUIDFromCookie();
    }
    var paramData = {
        url: guid ? GET_CART_V3 + "&guid=" + guid : GET_CART_V3,
        getTransformedData: function (cartData) { return getCartEntries(cartData); },
        apiVersion: 3,
    };
    var url = paramData.url, getTransformedData = paramData.getTransformedData, apiVersion = paramData.apiVersion;
    if (guid || isLoggedIn) {
        dispatch({
            type: EMiniCartTypes$1.MINI_CART_GET,
            payload: {
                apiVersion: apiVersion,
                url: url,
                method: EApiMiddlewareMethod$1.GET,
                params: {
                    areaCode: areaCode,
                    nsp: nsp,
                },
                onSuccess: function (cartData) {
                    var updatedCart = getTransformedData(cartData);
                    var _a = getEntriesAndOffersEntries(updatedCart), productEntries = _a.productEntries, totalProductCount = _a.totalProductCount;
                    dispatch(setMiniCartData({ entries: productEntries, totalUnitCount: totalProductCount }));
                },
                onFailure: function () {
                    showNotification({
                        type: 'error',
                        message: 'Unable to retrieve cart',
                        variant: 'sticky',
                    });
                },
            },
        });
    }
}; };
var getEntriesAndOffersEntries = function (cart) {
    var entries = cart.entries, totalItems = cart.totalItems;
    var productEntries = {};
    entries &&
        entries.forEach(function (entry) {
            var _a = entry.product, code = _a.code, soldByWeight = _a.soldByWeight, quantity = entry.quantity, serviceEntries = entry.serviceEntries, offerId = entry.offerId, intent = entry.intent;
            var productId = Number(code);
            var offerIdWithOfferText = offerId ? (!offerId.includes('offer') ? "offer_" + offerId : offerId) : null;
            var uniqueEntryId = getUniqueEntryId(code, offerIdWithOfferText, intent);
            productEntries[uniqueEntryId] = {
                offerId: offerId,
                entry: productId,
                serviceEntries: serviceEntries,
                quantity: convertQuantityToKG(quantity, soldByWeight),
                intent: intent,
            };
        });
    return { productEntries: productEntries, totalProductCount: totalItems };
};
var updateEntryInMiniCart = function (miniCart, params) {
    var _a;
    var _b;
    var productId = params.productId, _c = params.offerId, offerIdWithOfferText = _c === void 0 ? '' : _c, quantity = params.quantity, isSoldByWeight = params.isSoldByWeight, intent = params.intent, serviceProductCode = params.serviceProductCode;
    var entries = miniCart.entries;
    var updatedEntries = entries;
    var uniqueEntryId = getUniqueEntryId(productId, offerIdWithOfferText, intent);
    var serviceEntries = ((_b = miniCart.entries[uniqueEntryId]) === null || _b === void 0 ? void 0 : _b.serviceEntries) || [];
    var splittedOfferId = offerIdWithOfferText.split('_');
    if (serviceProductCode) {
        if (serviceEntries.length < 1) {
            serviceEntries.push({ product: { code: serviceProductCode } });
        }
        else {
            serviceEntries[0].product.code = serviceProductCode;
        }
    }
    updatedEntries = __assign$1(__assign$1({}, entries), (_a = {}, _a[uniqueEntryId] = {
        offerId: splittedOfferId[1] || splittedOfferId[0],
        entry: productId,
        quantity: convertQuantityToKG(quantity, isSoldByWeight),
        intent: intent,
        serviceEntries: serviceEntries,
    }, _a));
    return { productEntries: updatedEntries };
};
var CARREFOUR_SELLER_OFFER_ID = 'offer_carrefour_';
var getUniqueEntryId = function (productId, offerId, serviceType) {
    var resolvedOfferId = offerId || CARREFOUR_SELLER_OFFER_ID;
    return "" + productId + resolvedOfferId + serviceType;
};
var addToCart = function (productId, qty, params, finalCb, productPosition, sortBy) { return function (dispatch, getState) {
    var state = getState();
    var guid = getGUID();
    atcAlgoliaOperations(state, { productId: productId, productPosition: productPosition, sortBy: sortBy }, dispatch);
    if (!guid) {
        dispatch(setDisabled(true));
    }
    var gtmCallBack = params.gtmCallBack, brazeAddToCartCB = params.brazeAddToCartCB, _a = params.withRelevantProducts, withRelevantProducts = _a === void 0 ? false : _a, _b = params.isMarketPlace, isMarketPlace = _b === void 0 ? false : _b, offerId = params.offerId, _c = params.serviceProductCode, serviceProductCode = _c === void 0 ? '' : _c, onSuccessCb = params.onSuccessCb, onFailureCb = params.onFailureCb, _d = params.productName, productName = _d === void 0 ? '' : _d, _e = params.isCartRequired, isCartRequired = _e === void 0 ? false : _e, _f = params.shippingIndicator, shippingIndicator = _f === void 0 ? '' : _f, productImageURL = params.productImageURL, intent = params.intent, _g = params.incrementBy, incrementBy = _g === void 0 ? 1 : _g, isSponsored = params.isSponsored, applicablePrice = params.applicablePrice, isV4Basket = params.isV4Basket, basketV4Attributes = __rest$1(params, ["gtmCallBack", "brazeAddToCartCB", "withRelevantProducts", "isMarketPlace", "offerId", "serviceProductCode", "onSuccessCb", "onFailureCb", "productName", "isCartRequired", "shippingIndicator", "productImageURL", "intent", "incrementBy", "isSponsored", "applicablePrice", "isV4Basket"]);
    dispatch(setLoading(offerId || productId, true));
    var isV4BasketApplicable = isV4Basket && !isCartRequired;
    var journeyIntent = shippingIndicator ? { intent: shippingIndicator } : getBasketIntent(state, intent);
    var isNewJourney = isNewC4Journey(state);
    var areaCode = state.appConfig.areaCode, miniCart = state.miniCart;
    if (withRelevantProducts) {
        dispatch(setRelevantProductId(''));
    }
    var isShareMember = isUserShareMember(state);
    var basketV4Params = isV4BasketApplicable ? basketV4Attributes : {};
    var paramData = {
        url: guid ? ADD_TO_CART_V3 + "&guid=" + guid : ADD_TO_CART_V3,
        apiVersion: isV4BasketApplicable ? 4 : 3,
        data: __assign$1(__assign$1(__assign$1({ productId: productId, quantity: qty }, journeyIntent), { serviceProductCode: serviceProductCode ? [serviceProductCode] : [], productName: productName, imageUrl: productImageURL, offerId: isMarketPlace ? offerId : '' }), basketV4Params),
    };
    var growthbook = createGrowthBookInstance(__assign$1({}, state.appConfig.growthBook), state);
    var isCartBundlingEnabled = growthbook.feature('common.cart_bundling.enabled').on;
    var url = paramData.url, apiVersion = paramData.apiVersion, data = paramData.data;
    dispatch({
        type: EMiniCartTypes$1.MINI_CART_ADD_TO_CART,
        payload: {
            headers: { 'content-type': isNewJourney ? 'application/json' : 'application/x-www-form-urlencoded' },
            apiVersion: apiVersion,
            url: url + (isCartBundlingEnabled ? '&cp=true' : ''),
            method: EApiMiddlewareMethod$1.POST,
            params: {
                areaCode: areaCode,
                isCartRequired: isCartRequired,
                lm: isShareMember,
            },
            data: data,
            onSuccess: function (cartResponse) {
                var guid = cartResponse.guid, isSoldByWeight = cartResponse.isSoldByWeight, quantity = cartResponse.quantity, totalUnitCount = cartResponse.totalUnitCount;
                onCartUpdate(productId, state);
                var isCriteoEnabled = isAdTechCriteoEnabled(state);
                if (isCriteoEnabled && !isSponsored) {
                    var quantityInUnits = convertQtyIntoUnit(qty, incrementBy);
                    addToCartTracking({ quantity: quantityInUnits, price: applicablePrice, item: productId }, dispatch);
                }
                if (guid) {
                    setGUID(guid);
                }
                if (withRelevantProducts) {
                    dispatch(setRelevantProductId(productId));
                }
                if (gtmCallBack) {
                    gtmCallBack(qty, eventTypeEnum.add_to_cart, productId);
                }
                if (onSuccessCb) {
                    onSuccessCb(cartResponse);
                }
                var productEntries = updateEntryInMiniCart(miniCart, {
                    offerId: offerId,
                    productId: productId,
                    quantity: quantity,
                    isSoldByWeight: isSoldByWeight,
                    intent: journeyIntent === null || journeyIntent === void 0 ? void 0 : journeyIntent.intent,
                }).productEntries;
                if (brazeAddToCartCB) {
                    brazeAddToCartCB(totalUnitCount);
                }
                dispatch(setMiniCartData({ entries: productEntries, totalUnitCount: totalUnitCount }));
            },
            onFailure: function (_errMessage, _a) {
                var data = (_a === void 0 ? {} : _a).response.data;
                var _b = data.meta, detail = (_b === void 0 ? { detail: '' } : _b).detail;
                if (onFailureCb) {
                    onFailureCb(productName, data);
                }
                dispatch(setError(productId, true, detail));
            },
            onFinally: function () {
                dispatch(setLoading(offerId || productId, false));
                dispatch(setDisabled(false));
                dispatch(setExpandedQtySelectorProductId(productId));
                setTimerForQTYSeclector(dispatch);
                if (finalCb) {
                    finalCb(productId);
                }
            },
        },
    });
}; };
var updateCart = function (productId, qty, params) {
    if (params === void 0) { params = {}; }
    return function (dispatch, getState) {
        clearTimerForQTYSeclector();
        var guid = getGUID();
        var state = getState();
        var miniCart = state.miniCart, areaCode = state.appConfig.areaCode;
        var serviceProductCode = params.serviceProductCode, brazeCB = params.brazeCB, gtmCallBack = params.gtmCallBack, offerId = params.offerId, isV4Basket = params.isV4Basket, productName = params.productName, productImageURL = params.productImageURL, onSuccessCb = params.onSuccessCb, _a = params.isCartRequired, isCartRequired = _a === void 0 ? false : _a, _b = params.shippingIndicator, shippingIndicator = _b === void 0 ? '' : _b, basketV4Attributes = __rest$1(params, ["serviceProductCode", "brazeCB", "gtmCallBack", "offerId", "isV4Basket", "productName", "productImageURL", "onSuccessCb", "isCartRequired", "shippingIndicator"]);
        var isV4BasketApplicable = isV4Basket && !isCartRequired;
        var journeyIntent = shippingIndicator ? { intent: shippingIndicator } : {};
        var isNewJourney = isNewC4Journey(state);
        var offerString = offerId ? (!offerId.includes('offer') ? "offer_" + offerId : offerId) : '';
        var basketV4Params = isV4BasketApplicable ? __assign$1({ productName: productName, imageUrl: productImageURL }, basketV4Attributes) : {};
        var UPDATE_CART = isV4BasketApplicable ? ADD_TO_CART_V3 : UPDATE_CART_V3;
        var paramData = {
            url: guid ? UPDATE_CART + "&guid=" + guid : UPDATE_CART,
            apiVersion: isV4BasketApplicable ? 4 : 3,
            data: __assign$1(__assign$1(__assign$1({}, journeyIntent), { productId: productId, quantity: qty, serviceProductCode: serviceProductCode ? [serviceProductCode] : null, offerId: offerId ? offerString : '' }), basketV4Params),
        };
        var growthbook = createGrowthBookInstance(__assign$1({}, state.appConfig.growthBook), state);
        var isCartBundlingEnabled = growthbook.feature('common.cart_bundling.enabled').on;
        var url = paramData.url, apiVersion = paramData.apiVersion, data = paramData.data;
        var isShareMember = isUserShareMember(state);
        dispatch(setLoading(productId, true));
        dispatch({
            type: EMiniCartTypes$1.MINI_CART_UPDATE_CART,
            payload: {
                headers: { 'content-type': isNewJourney ? 'application/json' : 'application/x-www-form-urlencoded' },
                apiVersion: apiVersion,
                url: url + (isCartBundlingEnabled ? '&cp=true' : ''),
                method: isV4BasketApplicable ? EApiMiddlewareMethod$1.POST : EApiMiddlewareMethod$1.PUT,
                params: {
                    areaCode: areaCode,
                    cartEntryNumber: productId,
                    isCartRequired: isCartRequired,
                    lm: isShareMember,
                },
                data: data,
                onSuccess: function (cartResponse) {
                    var isSoldByWeight = cartResponse.isSoldByWeight, quantity = cartResponse.quantity, totalUnitCount = cartResponse.totalUnitCount;
                    var productEntries = updateEntryInMiniCart(miniCart, {
                        offerId: offerId,
                        productId: productId,
                        quantity: quantity,
                        isSoldByWeight: isSoldByWeight,
                        intent: journeyIntent.intent,
                        serviceProductCode: serviceProductCode,
                    }).productEntries;
                    if (brazeCB) {
                        brazeCB(totalUnitCount);
                    }
                    if (onSuccessCb) {
                        onSuccessCb(cartResponse);
                    }
                    dispatch(setMiniCartData({ entries: productEntries, totalUnitCount: totalUnitCount }));
                },
                onFinally: function () {
                    dispatch(setLoading(productId, false));
                    dispatch(setDisabled(false));
                    setTimerForQTYSeclector(dispatch);
                    if (gtmCallBack) {
                        gtmCallBack(qty, eventTypeEnum.change_the_quantity);
                    }
                },
            },
        });
    };
};
var removeFromCart = function (productId, params) {
    if (params === void 0) { params = {}; }
    return function (dispatch, getState) {
        clearTimerForQTYSeclector();
        var guid = getGUID();
        var state = getState();
        var _a = state.miniCart.entries, entries = _a === void 0 ? {} : _a, _b = state.appConfig, areaCode = _b.areaCode, _c = _b.posInfoConfig, posInfoConfig = _c === void 0 ? [] : _c;
        var nsp = posInfoConfig.join(',');
        var brazeCB = params.brazeCB, gtmCallBack = params.gtmCallBack, offerId = params.offerId, onSuccessCb = params.onSuccessCb, _d = params.isCartRequired, isCartRequired = _d === void 0 ? false : _d, shippingIndicator = params.shippingIndicator;
        var offerString = offerId ? (!offerId.includes('offer') ? "offer_" + offerId : offerId) : '';
        var uniqueEntryId = getUniqueEntryId(productId, offerString, shippingIndicator || '');
        var journeyIntent = shippingIndicator ? { intent: shippingIndicator } : {};
        var entry = entries[uniqueEntryId].entry;
        dispatch(setLoading(productId, true));
        dispatch(setDisabled(true));
        var paramData = {
            apiVersion: 3,
            url: guid ? NEW_REMOVE_FROM_CART + "&guid=" + guid : NEW_REMOVE_FROM_CART,
            data: {
                deleteItems: [
                    __assign$1({ productId: productId, offerId: offerString }, journeyIntent),
                ],
            },
        };
        var url = paramData.url, data = paramData.data, apiVersion = paramData.apiVersion;
        dispatch({
            type: EMiniCartTypes$1.MINI_CART_REMOVE_FROM_CART,
            payload: {
                url: url,
                method: EApiMiddlewareMethod$1.DELETE,
                apiVersion: apiVersion,
                params: {
                    cartEntryNumber: entry,
                    areaCode: areaCode,
                    isCartRequired: isCartRequired,
                    nsp: nsp,
                },
                data: data,
                onSuccess: function (cartResponse) {
                    var totalUnitCount = cartResponse.totalUnitCount;
                    onCartUpdate(productId, state);
                    if (Object.keys(entries).length === 1) {
                        removeGUIDFromCookie();
                    }
                    if (gtmCallBack) {
                        gtmCallBack(0, eventTypeEnum.remove_from_cart, productId);
                    }
                    if (brazeCB) {
                        brazeCB(totalUnitCount);
                    }
                    if (onSuccessCb) {
                        onSuccessCb(cartResponse);
                    }
                    dispatch({
                        type: EMiniCartTypes$1.MINI_CART_REMOVE_FROM_ENTRIES,
                        payload: {
                            productId: productId,
                            totalUnitCount: totalUnitCount,
                            offerString: offerString,
                            uniqueEntryId: uniqueEntryId,
                        },
                    });
                },
                onFinally: function () {
                    dispatch(setLoading(productId, false));
                    dispatch(setDisabled(false));
                    dispatch(setExpandedQtySelectorProductId(''));
                },
            },
        });
    };
};
var addToCartTracking = function (trackingParams, dispatch) {
    var userId = getCustomCookie(constants.rrUserId) || '';
    var visitorId = getCustomCookie(constants.rrSessionId);
    dispatch({
        type: EMiniCartTypes$1.MINI_CART_ADD_TO_CART_TRACKING,
        payload: {
            headers: { userId: userId, visitorId: visitorId },
            url: ADD_TO_CART_TRACKING,
            apiVersion: 1,
            method: EApiMiddlewareMethod$1.POST,
            data: trackingParams,
        },
    });
};
var fbtAddToCart = function (products, cb, isV4Basket, gtmCallBack) { return function (dispatch, getState) {
    dispatch(setDisabled(true));
    var state = getState();
    var isNewJourney = isNewC4Journey(state);
    products.forEach(function (p) {
        algoliaTrackingOnATC({
            clickType: ATC_EVENT,
            pageType: 'PDP',
            products: [p.productId],
            searchQueryID: window.location.href.includes(p.productId) ? sessionStorage.getItem('queryId') : '',
        }, dispatch);
    });
    products.forEach(function (p) {
        dispatch(setError(p.productId, false));
    });
    var startRequest = function (req) {
        var _a, _b, _c, _d, _e;
        if (req === void 0) { req = 0; }
        if (req <= products.length - 1) {
            var state_1 = getState();
            var guid = getGUID();
            var areaCode = state_1.appConfig.areaCode, miniCart_1 = state_1.miniCart;
            var _f = products[req], productId_1 = _f.productId, isMarketPlace = _f.isMarketPlace, min_1 = _f.min, _g = _f.serviceProductCode, serviceProductCode = _g === void 0 ? '' : _g, _h = _f.offers, offers = _h === void 0 ? [] : _h, _j = _f.name, productName = _j === void 0 ? '' : _j, image = _f.image, _k = _f.incrementBy, incrementBy_1 = _k === void 0 ? 1 : _k, _l = _f.originalPrice, originalPrice_1 = _l === void 0 ? 1 : _l, soldByWeight = _f.soldByWeight;
            var basketV4Attributes_1 = {
                pis: ((_b = (_a = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _a === void 0 ? void 0 : _a.purchaseIndicators) === null || _b === void 0 ? void 0 : _b.SHIPPING) || [],
                shippingIndicator: ((_c = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _c === void 0 ? void 0 : _c.shippingIndicator) || '',
                shopId: (_d = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _d === void 0 ? void 0 : _d.shopId,
                shopName: (_e = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _e === void 0 ? void 0 : _e.shop,
                isSoldByWeight: soldByWeight,
            };
            var basketV4Params = isV4Basket ? basketV4Attributes_1 : {};
            var offerId_1 = isMarketPlace && offers.length > 0 ? offers[0].id : undefined;
            var paramData = {
                url: guid ? ADD_TO_CART_V3 + "&guid=" + guid : ADD_TO_CART_V3,
                apiVersion: isV4Basket ? 4 : 3,
                data: __assign$1({ productId: productId_1, quantity: min_1, serviceProductCode: serviceProductCode ? [serviceProductCode] : [], productName: productName, imageUrl: (image === null || image === void 0 ? void 0 : image.href) || '', offerId: isMarketPlace ? offerId_1 : '' }, basketV4Params),
            };
            var growthbook = createGrowthBookInstance(__assign$1({}, state_1.appConfig.growthBook), state_1);
            var isCartBundlingEnabled = growthbook.feature('common.cart_bundling.enabled').on;
            var url = paramData.url, apiVersion = paramData.apiVersion, data = paramData.data;
            dispatch(setLoading(productId_1, true));
            dispatch({
                type: EMiniCartTypes$1.MINI_CART_ADD_TO_CART,
                payload: {
                    headers: { 'content-type': isNewJourney ? 'application/json' : 'application/x-www-form-urlencoded' },
                    apiVersion: apiVersion,
                    url: url + (isCartBundlingEnabled ? '&cp=true' : ''),
                    method: EApiMiddlewareMethod$1.POST,
                    params: {
                        areaCode: areaCode,
                        isCartRequired: false,
                    },
                    data: data,
                    onSuccess: function (cartResponse) {
                        var guid = cartResponse.guid, isSoldByWeight = cartResponse.isSoldByWeight, quantity = cartResponse.quantity, totalUnitCount = cartResponse.totalUnitCount;
                        var productEntries = updateEntryInMiniCart(miniCart_1, {
                            offerId: offerId_1,
                            productId: productId_1,
                            quantity: quantity,
                            intent: basketV4Attributes_1 === null || basketV4Attributes_1 === void 0 ? void 0 : basketV4Attributes_1.shippingIndicator,
                            isSoldByWeight: isSoldByWeight,
                        }).productEntries;
                        onCartUpdate(productId_1, state_1);
                        var isCriteoEnabled = isAdTechCriteoEnabled(state_1);
                        if (gtmCallBack) {
                            gtmCallBack(products[req]);
                        }
                        if (isCriteoEnabled) {
                            var quantityInUnits = convertQtyIntoUnit(min_1, incrementBy_1);
                            addToCartTracking({ quantity: quantityInUnits, price: originalPrice_1, item: productId_1 }, dispatch);
                        }
                        if (guid) {
                            setGUID(guid);
                        }
                        dispatch(setMiniCartData({ entries: productEntries, totalUnitCount: totalUnitCount }));
                    },
                    onFailure: function (_errMessage, _a) {
                        var data = (_a === void 0 ? {} : _a).response.data;
                        var _b = data.meta, _c = _b === void 0 ? { detail: '', message: '' } : _b, detail = _c.detail, message = _c.message;
                        dispatch(setError(productId_1, true, detail || message));
                    },
                    onFinally: function () {
                        dispatch(setLoading(productId_1, false));
                        startRequest(req + 1);
                    },
                },
            });
        }
        else {
            dispatch(setDisabled(false));
            cb && cb();
        }
    };
    startRequest();
}; };
var miniCart_action = Object.freeze({
    __proto__: null,
    setMiniCartData: setMiniCartData,
    getCartData: getCartData,
    getUniqueEntryId: getUniqueEntryId,
    addToCart: addToCart,
    updateCart: updateCart,
    removeFromCart: removeFromCart,
    addToCartTracking: addToCartTracking,
    fbtAddToCart: fbtAddToCart
});
var decodeHtml = function (html) {
    if (isBrowser()) {
        var txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }
    return '';
};
var capitalizeFirstLetter = function (text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
var useAppConfig = function () {
    var dispatch = useDispatch();
    var methods = useRef({
        setArea: function (areaCode) {
            dispatch(setAreaCode(areaCode));
        },
        setLanguage: function (languageCode) {
            dispatch(setLanguageCode(languageCode));
        },
        setCurrency: function (currency) {
            dispatch(setCurrency(currency));
        },
    });
    var appConfigState = useSelector(function (state) { return state.appConfig; });
    var requestStatus = useMemo(function () {
        var isFailedReq = isExisty(appConfigState.statusCode) || isExisty(appConfigState.errors);
        return {
            done: isExisty(appConfigState.areaCode) || isFailedReq,
            failed: !isExisty(appConfigState.areaCode) && isFailedReq,
        };
    }, [appConfigState]);
    var setAppContext = function (url) { return (url ? "/" + appConfigState.storeId + "/" + appConfigState.language + url : '#'); };
    var _a = methods.current, setLanguage = _a.setLanguage, setArea = _a.setArea, setCurrency$1 = _a.setCurrency;
    return [appConfigState, setLanguage, setArea, requestStatus, setAppContext, setCurrency$1];
};
var Header = CustomStyled(Box)(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject$1(["\n  position: sticky;\n  width: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 9;\n  font-family: 'Montserrat';\n  html[dir='rtl'] & {\n    font-family: 'Noto Kufi Arabic';\n  }\n  height: ", ";\n  @media (max-width: ", ") {\n    ", ";\n  }\n"], ["\n  position: sticky;\n  width: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 9;\n  font-family: 'Montserrat';\n  html[dir='rtl'] & {\n    font-family: 'Noto Kufi Arabic';\n  }\n  height: ", ";\n  @media (max-width: ", ") {\n    ", ";\n  }\n"])), function (props) { return (props.isHideNav ? (props.cookieVisibility ? '180px' : '112px') : 'auto'); }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.isHideNav && "box-shadow: none"; });
var Spacer = CustomStyled(Box)(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject$1([""], [""])));
Spacer.defaultProps = {
    flexGrow: [1, null, 0],
    pl: 3,
};
var PageMaxWidth = CustomStyled(Box)(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject$1(["\n  max-width: 1440px;\n  margin: 0 auto;\n"], ["\n  max-width: 1440px;\n  margin: 0 auto;\n"])));
var Container = CustomStyled(Box)(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject$1([""], [""])));
Container.defaultProps = {
    bg: ['blue', null, null, null, 'white'],
    px: [3, 4, null, null, 0],
};
var Divider = CustomStyled(Box)(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject$1(["\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n  margin: auto;\n"], ["\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n  margin: auto;\n"])));
Divider.defaultProps = {
    as: 'i',
    display: ['none', null, null, null, 'block'],
    height: 23,
};
var HelplineWrapper = CustomStyled(Box)(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject$1(["\n  color: ", ";\n  font-weight: ", ";\n  padding-left: ", "px;\n  a{\n    color: inherit;\n    text-decoration: none;\n  }\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  padding-left: ", "px;\n  a{\n    color: inherit;\n    text-decoration: none;\n  }\n"])), function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.fontWeights[4]; }, function (props) { return props.theme.space[3]; });
var MobileAreaWrapper = CustomStyled(Box)(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject$1(["\ndisplay: none;\n@media (max-width: ", ") {\n  display: ", ";\n}\n"], ["\ndisplay: none;\n@media (max-width: ", ") {\n  display: ", ";\n}\n"])), function (props) { return props.theme.breakpoints[3]; }, function (props) { return (props.isHideNav ? 'none' : 'block'); });
var DesktopAreaWrapper = CustomStyled(Box)(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject$1(["\ndisplay: block;\n\n@media (max-width: ", ") {\n  display: none;\n}\n@media (min-width: ", ") {\n  ", ""], ["\ndisplay: block;\n\n@media (max-width: ", ") {\n  display: none;\n}\n@media (min-width: ", ") {\n  ",
    ""])), function (props) { return props.theme.breakpoints[3]; }, function (props) { return props.theme.breakpoints[1]; }, function (props) {
    return props.isDesktopHeader &&
        "\n  &:hover {\n    background: " + COLORS.BLUE_500 + ";\n    border-radius: 66px;\n  }\n  padding: 4px 12px;\n  ";
});
var HeadTabsWrapper = CustomStyled(Box)(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject$1(["\ndisplay: grid;\nplace-items: center;\nbackground: ", ";\n\n@media (max-width: ", ") {\n  display: none;\n}\n"], ["\ndisplay: grid;\nplace-items: center;\nbackground: ", ";\n\n@media (max-width: ", ") {\n  display: none;\n}\n"])), COLORS.WHITE, function (props) { return props.theme.breakpoints[1]; });
var HeadTabsWrapperMobile = CustomStyled(Box)(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject$1(["\nbackground: ", ";\npadding: 8px 8px 8px 0;\nheight: 53px;\n@media (min-width: ", ") {\n  display: none;\n}\n"], ["\nbackground: ", ";\npadding: 8px 8px 8px 0;\nheight: 53px;\n@media (min-width: ", ") {\n  display: none;\n}\n"])), COLORS.WHITE, function (props) { return props.theme.breakpoints[1]; });
var templateObject_1$2, templateObject_2$2, templateObject_3$2, templateObject_4$2, templateObject_5$2, templateObject_6$2, templateObject_7$2, templateObject_8$2, templateObject_9$2, templateObject_10$2;
var DrawerMenuOptionStyle;
(function (DrawerMenuOptionStyle) {
    DrawerMenuOptionStyle["Default"] = "__menuoptionstyledefault__";
    DrawerMenuOptionStyle["Bold"] = "__menuoptionstylebold__";
    DrawerMenuOptionStyle["Focussed"] = "__menuoptionstylefocussed__";
    DrawerMenuOptionStyle["Bolder"] = "__menuoptionstylebolder__";
})(DrawerMenuOptionStyle || (DrawerMenuOptionStyle = {}));
var Caption = Text.Caption, Paragraph = Text.Paragraph;
var DrawerMenuContainer = styled(Flex)(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject$1(["\n  flex-direction: row;\n  position: relative;\n  align-items: stretch;\n  justify-content: space-between;\n  transition: 0.3s all;\n  transform: ", ";\n  padding-top: 116px;\n"], ["\n  flex-direction: row;\n  position: relative;\n  align-items: stretch;\n  justify-content: space-between;\n  transition: 0.3s all;\n  transform: ", ";\n  padding-top: 116px;\n"])), function (props) { return (props.isSubMenuOpen ? "translateX(-100%)" : "translateX(0)"); });
var DrawerHeaderSeparator = styled(Box)(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject$1(["\n  border-bottom: 8px solid ", ";\n  margin: 0 -", ";\n"], ["\n  border-bottom: 8px solid ", ";\n  margin: 0 -", ";\n"])), COLORS.LIGHT_BORDER, SPACINGS[16]);
var DrawerFixedHeaderSeparator = styled(Box)(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject$1(["\n  border-bottom: 8px solid ", ";\n"], ["\n  border-bottom: 8px solid ", ";\n"])), COLORS.LIGHT_BORDER);
var DrawerItemSeparator = styled(Box)(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject$1(["\n  border-bottom: 1px solid ", ";\n  width: 86%;\n  margin: auto;\n"], ["\n  border-bottom: 1px solid ", ";\n  width: 86%;\n  margin: auto;\n"])), COLORS.LIGHT_GRAY);
var DrawerMenuOptionCell = styled(Flex)(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject$1(["\n  border-bottom: ", " solid ", ";\n  padding: 24px 0 20px 0;\n  cursor: pointer;\n"], ["\n  border-bottom: ", " solid ", ";\n  padding: 24px 0 20px 0;\n  cursor: pointer;\n"])), function (props) { return (!props.isLastInList ? '1px' : '0px'); }, COLORS.LIGHT_GRAY);
var CaptionText = styled(Caption)(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject$1(["\n  text-transform: capitalize;\n"], ["\n  text-transform: capitalize;\n"])));
var DrawerMenuOptionLabel = styled(Paragraph)(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject$1(["\n  color: ", ";\n  font-weight: ", ";\n"], ["\n  color: ", ";\n  font-weight: ", ";\n"])), function (props) { return getColorFor(props.optionStyle); }, function (props) { return getFontWeightFor(props.optionStyle); });
var getColorFor = function (styleType) {
    if (styleType === void 0) { styleType = DrawerMenuOptionStyle.Default; }
    return styleType === DrawerMenuOptionStyle.Focussed ? COLORS.RED : COLORS.THUNDORA;
};
var getFontWeightFor = function (styleType) {
    if (styleType === void 0) { styleType = DrawerMenuOptionStyle.Default; }
    return styleType === DrawerMenuOptionStyle.Bolder
        ? TYPOGRAPHY.WEIGHT[700]
        : DrawerMenuOptionStyle.Bold
            ? TYPOGRAPHY.WEIGHT[500]
            : TYPOGRAPHY.WEIGHT[400];
};
var DrawerNavItem = styled.a(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject$1(["\n  position: relative;\n  display: block;\n  padding: ", ";\n  text-decoration: none;\n"], ["\n  position: relative;\n  display: block;\n  padding: ",
    ";\n  text-decoration: none;\n"])), function (props) {
    return props.quickBuy || props.buyNow ? "15px 16px 18px 24px" : "24px 16px 20px 24px";
});
var DrawerContent = styled(Flex)(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject$1(["\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n"], ["\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n"])));
var DrawerHeader = styled(Flex)(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject$1(["\n  padding: 20px 16px 16px 24px;\n  justify-content: flex-end;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  background: #ffffff;\n  top: 0;\n  ", "\n"], ["\n  padding: 20px 16px 16px 24px;\n  justify-content: flex-end;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  background: #ffffff;\n  top: 0;\n  ",
    "\n"])), variant({
    prop: 'type',
    variants: {
        bodered: {
            borderBottom: "1px solid " + COLORS.MERCURY,
            padding: '24px 0px 20px 0px',
            margin: '0px 16px',
            justifyContent: 'space-between',
        },
    },
}));
var DrawerSubHeader = styled(Text)(templateObject_11$2 || (templateObject_11$2 = __makeTemplateObject$1(["\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  background: #ffffff;\n  top: 66px;\n"], ["\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  background: #ffffff;\n  top: 66px;\n"])));
var DrawerIconWrapper = styled.span(templateObject_12$2 || (templateObject_12$2 = __makeTemplateObject$1(["\n  padding: 0px 10px 0px 0px;\n  margin-top: 6px;\n  position: relative;\n"], ["\n  padding: 0px 10px 0px 0px;\n  margin-top: 6px;\n  position: relative;\n"])));
var AllCategoryContent = styled.div(templateObject_13$2 || (templateObject_13$2 = __makeTemplateObject$1(["\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  width: 100%;\n  left: 100%;\n  top: 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  width: 100%;\n  left: 100%;\n  top: 0;\n"])));
var DrawerNavText = styled.div(templateObject_14$2 || (templateObject_14$2 = __makeTemplateObject$1(["\n  font-weight: 500;\n  font-size: 14px;\n  color: ", ";\n"], ["\n  font-weight: 500;\n  font-size: 14px;\n  color: ",
    ";\n"])), function (props) {
    return props.isDeal ? "#FF0000" : props.isLogin ? '#0E5AA7' : "#4d4d4d";
});
var DrawerHeaderContent = styled(Flex)(templateObject_15$2 || (templateObject_15$2 = __makeTemplateObject$1([""], [""])));
var templateObject_1$3, templateObject_2$3, templateObject_3$3, templateObject_4$3, templateObject_5$3, templateObject_6$3, templateObject_7$3, templateObject_8$3, templateObject_9$3, templateObject_10$3, templateObject_11$2, templateObject_12$2, templateObject_13$2, templateObject_14$2, templateObject_15$2;
var MenuHeader = {
    linksTo: URLS_CONFIG.urlPrefix + "/v1/my-account",
    key: '__menu_header_component__',
};
var IconButton = styled.button(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject$1(["\n  ", ";\n  font-style: normal;\n  display: inline-flex;\n  align-items: center;\n  height: ", ";\n  background: 0;\n  border: 0;\n  text-decoration: none;\n  position: relative;\n"], ["\n  ", ";\n  font-style: normal;\n  display: inline-flex;\n  align-items: center;\n  height: ", ";\n  background: 0;\n  border: 0;\n  text-decoration: none;\n  position: relative;\n"])), space, SIZES.BUTTON_SIZE);
IconButton.Text = styled.span(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject$1(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  white-space: nowrap;\n  margin-left: 10px;\n\n  html[dir='rtl'] & {\n    font-weight: 600;\n  }\n  display: block;\n\n  @media (max-width: 767px) {\n    display: none;\n  }\n"], ["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  white-space: nowrap;\n  margin-left: 10px;\n\n  html[dir='rtl'] & {\n    font-weight: 600;\n  }\n  display: block;\n\n  @media (max-width: 767px) {\n    display: none;\n  }\n"])), function (props) { return (props.isDesktopHeader ? COLORS.WHITE : COLORS.ANCHOR_BLUE); }, TYPOGRAPHY.SIZE[12], TYPOGRAPHY.WEIGHT[500]);
var templateObject_1$4, templateObject_2$4;
var NowButtonWrapper = CustomStyled.a(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject$1(["\n  display: flex;\n  flex-direction: row;\n  text-decoration: none;\n  align-items: center;\n  align-self: stretch;\n  color: ", ";\n  @media (min-width: ", ") {\n    margin-left: 15px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  text-decoration: none;\n  align-items: center;\n  align-self: stretch;\n  color: ", ";\n  @media (min-width: ", ") {\n    margin-left: 15px;\n  }\n"])), COLORS.BLUE, function (props) { return props.theme.breakpoints[3]; });
var IconWrapper = CustomStyled(Flex)(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject$1(["\n  @media (min-width: ", ") {\n    border-left: 1px solid #E6E6E6;\n    padding-left: 12px;\n  } \n  margin-right: 10px;\n"], ["\n  @media (min-width: ", ") {\n    border-left: 1px solid #E6E6E6;\n    padding-left: 12px;\n  } \n  margin-right: 10px;\n"])), function (props) { return props.theme.breakpoints[3]; });
var TextWrapper = CustomStyled(Text)(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject$1([""], [""])));
TextWrapper.defaultProps = {
    color: COLORS.BLUE,
    fontSize: 0,
};
var templateObject_1$5, templateObject_2$5, templateObject_3$4;
var headerHeightProp = { height: '56px' };
var Header$1 = CustomStyled(Box)(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject$1([""], [""])));
Header$1.defaultProps = __assign$1(__assign$1({}, headerHeightProp), { mt: [0, null, null, null, 2] });
var Search = CustomStyled(Box)(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject$1(["\n  height: 48px;\n"], ["\n  height: 48px;\n"])));
Search.defaultProps = {
    display: [null, null, 'none'],
};
var Area = CustomStyled(Box)(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject$1(["\n   ", ";\n\n  align-items: center;\n"], ["\n   ",
    ";\n\n  align-items: center;\n"])), function (props) {
    return !props.static
        ? "\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n   "
        : '';
});
Area.defaultProps = {
    bg: 'white',
    display: ['flex', null, null, null, 'none'],
    height: '40px',
    px: [3, 4],
};
var Nav = CustomStyled(Box)(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject$1(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
Nav.defaultProps = {
    display: ['none', null, null, null, 'flex'],
    height: '50px',
};
var NavItem = CustomStyled(Box)(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject$1(["\n  height: 16px;\n  width: 100px;\n"], ["\n  height: 16px;\n  width: 100px;\n"])));
NavItem.defaultProps = {
    variant: 'skeletonSquare',
    mx: '12px',
};
var templateObject_1$6, templateObject_2$6, templateObject_3$5, templateObject_4$4, templateObject_5$4;
var MenuNavigationMainContainer = CustomStyled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject$1(["\n  background-color: ", ";\n  transition: 0.1s all;\n  position: relative;\n  z-index: 1;\n\n  position: relative;\n  z-index: -1;\n  padding: 0px 16px;\n  @media (min-width: ", ") {\n    min-height: 46px;\n  }\n"], ["\n  background-color: ", ";\n  transition: 0.1s all;\n  position: relative;\n  z-index: 1;\n\n  position: relative;\n  z-index: -1;\n  padding: 0px 16px;\n  @media (min-width: ", ") {\n    min-height: 46px;\n  }\n"])), function (props) { return (props.isDesktopHeader ? COLORS.ANCHOR_BLUE : COLORS.WHITE); }, function (props) { return props.theme.breakpoints[3]; });
var MenuNavigationWrapper = CustomStyled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject$1(["\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  overflow-x: auto;\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  // #AHN-1274\n  html[dir=\"rtl\"] & [data-testid=\"trolly-text\"] {\n    font-size: 12px;\n  },\n"], ["\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  overflow-x: auto;\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  // #AHN-1274\n  html[dir=\"rtl\"] & [data-testid=\"trolly-text\"] {\n    font-size: 12px;\n  },\n"])));
var MenuNavigationContainer = CustomStyled(Nav)(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject$1(["\n  flex-wrap: wrap;\n  height: auto;\n  max-width: 1440px;\n  margin: 0 auto;\n  justify-content: space-between;\n  position: relative;\n  background-color: ", ";\n"], ["\n  flex-wrap: wrap;\n  height: auto;\n  max-width: 1440px;\n  margin: 0 auto;\n  justify-content: space-between;\n  position: relative;\n  background-color: ", ";\n"])), function (props) { return !props.isDesktopHeader && COLORS.WHITE; });
var MenuNavigationItem = CustomStyled(Flex)(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject$1(["\n  ", ";\n  flex-direction: column;\n  background-color: ", ";\n  transition: all .3s ease;\n  position: relative;\n  min-width: unset;\n  background-color:  ", ";\n\n  :after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    width: ", ";\n    background-color: ", ";\n    transition: .3s;\n    margin: auto;\n  }\n  \n"], ["\n  ", ";\n  flex-direction: column;\n  background-color: ", ";\n  transition: all .3s ease;\n  position: relative;\n  min-width: unset;\n  background-color:  ", ";\n\n  :after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    width: ", ";\n    background-color: ", ";\n    transition: .3s;\n    margin: auto;\n  }\n  \n"])), margin, function (props) { return (props.isHover && !props.isDesktopHeader ? COLORS.BODY : COLORS.WHITE); }, function (props) { return props.isDesktopHeader && COLORS.BLUE; }, function (props) { return (props.isHover ? '100%' : '0px'); }, function (props) { return (props.isDesktopHeader ? COLORS.WHITE : COLORS.BLUE); });
var MenuNavigationLink = CustomStyled.a(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject$1(["\n  ", "\n  cursor: pointer;\n  text-decoration: none;\n  text-transform: capitalize;\n  vertical-align: baseline;\n  display: inherit;\n  background: ", ";\n"], ["\n  ", "\n  cursor: pointer;\n  text-decoration: none;\n  text-transform: capitalize;\n  vertical-align: baseline;\n  display: inherit;\n  background: ", ";\n"])), padding, function (_a) {
    var isHover = _a.isHover, theme = _a.theme;
    return (isHover ? theme.colors.mercury : theme.colors.transparent);
});
var MenuNavigationText = CustomStyled(Text)(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject$1(["\n  position: inherit;\n  text-overflow: ellipsis;\n  text-transform: capitalize;\n  font-size: 12px;\n  line-height: 15px;\n  white-space: nowrap;\n  transition: .5s all;\n\n  ", "\n"], ["\n  position: inherit;\n  text-overflow: ellipsis;\n  text-transform: capitalize;\n  font-size: 12px;\n  line-height: 15px;\n  white-space: nowrap;\n  transition: .5s all;\n\n  ",
    "\n"])), variant({
    prop: 'type',
    variants: {
        mainMenu: {
            lineHeight: '15px',
            fontSize: '12px',
        },
        allCategories: {
            fontSize: '12px',
            fontWeight: 700,
        },
        deals: {
            fontSize: '12px',
            fontWeight: 700,
            color: COLORS.RED,
        },
        menuTitle: {
            fontWeight: 500,
            padding: '12px 24px',
            'html[dir="rtl"] &': {
                fontWeight: 600,
            },
        },
        subMenuTitle: {
            padding: '4px 24px',
            maxWidth: '265px',
            ':hover': {
                color: COLORS.BLUE,
                fontWeight: 500,
            },
        },
        new: {
            '::after': {
                content: "\"New\"",
                color: COLORS.WHITE,
                background: COLORS.RED,
                fontSize: '10px',
                fontWeight: 500,
                position: 'absolute',
                padding: '2px 4px',
                top: '2px',
                borderRadius: '4px',
                marginLeft: '4px',
                zIndex: 8,
            },
            fontSize: '14px',
            fontWeight: 500,
            width: '105px',
        },
        allCategory: {
            padding: '8px 12px',
            fontSize: '12px',
            position: 'relative',
            lineHeight: '14px',
        },
    },
}));
var MenuNavigationSlot = CustomStyled(Flex)(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject$1(["\n  background-color: ", ";\n  ", ";\n  flex-direction: row;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width:100%;\n  height: 650px;\n\n  :before {\n    content: \"\";\n    display: block;\n    position: fixed;\n    z-index: -1;\n    background: rgba(0,0,0,.5);\n    top: ", ";\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100vh;\n    pointer-events: none;\n    opacity: ", ";\n    transform: ", ";\n    transition-delay: .2s;\n    transition: opacity .3s ease;\n  }\n"], ["\n  background-color: ", ";\n  ", ";\n  flex-direction: row;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width:100%;\n  height: 650px;\n\n  :before {\n    content: \"\";\n    display: block;\n    position: fixed;\n    z-index: -1;\n    background: rgba(0,0,0,.5);\n    top: ", ";\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100vh;\n    pointer-events: none;\n    opacity: ", ";\n    transform: ", ";\n    transition-delay: .2s;\n    transition: opacity .3s ease;\n  }\n"])), COLORS.WHITE, background, function (props) { return (props.isDesktopHeader ? '158px' : '119px'); }, function (props) { return (props.isHover ? '1' : '0'); }, function (props) { return (props.isHover ? 'scale(1)' : 'scale(0)'); });
var MenuNavigationSlotItems = CustomStyled.ul(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject$1(["\n  background-color: ", ";\n  display: ", ";\n  position: relative;\n  left: 0;\n  opacity: 1;\n  margin-bottom: 18px;\n  z-index: 1;\n  pointer-events: auto;\n  padding: 0;\n  border: 0;\n  flex: 1 1 75%;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  overflow: auto;\n  height: 100%;\n"], ["\n  background-color: ", ";\n  display: ", ";\n  position: relative;\n  left: 0;\n  opacity: 1;\n  margin-bottom: 18px;\n  z-index: 1;\n  pointer-events: auto;\n  padding: 0;\n  border: 0;\n  flex: 1 1 75%;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  overflow: auto;\n  height: 100%;\n"])), COLORS.WHITE, function (props) { return (props.isChild ? 'inline' : 'flex'); });
var MenuTextIconWrapper = CustomStyled(Flex)(templateObject_9$4 || (templateObject_9$4 = __makeTemplateObject$1(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var isSeparator = _a.isSeparator;
    return isSeparator &&
        " border-right: 1px solid #E6E6E6;\n      padding-right: 10px;\n    ";
});
var MenuAllCategoriesItem = CustomStyled.li(templateObject_10$4 || (templateObject_10$4 = __makeTemplateObject$1(["\n  font-size: 12px;\n  position: relative;\n  white-space: nowrap;\n  line-height: 14px;\n  list-style: none;\n  min-width: 230px;\n"], ["\n  font-size: 12px;\n  position: relative;\n  white-space: nowrap;\n  line-height: 14px;\n  list-style: none;\n  min-width: 230px;\n"])));
var MenuNavigationInnerItem = CustomStyled.div(templateObject_11$3 || (templateObject_11$3 = __makeTemplateObject$1(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), COLORS.WHITE);
var SubMenuText = CustomStyled(Text.Caption)(templateObject_12$3 || (templateObject_12$3 = __makeTemplateObject$1(["\n"], ["\n"])));
var AllCategoryWrapper = CustomStyled.ul(templateObject_13$3 || (templateObject_13$3 = __makeTemplateObject$1(["\n  display: block;\n  background-color: ", ";\n  padding: 10px 0px;\n  flex: 1 1 25%;\n  height: 100%;\n  overflow-y: auto;\n"], ["\n  display: block;\n  background-color: ", ";\n  padding: 10px 0px;\n  flex: 1 1 25%;\n  height: 100%;\n  overflow-y: auto;\n"])), COLORS.BODY);
var QuickBuyLink = CustomStyled(Flex)(templateObject_14$3 || (templateObject_14$3 = __makeTemplateObject$1(["\n  color: #E3870F;\n  align-items: center;\n  text-decoration: none;\n"], ["\n  color: #E3870F;\n  align-items: center;\n  text-decoration: none;\n"])));
QuickBuyLink.defaultProps = {
    as: 'a',
};
var IconWrapper$1 = CustomStyled(Flex)(templateObject_15$3 || (templateObject_15$3 = __makeTemplateObject$1(["\n  border-left: 1px solid #E6E6E6;\n  margin-right: 10px;\n  padding-left: 12px;\n"], ["\n  border-left: 1px solid #E6E6E6;\n  margin-right: 10px;\n  padding-left: 12px;\n"])));
var TextWrapper$1 = CustomStyled(Text)(templateObject_16$2 || (templateObject_16$2 = __makeTemplateObject$1([""], [""])));
TextWrapper$1.defaultProps = {
    color: '#E3870F',
    fontSize: 0,
    lineHeight: '15px',
};
var QuickLinks = CustomStyled(Flex)(templateObject_17$2 || (templateObject_17$2 = __makeTemplateObject$1([""], [""])));
var AdBannerContainer = CustomStyled.div(templateObject_18$2 || (templateObject_18$2 = __makeTemplateObject$1(["\n  padding-top: 10px;\n  padding-right: 10px;\n"], ["\n  padding-top: 10px;\n  padding-right: 10px;\n"])));
var MenuIconWrapper = CustomStyled.span(templateObject_19$2 || (templateObject_19$2 = __makeTemplateObject$1(["\n  padding-top: 11px;  \n  background: ", ";\n"], ["\n  padding-top: 11px;  \n  background: ", ";\n"])), function (props) { return props.isDesktopHeader && COLORS.BLUE; });
var templateObject_1$7, templateObject_2$7, templateObject_3$6, templateObject_4$5, templateObject_5$5, templateObject_6$4, templateObject_7$4, templateObject_8$4, templateObject_9$4, templateObject_10$4, templateObject_11$3, templateObject_12$3, templateObject_13$3, templateObject_14$3, templateObject_15$3, templateObject_16$2, templateObject_17$2, templateObject_18$2, templateObject_19$2;
var AllCategoryMenuItem = styled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject$1(["\n  background: ", ";\n  margin: 0 -4%;\n"], ["\n  background: ", ";\n  margin: 0 -4%;\n"])), COLORS.BODY);
var AllCategoryLink = styled.a(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject$1(["\n  padding: 20px 16px 20px 44px;\n  display: block;\n  text-decoration: none;\n"], ["\n  padding: 20px 16px 20px 44px;\n  display: block;\n  text-decoration: none;\n"])));
var templateObject_1$8, templateObject_2$8;
var MenuButton = styled.button(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject$1(["\n  height: ", ";\n  width: ", ";\n\n  background: rgba(255, 255, 255, 0.2);\n  border: 0;\n  padding: 0;\n\n  i {\n    margin: 0 4px;\n    &,\n    &:before,\n    &:after {\n      background: ", ";\n      display: block;\n      height: 2px;\n    }\n\n    &:before,\n    &:after {\n      content: '';\n      margin-top: -1px;\n    }\n\n    &:before {\n      transform: translate3d(0, -6px, 0);\n    }\n\n    &:after {\n      transform: translate3d(0, 5px, 0);\n    }\n  }\n"], ["\n  height: ", ";\n  width: ", ";\n\n  background: rgba(255, 255, 255, 0.2);\n  border: 0;\n  padding: 0;\n\n  i {\n    margin: 0 4px;\n    &,\n    &:before,\n    &:after {\n      background: ", ";\n      display: block;\n      height: 2px;\n    }\n\n    &:before,\n    &:after {\n      content: '';\n      margin-top: -1px;\n    }\n\n    &:before {\n      transform: translate3d(0, -6px, 0);\n    }\n\n    &:after {\n      transform: translate3d(0, 5px, 0);\n    }\n  }\n"])), SIZES.ICON_SIZE, SIZES.ICON_SIZE, COLORS.ANCHOR_BLUE);
var templateObject_1$9;
var Container$1 = CustomStyled(Box)(templateObject_1$a || (templateObject_1$a = __makeTemplateObject$1(["\n  flex-shrink: 0;\n"], ["\n  flex-shrink: 0;\n"])));
Container$1.defaultProps = {
    mr: 3,
    display: [null, null, null, null, 'none'],
};
var templateObject_1$a;
var FlexWrapper = styled(Flex)(templateObject_1$b || (templateObject_1$b = __makeTemplateObject$1(["\n  cursor: pointer;\n  position: relative;\n  padding: 5px 0;\n"], ["\n  cursor: pointer;\n  position: relative;\n  padding: 5px 0;\n"])));
var Items = styled(Flex)(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject$1(["\n  padding: 12px;\n  color: 'black';\n  cursor: pointer;\n\n  ", "\n  &:not(:first-child) {\n    border-top: 1px solid #f5f5f5;\n  }\n\n  > a span {\n    font-weight: 500;\n  }\n  &:hover {\n    span {\n      color: #0e5aa7;\n    }\n  }\n"], ["\n  padding: 12px;\n  color: 'black';\n  cursor: pointer;\n\n  ",
    "\n  &:not(:first-child) {\n    border-top: 1px solid #f5f5f5;\n  }\n\n  > a span {\n    font-weight: 500;\n  }\n  &:hover {\n    span {\n      color: #0e5aa7;\n    }\n  }\n"])), function (props) {
    return (props.active &&
        "\n      background-color: " + COLORS.LIGHT_GRAY + ";\n      ");
});
Items.defaultProps = {
    as: 'li',
};
var Link = styled(Box)(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject$1(["\n  text-decoration: none;\n  padding: 8px;\n"], ["\n  text-decoration: none;\n  padding: 8px;\n"])));
Link.defaultProps = {
    as: 'a',
};
var LinkText = styled(Box)(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject$1(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
LinkText.defaultProps = {
    as: 'span',
    fontSize: '13px',
    fontWeight: 5,
};
var templateObject_1$b, templateObject_2$9, templateObject_3$7, templateObject_4$6;
var SECONDARY_LANG = {
    mafgeo: 'ka',
    mafuzb: 'uz',
    mafarm: 'hy',
};
var LanguageChange = function (_a) {
    var _b = _a.isDrawer, isDrawer = _b === void 0 ? false : _b, isEN = _a.isEN, onLanguageChange = _a.onLanguageChange, rest = __rest$1(_a, ["isDrawer", "isEN", "onLanguageChange"]);
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _c = __read$1(useAppConfig(), 1), _d = _c[0], _e = _d.storeId, storeId = _e === void 0 ? '' : _e, _f = _d.language, language = _f === void 0 ? EN : _f;
    var ref = useRef({
        languageSelectionPopupOpen: false,
        languageSelectionPopupOpenFn: function () { return null; },
    });
    var tooltipItems = useMemo(function () {
        var multiLang = Object.entries(countries[storeId.substring(3)] || []);
        return multiLang.map(function (arr) {
            var _a = __read$1(arr, 2), lang = _a[0], languageToggle = _a[1].languageToggle;
            return {
                text: languageToggle,
                value: lang,
            };
        });
    }, [storeId]);
    var currentLanguage = useMemo(function () {
        var _a;
        return (_a = tooltipItems.find(function (_a) {
            var value = _a.value;
            return value === language;
        })) === null || _a === void 0 ? void 0 : _a.text;
    }, [tooltipItems, language]);
    var MoreLinks = function () {
        return (React.createElement(React.Fragment, null, tooltipItems.map(function (_a) {
            var text = _a.text, value = _a.value;
            return (React.createElement(Items, { key: value, onClick: function () { return onClickHandler(value); }, active: text === currentLanguage },
                React.createElement(Link, null,
                    React.createElement(LinkText, { color: COLORS.BLACK, fontSize: 2 }, text))));
        })));
    };
    var onClickHandler = useCallback(function (value) {
        var language;
        if (value && ref.current.languageSelectionPopupOpen) {
            ref.current.languageSelectionPopupOpenFn(false);
            language = value;
        }
        else {
            language = isEN ? SECONDARY_LANG[storeId] || AR : EN;
        }
        setStoreInfoCookie({ language: language });
        if (onLanguageChange) {
            onLanguageChange(language);
            return;
        }
        dispatch(setLanguageCode(language));
    }, [dispatch, isEN, onLanguageChange, storeId]);
    var props = __assign$1({ color: COLORS.ANCHOR_BLUE }, rest);
    return (React.createElement(Flex, { mr: 2, alignItems: "center" },
        tooltipItems.length <= 2 ? (React.createElement(Button$1, __assign$1({ fontWeight: 700, fontSize: isDrawer ? 2 : 1, onClick: onClickHandler, px: isDrawer ? 0 : 3, testid: "change_language", variant: "link", size: "CUSTOM" }, props), isBrowser() && t('language'))) : (React.createElement(Tooltip, { content: React.createElement(MoreLinks, null), cardProps: { style: { minWidth: 200, padding: 0, borderRadius: 5 } }, popupWrapperStyle: { zIndex: 9, right: 0, top: 25 },
            getCurrentStateMethod: function (value) {
                ref.current.languageSelectionPopupOpen = value;
            }, getChangeStateMethod: function (fn) {
                ref.current.languageSelectionPopupOpenFn = fn;
            }, tipPosition: 'end', tipPositionFromRight: language === 'ar' ? 145 : 0, isHoverDropdown: true, tipWidth: 5 },
            React.createElement(FlexWrapper, { alignItems: "center", mx: "2" },
                React.createElement(Box, { fontSize: 1, mx: "1" }, currentLanguage),
                React.createElement(ChevronDown, { size: "XS", fill: COLORS.WHITE })))),
        React.createElement(Divider, null)));
};
var LanguageChange$1 = memo(LanguageChange);
var ChangeCurrencyMobile = styled(Flex)(templateObject_1$c || (templateObject_1$c = __makeTemplateObject$1(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
var ChangeCurrency = styled(Flex)(templateObject_2$a || (templateObject_2$a = __makeTemplateObject$1(["\n  flex-direction: column;\n"], ["\n  flex-direction: column;\n"])));
ChangeCurrency.defaultProps = {};
var TooltipLabel = styled(Box)(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject$1(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
TooltipLabel.defaultProps = {
    mr: 2,
};
var Label = styled(Box)(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject$1(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
Label.defaultProps = {
    as: 'span',
    fontSize: 2,
    fontWeight: 4,
    color: 'copy',
    mr: 4,
};
var Item = styled(Box)(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject$1([""], [""])));
Item.defaultProps = {
    as: 'span',
    fontSize: 2,
    fontWeight: 4,
    color: 'copy',
    pb: 3,
    mb: 3,
    sx: {
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'wildSand',
        '&:last-child': {
            border: 'none',
            mb: 0,
            pb: 0,
        },
    },
};
var templateObject_1$c, templateObject_2$a, templateObject_3$8, templateObject_4$7, templateObject_5$6;
var QuickBuyLink$1 = CustomStyled(Flex)(templateObject_1$d || (templateObject_1$d = __makeTemplateObject$1(["\n  color: #E3870F;\n  align-items: center;\n  text-decoration: none;\n"], ["\n  color: #E3870F;\n  align-items: center;\n  text-decoration: none;\n"])));
QuickBuyLink$1.defaultProps = {
    as: 'a',
};
var IconWrapper$2 = CustomStyled(Flex)(templateObject_2$b || (templateObject_2$b = __makeTemplateObject$1(["\n  margin-right: 10px;\n  ", "\n"], ["\n  margin-right: 10px;\n  ",
    "\n"])), function (props) {
    return !props.isMobile &&
        "\n    border-left: 1px solid #E6E6E6;\n     padding-left: 12px;";
});
var TextWrapper$2 = CustomStyled(Text)(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject$1([""], [""])));
TextWrapper$2.defaultProps = {
    color: '#E3870F',
    fontSize: 0,
    lineHeight: '15px',
};
var templateObject_1$d, templateObject_2$b, templateObject_3$9;
var DrawerLoggedInHeaderText = styled(Text)(templateObject_1$e || (templateObject_1$e = __makeTemplateObject$1(["\n  font-weight: 400;\n  font-size: 14px;\n  color: #6b6b6b;\n  margin-left: 7px;\n"], ["\n  font-weight: 400;\n  font-size: 14px;\n  color: #6b6b6b;\n  margin-left: 7px;\n"])));
var DrawerLoggedInUserName = styled(Text)(templateObject_2$c || (templateObject_2$c = __makeTemplateObject$1(["\n  font-weight: 500;\n  font-size: 14px;\n  color: #4d4d4d;\n"], ["\n  font-weight: 500;\n  font-size: 14px;\n  color: #4d4d4d;\n"])));
var IconWrapper$3 = styled(Text)(templateObject_3$a || (templateObject_3$a = __makeTemplateObject$1(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n"])));
var Points = styled(Text)(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject$1(["\n  font-size: 16px;\n  color: #4d4d4d;\n"], ["\n  font-size: 16px;\n  color: #4d4d4d;\n"])));
var templateObject_1$e, templateObject_2$c, templateObject_3$a, templateObject_4$8;
var Logo = styled(Flex)(templateObject_1$f || (templateObject_1$f = __makeTemplateObject$1(["\n  flex-shrink: 0;\n"], ["\n  flex-shrink: 0;\n"])));
var MobileLogoWrapper = CustomStyled(Box)(templateObject_2$d || (templateObject_2$d = __makeTemplateObject$1(["\n    display: none;\n    height: 35px;\n    width: 32px;\n\n    @media (max-width: ", ") {\n      display: block;\n    }\n"], ["\n    display: none;\n    height: 35px;\n    width: 32px;\n\n    @media (max-width: ", ") {\n      display: block;\n    }\n"])), function (props) { return props.theme.breakpoints[2]; });
var DesktopLogoWrapper = CustomStyled(Box)(templateObject_3$b || (templateObject_3$b = __makeTemplateObject$1(["\n    display: block;\n\n    @media (max-width: ", ") {\n      display: none;\n    }\n"], ["\n    display: block;\n\n    @media (max-width: ", ") {\n      display: none;\n    }\n"])), function (props) { return props.theme.breakpoints[2]; });
Logo.defaultProps = {
    as: 'a',
    height: [null, null, null, '36px'],
    width: [null, null, null, '142px'],
    mr: [null, null, 4],
    mt: ['-2px', null, null, null],
    sx: {
        svg: {
            height: '100%',
            width: '100%',
        },
    },
};
var templateObject_1$f, templateObject_2$d, templateObject_3$b;
var Logo$1 = function (_a) {
    var storeId = _a.storeId, _b = _a.fill, fill = _b === void 0 ? '#0e5aa7' : _b, language = _a.language, isNotEnableCache = _a.isNotEnableCache;
    return (React.createElement(Logo, { "data-testid": "carrefour_logo", href: isNotEnableCache ? '/' : "/" + storeId + "/" + language + "/" },
        React.createElement(MobileLogoWrapper, null,
            React.createElement(CarrefourNewLogoMobile, { storeId: storeId, size: "XL", fill: fill })),
        React.createElement(DesktopLogoWrapper, null,
            React.createElement(CarrefourNewLogo, { storeId: storeId, size: "XL", fill: fill }))));
};
var SearchBoxWrapper = CustomStyled(Box)(templateObject_1$g || (templateObject_1$g = __makeTemplateObject$1(["\n  position: relative;\n  flex-grow: 1;\n  ", "\n"], ["\n  position: relative;\n  flex-grow: 1;\n  ",
    "\n"])), function (props) {
    return props.isSearchClicked &&
        "\n    margin-top: 8px;\n    margin-bottom: 8px;\n  ";
});
SearchBoxWrapper.defaultProps = {};
var SearchInputWrapper = CustomStyled(Flex)(templateObject_2$e || (templateObject_2$e = __makeTemplateObject$1(["\n  position: relative;\n  animation: fade-in 0.2s ease-in-out;\n  border-radius: 4px;\n  height: inherit;\n  justify-content: space-between;\n  border-bottom-left-radius: 48px;\n  border-top-left-radius: 48px;\n  border-bottom-right-radius: 48px;\n  border-top-right-radius: 48px;\n  background-color: ", ";\n  align-items: center;\n"], ["\n  position: relative;\n  animation: fade-in 0.2s ease-in-out;\n  border-radius: 4px;\n  height: inherit;\n  justify-content: space-between;\n  border-bottom-left-radius: 48px;\n  border-top-left-radius: 48px;\n  border-bottom-right-radius: 48px;\n  border-top-right-radius: 48px;\n  background-color: ", ";\n  align-items: center;\n"])), function (props) { return props.theme.colors.wildSand; });
var SearchInput = CustomStyled(Box)(templateObject_3$c || (templateObject_3$c = __makeTemplateObject$1(["\n  border: 0;\n  outline: none;\n  margin: 0;\n  padding: 11px 20px;\n  vertical-align: middle;\n  ", "\n  ", "\n  ", "\n  background: transparent;\n  font-size: 12px;\n  color: ", ";\n\n  height: 40px; // [Arabic] firefox & safari box height expanded fix\n  line-height: 26px; // [Arabic] safari text misaligned fix\n"], ["\n  border: 0;\n  outline: none;\n  margin: 0;\n  padding: 11px 20px;\n  vertical-align: middle;\n  ", "\n  ", "\n  ", "\n  background: transparent;\n  font-size: 12px;\n  color: ", ";\n\n  height: 40px; // [Arabic] firefox & safari box height expanded fix\n  line-height: 26px; // [Arabic] safari text misaligned fix\n"])), function (props) { return (props.isCompleteWidth ? 'width: 100%;' : 'width: 0;'); }, function (props) { return (props.isSSPEnabled ? 'cursor:pointer;' : 'cursor:auto;'); }, function (props) { return (props.isSSPEnabled ? 'caret-color:transparent;' : ''); }, function (props) { return props.theme.colors.blue; });
var SearchIconWrapper = CustomStyled.a(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject$1(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  text-align: center;\n  cursor: pointer;\n  background: transparent;\n  border-bottom-right-radius: 48px;\n  border-top-right-radius: 48px;\n  padding-left: 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  text-align: center;\n  cursor: pointer;\n  background: transparent;\n  border-bottom-right-radius: 48px;\n  border-top-right-radius: 48px;\n  padding-left: 16px;\n"])));
var CloseIconWrapper = CustomStyled.span(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject$1(["\n  width: 40px;\n  height: 40px;\n  text-align: center;\n  padding-top: 11px;\n  padding-bottom: 10px;\n  cursor: pointer;\n  position: absolute;\n  right: 10px;\n"], ["\n  width: 40px;\n  height: 40px;\n  text-align: center;\n  padding-top: 11px;\n  padding-bottom: 10px;\n  cursor: pointer;\n  position: absolute;\n  right: 10px;\n"])));
var templateObject_1$g, templateObject_2$e, templateObject_3$c, templateObject_4$9, templateObject_5$7;
var FlyoutCard = styled(Card)(templateObject_1$h || (templateObject_1$h = __makeTemplateObject$1(["\n  background: ", ";\n  list-style: none;\n  margin: 7px 0px !important;\n  padding: 0px;\n  overflow: auto;\n  z-index: 9;\n  max-height: 650px;\n\n  ", ";\n"], ["\n  background: ", ";\n  list-style: none;\n  margin: 7px 0px !important;\n  padding: 0px;\n  overflow: auto;\n  z-index: 9;\n  max-height: 650px;\n\n  ",
    ";\n"])), COLORS.WHITE, variant({
    prop: 'type',
    variants: {
        fullScreen: {
            position: 'fixed',
            width: '100%',
            zIndex: 999,
            margin: 0,
            left: 0,
            right: 0,
            marginTop: 13,
            maxHeight: 'none',
        },
        basic: {
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
        },
    },
}));
var FlyoutItemWrapper = styled.li(templateObject_2$f || (templateObject_2$f = __makeTemplateObject$1(["\n  box-sizing: border-box;\n  padding: 8px 0px 0px 0px;\n"], ["\n  box-sizing: border-box;\n  padding: 8px 0px 0px 0px;\n"])));
var FlyoutItem = styled(Text)(templateObject_3$d || (templateObject_3$d = __makeTemplateObject$1(["\n  font-weight: ", ";\n  animation: fade-in 0.2s ease-in;\n  background-color: ", ";\n  line-height: ", ";\n  padding: ", ";\n  background-color: ", ";\n  :hover {\n    background-color: rgba(14, 90, 167, 0.2);\n    text-decoration: none;\n    color: #0e5aa7;\n  }\n  strong {\n    font-weight: ", ";\n  }\n  font-size: ", ";\n  border: ", ";\n  border-radius: ", ";\n  margin-left: ", ";\n"], ["\n  font-weight: ", ";\n  animation: fade-in 0.2s ease-in;\n  background-color: ", ";\n  line-height: ", ";\n  padding: ", ";\n  background-color: ", ";\n  :hover {\n    background-color: rgba(14, 90, 167, 0.2);\n    text-decoration: none;\n    color: #0e5aa7;\n  }\n  strong {\n    font-weight: ", ";\n  }\n  font-size: ", ";\n  border: ", ";\n  border-radius: ", ";\n  margin-left: ", ";\n"])), TYPOGRAPHY.WEIGHT[400], COLORS.WHITE, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '40px' : '');
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '0px 8px' : '11px 32px');
}, function (_a) {
    var selected = _a.selected;
    return (selected ? 'rgba(14, 90, 167, 0.2)' : null);
}, TYPOGRAPHY.WEIGHT[600], function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '12px' : '14px');
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '1px solid #E6E6E6' : 'none');
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '6px' : 'none');
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '8px' : '0');
});
var FlyoutHeaderWrapper = styled(Flex)(templateObject_4$a || (templateObject_4$a = __makeTemplateObject$1(["\n  flex-direction: row;\n  justify-content: space-between;\n"], ["\n  flex-direction: row;\n  justify-content: space-between;\n"])));
var FlyoutHeader = styled(Text)(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject$1(["\n  font-weight: ", ";\n  opacity: ", ";\n  padding: ", ";\n  background-color: ", ";\n  text-transform: ", ";\n  color: ", ";\n"], ["\n  font-weight: ", ";\n  opacity: ", ";\n  padding: ", ";\n  background-color: ", ";\n  text-transform: ", ";\n  color: ", ";\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? TYPOGRAPHY.WEIGHT[700] : TYPOGRAPHY.WEIGHT[600]);
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 1 : 0.6);
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '16px' : '11px 32px');
}, COLORS.WHITE, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 'none' : 'uppercase');
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? COLORS.BLACK : COLORS.MINE_SHAFT);
});
var FlyoutClearAnchor = styled.a(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject$1(["\n  text-decoration: none;\n  padding: 11px 32px;\n  color: ", ";\n  cursor: pointer;\n"], ["\n  text-decoration: none;\n  padding: 11px 32px;\n  color: ", ";\n  cursor: pointer;\n"])), COLORS.ANCHOR_BLUE);
var FlyoutItemAnchor = styled.a(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject$1(["\n  text-decoration: none;\n  display: ", ";\n  margin-bottom: 8px;\n"], ["\n  text-decoration: none;\n  display: ", ";\n  margin-bottom: 8px;\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 'inline-block' : 'inline');
});
var StrongBlue = styled.strong(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject$1(["\n  font-weight: ", ";\n  color: ", ";\n"], ["\n  font-weight: ", ";\n  color: ", ";\n"])), TYPOGRAPHY.WEIGHT[500], COLORS.BLUE);
var Separator = styled.div(templateObject_9$5 || (templateObject_9$5 = __makeTemplateObject$1(["\n  border-top: 1px solid ", ";\n  max-height: 1px;\n  margin-top: 8px;\n"], ["\n  border-top: 1px solid ", ";\n  max-height: 1px;\n  margin-top: 8px;\n"])), COLORS.MERCURY);
var VisitStoreBrand = styled.text(templateObject_10$5 || (templateObject_10$5 = __makeTemplateObject$1(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: bold;\n  padding: 4px;\n  text-transform: uppercase;\n"], ["\n  color: ", ";\n  font-size: 14px;\n  font-weight: bold;\n  padding: 4px;\n  text-transform: uppercase;\n"])), COLORS.DARK_RED);
var FlyoutWrapper = styled.div(templateObject_11$4 || (templateObject_11$4 = __makeTemplateObject$1(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '0 8px' : '0');
});
var templateObject_1$h, templateObject_2$f, templateObject_3$d, templateObject_4$a, templateObject_5$8, templateObject_6$5, templateObject_7$5, templateObject_8$5, templateObject_9$5, templateObject_10$5, templateObject_11$4;
var AdBannerWrapper = customStyled.div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject$1(["\n    background-color: ", ";\n    ", ";\n"], ["\n    background-color: ", ";\n    ", ";\n"])), function (props) { return props.theme.colors.white; }, space);
var templateObject_1$i;
var BANNER_TYPE;
(function (BANNER_TYPE) {
    BANNER_TYPE["HERO_BANNER"] = "hero-banner";
    BANNER_TYPE["MONETIZATION_BANNER"] = "monetisation-banner";
    BANNER_TYPE["TWO_IN_ONE"] = "2-in-1";
    BANNER_TYPE["SLIM_BANNER"] = "slim-hero-banner";
    BANNER_TYPE["MONETISAION_TWO"] = "monetisation-2";
})(BANNER_TYPE || (BANNER_TYPE = {}));
var ETrackingKind;
(function (ETrackingKind) {
    ETrackingKind["VIEW_TRACKING"] = "viewTrackingUrl";
    ETrackingKind["CLICK_TRACKING"] = "clickTrackingUrl";
    ETrackingKind["LOAD_TRACKING"] = "loadTrackingUrl";
})(ETrackingKind || (ETrackingKind = {}));
var _a$2;
var SIZES$1 = (_a$2 = {},
    _a$2[BANNER_TYPE.HERO_BANNER] = {
        mobile: [343, 110],
        tablet: [720, 360],
        desktop: [1232, 280],
    },
    _a$2[BANNER_TYPE.SLIM_BANNER] = {
        mobile: [343, 110],
        tablet: [720, 360],
        desktop: [1232, 280],
    },
    _a$2[BANNER_TYPE.MONETIZATION_BANNER] = {
        mobile: [328, 110],
        tablet: [720, 360],
        desktop: [1232, 196],
    },
    _a$2[BANNER_TYPE.TWO_IN_ONE] = {
        mobile: [320, 160],
        tablet: [],
        desktop: [608, 160],
    },
    _a$2[BANNER_TYPE.MONETISAION_TWO] = {
        mobile: [328, 110],
        tablet: [720, 360],
        desktop: [1232, 196],
    },
    _a$2);
var CriteoBannerImage = customStyled.a(templateObject_1$j || (templateObject_1$j = __makeTemplateObject$1(["\n  display: flex;\n  position: absolute;\n  z-index: 3;\n  cursor: pointer;\n  ", ";\n  ", "\n  ", "\n"], ["\n  display: flex;\n  position: absolute;\n  z-index: 3;\n  cursor: pointer;\n  ", ";\n  ",
    "\n  ",
    "\n"])), space, function (props) {
    return [BANNER_TYPE.MONETIZATION_BANNER, BANNER_TYPE.MONETISAION_TWO].includes(props.bannerType) && "position: relative;";
}, function (props) {
    return props.bannerType === BANNER_TYPE.TWO_IN_ONE &&
        "\n      img, source {\n      height: " + SIZES$1[BANNER_TYPE.TWO_IN_ONE].desktop[1] + "px;\n      }\n    ";
});
var templateObject_1$j;
var AnimationWrapper = customStyled.div(templateObject_1$k || (templateObject_1$k = __makeTemplateObject$1(["\n  overflow: hidden;\n  height: 20px;\n  position: relative;\n  width: 100%;\n  margin-left: 10px;\n"], ["\n  overflow: hidden;\n  height: 20px;\n  position: relative;\n  width: 100%;\n  margin-left: 10px;\n"])));
var SearchForText = customStyled.div(templateObject_2$g || (templateObject_2$g = __makeTemplateObject$1(["\n  color: #747474ff;\n  font-size: 14px;\n  line-height: 20px;\n"], ["\n  color: #747474ff;\n  font-size: 14px;\n  line-height: 20px;\n"])));
var ListContainer = customStyled.div(templateObject_3$e || (templateObject_3$e = __makeTemplateObject$1(["\n  position: absolute;\n  left: ", "px;\n  top: 0;\n"], ["\n  position: absolute;\n  left: ", "px;\n  top: 0;\n"])), function (props) { return (props.language === 'ar' ? 50 : 76); });
var Item$1 = customStyled.div(templateObject_4$b || (templateObject_4$b = __makeTemplateObject$1(["\n  color: #747474ff;\n  font-size: 14px;\n  line-height: 20px;\n"], ["\n  color: #747474ff;\n  font-size: 14px;\n  line-height: 20px;\n"])));
var templateObject_1$k, templateObject_2$g, templateObject_3$e, templateObject_4$b;
var Container$2 = CustomStyled(Box)(templateObject_1$l || (templateObject_1$l = __makeTemplateObject$1(["\n  align-items: center;\n  flex-grow: 1;\n\n  ", ";\n"], ["\n  align-items: center;\n  flex-grow: 1;\n\n  ",
    ";\n"])), function (props) {
    return props.isFullscreen
        ? "\n    position: fixed;\n    top: " + (props.isNonFoodV2Enabled ? '52px' : '0px') + ";\n    left: 0;\n    right: 0;\n    z-index: 1;\n    padding: 0 " + props.theme.space[3] + "px;\n    background-color: " + COLORS.WHITE + ";\n  "
        : '';
});
var templateObject_1$l;
var Container$3 = styled(Box)(templateObject_1$m || (templateObject_1$m = __makeTemplateObject$1(["\n  :last-of-type {\n    border: 0;\n  }\n  padding: 0px 24px;\n"], ["\n  :last-of-type {\n    border: 0;\n  }\n  padding: 0px 24px;\n"])));
Container$3.defaultProps = {
    as: 'li',
    sx: {
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'wildSand',
    },
};
var Link$1 = styled(Flex)(templateObject_2$h || (templateObject_2$h = __makeTemplateObject$1(["\n  align-items: center;\n  justify-content: space-between;\n  text-decoration: none;\n"], ["\n  align-items: center;\n  justify-content: space-between;\n  text-decoration: none;\n"])));
Link$1.defaultProps = {
    as: 'a',
    color: 'thundora',
    fontSize: 1,
    py: 2,
    sx: {
        '&:hover': {
            color: 'blue',
        },
    },
};
var LinkLoyalty = styled(Link$1)(templateObject_3$f || (templateObject_3$f = __makeTemplateObject$1(["\n  position: relative;\n  color: rgb(37, 37, 37);\n"], ["\n  position: relative;\n  color: rgb(37, 37, 37);\n"])));
LinkLoyalty.defaultProps = {
    as: 'a',
    py: 1,
    px: 0,
    sx: {
        '&:hover': {
            color: 'blue',
        },
    },
};
var LoyaltyPoints = styled(Box)(templateObject_4$c || (templateObject_4$c = __makeTemplateObject$1([""], [""])));
LoyaltyPoints.defaultProps = {
    color: 'mineShaft',
    fontSize: 1,
    fontWeight: 4,
    sx: {
        borderRadius: 1,
    },
};
var Caption$1 = styled(Box)(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject$1([""], [""])));
Caption$1.defaultProps = {
    color: 'doveGrey',
    fontSize: 0,
    fontWeight: 4,
    ml: 1,
};
var templateObject_1$m, templateObject_2$h, templateObject_3$f, templateObject_4$c, templateObject_5$9;
var UserButtonWrapper = styled(Box)(templateObject_1$n || (templateObject_1$n = __makeTemplateObject$1(["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  ", "\n"], ["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  ",
    "\n"])), function (props) {
    return props.isDesktopHeader &&
        "\n        margin: 4px 12px;\n        padding: 4px 12px !important;\n        height: 100%;\n        &:hover {\n          background: " + COLORS.BLUE_500 + ";\n          border-radius: 66px;\n        }\n    ";
});
UserButtonWrapper.defaultProps = {
    mb: ['1px', null, null, null, 0],
    position: 'relative',
    padding: [null, null, null, '15px 11px 15px 16px'],
    minWidth: [null, null, null, '160px'],
    mr: [3, null, null, null],
};
var UserButton = styled(Flex)(templateObject_2$i || (templateObject_2$i = __makeTemplateObject$1(["\n  align-items: center;\n  margin: ", ";\n"], ["\n  align-items: center;\n  margin: ", ";\n"])), function (props) { return props.isDesktopHeader && '4px 12px'; });
var Wrapper = styled(Flex)(templateObject_3$g || (templateObject_3$g = __makeTemplateObject$1(["\n  font-style: normal;\n"], ["\n  font-style: normal;\n"])));
Wrapper.defaultProps = {
    mx: 2,
    flexDirection: ['column', null, null, null, 'row'],
};
var Caption$2 = styled(Box)(templateObject_4$d || (templateObject_4$d = __makeTemplateObject$1(["\n  color: ", " !important;\n  margin-bottom: ", " !important;\n"], ["\n  color: ", " !important;\n  margin-bottom: ", " !important;\n"])), function (props) { return (props.isDesktopHeader ? COLORS.WHITE : COLORS.ANCHOR_BLUE); }, function (props) { return (props.isDesktopHeader ? '0' : '4px'); });
Caption$2.defaultProps = {
    as: 'span',
    fontSize: [1, null, null, null, 1],
    fontWeight: [3, null, null, null, 3],
    color: ['copy', null, null, null, COLORS.ANCHOR_BLUE],
    mb: [0, null, null, null, 1],
    mr: [1, null, null, null, 0],
};
var Username = styled(Box)(templateObject_5$a || (templateObject_5$a = __makeTemplateObject$1(["\n  color: ", " !important;\n"], ["\n  color: ", " !important;\n"])), function (props) { return (props.isDesktopHeader ? COLORS.WHITE : COLORS.ANCHOR_BLUE); });
Username.defaultProps = {
    as: 'span',
    fontSize: 1,
    fontWeight: [3, null, null, null, 6],
    color: ['copy', null, null, null, COLORS.ANCHOR_BLUE],
};
var UserButtonLink = styled(Box)(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject$1(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
UserButtonLink.defaultProps = {
    as: 'a',
    color: 'blue',
    fontSize: 1,
    fontWeight: 4,
    mt: 1,
};
var ListItem = styled(Box)(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject$1(["\n  &:last-of-type {\n    border: none;\n  }\n  &:last-of-type a {\n    padding-bottom: 0;\n  }\n"], ["\n  &:last-of-type {\n    border: none;\n  }\n  &:last-of-type a {\n    padding-bottom: 0;\n  }\n"])));
ListItem.defaultProps = {
    as: 'li',
    fontWeight: 500,
    sx: {
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'wildSand',
    },
    py: '12px',
    px: 4,
};
var Link$2 = styled(Box)(templateObject_8$6 || (templateObject_8$6 = __makeTemplateObject$1(["\n  text-decoration: none;\n  display: block;\n"], ["\n  text-decoration: none;\n  display: block;\n"])));
Link$2.defaultProps = {
    py: 1,
    as: 'a',
    color: 'mineShaft',
    fontSize: 2,
    sx: {
        '&:hover': {
            color: 'blue',
        },
    },
};
var BadgeText = styled.div(templateObject_9$6 || (templateObject_9$6 = __makeTemplateObject$1(["\n  font-family: Montserrat;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 12px;\n  text-align: center;\n  color: #ffffff;\n"], ["\n  font-family: Montserrat;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 12px;\n  text-align: center;\n  color: #ffffff;\n"])));
var UserButtonDiv = styled(Box)(templateObject_10$6 || (templateObject_10$6 = __makeTemplateObject$1(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) {
    return props.isDesktopHeader &&
        "\n      margin: 4px 12px;\n      padding: 0px 12px;\n      &:hover {\n        background: " + COLORS.BLUE_500 + ";\n        border-radius: 66px;\n      }\n  ";
});
var templateObject_1$n, templateObject_2$i, templateObject_3$g, templateObject_4$d, templateObject_5$a, templateObject_6$6, templateObject_7$6, templateObject_8$6, templateObject_9$6, templateObject_10$6;
var Badge = styled.span(templateObject_1$o || (templateObject_1$o = __makeTemplateObject$1(["\n  animation: ", ";\n  animation-fill-mode: both;\n  background: ", ";\n  border-radius: 50%;\n  color: ", ";\n  font-size: ", ";\n  height: ", ";\n  line-height: ", ";\n  min-width: ", ";\n  padding-left: 1px;\n  position: absolute;\n  /* @noflip */\n  right: -8px;\n  text-align: center;\n  top: 0;\n\n  @keyframes popup {\n    0% {\n      opacity: 0.6;\n      transform: scale3d(0.3, 0.3, 0.3);\n      box-shadow: 0 0 0 0 rgba(243, 64, 65, 0.1);\n    }\n    30% {\n      transform: scale3d(1.1, 1.1, 1.1);\n    }\n    55% {\n      transform: scale3d(0.9, 0.9, 0.9);\n    }\n    90% {\n      opacity: 1;\n      transform: scale3d(1.04, 1.04, 1.04);\n      box-shadow: 0 0 0 10px rgba(243, 64, 65, 0.1);\n    }\n    100% {\n      opacity: 1;\n      transform: scaleX(1);\n      box-shadow: 0 0 0 0 rgba(243, 64, 65, 0.1);\n    }\n  }\n"], ["\n  animation: ", ";\n  animation-fill-mode: both;\n  background: ", ";\n  border-radius: 50%;\n  color: ", ";\n  font-size: ", ";\n  height: ", ";\n  line-height: ", ";\n  min-width: ", ";\n  padding-left: 1px;\n  position: absolute;\n  /* @noflip */\n  right: -8px;\n  text-align: center;\n  top: 0;\n\n  @keyframes popup {\n    0% {\n      opacity: 0.6;\n      transform: scale3d(0.3, 0.3, 0.3);\n      box-shadow: 0 0 0 0 rgba(243, 64, 65, 0.1);\n    }\n    30% {\n      transform: scale3d(1.1, 1.1, 1.1);\n    }\n    55% {\n      transform: scale3d(0.9, 0.9, 0.9);\n    }\n    90% {\n      opacity: 1;\n      transform: scale3d(1.04, 1.04, 1.04);\n      box-shadow: 0 0 0 10px rgba(243, 64, 65, 0.1);\n    }\n    100% {\n      opacity: 1;\n      transform: scaleX(1);\n      box-shadow: 0 0 0 0 rgba(243, 64, 65, 0.1);\n    }\n  }\n"])), function (props) { return (props.isPopUp ? 'popup 0.5s' : 'none'); }, COLORS.RED, COLORS.WHITE, TYPOGRAPHY.SIZE[10], SIZES.BADGE_SIZE, SIZES.BADGE_SIZE, SIZES.BADGE_SIZE);
var templateObject_1$o;
var Container$4 = CustomStyled(Box)(templateObject_1$p || (templateObject_1$p = __makeTemplateObject$1(["\n  flex-shrink: 0;\n  position: relative;\n  margin-left: 16px;\n"], ["\n  flex-shrink: 0;\n  position: relative;\n  margin-left: 16px;\n"])));
Container$4.defaultProps = {
    as: 'nav',
};
var templateObject_1$p;
var HeaderStatic = memo(function (_a) {
    var _b = _a.isMenuNav, isMenuNav = _b === void 0 ? true : _b, _c = _a.isSearchBox, isSearchBox = _c === void 0 ? true : _c;
    var _d = __read$1(useAppConfig(), 4), requestStatus = _d[3];
    return (React.createElement(React.Fragment, null,
        React.createElement(Header$1, { as: "aside" }),
        isSearchBox && React.createElement(Search, { as: "aside" }),
        isMenuNav && !requestStatus.failed && React.createElement(Nav, { as: "aside" })));
});
var MainPane = customStyled(Box)(templateObject_1$q || (templateObject_1$q = __makeTemplateObject$1(["\n  transition: 0.1s all;\n  @media (min-width: ", ") {\n    min-height: 72px;\n  }\n  @media (max-width: ", ") {\n    ", "\n    position: relative;\n    z-index: -1;\n  }\n  @media (min-width: ", ") {\n    background: ", ";\n  }\n"], ["\n  transition: 0.1s all;\n  @media (min-width: ", ") {\n    min-height: 72px;\n  }\n  @media (max-width: ", ") {\n    ", "\n    position: relative;\n    z-index: -1;\n  }\n  @media (min-width: ", ") {\n    background: ", ";\n  }\n"])), function (props) { return props.theme.breakpoints[3]; }, function (props) { return props.theme.breakpoints[0]; }, function (_a) {
    var isHideNav = _a.isHideNav;
    return isHideNav && "transform: translate(0, -53px);";
}, function (props) { return props.theme.breakpoints[1]; }, function (_a) {
    var isNonFoodV2Enabled = _a.isNonFoodV2Enabled;
    return isNonFoodV2Enabled && COLORS.BLUE;
});
MainPane.defaultProps = {
    bg: COLORS.WHITE,
    py: 2,
    px: 3,
};
var DealsMenuContainer = customStyled(Flex)(templateObject_2$j || (templateObject_2$j = __makeTemplateObject$1(["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), function (props) { return props.theme.breakpoints[3]; });
DealsMenuContainer.defaultProps = {
    ml: 10,
};
var DealsMenuSkeltonBox = customStyled(Flex)(templateObject_3$h || (templateObject_3$h = __makeTemplateObject$1(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
var DealsMenuSkeleton = customStyled(Box)(templateObject_4$e || (templateObject_4$e = __makeTemplateObject$1(["\n  background-image: linear-gradient(90deg, #0a437c, #0c4e91, #0a437c);\n"], ["\n  background-image: linear-gradient(90deg, #0a437c, #0c4e91, #0a437c);\n"])));
DealsMenuSkeleton.defaultProps = {
    variant: 'skeletonSquare',
    bg: '#0A437C',
};
var templateObject_1$q, templateObject_2$j, templateObject_3$h, templateObject_4$e;
var PolicyAccept;
(function (PolicyAccept) {
    PolicyAccept["YES"] = "y";
    PolicyAccept["NO"] = "n";
})(PolicyAccept || (PolicyAccept = {}));
function SingleOTPInputComponent(props) {
    var focus = props.focus, autoFocus = props.autoFocus, rest = __rest$1(props, ["focus", "autoFocus"]);
    var inputRef = useRef(null);
    var prevFocus = usePrevious(!!focus);
    useLayoutEffect(function () {
        if (inputRef.current) {
            if (focus && autoFocus) {
                inputRef.current.focus();
            }
            if (focus && autoFocus && focus !== prevFocus) {
                inputRef.current.focus();
                inputRef.current.select();
            }
        }
    }, [autoFocus, focus, prevFocus]);
    return React.createElement("input", __assign$1({ ref: inputRef }, rest, { style: { height: '100%', width: '100%', textAlign: 'center' } }));
}
var SingleOTPInput = memo(SingleOTPInputComponent);
var OTPInputContainer = styled(Box)(templateObject_1$r || (templateObject_1$r = __makeTemplateObject$1(["\n  margin: 5% auto;\n"], ["\n  margin: 5% auto;\n"])));
var OTPInputStyle = styled(Box)(templateObject_2$k || (templateObject_2$k = __makeTemplateObject$1(["\n  width: ", ";\n  height: 3.5rem;\n  margin-right: 1rem;\n  font-size: 1.5rem;\n  text-align: center !important;\n  border-radius: 4px;\n  justify-content: middle;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n"], ["\n  width: ", ";\n  height: 3.5rem;\n  margin-right: 1rem;\n  font-size: 1.5rem;\n  text-align: center !important;\n  border-radius: 4px;\n  justify-content: middle;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n"])), function (props) { return (props.length === 4 ? '6rem !important' : '4rem !important'); });
var templateObject_1$r, templateObject_2$k;
function OTPInputComponent(props) {
    var length = props.length, isNumberInput = props.isNumberInput, autoFocus = props.autoFocus, disabled = props.disabled, onChangeOTP = props.onChangeOTP, inputClassName = props.inputClassName, inputStyle = props.inputStyle, isResetInput = props.isResetInput, resetInput = props.resetInput, rest = __rest$1(props, ["length", "isNumberInput", "autoFocus", "disabled", "onChangeOTP", "inputClassName", "inputStyle", "isResetInput", "resetInput"]);
    var _a = __read$1(useState(0), 2), activeInput = _a[0], setActiveInput = _a[1];
    var _b = __read$1(useState(Array(length).fill('')), 2), otpValues = _b[0], setOTPValues = _b[1];
    var handleOtpChange = useCallback(function (otp) {
        var otpValue = otp.join('');
        onChangeOTP(otpValue);
    }, [onChangeOTP]);
    useEffect(function () {
        if (isResetInput) {
            setOTPValues(Array(length).fill(''));
            resetInput();
        }
    }, [isResetInput, resetInput, length]);
    var getRightValue = useCallback(function (str) {
        var changedValue = str;
        if (!isNumberInput) {
            return changedValue;
        }
        return !changedValue || /\d/.test(changedValue) ? changedValue : '';
    }, [isNumberInput]);
    var changeCodeAtFocus = useCallback(function (str) {
        var updatedOTPValues = __spread$1(otpValues);
        updatedOTPValues[activeInput] = str[0] || '';
        setOTPValues(updatedOTPValues);
        handleOtpChange(updatedOTPValues);
    }, [activeInput, handleOtpChange, otpValues]);
    var focusInput = useCallback(function (inputIndex) {
        var selectedIndex = Math.max(Math.min(length - 1, inputIndex), 0);
        setActiveInput(selectedIndex);
    }, [length]);
    var focusPrevInput = useCallback(function () {
        focusInput(activeInput - 1);
    }, [activeInput, focusInput]);
    var focusNextInput = useCallback(function () {
        focusInput(activeInput + 1);
    }, [activeInput, focusInput]);
    var handleOnFocus = useCallback(function (index) { return function () {
        focusInput(index);
    }; }, [focusInput]);
    var handleOnChange = useCallback(function (e) {
        var val = getRightValue(e.currentTarget.value);
        if (!val) {
            e.preventDefault();
            return;
        }
        changeCodeAtFocus(val);
        focusNextInput();
    }, [changeCodeAtFocus, focusNextInput, getRightValue]);
    var onBlur = useCallback(function () {
        setActiveInput(-1);
    }, []);
    var handleOnKeyDown = useCallback(function (e) {
        switch (e.key) {
            case 'Backspace':
            case 'Delete': {
                e.preventDefault();
                if (otpValues[activeInput]) {
                    changeCodeAtFocus('');
                }
                else {
                    focusPrevInput();
                }
                break;
            }
            case 'ArrowLeft': {
                e.preventDefault();
                focusPrevInput();
                break;
            }
            case 'ArrowRight': {
                e.preventDefault();
                focusNextInput();
                break;
            }
            case ' ': {
                e.preventDefault();
                break;
            }
        }
    }, [activeInput, changeCodeAtFocus, focusNextInput, focusPrevInput, otpValues]);
    var handleOnPaste = useCallback(function (e) {
        e.preventDefault();
        var pastedData = e.clipboardData
            .getData('text/plain')
            .trim()
            .slice(0, length - activeInput)
            .split('');
        if (pastedData) {
            var nextFocusIndex_1 = 0;
            var updatedOTPValues_1 = __spread$1(otpValues);
            updatedOTPValues_1.forEach(function (val, index) {
                if (index >= activeInput) {
                    var changedValue = getRightValue(pastedData.shift() || val);
                    if (changedValue) {
                        updatedOTPValues_1[index] = changedValue;
                        nextFocusIndex_1 = index;
                    }
                }
            });
            setOTPValues(updatedOTPValues_1);
            setActiveInput(Math.min(nextFocusIndex_1 + 1, length - 1));
        }
    }, [activeInput, getRightValue, length, otpValues]);
    return (React.createElement("div", __assign$1({}, rest),
        React.createElement(OTPInputContainer, null,
            React.createElement(Flex, { spacing: 10 }, Array(length)
                .fill('')
                .map(function (_, index) { return (React.createElement(Box, { width: 1 / 4, key: "SingleInputBox-" + index },
                React.createElement(OTPInputStyle, null,
                    React.createElement(SingleOTPInput, { key: "SingleInput-" + index, focus: activeInput === index, value: otpValues && otpValues[index], autoFocus: autoFocus, onFocus: handleOnFocus(index), onChange: handleOnChange, onKeyDown: handleOnKeyDown, onBlur: onBlur, onPaste: handleOnPaste, style: inputStyle, className: inputClassName, disabled: disabled, placeholder: "-" })))); })))));
}
var OTPInput = memo(OTPInputComponent);
var ErrorMessage = customStyled(Box)(templateObject_1$s || (templateObject_1$s = __makeTemplateObject$1(["\n  color: ", ";\n  background-color:", ";\n  padding:20px;\n  text-align:center;\n  margin-bottom: 20px;\n  margin: 0px 10px;\n"], ["\n  color: ", ";\n  background-color:", ";\n  padding:20px;\n  text-align:center;\n  margin-bottom: 20px;\n  margin: 0px 10px;\n"])), COLORS.LIGHT_RED, COLORS.LIGHT_RED);
var ErrorText = customStyled.span(templateObject_2$l || (templateObject_2$l = __makeTemplateObject$1(["\n  margin-left:20px;\n"], ["\n  margin-left:20px;\n"])));
var CountrySvgContainer = customStyled(Flex)(templateObject_3$i || (templateObject_3$i = __makeTemplateObject$1(["\n  min-width: 15px;\n  max-width: 15px;  \n  align-self: flex-end;\n"], ["\n  min-width: 15px;\n  max-width: 15px;  \n  align-self: flex-end;\n"])));
var OtpHeading = customStyled(Box)(templateObject_4$f || (templateObject_4$f = __makeTemplateObject$1(["\n  font-size: ", ";\n"], ["\n  font-size: ", ";\n"])), SPACINGS[24]);
var templateObject_1$s, templateObject_2$l, templateObject_3$i, templateObject_4$f;
var EditPhoneNumber = function (props) {
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var isOpen = props.isOpen, onSuccess = props.onSuccess, onClose = props.onClose;
    var _a = __read$1(useState(''), 1), updateError = _a[0];
    var _b = useForm({
        mode: 'onSubmit',
    }), register = _b.register, errors = _b.errors, setError = _b.setError, clearErrors = _b.clearErrors, getValues = _b.getValues, handleSubmit = _b.handleSubmit;
    var _c = useSelector(function (state) {
        return __assign$1({ userData: state.userData }, state.appConfig);
    }), _d = _c.phoneExpression, phoneExpression = _d === void 0 ? '' : _d, _e = _c.phoneCountryCode, phoneCountryCode = _e === void 0 ? '' : _e, _f = _c.countryName, countryName = _f === void 0 ? '' : _f, userData = _c.userData;
    var handleVerifyPhone = function (apiResponse) {
        var _a;
        if ((_a = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.meta) === null || _a === void 0 ? void 0 : _a.errorCode) {
            setError('phone', {
                type: 'phone_exist',
                message: t('verifyOTP.CustomerPhoneConflictError'),
            });
        }
        else {
            clearErrors('phone');
            onSuccess(phoneCountryCode + getValues('phone').replace(/^0/, ''));
        }
    };
    var onFormSubmit = function (formData) { return __awaiter$1(void 0, void 0, void 0, function () {
        return __generator$1(this, function (_a) {
            updateUserContact(formData.phone.replace(/^0/, ''), handleVerifyPhone)(dispatch);
            return [2 ];
        });
    }); };
    var getIcon = function (countryName) {
        switch (countryName) {
            case 'UAE':
                return React.createElement(UAEFlag, { size: "L" });
            case 'Bahrain':
                return React.createElement(BahrainFlag, { size: "L" });
            case 'Egypt':
                return React.createElement(EgyptFlag, { size: "L" });
            case 'Jordan':
                return React.createElement(JordanFlag, { size: "L" });
            case 'Kuwait':
                return React.createElement(KuwaitFlag, { size: "L" });
            case 'Lebanon':
                return React.createElement(LebanonFlag, { size: "L" });
            case 'Oman':
                return React.createElement(OmanFlag, { size: "L" });
            case 'Pakistan':
                return React.createElement(PakistanFlag, { size: "L" });
            case 'Qatar':
                return React.createElement(QatarFlag, { size: "L" });
            case 'KSA':
                return React.createElement(KSAFlag, { size: "L" });
            case 'Kenya':
                return React.createElement(KenyaFlag, { size: "L" });
            case 'Georgia':
                return React.createElement(GeorgiaFlag, { size: "L" });
            default:
                return countryName;
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { "data-test-id": "edit_profile_phone_number_modal", isOpen: isOpen, title: '   ', onClose: onClose, width: [1, null, null, '428px'], marginBottom: "0", titleStyles: { fontWeight: 'bold' }, p: "24px 0", headerStyles: { paddingX: '24px' } },
            updateError && (React.createElement(ErrorMessage, null,
                React.createElement(Warning, { fill: COLORS.LIGHT_RED }),
                React.createElement(ErrorText, null, updateError))),
            React.createElement(Box, { pl: '80px', pr: '80px' },
                React.createElement(Text.H1, { mt: 2, textAlign: "center" }, t('verifyOTP.changeNumber')),
                React.createElement(Flex, { flexDirection: "column", flex: 1, mt: 16, as: "form", onSubmit: handleSubmit(onFormSubmit), "data-testid": "__phone_number_edit__" },
                    React.createElement(Flex, { justifyContent: "space-between", mt: 20 },
                        React.createElement(Flex, { width: "25%" },
                            React.createElement(CountrySvgContainer, { pt: 2 }, countryName && getIcon(countryName)),
                            React.createElement(Box, null,
                                React.createElement(Input, { testid: "country-code-field", defaultValue: phoneCountryCode, disabled: true, backgroundColor: COLORS.LIGHT_GREY }))),
                        React.createElement(Box, { width: "75%" },
                            React.createElement(Input, { testid: 'phone-number-field', label: t('address.mobileNumber'), name: "phone", successIcon: true, allowedRegExpChars: "alphanumericCommaPeriod", backgroundColor: COLORS.LIGHT_GREY, register: register({
                                    required: t('address.requiredField'),
                                    pattern: {
                                        value: new RegExp(phoneExpression),
                                        message: t('address.invalidPhone'),
                                    },
                                }) }))),
                    errors.phone && (React.createElement(Text.Paragraph, { color: COLORS.RED, mt: 1, fontSize: TYPOGRAPHY.SIZE[14] }, errors.phone.message)),
                    React.createElement(Flex, { mt: 30 },
                        React.createElement(Button$1, { flex: 1, type: "submit", testid: "phone-submit-button" },
                            t('verifyOTP.saveAndVerify'),
                            userData.isProfileUpdating && React.createElement(LinearProgress, { withBlock: true }))))))));
};
EditPhoneNumber.defaultProps = {};
var EditPhoneNumber$1 = React.memo(EditPhoneNumber);
var setOTPSuccess = function (otpResponse) { return ({
    type: VerifyOTPTypes$1.SEND_OTP_SUCCESS,
    payload: { otpResponse: otpResponse },
}); };
var setOTPLoading = function (state) { return ({
    type: VerifyOTPTypes$1.SEND_OTP_LOADING,
    payload: state,
}); };
var setOTPError = function (message) { return ({
    type: VerifyOTPTypes$1.SEND_OTP_ERROR,
    payload: message,
}); };
var setOTPVerificationSuccess = function (otpVerificationResponse) { return ({
    type: VerifyOTPTypes$1.OTP_VERIFICATION_SUCCESS,
    payload: { otpVerificationResponse: otpVerificationResponse },
}); };
var setOTPVerificationLoading = function (state) { return ({
    type: VerifyOTPTypes$1.OTP_VERIFICATION_LOADING,
    payload: state,
}); };
var setOTPVerificationError = function (message) { return ({
    type: VerifyOTPTypes$1.OTP_VERIFICATION_ERROR,
    payload: message,
}); };
var sendOTP = function (otpPayload) { return function (dispatch) {
    dispatch(setOTPLoading(true));
    dispatch(setOTPError(''));
    dispatch(setOTPVerificationError(''));
    dispatch(setOTPVerificationSuccess(null));
    dispatch({
        type: VerifyOTPTypes$1.SEND_OTP,
        payload: {
            data: otpPayload,
            headers: {
                'Content-Type': 'application/json',
            },
            method: EApiMiddlewareMethod$1.POST,
            onSuccess: function (apiResponse) {
                if (apiResponse.result) {
                    setOTPSuccess && dispatch(setOTPSuccess(apiResponse.data));
                }
                else {
                    dispatch(setOTPError(i18next.t('errorGeneral')));
                }
            },
            onFailure: function (_errMessage, _a) {
                var data = (_a === void 0 ? {} : _a).response.data;
                var errorCode = data.meta.errorCode;
                var errorMessage = i18next.t("verifyOTP." + errorCode).includes('verifyOTP.')
                    ? i18next.t('errorGeneral')
                    : i18next.t("verifyOTP." + errorCode);
                dispatch(setOTPError(errorMessage));
            },
            onFinally: function () {
                dispatch(setOTPLoading(false));
            },
            url: otpPayload.mode === 'otp' ? SEND_OTP_API : SEND_PHONE_CALL_OTP_API,
        },
    });
}; };
var verifyOTP = function (verifyOTPPayload, onGTMEventCall) {
    if (onGTMEventCall === void 0) { onGTMEventCall = null; }
    return function (dispatch) {
        dispatch(setOTPVerificationLoading(true));
        dispatch(setOTPVerificationError(''));
        dispatch({
            type: VerifyOTPTypes$1.OTP_VERIFICATION,
            payload: {
                isAbsUrl: true,
                data: {
                    code: verifyOTPPayload.code,
                },
                headers: {
                    'Content-Type': 'application/json',
                },
                method: EApiMiddlewareMethod$1.POST,
                onSuccess: function (apiResponse) {
                    var _a;
                    if (apiResponse.result) {
                        setOTPVerificationSuccess && dispatch(setOTPVerificationSuccess(apiResponse.data));
                    }
                    else {
                        dispatch(setOTPVerificationError(i18next.t(('verifyOTP.' + ((_a = apiResponse.error) === null || _a === void 0 ? void 0 : _a.code)))));
                    }
                },
                onFailure: function (_errMessage, _a) {
                    var data = (_a === void 0 ? {} : _a).response.data;
                    var _b = data.meta, errorCode = (_b === void 0 ? { errorCode: '' } : _b).errorCode;
                    dispatch(setOTPVerificationError(i18next.t("verifyOTP." + errorCode)));
                    onGTMEventCall && onGTMEventCall('error', errorCode);
                },
                onFinally: function () {
                    dispatch(setOTPVerificationLoading(false));
                },
                url: OTP_VERIFICATION_API + "/" + verifyOTPPayload.uuid,
            },
        });
    };
};
var useVerifyOTP = function () {
    var _a = useSelector(function (state) {
        return {
            otpVeritification: state.verifyOTP,
            appConfig: state.appConfig,
        };
    }), otpVeritification = _a.otpVeritification, appConfig = _a.appConfig;
    var sendOTPState = otpVeritification.sendOTP, verifyOTPState = otpVeritification.verifyOTP;
    var language = appConfig.language;
    var dispatch = useDispatch();
    var onSendOTP = useCallback(function (action, email, mode, uuid, phoneNumber) {
        if (phoneNumber === void 0) { phoneNumber = ''; }
        var bodyPayload = {
            mode: mode,
            action: action,
            email: email,
        };
        if (phoneNumber) {
            bodyPayload.phoneNumber = phoneNumber;
        }
        if (mode === 'voice') {
            bodyPayload.uuid = uuid || '';
            bodyPayload.locale = language;
        }
        sendOTP(bodyPayload)(dispatch);
    }, [dispatch, language]);
    var onVerifyOTP = useCallback(function (code, uuid, onGTMEventCall) {
        if (onGTMEventCall === void 0) { onGTMEventCall = null; }
        return __awaiter$1(void 0, void 0, void 0, function () {
            var payload;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = { code: code, uuid: uuid };
                        return [4 , verifyOTP(payload, onGTMEventCall)(dispatch)];
                    case 1:
                        _a.sent();
                        return [2 ];
                }
            });
        });
    }, [dispatch]);
    return {
        otpData: sendOTPState.otpData,
        verificationData: verifyOTPState.verificationData,
        resendCodeLoading: sendOTPState.isLoading,
        loading: verifyOTPState.isLoading,
        serverError: sendOTPState.error || verifyOTPState.error,
        verifyOTPError: verifyOTPState.error,
        onSendOTP: onSendOTP,
        onVerifyOTP: onVerifyOTP,
    };
};
var InputWrapper = customStyled.div(templateObject_1$t || (templateObject_1$t = __makeTemplateObject$1(["\n  margin: 16px 0;\n"], ["\n  margin: 16px 0;\n"])));
var WarningMessage = customStyled(Box)(templateObject_2$m || (templateObject_2$m = __makeTemplateObject$1(["\n  color:", ";\n  margin-top:10px;\n"], ["\n  color:", ";\n  margin-top:10px;\n"])), function (props) { return props.theme.colors.red; });
var ErrorMessage$1 = customStyled(Box)(templateObject_3$j || (templateObject_3$j = __makeTemplateObject$1(["\n  color: #f34041;\n  background-color:rgba(243,64,65,.05);\n  padding:20px;\n  text-align:center;\n  margin-bottom: 20px;\n"], ["\n  color: #f34041;\n  background-color:rgba(243,64,65,.05);\n  padding:20px;\n  text-align:center;\n  margin-bottom: 20px;\n"])));
var ErrorText$1 = customStyled.span(templateObject_4$g || (templateObject_4$g = __makeTemplateObject$1(["\n  margin-left:20px;\n"], ["\n  margin-left:20px;\n"])));
var LinkText$1 = customStyled(Box)(templateObject_5$b || (templateObject_5$b = __makeTemplateObject$1(["\n  cursor: pointer;\n  color: #7d0f34;\n  font-weight:bold;\n"], ["\n  cursor: pointer;\n  color: #7d0f34;\n  font-weight:bold;\n"])));
var InputContainerPadding = customStyled(Box)(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject$1(["\n  padding: 5px;\n"], ["\n  padding: 5px;\n"])));
var HRText = customStyled(Box)(templateObject_7$7 || (templateObject_7$7 = __makeTemplateObject$1(["\n  width: 100%; \n  text-align: center; \n  border-bottom: 1px solid #000;\n  opacity:0.5;\n  line-height: 0.1em;\n  margin: 20px 0px;\n  & > span {\n    background:#fff; \n    padding:0 10px; \n  }\n"], ["\n  width: 100%; \n  text-align: center; \n  border-bottom: 1px solid #000;\n  opacity:0.5;\n  line-height: 0.1em;\n  margin: 20px 0px;\n  & > span {\n    background:#fff; \n    padding:0 10px; \n  }\n"])));
var LoaderSpan = customStyled(Box)(templateObject_8$7 || (templateObject_8$7 = __makeTemplateObject$1(["\n  display: inline-flex;\n  position: relative;\n  width: 100%;\n  margin:", ";\n"], ["\n  display: inline-flex;\n  position: relative;\n  width: 100%;\n  margin:", ";\n"])), function (props) { return (props.m ? props.m + 'px 0px' : '0px'); });
var AlignCenter = customStyled(Box)(templateObject_9$7 || (templateObject_9$7 = __makeTemplateObject$1(["\n  text-align:center;\n"], ["\n  text-align:center;\n"])));
var HighLightPhone = customStyled(Box)(templateObject_10$7 || (templateObject_10$7 = __makeTemplateObject$1(["\n  color:#0e5aa7;\n  font-weight:bold;\n  display: inline;\n"], ["\n  color:#0e5aa7;\n  font-weight:bold;\n  display: inline;\n"])));
var Timer = customStyled(Box)(templateObject_11$5 || (templateObject_11$5 = __makeTemplateObject$1(["\n  margin: 20px 0px;\n"], ["\n  margin: 20px 0px;\n"])));
var Heading = customStyled(Box)(templateObject_12$4 || (templateObject_12$4 = __makeTemplateObject$1(["\n  margin: 20px 0px;\n"], ["\n  margin: 20px 0px;\n"])));
var PageTitle = customStyled(Text.H1)(templateObject_13$4 || (templateObject_13$4 = __makeTemplateObject$1(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
var OTPSentSuccess = customStyled(Box)(templateObject_14$4 || (templateObject_14$4 = __makeTemplateObject$1(["\n  width: 170px;\n  height: 21px;\n  margin-top:-10px;\n  font-size: 14px;\n  color: #267949;\n"], ["\n  width: 170px;\n  height: 21px;\n  margin-top:-10px;\n  font-size: 14px;\n  color: #267949;\n"])));
var CopyrightMaxLayout = customStyled(Flex)(templateObject_15$4 || (templateObject_15$4 = __makeTemplateObject$1(["\n  align-items: center;\n  margin: 0 auto;\n  max-width: ", "px;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin-top:35px;\n"], ["\n  align-items: center;\n  margin: 0 auto;\n  max-width: ", "px;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin-top:35px;\n"])), function (props) { return props.theme.maxLayoutWidth; });
var Logo$2 = customStyled.a(templateObject_16$3 || (templateObject_16$3 = __makeTemplateObject$1(["\n  svg {\n    display: block; {/* Remove space around the element */}\n  }\n  color: '#000000'\n"], ["\n  svg {\n    display: block; {/* Remove space around the element */}\n  }\n  color: '#000000'\n"])));
var PhoneWrapper = customStyled.span(templateObject_17$3 || (templateObject_17$3 = __makeTemplateObject$1(["\n  svg {\n    vertical-align: middle;\n  }\n  margin-right:10px;\n"], ["\n  svg {\n    vertical-align: middle;\n  }\n  margin-right:10px;\n"])));
var VerificationCodeSent = customStyled(Text)(templateObject_18$3 || (templateObject_18$3 = __makeTemplateObject$1(["\n  font-size: 14px;\n  color: ", ";\n  span {\n    font-weight:bold;\n    margin-right: 5px;\n  }\n"], ["\n  font-size: 14px;\n  color: ", ";\n  span {\n    font-weight:bold;\n    margin-right: 5px;\n  }\n"])), COLORS.DARK_GREY);
var VerifyPhoneText = customStyled(Text.H3)(templateObject_19$3 || (templateObject_19$3 = __makeTemplateObject$1(["\n  font-size: 16px;\n  margin-top: 8px;\n  font-weight: bold;\n"], ["\n  font-size: 16px;\n  margin-top: 8px;\n  font-weight: bold;\n"])));
var BroughtYouByWrapper = customStyled(Flex)(templateObject_20$2 || (templateObject_20$2 = __makeTemplateObject$1(["\n  justify-content:center;\n  margin-top:16px;\n  text-align:center;\n"], ["\n  justify-content:center;\n  margin-top:16px;\n  text-align:center;\n"])));
var BroughtToYouBuyStyle = customStyled.span(templateObject_21$2 || (templateObject_21$2 = __makeTemplateObject$1(["\n  font-size: 9px;\n  font-family: MarselisPro, \"Marselis Pro\";\n  transform: translate(0, 24.46);\n"], ["\n  font-size: 9px;\n  font-family: MarselisPro, \"Marselis Pro\";\n  transform: translate(0, 24.46);\n"])));
var BroughtToYouBuyBox = customStyled(Box)(templateObject_22$2 || (templateObject_22$2 = __makeTemplateObject$1(["\n  text-align:center;\n  width:100%;\n  margin: '0px 0px -10px -35px'};\n  font-weight:bold;\n"], ["\n  text-align:center;\n  width:100%;\n  margin: '0px 0px -10px -35px'};\n  font-weight:bold;\n"])));
var MafLogoBox = customStyled(Box)(templateObject_23$1 || (templateObject_23$1 = __makeTemplateObject$1(["\n  text-align:center;\n  width:100%;\n"], ["\n  text-align:center;\n  width:100%;\n"])));
var templateObject_1$t, templateObject_2$m, templateObject_3$j, templateObject_4$g, templateObject_5$b, templateObject_6$7, templateObject_7$7, templateObject_8$7, templateObject_9$7, templateObject_10$7, templateObject_11$5, templateObject_12$4, templateObject_13$4, templateObject_14$4, templateObject_15$4, templateObject_16$3, templateObject_17$3, templateObject_18$3, templateObject_19$3, templateObject_20$2, templateObject_21$2, templateObject_22$2, templateObject_23$1;
var WhatsAppButton = styled(Button$1)(templateObject_1$u || (templateObject_1$u = __makeTemplateObject$1(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), COLORS.SLIMY_GREEN);
var OtpButton = styled(Button$1)(templateObject_2$n || (templateObject_2$n = __makeTemplateObject$1(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), COLORS.BLUE);
var templateObject_1$u, templateObject_2$n;
var setWhatsAppOTPSuccess = function (otpVerificationResponse) { return ({
    type: VerifyWhatsAppTypes$1.WHATSAPP_OTP_SUCCESS,
    payload: { otpVerificationResponse: otpVerificationResponse },
}); };
var setWhatsAppOTPLoading = function (state) { return ({
    type: VerifyWhatsAppTypes$1.WHATSAPP_OTP_LOADING,
    payload: state,
}); };
var setWhatsAppOTPError = function (message) { return ({
    type: VerifyWhatsAppTypes$1.WHATSAPP_OTP_ERROR,
    payload: message,
}); };
var getWhatAppOTP = function (verifyWhatsAppRequestPayload, onGTMEventCall) {
    if (onGTMEventCall === void 0) { onGTMEventCall = null; }
    return function (dispatch) {
        dispatch(setWhatsAppOTPLoading(true));
        dispatch(setWhatsAppOTPError(''));
        dispatch(setWhatsAppOTPSuccess(null));
        dispatch({
            type: VerifyWhatsAppTypes$1.WHATSAPP_OTP_VERIFICATION,
            payload: {
                data: verifyWhatsAppRequestPayload,
                headers: {
                    'Content-Type': 'application/json',
                },
                method: EApiMiddlewareMethod$1.POST,
                onSuccess: function (apiResponse) {
                    var _a;
                    if (apiResponse.result) {
                        setWhatsAppOTPSuccess && dispatch(setWhatsAppOTPSuccess(apiResponse.data));
                    }
                    else {
                        dispatch(setWhatsAppOTPError(i18next.t(('verifyOTP.' + ((_a = apiResponse.error) === null || _a === void 0 ? void 0 : _a.code)))));
                    }
                },
                onFailure: function (_errMessage, _a) {
                    var data = (_a === void 0 ? {} : _a).response.data;
                    var _b = data.error, code = (_b === void 0 ? { code: '' } : _b).code;
                    dispatch(setWhatsAppOTPError(i18next.t('verifyOTP.' + code)));
                    onGTMEventCall && onGTMEventCall('error', code);
                },
                onFinally: function () {
                    dispatch(setWhatsAppOTPLoading(false));
                },
                url: GET_WHATSAPP_OTP_API_URL,
                apiVersion: 2,
            },
        });
    };
};
var OTP_ENUM;
(function (OTP_ENUM) {
    OTP_ENUM["OTP"] = "otp";
})(OTP_ENUM || (OTP_ENUM = {}));
var RequestByWhatsAppOtp = function (props) {
    var t = useTranslation().t;
    var _a = useAnalytic(), GTMEventCall = _a.GTMEventCall, getGTMPageData = _a.getGTMPageData;
    var onShowOtp = props.onShowOtp, phoneNumber = props.phoneNumber, isResendCodeEnable = props.isResendCodeEnable, action = props.action;
    var _b = useSelector(function (state) { return state.verifyWhatsAppOTP; }), isWhatAppOtpLoading = _b.isWhatAppOtpLoading, whatsAppOtpSuccess = _b.whatsAppOtpSuccess;
    var dispatch = useDispatch();
    var getWhatsOtp = function () {
        GTMEventCall(GTMEvents.custom_event, {
            eventAction: GTMEventActions.registration,
            eventLabel: 'request_otp_via_whatsapp',
            pageData: getGTMPageData({ getData: true }) || {},
            ga4: true,
        });
        var email = props.email, locale = props.language;
        dispatch(getWhatAppOTP({
            phoneNumber: phoneNumber,
            email: email,
            mode: OTP_ENUM.OTP,
            locale: locale,
            action: action,
        }));
    };
    useEffect(function () {
        var _a;
        if ((_a = whatsAppOtpSuccess === null || whatsAppOtpSuccess === void 0 ? void 0 : whatsAppOtpSuccess.otpVerificationResponse) === null || _a === void 0 ? void 0 : _a.uuid) {
            onShowOtp('whatsapp');
        }
    }, [whatsAppOtpSuccess, onShowOtp]);
    return (React.createElement(WhatsAppButton, { disabled: !isResendCodeEnable || isWhatAppOtpLoading, width: "100%", mt: 2, mb: 2, onClick: function () { return getWhatsOtp(); } },
        React.createElement(Flex, { flexDirection: "row", alignItems: "space", justifyContent: "center" },
            React.createElement(Box, null,
                React.createElement(WhatsApp, { size: 'M', fill: !isResendCodeEnable || isWhatAppOtpLoading ? COLORS.WHITE_GREEN : COLORS.WHITE })),
            React.createElement(Box, { alignSelf: "center", ml: 1 }, t('whatsAppOTP.REQUESTOTPByWhatsapp')))));
};
var VerifyWhatsApp = function (props) {
    var t = useTranslation().t;
    var onShowOtp = props.onShowOtp, phoneNumber = props.phoneNumber, email = props.email, language = props.language, action = props.action;
    var whatsAppOtpError = useSelector(function (state) { return state.verifyWhatsAppOTP; }).whatsAppOtpError;
    return (React.createElement(Box, { textAlign: "center" },
        whatsAppOtpError && (React.createElement(ErrorMessage, null,
            React.createElement(Warning, { fill: "#f34041" }),
            React.createElement(ErrorText, null, whatsAppOtpError))),
        React.createElement(OtpHeading, { mt: 3, mb: 5, as: "h2" }, t('whatsAppOTP.PleaseVerifyYourMobileNumber')),
        React.createElement(Box, { mb: 1 }, t('whatsAppOTP.WeWillSendA4DigitCodeTo')),
        React.createElement(Box, { fontWeight: "bold", mb: 1 }, transformPhoneNo(phoneNumber, language)),
        React.createElement(Box, { mb: 4 }, t('whatsAppOTP.PleaseSelectOneOfTheMethodsToVerifyYourAccount')),
        React.createElement(Flex, { flexDirection: "column", alignItems: "center" },
            React.createElement(OtpButton, { width: "100%", onClick: function () {
                    onShowOtp('otp');
                } }, t('whatsAppOTP.RequestOTPBYSMS')),
            React.createElement(RequestByWhatsAppOtp, { onShowOtp: onShowOtp, phoneNumber: phoneNumber, email: email, language: language, isResendCodeEnable: true, action: action }))));
};
var timerObj = null;
var VERiFY_OTP_ENUMS;
(function (VERiFY_OTP_ENUMS) {
    VERiFY_OTP_ENUMS["VOICE"] = "voice";
    VERiFY_OTP_ENUMS["OTP"] = "otp";
    VERiFY_OTP_ENUMS["WHATSAPP"] = "whatsapp";
    VERiFY_OTP_ENUMS["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    VERiFY_OTP_ENUMS["PHONE_UPDATE_VERIFICATION"] = "PHONE_UPDATE_VERIFICATION";
})(VERiFY_OTP_ENUMS || (VERiFY_OTP_ENUMS = {}));
var VerifyPassword = function (props) {
    var t = useTranslation().t;
    var isShowShopping = props.isShowShopping, onVerifyAccount = props.onVerifyAccount, onGTMEventCall = props.onGTMEventCall, phoneNumber = props.phoneNumber, email = props.email, action = props.action, modalBackGroundColor = props.modalBackGroundColor, _a = props.showModalClose, showModalClose = _a === void 0 ? true : _a, _b = props.isForceVerify, isForceVerify = _b === void 0 ? false : _b, userName = props.userName, isModal = props.isModal, isShowLogo = props.isShowLogo, isShowCloseButton = props.isShowCloseButton, onCloseModal = props.onCloseModal, trackSmartlookError = props.trackSmartlookError, rest = __rest$1(props, ["isShowShopping", "onVerifyAccount", "onGTMEventCall", "phoneNumber", "email", "action", "modalBackGroundColor", "showModalClose", "isForceVerify", "userName", "isModal", "isShowLogo", "isShowCloseButton", "onCloseModal", "trackSmartlookError"]);
    var _c = __read$1(useState(59), 2), timer = _c[0], setTimer = _c[1];
    var _d = __read$1(useState(0), 2), otpCount = _d[0], setSendOTPCount = _d[1];
    var _e = useSelector(function (state) { return state.appConfig; }), storeId = _e.storeId, language = _e.language, features = _e.features;
    var whatsAppOtpSuccess = useSelector(function (state) { return state.verifyWhatsAppOTP; }).whatsAppOtpSuccess;
    var _f = __read$1(useState(true), 2), isEmailVerification = _f[0], setIsEmailVerification = _f[1];
    var _g = __read$1(useState(false), 2), isOTPSent = _g[0], setOTPSent = _g[1];
    var _h = __read$1(useState(false), 2), showOTPCall = _h[0], setShowOTPCall = _h[1];
    var _j = __read$1(useState(false), 2), showEditPhoneNumber = _j[0], setShowEditPhoneNumber = _j[1];
    var _k = __read$1(useState(phoneNumber), 2), otpPhoneNumber = _k[0], setOTPPhoneNumber = _k[1];
    var dispatch = useDispatch();
    var _l = __read$1(useState(false), 2), isResetInput = _l[0], setResetInput = _l[1];
    var _m = __read$1(useState(false), 2), isResendCodeEnable = _m[0], toggleResendCode = _m[1];
    var _o = useVerifyOTP(), otpData = _o.otpData, verificationData = _o.verificationData, resendCodeLoading = _o.resendCodeLoading, loading = _o.loading, serverError = _o.serverError, onSendOTP = _o.onSendOTP, onVerifyOTP = _o.onVerifyOTP;
    var accountVerificationActions = ['ACCOUNT_VERIFICATION', 'PHONE_VERIFICATION', VERiFY_OTP_ENUMS.FORGOT_PASSWORD];
    var _p = __read$1(useState(!((features === null || features === void 0 ? void 0 : features.isWhatsAppOtpEnabled) && action !== VERiFY_OTP_ENUMS.FORGOT_PASSWORD)), 2), showOtpContainer = _p[0], setShowOtpContainer = _p[1];
    var _q = __read$1(useState(VERiFY_OTP_ENUMS.OTP), 2), otpType = _q[0], setOtpType = _q[1];
    var otpSMSSendLimit = 1;
    var _r = useAnalytic(), GTMEventCall = _r.GTMEventCall, getGTMPageData = _r.getGTMPageData;
    var onStartShoppingClick = function () {
        onGTMEventCall && onGTMEventCall('skipotp');
        window.location.href = '/';
    };
    var onResendCodeClick = function (type) {
        GTMEventCall(GTMEvents.custom_event, {
            eventAction: GTMEventActions.registration,
            eventLabel: 'request_otp_via_sms',
            pageData: getGTMPageData({ getData: true }) || {},
            ga4: true,
        });
        setOtpType(type);
        onGTMEventCall && onGTMEventCall('resendotp');
        clearInterval(timerObj);
        initTimer();
        toggleResendCode(false);
        setResetInput(true);
        onSendOTP(action, email, type, otpData === null || otpData === void 0 ? void 0 : otpData.uuid, otpPhoneNumber);
        setOTPSent(true);
        setSendOTPCount(function (otpCount) { return otpCount + 1; });
    };
    var onActivateSendCallOTP = useCallback(function () {
        if (otpCount >= otpSMSSendLimit) {
            setResetInput(true);
        }
    }, [otpCount]);
    var changeOTP = function (otp) {
        var _a;
        if (otp.length === 4) {
            onVerifyOTP(otp, otpType === VERiFY_OTP_ENUMS.WHATSAPP ? (_a = whatsAppOtpSuccess === null || whatsAppOtpSuccess === void 0 ? void 0 : whatsAppOtpSuccess.otpVerificationResponse) === null || _a === void 0 ? void 0 : _a.uuid : otpData.uuid, onGTMEventCall);
        }
    };
    useEffect(function () {
        if (verificationData) {
            onVerifyAccount(verificationData.uuid, otpPhoneNumber);
            dispatch(setOTPVerificationSuccess(null));
        }
    }, [verificationData, otpPhoneNumber, dispatch, onVerifyAccount]);
    useEffect(function () {
        if (serverError && trackSmartlookError) {
            trackSmartlookError();
        }
    }, [serverError, trackSmartlookError]);
    useEffect(function () {
        if (showOtpContainer) {
            clearInterval(timerObj);
            initTimer();
            onSendOTP(action, email, VERiFY_OTP_ENUMS.OTP, '', otpPhoneNumber);
            setOTPSent(true);
            setResetInput(true);
            setShowOTPCall(false);
            setSendOTPCount(1);
            setIsEmailVerification(otpPhoneNumber ? false : true);
        }
    }, [action, email, features, otpPhoneNumber, showOtpContainer, onSendOTP]);
    useEffect(function () {
        if (timer === 0) {
            clearInterval(timerObj);
            toggleResendCode(true);
            setOTPSent(false);
            onActivateSendCallOTP();
            if (otpCount >= otpSMSSendLimit && (features === null || features === void 0 ? void 0 : features.isOTPCallEnabled)) {
                setShowOTPCall(true);
            }
        }
    }, [timer, otpCount, onActivateSendCallOTP, features]);
    var initTimer = function () {
        setTimer(59);
        timerObj = setInterval(function () {
            setTimer(function (timer) { return timer - 1; });
        }, 1000);
    };
    var resetInput = function () {
        setResetInput(false);
    };
    var onCloseOTPVerifyModal = function () {
        if (showModalClose) {
            setOTPSuccess && dispatch(setOTPSuccess(null));
            onCloseModal && onCloseModal(false);
        }
    };
    var tooglePhoneNumberModal = function () {
        setShowEditPhoneNumber(!showEditPhoneNumber);
    };
    var onPhoneNumberUpdate = function (phoneNumber) {
        clearInterval(timerObj);
        initTimer();
        tooglePhoneNumberModal();
        setOTPPhoneNumber(phoneNumber);
    };
    var onShowOtp = useCallback(function (type) {
        setShowOtpContainer(true);
        setOtpType(type);
    }, []);
    var getTimer = function () {
        var minutes = Math.floor(timer / 60);
        var seconds = timer - minutes * 60;
        return ((minutes < 10 ? '0' + minutes : minutes.toString()) + ':' + (seconds < 10 ? '0' + seconds : seconds.toString()));
    };
    var renderData = function () {
        return (React.createElement(React.Fragment, null,
            isShowLogo && (React.createElement(Box, { pb: 3 },
                React.createElement(CarrefourLogo, { size: "CUSTOM", height: 32, width: 128, fill: "#0e5aa7", storeId: storeId }))),
            ' ',
            serverError && (React.createElement(ErrorMessage$1, null,
                React.createElement(Warning, { fill: "#f34041" }),
                React.createElement(ErrorText$1, null, serverError))),
            loading && React.createElement(LinearProgress, { withBlock: true }),
            React.createElement(React.Fragment, null,
                !isForceVerify && otpData && (React.createElement(React.Fragment, null,
                    React.createElement(Flex, { my: "1" },
                        React.createElement(PageTitle, null, t('verifyOTP.' +
                            (accountVerificationActions.includes(action) ? 'verifyYourAccount' : 'verifyYourPhone')))),
                    React.createElement(Heading, null,
                        t('verifyOTP.fourDigitSecurityCodeSent'),
                        " ",
                        React.createElement(HighLightPhone, null, otpData.maskedPhoneNumber),
                        ' ',
                        isEmailVerification ? (React.createElement(React.Fragment, null,
                            t('verifyOTP.and'),
                            " ",
                            React.createElement(HighLightPhone, null, otpData.maskedEmail))) : ('')))),
                isForceVerify && (React.createElement(React.Fragment, null,
                    React.createElement(Flex, { my: "1" }, t('verifyOTP.hi') + " " + userName),
                    React.createElement(VerifyPhoneText, null, t('verifyOTP.letQuicklyVerifyYourPhone')),
                    React.createElement(VerificationCodeSent, { mt: 4, "data-sl": "mask" },
                        t('verifyOTP.verificationCodeSentTo'),
                        " ",
                        React.createElement("span", null, transformPhoneNo(otpPhoneNumber, language)),
                        ' ',
                        React.createElement(Button$1, { variant: "link", onClick: function () {
                                tooglePhoneNumberModal();
                            } },
                            React.createElement(Edit, null))))),
                React.createElement(InputContainerPadding, null,
                    React.createElement(OTPInput, { autoFocus: true, length: 4, className: "otpContainer", inputClassName: "otpInput", onChangeOTP: function (otp) { return changeOTP(otp); }, isResetInput: isResetInput, resetInput: resetInput }),
                    isOTPSent && !showOTPCall && React.createElement(OTPSentSuccess, null,
                        " ",
                        t('verifyOTP.otpSentSuccessfully'))),
                React.createElement(AlignCenter, null,
                    !showOTPCall && !(features === null || features === void 0 ? void 0 : features.isWhatsAppOtpEnabled) && (React.createElement(React.Fragment, null,
                        React.createElement(LoaderSpan, null,
                            React.createElement(Button$1, { onClick: function () { return onResendCodeClick(VERiFY_OTP_ENUMS.OTP); }, width: "100%", disabled: !isResendCodeEnable || resendCodeLoading, mb: 2 },
                                t('verifyOTP.resendCode'),
                                resendCodeLoading && React.createElement(LinearProgress, { withBlock: true }))),
                        (features === null || features === void 0 ? void 0 : features.isOTPCallEnabled) && otpCount > 1 && (React.createElement(Heading, null, t('verifyOTP.otpHasBeenSent', { otpCount: otpCount, otpSMSSendLimit: otpSMSSendLimit }))))),
                    (features === null || features === void 0 ? void 0 : features.isWhatsAppOtpEnabled) && action !== VERiFY_OTP_ENUMS.FORGOT_PASSWORD && (React.createElement(Box, { mb: 2, mt: 2, fontWeight: "bold" }, t('whatsAppOTP.TryAnotherVerificationMethod'))),
                    (showOTPCall || (features === null || features === void 0 ? void 0 : features.isWhatsAppOtpEnabled)) &&
                        (otpType !== VERiFY_OTP_ENUMS.VOICE ||
                            action == VERiFY_OTP_ENUMS.FORGOT_PASSWORD ||
                            action == VERiFY_OTP_ENUMS.PHONE_UPDATE_VERIFICATION) && (React.createElement(React.Fragment, null,
                        React.createElement(LoaderSpan, null,
                            React.createElement(Button$1, { onClick: function () { return onResendCodeClick(VERiFY_OTP_ENUMS.VOICE); }, width: "100%", disabled: !isResendCodeEnable || resendCodeLoading, mb: 2 },
                                React.createElement(PhoneWrapper, null,
                                    React.createElement(Phone, { size: 'M', fill: !isResendCodeEnable || resendCodeLoading ? '#000000' : '#FFFFFF' })),
                                t('verifyOTP.requestOTPBYCall'),
                                resendCodeLoading && React.createElement(LinearProgress, { withBlock: true }))))),
                    !isResendCodeEnable && otpType === VERiFY_OTP_ENUMS.VOICE && (React.createElement(Heading, null, t('verifyOTP.youWillReceiveCall'))),
                    (features === null || features === void 0 ? void 0 : features.isWhatsAppOtpEnabled) &&
                        action !== VERiFY_OTP_ENUMS.FORGOT_PASSWORD &&
                        otpType !== VERiFY_OTP_ENUMS.OTP && (React.createElement(Button$1, { onClick: function () { return onResendCodeClick(VERiFY_OTP_ENUMS.OTP); }, width: "100%", disabled: !isResendCodeEnable || resendCodeLoading, mb: 2 },
                        t('whatsAppOTP.RequestOTPBYSMS'),
                        resendCodeLoading && React.createElement(LinearProgress, { withBlock: true }))),
                    React.createElement(Box, { style: {
                            display: otpType !== VERiFY_OTP_ENUMS.WHATSAPP && (features === null || features === void 0 ? void 0 : features.isWhatsAppOtpEnabled) &&
                                action !== VERiFY_OTP_ENUMS.FORGOT_PASSWORD
                                ? 'block'
                                : 'none',
                        } },
                        React.createElement(RequestByWhatsAppOtp, { onShowOtp: onShowOtp, phoneNumber: phoneNumber, email: email, language: language, isResendCodeEnable: isResendCodeEnable, action: action })),
                    React.createElement(Timer, null, getTimer()),
                    isShowShopping && (React.createElement(Button$1, { onClick: onStartShoppingClick, variant: "link", fontWeight: "bold" }, t('verifyOTP.startShopping'))))),
            isShowLogo && (React.createElement(BroughtYouByWrapper, null, language === 'en' || language === 'ka' || language === 'ru' || language === 'uz' ? (React.createElement(MafLogoEn, { fill: COLORS.LIGHT_BROWN, size: "CUSTOM", height: 48, width: 164 })) : (React.createElement(MafLogoAr, { fill: COLORS.LIGHT_BROWN, size: "CUSTOM", height: 48, width: 164 }))))));
    };
    var bodyRender = function () {
        return !showOtpContainer && (features === null || features === void 0 ? void 0 : features.isWhatsAppOtpEnabled) && action !== VERiFY_OTP_ENUMS.FORGOT_PASSWORD ? (React.createElement(VerifyWhatsApp, { onShowOtp: onShowOtp, email: email, phoneNumber: phoneNumber, language: language, action: action })) : (renderData());
    };
    return (React.createElement(React.Fragment, null,
        isModal ? (React.createElement(Modal, __assign$1({ isOpen: true, title: isShowCloseButton ? '   ' : '', onClose: function () { return onCloseOTPVerifyModal(); }, backgroundColor: modalBackGroundColor, showClose: showModalClose }, rest), bodyRender())) : (bodyRender()),
        showEditPhoneNumber && (React.createElement(EditPhoneNumber$1, { isOpen: showEditPhoneNumber, onSuccess: onPhoneNumberUpdate, onClose: tooglePhoneNumberModal }))));
};
VerifyPassword.defaultProps = {
    isShowShopping: true,
    isModal: true,
    isShowLogo: false,
    isShowCloseButton: true,
};
var InputWrapper$1 = customStyled.div(templateObject_1$v || (templateObject_1$v = __makeTemplateObject$1(["\n  margin: 16px 0;\n"], ["\n  margin: 16px 0;\n"])));
var WarningMessage$1 = customStyled(Box)(templateObject_2$o || (templateObject_2$o = __makeTemplateObject$1(["\n  color:", ";\n  margin-top:10px;\n"], ["\n  color:", ";\n  margin-top:10px;\n"])), function (props) { return props.theme.colors.red; });
var ErrorMessage$2 = customStyled(Box)(templateObject_3$k || (templateObject_3$k = __makeTemplateObject$1(["\n  color: #f34041;\n  background-color:rgba(243,64,65,.05);\n  padding:20px;\n  text-align:center;\n  margin-bottom: 20px;\n"], ["\n  color: #f34041;\n  background-color:rgba(243,64,65,.05);\n  padding:20px;\n  text-align:center;\n  margin-bottom: 20px;\n"])));
var ErrorText$2 = customStyled.span(templateObject_4$h || (templateObject_4$h = __makeTemplateObject$1(["\n  margin-left:20px;\n"], ["\n  margin-left:20px;\n"])));
var LoaderSpan$1 = customStyled(Box)(templateObject_5$c || (templateObject_5$c = __makeTemplateObject$1(["\n  display: inline-flex;\n  position: relative;\n  width: 100%;\n  margin:", ";\n"], ["\n  display: inline-flex;\n  position: relative;\n  width: 100%;\n  margin:", ";\n"])), function (props) { return (props.m ? props.m + 'px 0px' : '0px'); });
var PageTitle$1 = customStyled(Text.H1)(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject$1(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
var SmallInputBox = customStyled.div(templateObject_7$8 || (templateObject_7$8 = __makeTemplateObject$1(["\n  margin: 5px;\n  width: 30%;\n"], ["\n  margin: 5px;\n  width: 30%;\n"])));
var MidInputBox = customStyled.div(templateObject_8$8 || (templateObject_8$8 = __makeTemplateObject$1(["\n  margin: 5px;\n  width: 65%;\n"], ["\n  margin: 5px;\n  width: 65%;\n"])));
var InputContainerPadding$1 = customStyled(Box)(templateObject_9$8 || (templateObject_9$8 = __makeTemplateObject$1(["\n  padding: 5px;\n  margin-bottom: 10px;\n  line-height: 20px;\n"], ["\n  padding: 5px;\n  margin-bottom: 10px;\n  line-height: 20px;\n"])));
var RadioButtonStyle = customStyled(Box)(templateObject_10$8 || (templateObject_10$8 = __makeTemplateObject$1(["\n  margin: 5px;\n"], ["\n  margin: 5px;\n"])));
var IconStyle = customStyled(Box)(templateObject_11$6 || (templateObject_11$6 = __makeTemplateObject$1(["\n  margin-right: 10px;\n  verticle-align:middle;\n"], ["\n  margin-right: 10px;\n  verticle-align:middle;\n"])));
var AccountIconStyle = customStyled(Box)(templateObject_12$5 || (templateObject_12$5 = __makeTemplateObject$1(["\n  verticle-align:middle;\n  margin-top: 10px;\n"], ["\n  verticle-align:middle;\n  margin-top: 10px;\n"])));
var PhoneStyle = customStyled(Box)(templateObject_13$5 || (templateObject_13$5 = __makeTemplateObject$1(["\n  padding-top: 3px;\n  margin-left:2px;\n"], ["\n  padding-top: 3px;\n  margin-left:2px;\n"])));
var FormContainer = customStyled(Box)(templateObject_14$5 || (templateObject_14$5 = __makeTemplateObject$1(["\n  margin-top:20px;\n"], ["\n  margin-top:20px;\n"])));
var TermAndCondition = customStyled(Box)(templateObject_15$5 || (templateObject_15$5 = __makeTemplateObject$1(["\n  margin:10px 0px;\n  padding-left:2px;\n  line-height:20px;\n"], ["\n  margin:10px 0px;\n  padding-left:2px;\n  line-height:20px;\n"])));
var DOBLabel = customStyled(Box)(templateObject_16$4 || (templateObject_16$4 = __makeTemplateObject$1(["\n  margin: 16px 0px 0px 5px;\n  line-height: 1.8;\n  font-size: 16px;\n"], ["\n  margin: 16px 0px 0px 5px;\n  line-height: 1.8;\n  font-size: 16px;\n"])));
var CompleteProfileTitle = customStyled(Text.H1)(templateObject_17$4 || (templateObject_17$4 = __makeTemplateObject$1(["\nfont-weight: bold;\ntext-align: center;\n"], ["\nfont-weight: bold;\ntext-align: center;\n"])));
CompleteProfileTitle.defaultProps = {
    my: 1,
};
var templateObject_1$v, templateObject_2$o, templateObject_3$k, templateObject_4$h, templateObject_5$c, templateObject_6$8, templateObject_7$8, templateObject_8$8, templateObject_9$8, templateObject_10$8, templateObject_11$6, templateObject_12$5, templateObject_13$5, templateObject_14$5, templateObject_15$5, templateObject_16$4, templateObject_17$4;
var STATIC_PAGE_LINKS = {
    SHARE_TERM_AND_CONDITION: 'https://www.sharerewards.com/en/terms-and-conditions',
    TERM_AND_CONDITION: '/termsandconditions',
    UPDATE_PRIVACY_POLICY: '/updatePrivacyPolicy',
    PRIVACY_POLICY: '/privacypolicy',
};
var yearArr = [];
for (var i = new Date().getFullYear() - 18; i >= 1915; i--) {
    yearArr.push({ id: i, label: i, value: i });
}
var years = yearArr;
var countries$1 = {
    en: [
        {
            value: 'TTO',
            label: 'Trinidad and Tobago',
        },
        {
            value: 'DMA',
            label: 'Dominica',
        },
        {
            value: 'KNA',
            label: 'Saint Kitts and Nevis',
        },
        {
            value: 'GNQ',
            label: 'Equatorial Guinea',
        },
        {
            value: 'ATG',
            label: 'Antigua and Barbuda',
        },
        {
            value: 'PNG',
            label: 'Papua New Guinea',
        },
        {
            value: 'VCT',
            label: 'Saint Vincent and the Grenadines',
        },
        {
            value: 'SLB',
            label: 'Solomon Islands',
        },
        {
            value: 'CAF',
            label: 'Central African Republic',
        },
        {
            value: 'COG',
            label: 'Republic of the Congo',
        },
        {
            value: 'GNB',
            label: 'Guinea-Bissau',
        },
        {
            value: 'LIE',
            label: 'Liechtenstein',
        },
        {
            value: 'COD',
            label: 'Democratic Republic of the Congo',
        },
        {
            value: 'DOM',
            label: 'Dominican Republic',
        },
        {
            value: 'SLE',
            label: 'Sierra Leone',
        },
        {
            value: 'SSD',
            label: 'South Sudan',
        },
        {
            value: 'NZL',
            label: 'New Zealand',
        },
        {
            value: 'ZAF',
            label: 'South Africa',
        },
        {
            value: 'CPV',
            label: 'Cape Verde',
        },
        {
            value: 'KOR',
            label: 'South Korea',
        },
        {
            value: 'LCA',
            label: 'Saint Lucia',
        },
        {
            value: 'LUX',
            label: 'Luxembourg',
        },
        {
            value: 'PRK',
            label: 'North Korea',
        },
        {
            value: 'SMR',
            label: 'San Marino',
        },
        {
            value: 'ARG',
            label: 'Argentina',
        },
        {
            value: 'AZE',
            label: 'Azerbaijan',
        },
        {
            value: 'BGD',
            label: 'Bangladesh',
        },
        {
            value: 'CMR',
            label: 'Cameroon',
        },
        {
            value: 'CRI',
            label: 'Costa Rica',
        },
        {
            value: 'FSM',
            label: 'Micronesia',
        },
        {
            value: 'KAZ',
            label: 'Kazakhstan',
        },
        {
            value: 'MHL',
            label: 'Marshall Islands',
        },
        {
            value: 'MNE',
            label: 'Montenegro',
        },
        {
            value: 'MRT',
            label: 'Mauritania',
        },
        {
            value: 'SGP',
            label: 'Singapore',
        },
        {
            value: 'SYC',
            label: 'Seychelles',
        },
        {
            value: 'UZB',
            label: 'Uzbekistan',
        },
        {
            value: 'VNM',
            label: 'Vietnam',
        },
        {
            value: 'AUS',
            label: 'Australia',
        },
        {
            value: 'BLR',
            label: 'Belarus',
        },
        {
            value: 'ECU',
            label: 'Ecuador',
        },
        {
            value: 'GTM',
            label: 'Guatemala',
        },
        {
            value: 'IDN',
            label: 'Indonesia',
        },
        {
            value: 'KIR',
            label: 'Kiribati',
        },
        {
            value: 'LKA',
            label: 'Sri Lanka',
        },
        {
            value: 'LTU',
            label: 'Lithuania',
        },
        {
            value: 'MKD',
            label: 'Macedonia',
        },
        {
            value: 'MOZ',
            label: 'Mozambique',
        },
        {
            value: 'NIC',
            label: 'Nicaragua',
        },
        {
            value: 'PAN',
            label: 'Panama',
        },
        {
            value: 'PRT',
            label: 'Portugal',
        },
        {
            value: 'PRY',
            label: 'Paraguay',
        },
        {
            value: 'SEN',
            label: 'Senegal',
        },
        {
            value: 'SLV',
            label: 'El Salvador',
        },
        {
            value: 'STP',
            label: 'Sao Tome and Principe',
        },
        {
            value: 'TZA',
            label: 'Tanzania',
        },
        {
            value: 'VEN',
            label: 'Venezuela',
        },
        {
            value: 'ZWE',
            label: 'Zimbabwe',
        },
        {
            value: 'BDI',
            label: 'Burundi',
        },
        {
            value: 'BFA',
            label: 'Burkina Faso',
        },
        {
            value: 'BGR',
            label: 'Bulgaria',
        },
        {
            value: 'BHS',
            label: 'Bahamas',
        },
        {
            value: 'BRA',
            label: 'Brazil',
        },
        {
            value: 'BRB',
            label: 'Barbados',
        },
        {
            value: 'BRN',
            label: 'Brunei',
        },
        {
            value: 'BTN',
            label: 'Bhutan',
        },
        {
            value: 'COL',
            label: 'Colombia',
        },
        {
            value: 'ETH',
            label: 'Ethiopia',
        },
        {
            value: 'GRD',
            label: 'Grenada',
        },
        {
            value: 'HUN',
            label: 'Hungary',
        },
        {
            value: 'ISL',
            label: 'Iceland',
        },
        {
            value: 'JOR',
            label: 'Jordan',
        },
        {
            value: 'KHM',
            label: 'Cambodia',
        },
        {
            value: 'MDA',
            label: 'Moldova',
        },
        {
            value: 'MNG',
            label: 'Mongolia',
        },
        {
            value: 'MUS',
            label: 'Mauritius',
        },
        {
            value: 'MYS',
            label: 'Malaysia',
        },
        {
            value: 'NOR',
            label: 'Norway',
        },
        {
            value: 'PAK',
            label: 'Pakistan',
        },
        {
            value: 'PHL',
            label: 'Philippines',
        },
        {
            value: 'SUR',
            label: 'Suriname',
        },
        {
            value: 'SVK',
            label: 'Slovakia',
        },
        {
            value: 'SVN',
            label: 'Slovenia',
        },
        {
            value: 'UKR',
            label: 'Ukraine',
        },
        {
            value: 'URY',
            label: 'Uruguay',
        },
        {
            value: 'VUT',
            label: 'Vanuatu',
        },
        {
            value: 'ALB',
            label: 'Albania',
        },
        {
            value: 'AND',
            label: 'Andorra',
        },
        {
            value: 'ARM',
            label: 'Armenia',
        },
        {
            value: 'AUT',
            label: 'Austria',
        },
        {
            value: 'BEN',
            label: 'Benin',
        },
        {
            value: 'BHR',
            label: 'Bahrain',
        },
        {
            value: 'BLZ',
            label: 'Belize',
        },
        {
            value: 'BOL',
            label: 'Bolivia',
        },
        {
            value: 'BWA',
            label: 'Botswana',
        },
        {
            value: 'CAN',
            label: 'Canada',
        },
        {
            value: 'DJI',
            label: 'Djibouti',
        },
        {
            value: 'DZA',
            label: 'Algeria',
        },
        {
            value: 'EGY',
            label: 'Egypt',
        },
        {
            value: 'ERI',
            label: 'Eritrea',
        },
        {
            value: 'EST',
            label: 'Estonia',
        },
        {
            value: 'GAB',
            label: 'Gabon',
        },
        {
            value: 'GEO',
            label: 'Georgia',
        },
        {
            value: 'GHA',
            label: 'Ghana',
        },
        {
            value: 'GUY',
            label: 'Guyana',
        },
        {
            value: 'HND',
            label: 'Honduras',
        },
        {
            value: 'HRV',
            label: 'Croatia',
        },
        {
            value: 'JAM',
            label: 'Jamaica',
        },
        {
            value: 'JPN',
            label: 'Japan',
        },
        {
            value: 'LBN',
            label: 'Lebanon',
        },
        {
            value: 'LBR',
            label: 'Liberia',
        },
        {
            value: 'MAR',
            label: 'Morocco',
        },
        {
            value: 'MDG',
            label: 'Madagascar',
        },
        {
            value: 'MDV',
            label: 'Maldives',
        },
        {
            value: 'MMR',
            label: 'Myanmar',
        },
        {
            value: 'MWI',
            label: 'Malawi',
        },
        {
            value: 'NAM',
            label: 'Namibia',
        },
        {
            value: 'NER',
            label: 'Niger',
        },
        {
            value: 'NGA',
            label: 'Nigeria',
        },
        {
            value: 'NPL',
            label: 'Nepal',
        },
        {
            value: 'PER',
            label: 'Peru',
        },
        {
            value: 'ROU',
            label: 'Romania',
        },
        {
            value: 'SDN',
            label: 'Sudan',
        },
        {
            value: 'TGO',
            label: 'Togo',
        },
        {
            value: 'TLS',
            label: 'East Timor',
        },
        {
            value: 'TUN',
            label: 'Tunisia',
        },
        {
            value: 'TUV',
            label: 'Tuvalu',
        },
        {
            value: 'USA',
            label: 'United States of America',
        },
        {
            value: 'AGO',
            label: 'Angola',
        },
        {
            value: 'ARE',
            label: 'United Arab Emirates',
        },
        {
            value: 'BEL',
            label: 'Belgium',
        },
        {
            value: 'BIH',
            label: 'Bosnia and Herzegovina',
        },
        {
            value: 'CHL',
            label: 'Chile',
        },
        {
            value: 'CHN',
            label: 'China',
        },
        {
            value: 'CIV',
            label: 'Ivory Coast',
        },
        {
            value: 'COM',
            label: 'Comoros',
        },
        {
            value: 'CYP',
            label: 'Cyprus',
        },
        {
            value: 'ESP',
            label: 'Spain',
        },
        {
            value: 'FIN',
            label: 'Finland',
        },
        {
            value: 'GBR',
            label: 'United Kingdom',
        },
        {
            value: 'GIN',
            label: 'Guinea',
        },
        {
            value: 'GMB',
            label: 'Gambia',
        },
        {
            value: 'HTI',
            label: 'Haiti',
        },
        {
            value: 'ITA',
            label: 'Italy',
        },
        {
            value: 'KWT',
            label: 'Kuwait',
        },
        {
            value: 'LSO',
            label: 'Lesotho',
        },
        {
            value: 'LVA',
            label: 'Latvia',
        },
        {
            value: 'MCO',
            label: 'Monaco',
        },
        {
            value: 'MEX',
            label: 'Mexico',
        },
        {
            value: 'MLT',
            label: 'Malta',
        },
        {
            value: 'NRU',
            label: 'Nauru',
        },
        {
            value: 'PLW',
            label: 'Palau',
        },
        {
            value: 'RUS',
            label: 'Russia',
        },
        {
            value: 'RWA',
            label: 'Rwanda',
        },
        {
            value: 'SRB',
            label: 'Serbia',
        },
        {
            value: 'SWE',
            label: 'Sweden',
        },
        {
            value: 'TCD',
            label: 'Chad',
        },
        {
            value: 'TKM',
            label: 'Turkmenistan',
        },
        {
            value: 'TUR',
            label: 'Turkey',
        },
        {
            value: 'UGA',
            label: 'Uganda',
        },
        {
            value: 'ZMB',
            label: 'Zambia',
        },
        {
            value: 'AFG',
            label: 'Afghanistan',
        },
        {
            value: 'DEU',
            label: 'Germany',
        },
        {
            value: 'DNK',
            label: 'Denmark',
        },
        {
            value: 'FJI',
            label: 'Fiji',
        },
        {
            value: 'FRA',
            label: 'France',
        },
        {
            value: 'IND',
            label: 'India',
        },
        {
            value: 'KEN',
            label: 'Kenya',
        },
        {
            value: 'KGZ',
            label: 'Kyrgyzstan',
        },
        {
            value: 'LBY',
            label: 'Libya',
        },
        {
            value: 'MLI',
            label: 'Mali',
        },
        {
            value: 'POL',
            label: 'Poland',
        },
        {
            value: 'SOM',
            label: 'Somalia',
        },
        {
            value: 'SYR',
            label: 'Syria',
        },
        {
            value: 'TON',
            label: 'Tonga',
        },
        {
            value: 'WSM',
            label: 'Samoa',
        },
        {
            value: 'YEM',
            label: 'Yemen',
        },
        {
            value: 'CHE',
            label: 'Switzerland',
        },
        {
            value: 'CUB',
            label: 'Cuba',
        },
        {
            value: 'CZE',
            label: 'Czech Republic',
        },
        {
            value: 'GRC',
            label: 'Greece',
        },
        {
            value: 'IRL',
            label: 'Ireland',
        },
        {
            value: 'IRQ',
            label: 'Iraq',
        },
        {
            value: 'NLD',
            label: 'Netherlands',
        },
        {
            value: 'OMN',
            label: 'Oman',
        },
        {
            value: 'SAU',
            label: 'Saudi Arabia',
        },
        {
            value: 'SWZ',
            label: 'Eswatini',
        },
        {
            value: 'TJK',
            label: 'Tajikistan',
        },
        {
            value: 'THA',
            label: 'Thailand',
        },
        {
            value: 'LAO',
            label: 'Laos',
        },
        {
            value: 'QAT',
            label: 'Qatar',
        },
        {
            value: 'IRN',
            label: 'Iran',
        },
        {
            value: 'PSE',
            label: 'Palestine',
        },
    ],
    ar: [
        {
            value: 'TTO',
            label: 'ترينيداد وتوباغو',
        },
        {
            value: 'DMA',
            label: 'دومينيكا',
        },
        {
            value: 'KNA',
            label: 'سانت كيتس ونيفس',
        },
        {
            value: 'GNQ',
            label: 'غينيا الاستوائي',
        },
        {
            value: 'ATG',
            label: 'أنتيغوا وبربودا',
        },
        {
            value: 'PNG',
            label: 'بابوا غينيا الجديدة',
        },
        {
            value: 'VCT',
            label: 'سانت فنسنت وجزر غرينادين',
        },
        {
            value: 'SLB',
            label: 'جزر سليمان',
        },
        {
            value: 'CAF',
            label: 'جمهورية أفريقيا الوسطى',
        },
        {
            value: 'COG',
            label: 'جمهورية الكونغو',
        },
        {
            value: 'GNB',
            label: 'غينيا-بيساو',
        },
        {
            value: 'LIE',
            label: 'ليختنشتين',
        },
        {
            value: 'COD',
            label: 'جمهورية الكونغو الديمقراطية',
        },
        {
            value: 'DOM',
            label: 'الجمهورية الدومينيكية',
        },
        {
            value: 'SLE',
            label: 'سيراليون',
        },
        {
            value: 'SSD',
            label: 'جنوب السودان',
        },
        {
            value: 'NZL',
            label: 'نيوزيلندا',
        },
        {
            value: 'ZAF',
            label: 'جنوب أفريقيا',
        },
        {
            value: 'CPV',
            label: 'الرأس الأخضر',
        },
        {
            value: 'KOR',
            label: 'كوريا الجنوبية',
        },
        {
            value: 'LCA',
            label: 'سانت لوسيا',
        },
        {
            value: 'LUX',
            label: 'لوكسمبورغ',
        },
        {
            value: 'PRK',
            label: 'كوريا الشمالية',
        },
        {
            value: 'SMR',
            label: 'سان مارينو',
        },
        {
            value: 'ARG',
            label: 'الأرجنتين',
        },
        {
            value: 'AZE',
            label: 'أذربيجان',
        },
        {
            value: 'BGD',
            label: 'بنغلاديش',
        },
        {
            value: 'CMR',
            label: 'كاميرون',
        },
        {
            value: 'CRI',
            label: 'كوستاريكا',
        },
        {
            value: 'FSM',
            label: 'ولايات ميكرونيسيا المتحدة',
        },
        {
            value: 'KAZ',
            label: 'كازاخستان',
        },
        {
            value: 'MHL',
            label: 'جزر مارشال',
        },
        {
            value: 'MNE',
            label: 'الجبل الأسو',
        },
        {
            value: 'MRT',
            label: 'موريتانيا',
        },
        {
            value: 'SGP',
            label: 'سنغافورة',
        },
        {
            value: 'SYC',
            label: 'سيشيل',
        },
        {
            value: 'UZB',
            label: 'أوزباكستان',
        },
        {
            value: 'VNM',
            label: 'فيتنام',
        },
        {
            value: 'AUS',
            label: 'أستراليا',
        },
        {
            value: 'BLR',
            label: 'روسيا البيضاء',
        },
        {
            value: 'ECU',
            label: 'إكوادور',
        },
        {
            value: 'GTM',
            label: 'غواتيمال',
        },
        {
            value: 'IDN',
            label: 'أندونيسيا',
        },
        {
            value: 'KIR',
            label: 'كيريباتي',
        },
        {
            value: 'LKA',
            label: 'سريلانكا',
        },
        {
            value: 'LTU',
            label: 'لتوانيا',
        },
        {
            value: 'MKD',
            label: 'جمهورية مقدونيا',
        },
        {
            value: 'MOZ',
            label: 'موزمبيق',
        },
        {
            value: 'NIC',
            label: 'نيكاراجوا',
        },
        {
            value: 'PAN',
            label: 'بنما',
        },
        {
            value: 'PRT',
            label: 'البرتغال',
        },
        {
            value: 'PRY',
            label: 'باراغواي',
        },
        {
            value: 'SEN',
            label: 'السنغال',
        },
        {
            value: 'SLV',
            label: 'إلسلفادور',
        },
        {
            value: 'STP',
            label: 'ساو تومي وبرينسيبي',
        },
        {
            value: 'TZA',
            label: 'تنزانيا',
        },
        {
            value: 'VEN',
            label: 'فنزويلا',
        },
        {
            value: 'ZWE',
            label: 'زمبابوي',
        },
        {
            value: 'BDI',
            label: 'بوروندي',
        },
        {
            value: 'BFA',
            label: 'بوركينا فاسو',
        },
        {
            value: 'BGR',
            label: 'بلغاريا',
        },
        {
            value: 'BHS',
            label: 'الباهاماس',
        },
        {
            value: 'BRA',
            label: 'البرازيل',
        },
        {
            value: 'BRB',
            label: 'بربادوس',
        },
        {
            value: 'BRN',
            label: 'بروناي',
        },
        {
            value: 'BTN',
            label: 'بوتان',
        },
        {
            value: 'COL',
            label: 'كولومبيا',
        },
        {
            value: 'ETH',
            label: 'أثيوبيا',
        },
        {
            value: 'GRD',
            label: 'غرينادا',
        },
        {
            value: 'HUN',
            label: 'المجر',
        },
        {
            value: 'ISL',
            label: 'آيسلندا',
        },
        {
            value: 'JOR',
            label: 'الأردن',
        },
        {
            value: 'KHM',
            label: 'كمبوديا',
        },
        {
            value: 'MDA',
            label: 'مولدافيا',
        },
        {
            value: 'MNG',
            label: 'منغوليا',
        },
        {
            value: 'MUS',
            label: 'موريشيوس',
        },
        {
            value: 'MYS',
            label: 'ماليزيا',
        },
        {
            value: 'NOR',
            label: 'النرويج',
        },
        {
            value: 'PAK',
            label: 'باكستان',
        },
        {
            value: 'PHL',
            label: 'الفليبين',
        },
        {
            value: 'SUR',
            label: 'سورينام',
        },
        {
            value: 'SVK',
            label: 'سلوفاكيا',
        },
        {
            value: 'SVN',
            label: 'سلوفينيا',
        },
        {
            value: 'UKR',
            label: 'أوكرانيا',
        },
        {
            value: 'URY',
            label: 'أورغواي',
        },
        {
            value: 'VUT',
            label: 'فانواتو',
        },
        {
            value: 'ALB',
            label: 'ألبانيا',
        },
        {
            value: 'AND',
            label: 'أندورا',
        },
        {
            value: 'ARM',
            label: 'أرمينيا',
        },
        {
            value: 'AUT',
            label: 'النمسا',
        },
        {
            value: 'BEN',
            label: 'بنين',
        },
        {
            value: 'BHR',
            label: 'البحرين',
        },
        {
            value: 'BLZ',
            label: 'بيليز',
        },
        {
            value: 'BOL',
            label: 'بوليفيا',
        },
        {
            value: 'BWA',
            label: 'بوتسوانا',
        },
        {
            value: 'CAN',
            label: 'كندا',
        },
        {
            value: 'DJI',
            label: 'جيبوتي',
        },
        {
            value: 'DZA',
            label: 'الجزائر',
        },
        {
            value: 'EGY',
            label: 'مصر',
        },
        {
            value: 'ERI',
            label: 'إريتريا',
        },
        {
            value: 'EST',
            label: 'استونيا',
        },
        {
            value: 'GAB',
            label: 'الغابون',
        },
        {
            value: 'GEO',
            label: 'جيورجيا',
        },
        {
            value: 'GHA',
            label: 'غانا',
        },
        {
            value: 'GUY',
            label: 'غيانا',
        },
        {
            value: 'HND',
            label: 'هندوراس',
        },
        {
            value: 'HRV',
            label: 'كرواتيا',
        },
        {
            value: 'JAM',
            label: 'جمايكا',
        },
        {
            value: 'JPN',
            label: 'اليابان',
        },
        {
            value: 'LBN',
            label: 'لبنان',
        },
        {
            value: 'LBR',
            label: 'ليبيريا',
        },
        {
            value: 'MAR',
            label: 'المغرب',
        },
        {
            value: 'MDG',
            label: 'مدغشقر',
        },
        {
            value: 'MDV',
            label: 'المالديف',
        },
        {
            value: 'MMR',
            label: 'ميانمار',
        },
        {
            value: 'MWI',
            label: 'مالاوي',
        },
        {
            value: 'NAM',
            label: 'ناميبيا',
        },
        {
            value: 'NER',
            label: 'النيجر',
        },
        {
            value: 'NGA',
            label: 'نيجيريا',
        },
        {
            value: 'NPL',
            label: 'نيبال',
        },
        {
            value: 'PER',
            label: 'بيرو',
        },
        {
            value: 'ROU',
            label: 'رومانيا',
        },
        {
            value: 'SDN',
            label: 'السودان',
        },
        {
            value: 'TGO',
            label: 'توغو',
        },
        {
            value: 'TLS',
            label: 'تيمور الشرقية',
        },
        {
            value: 'TUN',
            label: 'تونس',
        },
        {
            value: 'TUV',
            label: 'توفالو',
        },
        {
            value: 'USA',
            label: 'الولايات المتحدة',
        },
        {
            value: 'AGO',
            label: 'أنغولا',
        },
        {
            value: 'ARE',
            label: 'الإمارات العربية المتحدة',
        },
        {
            value: 'BEL',
            label: 'بلجيكا',
        },
        {
            value: 'BIH',
            label: 'البوسنة و الهرسك',
        },
        {
            value: 'CHL',
            label: 'تشيلي',
        },
        {
            value: 'CHN',
            label: 'جمهورية الصين الشعبية',
        },
        {
            value: 'CIV',
            label: 'ساحل العاج',
        },
        {
            value: 'COM',
            label: 'جزر القمر',
        },
        {
            value: 'CYP',
            label: 'قبرص',
        },
        {
            value: 'ESP',
            label: 'إسبانيا',
        },
        {
            value: 'FIN',
            label: 'فنلندا',
        },
        {
            value: 'GBR',
            label: 'المملكة المتحدة',
        },
        {
            value: 'GIN',
            label: 'غينيا',
        },
        {
            value: 'GMB',
            label: 'غامبيا',
        },
        {
            value: 'HTI',
            label: 'هايتي',
        },
        {
            value: 'ITA',
            label: 'إيطاليا',
        },
        {
            value: 'KWT',
            label: 'الكويت',
        },
        {
            value: 'LSO',
            label: 'ليسوتو',
        },
        {
            value: 'LVA',
            label: 'لاتفيا',
        },
        {
            value: 'MCO',
            label: 'موناكو',
        },
        {
            value: 'MEX',
            label: 'المكسيك',
        },
        {
            value: 'MLT',
            label: 'مالطا',
        },
        {
            value: 'NRU',
            label: 'ناورو',
        },
        {
            value: 'PLW',
            label: 'بالاو',
        },
        {
            value: 'RUS',
            label: 'روسيا',
        },
        {
            value: 'RWA',
            label: 'رواندا',
        },
        {
            value: 'SRB',
            label: 'جمهورية صربيا',
        },
        {
            value: 'SWE',
            label: 'السويد',
        },
        {
            value: 'TCD',
            label: 'تشاد',
        },
        {
            value: 'TKM',
            label: 'تركمانستان',
        },
        {
            value: 'TUR',
            label: 'تركيا',
        },
        {
            value: 'UGA',
            label: 'أوغندا',
        },
        {
            value: 'ZMB',
            label: 'زامبيا',
        },
        {
            value: 'AFG',
            label: 'أفغانستان',
        },
        {
            value: 'DEU',
            label: 'ألمانيا',
        },
        {
            value: 'DNK',
            label: 'الدانمارك',
        },
        {
            value: 'FJI',
            label: 'فيجي',
        },
        {
            value: 'FRA',
            label: 'فرنسا',
        },
        {
            value: 'IND',
            label: 'الهند',
        },
        {
            value: 'KEN',
            label: 'كينيا',
        },
        {
            value: 'KGZ',
            label: 'قيرغيزستان',
        },
        {
            value: 'LBY',
            label: 'ليبيا',
        },
        {
            value: 'MLI',
            label: 'مالي',
        },
        {
            value: 'POL',
            label: 'بولندا',
        },
        {
            value: 'SOM',
            label: 'الصومال',
        },
        {
            value: 'SYR',
            label: 'سوريا',
        },
        {
            value: 'TON',
            label: 'تونغا',
        },
        {
            value: 'WSM',
            label: 'ساموا',
        },
        {
            value: 'YEM',
            label: 'اليمن',
        },
        {
            value: 'CHE',
            label: 'سويسرا',
        },
        {
            value: 'CUB',
            label: 'كوبا',
        },
        {
            value: 'CZE',
            label: 'الجمهورية التشيكية',
        },
        {
            value: 'GRC',
            label: 'اليونان',
        },
        {
            value: 'IRL',
            label: 'جمهورية أيرلندا',
        },
        {
            value: 'IRQ',
            label: 'العراق',
        },
        {
            value: 'NLD',
            label: 'هولندا',
        },
        {
            value: 'OMN',
            label: 'عُمان',
        },
        {
            value: 'SAU',
            label: 'المملكة العربية السعودية',
        },
        {
            value: 'SWZ',
            label: 'مملكة إسواتيني',
        },
        {
            value: 'TJK',
            label: 'طاجيكستان',
        },
        {
            value: 'THA',
            label: 'تايلندا',
        },
        {
            value: 'LAO',
            label: 'لائوس',
        },
        {
            value: 'QAT',
            label: 'قطر',
        },
        {
            value: 'IRN',
            label: 'إيران',
        },
        {
            value: 'PSE',
            label: 'فلسطين',
        },
    ],
    ka: [
        {
            value: 'TTO',
            label: 'Trinidad and Tobago',
        },
        {
            value: 'DMA',
            label: 'Dominica',
        },
        {
            value: 'KNA',
            label: 'Saint Kitts and Nevis',
        },
        {
            value: 'GNQ',
            label: 'Equatorial Guinea',
        },
        {
            value: 'ATG',
            label: 'Antigua and Barbuda',
        },
        {
            value: 'PNG',
            label: 'Papua New Guinea',
        },
        {
            value: 'VCT',
            label: 'Saint Vincent and the Grenadines',
        },
        {
            value: 'SLB',
            label: 'Solomon Islands',
        },
        {
            value: 'CAF',
            label: 'Central African Republic',
        },
        {
            value: 'COG',
            label: 'Republic of the Congo',
        },
        {
            value: 'GNB',
            label: 'Guinea-Bissau',
        },
        {
            value: 'LIE',
            label: 'Liechtenstein',
        },
        {
            value: 'COD',
            label: 'Democratic Republic of the Congo',
        },
        {
            value: 'DOM',
            label: 'Dominican Republic',
        },
        {
            value: 'SLE',
            label: 'Sierra Leone',
        },
        {
            value: 'SSD',
            label: 'South Sudan',
        },
        {
            value: 'NZL',
            label: 'New Zealand',
        },
        {
            value: 'ZAF',
            label: 'South Africa',
        },
        {
            value: 'CPV',
            label: 'Cape Verde',
        },
        {
            value: 'KOR',
            label: 'South Korea',
        },
        {
            value: 'LCA',
            label: 'Saint Lucia',
        },
        {
            value: 'LUX',
            label: 'Luxembourg',
        },
        {
            value: 'PRK',
            label: 'North Korea',
        },
        {
            value: 'SMR',
            label: 'San Marino',
        },
        {
            value: 'ARG',
            label: 'Argentina',
        },
        {
            value: 'AZE',
            label: 'Azerbaijan',
        },
        {
            value: 'BGD',
            label: 'Bangladesh',
        },
        {
            value: 'CMR',
            label: 'Cameroon',
        },
        {
            value: 'CRI',
            label: 'Costa Rica',
        },
        {
            value: 'FSM',
            label: 'Micronesia',
        },
        {
            value: 'KAZ',
            label: 'Kazakhstan',
        },
        {
            value: 'MHL',
            label: 'Marshall Islands',
        },
        {
            value: 'MNE',
            label: 'Montenegro',
        },
        {
            value: 'MRT',
            label: 'Mauritania',
        },
        {
            value: 'SGP',
            label: 'Singapore',
        },
        {
            value: 'SYC',
            label: 'Seychelles',
        },
        {
            value: 'UZB',
            label: 'Uzbekistan',
        },
        {
            value: 'VNM',
            label: 'Vietnam',
        },
        {
            value: 'AUS',
            label: 'Australia',
        },
        {
            value: 'BLR',
            label: 'Belarus',
        },
        {
            value: 'ECU',
            label: 'Ecuador',
        },
        {
            value: 'GTM',
            label: 'Guatemala',
        },
        {
            value: 'IDN',
            label: 'Indonesia',
        },
        {
            value: 'KIR',
            label: 'Kiribati',
        },
        {
            value: 'LKA',
            label: 'Sri Lanka',
        },
        {
            value: 'LTU',
            label: 'Lithuania',
        },
        {
            value: 'MKD',
            label: 'Macedonia',
        },
        {
            value: 'MOZ',
            label: 'Mozambique',
        },
        {
            value: 'NIC',
            label: 'Nicaragua',
        },
        {
            value: 'PAN',
            label: 'Panama',
        },
        {
            value: 'PRT',
            label: 'Portugal',
        },
        {
            value: 'PRY',
            label: 'Paraguay',
        },
        {
            value: 'SEN',
            label: 'Senegal',
        },
        {
            value: 'SLV',
            label: 'El Salvador',
        },
        {
            value: 'STP',
            label: 'Sao Tome and Principe',
        },
        {
            value: 'TZA',
            label: 'Tanzania',
        },
        {
            value: 'VEN',
            label: 'Venezuela',
        },
        {
            value: 'ZWE',
            label: 'Zimbabwe',
        },
        {
            value: 'BDI',
            label: 'Burundi',
        },
        {
            value: 'BFA',
            label: 'Burkina Faso',
        },
        {
            value: 'BGR',
            label: 'Bulgaria',
        },
        {
            value: 'BHS',
            label: 'Bahamas',
        },
        {
            value: 'BRA',
            label: 'Brazil',
        },
        {
            value: 'BRB',
            label: 'Barbados',
        },
        {
            value: 'BRN',
            label: 'Brunei',
        },
        {
            value: 'BTN',
            label: 'Bhutan',
        },
        {
            value: 'COL',
            label: 'Colombia',
        },
        {
            value: 'ETH',
            label: 'Ethiopia',
        },
        {
            value: 'GRD',
            label: 'Grenada',
        },
        {
            value: 'HUN',
            label: 'Hungary',
        },
        {
            value: 'ISL',
            label: 'Iceland',
        },
        {
            value: 'JOR',
            label: 'Jordan',
        },
        {
            value: 'KHM',
            label: 'Cambodia',
        },
        {
            value: 'MDA',
            label: 'Moldova',
        },
        {
            value: 'MNG',
            label: 'Mongolia',
        },
        {
            value: 'MUS',
            label: 'Mauritius',
        },
        {
            value: 'MYS',
            label: 'Malaysia',
        },
        {
            value: 'NOR',
            label: 'Norway',
        },
        {
            value: 'PAK',
            label: 'Pakistan',
        },
        {
            value: 'PHL',
            label: 'Philippines',
        },
        {
            value: 'SUR',
            label: 'Suriname',
        },
        {
            value: 'SVK',
            label: 'Slovakia',
        },
        {
            value: 'SVN',
            label: 'Slovenia',
        },
        {
            value: 'UKR',
            label: 'Ukraine',
        },
        {
            value: 'URY',
            label: 'Uruguay',
        },
        {
            value: 'VUT',
            label: 'Vanuatu',
        },
        {
            value: 'ALB',
            label: 'Albania',
        },
        {
            value: 'AND',
            label: 'Andorra',
        },
        {
            value: 'ARM',
            label: 'Armenia',
        },
        {
            value: 'AUT',
            label: 'Austria',
        },
        {
            value: 'BEN',
            label: 'Benin',
        },
        {
            value: 'BHR',
            label: 'Bahrain',
        },
        {
            value: 'BLZ',
            label: 'Belize',
        },
        {
            value: 'BOL',
            label: 'Bolivia',
        },
        {
            value: 'BWA',
            label: 'Botswana',
        },
        {
            value: 'CAN',
            label: 'Canada',
        },
        {
            value: 'DJI',
            label: 'Djibouti',
        },
        {
            value: 'DZA',
            label: 'Algeria',
        },
        {
            value: 'EGY',
            label: 'Egypt',
        },
        {
            value: 'ERI',
            label: 'Eritrea',
        },
        {
            value: 'EST',
            label: 'Estonia',
        },
        {
            value: 'GAB',
            label: 'Gabon',
        },
        {
            value: 'GEO',
            label: 'Georgia',
        },
        {
            value: 'GHA',
            label: 'Ghana',
        },
        {
            value: 'GUY',
            label: 'Guyana',
        },
        {
            value: 'HND',
            label: 'Honduras',
        },
        {
            value: 'HRV',
            label: 'Croatia',
        },
        {
            value: 'JAM',
            label: 'Jamaica',
        },
        {
            value: 'JPN',
            label: 'Japan',
        },
        {
            value: 'LBN',
            label: 'Lebanon',
        },
        {
            value: 'LBR',
            label: 'Liberia',
        },
        {
            value: 'MAR',
            label: 'Morocco',
        },
        {
            value: 'MDG',
            label: 'Madagascar',
        },
        {
            value: 'MDV',
            label: 'Maldives',
        },
        {
            value: 'MMR',
            label: 'Myanmar',
        },
        {
            value: 'MWI',
            label: 'Malawi',
        },
        {
            value: 'NAM',
            label: 'Namibia',
        },
        {
            value: 'NER',
            label: 'Niger',
        },
        {
            value: 'NGA',
            label: 'Nigeria',
        },
        {
            value: 'NPL',
            label: 'Nepal',
        },
        {
            value: 'PER',
            label: 'Peru',
        },
        {
            value: 'ROU',
            label: 'Romania',
        },
        {
            value: 'SDN',
            label: 'Sudan',
        },
        {
            value: 'TGO',
            label: 'Togo',
        },
        {
            value: 'TLS',
            label: 'East Timor',
        },
        {
            value: 'TUN',
            label: 'Tunisia',
        },
        {
            value: 'TUV',
            label: 'Tuvalu',
        },
        {
            value: 'USA',
            label: 'United States of America',
        },
        {
            value: 'AGO',
            label: 'Angola',
        },
        {
            value: 'ARE',
            label: 'United Arab Emirates',
        },
        {
            value: 'BEL',
            label: 'Belgium',
        },
        {
            value: 'BIH',
            label: 'Bosnia and Herzegovina',
        },
        {
            value: 'CHL',
            label: 'Chile',
        },
        {
            value: 'CHN',
            label: 'China',
        },
        {
            value: 'CIV',
            label: 'Ivory Coast',
        },
        {
            value: 'COM',
            label: 'Comoros',
        },
        {
            value: 'CYP',
            label: 'Cyprus',
        },
        {
            value: 'ESP',
            label: 'Spain',
        },
        {
            value: 'FIN',
            label: 'Finland',
        },
        {
            value: 'GBR',
            label: 'United Kingdom',
        },
        {
            value: 'GIN',
            label: 'Guinea',
        },
        {
            value: 'GMB',
            label: 'Gambia',
        },
        {
            value: 'HTI',
            label: 'Haiti',
        },
        {
            value: 'ITA',
            label: 'Italy',
        },
        {
            value: 'KWT',
            label: 'Kuwait',
        },
        {
            value: 'LSO',
            label: 'Lesotho',
        },
        {
            value: 'LVA',
            label: 'Latvia',
        },
        {
            value: 'MCO',
            label: 'Monaco',
        },
        {
            value: 'MEX',
            label: 'Mexico',
        },
        {
            value: 'MLT',
            label: 'Malta',
        },
        {
            value: 'NRU',
            label: 'Nauru',
        },
        {
            value: 'PLW',
            label: 'Palau',
        },
        {
            value: 'RUS',
            label: 'Russia',
        },
        {
            value: 'RWA',
            label: 'Rwanda',
        },
        {
            value: 'SRB',
            label: 'Serbia',
        },
        {
            value: 'SWE',
            label: 'Sweden',
        },
        {
            value: 'TCD',
            label: 'Chad',
        },
        {
            value: 'TKM',
            label: 'Turkmenistan',
        },
        {
            value: 'TUR',
            label: 'Turkey',
        },
        {
            value: 'UGA',
            label: 'Uganda',
        },
        {
            value: 'ZMB',
            label: 'Zambia',
        },
        {
            value: 'AFG',
            label: 'Afghanistan',
        },
        {
            value: 'DEU',
            label: 'Germany',
        },
        {
            value: 'DNK',
            label: 'Denmark',
        },
        {
            value: 'FJI',
            label: 'Fiji',
        },
        {
            value: 'FRA',
            label: 'France',
        },
        {
            value: 'IND',
            label: 'India',
        },
        {
            value: 'KEN',
            label: 'Kenya',
        },
        {
            value: 'KGZ',
            label: 'Kyrgyzstan',
        },
        {
            value: 'LBY',
            label: 'Libya',
        },
        {
            value: 'MLI',
            label: 'Mali',
        },
        {
            value: 'POL',
            label: 'Poland',
        },
        {
            value: 'SOM',
            label: 'Somalia',
        },
        {
            value: 'SYR',
            label: 'Syria',
        },
        {
            value: 'TON',
            label: 'Tonga',
        },
        {
            value: 'WSM',
            label: 'Samoa',
        },
        {
            value: 'YEM',
            label: 'Yemen',
        },
        {
            value: 'CHE',
            label: 'Switzerland',
        },
        {
            value: 'CUB',
            label: 'Cuba',
        },
        {
            value: 'CZE',
            label: 'Czech Republic',
        },
        {
            value: 'GRC',
            label: 'Greece',
        },
        {
            value: 'IRL',
            label: 'Ireland',
        },
        {
            value: 'IRQ',
            label: 'Iraq',
        },
        {
            value: 'NLD',
            label: 'Netherlands',
        },
        {
            value: 'OMN',
            label: 'Oman',
        },
        {
            value: 'SAU',
            label: 'Saudi Arabia',
        },
        {
            value: 'SWZ',
            label: 'Eswatini',
        },
        {
            value: 'TJK',
            label: 'Tajikistan',
        },
        {
            value: 'THA',
            label: 'Thailand',
        },
        {
            value: 'LAO',
            label: 'Laos',
        },
        {
            value: 'QAT',
            label: 'Qatar',
        },
        {
            value: 'IRN',
            label: 'Iran',
        },
        {
            value: 'PSE',
            label: 'Palestine',
        },
    ],
    ru: [
        {
            value: 'TTO',
            label: 'Тринидад и Тобаго',
        },
        {
            value: 'DMA',
            label: 'Доминика',
        },
        {
            value: 'KNA',
            label: 'Сент-Китс и Невис',
        },
        {
            value: 'GNQ',
            label: 'Экваториальная Гвинея',
        },
        {
            value: 'ATG',
            label: 'Антигуа и Барбуда',
        },
        {
            value: 'PNG',
            label: 'Папуа-Новая Гвинея',
        },
        {
            value: 'VCT',
            label: 'Святой Винсент и Гренадины',
        },
        {
            value: 'SLB',
            label: 'Соломоновы острова',
        },
        {
            value: 'CAF',
            label: 'Центрально-Африканская Республика',
        },
        {
            value: 'COG',
            label: 'Республика Конго',
        },
        {
            value: 'GNB',
            label: 'Гвинея-Бисау',
        },
        {
            value: 'LIE',
            label: 'Лихтенштейн',
        },
        {
            value: 'COD',
            label: 'Демократическая Республика Конго',
        },
        {
            value: 'DOM',
            label: 'Доминиканская Республика',
        },
        {
            value: 'SLE',
            label: 'Сьерра-Леоне',
        },
        {
            value: 'SSD',
            label: 'Южный Судан',
        },
        {
            value: 'NZL',
            label: 'Новая Зеландия',
        },
        {
            value: 'ZAF',
            label: 'Южная Африка',
        },
        {
            value: 'CPV',
            label: 'Кабо-Верде',
        },
        {
            value: 'KOR',
            label: 'Южная Корея',
        },
        {
            value: 'LCA',
            label: 'Санет-Люсия',
        },
        {
            value: 'LUX',
            label: 'Люксембург',
        },
        {
            value: 'PRK',
            label: 'Северная Корея',
        },
        {
            value: 'SMR',
            label: 'Сан-Марино',
        },
        {
            value: 'ARG',
            label: 'Аргентина',
        },
        {
            value: 'AZE',
            label: 'Азербайджан',
        },
        {
            value: 'BGD',
            label: 'Бангладеш',
        },
        {
            value: 'CMR',
            label: 'Камерун',
        },
        {
            value: 'CRI',
            label: 'Коста-Рика',
        },
        {
            value: 'FSM',
            label: 'Микронезия',
        },
        {
            value: 'KAZ',
            label: 'Казахстан',
        },
        {
            value: 'MHL',
            label: 'Маршалловы острова',
        },
        {
            value: 'MNE',
            label: 'Черногория',
        },
        {
            value: 'MRT',
            label: 'Мавритания',
        },
        {
            value: 'SGP',
            label: 'Сингапур',
        },
        {
            value: 'SYC',
            label: 'Сейшельские острова',
        },
        {
            value: 'UZB',
            label: 'Узбекистан',
        },
        {
            value: 'VNM',
            label: 'Вьетнам',
        },
        {
            value: 'AUS',
            label: 'Австралия',
        },
        {
            value: 'BLR',
            label: 'Беларусь',
        },
        {
            value: 'ECU',
            label: 'Эквадор',
        },
        {
            value: 'GTM',
            label: 'Гватемала',
        },
        {
            value: 'IDN',
            label: 'Индонезия',
        },
        {
            value: 'KIR',
            label: 'Кирибати',
        },
        {
            value: 'LKA',
            label: 'Шри-Ланка',
        },
        {
            value: 'LTU',
            label: 'Литва',
        },
        {
            value: 'MKD',
            label: 'Македония',
        },
        {
            value: 'MOZ',
            label: 'Мозамбик',
        },
        {
            value: 'NIC',
            label: 'Никарагуа',
        },
        {
            value: 'PAN',
            label: 'Панама',
        },
        {
            value: 'PRT',
            label: 'Португалия',
        },
        {
            value: 'PRY',
            label: 'Парагвай',
        },
        {
            value: 'SEN',
            label: 'Сенегал',
        },
        {
            value: 'SLV',
            label: 'Сальвадор',
        },
        {
            value: 'STP',
            label: 'Сан-Томе и Принсипи',
        },
        {
            value: 'TZA',
            label: 'Танзания',
        },
        {
            value: 'VEN',
            label: 'Венесуэла',
        },
        {
            value: 'ZWE',
            label: 'Зимбабве',
        },
        {
            value: 'BDI',
            label: 'Бурунди',
        },
        {
            value: 'BFA',
            label: 'Буркина-Фасо',
        },
        {
            value: 'BGR',
            label: 'Болгария',
        },
        {
            value: 'BHS',
            label: 'Багамы',
        },
        {
            value: 'BRA',
            label: 'Бразилия',
        },
        {
            value: 'BRB',
            label: 'Барбадос',
        },
        {
            value: 'BRN',
            label: 'Бруней',
        },
        {
            value: 'BTN',
            label: 'Бутан',
        },
        {
            value: 'COL',
            label: 'Колумбия',
        },
        {
            value: 'ETH',
            label: 'Эфиопия',
        },
        {
            value: 'GRD',
            label: 'Гренада',
        },
        {
            value: 'HUN',
            label: 'Венгрия',
        },
        {
            value: 'ISL',
            label: 'Исландия',
        },
        {
            value: 'JOR',
            label: 'Иордания',
        },
        {
            value: 'KHM',
            label: 'Камбоджа',
        },
        {
            value: 'MDA',
            label: 'Молдова',
        },
        {
            value: 'MNG',
            label: 'Монголия',
        },
        {
            value: 'MUS',
            label: 'Маврикий',
        },
        {
            value: 'MYS',
            label: 'Малайзия',
        },
        {
            value: 'NOR',
            label: 'Норвегия',
        },
        {
            value: 'PAK',
            label: 'Пакистан',
        },
        {
            value: 'PHL',
            label: 'Филиппины',
        },
        {
            value: 'SUR',
            label: 'Суринам',
        },
        {
            value: 'SVK',
            label: 'Словакия',
        },
        {
            value: 'SVN',
            label: 'Словения',
        },
        {
            value: 'UKR',
            label: 'Украина',
        },
        {
            value: 'URY',
            label: 'Уругвай',
        },
        {
            value: 'VUT',
            label: 'Вануату',
        },
        {
            value: 'ALB',
            label: 'Албания',
        },
        {
            value: 'AND',
            label: 'Андорра',
        },
        {
            value: 'ARM',
            label: 'Армения',
        },
        {
            value: 'AUT',
            label: 'Австрия',
        },
        {
            value: 'BEN',
            label: 'Бенин',
        },
        {
            value: 'BHR',
            label: 'Бахрейн',
        },
        {
            value: 'BLZ',
            label: 'Белиз',
        },
        {
            value: 'BOL',
            label: 'Боливия',
        },
        {
            value: 'BWA',
            label: 'Ботсвана',
        },
        {
            value: 'CAN',
            label: 'Канада',
        },
        {
            value: 'DJI',
            label: 'Джибути',
        },
        {
            value: 'DZA',
            label: 'Алжир',
        },
        {
            value: 'EGY',
            label: 'Египет',
        },
        {
            value: 'ERI',
            label: 'Эритрея',
        },
        {
            value: 'EST',
            label: 'Эстония',
        },
        {
            value: 'GAB',
            label: 'Габон',
        },
        {
            value: 'GEO',
            label: 'Грузия',
        },
        {
            value: 'GHA',
            label: 'Гана',
        },
        {
            value: 'GUY',
            label: 'Гайана',
        },
        {
            value: 'HND',
            label: 'Гондурас',
        },
        {
            value: 'HRV',
            label: 'Хорватия',
        },
        {
            value: 'JAM',
            label: 'Ямайка',
        },
        {
            value: 'JPN',
            label: 'Япония',
        },
        {
            value: 'LBN',
            label: 'Ливан',
        },
        {
            value: 'LBR',
            label: 'Либерия',
        },
        {
            value: 'MAR',
            label: 'Марокко',
        },
        {
            value: 'MDG',
            label: 'Мадагаскар',
        },
        {
            value: 'MDV',
            label: 'Мальдивы',
        },
        {
            value: 'MMR',
            label: 'Мьянма',
        },
        {
            value: 'MWI',
            label: 'Малави',
        },
        {
            value: 'NAM',
            label: 'Намибия',
        },
        {
            value: 'NER',
            label: 'Нигер',
        },
        {
            value: 'NGA',
            label: 'Нигерия',
        },
        {
            value: 'NPL',
            label: 'Непал',
        },
        {
            value: 'PER',
            label: 'Перу',
        },
        {
            value: 'ROU',
            label: 'Румыния',
        },
        {
            value: 'SDN',
            label: 'Судан',
        },
        {
            value: 'TGO',
            label: 'Того',
        },
        {
            value: 'TLS',
            label: 'Восточный Тимор',
        },
        {
            value: 'TUN',
            label: 'Тунис',
        },
        {
            value: 'TUV',
            label: 'Тувалу',
        },
        {
            value: 'USA',
            label: 'Соединенные Штаты Америки',
        },
        {
            value: 'AGO',
            label: 'Ангола',
        },
        {
            value: 'ARE',
            label: 'Объединенные Арабские Эмираты',
        },
        {
            value: 'BEL',
            label: 'Бельгия',
        },
        {
            value: 'BIH',
            label: 'Босния и Герцеговина',
        },
        {
            value: 'CHL',
            label: 'Чили',
        },
        {
            value: 'CHN',
            label: 'Китай',
        },
        {
            value: 'CIV',
            label: 'Кот-д’Ивуар',
        },
        {
            value: 'COM',
            label: 'Коморские острова',
        },
        {
            value: 'CYP',
            label: 'Кипр',
        },
        {
            value: 'ESP',
            label: 'Испания',
        },
        {
            value: 'FIN',
            label: 'Финляндия',
        },
        {
            value: 'GBR',
            label: 'Великобритания',
        },
        {
            value: 'GIN',
            label: 'Гвинея',
        },
        {
            value: 'GMB',
            label: 'Гамбия',
        },
        {
            value: 'HTI',
            label: 'Гаити',
        },
        {
            value: 'ITA',
            label: 'Италия',
        },
        {
            value: 'KWT',
            label: 'Кувейт',
        },
        {
            value: 'LSO',
            label: 'Лесото',
        },
        {
            value: 'LVA',
            label: 'Латвия',
        },
        {
            value: 'MCO',
            label: 'Монако',
        },
        {
            value: 'MEX',
            label: 'Мексика',
        },
        {
            value: 'MLT',
            label: 'Мальта',
        },
        {
            value: 'NRU',
            label: 'Науру',
        },
        {
            value: 'PLW',
            label: 'Палау',
        },
        {
            value: 'RUS',
            label: 'Россия',
        },
        {
            value: 'RWA',
            label: 'Руанда',
        },
        {
            value: 'SRB',
            label: 'Сербия',
        },
        {
            value: 'SWE',
            label: 'Швеция',
        },
        {
            value: 'TCD',
            label: 'Чад',
        },
        {
            value: 'TKM',
            label: 'Туркменистан',
        },
        {
            value: 'TUR',
            label: 'Турция',
        },
        {
            value: 'UGA',
            label: 'Уганда',
        },
        {
            value: 'ZMB',
            label: 'Замбия',
        },
        {
            value: 'AFG',
            label: 'Афганистан',
        },
        {
            value: 'DEU',
            label: 'Германия',
        },
        {
            value: 'DNK',
            label: 'Дания',
        },
        {
            value: 'FJI',
            label: 'Фиджи',
        },
        {
            value: 'FRA',
            label: 'Франция',
        },
        {
            value: 'IND',
            label: 'Индия',
        },
        {
            value: 'KEN',
            label: 'Кения',
        },
        {
            value: 'KGZ',
            label: 'Кыргызстан',
        },
        {
            value: 'LBY',
            label: 'Ливия',
        },
        {
            value: 'MLI',
            label: 'Мали',
        },
        {
            value: 'POL',
            label: 'Польша',
        },
        {
            value: 'SOM',
            label: 'Сомали',
        },
        {
            value: 'SYR',
            label: 'Сирия',
        },
        {
            value: 'TON',
            label: 'Тонга',
        },
        {
            value: 'WSM',
            label: 'Самоа',
        },
        {
            value: 'YEM',
            label: 'Йемен',
        },
        {
            value: 'CHE',
            label: 'Швейцария',
        },
        {
            value: 'CUB',
            label: 'Куба',
        },
        {
            value: 'CZE',
            label: 'Чехия',
        },
        {
            value: 'GRC',
            label: 'Греция',
        },
        {
            value: 'IRL',
            label: 'Ирландия',
        },
        {
            value: 'IRQ',
            label: 'Ирак',
        },
        {
            value: 'NLD',
            label: 'Нидерланды',
        },
        {
            value: 'OMN',
            label: 'Оман',
        },
        {
            value: 'SAU',
            label: 'Саудовская Аравия',
        },
        {
            value: 'SWZ',
            label: 'Эсватини',
        },
        {
            value: 'TJK',
            label: 'Таджикистан',
        },
        {
            value: 'THA',
            label: 'Таиланд',
        },
        {
            value: 'LAO',
            label: 'Лаос',
        },
        {
            value: 'QAT',
            label: 'Катар',
        },
        {
            value: 'IRN',
            label: 'Иран',
        },
        {
            value: 'PSE',
            label: 'Палестина',
        },
    ],
    uz: [
        {
            value: 'TTO',
            label: 'Trinidad va Tobago',
        },
        {
            value: 'DMA',
            label: 'Dominika',
        },
        {
            value: 'KNA',
            label: 'Sent Kits va Nevis',
        },
        {
            value: 'GNQ',
            label: 'Ekvatorial Gvineya',
        },
        {
            value: 'ATG',
            label: 'Antigua va Berbuda',
        },
        {
            value: 'PNG',
            label: 'Papua Yangi Gvineya',
        },
        {
            value: 'VCT',
            label: 'Sent Vinsent va Grinada',
        },
        {
            value: 'SLB',
            label: 'Solomon Orollari',
        },
        {
            value: 'CAF',
            label: 'Markaziy Afrika Respublikasi',
        },
        {
            value: 'COG',
            label: 'Kongo Respublikasi',
        },
        {
            value: 'GNB',
            label: 'Gvineya-Bisau',
        },
        {
            value: 'LIE',
            label: 'Lixtenshteyn',
        },
        {
            value: 'COD',
            label: 'Kongo Demokratik Respublikasi',
        },
        {
            value: 'DOM',
            label: 'Dominika Respublikasi',
        },
        {
            value: 'SLE',
            label: 'Sierra-Leone',
        },
        {
            value: 'SSD',
            label: 'Janubiy Sudan',
        },
        {
            value: 'NZL',
            label: 'Yangi Zalandiya',
        },
        {
            value: 'ZAF',
            label: 'Janibiy Afrika',
        },
        {
            value: 'CPV',
            label: 'Kabo-Verde',
        },
        {
            value: 'KOR',
            label: 'Janubiy Korea',
        },
        {
            value: 'LCA',
            label: 'Sanet-Lyusiya',
        },
        {
            value: 'LUX',
            label: 'Lyuksemburg',
        },
        {
            value: 'PRK',
            label: 'Shimoliy Korea',
        },
        {
            value: 'SMR',
            label: 'San-Marino',
        },
        {
            value: 'ARG',
            label: 'Argentina',
        },
        {
            value: 'AZE',
            label: 'Ozarbayjon',
        },
        {
            value: 'BGD',
            label: 'Bangladesh',
        },
        {
            value: 'CMR',
            label: 'Kamerun',
        },
        {
            value: 'CRI',
            label: 'Kosta Rika',
        },
        {
            value: 'FSM',
            label: 'Mikroneziya',
        },
        {
            value: 'KAZ',
            label: 'Qozog’iston',
        },
        {
            value: 'MHL',
            label: 'Marshal Orollari',
        },
        {
            value: 'MNE',
            label: 'Chernogoriya',
        },
        {
            value: 'MRT',
            label: 'Mavritaniya',
        },
        {
            value: 'SGP',
            label: 'Singapur',
        },
        {
            value: 'SYC',
            label: 'Seyshel orollari',
        },
        {
            value: 'UZB',
            label: 'O’zbekiston',
        },
        {
            value: 'VNM',
            label: 'Vietnam',
        },
        {
            value: 'AUS',
            label: 'Avstraliya',
        },
        {
            value: 'BLR',
            label: 'Belorusiya',
        },
        {
            value: 'ECU',
            label: 'Ekvador',
        },
        {
            value: 'GTM',
            label: 'Gvatemala',
        },
        {
            value: 'IDN',
            label: 'Indoneziya',
        },
        {
            value: 'KIR',
            label: 'Kiribati',
        },
        {
            value: 'LKA',
            label: 'Shri Lanka',
        },
        {
            value: 'LTU',
            label: 'Litva',
        },
        {
            value: 'MKD',
            label: 'Makedoniya',
        },
        {
            value: 'MOZ',
            label: 'Mozambik',
        },
        {
            value: 'NIC',
            label: 'Nikaragua',
        },
        {
            value: 'PAN',
            label: 'Panama',
        },
        {
            value: 'PRT',
            label: 'Portugaliya',
        },
        {
            value: 'PRY',
            label: 'Paragvay',
        },
        {
            value: 'SEN',
            label: 'Senegal',
        },
        {
            value: 'SLV',
            label: 'Salvador',
        },
        {
            value: 'STP',
            label: 'San Tome va Prinsipi',
        },
        {
            value: 'TZA',
            label: 'Tanzaniya',
        },
        {
            value: 'VEN',
            label: 'Venesuela',
        },
        {
            value: 'ZWE',
            label: 'Zimbabve',
        },
        {
            value: 'BDI',
            label: 'Burundi',
        },
        {
            value: 'BFA',
            label: 'Burkina Faso',
        },
        {
            value: 'BGR',
            label: 'Bolgariya',
        },
        {
            value: 'BHS',
            label: 'Bogama orollari',
        },
        {
            value: 'BRA',
            label: 'Braziliya',
        },
        {
            value: 'BRB',
            label: 'Barbados',
        },
        {
            value: 'BRN',
            label: 'Bruney',
        },
        {
            value: 'BTN',
            label: 'Butan',
        },
        {
            value: 'COL',
            label: 'Kolumbiya',
        },
        {
            value: 'ETH',
            label: 'Efiyopiya',
        },
        {
            value: 'GRD',
            label: 'Grenada',
        },
        {
            value: 'HUN',
            label: 'Vengriya',
        },
        {
            value: 'ISL',
            label: 'Islandiya',
        },
        {
            value: 'JOR',
            label: 'Yordaniya',
        },
        {
            value: 'KHM',
            label: 'Kombodja',
        },
        {
            value: 'MDA',
            label: 'Moldova',
        },
        {
            value: 'MNG',
            label: 'Mongoliya',
        },
        {
            value: 'MUS',
            label: 'Mavrikiy',
        },
        {
            value: 'MYS',
            label: 'Malayziya',
        },
        {
            value: 'NOR',
            label: 'Norvegiya',
        },
        {
            value: 'PAK',
            label: 'Pokiston',
        },
        {
            value: 'PHL',
            label: 'Filipin',
        },
        {
            value: 'SUR',
            label: 'Suriname',
        },
        {
            value: 'SVK',
            label: 'Slovakiya',
        },
        {
            value: 'SVN',
            label: 'Sloveniya',
        },
        {
            value: 'UKR',
            label: 'Ukraina',
        },
        {
            value: 'URY',
            label: 'Urugvay',
        },
        {
            value: 'VUT',
            label: 'Vanuatu',
        },
        {
            value: 'ALB',
            label: 'Albaniya',
        },
        {
            value: 'AND',
            label: 'Andorra',
        },
        {
            value: 'ARM',
            label: 'Armaniston',
        },
        {
            value: 'AUT',
            label: 'Avstriya',
        },
        {
            value: 'BEN',
            label: 'Benin',
        },
        {
            value: 'BHR',
            label: 'Bahrayn',
        },
        {
            value: 'BLZ',
            label: 'Beliz',
        },
        {
            value: 'BOL',
            label: 'Boliviya',
        },
        {
            value: 'BWA',
            label: 'Botsvana',
        },
        {
            value: 'CAN',
            label: 'Kanada',
        },
        {
            value: 'DJI',
            label: 'Djibuti',
        },
        {
            value: 'DZA',
            label: 'Jazoyir',
        },
        {
            value: 'EGY',
            label: 'Misr',
        },
        {
            value: 'ERI',
            label: 'Eritriya',
        },
        {
            value: 'EST',
            label: 'Estoniya',
        },
        {
            value: 'GAB',
            label: 'Gabon',
        },
        {
            value: 'GEO',
            label: 'Gruziya',
        },
        {
            value: 'GHA',
            label: 'Gana',
        },
        {
            value: 'GUY',
            label: 'Gayana',
        },
        {
            value: 'HND',
            label: 'Gonduras',
        },
        {
            value: 'HRV',
            label: 'Horvatiya',
        },
        {
            value: 'JAM',
            label: 'Yamayka',
        },
        {
            value: 'JPN',
            label: 'Yaponiya',
        },
        {
            value: 'LBN',
            label: 'Livan',
        },
        {
            value: 'LBR',
            label: 'Liberiya',
        },
        {
            value: 'MAR',
            label: 'Marokash',
        },
        {
            value: 'MDG',
            label: 'Madagaskar',
        },
        {
            value: 'MDV',
            label: 'Maldiv orollari',
        },
        {
            value: 'MMR',
            label: 'Myanmar',
        },
        {
            value: 'MWI',
            label: 'Malavi',
        },
        {
            value: 'NAM',
            label: 'Namibiya',
        },
        {
            value: 'NER',
            label: 'Niger',
        },
        {
            value: 'NGA',
            label: 'Nigeriya',
        },
        {
            value: 'NPL',
            label: 'Nepal',
        },
        {
            value: 'PER',
            label: 'Peru',
        },
        {
            value: 'ROU',
            label: 'Ruminiya',
        },
        {
            value: 'SDN',
            label: 'Sudan',
        },
        {
            value: 'TGO',
            label: 'Togo',
        },
        {
            value: 'TLS',
            label: 'Sharqiy Timor',
        },
        {
            value: 'TUN',
            label: 'Tunisiya',
        },
        {
            value: 'TUV',
            label: 'Tuvalu',
        },
        {
            value: 'USA',
            label: 'Amerika Qo’shma Shtatlari',
        },
        {
            value: 'AGO',
            label: 'Angola',
        },
        {
            value: 'ARE',
            label: 'Birlashgan Arab Amirliklari',
        },
        {
            value: 'BEL',
            label: 'Belgiya',
        },
        {
            value: 'BIH',
            label: 'Bosniya va Gertsogavina',
        },
        {
            value: 'CHL',
            label: 'Chili',
        },
        {
            value: 'CHN',
            label: 'Xitoy',
        },
        {
            value: 'CIV',
            label: 'Kote d’Iuvar',
        },
        {
            value: 'COM',
            label: 'Komor Orollari',
        },
        {
            value: 'CYP',
            label: 'Kipr',
        },
        {
            value: 'ESP',
            label: 'Ispaniya',
        },
        {
            value: 'FIN',
            label: 'Finlandiya',
        },
        {
            value: 'GBR',
            label: 'Buyuk Britaniya',
        },
        {
            value: 'GIN',
            label: 'Gvineya',
        },
        {
            value: 'GMB',
            label: 'Gambiya',
        },
        {
            value: 'HTI',
            label: 'Gaiti',
        },
        {
            value: 'ITA',
            label: 'Italya',
        },
        {
            value: 'KWT',
            label: 'Qavayt',
        },
        {
            value: 'LSO',
            label: 'Leseto',
        },
        {
            value: 'LVA',
            label: 'Latviya',
        },
        {
            value: 'MCO',
            label: 'Monako',
        },
        {
            value: 'MEX',
            label: 'Meksika',
        },
        {
            value: 'MLT',
            label: 'Malta',
        },
        {
            value: 'NRU',
            label: 'Nauri',
        },
        {
            value: 'PLW',
            label: 'Palau',
        },
        {
            value: 'RUS',
            label: 'Rossiya',
        },
        {
            value: 'RWA',
            label: 'Ruanda',
        },
        {
            value: 'SRB',
            label: 'Serbiya',
        },
        {
            value: 'SWE',
            label: 'Shvetsiya',
        },
        {
            value: 'TCD',
            label: 'Chad',
        },
        {
            value: 'TKM',
            label: 'Turkmaniston',
        },
        {
            value: 'TUR',
            label: 'Turkiya',
        },
        {
            value: 'UGA',
            label: 'Uganda',
        },
        {
            value: 'ZMB',
            label: 'Zambiya',
        },
        {
            value: 'AFG',
            label: 'Afg’oniston',
        },
        {
            value: 'DEU',
            label: 'Germaniya',
        },
        {
            value: 'DNK',
            label: 'Daniya',
        },
        {
            value: 'FJI',
            label: 'Fiji',
        },
        {
            value: 'FRA',
            label: 'Fransiya',
        },
        {
            value: 'IND',
            label: 'Hindiston',
        },
        {
            value: 'KEN',
            label: 'Keniya',
        },
        {
            value: 'KGZ',
            label: 'Qirg’iziston',
        },
        {
            value: 'LBY',
            label: 'Liviya',
        },
        {
            value: 'MLI',
            label: 'Mali',
        },
        {
            value: 'POL',
            label: 'Polsha',
        },
        {
            value: 'SOM',
            label: 'Somaliya',
        },
        {
            value: 'SYR',
            label: 'Suriya',
        },
        {
            value: 'TON',
            label: 'Tongo',
        },
        {
            value: 'WSM',
            label: 'Samoa',
        },
        {
            value: 'YEM',
            label: 'Yaman',
        },
        {
            value: 'CHE',
            label: 'Shveytsariya',
        },
        {
            value: 'CUB',
            label: 'Kuba',
        },
        {
            value: 'CZE',
            label: 'Chexiya',
        },
        {
            value: 'GRC',
            label: 'Gretsiya',
        },
        {
            value: 'IRL',
            label: 'Irlandiya',
        },
        {
            value: 'IRQ',
            label: 'Iroq',
        },
        {
            value: 'NLD',
            label: 'Gollandiya',
        },
        {
            value: 'OMN',
            label: 'Ummon',
        },
        {
            value: 'SAU',
            label: 'Saudiya Arabistoni',
        },
        {
            value: 'SWZ',
            label: 'Esvatini',
        },
        {
            value: 'TJK',
            label: 'Tojikiston',
        },
        {
            value: 'THA',
            label: 'Tailand',
        },
        {
            value: 'LAO',
            label: 'Laos',
        },
        {
            value: 'QAT',
            label: 'Qatar',
        },
        {
            value: 'IRN',
            label: 'Eron',
        },
        {
            value: 'PSE',
            label: 'Falastin',
        },
    ],
};
function compare(a, b) {
    var labelA = a.label;
    var labelB = b.label;
    return labelA.localeCompare(labelB);
}
countries$1.en && countries$1.en.sort(compare);
countries$1.ar && countries$1.ar.sort(compare);
countries$1.ka && countries$1.ka.sort(compare);
var daysArr = [];
for (var i = 1; i <= 31; i++) {
    daysArr.push({ id: i, label: i, value: i });
}
var days = daysArr;
var months = {
    en: [
        { id: 1, label: 'January', value: 1 },
        { id: 2, label: 'Febuary', value: 2 },
        { id: 3, label: 'March', value: 3 },
        { id: 4, label: 'April', value: 4 },
        { id: 5, label: 'May', value: 5 },
        { id: 6, label: 'June', value: 6 },
        { id: 7, label: 'July', value: 7 },
        { id: 8, label: 'August', value: 8 },
        { id: 9, label: 'September', value: 9 },
        { id: 10, label: 'October', value: 10 },
        { id: 11, label: 'November', value: 11 },
        { id: 12, label: 'December', value: 12 },
    ],
    ar: [
        { id: 1, label: 'يناير', value: 1 },
        { id: 2, label: 'فبراير', value: 2 },
        { id: 3, label: 'مارس', value: 3 },
        { id: 4, label: 'أبريل', value: 4 },
        { id: 5, label: 'مايو', value: 5 },
        { id: 6, label: 'يونيو', value: 6 },
        { id: 7, label: 'يوليو', value: 7 },
        { id: 8, label: 'أغسطس', value: 8 },
        { id: 9, label: 'سبتمبر', value: 9 },
        { id: 10, label: 'أكتوبر', value: 10 },
        { id: 11, label: 'نوفمبر', value: 11 },
        { id: 12, label: 'ديسمبر', value: 12 },
    ],
    ka: [
        { id: 1, label: 'იანვარი', value: 1 },
        { id: 2, label: 'თებერვალი', value: 2 },
        { id: 3, label: 'მარტი', value: 3 },
        { id: 4, label: 'აპრილი', value: 4 },
        { id: 5, label: 'მაისი', value: 5 },
        { id: 6, label: 'ივნისი', value: 6 },
        { id: 7, label: 'ივლისი', value: 7 },
        { id: 8, label: 'აგვისტო', value: 8 },
        { id: 9, label: 'სექტემბერი', value: 9 },
        { id: 10, label: 'ოქტომბერი', value: 10 },
        { id: 11, label: 'ნოემბერი', value: 11 },
        { id: 12, label: 'დეკემბერი', value: 12 },
    ],
    uz: [
        { id: 1, label: 'yanvar', value: 1 },
        { id: 2, label: 'fevral', value: 2 },
        { id: 3, label: 'mart', value: 3 },
        { id: 4, label: 'aprel', value: 4 },
        { id: 5, label: 'may', value: 5 },
        { id: 6, label: 'iyun', value: 6 },
        { id: 7, label: 'iyul', value: 7 },
        { id: 8, label: 'avgust', value: 8 },
        { id: 9, label: 'sentabr', value: 9 },
        { id: 10, label: 'oktabr', value: 10 },
        { id: 11, label: 'noyabr', value: 11 },
        { id: 12, label: 'dekabr', value: 12 },
    ],
    ru: [
        { id: 1, label: 'январь', value: 1 },
        { id: 2, label: 'февраль', value: 2 },
        { id: 3, label: 'март', value: 3 },
        { id: 4, label: 'апрель', value: 4 },
        { id: 5, label: 'май', value: 5 },
        { id: 6, label: 'июнь', value: 6 },
        { id: 7, label: 'июль', value: 7 },
        { id: 8, label: 'август', value: 8 },
        { id: 9, label: 'сентябрь', value: 9 },
        { id: 10, label: 'октябрь', value: 10 },
        { id: 11, label: 'ноябрь', value: 11 },
        { id: 12, label: 'декабрь', value: 12 },
    ],
    hy: [
        { id: 1, label: 'Յունուար', value: 1 },
        { id: 2, label: 'Փետրուար', value: 2 },
        { id: 3, label: 'Մարտ', value: 3 },
        { id: 4, label: 'Ապրիլ', value: 4 },
        { id: 5, label: 'Մայիս', value: 5 },
        { id: 6, label: 'Յունիս', value: 6 },
        { id: 7, label: 'Յուլիս', value: 7 },
        { id: 8, label: 'Օգոստոս', value: 8 },
        { id: 9, label: 'Սեպտեմբեր', value: 9 },
        { id: 10, label: 'Հոկտեմբեր', value: 10 },
        { id: 11, label: 'Նոյեմբեր', value: 11 },
        { id: 12, label: 'Դեկտեմբեր', value: 12 },
    ],
};
var CompleteYourProfile = function (_a) {
    var t = _a.t, onSuccess = _a.onSuccess;
    var _b = __read$1(useState(PolicyAccept.YES), 2), policyAccept = _b[0], setSubscribe = _b[1];
    var _c = __read$1(useState(true), 2), showModal = _c[0], setShowModal = _c[1];
    var _d = __read$1(useState(), 2), updateProfilePayload = _d[0], setUpdateProfilePayload = _d[1];
    var dispatch = useDispatch();
    var _e = __read$1(useState(false), 2), isVerifyPhoneModalOpen = _e[0], setVerifyPhoneModalOpen = _e[1];
    var _f = __read$1(useState(false), 2), phoneNumberExist = _f[0], setPhoneNumberExist = _f[1];
    var selectFormElements = [
        { field_name: 'nationality' },
        { field_name: 'birth_date' },
        { field_name: 'birth_month' },
        { field_name: 'birth_year' },
    ];
    var _g = useSelector(function (state) { return (__assign$1({}, __assign$1(__assign$1(__assign$1({}, state.userData), state.appConfig), { isLoading: state.userData.isLoading }))); }), email = _g.email, isLoading = _g.isLoading, _h = _g.language, language = _h === void 0 ? 'en' : _h, phoneCountryCode = _g.phoneCountryCode, phoneExpression = _g.phoneExpression, storeId = _g.storeId, code = _g.code, features = _g.features;
    var _j = useForm({
        mode: 'onChange',
    }), register = _j.register, handleSubmit = _j.handleSubmit, errors = _j.errors, control = _j.control, setError = _j.setError, clearErrors = _j.clearErrors, getValues = _j.getValues;
    var onPhoneChange = function (phoneNumber) {
        if (phoneNumber) {
            verifyUserPhoneNumber(formatPhoneNo(phoneNumber), function (apiResponse) {
                var _a;
                handlePhoneExist((_a = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.data) === null || _a === void 0 ? void 0 : _a.customerExist);
            })(dispatch);
        }
    };
    var onChangeSubscribe = function () {
        var policyAcc = policyAccept === PolicyAccept.NO ? PolicyAccept.YES : PolicyAccept.NO;
        setSubscribe(policyAcc);
    };
    var onClickSubmit = function (data) {
        handleSubmit(onSubmit, function () {
            isValidAllSelectBoxItems(getValues(), selectFormElements);
        })(data);
    };
    var isValidAllSelectBoxItems = function (data, fieldNames) {
        var isValid = true;
        fieldNames.map(function (fieldData) {
            var _a;
            if (!((_a = data[fieldData.field_name]) === null || _a === void 0 ? void 0 : _a.value) && policyAccept === PolicyAccept.YES) {
                setError(fieldData.field_name, {
                    type: 'required',
                });
                isValid = false;
            }
            else {
                clearErrors(fieldData.field_name);
            }
            return fieldData;
        });
        return isValid;
    };
    var handlePhoneExist = function (phoneExist) {
        if (phoneExist) {
            setError('phone_no', {
                type: 'phone_exist',
                message: t('verifyOTP.CustomerPhoneConflictError'),
            });
            setPhoneNumberExist(true);
        }
        else {
            clearErrors('phone_no');
            setPhoneNumberExist(false);
        }
    };
    var addLeadingZero = function (value) { return (value < 10 ? "0" + value : value.toString()); };
    var formatBirthDate = function (year, month, day) {
        return year + "-" + addLeadingZero(month) + "-" + addLeadingZero(day);
    };
    var formatPhoneNo = function (phoneNumber) { return "" + +(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/^0/, '')); };
    var onSubmit = function (data) {
        var _a, _b, _c, _d;
        handlePhoneExist(phoneNumberExist);
        if ((isValidAllSelectBoxItems(data, selectFormElements) === true || policyAccept !== PolicyAccept.YES) &&
            !phoneNumberExist) {
            var profileUpdateData = {
                birthday: policyAccept === PolicyAccept.YES
                    ? formatBirthDate((_a = data.birth_year) === null || _a === void 0 ? void 0 : _a.value, (_b = data.birth_month) === null || _b === void 0 ? void 0 : _b.value, (_c = data.birth_date) === null || _c === void 0 ? void 0 : _c.value)
                    : '',
                mobileNumberType: 'mobile',
                nationality: (_d = data.nationality) === null || _d === void 0 ? void 0 : _d.value,
                newEmail: email,
                newMobileNumber: "" + phoneCountryCode + formatPhoneNo(data.phone_no),
                oldEmail: email,
                title: data.title,
                isPhoneVerified: true,
            };
            setUpdateProfilePayload(profileUpdateData);
            setVerifyPhoneModalOpen(true);
        }
    };
    var onVerifyAccount = function (uuid) {
        var payload = __assign$1(__assign$1({}, updateProfilePayload), { uuid: uuid });
        userProfileUpdate(payload, function (res) {
            if (res.meta.statusCode === 200) {
                localStorage.removeItem('userLoggedIn');
                localStorage.setItem('userRegistered', '1');
                localStorage.setItem('userLoggedIn', '1');
                if (((features === null || features === void 0 ? void 0 : features.share) && policyAccept === PolicyAccept.YES) || !(features === null || features === void 0 ? void 0 : features.share)) {
                    var loyaltyPayload = (features === null || features === void 0 ? void 0 : features.share) ? { type: 'share' }
                        : {
                            cardNumber: '',
                            country: code,
                            secretQuestion: 'What is your mobile number?',
                            secretAnswer: updateProfilePayload === null || updateProfilePayload === void 0 ? void 0 : updateProfilePayload.newMobileNumber,
                            type: 'address',
                            title: updateProfilePayload === null || updateProfilePayload === void 0 ? void 0 : updateProfilePayload.title,
                            mobileNumber: updateProfilePayload === null || updateProfilePayload === void 0 ? void 0 : updateProfilePayload.newMobileNumber,
                            preferredLanguage: language,
                        };
                    var type = (features === null || features === void 0 ? void 0 : features.share) ? 'share' : 'myclub';
                    createLoyaltyAccount(loyaltyPayload, type)(dispatch);
                }
                refreshToken(onSuccess)(dispatch);
                setVerifyPhoneModalOpen(!isVerifyPhoneModalOpen);
                setShowModal(false);
            }
        })(dispatch);
    };
    useEffect(function () {
        if (!isLoading) {
            setVerifyPhoneModalOpen(false);
        }
    }, [isLoading]);
    var toggleSetVerifyPhoneModalOpen = useCallback(function () {
        setVerifyPhoneModalOpen(!isVerifyPhoneModalOpen);
    }, [isVerifyPhoneModalOpen]);
    var renderData = function () {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement(CompleteProfileTitle, null, t('completeYourProfile.screenTitle')),
            React.createElement(FormContainer, { "data-testid": "__complete_your_profile__" },
                React.createElement(Text.H3, null, t('completeYourProfile.titleText')),
                React.createElement(Flex, { justifyContent: "space-between" },
                    React.createElement(RadioButtonStyle, null,
                        React.createElement("input", { type: "radio", name: "title", ref: register({ required: true }), value: "Mr" }),
                        " \u00A0",
                        React.createElement("span", null, t('completeYourProfile.mr'))),
                    React.createElement(RadioButtonStyle, null,
                        React.createElement("input", { type: "radio", name: "title", ref: register({ required: true }), value: "Mrs" }),
                        "\u00A0",
                        React.createElement("label", null, t('completeYourProfile.mrs'))),
                    storeId !== EStoreID.MAFGEO && (React.createElement(RadioButtonStyle, null,
                        React.createElement("input", { type: "radio", name: "title", ref: register({ required: true }), value: "Ms" }),
                        "\u00A0",
                        React.createElement("label", null, t('completeYourProfile.ms'))))),
                errors.title && React.createElement(WarningMessage$1, { ml: 1 }, t('completeYourProfile.titleRequired')),
                React.createElement(Flex, { justifyContent: "space-between" },
                    React.createElement(SmallInputBox, null,
                        React.createElement(Input, { defaultValue: phoneCountryCode, name: "country_code", variant: errors.country_code ? 'error' : 'primary', register: register({}), disabled: true }),
                        errors.country_code && React.createElement(WarningMessage$1, null, errors.country_code.message)),
                    React.createElement(MidInputBox, null,
                        React.createElement(Input, { label: t('completeYourProfile.mobileNumber'), defaultValue: "", name: "phone_no", variant: errors.phone_no ? 'error' : 'primary', onBlur: function (e) { return !errors.phone_no && onPhoneChange(e.target.value); }, register: register({
                                required: t('completeYourProfile.mobileNumberRequired'),
                                pattern: {
                                    value: RegExp(phoneExpression),
                                    message: t('completeYourProfile.invalidMobileNumber'),
                                },
                            }), "data-testid": "__phone_no__" }),
                        errors.phone_no && React.createElement(WarningMessage$1, null, errors.phone_no.message))),
                React.createElement(InputContainerPadding$1, null, t('completeYourProfile.weWillOnlyCallYou')),
                policyAccept === PolicyAccept.YES ? (React.createElement(React.Fragment, null,
                    React.createElement(DOBLabel, null, t('completeYourProfile.dobFullText')),
                    React.createElement(Flex, { justifyContent: "space-between", width: "98%" },
                        React.createElement(SmallInputBox, null,
                            React.createElement(Controller, { control: control, as: Select, options: days, label: t('completeYourProfile.date'), name: "birth_date", defaultValue: null, style: { border: '0.5px solid black' }, variant: errors.birth_date ? 'error' : 'primary', register: policyAccept === PolicyAccept.YES ? register({}) : register, isLabelSeletionNull: true, m: 0, mt: 2, "data-testid": "__dob_date__" })),
                        React.createElement(SmallInputBox, null,
                            React.createElement(Controller, { control: control, as: Select, label: t('completeYourProfile.month'), options: months[language], defaultValue: null, name: "birth_month", style: { border: '0.5px solid black' }, variant: errors.birth_month ? 'error' : 'primary', register: policyAccept === PolicyAccept.YES ? register({}) : register, isLabelSeletionNull: true, m: 0, mt: 2, "data-testid": "__dob_month__" })),
                        React.createElement(SmallInputBox, null,
                            React.createElement(Controller, { control: control, as: Select, label: t('completeYourProfile.year'), options: years, defaultValue: null, name: "birth_year", style: { border: '0.5px solid black' }, variant: errors.birth_year ? 'error' : 'primary', register: policyAccept === PolicyAccept.YES ? register({}) : register, isLabelSeletionNull: true, m: 0, mt: 2, "data-testid": "__dob_year__" }))),
                    (errors.birth_date || errors.birth_year || errors.birth_month) && (React.createElement(WarningMessage$1, { ml: 1 }, t('completeYourProfile.dobRequired'))),
                    React.createElement(Flex, null, React.createElement(Controller, { control: control, as: Select, options: countries$1[language], label: t('completeYourProfile.nationality'), key: "code", defaultValue: null, name: "nationality", style: { border: '1px solid black' }, variant: errors.nationality ? 'error' : 'primary', ref: register({}), isLabelSeletionNull: true, "data-testid": "__dob_nationality__" })),
                    errors.nationality && (React.createElement(WarningMessage$1, { ml: 1 }, t('completeYourProfile.nationalityRequired'))))) : (''),
                storeId === 'mafuae' && (React.createElement(InputContainerPadding$1, null,
                    React.createElement(Checkbox, { size: 18, checkedBackground: '#000000', checkMarkTint: 'white', onChangeCheckbox: onChangeSubscribe, checked: policyAccept === PolicyAccept.YES }),
                    "\u00A0",
                    t('completeYourProfile.subscribeForLoyalty'),
                    " ",
                    t('completeYourProfile.read'),
                    ' ',
                    React.createElement(Button$1, { variant: "link", fontWeight: "bold", href: STATIC_PAGE_LINKS.SHARE_TERM_AND_CONDITION }, t('completeYourProfile.termAndConditions')))),
                React.createElement(LoaderSpan$1, null,
                    React.createElement(Button$1, { onClick: onClickSubmit, width: "100%", fontWeight: "bold" }, t('completeYourProfile.continue'))),
                React.createElement(TermAndCondition, null,
                    t('completeYourProfile.termConditionTxt'),
                    "\u00A0",
                    React.createElement(Button$1, { variant: "link", fontWeight: "bold", href: STATIC_PAGE_LINKS.TERM_AND_CONDITION }, t('completeYourProfile.termAndConditions')),
                    ' ',
                    t('completeYourProfile.and'),
                    ' ',
                    React.createElement(Button$1, { variant: "link", fontWeight: "bold", href: STATIC_PAGE_LINKS.UPDATE_PRIVACY_POLICY },
                        t('completeYourProfile.privacyPolicy'),
                        "."))),
            isBrowser() && isVerifyPhoneModalOpen && (React.createElement(VerifyPassword, { isShowShopping: false, email: email || '', phoneNumber: "" + phoneCountryCode + ((_a = getValues('phone_no')) === null || _a === void 0 ? void 0 : _a.replace(/^0/, '')), onVerifyAccount: function (uuid) { return onVerifyAccount(uuid); }, isShowCloseButton: true, action: "PHONE_UPDATE_VERIFICATION", modalBackGroundColor: "#0E5AA7", onCloseModal: toggleSetVerifyPhoneModalOpen }))));
    };
    return (React.createElement(Modal, { isOpen: showModal, title: '   ', showClose: false, backgroundColor: "#0E5AA7" }, renderData()));
};
var CompleteYourProfile$1 = withTranslation()(CompleteYourProfile);
var getSelectedArea = function (regions) {
    var areaCode = APP_CONFIG.areaCode;
    var selectedArea;
    if (areaCode) {
        selectedArea = regions
            .filter(function (region) { return region.areas; })
            .flatMap(function (_a) {
            var areas = _a.areas;
            return areas;
        })
            .find(function (_a) {
            var code = _a.code;
            return code === areaCode;
        });
    }
    return selectedArea;
};
var getSelectedCity = function (regions) {
    var areaCode = APP_CONFIG.areaCode;
    if (areaCode) {
        var selectedCity = (regions.filter(function (region) { return region.areas; }).find(function (_a) {
            var areas = _a.areas;
            return areas.find(function (_a) {
                var code = _a.code;
                return code === areaCode;
            });
        }) || {}).name;
        return selectedCity;
    }
};
var setAreas = function (regions, selectedArea, selectedCity) {
    return {
        type: EArea$1.FETCH_AREAS_SET,
        payload: { regions: regions, selectedArea: selectedArea, selectedCity: selectedCity },
    };
};
var setAddressAreas = function (areas) {
    return {
        type: EArea$1.FETCH_AREAS_SET_QATAR,
        payload: areas,
    };
};
var fetchAreas = function () { return function (dispatch) {
    dispatch({
        type: EArea$1.FETCH_AREAS_GET,
        payload: {
            method: EApiMiddlewareMethod$1.GET,
            url: GET_DELIVERY_AREAS,
            onSuccess: function (data) {
                var regions = data.regions;
                var selectedArea = getSelectedArea(regions);
                var selectedCity = getSelectedCity(regions) || '';
                dispatch(setAreas(regions, selectedArea, selectedCity));
            },
        },
    });
}; };
var fetchAddressCitiesAndAreasAction = function () { return function (dispatch, getState) {
    var code = getState().appConfig.code;
    dispatch({
        type: EArea$1.FETCH_AREAS_GET_QATAR,
        payload: {
            method: EApiMiddlewareMethod$1.GET,
            url: GET_ADDRESS_CITIES_ZONE_AREAS,
            params: { code: code },
            onSuccess: function (data) {
                dispatch(setAddressAreas(data.data));
            },
            apiVersion: 1,
        },
    });
}; };
var useFetchAreas = function (areaCode, language) {
    var dispatch = useDispatch();
    var areaState = useSelector(function (state) {
        return {
            areaState: state.area,
        };
    }).areaState;
    var _a = __read$1(useAppConfig(), 1), _b = _a[0].features, features = _b === void 0 ? {} : _b;
    useEffect(function () {
        if (areaCode && language && (features === null || features === void 0 ? void 0 : features.isLocationCXEnable) === false) {
            dispatch(fetchAreas());
        }
    }, [areaCode, dispatch, language, features]);
    return areaState;
};
var ChangeAreaList;
(function (ChangeAreaList) {
    ChangeAreaList["CITY"] = "CITY";
    ChangeAreaList["AREA"] = "AREA";
})(ChangeAreaList || (ChangeAreaList = {}));
var ChangeAreaView;
(function (ChangeAreaView) {
    ChangeAreaView["DEFAULT"] = "ChangeArea/Default";
    ChangeAreaView["USER_ADDRESSES"] = "ChangeArea/USER_ADDRESSES";
})(ChangeAreaView || (ChangeAreaView = {}));
var CitySelectedContainer = styled(Flex)({
    background: COLORS.WILD_SAND,
    padding: '12px 16px',
    marginBottom: '16px',
    width: '100%',
    justifyContent: 'space-between',
});
var ParentContainer = customStyled(Flex)(templateObject_1$w || (templateObject_1$w = __makeTemplateObject$1(["\n  flex-direction: column;\n  align-items: center;\n  justify-content: 'space-between';\n  ", "\n"], ["\n  flex-direction: column;\n  align-items: center;\n  justify-content: 'space-between';\n  ",
    "\n"])), function (props) {
    return props.currentView === ChangeAreaView.USER_ADDRESSES
        ? "\n      height: 84vh;\n      overflow-x: auto;\n      padding: 0 24px;\n\n      @media (min-width: " + props.theme.breakpoints[2] + ") {\n        height: 488px;\n      }\n    "
        : "\n      padding: 0 24px;\n    ";
});
var SelectNewAreaContainer = styled.div({
    left: 0,
    display: 'block',
    position: 'fixed',
    bottom: 0,
    height: '40px',
    width: '100%',
    backgroundColor: COLORS.WHITE,
    margin: '15px 0px',
    'box-shadow': '0 14px 0 0 #fff, 0 3px 16px 0 rgba(0,0,0,.2)',
});
var SelectNewAreaCTAContainer = styled.div({
    display: 'block',
    position: 'absolute',
    bottom: 0,
    right: 16,
    backgroundColor: COLORS.WHITE,
});
var CityAreaSelectionContainer = styled.div({ width: '100%' });
var NewAreaText = styled.div({
    color: COLORS.BLUE,
    display: 'inline',
    'padding-right': '10px',
    'font-weight': 500,
    cursor: 'pointer',
});
var City = styled.div({ fontWeight: TYPOGRAPHY.WEIGHT[400], display: 'inline' });
var ChangeCity = styled.div({
    cursor: 'pointer',
    color: COLORS.BLUE,
    fontWeight: TYPOGRAPHY.WEIGHT[500],
    fontSize: '14px',
});
var Title = styled.div({ margin: '16px 0', fontWeight: TYPOGRAPHY.WEIGHT[500] });
var templateObject_1$w;
var getFormattedFullAddress = function (address) {
    var _a = address || {}, landmark = _a.landmark, streetName = _a.streetName, deliveryArea = _a.deliveryArea, town = _a.town;
    if (!deliveryArea) {
        return '';
    }
    return __spread$1((landmark ? [landmark] : []), [streetName, deliveryArea.name, town]).join(', ').substr(0, 150);
};
var getExtraProps = function (address, isAddressActive, display) { return (__assign$1({ isAddressActive: isAddressActive(address) }, (display ? { m: 0, width: 'calc(50% - 8px)' } : { mb: [2, '12px'] }))); };
var AddressList = function (_a) {
    var addresses = _a.addresses, isAddressActive = _a.isAddressActive, onValidateCartEntries = _a.onValidateCartEntries, rest = __rest$1(_a, ["addresses", "isAddressActive", "onValidateCartEntries"]);
    var selectedAddress = useSelector(function (state) { return state.userData; }).selectedAddress;
    return (React.createElement(ButtonGroup, __assign$1({ onChange: onValidateCartEntries }, rest), addresses.map(function (address) {
        var firstName = address.firstName, phone = address.phone, defaultAddress = address.defaultAddress;
        var fullSelectedAddress = selectedAddress ? getFormattedFullAddress(selectedAddress) : '';
        var fullAddress = getFormattedFullAddress(address);
        var isSelected = fullSelectedAddress === fullAddress;
        var bgColor = isSelected ? COLORS.LAVENDOR : COLORS.WHITE;
        return (React.createElement(ButtonGroupItem, __assign$1({ bg: bgColor, boxShadow: "0 1px 1px 0 rgba(0, 0, 0, .2)", key: address.id, fontSize: 2, p: 3, lineHeight: 1.3, value: address, testid: "address-button" }, getExtraProps(address, isAddressActive, rest.display)),
            React.createElement(Flex, { justifyContent: "space-between" },
                React.createElement(Flex, { flexDirection: "column" },
                    firstName && (React.createElement(Text, { mb: SPACINGS[8], fontWeight: 4, "data-testid": "__checkout_delivery_address_receiver_name__", color: COLORS.THUNDURA }, firstName)),
                    phone && (React.createElement(Text, { fontWeight: 3, color: COLORS.THUNDURA, "data-testid": "__checkout_delivery_address_receiver_phone__" }, phone)),
                    fullAddress && (React.createElement(Text, { fontWeight: 3, color: COLORS.THUNDURA, "data-testid": "__checkout_delivery_address_receiver_address__" }, fullAddress))),
                defaultAddress === true && React.createElement(Star, { size: "CUSTOM", height: 24, width: 24, fill: COLORS.BLUE }))));
    })));
};
var AddressList$1 = memo(AddressList, function (prev, next) { return prev.addresses === next.addresses; });
var AreaChangeContainer = customStyled(Flex)(templateObject_1$x || (templateObject_1$x = __makeTemplateObject$1(["\n  align-items: center;\n  justify-content: space-between;\n  min-height: 24px;\n  margin: 4px 12px;\n  transform: translate(0px, 0px);\n  @media (max-width: ", ") {\n    padding: 15px 0px 7px;\n    margin: 0px;\n    width: 100%;\n    transform: ", "\n    background-color: #fff;\n  }\n  \n"], ["\n  align-items: center;\n  justify-content: space-between;\n  min-height: 24px;\n  margin: 4px 12px;\n  transform: translate(0px, 0px);\n  @media (max-width: ", ") {\n    padding: 15px 0px 7px;\n    margin: 0px;\n    width: 100%;\n    transform: ", "\n    background-color: #fff;\n  }\n  \n"])), function (props) { return props.theme.breakpoints[3]; }, function (props) { return (props.isHideNav ? 'translate(0px, -155px);' : 'translate(0px, 0px);'); });
AreaChangeContainer.defaultProps = {
    as: 'div',
};
var AreaChangeCommonContainer = styled(Flex)(templateObject_2$p || (templateObject_2$p = __makeTemplateObject$1(["\n  flex-direction: row;\n  align-items: center;\n"], ["\n  flex-direction: row;\n  align-items: center;\n"])));
var DeliverToText = styled(Flex)(templateObject_3$l || (templateObject_3$l = __makeTemplateObject$1(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), function (props) { return (props.isDesktopHeader ? '2px' : '4px'); });
var DeliverTimeText = customStyled(Box)(templateObject_4$i || (templateObject_4$i = __makeTemplateObject$1(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 250px;\n  flex: 1;\n  font-weight: ", ";\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 250px;\n  flex: 1;\n  font-weight: ", ";\n"])), function (props) { return props.theme.fontWeights[3]; });
var AreaChangeTextWrapper = customStyled(Box)(templateObject_5$d || (templateObject_5$d = __makeTemplateObject$1(["\n  white-space: nowrap;\n  align-items: center;\n  cursor: pointer;\n  color: ", ";\n  @media (min-width: ", ") {\n    font-weight: ", ";\n  }\n\n  @media (max-width: ", ") {\n    font-weight: ", ";\n  }\n"], ["\n  white-space: nowrap;\n  align-items: center;\n  cursor: pointer;\n  color: ", ";\n  @media (min-width: ", ") {\n    font-weight: ", ";\n  }\n\n  @media (max-width: ", ") {\n    font-weight: ", ";\n  }\n"])), function (props) { return (props.isDesktopHeader ? COLORS.WHITE : COLORS.ANCHOR_BLUE); }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.fontWeights[4]; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.theme.fontWeights[6]; });
AreaChangeTextWrapper.defaultProps = {
    fontSize: [1, null, null, null, 1],
};
var DeliveryAreaText = customStyled(Box)(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject$1(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-left: 1px;\n  max-width: 150px;\n  ", "\n  color: ", ";\n  @media (min-width: ", ") {\n    font-weight: ", ";\n  }\n  @media (max-width: ", ") {\n    height: 15px;\n    font-weight: ", ";\n  }\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-left: 1px;\n  max-width: 150px;\n  ", "\n  color: ", ";\n  @media (min-width: ", ") {\n    font-weight: ", ";\n  }\n  @media (max-width: ", ") {\n    height: 15px;\n    font-weight: ", ";\n  }\n"])), function (props) { return (props === null || props === void 0 ? void 0 : props.isShowFullArea) && "max-width: 109px;"; }, function (props) { return (props.isDesktopHeader ? COLORS.WHITE : COLORS.ANCHOR_BLUE); }, function (props) { return props.theme.breakpoints[3]; }, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.breakpoints[3]; }, function (props) { return props.theme.fontWeights[4]; });
var ChangeAreaCTA = customStyled(Box)(templateObject_7$9 || (templateObject_7$9 = __makeTemplateObject$1(["\n  margin-left: 10px;\n  @media (min-width: ", ") {\n    color: ", ";\n  }\n  font-weight: ", ";\n  ", "\n\n"], ["\n  margin-left: 10px;\n  @media (min-width: ", ") {\n    color: ", ";\n  }\n  font-weight: ", ";\n  ",
    "\n\n"])), function (props) { return props.theme.breakpoints[1]; }, COLORS.ANCHOR_BLUE, function (props) { return props.theme.fontWeights[6]; }, function (props) {
    return variant({
        prop: 'language',
        variants: {
            en: {
                fontWeight: props.theme.fontWeights[6],
            },
            ar: {
                fontWeight: props.theme.fontWeights[6],
            },
        },
    });
});
ChangeAreaCTA.defaultProps = {
    display: ['none', 'none', 'none', 'none', 'block'],
};
var MChangeArea = customStyled(Box)(templateObject_8$9 || (templateObject_8$9 = __makeTemplateObject$1(["\n  cursor: pointer;\n  font-size: 12px;\n  margin-left: 10px;\n  min-width: 50px;\n  margin-right: 0px;\n  font-weight: 700;\n"], ["\n  cursor: pointer;\n  font-size: 12px;\n  margin-left: 10px;\n  min-width: 50px;\n  margin-right: 0px;\n  font-weight: 700;\n"])));
MChangeArea.defaultProps = {
    color: [COLORS.ANCHOR_BLUE, null, null, null, 'mineShaft'],
    display: ['block', null, null, null, 'none'],
};
var templateObject_1$x, templateObject_2$p, templateObject_3$l, templateObject_4$i, templateObject_5$d, templateObject_6$9, templateObject_7$9, templateObject_8$9;
var SelectAddressLocation = React.lazy(function () {
    return Promise.resolve().then(function () { return index$4; }).then(function (module) { return ({ default: module.SelectAddressLocation }); });
});
var AddAddress = React.lazy(function () { return Promise.resolve().then(function () { return index$4; }).then(function (module) { return ({ default: module.AddAddress }); }); });
var AddressList$2 = React.lazy(function () { return Promise.resolve().then(function () { return index$4; }).then(function (module) { return ({ default: module.AddressList }); }); });
var Container$5 = customStyled(Flex)(templateObject_1$y || (templateObject_1$y = __makeTemplateObject$1(["\n  input[type='radio'] {\n    width: 18px;\n    height: 18px;\n  }\n  border-top: 1px solid ", ";\n  &:nth-last-of-type(2){\n    border-bottom: 1px solid ", ";\n  }\n  \n  background-color: ", ";\n"], ["\n  input[type='radio'] {\n    width: 18px;\n    height: 18px;\n  }\n  border-top: 1px solid ", ";\n  &:nth-last-of-type(2){\n    border-bottom: 1px solid ", ";\n  }\n  \n  background-color: ", ";\n"])), COLORS.LIGHT_GRAY, COLORS.LIGHT_GRAY, function (props) { return (props.isChecked ? COLORS.LIGHT_GREY_100 : COLORS.WHITE); });
var ImageWrapper = styled(Flex)(templateObject_2$q || (templateObject_2$q = __makeTemplateObject$1(["\n  flex: 1;\n  height: 16px;\n  gap: ", ";\n  width: auto;\n  cursor: pointer;\n"], ["\n  flex: 1;\n  height: 16px;\n  gap: ", ";\n  width: auto;\n  cursor: pointer;\n"])), function (props) { return props.isDesktopHeader && '8px'; });
var CountryLabel = customStyled(Flex)(templateObject_3$m || (templateObject_3$m = __makeTemplateObject$1(["\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  flex: 3;\n  text-align: left;\n\n  height: 16px;\n    font-weight: ", ";\n    line-height: 16px;\n"], ["\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  flex: 3;\n  text-align: left;\n\n  height: 16px;\n    font-weight: ", ";\n    line-height: 16px;\n"])), function (props) { return (props.isChecked ? '700' : '400'); });
var CallingCodeLabel = styled(Flex)(templateObject_4$j || (templateObject_4$j = __makeTemplateObject$1(["\n  flex:1\n  justify-content: flex-end;\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-size: 12px;\n  font-weight: bold;\n"], ["\n  flex:1\n  justify-content: flex-end;\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-size: 12px;\n  font-weight: bold;\n"])));
var CountrySelectorWrapper = styled(Box)(templateObject_5$e || (templateObject_5$e = __makeTemplateObject$1(["\n  cursor: pointer;\n  ", ";\n\n  @media (max-width: 300px) {\n    margin: 5px !important;\n  }\n"], ["\n  cursor: pointer;\n  ",
    ";\n\n  @media (max-width: 300px) {\n    margin: 5px !important;\n  }\n"])), function (props) {
    return props.isDesktopHeader &&
        " padding: 8px;\n      border-radius:4px;\n      background: " + COLORS.BLUE_500 + ";\n      ";
});
var TabWrapper = styled(Flex)(templateObject_6$a || (templateObject_6$a = __makeTemplateObject$1(["\n  background-color: ", ";\n  border-radius: 5px;\n  padding: 5px;\n  width: 100%;\n"], ["\n  background-color: ", ";\n  border-radius: 5px;\n  padding: 5px;\n  width: 100%;\n"])), COLORS.GRAYSCALE);
var Tab = customStyled(Box)(templateObject_7$a || (templateObject_7$a = __makeTemplateObject$1(["\n  width: 162px;\n  height: 36px;\n  line-height: 36px;\n  border-radius: 4px;\n  transition: .2s all;\n  text-align: center;\n  font-weight: ", ";\n  background-color: ", ";\n  cursor: pointer;\n"], ["\n  width: 162px;\n  height: 36px;\n  line-height: 36px;\n  border-radius: 4px;\n  transition: .2s all;\n  text-align: center;\n  font-weight: ", ";\n  background-color: ", ";\n  cursor: pointer;\n"])), function (props) { return (props.isChecked ? '700' : '400'); }, function (props) { return (props.isChecked ? COLORS.WHITE : COLORS.GRAYSCALE); });
var LabelWrapper = styled.label(templateObject_8$a || (templateObject_8$a = __makeTemplateObject$1(["\n  display: inline-flex;\n  cursor: pointer;\n  height: 16px;\n\n  img {\n    margin-left: 20px;\n  }\n"], ["\n  display: inline-flex;\n  cursor: pointer;\n  height: 16px;\n\n  img {\n    margin-left: 20px;\n  }\n"])));
var LanguageSelectorWrapper = customStyled(Box)(templateObject_9$9 || (templateObject_9$9 = __makeTemplateObject$1(["\n  height: 0px;\n  overflow: hidden;\n  ", "\n"], ["\n  height: 0px;\n  overflow: hidden;\n  ",
    "\n"])), function (props) {
    if (props.isChecked) {
        return "\n          transition: .2s all;\n          height: 105px;\n      ";
    }
});
var ButtonSection = styled.div(templateObject_10$9 || (templateObject_10$9 = __makeTemplateObject$1(["\n  position: fixed;\n  bottom: 0px;\n  background-color: ", ";\n  box-shadow: 0px -2px 5px rgb(0 0 0 / 10%);\n  width: 100%;\n  padding: 16px 0px;\n  text-align: center;\n\n  button {\n    width: 150px;\n    border-radius: 12px;\n    background-color: ", ";\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n    &:first-of-type {\n      background-color: ", ";\n      margin-right: 20px;\n      color: ", ";\n    }\n\n    @media (max-width: 992px) {\n      height: 40px;\n    }\n  }\n"], ["\n  position: fixed;\n  bottom: 0px;\n  background-color: ", ";\n  box-shadow: 0px -2px 5px rgb(0 0 0 / 10%);\n  width: 100%;\n  padding: 16px 0px;\n  text-align: center;\n\n  button {\n    width: 150px;\n    border-radius: 12px;\n    background-color: ", ";\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n    &:first-of-type {\n      background-color: ", ";\n      margin-right: 20px;\n      color: ", ";\n    }\n\n    @media (max-width: 992px) {\n      height: 40px;\n    }\n  }\n"])), COLORS.WHITE, COLORS.ANCHOR_BLUE, COLORS.WHITE, COLORS.ANCHOR_BLUE, COLORS.WHITE, COLORS.ANCHOR_BLUE);
var templateObject_1$y, templateObject_2$q, templateObject_3$m, templateObject_4$j, templateObject_5$e, templateObject_6$a, templateObject_7$a, templateObject_8$a, templateObject_9$9, templateObject_10$9;
var getRedirectionUrl = function (newCountry, languageRef) {
    var redirectionLink = '';
    var currentHost = window.location.host;
    var name = newCountry.name, countryDomain = newCountry.countryDomain;
    if (currentHost.includes('localhost')) {
        redirectionLink = window.location.protocol + "//" + window.location.host + "/" + name + "/" + languageRef.current.value;
    }
    else if (currentHost.includes('uat')) {
        var domainPrefix = currentHost.split('.')[0];
        redirectionLink = window.location.protocol + "//" + domainPrefix + "." + countryDomain + "/" + name + "/" + languageRef.current.value;
    }
    else {
        redirectionLink = window.location.protocol + "//www." + countryDomain + "/" + name + "/" + languageRef.current.value;
    }
    return redirectionLink + "/";
};
var loadPageWithUpdatedLang = function (lan, currentStoreId) {
    var asPath = window.location.pathname;
    var pathResources = asPath.split('/');
    var _a = __read$1(pathResources), storeId = _a[1], queryLang = _a[2], rest = _a.slice(3);
    var baseUrl = asPath;
    var appboy = window.appboy;
    setAppLanguageAndCountry({ language: lan, storeId: currentStoreId }, appboy);
    if (storeId.indexOf('maf') > -1 && ['ar', 'en', 'ka'].indexOf(queryLang) > -1) {
        baseUrl = storeId + "/" + lan + "/" + rest.join('/');
        var finalPathName = storeId && queryLang ? baseUrl : currentStoreId + "/" + lan + baseUrl;
        window.location.href = "https://" + window.location.hostname + "/" + finalPathName + window.location.search;
    }
    else {
        window.location.reload();
    }
};
var CountryListElement = function (_a) {
    var code = _a.code, countryName = _a.name, countryStoreId = _a.countryStoreId, isChecked = _a.isChecked, onCountrySelector = _a.onCountrySelector, language = _a.language, onLanguageSelector = _a.onLanguageSelector, key = _a.key, supportedLanguages = _a.supportedLanguages, media = _a.media;
    var t = useTranslation().t;
    var _b = __read$1(useState(''), 2), selectedLanguage = _b[0], setLanguage = _b[1];
    useEffect(function () {
        setLanguage(language);
    }, [language]);
    var onLangChange = function (event) {
        var _a, _b;
        setLanguage((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.dataset.value);
        onLanguageSelector((_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.dataset.value);
    };
    return (React.createElement(Container$5, { flexDirection: "column", p: 3, ml: ['0px', '0px', '0px', '20px'], isChecked: isChecked, key: key, "data-testid": key },
        React.createElement(Box, null,
            React.createElement(LabelWrapper, { htmlFor: countryName },
                React.createElement("input", { type: "radio", name: "country", id: countryName, value: countryStoreId, onChange: onCountrySelector, checked: isChecked }),
                React.createElement("img", { src: media, alt: code + ".png" }),
                React.createElement(CountryLabel, { pl: "10px", isChecked: isChecked }, countryName))),
        supportedLanguages.length > 1 ? (React.createElement(LanguageSelectorWrapper, { ml: "40px", isChecked: isChecked },
            React.createElement(Box, { as: "p", textAlign: "left", my: "20px" }, t('selectLanguageText')),
            React.createElement(TabWrapper, null, supportedLanguages.map(function (lang, index) { return (React.createElement(Tab, { key: lang.code + "_" + index, isChecked: selectedLanguage === lang.code, "data-value": lang.code, onClick: onLangChange }, lang.name)); })))) : null));
};
var Heading$1 = function (_a) {
    var headingTitle = _a.headingTitle;
    return (React.createElement(Box, { fontWeight: [5, 6], fontSize: [3, 4], textAlign: ['center', 'left'], display: "block", sx: {
            fontFamily: 'Montserrat',
        }, mt: [null, null, '-10px'], ml: "10px", py: 3 }, headingTitle));
};
var LocalisationSettingsDrawer = function (props) {
    var t = useTranslation().t;
    var closeHandler = props.closeHandler, isOpen = props.isOpen, _a = props.contents, contents = _a === void 0 ? [] : _a, language = props.language, storeId = props.storeId;
    var _b = __read$1(useState(''), 2), selectedCountry = _b[0], setCountry = _b[1];
    var languageRef = useRef({
        value: language,
    });
    useEffect(function () {
        setCountry(storeId);
    }, [language, storeId]);
    var onSubmit = function () {
        var _a;
        if (selectedCountry === storeId) {
            setStoreInfoCookie({ language: languageRef.current.value });
            return loadPageWithUpdatedLang(languageRef.current.value, storeId);
        }
        var newCountry = contents.find(function (item) {
            if (item.name === selectedCountry) {
                return item;
            }
        });
        var languageIndex = newCountry === null || newCountry === void 0 ? void 0 : newCountry.languages.findIndex(function (item) { return item.code === languageRef.current.value; });
        if (languageIndex === -1) {
            var defaultLanguage = (_a = newCountry === null || newCountry === void 0 ? void 0 : newCountry.languages.find(function (item) { return item.isDefault; })) === null || _a === void 0 ? void 0 : _a.code;
            languageRef.current.value = defaultLanguage || languageRef.current.value;
        }
        window.location.href = getRedirectionUrl(newCountry, languageRef);
    };
    var onLanguageSelector = function (val) {
        languageRef.current.value = val;
    };
    var onCountrySelector = function (event) {
        setCountry(event.target.value);
        languageRef.current.value = language;
    };
    return (React.createElement("div", null,
        React.createElement(Drawer, { onClose: closeHandler, isOpen: isOpen, width: ['100%', '400px', '450px'], anchor: ['bottom', null, 'right'], contentStyles: { p: [0], height: '100%', display: 'flex', flexDirection: 'column', fontFamily: 'Montserrat' }, variant: "float", title: React.createElement(Heading$1, { headingTitle: t('localisationSettingsText') }), "data-testid": "localization-settings-drawer", isTitleBorder: false, isRtl: language === AR },
            React.createElement(Box, { p: 3, pt: [0, 0, 0, 3] },
                React.createElement(Box, { as: "h3", px: ['0px', '0px', '0px', '10px'], mb: "15px", ml: ['0px', '0px', '0px', '10px'], fontWeight: "bold" }, t('chooseCountry')),
                contents.map(function (item, index) {
                    return item && item.code ? (React.createElement(CountryListElement, { name: item.displayName, code: item.code, countryStoreId: item.name, isChecked: selectedCountry === item.name, onCountrySelector: onCountrySelector, supportedLanguages: item.languages, language: language, key: item.name + "_" + index, onLanguageSelector: onLanguageSelector, media: item.media })) : null;
                }),
                React.createElement(Box, { height: "72px" })),
            React.createElement(ButtonSection, null,
                React.createElement(Button$1, { "data-testid": "country-selector-cancel-icon", onClick: closeHandler, fontSize: 2, fontWeight: 6, height: "48px", preventTextTransform: true },
                    React.createElement(Box, { sx: {
                            whiteSpace: 'nowrap',
                        } }, t('completeYourProfile.cancel'))),
                React.createElement(Button$1, { "data-testid": "country-selector-confirm-icon", variant: "primary", onClick: onSubmit, fontSize: 2, fontWeight: 6, height: "48px", preventTextTransform: true },
                    React.createElement(Box, { sx: {
                            whiteSpace: 'nowrap',
                        } }, t('address.confirm')))))));
};
var CountrySelector = function (_a) {
    var countryOfOperationID = _a.countryOfOperationID, isDesktop = _a.isDesktop, language = _a.language, storeId = _a.storeId, isDesktopHeader = _a.isDesktopHeader;
    var _b = __read$1(useState(false), 2), openCountrySelector = _b[0], setOpenCountrySelector = _b[1];
    var _c = __read$1(useState([]), 2), countryDetails = _c[0], setCountryDetails = _c[1];
    var _d = __read$1(useState({}), 2), preSelectedCountry = _d[0], setPreSelectedCountry = _d[1];
    var getCountryDetails = function () { return __awaiter$1(void 0, void 0, void 0, function () {
        var response, currentCountry, e_1;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 , AppConfigService$1.getCountryDetailsApi()];
                case 1:
                    response = _a.sent();
                    setCountryDetails(response.data);
                    currentCountry = response.data.find(function (item) { return item.code === countryOfOperationID; });
                    setPreSelectedCountry(currentCountry || {});
                    return [3 , 3];
                case 2:
                    e_1 = _a.sent();
                    console.error('country details: ', e_1);
                    return [3 , 3];
                case 3: return [2 ];
            }
        });
    }); };
    useEffect(function () {
        getCountryDetails();
    }, []);
    var showCountrySelector = function () {
        setOpenCountrySelector(true);
    };
    var hideCountrySelector = function () {
        setOpenCountrySelector(false);
    };
    var _e = preSelectedCountry.media, media = _e === void 0 ? '' : _e, _f = preSelectedCountry.code, code = _f === void 0 ? '' : _f;
    return (React.createElement(React.Fragment, null,
        openCountrySelector && (React.createElement(LocalisationSettingsDrawer, { contents: countryDetails, isOpen: openCountrySelector, closeHandler: hideCountrySelector, language: language, storeId: storeId })),
        React.createElement(CountrySelectorWrapper, { id: "country_change", mx: [3, null, null, null], onClick: showCountrySelector, isDesktopHeader: isDesktopHeader },
            React.createElement(ImageWrapper, { isDesktopHeader: isDesktopHeader },
                React.createElement(Image, { url: media, name: code, height: "16px", width: "auto", useAltFallback: true }),
                isDesktop ? React.createElement(ChevronDown, { size: "S", fill: isDesktopHeader ? COLORS.WHITE : COLORS.ANCHOR_BLUE }) : null))));
};
var CountrySelector$1 = React.memo(CountrySelector);
var sharedData = {
    event_category: GTMEventCategories.enhanced_ecommerce,
    position: 'monetisation',
};
var detectIframeClick = function (PromotionEventCall, _a, storeId, position) {
    var promotionData = __rest$1(_a, []);
    var iframeConfig = {
        isIframeClicked: false,
    };
    var iframeContainer = document.getElementById(promotionData.id);
    var trackOnClick = function () {
        if (iframeConfig.isIframeClicked) {
            PromotionEventCall(PromotionEvents.promotion_click, __assign$1(__assign$1({}, sharedData), { event_action: PromotionEvents.promotion_click, event_label: promotionData.id, market: storeId, page_url: typeof window !== 'undefined' ? window.location.href : '',
                screen_type: getPageType() }), __assign$1({}, promotionData), false);
            PromotionEventCall(PromotionEvents.promotion_click, __assign$1(__assign$1({}, sharedData), { event_action: PromotionEvents.promotion_click, event_label: promotionData.id, market: storeId, page_url: typeof window !== 'undefined' ? window.location.href : '',
                screen_type: getPageType() }), {
                creative_name: promotionData.creative,
                creative_slot: position,
                index: position,
                item_list_name: '',
                promotion_id: promotionData.id,
                promotion_name: promotionData.name,
            }, true);
        }
    };
    if (typeof window !== 'undefined') {
        window.addEventListener('blur', trackOnClick);
    }
    iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.addEventListener('mouseover', function () {
        iframeConfig.isIframeClicked = true;
        window.focus();
    });
    iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.addEventListener('mouseout', function () {
        iframeConfig.isIframeClicked = false;
    });
    return function () {
        window.removeEventListener('blur', trackOnClick);
    };
};
var AdBanner = function (props) {
    var id = props.id, fallbackEmptyContent = props.fallbackEmptyContent, position = props.position, rest = __rest$1(props, ["id", "fallbackEmptyContent", "position"]);
    var _a = __read$1(useAppConfig(), 1), _b = _a[0], language = _b.language, storeId = _b.storeId;
    var PromotionEventCall = useAnalytic().PromotionEventCall;
    var _c = __read$1(useInView(), 2), inViewRef = _c[0], inView = _c[1];
    var promotionData = useMemo(function () { return ({
        id: id,
        name: rest.path,
        creative: rest.gtmCreative ? rest.gtmCreative : '',
        position: position,
    }); }, [id, rest.path, rest.gtmCreative, position]);
    useEffect(function () {
        var handleIframeClick = detectIframeClick(PromotionEventCall, promotionData, storeId, position);
        return function () { return handleIframeClick(); };
    }, [PromotionEventCall, promotionData, storeId, position]);
    useEffect(function () {
        if (inView) {
            PromotionEventCall(PromotionEvents.promotion_impressions, __assign$1(__assign$1({}, sharedData), { event_action: PromotionEvents.promotion_impressions, event_label: id + "|" + position, market: storeId, page_url: typeof window !== 'undefined' ? window.location.href : '',
                screen_type: getPageType() }), __assign$1({}, promotionData), false);
            PromotionEventCall(PromotionEvents.promotion_impressions, __assign$1(__assign$1({}, sharedData), { event_action: PromotionEvents.promotion_impressions, event_label: id + "|" + position, market: storeId, page_url: typeof window !== 'undefined' ? window.location.href : '',
                screen_type: getPageType() }), __assign$1({}, promotionData), true);
        }
    }, [inView, PromotionEventCall, promotionData, id, storeId, position]);
    var slotInfo = useDfpSlot(__assign$1(__assign$1({}, props), { lang: language })).slotInfo;
    var slotId = slotInfo.slotId, isEmpty = slotInfo.isEmpty;
    useEffect(function () {
        if (fallbackEmptyContent) {
            fallbackEmptyContent({ slotId: slotId, isEmpty: isEmpty });
        }
    }, [fallbackEmptyContent, slotId, isEmpty]);
    return React.createElement(AdBannerWrapper, __assign$1({ id: id, ref: inViewRef }, rest));
};
var AdBanner$1 = React.memo(AdBanner, function (prevProps, nextProps) {
    var _a, _b;
    return (prevProps.id === nextProps.id && ((_a = prevProps === null || prevProps === void 0 ? void 0 : prevProps.targets) === null || _a === void 0 ? void 0 : _a.hybris_categoryid) === ((_b = nextProps === null || nextProps === void 0 ? void 0 : nextProps.targets) === null || _b === void 0 ? void 0 : _b.hybris_categoryid));
});
var InnerWrapper = styled('div')(templateObject_1$z || (templateObject_1$z = __makeTemplateObject$1([""], [""])));
var WrapperSection = styled('div')(templateObject_2$r || (templateObject_2$r = __makeTemplateObject$1(["\n  .smartbanner-top {\n    position: relative;\n    height: 78px;\n  }\n  .smartbanner-container {\n    top: 0;\n    left: 0;\n    overflow-x: hidden;\n    width: 100%;\n    background: ", ";\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding: 0 8px;\n    position: absolute;\n    z-index: 1;\n    font-family: Roboto;\n  }\n  .smartbanner-close {\n    display: block;\n    margin: 0;\n    width: 12px;\n    height: 12px;\n    text-align: center;\n    background: none;\n    border: none;\n    box-shadow: none;\n    text-shadow: none;\n    color: ", ";\n    font-family: inherit;\n    height: 16px;\n    line-height: 16px;\n  }\n  .smartbanner-icon {\n    background-size: 48px 48px;\n    width: 48px;\n    height: 48px;\n    margin: 0 8px;\n    border-radius: 15px;\n    background-image: url(", ") !important;\n  }\n  .smartbanner-title,\n  .smartbanner-author {\n    color: ", ";\n\n    text-shadow: none;\n    font-size: 14px;\n  }\n  .smartbanner-title {\n    font-weight: 500;\n    margin-bottom: 3px;\n  }\n  .smartbanner-android .smartbanner-title {\n    color: ", ";\n  }\n  .smartbanner-author {\n    font-weight: normal;\n  }\n  .smartbanner-button {\n    z-index: 1;\n    display: block;\n    min-width: 10%;\n    text-align: center;\n    background: ", ";\n    color: ", ";\n    font-size: 12px;\n    font-weight: 500;\n    border-radius: 2px;\n    position: static;\n    margin-left: auto;\n    border: none;\n    box-shadow: none;\n    height: auto;\n    padding: 0;\n  }\n  .smartbanner-wrapper {\n    margin-left: auto;\n    width: auto;\n  }\n  .smartbanner-button-text {\n    background: none;\n    padding: 10px;\n    display: inline-block;\n    line-height: 1.3;\n    text-shadow: none;\n  }\n  .smartbanner-description {\n    display: none;\n  }\n  .smartbanner-info {\n    width: calc(99% - 145px);\n  }\n"], ["\n  .smartbanner-top {\n    position: relative;\n    height: 78px;\n  }\n  .smartbanner-container {\n    top: 0;\n    left: 0;\n    overflow-x: hidden;\n    width: 100%;\n    background: ", ";\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding: 0 8px;\n    position: absolute;\n    z-index: 1;\n    font-family: Roboto;\n  }\n  .smartbanner-close {\n    display: block;\n    margin: 0;\n    width: 12px;\n    height: 12px;\n    text-align: center;\n    background: none;\n    border: none;\n    box-shadow: none;\n    text-shadow: none;\n    color: ", ";\n    font-family: inherit;\n    height: 16px;\n    line-height: 16px;\n  }\n  .smartbanner-icon {\n    background-size: 48px 48px;\n    width: 48px;\n    height: 48px;\n    margin: 0 8px;\n    border-radius: 15px;\n    background-image: url(", ") !important;\n  }\n  .smartbanner-title,\n  .smartbanner-author {\n    color: ", ";\n\n    text-shadow: none;\n    font-size: 14px;\n  }\n  .smartbanner-title {\n    font-weight: 500;\n    margin-bottom: 3px;\n  }\n  .smartbanner-android .smartbanner-title {\n    color: ", ";\n  }\n  .smartbanner-author {\n    font-weight: normal;\n  }\n  .smartbanner-button {\n    z-index: 1;\n    display: block;\n    min-width: 10%;\n    text-align: center;\n    background: ", ";\n    color: ", ";\n    font-size: 12px;\n    font-weight: 500;\n    border-radius: 2px;\n    position: static;\n    margin-left: auto;\n    border: none;\n    box-shadow: none;\n    height: auto;\n    padding: 0;\n  }\n  .smartbanner-wrapper {\n    margin-left: auto;\n    width: auto;\n  }\n  .smartbanner-button-text {\n    background: none;\n    padding: 10px;\n    display: inline-block;\n    line-height: 1.3;\n    text-shadow: none;\n  }\n  .smartbanner-description {\n    display: none;\n  }\n  .smartbanner-info {\n    width: calc(99% - 145px);\n  }\n"])), function (props) { var _a; return (_a = props.theme.colors) === null || _a === void 0 ? void 0 : _a.alabaster; }, function (props) { var _a; return (_a = props.theme.colors) === null || _a === void 0 ? void 0 : _a.silverChalice; }, function (props) { return props.logoPath; }, function (props) { var _a; return (_a = props.theme.colors) === null || _a === void 0 ? void 0 : _a.copy; }, function (props) { var _a; return (_a = props.theme.colors) === null || _a === void 0 ? void 0 : _a.copy; }, function (props) { var _a; return (_a = props.theme.colors) === null || _a === void 0 ? void 0 : _a.redCta; }, function (props) { var _a; return (_a = props.theme.colors) === null || _a === void 0 ? void 0 : _a.white; });
var templateObject_1$z, templateObject_2$r;
var MarketingStripWrapper = CustomStyled.div(templateObject_1$A || (templateObject_1$A = __makeTemplateObject$1(["    \n  transition: 0.1s all;\n  transform: ", ";\n  @media (min-width: ", "){\n    ", ";\n  }\n  @media (max-width: ", "){\n    ", ";\n  }\n  @media (min-width: ", ") and (max-width: ", ") {\n    padding: 0 15px;\n  }\n  position: relative;\n  z-index: -2;\n  @media (max-width: ", ") {\n      transform: ", ";\n  }\n  @media (min-width: ", ") {\n    min-height: 52px;\n  }\n"], ["    \n  transition: 0.1s all;\n  transform: ", ";\n  @media (min-width: ", "){\n    ",
    ";\n  }\n  @media (max-width: ", "){\n    ",
    ";\n  }\n  @media (min-width: ", ") and (max-width: ",
    ") {\n    padding: 0 15px;\n  }\n  position: relative;\n  z-index: -2;\n  @media (max-width: ", ") {\n      transform: ", ";\n  }\n  @media (min-width: ", ") {\n    min-height: 52px;\n  }\n"])), function (props) { return (props.isHideNav ? 'translate(0, -125px);' : 'translate(0, 0);'); }, function (props) { return props.theme.breakpoints[1]; }, function (props) {
    var _a, _b;
    return ((_a = props === null || props === void 0 ? void 0 : props.styles) === null || _a === void 0 ? void 0 : _a.background_image_web) ? "background-image: url(" + props.styles.background_image_web + ");\n            background-position: center; /* Center the image */\n            background-repeat: no-repeat; /* Do not repeat the image */\n            background-size: cover"
        : "background-color: " + ((_b = props === null || props === void 0 ? void 0 : props.styles) === null || _b === void 0 ? void 0 : _b.background_color);
}, function (props) { return props.theme.breakpoints[1]; }, function (props) {
    var _a, _b;
    return ((_a = props === null || props === void 0 ? void 0 : props.styles) === null || _a === void 0 ? void 0 : _a.background_image_mobile) ? "background-image: url(" + props.styles.background_image_mobile + ");\n            background-position: center; /* Center the image */\n            background-repeat: no-repeat; /* Do not repeat the image */\n            background-size: cover"
        : "background-color: " + ((_b = props === null || props === void 0 ? void 0 : props.styles) === null || _b === void 0 ? void 0 : _b.background_color);
}, function (props) { return props.theme.breakpoints[1]; }, function (props) {
    return props.theme.breakpoints[3];
}, function (props) { return props.theme.breakpoints[2]; }, function (props) { return (props.isHideNav ? 'translate(0, -150px);' : 'translate(0, 0);'); }, function (props) { return props.theme.breakpoints[3]; });
var MarketingStripText = CustomStyled(Flex)(templateObject_2$s || (templateObject_2$s = __makeTemplateObject$1(["\n    margin: 0 auto;\n    max-width: 1232px;\n    ", ";\n    ", ";\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n"], ["\n    margin: 0 auto;\n    max-width: 1232px;\n    ", ";\n    ", ";\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n"])), function (props) { return (props.isBambuser ? 'padding: 0;' : 'padding: 10px 0'); }, function (props) { return props.isTimer && "padding-bottom: 2px"; });
var TextWrapper$3 = CustomStyled(Flex)(templateObject_3$n || (templateObject_3$n = __makeTemplateObject$1(["\n    align-items: center;\n    min-width: 18px;\n    text-decoration: none;\n    ", "\n\n    ", "\n"], ["\n    align-items: center;\n    min-width: 18px;\n    text-decoration: none;\n    ",
    "\n\n    ",
    "\n"])), function (props) {
    return props.isMobile &&
        "\n      display: block;\n      margin-left: 15px;\n    ";
}, function (props) {
    return props.isTopCloseIcon &&
        "\n      position: relative;\n      margin: 0 15px 0 5px;\n     ";
});
TextWrapper$3.defaultProps = {
    as: 'a',
};
var BambuserContainer = CustomStyled(TextWrapper$3)(templateObject_4$k || (templateObject_4$k = __makeTemplateObject$1(["\n  background-color: transparent;\n  border: none;\n  flex: auto;\n"], ["\n  background-color: transparent;\n  border: none;\n  flex: auto;\n"])));
var IconWrapper$4 = CustomStyled(Box)(templateObject_5$f || (templateObject_5$f = __makeTemplateObject$1(["\n  position: relative;\n  ", "\n"], ["\n  position: relative;\n  ", "\n"])), function (props) { return (props.isBambuser ? 'height: 52px;' : 'height: 14px;'); });
IconWrapper$4.defaultProps = {
    as: 'img',
    mr: 2,
};
var BambuserThumbnailWrapper = CustomStyled(Flex)(templateObject_6$b || (templateObject_6$b = __makeTemplateObject$1(["\n  position: relative;\n  height: 52px;\n  align-items: center;\n"], ["\n  position: relative;\n  height: 52px;\n  align-items: center;\n"])));
var LiveIcon = CustomStyled(Box)(templateObject_7$b || (templateObject_7$b = __makeTemplateObject$1(["\n  color: ", ";\n  padding: 8px 10px 8px 20px;\n  margin-left: 4px;\n  margin-right: 4px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  border-radius: 2px;\n  font-family: Roboto;\n\n  @media (max-width: ", "){\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  @media (min-width: ", "){\n    position: relative;\n  }\n\n  :: before {\n    content: \"\";\n    width: 8px;\n    height: 8px;\n    top: 50%;\n    left: 10px;\n    transform: translate(-50%,-50%);\n    background-color: white;\n    border-radius: 50%;\n    position: absolute;\n  }\n"], ["\n  color: ", ";\n  padding: 8px 10px 8px 20px;\n  margin-left: 4px;\n  margin-right: 4px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  border-radius: 2px;\n  font-family: Roboto;\n\n  @media (max-width: ", "){\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  @media (min-width: ", "){\n    position: relative;\n  }\n\n  :: before {\n    content: \"\";\n    width: 8px;\n    height: 8px;\n    top: 50%;\n    left: 10px;\n    transform: translate(-50%,-50%);\n    background-color: white;\n    border-radius: 50%;\n    position: absolute;\n  }\n"])), COLORS.WHITE, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.breakpoints[2]; });
var Title$1 = CustomStyled(Text)(templateObject_8$b || (templateObject_8$b = __makeTemplateObject$1(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (props) { return props.styles.color; });
Title$1.defaultProps = {
    fontSize: 1,
    fontWeight: 'bold',
};
var SubTitle = CustomStyled(Text)(templateObject_9$a || (templateObject_9$a = __makeTemplateObject$1(["\n  color: ", ";\n  @media (max-width: ", ") {\n    margin-left: 0;\n  }\n  ", "\n \n  overflow: hidden;\n   html[dir='rtl'] & {\n    overflow: ", ";\n  }\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* number of lines to show */\n  -webkit-box-orient: vertical;   \n  flex:1\n"], ["\n  color: ", ";\n  @media (max-width: ", ") {\n    margin-left: 0;\n  }\n  ",
    "\n \n  overflow: hidden;\n   html[dir='rtl'] & {\n    overflow: ",
    ";\n  }\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* number of lines to show */\n  -webkit-box-orient: vertical;   \n  flex:1\n"])), function (props) { var _a; return (_a = props === null || props === void 0 ? void 0 : props.styles) === null || _a === void 0 ? void 0 : _a.color; }, function (props) { return props.theme.breakpoints[1]; }, function (props) {
    return props.isTitle &&
        props.isMobile &&
        "\n      margin-top: 8px;\n  ";
}, function (props) {
    return props.children && props.children.length > 50 ? "hidden" : "visible";
});
SubTitle.defaultProps = {
    fontSize: 1,
    marginLeft: '5px',
};
var BambuserTitle = CustomStyled(SubTitle)(templateObject_10$a || (templateObject_10$a = __makeTemplateObject$1(["\n  padding: 8px;\n  max-width: 70%;\n"], ["\n  padding: 8px;\n  max-width: 70%;\n"])));
var CloseIconWrapper$1 = memo(CustomStyled(Flex)(templateObject_11$7 || (templateObject_11$7 = __makeTemplateObject$1(["\n", "\n  \n  cursor: pointer;\n"], ["\n",
    "\n  \n  cursor: pointer;\n"])), function (props) {
    return props.isTimer &&
        "position: relative;\n  top: -5px;";
}));
var MarketingStripTitle = memo(CustomStyled(Flex)(templateObject_12$6 || (templateObject_12$6 = __makeTemplateObject$1(["\n  align-items: center;\n"], ["\n  align-items: center;\n"]))));
var MarketingStripSubTitle = CustomStyled(MarketingStripTitle)(templateObject_13$6 || (templateObject_13$6 = __makeTemplateObject$1(["\n align-items: flex-start;\n"], ["\n align-items: flex-start;\n"])));
var BambuserStripWrapper = CustomStyled(Flex)(templateObject_14$6 || (templateObject_14$6 = __makeTemplateObject$1(["\n flex: 1;\n align-items: center;\n @media (max-width : ", "){\n  flex-direction: row-reverse;\n  flex: 1;\n}\n"], ["\n flex: 1;\n align-items: center;\n @media (max-width : ", "){\n  flex-direction: row-reverse;\n  flex: 1;\n}\n"])), function (props) { return props.theme.breakpoints[2]; });
var TimerWrapper = CustomStyled(Flex)(templateObject_15$6 || (templateObject_15$6 = __makeTemplateObject$1(["\n  text-decoration: none;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items:center;\n  @media (max-width : ", "){\n    justify-content: flex-end;\n    align-items: center;\n    margin-right: 1vw;\n  }\n"], ["\n  text-decoration: none;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items:center;\n  @media (max-width : ", "){\n    justify-content: flex-end;\n    align-items: center;\n    margin-right: 1vw;\n  }\n"])), function (props) { return props.theme.breakpoints[1]; });
TimerWrapper.defaultProps = {
    as: 'a',
};
var TitleTimer = CustomStyled(Title$1)(templateObject_16$5 || (templateObject_16$5 = __makeTemplateObject$1(["\n  margin-right: 8px;\n  height: 24px;\n"], ["\n  margin-right: 8px;\n  height: 24px;\n"])));
var TitleTimerMobile = CustomStyled(TitleTimer)(templateObject_17$5 || (templateObject_17$5 = __makeTemplateObject$1(["\n  height: auto;\n"], ["\n  height: auto;\n"])));
var TimerWapperText = memo(CustomStyled(Flex)(templateObject_18$4 || (templateObject_18$4 = __makeTemplateObject$1(["\n  justify-content: center;\n  align-items:center;\n  \n"], ["\n  justify-content: center;\n  align-items:center;\n  \n"]))));
var TimerWapperTextMobile = CustomStyled(TimerWapperText)(templateObject_19$4 || (templateObject_19$4 = __makeTemplateObject$1(["\n  flex: ", ";\n  min-width: fit-content;\n"], ["\n  flex: ", ";\n  min-width: fit-content;\n"])), function (props) { var _a; return (props.isMobile && ((_a = props.styles) === null || _a === void 0 ? void 0 : _a.background_image_mobile) ? '0' : '1 1 0%'); });
var CountdownWrapper = CustomStyled(Flex)(templateObject_20$3 || (templateObject_20$3 = __makeTemplateObject$1(["\n  flex-direction: column; \n  justify-content: center; \n  align-items: center;\n  font-family: 'Montserrat';\n"], ["\n  flex-direction: column; \n  justify-content: center; \n  align-items: center;\n  font-family: 'Montserrat';\n"])));
var SubTitleTimer = memo(CustomStyled(SubTitle)(templateObject_21$3 || (templateObject_21$3 = __makeTemplateObject$1(["\n  flex:0;\n  height: ", ";\n  ", ";\n\n"], ["\n  flex:0;\n  height: ", ";\n  ", ";\n\n"])), function (props) { return (props.isMobile ? 'auto' : '24px'); }, function (props) { return props.isMobile && "padding: 5px 0"; }));
var CountDownNumberWrapper = memo(CustomStyled(Flex)(templateObject_22$3 || (templateObject_22$3 = __makeTemplateObject$1(["\n\n  width: 23px;\n  height: 24px;\n  font-weight: 600;\n  font-size: 16px;\n  border-radius: 2px;\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  background: ", ";\n  color: ", ";\n  font-family: 'Montserrat';\n  @media (max-width : ", "){\n    width: 20px;\n    height: 20px;\n    font-weight: 600;\n    font-size: 14px;\n  }\n"], ["\n\n  width: 23px;\n  height: 24px;\n  font-weight: 600;\n  font-size: 16px;\n  border-radius: 2px;\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  background: ",
    ";\n  color: ", ";\n  font-family: 'Montserrat';\n  @media (max-width : ", "){\n    width: 20px;\n    height: 20px;\n    font-weight: 600;\n    font-size: 14px;\n  }\n"])), function (props) {
    return props.background_color;
}, function (props) { return props.timer_digits_color; }, function (props) { return props.theme.breakpoints[1]; }));
var CountDownNumberWrapperRigth = memo(CustomStyled(CountDownNumberWrapper)(templateObject_23$2 || (templateObject_23$2 = __makeTemplateObject$1(["\n  html[dir='ltr'] & {margin-left: 2px};\n  html[dir='rtl'] & {margin-right 2px};\n"], ["\n  html[dir='ltr'] & {margin-left: 2px};\n  html[dir='rtl'] & {margin-right 2px};\n"]))));
var CountDownNumberWrapperLeft = memo(CustomStyled(CountDownNumberWrapper)(templateObject_24$1 || (templateObject_24$1 = __makeTemplateObject$1(["\n  html[dir='ltr'] & {margin-right: 2px};\n  html[dir='rtl'] & {margin-left 2px};\n\n"], ["\n  html[dir='ltr'] & {margin-right: 2px};\n  html[dir='rtl'] & {margin-left 2px};\n\n"]))));
var CountDownNumberSeperator = memo(CustomStyled(Flex)(templateObject_25$1 || (templateObject_25$1 = __makeTemplateObject$1(["\n  height: 24px;\n  font-size: 20px;\n  color: ", ";\n  visibility: ", ";\n  padding: 0 8px;\n  line-height: 6px;\n  padding: 0 5px;\n  @media (max-width : ", "){\n    padding: 0 2px;\n  }\n  \n"], ["\n  height: 24px;\n  font-size: 20px;\n  color: ", ";\n  visibility: ", ";\n  padding: 0 8px;\n  line-height: 6px;\n  padding: 0 5px;\n  @media (max-width : ", "){\n    padding: 0 2px;\n  }\n  \n"])), function (props) { return props.font_color; }, function (props) { return (props.toogleSeprator ? "hidden" : 'visible'); }, function (props) { return props.theme.breakpoints[1]; }));
var CountdownText = memo(CustomStyled(Flex)(templateObject_26$1 || (templateObject_26$1 = __makeTemplateObject$1(["\n  color: ", ";\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px;\n"], ["\n  color: ", ";\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px;\n"])), function (props) { return props.timer_text_color; }));
var TimerWrapperBox = CustomStyled.div(templateObject_27$1 || (templateObject_27$1 = __makeTemplateObject$1(["\n    margin-right: auto;\n    margin-left: 15px;\n"], ["\n    margin-right: auto;\n    margin-left: 15px;\n"])));
var templateObject_1$A, templateObject_2$s, templateObject_3$n, templateObject_4$k, templateObject_5$f, templateObject_6$b, templateObject_7$b, templateObject_8$b, templateObject_9$a, templateObject_10$a, templateObject_11$7, templateObject_12$6, templateObject_13$6, templateObject_14$6, templateObject_15$6, templateObject_16$5, templateObject_17$5, templateObject_18$4, templateObject_19$4, templateObject_20$3, templateObject_21$3, templateObject_22$3, templateObject_23$2, templateObject_24$1, templateObject_25$1, templateObject_26$1, templateObject_27$1;
var DefaultStrip = function (_a) {
    var isMobile = _a.isMobile, url = _a.url, marketingInfo = _a.marketingInfo, GTMHandler = _a.GTMHandler;
    var href = url && url !== '#' && { href: url };
    return (React.createElement(TextWrapper$3, __assign$1({ isMobile: isMobile }, href, { onClick: function () { return GTMHandler('click', (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.title) || (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.name)); } }), (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.title) ? (React.createElement(React.Fragment, null,
        React.createElement(MarketingStripTitle, null,
            (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.icon) && React.createElement(IconWrapper$4, { src: marketingInfo.icon }),
            React.createElement(Title$1, { styles: marketingInfo.styles }, marketingInfo.title)),
        React.createElement(SubTitle, { isMobile: isMobile, styles: marketingInfo.styles, isTitle: marketingInfo.title }, marketingInfo.subtitle))) : (React.createElement(MarketingStripSubTitle, null,
        (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.icon) && React.createElement(IconWrapper$4, { src: marketingInfo.icon }),
        React.createElement(SubTitle, { styles: marketingInfo.styles }, marketingInfo.subtitle)))));
};
var BambuserStrip = function (_a) {
    var isMobile = _a.isMobile, _b = _a.bambuserData, _c = _b.thumbnail, thumbnail = _c === void 0 ? '' : _c, _d = _b.live_icon_title, live_icon_title = _d === void 0 ? '' : _d, _e = _b.live_icon_background_color, live_icon_background_color = _e === void 0 ? COLORS.RED : _e, _f = _b.title, title = _f === void 0 ? '' : _f, _g = _b.show_id, show_id = _g === void 0 ? '' : _g, _h = _b.mobile_viewport_title, mobile_viewport_title = _h === void 0 ? '' : _h, _j = _b.mobile_deep_link, mobile_deep_link = _j === void 0 ? '' : _j, styles = _a.styles, isBambuserMobileAppDisabled = _a.isBambuserMobileAppDisabled;
    var bambuserMobileAppDisabled = isBambuserMobileAppDisabled && isMobile;
    useBambuser(bambuserMobileAppDisabled ? '' : show_id, 'liveshopping');
    return (React.createElement(BambuserContainer, { isMobile: isMobile, id: "liveshopping", as: bambuserMobileAppDisabled ? 'a' : 'button', href: bambuserMobileAppDisabled ? mobile_deep_link : '' },
        React.createElement(BambuserStripWrapper, null,
            React.createElement(BambuserThumbnailWrapper, null,
                thumbnail && React.createElement(IconWrapper$4, { isBambuser: true, src: thumbnail }),
                live_icon_title && React.createElement(LiveIcon, { backgroundColor: live_icon_background_color }, live_icon_title)),
            !bambuserMobileAppDisabled && title && React.createElement(BambuserTitle, { styles: styles }, title),
            bambuserMobileAppDisabled && mobile_viewport_title && (React.createElement(BambuserTitle, { styles: styles }, mobile_viewport_title)))));
};
var Timer$1 = memo(function Timer(_a) {
    var marketingInfo = _a.marketingInfo, onClick = _a.onClick, onTimerExpire = _a.onTimerExpire;
    var prefixZero = function (deg) {
        return ('0' + deg).slice(-2);
    };
    var calculateTimeLeft = useCallback(function () {
        var endTime = marketingInfo.timer.end_at;
        var difference = +new Date(endTime) - +new Date();
        var timeLeft = {};
        if (difference >= 0) {
            timeLeft = {
                Days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                Hrs: Math.floor((difference / (1000 * 60 * 60)) % 24),
                Mins: Math.floor((difference / 1000 / 60) % 60),
                Secs: Math.floor((difference / 1000) % 60),
            };
        }
        else {
            onTimerExpire(true);
        }
        return timeLeft;
    }, [marketingInfo, onTimerExpire]);
    var _b = __read$1(useState(calculateTimeLeft()), 2), timeLeft = _b[0], setTimeLeft = _b[1];
    var _c = __read$1(useState(false), 2), toogleSeprator = _c[0], setToogleSeprator = _c[1];
    var isMobile = useBreakpoints().isMobile;
    useEffect(function () {
        var timer = setTimeout(function () {
            setTimeLeft(calculateTimeLeft());
            setToogleSeprator(!toogleSeprator);
        }, 1000);
        return function () { return clearTimeout(timer); };
    });
    var timerComponents = [];
    Object.keys(timeLeft).forEach(function (interval, index) {
        if (interval === 'Days' && !timeLeft[interval]) {
            return null;
        }
        if (interval === 'Hrs' && !timeLeft[interval] && !timeLeft['Days'])
            return null;
        if (interval === 'Days' && timeLeft[interval]) {
            delete timeLeft.Sec;
        }
        if (timeLeft[interval] === undefined)
            return null;
        var ele = prefixZero(timeLeft[interval]).split('');
        timerComponents.push(React.createElement(CountdownWrapper, { key: interval },
            React.createElement("div", { style: { display: 'flex', flexDirection: 'row' } },
                React.createElement(CountDownNumberWrapperLeft, __assign$1({}, marketingInfo.timer), ele[0]),
                React.createElement(CountDownNumberWrapperRigth, __assign$1({}, marketingInfo.timer), ele[1])),
            React.createElement(CountdownText, __assign$1({}, marketingInfo.timer), timeLeft[interval] === 1 ? interval.substr(0, interval.length - 1) : interval)));
        if (index !== Object.keys(timeLeft).length - 1)
            timerComponents.push(React.createElement(CountDownNumberSeperator, __assign$1({ toogleSeprator: toogleSeprator }, marketingInfo.timer), ":"));
    });
    var href = (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.cta_url) && { href: marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.cta_url };
    if (isMobile) {
        return (React.createElement(TimerWrapper, __assign$1({ onClick: onClick }, href),
            React.createElement(TimerWrapperBox, null,
                React.createElement(TitleTimerMobile, { styles: marketingInfo.styles }, marketingInfo.title),
                React.createElement(SubTitleTimer, { as: "span", styles: marketingInfo.styles, isMobile: isMobile }, marketingInfo.subtitle)),
            React.createElement(TimerWapperTextMobile, __assign$1({ dir: "ltr" }, marketingInfo, { isMobile: isMobile }), timerComponents)));
    }
    return (React.createElement(TimerWrapper, __assign$1({ onClick: onClick }, href),
        React.createElement(TitleTimer, { styles: marketingInfo.styles }, marketingInfo.title),
        React.createElement(TimerWapperText, { dir: "ltr" }, timerComponents),
        React.createElement(SubTitleTimer, { as: "span", styles: marketingInfo.styles }, marketingInfo.subtitle)));
});
var MarketingStrip = function (_a) {
    var _b, _c, _d;
    var isHideNav = _a.isHideNav, marketingInfo = _a.marketingInfo, loading = _a.loading;
    var _e = __read$1(useAppConfig(), 5), appConfigState = _e[0], setAppContext = _e[4];
    var _f = __read$1(useState(false), 2), isHide = _f[0], setIsHide = _f[1];
    var _g = __read$1(useState(false), 2), isTimerExpired = _g[0], setTimeExpired = _g[1];
    var _h = useBreakpoints(), isDesktop = _h.isDesktop, isMobile = _h.isMobile;
    var GTMEventCall = useAnalytic().GTMEventCall;
    var onClose = function () {
        isBrowser() && sessionStorage.setItem('isHideMarketingStrip', 'true');
        setIsHide(true);
    };
    var GTMHandler = useCallback(function (eventAction, eventLabel) {
        GTMEventCall(GTMEvents.custom_event, {
            eventAction: eventAction,
            eventLabel: eventLabel,
        });
    }, [GTMEventCall]);
    useEffect(function () {
        if (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.name) ;
    }, [GTMHandler, marketingInfo]);
    if (loading || !marketingInfo || isEmptyObject(marketingInfo))
        return null;
    if (isHide)
        return null;
    var _j = marketingInfo.type, type = _j === void 0 ? 'CLASSIC' : _j, bambuser = marketingInfo.bambuser, styles = marketingInfo.styles;
    var getStrip = function () {
        var _a;
        switch (type) {
            case 'BAMBUSER':
                return (React.createElement(BambuserStrip, { isMobile: isMobile, bambuserData: bambuser, styles: styles, isBambuserMobileAppDisabled: !!((_a = appConfigState === null || appConfigState === void 0 ? void 0 : appConfigState.features) === null || _a === void 0 ? void 0 : _a.isBambuserMobileAppDisabled) }));
            case 'CLASSIC':
            default:
                return React.createElement(DefaultStrip, { isMobile: isMobile, url: url, marketingInfo: marketingInfo, GTMHandler: GTMHandler });
        }
    };
    var onTimerExpire = function () {
        setTimeExpired(true);
    };
    var url = setAppContext(marketingInfo.cta_url);
    var isStart = ((_b = marketingInfo.timer) === null || _b === void 0 ? void 0 : _b.start_at) && +new Date(marketingInfo.timer.start_at) < Date.now();
    var isEnd = ((_c = marketingInfo.timer) === null || _c === void 0 ? void 0 : _c.start_at) && +new Date(marketingInfo.timer.end_at) > Date.now();
    var isTimer = !isTimerExpired &&
        marketingInfo.timer &&
        marketingInfo.timer.start_at &&
        marketingInfo.timer.end_at &&
        isStart &&
        isEnd;
    var isBambuser = type === 'BAMBUSER';
    return (React.createElement(MarketingStripWrapper, { isHideNav: isHideNav, styles: marketingInfo.styles, "data-testid": "marketing-strip" },
        React.createElement(MarketingStripText, { isTimer: isTimer, isBambuser: !isTimer && isBambuser },
            isTimer ? (React.createElement(Timer$1, { marketingInfo: marketingInfo, onClick: function () { return GTMHandler('click', (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.title) || (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.name)); }, onTimerExpire: onTimerExpire })) : (getStrip()),
            React.createElement(TextWrapper$3, { isTopCloseIcon: isMobile },
                isDesktop && marketingInfo.date && !marketingInfo.timer && (React.createElement(Title$1, { styles: marketingInfo.styles, fontSize: 1, marginRight: "15px" }, marketingInfo.date)),
                React.createElement(CloseIconWrapper$1, { onClick: onClose, isTimer: isTimer },
                    React.createElement(CloseIcon, { size: "S", fill: (_d = marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.styles) === null || _d === void 0 ? void 0 : _d.color }))))));
};
var MarketingStrip$1 = memo(MarketingStrip);
var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var windowObject = void 0;
if (typeof window !== 'undefined') {
  windowObject = window;
} else if (typeof self !== 'undefined') {
  windowObject = self;
} else {
  windowObject = global;
}
var cancelFrame = null;
var requestFrame = null;
var TIMEOUT_DURATION = 20;
var clearTimeoutFn = windowObject.clearTimeout;
var setTimeoutFn = windowObject.setTimeout;
var cancelAnimationFrameFn = windowObject.cancelAnimationFrame || windowObject.mozCancelAnimationFrame || windowObject.webkitCancelAnimationFrame;
var requestAnimationFrameFn = windowObject.requestAnimationFrame || windowObject.mozRequestAnimationFrame || windowObject.webkitRequestAnimationFrame;
if (cancelAnimationFrameFn == null || requestAnimationFrameFn == null) {
  cancelFrame = clearTimeoutFn;
  requestFrame = function requestAnimationFrameViaSetTimeout(callback) {
    return setTimeoutFn(callback, TIMEOUT_DURATION);
  };
} else {
  cancelFrame = function cancelFrame(_ref) {
    var _ref2 = slicedToArray(_ref, 2),
        animationFrameID = _ref2[0],
        timeoutID = _ref2[1];
    cancelAnimationFrameFn(animationFrameID);
    clearTimeoutFn(timeoutID);
  };
  requestFrame = function requestAnimationFrameWithSetTimeoutFallback(callback) {
    var animationFrameID = requestAnimationFrameFn(function animationFrameCallback() {
      clearTimeoutFn(timeoutID);
      callback();
    });
    var timeoutID = setTimeoutFn(function timeoutCallback() {
      cancelAnimationFrameFn(animationFrameID);
      callback();
    }, TIMEOUT_DURATION);
    return [animationFrameID, timeoutID];
  };
}
function createDetectElementResize(nonce) {
  var animationKeyframes = void 0;
  var animationName = void 0;
  var animationStartEvent = void 0;
  var animationStyle = void 0;
  var checkTriggers = void 0;
  var resetTriggers = void 0;
  var scrollListener = void 0;
  var attachEvent = typeof document !== 'undefined' && document.attachEvent;
  if (!attachEvent) {
    resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };
    checkTriggers = function checkTriggers(element) {
      return element.offsetWidth !== element.__resizeLast__.width || element.offsetHeight !== element.__resizeLast__.height;
    };
    scrollListener = function scrollListener(e) {
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }
      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame(function animationFrame() {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function forEachResizeListener(fn) {
            fn.call(element, e);
          });
        }
      });
    };
    var animation = false;
    var keyframeprefix = '';
    animationStartEvent = 'animationstart';
    var domPrefixes = 'Webkit Moz O ms'.split(' ');
    var startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' ');
    var pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }
      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationStartEvent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }
    animationName = 'resizeanim';
    animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }
  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');
      style.id = 'detectElementResize';
      style.type = 'text/css';
      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }
      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }
      head.appendChild(style);
    }
  };
  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = windowObject.getComputedStyle(element);
        if (elementStyle && elementStyle.position === 'static') {
          element.style.position = 'relative';
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        var expandTrigger = doc.createElement('div');
        expandTrigger.className = 'expand-trigger';
        expandTrigger.appendChild(doc.createElement('div'));
        var contractTrigger = doc.createElement('div');
        contractTrigger.className = 'contract-trigger';
        element.__resizeTriggers__.appendChild(expandTrigger);
        element.__resizeTriggers__.appendChild(contractTrigger);
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);
        if (animationStartEvent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName === animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationStartEvent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };
  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationStartEvent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
        }
      }
    }
  };
  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
var AutoSizer = function (_React$PureComponent) {
  inherits(AutoSizer, _React$PureComponent);
  function AutoSizer() {
    var _ref;
    var _temp, _this, _ret;
    classCallCheck(this, AutoSizer);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    }, _this._onResize = function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;
      if (_this._parentNode) {
        var _height = _this._parentNode.offsetHeight || 0;
        var _width = _this._parentNode.offsetWidth || 0;
        var _style = window.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;
        var newHeight = _height - paddingTop - paddingBottom;
        var newWidth = _width - paddingLeft - paddingRight;
        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: _height - paddingTop - paddingBottom,
            width: _width - paddingLeft - paddingRight
          });
          onResize({ height: _height, width: _width });
        }
      }
    }, _this._setRef = function (autoSizer) {
      _this._autoSizer = autoSizer;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }
  createClass(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;
      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        this._parentNode = this._autoSizer.parentNode;
        this._detectElementResize = createDetectElementResize(nonce);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
        this._onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          width = _state.width;
      var outerStyle = { overflow: 'visible' };
      var childParams = {};
      var bailoutOnChildren = false;
      if (!disableHeight) {
        if (height === 0) {
          bailoutOnChildren = true;
        }
        outerStyle.height = 0;
        childParams.height = height;
      }
      if (!disableWidth) {
        if (width === 0) {
          bailoutOnChildren = true;
        }
        outerStyle.width = 0;
        childParams.width = width;
      }
      return createElement(
        'div',
        {
          className: className,
          ref: this._setRef,
          style: _extends({}, outerStyle, style)
        },
        !bailoutOnChildren && children(childParams)
      );
    }
  }]);
  return AutoSizer;
}(PureComponent);
AutoSizer.defaultProps = {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
};
var QuantitySelectorWrapper = CustomStyled.div(templateObject_1$B || (templateObject_1$B = __makeTemplateObject$1(["\n  width: 100%;\n  display: inline-block;\n  ", ";\n  ", "\n"], ["\n  width: 100%;\n  display: inline-block;\n  ", ";\n  ",
    "\n"])), space, function (props) {
    return variant({
        prop: 'variant',
        variants: {
            pdp: {
                height: 37,
                border: props.inCart ? 'none' : "1px solid " + props.theme.colors.mercury,
                padding: '4px 4px',
                textAlign: 'center',
                background: props.inCart ? 'transparent' : "" + props.theme.colors.white,
                width: props.inCart ? [68, 157] : [100, 51],
                minWidth: '100%',
                borderRadius: '4px',
                svg: {
                    height: 10,
                    width: 10,
                    marginLeft: 1,
                    marginRight: 1,
                },
            },
            fbt: {
                svg: {
                    height: 12,
                    width: 12,
                    marginLeft: 2,
                },
            },
            regular: {
                height: props.open ? 28 : 30,
            },
        },
    });
});
var SelectBox = CustomStyled(Flex)(templateObject_2$t || (templateObject_2$t = __makeTemplateObject$1(["\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  color: #4d4d4d;\n  cursor: pointer;\n  background: none;\n  height: 32px;\n  border-radius: 2px;\n\n  &::after {\n    background: grey;\n    position: absolute;\n    top: 12px;\n    left: 8px;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #fff;\n    width: 0;\n    height: 0;\n  }\n\n  span:first-of-type, svg > path:first-of-type {\n    transition: color 0.25s ease, stroke 0.25s ease;\n  }\n\n  ", "\n\n  ", "\n \n  ", "\n  \n  ", "\n  \n  ", "\n"], ["\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  color: #4d4d4d;\n  cursor: pointer;\n  background: none;\n  height: 32px;\n  border-radius: 2px;\n\n  &::after {\n    background: grey;\n    position: absolute;\n    top: 12px;\n    left: 8px;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #fff;\n    width: 0;\n    height: 0;\n  }\n\n  span:first-of-type, svg > path:first-of-type {\n    transition: color 0.25s ease, stroke 0.25s ease;\n  }\n\n  ",
    "\n\n  ",
    "\n \n  ",
    "\n  \n  ",
    "\n  \n  ",
    "\n"])), function (props) {
    return props.isLoading &&
        "\n    cursor: default;\n\n    span:first-of-type {\n      color: " + props.theme.colors.mercury + ";\n\n      + div {\n        cursor: default;\n      }\n    }\n\n\n    svg > path:first-of-type {\n      stroke: " + props.theme.colors.mercury + ";\n    }\n  ";
}, function (props) {
    return !props.expandQtySelector &&
        "\n    position: absolute;\n    bottom: 0;\n  ";
}, function (props) {
    return props.dir == 'rtl'
        ? "\n    left: 0;\n  "
        : "right: 0;";
}, function (props) {
    return props.expandQtySelector &&
        "\n    position: static;\n  ";
}, function (props) {
    return variant({
        variants: {
            fbt: {
                width: '82px',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 0,
                margin: '0 12px',
                svg: {
                    height: '12px',
                    width: '12px',
                },
            },
            pdp: {
                padding: 0,
                height: 27,
                background: 'transparent',
                justifyContent: 'center',
            },
            regular: {
                width: props.soldByWeight ? 'auto' : '32px',
                minWidth: props.soldByWeight && '32px',
                height: '32px',
                background: 'rgb(14, 90, 167)',
                borderRadius: '16px',
                placeContent: 'center',
                padding: props.soldByWeight ? '6px 12px' : '0',
            },
            regular_wide: {
                width: props.soldByWeight ? 'auto' : '32px',
                minWidth: props.soldByWeight && '32px',
                height: '32px',
                borderRadius: '16px',
                placeContent: 'center',
                color: props.theme.colors.black,
                padding: props.soldByWeight ? '6px 12px' : '0',
            },
            list: {
                size: 23,
            },
            compact: {
                height: 23,
                width: 40,
            },
            mini: {
                height: 23,
            },
        },
    });
});
var SelectBoxLabel = CustomStyled.span(templateObject_3$o || (templateObject_3$o = __makeTemplateObject$1(["\n  color: ", ";\n  overflow: hidden;\n  line-height: normal;\n  @media only screen and (max-width: 1264px) {\n    text-overflow: ellipsis;\n  };\n  white-space: nowrap;\n\n\n  ", "\n\n  ", "\n"], ["\n  color: ", ";\n  overflow: hidden;\n  line-height: normal;\n  @media only screen and (max-width: 1264px) {\n    text-overflow: ellipsis;\n  };\n  white-space: nowrap;\n\n\n  ",
    "\n\n  ",
    "\n"])), function (props) { return props.theme.colors.copy; }, function (props) {
    return variant({
        prop: 'productCardVariant',
        variants: {
            mini: {
                fontSize: props.theme.fontSizes[props.inCart ? 1 : 2] + "px",
                paddingRight: 4,
            },
            simple: {
                paddingRight: 1,
            },
        },
    });
}, function (props) {
    return variant({
        prop: 'variant',
        variants: {
            pdp: {
                width: props.inCart ? 'auto' : '',
                fontSize: '12px',
                fontWeight: 700,
            },
            regular: {
                color: props.theme.colors.white,
                fontWeight: 700,
            },
            regular_wide: {
                color: props.theme.colors.black,
                fontWeight: 700,
                background: 'transparent !important',
            },
            list: {
                color: props.theme.colors.blue,
                fontWeight: 700,
                marginRight: '3px',
            },
            compact: {
                color: props.theme.colors.blue,
                fontWeight: 700,
                marginRight: '3px',
            },
        },
    });
});
var SelectOption = CustomStyled.li(templateObject_4$l || (templateObject_4$l = __makeTemplateObject$1(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #4d4d4d;\n  cursor: pointer;\n  text-align: center;\n\n  ", "\n  span {\n    color: rgba(77, 77, 77, 0.7);\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #4d4d4d;\n  cursor: pointer;\n  text-align: center;\n\n  ",
    "\n  span {\n    color: rgba(77, 77, 77, 0.7);\n  }\n"])), function (props) {
    var selected = props.selected;
    if (selected) {
        return "\n      ";
    }
});
var SelectOptionsHeader = CustomStyled.h4(templateObject_5$g || (templateObject_5$g = __makeTemplateObject$1(["\n  width: 100%;\n  top: 0;\n  padding: 12px;\n  color: ", ";\n  border-bottom: 1px solid ", ";\n  display: flex;\n  justify-content: space-between;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px 0px;\n"], ["\n  width: 100%;\n  top: 0;\n  padding: 12px;\n  color: ", ";\n  border-bottom: 1px solid ", ";\n  display: flex;\n  justify-content: space-between;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px 0px;\n"])), function (props) { return props.theme.colors.blacks[6]; }, function (props) { return props.theme.colors.blacks[3]; });
var SelectOptionQuantity = CustomStyled(Flex)(templateObject_6$c || (templateObject_6$c = __makeTemplateObject$1(["\n  padding-left: 28px;\n  position: relative;\n  font-weight: 500;\n  color: ", ";\n::before{\n  content:\"\";\n  width: 19px;\n  height: 19px;\n  border-radius: 100%;\n  border: 2px solid ", ";\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n::after{\n  content:\"\";\n  width: 11px;\n  height: 11px;\n  border-radius: 100%;\n  position: absolute;\n  left: 4px;\n  top: 4px;\n  background: #4D4D4D;\n  opacity: 0;\n    ", "\n}\n"], ["\n  padding-left: 28px;\n  position: relative;\n  font-weight: 500;\n  color: ", ";\n::before{\n  content:\"\";\n  width: 19px;\n  height: 19px;\n  border-radius: 100%;\n  border: 2px solid ", ";\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n::after{\n  content:\"\";\n  width: 11px;\n  height: 11px;\n  border-radius: 100%;\n  position: absolute;\n  left: 4px;\n  top: 4px;\n  background: #4D4D4D;\n  opacity: 0;\n    ",
    "\n}\n"])), function (props) { return ((props === null || props === void 0 ? void 0 : props.selected) ? props.theme.colors.black : props.theme.colors.black); }, function (props) { return ((props === null || props === void 0 ? void 0 : props.selected) ? '#4D4D4D' : '#969696'); }, function (props) {
    var selected = props.selected;
    if (selected) {
        return "opacity: 1";
    }
});
var SelectOptionPrice = CustomStyled(Flex)(templateObject_7$c || (templateObject_7$c = __makeTemplateObject$1(["\ncolor: ", ";\n "], ["\ncolor: ", ";\n "])), function (props) { return ((props === null || props === void 0 ? void 0 : props.selected) ? props.theme.colors.black : props.theme.colors.black); });
var SelecOptionWrapper = CustomStyled(Flex)(templateObject_8$c || (templateObject_8$c = __makeTemplateObject$1(["\npadding: 0  ", "px;\nwidth: 100%;\njustify-content: space-between;\nfont-weight: 700;\nheight: 19px;\nline-height: 19px;\n&:hover{\n  color: ", ";\n}\n\n", "\n"], ["\npadding: 0  ", "px;\nwidth: 100%;\njustify-content: space-between;\nfont-weight: 700;\nheight: 19px;\nline-height: 19px;\n&:hover{\n  color: ", ";\n}\n\n",
    "\n"])), function (props) { return props.theme.space[4]; }, function (props) { return props.theme.colors.blue; }, variant({
    variants: {
        mini: {
            padding: '0 12px',
        },
    },
}));
var SelectOptionsContainer = CustomStyled.div(templateObject_9$b || (templateObject_9$b = __makeTemplateObject$1(["\n  position: absolute;\n  overflow-x: hidden;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background-color: ", ";\n  ", "\n  z-index: 3;\n    ", "\n"], ["\n  position: absolute;\n  overflow-x: hidden;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background-color: ", ";\n  ",
    "\n  z-index: 3;\n    ",
    "\n"])), function (props) { return props.theme.colors.white; }, function (props) {
    return props.isMobile &&
        "\n      position: fixed;\n      bottom: 0;\n      top: auto;\n      height: 150px;\n  ";
}, function (props) {
    return variant({
        prop: 'variant',
        variants: {
            pdp: {
                overflowY: props.isSticky ? ['hidden', 'visible'] : 'visible',
                position: props.isSticky ? ['fixed', 'absolute'] : 'absolute',
                height: (props === null || props === void 0 ? void 0 : props.selectHeight) ? (props === null || props === void 0 ? void 0 : props.selectHeight) + 20 : ['30%', 215],
                paddingTop: [10, '7px'],
                paddingBottom: [10, '5px'],
                maxHeight: props.isSticky ? ['55%', 225] : 225,
                minHeight: [84, 'unset'],
                marginTop: [1],
                bottom: 0,
                top: props.isSticky ? ['auto', '40px'] : '40px',
                width: ['100%', props.inCart ? 157 : '100%'],
                minWidth: '100%',
                zIndex: '3',
                boxShadow: '0px 4px 4px rgb(0 0 0 / 15%)',
                borderRadius: "4px",
            },
            regular: {
                height: 143,
                bottom: '-12px',
                left: '-12px',
                right: '-12px',
                width: 'auto',
                top: 'auto',
                zIndex: '3',
                boxShadow: '0px -2px 6px rgba(0, 0, 0, 0.25)',
                borderRadius: "6px",
            },
            mini: {
                height: 143,
                bottom: '-8px',
                left: '-8px',
                right: '-8px',
                width: 'auto',
                top: 'auto',
                zIndex: '3',
                boxShadow: '0px -2px 6px rgba(0, 0, 0, 0.25)',
                borderRadius: "6px",
                fontSize: '10px',
            },
            fbt: {
                overflowY: props.isSticky ? ['hidden', 'visible'] : 'visible',
                position: props.isSticky ? ['fixed', 'absolute'] : 'absolute',
                height: props.isSticky ? ['75%', 215] : 215,
                top: props.isSticky ? ['auto', 0] : [0],
                bottom: 0,
            },
        },
    });
});
var StyledIconContainer = CustomStyled.div(templateObject_10$b || (templateObject_10$b = __makeTemplateObject$1(["\n  cursor: pointer;\n  transform: rotate(90deg);\n  ", "\n"], ["\n  cursor: pointer;\n  transform: rotate(90deg);\n  ",
    "\n"])), variant({
    prop: 'variant',
    variants: {
        pdp: {
            transform: 'rotate(360deg)',
            marginBottom: '3px',
        },
    },
}));
var SelectorProductDetails = styled(Box)(templateObject_11$8 || (templateObject_11$8 = __makeTemplateObject$1(["\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n"], ["\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n"])));
SelectorProductDetails.defaultProps = {
    display: ['inline-block', 'none'],
    padding: ['16px', 0],
    width: '100%',
    mb: '4px',
};
var SelectorProductImage = customStyled.figure(templateObject_12$7 || (templateObject_12$7 = __makeTemplateObject$1(["\n  width: 100px;\n  height: 100px;\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0;\n"], ["\n  width: 100px;\n  height: 100px;\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0;\n"])));
var SelectorProductTitle = customStyled.span(templateObject_13$7 || (templateObject_13$7 = __makeTemplateObject$1(["\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 500;\n  margin-left: 16px;\n  vertical-align: middle;\n  white-space: normal;\n  color: #4d4d4d;\n  max-width: calc(100% - 120px);\n"], ["\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 500;\n  margin-left: 16px;\n  vertical-align: middle;\n  white-space: normal;\n  color: #4d4d4d;\n  max-width: calc(100% - 120px);\n"])));
var SelectorPdpBackgound = styled(Box)(templateObject_14$7 || (templateObject_14$7 = __makeTemplateObject$1(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  background-color: rgba(0, 0, 0, 0.5);\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  background-color: rgba(0, 0, 0, 0.5);\n"])));
SelectorPdpBackgound.defaultProps = {
    display: ['block', 'none'],
};
var CloseText = styled(Box)(templateObject_15$7 || (templateObject_15$7 = __makeTemplateObject$1(["\n  text-align: right;\n  margin-top: 5px;\n  font-size: 9px;\n  color: #000408;\n  cursor: pointer;\n"], ["\n  text-align: right;\n  margin-top: 5px;\n  font-size: 9px;\n  color: #000408;\n  cursor: pointer;\n"])));
CloseText.defaultProps = {
    mr: ['25px', null, null, '5px'],
};
var templateObject_1$B, templateObject_2$t, templateObject_3$o, templateObject_4$l, templateObject_5$g, templateObject_6$c, templateObject_7$c, templateObject_8$c, templateObject_9$b, templateObject_10$b, templateObject_11$8, templateObject_12$7, templateObject_13$7, templateObject_14$7, templateObject_15$7;
var QuantityOption = memo(function (_a) {
    var data = _a.data, index = _a.index, style = _a.style;
    var options = data.options, onSelectOptionHandle = data.onSelectOptionHandle, selected = data.selected;
    var option = options[index];
    return (React.createElement(SelectOption, { key: index, onClick: onSelectOptionHandle(option), selected: selected === option, style: style }, option.label));
}, areEqual);
var QuantityOptionPDP = memo(function (_a) {
    var data = _a.data, index = _a.index, style = _a.style;
    var options = data.options, onSelectOptionHandle = data.onSelectOptionHandle, selected = data.selected, currency = data.currency, variant = data.variant;
    var option = options[index];
    return (React.createElement(SelectOption, { key: index, onClick: onSelectOptionHandle(option), selected: selected === option, style: style },
        React.createElement(SelecOptionWrapper, { variant: variant },
            React.createElement(SelectOptionQuantity, { selected: selected === option }, option.label),
            React.createElement(SelectOptionPrice, { selected: selected === option },
                currency,
                " ",
                option.price))));
}, areEqual);
var createItemData = memoize(function (options, selected, onSelectOptionHandle, currency) { return ({
    options: options,
    selected: selected,
    onSelectOptionHandle: onSelectOptionHandle,
    currency: currency,
}); });
var QuantitySelector = function (props) {
    var _a;
    var _b = props.inCart, inCart = _b === void 0 ? false : _b, _c = props.isLoading, isLoading = _c === void 0 ? false : _c, _d = props.isOpen, isOpen = _d === void 0 ? false : _d, onSelectHandler = props.onSelectHandler, _e = props.options, options = _e === void 0 ? [] : _e, _f = props.productCardVariant, productCardVariant = _f === void 0 ? EProductCardVariants.REGULAR : _f, selectOnChange = props.selectOnChange, selectedValue = props.selectedValue, soldByWeight = props.soldByWeight, productImage = props.productImage, onlineName = props.onlineName, _g = props.isSticky, isSticky = _g === void 0 ? false : _g, _h = props.variant, variant = _h === void 0 ? 'plp' : _h, _j = props.currency, currency = _j === void 0 ? '' : _j, isNewCarrefourJourney = props.isNewCarrefourJourney, expandQtySelector = props.expandQtySelector, dir = props.dir, productId = props.productId;
    var _k = __read$1(useState(false), 2), open = _k[0], setOpen = _k[1];
    var t = useTranslation().t;
    var _l = __read$1(useState(options[0]), 2), selected = _l[0], setSelected = _l[1];
    var selectHeaderRef = useRef();
    var detailsRef = useRef();
    var isMobile = useBreakpoints().isMobile;
    useEffect(function () {
        setOpen(isOpen);
    }, [isOpen]);
    useEffect(function () {
        if (!selectedValue) {
            setSelected(options[0]);
        }
        else {
            var selectedOption = options.filter(function (option) { return option.value === selectedValue; })[0];
            setSelected(selectedOption);
        }
    }, [options, selectedValue]);
    var onHeaderCloseHandler = function () {
        setOpen(false);
        if (onSelectHandler) {
            onSelectHandler(false);
        }
    };
    var onSelectOptionHandle = function (option) { return function () {
        var state = !open;
        setOpen(state);
        if (selectOnChange) {
            selectOnChange(option);
        }
        else {
            setSelected(option);
        }
        if (onSelectHandler) {
            onSelectHandler(state);
        }
    }; };
    var dispatch = useDispatch();
    var onSelectBox = function () {
        if (!isNewCarrefourJourney) {
            var state_1 = !isLoading && !open;
            setOpen(state_1);
            setTimeout(function () {
                if (onSelectHandler) {
                    onSelectHandler(state_1);
                }
            });
        }
        else {
            dispatch(setExpandedQtySelectorProductId(productId));
        }
    };
    var onClose = function () {
        setOpen(false);
    };
    var itemData = createItemData(options, selected, onSelectOptionHandle, currency);
    itemData.variant = variant;
    return (React.createElement(React.Fragment, null,
        React.createElement(QuantitySelectorWrapper, { variant: variant, inCart: inCart, open: open }, (!open || variant === EProductCardVariants.FBT || variant === EProductCardVariants.PDP) && (React.createElement(SelectBox, { expandQtySelector: !isNewCarrefourJourney ? true : expandQtySelector, variant: variant, isLoading: isLoading, open: variant === EProductCardVariants.REGULAR_WIDE ? true : open, onClick: onSelectBox, "data-testid": "select-box", dir: dir, soldByWeight: soldByWeight },
            React.createElement(SelectBoxLabel, { "data-testid": "select-label", inCart: inCart, productCardVariant: productCardVariant, variant: variant },
                selected &&
                    (isNewCarrefourJourney && soldByWeight
                        ? formatPriceForScalablePrducts(selected.value)
                        : selected.label),
                inCart &&
                    (variant === EProductCardVariants.FBT || variant === EProductCardVariants.PDP) &&
                    "(" + currency + " " + selected.price + ")",
                React.createElement("span", null)),
            variant !== EProductCardVariants.REGULAR_WIDE && (React.createElement(StyledIconContainer, { variant: variant }, variant === EProductCardVariants.PDP ? (React.createElement(ArrowDown, { size: "XS", fill: "#4d4d4d" })) : ((!isNewC4Journey ||
                (variant !== EProductCardVariants.REGULAR && variant !== EProductCardVariants.REGULAR_WIDE)) && (React.createElement(ArrowDark, { size: "CUSTOM", height: "14px", width: "9px", fill: "#0E5AA7" })))))))),
        open && (React.createElement(React.Fragment, null,
            (variant === EProductCardVariants.PDP || variant === EProductCardVariants.FBT) && isSticky && (React.createElement(SelectorPdpBackgound, null)),
            React.createElement(SelectOptionsContainer, { key: "select-options-container", variant: variant, isSticky: isSticky, selectHeight: ((_a = itemData === null || itemData === void 0 ? void 0 : itemData.options) === null || _a === void 0 ? void 0 : _a.length) * 42 || 0, isMobile: isMobile },
                variant !== EProductCardVariants.PDP &&
                    variant !== EProductCardVariants.REGULAR &&
                    variant !== EProductCardVariants.REGULAR_WIDE &&
                    variant !== EProductCardVariants.MINI &&
                    variant !== EProductCardVariants.COMPACT &&
                    variant !== EProductCardVariants.LIST ? (React.createElement(SelectOptionsHeader, { "data-testid": "select-header", ref: selectHeaderRef },
                    "- ",
                    soldByWeight ? t('productCard.selectWeight') : t('productCard.selectQuantity'),
                    "-",
                    ' ',
                    React.createElement(StyledIconContainer, { "data-testid": "select-header-close", onClick: onHeaderCloseHandler, variant: variant },
                        "- \u2715 -",
                        ' '),
                    "-",
                    ' ')) : null,
                variant === EProductCardVariants.FBT && isSticky && (React.createElement(SelectorProductDetails, { ref: detailsRef },
                    React.createElement(SelectorProductImage, null,
                        React.createElement(Image, { url: productImage, name: onlineName })),
                    React.createElement(SelectorProductTitle, { dangerouslySetInnerHTML: { __html: onlineName } }))),
                (variant === EProductCardVariants.REGULAR ||
                    variant === EProductCardVariants.REGULAR_WIDE ||
                    variant === EProductCardVariants.MINI ||
                    variant === EProductCardVariants.COMPACT ||
                    variant === EProductCardVariants.LIST) && (React.createElement(CloseText, { onClick: onClose }, t('productCard.close'))),
                React.createElement(AutoSizer, null, function (_a) {
                    var _b, _c;
                    var height = _a.height, width = _a.width;
                    return (React.createElement(FixedSizeList, { height: variant === EProductCardVariants.PDP ||
                            variant === EProductCardVariants.REGULAR ||
                            variant === EProductCardVariants.REGULAR_WIDE ||
                            variant === EProductCardVariants.MINI ||
                            variant === EProductCardVariants.COMPACT ||
                            variant === EProductCardVariants.LIST
                            ? height - (((_b = detailsRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0)
                            : height -
                                -selectHeaderRef.current.offsetHeight -
                                -(((_c = detailsRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight) || 0), itemCount: options.length, itemData: itemData, itemSize: 42, ref: function (el) { return el && el.scrollToItem(options.indexOf(selected), 'start'); }, width: width, "data-testid": "product_qnty_picker" }, variant === EProductCardVariants.PDP ||
                        variant === EProductCardVariants.REGULAR ||
                        variant === EProductCardVariants.REGULAR_WIDE ||
                        variant === EProductCardVariants.MINI ||
                        variant === EProductCardVariants.COMPACT ||
                        variant === EProductCardVariants.LIST
                        ? QuantityOptionPDP
                        : QuantityOption));
                }))))));
};
var formatPriceForScalablePrducts = function (price) {
    return price < 1 ? price * 1000 + 'g' : price + 'kg';
};
var useProductCard = function (productId) {
    var productCardSelector = function (state) { return state.productCard; };
    var selectProductCard = createSelector(productCardSelector, function (productCard) { return productCard; });
    var makeSelectProductCardState = function () {
        return createSelector(selectProductCard, function (_, productId) { return productId; }, function (state, productId) {
            var product = state[productId];
            if (product) {
                return {
                    error: product.error,
                    errDetail: product.errDetail,
                    loading: product.loading,
                };
            }
            else {
                return {
                    error: false,
                    errDetail: '',
                    loading: false,
                };
            }
        });
    };
    var selectProductCardState = useMemo(makeSelectProductCardState, []);
    var productCardState = useSelector(function (state) { return selectProductCardState(state, productId); });
    return productCardState;
};
var hasReachedQtyMinLimit = function (qty, min) { return qty <= min; };
var hasReachedQtyMaxLimit = function (qty, max) { return qty >= max; };
var isQtyOnlyOne = function (min, max) { return min === max; };
var getDecreaseButtonProps = function (_a) {
    var quantity = _a.quantity, min = _a.min, onDecrementHandler = _a.onDecrementHandler, onRemoveHandler = _a.onRemoveHandler, soldByWeight = _a.soldByWeight, variant = _a.variant, setQuantitySelector = _a.setQuantitySelector, isNewCarrefourJourney = _a.isNewCarrefourJourney;
    var defaultDecreaseButtonProps = {
        children: variant === EProductCardVariants.PDP
            ? '-'
            : createElement(MinusAlt, {
                size: 'S',
                fill: variant === EProductCardVariants.REGULAR_WIDE ? COLORS.BLUE : COLORS.WHITE,
            }),
        onClick: onDecrementHandler,
    };
    var isDelete = hasReachedQtyMinLimit(quantity, parseFloat(formatQuantityKG(min, soldByWeight)));
    var DeleteIconProps = {
        size: 'S',
        fill: variant === EProductCardVariants.REGULAR_WIDE ? COLORS.BLUE : COLORS.WHITE,
    };
    quantity === 0 && setQuantitySelector(false);
    var checkIsNewCarrefour = function (condition) { return (condition ? Minus : Trash); };
    return __assign$1(__assign$1({}, defaultDecreaseButtonProps), (isDelete
        ? {
            children: createElement(variant === EProductCardVariants.FBT
                ? TrashAlt
                : quantity > 1
                    ? Minus
                    : checkIsNewCarrefour(isNewCarrefourJourney), DeleteIconProps),
            onClick: onRemoveHandler,
        }
        : {}));
};
var QuantitySelectorWrapper$1 = CustomStyled(Box)(templateObject_1$C || (templateObject_1$C = __makeTemplateObject$1(["\n    ", "\n"], ["\n    ",
    "\n"])), function (props) {
    return variant({
        variants: {
            pdp: {
                display: props.isBuyNow ? 'none' : '',
                position: 'static',
                margin: props.inCart ? '0' : '0 0 0 0',
                flex: props.inCart ? 1 : 'none',
                height: 37,
                width: props.inCart ? [100, 157] : props.isSticky ? '33%' : [100, 51],
            },
        },
    });
});
var CartButtonWrapper = CustomStyled(Box)(templateObject_2$u || (templateObject_2$u = __makeTemplateObject$1(["\n      ", "\n         button {\n           ", "\n           }\n"], ["\n      ",
    "\n         button {\n           ",
    "\n           }\n"])), function (props) {
    return variant({
        variants: {
            pdp: {
                maxWidth: props.isBuyNow ? '100%' : ['100%', '262px'],
                width: '64%',
                height: 37,
                lineHeight: '37px',
            },
        },
    });
}, function (props) {
    return variant({
        variants: {
            pdp: {
                width: '100%',
                height: '100%',
                cursor: 'pointer',
                backgroundColor: props.theme.colors.blue,
                borderRadius: props.theme.radii[1],
                fontSize: [16, 16, 16, 16, 14],
                fontWeight: props.theme.fontWeights[6],
                lineHeight: '37px',
                padding: '0px 10px',
                '&:hover': {
                    backgroundColor: props.theme.colors.blue,
                },
            },
            regular: {
                backgroundColor: props.theme.colors.blue,
            },
        },
    });
});
var CartActionsWrapper = CustomStyled(Flex)(templateObject_3$p || (templateObject_3$p = __makeTemplateObject$1(["\n  flex-grow: 1;\n  justify-content: space-between;\n  border-radius: 18px;\n  color: ", ";\n  ", "\n  button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ", "\n}\n     button[data-testid=\"btn-decrement\"]{\n      ", "\n             ", "\n      }\n      \n      button[data-testid=\"btn-increment\"]{\n        ", "\n        ", "\n      }\n\n"], ["\n  flex-grow: 1;\n  justify-content: space-between;\n  border-radius: 18px;\n  color: ", ";\n  ",
    "\n  button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ",
    "\n}\n     button[data-testid=\"btn-decrement\"]{\n      ",
    "\n             ",
    "\n      }\n      \n      button[data-testid=\"btn-increment\"]{\n        ",
    "\n        ",
    "\n      }\n\n"])), function (props) { return props.theme.colors.white; }, function (props) {
    return variant({
        variants: {
            regular: {
                backgroundColor: props.theme.colors.blue,
            },
        },
    });
}, function (props) {
    return variant({
        variants: {
            fbt: {
                backgroundColor: props.theme.colors.blue,
                svg: {
                    height: '16px',
                    width: '14px',
                    fill: props.isMin ? props.theme.colors.white : props.theme.colors.blue,
                },
                ':disabled': {
                    opacity: 0.5,
                },
                ':first-of-type': {
                    backgroundColor: props.isMin ? 'rgba(14, 90, 167, 0.3)' : props.theme.colors.blue,
                },
            },
            pdp: {
                backgroundColor: props.theme.colors.blue,
                borderRadius: props.theme.radii[1],
                lineHeight: '26px',
                '&:hover': {
                    backgroundColor: props.theme.colors.blue,
                },
            },
            regular: {
                lineHeight: '26px',
                '&:hover': {
                    backgroundColor: props.theme.colors.blue,
                },
            },
            regular_wide: {
                lineHeight: '26px',
            },
            mini: {
                borderRadius: props.theme.radii[1],
                lineHeight: '26px',
                '&:hover': {
                    backgroundColor: props.theme.colors.blue,
                },
            },
        },
    });
}, function (props) {
    return props.disabled &&
        "\n        background-color: transparent !important;\n        opacity: 0.5;\n      ";
}, function (props) {
    return variant({
        variants: {
            pdp: {
                backgroundColor: props.theme.colors.blue,
            },
            regular: { color: COLORS.BODY, borderRadius: '18px' },
            regular_wide: {
                color: COLORS.BODY,
                borderRadius: '18px',
                backgroundColor: props.theme.colors.alabaster + " !important",
            },
        },
    });
}, function (props) {
    return props.disabled &&
        "\n          background-color: transparent !important;\n          opacity: 0.5;\n        ";
}, function (props) {
    return variant({
        variants: {
            pdp: {
                color: props.theme.colors.alabaster,
            },
            regular: {
                color: props.theme.colors.alabaster,
                borderRadius: '18px',
                '&:hover': {
                    background: 'rgb(14, 90, 167) !important',
                },
            },
            regular_wide: {
                color: props.theme.colors.alabaster,
                borderRadius: '18px',
                backgroundColor: props.theme.colors.alabaster + " !important",
            },
        },
    });
});
var DisclaimerButtonWrapper = CustomStyled(Flex)(templateObject_4$m || (templateObject_4$m = __makeTemplateObject$1(["\nflex-direction: column;\njustify-content: space-between"], ["\nflex-direction: column;\njustify-content: space-between"])));
var CancelText = CustomStyled(Box)(templateObject_5$h || (templateObject_5$h = __makeTemplateObject$1(["\nfont-size: 14px;\nfont-weight: bold;\npadding: 16px 24px;\ntext-transform: uppercase;\ntext-align: center;\n"], ["\nfont-size: 14px;\nfont-weight: bold;\npadding: 16px 24px;\ntext-transform: uppercase;\ntext-align: center;\n"])));
var MessageText = CustomStyled(Box)(templateObject_6$d || (templateObject_6$d = __makeTemplateObject$1(["\npadding-top: 16px;\npadding-bottom: 16px;"], ["\npadding-top: 16px;\npadding-bottom: 16px;"])));
var Title$2 = CustomStyled(Box)(templateObject_7$d || (templateObject_7$d = __makeTemplateObject$1(["\nfont-size: 20px;\nfont-weight: bold"], ["\nfont-size: 20px;\nfont-weight: bold"])));
var ModalContainer = CustomStyled(Box)(templateObject_8$d || (templateObject_8$d = __makeTemplateObject$1(["\ntext-align: center;"], ["\ntext-align: center;"])));
var CloseButtonWrapper = CustomStyled(Flex)(templateObject_9$c || (templateObject_9$c = __makeTemplateObject$1(["\nfloat: right;"], ["\nfloat: right;"])));
var ModalContainet = CustomStyled(Box)(templateObject_10$c || (templateObject_10$c = __makeTemplateObject$1(["\npadding-top: 16px;\nmargin: auto;"], ["\npadding-top: 16px;\nmargin: auto;"])));
ModalContainet.defaultProps = {
    width: ['70%', '50%', '50%'],
};
var NotifyButton = CustomStyled(Button$1)(templateObject_11$9 || (templateObject_11$9 = __makeTemplateObject$1(["\n  height: 30px;\n  width: 48px;\n  padding: 0px;\n  border-color: ", ";\n  &:hover {\n    border-color: ", ";\n  }\n"], ["\n  height: 30px;\n  width: 48px;\n  padding: 0px;\n  border-color: ", ";\n  &:hover {\n    border-color: ", ";\n  }\n"])), function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.colors.blue; });
var ViewSimilarButton = CustomStyled(Button$1)(templateObject_12$8 || (templateObject_12$8 = __makeTemplateObject$1(["\n  flex: 1;\n  height: 30px;\n  padding: 0px;\n  margin-left: 8px;\n  font-size: 12px;\n"], ["\n  flex: 1;\n  height: 30px;\n  padding: 0px;\n  margin-left: 8px;\n  font-size: 12px;\n"])));
var CartButton = CustomStyled(Button$1)(templateObject_13$8 || (templateObject_13$8 = __makeTemplateObject$1(["\n  height: 36px;\n  width: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: ", "px;\n  background-color: ", ";\n  ", "\n  ", "\n\n  ", "\n  ", "\n"], ["\n  height: 36px;\n  width: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: ", "px;\n  background-color: ", ";\n  ",
    "\n  ",
    "\n\n  ",
    "\n  ",
    "\n"])), function (props) { return props.theme.radii[2]; }, function (props) { return props.theme.colors.blue; }, function (props) {
    return props.isMobile &&
        "\n    background-color: " + props.theme.colors.blue + " !important;\n  ";
}, function (props) {
    return props.disabled &&
        "\n    background-color: " + props.theme.colors.mercury + " !important;\n    opacity: 0.5;\n  ";
}, function (props) {
    return props.disabled &&
        props.cardVariant === 'regular' &&
        "\n     background-color: " + props.theme.colors.blue + " !important;\n     opacity: 0.5;\n  ";
}, function () {
    return variant({
        prop: 'cardVariant',
        variants: {
            regular: {
                height: '32px',
                width: '32px',
                borderRadius: '50%',
                backgroundColor: COLORS.ANCHOR_BLUE + " !important",
                '&:hover': {
                    backgroundColor: COLORS.ANCHOR_BLUE,
                },
            },
            regular_wide: {
                height: '32px',
                width: '32px',
                borderRadius: '50%',
            },
            list: {
                size: '23px',
                fontSize: '10px',
            },
            mini: {
                size: '23px',
                fontSize: '10px',
            },
            compact: {
                size: '23px',
            },
            pdp: {
                size: '37px',
                fontSize: '35px',
            },
            simple: {
                height: '24px',
                width: '24px',
            },
        },
    });
});
CartButton.defaultProps = {
    p: 0,
};
var MaxLimitContainer = CustomStyled(Box)(templateObject_14$8 || (templateObject_14$8 = __makeTemplateObject$1(["\n  background-color: #FEF2F2;\n  margin-bottom: 10px;\n  padding-left: 13px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: 12px;\n  color: #EE2527;\n  line-height: 14px;\n\n  ", "\n"], ["\n  background-color: #FEF2F2;\n  margin-bottom: 10px;\n  padding-left: 13px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: 12px;\n  color: #EE2527;\n  line-height: 14px;\n\n  ",
    "\n"])), variant({
    variants: {
        compact: {
            marginBottom: '3px',
            fontSize: '9px',
        },
        list: {
            display: 'inline-flex',
            padding: '5px',
            marginTop: '8px',
            marginBottom: 0,
        },
    },
}));
var MaxLimitContainerNew = CustomStyled(Box)(templateObject_15$8 || (templateObject_15$8 = __makeTemplateObject$1(["\n  background-color: ", ";\n  margin: 0 auto 10px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: ", "px;\n  color: ", ";\n  line-height: 14px;\n  width: 103px;\n  border-radius: 50px;\n  font-weight: ", ";\n\n  ", "\n"], ["\n  background-color: ", ";\n  margin: 0 auto 10px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: ", "px;\n  color: ", ";\n  line-height: 14px;\n  width: 103px;\n  border-radius: 50px;\n  font-weight: ", ";\n\n  ",
    "\n"])), function (props) { return props.theme.colors.peach; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.colors.darkRed; }, function (props) { return props.theme.fontWeights[6]; }, variant({
    variants: {
        compact: {
            marginBottom: '3px',
            fontSize: '9px',
        },
        list: {
            display: 'inline-flex',
            padding: '5px',
            marginTop: '8px',
            marginBottom: 0,
        },
    },
}));
var templateObject_1$C, templateObject_2$u, templateObject_3$p, templateObject_4$m, templateObject_5$h, templateObject_6$d, templateObject_7$d, templateObject_8$d, templateObject_9$c, templateObject_10$c, templateObject_11$9, templateObject_12$8, templateObject_13$8, templateObject_14$8, templateObject_15$8;
var CartElements = function (props) {
    var t = useTranslation().t;
    var _a = props.disabled, disabled = _a === void 0 ? false : _a, max = props.max, min = props.min, inCart = props.inCart, incrementBy = props.incrementBy, isOpen = props.isOpen, isLoading = props.isLoading, onAddHandler = props.onAddHandler, onDecrementHandler = props.onDecrementHandler, onIncrementHandler = props.onIncrementHandler, onRemoveHandler = props.onRemoveHandler, onSelectHandler = props.onSelectHandler, productCardVariant = props.productCardVariant, _b = props.quantity, quantity = _b === void 0 ? 1 : _b, selectOnChange = props.selectOnChange, _c = props.soldByWeight, soldByWeight = _c === void 0 ? false : _c, _d = props.variant, variant = _d === void 0 ? EProductCardVariants.PLP : _d, onlineName = props.onlineName, productImage = props.productImage, _e = props.isSticky, isSticky = _e === void 0 ? false : _e, _f = props.isBuyNow, isBuyNow = _f === void 0 ? false : _f, price = props.price, currency = props.currency, showAgeDisclaimer = props.showAgeDisclaimer, productId = props.productId, isNewCarrefourJourney = props.isNewCarrefourJourney, dir = props.dir;
    var isMobile = useBreakpoints().isMobile;
    var _g = __read$1(useAppConfig(), 1), _h = _g[0], currencyDecimal = _h.currencyDecimal, pageName = _h.pageName;
    var quantityList = useMemo(function () {
        var currencyDecimalValue = variant === EProductCardVariants.PDP ? currencyDecimal : undefined;
        return generateQuantityList({
            incrementBy: incrementBy,
            soldByWeight: soldByWeight,
            max: max,
            min: min,
            price: price,
            currencyDecimal: currencyDecimalValue,
        });
    }, [incrementBy, max, min, soldByWeight, price, currencyDecimal, variant]);
    var _j = __read$1(useState(variant === EProductCardVariants.PDP), 2), showQuantitySelector = _j[0], setQuantitySelector = _j[1];
    var _k = useMemo(function () {
        return getDecreaseButtonProps({
            quantity: quantity,
            min: min,
            onDecrementHandler: onDecrementHandler,
            onRemoveHandler: onRemoveHandler,
            soldByWeight: soldByWeight,
            variant: variant,
            setQuantitySelector: setQuantitySelector,
            isNewCarrefourJourney: isNewCarrefourJourney,
        });
    }, [quantity, min, onDecrementHandler, onRemoveHandler, soldByWeight, variant, isNewCarrefourJourney]), children = _k.children, restDecreaseProps = __rest$1(_k, ["children"]);
    var productsData = useSelector(function (state) { return state.productList; });
    var isExpandQtySelector = productsData.expandedQtySelectorProductId == productId ? true : false;
    var _l = __read$1(useState(false), 2), popUp = _l[0], setPopUp = _l[1];
    var _m = __read$1(useState(isExpandQtySelector), 2), expandQtySelector = _m[0], setExpandQtySelector = _m[1];
    useEffect(function () {
        setExpandQtySelector(isExpandQtySelector);
    }, [isExpandQtySelector]);
    var onAddDisclaimerEnabled = function () {
        if (!showQuantitySelector) {
            setQuantitySelector(true);
        }
        if (showAgeDisclaimer) {
            setPopUp(true);
        }
        else {
            onAddHandler && onAddHandler();
            setExpandQtySelector(true);
        }
    };
    var onSelectDisclaimerHandler = function (option) {
        if (showAgeDisclaimer) {
            setPopUp(true);
        }
        else {
            selectOnChange && selectOnChange(option);
        }
    };
    var hideDisclaimerPopup = function () {
        setPopUp(false);
    };
    var addToCartHandler = function () {
        onAddHandler && onAddHandler();
        if (popUp) {
            setPopUp(false);
        }
    };
    var Display = variant === EProductCardVariants.PDP || !inCart ? Flex : Box;
    var isReachedQtyMaxLimit = hasReachedQtyMaxLimit(quantity, max);
    return (React.createElement(Display, { sx: { position: "" + (variant === EProductCardVariants.PDP ? 'relative' : 'auto') }, justifyContent: "space-between", alignItems: "center", h: "32px", w: 1, "data-testid": "product_qnty_dropdown" },
        isReachedQtyMaxLimit &&
            variant !== EProductCardVariants.PDP &&
            variant !== EProductCardVariants.LIST &&
            (isNewCarrefourJourney ? (React.createElement(MaxLimitContainerNew, { expandQtySelector: expandQtySelector, variant: variant },
                React.createElement("div", null, t('productCard.maxLimitC4Journey')))) : (React.createElement(MaxLimitContainer, { variant: variant },
                React.createElement("div", null, t('productCard.maxLimit'))))),
        React.createElement(React.Fragment, null,
            !inCart && (React.createElement(React.Fragment, null,
                React.createElement(QuantitySelectorWrapper$1, { flexGrow: 1, variant: variant, isSticky: isSticky, isBuyNow: isBuyNow }, (variant === EProductCardVariants.PDP || showQuantitySelector) && !isLoading && (React.createElement(QuantitySelector, { isLoading: isLoading || disabled, inCart: inCart, isOpen: isOpen, onSelectHandler: onSelectHandler, options: quantityList, productCardVariant: productCardVariant, selectOnChange: onSelectDisclaimerHandler, soldByWeight: soldByWeight, variant: variant, onlineName: onlineName, productImage: productImage, isSticky: isSticky, isBuyNow: isBuyNow, currency: currency, expandQtySelector: expandQtySelector }))),
                React.createElement(CartButtonWrapper, { variant: variant, isBuyNow: isBuyNow }, variant === EProductCardVariants.PDP ? (React.createElement(Button$1, { height: "100%", minWidth: 63.61, fontSize: 2, paddingY: 1, paddingX: 3, className: pageName + "_add_to_cart", onClick: onAddDisclaimerEnabled, "data-testid": "add_to_cart_button", disabled: isLoading || disabled }, variant === EProductCardVariants.PDP && (isSticky || !isMobile) ? t('addToCart') : t('add'))) : (React.createElement(CartButton, { onClick: onAddDisclaimerEnabled, "data-testid": "add_to_cart_button", disabled: isLoading || disabled, className: pageName + "_add_to_cart", cardVariant: variant === EProductCardVariants.REGULAR_WIDE ? EProductCardVariants.REGULAR : variant, isMobile: isMobile },
                    React.createElement(Plus, { stroke: COLORS.WHITE })))),
                popUp && (React.createElement(Modal, { isOpen: true, width: [1, null, '500px'], height: ['auto'], variant: isMobile ? 'bottomStickyMobile' : 'bottomSticky' },
                    React.createElement(ModalContainer, null,
                        React.createElement(CloseButtonWrapper, null,
                            React.createElement(Button$1, { variant: "naked", "aria-label": "Close", onClick: hideDisclaimerPopup },
                                React.createElement(Cross, { size: "M" }))),
                        React.createElement(ModalContainet, null,
                            React.createElement(Title$2, null, t('disclaimer.disclaimerTitle')),
                            React.createElement(MessageText, null, t('disclaimer.disclaimerMessage')),
                            React.createElement(DisclaimerButtonWrapper, null,
                                React.createElement(Button$1, { variant: "secondary", fontWeight: "bold", onClick: addToCartHandler }, t('disclaimer.aboveAgeText')),
                                React.createElement(CancelText, { onClick: hideDisclaimerPopup }, t('disclaimer.belowAgeText'))))))))),
            inCart &&
                (!isNewCarrefourJourney || expandQtySelector || variant === EProductCardVariants.REGULAR_WIDE ? (React.createElement(CartActionsWrapper, { variant: variant, isMin: quantity === min },
                    React.createElement(CartButton, __assign$1({}, restDecreaseProps, { "data-testid": "btn-decrement", disabled: (disabled && !isLoading) || isLoading, className: quantity === min ? pageName + "_remove_from_cart" : '', round: variant === EProductCardVariants.PDP ? true : false, cardVariant: variant, isMobile: isMobile }), children),
                    React.createElement(QuantitySelectorWrapper$1, { variant: variant, inCart: inCart },
                        React.createElement(QuantitySelector, { inCart: inCart, isLoading: isLoading || disabled, isOpen: isOpen, onSelectHandler: onSelectHandler, options: quantityList, productCardVariant: productCardVariant, selectOnChange: selectOnChange, selectedValue: quantity, soldByWeight: soldByWeight, variant: variant, onlineName: onlineName, productImage: productImage, isSticky: isSticky, currency: currency, isNewCarrefourJourney: isNewCarrefourJourney, expandQtySelector: variant === EProductCardVariants.REGULAR_WIDE ? true : expandQtySelector })),
                    React.createElement(CartButton, { onClick: onIncrementHandler, disabled: isReachedQtyMaxLimit || isQtyOnlyOne(min, max) || disabled || isLoading, "data-testid": "btn-increment", cardVariant: variant, className: pageName + "_add_to_cart", variant: "primary", isMobile: isMobile }, variant === EProductCardVariants.PDP || variant === EProductCardVariants.SIMPLE ? ('+') : (React.createElement(Plus, { stroke: variant === EProductCardVariants.REGULAR_WIDE ? COLORS.ANCHOR_BLUE : COLORS.WHITE }))))) : (React.createElement(QuantitySelector, { inCart: inCart, isLoading: isLoading || disabled, isOpen: isOpen, onSelectHandler: onSelectHandler, options: quantityList, productCardVariant: productCardVariant, selectOnChange: selectOnChange, selectedValue: quantity, soldByWeight: soldByWeight, variant: variant, onlineName: onlineName, productImage: productImage, isSticky: isSticky, currency: currency, isNewCarrefourJourney: isNewCarrefourJourney, expandQtySelector: variant === EProductCardVariants.REGULAR_WIDE ? true : expandQtySelector, dir: dir, productId: productId }))))));
};
var OutOfStockOptions = function (_a) {
    var onNotificationHandler = _a.onNotificationHandler, onViewSimilarHandler = _a.onViewSimilarHandler;
    var t = useTranslation().t;
    return (React.createElement(CartActionsWrapper, null,
        React.createElement(NotifyButton, { variant: "outlined", onClick: onNotificationHandler },
            React.createElement(Bell, { fill: COLORS.RED })),
        React.createElement(ViewSimilarButton, { onClick: onViewSimilarHandler }, t('viewSimilar'))));
};
var useProductCardHandlers = function (props, isV4Basket) {
    var _a, _b, _c, _d, _e;
    if (isV4Basket === void 0) { isV4Basket = false; }
    var dispatch = useDispatch();
    var incrementBy = props.incrementBy, max = props.max, min = props.min, productId = props.productId, position = props.position, _f = props.quantity, quantity = _f === void 0 ? 0 : _f, unitOfMeasure = props.unitOfMeasure, _g = props.withRelevantProducts, withRelevantProducts = _g === void 0 ? false : _g, _h = props.isMarketPlace, isMarketPlace = _h === void 0 ? false : _h, _j = props.offers, offers = _j === void 0 ? [] : _j, _k = props.serviceProductCode, serviceProductCode = _k === void 0 ? '' : _k, onSuccessCb = props.onSuccessCb, onFailureCb = props.onFailureCb, intent = props.intent, _l = props.rowIndex, rowIndex = _l === void 0 ? 0 : _l, _m = props.isSponsored, isSponsored = _m === void 0 ? false : _m, soldByWeight = props.soldByWeight, _o = props.minBuyingValue, minBuyValue = _o === void 0 ? '' : _o, _p = props.priceDetails, priceDetails = _p === void 0 ? {} : _p, _q = props.originalPrice, originalPrice = _q === void 0 ? 0 : _q, _r = props.discount, productDiscount = _r === void 0 ? {} : _r, currency = props.currency, isSponsoredListing = props.isSponsoredListing, _s = props.isCart, isCart = _s === void 0 ? false : _s, sid = props.sid;
    var appConfig = useSelector(function (state) { return ({
        appConfig: state.appConfig,
        pageStructure: state.pageStructure,
    }); }).appConfig;
    var pisValue = (_b = (_a = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _a === void 0 ? void 0 : _a.purchaseIndicators) === null || _b === void 0 ? void 0 : _b.SHIPPING;
    var shippingIndicator = sid || ((_c = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _c === void 0 ? void 0 : _c.shippingIndicator) || '';
    var basketV4Attributes = {
        pis: pisValue || [],
        shopId: (_d = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _d === void 0 ? void 0 : _d.shopId,
        shopName: (_e = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _e === void 0 ? void 0 : _e.shop,
        isSoldByWeight: soldByWeight,
        isV4Basket: isV4Basket,
    };
    var _t = useBreakpoints(), isDesktop = _t.isDesktop, isMobile = _t.isMobile;
    var _u = __read$1(useMemo(function () {
        var incValue = quantity + incrementBy;
        var decValue = quantity - incrementBy;
        if (incValue > max) {
            incValue = max;
        }
        if (quantity && quantity >= max) {
            var quantityOptionList = generateQuantityList({
                incrementBy: incrementBy,
                soldByWeight: unitOfMeasure === KG_LABEL,
                max: max,
                min: min,
            });
            if (quantityOptionList.length > 1) {
                decValue = quantityOptionList[quantityOptionList.length - 2].value;
            }
        }
        var inc = parseFloat(setDecimalPoint(incValue));
        var dec = parseFloat(setDecimalPoint(decValue));
        return [inc, dec];
    }, [incrementBy, quantity, max, min, unitOfMeasure]), 2), increment = _u[0], decrement = _u[1];
    var sortBy = useSelector(function (state) {
        var _a, _b;
        return {
            sortBy: (_b = (_a = state === null || state === void 0 ? void 0 : state.search) === null || _a === void 0 ? void 0 : _a.query) === null || _b === void 0 ? void 0 : _b.sortBy,
        };
    }).sortBy;
    var _v = useAnalytic(), GTMEventCall = _v.GTMEventCall, EventCall = _v.EventCall, BrazeEventCall = _v.BrazeEventCall, BrazeSetCustomUserAttribute = _v.BrazeSetCustomUserAttribute;
    var gtmCallBack = useCallback(function (selectedQuantity, eventType) {
        var deltaQtyInUnit = convertDeltaQtyInoUnit(selectedQuantity, quantity, incrementBy);
        var gtmCommonData = getCommonGtmData({
            selectedQuantity: selectedQuantity,
            quantity: quantity,
            incrementBy: incrementBy,
            min: min,
            minBuyValue: minBuyValue,
            priceDetails: priceDetails,
            originalPrice: originalPrice,
            soldByWeight: soldByWeight,
            productDiscount: productDiscount,
        });
        switch (eventType) {
            case eventTypeEnum.add_to_cart:
                GTMEventCall(GTMEvents.add_to_cart, __assign$1(__assign$1({ product: props, position: position }, gtmCommonData), { ga4: false }));
                GTMEventCall(GTMEvents.add_to_cart, __assign$1(__assign$1({ product: props, position: position }, gtmCommonData), { ga4: true, currency: currency, countryCode: appConfig === null || appConfig === void 0 ? void 0 : appConfig.code }));
                EventCall(GTMEvents.add_to_cart, __assign$1(__assign$1({}, props), { quantity: selectedQuantity }));
                if (isSponsored)
                    EventCall(GTMEvents.change_the_quantity, __assign$1(__assign$1({}, props), { quantity: deltaQtyInUnit }));
                break;
            case eventTypeEnum.change_the_quantity:
                if (deltaQtyInUnit > 0) {
                    GTMEventCall(GTMEvents.add_to_cart, __assign$1(__assign$1({ product: props, position: position }, gtmCommonData), { ga4: true, currency: currency, countryCode: appConfig === null || appConfig === void 0 ? void 0 : appConfig.code }));
                }
                else {
                    GTMEventCall(GTMEvents.remove_from_cart, __assign$1(__assign$1({ product: props, position: position }, gtmCommonData), { ga4: true, currency: currency, countryCode: appConfig === null || appConfig === void 0 ? void 0 : appConfig.code }));
                }
                EventCall(GTMEvents.change_the_quantity, __assign$1(__assign$1({}, props), { quantity: deltaQtyInUnit }));
                break;
            case eventTypeEnum.remove_from_cart:
                GTMEventCall(GTMEvents.remove_from_cart, { product: props, position: position, ga4: false });
                GTMEventCall(GTMEvents.remove_from_cart, __assign$1(__assign$1({ product: props, position: position }, gtmCommonData), { ga4: true, currency: currency, countryCode: appConfig === null || appConfig === void 0 ? void 0 : appConfig.code }));
                EventCall(GTMEvents.change_the_quantity, __assign$1(__assign$1({}, props), { quantity: convertDeltaQtyInoUnit(selectedQuantity, quantity, incrementBy) }));
                break;
        }
    }, [
        GTMEventCall,
        currency,
        EventCall,
        position,
        props,
        appConfig,
        incrementBy,
        quantity,
        isSponsored,
        min,
        minBuyValue,
        priceDetails,
        soldByWeight,
        originalPrice,
        productDiscount,
    ]);
    var brazeCB = useCallback(function (totalUnitCount) {
        var _a;
        if (totalUnitCount === 0)
            BrazeSetCustomUserAttribute((_a = {}, _a[BrazeEvents.cart_count] = false, _a));
    }, [BrazeSetCustomUserAttribute]);
    var brazeAddToCartCB = useCallback(function (totalUnitCount) {
        var _a;
        var _b;
        if (!((_b = appConfig === null || appConfig === void 0 ? void 0 : appConfig.userCredentials) === null || _b === void 0 ? void 0 : _b.userId) && !(appConfig === null || appConfig === void 0 ? void 0 : appConfig.brazeInitialized)) {
            var storage = initStorageManager(function () { return localStorage; });
            var data = storage.getItem('initBrazeAnonymousUserWithData') || [];
            data.push(props);
            storage.setItem('initBrazeAnonymousUserWithData', data);
        }
        else {
            BrazeEventCall(BrazeEvents.add_to_cart, props);
            if (totalUnitCount === 1)
                BrazeSetCustomUserAttribute((_a = {}, _a[BrazeEvents.cart_count] = true, _a));
        }
    }, [BrazeEventCall, BrazeSetCustomUserAttribute, props, appConfig]);
    var offerId = useMemo(function () {
        return isMarketPlace && offers.length > 0 ? offers[0].id : undefined;
    }, [isMarketPlace, offers]);
    var onAddHandler = useCallback(function () {
        var _a;
        var convertedMin = parseFloat(formatQuantityKG(min, unitOfMeasure === KG_LABEL));
        var productId = props.productId, _b = props.position, position = _b === void 0 ? 0 : _b;
        var productPosition = getProductPosition(rowIndex, position, isDesktop, isMobile);
        var hasCart = window.location.href.indexOf('/cart') !== -1;
        var _c = getGa4AlgoliaEventsParams(), experimentKey = _c.experimentKey, variationId = _c.variationId;
        var _d = appConfig.language, language = _d === void 0 ? '' : _d, _e = appConfig.currency, currency = _e === void 0 ? '' : _e;
        if (variationId && experimentKey) {
            GTMEventCall(GTMEvents.algolia_custom_events, {
                experiment_key: experimentKey,
                variation_id: variationId,
                pageData: { language: language, currency: currency },
            });
        }
        dispatch(addToCart(productId, convertedMin, __assign$1({ isMarketPlace: isMarketPlace,
            withRelevantProducts: withRelevantProducts,
            gtmCallBack: gtmCallBack,
            onSuccessCb: onSuccessCb,
            onFailureCb: onFailureCb,
            offerId: offerId,
            serviceProductCode: serviceProductCode, productName: props.name, brazeAddToCartCB: brazeAddToCartCB, isCartRequired: hasCart ? true : false, productImageURL: (_a = props === null || props === void 0 ? void 0 : props.image) === null || _a === void 0 ? void 0 : _a.href, intent: intent,
            incrementBy: incrementBy,
            isSponsored: isSponsored, applicablePrice: props.applicablePrice, shippingIndicator: shippingIndicator }, basketV4Attributes), function () {
            return;
        }, productPosition, sortBy));
    }, [
        min,
        unitOfMeasure,
        props,
        rowIndex,
        isDesktop,
        isMobile,
        appConfig,
        dispatch,
        isMarketPlace,
        withRelevantProducts,
        gtmCallBack,
        onSuccessCb,
        onFailureCb,
        offerId,
        serviceProductCode,
        brazeAddToCartCB,
        intent,
        incrementBy,
        isSponsored,
        shippingIndicator,
        basketV4Attributes,
        sortBy,
        GTMEventCall,
    ]);
    var isAdtechCartCarousel = isSponsoredListing && isCart;
    var onDecrementHandler = useCallback(function () {
        var _a;
        if (quantity > min) {
            dispatch(updateCart(productId, decrement, __assign$1({ isCartRequired: isAdtechCartCarousel, onSuccessCb: onSuccessCb,
                intent: intent,
                offerId: offerId,
                gtmCallBack: gtmCallBack,
                incrementBy: incrementBy, currentQuantity: quantity, productName: props.name, productImageURL: (_a = props === null || props === void 0 ? void 0 : props.image) === null || _a === void 0 ? void 0 : _a.href, shippingIndicator: shippingIndicator }, basketV4Attributes)));
            GTMEventCall(GTMEvents.add_to_cart, { quantity: decrement });
        }
    }, [
        quantity,
        min,
        dispatch,
        productId,
        decrement,
        isAdtechCartCarousel,
        onSuccessCb,
        intent,
        offerId,
        gtmCallBack,
        incrementBy,
        props,
        shippingIndicator,
        basketV4Attributes,
        GTMEventCall,
    ]);
    var onIncrementHandler = useCallback(function () {
        var _a;
        if (quantity < max) {
            dispatch(updateCart(productId, increment, __assign$1({ isCartRequired: isAdtechCartCarousel, intent: intent,
                offerId: offerId,
                gtmCallBack: gtmCallBack,
                incrementBy: incrementBy, currentQuantity: quantity, shippingIndicator: shippingIndicator, productName: props.name, productImageURL: (_a = props === null || props === void 0 ? void 0 : props.image) === null || _a === void 0 ? void 0 : _a.href, onSuccessCb: onSuccessCb }, basketV4Attributes)));
        }
    }, [
        quantity,
        max,
        dispatch,
        productId,
        increment,
        isAdtechCartCarousel,
        intent,
        offerId,
        gtmCallBack,
        incrementBy,
        shippingIndicator,
        props,
        onSuccessCb,
        basketV4Attributes,
    ]);
    var onRemoveHandler = useCallback(function () {
        dispatch(removeFromCart(productId, {
            brazeCB: brazeCB,
            gtmCallBack: gtmCallBack,
            offerId: offerId,
            intent: intent,
            incrementBy: incrementBy,
            currentQuantity: quantity,
            shippingIndicator: shippingIndicator,
            isCartRequired: isAdtechCartCarousel,
            onSuccessCb: onSuccessCb,
        }));
    }, [
        dispatch,
        productId,
        brazeCB,
        gtmCallBack,
        offerId,
        intent,
        incrementBy,
        quantity,
        shippingIndicator,
        isAdtechCartCarousel,
        onSuccessCb,
    ]);
    return [onAddHandler, onDecrementHandler, onIncrementHandler, onRemoveHandler];
};
var ECartNotificationType;
(function (ECartNotificationType) {
    ECartNotificationType["ERROR"] = "ERROR";
    ECartNotificationType["OUT_OF_STOCK"] = "OUT_OF_STOCK";
    ECartNotificationType["SUCCESS"] = "SUCCESS";
    ECartNotificationType["NULL"] = "";
})(ECartNotificationType || (ECartNotificationType = {}));
var ECartAPINotification;
(function (ECartAPINotification) {
    ECartAPINotification["OUT_OF_STOCK"] = "noStock";
})(ECartAPINotification || (ECartAPINotification = {}));
var CartNotificationWrapper = CustomStyled(Flex)(templateObject_1$D || (templateObject_1$D = __makeTemplateObject$1(["\n    align-items: center;\n    background-color: ", ";\n    bottom: 0;\n    color: ", ";\n    flex-direction: column;\n    font-size: ", "px;\n    justify-content: center;\n    line-height: normal;\n    min-height: 45px;\n    opacity: ", ";\n    padding: ", "px;\n    position: absolute;\n    text-align: center;\n    text-transform: ", ";\n    width: 100%;\n    z-index: 2;\n"], ["\n    align-items: center;\n    background-color: ",
    ";\n    bottom: 0;\n    color: ", ";\n    flex-direction: column;\n    font-size: ", "px;\n    justify-content: center;\n    line-height: normal;\n    min-height: 45px;\n    opacity: ", ";\n    padding: ", "px;\n    position: absolute;\n    text-align: center;\n    text-transform: ", ";\n    width: 100%;\n    z-index: 2;\n"])), function (props) {
    switch (props.type) {
        case ECartNotificationType.SUCCESS:
            return props.theme.colors.persiangreen;
        case ECartNotificationType.ERROR:
            return props.theme.colors.red;
        default:
            return props.theme.colors.doveGrey;
    }
}, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.type === ECartNotificationType.ERROR && 0.7; }, function (props) { return props.theme.space[2]; }, function (props) { return (props.type === ECartNotificationType.OUT_OF_STOCK ? 'uppercase' : 'unset'); });
var CartNotificationQtyWrapper = CustomStyled(Flex)(templateObject_2$v || (templateObject_2$v = __makeTemplateObject$1(["\n    font-size: ", "px;\n    font-weight: ", ";\n"], ["\n    font-size: ", "px;\n    font-weight: ", ";\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.fontWeights[6]; });
var templateObject_1$D, templateObject_2$v;
var CartNotification = function (_a) {
    var currency = _a.currency, currencyPosition = _a.currencyPosition, discount = _a.discount, originalPrice = _a.originalPrice, notification = _a.notification, _b = _a.quantity, quantity = _b === void 0 ? 1 : _b, unitOfMeasure = _a.unitOfMeasure, errDetail = _a.errDetail;
    var t = useTranslation().t;
    var soldByWeight = unitOfMeasure === KG_LABEL;
    var price = useMemo(function () {
        if (notification === ECartNotificationType.SUCCESS) {
            var dc = discount ? discount.price : 0;
            var op = originalPrice;
            var curr = currency;
            var currPos = currencyPosition;
            return dc > 0 ? formatPrice(dc * quantity, curr, currPos) : formatPrice(op * quantity, curr, currPos);
        }
        else {
            return 0;
        }
    }, [notification, discount, originalPrice, currency, currencyPosition, quantity]);
    var renderErrMsg = useCallback(function () {
        switch (errDetail) {
            case ECartAPINotification.OUT_OF_STOCK:
                return t('productCard.outOfStock');
            default:
                return t('somethingWentWrong');
        }
    }, [errDetail, t]);
    return (React.createElement(CartNotificationWrapper, { "data-testid": "cart-notification", type: notification },
        notification === ECartNotificationType.ERROR && React.createElement(Flex, null, renderErrMsg()),
        notification === ECartNotificationType.OUT_OF_STOCK && React.createElement(Flex, null, t('outOfStockLabel')),
        notification === ECartNotificationType.SUCCESS && (React.createElement(React.Fragment, null,
            React.createElement(CartNotificationQtyWrapper, { "data-testid": "quantity" }, soldByWeight ? addKGLabel(formatQuantityKG(quantity, soldByWeight)) : quantity),
            React.createElement(Flex, { "data-testid": "price" },
                "(",
                price,
                ") ",
                t('productCard.inCart'))))));
};
var Dots = function (_a) {
    var size = _a.size, selectedIndex = _a.selectedIndex;
    return (React.createElement(Flex, { "data-testid": "image_carousel_dots", alignItems: "center", flexDirection: "row", margin: "auto", height: "5%" }, Array.from({ length: size }).map(function (__value, index) { return (React.createElement(Dot, { selected: selectedIndex === index, key: index })); })));
};
var ImageCarousel = function (_a) {
    var imageLibrary = _a.imageLibrary, newProductCardImageLibrary = _a.newProductCardImageLibrary, title = _a.title, variant = _a.variant, _b = _a.isSponsoredListing, isSponsoredListing = _b === void 0 ? false : _b, _c = _a.carousel, carousel = _c === void 0 ? false : _c, productCardImageResizeString = _a.productCardImageResizeString;
    var _d = __read$1(useState(0), 2), index = _d[0], setIndex = _d[1];
    var images = useMemo(function () {
        return newProductCardImageLibrary.map(function (href, i) {
            return (React.createElement(ImageSlide, { key: href + "-" + i, widthPerSlide: variant === 'regular2' ? '56px' : '100%', gaps: "10" },
                React.createElement(CarousalImage, { isSponsoredListing: isSponsoredListing, carousel: carousel, variant: variant, url: updateImageResizeInUrl(href, productCardImageResizeString), name: title, testId: "product_image_carousel_" + i })));
        });
    }, [newProductCardImageLibrary, title, variant, isSponsoredListing, carousel, productCardImageResizeString]);
    var onSlideChange = useCallback(function (index) {
        setIndex(index);
    }, [setIndex]);
    var isNavEnabled = variant !== 'mini';
    if (newProductCardImageLibrary.length > 1) {
        return (React.createElement(Flex, { flexDirection: "column", "data-testid": "image_carousel_wrapper" },
            React.createElement(Flex, { height: "98%" },
                React.createElement(Carousel, { onSlideEnd: onSlideChange, autoPlay: 1400 }, images)),
            isNavEnabled && React.createElement(Dots, { size: imageLibrary.length, selectedIndex: index })));
    }
    else {
        return null;
    }
};
var NowJourneyIcon = function (_a) {
    var _b, _c;
    var nowIconProps = _a.nowIconProps, iconProps = _a.iconProps, variant = _a.variant;
    var isNewJourney = ((_c = (_b = useFeature('new_carrefour_journey')) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.new_journey) || false;
    if (isNewJourney) {
        return React.createElement(NowExpressIconEn, __assign$1({}, nowIconProps));
    }
    else if (variant === 'old')
        return React.createElement(ExpressNow, __assign$1({}, iconProps));
    else
        return React.createElement(ExpressNowNew, __assign$1({}, iconProps));
};
var ProductImage = function (props) {
    var variant = props.variant, url = props.url, onProductClickHandler = props.onProductClickHandler, isAvailable = props.isAvailable, name = props.name, isExpressProduct = props.isExpressProduct, _a = props.isHover, isHover = _a === void 0 ? false : _a, _b = props.imageLibrary, imageLibrary = _b === void 0 ? [] : _b, _c = props.newProductCardImageLibrary, newProductCardImageLibrary = _c === void 0 ? [] : _c, _d = props.newProductCardImage, newProductCardImage = _d === void 0 ? '' : _d, inCart = props.inCart, error = props.error, errDetail = props.errDetail, onRightClickHandler = props.onRightClickHandler, promoBadgesAreaB = props.promoBadgesAreaB, isSponsoredListing = props.isSponsoredListing, showNewPromoBadges = props.showNewPromoBadges, showFoodNutrition = props.showFoodNutrition, dietary = props.dietary, isNewPromoBadges = props.isNewPromoBadges, promoBadgesAreaBEle = props.promoBadgesAreaBEle, renderProductCardActions = props.renderProductCardActions, isSponsored = props.isSponsored, promoBadgesAreaAEle = props.promoBadgesAreaAEle, renderHeaderSticker = props.renderHeaderSticker, isNewCarrefourJourney = props.isNewCarrefourJourney, carousel = props.carousel, expressHeight = props.expressHeight, expressWidth = props.expressWidth, dir = props.dir, discountBadgePercentageThreshold = props.discountBadgePercentageThreshold;
    var productCardImageResizeString = '400';
    var t = useTranslation().t;
    var hasImages = newProductCardImageLibrary.length > 1;
    var title = useMemo(function () { return decodeHtml(name); }, [name]);
    var hasNotification = useMemo(function () {
        if (error) {
            return ECartNotificationType.ERROR;
        }
        return ECartNotificationType.NULL;
    }, [error]);
    var showCarousel = useMemo(function () { return isHover && hasImages && !inCart; }, [isHover, hasImages, inCart]);
    var text = ((promoBadgesAreaB === null || promoBadgesAreaB === void 0 ? void 0 : promoBadgesAreaB[0]) || {}).text;
    var _e = text || {}, normalText = _e.normalText, boldText = _e.boldText;
    var dietaryPreferences = (dietary === null || dietary === void 0 ? void 0 : dietary.dietaryPreferences) || [];
    return (React.createElement(React.Fragment, null,
        React.createElement(ProductCardImageContainer$1, { variant: variant, "data-testid": "product_card_image_container" },
            React.createElement(HeaderStickerContainer, { isSponsored: isSponsored && !isSponsoredListing },
                isSponsored && !isSponsoredListing && (React.createElement(SponseredProduct, { "data-testid": "sponsored_label", variant: variant, isAreaABadge: promoBadgesAreaAEle ? true : false }, "Ad")),
                !isSponsoredListing && (React.createElement(ProductCardHeaderWrapper, { "data-testid": "product_discount_badge", variant: variant, isSponsored: isSponsored }, showNewPromoBadges || isNewPromoBadges ? promoBadgesAreaAEle : renderHeaderSticker)),
                !promoBadgesAreaAEle && !isSponsoredListing && discountBadgePercentageThreshold && (React.createElement(ProductCardHeaderWrapper, { "data-testid": "product_discount_badge", variant: variant, isSponsored: isSponsored },
                    React.createElement(ProductCardNewHeaderSticker, { type: "discountThresholdBadge" }, discountBadgePercentageThreshold + '% ' + t('frequentlyBoughtTogether.off'))))),
            React.createElement(ProductcardImageContainerInner, { "data-testid": "product_card_image", variant: variant, isSponsoredListing: isSponsoredListing, carousel: carousel },
                React.createElement("a", { href: url, title: title, onClick: onProductClickHandler(url), onContextMenu: onRightClickHandler },
                    isAvailable && showCarousel && (React.createElement(ImageCarousel, { title: title, imageLibrary: imageLibrary, newProductCardImageLibrary: newProductCardImageLibrary, variant: variant, isSponsoredListing: isSponsoredListing, carousel: carousel, productCardImageResizeString: productCardImageResizeString })),
                    React.createElement(ProductCardImage, { display: isAvailable && showCarousel ? 'none' : 'block', key: "main-image", url: updateImageResizeInUrl(newProductCardImage, productCardImageResizeString), name: title, "data-testid": "product_image_main", variant: variant, carousel: carousel, isSponsoredListing: isSponsoredListing })),
                variant !== EProductCardVariants.REGULAR_WIDE && renderProductCardActions,
                React.createElement(PromoBadgesAreaBBox, { dir: dir, variant: variant },
                    isAvailable && isExpressProduct ? (React.createElement(NowJourneyIcon, { variant: "old", iconProps: { size: 'CUSTOM', height: expressHeight, width: expressWidth } })) : (isAvailable &&
                        (showNewPromoBadges || isNewPromoBadges
                            ? promoBadgesAreaBEle
                            : (promoBadgesAreaB === null || promoBadgesAreaB === void 0 ? void 0 : promoBadgesAreaB.length) > 0 &&
                                !isExpressProduct && (React.createElement(PromoBadgesAreaBContainer, { dir: "ltr" },
                                React.createElement(PromoBadgesAreaBText, null, boldText),
                                React.createElement(PromoBadgesAreaBTextLight, null, ' ' + normalText))))),
                    variant === EProductCardVariants.REGULAR_WIDE && !isAvailable && (React.createElement(OutOfStockText, null, t('outOfStockLabel')))),
                !isNewCarrefourJourney && (React.createElement("a", { dir: "ltr", href: url, title: title, onClick: onProductClickHandler(url), onContextMenu: onRightClickHandler }, variant === EProductCardVariants.COMPACT && (React.createElement(ProductCardExpressWrapper$1, { variant: variant, "data-testid": "product_now_badge" },
                    React.createElement(ProductCardAttributeIcon, { "data-testid": "product_now_foodicon" }, showFoodNutrition &&
                        dietaryPreferences
                            .slice(0, 1)
                            .map(function (_a) {
                            var attributeCode = _a.attributeCode;
                            return (React.createElement("img", { key: attributeCode, src: "https://cdnst.mafretailproxy.com/assets/images/dietconf/" + attributeCode + ".png", className: "attributeIcon1" }));
                        }))))))),
            hasNotification && React.createElement(CartNotification, __assign$1({ notification: hasNotification, errDetail: errDetail }, props))),
        variant !== EProductCardVariants.REGULAR_WIDE && (React.createElement(ProductCardExpressWrapper$1, { variant: variant, "data-testid": "product_now_badge" },
            !isNewCarrefourJourney && variant !== EProductCardVariants.COMPACT && (React.createElement(ProductCardAttributeIcon, { "data-testid": "product_now_foodicon" }, showFoodNutrition &&
                variant != 'list' &&
                dietaryPreferences
                    .slice(0, 2)
                    .map(function (_a) {
                    var attributeCode = _a.attributeCode;
                    return (React.createElement("img", { key: attributeCode, src: "https://cdnst.mafretailproxy.com/assets/images/dietconf/" + attributeCode + ".png", className: "attributeIcon2" }));
                }))),
            !isAvailable && React.createElement(OutOfStockText, null, t('outOfStockLabel'))))));
};
var fullfilledByCarreFourProductInfo = function (_a) {
    var _b;
    var _c = _a.isFBC, isFBC = _c === void 0 ? false : _c, _d = _a.supplier, supplier = _d === void 0 ? '' : _d, _e = _a.delivery, delivery = _e === void 0 ? [] : _e, t = _a.t;
    var isCarrefourDelivery = false;
    var deliveryPartner = delivery && delivery.length > 0 ? supplier : '';
    if (delivery && ((_b = delivery[0]) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes('carrefour'))) {
        isCarrefourDelivery = true;
        deliveryPartner = 'Carrefour';
    }
    if (isFBC) {
        return t('productCard.fbc.fc');
    }
    if (supplier && deliveryPartner != '' && supplier.toLowerCase() != deliveryPartner.toLowerCase()) {
        return t('productCard.fbc.ss_dp', { supplier: supplier, deliveryPartner: deliveryPartner });
    }
    if (supplier && deliveryPartner != '' && !isCarrefourDelivery) {
        return t('productCard.fbc.s_ds', { supplier: supplier });
    }
    if (supplier && deliveryPartner != '' && isCarrefourDelivery) {
        return t('productCard.fbc.s_dc');
    }
    return t('productCard.soldBy') + " " + supplier;
};
var useFbcFeature = function () {
    var _a;
    var fbcConfig = (_a = useFeature('fbc')) === null || _a === void 0 ? void 0 : _a.value;
    var isFbcSupported = !!(fbcConfig === null || fbcConfig === void 0 ? void 0 : fbcConfig.enabled);
    var fbcIconUrl = fbcConfig === null || fbcConfig === void 0 ? void 0 : fbcConfig.icon;
    return {
        isFbcSupported: isFbcSupported,
        fbcIconUrl: fbcIconUrl,
    };
};
var ERR_TIMEOUT = 5000;
var ProductCard = function (props) {
    var _a, _b, _c, _d, _e;
    var dispatch = useDispatch();
    var _f = useProductCard(props.productId), error = _f.error, errDetail = _f.errDetail, loading = _f.loading;
    var _g = useAnalytic(), GTMEventCall = _g.GTMEventCall, EventCall = _g.EventCall;
    var _h = useBreakpoints(), isMobile = _h.isMobile, isDesktop = _h.isDesktop;
    var isBasketV4 = useFeature('basket_v4_global').on;
    var _j = __read$1(useProductCardHandlers(props, isBasketV4), 4), onAddHandler = _j[0], onDecrementHandler = _j[1], onIncrementHandler = _j[2], onRemoveHandler = _j[3];
    var _k = useSelector(function (state) { return state.appConfig; }), language = _k.language, storeId = _k.storeId, code = _k.code;
    var sortBy = useSelector(function (state) {
        var _a, _b;
        return {
            sortBy: (_b = (_a = state === null || state === void 0 ? void 0 : state.search) === null || _a === void 0 ? void 0 : _a.query) === null || _b === void 0 ? void 0 : _b.sortBy,
        };
    }).sortBy;
    var expressHeight = '17px';
    var expressWidth = '51px';
    if (isMobile) {
        expressWidth = '42px';
        expressHeight = '14px';
    }
    var dir = useMemo(function () { return ((language ? language : EN) === AR ? 'rtl' : 'ltr'); }, [language]);
    var _l = (useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.search; }) || {}).algoliaQueryID, algoliaQueryID = _l === void 0 ? '' : _l;
    var t = useTranslation().t;
    var showNewPromoBadges = !((_a = useFeature('old_promo_badges')) === null || _a === void 0 ? void 0 : _a.on);
    var showFoodNutrition = (_b = useFeature('product_card_food_nutrition')) === null || _b === void 0 ? void 0 : _b.on;
    var dietary = props.dietary, _m = props.bulkMessage, bulkMessage = _m === void 0 ? '' : _m, currency = props.currency, _o = props.currencyPosition, currencyPosition = _o === void 0 ? 'right' : _o, disabled = props.disabled, _p = props.discount, discount = _p === void 0 ? {
        type: 'none',
        value: 0,
        price: 0,
        minBuyingValue: '',
    } : _p, image = props.image, newProductCardImage = props.newProductCardImage, inCart = props.inCart, incrementBy = props.incrementBy, isAvailable = props.isAvailable, isExpress = props.isExpress, _q = props.isLebanon, isLebanon = _q === void 0 ? false : _q, _r = props.isSponsored, isSponsored = _r === void 0 ? false : _r, _s = props.isCart, isCart = _s === void 0 ? false : _s, _t = props.promoVoucher, promoVoucher = _t === void 0 ? {} : _t, isOpen = props.isOpen, itemsPerUnit = props.itemsPerUnit, max = props.max, min = props.min, minBuyingValue = props.minBuyingValue, name = props.name, _u = props.originalPrice, originalPrice = _u === void 0 ? 0 : _u, _v = props.points, points = _v === void 0 ? 0 : _v, productId = props.productId, _w = props.productVariants, productVariants = _w === void 0 ? [] : _w, _x = props.quantity, quantity = _x === void 0 ? 1 : _x, _y = props.size, size = _y === void 0 ? '' : _y, _z = props.testId, testId = _z === void 0 ? '' : _z, unitOfMeasure = props.unitOfMeasure, unitItem = props.unitItem, _0 = props.position, position = _0 === void 0 ? 0 : _0, url = props.url, _1 = props.withProductVariants, withProductVariants = _1 === void 0 ? false : _1, imageLibrary = props.imageLibrary, newProductCardImageLibrary = props.newProductCardImageLibrary, showAgeDisclaimer = props.showAgeDisclaimer, isSponsoredListing = props.isSponsoredListing, productOrigin = props.productOrigin, supplier = props.supplier, isFBC = props.isFBC, type = props.type, _2 = props.isFoodCategory, isFoodCategory = _2 === void 0 ? false : _2, onNotificationHandler = props.onNotificationHandler, onViewSimilarHandler = props.onViewSimilarHandler, promoBadges = props.promoBadges, _3 = props.promoBadgesAreaA, promoBadgesAreaA = _3 === void 0 ? [] : _3, _4 = props.promoBadgesAreaB, promoBadgesAreaB = _4 === void 0 ? [] : _4, isNewPromoBadges = props.isNewPromoBadges, offers = props.offers, preorder = props.preorder, _5 = props.delivery, delivery = _5 === void 0 ? [] : _5, _6 = props.rowIndex, rowIndex = _6 === void 0 ? 0 : _6, carousel = props.carousel, rest = __rest$1(props, ["dietary", "bulkMessage", "currency", "currencyPosition", "disabled", "discount", "image", "newProductCardImage", "inCart", "incrementBy", "isAvailable", "isExpress", "isLebanon", "isSponsored", "isCart", "promoVoucher", "isOpen", "itemsPerUnit", "max", "min", "minBuyingValue", "name", "originalPrice", "points", "productId", "productVariants", "quantity", "size", "testId", "unitOfMeasure", "unitItem", "position", "url", "withProductVariants", "imageLibrary", "newProductCardImageLibrary", "showAgeDisclaimer", "isSponsoredListing", "productOrigin", "supplier", "isFBC", "type", "isFoodCategory", "onNotificationHandler", "onViewSimilarHandler", "promoBadges", "promoBadgesAreaA", "promoBadgesAreaB", "isNewPromoBadges", "offers", "preorder", "delivery", "rowIndex", "carousel"]);
    var _7 = __read$1(useInView({
        threshold: 0,
    }), 2), ref = _7[0], inView = _7[1];
    var isNewCarrefourJourney = ((_d = (_c = useFeature('new_carrefour_journey')) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.new_journey) || false;
    var discountBadgePercentageThreshold = ((_e = useFeature('discount_badge_percentage_threshold')) === null || _e === void 0 ? void 0 : _e.value) || null;
    var _8 = useFbcFeature(), isFbcSupported = _8.isFbcSupported, fbcIconUrl = _8.fbcIconUrl;
    var isDiscountBadgePercentageThreshold = discountBadgePercentageThreshold
        ? discount.value > discountBadgePercentageThreshold
        : false;
    var isLBN = isLebanon || storeId === EStoreID.MAFLBN;
    var variant = props.variant || EProductCardVariants.REGULAR;
    var isCompactView = isFoodCategory && isMobile;
    useEffect(function () {
        if (inView) {
            var productPosition = getProductPosition(rowIndex, position, isDesktop, isMobile);
            GTMEventCall(GTMEvents.product_impressions, { product: props, position: productPosition, ga4: false });
            GTMEventCall(GTMEvents.product_impressions, {
                product: props,
                position: productPosition,
                ga4: true,
                countryCode: code,
            });
            if (props.isSponsored) {
                if (!isImpressionTracked(props)) {
                    Promise.resolve(EventCall(GTMEvents.product_impression, props));
                }
            }
        }
    }, [inView, GTMEventCall, EventCall, productId, position, props, code, isDesktop, isMobile, rowIndex]);
    useEffect(function () {
        var timer;
        if (error) {
            timer = setTimeout(function () { return dispatch(setError(productId, false, '', false)); }, ERR_TIMEOUT);
        }
        return function () { return timer && clearTimeout(timer); };
    }, [dispatch, error, productId]);
    var borderType = useMemo(function () {
        if (isSponsoredListing) {
            return EProductCardBorderType.SPONSORED_LISTING;
        }
        else if (isOpen || (isLBN && points > 0)) {
            return EProductCardBorderType.ORIGINAL;
        }
        else if (inCart) {
            return EProductCardBorderType.IN_CART;
        }
        else if (discount.price > 0) {
            return EProductCardBorderType.DISCOUNT;
        }
        return EProductCardBorderType.ORIGINAL;
    }, [discount.price, inCart, isLBN, isOpen, points, isSponsoredListing]);
    var onProductClickHandler = useCallback(function (url) { return function (event) {
        event.preventDefault();
        if (isSponsoredListing && isCart) {
            return;
        }
        var updatedUrl = url;
        if (rest.gaListName) {
            updatedUrl = updateQueryStringParamter(updatedUrl, 'list_name', gtmSnakeCase(rest.gaListName));
        }
        var offerId = offers && offers.length > 0 ? offers[0].id : '';
        if (offerId) {
            updatedUrl = updateQueryStringParamter(updatedUrl, 'offer', offerId);
        }
        var sid = offers && offers.length > 0 ? offers[0].shippingIndicator : '';
        updatedUrl = updateQueryStringParamter(updatedUrl, 'sid', sid);
        var productPosition = getProductPosition(rowIndex, position, isDesktop, isMobile);
        sessionStorage.setItem('queryId', algoliaQueryID);
        Promise.resolve(clickAlgoliaOperation({ searchQueryID: algoliaQueryID, productId: props.productId, productPosition: productPosition, sortBy: sortBy }, dispatch));
        var _a = getGa4AlgoliaEventsParams(), experimentKey = _a.experimentKey, variationId = _a.variationId;
        if (variationId && experimentKey) {
            GTMEventCall(GTMEvents.algolia_custom_events, {
                experiment_key: experimentKey,
                variation_id: variationId,
                pageData: { language: language, currency: currency },
            });
        }
        GTMEventCall(GTMEvents.product_click, { product: props, position: position, ga4: false });
        GTMEventCall(GTMEvents.product_click, { product: props, position: position, ga4: true, countryCode: code });
        Promise.resolve(EventCall(GTMEvents.product_click, props));
        window.location.href = "" + updatedUrl;
    }; }, [
        rest.gaListName,
        rowIndex,
        position,
        isDesktop,
        isMobile,
        algoliaQueryID,
        props,
        sortBy,
        dispatch,
        GTMEventCall,
        code,
        EventCall,
        currency,
        language,
        offers,
        isSponsoredListing,
        isCart,
    ]);
    var onRightClickHandler = useCallback(function () {
        if (props.isSponsored) {
            Promise.resolve(EventCall(GTMEvents.right_click, props));
        }
    }, [props, EventCall]);
    var productNote = useMemo(function () {
        return getProductNote(itemsPerUnit, t);
    }, [itemsPerUnit, t]);
    var hasVariants = useMemo(function () { return productVariants.length > 0 && withProductVariants; }, [
        productVariants.length,
        withProductVariants,
    ]);
    var showOOSOptions = useMemo(function () { return !!(onNotificationHandler || onViewSimilarHandler); }, [
        onNotificationHandler,
        onViewSimilarHandler,
    ]);
    var isExpressProduct = useMemo(function () {
        if (variant === EProductCardVariants.REGULAR_WIDE || !isSponsoredListing)
            return !!isExpress;
        if (variant === EProductCardVariants.REGULAR && isSponsoredListing)
            return !!isExpress;
        return false;
    }, [isExpress, isSponsoredListing, variant]);
    var _9 = __read$1(useState(false), 2), mouseHover = _9[0], setMouseHover = _9[1];
    var onMouseHover = useCallback(function (hovering) { return function () { return setMouseHover(hovering); }; }, [setMouseHover]);
    var getSimplePrice = useCallback(function (price, type) {
        return formatPrice(price, currency, currencyPosition, false, type);
    }, [currency, currencyPosition]);
    var onNotifyMeCb = useCallback(function () {
        if (onNotificationHandler) {
            onNotificationHandler(__assign$1({}, props));
        }
    }, [props, onNotificationHandler]);
    var onViewSimilarCb = useCallback(function () {
        if (onViewSimilarHandler) {
            var isMarketPlace = rest.isMarketPlace;
            var product = {
                name: name,
                productId: productId,
                image: image,
                size: size,
                unitOfMeasure: unitOfMeasure,
                isMarketPlace: isMarketPlace,
                type: type,
                price: getSimplePrice(originalPrice, 'original'),
            };
            onViewSimilarHandler(product);
        }
    }, [productId, name, getSimplePrice, image, size, unitOfMeasure, originalPrice, onViewSimilarHandler, rest, type]);
    var ProductPriceWrapper = function () {
        if (variant === EProductCardVariants.COMPACT ||
            variant === EProductCardVariants.LIST ||
            variant === EProductCardVariants.MINI) {
            return (React.createElement(ProductCardPricesWrapper, { variant: variant, "data-testid": "product_price" }, discount.price > 0
                ? renderProductPrice(discount.price, 'discount', currency, currencyPosition, unitOfMeasure, true, variant, t, 'product-card-discount-price', isSponsoredListing)
                : originalPrice > 0 &&
                    renderProductPrice(originalPrice, 'original', currency, currencyPosition, unitOfMeasure, discount.price > 0, variant, t, 'product-card-original-price', isSponsoredListing)));
        }
        else {
            return (React.createElement(ProductCardPricesWrapper, { variant: variant, "data-testid": "product_price" },
                discount.price > 0 &&
                    renderProductPrice(discount.minBuyingValue && type === ProductType.FOOD
                        ? parseFloat(discount.minBuyingValue)
                        : discount.price, 'discount', currency, currencyPosition, unitOfMeasure, true, variant, t, 'product-card-discount-price', isSponsoredListing, unitItem, undefined, isNewCarrefourJourney),
                originalPrice > 0 &&
                    discount.price == 0 &&
                    renderProductPrice(minBuyingValue ? parseFloat(minBuyingValue) : originalPrice, 'original', currency, currencyPosition, unitOfMeasure, discount.price > 0, variant, t, 'product-card-original-price', isSponsoredListing, unitItem, discount, isNewCarrefourJourney)));
        }
    };
    var isTopHeaderSticker = (promoVoucher === null || promoVoucher === void 0 ? void 0 : promoVoucher.hasPromoVoucher) || (discount === null || discount === void 0 ? void 0 : discount.value) > 0 || bulkMessage.length > 0 || points > 0;
    var cardWidth = ['115px', '115px', '222px', '222px'];
    var cardHeight = ['141px', '129px', '96px', '96px'];
    if (variant === 'simple') {
        if (isSponsoredListing) {
            cardHeight = '100px';
            cardWidth = '222px';
        }
        if (isCart) {
            cardHeight = '112px';
            cardWidth = '90px';
        }
    }
    var isReachedQtyMaxLimit = hasReachedQtyMaxLimit(quantity, max);
    var renderProductCardActions = (React.createElement(ProductCardActionsWrapper, { dir: "ltr", "data-testid": "product-card-actions", variant: variant, inCart: inCart }, isAvailable ? (React.createElement(CartElements, __assign$1({}, rest, { disabled: disabled || !isAvailable, inCart: inCart, incrementBy: incrementBy, isOpen: isOpen, isLoading: loading, max: max, min: min, onAddHandler: onAddHandler, onDecrementHandler: onDecrementHandler, onIncrementHandler: onIncrementHandler, onRemoveHandler: onRemoveHandler, productCardVariant: variant, variant: variant, quantity: quantity, soldByWeight: unitOfMeasure === KG_LABEL, showAgeDisclaimer: showAgeDisclaimer, currency: currency, productId: productId, price: discount.price > 0 ? discount.price : originalPrice, isNewCarrefourJourney: isNewCarrefourJourney, dir: dir }))) : (showOOSOptions && (React.createElement(OutOfStockOptions, { onNotificationHandler: onNotifyMeCb, onViewSimilarHandler: onViewSimilarCb })))));
    var params1 = [currency, points];
    var params2 = [variant, promoVoucher, language, t, promoBadgesAreaA, bulkMessage];
    var params = __spread$1(params1, [isLBN], params2);
    var _10 = __read$1(useMemo(function () {
        if (showNewPromoBadges || isNewPromoBadges) {
            var badges = promoBadges === null || promoBadges === void 0 ? void 0 : promoBadges.filter(function (ele) {
                var _a, _b, _c;
                var seller = (_a = ele === null || ele === void 0 ? void 0 : ele.seller) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                var sellerName = (_c = (_b = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _b === void 0 ? void 0 : _b.sellerName) === null || _c === void 0 ? void 0 : _c.toLowerCase();
                if (!seller ||
                    seller === 'both' ||
                    (seller === 'carrefour' && sellerName === 'carrefour') ||
                    (seller !== 'both' && seller !== 'carrefour' && sellerName !== 'carrefour'))
                    return true;
            }).sort(function (a, b) { return a.priority - b.priority; });
            return getBadges(points, variant, promoVoucher, language, t, badges, bulkMessage, discount, isLebanon, preorder);
        }
        return [];
    }, [
        bulkMessage,
        isNewPromoBadges,
        language,
        offers,
        points,
        promoBadges,
        promoVoucher,
        showNewPromoBadges,
        t,
        variant,
        discount,
        isLebanon,
        preorder,
    ]), 2), promoBadgesAreaAEle = _10[0], promoBadgesAreaBEle = _10[1];
    return variant !== 'simple' ? (React.createElement("div", null,
        React.createElement(ProductCardWrapper, { ref: ref, "data-testid": testId, variant: variant, hasProductVariants: hasVariants, borderType: borderType, dir: dir, onMouseEnter: onMouseHover(true), onMouseLeave: onMouseHover(false), isSponsoredListing: isSponsoredListing, borderRadius: 4, carousel: carousel },
            React.createElement(ProductCardContentElevation, { isSponsoredListing: isSponsoredListing, variant: variant },
                React.createElement(ProductImage, { dietary: dietary, onProductClickHandler: onProductClickHandler, inCart: inCart, isHover: mouseHover, isExpressProduct: isExpressProduct, currency: currency, currencyPosition: currencyPosition, discount: discount, originalPrice: originalPrice, quantity: quantity, unitOfMeasure: unitOfMeasure, image: image, newProductCardImage: newProductCardImage, errDetail: errDetail, error: error, name: name, url: url, isAvailable: isAvailable, imageLibrary: imageLibrary, newProductCardImageLibrary: newProductCardImageLibrary, variant: variant, onRightClickHandler: onRightClickHandler, isTopHeaderSticker: isTopHeaderSticker, promoBadgesAreaB: promoBadgesAreaB, isSponsoredListing: isSponsoredListing, showFoodNutrition: showFoodNutrition, showNewPromoBadges: showNewPromoBadges, isNewPromoBadges: isNewPromoBadges, promoBadgesAreaBEle: promoBadgesAreaBEle, renderProductCardActions: renderProductCardActions, isSponsored: isSponsored, promoBadgesAreaAEle: promoBadgesAreaAEle, renderHeaderSticker: renderHeaderSticker.apply(void 0, __spread$1(params)), isNewCarrefourJourney: isNewCarrefourJourney, carousel: carousel, expressHeight: expressHeight, expressWidth: expressWidth, dir: dir, discountBadgePercentageThreshold: isDiscountBadgePercentageThreshold ? discount.value : undefined }),
                React.createElement(ProductItems, { variant: variant },
                    variant !== EProductCardVariants.REGULAR_WIDE && (React.createElement(React.Fragment, null,
                        React.createElement(ProductPriceWrapper, null),
                        discount.price > 0 && points < 1 ? (React.createElement(DisplayDiscountTemplateNew, { originalPrice: originalPrice, discount: discount, minBuyingValue: minBuyingValue, variant: variant, currency: currency, currencyPos: 'right', unitOfMeasure: unitOfMeasure, isSponsoredListing: isSponsoredListing, unitItem: unitItem })) : (React.createElement(EmptyDiscountedPrice, null)))),
                    React.createElement(ProductCardName, { variant: variant, isSponsoredListing: isSponsoredListing },
                        React.createElement("a", { href: url, title: decodeHtml(name), dangerouslySetInnerHTML: { __html: name }, onClick: onProductClickHandler(url), onContextMenu: onRightClickHandler, "data-testid": "product_name" })),
                    !isNewCarrefourJourney && variant !== EProductCardVariants.COMPACT && (React.createElement(GetProductDeliveryInfo, { productOrigin: productOrigin, supplier: supplier, type: type, variant: variant, isFBC: isFBC, delivery: delivery, unitOfMeasure: unitOfMeasure, size: size, min: min })),
                    ((variant === EProductCardVariants.REGULAR && !isSponsoredListing && !isCompactView) ||
                        variant === EProductCardVariants.REGULAR_WIDE) && (React.createElement(ProductCardNote, { isSponsoredListing: isSponsoredListing, variant: variant },
                        productNote && (size ? size + " " + unitOfMeasure + " - " : formatFoodWeight(min, unitOfMeasure) + " - "),
                        productNote)),
                    variant !== EProductCardVariants.REGULAR_WIDE && (React.createElement(ProductCardStockIndicator, null, max <= STOCK_ALERT && type === ProductType.NONFOOD ? t('productCard.onlyQtyLeft', { qty: max }) : '')),
                    type === ProductType.NONFOOD && isFBC && isFbcSupported && variant !== EProductCardVariants.REGULAR_WIDE && (React.createElement(FBCContainer, null,
                        !!fbcIconUrl && React.createElement("img", { src: fbcIconUrl }),
                        React.createElement("span", null, t('productCard.fbc.fc')))),
                    isReachedQtyMaxLimit && variant === EProductCardVariants.LIST && (React.createElement(MaxLimitContainer, { variant: variant },
                        React.createElement("div", null, t('productCard.maxLimit')))),
                    variant === EProductCardVariants.REGULAR_WIDE && (React.createElement(React.Fragment, null,
                        React.createElement(ProductPriceWrapper, null),
                        renderProductCardActions,
                        discount.price > 0 && points < 1 ? (React.createElement(DisplayDiscountTemplateNew, { originalPrice: originalPrice, discount: discount, minBuyingValue: minBuyingValue, variant: variant, currency: currency, currencyPos: 'right', unitOfMeasure: unitOfMeasure, isSponsoredListing: isSponsoredListing, unitItem: unitItem })) : (React.createElement(EmptyDiscountedPrice, null))))))))) : (React.createElement(ProductCardSimple, { flexDirection: "column", height: cardHeight, width: cardWidth, dir: dir, ref: ref, isSponsoredListing: isSponsoredListing, isCart: isCart },
        React.createElement(ProductCardSimpleImageContainer, { onClick: onProductClickHandler(url), isCart: isCart },
            React.createElement(Image, { url: image.href, name: image.altText }),
            isExpress && !isSponsoredListing && isBrowser() && React.createElement(NowJourneyIcon, { variant: isCart ? 'new' : 'old' })),
        React.createElement(ProductCardSimpleContent, { mt: [2, 2, 0, 0], alignItems: isSponsoredListing ? 'flex-start' : ['center', 'center', 'flex-start', 'flex-start'] },
            isCart ? null : (React.createElement(React.Fragment, null,
                React.createElement(ProductCardSimpleHeader, { isSponsoredListing: isSponsoredListing, display: isSponsoredListing ? '-webkit-box' : ['none', 'none', '-webkit-box', '-webkit-box'] }, name),
                !isSponsoredListing ? (React.createElement(ProductCardSimplePrice, { "data-testid": "product-card-simple-price" }, discount.price > 0
                    ? getSimplePrice(discount.price, 'discount')
                    : getSimplePrice(originalPrice, 'original'))) : (ProductPriceWrapper),
                isMobile && !isSponsoredListing && (React.createElement(ProductCardSimpleSeperator, { width: ['115px', '115px', '222px', '222px'] })))),
            !isSponsoredListing && !isCart && (React.createElement(ProductCardSimpleCTA, { disabled: loading, onClick: onAddHandler }, t(loading ? 'adding' : 'add'))),
            !isSponsoredListing && isCart && (React.createElement(ProductCardSimpleCartCTA, { disabled: loading, onClick: onAddHandler }, t("" + (loading ? 'adding' : 'add')))),
            isSponsoredListing && renderProductCardActions)));
};
var GetProductDeliveryInfo = function (_a) {
    var variant = _a.variant, type = _a.type, productOrigin = _a.productOrigin, supplier = _a.supplier, _b = _a.isFBC, isFBC = _b === void 0 ? false : _b, _c = _a.delivery, delivery = _c === void 0 ? [] : _c, unitOfMeasure = _a.unitOfMeasure, size = _a.size, min = _a.min;
    var info = React.createElement("br", null);
    var t = useTranslation().t;
    if (productOrigin && type === ProductType.FOOD) {
        size
            ? (info = size + " " + unitOfMeasure + " - " + productOrigin)
            : (info = formatFoodWeight(min, unitOfMeasure) + " - " + productOrigin);
    }
    else if (type === ProductType.NONFOOD) {
        info = fullfilledByCarreFourProductInfo({ isFBC: isFBC, supplier: supplier, delivery: delivery, t: t });
    }
    return (React.createElement(Flex, { alignItems: "center", height: "20", mt: 2 },
        React.createElement(ProductDeliveryInfo, { ml: isFBC ? 1 : 0, variant: variant }, info)));
};
var ProductCard$1 = React.memo(ProductCard);
var FbtWrapper = customStyled.div(templateObject_1$E || (templateObject_1$E = __makeTemplateObject$1(["\n  display: inline-block;\n  font-family: ", ";\n  width: 100%;\n  ", ";\n\n  a {\n    text-decoration: none;\n  }\n"], ["\n  display: inline-block;\n  font-family: ", ";\n  width: 100%;\n  ", ";\n\n  a {\n    text-decoration: none;\n  }\n"])), function (props) { return props.theme.fonts.montserrat; }, space);
var FbtWrappperInner = customStyled.div(templateObject_2$w || (templateObject_2$w = __makeTemplateObject$1(["\n  @media (min-width: ", ") {\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 8px;\n    padding: ", "px;\n    position: relative;\n  }\n"], ["\n  @media (min-width: ", ") {\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 8px;\n    padding: ", "px;\n    position: relative;\n  }\n"])), function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.colors.mercury; }, function (props) { return props.theme.space[3]; });
var FbtHeader = customStyled(Flex)(templateObject_3$q || (templateObject_3$q = __makeTemplateObject$1(["\n  justify-content: space-between;\n  margin-bottom: 12px;\n\n  p {\n    color: ", ";\n    font-size: ", "px;\n    font-weight: ", ";\n  }\n\n  @media (min-width: ", ") {\n    height: 40px;\n\n    p {\n      font-size: ", "px;\n    }\n  }\n"], ["\n  justify-content: space-between;\n  margin-bottom: 12px;\n\n  p {\n    color: ", ";\n    font-size: ", "px;\n    font-weight: ", ";\n  }\n\n  @media (min-width: ", ") {\n    height: 40px;\n\n    p {\n      font-size: ", "px;\n    }\n  }\n"])), function (props) { return props.theme.colors.black; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.fontWeights[5]; }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.fontSizes[3]; });
var FbtCTA = customStyled(Button$1)(templateObject_4$n || (templateObject_4$n = __makeTemplateObject$1(["\n  border-radius: 4px;\n  font-size: ", "px;\n  font-weight: ", ";\n  margin-top: ", "px;\n  width: 100%;\n  background-color: ", ";\n\n  @media (min-width: ", ") {\n    margin-top: 0;\n    html[dir='ltr'] && position: absolute;\n    html[dir='ltr'] && right: ", "px;\n    html[dir='ltr'] && top: ", "px;\n    width: auto;\n  }\n"], ["\n  border-radius: 4px;\n  font-size: ", "px;\n  font-weight: ", ";\n  margin-top: ", "px;\n  width: 100%;\n  background-color: ", ";\n\n  @media (min-width: ", ") {\n    margin-top: 0;\n    html[dir='ltr'] && position: absolute;\n    html[dir='ltr'] && right: ", "px;\n    html[dir='ltr'] && top: ", "px;\n    width: auto;\n  }\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.space[3]; }, function (props) { return props.theme.colors.ctaRed; }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.space[3]; }, function (props) { return props.theme.space[3]; });
FbtCTA.defaultProps = {
    paddingBottom: '12px',
    paddingLeft: '18px',
    paddingRight: '18px',
    paddingTop: '12px',
};
var FbtCTALoader = customStyled.div(templateObject_5$i || (templateObject_5$i = __makeTemplateObject$1(["\n  border: 4px solid ", ";\n  border-radius: 50%;\n  border-top: 4px solid ", ";\n  width: 18px;\n  height: 18px;\n  -webkit-animation: spin 1s linear infinite; /* Safari */\n  animation: spin 1s linear infinite;\n\n  /* Safari */\n  @-webkit-keyframes spin {\n    0% { -webkit-transform: rotate(0deg); }\n    100% { -webkit-transform: rotate(360deg); }\n  }\n\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n"], ["\n  border: 4px solid ", ";\n  border-radius: 50%;\n  border-top: 4px solid ", ";\n  width: 18px;\n  height: 18px;\n  -webkit-animation: spin 1s linear infinite; /* Safari */\n  animation: spin 1s linear infinite;\n\n  /* Safari */\n  @-webkit-keyframes spin {\n    0% { -webkit-transform: rotate(0deg); }\n    100% { -webkit-transform: rotate(360deg); }\n  }\n\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n"])), function (props) { return (props.color ? props.color : '#f1f1f1'); }, function (props) { return props.theme.colors.white; });
var FbtProductList = customStyled.div(templateObject_6$e || (templateObject_6$e = __makeTemplateObject$1(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  padding: ", "px;\n\n  @media (min-width: ", ") {\n    background-color: transparent;\n    border: 0;\n    border-radius: 0;\n    display: grid;\n    grid-gap: 20px;\n    grid-template-columns: repeat(", ", 1fr);\n    margin-top: ", "px;\n    padding: 0;\n  }\n"], ["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  padding: ", "px;\n\n  @media (min-width: ", ") {\n    background-color: transparent;\n    border: 0;\n    border-radius: 0;\n    display: grid;\n    grid-gap: 20px;\n    grid-template-columns: repeat(", ", 1fr);\n    margin-top: ", "px;\n    padding: 0;\n  }\n"])), function (props) { return props.theme.colors.white; }, function (props) { return props.theme.colors.mercury; }, function (props) { return props.theme.space[3]; }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.productLen; }, function (props) { return props.theme.space[3]; });
var FbtProduct = customStyled.div(templateObject_7$e || (templateObject_7$e = __makeTemplateObject$1(["\n  display: grid;\n  border-bottom: 1px solid ", ";\n  grid-template-columns: 76px 1fr;\n  grid-gap: 12px;\n  padding: ", "px 0;\n\n  &:first-of-type {\n    padding-top: 0;\n  }\n\n  &:last-of-type {\n    border: 0;\n    padding-bottom: 0;\n  }\n\n  @media (min-width: ", ") {\n    display: flex;\n    border-bottom: 0;\n    flex-direction: column;\n    grid-gap: 0;\n    padding: 0;\n  }\n"], ["\n  display: grid;\n  border-bottom: 1px solid ", ";\n  grid-template-columns: 76px 1fr;\n  grid-gap: 12px;\n  padding: ", "px 0;\n\n  &:first-of-type {\n    padding-top: 0;\n  }\n\n  &:last-of-type {\n    border: 0;\n    padding-bottom: 0;\n  }\n\n  @media (min-width: ", ") {\n    display: flex;\n    border-bottom: 0;\n    flex-direction: column;\n    grid-gap: 0;\n    padding: 0;\n  }\n"])), function (props) { return props.theme.colors.mercury; }, function (props) { return props.theme.space[3]; }, function (props) { return props.theme.breakpoints[2]; });
var FbtProductHeading = customStyled(Flex)(templateObject_8$e || (templateObject_8$e = __makeTemplateObject$1(["\n  align-items: center;\n  \n\n  @media (min-width: ", ") {\n    margin-bottom: ", "px;\n  }\n"], ["\n  align-items: center;\n  \n\n  @media (min-width: ", ") {\n    margin-bottom: ", "px;\n  }\n"])), function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.space[2]; });
var FbtCheckbox = customStyled(Checkbox)(templateObject_9$d || (templateObject_9$d = __makeTemplateObject$1(["\nhtml[dir='ltr'] & {margin-right: ", "px};\nhtml[dir='rtl'] & {margin-left: ", "px};\n\n  input + div {\n    opacity: 1;\n    transition: opacity 0.25s ease;\n    cursor: pointer;\n  }\n\n  input[disabled] + div {\n    opacity 0.4;\n    cursor: not-allowed;\n  }\n"], ["\nhtml[dir='ltr'] & {margin-right: ", "px};\nhtml[dir='rtl'] & {margin-left: ", "px};\n\n  input + div {\n    opacity: 1;\n    transition: opacity 0.25s ease;\n    cursor: pointer;\n  }\n\n  input[disabled] + div {\n    opacity 0.4;\n    cursor: not-allowed;\n  }\n"])), function (props) { return props.theme.space[2]; }, function (props) { return props.theme.space[2]; });
var FbtWarningWrapper = customStyled.div(templateObject_10$d || (templateObject_10$d = __makeTemplateObject$1(["\n  left: -3px;\n  margin-right: ", "px;\n  position: relative;\n  width: 18px;\n\n  &:hover + span {\n    opacity: 1;\n  }\n"], ["\n  left: -3px;\n  margin-right: ", "px;\n  position: relative;\n  width: 18px;\n\n  &:hover + span {\n    opacity: 1;\n  }\n"])), function (props) { return props.theme.space[2]; });
var FbtProductDiscountSticker = customStyled.div(templateObject_11$a || (templateObject_11$a = __makeTemplateObject$1(["\n  background-color: ", ";\n  color: ", ";\n  font-size: 6px;\n  font-weight: ", ";\n  left: 0;\n  padding: 2px;\n  position: absolute;\n  text-align: center;\n  text-transform: uppercase;\n  top: 0;\n  width: 100%;\n  z-index: 2;\n"], ["\n  background-color: ", ";\n  color: ", ";\n  font-size: 6px;\n  font-weight: ", ";\n  left: 0;\n  padding: 2px;\n  position: absolute;\n  text-align: center;\n  text-transform: uppercase;\n  top: 0;\n  width: 100%;\n  z-index: 2;\n"])), function (props) { return props.theme.colors.yellow; }, function (props) { return props.theme.colors.red; }, function (props) { return props.theme.fontWeights[5]; });
var FbtProductImage = customStyled.div(templateObject_12$9 || (templateObject_12$9 = __makeTemplateObject$1(["\n  height: 50px;\n  position: relative;\n  min-width: 50px;\n\n  img {\n    bottom: 0;\n    height: auto;\n    left: 0;\n    margin: auto;\n    max-height: 100%;\n    position: absolute;\n    max-width: 100%;\n    right: 0;\n    top: 0;\n    width: auto;\n  }\n"], ["\n  height: 50px;\n  position: relative;\n  min-width: 50px;\n\n  img {\n    bottom: 0;\n    height: auto;\n    left: 0;\n    margin: auto;\n    max-height: 100%;\n    position: absolute;\n    max-width: 100%;\n    right: 0;\n    top: 0;\n    width: auto;\n  }\n"])));
var FbtProductDetails = customStyled(Flex)(templateObject_13$9 || (templateObject_13$9 = __makeTemplateObject$1(["\n  flex-direction: column;\n  justify-content: space-around;\n"], ["\n  flex-direction: column;\n  justify-content: space-around;\n"])));
var FbtProductName = customStyled.a(templateObject_14$9 || (templateObject_14$9 = __makeTemplateObject$1(["\n  color: ", ";\n  display: -webkit-box;\n  font-size: ", "px;\n  margin-bottom: 2px;\n  overflow: hidden;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n\n  @media (min-width: ", ") {\n    -webkit-line-clamp: 1;\n  }\n"], ["\n  color: ", ";\n  display: -webkit-box;\n  font-size: ", "px;\n  margin-bottom: 2px;\n  overflow: hidden;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n\n  @media (min-width: ", ") {\n    -webkit-line-clamp: 1;\n  }\n"])), function (props) { return props.color; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.breakpoints[2]; });
var FbtPriceWrapper = customStyled(Flex)(templateObject_15$9 || (templateObject_15$9 = __makeTemplateObject$1(["\n  color: ", " !important;\n  align-items: center;\n  margin-top: 2px;\n"], ["\n  color: ", " !important;\n  align-items: center;\n  margin-top: 2px;\n"])), function (props) { return props.color; });
var FbtPriceOriginal = customStyled.div(templateObject_16$6 || (templateObject_16$6 = __makeTemplateObject$1(["\n  align-items: center;\n  display: flex;\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n\n  ", "\n"], ["\n  align-items: center;\n  display: flex;\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n\n  ",
    "\n"])), function (props) { return (props.isError ? 'red' : 'black'); }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.fontWeights[5]; }, function (props) {
    return props.hasDiscount
        ? "\n      color: " + (props.isError ? props.theme.colors.red : props.theme.colors.silverChalice) + ";\n      font-size: " + props.theme.fontSizes[0] + "px;\n      font-weight: normal;\n      margin-left: " + props.theme.space[1] + "px;\n      text-decoration: line-through;\n    "
        : '';
});
var FbtPriceDiscount = customStyled(FbtPriceOriginal)(templateObject_17$6 || (templateObject_17$6 = __makeTemplateObject$1(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) { return props.theme.colors.red; });
var FbtProductWeight = customStyled.div(templateObject_18$5 || (templateObject_18$5 = __makeTemplateObject$1(["\n  color: ", ";\n  display: inline-block;\n  font-size: ", "px;\n  margin-left: ", "px;\n  vertical-align: middle;\n"], ["\n  color: ", ";\n  display: inline-block;\n  font-size: ", "px;\n  margin-left: ", "px;\n  vertical-align: middle;\n"])), function (props) { return (props.isError ? props.theme.colors.red : props.theme.colors.silverChalice); }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.space[1]; });
var FbtProductErrorDetail = customStyled(Text)(templateObject_19$5 || (templateObject_19$5 = __makeTemplateObject$1(["\n    color: ", ";\n    font-size: ", "px;\n    grid-column-start: 1;\n    grid-column-end: 3;\n    margin-bottom: 0;\n\n    @media (min-width: ", ") {\n      margin-top: 12px;\n    }\n"], ["\n    color: ", ";\n    font-size: ", "px;\n    grid-column-start: 1;\n    grid-column-end: 3;\n    margin-bottom: 0;\n\n    @media (min-width: ", ") {\n      margin-top: 12px;\n    }\n"])), function (props) { return props.theme.colors.red; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.breakpoints[2]; });
var FbtCartElementsWrapper = customStyled(Flex)(templateObject_20$4 || (templateObject_20$4 = __makeTemplateObject$1(["\n  align-items: center;\n  grid-column-start: 1;\n  grid-column-end: 3;\n  justify-content: flex-end;\n  margin-top: 12px;\n\n  @media (min-width: ", ") {\n    justify-content: flex-start;\n  }\n"], ["\n  align-items: center;\n  grid-column-start: 1;\n  grid-column-end: 3;\n  justify-content: flex-end;\n  margin-top: 12px;\n\n  @media (min-width: ", ") {\n    justify-content: flex-start;\n  }\n"])), function (props) { return props.theme.breakpoints[2]; });
var FbtCartElementsLoaderWrapper = customStyled(Flex)(templateObject_21$4 || (templateObject_21$4 = __makeTemplateObject$1(["\n  justify-content: center;\n  min-width: 106px;\n  padding: 0 12px;\n"], ["\n  justify-content: center;\n  min-width: 106px;\n  padding: 0 12px;\n"])));
var FbtCartElementsBtn = customStyled(Button$1)(templateObject_22$4 || (templateObject_22$4 = __makeTemplateObject$1(["\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  fill: ", ";\n  rect {\n    fill: ", ";\n  }\n\n  ", "\n"], ["\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  fill: ", ";\n  rect {\n    fill: ", ";\n  }\n\n  ",
    "\n"])), function (props) { return props.theme.colors.white; }, function (props) { return props.theme.colors.white; }, function (props) {
    return props.decrement
        ? "\n    &:not([disabled]) {\n      background-color: #ff5a57;\n    }\n\n    &:disabled path {\n      fill: " + props.theme.colors.white + ";\n    }\n  "
        : '';
});
FbtCartElementsBtn.defaultProps = {
    round: true,
    size: '30px',
    padding: 0,
};
var FbtQuantitySelect = customStyled(Select)(templateObject_23$3 || (templateObject_23$3 = __makeTemplateObject$1(["\n  width: auto;\n  margin: 0;\n\n &[disabled] {\n   cursor: not-allowed;\n   opacity: 0.5;\n   pointer-events: none;\n }\n\n  > div {\n    height: 30px;\n    margin: 0;\n    padding-bottom: 0;\n    padding-top: 0;\n\n    > div {\n      width: 82px;\n      justify-content: center;\n      font-weight: ", ";\n\n      > span {\n        font-size: 12px;\n        margin-right: ", "px;\n        width: auto;\n        text-align: center;\n      }\n    }\n  }\n"], ["\n  width: auto;\n  margin: 0;\n\n &[disabled] {\n   cursor: not-allowed;\n   opacity: 0.5;\n   pointer-events: none;\n }\n\n  > div {\n    height: 30px;\n    margin: 0;\n    padding-bottom: 0;\n    padding-top: 0;\n\n    > div {\n      width: 82px;\n      justify-content: center;\n      font-weight: ", ";\n\n      > span {\n        font-size: 12px;\n        margin-right: ", "px;\n        width: auto;\n        text-align: center;\n      }\n    }\n  }\n"])), function (props) { return props.theme.fontWeights[5]; }, function (props) { return props.theme.space[2]; });
var FbtErrorList = customStyled.ul(templateObject_24$2 || (templateObject_24$2 = __makeTemplateObject$1(["\n  list-style-type: ", ";\n  margin-left: ", ";\n\n  li {\n    color: ", ";\n    font-weight: ", ";\n\n    &:not(:first-of-type) {\n      margin-top: ", "px;\n    }\n  }\n"], ["\n  list-style-type: ", ";\n  margin-left: ", ";\n\n  li {\n    color: ", ";\n    font-weight: ", ";\n\n    &:not(:first-of-type) {\n      margin-top: ", "px;\n    }\n  }\n"])), function (props) { return (props.hasBullet ? 'disc' : 'none'); }, function (props) { return (props.hasBullet ? '16px' : 0); }, function (props) { return props.theme.colors.red; }, function (props) { return props.theme.fontWeights[5]; }, function (props) { return props.theme.space[1]; });
var RetryText = customStyled(Text)(templateObject_25$2 || (templateObject_25$2 = __makeTemplateObject$1(["\n  color: ", ";\n  cursor: pointer;\n  font-weight: ", ";\n  text-transform: capitalize;\n"], ["\n  color: ", ";\n  cursor: pointer;\n  font-weight: ", ";\n  text-transform: capitalize;\n"])), function (props) { return props.theme.colors.copy; }, function (props) { return props.theme.fontWeights[6]; });
var FbtMobileElements = customStyled.div(templateObject_26$2 || (templateObject_26$2 = __makeTemplateObject$1(["\n    font-size: ", "px;\n    font-weight: ", ";\n    width: auto;\n    text-align: center;\n"], ["\n    font-size: ", "px;\n    font-weight: ", ";\n    width: auto;\n    text-align: center;\n"])), function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.fontWeights[5]; });
var FbtTextSection = customStyled(Flex)(templateObject_27$2 || (templateObject_27$2 = __makeTemplateObject$1(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
var SponsoredText = customStyled.div(templateObject_28$1 || (templateObject_28$1 = __makeTemplateObject$1(["\n    font-weight: ", ";\n    margin-left:  ", "px;\n    border-radius: ", "px;\n    font-size: 13px;\n    color: #20B0E6;\n    padding: 4px 6px;\n    background: #EFF3F8;\n"], ["\n    font-weight: ", ";\n    margin-left:  ", "px;\n    border-radius: ", "px;\n    font-size: 13px;\n    color: #20B0E6;\n    padding: 4px 6px;\n    background: #EFF3F8;\n"])), function (props) { return props.theme.fontWeights[4]; }, function (props) { return props.theme.space[2]; }, function (props) { return props.theme.radii[1]; });
var templateObject_1$E, templateObject_2$w, templateObject_3$q, templateObject_4$n, templateObject_5$i, templateObject_6$e, templateObject_7$e, templateObject_8$e, templateObject_9$d, templateObject_10$d, templateObject_11$a, templateObject_12$9, templateObject_13$9, templateObject_14$9, templateObject_15$9, templateObject_16$6, templateObject_17$6, templateObject_18$5, templateObject_19$5, templateObject_20$4, templateObject_21$4, templateObject_22$4, templateObject_23$3, templateObject_24$2, templateObject_25$2, templateObject_26$2, templateObject_27$2, templateObject_28$1;
function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}
	return Object(val);
}
function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}
		var test1 = new String('abc');
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}
		return true;
	} catch (err) {
		return false;
	}
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;
	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);
		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}
		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}
	return to;
};
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;
var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {  }
  };
}
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes;
var printWarning$1 = function() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
var propTypes = createCommonjsModule(function (module) {
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  module.exports = factoryWithThrowingShims();
}
});
var rng = function nodeRNG() {
  return crypto.randomBytes(16);
};
var byteToHex = [];
for (var i$1 = 0; i$1 < 256; ++i$1) {
  byteToHex[i$1] = (i$1 + 0x100).toString(16).substr(1);
}
function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}
var bytesToUuid_1 = bytesToUuid;
var _nodeId;
var _clockseq;
var _lastMSecs = 0;
var _lastNSecs = 0;
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;
  msecs += 12219292800000;
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;
  b[i++] = tmh >>> 24 & 0xf | 0x10;
  b[i++] = tmh >>> 16 & 0xff;
  b[i++] = clockseq >>> 8 | 0x80;
  b[i++] = clockseq & 0xff;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }
  return buf ? buf : bytesToUuid_1(b);
}
var v1_1 = v1;
function v4(options, buf, offset) {
  var i = buf && offset || 0;
  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};
  var rnds = options.random || (options.rng || rng)();
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }
  return buf || bytesToUuid_1(rnds);
}
var v4_1 = v4;
var uuid = v4_1;
uuid.v1 = v1_1;
uuid.v4 = v4_1;
var uuid_1 = uuid;
var State_1 = createCommonjsModule(function (module, exports) {
exports.__esModule = true;
var _react2 = _interopRequireDefault(React);
var _propTypes2 = _interopRequireDefault(propTypes);
var _uuid2 = _interopRequireDefault(uuid_1);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var State = function (_Component) {
  _inherits(State, _Component);
  function State(props) {
    _classCallCheck(this, State);
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
    _this.stateStore = _this.props.store;
    _this.state = _this.stateStore.state;
    return _this;
  }
  State.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;
    this.subscription = this.stateStore.subscribe(function (state) {
      return _this2.setState(state);
    });
  };
  State.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stateStore.unSubscribe(this.subscription);
  };
  State.prototype.render = function render() {
    var state = this.props.parseState ? this.props.parseState(this.state) : this.state;
    if (!this.props.children) {
      throw new Error("Please add at least one child element.");
    }
    if (typeof this.props.children === "function") {
      return this.props.children(state);
    }
    if (Array.isArray(this.props.children)) {
      return this.props.children.map(function (child) {
        return (0, React.cloneElement)(child, state);
      });
    }
    return (0, React.cloneElement)(this.props.children, state);
  };
  return State;
}(React.Component);
exports.default = State;
});
unwrapExports(State_1);
var Store_1 = createCommonjsModule(function (module, exports) {
exports.__esModule = true;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
var _uuid2 = _interopRequireDefault(uuid_1);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var Store = function () {
  function Store(state) {
    _classCallCheck(this, Store);
    this.state = {};
    this.callbacks = [];
    this.state = _extends({}, state);
  }
  Store.prototype.set = function set(newState) {
    var _this = this;
    this.state = _extends({}, this.state, newState);
    this.callbacks.forEach(function (callback) {
      return callback.callback(_this.state);
    });
  };
  Store.prototype.get = function get(key) {
    if (key) {
      return this.state[key];
    }
    return this.state;
  };
  Store.prototype.subscribe = function subscribe(callback) {
    var subscription = (0, _uuid2.default)();
    this.callbacks.push({ subscription: subscription, callback: callback });
    return subscription;
  };
  Store.prototype.unSubscribe = function unSubscribe(subscription) {
    var _this2 = this;
    this.callbacks.forEach(function (callback, index) {
      if (callback.subscription === subscription) {
        _this2.callbacks.splice(index, 1);
      }
    });
  };
  return Store;
}();
exports.default = Store;
});
unwrapExports(Store_1);
var StateDecorator_1 = createCommonjsModule(function (module, exports) {
exports.__esModule = true;
var _react2 = _interopRequireDefault(React);
var _State2 = _interopRequireDefault(State_1);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var StateDecorator = function StateDecorator(store) {
  var parseState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
    return state;
  };
  return function (storyFn) {
    return _react2.default.createElement(
      _State2.default,
      { store: store, parseState: parseState },
      storyFn()
    );
  };
};
exports.default = StateDecorator;
});
unwrapExports(StateDecorator_1);
var dist = createCommonjsModule(function (module, exports) {
exports.__esModule = true;
exports.StateDecorator = exports.Store = exports.State = undefined;
var _State3 = _interopRequireDefault(State_1);
var _Store3 = _interopRequireDefault(Store_1);
var _StateDecorator3 = _interopRequireDefault(StateDecorator_1);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.State = _State3.default;
exports.Store = _Store3.default;
exports.StateDecorator = _StateDecorator3.default;
});
unwrapExports(dist);
var dist_1 = dist.StateDecorator;
var dist_2 = dist.Store;
var dist_3 = dist.State;
var initialState$1 = {
    quantity: 1,
    max: 1000,
    min: 1,
    loading: false,
    inCart: false,
    delta: 1,
};
var store = new dist_2(initialState$1);
var useProductList = function (isRelevanceCarousel, gaListName) {
    if (isRelevanceCarousel === void 0) { isRelevanceCarousel = true; }
    var dispatch = useDispatch();
    var miniCartSelector = function (state) { return state.miniCart; };
    var productListSelector = function (state) { return state.productList; };
    var selectMiniCartEntries = createSelector(miniCartSelector, function (miniCart) {
        return miniCart.entries;
    });
    var selectProductList = createSelector(productListSelector, function (productList) { return productList; });
    var _a = __read$1(useState(''), 2), openQty = _a[0], setOpenQty = _a[1];
    var cartEntries = useSelector(selectMiniCartEntries) || {};
    var productList = useSelector(selectProductList);
    var appConfig = useSelector(function (state) { return state.appConfig; });
    var closeAllQty = useCallback(function () {
        if (openQty !== '') {
            setOpenQty('');
        }
    }, [openQty]);
    var _b = useAnalytic(), GTMEventCall = _b.GTMEventCall, EventCall = _b.EventCall, BrazeSetCustomUserAttribute = _b.BrazeSetCustomUserAttribute, BrazeEventCall = _b.BrazeEventCall;
    var gtmCallBack = useCallback(function (quantity, eventType, productId, position, product) {
        var selectedProduct = productList.products.find(function (product) { return product.productId === productId; }) || product;
        if (selectedProduct && isObject(selectedProduct) && !(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.gaListName)) {
            selectedProduct.gaListName = gaListName;
        }
        switch (eventType) {
            case eventTypeEnum.add_to_cart:
                GTMEventCall(GTMEvents.add_to_cart, { product: selectedProduct, quantity: quantity, position: position });
                EventCall(GTMEvents.add_to_cart, selectedProduct);
                break;
            case eventTypeEnum.remove_from_cart:
                GTMEventCall(GTMEvents.remove_from_cart, { product: selectedProduct, position: position });
                break;
        }
    }, [GTMEventCall, EventCall, productList.products, gaListName]);
    useEffect(function () {
        document.addEventListener('click', closeAllQty, false);
        return function () {
            document.removeEventListener('click', closeAllQty, false);
        };
    }, [closeAllQty]);
    var onSelectHandler = useCallback(function (productId) { return function (state) {
        if (state) {
            setOpenQty(productId);
        }
    }; }, []);
    var brazeAddToCartCB = useCallback(function (totalUnitCount, product) {
        var _a;
        var _b;
        if (!((_b = appConfig === null || appConfig === void 0 ? void 0 : appConfig.userCredentials) === null || _b === void 0 ? void 0 : _b.userId) && !(appConfig === null || appConfig === void 0 ? void 0 : appConfig.brazeInitialized)) {
            var storage = initStorageManager(function () { return localStorage; });
            var data = storage.getItem('initBrazeAnonymousUserWithData') || [];
            data.push(product);
            storage.setItem('initBrazeAnonymousUserWithData', data);
        }
        else {
            BrazeEventCall(BrazeEvents.add_to_cart, product);
            if (totalUnitCount === 1)
                BrazeSetCustomUserAttribute((_a = {}, _a[BrazeEvents.cart_count] = true, _a));
        }
    }, [BrazeEventCall, BrazeSetCustomUserAttribute, appConfig]);
    var selectOnChange = useCallback(function (product, inCart, quantity, position, intent) { return function (_a) {
        var value = _a.value;
        if (quantity !== value) {
            var productId_1 = product.productId, _b = product.isMarketPlace, isMarketPlace = _b === void 0 ? false : _b, _c = product.offers, offers = _c === void 0 ? [] : _c, _d = product.incrementBy, incrementBy = _d === void 0 ? 1 : _d;
            var offerId = offers.length > 0 ? offers[0].id : undefined;
            var shippingIndicator = offers[0].shippingIndicator || '';
            if (!inCart) {
                dispatch(addToCart(productId_1, value, {
                    gtmCallBack: function () {
                        return gtmCallBack(quantity, value > quantity ? eventTypeEnum.add_to_cart : eventTypeEnum.remove_from_cart, productId_1, position, product);
                    },
                    isMarketPlace: isMarketPlace,
                    shippingIndicator: shippingIndicator,
                    withRelevantProducts: isRelevanceCarousel,
                    offerId: offerId,
                    brazeAddToCartCB: function (totalUnitCount) {
                        return brazeAddToCartCB(totalUnitCount, product);
                    },
                    intent: intent,
                    displayPrice: product.displayPrice,
                }));
            }
            else {
                dispatch(updateCart(productId_1, value, {
                    intent: intent,
                    shippingIndicator: shippingIndicator,
                    currentQuantity: quantity,
                    incrementBy: incrementBy,
                    offerId: offerId,
                }));
            }
        }
        else {
            setOpenQty('');
        }
    }; }, [brazeAddToCartCB, dispatch, gtmCallBack, isRelevanceCarousel]);
    return [cartEntries, productList, openQty, onSelectHandler, selectOnChange];
};
var ProductListWrapper = customStyled(Flex)(templateObject_1$F || (templateObject_1$F = __makeTemplateObject$1(["\n  flex: 1 auto;\n  flex-flow: column wrap;\n  justify-content: space-between;\n  margin: 6px -6px;\n\n  &:after {\n    content: '';\n    flex: auto;\n  }\n"], ["\n  flex: 1 auto;\n  flex-flow: column wrap;\n  justify-content: space-between;\n  margin: 6px -6px;\n\n  &:after {\n    content: '';\n    flex: auto;\n  }\n"])));
var ProductListItemWrapper = customStyled(Flex)(templateObject_2$x || (templateObject_2$x = __makeTemplateObject$1(["\n  > div {\n    width: 100%;\n  }\n  margin: 6px;\n  width: ", ";\n  ", "\n  > ul {\n    width: 100%;\n  }\n  @media (min-width: ", ") {\n    display: block;\n    width: calc(", "% - 12px);\n  }\n  @media (min-width: ", ") {\n    width: calc(", "% - 12px);\n  }\n"], ["\n  > div {\n    width: 100%;\n  }\n  margin: 6px;\n  width: ", ";\n  ",
    "\n  > ul {\n    width: 100%;\n  }\n  @media (min-width: ", ") {\n    display: block;\n    width: calc(", "% - 12px);\n  }\n  @media (min-width: ", ") {\n    width: calc(", "% - 12px);\n  }\n"])), function (props) { return (props.variant === 'list' ? '100%' : "calc(" + 100 / props.offsets[2] + "% - 12px)"); }, function (props) {
    return props.variant === 'list' &&
        "\n    display: block;\n    margin: 0;\n    margin-bottom: 6px;\n  ";
}, function (props) { return props.theme.breakpoints[1]; }, function (props) { return 100 / props.offsets[1]; }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return 100 / props.offsets[0]; });
var ProductListCarouselWrapper = customStyled(animated.div)(templateObject_3$r || (templateObject_3$r = __makeTemplateObject$1(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var templateObject_1$F, templateObject_2$x, templateObject_3$r;
var ProductCardCarouselWrapper = customStyled(Flex)(templateObject_1$G || (templateObject_1$G = __makeTemplateObject$1(["\n    flex-direction: column;\n    width: 100%;\n    font-family: ", ";\n    @media screen and (max-width: 576px) {\n      .is-open {\n        will-change: unset;\n        transform: none !important;\n      }\n    }\n"], ["\n    flex-direction: column;\n    width: 100%;\n    font-family: ", ";\n    @media screen and (max-width: 576px) {\n      .is-open {\n        will-change: unset;\n        transform: none !important;\n      }\n    }\n"])), function (props) { return (props.isCart ? ' Montserrat' : 'default'); });
var ProductCardCarouselHeader = customStyled.div(templateObject_2$y || (templateObject_2$y = __makeTemplateObject$1(["\n    font-size: ", "px;\n    font-weight: ", ";\n    margin-bottom: ", "px;\n    text-transform: capitalize;\n"], ["\n    font-size: ", "px;\n    font-weight: ", ";\n    margin-bottom: ",
    "px;\n    text-transform: capitalize;\n"])), function (props) { return props.theme.fontSizes[3]; }, function (props) { return props.theme.fontWeights[5]; }, function (props) {
    return props.variant === EProductCardVariants.REGULAR || props.variant === EProductCardVariants.REGULAR_WIDE
        ? props.theme.space[3]
        : props.theme.space[2];
});
var Slide = customStyled.div(templateObject_3$s || (templateObject_3$s = __makeTemplateObject$1(["\n    box-sizing: border-box;\n    flex: 0 0 auto;\n    position: relative;\n    // padding: ", "px\n    > ul {\n        width: 100%;\n    }\n    ", "\n"], ["\n    box-sizing: border-box;\n    flex: 0 0 auto;\n    position: relative;\n    // padding: ", "px\n    > ul {\n        width: 100%;\n    }\n    ",
    "\n"])), function (props) { return (props.isCart || props.isSponsoredListing ? '0' : '4'); }, function (props) {
    return variant({
        variants: {
            regular: {
                width: 178,
            },
            regular_wide: {
                marginRight: '8px',
            },
            mini: {
                width: 148,
            },
            simple: {
                width: [props.isSponsoredListing ? 206 : props.isCart ? 95 : 130, null, props.isCart ? 95 : 240],
            },
        },
    });
});
var templateObject_1$G, templateObject_2$y, templateObject_3$s;
var setEmptyList = function (key) { return ({
    type: EProductCardCarouselTypes$1.SET_PRODUCTS,
    payload: { key: key, products: [{ productCards: [] }] },
}); };
var setProducts$1 = function (key, products) { return ({
    type: EProductCardCarouselTypes$1.SET_PRODUCTS,
    payload: { key: key, products: products },
}); };
var getProductsByIds = function (ids, listName, recommendedProducts, isManualV2Enabled, productsFilterPayload) {
    if (ids === void 0) { ids = []; }
    if (recommendedProducts === void 0) { recommendedProducts = []; }
    if (isManualV2Enabled === void 0) { isManualV2Enabled = false; }
    if (productsFilterPayload === void 0) { productsFilterPayload = []; }
    return function (dispatch) { return __awaiter$1(void 0, void 0, void 0, function () {
        var productCards;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: EProductCardCarouselTypes$1.GET_PRODUCTS, payload: listName });
                    if (!(isManualV2Enabled && productsFilterPayload.length)) return [3 , 2];
                    return [4 , ProductServices$1.getProductCardsByFilters(productsFilterPayload, recommendedProducts)];
                case 1:
                    productCards = _a.sent();
                    return [3 , 4];
                case 2: return [4 , ProductServices$1.getProductCardsByIdV2(ids, recommendedProducts)];
                case 3:
                    productCards = _a.sent();
                    _a.label = 4;
                case 4:
                    if (productCards) {
                        dispatch(setProducts$1(listName, [{ productCards: productCards }]));
                    }
                    else {
                        dispatch(setEmptyList(listName));
                    }
                    return [2 ];
            }
        });
    }); };
};
var Skeleton = customStyled(Box)(templateObject_1$H || (templateObject_1$H = __makeTemplateObject$1([""], [""])));
Skeleton.defaultProps = {
    variant: 'skeletonSquare',
};
var SkeletonBox = customStyled(Box)(templateObject_2$z || (templateObject_2$z = __makeTemplateObject$1(["\n  flex-shrink: 0;\n\n  ", "\n"], ["\n  flex-shrink: 0;\n\n  ", "\n"])), margin);
SkeletonBox.defaultProps = {
    variant: 'skeletonBoxSquare',
};
var SkeletonAction = customStyled(SkeletonBox)(templateObject_3$t || (templateObject_3$t = __makeTemplateObject$1(["\n  border-width: 1px 0 0;\n"], ["\n  border-width: 1px 0 0;\n"])));
var templateObject_1$H, templateObject_2$z, templateObject_3$t;
var ProductCardLoader = function (_a) {
    var _b = _a.mr, mr = _b === void 0 ? 2 : _b, _c = _a.width, width = _c === void 0 ? ['155px', null, '182px'] : _c, _d = _a.variant, variant = _d === void 0 ? 'regular' : _d, rest = __rest$1(_a, ["mr", "width", "variant"]);
    return (React.createElement(SkeletonBox, __assign$1({ mr: mr, px: "12px", pt: "32px", width: width }, rest),
        React.createElement(Skeleton, { height: variant === EProductCardVariants.REGULAR || variant === EProductCardVariants.REGULAR_WIDE ? 156 : 122 }),
        React.createElement(Box, { height: variant === EProductCardVariants.REGULAR || variant === EProductCardVariants.REGULAR_WIDE ? 87 : 43, mt: 2 },
            React.createElement(Skeleton, { height: 12 }),
            React.createElement(Skeleton, { height: 12, mt: "5px", width: "80%" })),
        React.createElement(Skeleton, { height: 16, width: 74 }),
        React.createElement(SkeletonAction, { display: "flex", alignItems: "center", justifyContent: "space-between", m: (variant === EProductCardVariants.REGULAR || variant === EProductCardVariants.REGULAR_WIDE ? '32px' : '22px') + " -12px 0", p: 2 },
            React.createElement(Skeleton, { height: 12, width: "48%" }),
            React.createElement(Skeleton, { height: 32, width: 64 }))));
};
var ProductCardCarouselLoader = function (_a) {
    var _b = _a.numOfProduct, numOfProduct = _b === void 0 ? 3 : _b, JSXTitle = _a.JSXTitle, _c = _a.variant, variant = _c === void 0 ? 'regular' : _c;
    return (React.createElement(React.Fragment, null,
        JSXTitle && JSXTitle,
        React.createElement(Flex, { overflow: "hidden" }, __spread$1(Array(numOfProduct).keys()).map(function (i) { return (React.createElement(ProductCardLoader, { key: i, width: variant === EProductCardVariants.REGULAR || variant === EProductCardVariants.REGULAR_WIDE ? 194 : 144, mr: "5px", variant: variant })); }))));
};
var UPPER_LIMIT = 7;
var LOWER_LIMIT = 6;
var selectProductCarousel = createSelector(function (state) { return state.productCardCarousel; }, function (productCardCarousel) { return productCardCarousel; });
var ProductCardCarousel = function (_a) {
    var _b;
    var productsFromProps = _a.products, productIds = _a.productIds, productsFilterPayload = _a.productsFilterPayload, listName = _a.listName, _c = _a.gaListName, gaListName = _c === void 0 ? '' : _c, _d = _a.variant, variant = _d === void 0 ? EProductCardVariants.REGULAR : _d, _e = _a.title, title = _e === void 0 ? '' : _e, JSXTitle = _a.JSXTitle, _f = _a.containerStyleProps, containerStyleProps = _f === void 0 ? {} : _f, _g = _a.carouselOptions, carouselOptions = _g === void 0 ? {
        hideNavMaxWidth: 768,
    } : _g, _h = _a.withLoader, withLoader = _h === void 0 ? true : _h, _j = _a.isRelevantCarousel, isRelevantCarousel = _j === void 0 ? true : _j, _k = _a.recommendedProducts, recommendedProducts = _k === void 0 ? [] : _k, onSuccessCb = _a.onSuccessCb, onFailureCb = _a.onFailureCb, isSponsoredListing = _a.isSponsoredListing, isCart = _a.isCart;
    var _l = __read$1(useProductList(isRelevantCarousel, gaListName), 5), cartEntries = _l[0], productList = _l[1], openQty = _l[2], onSelectHandler = _l[3], selectOnChange = _l[4];
    var dispatch = useDispatch();
    var _m = __read$1(useAppConfig(), 1), _o = _m[0], areaCode = _o.areaCode, gtmInitialized = _o.gtmInitialized;
    var isManualV2Enabled = ((_b = useFeature('home.manual_carousel_v2.enabled')) === null || _b === void 0 ? void 0 : _b.on) || false;
    var getProducts = useRef(function () {
        if ((productIds || productsFilterPayload) && !productsFromProps) {
            dispatch(getProductsByIds(productIds, listName, recommendedProducts, isManualV2Enabled, productsFilterPayload));
        }
    });
    useEffect(function () {
        if (areaCode && gtmInitialized) {
            getProducts.current();
        }
    }, [areaCode, gtmInitialized]);
    var strategy = useSelector(selectProductCarousel).strategy;
    var _p = __read$1(useMemo(function () {
        if (productsFromProps) {
            return [productsFromProps, false];
        }
        else {
            var _a = strategy[listName] || {}, data = _a.data, isLoadingProp = _a.isLoading;
            if (!isLoadingProp) {
                var productData = data ? data[0].productCards : [];
                return [productData, false];
            }
            return [[], isLoadingProp];
        }
    }, [productsFromProps, strategy, listName]), 2), products = _p[0], isLoading = _p[1];
    var availableProducts = useMemo(function () {
        return products.filter(function (productCard) { return productCard.isAvailable; });
    }, [products]);
    var limit = useMemo(function () {
        switch (variant) {
            case EProductCardVariants.REGULAR || EProductCardVariants.REGULAR_WIDE:
                return !isSponsoredListing ? UPPER_LIMIT : 5;
            case EProductCardVariants.MINI:
                return LOWER_LIMIT;
            default:
                return availableProducts.length;
        }
    }, [availableProducts.length, variant, isSponsoredListing]);
    var isVisible = availableProducts.length > 0 && availableProducts.length >= limit;
    var _q = __read$1(useState(__assign$1({ arrows: variant, rtl: isRTL() }, carouselOptions)), 2), carouselProp = _q[0], setCarouselProp = _q[1];
    var onLanguageChanged = useCallback(function () {
        setCarouselProp(__assign$1(__assign$1({}, carouselProp), { rtl: isRTL() }));
    }, [carouselProp]);
    var renderTitle = useCallback(function () {
        return title ? (React.createElement(ProductCardCarouselHeader, { variant: variant }, title)) : JSXTitle ? (JSXTitle) : null;
    }, [JSXTitle, title, variant]);
    useEffect(function () {
        i18next.on('languageChanged', onLanguageChanged);
        return function () {
            i18next.off('languageChanged', onLanguageChanged);
        };
    }, [carouselProp, onLanguageChanged]);
    if (isLoading && withLoader) {
        return (React.createElement(Flex, __assign$1({}, containerStyleProps, { flexDirection: "column" }),
            renderTitle(),
            React.createElement(ProductCardCarouselLoader, { variant: variant })));
    }
    var MAIN_OFFER_TYPE = 'main';
    return isVisible ? (
    React.createElement(ProductCardCarouselWrapper, __assign$1({}, containerStyleProps, { isCart: isCart }),
        renderTitle(),
        React.createElement(Carousel, __assign$1({}, carouselProp, { isNewButton: true, className: openQty ? 'is-open' : '' }), availableProducts.map(function (product, index) {
            var _a = product.offers, offers = _a === void 0 ? [] : _a;
            var applicableOffer = offers.find(function (offer) { return offer.type === MAIN_OFFER_TYPE; }) || {
                id: '',
                shippingIndicator: '',
            };
            var offerId = applicableOffer.id;
            var shippingIndicator = applicableOffer.shippingIndicator || '';
            offerId = offerId && !offerId.includes('offer') ? "offer_" + offerId : offerId;
            var uniqueEntryId = getUniqueEntryId(product.productId, offerId, shippingIndicator);
            var cartEntry = cartEntries[uniqueEntryId];
            var inCart = !!cartEntry;
            var quantity = 0;
            var intent;
            if (inCart) {
                quantity = cartEntry.quantity;
                intent = cartEntry.intent;
            }
            return (React.createElement(Slide, { key: product.productId + "-" + index, variant: variant, isCart: isCart, isSponsoredListing: isSponsoredListing },
                React.createElement(ProductCard$1, __assign$1({ "data-testid": "product-card" }, product, { disabled: productList.disabled, inCart: inCart, isOpen: openQty === product.productId, listName: listName, gaListName: isSponsoredListing && isCart ? gaListName : gaListName.toLowerCase(), onSelectHandler: onSelectHandler(product.productId), position: index + 1, quantity: quantity, selectOnChange: selectOnChange(product, inCart, quantity, index + 1, intent), variant: variant, onSuccessCb: onSuccessCb, onFailureCb: onFailureCb, isSponsoredListing: isSponsoredListing, isCart: isCart, intent: intent, productId: product.productId, carousel: true }))));
        })))) :
        null;
};
var ProductCardCarousel$1 = memo(ProductCardCarousel);
var Section = customStyled(Box)(templateObject_1$I || (templateObject_1$I = __makeTemplateObject$1(["\n  [data-testid='carousel-container'] > div {\n    padding: 0;\n  }\n\n  @media screen and (max-width: ", ") {\n    [data-testid='carousel-container'] > div {\n      padding: 4px;\n      width: 168px;\n    }\n\n  ", "\n\n  [data-testid='prev-button'],\n  [data-testid='next-button'] {\n    border-color: ", ";\n    cursor: pointer;\n\n    svg > path:first-of-type {\n      stroke: ", ";\n    }\n\n    :disabled {\n      display: none;\n    }\n  }\n"], ["\n  [data-testid='carousel-container'] > div {\n    padding: 0;\n  }\n\n  @media screen and (max-width: ", ") {\n    [data-testid='carousel-container'] > div {\n      padding: 4px;\n      width: 168px;\n    }\n\n  ",
    "\n\n  [data-testid='prev-button'],\n  [data-testid='next-button'] {\n    border-color: ", ";\n    cursor: pointer;\n\n    svg > path:first-of-type {\n      stroke: ", ";\n    }\n\n    :disabled {\n      display: none;\n    }\n  }\n"])), function (props) { return props.theme.breakpoints[1]; }, function (props) {
    return props.isNewHomePage &&
        "[data-testid='relevant-product-carousel'] > div {\n      margin-bottom: 12px;\n      > p {\n        font-size: 24px;\n        font-family: Teshrin AR LT;\n        font-weight: 700;\n        color: #2d2d2d;\n      }\n\n      @media (max-width: 768px) {\n        > p {\n          font-size: 16px;\n        }\n      }\n    }\n  ";
}, function (props) { return props.theme.colors.silverChalice; }, function (props) { return props.theme.colors.silverChalice; });
Section.defaultProps = {
    as: 'section',
    sx: {
        "[data-testid='prev-button'], [data-testid='next-button']": {
            display: ['none', null, null, null, 'block'],
        },
    },
    mx: [3, 4, null, '40px', 0],
    mt: [4, null, null, 5],
};
var SponsoredProductsTitle = customStyled(Box)(templateObject_2$A || (templateObject_2$A = __makeTemplateObject$1(["\n  color: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  font-size: ", "px;\n  margin: 8px;\n  @media (min-width: ", ") {\n    font-size: ", "px;\n    margin: 12px;\n    margin-left: 0;\n  }\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  font-size: ", "px;\n  margin: 8px;\n  @media (min-width: ", ") {\n    font-size: ", "px;\n    margin: 12px;\n    margin-left: 0;\n  }\n"])), COLORS.BLACK, function (props) { return props.theme.fontWeights[4]; }, function (props) { return (props.isRTL ? 'Noto Kufi Arabic' : props.theme.fonts.montserrat); }, function (props) { return props.theme.fontSizes[0]; }, function (props) { return props.theme.breakpoints[0]; }, function (props) { return props.theme.fontSizes[1]; });
var templateObject_1$I, templateObject_2$A;
var SponsoredCarousel = function (props) {
    var _a = props.header, header = _a === void 0 ? '' : _a, _b = props.placementId, placementId = _b === void 0 ? '' : _b, _c = props.page, page = _c === void 0 ? constants.home : _c;
    var _d = __read$1(useState([]), 2), productCards = _d[0], setProductCards = _d[1];
    var _e = __read$1(useInView({
        threshold: 0,
        triggerOnce: true,
    }), 2), ref = _e[0], inView = _e[1];
    var products = useSelector(function (state) {
        var _a, _b;
        return ((_b = (_a = state === null || state === void 0 ? void 0 : state.adtech) === null || _a === void 0 ? void 0 : _a.criteoCarousels) === null || _b === void 0 ? void 0 : _b[placementId]) || [];
    });
    useEffect(function () {
        if (inView) {
            var productCards_1 = new ProductTransformerV2(products).getProductCards();
            setProductCards(productCards_1);
        }
    }, [inView, products]);
    return products.length < UPPER_LIMIT ? null : (React.createElement(Section, { ref: ref }, inView ? (React.createElement(ProductCardCarousel$1, { carouselOptions: {
            arrows: 'solid',
        }, listName: "sponsored_carousel_pc|" + page, gaListName: "sponsored_carousel_pc|" + page, JSXTitle: React.createElement(SponsoredProductsTitle, { isRTL: isRTL() },
            " ",
            header,
            " "), products: __spread$1(productCards), isSponsoredListing: true, variant: "regular" })) : (React.createElement(ProductCardCarouselLoader, null))));
};
var index$1$1 = memo(SponsoredCarousel);
var useUser = function () {
    var firstName = useSelector(function (_a) {
        var userData = _a.userData;
        return userData;
    }).firstName;
    var isLoggedIn = isExisty(firstName);
    return [isLoggedIn];
};
var CarouselHeading = customStyled(Flex)(templateObject_1$J || (templateObject_1$J = __makeTemplateObject$1(["\n  align-items: center;\n  font-weight: normal;\n  justify-content: space-between;\n  line-height: 1.75em;\n  ", ";\n\n  a {\n    align-items: center;\n    color: ", ";\n    display: flex;\n    font-weight: ", ";\n    text-decoration: none;\n\n    svg {\n      height: 12px;\n      margin-left: ", "px;\n      width: 12px;\n    }\n  }\n"], ["\n  align-items: center;\n  font-weight: normal;\n  justify-content: space-between;\n  line-height: 1.75em;\n  ", ";\n\n  a {\n    align-items: center;\n    color: ", ";\n    display: flex;\n    font-weight: ", ";\n    text-decoration: none;\n\n    svg {\n      height: 12px;\n      margin-left: ", "px;\n      width: 12px;\n    }\n  }\n"])), space, function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.fontWeights[4]; }, function (props) { return props.theme.space[2]; });
var CarouselCapsulesWrapper = customStyled(Flex)(templateObject_2$B || (templateObject_2$B = __makeTemplateObject$1(["\n    font-size: ", "px;\n    margin-bottom: 8px;\n    overflow: auto;\n\n    > div {\n      white-space: nowrap;\n      min-width: auto;\n    }\n    > div:not(:first-of-type) {\n      margin-left: ", "px;\n    }\n"], ["\n    font-size: ", "px;\n    margin-bottom: 8px;\n    overflow: auto;\n\n    > div {\n      white-space: nowrap;\n      min-width: auto;\n    }\n    > div:not(:first-of-type) {\n      margin-left: ", "px;\n    }\n"])), function (_a) {
    var isMobile = _a.isMobile, theme = _a.theme;
    return (isMobile ? theme.fontSizes[1] : theme.fontSizes[2]);
}, function (props) { return props.theme.space[2]; });
var templateObject_1$J, templateObject_2$B;
var BUY_AGAIN_STRATEGY = 'DSW_FPP_6';
var useRelevantCarousel = function (_a) {
    var _b = _a.isLazy, isLazy = _b === void 0 ? false : _b, keyword = _a.keyword, productId = _a.productId, _c = _a.placements, placements = _c === void 0 ? '' : _c, _d = _a.testId, testId = _d === void 0 ? 'relevant-product-carousel' : _d, _e = _a.variant, variant = _e === void 0 ? 'regular' : _e, _f = _a.asCard, asCard = _f === void 0 ? false : _f, _g = _a.carouselOptions, carouselOptions = _g === void 0 ? {} : _g, _h = _a.headingStyles, headingStyles = _h === void 0 ? { mb: 20 } : _h, _j = _a.titleStyles, titleStyles = _j === void 0 ? {} : _j, JSXHeader = _a.JSXHeader, _k = _a.isNonFoodV1Header, isNonFoodV1Header = _k === void 0 ? false : _k, _l = _a.withLoader, withLoader = _l === void 0 ? true : _l, animateHeight = _a.animateHeight, onSuccessCb = _a.onSuccessCb, onFailureCb = _a.onFailureCb, isCart = _a.isCart, gaListName = _a.gaListName;
    var _m = __read$1(useAppConfig(), 4), requestStatus = _m[3];
    var decodedPlacements = decodeURIComponent(placements).split('|');
    var _o = __read$1(useState(), 2), placementsArr = _o[0], setPlacementsArr = _o[1];
    useEffect(function () {
        if (!placements)
            return;
        (function () { return __awaiter$1(void 0, void 0, void 0, function () {
            var placementsArrData;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 , ProductServices$1.getRelevance(productId ? { id: productId, placements: placements } : { keyword: keyword, placements: placements })];
                    case 1:
                        placementsArrData = _a.sent();
                        setPlacementsArr(placementsArrData);
                        return [2 ];
                }
            });
        }); })();
    }, [keyword, placements, productId]);
    return useMemo(function () {
        if (!placements || requestStatus.failed)
            return [null];
        return getCarousels({
            isLazy: isLazy,
            decodedPlacements: decodedPlacements,
            placementsArr: placementsArr,
            testId: testId,
            variant: variant,
            isNonFoodV1Header: isNonFoodV1Header,
            asCard: asCard,
            carouselOptions: carouselOptions,
            headingStyles: headingStyles,
            titleStyles: titleStyles,
            JSXHeader: JSXHeader,
            withLoader: withLoader,
            animateHeight: animateHeight,
            onFailureCb: onFailureCb,
            onSuccessCb: onSuccessCb,
            isCart: isCart,
            gaListName: gaListName,
        });
    }, [
        placements,
        requestStatus.failed,
        isLazy,
        isNonFoodV1Header,
        decodedPlacements,
        placementsArr,
        testId,
        variant,
        asCard,
        carouselOptions,
        headingStyles,
        titleStyles,
        JSXHeader,
        withLoader,
        animateHeight,
        onFailureCb,
        onSuccessCb,
        isCart,
        gaListName,
    ]);
};
var getCarousels = function (_a) {
    var isLazy = _a.isLazy, decodedPlacements = _a.decodedPlacements, placementsArr = _a.placementsArr, testId = _a.testId, variant = _a.variant, asCard = _a.asCard, carouselOptions = _a.carouselOptions, isNonFoodV1Header = _a.isNonFoodV1Header, headingStyles = _a.headingStyles, titleStyles = _a.titleStyles, JSXHeader = _a.JSXHeader, withLoader = _a.withLoader, animateHeight = _a.animateHeight, onSuccessCb = _a.onSuccessCb, onFailureCb = _a.onFailureCb, isCart = _a.isCart, gaListName = _a.gaListName;
    if (!placementsArr) {
        return withLoader ? [getLoadingCarousels(decodedPlacements, JSXHeader), true] : [null, false];
    }
    else if (placementsArr.length) {
        return [
            placementsArr.reduce(function (obj, _a, i) {
                var _b;
                var recommendedProducts = _a.recommendedProducts, strategyName = _a.strategyName, strategyMessage = _a.strategyMessage;
                var isBuyAgain = strategyName === BUY_AGAIN_STRATEGY;
                var listMessage = strategyMessage.split(' ').join('_').toLowerCase() || '';
                var listName = listMessage;
                return __assign$1(__assign$1({}, obj), (_b = {}, _b[placementsArr[i].placement] = (React.createElement(CarouselProvider, { isBuyAgain: isBuyAgain, listName: strategyMessage, gaListName: gaListName || listName, testId: testId, isNonFoodV1Header: isNonFoodV1Header, asCard: asCard, headingStyles: headingStyles, titleStyles: titleStyles, JSXHeader: JSXHeader, key: listName + "-" + i }, isLazy ? (React.createElement(LazyCarousel, { products: recommendedProducts, gaListName: gaListName || listName, listName: strategyMessage, variant: variant, JSXHeader: JSXHeader, withLoader: withLoader, animateHeight: animateHeight, recommendedProducts: recommendedProducts, onSuccessCb: onSuccessCb, onFailureCb: onFailureCb, isCart: isCart })) : (React.createElement(NonLazyCarousel, { products: recommendedProducts, carouselOptions: carouselOptions, listName: strategyMessage, variant: variant, gaListName: gaListName || listName, withLoader: withLoader, animateHeight: animateHeight, recommendedProducts: recommendedProducts, onSuccessCb: onSuccessCb, onFailureCb: onFailureCb, isCart: isCart })))), _b));
            }, {}),
        ];
    }
    return [null];
};
var CarouselContext = createContext({});
var CarouselProvider = function (_a) {
    var isBuyAgain = _a.isBuyAgain, listName = _a.listName, testId = _a.testId, asCard = _a.asCard, headingStyles = _a.headingStyles, titleStyles = _a.titleStyles, isNonFoodV1Header = _a.isNonFoodV1Header, JSXHeader = _a.JSXHeader, rest = __rest$1(_a, ["isBuyAgain", "listName", "testId", "asCard", "headingStyles", "titleStyles", "isNonFoodV1Header", "JSXHeader"]);
    var theme = useTheme();
    var t = useTranslation().t;
    var _b = __read$1(useUser(), 1), isLoggedIn = _b[0];
    var _c = __read$1(useAppConfig(), 5), setAppContext = _c[4];
    var buyAgainLink = setAppContext('/buyAgain');
    var seeMoreText = capitalizeFirstLetter(t('seeMore').toLowerCase());
    var value = useMemo(function () { return ({
        containerProps: {
            containerStyleProps: __assign$1({ 'data-testid': testId }, (asCard
                ? {
                    backgroundColor: theme.colors.white,
                    px: 3,
                    py: 2,
                    mx: '6px',
                    sx: {
                        boxShadow: theme.elevation(1),
                    },
                }
                : {})),
        },
        renderTitle: function () {
            if (listName && !isNonFoodV1Header) {
                if (JSXHeader) {
                    return (React.createElement(JSXHeader
                    , {
                        seeMoreLink: isBuyAgain ? buyAgainLink : '', seeMoreText: seeMoreText }, listName));
                }
                else {
                    var Icon = isRTL() ? ArrowLeft : RightArrow$2;
                    return (React.createElement(CarouselHeading, __assign$1({}, headingStyles),
                        listName && (React.createElement(Text, __assign$1({ fontSize: "1.25em" }, titleStyles), listName)),
                        isBuyAgain && (React.createElement("a", { href: buyAgainLink, "data-testid": "see-more-link" },
                            seeMoreText,
                            React.createElement(Icon, { fill: theme.colors.blue })))));
                }
            }
            return null;
        },
    }); }, [
        testId,
        asCard,
        theme,
        listName,
        isNonFoodV1Header,
        JSXHeader,
        isBuyAgain,
        buyAgainLink,
        seeMoreText,
        headingStyles,
        titleStyles,
    ]);
    if (isBuyAgain && !isLoggedIn)
        return null;
    return React.createElement(CarouselContext.Provider, __assign$1({ value: value }, rest));
};
var useCarouselContext = function () { return useContext(CarouselContext); };
var LazyCarousel = function (_a) {
    var JSXHeader = _a.JSXHeader, rest = __rest$1(_a, ["JSXHeader"]);
    var _b = useCarouselContext(), containerProps = _b.containerProps, renderTitle = _b.renderTitle;
    var _c = useInView$2({
        unobserveOnEnter: true,
        rootMargin: '300px 0px',
    }), ref = _c.ref, inView = _c.inView;
    return (React.createElement("div", { "data-testid": "lazy-relevant-carousel", ref: ref }, inView ? (React.createElement(ProductCardCarousel$1, __assign$1({}, containerProps, rest, { JSXTitle: renderTitle(), isRelevantCarousel: false }))) : (React.createElement(ProductCardCarouselLoader, { JSXTitle: JSXHeader ? React.createElement(JSXHeader, null, "\u00A0") : null }))));
};
var NonLazyCarousel = function (_a) {
    var rest = __rest$1(_a, []);
    var _b = useCarouselContext(), containerProps = _b.containerProps, renderTitle = _b.renderTitle;
    return React.createElement(ProductCardCarousel$1, __assign$1({}, containerProps, rest, { JSXTitle: renderTitle(), isRelevantCarousel: false }));
};
var getLoadingCarousels = function (decodedPlacements, JSXHeader) {
    return decodedPlacements.reduce(function (obj, key) {
        var _a;
        return (__assign$1(__assign$1({}, obj), (_a = {}, _a[key] = React.createElement(ProductCardCarouselLoader, { JSXTitle: JSXHeader ? React.createElement(JSXHeader, null, "\u00A0") : null }), _a)));
    }, {});
};
var RelevantProductCarousel = function (props) {
    var _a = __read$1(useRelevantCarousel(props), 2), carousels = _a[0], isLoading = _a[1];
    var theme = useTheme();
    var cardProps = useMemo(function () {
        return props.asCard
            ? {
                backgroundColor: COLORS.WHITE,
                px: 3,
                py: 2,
                mx: '6px',
                sx: {
                    boxShadow: theme.elevation(1),
                },
            }
            : {};
    }, [props.asCard, theme]);
    if (isLoading) {
        return (React.createElement(Flex, __assign$1({}, cardProps, { flexDirection: "column" }),
            React.createElement(ProductCardCarouselLoader, { variant: props.variant })));
    }
    if (carousels) {
        return React.createElement(React.Fragment, null, Object.keys(carousels).map(function (key) { return carousels[key]; }));
    }
    return null;
};
var RelevantProductCarousel$1 = memo(RelevantProductCarousel);
var RECOMMENDATION_PLACEMENT = 'add_to_cart_page.web_from-list';
var carouselOptions = {
    arrows: 'mini',
    hideNavMaxWidth: BREAKPOINTS[3],
};
var staticProps = {
    headingStyles: {
        marginY: '5px',
    },
    titleStyles: {
        fontSize: 16,
        lineHeight: 1.6,
        fontWeight: 500,
    },
};
var ProductListRowCarousel = function (_a) {
    var relevantProductId = _a.relevantProductId, rowIndex = _a.rowIndex, selectedRow = _a.selectedRow;
    return selectedRow === rowIndex && relevantProductId !== '' ? (React.createElement(RelevantProductCarousel$1, __assign$1({ carouselOptions: carouselOptions, asCard: true, testId: "relevance-carousel-card", placements: RECOMMENDATION_PLACEMENT, productId: relevantProductId, variant: "regular", withLoader: false, animateHeight: 354 }, staticProps))) : null;
};
var ProductListRowCarousel$1 = React.memo(ProductListRowCarousel);
var MAIN_OFFER_TYPE = 'main';
var ProductListRow = function (_a) {
    var cartEntries = _a.cartEntries, disabled = _a.disabled, isRelevanceCarousel = _a.isRelevanceCarousel, offsets = _a.offsets, onRelevantHandler = _a.onRelevantHandler, onSelectHandler = _a.onSelectHandler, onNotificationHandler = _a.onNotificationHandler, onViewSimilarHandler = _a.onViewSimilarHandler, openQty = _a.openQty, products = _a.products, relevantProductId = _a.relevantProductId, rowIndex = _a.rowIndex, selectedRow = _a.selectedRow, selectOnChange = _a.selectOnChange, withProductVariants = _a.withProductVariants, gaListName = _a.gaListName, isFoodCategory = _a.isFoodCategory, _b = _a.variant, variant = _b === void 0 ? 'regular' : _b;
    var _c = __read$1(useState(''), 2), keyword = _c[0], setKeyword = _c[1];
    var href = isBrowser() ? window.location.href : '';
    useEffect(function () {
        if (isBrowser()) {
            var url = new URL(href);
            var searchKeyword = url.searchParams.get('keyword');
            if (searchKeyword) {
                setKeyword(decodeStr(searchKeyword));
            }
        }
    }, [href]);
    var isMobile = useBreakpoints().isMobile;
    var Display = Flex;
    if (isMobile && isFoodCategory && variant !== 'compact' && variant === 'list') {
        Display = Box;
    }
    return (React.createElement(Flex, { w: 1, flexDirection: "column" },
        React.createElement(Display, { width: "100%", flexWrap: "wrap", alignItems: "flex-end" }, products.map(function (card, index) {
            var _a = card.offers, offers = _a === void 0 ? [] : _a;
            var applicableOffer = offers.find(function (offer) { return offer.type === MAIN_OFFER_TYPE; }) || {
                id: '',
                shippingIndicator: '',
            };
            var offerId = applicableOffer.id;
            var shippingIndicator = applicableOffer.shippingIndicator || '';
            offerId = offerId && !offerId.includes('offer') ? "offer_" + offerId : offerId;
            var uniqueEntryId = getUniqueEntryId(card.productId, offerId, shippingIndicator);
            var cartEntry = cartEntries[uniqueEntryId];
            var inCart = cartEntry !== undefined;
            var quantity = 0;
            var intent;
            if (inCart) {
                quantity = cartEntry.quantity;
                intent = cartEntry.intent;
            }
            var gaListNameUpdated = card.isSponsored && keyword
                ? "sponsored_listing|" + keyword
                : card.isSponsored && gaListName && gaListName.includes('category')
                    ? gaListName.replace('category', 'sponsored_listing')
                    : gaListName;
            if (relevantProductId === card.productId) {
                onRelevantHandler(rowIndex);
            }
            return (React.createElement(ProductListItemWrapper, { variant: variant, key: card.productId + "-" + index, offsets: offsets },
                React.createElement(ProductCard$1, __assign$1({}, card, { disabled: disabled, rowIndex: rowIndex, inCart: inCart, isOpen: openQty === card.productId, gaListName: gaListNameUpdated || '', onSelectHandler: onSelectHandler(card.productId), onNotificationHandler: onNotificationHandler, onViewSimilarHandler: onViewSimilarHandler, position: index + 1, quantity: quantity, selectOnChange: selectOnChange(card, inCart, quantity, index + 1, intent), withProductVariants: withProductVariants, withRelevantProducts: isRelevanceCarousel, isFoodCategory: isFoodCategory, variant: variant, intent: intent }))));
        })),
        isRelevanceCarousel && (React.createElement(ProductListRowCarousel$1, { relevantProductId: relevantProductId, rowIndex: rowIndex, selectedRow: selectedRow }))));
};
var ProductListRow$1 = React.memo(ProductListRow);
var PaginationControlWrapper = CustomStyled.ul(templateObject_1$K || (templateObject_1$K = __makeTemplateObject$1(["\n  display: flex;\n  list-style: none;\n  align-items: center;\n  li{\n    margin: 0px 6px;\n    text-align: center;\n    &:first-of-type{\n      margin-left: 0px;\n    }\n    &:last-of-type{\n      margin-right: 0px;\n    } \n  }\n"], ["\n  display: flex;\n  list-style: none;\n  align-items: center;\n  li{\n    margin: 0px 6px;\n    text-align: center;\n    &:first-of-type{\n      margin-left: 0px;\n    }\n    &:last-of-type{\n      margin-right: 0px;\n    } \n  }\n"])));
var templateObject_1$K;
var LinkWrapper = CustomStyled.li(templateObject_1$L || (templateObject_1$L = __makeTemplateObject$1(["\n    opacity: ", ";\n"], ["\n    opacity: ", ";\n"])), function (props) { return (props.disabled ? '0.5' : '1'); });
var StyledLink = CustomStyled.a(templateObject_2$C || (templateObject_2$C = __makeTemplateObject$1(["\n    color: ", ";\n    text-decoration: none;\n    font-size: ", "px;\n    cursor: ", ";\n"], ["\n    color: ", ";\n    text-decoration: none;\n    font-size: ", "px;\n    cursor: ", ";\n"])), function (props) { return props.theme.colors.copy; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return (props.disabled ? 'unset' : 'pointer'); });
var IconWrapper$5 = CustomStyled.div(templateObject_3$u || (templateObject_3$u = __makeTemplateObject$1(["\n  margin: 0px ", "px;  \n"], ["\n  margin: 0px ", "px;  \n"])), function (props) { return props.theme.space[2]; });
var LeftArrow = CustomStyled(IconWrapper$5)(templateObject_4$o || (templateObject_4$o = __makeTemplateObject$1(["\n  transform: rotate(90deg);\n\n  html[dir=\"rtl\"] & {\n    transform: rotate(-90deg);\n  }\n"], ["\n  transform: rotate(90deg);\n\n  html[dir=\"rtl\"] & {\n    transform: rotate(-90deg);\n  }\n"])));
var RightArrow = CustomStyled(IconWrapper$5)(templateObject_5$j || (templateObject_5$j = __makeTemplateObject$1(["\n  transform: rotate(-90deg);\n\n  html[dir=\"rtl\"] & {\n    transform: rotate(90deg);\n  }\n"], ["\n  transform: rotate(-90deg);\n\n  html[dir=\"rtl\"] & {\n    transform: rotate(90deg);\n  }\n"])));
var LinkDescription = CustomStyled.p(templateObject_6$f || (templateObject_6$f = __makeTemplateObject$1(["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), function (props) { return props.theme.breakpoints[0]; });
var templateObject_1$L, templateObject_2$C, templateObject_3$u, templateObject_4$o, templateObject_5$j, templateObject_6$f;
var StyledButton = CustomStyled(Button$1)(templateObject_1$M || (templateObject_1$M = __makeTemplateObject$1(["\n    ", ";\n    border-width: 1px;\n    border-style: solid;\n    font-size: ", "px;\n    box-shadow: none;\n    width: 50px;\n    height: 50px;\n    padding: 12px 5px;\n    transition-property: box-shadow, background-color;\n    transition-duration: 0s;\n    &:hover{\n        color: ", ";\n        border-width: 1px;\n        border-color: ", ";\n        background-color: ", ";\n        box-shadow: none;\n    }\n"], ["\n    ",
    ";\n    border-width: 1px;\n    border-style: solid;\n    font-size: ", "px;\n    box-shadow: none;\n    width: 50px;\n    height: 50px;\n    padding: 12px 5px;\n    transition-property: box-shadow, background-color;\n    transition-duration: 0s;\n    &:hover{\n        color: ", ";\n        border-width: 1px;\n        border-color: ", ";\n        background-color: ", ";\n        box-shadow: none;\n    }\n"])), function (props) {
    return variant({
        variants: {
            primary: {
                color: props.theme.colors.copy,
                borderColor: props.theme.colors.copy,
                backgroundColor: props.theme.colors.white,
            },
            secondary: {
                color: props.theme.colors.white,
                backgroundColor: props.theme.colors.blue,
                borderColor: props.theme.colors.blue,
            },
        },
    });
}, function (props) { return props.theme.fontSizes[5]; }, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.colors.blue; });
var templateObject_1$M;
var textColor = style({
    prop: 'textColor',
    cssProperty: 'color',
    key: 'colors',
});
var ContentWrapper = styled.div(templateObject_1$N || (templateObject_1$N = __makeTemplateObject$1(["\n  color: ", ";\n  display: flex;\n  ", "\n  ", "\n  ", "\n  margin-top: 0;\n  h1 {\n    direction: ltr;\n    font-size: ", "px;\n    margin-bottom: ", "px;\n  }\n  p {\n    direction: ltr;\n    font-size: 0.583333em;\n  }\n"], ["\n  color: ", ";\n  display: flex;\n  ", "\n  ", "\n  ", "\n  margin-top: 0;\n  h1 {\n    direction: ltr;\n    font-size: ", "px;\n    margin-bottom: ", "px;\n  }\n  p {\n    direction: ltr;\n    font-size: 0.583333em;\n  }\n"])), function (props) { return props.theme.colors.copy; }, typography, space, textColor, function (props) { return props.theme.fontSizes[6]; }, function (props) { return props.theme.space[1]; });
var Container$6 = styled(Flex)(templateObject_2$D || (templateObject_2$D = __makeTemplateObject$1(["\n  flex-direction: column;\n"], ["\n  flex-direction: column;\n"])));
var PageInfoContent = styled.div(templateObject_3$v || (templateObject_3$v = __makeTemplateObject$1(["\n  > p,\n  > span,\n  > div {\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 8px;\n  }\n  white-space: nowrap;\n  overflow-x: scroll;\n"], ["\n  > p,\n  > span,\n  > div {\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 8px;\n  }\n  white-space: nowrap;\n  overflow-x: scroll;\n"])));
var QuickFilters = styled.div(templateObject_4$p || (templateObject_4$p = __makeTemplateObject$1(["\n  color: ", ";\n  font-family: Montserrat;\n  font-size: 14px;\n  line-height: 18px;\n  display: inline-block;\n  font-weight: 700;\n  padding: 7px 16px;\n  background: ", ";\n  border: solid 1px ", ";\n  border-radius: 48px;\n  cursor: pointer;\n"], ["\n  color: ", ";\n  font-family: Montserrat;\n  font-size: 14px;\n  line-height: 18px;\n  display: inline-block;\n  font-weight: 700;\n  padding: 7px 16px;\n  background: ", ";\n  border: solid 1px ", ";\n  border-radius: 48px;\n  cursor: pointer;\n"])), function (_a) {
    var selected = _a.selected;
    return (selected ? COLORS.BLUE : COLORS.BLACK);
}, function (_a) {
    var selected = _a.selected;
    return (selected ? '#0E5AA70d' : COLORS.WHITE);
}, function (_a) {
    var selected = _a.selected;
    return (selected ? COLORS.BLUE : COLORS.GRAY_100);
});
var templateObject_1$N, templateObject_2$D, templateObject_3$v, templateObject_4$p;
var GTM_KEYS = {
    uat: {
        mafuae: '',
        mafegy: '',
        mafsau: '',
        mafjor: '',
        mafqat: '',
        maflbn: '',
        mafpak: '',
        mafbhr: '',
        mafkwt: '',
        mafomn: '',
        mafken: '',
        mafgeo: '',
        mafuzb: '',
        mafarm: '',
        mafuga: '',
        mafirq: '',
        unified: process.env.REACT_APP_GTM_KEY,
    },
    prod: {
        mafuae: '',
        mafegy: '',
        mafsau: '',
        mafjor: '',
        mafqat: '',
        maflbn: '',
        mafpak: '',
        mafbhr: '',
        mafkwt: '',
        mafomn: '',
        mafken: '',
        mafgeo: '',
        mafuzb: '',
        mafarm: '',
        mafuga: '',
        mafirq: '',
        unified: process.env.REACT_APP_GTM_KEY,
    },
};
var ConsumerLogoContainer = customStyled(Flex)(templateObject_1$O || (templateObject_1$O = __makeTemplateObject$1(["\n  --direction: column;\n  flex-direction: var(--direction);\n  gap: 10px;\n  @media only screen and (max-width: ", " ) {\n    --direction: row;\n  }\n"], ["\n  --direction: column;\n  flex-direction: var(--direction);\n  gap: 10px;\n  @media only screen and (max-width: ", " ) {\n    --direction: row;\n  }\n"])), function (props) { return props.theme.breakpoints[3]; });
var FooterBrandLogoContainer = customStyled(Flex)(templateObject_2$E || (templateObject_2$E = __makeTemplateObject$1(["\n  --direction: column;\n  flex-direction: var(--direction);\n  gap: 10px;\n  @media only screen and (max-width: ", " ) {\n    --direction: row;\n  }\n"], ["\n  --direction: column;\n  flex-direction: var(--direction);\n  gap: 10px;\n  @media only screen and (max-width: ", " ) {\n    --direction: row;\n  }\n"])), function (props) { return props.theme.breakpoints[3]; });
var FooterBrandLogo = customStyled.img(templateObject_3$w || (templateObject_3$w = __makeTemplateObject$1(["\n  max-inline-size: 100%;\n  block-size: auto;\n  max-width: 100%;\n"], ["\n  max-inline-size: 100%;\n  block-size: auto;\n  max-width: 100%;\n"])));
var SocialIconWrapper = customStyled.div(templateObject_4$q || (templateObject_4$q = __makeTemplateObject$1(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  max-width: 200px; \n  margin-top: 5px;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  max-width: 200px; \n  margin-top: 5px;\n"])));
var FooterTop = customStyled.div(templateObject_5$k || (templateObject_5$k = __makeTemplateObject$1(["\n  background: ", ";\n  padding: 24px 0;\n\n  p,\n  a,\n  h4 {\n    color: ", ";\n  }\n\n  li {\n    list-style: none;\n    a {\n      text-decoration: none;\n      font-size: 12px;\n      line-height: 16px;\n      display: block;\n    }\n  }\n  ", "\n"], ["\n  background: ", ";\n  padding: 24px 0;\n\n  p,\n  a,\n  h4 {\n    color: ", ";\n  }\n\n  li {\n    list-style: none;\n    a {\n      text-decoration: none;\n      font-size: 12px;\n      line-height: 16px;\n      display: block;\n    }\n  }\n  ", "\n"])), function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.colors.white; }, padding);
var FooterContainer = customStyled(Flex)(templateObject_6$g || (templateObject_6$g = __makeTemplateObject$1(["\n  margin: 0 auto;\n  max-width: ", "px;\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  margin: 0 auto;\n  max-width: ", "px;\n  display: flex;\n  flex-wrap: wrap;\n"])), function (props) { return props.theme.maxLayoutWidth; });
var FooterBranding = styled(Flex)(templateObject_7$f || (templateObject_7$f = __makeTemplateObject$1(["\n  flex-basis: 20%;\n"], ["\n  flex-basis: 20%;\n"])));
FooterBranding.defaultProps = {
    flexDirection: ['column', 'row', null, null, 'column'],
    justifyContent: ['space-between', null, null, null, 'start'],
};
var SocialIcons = styled(Flex)(templateObject_8$f || (templateObject_8$f = __makeTemplateObject$1([""], [""])));
SocialIcons.defaultProps = {
    alignItems: ['center', null, null, null, 'start'],
    flexDirection: [null, null, null, null, 'column'],
    mt: ['12px', 0, null, null, 30],
};
var ConsumerRights = styled(Box)(templateObject_9$e || (templateObject_9$e = __makeTemplateObject$1(["\n  max-width: 74px;\n  margin-top: 30px;\n"], ["\n  max-width: 74px;\n  margin-top: 30px;\n"])));
ConsumerRights.defaultProps = {
    as: 'img',
    display: ['none', null, null, null, 'block'],
};
var FooterSiteNav = customStyled.div(templateObject_10$e || (templateObject_10$e = __makeTemplateObject$1(["\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1;\n  justify-content: space-between;\n  li {\n    margin-bottom: 8px;\n  }\n  a:hover {\n    text-decoration: underline;\n  }\n  gap: 20px;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1;\n  justify-content: space-between;\n  li {\n    margin-bottom: 8px;\n  }\n  a:hover {\n    text-decoration: underline;\n  }\n  gap: 20px;\n"])));
var Column = styled(Flex)(templateObject_11$b || (templateObject_11$b = __makeTemplateObject$1(["\n  flex-basis: 23%;\n  flex-direction: column;\n"], ["\n  flex-basis: 23%;\n  flex-direction: column;\n"])));
var Title$3 = styled(Box)(templateObject_12$a || (templateObject_12$a = __makeTemplateObject$1([""], [""])));
Title$3.defaultProps = {
    color: 'white',
    fontSize: 2,
    mb: 3,
};
var AppLogo = styled.a(templateObject_13$a || (templateObject_13$a = __makeTemplateObject$1(["\n  img {\n    width: 100px;\n    height: auto;\n    padding-left: 16px;\n  }\n"], ["\n  img {\n    width: 100px;\n    height: auto;\n    padding-left: 16px;\n  }\n"])));
var FooterContactUs = styled(Flex)(templateObject_14$a || (templateObject_14$a = __makeTemplateObject$1(["\n  flex-basis: 100%;\n  justify-content: flex-end;\n"], ["\n  flex-basis: 100%;\n  justify-content: flex-end;\n"])));
FooterContactUs.defaultProps = {
    mt: 3,
};
var FooterApps = styled(Flex)(templateObject_15$a || (templateObject_15$a = __makeTemplateObject$1(["\n  align-items: center;\n  flex-basis: 100%;\n  justify-content: var(--justifyContent, flex-end);\n  margin-top: 16px;\n  gap: 10px;\n  @media (max-width: ", "px) {\n    --justifyContent: space-evenly;\n  }\n"], ["\n  align-items: center;\n  flex-basis: 100%;\n  justify-content: var(--justifyContent, flex-end);\n  margin-top: 16px;\n  gap: 10px;\n  @media (max-width: ", "px) {\n    --justifyContent: space-evenly;\n  }\n"])), BREAKPOINTS[1]);
var FooterAccordion = customStyled(Accordion)(templateObject_16$7 || (templateObject_16$7 = __makeTemplateObject$1(["\n  background-color: ", ";\n  justify-content: space-between;\n"], ["\n  background-color: ", ";\n  justify-content: space-between;\n"])), function (props) { return props.theme.colors.blue; });
var List = styled.ul(templateObject_17$7 || (templateObject_17$7 = __makeTemplateObject$1(["\n  background-color: ", ";\n  max-height: 500px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  ", "\n"], ["\n  background-color: ", ";\n  max-height: 500px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  ", "\n"])), COLORS.PURPLE, padding);
var ContactUsWrapper = styled(Flex)(templateObject_18$6 || (templateObject_18$6 = __makeTemplateObject$1(["\n  background: ", ";\n  justify-content: space-between;\n  color: ", ";\n"], ["\n  background: ", ";\n  justify-content: space-between;\n  color: ", ";\n"])), COLORS.PURPLE, COLORS.WHITE);
var ContactUsLink = styled(Box)(templateObject_19$6 || (templateObject_19$6 = __makeTemplateObject$1(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
ContactUsLink.defaultProps = {
    as: 'a',
    fontSize: [25, 30],
    ml: 2,
};
var Container$7 = styled(Flex)(templateObject_20$5 || (templateObject_20$5 = __makeTemplateObject$1(["\n  flex-direction: column;\n  color: ", ";\n  margin-top: 40px;\n  gap: 10px;\n"], ["\n  flex-direction: column;\n  color: ", ";\n  margin-top: 40px;\n  gap: 10px;\n"])), COLORS.WHITE);
var templateObject_1$O, templateObject_2$E, templateObject_3$w, templateObject_4$q, templateObject_5$k, templateObject_6$g, templateObject_7$f, templateObject_8$f, templateObject_9$e, templateObject_10$e, templateObject_11$b, templateObject_12$a, templateObject_13$a, templateObject_14$a, templateObject_15$a, templateObject_16$7, templateObject_17$7, templateObject_18$6, templateObject_19$6, templateObject_20$5;
var selectfooterData = createSelector(function (state) { return state.footerData; }, function (state) { return state === null || state === void 0 ? void 0 : state.data; });
var getLinks = createSelector(selectfooterData, function (state) {
    var _a;
    return (_a = state === null || state === void 0 ? void 0 : state.list_link) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
        var title = _a.title, text_link = _a.text_link;
        return ({
            label: title || '',
            links: text_link.map(function (_a) {
                var title = _a.title, cta_url_web = _a.cta_url_web, ctaUrlWebExternal = _a.ctaUrlWebExternal;
                return ({
                    name: title,
                    href: cta_url_web,
                    externalLink: ctaUrlWebExternal,
                });
            }) || [],
        });
    });
});
var FooterImageLinkWrapper = function (props) {
    var data = props.data, rest = __rest$1(props, ["data"]);
    return data.map(function (ele, index) { return React.createElement(FooterImageLink, __assign$1({}, rest, ele, { key: index })); });
};
var FooterImageLink = function (props) {
    var media_mobile = props.media_mobile, media_web = props.media_web, alt_text = props.alt_text, width = props.width, height = props.height, cta_url_web = props.cta_url_web, target = props.target;
    return (React.createElement("a", { href: cta_url_web, target: target },
        React.createElement("picture", null,
            React.createElement("source", { srcSet: media_mobile, media: "(max-width: " + BREAKPOINTS[0] + "px)" }),
            React.createElement(FooterBrandLogo, { src: media_web, alt: alt_text, width: width, height: height, loading: "lazy", decoding: "async" }))));
};
var currentYear = new Date().getFullYear();
var Copyright = customStyled.div(templateObject_1$P || (templateObject_1$P = __makeTemplateObject$1(["\n  background: ", ";\n  ", ";\n"], ["\n  background: ", ";\n  ", ";\n"])), function (props) { return props.theme.colors.brown; }, padding);
var CopyrightMaxLayout$1 = customStyled(Flex)(templateObject_2$F || (templateObject_2$F = __makeTemplateObject$1(["\n  align-items: center;\n  margin: 0 auto;\n  max-width: ", "px;\n  flex-wrap: wrap;\n  justify-content: space-around;\n"], ["\n  align-items: center;\n  margin: 0 auto;\n  max-width: ", "px;\n  flex-wrap: wrap;\n  justify-content: space-around;\n"])), function (props) { return props.theme.maxLayoutWidth; });
var CopyrightText = customStyled(Box)(templateObject_3$x || (templateObject_3$x = __makeTemplateObject$1(["\n  color: ", ";\n  font-size: ", "px;\n  margin-bottom: -4px;\n"], ["\n  color: ", ";\n  font-size: ", "px;\n  margin-bottom: -4px;\n"])), function (props) { return props.theme.colors.white; }, function (props) { return props.theme.fontSizes[1]; });
var Logo$3 = customStyled.a(templateObject_4$r || (templateObject_4$r = __makeTemplateObject$1(["\n  svg {\n    display: block; {/* Remove space around the element */}\n  }\n  color: ", "\n"], ["\n  svg {\n    display: block; {/* Remove space around the element */}\n  }\n  color: ", "\n"])), COLORS.WHITE);
var templateObject_1$P, templateObject_2$F, templateObject_3$x, templateObject_4$r;
var SocialMedia;
(function (SocialMedia) {
    SocialMedia["FACEBOOK"] = "Facebook";
    SocialMedia["TWITTER"] = "Twitter";
    SocialMedia["INSTAGRAM"] = "Instagram";
    SocialMedia["YOUTUBE"] = "YouTube";
})(SocialMedia || (SocialMedia = {}));
var SocialIconList = memo(function (props) {
    var name = props.name;
    var params = { height: 24, width: 24, size: 'CUSTOM' };
    switch (name) {
        case SocialMedia.FACEBOOK:
            return React.createElement(Facebook, __assign$1({}, params));
        case SocialMedia.TWITTER:
            return React.createElement(Twitter, __assign$1({}, params));
        case SocialMedia.INSTAGRAM:
            return React.createElement(Instagram, __assign$1({}, params));
        case SocialMedia.YOUTUBE:
            return React.createElement(YouTube, __assign$1({}, params));
        default:
            return null;
    }
});
var SOCIAL_MEDIA_LINKS = {
    mafuae: {
        Facebook: 'carrefouruae',
        Twitter: 'carrefouruae',
        Instagram: 'carrefouruae',
        YouTube: 'CarrefourUAE',
    },
    mafgeo: {
        Facebook: 'carrefourgeorgia',
        Twitter: 'carrefourge',
        Instagram: 'carrefour_georgia',
        YouTube: 'channel/UCQ7aPJ3odUD15oPgBrqhEtA/search',
    },
    mafegy: {
        Facebook: 'carrefouregypt',
        Twitter: 'CarrefourEgypt',
        Instagram: 'carrefouregypt',
        YouTube: 'user/CarrefourEgypt',
    },
    mafsau: {
        Facebook: 'Carrefoursaudi',
        Twitter: 'carrefoursaudi',
        Instagram: 'carrefoursaudi',
        YouTube: 'user/CarrefourSaudi',
    },
    mafjor: {
        Facebook: 'CarrefourJordanOfficialPage',
        Twitter: 'carrefourjo',
        Instagram: 'carrefourjo',
        YouTube: 'channel/UChnMFQor7LVKK_GuUF2BVCw',
    },
    maflbn: {
        Facebook: 'carrefourlebanon',
        Twitter: 'carrefourleb',
        Instagram: 'carrefourlebanon',
        YouTube: 'user/carrefourlebanon',
    },
    mafqat: {
        Facebook: 'CarrefourQatar',
        Twitter: 'carrefour_qa',
        Instagram: 'carrefour_qa',
        YouTube: 'channel/UCecXe3Tymp1QC8Cmx6pXjVQ',
    },
    mafpak: {
        Facebook: 'OfficialCarrefourPakistan',
        Twitter: 'carrefour_pak',
        Instagram: 'carrefourpak',
        YouTube: 'channel/UCQYs-5-kFHRVIyefzZ6oyCQ',
    },
    mafuzb: {
        Facebook: 'carrefouruzbekistan',
        Twitter: 'majidalfuttaim',
        Instagram: 'carrefouruzbekistan',
        YouTube: 'user/majidalfuttaim/',
    },
    mafuga: {
        Facebook: 'UgCarrefour',
        Twitter: 'CarrefourUG',
        Instagram: 'carrefouruganda',
        YouTube: 'user/majidalfuttaim/',
    },
    mafirq: {
        Facebook: 'Carrefour.Iraq',
        Twitter: 'Carrefour_Iraq',
        Instagram: 'carrefour_iraq',
        YouTube: 'CarrefourIraq',
    },
};
var SOCIAL_MEDIA_DOMAINS = {
    Facebook: 'facebook.com',
    Twitter: 'twitter.com',
    Instagram: 'instagram.com',
    YouTube: 'youtube.com',
};
var SocialIcon = memo(function () {
    var t = useTranslation().t;
    var _a = __read$1(useAppConfig(), 1), storeId = _a[0].storeId;
    var stay_in_touch = (useSelector(selectfooterData) || {}).stay_in_touch;
    var _b = stay_in_touch || {}, image_link = _b.image_link, title = _b.title;
    var socialMediaLinks = useMemo(function () { return SOCIAL_MEDIA_LINKS[storeId]; }, [storeId]);
    var isFromStrapi = image_link && (image_link === null || image_link === void 0 ? void 0 : image_link.length) > 0;
    return (React.createElement(SocialIcons, { "data-testid": "social-media" },
        React.createElement(Box, { color: "white", mr: 3, my: 2 }, title || t('footer.stayInTouch')),
        !isFromStrapi ? (React.createElement(Flex, { mt: 1 }, socialMediaLinks &&
            Object.keys(socialMediaLinks).map(function (socialMedia, i) {
                var link = socialMediaLinks[socialMedia];
                return link ? (React.createElement(Box, { key: socialMedia, ml: i ? 3 : 0, as: "a", height: 24, width: 24, href: "https://" + SOCIAL_MEDIA_DOMAINS[socialMedia] + "/" + link, target: "_blank" },
                    React.createElement(SocialIconList, { name: socialMedia }))) : null;
            }))) : (React.createElement(SocialIconWrapper, null,
            React.createElement(FooterImageLinkWrapper, { data: image_link, width: 24, target: "_blank" })))));
});
var Branding = function (props) {
    var _a;
    var t = useTranslation().t;
    var _b = __read$1(useAppConfig(), 1), _c = _b[0], storeId = _c.storeId, _d = _c.language, language = _d === void 0 ? 'en' : _d;
    var _e = useSelector(selectfooterData) || {}, _f = _e.consumer_right_logo, consumer_right_logo = _f === void 0 ? [] : _f, _g = _e.logo_media, logo_media = _g === void 0 ? [] : _g;
    var shouldShowQR = ((_a = useFeature('footer.should_show_qr_code.enabled')) === null || _a === void 0 ? void 0 : _a.on) || false;
    var newLogo = (React.createElement(ConsumerLogoContainer, { mt: 20 },
        React.createElement(FooterImageLinkWrapper, { data: consumer_right_logo, width: 74, target: "_blank" })));
    return (React.createElement(FooterBranding, __assign$1({}, props),
        logo_media.length > 0 ? (React.createElement(FooterBrandLogoContainer, null,
            React.createElement(FooterImageLinkWrapper, { data: logo_media, width: 142 }))) : (React.createElement(Logo$1, { language: language, storeId: storeId, fill: COLORS.WHITE })),
        React.createElement(SocialIcon, null),
        consumer_right_logo.length > 0 ? newLogo : null,
        EStoreID.MAFSAU === storeId && (React.createElement(Container$7, null,
            React.createElement("div", null,
                React.createElement("span", { dir: "ltr" }, t('ksaCr'))),
            React.createElement("div", null,
                React.createElement("span", { dir: "ltr" }, t('ksaVat'))),
            shouldShowQR && (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement("span", { dir: "ltr" }, t('authenticationCode'))),
                React.createElement(Box, { as: "div", width: 120 },
                    React.createElement(Image, { url: process.env.REACT_APP_CDN_URL + "/assets/images/" + storeId + "_qrcode.png", name: "qr_code" }))))))));
};
var Branding$1 = React.memo(Branding);
var CUSTOMER_SERVICE_LINKS = [
    {
        name: 'serviceWarranty',
        href: '/servicewarranty',
    },
    {
        name: 'returnExchange',
        href: '/returnandexchange',
    },
    {
        name: 'securedOnlinePayments',
        href: '/onlinepayments',
    },
    {
        name: 'cashOnDelivery',
        href: '/cashondelivery',
    },
    {
        name: 'shippingDelivery',
        href: '/shippingdelivery',
    },
    {
        name: 'valetTrolley',
        href: '/valet-trolley-home-delivery',
    },
];
var HELP_AND_SUPPORT_LINKS = [
    {
        name: 'sitemap',
        href: '/sitemap',
    },
    {
        name: 'privacyPolicy',
        href: '/privacypolicy',
    },
    {
        name: 'disclaimer',
        href: 'https://www.majidalfuttaim.com/en/anti-fraud-disclaimer',
    },
    {
        name: 'disclosure',
        href: 'https://www.majidalfuttaim.com/en/responsible-disclosure-policy',
    },
    {
        name: 'termsConditions',
        href: '/termsandconditions',
    },
    {
        name: 'contactUs',
        href: '/contact-us',
    },
    {
        name: 'faqs',
        href: '/instorefaqs',
    },
    {
        name: 'findStore',
        href: '/store-finder',
    },
];
var HELP_AND_SUPPORT = {
    mafuae: [
        {
            name: 'privacyPolicy',
            href: '/helpcenter/articles/service/18?article=21',
        },
        {
            name: 'disclaimer',
            href: 'https://www.majidalfuttaim.com/en/anti-fraud-disclaimer',
        },
        {
            name: 'disclosure',
            href: 'https://www.majidalfuttaim.com/en/responsible-disclosure-policy',
        },
        {
            name: 'termsConditions',
            href: '/helpcenter/articles/service/18?article=23',
        },
        {
            name: 'contactUs',
            href: '/contact-us',
        },
        {
            name: 'faqs',
            href: '/helpcenter/',
        },
        {
            name: 'findStore',
            href: '/store-finder',
        },
    ],
    mafegy: __spread$1(HELP_AND_SUPPORT_LINKS),
    mafsau: __spread$1(HELP_AND_SUPPORT_LINKS),
    mafjor: __spread$1(HELP_AND_SUPPORT_LINKS),
    mafkwt: __spread$1(HELP_AND_SUPPORT_LINKS),
    maflbn: __spread$1(HELP_AND_SUPPORT_LINKS),
    mafgeo: __spread$1(HELP_AND_SUPPORT_LINKS.filter(function (ele) { return ele.name !== 'sitemap'; })),
    mafpak: __spread$1(HELP_AND_SUPPORT_LINKS),
    mafken: __spread$1(HELP_AND_SUPPORT_LINKS),
    mafqat: __spread$1(HELP_AND_SUPPORT_LINKS),
    mafuzb: __spread$1(HELP_AND_SUPPORT_LINKS),
    mafuga: __spread$1(HELP_AND_SUPPORT_LINKS),
    mafirq: __spread$1(HELP_AND_SUPPORT_LINKS),
};
var CUSTOMER_SERVICE = {
    mafuae: [
        {
            name: 'serviceWarranty',
            href: '/helpcenter/articles/service/3-Service%20and%20Warranty',
        },
        {
            name: 'returnExchange',
            href: '/helpcenter/articles/service/4-Return-%20and%20Exchange-',
        },
        {
            name: 'securedOnlinePayments',
            href: '/helpcenter/articles/service/10-Payment-',
        },
        {
            name: 'cashOnDelivery',
            href: '/helpcenter/articles/service/10?article=10',
        },
        {
            name: 'shippingDelivery',
            href: '/helpcenter/articles/topic/21-Shipping%20&%20Delivery',
        },
        {
            name: 'valetTrolley',
            href: '/helpcenter/articles/topic/19-Valet%20trolley',
        },
    ],
    mafegy: __spread$1(CUSTOMER_SERVICE_LINKS),
    mafsau: __spread$1(CUSTOMER_SERVICE_LINKS),
    mafjor: __spread$1(CUSTOMER_SERVICE_LINKS),
    mafkwt: __spread$1(CUSTOMER_SERVICE_LINKS),
    maflbn: __spread$1(CUSTOMER_SERVICE_LINKS),
    mafgeo: [
        {
            name: 'serviceWarranty',
            href: '/servicewarranty',
        },
        {
            name: 'returnExchange',
            href: '/returnandexchange',
        },
        {
            name: 'securedOnlinePayments',
            href: '/securepayment',
        },
        {
            name: 'cashOnDelivery',
            href: '/cashondelivery',
        },
        {
            name: 'shippingDelivery',
            href: '/shippingdelivery',
        },
    ],
    mafpak: [
        {
            name: 'serviceWarranty',
            href: '/servicewarranty',
        },
        {
            name: 'returnExchange',
            href: '/returnandexchange',
        },
        {
            name: 'securedOnlinePayments',
            href: '/onlinepayments',
        },
        {
            name: 'cashOnDelivery',
            href: '/cashondelivery',
        },
        {
            name: 'shippingDelivery',
            href: '/shippingdelivery',
        },
    ],
    mafken: [
        {
            name: 'serviceWarranty',
            href: '/servicewarranty',
        },
        {
            name: 'returnExchange',
            href: '/returnandexchange',
        },
        {
            name: 'securedOnlinePayments',
            href: '/onlinepayments',
        },
        {
            name: 'cashOnDelivery',
            href: '/cashondelivery',
        },
        {
            name: 'shippingDelivery',
            href: '/shippingdelivery',
        },
    ],
    mafqat: [
        {
            name: 'serviceWarranty',
            href: '/servicewarranty',
        },
        {
            name: 'returnExchange',
            href: '/returnandexchange',
        },
        {
            name: 'securedOnlinePayments',
            href: '/onlinepayments',
        },
        {
            name: 'shippingDelivery',
            href: '/shippingdelivery',
        },
        {
            name: 'deliveryZones',
            href: '/deliveryzones',
        },
        {
            name: 'carrefourAppFAQs',
            href: '/appfaq',
        },
    ],
    mafuzb: __spread$1(CUSTOMER_SERVICE_LINKS),
    mafuga: __spread$1(CUSTOMER_SERVICE_LINKS),
    mafirq: __spread$1(CUSTOMER_SERVICE_LINKS),
};
var DownloadApp = function () {
    var download_app = (useSelector(selectfooterData) || {}).download_app;
    var _a = download_app || {}, ios_app = _a.ios_app, android_app = _a.android_app, huawei_app = _a.huawei_app;
    return (React.createElement(React.Fragment, null,
        ios_app && React.createElement(FooterImageLink, __assign$1({}, ios_app, { width: 100 })),
        android_app && React.createElement(FooterImageLink, __assign$1({}, android_app, { width: 100 })),
        huawei_app && React.createElement(FooterImageLink, __assign$1({}, huawei_app, { width: 100 }))));
};
var DownloadApp$1 = memo(DownloadApp);
var ErrorPageWrapper = customStyled(Flex)(templateObject_1$Q || (templateObject_1$Q = __makeTemplateObject$1(["\n    align-items: center;\n    flex-direction: column;\n    font-weight: ", ";\n    justify-content: center;\n    //margin: 0 auto;\n    position: relative;\n    h2 {\n        color: ", ";\n        font-size: 18px;\n        font-weight: ", ";\n        margin-top: ", "px;\n        text-align: center;\n    }\n    h4{\n        margin-bottom: ", "px;\n        a {\n        color: ", ";\n        font-weight: ", ";\n        text-decoration: none;\n        }\n    }\n\n    div[data-testid=relevant-product-carousel]{\n        margin-bottom: 32px;\n        > div > p[data-testid=trolly-text]{\n    font-weight: 700;\n    font-size: 24px;\n    font-family: Montserrat;\n    }\n    }\n    @media (max-width: ", ") {\n        padding-top: 28px;\n    }\n"], ["\n    align-items: center;\n    flex-direction: column;\n    font-weight: ", ";\n    justify-content: center;\n    //margin: 0 auto;\n    position: relative;\n    h2 {\n        color: ", ";\n        font-size: 18px;\n        font-weight: ", ";\n        margin-top: ", "px;\n        text-align: center;\n    }\n    h4{\n        margin-bottom: ", "px;\n        a {\n        color: ", ";\n        font-weight: ", ";\n        text-decoration: none;\n        }\n    }\n\n    div[data-testid=relevant-product-carousel]{\n        margin-bottom: 32px;\n        > div > p[data-testid=trolly-text]{\n    font-weight: 700;\n    font-size: 24px;\n    font-family: Montserrat;\n    }\n    }\n    @media (max-width: ", ") {\n        padding-top: 28px;\n    }\n"])), function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.colors.thundora; }, function (props) { return (props.rtl ? props.theme.fontWeights[5] : props.theme.fontWeights[4]); }, function (props) { return props.theme.space[3]; }, function (props) { return props.theme.space[5]; }, function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.fontWeights[4]; }, function (props) { return props.theme.breakpoints[1]; });
var ErrorPageImageWrapper = customStyled.div(templateObject_2$G || (templateObject_2$G = __makeTemplateObject$1(["\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 240px;\n    svg{\n        width: 100%;\n        height: 100%;\n    }\n    @media (max-width: ", ") {\n    width: 130px;\n    height: 198px;\n    }\n"], ["\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 240px;\n    svg{\n        width: 100%;\n        height: 100%;\n    }\n    @media (max-width: ", ") {\n    width: 130px;\n    height: 198px;\n    }\n"])), function (props) { return props.theme.breakpoints[0]; });
var ErrorPageDescription = customStyled.div(templateObject_3$y || (templateObject_3$y = __makeTemplateObject$1(["\n    font-size: ", "px;\n    font-weight: ", ";\n    margin-top: ", "px;\n\n    p {\n        color: ", ";\n        line-height: 1.5;\n        text-align: center;\n    }\n"], ["\n    font-size: ", "px;\n    font-weight: ", ";\n    margin-top: ", "px;\n\n    p {\n        color: ", ";\n        line-height: 1.5;\n        text-align: center;\n    }\n"])), function (props) { return (props.rtl ? 15 : props.theme.fontSizes[3]); }, function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.space[3]; }, function (props) { return props.theme.colors.thundora; });
var ErrorPageLinks = customStyled.div(templateObject_4$s || (templateObject_4$s = __makeTemplateObject$1(["\n    margin-top: ", "px;\n    width: 100%;\n\n    @media (min-width: ", ") {\n        display: grid;\n        grid-column-gap: ", "px;\n        grid-template-columns: repeat(2, 1fr);\n    }\n"], ["\n    margin-top: ", "px;\n    width: 100%;\n\n    @media (min-width: ", ") {\n        display: grid;\n        grid-column-gap: ", "px;\n        grid-template-columns: repeat(2, 1fr);\n    }\n"])), function (props) { return props.theme.space[4]; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.theme.space[3]; });
var ErrorPageLinksCard = customStyled(Card)(templateObject_5$l || (templateObject_5$l = __makeTemplateObject$1(["\n    padding: ", "px;\n\n    h3 {\n        color: ", ";\n        font-size: ", "px;\n        font-weight: ", ";\n    }\n\n    &:not(:first-of-type) {\n        margin-top: ", "px;\n\n        @media (min-width: ", ") {\n            margin-top: 0;\n        }\n    }\n\n    ul {\n        margin-top: 22px;\n\n        li {\n            display: block;\n\n            &:not(:first-of-type) {\n                margin-top: 22px;\n            }\n\n            > a {\n                font-size: ", "px;\n                font-weight: ", ";\n            }\n        }\n    }\n"], ["\n    padding: ", "px;\n\n    h3 {\n        color: ", ";\n        font-size: ", "px;\n        font-weight: ", ";\n    }\n\n    &:not(:first-of-type) {\n        margin-top: ", "px;\n\n        @media (min-width: ", ") {\n            margin-top: 0;\n        }\n    }\n\n    ul {\n        margin-top: 22px;\n\n        li {\n            display: block;\n\n            &:not(:first-of-type) {\n                margin-top: 22px;\n            }\n\n            > a {\n                font-size: ", "px;\n                font-weight: ", ";\n            }\n        }\n    }\n"])), function (props) { return props.theme.space[4]; }, function (props) { return props.theme.colors.copy; }, function (props) { return (props.rtl ? props.theme.fontSizes[2] : props.theme.fontSizes[3]); }, function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.space[3]; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return (props.rtl ? props.theme.fontSizes[1] : props.theme.fontSizes[2]); }, function (props) { return (props.rtl ? props.theme.fontWeights[5] : props.theme.fontWeights[4]); });
var TopTitle = customStyled.div(templateObject_6$h || (templateObject_6$h = __makeTemplateObject$1(["\n    padding-top: ", "px;\n\n"], ["\n    padding-top: ", "px;\n\n"])), function (props) { return props.theme.space[5]; });
var TopTitleText = customStyled(Box)(templateObject_7$g || (templateObject_7$g = __makeTemplateObject$1(["\n    font-size: 100px;\n    color: ", ";\n    font-weight: 200;\n    font-style: normal;\n    margin-bottom: ", "px;\n     @media (max-width: ", ") {\n        font-size: 80px;\n    }\n"], ["\n    font-size: 100px;\n    color: ", ";\n    font-weight: 200;\n    font-style: normal;\n    margin-bottom: ", "px;\n     @media (max-width: ", ") {\n        font-size: 80px;\n    }\n"])), function (props) { return props.theme.colors.lightBlue; }, function (props) { return props.theme.space[5]; }, function (props) { return props.theme.breakpoints[1]; });
var SmallTexts = customStyled.div(templateObject_8$g || (templateObject_8$g = __makeTemplateObject$1(["\nfont-weight: ", ";\ncolor: ", ";\nmargin-bottom: ", "px;\nletter-spacing: 0.8px;\nfont-size: ", "px;\nh2{\nfont-weight: ", ";\nmargin-bottom: ", "px;\ntext-align: left;\nfont-size: 32px;\ncolor: ", ";\n@media (max-width: ", ") {\n        font-size: 24px;\n        padding-right: 100px\n}\n}\nspan{\n    max-width: 480px;\n    display: inline-block;\n    line-height: 30px;\n@media (max-width: ", ") {\n    line-height: 24px;\n    font-size: 20px;\n            padding-right: 100px\n\n    }\n}\n"], ["\nfont-weight: ", ";\ncolor: ", ";\nmargin-bottom: ", "px;\nletter-spacing: 0.8px;\nfont-size: ", "px;\nh2{\nfont-weight: ", ";\nmargin-bottom: ", "px;\ntext-align: left;\nfont-size: 32px;\ncolor: ", ";\n@media (max-width: ", ") {\n        font-size: 24px;\n        padding-right: 100px\n}\n}\nspan{\n    max-width: 480px;\n    display: inline-block;\n    line-height: 30px;\n@media (max-width: ", ") {\n    line-height: 24px;\n    font-size: 20px;\n            padding-right: 100px\n\n    }\n}\n"])), function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.space[5]; }, function (props) { return props.theme.fontSizes[6]; }, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.space[2]; }, function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.theme.breakpoints[1]; });
var TopWrapper = styled(Flex)(templateObject_9$f || (templateObject_9$f = __makeTemplateObject$1(["\n  width: 100%;\n  font-family: Montserrat;\n"], ["\n  width: 100%;\n  font-family: Montserrat;\n"])));
TopWrapper.defaultProps = {
    flexDirection: ['row'],
    justifyContent: 'space-between',
    mb: 6,
};
var SmallPara = customStyled.div(templateObject_10$f || (templateObject_10$f = __makeTemplateObject$1(["\nh4, h4 a{\n    font-weight: ", ";\n    line-height: 20px;\n}\n"], ["\nh4, h4 a{\n    font-weight: ", ";\n    line-height: 20px;\n}\n"])), function (props) { return props.theme.fontWeights[6]; });
var ColoredBackground = customStyled.div(templateObject_11$c || (templateObject_11$c = __makeTemplateObject$1(["\nposition: absolute;\nright: 0;\ntop: 0;\n"], ["\nposition: absolute;\nright: 0;\ntop: 0;\n"])));
var MovingObjectWrapper = customStyled.div(templateObject_12$b || (templateObject_12$b = __makeTemplateObject$1(["\nposition: absolute;\nleft: -45px;\ntop: 120px;\nwidth: 180px;\ntransform: translatey(0px);\nanimation: float 3s ease-in-out infinite 2s, land 2s ease-in-out;\n@keyframes float {\n\t0% {\n\t\ttransform: translatey(0px);\n\t}\n\t50% {\n        transform: translatey(-20px);\n\t}\n    100% {\n        transform: translatey(0px);\n\t}\n}\n@keyframes land {\n\t0% {\n        transform: translatey(-100px);\n\t}\n    100% {\n\t\ttransform: translatey(0px);\n\t}\n}\n@media (max-width: ", ") {\n    width: 100px;\n    right: 15px;\n    left: auto;\n    top: 80px;\n    }\n"], ["\nposition: absolute;\nleft: -45px;\ntop: 120px;\nwidth: 180px;\ntransform: translatey(0px);\nanimation: float 3s ease-in-out infinite 2s, land 2s ease-in-out;\n@keyframes float {\n\t0% {\n\t\ttransform: translatey(0px);\n\t}\n\t50% {\n        transform: translatey(-20px);\n\t}\n    100% {\n        transform: translatey(0px);\n\t}\n}\n@keyframes land {\n\t0% {\n        transform: translatey(-100px);\n\t}\n    100% {\n\t\ttransform: translatey(0px);\n\t}\n}\n@media (max-width: ", ") {\n    width: 100px;\n    right: 15px;\n    left: auto;\n    top: 80px;\n    }\n"])), function (props) { return props.theme.breakpoints[1]; });
var ReasonsList = customStyled.div(templateObject_13$b || (templateObject_13$b = __makeTemplateObject$1(["\nmax-width: 350px;\nlist-style: none;\nmargin-bottom: ", "px;\nli{\n    position: relative;\n    padding-left: 10px;\n    margin-bottom: 10px;\n    &::before{\n        content:\"\";\n        width: 4px;\n        height: 4px;\n        background: ", ";\n        position: absolute;\n        left: 0;\n        top: 6px;\n        -webkit-border-radius: 100%;\n        border-radius: 100%;\n    }\n}\n"], ["\nmax-width: 350px;\nlist-style: none;\nmargin-bottom: ", "px;\nli{\n    position: relative;\n    padding-left: 10px;\n    margin-bottom: 10px;\n    &::before{\n        content:\"\";\n        width: 4px;\n        height: 4px;\n        background: ", ";\n        position: absolute;\n        left: 0;\n        top: 6px;\n        -webkit-border-radius: 100%;\n        border-radius: 100%;\n    }\n}\n"])), function (props) { return props.theme.space[5]; }, function (props) { return props.theme.colors.thundora; });
var PageContainer = customStyled.div(templateObject_14$b || (templateObject_14$b = __makeTemplateObject$1(["\n    width: 1232px;\n    max-width: 90%;\n"], ["\n    width: 1232px;\n    max-width: 90%;\n"])));
var CategoriesWrapper = styled(Flex)(templateObject_15$b || (templateObject_15$b = __makeTemplateObject$1(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
CategoriesWrapper.defaultProps = {
    py: 5,
};
var ButtonWrapper = customStyled.a(templateObject_16$8 || (templateObject_16$8 = __makeTemplateObject$1(["\n    color: ", ";\n    text-decoration: none;\n    font-family: Montserrat;\n    font-weight: ", ";\n    &:hover {\n        button {\n            background-color: ", ";\n            color:#FFF;\n        }\n    }\n"], ["\n    color: ", ";\n    text-decoration: none;\n    font-family: Montserrat;\n    font-weight: ", ";\n    &:hover {\n        button {\n            background-color: ", ";\n            color:#FFF;\n        }\n    }\n"])), function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.fontWeights[4]; }, function (props) { return props.theme.colors.blue; });
var ComponentTitle = customStyled.h3(templateObject_17$8 || (templateObject_17$8 = __makeTemplateObject$1(["\n    color: ", ";\n    font-family: 'Montserrat';\n    font-weight: ", ";\n    font-size: ", "px;\n    margin-bottom: 16px;\n"], ["\n    color: ", ";\n    font-family: 'Montserrat';\n    font-weight: ", ";\n    font-size: ", "px;\n    margin-bottom: 16px;\n"])), function (props) { return props.theme.colors.black; }, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.fontSizes[6]; });
var templateObject_1$Q, templateObject_2$G, templateObject_3$y, templateObject_4$s, templateObject_5$l, templateObject_6$h, templateObject_7$g, templateObject_8$g, templateObject_9$f, templateObject_10$f, templateObject_11$c, templateObject_12$b, templateObject_13$b, templateObject_14$b, templateObject_15$b, templateObject_16$8, templateObject_17$8;
var ADD_TO_LIST_API_BASE = 'wishlists/{{StoreId}}/{{language}}';
var FETCH_LIST_API = ADD_TO_LIST_API_BASE;
var ADD_PRODUCT_ONLY_API = ADD_TO_LIST_API_BASE + "/product";
var ADD_PRODUCT_AND_NEW_LIST_API = ADD_TO_LIST_API_BASE;
var toggleLoading = function (loading) { return ({
    type: EAddToListTypes$1.ADD_TO_LIST_TOGGLE_LOADING,
    payload: loading,
}); };
var clearErrorAndSuccess = function () { return ({
    type: EAddToListTypes$1.ADD_TO_LIST_CLEAR_ERROR_AND_SUCCESS,
}); };
var fetchList = function () { return function (dispatch) {
    dispatch({
        type: EAddToListTypes$1.ADD_TO_LIST_FETCH_LIST,
        payload: {
            enableProgress: false,
            onSuccess: function (data) {
                dispatch({
                    type: EAddToListTypes$1.ADD_TO_LIST_FETCH_LIST_SUCCESS,
                    payload: data,
                });
            },
            onFailure: function (error) {
                return dispatch({
                    type: EAddToListTypes$1.ADD_TO_LIST_SET_ERROR,
                    payload: error,
                });
            },
            url: FETCH_LIST_API,
        },
    });
}; };
var addProductAndNewList = function (dispatch, _a) {
    var newListName = _a.newListName, productCode = _a.productCode;
    dispatch({
        type: EAddToListTypes$1.ADD_PRODUCT_AND_NEW_LIST,
        payload: {
            data: {
                wishlistName: newListName,
                wishlistDesc: newListName,
                productCode: productCode,
                quantity: 1,
            },
            enableProgress: false,
            method: EApiMiddlewareMethod$1.POST,
            onSuccess: function (_a) {
                var error = _a.error, message = _a.message;
                if (error) {
                    dispatch({
                        type: EAddToListTypes$1.ADD_TO_LIST_SET_ERROR,
                        payload: message,
                    });
                    dispatch(toggleLoading(false));
                    return;
                }
                addProductOnly(dispatch, { selectedList: newListName, productCode: productCode });
            },
            url: ADD_PRODUCT_AND_NEW_LIST_API,
        },
    });
};
var addProductOnly = function (dispatch, _a) {
    var selectedList = _a.selectedList, productCode = _a.productCode;
    dispatch({
        type: EAddToListTypes$1.ADD_PRODUCT_ONLY,
        payload: {
            data: {
                wishlistName: selectedList,
                productCode: productCode,
                userId: getUserEmailFromCookie(),
            },
            enableProgress: false,
            method: EApiMiddlewareMethod$1.POST,
            onSuccess: function (_a) {
                var error = _a.error, message = _a.message;
                if (error) {
                    dispatch({
                        type: EAddToListTypes$1.ADD_TO_LIST_SET_ERROR,
                        payload: message,
                    });
                    return;
                }
                dispatch({
                    type: EAddToListTypes$1.ADD_TO_LIST_SET_SUCCESS,
                    payload: selectedList,
                });
            },
            onFailure: function (error) {
                return dispatch({
                    type: EAddToListTypes$1.ADD_TO_LIST_SET_ERROR,
                    payload: error,
                });
            },
            onFinally: function () { return dispatch(toggleLoading(false)); },
            url: ADD_PRODUCT_ONLY_API,
        },
    });
};
var addProductToList = function (params) { return function (dispatch) {
    dispatch(toggleLoading(true));
    dispatch(clearErrorAndSuccess());
    params.selectedList ? addProductOnly(dispatch, params) : addProductAndNewList(dispatch, params);
}; };
var useAddToList = function () {
    var dispatch = useDispatch();
    var _a = __read$1(useState(false), 2), visible = _a[0], setVisible = _a[1];
    useEffect(function () {
        if (visible) {
            dispatch(fetchList());
        }
    }, [dispatch, visible]);
    var clearErrorAndSuccess$1 = useCallback(function () { return dispatch(clearErrorAndSuccess()); }, [dispatch]);
    var hideAddToList = function () {
        setVisible(false);
        setTimeout(clearErrorAndSuccess$1, 500);
    };
    var addToList = function () { return setVisible(true); };
    return [visible, { hideAddToList: hideAddToList, addToList: addToList }];
};
var AddToListPopupSuccess = styled(Flex)(templateObject_1$R || (templateObject_1$R = __makeTemplateObject$1(["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  height: 100%;\n"], ["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  height: 100%;\n"])));
var AddToListPopupSucessCheck = styled(Box)(templateObject_2$H || (templateObject_2$H = __makeTemplateObject$1(["\n  border: solid ", ";\n  border-width: 0 0 3px 3px;\n  transform: rotate3d(0, 0, 1, -45deg);\n  display: inline-block;\n  height: 25px;\n  width: 45px;\n"], ["\n  border: solid ", ";\n  border-width: 0 0 3px 3px;\n  transform: rotate3d(0, 0, 1, -45deg);\n  display: inline-block;\n  height: 25px;\n  width: 45px;\n"])), COLORS.LIGHT_GREEN);
var templateObject_1$R, templateObject_2$H;
var Paragraph$1 = Text.Paragraph;
var AddToListPopupSuccess$1 = function (_a) {
    var hideAddToList = _a.hideAddToList, list = _a.list;
    var t = useTranslation().t;
    return (React.createElement(AddToListPopupSuccess, { flexDirection: "column", alignItems: "center", justifyContent: "center" },
        React.createElement(AddToListPopupSucessCheck, { as: "i" }),
        React.createElement(Paragraph$1, { fontSize: 4, my: 5 },
            t('itemAddedTo'),
            " ",
            React.createElement("strong", null, list)),
        React.createElement(Button$1, { onClick: hideAddToList, width: 1 }, t('continueShopping').toUpperCase())));
};
var useAddToListPopup = function (code) {
    var dispatch = useDispatch();
    var addToListState = useSelector(function (_a) {
        var addToList = _a.addToList;
        return addToList;
    });
    var list = addToListState.list;
    var _a = __read$1(useState(''), 2), selectedList = _a[0], setSelectedList = _a[1];
    var _b = __read$1(useState(''), 2), newListName = _b[0], setNewListName = _b[1];
    var hasSelectedList = isExisty(selectedList);
    var hasNewListName = isExisty(newListName);
    var setSelectedListHandler = function (_a) {
        var value = _a.value;
        return setSelectedList(value);
    };
    var setNewListNameHandler = function (_a) {
        var target = _a.target;
        return setNewListName(target.value);
    };
    var submitHandler = useCallback(function () {
        if (!hasSelectedList && !hasNewListName) {
            return;
        }
        dispatch(addProductToList({ selectedList: selectedList, newListName: newListName, productCode: code }));
    }, [code, dispatch, newListName, selectedList, hasSelectedList, hasNewListName]);
    var keyPressHandler = useCallback(function (_a) {
        var key = _a.key;
        if (key === 'Enter') {
            submitHandler();
        }
    }, [submitHandler]);
    useEffect(function () {
        if (isNonEmptyArray(list)) {
            setSelectedList(list[0].name);
        }
    }, [list]);
    return [
        addToListState,
        newListName,
        selectedList,
        { setSelectedListHandler: setSelectedListHandler, setNewListNameHandler: setNewListNameHandler, submitHandler: submitHandler, keyPressHandler: keyPressHandler },
        { hasSelectedList: hasSelectedList, hasNewListName: hasNewListName },
    ];
};
var listDefaultOption = (function (t) { return [
    {
        id: 'list-create',
        label: t('createNewList'),
        value: '',
    },
]; });
var generateListOptions = function (list, t) {
    var options = listDefaultOption(t);
    if (isNonEmptyArray(list)) {
        return {
            options: options.concat(list.map(function (_a) {
                var pk = _a.pk, name = _a.name;
                return ({
                    id: "list-" + pk,
                    label: name,
                    value: name,
                });
            })),
            value: list[0].name,
        };
    }
    return {
        options: options,
    };
};
var AddToListPopup = styled(Box)(templateObject_1$S || (templateObject_1$S = __makeTemplateObject$1(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var success = _a.success;
    return (success ? 'overflow: hidden' : '');
});
var AddToListPopupAnimator = styled(Box)(templateObject_2$I || (templateObject_2$I = __makeTemplateObject$1(["\n  position: relative;\n  transition: transform 0.3s ease-in-out;\n  ", ";\n"], ["\n  position: relative;\n  transition: transform 0.3s ease-in-out;\n  ", ";\n"])), function (_a) {
    var success = _a.success;
    return (success ? 'transform: translate3d(0, -100%, 0)' : '');
});
var AddToListPopupContent = styled(Flex)(templateObject_3$z || (templateObject_3$z = __makeTemplateObject$1(["\n  transition: opacity 0.3s, transform 0.5s ease-in-out;\n  ", ";\n"], ["\n  transition: opacity 0.3s, transform 0.5s ease-in-out;\n  ", ";\n"])), function (_a) {
    var success = _a.success;
    return (success ? 'opacity: 0; transform: scale3d(0, 0, 0);' : '');
});
var AddToListPopupSelect = styled(Box)(templateObject_4$t || (templateObject_4$t = __makeTemplateObject$1(["\n  border: 1px solid ", ";\n  position: relative;\n"], ["\n  border: 1px solid ", ";\n  position: relative;\n"])), COLORS.MERCURY);
var AddToListPopupTextbox = styled(Box)(templateObject_5$m || (templateObject_5$m = __makeTemplateObject$1(["\n  border: 1px solid ", ";\n"], ["\n  border: 1px solid ", ";\n"])), COLORS.MERCURY);
var templateObject_1$S, templateObject_2$I, templateObject_3$z, templateObject_4$t, templateObject_5$m;
var Caption$3 = Text.Caption;
var AddToListPopup$1 = function (_a) {
    var code = _a.code, hideAddToList = _a.hideAddToList;
    var t = useTranslation().t;
    var _b = __read$1(useAddToListPopup(code), 5), addToList = _b[0], newListName = _b[1], selectedList = _b[2], _c = _b[3], setSelectedListHandler = _c.setSelectedListHandler, setNewListNameHandler = _c.setNewListNameHandler, submitHandler = _c.submitHandler, keyPressHandler = _c.keyPressHandler, _d = _b[4], hasSelectedList = _d.hasSelectedList, hasNewListName = _d.hasNewListName;
    var error = addToList.error, list = addToList.list, loading = addToList.loading, success = addToList.success;
    var listOptions = generateListOptions(list, t);
    var isFetchingList = !isExisty(list) && !error;
    return (React.createElement(AddToListPopup, { success: success },
        React.createElement(AddToListPopupAnimator, { success: success },
            React.createElement(AddToListPopupContent, { flexDirection: "column", success: success },
                error && React.createElement(Notification, { mb: 3 }, error),
                React.createElement(AddToListPopupSelect, { sx: {
                        '> div:first-of-type': {
                            display: 'block',
                        },
                    } },
                    React.createElement(Select
                    , __assign$1({
                        key: "length-" + listOptions.options.length }, listOptions, { onChange: setSelectedListHandler, m: 0 })),
                    isFetchingList && React.createElement(LinearProgress, { withBlock: false })),
                !hasSelectedList && (React.createElement(AddToListPopupTextbox, { as: "input", mt: 2, p: 3, onChange: setNewListNameHandler, onKeyPress: keyPressHandler, placeholder: t('newList'), type: "text", value: newListName })),
                React.createElement(Box, { mt: 2, sx: { position: 'relative' } },
                    React.createElement(Button$1, { disabled: (!hasSelectedList && !hasNewListName) || loading, onClick: submitHandler, width: 1 }, loading ? t('addToExistingList', { list: selectedList || newListName }) : t('addToShoppingList')),
                    loading && React.createElement(LinearProgress, { withBlock: false })),
                React.createElement(Button$1, { mt: 2, onClick: hideAddToList, variant: "outlined" }, t('cancel')),
                React.createElement(Caption$3, { mt: 3 }, t('selectCreateList'))),
            success && React.createElement(AddToListPopupSuccess$1, { list: success, hideAddToList: hideAddToList }))));
};
var AddToListPopup$2 = memo(AddToListPopup$1);
var Login = function (_a) {
    var t = _a.t;
    return (React.createElement(Box, null,
        t('loginWishlist.please'),
        ' ',
        React.createElement(Button$1, { href: '/login', variant: "link" }, t('loginWishlist.login')),
        ' ',
        t('loginWishlist.wishlist')));
};
var Login$1 = withTranslation()(Login);
var AddToList = function (_a) {
    var children = _a.children, productCode = _a.productCode;
    var _b = __read$1(useUser(), 1), isLoggedIn = _b[0];
    var _c = __read$1(useAddToList(), 2), visible = _c[0], _d = _c[1], hideAddToList = _d.hideAddToList, addToList = _d.addToList;
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        children(addToList),
        isBrowser() && (React.createElement(Modal, { isOpen: visible, onClose: hideAddToList, title: t('addToList') }, isLoggedIn ? React.createElement(AddToListPopup$2, { code: productCode, hideAddToList: hideAddToList }) : React.createElement(Login$1, null)))));
};
var index$3 = memo(AddToList);
var sharedStyle = css(templateObject_1$T || (templateObject_1$T = __makeTemplateObject$1(["\n  font-family: 'Montserrat';\n  font-style: normal;\n"], ["\n  font-family: 'Montserrat';\n  font-style: normal;\n"])));
var SearchInputBox = styled.input(templateObject_2$J || (templateObject_2$J = __makeTemplateObject$1(["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-bottom: ", " solid ", ";\n  width: 100%;\n  padding: 10px 44px 10px 42px;\n  margin-bottom: 12px;\n  transition: all 0.3s;\n  ", "\n  @media (max-width: ", "px) {\n    font-size: ", ";\n  }\n"], ["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-bottom: ", " solid ", ";\n  width: 100%;\n  padding: 10px 44px 10px 42px;\n  margin-bottom: 12px;\n  transition: all 0.3s;\n  ", "\n  @media (max-width: ", "px) {\n    font-size: ", ";\n  }\n"])), sharedStyle, TYPOGRAPHY.WEIGHT[400], TYPOGRAPHY.SIZE[16], TYPOGRAPHY.SIZE[20], COLORS.GRAY_500, COLORS.WHITE, function (props) { return (props.error ? '3px' : '0px'); }, COLORS.LIGHT_GRAY, function (props) { return ({ ...props.moreStyle }); }, BREAKPOINTS[1], function (props) { return props.theme.fontSizes[2]; });
var SearchMessage = styled.div(templateObject_3$A || (templateObject_3$A = __makeTemplateObject$1(["\n  background: ", ";\n  backdrop-filter: blur(15px);\n  border-radius: 12px 12px 0px 0px;\n  position: relative;\n  width: 90%;\n  height: 27px;\n  padding-top: 8px;\n  padding-left: 12px;\n"], ["\n  background: ", ";\n  backdrop-filter: blur(15px);\n  border-radius: 12px 12px 0px 0px;\n  position: relative;\n  width: 90%;\n  height: 27px;\n  padding-top: 8px;\n  padding-left: 12px;\n"])), COLORS.LIGHT_GREY_100);
var SearchErrorMessage = styled.div(templateObject_4$u || (templateObject_4$u = __makeTemplateObject$1(["\n  display: flex;\n  margin-top: -14px;\n  background: ", ";\n  border-radius: 0px 0px 12px 12px;\n  position: relative;\n  width: 90%;\n  height: 37px;\n  padding-top: 9px;\n  padding-left: 13px;\n"], ["\n  display: flex;\n  margin-top: -14px;\n  background: ", ";\n  border-radius: 0px 0px 12px 12px;\n  position: relative;\n  width: 90%;\n  height: 37px;\n  padding-top: 9px;\n  padding-left: 13px;\n"])), COLORS.WHITE);
var SearchLabel = styled.span(templateObject_5$n || (templateObject_5$n = __makeTemplateObject$1(["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"], ["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"])), sharedStyle, function (props) { return props.theme.fontWeights[2]; }, TYPOGRAPHY.SIZE[12], TYPOGRAPHY.SIZE[16], COLORS.BLACK);
var SearchErrorLabel = styled.span(templateObject_6$i || (templateObject_6$i = __makeTemplateObject$1(["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin-left: 8px;\n  margin-top: 5px;\n"], ["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin-left: 8px;\n  margin-top: 5px;\n"])), sharedStyle, TYPOGRAPHY.WEIGHT[400], TYPOGRAPHY.SIZE[12], TYPOGRAPHY.SIZE[16], COLORS.LIGHT_RED);
var SearchWrapper = styled.div(templateObject_7$h || (templateObject_7$h = __makeTemplateObject$1(["\n  position: relative;\n  width: 90%;\n  height: 100%;\n"], ["\n  position: relative;\n  width: 90%;\n  height: 100%;\n"])));
var LocationSearchError = styled.div(templateObject_8$h || (templateObject_8$h = __makeTemplateObject$1(["\n  color: ", ";\n  margin-bottom: 12px;\n  margin-top: -7px;\n  padding-left: 8px;\n  font-size: ", ";\n"], ["\n  color: ", ";\n  margin-bottom: 12px;\n  margin-top: -7px;\n  padding-left: 8px;\n  font-size: ", ";\n"])), COLORS.RED, TYPOGRAPHY.SIZE[12]);
var SearchIconContainer = styled(Box)(templateObject_9$g || (templateObject_9$g = __makeTemplateObject$1(["\n  position: absolute;\n  top: 12px;\n  left: 12px;\n"], ["\n  position: absolute;\n  top: 12px;\n  left: 12px;\n"])));
var ClearSearchContainer = styled(Box)(templateObject_10$g || (templateObject_10$g = __makeTemplateObject$1(["\n  position: absolute;\n  top: 12px;\n  right: 10px;\n"], ["\n  position: absolute;\n  top: 12px;\n  right: 10px;\n"])));
var LabelContainer = styled(Flex)(templateObject_11$d || (templateObject_11$d = __makeTemplateObject$1(["\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: 9px 11px;\n  font-size: ", ";\n  margin-left: ", ";\n  background-color: ", ";\n  color: ", ";\n  align-items: center;\n  text-transform: capitalize;\n"], ["\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: 9px 11px;\n  font-size: ", ";\n  margin-left: ", ";\n  background-color: ", ";\n  color: ", ";\n  align-items: center;\n  text-transform: capitalize;\n"])), COLORS.MERCURY, TYPOGRAPHY.SIZE[16], TYPOGRAPHY.SIZE[12], function (props) { return (props.index ? '8px' : '0px'); }, function (props) { return (props.isSelected ? COLORS.BLUE : 'transparent'); }, function (props) { return (props.isSelected ? COLORS.WHITE : COLORS.THUNDORA); });
var ButtonWrapper$1 = styled(Flex)(templateObject_12$c || (templateObject_12$c = __makeTemplateObject$1(["\n  flex-direction: row;\n  justify-content: space-evenly;\n  @media (max-width: ", "px) {\n    justify-content: center;\n  }\n"], ["\n  flex-direction: row;\n  justify-content: space-evenly;\n  @media (max-width: ", "px) {\n    justify-content: center;\n  }\n"])), BREAKPOINTS[1]);
var LabelHeading = styled(Text)(templateObject_13$c || (templateObject_13$c = __makeTemplateObject$1(["\n  ", "\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: ", ";\n"], ["\n  ", "\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: ", ";\n"])), sharedStyle, COLORS.BLACK);
var FormFooter = styled(Flex)(templateObject_14$c || (templateObject_14$c = __makeTemplateObject$1(["\n  flex-direction: column;\n  bottom: 0px;\n  position: relative;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);\n  width: 118%;\n  height: 80px;\n  margin-left: -37px;\n  margin-top: 37px;\n"], ["\n  flex-direction: column;\n  bottom: 0px;\n  position: relative;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);\n  width: 118%;\n  height: 80px;\n  margin-left: -37px;\n  margin-top: 37px;\n"])));
var MarkerBox = styled.div(templateObject_15$c || (templateObject_15$c = __makeTemplateObject$1(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-left: -24px;\n  margin-top: -48px;\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-left: -24px;\n  margin-top: -48px;\n"])));
var BackDrop = styled.div(templateObject_16$9 || (templateObject_16$9 = __makeTemplateObject$1(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1041;\n  background-color: rgba(0, 0, 0, 0.5);\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1041;\n  background-color: rgba(0, 0, 0, 0.5);\n"])));
var MapOverlayWapper = styled.div(templateObject_17$9 || (templateObject_17$9 = __makeTemplateObject$1(["\n  display: flex;\n  position: absolute;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  top: 30%;\n  left: 4%;\n  @media (max-width: ", "px) {\n    top: 30%;\n    left: -6%;\n  }\n"], ["\n  display: flex;\n  position: absolute;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  top: 30%;\n  left: 4%;\n  @media (max-width: ", "px) {\n    top: 30%;\n    left: -6%;\n  }\n"])), BREAKPOINTS[1]);
var AddressInfoCard = styled(Flex)(templateObject_18$7 || (templateObject_18$7 = __makeTemplateObject$1(["\n  @media (max-width: ", "px) {\n    width: 230px;\n    height: ", ";\n    top: 28%;\n  }\n  width: 240px;\n  height: ", ";\n  align-items: center;\n  padding-top: 9px;\n  background: ", ";\n  border-radius: 8px;\n  z-index: 1042;\n  position: absolute;\n  top: ", ";\n  left: 50%;\n  transform: translateX(-50%);\n  flex-direction: column;\n"], ["\n  @media (max-width: ", "px) {\n    width: 230px;\n    height: ", ";\n    top: 28%;\n  }\n  width: 240px;\n  height: ", ";\n  align-items: center;\n  padding-top: 9px;\n  background: ", ";\n  border-radius: 8px;\n  z-index: 1042;\n  position: absolute;\n  top: ", ";\n  left: 50%;\n  transform: translateX(-50%);\n  flex-direction: column;\n"])), BREAKPOINTS[1], function (props) { return (props.isAreaNotSupported ? '68px' : "57px"); }, function (props) { return (props.isAreaNotSupported ? '76px' : "60px"); }, function (props) { return (props.isAreaNotSupported ? COLORS.LIGHT_RED : COLORS.COFFEE_BLACK); }, function (props) { return (props.isAreaNotSupported ? '31%' : '33%'); });
var AddressInfoLabel = styled.label(templateObject_19$7 || (templateObject_19$7 = __makeTemplateObject$1(["\n  text-align: center;\n  color: ", ";\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  text-align: center;\n  color: ", ";\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n"])), COLORS.WHITE, sharedStyle, TYPOGRAPHY.WEIGHT[700], TYPOGRAPHY.SIZE[12], TYPOGRAPHY.SIZE[16]);
var AddressInfoText = styled.span(templateObject_20$6 || (templateObject_20$6 = __makeTemplateObject$1(["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin-top: 5px;\n"], ["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin-top: 5px;\n"])), sharedStyle, TYPOGRAPHY.WEIGHT[400], TYPOGRAPHY.SIZE[12], TYPOGRAPHY.SIZE[16], COLORS.WHITE);
var CancelIconContainer = styled(Box)(templateObject_21$5 || (templateObject_21$5 = __makeTemplateObject$1(["\n  background-color: ", ";\n  height: 14px;\n  width: 14px;\n  border-radius: 7px;\n"], ["\n  background-color: ", ";\n  height: 14px;\n  width: 14px;\n  border-radius: 7px;\n"])), COLORS.WHITE);
var RadioButtonStyle$1 = customStyled(Box)(templateObject_22$5 || (templateObject_22$5 = __makeTemplateObject$1(["\n  input[type='radio'] {\n    accent-color: ", ";\n    width: 15px;\n    height: 15px;\n    vertical-align: -webkit-baseline-middle;\n    position: relative;\n    margin: 0 10px 0 0;\n  }\n  span {\n    ", "\n    font-weight: ", ";\n    font-size: ", " ;\n    line-height: ", ";\n    color: ", ";\n    text-transform: capitalize;\n"], ["\n  input[type='radio'] {\n    accent-color: ", ";\n    width: 15px;\n    height: 15px;\n    vertical-align: -webkit-baseline-middle;\n    position: relative;\n    margin: 0 10px 0 0;\n  }\n  span {\n    ", "\n    font-weight: ", ";\n    font-size: ", " ;\n    line-height: ", ";\n    color: ", ";\n    text-transform: capitalize;\n"])), COLORS.BLUE, sharedStyle, function (props) { return props.theme.fontWeights[4]; }, function (props) { return props.theme.fontSizes[3]; }, TYPOGRAPHY.SIZE[24], COLORS.BLACK);
var AddressInfo = styled(Box)(templateObject_23$4 || (templateObject_23$4 = __makeTemplateObject$1(["\n  border-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  border-top-width: 0;\n  border-color: #b2b2b2;\n  border-style: solid;\n"], ["\n  border-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  border-top-width: 0;\n  border-color: #b2b2b2;\n  border-style: solid;\n"])));
var CurrentlySelectedContainer = styled(Box)(templateObject_24$3 || (templateObject_24$3 = __makeTemplateObject$1(["\n  position: absolute;\n  bottom: 16px;\n  left: 25px;\n  right: 25px;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  bottom: 16px;\n  left: 25px;\n  right: 25px;\n  background-color: ", ";\n"])), COLORS.WHITE);
var CurrentlySelectedLabel = customStyled.div(templateObject_25$3 || (templateObject_25$3 = __makeTemplateObject$1(["\n  ", "\n  font-weight: ", "; \n  font-size: ", ";  \n  line-height: ", ";\n  color: ", ";\n"], ["\n  ", "\n  font-weight: ", "; \n  font-size: ", ";  \n  line-height: ", ";\n  color: ", ";\n"])), sharedStyle, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.fontSizes[2]; }, TYPOGRAPHY.SIZE[20], COLORS.BLACK);
var OutofServiceLabel = styled.div(templateObject_26$3 || (templateObject_26$3 = __makeTemplateObject$1(["\n  ", "\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"], ["\n  ", "\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"])), sharedStyle, TYPOGRAPHY.SIZE[14], TYPOGRAPHY.SIZE[20], COLORS.BLACK);
var DrawerContainer = styled(Flex)(templateObject_27$3 || (templateObject_27$3 = __makeTemplateObject$1(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transition: 0.3s all;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transition: 0.3s all;\n"])));
DrawerContainer.defaultProps = {
    px: 16,
};
var MapContainer = styled(DrawerContainer)(templateObject_28$2 || (templateObject_28$2 = __makeTemplateObject$1(["\n  transform: ", ";\n"], ["\n  transform: ", ";\n"])), function (props) { return (props.open ? "translateX(0)" : "translateX(-100%)"); });
var FormContainer$1 = styled(DrawerContainer)(templateObject_29$1 || (templateObject_29$1 = __makeTemplateObject$1(["\n  transform: ", ";\n"], ["\n  transform: ", ";\n"])), function (props) { return (props.open ? "translateX(0)" : "translateX(100%)"); });
var DrawerHeader$1 = styled(Box)(templateObject_30$1 || (templateObject_30$1 = __makeTemplateObject$1(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), TYPOGRAPHY.SIZE[16]);
var DrawerIconContainer = styled(Button$1)(templateObject_31$1 || (templateObject_31$1 = __makeTemplateObject$1(["\n  padding: 0px;\n  position: absolute;\n  left: -18px;\n  height: 38px;\n  width: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  border-radius: 50%;\n  top: 33px;\n  transform: translateY(-50%);\n\n  @media (max-width: ", ") {\n    left: unset;\n    right: 20px;\n    top: -2px;\n  }\n"], ["\n  padding: 0px;\n  position: absolute;\n  left: -18px;\n  height: 38px;\n  width: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  border-radius: 50%;\n  top: 33px;\n  transform: translateY(-50%);\n\n  @media (max-width: ", ") {\n    left: unset;\n    right: 20px;\n    top: -2px;\n  }\n"])), function (props) { return props.theme.colors.white; }, function (props) { return props.theme.breakpoints[1]; });
var HeaderTitle = customStyled(Flex)(templateObject_32$1 || (templateObject_32$1 = __makeTemplateObject$1(["\n  width: 332px;\n  height: 32px;\n  ", "\n  font-weight: ", "; \n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  position: relative;\n  left: 13px;\n  @media (max-width: ", "px) {\n    font-size: ", ";\n    left: 53px;\n  }\n"], ["\n  width: 332px;\n  height: 32px;\n  ", "\n  font-weight: ", "; \n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  position: relative;\n  left: 13px;\n  @media (max-width: ", "px) {\n    font-size: ", ";\n    left: 53px;\n  }\n"])), sharedStyle, function (props) { return props.theme.fontWeights[5]; }, TYPOGRAPHY.SIZE[22], TYPOGRAPHY.SIZE[32], COLORS.BLACK, BREAKPOINTS[1], TYPOGRAPHY.SIZE[18]);
var LoginLinkText = styled(Box)(templateObject_33$1 || (templateObject_33$1 = __makeTemplateObject$1(["\n  font-size: ", ";\n  color: ", ";\n  font-weight: ", ";\n"], ["\n  font-size: ", ";\n  color: ", ";\n  font-weight: ", ";\n"])), TYPOGRAPHY.SIZE[16], function (props) { return (props.isLink ? COLORS.BLUE : COLORS.THUNDORA); }, function (props) { return (props.isLink ? '500' : '400'); });
var FlagIcon = styled.img(templateObject_34$1 || (templateObject_34$1 = __makeTemplateObject$1(["\n  min-height: ", ";\n  max-height: ", ";\n  min-width: ", ";\n  max-width: ", ";\n"], ["\n  min-height: ", ";\n  max-height: ", ";\n  min-width: ", ";\n  max-width: ", ";\n"])), TYPOGRAPHY.SIZE[16], TYPOGRAPHY.SIZE[16], TYPOGRAPHY.SIZE[16], TYPOGRAPHY.SIZE[16]);
var GoogleMapBox = styled(Box)(templateObject_35$1 || (templateObject_35$1 = __makeTemplateObject$1(["\n  position: relative;\n  flex: 1;\n"], ["\n  position: relative;\n  flex: 1;\n"])));
var GoogleMapFlex = styled(Flex)(templateObject_36$1 || (templateObject_36$1 = __makeTemplateObject$1(["\n  position: relative;\n  height: ", ";\n"], ["\n  position: relative;\n  height: ", ";\n"])), function (props) { return (props.isMobile ? '100%' : '350'); });
var LeftBox = styled(Box)(templateObject_37$1 || (templateObject_37$1 = __makeTemplateObject$1(["\n  width: 35%;\n"], ["\n  width: 35%;\n"])));
var RightBox = styled(Box)(templateObject_38$1 || (templateObject_38$1 = __makeTemplateObject$1(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), function (props) { return (props.fullWidth ? '100%' : '63%'); });
var Verified = styled(Box)(templateObject_39$1 || (templateObject_39$1 = __makeTemplateObject$1(["\n  color: ", ";\n  min-width: 140px;\n  text-align: right;\n"], ["\n  color: ", ";\n  min-width: 140px;\n  text-align: right;\n"])), COLORS.GREEN);
var Verify = styled(Button$1)(templateObject_40 || (templateObject_40 = __makeTemplateObject$1(["\n  padding: 8px;\n  margin-bottom: 2px;\n"], ["\n  padding: 8px;\n  margin-bottom: 2px;\n"])));
var CountrySvgContainer$1 = styled(Flex)(templateObject_41 || (templateObject_41 = __makeTemplateObject$1(["\n  min-width: 20px;\n  max-width: 20px;\n  margin-bottom: -15px;\n  align-self: center;\n"], ["\n  min-width: 20px;\n  max-width: 20px;\n  margin-bottom: -15px;\n  align-self: center;\n"])));
var StreetNameBox = styled(Box)(templateObject_42 || (templateObject_42 = __makeTemplateObject$1(["\n  display: ", ";\n"], ["\n  display: ", ";\n"])), function (props) { return (props.isDisplay ? 'block' : 'none'); });
var DeliverTo = styled(Button$1)(templateObject_43 || (templateObject_43 = __makeTemplateObject$1(["\n  color: ", ";\n  font-weight: ", ";\n  height: 48px;\n  width: ", ";\n  @media (max-width: ", "px) {\n    width: 262px;\n    margin-left: 3%;\n  }\n  font-family: Montserrat;\n  border-radius: 8px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-top: 13px;\n  line-height: 20px;\n  border-color: ", ";\n  background-color: ", ";\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  height: 48px;\n  width: ", ";\n  @media (max-width: ", "px) {\n    width: 262px;\n    margin-left: 3%;\n  }\n  font-family: Montserrat;\n  border-radius: 8px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-top: 13px;\n  line-height: 20px;\n  border-color: ", ";\n  background-color: ", ";\n"])), COLORS.WHITE, TYPOGRAPHY.WEIGHT[700], function (props) { return props.width; }, BREAKPOINTS[1], COLORS.WHITE, COLORS.BLUE);
var Back = customStyled(Button$1)(templateObject_44 || (templateObject_44 = __makeTemplateObject$1(["\n  font-weight: ", "; \n  padding: 25px;\n  ", "\n  font-size: ", ";\n  margin-top: 2%;\n"], ["\n  font-weight: ", "; \n  padding: 25px;\n  ", "\n  font-size: ", ";\n  margin-top: 2%;\n"])), function (props) { return props.theme.fontWeights[5]; }, sharedStyle, function (props) { return props.theme.fontSizes[2]; });
var SelectedLocationWrapper = styled.div(templateObject_45 || (templateObject_45 = __makeTemplateObject$1(["\n  padding-right: 10px;\n"], ["\n  padding-right: 10px;\n"])));
var SelectedLocationContainer = styled(Flex)(templateObject_46 || (templateObject_46 = __makeTemplateObject$1(["\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  align-items: center;\n  justify-content: space-between;\n"])));
var SelectedLocation = customStyled.div(templateObject_47 || (templateObject_47 = __makeTemplateObject$1(["\n  color: ", ";\n  font-weight: ", ";\n  ", "\n  font-size: ", ";\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  ", "\n  font-size: ", ";\n"])), COLORS.BLACK, function (props) { return props.theme.fontWeights[6]; }, sharedStyle, function (props) { return props.theme.fontSizes[2]; });
var SelectedLocationLabel = customStyled.div(templateObject_48 || (templateObject_48 = __makeTemplateObject$1(["\n  margin-top: 3%;\n  color: ", ";\n  font-size: ", "; \n  ", "\n"], ["\n  margin-top: 3%;\n  color: ", ";\n  font-size: ", "; \n  ", "\n"])), COLORS.BLACK, function (props) { return props.theme.fontSizes[2]; }, sharedStyle);
var ChangeLocation = customStyled(Button$1)(templateObject_49 || (templateObject_49 = __makeTemplateObject$1(["\n  width:108px\n  height:40px\n  ", "\n  border-radius: 12px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  font-weight: ", "; \n  line-height: 20px;\n  border-color: ", ";\n  color: ", ";\n"], ["\n  width:108px\n  height:40px\n  ", "\n  border-radius: 12px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  font-weight: ", "; \n  line-height: 20px;\n  border-color: ", ";\n  color: ", ";\n"])), sharedStyle, function (props) { return props.theme.fontWeights[5]; }, COLORS.WHITE, COLORS.BLUE);
var RequiredField = styled(Flex)(templateObject_50 || (templateObject_50 = __makeTemplateObject$1(["\n  flex-direction: column;\n  align-items: flex-end;\n"], ["\n  flex-direction: column;\n  align-items: flex-end;\n"])));
var RequiredFieldText = styled.span(templateObject_51 || (templateObject_51 = __makeTemplateObject$1(["\n  ", "\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 3%;\n  margin-right: -3%;\n"], ["\n  ", "\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 3%;\n  margin-right: -3%;\n"])), sharedStyle);
var HintText = styled(Text)(templateObject_52 || (templateObject_52 = __makeTemplateObject$1(["\n  ", "\n  padding-left: 5px;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #ce3637;\n"], ["\n  ", "\n  padding-left: 5px;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #ce3637;\n"])), sharedStyle);
var HintWrapper = styled(Flex)(templateObject_53 || (templateObject_53 = __makeTemplateObject$1(["\n  flex-direction: row;\n  margin-top:4px;\n  margin-left 2px;\n"], ["\n  flex-direction: row;\n  margin-top:4px;\n  margin-left 2px;\n"])));
var templateObject_1$T, templateObject_2$J, templateObject_3$A, templateObject_4$u, templateObject_5$n, templateObject_6$i, templateObject_7$h, templateObject_8$h, templateObject_9$g, templateObject_10$g, templateObject_11$d, templateObject_12$c, templateObject_13$c, templateObject_14$c, templateObject_15$c, templateObject_16$9, templateObject_17$9, templateObject_18$7, templateObject_19$7, templateObject_20$6, templateObject_21$5, templateObject_22$5, templateObject_23$4, templateObject_24$3, templateObject_25$3, templateObject_26$3, templateObject_27$3, templateObject_28$2, templateObject_29$1, templateObject_30$1, templateObject_31$1, templateObject_32$1, templateObject_33$1, templateObject_34$1, templateObject_35$1, templateObject_36$1, templateObject_37$1, templateObject_38$1, templateObject_39$1, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53;
var rearrangeAddressList = function (addressList, selectedAddress) {
    var e_1, _a;
    var newRearrangedAddressList = [];
    try {
        for (var addressList_1 = __values$1(addressList), addressList_1_1 = addressList_1.next(); !addressList_1_1.done; addressList_1_1 = addressList_1.next()) {
            var address = addressList_1_1.value;
            if (selectedAddress.id === address.id) {
                newRearrangedAddressList.unshift(selectedAddress);
                continue;
            }
            newRearrangedAddressList.push(address);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (addressList_1_1 && !addressList_1_1.done && (_a = addressList_1.return)) _a.call(addressList_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return newRearrangedAddressList;
};
var getSubLocalityAsTown = function (result) {
    var e_2, _a;
    var addressComponents = result.address_components || [];
    var town = '', sublocality, neighborhood, locality, administrativeArea;
    try {
        for (var addressComponents_1 = __values$1(addressComponents), addressComponents_1_1 = addressComponents_1.next(); !addressComponents_1_1.done; addressComponents_1_1 = addressComponents_1.next()) {
            var addressComponent = addressComponents_1_1.value;
            var types = addressComponent.types || [];
            sublocality = types.includes('sublocality') ? addressComponent.long_name : sublocality;
            neighborhood = types.includes('neighborhood') ? addressComponent.long_name : neighborhood;
            administrativeArea = types.includes('administrative_area') ? addressComponent.long_name : administrativeArea;
            locality = types.includes('locality') ? addressComponent.long_name : locality;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (addressComponents_1_1 && !addressComponents_1_1.done && (_a = addressComponents_1.return)) _a.call(addressComponents_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    town = sublocality || neighborhood || administrativeArea || locality;
    return town;
};
var getCountryCodeFromGoogleReponse = function (result) {
    var e_3, _a;
    var addressComponents = result.address_components || [];
    var country = '';
    try {
        for (var addressComponents_2 = __values$1(addressComponents), addressComponents_2_1 = addressComponents_2.next(); !addressComponents_2_1.done; addressComponents_2_1 = addressComponents_2.next()) {
            var addressComponent = addressComponents_2_1.value;
            var types = addressComponent.types || [];
            if (types.indexOf('country') !== -1) {
                country = addressComponent.short_name;
                break;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (addressComponents_2_1 && !addressComponents_2_1.done && (_a = addressComponents_2.return)) _a.call(addressComponents_2);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return country;
};
var extractEmirateFromGoogleResponse = function (result) {
    var e_4, _a;
    var addressComponents = (result === null || result === void 0 ? void 0 : result.address_components) || [];
    var administrativeArea, locality;
    try {
        for (var addressComponents_3 = __values$1(addressComponents), addressComponents_3_1 = addressComponents_3.next(); !addressComponents_3_1.done; addressComponents_3_1 = addressComponents_3.next()) {
            var addressComponent = addressComponents_3_1.value;
            var types = addressComponent.types || [];
            administrativeArea = types.includes('administrative_area_level_1')
                ? addressComponent.long_name
                : administrativeArea;
            locality = types.includes('locality') ? addressComponent.long_name : locality;
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (addressComponents_3_1 && !addressComponents_3_1.done && (_a = addressComponents_3.return)) _a.call(addressComponents_3);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return administrativeArea || locality || '';
};
var formattedGoogleAddressDescription = function (address, alternativeAddress, country) {
    if (address === void 0) { address = ''; }
    if (alternativeAddress === void 0) { alternativeAddress = ''; }
    if (country === void 0) { country = ''; }
    var addressDescriptionComponents = address ? address.split(' - ') : [];
    var filteredComponents = addressDescriptionComponents.filter(function (component) {
        var _a;
        var comp = component.toLowerCase();
        return !(comp.includes('+') ||
            comp.includes('untitled') ||
            comp.includes('unknown') ||
            comp.includes('unnamed') ||
            comp.includes((_a = country === null || country === void 0 ? void 0 : country.toLowerCase()) !== null && _a !== void 0 ? _a : ''));
    });
    if (!filteredComponents.length) {
        return [alternativeAddress || '', country || ''].join(', ');
    }
    return filteredComponents.join(', ');
};
var mapStyles = function (isMobile, isSelected) { return ({
    width: '100%',
    height: isMobile ? 'inherit' : '',
    opacity: isSelected ? '1' : '0.1',
    zIndex: isSelected ? '0' : '-2',
}); };
var Address = function (_a) {
    var isAreaNotSupported = _a.isAreaNotSupported;
    var t = useTranslation().t;
    return (React.createElement(AddressInfoCard, { isAreaNotSupported: isAreaNotSupported },
        React.createElement(AddressInfoLabel, null, isAreaNotSupported ? t('address.notServiceable') : t('address.deliverTo')),
        React.createElement(AddressInfoText, null, isAreaNotSupported ? t('address.otherLocation') : t('address.movePin'))));
};
var GoogleMapBase = function (props) {
    var location = props.location, google = props.google, fetchMapCoordinates = props.fetchMapCoordinates,
    flatNo = props.flatNo, building = props.building, landmark = props.landmark,
    checkCoverageArea = props.checkCoverageArea, countryConfig = props.countryConfig, isMobile = props.isMobile, setAddressInfo = props.setAddressInfo, setTown = props.setTown, setLatLng = props.setLatLng, setCountry = props.setCountry, addressInfo = props.addressInfo, setEmirate = props.setEmirate, isSelected = props.isSelected, setIsSelected = props.setIsSelected, setZoom = props.setZoom, hideFlatNo = props.hideFlatNo, isAreaNotSupported = props.isAreaNotSupported, editInfo = props.editInfo;
    var countryOfOperationID = countryConfig.countryOfOperationID;
    var _a = __read$1(useState(), 2), mapInstance = _a[0], setMapInstance = _a[1];
    var _b = __read$1(useState(function () {
        var lat = Number(getCustomCookie('lat'));
        var lng = Number(getCustomCookie('long'));
        return isNaN(lat) || isNaN(lng) ? location : { lat: lat, lng: lng };
    }), 2), updatedLocation = _b[0], setUpdatedLocation = _b[1];
    var geocoder = useMemo(function () { return new google.maps.Geocoder(); }, [google]);
    var options = countryOfOperationID
        ? {
            componentRestrictions: { country: countryOfOperationID },
        }
        : {};
    var storage = initStorageManager(function () { return localStorage; });
    var setFormattedAddress = useCallback(function (_a, forceUpdate) {
        var _b, _c;
        var lat = _a.lat, lng = _a.lng;
        var storedResults = storage.getItem('geocode_results');
        if (!storedResults || (storedResults.lat !== lat && storedResults.lng !== lng) || forceUpdate) {
            geocoder.geocode({ location: { lat: lat, lng: lng } }, function (results, status) {
                var _a, _b;
                if (status === 'OK') {
                    if (results === null || results === void 0 ? void 0 : results.length) {
                        setAddressInfo && setAddressInfo(((_a = results[1]) === null || _a === void 0 ? void 0 : _a.formatted_address) || ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.formatted_address));
                        setTown && setTown(getSubLocalityAsTown(results[0]));
                        setCountry && setCountry(getCountryCodeFromGoogleReponse(results[0]));
                        setEmirate && setEmirate(extractEmirateFromGoogleResponse(results[0]));
                        setIsSelected(true);
                        setLatLng && setLatLng({ latitude: lat, longitude: lng });
                        storage.setItem('geocode_results', { results: results, lat: lat, lng: lng });
                    }
                    else {
                        console.error('No results found');
                    }
                }
                else {
                    console.error('Geocoder failed due to: ' + status);
                }
            });
        }
        else {
            var _d = storedResults.results, results = _d === void 0 ? [] : _d;
            setAddressInfo && setAddressInfo(((_b = results[1]) === null || _b === void 0 ? void 0 : _b.formatted_address) || ((_c = results[0]) === null || _c === void 0 ? void 0 : _c.formatted_address));
            setTown && setTown(getSubLocalityAsTown(results[0]));
            setCountry && setCountry(getCountryCodeFromGoogleReponse(results[0]));
            setEmirate && setEmirate(extractEmirateFromGoogleResponse(results[0]));
            setLatLng && setLatLng({ latitude: updatedLocation.lat, longitude: updatedLocation.lng });
        }
    }, [geocoder, setAddressInfo, setTown, setCountry, setLatLng, updatedLocation]);
    var clearAutoComplete = function () {
        var autocompInp = document.getElementById('pac-input-add-address');
        if (autocompInp) {
            autocompInp.value = '';
        }
    };
    useEffect(function () {
        if (mapInstance) {
            mapInstance.panTo(updatedLocation);
            mapInstance.setZoom(16);
        }
    }, [updatedLocation.lat, updatedLocation.lng, mapInstance]);
    useEffect(function () {
        setUpdatedLocation({ lat: location === null || location === void 0 ? void 0 : location.lat, lng: location === null || location === void 0 ? void 0 : location.lng });
        if (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) {
            setFormattedAddress({ lat: location === null || location === void 0 ? void 0 : location.lat, lng: location === null || location === void 0 ? void 0 : location.lng }, false);
        }
    }, [editInfo === null || editInfo === void 0 ? void 0 : editInfo.id]);
    var onReady = useCallback(function (_a, map) {
        var google = _a.google;
        var autocomplete = new google.maps.places.Autocomplete(document.getElementById('pac-input-add-address'), __assign$1(__assign$1({}, options), { fields: ['geometry', 'place_id', 'formatted_address'], types: ['establishment'] }));
        autocomplete.bindTo('bounds', map);
        autocomplete.addListener('place_changed', function () {
            var _a, _b;
            var place = autocomplete.getPlace();
            if (!(((_a = place === null || place === void 0 ? void 0 : place.geometry) === null || _a === void 0 ? void 0 : _a.viewport) || ((_b = place === null || place === void 0 ? void 0 : place.geometry) === null || _b === void 0 ? void 0 : _b.location)))
                return;
            if (place.geometry.viewport) {
                map.fitBounds(place.geometry.viewport);
            }
            var _c = place.geometry.location, location = _c === void 0 ? null : _c;
            var lat = location && location.lat();
            var lng = location && location.lng();
            if (lat && lng) {
                fetchMapCoordinates({ latitude: lat, longitude: lng });
                setUpdatedLocation({ lat: lat, lng: lng });
                setFormattedAddress({ lat: lat, lng: lng }, true);
            }
        });
        setMapInstance(map);
    }, [options]);
    var onCenterChanged = function (_mapProps, map) {
        var centerLat = map.getCenter().lat();
        var centerLng = map.getCenter().lng();
        var latLngChanged = updatedLocation.lat !== centerLat || updatedLocation.lng !== centerLng;
        if (latLngChanged) {
            setUpdatedLocation({ lat: centerLat, lng: centerLng });
            setFormattedAddress({ lat: centerLat, lng: centerLng }, true);
        }
        else {
            setFormattedAddress({ lat: centerLat, lng: centerLng }, false);
        }
        setZoom && setZoom(map.getZoom());
        checkCoverageArea({ lat: centerLat, lng: centerLng });
    };
    var onZoomChanged = function (_mapProps, map) {
        var lat = updatedLocation.lat, lng = updatedLocation.lng;
        setZoom && setZoom(map.getZoom());
        checkCoverageArea({ lat: lat, lng: lng });
    };
    var onDragStart = function () {
        setAddressInfo && setAddressInfo('');
        setTown && setTown('');
        setCountry && setCountry('');
        clearAutoComplete();
    };
    return (React.createElement(Box, { style: { height: isMobile ? 'inherit' : 350 } },
        React.createElement(Map$1, { onReady: onReady, onDragend: onCenterChanged, onDragstart: onDragStart, onZoomChanged: onZoomChanged, google: google, style: mapStyles(isMobile, isSelected), initialCenter: updatedLocation,
            mapTypeControl: false, streetViewControl: false, fullscreenControl: false, zoomControl: !isMobile, zoomControlOptions: { position: google.maps.ControlPosition.LEFT_BOTTOM } }),
        isSelected && (React.createElement(Address, { isAreaNotSupported: isAreaNotSupported, addressInfo: addressInfo, flatNo: flatNo, building: building, landmark: landmark, hideFlatNo: hideFlatNo }))));
};
var GoogleMap = GoogleApiWrapper(function (props) { return ({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    language: props.appConfig.language,
}); })(GoogleMapBase);
var StaticMapBase = function (_a) {
    var google = _a.google, location = _a.location, restProps = __rest$1(_a, ["google", "location"]);
    return (React.createElement(Map$1, __assign$1({ google: google, initialCenter: location, mapTypeControl: false, streetViewControl: false, fullscreenControl: false, zoomControl: false, draggable: false }, restProps)));
};
var StaticMap = GoogleApiWrapper({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
})(StaticMapBase);
var customLabel = function (t) { return t('address.other'); };
var AddressLabels = function (t) { return [t('address.home'), t('address.office'), t('address.other')]; };
var CustomLabel = customLabel;
var isNumberValid = function (phoneNumber, countryCode) {
    try {
        var phoneUtil = PhoneNumberUtil.getInstance();
        var number = phoneUtil.parseAndKeepRawInput(phoneNumber, countryCode);
        var regionCode = phoneUtil.getRegionCodeForNumber(number);
        var isValidNumber = phoneUtil.isValidNumberForRegion(number, regionCode || countryCode);
        return isValidNumber;
    }
    catch (error) {
        console.error('error', error);
        return false;
    }
};
var countryCodeShaper = function (phone) {
    var phoneUtil = PhoneNumberUtil.getInstance();
    try {
        var phoneNumber = phoneUtil.parse(phone);
        var countryCode = phoneNumber.getCountryCode();
        return "+" + countryCode;
    }
    catch (e) {
        console.error('Invalid phone number:', e);
    }
};
var Paragraph$2 = Text.Paragraph;
var AddressLabel = function (_a) {
    var setAddressLabel = _a.setAddressLabel, register = _a.register, errors = _a.errors, t = _a.t, defaultAddressLabel = _a.defaultAddressLabel, backgroundColor = _a.backgroundColor, addressLabels = _a.addressLabels, isShowCustomField = _a.isShowCustomField;
    var defaultAddresslbl = defaultAddressLabel
        ? addressLabels(t).indexOf(defaultAddressLabel) === -1
            ? CustomLabel(t)
            : defaultAddressLabel
        : '';
    var _b = __read$1(useState(defaultAddresslbl), 2), selectedLabel = _b[0], setSelectedLabel = _b[1];
    var onLabelSelection = function (label) { return function () {
        if (selectedLabel === label) {
            setSelectedLabel('');
            setAddressLabel('');
        }
        else {
            setSelectedLabel(label);
            setAddressLabel(label.toLowerCase());
        }
    }; };
    var isCustomSelected = selectedLabel === CustomLabel(t);
    return (React.createElement(Box, { mt: 16 },
        React.createElement(LabelHeading, null, t('address.addressLabel')),
        React.createElement(Flex, { mt: 12 }, addressLabels(t).map(function (label, index) { return (React.createElement(Flex, { "data-testid": label + "-label", key: index + "__address_label", flexDirection: "row", style: {
                padding: '12px',
                textTransform: 'capitalize',
            } },
            React.createElement(RadioButtonStyle$1, null,
                React.createElement(Flex, { alignItems: "center" },
                    React.createElement("input", { type: "radio", name: "address-label", value: label, defaultChecked: selectedLabel === label, onChange: onLabelSelection(label) }),
                    label)))); })),
        isCustomSelected && isShowCustomField && (React.createElement(React.Fragment, null,
            React.createElement(Input, { mui: true, testid: 'custom-label-field', defaultValue: defaultAddressLabel, label: t('address.nickname'), color: COLORS.BLUE, name: "addressLabel", register: register({
                    required: t('address.requiredField'),
                    minLength: 1,
                    maxLength: 255,
                }), backgroundColor: backgroundColor }),
            errors.addressLabel && (React.createElement(Paragraph$2, { color: COLORS.RED, mt: 1, fontSize: TYPOGRAPHY.SIZE[10] }, errors.addressLabel.message))))));
};
AddressLabel.defaultProps = {
    backgroundColor: COLORS.WHITE,
    addressLabels: AddressLabels,
    isShowCustomField: true,
};
var AddressLabel$1 = withTranslation()(AddressLabel);
var setCountryPhoneCodesData = function (countryPhoneCodesData) {
    return {
        type: NewAddressType$1.COUNTRIES_GET,
        payload: countryPhoneCodesData,
    };
};
var setCountryPhoneCodesError = function (_a) {
    return {
        type: NewAddressType$1.COUNTRIES_SET_ERROR,
        payload: [],
    };
};
var fetchCitiesAndAreasAction = function () {
    return {
        type: NewAddressType$1.FETCH_CITIES_AND_AREAS,
        payload: {
            method: EApiMiddlewareMethod$1.GET,
            url: GET_DELIVERY_AREAS,
        },
    };
};
var fetchCountriesAction = function () { return function (dispatch) {
    dispatch({
        type: NewAddressType$1.COUNTRIES_GET,
        payload: {
            apiVersion: 1,
            method: EApiMiddlewareMethod$1.GET,
            url: GET_COUNTRIES_API,
            onSuccess: function (data) {
                dispatch(setCountryPhoneCodesData(data.data));
            },
            onFailure: function (_a) {
                dispatch(setCountryPhoneCodesError());
            },
        },
    });
}; };
var updateLocation = function (cityData) {
    return {
        type: NewAddressType$1.UPDATE_LOCAION_DATA,
        payload: cityData,
    };
};
var useAddress = function (t) {
    var _a = useSelector(function (state) {
        var _a;
        return {
            citiesAndAreaState: state.userData.addresses.deliveryAreas,
            qatarCitiesAndAreaState: state.area,
            userProfile: state.userData,
            addressList: state.userData.addresses.list,
            error: state.userData.addresses.error,
            appConfig: state.appConfig,
            isAddressProcessing: state.userData.addresses.showLoader,
            countryPhoneCodesData: (_a = state.countries) === null || _a === void 0 ? void 0 : _a.allCountries,
        };
    }), citiesAndAreaState = _a.citiesAndAreaState, qatarCitiesAndAreaState = _a.qatarCitiesAndAreaState, error = _a.error, userProfile = _a.userProfile, addressList = _a.addressList, appConfig = _a.appConfig, isAddressProcessing = _a.isAddressProcessing, countryPhoneCodesData = _a.countryPhoneCodesData;
    var dispatch = useDispatch();
    var addNEditAddress = useCallback(function (formData, editInfo, setIsSubmitBtnDisabled) {
        userAddNEditAddress(formData, editInfo, setIsSubmitBtnDisabled)(dispatch);
        dispatch(init({
            changingLocation: true,
        }));
    }, [dispatch]);
    var addNEditAddressWithArea = useCallback(function (formData, editInfo) {
        userAddNEditAddressWithArea(__assign$1({}, formData), editInfo)(dispatch);
        dispatch(init({
            changingLocation: true,
        }));
    }, [dispatch]);
    var fetchCitiesAndAreas = useCallback(function () { return dispatch(fetchCitiesAndAreasAction()); }, [dispatch]);
    var fetchCitiesZonesAndAreas = useCallback(function () { return dispatch(fetchAddressCitiesAndAreasAction()); }, [dispatch]);
    var fetchCountries = useCallback(function () { return dispatch(fetchCountriesAction()); }, [dispatch]);
    var isCityAvailableInList = useCallback(function (value) {
        var isValidCityName = false;
        isValidCityName = citiesAndAreaState && citiesAndAreaState.find(function (_a) {
            var name = _a.name;
            return isLocaleStrEqual(name, value);
        });
        return isValidCityName;
    }, [citiesAndAreaState]);
    var isQatarCityAvailableInList = useCallback(function (value) {
        var isValidCityName = false;
        var qatarCities = qatarCitiesAndAreaState.qatarCities;
        isValidCityName =
            qatarCities &&
                qatarCities.cities &&
                qatarCities.cities.find(function (_a) {
                    var cityNameEN = _a.cityNameEN, cityNameAR = _a.cityNameAR;
                    return isLocaleStrEqual(cityNameEN, value) || isLocaleStrEqual(cityNameAR, value);
                });
        return isValidCityName;
    }, [qatarCitiesAndAreaState]);
    var validateCity = useCallback(function (value) { return isCityAvailableInList(value) || t('errorForm.validCity'); }, [
        isCityAvailableInList,
        t,
    ]);
    var validateCityQatar = useCallback(function (value) { return isQatarCityAvailableInList(value) || t('errorForm.validCity'); }, [isQatarCityAvailableInList, t]);
    var validateArea = useCallback(function (areas, value) {
        return areas.find(function (item) { return isLocaleStrEqual(item.name, value); }) || t('errorForm.validArea');
    }, [t]);
    var validateQatarZone = useCallback(function (zones, value) {
        return zones.find(function (item) { return isLocaleStrEqual(item.zoneNo, value); }) || t('errorForm.validArea');
    }, [t]);
    var validateQatarArea = useCallback(function (areas, value) {
        return (areas.find(function (item) { return isLocaleStrEqual(item.areaNameEN, value) || isLocaleStrEqual(item.areaNameAR, value); }) || t('errorForm.validArea'));
    }, [t]);
    var isPhoneVerified = function (phoneNumber, callback) {
        var isPhoneVerified = false;
        if ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone) === phoneNumber && (userProfile === null || userProfile === void 0 ? void 0 : userProfile.isPhoneVerified)) {
            isPhoneVerified = true;
        }
        isPhoneVerified = !isPhoneVerified
            ? addressList.some(function (address) {
                return address.phone === phoneNumber && address.isPhoneVerified === true;
            })
            : isPhoneVerified;
        if (!isPhoneVerified) {
            userAddressPhoneVerify(phoneNumber, function (res) {
                var _a;
                isPhoneVerified = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.isPhoneVerified) === true;
                callback(isPhoneVerified);
            })(dispatch);
        }
        else {
            callback(isPhoneVerified);
        }
    };
    var phoneNumberShaper = function (phone, isInternationalNumberFeature) {
        var countryCodeResult = (appConfig === null || appConfig === void 0 ? void 0 : appConfig.phoneCountryCode) || '';
        if (isInternationalNumberFeature) {
            countryCodeResult = countryCodeShaper(phone) || '';
        }
        var countryCode = (countryCodeResult === null || countryCodeResult === void 0 ? void 0 : countryCodeResult.replace('+', '')) || '';
        var countryRegex = new RegExp(String(appConfig === null || appConfig === void 0 ? void 0 : appConfig.phoneExpression), 'ig');
        var modifiedPhone = (phone === null || phone === void 0 ? void 0 : phone.trim().replace('+', '')) || '';
        modifiedPhone = modifiedPhone.startsWith(countryCode) ? modifiedPhone.replace(countryCode, '') : modifiedPhone;
        if (!isInternationalNumberFeature) {
            modifiedPhone = modifiedPhone.match(countryRegex) ? modifiedPhone : '';
        }
        return modifiedPhone;
    };
    var result = {
        addNEditAddress: addNEditAddress,
        addNEditAddressWithArea: addNEditAddressWithArea,
        fetchCitiesAndAreas: fetchCitiesAndAreas,
        fetchCitiesZonesAndAreas: fetchCitiesZonesAndAreas,
        fetchCountries: fetchCountries,
        error: error,
        citiesAndAreaState: citiesAndAreaState,
        qatarCitiesAndAreaState: qatarCitiesAndAreaState,
        validateCity: validateCity,
        validateCityQatar: validateCityQatar,
        validateArea: validateArea,
        validateQatarArea: validateQatarArea,
        validateQatarZone: validateQatarZone,
        isCityAvailableInList: isCityAvailableInList,
        isQatarCityAvailableInList: isQatarCityAvailableInList,
        userProfile: userProfile,
        isPhoneVerified: isPhoneVerified,
        addressList: addressList,
        phoneNumberShaper: phoneNumberShaper,
        isAddressProcessing: isAddressProcessing,
        countryPhoneCodesData: countryPhoneCodesData,
    };
    return result;
};
var CustomSelect = customStyled(Select)(templateObject_1$U || (templateObject_1$U = __makeTemplateObject$1(["\n&[data-testid='trolly-select']{\n  border: 1px solid ", ";\n  top: 15px;\n  height: 52px;\n  border-radius: 4px;\n}\n\n[data-testid='select-box']{\n  padding: 10px 12px 1px;\n}\nul{min-width:250px; top:60px;} \nul>li {\n  border-bottom:0.5px solid ", ";\n  padding:16px 14px;\n}\n"], ["\n&[data-testid='trolly-select']{\n  border: 1px solid ", ";\n  top: 15px;\n  height: 52px;\n  border-radius: 4px;\n}\n\n[data-testid='select-box']{\n  padding: 10px 12px 1px;\n}\nul{min-width:250px; top:60px;} \nul>li {\n  border-bottom:0.5px solid ", ";\n  padding:16px 14px;\n}\n"])), COLORS.GRAY_500, COLORS.GRAY_100);
var Container$8 = styled(Flex)(templateObject_2$K || (templateObject_2$K = __makeTemplateObject$1(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
var ImageWrapper$1 = styled(Flex)(templateObject_3$B || (templateObject_3$B = __makeTemplateObject$1(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var CountryLabel$1 = customStyled(Flex)(templateObject_4$v || (templateObject_4$v = __makeTemplateObject$1(["\n  font-family: ", ";\n  font-style: normal;\n  font-weight: ", ";\n  font-size: ", "px;\n  flex: 3;\n  text-align: left;\n"], ["\n  font-family: ", ";\n  font-style: normal;\n  font-weight: ", ";\n  font-size: ", "px;\n  flex: 3;\n  text-align: left;\n"])), function (props) { return props.theme.fonts.montserrat; }, function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.fontSizes[1]; });
var CallingCodeLabel$1 = customStyled(Flex)(templateObject_5$o || (templateObject_5$o = __makeTemplateObject$1(["\n  flex:1\n  justify-content: flex-end;\n  font-family: ", ";\n  font-style: normal;\n  font-size:", "px;\n  font-weight: ", ";\n"], ["\n  flex:1\n  justify-content: flex-end;\n  font-family: ", ";\n  font-style: normal;\n  font-size:", "px;\n  font-weight: ", ";\n"])), function (props) { return props.theme.fonts.montserrat; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.fontWeights[7]; });
var templateObject_1$U, templateObject_2$K, templateObject_3$B, templateObject_4$v, templateObject_5$o;
var nonSpaceAlphabetsOnlyRegEx = /^\S[a-zA-Z '.,\u0621-\u064A]+$/;
var addressInputRegex = /^\S[a-zA-Z0-9\s,'-.\u0621-\u064A]*$/;
var numericExpression = /^\d+$/;
var alphanumericCommaPeriodArabic = /[^A-Za-z0-9 ,.ء-ي٠-٩]+/gi;
var AutocompleteContainer = styled(Flex)(templateObject_1$V || (templateObject_1$V = __makeTemplateObject$1(["\n  flex-direction: column;\n"], ["\n  flex-direction: column;\n"])));
var ReferenceElm = styled.div(templateObject_2$L || (templateObject_2$L = __makeTemplateObject$1(["\n  height: 0;\n  width: 100%;\n"], ["\n  height: 0;\n  width: 100%;\n"])));
var ContentWrapper$1 = styled(Flex)(templateObject_3$C || (templateObject_3$C = __makeTemplateObject$1(["\n  padding: ", ";\n  :hover {\n    background-color: ", ";\n  }\n"], ["\n  padding: ", ";\n  :hover {\n    background-color: ", ";\n  }\n"])), SPACINGS[14], COLORS.TRANSPARENT_BLUE);
var DisplayContainer = styled.div(templateObject_4$w || (templateObject_4$w = __makeTemplateObject$1(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), SPACINGS[14]);
var templateObject_1$V, templateObject_2$L, templateObject_3$C, templateObject_4$w;
var defaultProps = {
    label: '',
    onFocus: function () { return void 0; },
    onBlur: function () { return void 0; },
    onSelection: function () { return void 0; },
    values: [],
    value: '',
};
var Autocomplete = function (props) {
    var onFocus = props.onFocus, onBlur = props.onBlur, onSelection = props.onSelection, _a = props.values, values = _a === void 0 ? [] : _a, value = props.value, isLoading = props.isLoading, label = props.label, variant = props.variant, name = props.name, register = props.register, successIcon = props.successIcon, testid = props.testid, used = props.used, defaultValue = props.defaultValue, onChange = props.onChange, rest = __rest$1(props, ["onFocus", "onBlur", "onSelection", "values", "value", "isLoading", "label", "variant", "name", "register", "successIcon", "testid", "used", "defaultValue", "onChange"]);
    var t = useTranslation().t;
    var _b = __read$1(useState(), 2), changeTooltipState = _b[0], setChangeTooltipState = _b[1];
    var _c = __read$1(useState(value), 2), valueLoc = _c[0], onValueChange = _c[1];
    var _d = __read$1(useState(React.createElement(DisplayContainer, null, t('address.notFound'))), 2), contentToShow = _d[0], setContentToShow = _d[1];
    useEffect(function () {
        onValueChange(value);
    }, [value]);
    var getChangeStateMethod = useCallback(function (onOpenHandle) {
        setChangeTooltipState(function () { return onOpenHandle; });
    }, [setChangeTooltipState]);
    var onChangeText = useCallback(function (e) {
        onChange && onChange(e);
        onValueChange(e.target.value);
        if (e.target.value === '') {
            e.currentTarget.blur();
            e.currentTarget.focus();
        }
    }, [onValueChange, onChange]);
    var onFocusHandle = useCallback(function (e) {
        changeTooltipState(true);
        if (onFocus) {
            onFocus(e);
        }
    }, [changeTooltipState, onFocus]);
    var onBlurHandle = useCallback(function (e) {
        changeTooltipState(false);
        if (onBlur) {
            onBlur(e);
        }
    }, [changeTooltipState, onBlur]);
    var onSelectionHandle = useCallback(function (item) { return function () {
        if (item) {
            onValueChange(item.displayName);
            changeTooltipState(false);
            if (onSelection) {
                onSelection(item.value);
            }
        }
        else {
            onValueChange('');
        }
    }; }, [onValueChange, changeTooltipState, onSelection]);
    useEffect(function () {
        if (values && values.length > 0) {
            var content = values
                .filter(function (item) {
                if (!valueLoc) {
                    return true;
                }
                var regEx;
                try {
                    regEx = new RegExp(valueLoc, 'i');
                }
                catch (e) {
                    regEx = new RegExp('');
                }
                return regEx.test(item.displayName);
            })
                .map(function (item) {
                return (React.createElement(ContentWrapper$1, { as: "i", key: item.displayName + "__autocomplete", onClick: onSelectionHandle(item), "data-testid": "add_address_autocomplete_option" }, item.displayName));
            });
            var loading = React.createElement(DisplayContainer, null, t('address.loading'));
            var notFound = React.createElement(DisplayContainer, null, t('address.notFound'));
            var contentOption = content.length < 1 ? notFound : content;
            setContentToShow(isLoading ? loading : contentOption);
        }
    }, [values, isLoading, valueLoc, t, onSelectionHandle]);
    return (React.createElement(AutocompleteContainer, null,
        React.createElement(Input, __assign$1({ mui: true, onChange: onChangeText, onFocus: onFocusHandle, onBlur: onBlurHandle, autoComplete: "nofill", label: label, variant: variant, name: name, register: register, successIcon: successIcon, "data-testid": testid, overrideInternalOptions: { used: !!valueLoc || used }, defaultValue: defaultValue }, rest)),
        React.createElement(Tooltip, { content: contentToShow, getChangeStateMethod: getChangeStateMethod, popupWrapperStyle: { left: 0, zIndex: 9, marginTop: 0, marginLeft: 1, marginRight: 1 }, cardProps: { maxHeight: 200, overflow: 'auto' } },
            React.createElement(ReferenceElm, null))));
};
Autocomplete.defaultProps = defaultProps;
var ELocationKey;
(function (ELocationKey) {
    ELocationKey["city"] = "cityName";
    ELocationKey["area"] = "areaName";
})(ELocationKey || (ELocationKey = {}));
var EFormState;
(function (EFormState) {
    EFormState["success"] = "success";
    EFormState["primary"] = "primary";
})(EFormState || (EFormState = {}));
var EFormKey;
(function (EFormKey) {
    EFormKey["city"] = "city";
    EFormKey["area"] = "area";
    EFormKey["zone"] = "zone";
    EFormKey["street"] = "street";
})(EFormKey || (EFormKey = {}));
var getCitiesValue = function (values) {
    var validCities = values.filter(function (item) { return item.areas; });
    return validCities.map(function (item) {
        return {
            displayName: item.name,
            value: item,
        };
    });
};
var getAreaValue = function (values) {
    var validAreas = values.filter(function (item) { return item.name; });
    return validAreas.map(function (item) {
        return {
            displayName: item.name,
            value: item,
        };
    });
};
var getSelectedDeliveryArea = function (deliveryAreas, selectedArea) {
    var selectedDeliveryArea = {
        city: null,
        area: null,
    };
    deliveryAreas.map(function (cityData) {
        cityData.areas.map(function (area) {
            if (isLocaleStrEqual((selectedArea === null || selectedArea === void 0 ? void 0 : selectedArea.areaNameEN) || '', area.name) ||
                isLocaleStrEqual((selectedArea === null || selectedArea === void 0 ? void 0 : selectedArea.areaNameAR) || '', area.name)) {
                selectedDeliveryArea = {
                    area: {
                        code: area.code,
                        name: area.name,
                        foodDeliveryStore: area.foodDeliveryStore,
                        isSlotsAvailable: area.isSlotsAvailable,
                    },
                    city: {
                        countryIso: cityData.countryIso,
                        isocode: cityData.isocode,
                        name: cityData.name,
                    },
                };
            }
        });
    });
    return selectedDeliveryArea;
};
var getLocationDataByLang = function (language, data, key) {
    var KEY = "" + key + (language === null || language === void 0 ? void 0 : language.toUpperCase()) || key + "AR";
    return data[KEY];
};
var getQatarAreaValue = function (values, language) {
    var validAreas = values.filter(function (item) { return item.areaNameEN && item.areaNameAR; });
    return validAreas.map(function (item) {
        return {
            displayName: getLocationDataByLang(language, item, ELocationKey.area),
            value: item,
        };
    });
};
var _a$3;
var FormErrorTypes;
(function (FormErrorTypes) {
    FormErrorTypes["required"] = "required";
    FormErrorTypes["pattern"] = "pattern";
    FormErrorTypes["minLength"] = "minLength";
    FormErrorTypes["maxLength"] = "maxLength";
})(FormErrorTypes || (FormErrorTypes = {}));
var errorMessages = (_a$3 = {},
    _a$3[FormErrorTypes.required] = function (param, t) { return t('errorForm.required', { param: param }); },
    _a$3[FormErrorTypes.pattern] = function (param, t) { return t('errorForm.valid', { param: param }); },
    _a$3[FormErrorTypes.minLength] = function (param, t) { return t('errorForm.minimum', { param: param }); },
    _a$3[FormErrorTypes.maxLength] = function (param, t) { return t('errorForm.maximum', { param: param }); },
    _a$3);
var getErrorMsg = function (type, t, errObj) {
    return errorMessages[type](errObj, t);
};
var initialLocationState = {
    city: '',
    area: '',
    zone: '',
    street: '',
};
var newAddressReducer = function (state, action) {
    if (state === void 0) { state = initialLocationState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case NewAddressType$1.UPDATE_LOCAION_DATA:
            return Object.assign({}, __assign$1(__assign$1({}, state), payload));
    }
    return state;
};
var ErrorLabel = function (props) {
    var message = props.message;
    return (React.createElement(HintWrapper, null,
        React.createElement(HintIcon, { height: 20, width: 20, fill: BASE_THEME.colors.red100 }),
        React.createElement(HintText, null,
            " ",
            message)));
};
var CountryListElement$1 = function (_a) {
    var code = _a.code, name = _a.name, callingCode = _a.callingCode;
    return (React.createElement(Container$8, null,
        React.createElement(ImageWrapper$1, null,
            React.createElement(Image, { url: "https://mafretailblobstorage.blob.core.windows.net/countryimages/" + code + ".png", name: code + ".png", height: "16px", width: "auto" })),
        React.createElement(CountryLabel$1, null, name),
        React.createElement(CallingCodeLabel$1, null, callingCode)));
};
var AddressLabel$2 = styled.label(templateObject_1$W || (templateObject_1$W = __makeTemplateObject$1(["\n  font-weight: bold;\n  font-size: 12px;\n"], ["\n  font-weight: bold;\n  font-size: 12px;\n"])));
var ButtonWrapper$2 = styled(Flex)(templateObject_2$M || (templateObject_2$M = __makeTemplateObject$1(["\n  position: fixed;\n  top: 91%;\n  align-items: center;\n  flex-direction: row;\n"], ["\n  position: fixed;\n  top: 91%;\n  align-items: center;\n  flex-direction: row;\n"])));
var FullAddress = styled.div(templateObject_3$D || (templateObject_3$D = __makeTemplateObject$1(["\n  margin-left: 25px;\n  max-width: 305px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"], ["\n  margin-left: 25px;\n  max-width: 305px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"])));
var FullAddressLabel = styled.label(templateObject_4$x || (templateObject_4$x = __makeTemplateObject$1(["\n  font-family: Montserrat;\n  font-style: normal;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"], ["\n  font-family: Montserrat;\n  font-style: normal;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"])), TYPOGRAPHY.SIZE[13], TYPOGRAPHY.SIZE[20], COLORS.BLACK);
var AddressCardContainer = styled(Box)(templateObject_5$p || (templateObject_5$p = __makeTemplateObject$1(["\n  padding: ", ";\n  border-radius: 3px;\n  border: 1px solid;\n  background-color: ", ";\n  color: ", ";\n  border-color: rgba(26,79,155,0.2);\n  font-size:", "};\n  margin-top: 8px;\n  margin-bottom: 8px;\n  &:hover {\n    background-color: rgba(26,79,155,0.1);\n    color:", "\n  }\n"], ["\n  padding: ", ";\n  border-radius: 3px;\n  border: 1px solid;\n  background-color: ", ";\n  color: ", ";\n  border-color: rgba(26,79,155,0.2);\n  font-size:", "};\n  margin-top: 8px;\n  margin-bottom: 8px;\n  &:hover {\n    background-color: rgba(26,79,155,0.1);\n    color:", "\n  }\n"])), TYPOGRAPHY.SIZE[12], function (props) { return (props.selected ? 'rgba(26,79,155,0.1)' : COLORS.WHITE); }, function (props) { return (props.selected ? COLORS.ANCHOR_BLUE : 'inherit'); }, TYPOGRAPHY.SIZE[12], COLORS.ANCHOR_BLUE);
var RadioButtonStyle$2 = styled(Box)(templateObject_6$j || (templateObject_6$j = __makeTemplateObject$1(["\n  input[type='radio'] {\n    accent-color: ", ";\n    width: 15px;\n    height: 15px;\n    vertical-align: -webkit-baseline-middle;\n    position: relative;\n    margin: 0 10px 0 0;\n  }\n  span {\n    font-family: Montserrat;\n    font-style: normal;\n    font-weight: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n  }\n"], ["\n  input[type='radio'] {\n    accent-color: ", ";\n    width: 15px;\n    height: 15px;\n    vertical-align: -webkit-baseline-middle;\n    position: relative;\n    margin: 0 10px 0 0;\n  }\n  span {\n    font-family: Montserrat;\n    font-style: normal;\n    font-weight: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n  }\n"])), COLORS.BLUE, TYPOGRAPHY.WEIGHT[500], TYPOGRAPHY.SIZE[16], TYPOGRAPHY.SIZE[24], COLORS.BLACK);
var AddLocation = styled(Button$1)(templateObject_7$i || (templateObject_7$i = __makeTemplateObject$1(["\n  height: 48px;\n  width: 340px;\n  font-family: Montserrat;\n  border-radius: 8px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  font-weight: ", ";\n  margin-left: 31px;\n  margin-top: 13px;\n  line-height: 20px;\n  border-color: ", ";\n  color: ", ";\n"], ["\n  height: 48px;\n  width: 340px;\n  font-family: Montserrat;\n  border-radius: 8px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  font-weight: ", ";\n  margin-left: 31px;\n  margin-top: 13px;\n  line-height: 20px;\n  border-color: ", ";\n  color: ", ";\n"])), TYPOGRAPHY.WEIGHT[600], COLORS.WHITE, COLORS.BLUE);
var HeaderTitle$1 = styled.div(templateObject_8$i || (templateObject_8$i = __makeTemplateObject$1(["\n  width: 332px;\n  height: 32px;\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  @media (max-width: ", "px) {\n    font-size: ", ";\n    margin-left: 90px;\n  }\n"], ["\n  width: 332px;\n  height: 32px;\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  @media (max-width: ", "px) {\n    font-size: ", ";\n    margin-left: 90px;\n  }\n"])), TYPOGRAPHY.WEIGHT[700], TYPOGRAPHY.SIZE[24], TYPOGRAPHY.SIZE[32], COLORS.BLACK, BREAKPOINTS[1], TYPOGRAPHY.SIZE[18]);
var HeaderAction = styled.a(templateObject_9$h || (templateObject_9$h = __makeTemplateObject$1(["\n  color: ", ";\n  display: block;\n  margin-top: 15px;\n  cursor: pointer;\n"], ["\n  color: ", ";\n  display: block;\n  margin-top: 15px;\n  cursor: pointer;\n"])), COLORS.BLUE);
var TickBox = styled(Flex)(templateObject_10$h || (templateObject_10$h = __makeTemplateObject$1(["\n  height: 16px;\n  width: 16px;\n  background-color: ", ";\n  border-radius: 8px;\n  align-items: center;\n  justify-content: center;\n"], ["\n  height: 16px;\n  width: 16px;\n  background-color: ", ";\n  border-radius: 8px;\n  align-items: center;\n  justify-content: center;\n"])), function (props) { return (props.selected ? COLORS.WHITE : 'transparent'); });
var Save = styled(Button$1)(templateObject_11$e || (templateObject_11$e = __makeTemplateObject$1(["\n  color: ", ";\n  position: relative;\n  left: 42%;\n  font-weight: ", ";\n  height: 48px;\n  width: 217.5px;\n  font-family: Montserrat;\n  border-radius: 8px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-top: 13px;\n  line-height: 20px;\n  border-color: ", ";\n  background-color: ", ";\n"], ["\n  color: ", ";\n  position: relative;\n  left: 42%;\n  font-weight: ", ";\n  height: 48px;\n  width: 217.5px;\n  font-family: Montserrat;\n  border-radius: 8px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-top: 13px;\n  line-height: 20px;\n  border-color: ", ";\n  background-color: ", ";\n"])), COLORS.WHITE, TYPOGRAPHY.WEIGHT[700], COLORS.WHITE, COLORS.BLUE);
var Cancel = styled(Button$1)(templateObject_12$d || (templateObject_12$d = __makeTemplateObject$1(["\n  position: relative;\n  left: 15%;\n  font-weight: ", ";\n  padding: 25px;\n  font-family: Montserrat;\n  font-size: ", ";\n  margin-top: 2%;\n"], ["\n  position: relative;\n  left: 15%;\n  font-weight: ", ";\n  padding: 25px;\n  font-family: Montserrat;\n  font-size: ", ";\n  margin-top: 2%;\n"])), TYPOGRAPHY.WEIGHT[600], TYPOGRAPHY.SIZE[14]);
var templateObject_1$W, templateObject_2$M, templateObject_3$D, templateObject_4$x, templateObject_5$p, templateObject_6$j, templateObject_7$i, templateObject_8$i, templateObject_9$h, templateObject_10$h, templateObject_11$e, templateObject_12$d;
var getIcon = function (countryName) {
    switch (countryName) {
        case 'UAE':
            return React.createElement(UAEFlag, { size: "M" });
        case 'Bahrain':
            return React.createElement(BahrainFlag, { size: "M" });
        case 'Egypt':
            return React.createElement(EgyptFlag, { size: "M" });
        case 'Jordan':
            return React.createElement(JordanFlag, { size: "M" });
        case 'Kuwait':
            return React.createElement(KuwaitFlag, { size: "M" });
        case 'Lebanon':
            return React.createElement(LebanonFlag, { size: "M" });
        case 'Oman':
            return React.createElement(OmanFlag, { size: "M" });
        case 'Pakistan':
            return React.createElement(PakistanFlag, { size: "M" });
        case 'Qatar':
            return React.createElement(QatarFlag, { size: "M" });
        case 'KSA':
            return React.createElement(KSAFlag, { size: "M" });
        case 'Kenya':
            return React.createElement(KenyaFlag, { size: "M" });
        case 'Georgia':
            return React.createElement(GeorgiaFlag, { size: "M" });
        default:
            return countryName;
    }
};
var countrySelectShaper = function (countryPhoneCodesList) {
    var allTopics = countryPhoneCodesList === null || countryPhoneCodesList === void 0 ? void 0 : countryPhoneCodesList.map(function (e) {
        return {
            value: e.code,
            label: e.callingCode,
            labelDropdown: React.createElement(CountryListElement$1, { key: e.callingCode, code: e.code, name: e.name, callingCode: e.callingCode }),
        };
    });
    return allTopics || [];
};
var AddAddressForm = function (_a) {
    var showMobileAddressForm = _a.showMobileAddressForm, closeAddressFormDrawer = _a.closeAddressFormDrawer, onSelectedLocationChange = _a.onSelectedLocationChange, showAddressForm = _a.showAddressForm, setFlatNo = _a.setFlatNo, setBuildingName = _a.setBuildingName, setLandmark = _a.setLandmark, onAddressSuccess = _a.onAddressSuccess, countryConfig = _a.countryConfig, t = _a.t, updatedLocation = _a.updatedLocation, addressInfo = _a.addressInfo, town = _a.town, country = _a.country, emirate = _a.emirate, _b = _a.editInfo, editInfo = _b === void 0 ? {} : _b, isHidden = _a.isHidden, userProfile = _a.userProfile, isSetSelectedAddress = _a.isSetSelectedAddress, block = _a.block, building = _a.building, isStreeNameChange = _a.isStreeNameChange, setIsStreetNameChange = _a.setIsStreetNameChange, isCityAreaNameChange = _a.isCityAreaNameChange, setIsCityAreaNameChange = _a.setIsCityAreaNameChange;
    var appartment = editInfo.appartment, landmark = editInfo.landmark, firstName = editInfo.firstName, phone = editInfo.phone, defaultAddress = editInfo.defaultAddress, deliveryInstructions = editInfo.deliveryInstructions, defaultAddressLabel = editInfo.addressLabel;
    var _c = countryConfig || '', phoneCountryCode = _c.phoneCountryCode, countryOfOperationID = _c.countryOfOperationID;
    var _d = useForm({
        mode: 'onChange',
    }), register = _d.register, errors = _d.errors, handleSubmit = _d.handleSubmit, getValues = _d.getValues, setValue = _d.setValue, control = _d.control, clearErrors = _d.clearErrors, setError = _d.setError, formState = _d.formState, trigger = _d.trigger, reset = _d.reset, _e = _d.formState, isDirty = _e.isDirty, isValid = _e.isValid;
    var _f = __read$1(useAppConfig(), 1), _g = _f[0], countryName = _g.countryName, code = _g.code, _h = _g.areaCode, areaCode = _h === void 0 ? '' : _h, language = _g.language;
    var countryConfiguration = useSelector(function (state) { return state.appConfig; }).countryConfiguration;
    var _j = countryConfiguration || {}, countryNameEn = _j.countryNameEn, countryNameAr = _j.countryNameAr;
    var _k = useAddress(t), addNEditAddress = _k.addNEditAddress, isPhoneVerified = _k.isPhoneVerified, addressList = _k.addressList, error = _k.error, phoneNumberShaper = _k.phoneNumberShaper, validateCity = _k.validateCity, validateCityQatar = _k.validateCityQatar, validateArea = _k.validateArea, validateQatarArea = _k.validateQatarArea, validateQatarZone = _k.validateQatarZone, fetchCitiesZonesAndAreas = _k.fetchCitiesZonesAndAreas, fetchCountries = _k.fetchCountries, countryPhoneCodesData = _k.countryPhoneCodesData;
    var _l = __read$1(useState(!isExisty(defaultAddress) || !(addressList === null || addressList === void 0 ? void 0 : addressList.length) ? true : defaultAddress), 2), isDefaultAddress = _l[0], setIsDefaultAddress = _l[1];
    var countriesList = useMemo(function () {
        if ((countryPhoneCodesData === null || countryPhoneCodesData === void 0 ? void 0 : countryPhoneCodesData.length) > 0) {
            return countrySelectShaper(countryPhoneCodesData);
        }
        return [];
    }, [countryPhoneCodesData]);
    var _m = __read$1(useState(), 2), formData = _m[0], setFormData = _m[1];
    var _o = __read$1(useState(false), 2), isVerifyOTPOpen = _o[0], setIsVerifyOTPOpen = _o[1];
    var _p = __read$1(useState(defaultAddressLabel || ''), 2), addressLabel = _p[0], setAddressLabel = _p[1];
    var _q = __read$1(useState(''), 2), warningMsg = _q[0], setWarningMsg = _q[1];
    var _r = __read$1(useState(false), 2), phoneVerified = _r[0], setPhoneVerified = _r[1];
    var _s = __read$1(useState(''), 2), streetName = _s[0], setstreetName = _s[1];
    var _t = __read$1(useState(''), 2), appartmentName = _t[0], setAppartmentName = _t[1];
    var _u = __read$1(useState(''), 2), floorName = _u[0], setFloorName = _u[1];
    var _v = __read$1(useState(false), 2), dropDownClicked = _v[0], setDropDownClicked = _v[1];
    var _w = __read$1(useReducer(newAddressReducer, initialLocationState), 2), newAddressState = _w[0], dispatch = _w[1];
    var city = newAddressState.city, area = newAddressState.area, zone = newAddressState.zone, street = newAddressState.street;
    var _x = __read$1(useState([]), 2), areaList = _x[0], setAreaList = _x[1];
    var _y = __read$1(useState([]), 2), zoneList = _y[0], setZoneList = _y[1];
    var didRecordInteractionWithAreaField = useRef(false);
    var didRecordInteractionWithZoneField = useRef(false);
    var _z = useAddress(t), citiesAndAreaState = _z.citiesAndAreaState, qatarCitiesAndAreaState = _z.qatarCitiesAndAreaState;
    var device = useBreakpoints();
    var _0 = __read$1(useState(false), 2), isSubmitBtnDisabled = _0[0], setIsSubmitBtnDisabled = _0[1];
    var isInternationalPhoneNumberEnabled = useFeature('international_number_support').on;
    var isUserDefinedCity = useFeature('user_defined_city').on;
    var isUserDefinedFloor = useFeature('user_defined_floor').on;
    var isQatarAddressFields = useFeature('qatar_address_fields').on;
    var isUAEAddressFields = useFeature('user_defined_city_area').on;
    useFetchAreas(areaCode, language);
    var isEditableStreetAddress = useFeature('editable_street_address').on;
    var isBlockAddressFields = useFeature('block_address_field').on;
    var updateAreaInteractionFlags = useCallback(function () {
        didRecordInteractionWithAreaField.current = true;
    }, [didRecordInteractionWithAreaField]);
    var updateZoneInteractionFlags = useCallback(function () {
        didRecordInteractionWithZoneField.current = true;
    }, [didRecordInteractionWithZoneField]);
    var isMobile = device.isMobile;
    var resetAreaField = useCallback(function (listArray) {
        if (listArray === void 0) { listArray = []; }
        setValue(EFormKey.area, '');
        setAreaList(listArray);
        dispatch(updateLocation({ area: '' }));
        clearErrors(EFormKey.area);
        trigger(EFormKey.area);
        didRecordInteractionWithAreaField.current = false;
    }, [clearErrors, setValue, trigger, didRecordInteractionWithAreaField]);
    var resetZoneField = useCallback(function (listArray) {
        if (listArray === void 0) { listArray = []; }
        setZoneList(listArray);
        setValue(EFormKey.zone, '');
        dispatch(updateLocation({ zone: '' }));
        clearErrors(EFormKey.zone);
        trigger(EFormKey.zone);
        didRecordInteractionWithAreaField.current = false;
    }, [clearErrors, setValue, didRecordInteractionWithAreaField, trigger]);
    var autocompleteCityValues = useMemo(function () {
        var _a;
        if (isQatarAddressFields || isUAEAddressFields) {
            return ((_a = qatarCitiesAndAreaState === null || qatarCitiesAndAreaState === void 0 ? void 0 : qatarCitiesAndAreaState.qatarCities) === null || _a === void 0 ? void 0 : _a.cities) ? qatarCitiesAndAreaState.qatarCities.cities.map(function (item) {
                var city = getLocationDataByLang(language, item, ELocationKey.city);
                return {
                    displayName: city,
                    value: item,
                };
            })
                : [];
        }
        else {
            return citiesAndAreaState ? getCitiesValue(citiesAndAreaState) : [];
        }
    }, [citiesAndAreaState, language, isQatarAddressFields, isUAEAddressFields, qatarCitiesAndAreaState]);
    var getVariant = useCallback(function (key) {
        if (!didRecordInteractionWithAreaField.current &&
            key === EFormKey.area &&
            (areaList.length === 0 || (getValues(EFormKey.area) || '').length === 0)) {
            return EFormState.primary;
        }
        var formStateTouched = formState.touched[key] ? EFormState.success : EFormState.primary;
        return errors[key] ? 'error' : formStateTouched;
    }, [errors, formState, areaList.length, getValues]);
    var autocompleteAreaValues = useMemo(function () {
        return isQatarAddressFields || isUAEAddressFields ? getQatarAreaValue(areaList, language) : getAreaValue(areaList);
    }, [areaList, language, isQatarAddressFields, isUAEAddressFields]);
    var autoCompleteZoneValues = useMemo(function () {
        return (zoneList === null || zoneList === void 0 ? void 0 : zoneList.map(function (zone) {
            return { displayName: zone.zoneNo, value: zone };
        })) || [];
    }, [zoneList]);
    var onCitySelection = useCallback(function (value) { return __awaiter$1(void 0, void 0, void 0, function () {
        var zones, restValue, areas, restValue;
        return __generator$1(this, function (_a) {
            if (isQatarAddressFields || isUAEAddressFields) {
                zones = value.zones, restValue = __rest$1(value, ["zones"]);
                dispatch(updateLocation({ city: getLocationDataByLang(language, restValue, ELocationKey.city), zone: '', area: '' }));
                resetZoneField(zones);
                if (isQatarAddressFields) {
                    resetAreaField([]);
                }
                if (isUAEAddressFields) {
                    resetAreaField(zones[0].areas);
                }
                setValue(EFormKey.city, getLocationDataByLang(language, restValue, ELocationKey.city));
                trigger(EFormKey.city);
            }
            else {
                areas = value.areas, restValue = __rest$1(value, ["areas"]);
                dispatch(updateLocation({ city: restValue, zone: '', area: '' }));
                resetAreaField(areas);
                setValue(EFormKey.city, restValue.name);
                trigger(EFormKey.city);
            }
            return [2 ];
        });
    }); }, [resetAreaField, resetZoneField, trigger, language, isQatarAddressFields, setValue, isUAEAddressFields]);
    var onAreaSelection = useCallback(function (value) {
        var name = isQatarAddressFields || isUAEAddressFields
            ? getLocationDataByLang(language, value, ELocationKey.area)
            : value.name;
        dispatch(updateLocation({ area: name }));
        setValue(EFormKey.area, name);
        trigger(EFormKey.area);
    }, [trigger, language, isQatarAddressFields, isUAEAddressFields, setValue]);
    var onZoneSelection = useCallback(function (value) { return __awaiter$1(void 0, void 0, void 0, function () {
        var areas;
        return __generator$1(this, function (_a) {
            areas = value.areas;
            dispatch(updateLocation({ zone: value.zoneNo, area: '' }));
            resetAreaField(__spread$1(areas));
            setValue(EFormKey.zone, value.zoneNo);
            trigger(EFormKey.zone);
            return [2 ];
        });
    }); }, [trigger, resetAreaField, setValue]);
    useEffect(function () {
        if (isQatarAddressFields || isUAEAddressFields) {
            fetchCitiesZonesAndAreas();
        }
    }, [fetchCitiesZonesAndAreas, isUAEAddressFields, isQatarAddressFields]);
    useEffect(function () {
        if (isInternationalPhoneNumberEnabled) {
            fetchCountries();
        }
    }, [fetchCountries, isInternationalPhoneNumberEnabled]);
    useEffect(function () {
        if (appartment) {
            if (isUserDefinedFloor) {
                var data = getFloorApartment(appartment, FLOOR_KEY, FLAT_KEY);
                if (data) {
                    var _a = __read$1(data, 2), floor = _a[0], appart = _a[1];
                    setAppartmentName(appart);
                    setFloorName(floor);
                    setValue('appartment', appart);
                    setValue('floor', floor);
                }
            }
            else {
                setAppartmentName(appartment);
                setValue('appartment', appartment);
            }
        }
    }, [appartment, isUserDefinedFloor, setValue]);
    var onSuccess = useCallback(function (res) {
        onAddressSuccess && onAddressSuccess(res);
    }, [onAddressSuccess]);
    var onFormDataSave = function (formData, uuid) {
        if (formData) {
            var ssoType = editInfo.ssoType, id = editInfo.id;
            var data = __assign$1(__assign$1({ defaultAddress: isDefaultAddress, addressLabel: addressLabel }, formData), { onSuccess: onSuccess, latitude: countObjectProperties(updatedLocation) > 0 ? updatedLocation.lat : editInfo === null || editInfo === void 0 ? void 0 : editInfo.latitude, longitude: countObjectProperties(updatedLocation) > 0 ? updatedLocation.lng : editInfo === null || editInfo === void 0 ? void 0 : editInfo.longitude, town: isUserDefinedCity && !(formData.cityArea || '').isEmptyObject ? formData.cityArea : town, streetName: formData.streetName || '', country: country || countryOfOperationID, emirate: APP_CONFIG.storeId === EStoreID.MAFUAE ? (!(editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) ? emirate : editInfo === null || editInfo === void 0 ? void 0 : editInfo.emirate) : '', isSetSelectedAddress: isSetSelectedAddress });
            if (isQatarAddressFields) {
                var makani = "Zone#" + formData.zone + " | Area:" + formData.area + " | City:" + formData.city + " | Street#" + formData.street;
                var phone_1 = getPhoneNumber(formData);
                data = __assign$1(__assign$1({}, data), { makani: makani, town: town, phone: phone_1, isQatarAddressFields: isQatarAddressFields });
            }
            if (isUAEAddressFields) {
                var makani = formData.city;
                var town_1 = formData.area;
                data = __assign$1(__assign$1({}, data), { makani: makani, town: town_1, isUAEAddressFields: isUAEAddressFields });
            }
            if (uuid) {
                data = __assign$1(__assign$1({}, data), { addressVerificationRefId: uuid });
            }
            var editInformation = void 0;
            if (id && ssoType) {
                editInformation = { id: id, ssoType: ssoType };
            }
            addNEditAddress(data, editInformation, setIsSubmitBtnDisabled);
        }
    };
    var onFormSubmit = function (formData) {
        setIsSubmitBtnDisabled(true);
        if (isBlockAddressFields) {
            formData.building = formData.building + "|Block#" + formData.block;
        }
        if (isUserDefinedFloor) {
            formData.appartment = "" + FLOOR_KEY + formData.floor + FLAT_KEY + formData.appartment;
        }
        formData.phone = formData.phone.replace(/^0/, '');
        if (!phoneVerified) {
            setFormData(formData);
            setIsVerifyOTPOpen(true);
        }
        else {
            onFormDataSave(formData, '');
        }
    };
    var validatePhoneNumber = function () {
        var _a;
        var phoneNumber = (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) ? phone : userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone;
        var intPhoneNumber = getValues('phone');
        var intPhoneCountryCode = (_a = getValues('phoneCountryCode')) === null || _a === void 0 ? void 0 : _a.label;
        if (phoneNumber) {
            isPhoneVerified((isInternationalPhoneNumberEnabled && dropDownClicked ? intPhoneCountryCode : '') +
                (isInternationalPhoneNumberEnabled && dropDownClicked ? intPhoneNumber : phoneNumber), function (isPhoneVerified) {
                setPhoneVerified(isPhoneVerified);
            });
        }
        else {
            setPhoneVerified(false);
        }
    };
    var handleControllerClick = function () {
        var phoneCodeValue = getValues().phoneCountryCode;
        var phoneNumber = getValues().phone;
        var isValid = isNumberValid(((phoneCodeValue === null || phoneCodeValue === void 0 ? void 0 : phoneCodeValue.label) || phoneCodeValue) + phoneNumber, phoneCodeValue === null || phoneCodeValue === void 0 ? void 0 : phoneCodeValue.value);
        isValid
            ? clearErrors('phone')
            : setError('phone', {
                type: 'phone_expression',
                message: t('address.invalidPhone'),
            });
    };
    useEffect(function () {
        if (phone || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone)) {
            validatePhoneNumber();
        }
    }, [phone, userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone]);
    useEffect(function () {
        if ((editInfo === null || editInfo === void 0 ? void 0 : editInfo.streetName) && !isStreeNameChange) {
            setValue('streetName', editInfo.streetName);
            setstreetName(editInfo.streetName);
            setIsStreetNameChange(true);
        }
        if ((editInfo === null || editInfo === void 0 ? void 0 : editInfo.town) && !isCityAreaNameChange) {
            setTimeout(function () {
                setValue('cityArea', editInfo.town);
                setIsCityAreaNameChange(true);
            }, 1000);
        }
    }, [
        showAddressForm,
        editInfo,
        isStreeNameChange,
        isCityAreaNameChange,
        setValue,
        setIsStreetNameChange,
        setIsCityAreaNameChange,
        trigger,
    ]);
    useEffect(function () {
        var _a, _b;
        var _c, _d, _e;
        if ((editInfo === null || editInfo === void 0 ? void 0 : editInfo.makani) && (isQatarAddressFields || isUAEAddressFields)) {
            var makani = editInfo.makani, town_2 = editInfo.town, streetName_1 = editInfo.streetName;
            var city_1, zone_1, area_1, street_1;
            if (isQatarAddressFields) {
                var makaniData = makani
                    .replace('Zone#', '')
                    .replace('City:', '')
                    .replace('Area:', '')
                    .replace('Street#', '')
                    .split(' | ');
                _a = __read$1(makaniData, 4), zone_1 = _a[0], area_1 = _a[1], city_1 = _a[2], street_1 = _a[3];
            }
            if (isUAEAddressFields) {
                city_1 = makani;
                area_1 = town_2;
                street_1 = streetName_1;
            }
            dispatch(updateLocation({ city: city_1, area: area_1, zone: zone_1, street: street_1 }));
            var formValues = getValues();
            reset(__assign$1(__assign$1({}, formValues), (_b = {}, _b[EFormKey.city] = city_1, _b[EFormKey.area] = area_1, _b[EFormKey.zone] = zone_1, _b[EFormKey.street] = street_1, _b)));
            trigger([EFormKey.city, EFormKey.zone, EFormKey.area, EFormKey.street]);
            var filtererCities = ((_d = (_c = qatarCitiesAndAreaState === null || qatarCitiesAndAreaState === void 0 ? void 0 : qatarCitiesAndAreaState.qatarCities) === null || _c === void 0 ? void 0 : _c.cities) === null || _d === void 0 ? void 0 : _d.filter(function (item) {
                var cityLocal = getLocationDataByLang(language, item, ELocationKey.city);
                return city_1 === cityLocal;
            })) || [];
            if (filtererCities.length > 0) {
                var zones = filtererCities[0].zones;
                setZoneList(zones);
                var zoneIndex = zones.findIndex(function (x) { return x.zoneNo === zone_1; });
                if (isUAEAddressFields) {
                    setAreaList(zones[0].areas);
                }
                if (zoneIndex > -1) {
                    setAreaList((_e = zones[zoneIndex]) === null || _e === void 0 ? void 0 : _e.areas);
                }
            }
        }
    }, [
        editInfo,
        isQatarAddressFields,
        isUAEAddressFields,
        qatarCitiesAndAreaState,
        language,
        trigger,
        setValue,
        reset,
        getValues,
    ]);
    useEffect(function () {
        var sharedConfig = countryConfig.sharedConfig;
        if (addressInfo) {
            if (isEditableStreetAddress && !isQatarAddressFields) {
                var unSupportedStreetAddressKeywords = sharedConfig.unSupportedStreetAddressKeywords;
                var isKeywordExist_1 = false;
                unSupportedStreetAddressKeywords.forEach(function (keyword) {
                    if (!isKeywordExist_1) {
                        var i = addressInfo.indexOf(keyword);
                        if (i > -1) {
                            isKeywordExist_1 = true;
                        }
                    }
                });
                setValue('streetName', formattedGoogleAddressDescription(addressInfo, emirate, countryNameEn || countryNameAr));
                setstreetName(formattedGoogleAddressDescription(addressInfo, emirate, countryNameEn || countryNameAr));
            }
            else {
                setValue('streetName', addressInfo);
                setstreetName(formattedGoogleAddressDescription(addressInfo, emirate, countryNameEn || countryNameAr));
            }
        }
    }, [
        addressInfo,
        setValue,
        countryConfig,
        isQatarAddressFields,
        emirate,
        countryNameEn,
        countryNameAr,
        isEditableStreetAddress,
    ]);
    useEffect(function () {
        if (town) {
            setValue('cityArea', town);
        }
    }, [town, setValue]);
    var onChangeSwitchHandle = function () {
        var value = !isDefaultAddress;
        setIsDefaultAddress(value);
    };
    var onCloseOTPVerifyModal = function () {
        setIsVerifyOTPOpen(false);
        var warningMsg = phone
            ? t('verifyOTP.verifyYourMobileNumberToUpdateAddress')
            : t('verifyOTP.verifyYourMobileNumberToAddAddress');
        setWarningMsg(warningMsg);
    };
    var validateInput = function (fieldName) {
        if (fieldName === 'streetName') {
            setValue(fieldName, getValues(fieldName));
        }
        else {
            setValue(fieldName, getValues(fieldName).replace(alphanumericCommaPeriodArabic, ''));
        }
    };
    var onFlatNumberChange = useCallback(function () {
        setFlatNo(getValues('appartment'));
    }, [setFlatNo, getValues]);
    var onBuildingNameChange = useCallback(function () {
        setBuildingName(getValues('building'));
    }, [setBuildingName, getValues]);
    var onLandmarkChange = useCallback(function () {
        setLandmark(getValues('landmark'));
    }, [setLandmark, getValues]);
    var notificationMessage = useMemo(function () {
        return (warningMsg || error) && React.createElement(Notification, { my: 2 }, warningMsg || (error && t('errorGeneral')));
    }, [error, warningMsg, t]);
    var isNumberKey = function (evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
            return false;
        }
        return true;
    };
    var onChangeLocation = useCallback(function (e, key) {
        var _a;
        var value = e.target.value;
        dispatch(updateLocation((_a = {}, _a[key] = value, _a)));
        setValue(key, e.target.value);
        trigger(key);
        if (key === EFormKey.city) {
            resetZoneField([]);
            resetAreaField([]);
        }
        else if (key === EFormKey.zone) {
            resetAreaField([]);
        }
    }, [setValue, trigger, resetZoneField, resetAreaField]);
    var defaultSelectValue = (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) && isInternationalPhoneNumberEnabled ? countryCodeShaper(editInfo.phone) : phoneCountryCode;
    var getPhoneNumber = function (formData) {
        var _a;
        var phoneNumber = (isInternationalPhoneNumberEnabled
            ? !dropDownClicked
                ? formData === null || formData === void 0 ? void 0 : formData.phoneCountryCode : (_a = formData === null || formData === void 0 ? void 0 : formData.phoneCountryCode) === null || _a === void 0 ? void 0 : _a.label
            : phoneCountryCode) + (formData === null || formData === void 0 ? void 0 : formData.phone);
        return phoneNumber;
    };
    return (React.createElement(Drawer, { preventCloseOnClickOutside: true, onClose: closeAddressFormDrawer, isOpen: showAddressForm || showMobileAddressForm, width: ['100%', '400px', '500px'], anchor: ['bottom', null, 'right'], contentStyles: { p: [0], height: '100%', display: 'flex', flexDirection: 'column', fontFamily: 'Montserrat' }, variant: "float", title: React.createElement(HeaderTitle$1, null, editInfo.id ? t('address.editAddress') : t('address.completeDetails')), "data-testid": "address-form-drawer", isTitleBorder: false },
        isVerifyOTPOpen && (React.createElement(VerifyPassword, { isShowShopping: false, email: getUserEmailFromCookie(), phoneNumber: getPhoneNumber(formData), onVerifyAccount: function (uuid) { return onFormDataSave(formData, uuid); }, onCloseModal: function () { return onCloseOTPVerifyModal(); }, action: "ADDRESS_PHONE_VERIFICATION" })),
        React.createElement(Flex, { flexDirection: "column", flex: 1, mt: 16, pr: 30, pl: 38, as: "form", onSubmit: handleSubmit(onFormSubmit), style: { display: isHidden ? 'none' : 'flex' }, "data-testid": "__location-cx-address__" },
            React.createElement(SelectedLocationContainer, null,
                React.createElement(SelectedLocationWrapper, null,
                    React.createElement(SelectedLocation, null, t('address.selectedLocation')),
                    React.createElement(SelectedLocationLabel, null, streetName)),
                React.createElement(ChangeLocation, { onClick: onSelectedLocationChange, variant: "custom", preventTextTransform: true, backgroundColor: "rgba(14, 90, 167, 0.05)" }, t('change'))),
            React.createElement(RequiredField, null,
                React.createElement(RequiredFieldText, null, t('address.requiredFieldNew'))),
            React.createElement(Box, null,
                notificationMessage,
                (isQatarAddressFields || isUAEAddressFields) && (React.createElement(React.Fragment, null,
                    React.createElement(Autocomplete, { value: city, label: t('address.city'), values: autocompleteCityValues, defaultValue: city, variant: getVariant(EFormKey.city), onSelection: onCitySelection, register: register({
                            required: getErrorMsg(FormErrorTypes.required, t),
                            validate: isQatarAddressFields || isUAEAddressFields ? validateCityQatar : validateCity,
                        }), name: "city", successIcon: false, testid: "appartment-number-field", onBlur: function (e) { return onChangeLocation(e, EFormKey.city); }, allowedRegExpChars: isRTL() ? undefined : 'alphanumericCommaPeriod', backgroundColor: COLORS.WHITE, onChange: function (e) { return onChangeLocation(e, EFormKey.city); } }),
                    errors.city && React.createElement(ErrorLabel, { message: errors.city.message }),
                    React.createElement(Flex, null,
                        isQatarAddressFields && (React.createElement(LeftBox, { mr: 2 },
                            React.createElement(Autocomplete, { value: zone, label: t('address.zone'), onSelection: onZoneSelection, defaultValue: zone, values: autoCompleteZoneValues, successIcon: false, name: "zone", register: register({
                                    required: getErrorMsg(FormErrorTypes.required, t),
                                    validate: function (value) { return validateQatarZone(zoneList, value); },
                                }), disabled: autoCompleteZoneValues.length < 1, variant: getVariant(EFormKey.zone), testid: "zone-field", onFocus: updateZoneInteractionFlags, allowedRegExpChars: isRTL() ? undefined : 'alphanumericCommaPeriod', backgroundColor: COLORS.WHITE, onChange: function (e) { return onChangeLocation(e, EFormKey.zone); } }),
                            errors.zone && (zoneList.length !== 0 || didRecordInteractionWithZoneField.current) && (React.createElement(ErrorLabel, { message: errors.zone.message })))),
                        React.createElement(RightBox, { fullWidth: true },
                            React.createElement(Autocomplete, { value: area, label: t('address.area'), onSelection: onAreaSelection, defaultValue: area, values: autocompleteAreaValues, successIcon: false, name: "area", register: register({
                                    required: getErrorMsg(FormErrorTypes.required, t),
                                    validate: function (value) {
                                        return isQatarAddressFields || isUAEAddressFields
                                            ? validateQatarArea(areaList, value)
                                            : validateArea(areaList, value);
                                    },
                                }), disabled: autocompleteAreaValues.length < 1, variant: getVariant(EFormKey.area), testid: "area-field", onFocus: updateAreaInteractionFlags, allowedRegExpChars: isRTL() ? undefined : 'alphanumericCommaPeriod', backgroundColor: COLORS.WHITE, onChange: function (e) { return onChangeLocation(e, EFormKey.area); } }),
                            errors.area && (areaList.length !== 0 || didRecordInteractionWithAreaField.current) && (React.createElement(ErrorLabel, { message: errors.area.message })))))),
                !isQatarAddressFields && (React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.appartment ? 'error' : 'primary', testid: 'appartment-number-field', defaultValue: appartmentName, label: t('address.apartmentNumber'), color: COLORS.BLUE, name: "appartment", onChange: function () {
                            validateInput('appartment');
                            onFlatNumberChange();
                        }, register: register({
                            required: t('address.requiredField'),
                            minLength: 1,
                            maxLength: 255,
                            pattern: {
                                value: isQatarAddressFields ? numericExpression : addressInputRegex,
                                message: getErrorMsg(FormErrorTypes.pattern, t, t('address.apartment').toLowerCase()),
                            },
                        }), onKeyPress: function (e) { return isQatarAddressFields && isNumberKey(e); } }),
                    errors.appartment && React.createElement(ErrorLabel, { message: t('address.numberError') }))),
                isQatarAddressFields && (React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.street ? 'error' : 'primary', defaultValue: street, label: t('address.streetNumber'), color: COLORS.BLUE, name: "street",
                        onChange: function () {
                            validateInput(EFormKey.street);
                        }, onKeyPress: function (ev) { return isNumberKey(ev); }, register: register({
                            required: getErrorMsg(FormErrorTypes.required, t),
                            maxLength: {
                                value: 255,
                                message: getErrorMsg(FormErrorTypes.maxLength, t, 255),
                            },
                            pattern: {
                                value: numericExpression,
                                message: getErrorMsg(FormErrorTypes.pattern, t, t('address.street')),
                            },
                        }) }),
                    errors.street && React.createElement(ErrorLabel, { message: t('address.streetError') }))),
                isUserDefinedFloor && (React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.floor ? 'error' : 'primary', defaultValue: floorName, label: t('address.floor'), color: COLORS.BLUE, name: "floor", onChange: function () {
                            validateInput('floor');
                        }, register: register({
                            required: getErrorMsg(FormErrorTypes.required, t),
                            maxLength: {
                                value: 255,
                                message: getErrorMsg(FormErrorTypes.maxLength, t, 255),
                            },
                        }) }),
                    errors.floor && React.createElement(ErrorLabel, { message: errors.floor.message }))),
                React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.building ? 'error' : 'primary', testid: 'building-field', defaultValue: building, label: isQatarAddressFields ? t('address.buildingOrCompound') : t('address.building'), color: COLORS.BLUE, name: "building", onChange: function () {
                            validateInput('building');
                            onBuildingNameChange();
                        }, register: register({
                            required: t('address.requiredField'),
                            maxLength: 255,
                            pattern: {
                                value: isQatarAddressFields ? numericExpression : addressInputRegex,
                                message: getErrorMsg(FormErrorTypes.pattern, t, isQatarAddressFields
                                    ? t('address.buildingOrCompound').toLowerCase()
                                    : t('address.buildingName').toLowerCase()),
                            },
                        }), onKeyPress: function (ev) { return isQatarAddressFields && isNumberKey(ev); } }),
                    errors.building && React.createElement(ErrorLabel, { message: t('address.buildingError') })),
                isQatarAddressFields && (React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.appartment ? 'error' : 'primary', testid: 'appartment-number-field', defaultValue: appartmentName, label: t('address.apartment'), color: COLORS.BLUE, name: "appartment", onChange: function () {
                            validateInput('appartment');
                            onFlatNumberChange();
                        }, register: register({
                            required: t('address.requiredField'),
                            minLength: 1,
                            maxLength: 255,
                            pattern: {
                                value: isQatarAddressFields ? numericExpression : addressInputRegex,
                                message: getErrorMsg(FormErrorTypes.pattern, t, t('address.apartment').toLowerCase()),
                            },
                        }), onKeyPress: function (ev) { return isQatarAddressFields && isNumberKey(ev); } }),
                    errors.appartment && React.createElement(ErrorLabel, { message: t('address.apartmentError') }))),
                isEditableStreetAddress && (React.createElement(StreetNameBox, { isDisplay: !isQatarAddressFields, paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.streetName ? 'error' : 'primary', defaultValue: streetName, label: t('address.street'), color: COLORS.BLUE, name: "streetName", allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () {
                            validateInput('streetName');
                        }, register: register({
                            required: t('address.requiredField'),
                        }) }),
                    errors.streetName && React.createElement(ErrorLabel, { message: t('address.streetError') }))),
                isBlockAddressFields && (React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.block ? 'error' : 'primary', label: t('address.block'), successIcon: true, name: "block", defaultValue: block, color: COLORS.BLUE, register: register({
                            required: getErrorMsg(FormErrorTypes.required, t),
                            min: 1,
                            pattern: {
                                value: numericExpression,
                                message: getErrorMsg(FormErrorTypes.pattern, t, t('address.block').toLowerCase()),
                            },
                            maxLength: {
                                value: 255,
                                message: getErrorMsg(FormErrorTypes.maxLength, t, 255),
                            },
                        }), "data-testid": "block-number-field", onChange: function () { return validateInput('block'); }, onKeyPress: function (ev) { return isNumberKey(ev); } }),
                    parseInt(getValues('block')) === 0 && React.createElement(ErrorLabel, { message: t('address.blockValueGreaterThanZero') }),
                    parseInt(getValues('block')) !== 0 && errors.block && React.createElement(ErrorLabel, { message: errors.block.message }))),
                !isQatarAddressFields && (React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, disabled: true, testid: 'area-field', defaultValue: (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) ? editInfo === null || editInfo === void 0 ? void 0 : editInfo.emirate : emirate, label: t('address.area'), color: COLORS.BLUE, name: "area" }))),
                React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.landmark ? 'error' : 'primary', testid: 'landmark-field', defaultValue: landmark, label: t('address.closestLandmark'), color: COLORS.BLUE, name: "landmark", allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () {
                            validateInput('landmark');
                            onLandmarkChange();
                        }, register: register({
                            maxLength: 255,
                        }) }),
                    errors.landmark && React.createElement(ErrorLabel, { message: errors.landmark.message })),
                React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, testid: 'delivery-instructions-field', defaultValue: deliveryInstructions, label: t('address.deliveryInstructions'), color: COLORS.BLUE, name: "deliveryInstructions", allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () { return validateInput('deliveryInstructions'); }, register: register({
                            minLength: 1,
                            maxLength: 255,
                        }) }))),
            React.createElement(AddressLabel$1, { setAddressLabel: setAddressLabel, register: register, errors: errors, defaultAddressLabel: defaultAddressLabel, isShowCustomField: (defaultAddressLabel && firstName) || !firstName ? true : false }),
            React.createElement(Box, { mt: 16 },
                React.createElement(LabelHeading, null, t('address.receiverInformation')),
                React.createElement(Input, { mui: true, variant: errors.fullName ? 'error' : 'primary', testid: 'receiver-name-field', defaultValue: firstName || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.fullName), label: t('address.receiverName'), color: COLORS.BLUE, name: "fullName", onChange: function () { return validateInput('fullName'); }, register: register({
                        required: t('address.requiredField'),
                        minLength: 1,
                        maxLength: 255,
                    }) }),
                errors.fullName && React.createElement(ErrorLabel, { message: errors.fullName.message }),
                React.createElement(Flex, { justifyContent: "space-between" },
                    React.createElement(Flex, { width: isMobile ? '29%' : '25%' }, isInternationalPhoneNumberEnabled ? (React.createElement(Controller, { control: control, as: CustomSelect, options: countriesList, defaultValue: defaultSelectValue, name: "phoneCountryCode", variant: errors.country_code ? 'error' : 'primary', register: register({}), isLabelSeletionNull: false, m: 0, onClick: function () {
                            setDropDownClicked(true);
                            handleControllerClick();
                            validatePhoneNumber();
                        } })) : (React.createElement(React.Fragment, null,
                        React.createElement(Input, { mui: true, label: t('address.country'), icon: countryName && getIcon(countryName), testid: "country-code-field", value: phoneCountryCode, disabled: true })))),
                    React.createElement(Box, { width: isMobile ? '68%' : '70%' },
                        React.createElement(Input, { mui: true, variant: errors.phone ? 'error' : 'primary', testid: 'phone-number-field', defaultValue: phoneNumberShaper(phone || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone), isInternationalPhoneNumberEnabled), label: t('address.mobileNumber'), name: "phone", successIcon: true, onChange: function (e) {
                                validatePhoneNumber();
                                var phoneCodeValue = getValues().phoneCountryCode;
                                if (!(phoneCodeValue === null || phoneCodeValue === void 0 ? void 0 : phoneCodeValue.label)) {
                                    phoneCodeValue = {
                                        label: phoneCountryCode,
                                        value: code,
                                    };
                                }
                                var isValid = isNumberValid((phoneCodeValue === null || phoneCodeValue === void 0 ? void 0 : phoneCodeValue.label) + e.target.value, phoneCodeValue === null || phoneCodeValue === void 0 ? void 0 : phoneCodeValue.value);
                                isValid
                                    ? clearErrors('phone')
                                    : setError('phone', {
                                        type: 'phone_expression',
                                        message: t('address.invalidPhone'),
                                    });
                            }, allowedRegExpChars: "alphanumericCommaPeriod", autoComplete: "tel", color: COLORS.BLUE, register: register({}), iconRight: phoneVerified &&
                                phoneNumberShaper(phone || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone)) && (React.createElement(Check, { size: "M", fill: COLORS.GREEN, stroke: COLORS.GREEN })) }))),
                errors.phone && React.createElement(ErrorLabel, { message: errors.phone.message }),
                (addressList === null || addressList === void 0 ? void 0 : addressList.length) && !defaultAddress ? (React.createElement(Flex, { justifyContent: "space-between", mt: 30, alignItems: "center", style: { position: 'relative' } },
                    React.createElement(Text, null, t('address.setAsDefault')),
                    React.createElement(Switch, { checked: isDefaultAddress, onChange: onChangeSwitchHandle, disabled: defaultAddress }))) : (''),
                React.createElement(FormFooter, null,
                    React.createElement(ButtonWrapper$1, null,
                        React.createElement(Back, { variant: "link" }, t('back')),
                        React.createElement(DeliverTo, { width: "202px", testid: "address-submit-button", type: "submit", variant: "custom", preventTextTransform: true, disabledNewUI: editInfo.id ? false : !isDirty || !isValid, disabled: isSubmitBtnDisabled }, editInfo.id ? t('address.updateAddress') : t('address.save'))))))));
};
var AddAddressForm$1 = withTranslation()(AddAddressForm);
var H3 = Text.H3, Paragraph$3 = Text.Paragraph;
var getIcon$1 = function (countryName) {
    switch (countryName) {
        case 'UAE':
            return React.createElement(UAEFlag, { size: "L" });
        case 'Bahrain':
            return React.createElement(BahrainFlag, { size: "L" });
        case 'Egypt':
            return React.createElement(EgyptFlag, { size: "L" });
        case 'Jordan':
            return React.createElement(JordanFlag, { size: "L" });
        case 'Kuwait':
            return React.createElement(KuwaitFlag, { size: "L" });
        case 'Lebanon':
            return React.createElement(LebanonFlag, { size: "L" });
        case 'Oman':
            return React.createElement(OmanFlag, { size: "L" });
        case 'Pakistan':
            return React.createElement(PakistanFlag, { size: "L" });
        case 'Qatar':
            return React.createElement(QatarFlag, { size: "L" });
        case 'KSA':
            return React.createElement(KSAFlag, { size: "L" });
        case 'Kenya':
            return React.createElement(KenyaFlag, { size: "L" });
        case 'Georgia':
            return React.createElement(GeorgiaFlag, { size: "L" });
        default:
            return countryName;
    }
};
var AddAddressFormWithArea = function (_a) {
    var _b;
    var onAddressSuccess = _a.onAddressSuccess, countryConfig = _a.countryConfig, t = _a.t, _c = _a.editInfo, editInfo = _c === void 0 ? {} : _c, isHidden = _a.isHidden, userProfile = _a.userProfile, isSetSelectedAddress = _a.isSetSelectedAddress, block = _a.block, building = _a.building;
    var streetName = editInfo.streetName, landmark = editInfo.landmark, firstName = editInfo.firstName, phone = editInfo.phone, defaultAddress = editInfo.defaultAddress, region = editInfo.region, deliveryArea = editInfo.deliveryArea, defaultAddressLabel = editInfo.addressLabel, deliveryInstructions = editInfo.deliveryInstructions, appartment = editInfo.appartment, makani = editInfo.makani;
    var phoneCountryCode = countryConfig.phoneCountryCode, _d = countryConfig.phoneExpression, phoneExpression = _d === void 0 ? '' : _d;
    var _e = __read$1(useState(defaultAddressLabel), 2), addressLabel = _e[0], setAddressLabel = _e[1];
    var _f = useForm({
        mode: 'onBlur',
    }), register = _f.register, errors = _f.errors, handleSubmit = _f.handleSubmit, trigger = _f.trigger,
    setValue = _f.setValue, clearErrors = _f.clearErrors, getValues = _f.getValues, formState = _f.formState;
    var dispatch = useDispatch();
    var _g = useAddress(t), validateCity = _g.validateCity, validateCityQatar = _g.validateCityQatar, validateArea = _g.validateArea, validateQatarArea = _g.validateQatarArea, validateQatarZone = _g.validateQatarZone, isCityAvailableInList = _g.isCityAvailableInList, isQatarCityAvailableInList = _g.isQatarCityAvailableInList, fetchCitiesZonesAndAreasQatar = _g.fetchCitiesZonesAndAreasQatar, isPhoneVerified = _g.isPhoneVerified, error = _g.error, addressList = _g.addressList, phoneNumberShaper = _g.phoneNumberShaper;
    var _h = __read$1(useState(!isExisty(defaultAddress) || !(addressList === null || addressList === void 0 ? void 0 : addressList.length) ? true : defaultAddress), 2), isDefaultAddress = _h[0], setIsDefaultAddress = _h[1];
    var _j = __read$1(useState(), 2), formData = _j[0], setFormData = _j[1];
    var _k = __read$1(useState(false), 2), isVerifyOTPOpen = _k[0], setIsVerifyOTPOpen = _k[1];
    var _l = __read$1(useState(''), 2), warningMsg = _l[0], setWarningMsg = _l[1];
    var _m = __read$1(useState(false), 2), phoneVerified = _m[0], setPhoneVerified = _m[1];
    var _o = __read$1(useState(false), 2), isEditPopulated = _o[0], setEditPopulated = _o[1];
    var _p = useAddress(t), addNEditAddressWithArea = _p.addNEditAddressWithArea, citiesAndAreaState = _p.citiesAndAreaState, qatarCitiesAndAreaState = _p.qatarCitiesAndAreaState;
    var _q = __read$1(useState(), 2), city = _q[0], setCity = _q[1];
    var _r = __read$1(useState(), 2), zone = _r[0], setZone = _r[1];
    var _s = __read$1(useState(), 2), area = _s[0], setArea = _s[1];
    var _t = __read$1(useState([]), 2), areaList = _t[0], setAreaList = _t[1];
    var _u = __read$1(useState([]), 2), zoneList = _u[0], setZoneList = _u[1];
    var didRecordInteractionWithAreaField = useRef(false);
    var didRecordInteractionWithZoneField = useRef(false);
    var _v = __read$1(useAppConfig(), 1), _w = _v[0], _x = _w.areaCode, areaCode = _x === void 0 ? '' : _x, language = _w.language, countryName = _w.countryName;
    useFetchAreas(areaCode, language);
    var isQatarCountry = APP_CONFIG.storeId === EStoreID.MAFQAT;
    var isEngLanguage = language === 'en';
    var isBlockAddressFields = ((_b = useFeature('BLOCK_ADDRESS_FIELD')) === null || _b === void 0 ? void 0 : _b.on) || false;
    var updateInteractionFlags = useCallback(function () {
        didRecordInteractionWithAreaField.current = true;
    }, [didRecordInteractionWithAreaField]);
    var updateZoneInteractionFlags = useCallback(function () {
        didRecordInteractionWithZoneField.current = true;
    }, [didRecordInteractionWithZoneField]);
    var resetAreaField = useCallback(function (listArray) {
        if (listArray === void 0) { listArray = []; }
        setAreaList(listArray);
        setValue('area', '');
        setArea(undefined);
        clearErrors('area');
        didRecordInteractionWithAreaField.current = false;
    }, [clearErrors, setValue]);
    var resetZoneField = useCallback(function (listArray) {
        if (listArray === void 0) { listArray = []; }
        setZoneList(listArray);
        setValue('zone', '');
        setZone(undefined);
        clearErrors('zone');
        didRecordInteractionWithAreaField.current = false;
    }, [clearErrors, setValue]);
    var autocompleteCityValues = useMemo(function () {
        var _a;
        if (isQatarCountry) {
            return ((_a = qatarCitiesAndAreaState === null || qatarCitiesAndAreaState === void 0 ? void 0 : qatarCitiesAndAreaState.qatarCities) === null || _a === void 0 ? void 0 : _a.cities) ? qatarCitiesAndAreaState.qatarCities.cities.map(function (item) {
                return {
                    displayName: isEngLanguage ? item.cityNameEN : item.cityNameAR,
                    value: item,
                };
            })
                : [];
        }
        else {
            return citiesAndAreaState ? getCitiesValue(citiesAndAreaState) : [];
        }
    }, [citiesAndAreaState, isEngLanguage, isQatarCountry, qatarCitiesAndAreaState]);
    var getVariant = useCallback(function (key) {
        if (!didRecordInteractionWithAreaField.current &&
            key === 'area' &&
            (areaList.length === 0 || (getValues('area') || '').length === 0)) {
            return 'primary';
        }
        return errors[key] ? 'error' : formState.touched[key] ? 'success' : 'primary';
    }, [errors, formState, areaList.length, getValues]);
    var autocompleteAreaValues = useMemo(function () {
        if (isQatarCountry)
            return getQatarAreaValue(areaList, isEngLanguage);
        return getAreaValue(areaList);
    }, [areaList, isEngLanguage, isQatarCountry]);
    var autoCompleteZoneValues = useMemo(function () { return zoneList === null || zoneList === void 0 ? void 0 : zoneList.map(function (zone) {
        return { displayName: zone.zoneNo, value: zone };
    }); }, [zoneList]);
    var validateInput = function (fieldName) {
        setValue(fieldName, getValues(fieldName).replace(alphanumericCommaPeriodArabic, ''));
    };
    var onSuccess = useCallback(function (res) {
        onAddressSuccess && onAddressSuccess(res);
    }, [onAddressSuccess]);
    var onCitySelection = useCallback(function (value) { return __awaiter$1(void 0, void 0, void 0, function () {
        var zones, restValue, areas, restValue;
        return __generator$1(this, function (_a) {
            if (isQatarCountry) {
                zones = value.zones, restValue = __rest$1(value, ["zones"]);
                setCity(restValue);
                resetZoneField(zones);
                resetAreaField([]);
                setValue('city', isEngLanguage ? restValue.cityNameEN : restValue.cityNameAR);
                trigger('city');
            }
            else {
                areas = value.areas, restValue = __rest$1(value, ["areas"]);
                setCity(restValue);
                resetAreaField(areas);
                setValue('city', restValue.name);
                trigger('city');
            }
            return [2 ];
        });
    }); }, [resetAreaField, resetZoneField, trigger, isEngLanguage, isQatarCountry, setValue]);
    var onAreaSelection = useCallback(function (value) {
        setArea(value);
        setValue('area', isQatarCountry ? (isEngLanguage ? value.areaNameEN : value.areaNameAR) : value.name);
        trigger('area');
    }, [trigger, isEngLanguage, isQatarCountry, setValue]);
    var onZoneSelection = useCallback(function (value) { return __awaiter$1(void 0, void 0, void 0, function () {
        var areas, restValue;
        return __generator$1(this, function (_a) {
            areas = value.areas, restValue = __rest$1(value, ["areas"]);
            setZone(restValue);
            resetAreaField(areas);
            setValue('zone', value.zoneNo);
            trigger('zone');
            return [2 ];
        });
    }); }, [trigger, resetAreaField, setValue]);
    var onFormDataSave = function (formData, uuid) {
        var _a, _b;
        if (formData) {
            var ssoType = editInfo.ssoType, id = editInfo.id;
            var address = addressLabel === CustomLabel(t) ? formData.addressLabel : addressLabel;
            var qatarCityAreaData = isQatarCountry
                ? getSelectedDeliveryArea(citiesAndAreaState, area)
                : { city: city, area: area };
            var data = __assign$1(__assign$1({}, formData), { city: qatarCityAreaData.city, area: qatarCityAreaData.area, addressLabel: address, defaultAddress: isDefaultAddress, isSetSelectedAddress: isSetSelectedAddress, zone: zone, isQatarCountry: isQatarCountry,
                onSuccess: onSuccess });
            if (uuid) {
                data = __assign$1(__assign$1({}, data), { addressVerificationRefId: uuid });
            }
            if ((data === null || data === void 0 ? void 0 : data.area) && (data === null || data === void 0 ? void 0 : data.defaultAddress)) {
                setDeliveryArea((_a = data === null || data === void 0 ? void 0 : data.area) === null || _a === void 0 ? void 0 : _a.code);
                dispatch(setAreaCode((_b = data === null || data === void 0 ? void 0 : data.area) === null || _b === void 0 ? void 0 : _b.code));
                dispatch(fetchAreas());
            }
            var editInformation = void 0;
            if (id && ssoType) {
                editInformation = { id: id, ssoType: ssoType };
            }
            addNEditAddressWithArea(data, editInformation);
            setIsVerifyOTPOpen(false);
        }
    };
    var onFormSubmit = function (formData) { return __awaiter$1(void 0, void 0, void 0, function () {
        return __generator$1(this, function (_a) {
            if (isBlockAddressFields) {
                formData.building = formData.building + "|Block#" + formData.block;
            }
            formData.phone = formData.phone.replace(/^0/, '');
            if (!phoneVerified) {
                setFormData(formData);
                setIsVerifyOTPOpen(true);
            }
            else {
                onFormDataSave(formData, '');
            }
            return [2 ];
        });
    }); };
    var validatePhoneNumber = function () {
        var _a;
        var phoneRegex = new RegExp(phoneExpression);
        var phoneNumber = (_a = getValues('phone')) === null || _a === void 0 ? void 0 : _a.replace(/^0/, '');
        if (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.match(phoneRegex)) {
            isPhoneVerified(phoneCountryCode + phoneNumber, function (isPhoneVerified) {
                setPhoneVerified(isPhoneVerified);
            });
        }
        else {
            setPhoneVerified(false);
        }
    };
    useEffect(function () {
        if (phone || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone)) {
            validatePhoneNumber();
        }
    }, [phone, userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone]);
    var onChangeSwitchHandle = function () {
        var value = !isDefaultAddress;
        setIsDefaultAddress(value);
    };
    var onCloseOTPVerifyModal = function () {
        setIsVerifyOTPOpen(false);
        var warningMsg = phone
            ? t('verifyOTP.verifyYourMobileNumberToUpdateAddress')
            : t('verifyOTP.verifyYourMobileNumberToAddAddress');
        setWarningMsg(warningMsg);
    };
    useEffect(function () {
        if (region && !zone && !isEditPopulated) {
            var isAValidCityName = isQatarCountry
                ? isQatarCityAvailableInList(region.name)
                : isCityAvailableInList(region.name);
            if (isAValidCityName) {
                onCitySelection(isAValidCityName);
            }
        }
    }, [
        region,
        isQatarCountry,
        isEditPopulated,
        zone,
        onCitySelection,
        isCityAvailableInList,
        isQatarCityAvailableInList,
    ]);
    useEffect(function () {
        if (makani && zoneList && zoneList.length && !isEditPopulated) {
            setEditPopulated(true);
            var qatarZone = isQatarCountry && validateQatarZone(zoneList, makani);
            isQatarCountry && onZoneSelection(qatarZone);
        }
    }, [isEditPopulated, zoneList, makani, isQatarCountry, onZoneSelection, validateQatarZone]);
    useEffect(function () {
        if (deliveryArea && areaList && areaList.length) {
            var isAValidAreaName = isQatarCountry
                ? validateQatarArea(areaList, deliveryArea.name)
                : validateArea(areaList, deliveryArea.name);
            onAreaSelection(isAValidAreaName);
        }
    }, [areaList, deliveryArea, isQatarCountry, onAreaSelection, validateArea, validateQatarArea]);
    useEffect(function () {
        if (isQatarCountry) {
            fetchCitiesZonesAndAreasQatar();
        }
    }, [fetchCitiesZonesAndAreasQatar, isQatarCountry]);
    var notificationMessage = useMemo(function () {
        return (warningMsg || error) && React.createElement(Notification, { my: 2 }, warningMsg || (error && t('errorGeneral')));
    }, [error, warningMsg, t]);
    var isNumberKey = function (evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
            return false;
        }
        return true;
    };
    return (React.createElement(React.Fragment, null,
        isVerifyOTPOpen && (React.createElement(VerifyPassword, { isShowShopping: false, email: getUserEmailFromCookie(), phoneNumber: phoneCountryCode + (formData === null || formData === void 0 ? void 0 : formData.phone), onVerifyAccount: function (uuid) { return onFormDataSave(formData, uuid); }, onCloseModal: function () { return onCloseOTPVerifyModal(); }, action: "ADDRESS_PHONE_VERIFICATION" })),
        React.createElement(Flex, { flexDirection: "column", flex: 1, mt: 16, as: "form", onSubmit: handleSubmit(onFormSubmit), style: { display: isHidden ? 'none' : 'flex' }, "data-testid": "__non-location-cx-address__" },
            React.createElement(Box, null,
                notificationMessage,
                React.createElement(H3, null, t('address.addressInformation')),
                React.createElement(Autocomplete, { used: city, label: t('address.city'), values: autocompleteCityValues, defaultValue: region === null || region === void 0 ? void 0 : region.name, variant: getVariant('city'), onSelection: onCitySelection, register: register({
                        required: getErrorMsg(FormErrorTypes.required, t),
                        validate: isQatarCountry ? validateCityQatar : validateCity,
                    }), name: "city", successIcon: true, testid: "appartment-number-field", allowedRegExpChars: isRTL() ? undefined : 'alphanumericCommaPeriod', backgroundColor: COLORS.LIGHT_GREY }),
                errors.city && (React.createElement(Paragraph$3, { color: COLORS.RED, mt: 1, fontSize: TYPOGRAPHY.SIZE[10] }, errors.city.message)),
                React.createElement(Flex, null,
                    isQatarCountry && (React.createElement(LeftBox, { mr: 2 },
                        React.createElement(Autocomplete, { used: zone, label: t('address.zone'), onSelection: onZoneSelection, defaultValue: makani, values: autoCompleteZoneValues, successIcon: true, name: "zone", register: register({
                                required: getErrorMsg(FormErrorTypes.required, t),
                                validate: function (value) { return validateQatarZone(zoneList, value); },
                            }), disabled: autoCompleteZoneValues.length < 1, variant: getVariant('zone'), testid: "zone-field", onFocus: updateZoneInteractionFlags, allowedRegExpChars: isRTL() ? undefined : 'alphanumericCommaPeriod', backgroundColor: COLORS.LIGHT_GREY }),
                        errors.zone && (zoneList.length !== 0 || didRecordInteractionWithZoneField.current) && (React.createElement(Paragraph$3, { color: COLORS.RED, mt: 1, fontSize: TYPOGRAPHY.SIZE[10] }, errors.zone.message)))),
                    React.createElement(Box, { style: { width: isQatarCountry ? '63%' : '100%' } },
                        React.createElement(Autocomplete, { used: area, label: t('address.area'), onSelection: onAreaSelection, defaultValue: deliveryArea === null || deliveryArea === void 0 ? void 0 : deliveryArea.name, values: autocompleteAreaValues, successIcon: true, name: "area", register: register({
                                required: getErrorMsg(FormErrorTypes.required, t),
                                validate: function (value) {
                                    return isQatarCountry ? validateQatarArea(areaList, value) : validateArea(areaList, value);
                                },
                            }), disabled: autocompleteAreaValues.length < 1, variant: getVariant('area'), testid: "area-field", onFocus: updateInteractionFlags, allowedRegExpChars: isRTL() ? undefined : 'alphanumericCommaPeriod', backgroundColor: COLORS.LIGHT_GREY }),
                        errors.area && (areaList.length !== 0 || didRecordInteractionWithAreaField.current) && (React.createElement(Paragraph$3, { color: COLORS.RED, mt: 1, fontSize: TYPOGRAPHY.SIZE[10] }, errors.area.message)))),
                React.createElement(Flex, null,
                    React.createElement(LeftBox, { mr: 2 },
                        React.createElement(Input, { label: isQatarCountry ? t('address.street') : t('address.streetName'), successIcon: true, name: "streetName", defaultValue: streetName, register: register({
                                required: getErrorMsg(FormErrorTypes.required, t),
                                maxLength: {
                                    value: 255,
                                    message: getErrorMsg(FormErrorTypes.maxLength, t, 255),
                                },
                                pattern: {
                                    value: isQatarCountry ? numericExpression : addressInputRegex,
                                    message: getErrorMsg(FormErrorTypes.pattern, t, (isQatarCountry ? t('address.street') : t('address.streetName')).toLowerCase()),
                                },
                            }), variant: getVariant('streetName'), "data-testid": "street-field", allowedRegExpChars: "alphanumericCommaPeriodArabic", autoComplete: "streetName", backgroundColor: COLORS.LIGHT_GREY, onChange: function () { return validateInput('streetName'); } }),
                        errors.streetName && (React.createElement(Paragraph$3, { color: COLORS.RED, mt: 1, fontSize: TYPOGRAPHY.SIZE[10] }, errors.streetName.message))),
                    React.createElement(RightBox, null,
                        React.createElement(Input, { label: isQatarCountry ? t('address.buildingOrCompound') : t('address.buildingName'), successIcon: true, name: "building", defaultValue: building, register: register({
                                required: getErrorMsg(FormErrorTypes.required, t),
                                maxLength: {
                                    value: 255,
                                    message: getErrorMsg(FormErrorTypes.maxLength, t, 255),
                                },
                                pattern: {
                                    value: isQatarCountry ? numericExpression : addressInputRegex,
                                    message: getErrorMsg(FormErrorTypes.pattern, t, (isQatarCountry ? t('address.buildingOrCompound') : t('address.buildingName')).toLowerCase()),
                                },
                            }), variant: getVariant('building'), "data-testid": "building-field", autoComplete: "building", allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () { return validateInput('building'); }, backgroundColor: COLORS.LIGHT_GREY }),
                        errors.building && (React.createElement(Paragraph$3, { color: COLORS.RED, mt: 1, fontSize: TYPOGRAPHY.SIZE[10] }, errors.building.message)))),
                isBlockAddressFields && (React.createElement(React.Fragment, null,
                    React.createElement(Input, { label: t('address.block'), successIcon: true, name: "block", defaultValue: block, register: register({
                            required: getErrorMsg(FormErrorTypes.required, t),
                            min: 1,
                            pattern: {
                                value: numericExpression,
                                message: getErrorMsg(FormErrorTypes.pattern, t, t('address.block').toLowerCase()),
                            },
                            maxLength: {
                                value: 255,
                                message: getErrorMsg(FormErrorTypes.maxLength, t, 255),
                            },
                        }), variant: getVariant('block'), "data-testid": "block-number-field", onChange: function () { return validateInput('block'); }, autoComplete: "block", backgroundColor: COLORS.LIGHT_GREY, onKeyPress: function (ev) { return isNumberKey(ev); } }),
                    parseInt(getValues('block')) === 0 && (React.createElement(Paragraph$3, { color: COLORS.RED, mt: 1, fontSize: TYPOGRAPHY.SIZE[10] }, t('address.blockValueGreaterThanZero'))),
                    parseInt(getValues('block')) !== 0 && errors.block && (React.createElement(Paragraph$3, { color: COLORS.RED, mt: 1, fontSize: TYPOGRAPHY.SIZE[10] }, errors.block.message)))),
                React.createElement(Input, { label: t('address.apartment'), successIcon: true, name: "appartment", defaultValue: appartment, register: register({
                        required: getErrorMsg(FormErrorTypes.required, t),
                        maxLength: {
                            value: 255,
                            message: getErrorMsg(FormErrorTypes.maxLength, t, 255),
                        },
                        pattern: {
                            value: addressInputRegex,
                            message: getErrorMsg(FormErrorTypes.pattern, t, t('address.apartment').toLowerCase()),
                        },
                    }), variant: getVariant('appartment'), "data-testid": "appartment-number-field", allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () { return validateInput('appartment'); }, autoComplete: "appartment", backgroundColor: COLORS.LIGHT_GREY }),
                errors.appartment && (React.createElement(Paragraph$3, { color: COLORS.RED, mt: 1, fontSize: TYPOGRAPHY.SIZE[10] }, errors.appartment.message)),
                !isQatarCountry && (React.createElement(React.Fragment, null,
                    React.createElement(Input, { testid: 'landmark-field', defaultValue: landmark, label: t('address.landmarkOptional'), color: COLORS.BLUE, name: "landmark", variant: getVariant('landmark'), successIcon: true, allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () { return validateInput('landmark'); }, register: register({
                            maxLength: {
                                value: 255,
                                message: getErrorMsg(FormErrorTypes.maxLength, t, 255),
                            },
                            pattern: {
                                value: addressInputRegex,
                                message: getErrorMsg(FormErrorTypes.pattern, t, t('address.landmark').toLowerCase()),
                            },
                        }), backgroundColor: COLORS.LIGHT_GREY }),
                    React.createElement(Paragraph$3, { color: COLORS.SILVER_CHALICE, mt: 2, fontSize: TYPOGRAPHY.SIZE[10] }, t('address.lHint')),
                    errors.landmark && (React.createElement(Paragraph$3, { color: COLORS.RED, mt: 1, fontSize: TYPOGRAPHY.SIZE[10] }, errors.landmark.message)))),
                React.createElement(Input, { testid: 'delivery-instructions-field', defaultValue: deliveryInstructions, label: t('address.di'), color: COLORS.BLUE, name: "deliveryInstructions", allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () { return validateInput('deliveryInstructions'); }, variant: getVariant('deliveryInstructions'), register: register({}), backgroundColor: COLORS.LIGHT_GREY }),
                React.createElement(Paragraph$3, { color: COLORS.SILVER_CHALICE, mt: 2, fontSize: TYPOGRAPHY.SIZE[10] }, t('address.diHint'))),
            React.createElement(AddressLabel$1, { setAddressLabel: setAddressLabel, register: register, errors: errors, defaultAddressLabel: defaultAddressLabel, backgroundColor: COLORS.LIGHT_GREY, addressLabels: function (t) { return [t('address.home'), t('address.office')]; }, isShowCustomField: false }),
            React.createElement(Box, { mt: 16 },
                React.createElement(H3, null, t('address.receiverInformation')),
                React.createElement(Input, { testid: 'receiver-name-field', defaultValue: firstName || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.fullName), label: t('address.receiverName'), color: COLORS.BLUE, name: "fullName", successIcon: true, variant: getVariant('fullName'), allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () { return validateInput('fullName'); }, register: register({
                        required: getErrorMsg(FormErrorTypes.required, t),
                        maxLength: {
                            value: 255,
                            message: getErrorMsg(FormErrorTypes.maxLength, t, 255),
                        },
                        pattern: {
                            value: nonSpaceAlphabetsOnlyRegEx,
                            message: getErrorMsg(FormErrorTypes.pattern, t, t('address.name')),
                        },
                    }), backgroundColor: COLORS.LIGHT_GREY }),
                errors.fullName && (React.createElement(Paragraph$3, { color: COLORS.RED, mt: 1, fontSize: TYPOGRAPHY.SIZE[10] }, errors.fullName.message)),
                React.createElement(Flex, { justifyContent: "space-between" },
                    React.createElement(Flex, { width: "25%" },
                        React.createElement(Flex, { alignSelf: "flex-end" }, countryName && getIcon$1(countryName)),
                        React.createElement(Input, { testid: "country-code-field", label: phoneCountryCode, disabled: true, backgroundColor: COLORS.LIGHT_GREY })),
                    React.createElement(Box, { width: "75%" },
                        React.createElement(Input, { testid: 'phone-number-field', defaultValue: phoneNumberShaper(phone || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone)), label: t('address.mobileNumber'), name: "phone", variant: getVariant('phone'), successIcon: true, onChange: validatePhoneNumber, allowedRegExpChars: "alphanumericCommaPeriod", autoComplete: "tel", color: COLORS.BLUE, register: register({
                                required: getErrorMsg(FormErrorTypes.required, t),
                                pattern: {
                                    value: new RegExp(phoneExpression),
                                    message: getErrorMsg(FormErrorTypes.pattern, t, t('address.mobileNumber').toLowerCase()),
                                },
                            }), icon: phoneVerified ? React.createElement(Verified, null, t('address.verified')) : React.createElement(Verify, null, t('address.verify')), backgroundColor: COLORS.LIGHT_GREY }))),
                errors.phone && (React.createElement(Paragraph$3, { color: COLORS.RED, mt: 1, fontSize: TYPOGRAPHY.SIZE[10] }, errors.phone.message))),
            React.createElement(Box, { mt: 16 },
                (addressList === null || addressList === void 0 ? void 0 : addressList.length) && !defaultAddress ? (React.createElement(Flex, { justifyContent: "space-between", mt: 14, alignItems: "center", style: { position: 'relative' } },
                    React.createElement(Text, null, t('address.setAsDefault')),
                    React.createElement(Switch, { checked: isDefaultAddress, onChange: onChangeSwitchHandle, disabled: defaultAddress }))) : (''),
                React.createElement(Flex, { my: 20 },
                    React.createElement(Button$1, { flex: 1, type: "submit", testid: "address-submit-button" }, editInfo.id ? t('address.updateAddress') : t('address.addAddress')))))));
};
var AddAddressFormWithArea$1 = withTranslation()(AddAddressFormWithArea);
var SearchBox$1 = function () {
    var _a = __read$1(useState(false), 2), error = _a[0], setError = _a[1];
    var _b = __read$1(useState(false), 2), showCloseIcon = _b[0], setShowCloseIcon = _b[1];
    var inputRef = useRef();
    var t = useTranslation().t;
    var clearSearch = function () {
        inputRef.current.value = '';
        setShowCloseIcon(false);
    };
    var onChangeInput = function () {
        setShowCloseIcon(true);
        if (inputRef.current.value === '') {
            setShowCloseIcon(false);
        }
        setTimeout(function () {
            var pacItem = document.getElementsByClassName('pac-item');
            if (pacItem.length === 0) {
                setError(true);
            }
            else {
                setError(false);
            }
        }, 500);
    };
    var searchText = {
        mafuae: ["" + t('address.searchMessage')],
        mafqat: ["" + t('address.qatarSearchMessage')],
        mafkwt: ["" + t('address.kuwaitSearchMessage')],
    };
    return (React.createElement(Box, { width: "100%", style: {
            position: 'absolute',
            zIndex: '2',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingTop: '12px',
            alignItems: 'center',
        } },
        React.createElement(SearchMessage, null,
            React.createElement(SearchLabel, null, searchText[APP_CONFIG.storeId])),
        React.createElement(SearchWrapper, null,
            React.createElement(SearchInputBox, { error: error, ref: inputRef, type: "text", placeholder: t('address.searchPlaceholder'), id: "pac-input-add-address", onChange: onChangeInput }),
            React.createElement(SearchIconContainer, null,
                React.createElement(Search$2, { size: "S", fill: COLORS.GRAY_500 })),
            showCloseIcon && (React.createElement(ClearSearchContainer, { onClick: function () { return clearSearch(); } },
                React.createElement(CancelDark, { size: "S", fill: COLORS.GRAY_900 })))),
        error && (React.createElement(SearchErrorMessage, null,
            React.createElement(WarningOctagon, { size: "M", width: "22px", height: "22px", fill: "#F34041" }),
            React.createElement(SearchErrorLabel, null, t('address.searchErrorMessage'))))));
};
var getLocation = function (defaultLat, defaultLng) { return __awaiter$1(void 0, void 0, void 0, function () {
    var resolve, onSuccess, onError, options;
    return __generator$1(this, function (_a) {
        onSuccess = function (pos) {
            var crd = pos.coords;
            resolve({ lat: crd.latitude, lng: crd.longitude });
        };
        onError = function () {
            resolve({ lat: Number(defaultLat), lng: Number(defaultLng), isDefaultLocation: true });
        };
        if (window.navigator.geolocation) {
            options = { enableHighAccuracy: true, timeout: 10000 };
            window.navigator.geolocation.getCurrentPosition(onSuccess, onError, options);
            return [2 , new Promise(function (res) {
                    resolve = res;
                })];
        }
        return [2 ];
    });
}); };
var getLatLong = function (editInfo) { return __awaiter$1(void 0, void 0, void 0, function () {
    var latLong, searchAddress, response, _a, lat, lng;
    var _b;
    return __generator$1(this, function (_c) {
        switch (_c.label) {
            case 0:
                latLong = null;
                if (!process.env.REACT_APP_GOOGLE_MAP_API_KEY) return [3 , 2];
                Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAP_API_KEY);
                searchAddress = (editInfo === null || editInfo === void 0 ? void 0 : editInfo.deliveryArea) ? editInfo.line1 + " " + editInfo.town + " " + ((_b = editInfo === null || editInfo === void 0 ? void 0 : editInfo.region) === null || _b === void 0 ? void 0 : _b.name)
                    : editInfo === null || editInfo === void 0 ? void 0 : editInfo.town;
                return [4 , Geocode.fromAddress(searchAddress).catch(function () {
                        latLong = null;
                    })];
            case 1:
                response = _c.sent();
                if ((response === null || response === void 0 ? void 0 : response.results) && response.results[0]) {
                    _a = response.results[0].geometry.location, lat = _a.lat, lng = _a.lng;
                    latLong = { lat: lat, lng: lng };
                }
                _c.label = 2;
            case 2: return [2 , latLong];
        }
    });
}); };
var useGetLocation = function () {
    var _a = __read$1(useState(), 2), location = _a[0], setLocation = _a[1];
    var dispatch = useDispatch();
    var countryConfig = useSelector(function (state) { return state.userData.countryConfig; }) || {};
    var appConfig = useSelector(function (state) { return state.appConfig; }) || {};
    useEffect(function () {
        var _a;
        fetchUserCountryConfig()(dispatch);
        if (!((_a = appConfig.features) === null || _a === void 0 ? void 0 : _a.isLocationCXEnable)) {
            fetchUserDeliveryAreas()(dispatch);
        }
    }, [dispatch, appConfig.features]);
    var fetchLocation = useCallback(function (editInfo, isSetDefaultCountryLocation, isSelectedLatLong) {
        if (isSetDefaultCountryLocation === void 0) { isSetDefaultCountryLocation = false; }
        if (isSelectedLatLong === void 0) { isSelectedLatLong = true; }
        return __awaiter$1(void 0, void 0, void 0, function () {
            var latitude, longitude, latLngFromAddress, res, e_1;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        latitude = Number(appConfig.latitude);
                        longitude = Number(appConfig.longitude);
                        if (!(editInfo && editInfo !== true)) return [3 , 4];
                        if (!(isNaN(editInfo.latitude) || isNaN(editInfo.longitude))) return [3 , 2];
                        return [4 , getLatLong(editInfo)];
                    case 1:
                        latLngFromAddress = _a.sent();
                        if (latLngFromAddress) {
                            setLocation({ lat: latLngFromAddress.lat, lng: latLngFromAddress.lng });
                        }
                        else {
                            setLocation({ lat: latitude, lng: longitude });
                        }
                        return [3 , 3];
                    case 2:
                        setLocation({ lat: Number(editInfo.latitude), lng: Number(editInfo.longitude) });
                        _a.label = 3;
                    case 3: return [3 , 10];
                    case 4:
                        _a.trys.push([4, 9, , 10]);
                        if (!(latitude && longitude)) return [3 , 8];
                        res = {
                            lat: latitude,
                            lng: longitude,
                            isDefaultLocation: true,
                        };
                        if (!(isSelectedLatLong && latitude && longitude)) return [3 , 5];
                        res = {
                            lat: latitude,
                            lng: longitude,
                            isDefaultLocation: false,
                        };
                        return [3 , 7];
                    case 5:
                        if (!!isSetDefaultCountryLocation) return [3 , 7];
                        return [4 , getLocation(latitude, longitude)];
                    case 6:
                        res = (_a.sent());
                        _a.label = 7;
                    case 7:
                        setLocation(res);
                        _a.label = 8;
                    case 8: return [3 , 10];
                    case 9:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 , 10];
                    case 10: return [2 ];
                }
            });
        });
    }, [appConfig]);
    return [location, fetchLocation, countryConfig, appConfig];
};
var CurrentlySelected = function (_a) {
    var _b = _a.mt, mt = _b === void 0 ? 12 : _b, t = _a.t, isVisible = _a.isVisible, addressInfo = _a.addressInfo, isAreaNotSupported = _a.isAreaNotSupported, formattedGoogleAddressDescription = _a.formattedGoogleAddressDescription, emirate = _a.emirate;
    var countryConfiguration = useSelector(function (state) { return state.appConfig; }).countryConfiguration;
    var _c = countryConfiguration || {}, countryNameEn = _c.countryNameEn, countryNameAr = _c.countryNameAr;
    return (React.createElement(Flex, { p: 12, mt: mt, style: { display: isVisible ? 'flex' : 'none', flexDirection: 'column' } },
        React.createElement(CurrentlySelectedLabel, null, t('address.currentlySelected')),
        React.createElement(OutofServiceLabel, null, isAreaNotSupported
            ? t('address.notServiceable')
            : formattedGoogleAddressDescription(addressInfo, emirate, countryNameEn || countryNameAr))));
};
var CurrentlySelected$1 = withTranslation()(CurrentlySelected);
var useCheckAreaIfSupported = function () {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return state.userData.addresses; }), coverageArea = _a.coverageArea, showLoader = _a.showLoader;
    var _b = __read$1(useState({}), 2), updatedLocation = _b[0], setUpdatedLocation = _b[1];
    var checkCoverageArea = useCallback(function (_a) {
        var lat = _a.lat, lng = _a.lng;
        if (lat === updatedLocation.lat && lng === updatedLocation.lng) {
            return;
        }
        checkUserCoverageAreaSupport(String(lat), String(lng))(dispatch);
        setUpdatedLocation({ lat: lat, lng: lng });
    }, [dispatch, updatedLocation.lat, updatedLocation.lng]);
    return [checkCoverageArea, coverageArea, updatedLocation, showLoader];
};
var LOGIN_PAGE$1 = '/login';
var LoginLink = function (_a) {
    var loginRedirection = _a.loginRedirection;
    var t = useTranslation().t;
    var url = LOGIN_PAGE$1;
    if (!!loginRedirection) {
        url = addRedirection(url, loginRedirection);
    }
    return (React.createElement(Flex, { my: 16, justifyContent: "center", as: "nav" },
        React.createElement(LoginLinkText, { as: "a", href: url, isLink: true }, t('address.loginSignup')),
        React.createElement(LoginLinkText, null,
            "\u00A0",
            t('address.loginSignupInfo'))));
};
var MobileAddressForm = function (props) {
    var closeAddressFormDrawer = props.closeAddressFormDrawer, setShowMobileAddressForm = props.setShowMobileAddressForm, setShowAddressForm = props.setShowAddressForm, emirate = props.emirate, showAddressForm = props.showAddressForm, updatedLocation = props.updatedLocation, addressInfo = props.addressInfo, building = props.building, setFlatNo = props.setFlatNo, setBuildingName = props.setBuildingName, setLandmark = props.setLandmark, onSuccess = props.onSuccess, countryConfig = props.countryConfig, editInfo = props.editInfo, town = props.town, country = props.country, userProfile = props.userProfile, isSetSelectedAddress = props.isSetSelectedAddress, block = props.block, isStreeNameChange = props.isStreeNameChange, setIsStreetNameChange = props.setIsStreetNameChange, isCityAreaNameChange = props.isCityAreaNameChange, setIsCityAreaNameChange = props.setIsCityAreaNameChange, showMobileAddressForm = props.showMobileAddressForm, onSelectedLocationChange = props.onSelectedLocationChange;
    return (React.createElement(Box, { flex: 1 },
        React.createElement(AddAddressForm$1, { showAddressForm: showAddressForm, onSelectedLocationChange: onSelectedLocationChange, showMobileAddressForm: showMobileAddressForm, closeAddressFormDrawer: closeAddressFormDrawer, setShowMobileAddressForm: setShowMobileAddressForm, setShowAddressForm: setShowAddressForm, emirate: emirate, editInfo: editInfo, setFlatNo: setFlatNo, setBuildingName: setBuildingName, setLandmark: setLandmark, onAddressSuccess: onSuccess, countryConfig: countryConfig, updatedLocation: updatedLocation, addressInfo: addressInfo, town: town, country: country, userProfile: userProfile, isSetSelectedAddress: isSetSelectedAddress, block: block, building: building, isStreeNameChange: isStreeNameChange, setIsStreetNameChange: setIsStreetNameChange, isCityAreaNameChange: isCityAreaNameChange, setIsCityAreaNameChange: setIsCityAreaNameChange })));
};
var AddAddress$1 = function (props) {
    var isOpen = props.isOpen, isShowCloseButton = props.isShowCloseButton, isGoogleMapVisible = props.isGoogleMapVisible, onClose = props.onClose, onBack = props.onBack,
    onSuccess = props.onSuccess, loginRedirection = props.loginRedirection,
    editInfo = props.editInfo, isSetSelectedAddress = props.isSetSelectedAddress;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _a = __read$1(useGetLocation(), 4), location = _a[0], fetchLocation = _a[1], _b = _a[2], countryConfig = _b === void 0 ? {} : _b, appConfig = _a[3];
    var _c = __read$1(useCheckAreaIfSupported(), 3), checkCoverageArea = _c[0], coverageArea = _c[1], updatedLocation = _c[2];
    var _d = __read$1(useState(editInfo ? editInfo.appartment : ''), 2), flatNo = _d[0], setFlatNo = _d[1];
    var _e = __read$1(useState(editInfo ? editInfo.building : ''), 2), building = _e[0], setBuildingName = _e[1];
    var _f = __read$1(useState(editInfo ? editInfo.landmark : ''), 2), landmark = _f[0], setLandmark = _f[1];
    var _g = __read$1(useState(''), 2), addressInfo = _g[0], setAddressInfo = _g[1];
    var _h = __read$1(useState(''), 2), town = _h[0], setTown = _h[1];
    var _j = __read$1(useState(''), 2), country = _j[0], setCountry = _j[1];
    var _k = __read$1(useState(''), 2), emirate = _k[0], setEmirate = _k[1];
    var _l = __read$1(useState(false), 2), isSelected = _l[0], setIsSelected = _l[1];
    var _m = __read$1(useState(''), 2), block = _m[0], setBlock = _m[1];
    var _o = __read$1(useState(17), 2), zoom = _o[0], setZoom = _o[1];
    var _p = __read$1(useState(false), 2), isStreeNameChange = _p[0], setIsStreetNameChange = _p[1];
    var _q = __read$1(useState(false), 2), isCityAreaNameChange = _q[0], setIsCityAreaNameChange = _q[1];
    var device = useBreakpoints();
    var userProfile = useAddress(t).userProfile;
    var _r = __read$1(useState(false), 2), isCoordsChanged = _r[0], setIsCoordsChanged = _r[1];
    var _s = __read$1(useState(false), 2), showSearchRequiredError = _s[0], setShowSearchRequiredError = _s[1];
    var isBlockAddressField = useFeature('block_address_field').on;
    useEffect(function () {
        if (editInfo && editInfo.building) {
            var block_1 = editInfo.building.split('|Block#');
            if (isBlockAddressField && block_1.length > 1) {
                setBlock(block_1[1]);
                setBuildingName(block_1[0]);
            }
        }
    }, [editInfo, countryConfig, isBlockAddressField]);
    useEffect(function () {
        if (!location && isOpen && isGoogleMapVisible) {
            fetchLocation(editInfo);
        }
    }, [fetchLocation, isOpen, location, editInfo, isGoogleMapVisible]);
    var isMobile = device.isMobile;
    var isLoggedIn = !!getUserTokenFromCookie();
    var extraProps = {};
    if (isMobile) {
        extraProps.style = { height: '100%', borderRadius: '24px 24px 0px 0px' };
    }
    var _t = __read$1(useState(false), 2), showMobileAddressForm = _t[0], setShowMobileAddressForm = _t[1];
    var _u = __read$1(useState(true), 2), showMapDrawer = _u[0], setShowMapDrawer = _u[1];
    var onBackToMap = function () {
        setShowMobileAddressForm(false);
    };
    var isAreaNotSupported = location && !(coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isChecking) && !(coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isSupported);
    var _v = __read$1(useState(false), 2), showAddressForm = _v[0], setShowAddressForm = _v[1];
    useEffect(function () {
        if (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) {
            setShowAddressForm(true);
        }
    }, [editInfo]);
    var closeDrawer = function (e) {
        if (isGoogleMapVisible) {
            var pacContainer = document.getElementsByClassName('pac-container');
            if (pacContainer && !pacContainer[pacContainer.length - 1].contains(e.target)) {
                onClose && onClose();
            }
        }
        else {
            onClose && onClose();
        }
    };
    var headerTitle = function () {
        var headerTitle = '';
        if (!isGoogleMapVisible || !isMobile) {
            headerTitle = editInfo && editInfo.id ? t('address.existingAddress') : t('address.addDeliveryLocation');
        }
        else {
            if (isMobile && showMobileAddressForm) {
                headerTitle = editInfo && editInfo.id ? t('address.existingAddress') : t('address.addDeliveryLocation');
            }
            else if (isMobile && !showMobileAddressForm) {
                headerTitle = t('address.chooseLocation');
            }
        }
        return headerTitle;
    };
    useEffect(function () {
        dispatch(userSetAddressesError(false));
    }, [dispatch]);
    useEffect(function () {
        if ((location === null || location === void 0 ? void 0 : location.lat) !== updatedLocation.lat && (location === null || location === void 0 ? void 0 : location.lng) !== updatedLocation.lng && !isCoordsChanged) {
            setIsCoordsChanged(true);
            setShowSearchRequiredError(false);
        }
    }, [updatedLocation]);
    var onDeliverToLocation = function () {
        if (isMobile) {
            setShowMobileAddressForm(true);
        }
        else {
            setShowAddressForm(true);
        }
    };
    var backToAddressList = function () {
        onBack && onBack();
    };
    var closeAddressFormDrawer = function () {
        setShowMobileAddressForm(false);
        setShowAddressForm(false);
        setShowMapDrawer(false);
        onClose && onClose();
    };
    var onSelectedLocationChange = function () {
        if (isMobile) {
            setShowMobileAddressForm(false);
        }
        setShowAddressForm(false);
        setShowMapDrawer(true);
    };
    return (React.createElement(React.Fragment, null,
        !showAddressForm && showMapDrawer && (React.createElement(Drawer, __assign$1({ variant: "float", isOpen: isOpen && (userProfile === null || userProfile === void 0 ? void 0 : userProfile.fullName), width: ['100%', '400px', '500px'], anchor: ['bottom', null, 'right'], contentStyles: { p: [0], height: '100%', display: 'flex', flexDirection: 'column', fontFamily: 'Montserrat' }, "data-testid": "map-drawer" }, extraProps),
            React.createElement(DrawerHeader$1, { "data-testid": "drawer-header" },
                React.createElement(Flex, { alignItems: "center", justifyContent: "space-between" },
                    isMobile && showMobileAddressForm && (React.createElement(DrawerIconContainer, { "data-testid": "back-icon", onClick: onBackToMap },
                        React.createElement(ArrowLeft, { size: "M" }))),
                    React.createElement(HeaderTitle, { flex: 1 }, headerTitle()),
                    (!isMobile || !showMobileAddressForm) && isShowCloseButton && (React.createElement(DrawerIconContainer, { onClick: closeDrawer, variant: "naked" },
                        React.createElement(DrawerCloseIcon, null))))),
            !isGoogleMapVisible && isLoggedIn && (React.createElement(GoogleMapBox, { "data-sl": "mask" },
                React.createElement(MapContainer, { flexDirection: "column", height: isMobile ? '100%' : 'auto', open: !isMobile || !showMobileAddressForm, "data-testid": "non-location-cx-address" },
                    React.createElement(Flex, { style: {
                            position: 'relative',
                            height: isMobile ? 'inherit' : 400,
                            minHeight: isMobile ? 'inherit' : 400,
                        }, flexDirection: "column" },
                        React.createElement(AddAddressFormWithArea$1, { editInfo: editInfo, onAddressSuccess: onSuccess, countryConfig: countryConfig, updatedLocation: updatedLocation, addressInfo: addressInfo, town: town, userProfile: userProfile, isSetSelectedAddress: isSetSelectedAddress, block: block, building: building }))))),
            location
                ? isGoogleMapVisible && (React.createElement(GoogleMapBox, { "data-sl": "mask" },
                    React.createElement(MapContainer, { flexDirection: "column", height: isMobile ? '100%' : 'auto', open: !isMobile || !showMobileAddressForm },
                        React.createElement(Flex, { style: {
                                position: 'relative',
                                height: isMobile ? 'inherit' : 992,
                                minHeight: isMobile ? 'inherit' : 400,
                            }, flexDirection: "column" }, !!location && (React.createElement(React.Fragment, null,
                            React.createElement(SearchBox$1, null),
                            !isSelected && (React.createElement(MapOverlayWapper, null,
                                React.createElement(MapOverlay, null))),
                            showSearchRequiredError && (React.createElement(LocationSearchError, null, t('address.selectLocationRequired'))),
                            React.createElement(GoogleMapFlex, { isMobile: true, flexDirection: "column", "data-testid": "google-map-wrapper" },
                                React.createElement(GoogleMap, { isAreaNotSupported: isAreaNotSupported, editInfo: editInfo, isMobile: isMobile, location: location, style: { width: '100%' }, fetchMapCoordinates: fetchLocation, fetchLocation: function () { return __awaiter$1(void 0, void 0, void 0, function () { return __generator$1(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 , fetchLocation(false, false, false)];
                                            case 1: return [2 , _a.sent()];
                                        }
                                    }); }); }, flatNo: flatNo, building: building, landmark: landmark, isDefaultLocation: location.isDefaultLocation, checkCoverageArea: checkCoverageArea, countryConfig: countryConfig, setAddressInfo: setAddressInfo, setTown: setTown, setCountry: setCountry, setEmirate: setEmirate, isSelected: isSelected, setIsSelected: setIsSelected, addressInfo: addressInfo, appConfig: appConfig, setZoom: setZoom, hideFlatNo: isAreaNotSupported || (coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isChecking) }),
                                (isSelected || (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id)) && (React.createElement(MarkerBox, null,
                                    React.createElement(PonPin, { size: 'L', fill: "#F45C5D" }))),
                                (coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isChecking) && React.createElement(LinearProgress, { position: "bottom" })),
                            React.createElement(Flex, { flexDirection: "column" },
                                React.createElement(CurrentlySelected$1, { emirate: emirate, formattedGoogleAddressDescription: formattedGoogleAddressDescription, isVisible: isSelected || isAreaNotSupported || (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id), addressInfo: addressInfo, isAreaNotSupported: isAreaNotSupported }))))),
                        React.createElement(Flex, { flexDirection: "column", style: {
                                boxShadow: isCoordsChanged ? 'none' : '0px 4px 15px rgba(0, 0, 0, 0.15)',
                                width: '108%',
                                height: '80px',
                                marginLeft: '-15px',
                                marginTop: '2px',
                            } },
                            React.createElement(ButtonWrapper$1, null,
                                React.createElement(Back, { onClick: backToAddressList, variant: "link" }, t('back')),
                                React.createElement(DeliverTo, { width: "303px", onClick: onDeliverToLocation, variant: "custom", preventTextTransform: true, disabledNewUI: !isSelected || isAreaNotSupported }, t('address.deliverToLocation')))),
                        !isLoggedIn && React.createElement(LoginLink, { loginRedirection: loginRedirection }))))
                : isGoogleMapVisible && React.createElement(BackDrop, null))),
        React.createElement(Flex, { "data-testid": "non-location-cx-address" },
            !isMobile && (React.createElement(React.Fragment, null,
                React.createElement(AddAddressForm$1, { closeAddressFormDrawer: closeAddressFormDrawer, showAddressForm: showAddressForm, setShowAddressForm: setShowAddressForm, onSelectedLocationChange: onSelectedLocationChange,
                    editInfo: editInfo, setFlatNo: setFlatNo, setBuildingName: setBuildingName, setLandmark: setLandmark, onAddressSuccess: onSuccess, countryConfig: countryConfig, updatedLocation: updatedLocation, addressInfo: addressInfo, town: town, country: country, emirate: emirate, userProfile: userProfile, isSetSelectedAddress: isSetSelectedAddress, block: block, building: building, isStreeNameChange: isStreeNameChange, setIsStreetNameChange: setIsStreetNameChange, isCityAreaNameChange: isCityAreaNameChange, setIsCityAreaNameChange: setIsCityAreaNameChange, setShowSearchRequiredError: setShowSearchRequiredError, isCoordsChanged: isCoordsChanged }))),
            React.createElement(React.Fragment, null,
                React.createElement(FormContainer$1, { open: isMobile && showMobileAddressForm },
                    React.createElement(MobileAddressForm, { closeAddressFormDrawer: closeAddressFormDrawer, onSelectedLocationChange: onSelectedLocationChange, emirate: emirate, showMobileAddressForm: showMobileAddressForm, editInfo: editInfo, onBackToMap: onBackToMap, updatedLocation: updatedLocation, flatNo: flatNo, addressInfo: addressInfo, town: town, country: country, building: building, landmark: landmark, setFlatNo: setFlatNo, setBuildingName: setBuildingName, setLandmark: setLandmark, onSuccess: onSuccess, countryConfig: countryConfig, zoom: zoom, userProfile: userProfile, isSetSelectedAddress: isSetSelectedAddress, block: block, isStreeNameChange: isStreeNameChange, setIsStreetNameChange: setIsStreetNameChange, isCityAreaNameChange: isCityAreaNameChange, setIsCityAreaNameChange: setIsCityAreaNameChange }))))));
};
AddAddress$1.defaultProps = {
    width: '480px',
    isOpen: true,
    isAddFormVisible: true,
    isShowCloseButton: true,
    isGoogleMapVisible: false,
    isSetSelectedAddress: true,
};
var useGetUserAddress = function () {
    var userData = useSelector(function (state) { return state.userData; });
    var countryConfig = userData.countryConfig || {};
    var _a = userData.addresses, error = _a.error, isAddressLoading = _a.isLoading, list = _a.list;
    var selectedAddress = userData.selectedAddress;
    var dispatch = useDispatch();
    var setSelectedAddress = useCallback(function (address) {
        dispatch(userSetSelectedAddress(address));
    }, [dispatch]);
    useEffect(function () {
        if (countryConfig.phoneCountryCode) {
            dispatch(fetchUserAddresses());
        }
        else {
            fetchUserCountryConfig()(dispatch);
        }
    }, [dispatch, countryConfig.phoneCountryCode]);
    var isLoading = isAddressLoading || countryConfig.isLoading;
    return [error, isLoading, list, selectedAddress, setSelectedAddress, countryConfig.phoneCountryCode];
};
var AddressAppartment = function (_a) {
    var appartment = _a.appartment;
    return React.createElement(React.Fragment, null, getFloorFlat(appartment, FLOOR_KEY, FLAT_KEY));
};
var H3$1 = Text.H3;
var AddressCard = function (_a) {
    var data = _a.data, onAddressSelection = _a.onAddressSelection, selectedId = _a.selectedId, index = _a.index, phoneCountryCode = _a.phoneCountryCode, testId = _a.testId;
    var t = useTranslation().t;
    var isMobile = useBreakpoints().isMobile;
    var fullName = data.firstName + (data.lastName ? ' ' + data.lastName : '');
    var isSelected = data.id === selectedId;
    var isInternationalPhoneNumberEnabled = useFeature('international_number_support').on;
    return (React.createElement(AddressCardContainer, { "data-testid": testId, "data-sl": "mask", selected: isSelected, onClick: onAddressSelection(data), minWidth: ['80%', '80%', '100%'], width: '100%', ml: isMobile ? index && 3 : 0 },
        React.createElement(Flex, null,
            React.createElement(AddressLabel$2, null,
                data.addressLabel || t('address.noLabel'),
                " ", "" + (data.defaultAddress ? "(" + t('address.default') + ")" : '')),
            React.createElement(Flex, { justifyContent: "flex-end", alignItems: "center", flex: 1 },
                React.createElement(TickBox, { selected: isSelected }, isSelected && React.createElement(Check, { size: "CUSTOM", fill: "#0059AD", height: 10, width: 12 })))),
        React.createElement(Box, { mt: 2, lineHeight: 1.2 },
            React.createElement(Box, null, fullName),
            React.createElement(Box, null,
                isInternationalPhoneNumberEnabled ? '' : phoneCountryCode,
                " ",
                data.phone),
            React.createElement(Box, null,
                data.appartment ? React.createElement(AddressAppartment, { appartment: data.appartment }) : '',
                ' ',
                data.building ? data.building + "," : '',
                " ",
                decodeStr(data.streetName) || ''),
            React.createElement(Box, null,
                data.landmark ? data.landmark + "," : '',
                " ", "" + (decodeStr(data.town) || '')))));
};
AddressCard.defaultProps = {
    testId: 'address-list-card',
};
var DrawerHeader$2 = function (_a) {
    var onHeaderActionPress = _a.onHeaderActionPress, testId = _a.testId;
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, null, t('address.selectAddress')),
        React.createElement(HeaderAction, { as: "a", onClick: onHeaderActionPress, "data-testid": testId, id: "add _address_popup" }, t('address.addNewAddress'))));
};
DrawerHeader$2.defaultProps = {
    testId: 'add-new-address-action',
};
var AddressList$3 = function (props) {
    var isOpen = props.isOpen, onClose = props.onClose, _a = props.width, width = _a === void 0 ? 480 : _a, onHeaderActionPress = props.onHeaderActionPress, onSelection = props.onSelection, onDataChange = props.onDataChange, headerActionTestId = props.headerActionTestId, cardTestId = props.cardTestId;
    var _b = __read$1(useGetUserAddress(), 6), error = _b[0], isLoading = _b[1], list = _b[2], selectedAddress = _b[3], setSelectedAddress = _b[4], phoneCountryCode = _b[5];
    var _c = __read$1(useState([]), 2), addressList = _c[0], setAddressList = _c[1];
    var t = useTranslation().t;
    var selectedId = selectedAddress ? selectedAddress.id : '';
    useEffect(function () {
        if (list && isNonEmptyArray(list) && list.length !== addressList.length) {
            setAddressList(rearrangeAddressList(list, selectedAddress));
        }
    }, [addressList, list, onDataChange, selectedAddress]);
    onDataChange && onDataChange(addressList);
    var dispatch = useDispatch();
    var onAddressSelection = useCallback(function (selectedAddress) { return function () {
        if (!isNaN(Number(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.latitude)) && !isNaN(Number(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.longitude))) {
            setSelectedAddress(selectedAddress);
            setSelectedAddressID(selectedAddress.id);
            setSelectedAddressIDCookie(selectedAddress.id);
            setAddressList(rearrangeAddressList(list, selectedAddress));
            dispatch(init({
                changingLocation: true,
            }));
        }
        onSelection && onSelection(selectedAddress);
    }; }, [list, onSelection, setSelectedAddress, dispatch]);
    return (React.createElement(Drawer, { isOpen: isOpen, onClose: onClose, width: [null, null, width], anchor: ['bottom', null, 'right'], title: React.createElement(DrawerHeader$2, { onHeaderActionPress: onHeaderActionPress, testId: headerActionTestId }), showLoader: Boolean(isLoading) },
        error && React.createElement(Notification, { my: 2 }, error),
        React.createElement(Box, null,
            React.createElement(H3$1, null,
                t('address.existingAddress'),
                " (",
                addressList.length,
                ")")),
        React.createElement(Flex, { flexDirection: ['row', 'row', 'column'], overflow: "auto" }, addressList.map(function (data, index) { return (React.createElement(AddressCard, { data: data, index: index, key: index + "__address_card", onAddressSelection: onAddressSelection, selectedId: selectedId, t: t, phoneCountryCode: phoneCountryCode, testId: cardTestId })); }))));
};
AddressList$3.defaultProps = {
    width: '480px',
    isOpen: true,
};
var SelectAddressLocation$1 = function (props) {
    var t = useTranslation().t;
    var closeDrawer = props.closeDrawer, _a = props.width, width = _a === void 0 ? 500 : _a, testId = props.testId;
    var isMobile = useBreakpoints().isMobile;
    var _b = __read$1(useGetLocation(), 4), location = _b[0], fetchLocation = _b[1], _c = _b[2], countryConfig = _c === void 0 ? {} : _c, appConfig = _b[3];
    var _d = __read$1(useState(false), 2), isSelected = _d[0], setIsSelected = _d[1];
    var _e = __read$1(useState(''), 2), emirate = _e[0], setEmirate = _e[1];
    var _f = __read$1(useCheckAreaIfSupported(), 4), checkCoverageArea = _f[0], coverageArea = _f[1], showLoader = _f[3];
    var _g = __read$1(useState(''), 2), addressInfo = _g[0], setAddressInfo = _g[1];
    var _h = __read$1(useState({
        latitude: location === null || location === void 0 ? void 0 : location.lat,
        longitude: location === null || location === void 0 ? void 0 : location.lng,
    }), 2), latLng = _h[0], setLatLng = _h[1];
    var _j = __read$1(useState(false), 2), isCoordsChanged = _j[0], setIsCoordsChanged = _j[1];
    var pageStructure = useSelector(function (state) { return state.pageStructure; });
    var state = useSelector(function (state) { return state; });
    var isAreaNotSupported = location && !(coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isChecking) && !(coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isSupported);
    var extraProps = {};
    var isLoading = countryConfig.isLoading;
    if (isMobile) {
        extraProps.style = { height: '100%', borderRadius: '24px 24px 0px 0px' };
    }
    useEffect(function () {
        if (!location) {
            fetchLocation(false, false);
        }
    }, [fetchLocation, location]);
    var dispatch = useDispatch();
    var GTMEventCall = useAnalytic().GTMEventCall;
    var confirmLocation = function () { return __awaiter$1(void 0, void 0, void 0, function () {
        var isPolygonChange, store;
        var _a;
        return __generator$1(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch(updateGeoArea(addressInfo, latLng === null || latLng === void 0 ? void 0 : latLng.latitude, latLng === null || latLng === void 0 ? void 0 : latLng.longitude));
                    dispatch(init({
                        changingLocation: true,
                    }));
                    GTMEventCall(GTMEvents.custom_event, {
                        eventAction: GTMEventActions.change_address_done,
                        eventLabel: addressInfo,
                        ga4: true,
                    });
                    closeDrawer && closeDrawer();
                    isPolygonChange = (_a = getGrowthBookFeatureValueViaInstance(state, 'is_polygon_cached')) === null || _a === void 0 ? void 0 : _a.on;
                    if (!isPolygonChange) return [3 , 2];
                    store = { appConfig: appConfig, pageStructure: pageStructure };
                    return [4 , getDeliveryTime()(dispatch, store, undefined, isPolygonChange)];
                case 1:
                    _b.sent();
                    window.location.reload();
                    _b.label = 2;
                case 2: return [2 ];
            }
        });
    }); };
    useEffect(function () {
        if ((location === null || location === void 0 ? void 0 : location.lat) !== latLng.latitude && (location === null || location === void 0 ? void 0 : location.lng) !== latLng.longitude && !isCoordsChanged) {
            setIsCoordsChanged(true);
        }
    }, [latLng]);
    return (React.createElement(Drawer, __assign$1({ variant: "float", isOpen: true, width: [null, null, width], anchor: ['bottom', null, 'right'], contentStyles: { p: [0], height: '100%', display: 'flex', flexDirection: 'column' }, "data-testid": testId, showLoader: isLoading || showLoader }, extraProps),
        React.createElement(DrawerHeader$1, { "data-testid": "drawer-header" },
            React.createElement(Flex, { alignItems: "center", justifyContent: "space-between" },
                React.createElement(HeaderTitle, { flex: 1 }, isMobile ? i18next.t('address.chooseLocation') : i18next.t('address.addDeliveryLocation')),
                React.createElement(DrawerIconContainer, { onClick: closeDrawer, variant: "naked" },
                    React.createElement(DrawerCloseIcon, null)))),
        location && (React.createElement(Box, { style: { position: 'relative', flex: 1 }, "data-sl": "mask" },
            React.createElement(MapContainer, { flexDirection: "column", height: isMobile ? '100%' : 'auto', open: true },
                React.createElement(Flex, { style: {
                        position: 'relative',
                        height: isMobile ? 'inherit' : 992,
                        minHeight: isMobile ? 'inherit' : 400,
                    }, flexDirection: "column" }, !!location && (React.createElement(React.Fragment, null,
                    React.createElement(SearchBox$1, null),
                    !isSelected && (React.createElement(MapOverlayWapper, null,
                        React.createElement(MapOverlay, null))),
                    React.createElement(Flex, { style: { position: 'relative', height: '100%' }, flexDirection: "column", "data-testid": "google-map-section" },
                        React.createElement(GoogleMap, { isAreaNotSupported: isAreaNotSupported, isMobile: isMobile, location: location, style: { width: '100%' }, fetchLocation: function () { return __awaiter$1(void 0, void 0, void 0, function () { return __generator$1(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 , fetchLocation(false, false, false)];
                                    case 1: return [2 , _a.sent()];
                                }
                            }); }); }, fetchMapCoordinates: fetchLocation, isDefaultLocation: location.isDefaultLocation, checkCoverageArea: checkCoverageArea, countryConfig: countryConfig, setAddressInfo: setAddressInfo, setLatLng: setLatLng, setEmirate: setEmirate, isSelected: isSelected, setIsSelected: setIsSelected, addressInfo: isCoordsChanged ? addressInfo : '', appConfig: appConfig, hideFlatNo: isAreaNotSupported || (coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isChecking) }),
                        isSelected && (React.createElement(MarkerBox, null,
                            React.createElement(PonPin, { size: 'L', fill: "#F45C5D" }))),
                        (coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isChecking) && React.createElement(LinearProgress, { position: "bottom" })),
                    React.createElement(Flex, { flexDirection: "column", mb: isMobile ? '-30px' : '0px' },
                        React.createElement(CurrentlySelected$1, { emirate: emirate, formattedGoogleAddressDescription: formattedGoogleAddressDescription, isVisible: isAreaNotSupported || isSelected, addressInfo: addressInfo, isAreaNotSupported: isAreaNotSupported }))))),
                React.createElement(Flex, { flexDirection: "column", style: {
                        boxShadow: isCoordsChanged ? 'none' : '0px 4px 15px rgba(0, 0, 0, 0.15)',
                        width: '484px',
                        height: '80px',
                        marginLeft: '-15px',
                        marginTop: '34px',
                    } },
                    React.createElement(ButtonWrapper$1, null,
                        React.createElement(Back, { onClick: closeDrawer, variant: "link" }, t('address.back')),
                        React.createElement(DeliverTo, { width: "303px", onClick: confirmLocation, variant: "custom", preventTextTransform: true, disabledNewUI: !isSelected || !location || isAreaNotSupported }, t('address.deliverToLocation')))))))));
};
SelectAddressLocation$1.defaultProps = {
    width: '480px',
    testId: 'search-location-test-id',
};
var index$4 = Object.freeze({
    __proto__: null,
    AddAddress: AddAddress$1,
    AddressList: AddressList$3,
    SelectAddressLocation: SelectAddressLocation$1,
    AddAddressForm: AddAddressForm$1
});
var RadioButtonCta = function (props) {
    var clickAction = props.clickAction, text = props.text, _a = props.variantType, variantType = _a === void 0 ? 'primary' : _a;
    return (React.createElement(Button$1, { variant: variantType, onClick: clickAction, height: "48px", width: "100%", "data-testid": "radio-cancel-button", preventTextTransform: true },
        React.createElement(Box, { sx: {
                whiteSpace: 'nowrap',
            }, fontSize: [2, 3], fontWeight: [5, 6] }, text)));
};
var RadioButtonList = function (props) {
    var listItem = props.listItem, btnTxt = props.btnTxt, _a = props.isCancel, isCancel = _a === void 0 ? false : _a, _b = props.cancelTxt, cancelTxt = _b === void 0 ? '' : _b, close = props.close;
    var _c = __read$1(listItem.filter(function (item) { return item.isSelected; }), 1), selectedItem = _c[0];
    var _d = selectedItem.heading, heading = _d === void 0 ? '' : _d, action = selectedItem.action, _e = selectedItem.label, label = _e === void 0 ? '' : _e, _f = selectedItem.subHeading, subHeading = _f === void 0 ? '' : _f;
    var _g = __read$1(useState({
        heading: heading,
        action: action,
        label: label,
        subHeading: subHeading,
    }), 2), selectedBtnAction = _g[0], updateBtnAction = _g[1];
    var btnAction = function (actionDetails) { return function () {
        var _a = actionDetails.heading, heading = _a === void 0 ? '' : _a, action = actionDetails.action, _b = actionDetails.label, label = _b === void 0 ? '' : _b, _c = actionDetails.subHeading, subHeading = _c === void 0 ? '' : _c;
        updateBtnAction({
            heading: heading,
            action: action,
            label: label,
            subHeading: subHeading,
        });
    }; };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, null, listItem.map(function (btnDetails) {
            var isRadioSelected = selectedBtnAction.label === btnDetails.label;
            return (React.createElement(Button$1, { variant: "link", minHeight: "32px", "data-testid": "radio-label-" + btnDetails.label, key: btnDetails.heading, onClick: btnAction(btnDetails), mb: 3 },
                React.createElement(Box, { display: "flex", color: COLORS.GRAY_800, minHeight: "32px", mb: 3 },
                    React.createElement(Box, { as: "span", sx: {
                            height: '16px',
                            minWidth: '16px',
                            borderRadius: '50%',
                            border: "2px solid " + (isRadioSelected ? COLORS.BLUE : COLORS.GRAY_500),
                            mr: 2,
                        } }, isRadioSelected && (React.createElement(Box, { bg: COLORS.BLUE, sx: {
                            margin: '1px',
                            height: '10px',
                            width: '10px',
                            borderRadius: '50%',
                        } }))),
                    React.createElement(Box, { as: "span" },
                        React.createElement(Box, { as: "span", fontSize: 2, display: "block", fontWeight: 6, mb: 2, color: isRadioSelected ? COLORS.BLUE : COLORS.BLACK }, btnDetails.heading),
                        (btnDetails === null || btnDetails === void 0 ? void 0 : btnDetails.subHeading) && (React.createElement(Box, { as: "span", fontSize: 2, display: "block", width: ['auto', '300px', '330px'], lineHeight: "20px" }, btnDetails === null || btnDetails === void 0 ? void 0 : btnDetails.subHeading))))));
        })),
        React.createElement(Flex, null,
            !!(isCancel && cancelTxt && close) && (React.createElement(Box, { mr: 2, width: "100%" },
                ' ',
                React.createElement(RadioButtonCta, { text: cancelTxt, clickAction: close, variantType: "outlined" }))),
            React.createElement(RadioButtonCta, { text: btnTxt, clickAction: selectedBtnAction.action, variantType: "secondary" }))));
};
var RadioButtonList$1 = memo(RadioButtonList);
var Title$4 = function () {
    var t = useTranslation().t;
    return (React.createElement(Box, { as: "span", fontWeight: [5, 6], fontSize: [3, 4], sx: {
            fontFamily: 'Montserrat',
        } }, t('plasticBagConsentDrawer.title')));
};
var UserConsent = function (props) {
    var _a = props.isOpen, isOpen = _a === void 0 ? true : _a, _b = props.isFormVisible, isFormVisible = _b === void 0 ? false : _b, callBack = props.callBack, close = props.close, _c = props.isUpdateConsent, isUpdateConsent = _c === void 0 ? false : _c;
    var t = useTranslation().t;
    var selectedDelivery = getPackageFreeDelivery() || 'true';
    var listItem = [
        {
            heading: t('plasticBagConsentDrawer.packageFreeHead'),
            action: function () {
                if (callBack) {
                    callBack(true);
                    setPackageFreeDelivery(true);
                    close && close();
                }
            },
            isSelected: selectedDelivery === 'true',
            label: 'package_free',
            subHeading: t('plasticBagConsentDrawer.packageFreeSub'),
        },
        {
            heading: t('plasticBagConsentDrawer.acceptBagHead'),
            action: function () {
                if (callBack) {
                    callBack(false);
                    setPackageFreeDelivery(false);
                    close && close();
                }
            },
            isSelected: selectedDelivery === 'false',
            label: 'with_bag',
            subHeading: t('plasticBagConsentDrawer.acceptBagSub'),
        },
    ];
    return (React.createElement(Drawer, { onClose: close, isOpen: isOpen, width: [null, null, '500px'], anchor: ['bottom', null, 'right'], contentStyles: { p: [0], height: '100%', display: 'flex', flexDirection: 'column', fontFamily: 'Montserrat' }, variant: "float", title: React.createElement(Title$4, null) },
        React.createElement(Box, { p: 3 }, isFormVisible ? (React.createElement(RadioButtonList$1, { listItem: listItem, btnTxt: isUpdateConsent ? t('plasticBagConsentDrawer.update') : t('plasticBagConsentDrawer.saveText'), isCancel: isUpdateConsent, close: close, cancelTxt: t('plasticBagConsentDrawer.cancel') })) : (React.createElement(Button$1, { variant: "primary", onClick: close, fontSize: 3, fontWeight: 6, height: "48px", width: "100%", preventTextTransform: true },
            React.createElement(Box, { sx: {
                    whiteSpace: 'nowrap',
                } }, t('plasticBagConsentDrawer.btnText')))))));
};
var NoLink = customStyled(Button$1)(templateObject_1$X || (templateObject_1$X = __makeTemplateObject$1(["\n  text-decoration: none;\n  letter-spacing: 0.5px;\n  display: flex;\n  padding: 10px;\n  border-top: 1px solid ", ";\n  align-items: center;\n  color: ", ";\n  @media (min-width: ", ") {\n    padding: 20px 24px;\n  }\n  cursor: pointer;\n  text-transform: uppercase;\n  @media (min-width: ", ") {\n    text-transform: none;\n  }\n"], ["\n  text-decoration: none;\n  letter-spacing: 0.5px;\n  display: flex;\n  padding: 10px;\n  border-top: 1px solid ", ";\n  align-items: center;\n  color: ", ";\n  @media (min-width: ", ") {\n    padding: 20px 24px;\n  }\n  cursor: pointer;\n  text-transform: uppercase;\n  @media (min-width: ", ") {\n    text-transform: none;\n  }\n"])), COLORS.MERCURY, COLORS.THUNDORA, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.breakpoints[2]; });
var templateObject_1$X;
var EPlasticBagActions;
(function (EPlasticBagActions) {
    EPlasticBagActions["FETCH_USER_CONSENT"] = "UserData/FETCH_USER_CONSENT";
    EPlasticBagActions["SET_USER_CONSENT"] = "UserData/SET_USER_CONSENT";
})(EPlasticBagActions || (EPlasticBagActions = {}));
var ComponentTypes;
(function (ComponentTypes) {
    ComponentTypes["V1"] = "V1";
    ComponentTypes["V2"] = "V2";
})(ComponentTypes || (ComponentTypes = {}));
var QuickNavigationWrapper = customStyled.div(templateObject_1$Y || (templateObject_1$Y = __makeTemplateObject$1(["\n    display: flex;\n    width: 100%;\n    > div {\n      direction: inherit !important;\n    }\n  "], ["\n    display: flex;\n    width: 100%;\n    > div {\n      direction: inherit !important;\n    }\n  "])));
var CustomizedCardWrapper = customStyled.a(templateObject_2$N || (templateObject_2$N = __makeTemplateObject$1(["\n  flex: 1;\n  text-align: left;\n  font-family: 'Montserrat';\n  color: ", ";\n  text-decoration: none;\n  width: ", ";\n\n  &:first-of-type{\n    margin-left: 0px;\n  }\n\n  &:last-of-type{\n    margin-right: 0px;\n  }\n"], ["\n  flex: 1;\n  text-align: left;\n  font-family: 'Montserrat';\n  color: ", ";\n  text-decoration: none;\n  width: ", ";\n\n  &:first-of-type{\n    margin-left: 0px;\n  }\n\n  &:last-of-type{\n    margin-right: 0px;\n  }\n"])), COLORS.BLACK, function (_a) {
    var width = _a.width;
    return width;
});
var CustomizedCardContent = customStyled(Box)(templateObject_3$E || (templateObject_3$E = __makeTemplateObject$1(["\n  background-color: ", ";\n  width: 100%;\n  height: fit-content;\n  align-items: center;\n  justify-content: ", ";\n  border-radius: 8px;\n  padding: 9px 8px 8px;\n  min-height: 68px;\n  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);\n  display: flex;\n  align-items: center;\n\n  @media (max-width: ", ") {\n    min-height: 88px;\n    border-radius: 12px;\n    ", "\n  }\n"], ["\n  background-color: ", ";\n  width: 100%;\n  height: fit-content;\n  align-items: center;\n  justify-content: ", ";\n  border-radius: 8px;\n  padding: 9px 8px 8px;\n  min-height: 68px;\n  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);\n  display: flex;\n  align-items: center;\n\n  @media (max-width: ", ") {\n    min-height: 88px;\n    border-radius: 12px;\n    ",
    "\n  }\n"])), function (_a) {
    var bgColor = _a.bgColor;
    return bgColor || COLORS.WHITE;
}, function (_a) {
    var isV2TypeComponent = _a.isV2TypeComponent;
    return (isV2TypeComponent ? 'space-between' : 'center');
}, function (props) { return props.theme.breakpoints[1]; }, function (props) {
    return props.isV2TypeComponent &&
        "\n        min-height: 48px;\n        border-radius: 8px;\n        min-width: 130px;\n        width: max-content;\n        padding: 8px 12px;\n      ";
});
var ImageSection = customStyled(Box)(templateObject_4$y || (templateObject_4$y = __makeTemplateObject$1(["\n  justify-content: space-between;\n  display: flex;\n  gap: ", ";\n  margin-bottom: ", ";\n\n  & img{\n    align-self: center;\n  }\n"], ["\n  justify-content: space-between;\n  display: flex;\n  gap: ", ";\n  margin-bottom: ", ";\n\n  & img{\n    align-self: center;\n  }\n"])), function (props) { return (props.isV2TypeComponent ? '8px' : ''); }, function (props) { return (props.isV2TypeComponent ? '' : '15px'); });
var Gap = customStyled(Box)(templateObject_5$q || (templateObject_5$q = __makeTemplateObject$1(["\n  min-width: ", "\n"], ["\n  min-width: ", "\n"])), function (props) { return (props.isV2TypeComponent ? '8px' : '20px'); });
var ImageWrapper$2 = customStyled(Box)(templateObject_6$k || (templateObject_6$k = __makeTemplateObject$1(["\n  height: 24px;\n  width: auto;\n\n  @media (max-width: ", ") {\n    height: ", ";\n    width: ", ";\n    margin-top: ", "\n  }\n"], ["\n  height: 24px;\n  width: auto;\n\n  @media (max-width: ", ") {\n    height: ", ";\n    width: ", ";\n    margin-top: ", "\n  }\n"])), function (props) { return props.theme.breakpoints[1]; }, function (props) { return (props.isV2TypeComponent ? '24px' : '20px'); }, function (props) { return (props.isV2TypeComponent ? '24px' : 'auto'); }, function (props) { return (props.isV2TypeComponent ? '4px' : ''); });
var templateObject_1$Y, templateObject_2$N, templateObject_3$E, templateObject_4$y, templateObject_5$q, templateObject_6$k;
var BundleContainer = customStyled(Flex)(function () { return ({
    flexFlow: 'column',
    flexShrink: 0,
}); });
var BundleHeader = customStyled(Box)(function (_a) {
    var theme = _a.theme, isDisabled = _a.isDisabled;
    return (__assign$1({ backgroundColor: COLORS.ERROR_RED_500, fontSize: theme.fontSizes[0], fontWeight: theme.fontWeights[6], color: theme.colors.white, padding: '4px 10px', width: '74px', borderRadius: '12px 2px', display: 'inline-flex', columnGap: '0.25rem' }, (isDisabled ? { opacity: 0.5 } : {})));
});
var CardContainer = customStyled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        borderRadius: '12px',
        borderTopLeftRadius: '0',
        backgroundColor: theme.colors.error,
        display: 'inline-flex',
        justifyContent: 'space-around',
        padding: '0.25rem 1rem',
        columnGap: '0.25rem',
    });
});
var DetailsContainer = customStyled(Flex)(function (_a) {
    var theme = _a.theme, isDisabled = _a.isDisabled;
    return ({
        border: "1px solid " + (isDisabled ? theme.colors.error : COLORS.ERROR_RED_50),
        borderRadius: theme.space[2],
        borderTopLeftRadius: 0,
        padding: '16px',
        paddingBottom: 0,
        flexDirection: 'column',
        columnGap: '0.5rem',
        display: 'inline-flex',
    });
});
var MarqueeContent = customStyled.div(templateObject_1$Z || (templateObject_1$Z = __makeTemplateObject$1(["\n  white-space: nowrap;\n  overflow: hidden;\n  display: block;\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  display: block;\n"])));
var AnimatedText = customStyled.div(templateObject_2$O || (templateObject_2$O = __makeTemplateObject$1(["\n  display: inline-block;\n  padding-left: 100%;\n  animation: marquee 10s linear infinite;\n\n  @keyframes marquee {\n    from {\n      transform: translateX(0);\n    }\n    to {\n      transform: translateX(-100%);\n    }\n  }\n"], ["\n  display: inline-block;\n  padding-left: 100%;\n  animation: marquee 10s linear infinite;\n\n  @keyframes marquee {\n    from {\n      transform: translateX(0);\n    }\n    to {\n      transform: translateX(-100%);\n    }\n  }\n"])));
var MarqueeTextWrapper = customStyled(Box)(function (_a) {
    var theme = _a.theme, isNotLongText = _a.isNotLongText;
    return (__assign$1({ backgroundColor: COLORS.ERROR_RED_500, fontSize: theme.fontSizes[0], fontWeight: theme.fontWeights[6], color: theme.colors.white, padding: '4px 10px', maxWidth: '136px', borderRadius: '12px 2px' }, (isNotLongText && { display: 'inline-block' })));
});
var SavedText = customStyled(Flex)(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: COLORS.ERROR_RED_25,
        fontSize: theme.fontSizes[1],
        fontWeight: theme.fontWeights[6],
        color: COLORS.ERROR_RED_500,
        padding: theme.space[2],
        maxWidth: '311px',
        borderRadius: '12px 2px',
        margin: '0 auto',
        justifyContent: 'center',
        alignItems: 'center',
    });
});
var BundleText = customStyled(Flex)(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: COLORS.ERROR_RED_25,
        fontSize: theme.fontSizes[1],
        fontWeight: theme.fontWeights[6],
        color: COLORS.ERROR_RED_500,
        padding: theme.space[2],
        maxWidth: '136px',
        borderRadius: '12px 2px',
        justifyContent: 'center',
        alignItems: 'center',
    });
});
var templateObject_1$Z, templateObject_2$O;
var InfoIcon = function (_a) {
    var _b = _a.isMobile, isMobile = _b === void 0 ? false : _b, _c = _a.display, display = _c === void 0 ? 'initial' : _c;
    return (React.createElement(Flex, { justifyContent: "center", alignItems: "center", minWidth: "24px", ml: [null, null, null, 1], display: display },
        React.createElement(InformationDark, { testid: "information-icon", size: "XS", fill: isMobile ? COLORS.SILVER : COLORS.ANCHOR_BLUE })));
};
var Container$9 = CustomStyled(Flex)(templateObject_1$_ || (templateObject_1$_ = __makeTemplateObject$1(["\n    background-color: ", ";\n    font-family: ", ";\n    border-radius: 12px;\n    padding: 4px;\n\n    @media (max-width: ", ") {\n      margin: 0 16px 20px;\n      justify-content: center;\n  }\n"], ["\n    background-color: ", ";\n    font-family: ", ";\n    border-radius: 12px;\n    padding: 4px;\n\n    @media (max-width: ", ") {\n      margin: 0 16px 20px;\n      justify-content: center;\n  }\n"])), COLORS.LIGHT_OPAC_BLUE, function (props) { return props.theme.fonts.montserrat; }, function (props) { return props.theme.breakpoints[3]; });
var TabWrapper$1 = CustomStyled(Flex)(templateObject_2$P || (templateObject_2$P = __makeTemplateObject$1(["\n    font-family: ", ";\n    padding: 8px 12px 8px 16px;\n    cursor:  ", ";\n    border-radius: 8px;\n    align-items: center;\n    width: ", ";\n    justify-content: space-between;\n    \n    &:first-of-type {\n      margin-right: 20px;\n    }\n    \n    background: ", ";\n\n    @media (min-width: ", "px) {\n        padding: ", ";\n        height: 80px;\n        \n        filter: ", "; \n        backdrop-filter: ", ";\n        justify-content: space-between;\n    }\n    \n    @media (max-width: ", ") {\n      &:first-of-type {\n        margin-right: 0px;\n      }\n      justify-content: center;\n    }\n\n"], ["\n    font-family: ", ";\n    padding: 8px 12px 8px 16px;\n    cursor:  ", ";\n    border-radius: 8px;\n    align-items: center;\n    width: ", ";\n    justify-content: space-between;\n    \n    &:first-of-type {\n      margin-right: 20px;\n    }\n    \n    background: ",
    ";\n\n    @media (min-width: ", "px) {\n        padding: ", ";\n        height: 80px;\n        \n        filter: ",
    "; \n        backdrop-filter: ",
    ";\n        justify-content: space-between;\n    }\n    \n    @media (max-width: ", ") {\n      &:first-of-type {\n        margin-right: 0px;\n      }\n      justify-content: center;\n    }\n\n"])), function (props) { return props.theme.fonts.montserrat; }, function (props) { return (props.isFullWidth ? 'auto' : 'pointer'); }, function (props) { return (props.isFullWidth ? '100%' : '50%'); }, function (props) {
    if (props.isActive) {
        return COLORS.WHITE;
    }
    return 'transparent';
}, MQ[2], function (props) { return (props.isFullWidth ? '0' : ' 16px 32px '); }, function (props) {
    return props.isActive ? 'drop-shadow(0px 4px 48px rgba(0, 0, 0, 0.08))' : '';
}, function (props) {
    return props.isActive ? 'blur(24px)' : 'blur(0)';
}, function (props) { return props.theme.breakpoints[1]; });
var Title$5 = CustomStyled(Box)(templateObject_3$F || (templateObject_3$F = __makeTemplateObject$1(["\n    white-space: nowrap;\n    font-family: ", ";\n    font-style: normal;\n    font-size: ", ";\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    font-weight: ", ";\n    color:", ";\n\n    @media (min-width: ", "px) {\n        font-weight: ", ";\n        color:", "; \n    }\n"], ["\n    white-space: nowrap;\n    font-family: ", ";\n    font-style: normal;\n    font-size: ", ";\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    font-weight: ", ";\n    color:", ";\n\n    @media (min-width: ", "px) {\n        font-weight: ", ";\n        color:", "; \n    }\n"])), function (props) { return props.theme.fonts.montserrat; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.fontWeights[6]; }, COLORS.ANCHOR_BLUE, MQ[2], function (props) { return props.theme.fontWeights[6]; }, function (props) { return (props.isActive ? COLORS.DARK_BLUE : COLORS.BLACK); });
var IconWrapper$6 = CustomStyled(Box)(templateObject_4$z || (templateObject_4$z = __makeTemplateObject$1(["\n    width: 48px;\n    height: 48px;  \n    border-radius: 50%;\n    align-items: center;\n    transform: ", ";\n    justify-content: ", ";\n\n    @media (max-width: ", ") {\n      width: 32px;\n      height: 32px;\n      background: unset;\n  }\n"], ["\n    width: 48px;\n    height: 48px;  \n    border-radius: 50%;\n    align-items: center;\n    transform: ", ";\n    justify-content: ", ";\n\n    @media (max-width: ", ") {\n      width: 32px;\n      height: 32px;\n      background: unset;\n  }\n"])), function (props) { return (props.isRTL ? 'rotateY(180deg);' : 'unset;'); }, function (props) { return (props.isRTL ? 'flex-end' : ''); }, function (props) { return props.theme.breakpoints[1]; });
var InformationWrapper = CustomStyled(Box)(templateObject_5$r || (templateObject_5$r = __makeTemplateObject$1(["\n    white-space: nowrap;\n    width: 110px;\n    font-family: ", ";\n    color: ", ";\n    text-align: center;\n    .title {\n        font-weight: ", ";\n        font-size: ", "px;\n        line-height: 16px;\n        margin-right: ", ";\n        text-overflow: ellipsis;\n        overflow: hidden;\n        margin-bottom: 1px;\n    }\n    .sub-title {\n        font-weight: ", ";\n        font-size: ", "px;\n        line-height: 16px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n    }\n\n    @media (min-width: ", "px) {\n      text-align: start;\n    }\n\n    @media (max-width: ", ") {\n      flex-grow: 1;\n      color: ", ";\n    }\n"], ["\n    white-space: nowrap;\n    width: 110px;\n    font-family: ", ";\n    color: ", ";\n    text-align: center;\n    .title {\n        font-weight: ", ";\n        font-size: ", "px;\n        line-height: 16px;\n        margin-right: ", ";\n        text-overflow: ellipsis;\n        overflow: hidden;\n        margin-bottom: 1px;\n    }\n    .sub-title {\n        font-weight: ", ";\n        font-size: ", "px;\n        line-height: 16px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n    }\n\n    @media (min-width: ", "px) {\n      text-align: start;\n    }\n\n    @media (max-width: ", ") {\n      flex-grow: 1;\n      color: ", ";\n    }\n"])), function (props) { return props.theme.fonts.montserrat; }, COLORS.ANCHOR_BLUE, function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return (props.isInlineBlock ? '12px' : 0); }, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.fontSizes[1]; }, MQ[2], function (props) { return props.theme.breakpoints[1]; }, COLORS.BLACK);
var ValuePropositionWrapper = CustomStyled(Flex)(templateObject_6$l || (templateObject_6$l = __makeTemplateObject$1(["\n    cursor: pointer;\n    justify-content: end;\n    position: relative;\n    \n    @media (max-width: ", ") {\n      justify-content: ", ";\n      margin: 16px 16px 0px;\n    }\n"], ["\n    cursor: pointer;\n    justify-content: end;\n    position: relative;\n    \n    @media (max-width: ", ") {\n      justify-content: ", ";\n      margin: 16px 16px 0px;\n    }\n"])), function (props) { return props.theme.breakpoints[1]; }, function (props) { return (props.totalLength === 1 ? 'center' : 'start'); });
var TabCoachMarkDescWrapper = CustomStyled(Flex)(templateObject_7$j || (templateObject_7$j = __makeTemplateObject$1(["\n    flex-direction: column;\n    min-height: 190px;\n    svg.up-left-arrow{\n      position: relative;\n      left: 50px;\n      transform: ", "\n      width: fit-content;\n    }\n\n    svg.up-right-arrow{\n      position: relative;\n      left: 50%;\n      transform: ", "\n      width: fit-content;\n    }\n"], ["\n    flex-direction: column;\n    min-height: 190px;\n    svg.up-left-arrow{\n      position: relative;\n      left: 50px;\n      transform: ", "\n      width: fit-content;\n    }\n\n    svg.up-right-arrow{\n      position: relative;\n      left: 50%;\n      transform: ", "\n      width: fit-content;\n    }\n"])), function (props) { return (props.isRTL ? 'rotateY(180deg);' : 'unset;'); }, function (props) { return (props.isRTL ? 'rotateY(180deg);' : 'unset;'); });
var ValuePropDivider = CustomStyled(Box)(templateObject_8$j || (templateObject_8$j = __makeTemplateObject$1(["\n    width: 1px;\n    height: inherit;\n    background-color: ", ";\n\n    @media (min-width: ", ") {\n      display: none;\n    }\n"], ["\n    width: 1px;\n    height: inherit;\n    background-color: ", ";\n\n    @media (min-width: ", ") {\n      display: none;\n    }\n"])), COLORS.GRAY_100, function (props) { return props.theme.breakpoints[3]; });
var templateObject_1$_, templateObject_2$P, templateObject_3$F, templateObject_4$z, templateObject_5$r, templateObject_6$l, templateObject_7$j, templateObject_8$j;
var InformationTemplate = function (props) {
    var id = props.id, _a = props.subTitle, subTitle = _a === void 0 ? '' : _a, _b = props.title, title = _b === void 0 ? '' : _b, _c = props.isInlineBlock, isInlineBlock = _c === void 0 ? false : _c, totalLength = props.totalLength, index = props.index;
    if (title === '' || subTitle === '') {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Fragment, { key: id + "_" + index },
        React.createElement(InformationWrapper, { key: id, isInlineBlock: isInlineBlock },
            React.createElement(Box, { className: "title", display: isInlineBlock ? 'inline-block' : 'block' }, title),
            React.createElement(Box, { className: "sub-title", display: isInlineBlock ? 'inline-block' : 'block' }, subTitle)),
        totalLength === 2 && index === 0 && React.createElement(ValuePropDivider, null)));
};
var ValueProposition = function (props) {
    var isMobile = useBreakpoints().isMobile;
    var componentsArray = props.componentsArray, onClick = props.onClick, display = props.display, className = props.className;
    var totalLength = componentsArray.length;
    return (React.createElement(React.Fragment, null,
        React.createElement(ValuePropositionWrapper, { onClick: onClick, display: display, totalLength: totalLength, className: className },
            totalLength === 1 ? (React.createElement(Box, { className: "title", display: "inline-flex", justifyContent: ['center', 'center', 'center', 'end'], flexGrow: "1", color: [COLORS.BLACK, COLORS.BLACK, COLORS.BLACK, COLORS.ANCHOR_BLUE] },
                React.createElement(Box, { as: "span", pr: "20px" },
                    componentsArray[0].title,
                    " ",
                    componentsArray[0].subTitle),
                isMobile && React.createElement(InfoIcon, { isMobile: isMobile, display: display }))) : (componentsArray.map(function (component, index) {
                return (React.createElement(InformationTemplate, { key: component.id, id: component.id, subTitle: component.subTitle, title: component.title, totalLength: totalLength, index: index }));
            })),
            (totalLength !== 1 || !isMobile) && React.createElement(InfoIcon, { isMobile: isMobile, display: display }))));
};
var ValueProposition$1 = React.memo(ValueProposition);
var StandardTabCoachMarkContent = function (props) {
    var t = useTranslation().t;
    return (React.createElement(TabCoachMarkDescWrapper, { isRTL: props.isRTL },
        React.createElement(UpLeftArrow, { size: "CUSTOM", width: "81", height: "65", fill: COLORS.WHITE, className: "up-left-arrow" }),
        React.createElement(Box, { as: "h2", my: 3, fontSize: "16px" }, t('standardTabCoachMark.heading')),
        React.createElement(Box, { as: "p", mb: 2, fontSize: "14px", fontWeight: "bold" },
            React.createElement("b", null, t('standardTabCoachMark.subHeading'))),
        React.createElement(Box, { as: "p", fontWeight: "lighter", fontSize: "14px", lineHeight: "17px" }, t('standardTabCoachMark.description'))));
};
var StandardTabCoachMarkContent$1 = memo(StandardTabCoachMarkContent);
var NowTabCoachMarkContent = function (props) {
    var t = useTranslation().t;
    return (React.createElement(TabCoachMarkDescWrapper, { isRTL: props.isRTL },
        React.createElement(UpRightArrow, { size: "CUSTOM", width: "81", height: "65", fill: COLORS.WHITE, className: "up-right-arrow" }),
        React.createElement(Box, { as: "h2", my: 3, fontSize: "16px" }, t('nowTabCoachMark.heading')),
        React.createElement(Box, { as: "p", mb: 2, fontSize: "14px", fontWeight: "bold" },
            React.createElement("b", null, t('nowTabCoachMark.subHeading'))),
        React.createElement(Box, { as: "p", fontWeight: "lighter", fontSize: "14px", lineHeight: "17px" }, t('nowTabCoachMark.description'))));
};
var NowTabCoachMarkContent$1 = memo(NowTabCoachMarkContent);
var ButtonStyle = CustomStyled(Button$1)(templateObject_1$$ || (templateObject_1$$ = __makeTemplateObject$1(["\n  height: 40px;\n  text-transform: inherit;\n  margin: 4px 0;\n"], ["\n  height: 40px;\n  text-transform: inherit;\n  margin: 4px 0;\n"])));
var templateObject_1$$;
var CollectionCardWrapper = customStyled(Box)(templateObject_1$10 || (templateObject_1$10 = __makeTemplateObject$1(["\n    min-width: 296px;\n    max-width: 296px;\n    min-height: 320px;\n    padding-right: 20px!important;    \n\tcolor: ", ";\n    font-family: ", ";\n"], ["\n    min-width: 296px;\n    max-width: 296px;\n    min-height: 320px;\n    padding-right: 20px!important;    \n\tcolor: ", ";\n    font-family: ", ";\n"])), COLORS.BLACK, function (props) { return props.theme.fonts.montserrat; });
var ContentWrapper$2 = customStyled(Box)(templateObject_2$Q || (templateObject_2$Q = __makeTemplateObject$1(["\n    background: ", ";\n    padding: 16px!important;\n    border-radius: 12px;\n    text-decoration: none;\n    text-align:left;\n    box-shadow: 0 0 16px -12px ", ";\n"], ["\n    background: ", ";\n    padding: 16px!important;\n    border-radius: 12px;\n    text-decoration: none;\n    text-align:left;\n    box-shadow: 0 0 16px -12px ", ";\n"])), COLORS.WHITE, COLORS.BLACK);
var Heading$3 = customStyled(Box)(templateObject_3$G || (templateObject_3$G = __makeTemplateObject$1(["\n    font-size: ", "px;\n    text-decoration: none;\n    font-weight: ", ";\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    direction: ltr;\n"], ["\n    font-size: ", "px;\n    text-decoration: none;\n    font-weight: ", ";\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    direction: ltr;\n"])), function (props) { return props.theme.fontSizes[3]; }, function (props) { return props.theme.fontWeights[6]; });
var ItemContent = customStyled(Box)(templateObject_4$A || (templateObject_4$A = __makeTemplateObject$1(["\n    width: 120px;\n    font-size: 12px;\n    line-height: 16px;\n    text-align: center;\n    display: inline-block;\n    margin-bottom: 16px;\n\n    img{\n        width: 85%;\n        margin: 0 auto;\n    }\n"], ["\n    width: 120px;\n    font-size: 12px;\n    line-height: 16px;\n    text-align: center;\n    display: inline-block;\n    margin-bottom: 16px;\n\n    img{\n        width: 85%;\n        margin: 0 auto;\n    }\n"])));
var LinkWrapper$1 = customStyled('a')(templateObject_5$s || (templateObject_5$s = __makeTemplateObject$1(["\t\n    text-decoration: none;\n\tcolor:inherit;\n    :active, :focus, :visited{\n        outline: none !important;\n        text-decoration: none;\n\t}\n"], ["\t\n    text-decoration: none;\n\tcolor:inherit;\n    :active, :focus, :visited{\n        outline: none !important;\n        text-decoration: none;\n\t}\n"])));
var ViewContentWrapper = customStyled(Box)(templateObject_6$m || (templateObject_6$m = __makeTemplateObject$1(["\n    color: ", ";\n    font-weight: ", ";\n    text-decoration: none;\n    align-items: center;\n    text-align: left;\n\n    svg{\n        margin-left: 5px;\n        top: 3px;\n        position: relative;\n        transform: rotate(-90deg);\n    }\n"], ["\n    color: ", ";\n    font-weight: ", ";\n    text-decoration: none;\n    align-items: center;\n    text-align: left;\n\n    svg{\n        margin-left: 5px;\n        top: 3px;\n        position: relative;\n        transform: rotate(-90deg);\n    }\n"])), COLORS.ANCHOR_BLUE, function (props) { return props.theme.fontWeights[6]; });
var NameWrapper = customStyled(Box)(templateObject_7$k || (templateObject_7$k = __makeTemplateObject$1(["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-align: left;\n"], ["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-align: left;\n"])));
var PriceText = customStyled(NameWrapper)(templateObject_8$k || (templateObject_8$k = __makeTemplateObject$1(["\n    text-align: center;\n    font-weight: ", ";\n    margin-top: 4px;\n    font-size:  ", "px;\n"], ["\n    text-align: center;\n    font-weight: ", ";\n    margin-top: 4px;\n    font-size:  ", "px;\n"])), function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.fontSizes[1]; });
var PriceSecondary = customStyled(NameWrapper)(templateObject_9$i || (templateObject_9$i = __makeTemplateObject$1(["\n    font-weight: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-decoration: line-through;\n    text-align: center;\n    visibility: ", "\n"], ["\n    font-weight: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-decoration: line-through;\n    text-align: center;\n    visibility: ", "\n"])), function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.fontSizes[0]; }, COLORS.GRAY_500, function (props) { return (props.isDiscountAvailable ? '' : 'hidden'); });
var templateObject_1$10, templateObject_2$Q, templateObject_3$G, templateObject_4$A, templateObject_5$s, templateObject_6$m, templateObject_7$k, templateObject_8$k, templateObject_9$i;
var TitleContainer = customStyled(Box)(templateObject_1$11 || (templateObject_1$11 = __makeTemplateObject$1(["\n    margin-bottom: 12px;\n    font-family: ", ";\n    font-size: ", "px;\n    font-weight: 700;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    white-space: nowrap;\n    color: ", ";\n\n    @media (min-width: ", ") {\n        font-size: ", "px;\n    }\n"], ["\n    margin-bottom: 12px;\n    font-family: ", ";\n    font-size: ", "px;\n    font-weight: 700;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    white-space: nowrap;\n    color: ", ";\n\n    @media (min-width: ", ") {\n        font-size: ", "px;\n    }\n"])), function (props) { return props.theme.fonts.montserrat; }, function (props) { return props.theme.fontSizes[6]; }, function (props) { return props.theme.colors.black; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.theme.fontSizes[6]; });
var LinkWrapper$2 = customStyled('a')(templateObject_2$R || (templateObject_2$R = __makeTemplateObject$1(["\t\n    text-decoration: none;\n    color: ", ";\n    font-size: ", "px;\n    font-weight: 700;\n    line-height: 20px;\n    :active, :focus, :visited{\n        outline: none !important;\n        text-decoration: none;\n\t}\n"], ["\t\n    text-decoration: none;\n    color: ", ";\n    font-size: ", "px;\n    font-weight: 700;\n    line-height: 20px;\n    :active, :focus, :visited{\n        outline: none !important;\n        text-decoration: none;\n\t}\n"])), function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.fontSizes[3]; });
var SpanText = customStyled('span')(templateObject_3$H || (templateObject_3$H = __makeTemplateObject$1(["\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"], ["\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"])));
var Header$3 = customStyled(Flex)(templateObject_4$B || (templateObject_4$B = __makeTemplateObject$1(["\n  align-items: center;\n  gap: 8px;\n"], ["\n  align-items: center;\n  gap: 8px;\n"])));
var templateObject_1$11, templateObject_2$R, templateObject_3$H, templateObject_4$B;
var useFsFlag = require('@flagship.io/react-sdk').useFsFlag;
var RichCategoryCardWrapper = customStyled('a')(templateObject_1$12 || (templateObject_1$12 = __makeTemplateObject$1(["\n    min-width: 260px;\n    max-width: 260px;\n    height: 392px;\n    position: relative;\n    padding-right: 20px;\n    display: inline-block;\n    border-radius: 12px;\n    color: ", ";\n    text-decoration: none;\n\n    :active, :focus, :visited{\n        outline: none!important;\n        text-decoration: none;\n    }\n\n    ", "\n    \n"], ["\n    min-width: 260px;\n    max-width: 260px;\n    height: 392px;\n    position: relative;\n    padding-right: 20px;\n    display: inline-block;\n    border-radius: 12px;\n    color: ", ";\n    text-decoration: none;\n\n    :active, :focus, :visited{\n        outline: none!important;\n        text-decoration: none;\n    }\n\n    ",
    "\n    \n"])), function (props) { return props.theme.colors.black; }, function (props) {
    if (props.rtl) {
        return ":first-of-type{\n                min-width: 240px;\n                max-width: 240px;\n                padding-right: 0px;\n            }";
    }
    return ":last-of-type{\n            min-width: 240px;\n            max-width: 240px;\n            padding-right: 0px;\n        }";
});
var ImageWrapper$3 = customStyled(Box)(templateObject_2$S || (templateObject_2$S = __makeTemplateObject$1(["\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100% 100%;\n    width: 100%;\n    height: 100%;\n    border-radius: 12px;\n    box-shadow: 0 0 16px -12px #000;\n"], ["\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100% 100%;\n    width: 100%;\n    height: 100%;\n    border-radius: 12px;\n    box-shadow: 0 0 16px -12px #000;\n"])), function (props) { return props.bgImage; });
var TextContentWrapper = customStyled(Box)(templateObject_3$I || (templateObject_3$I = __makeTemplateObject$1(["\n    padding: 20px 16px 0px;\n\n    & > * {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-align: left;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        line-height: 1.2;\n        max-height: 38px;\n        direction: ltr;\n    }\n\n    h3{\n        font-size: ", "px;\n        font-weight: ", ";\n        color: ", ";\n        margin-bottom: 4px;\n    }\n\n    p{\n        font-size: ", "px;\n    }\n"], ["\n    padding: 20px 16px 0px;\n\n    & > * {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-align: left;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        line-height: 1.2;\n        max-height: 38px;\n        direction: ltr;\n    }\n\n    h3{\n        font-size: ", "px;\n        font-weight: ", ";\n        color: ", ";\n        margin-bottom: 4px;\n    }\n\n    p{\n        font-size: ", "px;\n    }\n"])), function (props) { return props.theme.fontSizes[3]; }, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.color || props.theme.colors.black; }, function (props) { return props.theme.fontSizes[2]; });
var templateObject_1$12, templateObject_2$S, templateObject_3$I;
var Container$a = styled(Box)(templateObject_1$13 || (templateObject_1$13 = __makeTemplateObject$1(["\n  position: relative;\n  video {\n    width: 100%;\n    height: 193px;\n    background: ", ";\n    @media (min-width: ", ") {\n      height: 692px;\n    }\n  }\n"], ["\n  position: relative;\n  video {\n    width: 100%;\n    height: 193px;\n    background: ", ";\n    @media (min-width: ", ") {\n      height: 692px;\n    }\n  }\n"])), COLORS.VIDEO_BG_COLOR, function (props) { return props.theme.breakpoints[1]; });
var PlayButtons = styled(Box)(templateObject_2$T || (templateObject_2$T = __makeTemplateObject$1(["\n  height: 128px;\n  left: 50%;\n  margin: -64px 0 0 -64px;\n  position: absolute;\n  top: 50%;\n  width: 128px;\n  z-index: 1;\n"], ["\n  height: 128px;\n  left: 50%;\n  margin: -64px 0 0 -64px;\n  position: absolute;\n  top: 50%;\n  width: 128px;\n  z-index: 1;\n"])));
var templateObject_1$13, templateObject_2$T;

var isServer$1 = function () { return typeof window === 'undefined'; };
var createGrowthBookInstance$1 = function (_a, state) {
    var features = _a.features, attributes = _a.attributes;
    var growthbook = new GrowthBook({
        trackingCallback: function (experiment, result) {
            var _a = state === null || state === void 0 ? void 0 : state.appConfig, _b = _a.userCredentials, userCredentials = _b === void 0 ? {} : _b, _c = _a.storeId, storeId = _c === void 0 ? '' : _c, _d = _a.currency, currency = _d === void 0 ? '' : _d, _e = _a.language, language = _e === void 0 ? '' : _e;
            var featureId = result.featureId, variationId = result.variationId, value = result.value;
            if (!isServer$1()) {
                dataLayer.push({
                    event: 'viewed_experiment',
                    feature_id: featureId,
                    experiment_key: experiment.key,
                    variation_id: variationId,
                    variation_value: value,
                    screen_type: CookieUtils.getPageType(),
                    hashed_email: CookieUtils.getCustomCookie('maf-user-id'),
                    market: storeId,
                    currency: currency,
                    logged_in_status: !!(userCredentials === null || userCredentials === void 0 ? void 0 : userCredentials.userId) || false,
                    language: language,
                });
            }
        },
    });
    growthbook.setFeatures(features);
    growthbook.setAttributes(attributes);
    return growthbook;
};
var getGrowthBookFeatureValueViaInstance$1 = function (state, featureName) {
    var _a = ((state === null || state === void 0 ? void 0 : state.appConfig) || {}).growthBook, growthBook = _a === void 0 ? {} : _a;
    var growthbook = createGrowthBookInstance$1(growthBook, state);
    return growthbook.feature(featureName);
};

var growthbook_util$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    isServer: isServer$1,
    createGrowthBookInstance: createGrowthBookInstance$1,
    getGrowthBookFeatureValueViaInstance: getGrowthBookFeatureValueViaInstance$1
});

//  REF: https://github.com/nhn/tui.code-snippet/tree/v2.0.0
/**
 * Check whether the given variable is existing or not.
 * If the given variable is not null and not undefined, returns true.
 * @param {*} target - Target for checking
 * @returns {boolean} Is existy?
 */
var isExisty$1 = function (target) { return !isUndefined$1(target) && !isNull$1(target); };
/**
 * Check whether the given variable is null or not.
 * If the given variable(arguments[0]) is null, returns true.
 * @param {*} target - Target for checking
 * @returns {boolean} Is null?
 */
var isNull$1 = function (target) { return target === null || target === ''; };
/**
 * Check whether the given variable is empty object or not.
 * If the given variable(arguments[0]) is empty object, returns true.
 * @param {*} target - Target for checking
 * @returns {boolean} Is null?
 */
var isEmptyObject$1 = function (target) {
    if (target === void 0) { target = {}; }
    return !Object.keys(target).length;
};
/**
 * Check whether the given variable is a number or not.
 * If the given variable is a number, return true.
 * @param {*} target - Target for checking
 * @returns {boolean} Is number?
 */
var isNumber$1 = function (target) { return typeof target === 'number' || target instanceof Number; };
/**
 * Check whether the given variable is an object or not.
 * If the given variable is an object, return true.
 * @param {*} target - Target for checking
 * @returns {boolean} Is object?
 */
var isObject$1 = function (target) { return target === Object(target); };
/**
 * Check whether the given variable is string or not.
 * If the given variable is string, return true.
 * @param {*} target - Target for checking
 * @returns {boolean} Is object?
 */
var isString$1 = function (target) { return typeof target === 'string'; };
/**
 * Check whether the given variable is boolean or not.
 * If the given variable is boolean, return true.
 * @param {*} target - Target for checking
 * @returns {boolean} Is object?
 */
var isBoolean$1 = function (target) { return typeof target === 'boolean'; };
/**
 * Check whether the given variable is undefined or not.
 * If the given variable is undefined, returns true.
 * @param {*} target - Target for checking
 * @returns {boolean} Is undefined?
 */
var isUndefined$1 = function (target) { return target === undefined; };
/**
 * Check whether the given variable is a valid non-empty Array
 * @param {*} target - Target for checking
 * @returns {boolean} Is non-empty Array?
 */
var isNonEmptyArray$1 = function (target) { return target && target.length > 0; };
/**
 * Convert the given variable into decimal point
 * @param {*} target - Target for checking
 * @param {number} decimalPoint - Decimal point
 * @returns {string | number}
 */
var setDecimalPoint$1 = function (target, decimalPoint) {
    if (decimalPoint === void 0) { decimalPoint = 2; }
    return isNumber$1(target) ? target.toFixed(decimalPoint) : target;
};
/**
 * Return the correct Noun based on the given "target" variable
 * @param {number} target - Target for checking
 * @param {string} singularNoun - Will return if "target" is only one
 * @param {string} pluralNoun - Will return if "target" is more than one
 * @returns {string}
 */
var getProperNoun$1 = function (target, singularNoun, pluralNoun) {
    return target < 2 ? singularNoun : pluralNoun;
};
/**
 * Return the length of enumerable properties of the given object
 * @param {object} target - Target for checkout
 */
var countObjectProperties$1 = function (target) { return Object.keys(target).length; };
/**
 * Creates a subset by dividing the array from the length as offset
 * @param {array} array
 * @param {number} offset
 */
var subsets$1 = function (array, offset) {
    if (offset === void 0) { offset = 1; }
    var subset = [];
    var tempArray = [];
    array.forEach(function (item, index) {
        var i = index % offset;
        tempArray[i] = item;
        if ((index + 1) % offset === 0) {
            subset.push(tempArray);
            tempArray = [];
        }
        else if (index === array.length - 1 && tempArray.length > 0) {
            subset.push(tempArray);
            tempArray = [];
        }
    });
    return subset;
};
var isBrowser$1 = function () { return typeof window !== 'undefined'; };
var qs$1 = function (params) {
    return Object.entries(params)
        .map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        return key + "=" + encodeURIComponent(val);
    })
        .join('&');
};
var limitStr$1 = function (str, n) {
    return str.length > n ? str.substr(0, n) + '...' : str;
};
var decodeStr$1 = function (str) {
    if (str === void 0) { str = ''; }
    if (!str) {
        return '';
    }
    try {
        return decodeURIComponent(str);
    }
    catch (_a) {
        return unescape(str);
    }
};
var encodeStr$1 = function (str) {
    if (str === void 0) { str = ''; }
    return encodeURIComponent(str);
};
var getFloorApartment$1 = function (str, floorKey, flatKey) {
    if (str === void 0) { str = ''; }
    if (str.indexOf(floorKey) > -1) {
        return str.replace(floorKey, '').split(flatKey);
    }
    return null;
};
var getFloorFlat$1 = function (appartment, floorKey, flatKey) {
    var data = getFloorApartment$1(appartment, floorKey, flatKey);
    if (data) {
        var _a = __read(data, 2), floor = _a[0], flat = _a[1];
        return "\n        " + (floor ? floor + "," : '') + "\n        " + (flat ? flat + "," : '') + "\n      ";
    }
    else {
        return "" + (appartment ? appartment + "," : '');
    }
};
var transformPhoneNo$1 = function (phoneNumber, language) {
    if (phoneNumber === void 0) { phoneNumber = ''; }
    if (language === void 0) { language = ''; }
    if (!phoneNumber) {
        return '';
    }
    return language === 'ar' ? (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.slice(1)) + "+" : phoneNumber;
};
var isDefaultArea$1 = function (areaCode, defaultAreaCode) {
    return decodeURI(areaCode || '').toLowerCase() === decodeURI(defaultAreaCode || '').toLowerCase();
};
var isEventExist$1 = function (dataLayer, event, event_label) {
    var eventIndex = dataLayer.findIndex(function (item) { return item.event === event && item.event_label === event_label; });
    return eventIndex !== -1;
};
var isMobileDevice$1 = function (userAgent) {
    return Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));
};
var generateUuid$1 = function () {
    var result, i, j;
    result = '';
    for (j = 0; j < 32; j++) {
        if (j === 8 || j === 12 || j === 16 || j === 20)
            result = result + '-';
        i = Math.floor(Math.random() * 16)
            .toString(16)
            .toUpperCase();
        result = result + i;
    }
    return result;
};
var getMessagesForBusyOrOfflineScreen$1 = function (deliverySlot) {
    var _a = deliverySlot || {}, nextAvailableSlot = _a.nextAvailableSlot, _b = _a.busyStatus, busyStatus = _b === void 0 ? {} : _b;
    var _c = nextAvailableSlot || {}, _d = _c.title, offlineTitle = _d === void 0 ? '' : _d, _e = _c.subTitle, offlineSubtitle = _e === void 0 ? '' : _e;
    var _f = busyStatus.title, busyTitle = _f === void 0 ? '' : _f, _g = busyStatus.subTitle, busySubtitle = _g === void 0 ? '' : _g;
    var _h = busyStatus.isBusy, isBusyState = _h === void 0 ? false : _h;
    return { offlineTitle: offlineTitle, offlineSubtitle: offlineSubtitle, busyTitle: busyTitle, busySubtitle: busySubtitle, isBusyState: isBusyState };
};
var renderOtherTabsText$1 = function (pageStructure, selectedTabId, t) {
    if (selectedTabId === void 0) { selectedTabId = -1; }
    var tabLabels = pageStructure.reduce(function (acc, component) {
        if (component.title && component.id !== selectedTabId) {
            acc.push(component.title);
        }
        return acc;
    }, []);
    var tabCount = tabLabels.length;
    if (tabCount === 0) {
        return null;
    }
    var otherTabs = '';
    if (tabCount === 1) {
        otherTabs = "'" + tabLabels[0] + "'";
    }
    else if (tabCount === 2) {
        otherTabs = "'" + tabLabels[0] + "' " + t('otherTabsText.or') + " '" + tabLabels[1] + "'";
    }
    else {
        otherTabs = tabLabels
            .slice(0, -1)
            .map(function (label) { return "'" + label + "'"; })
            .join(', ') + " " + t('otherTabsText.or') + " '" + tabLabels[tabCount - 1] + "'";
    }
    return otherTabs;
};
var shouldAlwaysShowOlderAddressJourney$1 = function () {
    if (isServer$1())
        return false;
    var path = window.location.pathname;
    return path.includes('/app') || path.includes('/my-account');
};

var helpers_util$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    isExisty: isExisty$1,
    isNull: isNull$1,
    isEmptyObject: isEmptyObject$1,
    isNumber: isNumber$1,
    isObject: isObject$1,
    isString: isString$1,
    isBoolean: isBoolean$1,
    isUndefined: isUndefined$1,
    isNonEmptyArray: isNonEmptyArray$1,
    setDecimalPoint: setDecimalPoint$1,
    getProperNoun: getProperNoun$1,
    countObjectProperties: countObjectProperties$1,
    subsets: subsets$1,
    isBrowser: isBrowser$1,
    qs: qs$1,
    limitStr: limitStr$1,
    decodeStr: decodeStr$1,
    encodeStr: encodeStr$1,
    getFloorApartment: getFloorApartment$1,
    getFloorFlat: getFloorFlat$1,
    transformPhoneNo: transformPhoneNo$1,
    isDefaultArea: isDefaultArea$1,
    isEventExist: isEventExist$1,
    isMobileDevice: isMobileDevice$1,
    generateUuid: generateUuid$1,
    getMessagesForBusyOrOfflineScreen: getMessagesForBusyOrOfflineScreen$1,
    renderOtherTabsText: renderOtherTabsText$1,
    shouldAlwaysShowOlderAddressJourney: shouldAlwaysShowOlderAddressJourney$1
});

// Global helper for Product Quantity
var KG_VALUE$1 = 1000;
var KG_LABEL$1 = 'KG';
var CQtyDefault$1 = /** @class */ (function () {
    function CQtyDefault(_a) {
        var incrementBy = _a.incrementBy, soldByWeight = _a.soldByWeight, max = _a.max, min = _a.min, price = _a.price, currencyDecimal = _a.currencyDecimal;
        this.incrementBy = isUndefined$1(incrementBy) ? 1 : incrementBy;
        this.soldByWeight = isUndefined$1(soldByWeight) ? false : soldByWeight;
        this.max = isUndefined$1(max) ? 10 : max;
        this.min = isUndefined$1(min) ? 1 : min;
        this.price = isUndefined$1(price) ? 0 : price;
        // currency will be formatted to 2 decimal places by default
        this.currencyDecimal = currencyDecimal || 2;
    }
    return CQtyDefault;
}());
var formatQuantityKG$1 = function (quantity, soldByWeight) {
    if (soldByWeight === void 0) { soldByWeight = false; }
    return soldByWeight ? setDecimalPoint$1(quantity) : quantity;
};
var convertQuantityToKG$1 = function (quantity, soldByWeight) {
    if (soldByWeight === void 0) { soldByWeight = false; }
    return soldByWeight ? parseFloat(setDecimalPoint$1(quantity / KG_VALUE$1)) : quantity;
};
var addKGLabel$1 = function (quantity) { return quantity + " " + KG_LABEL$1; };
var generateOptionObj$1 = function (qtyRaw, soldByWeight, price, currencyDecimal) {
    if (soldByWeight === void 0) { soldByWeight = false; }
    var qty = formatQuantityKG$1(qtyRaw, soldByWeight);
    // out of memory error due to long string in qty
    var value = parseFloat(qty);
    return {
        id: "qty-" + value,
        value: value,
        label: soldByWeight ? addKGLabel$1(qty) : qty,
        price: price ? (price * value).toFixed(currencyDecimal) : '',
    };
};
var generateQuantityList$1 = function (params) {
    // For not getting in infinite loop and out of memory keeping a constant as fail safe machanism
    var _a = new CQtyDefault$1(params), incrementBy = _a.incrementBy, soldByWeight = _a.soldByWeight, _b = _a.max, max = _b === void 0 ? 10 : _b, _c = _a.min, min = _c === void 0 ? 1 : _c, price = _a.price, currencyDecimal = _a.currencyDecimal;
    var quantityList = [];
    var quantityOption = min;
    while (quantityOption <= max) {
        var optionObj = generateOptionObj$1(quantityOption, soldByWeight, price, currencyDecimal);
        quantityList.push(optionObj);
        quantityOption = optionObj.value + incrementBy;
        if (optionObj.value < max && quantityOption > max) {
            quantityOption = max;
        }
    }
    return quantityList;
};

var quantity_util$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    KG_LABEL: KG_LABEL$1,
    CQtyDefault: CQtyDefault$1,
    formatQuantityKG: formatQuantityKG$1,
    convertQuantityToKG: convertQuantityToKG$1,
    addKGLabel: addKGLabel$1,
    generateOptionObj: generateOptionObj$1,
    generateQuantityList: generateQuantityList$1
});

var E_SOLD_BY_MESSAGE_TYPE$1;
(function (E_SOLD_BY_MESSAGE_TYPE) {
    E_SOLD_BY_MESSAGE_TYPE["SFC"] = "SFC";
    E_SOLD_BY_MESSAGE_TYPE["SSDC"] = "SSDC";
    E_SOLD_BY_MESSAGE_TYPE["SSFS"] = "SSFS";
    E_SOLD_BY_MESSAGE_TYPE["SSFBC"] = "SSFBC";
})(E_SOLD_BY_MESSAGE_TYPE$1 || (E_SOLD_BY_MESSAGE_TYPE$1 = {}));
var E_TRIGGER_TYPE$1;
(function (E_TRIGGER_TYPE) {
    E_TRIGGER_TYPE["OPEN"] = "open";
    E_TRIGGER_TYPE["CLOSE"] = "close";
})(E_TRIGGER_TYPE$1 || (E_TRIGGER_TYPE$1 = {}));

var constants$1 = {
    userToken: 'authToken',
    userId: 'userId',
    guestToken: "mafuae-cart",
    guestSessionToken: 'guest-session-token',
    guestUserID: 'anonymous',
    guidUnavailable: 'bucket-id-not-present',
    rrSessionId: 'maf-session-id',
    rrUserId: 'maf-user-id',
    deliveryArea: 'preferred-delivery-area',
    prevAreaCode: 'prevAreaCode',
    cookieBannerAcceptance: 'maf-cookie-banner-accepted',
    expressDeliveryMessage: 'expressDeliveryMessage',
    expressPos: 'expressPos',
    selectedLat: 'lat',
    selectedLng: 'long',
    refreshToken: 'refreshToken',
    hybrisTokenExpiration: 'hybrisTokenExpiration',
    expiresIn: 'expiresIn',
    hybrisToken: 'reactUserToken',
    posIds: 'posIds',
    selectedAddressID: 'selectedAddressID',
    categorySearch: 'categorySearch',
    productSearch: 'productsearch',
    product_details: 'product_details',
    category: 'category',
    refreshTokenCallTimeStamp: 'refreshTokenCallTimeStamp',
    productDetails: 'product-details',
    categoryLandingPage: 'category_landing_page',
    brandLandingPage: 'brand_landing_page',
    home: 'home',
    actionField: 'actionField',
    needhelp: 'needHelp',
    deals: 'Deals',
    quickBuy: 'Buy Again',
    packageFreeDelivery: 'pkgFreeDlvry',
    defaultAreaCode: 'web-preferred-delivery-area',
    multiLevelCarousel: 'multi_level_carousel',
    sponsoredListing: 'sponsored_listing',
    cart: 'cart',
    reOrder: 'REORDER',
    isNowJourney: 'isNowJourney',
    pageName: 'page_type',
    categoryName: 'category_name',
    noName: 'no_name',
    isExpressServiceType: 'isExpressServiceType',
    profile: 'profile',
    customerId: 'customerId',
};
var FLOOR_KEY$1 = 'Floor#';
var FLAT_KEY$1 = '|Flat#';
var E_SOLD_BY_MESSAGE_TYPE$2 = E_SOLD_BY_MESSAGE_TYPE$1;
var GROWTHBOOK_FLAGS$1 = {
    adtechCriteo: 'criteo_ad_enabled',
    adtechCriteo2ndPhase: 'criteo_ad_phase_2_enabled',
    flagshipEnabled: 'flagship_enabled',
    adtech_plp: 'adtech_plp',
    adtech_slp: 'adtech_slp',
    non_food_v2: 'dynamic_page_structure.experiment',
    listing_page: 'flutter.listing_page.enabled',
    address_new_journey: 'flutter.address_revamp.enabled',
    common_whitelisted_service_type_config: 'common.whitelisted_service_type.config',
    store_closure_enabled: 'common.store_close_services.enabled',
};
var WHITELISTED_DEFAULT_VALUE = ['food', 'express', 'nonfood'];
var FLAGSHIP_KEYS$1 = {
    envKey: process.env.REACT_APP_FLAGSHIP_ENV_KEY,
    apiKey: process.env.REACT_APP_FLAGSHIP_API_KEY,
};

/**
 * This contains the entire logic related to App Cookie + Configuration
 *
 * NOTES:
 * It reads the browser cookie `storeInfo` in order to retrieve the current site's store info
 * The value of this cookie comes in the format of "mafuae|en|AED"
 */
// Reads the api cookie
var getApiInfoCookie$1 = function () { return new Cookies().get(APP_CONFIG$1.__cookie__.cartApiCookie) || ''; };
// Reads the cookie and splits its value
var getStoreInfoCookie$1 = function () {
    return (new Cookies().get(APP_CONFIG$1.__cookie__.storeInfoCookieName) || '').split('|');
};
// const getPosIdsCookie = (): string[] => (new Cookies().get(APP_CONFIG.__cookie__.posListCookieName) || '').split('|');
// Extracts a value from the splitted cookie value
var extractStoreInfoCookieValue$1 = function (indexPosition, propertyKey) { return APP_CONFIG$1.__cookie__.storeInfoCookieValue[indexPosition] || APP_CONFIG$1.__defaults__[propertyKey]; };
var extractCookieValue$1 = function (key) { return new Cookies().get(key) || ''; };
// Not flexible but having it only for the sake of default values
var EStoreID$1;
(function (EStoreID) {
    EStoreID["MAFEGY"] = "mafegy";
    EStoreID["MAFJOR"] = "mafjor";
    EStoreID["MAFLBN"] = "maflbn";
    EStoreID["MAFQAT"] = "mafqat";
    EStoreID["MAFSAU"] = "mafsau";
    EStoreID["MAFUAE"] = "mafuae";
    EStoreID["MAFPAK"] = "mafpak";
    EStoreID["MAFKEN"] = "mafken";
    EStoreID["MAFBHR"] = "mafbhr";
    EStoreID["MAFOMN"] = "mafomn";
    EStoreID["MAFKWT"] = "mafkwt";
    EStoreID["MAFGEO"] = "mafgeo";
    EStoreID["MAFUZB"] = "mafuzb";
    EStoreID["MAFARM"] = "mafarm";
    EStoreID["MAFUGA"] = "mafuga";
    EStoreID["MAFIRQ"] = "mafirq";
})(EStoreID$1 || (EStoreID$1 = {}));
var APP_CONFIG$1 = {
    __defaults__: {
        currency: 'AED',
        language: '',
        storeId: 'mafuae',
    },
    config: {},
    __inialize__: function (config) {
        this.current = config;
    },
    __cookie__: {
        cartApiCookie: 'cart_api',
        get appInfoCookieValue() {
            return getApiInfoCookie$1();
        },
        storeInfoCookieName: 'storeInfo',
        posListCookieName: 'posIds',
        get storeInfoCookieValue() {
            return getStoreInfoCookie$1();
        },
    },
    // TODO: set the cookie value when we changed the language and remove the condition to always
    // take it from cookie
    get isPolygonChange() {
        return this.config.isPolygonChange || false;
    },
    get adtech_plp() {
        return this.config.adtech_plp || false;
    },
    get: function () {
        return this.config.posInfoConfig || [''];
    },
    get adtech_slp() {
        return this.config.adtech_slp || false;
    },
    get nonFoodUIDs() {
        return this.config.nonFoodUIDs || {};
    },
    get currency() {
        return this.config.currency || extractStoreInfoCookieValue$1(2, 'currency');
    },
    get language() {
        return this.config.language || extractStoreInfoCookieValue$1(1, 'language');
    },
    get storeId() {
        return this.config.storeId || extractStoreInfoCookieValue$1(0, 'storeId');
    },
    get latitude() {
        return this.config.latitude || extractCookieValue$1(constants$1.selectedLat) || '';
    },
    get longitude() {
        return this.config.longitude || extractCookieValue$1(constants$1.selectedLng) || '';
    },
    get sessionId() {
        return this.config.sessionId || extractCookieValue$1(constants$1.rrSessionId);
    },
    get areaCode() {
        return this.config.areaCode || extractCookieValue$1(this.storeId + "-" + constants$1.deliveryArea);
    },
    get userId() {
        return this.config.userId || extractCookieValue$1(constants$1.userId);
    },
    get expressDeliveryMessage() {
        return this.config.expressDeliveryMessage || extractCookieValue$1(constants$1.expressDeliveryMessage);
    },
    get expressPos() {
        return this.config.expressPos || extractCookieValue$1(constants$1.expressPos);
    },
    get isLBN() {
        return APP_CONFIG$1.storeId === EStoreID$1.MAFLBN;
    },
    set current(config) {
        this.config = config;
    },
    get customerCareNumber() {
        return this.config.customerCareNumber || '';
    },
    get isNewEndpoint() {
        return this.__cookie__.appInfoCookieValue === 'v2' ? true : false;
    },
    get decimalPlaces() {
        return this.storeId === EStoreID$1.MAFBHR || this.storeId === EStoreID$1.MAFKWT ? 3 : 2;
    },
    userCredentials: {},
    get pageName() {
        return this.config.pageName || extractCookieValue$1(constants$1.pageName) || '';
    },
};

// REF: https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-currency-string-in-javascript
var prettifyPrice$1 = function (target) {
    var _a = __read(target.toFixed(APP_CONFIG$1.decimalPlaces).split('.'), 2), wholeNum = _a[0], decimalNum = _a[1];
    return APP_CONFIG$1.isLBN
        ? Number(wholeNum).toLocaleString() + " "
        : Number(wholeNum).toLocaleString() + "." + decimalNum;
};
var getFormattedPrice$1 = function (_a, showPerKG) {
    var value = _a.value, _b = _a.currencyIso, currencyIso = _b === void 0 ? '' : _b, soldByWeight = _a.soldByWeight;
    if (showPerKG === void 0) { showPerKG = false; }
    return (prettifyPrice$1(value) + " " + currencyIso + (showPerKG && soldByWeight ? "/" + KG_LABEL$1 : '')).trim();
};
var getWasPrice$1 = function (price) {
    var discountPrice = price.discountPrice, finalPrice = price.finalPrice, originalPrice = price.originalPrice, value = price.value;
    if (discountPrice && originalPrice && originalPrice.value !== value) {
        return getFormattedPrice$1(originalPrice);
    }
    if (finalPrice && finalPrice.value !== value) {
        return getFormattedPrice$1(finalPrice);
    }
    return null;
};

var price_util$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    prettifyPrice: prettifyPrice$1,
    getFormattedPrice: getFormattedPrice$1,
    getWasPrice: getWasPrice$1
});

var hydrateCustomMemory$1 = function () {
    var memorySnapshot = {}; // rehydrate this
    return memorySnapshot;
};
var customMemory$1 = hydrateCustomMemory$1();
function initStorageManager$1(targetStorage) {
    var isCompatible = function (candidateStorage) {
        try {
            var testKeyString = '__test_custom_storage_key__';
            candidateStorage.setItem(testKeyString, testKeyString);
            candidateStorage.removeItem(testKeyString);
            return true;
        }
        catch (e) {
            return false;
        }
    };
    var storage = targetStorage();
    var isStorageCompatible = isCompatible(storage);
    var getItem = function (itemKey) {
        if (isStorageCompatible) {
            var stringified = storage.getItem(itemKey);
            var parsed = stringified ? JSON.parse(stringified) : null;
            return parsed;
        }
        if (customMemory$1.hasOwnProperty(itemKey)) {
            return customMemory$1[itemKey];
        }
        return null;
    };
    var setItem = function (itemKey, value) {
        if (isStorageCompatible) {
            var stringify = JSON === null || JSON === void 0 ? void 0 : JSON.stringify(value);
            storage.setItem(itemKey, stringify);
        }
        else {
            customMemory$1[itemKey] = String(value);
        }
    };
    var removeItem = function (itemKey) {
        if (isStorageCompatible) {
            storage.removeItem(itemKey);
        }
        else {
            delete customMemory$1[itemKey];
        }
    };
    var clear = function () {
        if (isStorageCompatible) {
            storage.clear();
        }
        else {
            customMemory$1 = {};
        }
    };
    return {
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem,
        clear: clear,
    };
}

var customStorage_util$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    initStorageManager: initStorageManager$1
});

var EApiActionTypes$2;
(function (EApiActionTypes) {
    EApiActionTypes["API"] = "API";
    EApiActionTypes["API_ERROR"] = "API_ERROR";
    EApiActionTypes["ACCESS_DENIED"] = "ACCESS_DENIED";
    EApiActionTypes["API_START"] = "_START";
    EApiActionTypes["API_END"] = "_END";
    EApiActionTypes["API_SUCCESS"] = "_SUCCESS";
    EApiActionTypes["API_FAIL"] = "_FAIL";
})(EApiActionTypes$2 || (EApiActionTypes$2 = {}));
var EApiActionTypes$3 = EApiActionTypes$2;

var UserTypes$2;
(function (UserTypes) {
    UserTypes["USER_SET_SELECTED_ADDRESSES"] = "USER/USER_SET_SELECTED_ADDRESSES";
    UserTypes["USER_SET_ADDRESS_CHANGE"] = "USER/USER_SET_ADDRESS_CHANGE";
    UserTypes["USER_SET_ADDRESSES_LOADING"] = "USER/SET_ADDRESSES_LOADING";
    UserTypes["USER_SET_ADDRESSES_ERROR"] = "USER/SET_ADDRESSES_ERROR";
    UserTypes["USER_GET_DATA"] = "USER/GET_DATA";
    UserTypes["USER_GET_LOYALTY_DATA"] = "USER/GET_LOYALTY_DATA";
    UserTypes["USER_GET_DATA_START"] = "USER/GET_DATA_START";
    UserTypes["USER_GET_DATA_END"] = "USER/GET_DATA_END";
    UserTypes["USER_GET_LOYALTY_DATA_SUCCESS"] = "USER/GET_LOYALTY_DATA_SUCCESS";
    UserTypes["USER_GET_LOYALTY_DATA_END"] = "USER/GET_LOYALTY_DATA_END";
    UserTypes["USER_FETCH_ADDRESSES"] = "USER/FETCH_ADDRESSES";
    UserTypes["USER_UPDATE_DELIVERY_ADDRESS"] = "USER/UPDATE_DELIVERY_ADDRESS";
    UserTypes["USER_UPDATE_NEWLY_ADDED_ADDRESS"] = "USER/UPDATE_NEWLY_ADDED_ADDRESS";
    UserTypes["USER_COUNTRY_CONFIG"] = "USER/USER_COUNTRY_CONFIG";
    UserTypes["USER_CHECK_AREA_SUPPORT"] = "USER/USER_CHECK_AREA_SUPPORT";
    UserTypes["USER_GET_DELIVERY_AREAS"] = "USER/USER_GET_DELIVERY_AREAS";
    UserTypes["USER_ADD_ADDRESS"] = "USER/USER_ADD_ADDRESS";
    UserTypes["USER_UPDATE_ADDRESS"] = "USER/USER_UPDATE_ADDRESS";
    UserTypes["USER_ADDRESS_PHONE_VERIFIED"] = "USER/USER_ADDRESS_PHONE_VERIFIED";
    UserTypes["USER_PROFILE_DATA"] = "USER/GET_USER_PROFILE_DATA";
    UserTypes["USER_PROFILE_DATA_SUCCESS"] = "USER/GET_USER_PROFILE_DATA_SUCCESS";
    UserTypes["USER_UPDATE_PROFILE"] = "USER/USER_UPDATE_PROFILE";
    UserTypes["USER_UPDATE_PROFILE_START"] = "USER/USER_UPDATE_PROFILE_START";
    UserTypes["USER_UPDATE_PROFILE_END"] = "USER/USER_UPDATE_PROFILE_END";
    UserTypes["USER_PROFILE_PHONE_UPDATE"] = "USER/USER_PROFILE_PHONE_UPDATE";
    UserTypes["USER_GET_PHONE_EXIST_SUCCESS"] = "USER/GET_PHONE_EXIST_SUCCESS";
    UserTypes["UPDATE_USER_CONTACT"] = "USER/UPDATE_USER_CONTACT";
    UserTypes["UPDATE_USER_CONTACT_SUCCESS"] = "USER/UPDATE_USER_CONTACT_SUCCESS";
    UserTypes["UPDATE_USER_CONTACT_ERROR"] = "USER/UPDATE_USER_CONTACT_ERROR";
    UserTypes["USER_CREATE_LOYALTY_ACCOUNT"] = "USER/USER_CREATE_LOYALTY_ACCOUNT";
    UserTypes["USER_GET_LOYALTY_SUMMARY"] = "USER/USER_GET_LOYALTY_SUMMARY";
    UserTypes["USER_GET_LOYALTY_SUMMARY_SUCCESS"] = "USER/USER_GET_LOYALTY_SUMMARY_SUCCESS";
})(UserTypes$2 || (UserTypes$2 = {}));
var USER_FETCH_ADDRESSES_SUCCESS$1 = "" + UserTypes$2.USER_FETCH_ADDRESSES + EApiActionTypes$3.API_SUCCESS;
var USER_ADD_ADDRESS_SUCCESS$1 = "" + UserTypes$2.USER_ADD_ADDRESS + EApiActionTypes$3.API_SUCCESS;
var USER_COUNTRY_CONFIG_SUCCESS$1 = "" + UserTypes$2.USER_COUNTRY_CONFIG + EApiActionTypes$3.API_SUCCESS;
var USER_CHECK_AREA_SUPPORT_SUCCESS$1 = "" + UserTypes$2.USER_CHECK_AREA_SUPPORT + EApiActionTypes$3.API_SUCCESS;
var USER_CHECK_AREA_SUPPORT_FAIL$1 = "" + UserTypes$2.USER_CHECK_AREA_SUPPORT + EApiActionTypes$3.API_FAIL;
var USER_GET_DELIVERY_AREAS_SUCCESS$1 = "" + UserTypes$2.USER_GET_DELIVERY_AREAS + EApiActionTypes$3.API_SUCCESS;
var UserTypes$3 = UserTypes$2;

var EApiMiddlewareMethod$2;
(function (EApiMiddlewareMethod) {
    EApiMiddlewareMethod["DELETE"] = "DELETE";
    EApiMiddlewareMethod["GET"] = "GET";
    EApiMiddlewareMethod["POST"] = "POST";
    EApiMiddlewareMethod["PUT"] = "PUT";
    EApiMiddlewareMethod["PATCH"] = "PATCH";
})(EApiMiddlewareMethod$2 || (EApiMiddlewareMethod$2 = {}));
var EApiMiddlewareMethod$3 = EApiMiddlewareMethod$2;

var USER_API_BASE$1 = 'users/{{StoreId}}/{{language}}';
var CLOUDFLARE_API$1 = process.env.BASE_PERS_HOST || '';
var APIGEE_ENDPOINT$1 = process.env.APIGEE_ENDPOINT || '';
var HOME_BFF_BASE_URL$1 = process.env.HOME_BFF__K8S_BASE_URL || '';
var REACT_APP_APIGEE_ENDPOINT$1 = process.env.REACT_APP_RETAIL_SSO_BASE || '';
var BASE_URI$1 = CLOUDFLARE_API$1 + "/api/v1";
var BASE_URI_V2$1 = CLOUDFLARE_API$1 + "/api/v2";
var BASE_URI_V4$1 = CLOUDFLARE_API$1 + "/api/v4";
var BASE_URI_V5$1 = CLOUDFLARE_API$1 + "/api/v5";
var BASE_RELEVANCE_PRODUCT$1 = BASE_URI_V4$1 + "/relevance";
var BASE_PRODUCT_V2$1 = BASE_URI_V2$1 + "/products";
var BASE_PRODUCT_V4$1 = BASE_URI_V4$1 + "/products";
var GET_USER_LOYALTY_HISTORY_API = USER_API_BASE$1 + "/loyalty-points?fields=FULL&displayCurr={{Currency}}";
var GET_USER_LOYALTY_API = "/customers/loyalty-info";
var GET_AUTOCOMPLETE = "/auto-suggest?query={{query}}";
var GET_USER_COUNTRY_CONFIG$1 = USER_API_BASE$1 + "/switchingOfCountry?displayCurr={{Currency}}";
var CHECK_USER_COVERAGE_AREA_SUPPORT$1 = 'polygon/{{StoreId}}/{{language}}/coverageArea/isSupported?displayCurr={{Currency}}';
var GET_USER_DELIVERY_AREAS$1 = 'stores/{{StoreId}}/{{language}}/deliveryAreas?areaCode={{areaCode}}&displayCurr={{Currency}}';
var USER_ADDRESSES_API$1 = 'addresses/{{StoreId}}/{{language}}';
var GET_RELEVANCE_PRODUCTS_KEYWORD$1 = BASE_RELEVANCE_PRODUCT$1 + "/keyword?keyword={{keyword}}&lang={{lang}}&placements={{placements}}&displayCurr={{Currency}}&areaCode={{areaCode}}&needOOSProducts={{needOOSProducts}}";
var GET_RELEVANCE_PRODUCTS_FOR_OOS_ITEM$1 = APIGEE_ENDPOINT$1 + "/v1/relevance/{{storeId}}/{{lang}}/products/{{id}}?placements={{placements}}&appId={{appId}}&lang={{lang}}&latitude={{latitude}}&longitude={{longitude}}&needOOSProducts=false";
// Home page rr A/B testing
var GET_RELEVANCE_PRODUCTS_KEYWORD_HOME$1 = CLOUDFLARE_API$1 + "/v1/relevance/mafuae/en/keyword?keyword={{keyword}}&lang={{lang}}&placements={{placements}}&areaCode={{areaCode}}";
var GET_RELEVANCE_PRODUCTS_ID$1 = BASE_RELEVANCE_PRODUCT$1 + "/products/{{id}}?lang={{lang}}&placements={{placements}}&displayCurr={{Currency}}&areaCode={{areaCode}}";
var GET_PRODUCTS_BY_IDS_WITH_OFFSET$1 = BASE_PRODUCT_V2$1 + "?ids=[{{ids}}]&lang={{lang}}&areaCode={{areaCode}}&nextOffset={{nextPageOffset}}&displayCurr={{Currency}}";
var GET_MENU_NAVIGATION$1 = BASE_URI$1 + "/menu?areaCode={{areaCode}}&lang={{lang}}&displayCurr={{Currency}}";
var GET_TRENDING_SEARCH = 'trendingsearch/{{StoreId}}/{{language}}?displayCurr={{Currency}}';
var GET_DELIVERY_AREAS$1 = 'stores/{{StoreId}}/{{language}}/delivery-areas?displayCurr={{Currency}}';
var SET_DELIVERY_AREA$1 = CLOUDFLARE_API$1 + "/api/v1/session/area/{{areaCode}}?lang={{lang}}&displayCurr={{Currency}}";
var NEW_CART_API_BASE$1 = 'carts/{{StoreId}}/{{language}}/STANDARD';
var GET_CART_V3$1 = NEW_CART_API_BASE$1 + "/getCart?areaCode={{areaCode}}&nsp={{nsp}}";
var NEW_REMOVE_FROM_CART$1 = NEW_CART_API_BASE$1 + "/deleteItem?isCartRequired={{isCartRequired}}&areaCode={{areaCode}}&stopCartResponse=true&displayCurr={{Currency}}&nsp={{nsp}}";
var ADD_TO_CART_V3$1 = NEW_CART_API_BASE$1 + "/addItem?isCartRequired={{isCartRequired}}&areaCode={{areaCode}}&lm={{lm}}";
var UPDATE_CART_V3$1 = NEW_CART_API_BASE$1 + "/updateItem?isCartRequired={{isCartRequired}}&areaCode={{areaCode}}&lm={{lm}}";
var GET_CURRENCIES = APIGEE_ENDPOINT$1 + "/v2/stores/{{StoreId}}/{{language}}/currencies";
var OTP_API_BASE$1 = "/customers/otp";
var SEND_OTP_API$1 = "" + OTP_API_BASE$1;
var SEND_PHONE_CALL_OTP_API$1 = OTP_API_BASE$1 + "/voice-call";
var VERIFY_SMS_API = APIGEE_ENDPOINT$1 + "/v1/loyalty/{{StoreId}}/{{language}}/cards/verify-sms?cardExist=true";
var OTP_VERIFICATION_API$1 = APIGEE_ENDPOINT$1 + "/v3" + OTP_API_BASE$1 + "/verification";
var GET_TOP_CATEGORIES = APIGEE_ENDPOINT$1 + "/v2/categories/{{storeId}}/{{language}}?areacode={{areaCode}}&parentCategory={{parentCategory}}";
var GET_PRODUCTS_BY_IDS_V4$1 = BASE_PRODUCT_V4$1 + "?ids=[{{ids}}]&lang={{lang}}&areaCode={{areaCode}}&displayCurr={{Currency}}";
var GET_PRODUCTS_BY_FILTERS_V4$1 = BASE_URI_V5$1 + "/products";
var GET_NAVBAR_DELIVERY$1 = (APIGEE_ENDPOINT$1 ? APIGEE_ENDPOINT$1 : REACT_APP_APIGEE_ENDPOINT$1) + "/v2/stores/{{storeId}}/{{language}}/deliveryTime?areacode={{areaCode}}";
var GET_NAVBAR_DELIVERY_NEW$1 = (HOME_BFF_BASE_URL$1 ? HOME_BFF_BASE_URL$1 : REACT_APP_APIGEE_ENDPOINT$1) + "/v1/home/deliveryInfo";
var GET_HEADER$1 = APIGEE_ENDPOINT$1 + "/v1/frame/stores/{{storeId}}/headers";
var GET_COACHMARK_DETAILS$1 = APIGEE_ENDPOINT$1 + "/v1/frame/coach-marks/{{coachMarksUid}}";
var GET_HEADER_CLIENT = APIGEE_ENDPOINT$1 + "/v1/frame/stores/{{StoreId}}/headers";
var GET_FOOTER_CLIENT = APIGEE_ENDPOINT$1 + "/v1/frame/stores/{{StoreId}}/footers?lang={{language}}&areacode={{areaCode}}&displayCurr={{Currency}}";
var GOOGLE_MAP_API_URL$1 = 'https://maps.googleapis.com/maps/api/geocode/json?key=' + process.env.REACT_APP_GOOGLE_MAP_API_KEY;
var GET_ADDRESS_CITIES_ZONE_AREAS$1 = "content/address/areas?country={{code}}";
var GET_COUNTRIES_API$1 = "unmannedstore/countryphonecodes";
// REFRESH TOKEN API
var REFRESH_TOKEN_API_URL$1 = "oauth/token?grantType=refresh_token";
var VERIFY_ADDRESS_PHONE$1 = "users/{{StoreId}}/{{language}}/checkPhoneNumber";
var USER_PROFILE_API$1 = "users/{{StoreId}}/{{language}}";
var CHECK_PHONE_EXISTS$1 = "/customers/check";
var GET_WHATSAPP_OTP_API_URL$1 = '/customers/otp/whatsapp';
var UPDATE_USER_CONTACT$1 = APIGEE_ENDPOINT$1 + "/v1/users/{{StoreId}}/{{language}}/contacts";
var GET_PLASTIC_BAG_CONSENT = "/v2/customers/preferences?fields=username&fields=singleUseBagOpted";
var SET_PLASTIC_BAG_CONSENT = "/v2/customers/preferences";
var FETCH_GROWTHBOOK$1 = APIGEE_ENDPOINT$1 + "/abtest/api/features/" + process.env.REACT_APP_GROWTHBOOK_API_KEY;
var CREATE_SHARE_ACCOUNT$1 = "/customers/loyalty-membership";
var CREATE_MYCLUB_ACCOUNT$1 = "/loyalty/{{storeId}}/{{lang}}/cards?cardExist=false";
var GET_PAGE_STRUCTURE$1 = APIGEE_ENDPOINT$1 + "/v1/frame/page-structures/main-page";
var GET_PAGE_STRUCTURE_V2$1 = APIGEE_ENDPOINT$1 + "/v1/frame/v2/page-structures/{{pageStructureUid}}";
var TRACKING_ALGOLIA_URL$1 = BASE_URI_V2$1 + "/search/reporting/{{clickType}}?pageType={{pageType}}&products=[{{products}}]&lang={{lang}}";
var ADD_TO_CART_TRACKING$1 = "/adtech/rmp/track-event/add-to-cart";
var GET_BANNER_FOR_SNP = "/adtech/rmp/banners/searchTab";
var USER_GET_LOYALTY_SUMMARY_API = "/loyalty/{{StoreId}}/{{lang}}/summary";
var GET_COUNTRY_DETAILS_API$1 = APIGEE_ENDPOINT$1 + "/v1/frame/stores/country-details";
var UPDATE_CART_RELEVANCE$1 = BASE_RELEVANCE_PRODUCT$1 + "/cart/update?placements=cart_page";

var EAppConfigTypes$2;
(function (EAppConfigTypes) {
    EAppConfigTypes["INIT"] = "APP_CONFIG/INIT";
    EAppConfigTypes["SUCCESS"] = "APP_CONFIG/SUCCESS";
    EAppConfigTypes["SET_AREA_CODE"] = "APP_CONFIG/SET_AREA_CODE";
    EAppConfigTypes["SET_LANGUAGE_CODE"] = "APP_CONFIG/SET_LANGUAGE_CODE";
    EAppConfigTypes["REFRESH_TOKEN"] = "APP_CONFIG/REFRESH_TOKEN";
    EAppConfigTypes["REFRESH_TOKEN_SUCCESS"] = "APP_CONFIG/REFRESH_TOKEN_SUCCESS";
    EAppConfigTypes["GTM_INITIALIZED"] = "APP_CONFIG/GTM_INITIALISED";
    EAppConfigTypes["BRAZE_INITIALIZED"] = "APP_CONFIG/BRAZE_INITIALIZED";
    EAppConfigTypes["GROWTHBOOK_INITIALIZED"] = "APP_CONFIG/GROWTHBOOK_INITIALIZED";
    EAppConfigTypes["SET_PAGE_INTENT"] = "APP_CONFIG/SET_PAGE_INTENT";
    EAppConfigTypes["SET_PAGE_NAME"] = "SET_PAGE_NAME";
    EAppConfigTypes["FLAGSHIP_INITIALIZED"] = "APP_CONFIG/FLAGSHIP_INITIALIZED";
    EAppConfigTypes["SET_SELECTED_TAB"] = "SET_SELECTED_TAB";
})(EAppConfigTypes$2 || (EAppConfigTypes$2 = {}));
var EAppConfigTypes$3 = EAppConfigTypes$2;

var qat$1 = {
    // add any qatar specific strings here or to override base strings
    en: {
        qatar: 'Qatar',
        loyaltyPoints: 'MyCLUB Pts.',
        language: 'العربية',
        languageToggle: 'English',
        smartBannerText: {
            buttonText: 'OPEN',
            discountValue: '40%',
            discountTitle: 'OFF your first order',
            subtitle1: 'Use code: ',
            subtitle2: ', On orders above 75 QAR.',
            subtitle3: ' Max disc',
            code: 'HEY40',
            discCode: ' 30 QAR',
        },
    },
    ar: {
        qatar: 'نعم',
        loyaltyPoints: 'MyCLUB Pts.',
        language: 'English',
        languageToggle: 'العربية',
        smartBannerText: {
            buttonText: 'افتح',
            discountValue: 'وفــّر 40%',
            discountTitle: 'على طلبك الأول',
            subtitle1: 'استخدم الرمز: ',
            subtitle2: ' للطلبات التي تزيد عن 75 ريال.',
            subtitle3: ' الحد الأقصى للتوفير',
            code: 'HEY40',
            discCode: ' 30 ريال',
        },
    },
};

var uae$1 = {
    // add any qatar specific strings here or to override base strings
    en: {
        loyalty: 'SHARE',
        points: '$t(loyalty) Points',
        loyaltyPoints: '$t(loyalty) pts.',
        smartBannerText: {
            buttonText: 'OPEN',
            discountValue: '40% OFF',
            discountTitle: 'your first order',
            subtitle1: 'Use code: ',
            subtitle2: ', on orders above 75 AED. Max disc 30 AED',
            code: 'HEY40',
        },
        language: 'العربية',
        languageToggle: 'English',
    },
    ar: {
        loyalty: 'SHARE',
        points: 'نقاط شير',
        loyaltyPoints: '$t(loyalty) pts.',
        smartBannerText: {
            buttonText: 'افتح',
            discountValue: ' ',
            discountTitle: 'خصم 40٪ على طلبك الأول',
            subtitle1: 'أستخدم الرمز:',
            subtitle2: 'على الطلبات التي تزيد عن 75 درهماً. الحد الأقصى للخصم 30 درهم',
            code: ' HEY40 ',
        },
        language: 'English',
        languageToggle: 'العربية',
    },
};

var lbn$1 = {
    // add any qatar specific strings here or to override base strings
    en: {
        loyalty: 'Cashback',
        points: '$t(loyalty)',
        loyaltyPoints: '$t(loyalty)',
        language: 'العربية',
        languageToggle: 'English',
    },
    ar: {
        points: 'كاشباك',
        loyalty: '$t(loyalty)',
        loyaltyPoints: '$t(loyalty)',
        language: 'English',
        languageToggle: 'العربية',
    },
};

var egy$1 = {
    // add any egypt specific strings here or to override base strings
    en: {
        loyaltyPoints: 'MyCLUB Pts.',
        language: 'العربية',
        languageToggle: 'English',
    },
    ar: {
        loyaltyPoints: 'MyCLUB Pts.',
        language: 'English',
        languageToggle: 'العربية',
        buyAgain: 'اشتري_مره أخري',
        Quick: 'سريعا',
        expressDeliveryTitle: 'منتجات تصلك في ساعة',
        expressDeliverySubTitle: 'اشتري',
        footer: {
            extendedWarrantyRetail: 'الضمان الممتد',
        },
    },
};

var jor$1 = {
    // add any jordan specific strings here or to override base strings
    en: {
        loyaltyPoints: 'MyCLUB Pts.',
        language: 'العربية',
        languageToggle: 'English',
    },
    ar: {
        loyaltyPoints: 'MyCLUB Pts.',
        language: 'English',
        languageToggle: 'العربية',
        expressDeliveryTitle: 'منتجات للتوصيل',
        expressDeliverySubTitle: 'خلال 60 دقيقة',
    },
};

var sau$1 = {
    // add any saudi arabia specific strings here or to override base strings
    en: {
        loyaltyPoints: 'MyCLUB Pts.',
        smartBannerText: {
            buttonText: 'OPEN',
            discountValue: '30%',
            discountTitle: 'OFF your first order',
            subtitle1: 'USE code: ',
            subtitle2: ', on orders above 50 SAR',
            subtitle3: ' Max disc',
            code: 'NEW30',
            discCode: ' 30 SAR',
        },
        language: 'العربية',
        languageToggle: 'English',
        authenticationCode: 'Authentication code 0000123973',
    },
    ar: {
        loyaltyPoints: 'MyCLUB Pts.',
        smartBannerText: {
            buttonText: 'افتح',
            discountValue: 'وفــّر 30%',
            discountTitle: 'على طلبك الأول',
            subtitle1: 'أستخدم الرمز: ',
            subtitle2: ' للطلبات التي تزيد عن 50 ريال',
            subtitle3: ' الحد الأعلى للتوفير',
            code: 'NEW30',
            discCode: ' 30 ريال',
        },
        language: 'English',
        languageToggle: 'العربية',
        authenticationCode: 'رمز التحقق: 0000123973',
    },
};

var geo$1 = {
    // add any Georgia specific strings here or to override base strings
    en: {
        language: 'ინგლისური',
        languageToggle: 'English',
    },
    ka: {
        language: 'English',
        languageToggle: 'ინგლისური',
    },
};

var kwt$1 = {
    // add any kuwait specific strings here or to override base strings
    en: {
        language: 'العربية',
        languageToggle: 'English',
    },
    ar: {
        language: 'English',
        languageToggle: 'العربية',
    },
};

var uzb$1 = {
    // add any Georgia specific strings here or to override base strings
    en: {
        language: "o'zbekcha",
        languageToggle: 'English',
    },
    uz: {
        language: 'English',
        languageToggle: "o'zbekcha",
    },
    ru: {
        language: 'English',
        languageToggle: 'русский',
    },
};

var countries$2 = {
    qat: qat$1,
    uae: uae$1,
    lbn: lbn$1,
    egy: egy$1,
    jor: jor$1,
    sau: sau$1,
    geo: geo$1,
    kwt: kwt$1,
    uzb: uzb$1,
};
var getCountryConfig = function (country, locale) {
    if (locale === void 0) { locale = ''; }
    if (countries$2[country]) {
        return countries$2[country][locale];
    }
    return {};
};

/**
 * @description Method to perform a deep merge of objects
 * @param {Array<Object>} sources - The source(s) that will be used to update the @target object
 * @return {Object} The final merged object
 */
var deepMerge = function () {
    var arg = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arg[_i] = arguments[_i];
    }
    var target = {};
    var merge = function (obj) {
        for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                if (Object.prototype.toString.call(obj[key]) === '[object Object]') {
                    target[key] = deepMerge(target[key], obj[key]);
                }
                else if (Array.isArray(target[key]) && Array.isArray(obj[key])) {
                    // concatenate the two arrays and remove any duplicate primitive values
                    target[key] = Array.from(new Set(target[key].concat(obj[key])));
                }
                else {
                    target[key] = obj[key];
                }
            }
        }
    };
    for (var i = 0; i < arg.length; i++) {
        merge(arg[i]);
    }
    return target;
};

var _a$4;
var commonLanguages$1 = ['en', 'ar'];
/**
 * WHY TO LOAD ALL THE RESOURCES WHEN THE SYSTEM,
 * ONLY REQUIRES TWO TO OPERATE AT A TIME,
 * So, let add a resource based on *country check.
 * */
var SUPPORTED_LANGUAGES$1 = (_a$4 = {},
    _a$4[EStoreID$1.MAFUAE] = commonLanguages$1,
    _a$4[EStoreID$1.MAFBHR] = commonLanguages$1,
    _a$4[EStoreID$1.MAFEGY] = commonLanguages$1,
    _a$4[EStoreID$1.MAFJOR] = commonLanguages$1,
    _a$4[EStoreID$1.MAFGEO] = ['en', 'ka'],
    _a$4[EStoreID$1.MAFPAK] = ['en'],
    _a$4[EStoreID$1.MAFKWT] = commonLanguages$1,
    _a$4[EStoreID$1.MAFOMN] = commonLanguages$1,
    _a$4[EStoreID$1.MAFLBN] = ['en'],
    _a$4[EStoreID$1.MAFKEN] = ['en'],
    _a$4[EStoreID$1.MAFQAT] = commonLanguages$1,
    _a$4[EStoreID$1.MAFSAU] = commonLanguages$1,
    _a$4[EStoreID$1.MAFUZB] = ['en', 'uz', 'ru'],
    _a$4[EStoreID$1.MAFARM] = ['en', 'hy'],
    _a$4[EStoreID$1.MAFUGA] = ['en'],
    _a$4[EStoreID$1.MAFIRQ] = commonLanguages$1,
    _a$4);
var getTranlations = function (storeId, lang) {
    var languageFile = require("./" + lang + ".json");
    return deepMerge(languageFile, getCountryConfig(storeId.substring(3), lang));
};
var loadResourcesBasedOnStore = function (storeId) {
    var translations = SUPPORTED_LANGUAGES$1[storeId].map(function (lang) {
        var _a;
        return _a = {},
            _a[lang] = {
                translation: getTranlations(storeId, lang),
            },
            _a;
    });
    return translations.reduce(function (acc, curr) { return (__assign(__assign({}, acc), curr)); }, {});
};
var getResources = function (storeId) {
    return loadResourcesBasedOnStore(storeId || APP_CONFIG$1.storeId);
};

var mergeLocale = function (toMerge, toMergeIn) {
    var finalLocale = __assign({}, toMergeIn);
    if (!!toMerge) {
        var localeToMerge = Object.keys(toMerge);
        localeToMerge.forEach(function (locale) {
            if (toMergeIn.hasOwnProperty(locale)) {
                finalLocale[locale] = {
                    translation: __assign(__assign({}, toMergeIn[locale].translation), toMerge[locale].translation),
                };
            }
            else {
                finalLocale[locale] = __assign({}, toMerge[locale]);
            }
        });
    }
    return finalLocale;
};

var EN$1 = 'en';
var AR$1 = 'ar';
var getBrowserLanguage$1 = function () {
    return APP_CONFIG$1.language;
};
var parseCountryLocale = function (data) {
    return __assign(__assign({}, JSON.parse(data)), getCountryConfig(APP_CONFIG$1.storeId.substring(3)));
};
var commonOption$1 = {
    lng: getBrowserLanguage$1(),
    fallbackLng: EN$1,
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
        escapeValue: false,
    },
    react: {
        wait: true,
    },
};
var backendOption = {
    backend: {
        loadPath: '/strings/{{lng}}.json',
        parse: parseCountryLocale,
        react: {
            useSuspense: true,
        },
    },
};
var withRemoteData = function (loadPath, callback) {
    var options = __assign(__assign({}, commonOption$1), { backend: __assign(__assign({}, backendOption.backend), { loadPath: loadPath }) });
    i18next
        .use(HTTPApi)
        .use(initReactI18next)
        .init(options)
        .then(function () {
        languageSettings$1(options.lng || EN$1);
        callback(i18next);
    });
};
var withLocalData = function (extraOption) {
    if (extraOption === void 0) { extraOption = {}; }
    var extraResources = extraOption.resources, otherOptions = __rest(extraOption, ["resources"]);
    var mergedLocale = mergeLocale(extraResources, getResources());
    var options = __assign(__assign(__assign({}, commonOption$1), otherOptions), { resources: mergedLocale });
    i18next
        .use(initReactI18next)
        .init(options)
        .then(function () {
        languageSettings$1(options.lng || EN$1);
    });
    return i18next;
};
var i18NextInitialised = false;
var initLocalisation = function (extraOption) {
    var extraResources = extraOption.resources, otherOptions = __rest(extraOption, ["resources"]);
    var mergedLocale = mergeLocale(extraResources, getResources());
    var options = __assign(__assign(__assign({}, commonOption$1), otherOptions), { resources: mergedLocale });
    i18next.use(initReactI18next).init(options);
    i18NextInitialised = true;
};
var withSsrLocaleData = function (App, extraOption) {
    if (extraOption === void 0) { extraOption = {}; }
    if (!i18NextInitialised) {
        initLocalisation(extraOption);
    }
    setLanguage$1(extraOption.lng || 'en');
    return withSSR()(App);
};
var isRTL$1 = function () { return i18next.language === 'ar'; };
var languageSettings$1 = function (lang) {
    if (isBrowser$1()) {
        window.document.dir = lang === AR$1 ? 'rtl' : 'ltr';
        localStorage.setItem('language', lang);
    }
};
var setLanguage$1 = function (lang) {
    i18next.changeLanguage(lang);
    languageSettings$1(lang);
};
var isLocaleStrEqual$1 = function (first, second) {
    var collator = new Intl.Collator(i18next.language);
    var order = collator.compare(first, second);
    // console.log(order, first, second);
    /**
     * If the strings are equal, the function returns 0.
     * If they are not equal the function returns either 1 or -1,
     * which also indicates the alphabetical order of the strings.
     */
    if (!order) {
        return true;
    }
    else {
        return false;
    }
};

var initApp$1 = function (payload) {
    if (payload === void 0) { payload = {}; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var latitude, longitude, areaCode;
        return __generator(this, function (_a) {
            latitude = payload.latitude, longitude = payload.longitude, areaCode = payload.areaCode;
            dispatch(init$1({ selectNewLocation: false }));
            if (isBrowser$1()) {
                setSelectedLat$1(latitude);
                setSelectedLng$1(longitude);
                setDeliveryArea$1(encodeStr$1(areaCode));
                setCustomCookie$1(constants$1.prevAreaCode, encodeStr$1(areaCode));
            }
            // As with Location CX feature the cookies needs to be in place.
            dispatch(init$1({ latitude: latitude, longitude: longitude, areaCode: areaCode }));
            if (isBrowser$1()) {
                // temp fix for mweb for your convenice now button refactor later on
                if (window.innerWidth < 767) {
                    window.location.reload();
                }
                // Setting state for address change, So that Cart page can listen to this state and call Fetch Cart.
                dispatch(userSetAddressChange$1(true));
            }
            return [2 /*return*/];
        });
    }); };
};
var init$1 = function (payload) {
    if (payload === void 0) { payload = {}; }
    APP_CONFIG$1.__inialize__(payload);
    return {
        type: EAppConfigTypes$3.SUCCESS,
        payload: payload,
    };
};
var setAreaCode$1 = function (areaCode) {
    APP_CONFIG$1.current = __assign(__assign({}, APP_CONFIG$1), { areaCode: areaCode });
    return {
        type: EAppConfigTypes$3.SET_AREA_CODE,
        payload: areaCode,
    };
};
var setLanguageCode$1 = function (language) {
    APP_CONFIG$1.__defaults__.language = language;
    APP_CONFIG$1.current = __assign(__assign({}, APP_CONFIG$1), { language: language });
    setLanguage$1(language);
    return {
        type: EAppConfigTypes$3.SET_LANGUAGE_CODE,
        payload: language,
    };
};
var setCurrency$1 = function (currency) {
    APP_CONFIG$1.current = __assign(__assign({}, APP_CONFIG$1), { currency: currency });
    return {
        type: EAppConfigTypes$3.SUCCESS,
        payload: { currency: currency },
    };
};
var setGTMInitialized = function (isInitialized) {
    if (isInitialized === void 0) { isInitialized = false; }
    return {
        type: EAppConfigTypes$3.GTM_INITIALIZED,
        payload: isInitialized,
    };
};
var setBrazeInitialized = function (isInitialized) {
    if (isInitialized === void 0) { isInitialized = false; }
    return {
        type: EAppConfigTypes$3.BRAZE_INITIALIZED,
        payload: isInitialized,
    };
};
var setGrowthBook = function (payload) {
    return {
        type: EAppConfigTypes$3.GROWTHBOOK_INITIALIZED,
        payload: payload,
    };
};
var setFlagShip = function (payload) {
    return {
        type: EAppConfigTypes$3.FLAGSHIP_INITIALIZED,
        payload: payload,
    };
};
var setPageIntent = function (payload) {
    return {
        type: EAppConfigTypes$3.SET_PAGE_INTENT,
        payload: payload,
    };
};
var setPageName = function (payload) {
    return {
        type: EAppConfigTypes$3.SET_PAGE_NAME,
        payload: payload,
    };
};
var setSelectedTabId = function (payload) {
    return {
        type: EAppConfigTypes$3.SET_SELECTED_TAB,
        payload: payload,
    };
};

/**
 * @name: setLoyaltyId
 * @param responseData
 * @description: It will set loyalty_id key in local storage. Getting data from loyalty-info api
 */
var setLoyaltyId = function (responseData) {
    var _a;
    var data = responseData.data;
    var storage = initStorageManager$1(function () { return localStorage; });
    storage.setItem('loyalty_id', ((_a = data === null || data === void 0 ? void 0 : data.points) === null || _a === void 0 ? void 0 : _a.card_number) || '');
    return {
        type: UserTypes$3.USER_GET_LOYALTY_DATA_SUCCESS,
        payload: responseData,
    };
};
var getUserLoyaltyData = function (jwtToken) {
    return {
        type: UserTypes$3.USER_GET_LOYALTY_DATA,
        payload: {
            method: EApiMiddlewareMethod$3.GET,
            url: jwtToken ? GET_USER_LOYALTY_API : GET_USER_LOYALTY_HISTORY_API,
            onSuccess: setLoyaltyId,
        },
    };
};
var userSetAddressesSuccess$1 = function (_a) {
    var addresses = _a.addresses, defaultAreaCode = _a.defaultAreaCode;
    return ({
        type: USER_FETCH_ADDRESSES_SUCCESS$1,
        payload: { addresses: addresses, defaultAreaCode: defaultAreaCode },
    });
};
var setUserDataUpdateSuccess = function (params) { return ({
    type: UserTypes$3.USER_PROFILE_PHONE_UPDATE,
    payload: params,
}); };
var userSetAddressesError$1 = function (isError) { return ({
    type: UserTypes$3.USER_SET_ADDRESSES_ERROR,
    payload: isError,
}); };
var userSetAddressesLoading$1 = function (state) { return ({
    type: UserTypes$3.USER_SET_ADDRESSES_LOADING,
    payload: state,
}); };
var userSetSelectedAddress$1 = function (address) { return ({
    type: UserTypes$3.USER_SET_SELECTED_ADDRESSES,
    payload: address,
}); };
var userSetAddressChange$1 = function (payload) { return ({
    type: UserTypes$3.USER_SET_ADDRESS_CHANGE,
    payload: payload,
}); };
var setCountryConfig = function (payload) { return ({ type: USER_COUNTRY_CONFIG_SUCCESS$1, payload: payload }); };
var showNewAddressJourney$1 = function (addressNewJourney) {
    var showOldAddressJourney = shouldAlwaysShowOlderAddressJourney$1();
    return showOldAddressJourney ? false : addressNewJourney;
};
var fetchUserAddresses$1 = function () { return function (dispatch, getState) {
    var _a;
    dispatch(userSetAddressesLoading$1(true));
    dispatch(userSetAddressesError$1(false));
    var _b = getState().appConfig.defaultAreaCode, defaultAreaCode = _b === void 0 ? '' : _b;
    var addressNewJourney = (_a = getGrowthBookFeatureValueViaInstance$1(getState(), GROWTHBOOK_FLAGS$1.address_new_journey)) === null || _a === void 0 ? void 0 : _a.on;
    var showUnverfiiedAddresses = showNewAddressJourney$1(addressNewJourney);
    var url = USER_ADDRESSES_API$1 + '?displayCurr={{Currency}}' + '&includeUnverifiedAddresses=' + showUnverfiiedAddresses;
    dispatch({
        type: UserTypes$3.USER_FETCH_ADDRESSES,
        payload: {
            method: EApiMiddlewareMethod$3.GET,
            url: url,
            onSuccess: function (_a) {
                var addresses = _a.addresses;
                dispatch(userSetAddressesSuccess$1({ addresses: addresses, defaultAreaCode: defaultAreaCode }));
            },
            onFailure: function () {
                dispatch(userSetAddressesError$1(true));
            },
            onFinally: function () {
                dispatch(userSetAddressesLoading$1(false));
            },
        },
    });
}; };
var fetchUserCountryConfig$1 = function () { return function (dispatch) {
    dispatch({
        type: UserTypes$3.USER_COUNTRY_CONFIG,
        payload: {
            method: EApiMiddlewareMethod$3.GET,
            url: GET_USER_COUNTRY_CONFIG$1,
            apiVersion: 1,
            excludeFromDefaultHeaders: ['token'],
        },
    });
}; };
var fetchUserDeliveryAreas$1 = function () { return function (dispatch) {
    dispatch({
        type: UserTypes$3.USER_GET_DELIVERY_AREAS,
        payload: {
            method: EApiMiddlewareMethod$3.GET,
            url: GET_USER_DELIVERY_AREAS$1,
        },
    });
}; };
var getBuilding$1 = function (building) {
    if (building != null) {
        var buildingValue = building === null || building === void 0 ? void 0 : building.replace('|', ':');
        var buildingList = buildingValue === null || buildingValue === void 0 ? void 0 : buildingValue.split(':');
        if (buildingList != null && buildingList.length >= 2) {
            return buildingList[0];
        }
        else {
            return building;
        }
    }
    else {
        return building;
    }
};
var getApartment$1 = function (apartment) {
    if (apartment != null) {
        var apartmentValue = apartment === null || apartment === void 0 ? void 0 : apartment.replace('|', ':');
        var apartmentList = apartmentValue.split(':');
        if (apartmentList != null && apartmentList.length >= 2) {
            return apartmentList[1].replace('Flat#', '');
        }
        else {
            return apartment;
        }
    }
    else {
        return apartment;
    }
};
// SET location CX related information
var setLocationCXDetail$1 = function (addressData) { return function (dispatch) {
    var _a = addressData || {}, latitude = _a.latitude, longitude = _a.longitude;
    var lat = Number(latitude);
    var long = Number(longitude);
    if (!isNaN(lat) && !isNaN(long)) {
        var _b = addressData || {}, addressLabel = _b.addressLabel, building = _b.building, appartment = _b.appartment;
        var address = [addressLabel, getBuilding$1(building), getApartment$1(appartment)].filter(function (ele) { return ele; }).join(' - ');
        dispatch(updateGeoArea$1(address || '', lat, long));
    }
}; };
// SET location CX related information
var updateGeoArea$1 = function (address, latitude, longitude) { return function (dispatch) {
    dispatch(initApp$1({ latitude: latitude, longitude: longitude, features: { isLocationCXEnable: true }, areaCode: address }));
}; };
var checkUserCoverageAreaSupport$1 = function (lat, lng) { return function (dispatch) {
    dispatch({
        type: UserTypes$3.USER_CHECK_AREA_SUPPORT,
        payload: {
            method: EApiMiddlewareMethod$3.GET,
            url: CHECK_USER_COVERAGE_AREA_SUPPORT$1 + "&latitude=" + lat + "&longitude=" + lng,
            apiVersion: 1,
        },
    });
}; };
var userAddNEditAddress$1 = function (address, editInfo, setIsSubmitBtnDisabled) { return function (dispatch) {
    var appartment = address.appartment, landmark = address.landmark, addressLabel = address.addressLabel, fullName = address.fullName, phone = address.phone, defaultAddress = address.defaultAddress, countryIso = address.countryIso, areaCode = address.areaCode, onSuccess = address.onSuccess, latitude = address.latitude, longitude = address.longitude, deliveryInstructions = address.deliveryInstructions, streetName = address.streetName, town = address.town, country = address.country, building = address.building, addressVerificationRefId = address.addressVerificationRefId, isSetSelectedAddress = address.isSetSelectedAddress, makani = address.makani, emirate = address.emirate, isQatarAddressFields = address.isQatarAddressFields, isUAEAddressFields = address.isUAEAddressFields;
    var params = {
        appartment: appartment,
        landmark: landmark || '',
        firstName: fullName,
        phone: phone,
        town: town || areaCode,
        'country.isocode': country || countryIso,
        streetName: streetName,
        emirate: emirate,
        defaultAddress: defaultAddress,
        shippingAddress: true,
        latitude: latitude,
        longitude: longitude,
        deliveryInstructions: deliveryInstructions,
        building: building,
    };
    if (editInfo) {
        params.ssoType = editInfo.ssoType;
    }
    if (addressLabel) {
        params.addressLabel = addressLabel;
    }
    if (addressVerificationRefId) {
        params.addressVerificationRefId = addressVerificationRefId;
    }
    if (isQatarAddressFields || isUAEAddressFields) {
        params.makani = makani;
    }
    dispatch({
        type: editInfo ? UserTypes$3.USER_UPDATE_ADDRESS : UserTypes$3.USER_ADD_ADDRESS,
        payload: {
            data: qs$1(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            },
            method: editInfo ? EApiMiddlewareMethod$3.PUT : EApiMiddlewareMethod$3.POST,
            onSuccess: function (apiResponse) {
                params.id = (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) || (apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.id);
                onSuccess && onSuccess(params);
                if (isSetSelectedAddress || defaultAddress) {
                    setSelectedAddressID$1(params.id);
                    setSelectedAddressIDCookie$1(params.id);
                    dispatch(userSetSelectedAddress$1(params));
                }
                if (defaultAddress) {
                    dispatch(setLocationCXDetail$1(params));
                }
                dispatch(fetchUserAddresses$1());
            },
            onFailure: function () {
                dispatch(userSetAddressesError$1(true));
                setIsSubmitBtnDisabled && setIsSubmitBtnDisabled(false);
            },
            url: editInfo
                ? USER_ADDRESSES_API$1 + ("/" + editInfo.id + "?displayCurr={{Currency}}")
                : USER_ADDRESSES_API$1 + '?displayCurr={{Currency}}',
        },
    });
}; };
var userAddNEditAddressWithArea$1 = function (address, editInfo) { return function (dispatch) {
    var appartment = address.appartment, landmark = address.landmark, addressLabel = address.addressLabel, fullName = address.fullName, phone = address.phone, defaultAddress = address.defaultAddress, onSuccess = address.onSuccess, streetName = address.streetName, area = address.area, city = address.city, addressVerificationRefId = address.addressVerificationRefId, deliveryInstructions = address.deliveryInstructions, emirate = address.emirate, building = address.building, zone = address.zone, isQatarAddressFields = address.isQatarAddressFields;
    var params = {
        firstName: fullName,
        lastName: '',
        phone: phone,
        town: area.code,
        'country.isocode': city.countryIso,
        'region.isocode': city.isocode,
        streetName: streetName,
        emirate: emirate,
        appartment: appartment,
        landmark: landmark || '',
        defaultAddress: defaultAddress,
        shippingAddress: true,
        deliveryInstructions: deliveryInstructions,
        building: building,
    };
    if (addressVerificationRefId) {
        params.addressVerificationRefId = addressVerificationRefId;
    }
    if (editInfo) {
        params.ssoType = editInfo.ssoType;
    }
    if (isQatarAddressFields) {
        params.makani = zone.zoneNo;
    }
    if (addressLabel) {
        params.addressLabel = addressLabel;
    }
    dispatch({
        type: editInfo ? UserTypes$3.USER_UPDATE_ADDRESS : UserTypes$3.USER_ADD_ADDRESS,
        payload: {
            data: qs$1(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            },
            method: editInfo ? EApiMiddlewareMethod$3.PUT : EApiMiddlewareMethod$3.POST,
            onSuccess: function (apiResponse) {
                params.id = (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) || (apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.id);
                onSuccess && onSuccess(params);
                // refer deepak tiwari for this check
                if (defaultAddress && apiResponse && apiResponse.id) {
                    setSelectedAddressID$1(apiResponse.id);
                    setSelectedAddressIDCookie$1(apiResponse.id);
                    dispatch(userSetSelectedAddress$1(apiResponse));
                }
                dispatch(fetchUserAddresses$1());
            },
            onFailure: function () {
                dispatch(userSetAddressesError$1(true));
            },
            url: editInfo
                ? USER_ADDRESSES_API$1 + ("/" + editInfo.id + "?displayCurr={{Currency}}")
                : USER_ADDRESSES_API$1 + '?displayCurr={{Currency}}',
        },
    });
}; };
var userAddressPhoneVerify$1 = function (phoneNumber, callback) { return function (dispatch) {
    dispatch({
        type: UserTypes$3.USER_ADDRESS_PHONE_VERIFIED,
        payload: {
            data: { phoneNumber: phoneNumber },
            method: EApiMiddlewareMethod$3.POST,
            headers: {
                'Content-Type': 'application/json',
            },
            onSuccess: function (apiResponse) {
                callback && callback(apiResponse);
            },
            onFailure: function () {
                callback && callback(false);
            },
            url: VERIFY_ADDRESS_PHONE$1,
            apiVersion: 1,
        },
    });
}; };
var getUserProfileData = function () {
    return {
        type: UserTypes$3.USER_PROFILE_DATA,
        payload: {
            method: EApiMiddlewareMethod$3.GET,
            url: USER_PROFILE_API$1,
            apiVersion: 1,
        },
    };
};
var userProfileUpdate$1 = function (profile, handleResponse) { return function (dispatch) {
    dispatch({
        type: UserTypes$3.USER_UPDATE_PROFILE,
        payload: {
            data: profile,
            method: EApiMiddlewareMethod$3.PUT,
            apiVersion: 1,
            headers: {
                'Content-Type': 'application/json',
            },
            onSuccess: function (apiResponse) {
                handleResponse && handleResponse(apiResponse);
            },
            onFailure: function (_errMessage, _a) {
                var data = (_a === void 0 ? {} : _a).response.data;
                return handleResponse && handleResponse(data);
            },
            url: USER_PROFILE_API$1,
        },
    });
}; };
var verifyUserPhoneNumber$1 = function (phoneNumber, handleResponse) { return function (dispatch) {
    dispatch({
        type: UserTypes$3.USER_GET_PHONE_EXIST_SUCCESS,
        payload: {
            method: EApiMiddlewareMethod$3.GET,
            onSuccess: function (apiResponse) {
                handleResponse(apiResponse);
            },
            onFailure: function (_errMessage, _a) {
                var data = (_a === void 0 ? {} : _a).response.data;
                return handleResponse(data);
            },
            url: CHECK_PHONE_EXISTS$1 + "?phone=" + phoneNumber,
        },
    });
}; };
var updateUserContact$1 = function (number, handleResponse) { return function (dispatch) {
    dispatch({
        type: UserTypes$3.UPDATE_USER_CONTACT,
        payload: {
            apiVersion: 1,
            data: { number: number },
            method: EApiMiddlewareMethod$3.PATCH,
            onSuccess: function (apiResponse) {
                handleResponse(apiResponse);
            },
            onFailure: function (_errMessage, _a) {
                var data = _a.response.data;
                return handleResponse(data);
            },
            url: UPDATE_USER_CONTACT$1,
        },
    });
}; };
var createLoyaltyAccount$1 = function (data, type) { return function (dispatch) {
    dispatch({
        type: UserTypes$3.USER_CREATE_LOYALTY_ACCOUNT,
        payload: {
            data: data,
            method: EApiMiddlewareMethod$3.POST,
            apiVersion: type === 'share' ? 2 : 1,
            headers: {
                'Content-Type': 'application/json',
            },
            url: type === 'share' ? CREATE_SHARE_ACCOUNT$1 : CREATE_MYCLUB_ACCOUNT$1,
        },
    });
}; };
var refreshToken$1 = function (onSuccess) { return function (dispatch) {
    dispatch({
        type: EAppConfigTypes$3.REFRESH_TOKEN,
        payload: {
            data: {
                refreshToken: getRefreshTokenFromCookie$1(),
                loginType: 'normal',
            },
            method: EApiMiddlewareMethod$3.POST,
            url: REFRESH_TOKEN_API_URL$1,
            onSuccess: function (apiResponse) {
                onSuccess && onSuccess(apiResponse);
            },
        },
    });
}; };
var getUserLoyaltySummary = function () {
    return {
        type: UserTypes$3.USER_GET_LOYALTY_SUMMARY,
        payload: {
            method: EApiMiddlewareMethod$3.GET,
            url: USER_GET_LOYALTY_SUMMARY_API,
            apiVersion: 1,
        },
    };
};

// cookie-related utility helpers
var cookies$2 = new Cookies();
var DeliveryHeaders$1;
(function (DeliveryHeaders) {
    DeliveryHeaders["POS_INFO"] = "posInfo";
})(DeliveryHeaders$1 || (DeliveryHeaders$1 = {}));
var setAppVersion$1 = function (version) {
    if (version === void 0) { version = 'v1'; }
    return cookies$2.set('app_version', version, { path: '/' });
};
var getAppVersion$1 = function () {
    return cookies$2.get('app_version');
};
// getters
var getUserTokenFromCookie$1 = function () {
    return cookies$2.get(constants$1.userToken) || cookies$2.get(constants$1.hybrisToken);
};
var getUserEmailFromCookie$1 = function () {
    var emailID = cookies$2.get(constants$1.userId);
    if (emailID && emailID.length > 0) {
        return emailID.toLowerCase();
    }
    return emailID;
};
var getGUID$1 = function () {
    return cookies$2.get(APP_CONFIG$1.storeId + "-cart");
};
var setGUID$1 = function (guid) {
    return cookies$2.set(APP_CONFIG$1.storeId + "-cart", guid, {
        path: '/',
        maxAge: 360000000,
        secure: true,
    });
};
var getRefreshTokenFromCookie$1 = function () {
    return cookies$2.get(constants$1.refreshToken);
};
var removeGUIDFromCookie$1 = function () {
    cookies$2.remove(APP_CONFIG$1.storeId + "-cart");
};
var getGuestSessionToken$1 = function () {
    return cookies$2.get(constants$1.guestSessionToken);
};
var setSearchTypeCookie$1 = function (searchType) {
    cookies$2.set('search_type', searchType, { path: '/' });
};
var setSelectedAddressID$1 = function (addressID) {
    isBrowser$1() && localStorage.setItem(constants$1.selectedAddressID, addressID);
};
var getSelectedAddressID$1 = function () {
    return isBrowser$1() && localStorage.getItem(constants$1.selectedAddressID);
};
var setSelectedAddressIDCookie$1 = function (addressID) {
    return cookies$2.set(constants$1.selectedAddressID, addressID, { path: '/' });
};
var getSelectedAddressIDCookie$1 = function () {
    return cookies$2.get(constants$1.selectedAddressID);
};
var setRefreshTokenCallTime$1 = function () {
    isBrowser$1() && localStorage.setItem(constants$1.refreshTokenCallTimeStamp, Date.now().toString());
};
var getRefreshTokenCallTime$1 = function () {
    return isBrowser$1() && localStorage.getItem(constants$1.refreshTokenCallTimeStamp);
};
var getSearchTypeCookie$1 = function () {
    return cookies$2.get('search_type');
};
var setPageType$1 = function (pageType) {
    return cookies$2.set('page_type', pageType, { path: '/' });
};
var getPageType$1 = function () {
    return cookies$2.get('page_type');
};
var setCategoryName$1 = function (category) {
    return cookies$2.set(constants$1.categoryName, category, { path: '/' });
};
var getCategoryName$1 = function () {
    return cookies$2.get(constants$1.categoryName);
};
// setters
var setGuestSessionToken$1 = function (token, expiresIn) {
    return cookies$2.set(constants$1.guestSessionToken, token, { maxAge: expiresIn, path: '/' });
};
// for creating dummy cookie for test
var setUserTokenFromCookie$1 = function (token) {
    return cookies$2.set(constants$1.userToken, token, { path: '/' });
};
var removeCookie$1 = function (cookieName) {
    cookies$2.remove(cookieName);
};
var setRRSessionId$1 = function (value, expiry) {
    setCustomCookie$1(constants$1.rrSessionId, value, expiry);
};
var setRRUserId$1 = function (value, expiry) {
    setCustomCookie$1(constants$1.rrUserId, value, expiry);
};
var setDeliveryArea$1 = function (value, expiry) {
    var getAddressText = value.split('-');
    var deliveryArea = getAddressText[0] + "-" + getBuilding$1(getAddressText[1]) + " - " + getApartment$1(getAddressText[2]);
    setCustomCookie$1(APP_CONFIG$1.storeId + "-" + constants$1.deliveryArea, deliveryArea, expiry);
};
var getRRSessionId$1 = function () {
    return cookies$2.get(constants$1.rrSessionId);
};
var getRRUserId$1 = function () {
    return cookies$2.get(constants$1.rrUserId);
};
var getDeliveryArea$1 = function () {
    return cookies$2.get(APP_CONFIG$1.storeId + "-" + constants$1.deliveryArea);
};
var setSelectedLat$1 = function (seletedLat, expiresIn) {
    if (expiresIn === void 0) { expiresIn = 2630000; }
    return cookies$2.set(constants$1.selectedLat, seletedLat, { maxAge: expiresIn, path: '/' });
};
var setSelectedLng$1 = function (seletedLng, expiresIn) {
    if (expiresIn === void 0) { expiresIn = 2630000; }
    return cookies$2.set(constants$1.selectedLng, seletedLng, { maxAge: expiresIn, path: '/' });
};
var getSelectedLat$1 = function () {
    return cookies$2.get(constants$1.selectedLat);
};
var getSelectedLng$1 = function () {
    return cookies$2.get(constants$1.selectedLng);
};
var setPackageFreeDelivery$1 = function (data, expiresIn) {
    if (expiresIn === void 0) { expiresIn = 2630000; }
    return cookies$2.set(constants$1.packageFreeDelivery, data, { maxAge: expiresIn, path: '/' });
};
var getPackageFreeDelivery$1 = function () {
    return cookies$2.get(constants$1.packageFreeDelivery);
};
var removeLocalStorage$1 = function (key) {
    isBrowser$1() && localStorage.removeItem(key);
};
var setStoreInfoCookie$1 = function (_a) {
    var storeId = _a.storeId, language = _a.language, currency = _a.currency;
    return cookies$2.set('storeInfo', (storeId || APP_CONFIG$1.storeId) + "|" + (language || APP_CONFIG$1.language) + "|" + (currency || APP_CONFIG$1.currency), {
        path: '/',
        maxAge: 2630000,
        // https://github.com/reactivestack/cookies/issues/98
        encode: function (value) { return value; },
    });
};
var getCustomCookie$1 = function (key) { return cookies$2.get(key); };
var setCustomCookie$1 = function (key, value, expiry) {
    if (expiry === void 0) { expiry = 86400; }
    return cookies$2.set(key, value, { path: '/', maxAge: expiry, encode: function (value) { return value; } });
};
var removeCookies$1 = function (params) {
    params.forEach(function (cookieName) {
        cookies$2.remove(cookieName);
    });
};
var setNowJourneyCookie$1 = function () {
    //  expiry for an year 31536000
    return cookies$2.set(constants$1.isNowJourney, true, { path: '/', maxAge: 31536000 });
};
var getNowJourneyCookie$1 = function () {
    return cookies$2.get(constants$1.isNowJourney);
};
var removeNowJourneyCookie$1 = function () {
    return cookies$2.set(constants$1.isNowJourney, false, { path: '/', maxAge: 0 });
};
var removeDeliveryAreaInfoCookie$1 = function (ssrCookie) {
    var cookie = ssrCookie || cookies$2;
    cookie.set(DeliveryHeaders$1.POS_INFO, '', { path: '/', maxAge: 0, httpOnly: false });
};
var getPosInfo$1 = function (deliveryAreaInfo) {
    var posInfo = '';
    deliveryAreaInfo === null || deliveryAreaInfo === void 0 ? void 0 : deliveryAreaInfo.forEach(function (item, index) {
        var isComma = index < deliveryAreaInfo.length - 1;
        posInfo += item.serviceType + "=" + item.pos + "_" + item.identifier;
        if (isComma) {
            posInfo += ',';
        }
    });
    return posInfo;
};
var setDeliveryAreaInfo$1 = function (deliveryAreaInfo, ssrCookie) {
    var cookie = ssrCookie || cookies$2;
    var posInfo = getPosInfo$1(deliveryAreaInfo);
    cookie.set(DeliveryHeaders$1.POS_INFO, posInfo, {
        path: '/',
        maxAge: 3600000000,
        httpOnly: false,
        encode: function (value) { return value; },
    });
};
var setDeliveryAreaInHeaders$1 = function (deliveryAreaInfo) {
    var extraHeaders = {};
    var posInfo = getPosInfo$1(deliveryAreaInfo);
    if (posInfo.length) {
        extraHeaders.posInfo = posInfo;
        return extraHeaders;
    }
    if (cookies$2.get(DeliveryHeaders$1.POS_INFO)) {
        extraHeaders.posInfo = cookies$2.get(DeliveryHeaders$1.POS_INFO);
    }
    return extraHeaders;
};
var setSelectedTabData$1 = function (selectedTabData) {
    return cookies$2.set('selectedTabData', selectedTabData, { path: '/', maxAge: 3600000000 });
};
var getSelectedTabData$1 = function () {
    return cookies$2.get('selectedTabData') || '{}';
};
var removeSelectedTabData$1 = function () {
    return cookies$2.remove('selectedTabData', { path: '/' });
};
var removeIsExpressServiceType$1 = function () { return cookies$2.remove(constants$1.isExpressServiceType, { path: '/' }); };
var getIsExpressServiceType$1 = function () { return cookies$2.get(constants$1.isExpressServiceType); };

var CookieUtils$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get DeliveryHeaders () { return DeliveryHeaders$1; },
    setAppVersion: setAppVersion$1,
    getAppVersion: getAppVersion$1,
    getUserTokenFromCookie: getUserTokenFromCookie$1,
    getUserEmailFromCookie: getUserEmailFromCookie$1,
    getGUID: getGUID$1,
    setGUID: setGUID$1,
    getRefreshTokenFromCookie: getRefreshTokenFromCookie$1,
    removeGUIDFromCookie: removeGUIDFromCookie$1,
    getGuestSessionToken: getGuestSessionToken$1,
    setSearchTypeCookie: setSearchTypeCookie$1,
    setSelectedAddressID: setSelectedAddressID$1,
    getSelectedAddressID: getSelectedAddressID$1,
    setSelectedAddressIDCookie: setSelectedAddressIDCookie$1,
    getSelectedAddressIDCookie: getSelectedAddressIDCookie$1,
    setRefreshTokenCallTime: setRefreshTokenCallTime$1,
    getRefreshTokenCallTime: getRefreshTokenCallTime$1,
    getSearchTypeCookie: getSearchTypeCookie$1,
    setPageType: setPageType$1,
    getPageType: getPageType$1,
    setCategoryName: setCategoryName$1,
    getCategoryName: getCategoryName$1,
    setGuestSessionToken: setGuestSessionToken$1,
    setUserTokenFromCookie: setUserTokenFromCookie$1,
    removeCookie: removeCookie$1,
    setRRSessionId: setRRSessionId$1,
    setRRUserId: setRRUserId$1,
    setDeliveryArea: setDeliveryArea$1,
    getRRSessionId: getRRSessionId$1,
    getRRUserId: getRRUserId$1,
    getDeliveryArea: getDeliveryArea$1,
    setSelectedLat: setSelectedLat$1,
    setSelectedLng: setSelectedLng$1,
    getSelectedLat: getSelectedLat$1,
    getSelectedLng: getSelectedLng$1,
    setPackageFreeDelivery: setPackageFreeDelivery$1,
    getPackageFreeDelivery: getPackageFreeDelivery$1,
    removeLocalStorage: removeLocalStorage$1,
    setStoreInfoCookie: setStoreInfoCookie$1,
    getCustomCookie: getCustomCookie$1,
    setCustomCookie: setCustomCookie$1,
    removeCookies: removeCookies$1,
    setNowJourneyCookie: setNowJourneyCookie$1,
    getNowJourneyCookie: getNowJourneyCookie$1,
    removeNowJourneyCookie: removeNowJourneyCookie$1,
    removeDeliveryAreaInfoCookie: removeDeliveryAreaInfoCookie$1,
    getPosInfo: getPosInfo$1,
    setDeliveryAreaInfo: setDeliveryAreaInfo$1,
    setDeliveryAreaInHeaders: setDeliveryAreaInHeaders$1,
    setSelectedTabData: setSelectedTabData$1,
    getSelectedTabData: getSelectedTabData$1,
    removeSelectedTabData: removeSelectedTabData$1,
    removeIsExpressServiceType: removeIsExpressServiceType$1,
    getIsExpressServiceType: getIsExpressServiceType$1
});

var EPageSturctureTypes$2;
(function (EPageSturctureTypes) {
    EPageSturctureTypes["SET_PAGE_STRUCTURE"] = "SET_PAGE_STRUCTURE";
})(EPageSturctureTypes$2 || (EPageSturctureTypes$2 = {}));
var EDeliveryTimeTypes$1;
(function (EDeliveryTimeTypes) {
    EDeliveryTimeTypes["SET_DELIVERY_TIME"] = "SET_DELIVERY_TIME";
    EDeliveryTimeTypes["SET_COACHMARKS"] = "SET_COACHMARKS";
})(EDeliveryTimeTypes$1 || (EDeliveryTimeTypes$1 = {}));
var TAB_CONST = {
    homepage: 'homepage',
    now: 'clp',
};
var Constants$1;
(function (Constants) {
    Constants["STATIC"] = "STATIC";
    Constants["DELIVERY_TIME_STANDARD"] = "DELIVERY_TIME_STANDARD";
    Constants["DELIVERY_TIME_EXPRESS"] = "DELIVERY_TIME_EXPRESS";
})(Constants$1 || (Constants$1 = {}));
var slots$1 = [
    {
        key: 'expressSlot',
        busyHourKey: 'isNowBusyHour',
        offlineHourKey: 'isNowOfflineHour',
        nextSlotKey: 'nextAvailableSlotForNow',
        disclaimerKey: 'nowBusyHourDisclaimer',
        unavailableHourKey: 'isNowUnavailableHour',
        available: 'isNowAvailable',
        nextSlot: 'isNowNextSlot',
    },
    {
        key: 'qcommSlot',
        busyHourKey: 'isQcommBusyHour',
        offlineHourKey: 'isQcommOfflineHour',
        nextSlotKey: 'nextAvailableSlotForQcomm',
        disclaimerKey: 'qCommBusyHourDisclaimer',
        unavailableHourKey: 'isQcommUnavailableHour',
        available: 'isQCommAvailable',
        nextSlot: 'isQcommNextSlot',
    },
];
var EPageSturctureTypes$3 = EPageSturctureTypes$2;

var STORE$1;
var __REDUX_STORE__$1 = '__REDUX_STORE__';
var getStore$1 = function () {
    return isBrowser$1() ? window[__REDUX_STORE__$1] || STORE$1 : STORE$1;
};
var setStore = function (store) {
    STORE$1 = store;
};

var initialApiState$1 = {};
var apiReducer$1 = function (state, action) {
    if (state === void 0) { state = initialApiState$1; }
    switch (action.type) {
        case EApiActionTypes$3.API_ERROR:
            return __assign(__assign({}, state), { error: action.payload });
        case EApiActionTypes$3.ACCESS_DENIED:
            return __assign(__assign({}, state), { accessDenied: action.payload });
        default:
            return state;
    }
};

var EMiniCartTypes$2;
(function (EMiniCartTypes) {
    EMiniCartTypes["MINI_CART_ADD_TO_CART"] = "MiniCart/ADD_TO_CART";
    EMiniCartTypes["MINI_CART_ADD_TO_ENTRIES"] = "MiniCart/ADD_TO_ENTRIES";
    EMiniCartTypes["MINI_CART_GET"] = "MiniCart/GET";
    EMiniCartTypes["MINI_CART_REMOVE_FROM_CART"] = "MiniCart/REMOVE_FROM_CART";
    EMiniCartTypes["MINI_CART_REMOVE_FROM_ENTRIES"] = "MiniCart/REMOVE_FROM_ENTRIES";
    EMiniCartTypes["MINI_CART_SET_DATA"] = "MiniCart/SET_DATA";
    EMiniCartTypes["MINI_CART_UPDATE_CART"] = "MiniCart/UPDATE_CART";
    EMiniCartTypes["MINI_CART_ADD_TO_CART_TRACKING"] = "MiniCart/ADD_TO_CART_TRACKING";
})(EMiniCartTypes$2 || (EMiniCartTypes$2 = {}));
var EMiniCartTypes$3 = EMiniCartTypes$2;

var initialMiniCartState$1 = {
    entries: {},
    totalUnitCount: 0,
    updatedCart: null,
    statusCode: '',
};
var miniCartReducer$1 = function (state, action) {
    if (state === void 0) { state = initialMiniCartState$1; }
    switch (action.type) {
        case EMiniCartTypes$3.MINI_CART_SET_DATA:
            return __assign(__assign({}, state), action.payload);
        case EMiniCartTypes$3.MINI_CART_ADD_TO_ENTRIES: {
            var _a = action.payload, entry = _a.entry, totalUnitCount = _a.totalUnitCount, updatedCart = _a.updatedCart, statusCode = _a.statusCode, offerEntries = _a.offerEntries;
            return __assign(__assign({}, state), { totalUnitCount: totalUnitCount,
                updatedCart: updatedCart,
                statusCode: statusCode, entries: __assign(__assign({}, state.entries), entry), offerEntries: offerEntries });
        }
        case EMiniCartTypes$3.MINI_CART_REMOVE_FROM_ENTRIES: {
            var entries_1 = state.entries;
            var _b = action.payload, totalUnitCount = _b.totalUnitCount, uniqueEntryId = _b.uniqueEntryId;
            var deletedProductKey_1 = uniqueEntryId;
            var filteredEntries = Object.keys(entries_1).filter(function (key) { return key !== deletedProductKey_1.toString(); });
            var newEntries_1 = {};
            filteredEntries.forEach(function (val) {
                newEntries_1[val] = __assign({}, entries_1[val]);
            });
            return __assign(__assign({}, state), { totalUnitCount: totalUnitCount, entries: newEntries_1 });
        }
    }
    return state;
};

var EProductCardTypes$2;
(function (EProductCardTypes) {
    EProductCardTypes["SET_ERROR"] = "ProductCard/SET_ERROR";
    EProductCardTypes["SET_LOADING"] = "ProductCard/SET_LOADING";
    EProductCardTypes["SET_TRACKING"] = "ProductCard/ALGOLIA_TRACKING";
})(EProductCardTypes$2 || (EProductCardTypes$2 = {}));
var EProductCardTypes$3 = EProductCardTypes$2;

var initialProductCardState$1 = {};
var productCardReducer$1 = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initialProductCardState$1; }
    switch (action.type) {
        case EProductCardTypes$3.SET_ERROR:
            return __assign(__assign({}, state), (_a = {}, _a[action.payload.productId] = __assign(__assign(__assign({}, state[action.payload.productId]), { error: action.payload.error, errDetail: action.payload.errDetail }), (action.payload.persistent && {
                persistentError: {
                    error: action.payload.error,
                    errDetail: action.payload.errDetail,
                },
            })), _a));
        case EProductCardTypes$3.SET_LOADING:
            return __assign(__assign({}, state), (_b = {}, _b[action.payload.productId] = __assign(__assign({}, state[action.payload.productId]), { loading: action.payload.loading }), _b));
        default:
            return state;
    }
};

var EProductCardCarouselTypes$2;
(function (EProductCardCarouselTypes) {
    EProductCardCarouselTypes["GET_PRODUCTS"] = "CAROUSEL/GET_PRODUCTS";
    EProductCardCarouselTypes["SET_PRODUCTS"] = "CAROUSEL/SET_PRODUCTS";
})(EProductCardCarouselTypes$2 || (EProductCardCarouselTypes$2 = {}));
var EProductCardCarouselTypes$3 = EProductCardCarouselTypes$2;

var initialProductCardCarouselState$1 = {
    strategy: {},
};
var ProductCardCarouselReducer$1 = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initialProductCardCarouselState$1; }
    switch (action.type) {
        case EProductCardCarouselTypes$3.GET_PRODUCTS:
            var payload = action.payload;
            return __assign(__assign({}, state), { strategy: __assign(__assign({}, state.strategy), (_a = {}, _a[payload] = {
                    isLoading: true,
                }, _a)) });
        case EProductCardCarouselTypes$3.SET_PRODUCTS:
            var _c = action.payload, key = _c.key, products = _c.products;
            return __assign(__assign({}, state), { strategy: __assign(__assign({}, state.strategy), (_b = {}, _b[key] = {
                    data: products,
                    isLoading: false,
                }, _b)) });
        default:
            return state;
    }
};

var EProductListTypes$2;
(function (EProductListTypes) {
    EProductListTypes["SET_DISABLED"] = "ProductList/SET_DISABLED";
    EProductListTypes["SET_RELEVANT_PRODUCT_ID"] = "ProductList/SET_RELEVANT_PRODUCT_ID";
    EProductListTypes["SET_PRODUCTS"] = "ProductList/SET_PRODUCTS";
    EProductListTypes["SET_EXPANDED_QTY_SELECTOR_PRODUCT_ID"] = "ProductList/SET_EXPAND_QTY_SELECTOR";
})(EProductListTypes$2 || (EProductListTypes$2 = {}));
var EProductListTypes$3 = EProductListTypes$2;

var initialProductListState$1 = {
    disabled: false,
    relevantProductId: '',
    products: [],
    totalProducts: 0,
};
var ProductListReducer$1 = function (state, action) {
    if (state === void 0) { state = initialProductListState$1; }
    switch (action.type) {
        case EProductListTypes$3.SET_DISABLED:
            return __assign(__assign({}, state), { disabled: action.payload });
        case EProductListTypes$3.SET_RELEVANT_PRODUCT_ID:
            return __assign(__assign({}, state), { relevantProductId: action.payload });
        case EProductListTypes$3.SET_PRODUCTS:
            var _a = action.payload, products = _a.products, totalProducts = _a.totalProducts;
            return __assign(__assign({}, state), { relevantProductId: '', products: products,
                totalProducts: totalProducts });
        case EProductListTypes$3.SET_EXPANDED_QTY_SELECTOR_PRODUCT_ID:
            var productId = action.payload;
            return __assign(__assign({}, state), { expandedQtySelectorProductId: productId });
        default:
            return state;
    }
};

var ESearchBoxTypes$1;
(function (ESearchBoxTypes) {
    ESearchBoxTypes["GET_AUTOCOMPLETE"] = "SEARCH_BOX/GET_AUTOCOMPLETE";
    ESearchBoxTypes["SUCCESS_AUTOCOMPLETE"] = "SEARCH_BOX/SUCCESS_AUTOCOMPLETE";
    ESearchBoxTypes["ERROR_AUTOCOMPLETE"] = "SEARCH_BOX/ERROR_AUTOCOMPLETE";
    ESearchBoxTypes["SET_SEARCH_TYPE"] = "SEARCH_BOX/SET_SEARCH_TYPE";
    ESearchBoxTypes["GET_TRENDING_SEARCH"] = "SEARCH_BOX/GET_TRENDING_SEARCH";
    ESearchBoxTypes["GET_TRENDING_SEARCH_SUCCESS"] = "SEARCH_BOX/GET_TRENDING_SEARCH_SUCCESS";
    ESearchBoxTypes["GET_TRENDING_SEARCH_FAILURE"] = "SEARCH_BOX/GET_TRENDING_SEARCH_FAILURE";
    ESearchBoxTypes["CLEAR_AUTOCOMPLETE"] = "SEARCH_BOX/CLEAR_AUTOCOMPLETE";
    ESearchBoxTypes["FETCH_BANNER_DETAILS"] = "SEARCH/FETCH_BANNER_DETAILS";
})(ESearchBoxTypes$1 || (ESearchBoxTypes$1 = {}));

var initialSearchBoxState$1 = {
    isLoading: false,
    searchItems: [
        {
            asg_docId: '',
            asg_text_type: '',
            asg_text: '',
            asg_text_category: '',
            asg_text_category_id: '',
        },
    ],
    trendingSearch: [],
    wishlistSuggestion: [],
    searchKeyword: '',
};
var SearchBoxReducer$1 = function (state, action) {
    if (state === void 0) { state = initialSearchBoxState$1; }
    switch (action.type) {
        case ESearchBoxTypes$1.GET_AUTOCOMPLETE:
            var params = action.payload.params;
            return __assign(__assign({}, state), { searchKeyword: params.query, isLoading: true });
        case ESearchBoxTypes$1.SUCCESS_AUTOCOMPLETE:
            var searchItems = state.searchKeyword === '' ? [] : __spread(action.payload);
            return __assign(__assign({}, state), { searchItems: searchItems, isLoading: false });
        case ESearchBoxTypes$1.ERROR_AUTOCOMPLETE:
            return __assign(__assign({}, state), { searchItems: [], isLoading: false, error: action.payload });
        case ESearchBoxTypes$1.GET_TRENDING_SEARCH:
            return __assign(__assign({}, state), { isLoading: true });
        case ESearchBoxTypes$1.GET_TRENDING_SEARCH_SUCCESS:
            var trendingSearchPayload = action.payload.trendingSearchResults;
            var trendingSearch = trendingSearchPayload ? trendingSearchPayload.slice(0, 5) : [];
            var wishlistSuggestion = trendingSearchPayload ? trendingSearchPayload : [];
            return __assign(__assign({}, state), { isLoading: false, trendingSearch: trendingSearch,
                wishlistSuggestion: wishlistSuggestion });
        case ESearchBoxTypes$1.CLEAR_AUTOCOMPLETE:
            return __assign(__assign({}, state), { searchItems: [], searchKeyword: '' });
        default:
            return state;
    }
};

// End of default address
var initialUserState$1 = {
    isLoyaltyFetched: false,
    isProfileUpdating: false,
    addresses: {
        error: false,
        isLoading: false,
        list: [],
        deliveryAreas: [],
        coverageArea: {
            isChecking: false,
            isSupported: false,
        },
        showLoader: false,
    },
    defaultAddress: null,
    isLoading: false,
    addressChanged: false,
};
// change any to IUserState by resolving conflicts
var userReducer$1 = function (state, action) {
    var e_1, _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28;
    if (state === void 0) { state = initialUserState$1; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case UserTypes$3.USER_GET_DATA_START:
            return __assign(__assign({}, state), { isLoading: true });
        case UserTypes$3.USER_GET_DATA_END:
            return __assign(__assign({}, state), { isLoading: false });
        case UserTypes$3.USER_UPDATE_PROFILE_START:
            return __assign(__assign({}, state), { isProfileUpdating: true });
        case UserTypes$3.USER_UPDATE_PROFILE_END:
            return __assign(__assign({}, state), { isProfileUpdating: false });
        case UserTypes$3.USER_PROFILE_DATA_SUCCESS:
            return __assign(__assign({}, state), { firstName: (_c = (_b = payload === null || payload === void 0 ? void 0 : payload.data) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.first_name, lastName: (_e = (_d = payload === null || payload === void 0 ? void 0 : payload.data) === null || _d === void 0 ? void 0 : _d.profile) === null || _e === void 0 ? void 0 : _e.last_name, birthday: (_h = (_g = (_f = payload === null || payload === void 0 ? void 0 : payload.data) === null || _f === void 0 ? void 0 : _f.profile) === null || _g === void 0 ? void 0 : _g.birthday) === null || _h === void 0 ? void 0 : _h.split('T')[0], nationality: (_k = (_j = payload === null || payload === void 0 ? void 0 : payload.data) === null || _j === void 0 ? void 0 : _j.profile) === null || _k === void 0 ? void 0 : _k.nationality, title: (_m = (_l = payload === null || payload === void 0 ? void 0 : payload.data) === null || _l === void 0 ? void 0 : _l.profile) === null || _m === void 0 ? void 0 : _m.title, contact_number: (_p = (_o = payload === null || payload === void 0 ? void 0 : payload.data) === null || _o === void 0 ? void 0 : _o.profile) === null || _p === void 0 ? void 0 : _p.contact_number, fullName: ((_r = (_q = payload === null || payload === void 0 ? void 0 : payload.data) === null || _q === void 0 ? void 0 : _q.profile) === null || _r === void 0 ? void 0 : _r.first_name) + ' ' + ((_t = (_s = payload === null || payload === void 0 ? void 0 : payload.data) === null || _s === void 0 ? void 0 : _s.profile) === null || _t === void 0 ? void 0 : _t.last_name), phone: (_w = (_v = (_u = payload === null || payload === void 0 ? void 0 : payload.data) === null || _u === void 0 ? void 0 : _u.profile) === null || _v === void 0 ? void 0 : _v.contact_number[0]) === null || _w === void 0 ? void 0 : _w.number, isPhoneVerified: (_y = (_x = payload === null || payload === void 0 ? void 0 : payload.data) === null || _x === void 0 ? void 0 : _x.profile) === null || _y === void 0 ? void 0 : _y.isPhoneVerified, isNewUser: (_0 = (_z = payload === null || payload === void 0 ? void 0 : payload.data) === null || _z === void 0 ? void 0 : _z.profile) === null || _0 === void 0 ? void 0 : _0.isNewUser, cardNumber: ((_3 = (_2 = (_1 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _1 === void 0 ? void 0 : _1.profile) === null || _2 === void 0 ? void 0 : _2.loyalty) === null || _3 === void 0 ? void 0 : _3.card_number) || '', email: (_5 = (_4 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _4 === void 0 ? void 0 : _4.profile) === null || _5 === void 0 ? void 0 : _5.username, id: (_7 = (_6 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _6 === void 0 ? void 0 : _6.profile) === null || _7 === void 0 ? void 0 : _7.id });
        case UserTypes$3.USER_PROFILE_PHONE_UPDATE:
            return __assign(__assign({}, state), payload);
        case UserTypes$3.USER_GET_LOYALTY_DATA_SUCCESS:
            if (payload === null || payload === void 0 ? void 0 : payload.data) {
                return __assign(__assign({}, state), { cardNumber: (_9 = (_8 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _8 === void 0 ? void 0 : _8.points) === null || _9 === void 0 ? void 0 : _9.card_number, isShare: ((_11 = (_10 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _10 === void 0 ? void 0 : _10.points) === null || _11 === void 0 ? void 0 : _11.loyalty_program) === 'share' ? true : false, totalPoints: ((_13 = (_12 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _12 === void 0 ? void 0 : _12.points) === null || _13 === void 0 ? void 0 : _13.points) ? parseFloat((_15 = (_14 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _14 === void 0 ? void 0 : _14.points) === null || _15 === void 0 ? void 0 : _15.points).toFixed(2) : 0.0, totalPointsValue: ((_17 = (_16 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _16 === void 0 ? void 0 : _16.points) === null || _17 === void 0 ? void 0 : _17.converted_points) ? parseFloat((_19 = (_18 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _18 === void 0 ? void 0 : _18.points) === null || _19 === void 0 ? void 0 : _19.converted_points).toFixed(2)
                        : 0.0 });
            }
            else {
                return __assign(__assign({}, state), { cardNumber: payload.cardNumber, isShare: payload.isShare, totalPoints: payload.totalPoints, totalPointsValue: payload.totalPointsValue });
            }
        case UserTypes$3.USER_GET_LOYALTY_DATA_END:
            return __assign(__assign({}, state), { isLoyaltyFetched: true });
        case UserTypes$3.USER_SET_ADDRESSES_ERROR:
            return __assign(__assign({}, state), { addresses: __assign(__assign({}, state.addresses), { error: action.payload }) });
        case UserTypes$3.USER_SET_ADDRESSES_LOADING:
            return __assign(__assign({}, state), { addresses: __assign(__assign({}, state.addresses), { loading: action.payload /* default state has isLoading if there is any dependency on loading needs to be changed to isLoading */, isLoading: action.payload }) });
        case USER_FETCH_ADDRESSES_SUCCESS$1:
            var _29 = payload, addresses = _29.addresses, defaultAreaCode = _29.defaultAreaCode;
            var userDefaultAddress = state.selectedAddress;
            var selectedAddress = state.selectedAddress;
            if (!userDefaultAddress) {
                try {
                    for (var addresses_1 = __values(addresses), addresses_1_1 = addresses_1.next(); !addresses_1_1.done; addresses_1_1 = addresses_1.next()) {
                        var address = addresses_1_1.value;
                        var isAddressDefault = address.defaultAddress, addressID = address.id;
                        if (isAddressDefault) {
                            userDefaultAddress = address;
                        }
                        if (addressID === getSelectedAddressID$1()) {
                            selectedAddress = address;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (addresses_1_1 && !addresses_1_1.done && (_a = addresses_1.return)) _a.call(addresses_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            userDefaultAddress = userDefaultAddress || {};
            selectedAddress = selectedAddress || userDefaultAddress;
            if (Object.keys(selectedAddress).length > 0) {
                var deliverText = (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.addressLabel) + " - " + (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.building) + " - " + (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.appartment);
                setSelectedAddressID$1(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.id);
                setSelectedAddressIDCookie$1(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.id);
                setSelectedLat$1(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.latitude);
                setSelectedLng$1(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.longitude);
                setDeliveryArea$1(deliverText);
            }
            else {
                setDeliveryArea$1(defaultAreaCode);
            }
            return __assign(__assign({}, state), { addresses: __assign(__assign({}, state.addresses), { list: addresses }), selectedAddress: selectedAddress, defaultAddress: userDefaultAddress });
        case UserTypes$3.USER_SET_SELECTED_ADDRESSES: {
            return __assign(__assign({}, state), { selectedAddress: action.payload });
        }
        case UserTypes$3.USER_SET_ADDRESS_CHANGE: {
            return __assign(__assign({}, state), { addressChanged: action.payload });
        }
        case "" + UserTypes$3.USER_COUNTRY_CONFIG + EApiActionTypes$3.API_START: {
            return __assign(__assign({}, state), { countryConfig: __assign(__assign({}, state.countryConfig), { isLoading: true }) });
        }
        case USER_COUNTRY_CONFIG_SUCCESS$1: {
            var _30 = action.payload.data, countryConfiguration = _30.countryConfiguration, sharedConfig = _30.sharedConfig, unSupportedFeatures = _30.unSupportedFeatures;
            var countryFlagIcon = countryConfiguration.countryFlagIcon, defaultLatitude = countryConfiguration.defaultLatitude, defaultLongitude = countryConfiguration.defaultLongitude, phoneCountryCode = countryConfiguration.phoneCountryCode, phoneNumberLength = countryConfiguration.phoneNumberLength, countryOfOperationID = countryConfiguration.countryOfOperationID, storeId_1 = countryConfiguration.storeId;
            var countryCodePhoneNumber = sharedConfig.countryCodePhoneNumber;
            var countryPhoneConfig_1 = {
                expression: undefined,
            };
            countryCodePhoneNumber.some(function (conConfig) {
                if (conConfig.storeId === storeId_1) {
                    countryPhoneConfig_1 = conConfig;
                    return true;
                }
                return false;
            });
            return __assign(__assign({}, state), { countryConfig: {
                    countryFlagIcon: countryFlagIcon,
                    defaultLatitude: defaultLatitude,
                    defaultLongitude: defaultLongitude,
                    phoneCountryCode: phoneCountryCode,
                    phoneNumberLength: phoneNumberLength,
                    countryOfOperationID: countryOfOperationID,
                    phoneExpression: countryPhoneConfig_1.expression,
                    unSupportedFeatures: unSupportedFeatures,
                    sharedConfig: sharedConfig,
                } });
        }
        case "" + UserTypes$3.USER_COUNTRY_CONFIG + EApiActionTypes$3.API_END: {
            return __assign(__assign({}, state), { countryConfig: __assign(__assign({}, state.countryConfig), { isLoading: false }) });
        }
        case USER_GET_DELIVERY_AREAS_SUCCESS$1: {
            var data = action.payload.data;
            return __assign(__assign({}, state), { addresses: __assign(__assign({}, state.addresses), { deliveryAreas: data }) });
        }
        case "" + UserTypes$3.USER_CHECK_AREA_SUPPORT + EApiActionTypes$3.API_START: {
            return __assign(__assign({}, state), { addresses: __assign(__assign({}, state.addresses), { coverageArea: __assign(__assign({}, state.addresses.coverageArea), { isChecking: true }) }) });
        }
        case USER_CHECK_AREA_SUPPORT_SUCCESS$1: {
            return __assign(__assign({}, state), { addresses: __assign(__assign({}, state.addresses), { coverageArea: __assign(__assign(__assign({}, state.addresses.coverageArea), action.payload), { isSupported: (_20 = action.payload) === null || _20 === void 0 ? void 0 : _20.isSupported }) }) });
        }
        case USER_CHECK_AREA_SUPPORT_FAIL$1: {
            return __assign(__assign({}, state), { addresses: __assign(__assign({}, state.addresses), { coverageArea: __assign(__assign({}, state.addresses.coverageArea), { isSupported: false }) }) });
        }
        case "" + UserTypes$3.USER_CHECK_AREA_SUPPORT + EApiActionTypes$3.API_END: {
            return __assign(__assign({}, state), { addresses: __assign(__assign({}, state.addresses), { coverageArea: __assign(__assign({}, state.addresses.coverageArea), { isChecking: false }) }) });
        }
        case "" + UserTypes$3.USER_ADD_ADDRESS + EApiActionTypes$3.API_START:
        case "" + UserTypes$3.USER_UPDATE_ADDRESS + EApiActionTypes$3.API_START:
            return __assign(__assign({}, state), { addresses: __assign(__assign({}, state.addresses), { showLoader: true }) });
        case "" + UserTypes$3.USER_ADD_ADDRESS + EApiActionTypes$3.API_END:
        case "" + UserTypes$3.USER_UPDATE_ADDRESS + EApiActionTypes$3.API_END:
            return __assign(__assign({}, state), { addresses: __assign(__assign({}, state.addresses), { showLoader: false }) });
        case USER_ADD_ADDRESS_SUCCESS$1: {
            var newAddressesList = __spread(action.payload, state.addresses.list);
            return __assign(__assign({}, state), { addresses: __assign(__assign({}, state.addresses), { list: newAddressesList }) });
        }
        case UserTypes$3.USER_UPDATE_DELIVERY_ADDRESS:
            return __assign(__assign({}, state), { selectedAddress: payload.updatedDeliveryAddress });
        case UserTypes$3.USER_UPDATE_NEWLY_ADDED_ADDRESS: {
            return __assign(__assign({}, state), { selectedAddress: payload, addresses: __assign(__assign({}, state.addresses), { list: __spread([payload], state.addresses.list) }) });
        }
        case UserTypes$3.UPDATE_USER_CONTACT:
            return __assign(__assign({}, state), { userContactLoading: true });
        case UserTypes$3.UPDATE_USER_CONTACT_SUCCESS:
            return __assign(__assign({}, state), { userContactLoading: false });
        case UserTypes$3.UPDATE_USER_CONTACT_ERROR:
            return __assign(__assign({}, state), { userContactLoading: false });
        case UserTypes$3.USER_GET_LOYALTY_SUMMARY_SUCCESS:
            return __assign(__assign({}, state), { totalPoints: ((_22 = (_21 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _21 === void 0 ? void 0 : _21.points) === null || _22 === void 0 ? void 0 : _22.points) ? parseFloat((_24 = (_23 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _23 === void 0 ? void 0 : _23.points) === null || _24 === void 0 ? void 0 : _24.points).toFixed(2) : 0.0, totalPointsValue: ((_26 = (_25 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _25 === void 0 ? void 0 : _25.points) === null || _26 === void 0 ? void 0 : _26.converted_points) ? parseFloat((_28 = (_27 = payload === null || payload === void 0 ? void 0 : payload.data) === null || _27 === void 0 ? void 0 : _27.points) === null || _28 === void 0 ? void 0 : _28.converted_points).toFixed(2)
                    : 0.0 });
    }
    return state;
};

var initialAppConfigState$1 = {
    language: APP_CONFIG$1.language,
    currency: APP_CONFIG$1.currency,
    storeId: APP_CONFIG$1.storeId,
    // zoneId: APP_CONFIG.zoneId,
    areaCode: APP_CONFIG$1.areaCode,
    sessionId: APP_CONFIG$1.sessionId,
    userId: APP_CONFIG$1.userId,
    expressDeliveryMessage: APP_CONFIG$1.expressDeliveryMessage,
    expressPos: APP_CONFIG$1.expressPos,
    latitude: APP_CONFIG$1.latitude,
    longitude: APP_CONFIG$1.longitude,
    isLoading: false,
    gtmInitialized: false,
    brazeInitialized: false,
    features: {},
    userCredentials: {},
    growthBook: {},
    flagShip: {},
    pageIntent: false,
    pageName: APP_CONFIG$1.pageName,
};
var appConfigReducer$1 = function (state, action) {
    if (state === void 0) { state = initialAppConfigState$1; }
    switch (action.type) {
        case EAppConfigTypes$3.INIT:
            return {
                isLoading: true,
            };
        case EAppConfigTypes$3.SUCCESS:
            return __assign(__assign(__assign({}, state), action.payload), { isLoading: false });
        case EAppConfigTypes$3.SET_AREA_CODE:
            return __assign(__assign({}, state), { areaCode: action.payload, isLoading: false });
        case EAppConfigTypes$3.SET_LANGUAGE_CODE:
            return __assign(__assign({}, state), { language: action.payload, isLoading: false });
        case EAppConfigTypes$3.REFRESH_TOKEN_SUCCESS: {
            var _a = action.payload.data, authToken = _a.accessToken, expiresIn = _a.expiresIn;
            setCustomCookie$1(constants$1.userToken, authToken, expiresIn);
            return __assign(__assign({}, state), { userCredentials: __assign(__assign({}, state.userCredentials), { authToken: authToken }) });
        }
        case EAppConfigTypes$3.GTM_INITIALIZED: {
            var isInitialized = action.payload;
            return __assign(__assign({}, state), { gtmInitialized: isInitialized });
        }
        case EAppConfigTypes$3.BRAZE_INITIALIZED: {
            var isInitialized = action.payload;
            return __assign(__assign({}, state), { brazeInitialized: isInitialized });
        }
        case EAppConfigTypes$3.GROWTHBOOK_INITIALIZED: {
            var payload = action.payload;
            return __assign(__assign({}, state), { growthBook: __assign(__assign({}, state.growthBook), payload) });
        }
        case EAppConfigTypes$3.FLAGSHIP_INITIALIZED: {
            var payload = action.payload;
            return __assign(__assign({}, state), { flagShip: __assign(__assign({}, state.flagShip), payload) });
        }
        case EAppConfigTypes$3.SET_PAGE_INTENT: {
            var payload = action.payload;
            return __assign(__assign({}, state), { pageIntent: payload });
        }
        case EAppConfigTypes$3.SET_PAGE_NAME: {
            var payload = action.payload;
            return __assign(__assign({}, state), { pageName: payload });
        }
        case EAppConfigTypes$3.SET_SELECTED_TAB: {
            var payload = action.payload;
            return __assign(__assign({}, state), { selectedTabId: payload });
        }
        default:
            return state;
    }
};

var EMenuNavigation$2;
(function (EMenuNavigation) {
    EMenuNavigation["MENU_INIT"] = "MENU_NAVIGATION/INIT";
    EMenuNavigation["MENU_SUCCESS"] = "MENU_NAVIGATION/SUCCESS";
})(EMenuNavigation$2 || (EMenuNavigation$2 = {}));
var EMenuNavigation$3 = EMenuNavigation$2;

var NOW_FEED$1 = {
    children: [],
    styleAttribute: 'now',
    title: 'Now',
    url: '/c/now',
};
var initialMenuNavigationState$1 = {
    isLoading: false,
    menuFeed: [],
};
var menuNavigationReducers$1 = function (state, action) {
    if (state === void 0) { state = initialMenuNavigationState$1; }
    switch (action.type) {
        case EMenuNavigation$3.MENU_INIT:
            return __assign(__assign({}, state), { isLoading: true, menuFeed: [] });
        case EMenuNavigation$3.MENU_SUCCESS:
            var nowUrl_1 = '';
            var menuFeed = action.payload.response.filter(function (item) {
                if (item.styleAttribute === 'now') {
                    nowUrl_1 = item.url;
                }
                return item !== undefined && item.styleAttribute !== 'now';
            });
            var nowMenuItem = __assign(__assign({}, NOW_FEED$1), { url: nowUrl_1 || NOW_FEED$1.url });
            return __assign(__assign({}, state), { isLoading: false, menuFeed: action.payload.isDesktop
                    ? __spread(menuFeed, [nowMenuItem]) : __spread(menuFeed.slice(0, 1), [nowMenuItem], menuFeed.slice(1)) });
        default:
            return state;
    }
};

var EArea$2;
(function (EArea) {
    EArea["FETCH_AREAS_GET"] = "Area/FETCH_AREAS_GET";
    EArea["FETCH_AREAS_SET"] = "Area/FETCH_AREAS_SET";
    EArea["SET_AREA"] = "Area/SET_SELECTED_AREA";
    EArea["FETCH_AREAS_GET_QATAR"] = "Area/FETCH_AREAS_GET_QATAR";
    EArea["FETCH_AREAS_SET_QATAR"] = "Area/FETCH_AREAS_SET_QATAR";
})(EArea$2 || (EArea$2 = {}));
var TOGGLE_ADDRESS_LIST$1 = 'Area/TOGGLE_ADDRESS_LIST';
var EArea$3 = EArea$2;

var areaInitialState$1 = {
    error: false,
    isLoading: false,
    regions: [],
    isExpressDelivery: false,
    selectedCity: '',
    qatarCities: null,
    showAddressList: false,
};
var areaReducer$1 = function (state, action) {
    if (state === void 0) { state = areaInitialState$1; }
    switch (action.type) {
        case EArea$3.FETCH_AREAS_GET:
            return __assign(__assign({}, state), { regions: [], error: false, isLoading: true, selectedArea: {} });
        case EArea$3.FETCH_AREAS_SET: {
            var _a = action.payload, regions = _a.regions, selectedArea = _a.selectedArea, selectedCity = _a.selectedCity;
            var isExpressDelivery = selectedArea && selectedArea.posExpressName ? true : false;
            return __assign(__assign({}, state), { regions: regions, selectedArea: selectedArea, isExpressDelivery: isExpressDelivery, selectedCity: selectedCity });
        }
        case EArea$3.FETCH_AREAS_SET_QATAR: {
            return __assign(__assign({}, state), { qatarCities: action.payload });
        }
        case "" + EArea$3.FETCH_AREAS_GET + EApiActionTypes$3.API_ERROR:
            return __assign(__assign({}, state), { error: true });
        case "" + EArea$3.FETCH_AREAS_GET + EApiActionTypes$3.API_END:
            return __assign(__assign({}, state), { isLoading: false });
        case EArea$3.SET_AREA:
            return __assign(__assign({}, state), { loading: true });
        case "" + EArea$3.SET_AREA + EApiActionTypes$3.API_ERROR:
            return __assign(__assign({}, state), { loading: false, error: true });
        case "" + EArea$3.SET_AREA + EApiActionTypes$3.API_END:
            return __assign(__assign({}, state), { loading: false });
        case TOGGLE_ADDRESS_LIST$1:
            return __assign(__assign({}, state), { showAddressList: action.payload });
        default:
            return state;
    }
};

var ENotificationTypes$2;
(function (ENotificationTypes) {
    ENotificationTypes["NOTIFICATION_SHOW"] = "Notification/SHOW_NOTIFICATION";
    ENotificationTypes["NOTIFICATION_HIDE"] = "Notification/HIDE_NOTIFICATION";
})(ENotificationTypes$2 || (ENotificationTypes$2 = {}));
var ENotificationTypes$3 = ENotificationTypes$2;

var initialNotificationState$1 = {};
var notificationReducer$1 = function (state, action) {
    if (state === void 0) { state = initialNotificationState$1; }
    switch (action.type) {
        case ENotificationTypes$3.NOTIFICATION_SHOW:
            return action.payload;
        case ENotificationTypes$3.NOTIFICATION_HIDE:
            return initialNotificationState$1;
    }
    return state;
};

var EAddToListTypes$2;
(function (EAddToListTypes) {
    EAddToListTypes["ADD_TO_LIST_FETCH_LIST"] = "AddToList/FETCH_LIST";
    EAddToListTypes["ADD_TO_LIST_FETCH_LIST_SUCCESS"] = "AddToList/FETCH_LIST_SUCCESS";
    EAddToListTypes["ADD_PRODUCT_ONLY"] = "AddToList/ADD_PRODUCT_ONLY";
    EAddToListTypes["ADD_PRODUCT_AND_NEW_LIST"] = "AddToList/ADD_PRODUCT_AND_NEW_LIST";
    EAddToListTypes["ADD_TO_LIST_TOGGLE_LOADING"] = "AddToList/TOGGLE_LOADING";
    EAddToListTypes["ADD_TO_LIST_SET_ERROR"] = "AddToList/SET_ERROR";
    EAddToListTypes["ADD_TO_LIST_SET_SUCCESS"] = "AddToList/ADD_TO_LIST_SET_SUCCESS";
    EAddToListTypes["ADD_TO_LIST_CLEAR_ERROR_AND_SUCCESS"] = "AddToList/CLEAR_ERROR_AND_SUCCESS";
})(EAddToListTypes$2 || (EAddToListTypes$2 = {}));
var EAddToListTypes$3 = EAddToListTypes$2;

var initialAddToListState$1 = { loading: false };
var addToListReducer$1 = function (state, action) {
    if (state === void 0) { state = initialAddToListState$1; }
    switch (action.type) {
        case EAddToListTypes$3.ADD_TO_LIST_SET_ERROR:
            return __assign(__assign({}, state), { error: action.payload });
        case EAddToListTypes$3.ADD_TO_LIST_TOGGLE_LOADING:
            return __assign(__assign({}, state), { loading: action.payload });
        case EAddToListTypes$3.ADD_TO_LIST_FETCH_LIST_SUCCESS:
            return __assign(__assign({}, state), { list: action.payload });
        case EAddToListTypes$3.ADD_TO_LIST_SET_SUCCESS:
            return __assign(__assign({}, state), { success: action.payload });
        case EAddToListTypes$3.ADD_TO_LIST_CLEAR_ERROR_AND_SUCCESS:
            return __assign(__assign({}, state), { error: null, success: null });
    }
    return state;
};

var ECurrencies$2;
(function (ECurrencies) {
    ECurrencies["GET_CURRENCIES"] = "FETCH_CURRENCIES_GET";
    ECurrencies["SET_CURRENCIES"] = "FETCH_CURRENCIES_SET";
})(ECurrencies$2 || (ECurrencies$2 = {}));
var ECurrencies$3 = ECurrencies$2;

var currencyInitialState$1 = {
    currencies: [],
};
var currencyReducer$1 = function (state, action) {
    if (state === void 0) { state = currencyInitialState$1; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case ECurrencies$3.SET_CURRENCIES:
            return __assign(__assign({}, state), { currencies: payload });
        default:
            return state;
    }
};

var initialPageStructureState$1 = [];
var PageStructureReducer$1 = function (state, action) {
    if (state === void 0) { state = initialPageStructureState$1; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case EPageSturctureTypes$3.SET_PAGE_STRUCTURE:
            return __spread(payload);
        default:
            return state;
    }
};
var IServiceInfo$1;
(function (IServiceInfo) {
    IServiceInfo["STANDARD"] = "STANDARD";
    IServiceInfo["EXPRESS"] = "EXPRESS";
    IServiceInfo["ANY"] = "ANY";
    IServiceInfo["QCOMM"] = "QCOMM";
})(IServiceInfo$1 || (IServiceInfo$1 = {}));
var initialDeliveryTimeState$1 = {
    posNo: '',
    standardSlot: {},
    expressSlot: {},
    qcommSlot: {},
    deliveryAreaInfo: [],
    coachMarks: [],
};
var DeliveryTimeReducer$1 = function (state, action) {
    if (state === void 0) { state = initialDeliveryTimeState$1; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case EDeliveryTimeTypes$1.SET_DELIVERY_TIME:
            return __assign(__assign({}, state), payload);
        case EDeliveryTimeTypes$1.SET_COACHMARKS:
            return __assign(__assign({}, state), { coachMarks: payload });
        default:
            return state;
    }
};

var UPDATE_COOKIE_VISIBILITY$1 = 'COOKIE_VISIBILITY/UPDATE';

var hasUserClosedCookieBanner$1 = function () { return getCustomCookie$1(constants$1.cookieBannerAcceptance) === 'true'; };

var initialCookieVisibilityState$1 = { cookieVisibility: !hasUserClosedCookieBanner$1() };
var cookieBanner$1 = function (state, action) {
    if (state === void 0) { state = initialCookieVisibilityState$1; }
    if (action.type === UPDATE_COOKIE_VISIBILITY$1) {
        return __assign(__assign({}, state), { cookieVisibility: action.payload });
    }
    return state;
};

var VerifyOTPTypes$2;
(function (VerifyOTPTypes) {
    VerifyOTPTypes["SEND_OTP"] = "OTP/SEND_OTP";
    VerifyOTPTypes["SEND_OTP_SUCCESS"] = "OTP/SEND_OTP_SUCCESS";
    VerifyOTPTypes["SEND_OTP_ERROR"] = "OTP/SEND_OTP_ERROR";
    VerifyOTPTypes["SEND_OTP_LOADING"] = "OTP/SEND_OTP_LOADING";
    VerifyOTPTypes["OTP_VERIFICATION"] = "OTP/OTP_VERIFICATION";
    VerifyOTPTypes["OTP_VERIFICATION_SUCCESS"] = "OTP/OTP_VERIFICATION_SUCCESS";
    VerifyOTPTypes["OTP_VERIFICATION_ERROR"] = "OTP/OTP_VERIFICATION_ERROR";
    VerifyOTPTypes["OTP_VERIFICATION_LOADING"] = "OTP/OTP_VERIFICATION_LOADING";
})(VerifyOTPTypes$2 || (VerifyOTPTypes$2 = {}));
var SEND_OTP_SUCCESS$1 = "" + VerifyOTPTypes$2.SEND_OTP_SUCCESS + EApiActionTypes$3.API_SUCCESS;
var OTP_VERIFICATION_SUCCESS$1 = "" + VerifyOTPTypes$2.OTP_VERIFICATION_SUCCESS + EApiActionTypes$3.API_SUCCESS;
var VerifyOTPTypes$3 = VerifyOTPTypes$2;

var initialVerifyOTPState$1 = {
    sendOTP: {
        otpData: null,
        isLoading: false,
        error: '',
    },
    verifyOTP: {
        verificationData: null,
        isLoading: false,
        error: '',
    },
};
// change any to IUserState by resolving conflicts
var verifyOTPReducer$1 = function (state, action) {
    if (state === void 0) { state = initialVerifyOTPState$1; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case VerifyOTPTypes$3.SEND_OTP_SUCCESS:
            return __assign(__assign({}, state), { sendOTP: __assign(__assign({}, state.sendOTP), { otpData: payload.otpResponse }) });
        case VerifyOTPTypes$3.SEND_OTP_ERROR:
            return __assign(__assign({}, state), { sendOTP: __assign(__assign({}, state.sendOTP), { error: payload }) });
        case VerifyOTPTypes$3.SEND_OTP_LOADING:
            return __assign(__assign({}, state), { sendOTP: __assign(__assign({}, state.sendOTP), { isLoading: payload }) });
        case VerifyOTPTypes$3.OTP_VERIFICATION_SUCCESS:
            return __assign(__assign({}, state), { verifyOTP: __assign(__assign({}, state.verifyOTP), { verificationData: payload.otpVerificationResponse }) });
        case VerifyOTPTypes$3.OTP_VERIFICATION_ERROR:
            return __assign(__assign({}, state), { verifyOTP: __assign(__assign({}, state.verifyOTP), { error: payload }) });
        case VerifyOTPTypes$3.OTP_VERIFICATION_LOADING:
            return __assign(__assign({}, state), { verifyOTP: __assign(__assign({}, state.verifyOTP), { isLoading: payload }) });
    }
    return state;
};

var VerifyOTPSMSTypes$2;
(function (VerifyOTPSMSTypes) {
    VerifyOTPSMSTypes["VERIFY_SMS_OTP"] = "SMS/VERIFY_OTP";
    VerifyOTPSMSTypes["ERROR_SMS_OTP"] = "SMS/ERROR_OTP";
    VerifyOTPSMSTypes["SUCCESS_SMS_OTP"] = "SMS/SUCCESS_OTP";
})(VerifyOTPSMSTypes$2 || (VerifyOTPSMSTypes$2 = {}));
var VerifyOTPSMSTypes$3 = VerifyOTPSMSTypes$2;

var initialState$2 = {
    loyaltyCardNumber: '',
    smsToken: '',
    response: '',
    errorMessage: '',
};
var verifyOTPSMSReducer$1 = function (state, action) {
    if (state === void 0) { state = initialState$2; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case VerifyOTPSMSTypes$3.VERIFY_SMS_OTP:
            return __assign(__assign({}, state), payload.data);
        case VerifyOTPSMSTypes$3.ERROR_SMS_OTP:
            return __assign(__assign({}, state), { errorMessage: payload });
        case VerifyOTPSMSTypes$3.SUCCESS_SMS_OTP:
            return __assign(__assign({}, state), { response: payload });
        default:
            return state;
    }
};

var HeaderTypes$2;
(function (HeaderTypes) {
    HeaderTypes["HEADER_GET"] = "HEADER/GET";
})(HeaderTypes$2 || (HeaderTypes$2 = {}));
var HeaderTypes$3 = HeaderTypes$2;

var initialHeaderState$1 = {};
var headerReducer$1 = function (state, action) {
    if (state === void 0) { state = initialHeaderState$1; }
    switch (action.type) {
        case "" + HeaderTypes$3.HEADER_GET + EApiActionTypes$3.API_START:
            return __assign(__assign({}, state), { loading: true });
        case "" + HeaderTypes$3.HEADER_GET + EApiActionTypes$3.API_SUCCESS:
            return __assign(__assign({}, state), action.payload);
        case "" + HeaderTypes$3.HEADER_GET + EApiActionTypes$3.API_END:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};

var VerifyWhatsAppTypes$2;
(function (VerifyWhatsAppTypes) {
    VerifyWhatsAppTypes["WHATSAPP_OTP_VERIFICATION"] = "WHATSAPP_OTP/WHATSAPP_OTP_VERIFICATION";
    VerifyWhatsAppTypes["WHATSAPP_OTP_LOADING"] = "WHATSAPP_OTP/WHATSAPP_OTP_LOADING";
    VerifyWhatsAppTypes["WHATSAPP_OTP_SUCCESS"] = "WHATSAPP_OTP/WHATSAPP_OTP_SUCCESS";
    VerifyWhatsAppTypes["WHATSAPP_OTP_ERROR"] = "WHATSAPP_OTP/WHATSAPP_OTP_ERROR";
})(VerifyWhatsAppTypes$2 || (VerifyWhatsAppTypes$2 = {}));
var WHATSAPP_OTP_SUCCESS$1 = "" + VerifyWhatsAppTypes$2.WHATSAPP_OTP_SUCCESS + EApiActionTypes$3.API_SUCCESS;
var VerifyWhatsAppTypes$3 = VerifyWhatsAppTypes$2;

var initialWhatsAppOtpState$1 = {
    isWhatAppOtpLoading: false,
    whatsAppOtpSuccess: '',
    whatsAppOtpError: '',
};
var whatsAppOTPReducer$1 = function (state, action) {
    if (state === void 0) { state = initialWhatsAppOtpState$1; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case VerifyWhatsAppTypes$3.WHATSAPP_OTP_LOADING:
            return __assign(__assign({}, state), { isWhatAppOtpLoading: payload });
        case VerifyWhatsAppTypes$3.WHATSAPP_OTP_SUCCESS:
            return __assign(__assign({}, state), { whatsAppOtpSuccess: payload });
        case VerifyWhatsAppTypes$3.WHATSAPP_OTP_ERROR:
            return __assign(__assign({}, state), { whatsAppOtpError: payload });
        default:
            return state;
    }
};

var FooterTypes$2;
(function (FooterTypes) {
    FooterTypes["FOOTER_GET"] = "FOOTER/GET";
})(FooterTypes$2 || (FooterTypes$2 = {}));
var FooterTypes$3 = FooterTypes$2;

var initialFooterState$1 = {};
var footerReducer$1 = function (state, action) {
    if (state === void 0) { state = initialFooterState$1; }
    switch (action.type) {
        case "" + FooterTypes$3.FOOTER_GET + EApiActionTypes$3.API_START:
            return __assign(__assign({}, state), { loading: true });
        case "" + FooterTypes$3.FOOTER_GET + EApiActionTypes$3.API_SUCCESS:
            return __assign(__assign(__assign({}, state), action.payload), { loading: false });
        default:
            return state;
    }
};

var initialFBCSheetState$1 = {
    isOpen: false,
    fbcSheetType: '',
};
var FBCSheetReducers$1 = function (state, action) {
    if (state === void 0) { state = initialFBCSheetState$1; }
    switch (action.type) {
        case E_SOLD_BY_MESSAGE_TYPE$1.SFC:
        case E_SOLD_BY_MESSAGE_TYPE$1.SSDC:
        case E_SOLD_BY_MESSAGE_TYPE$1.SSFS:
        case E_SOLD_BY_MESSAGE_TYPE$1.SSFBC:
            return __assign(__assign({}, state), { fbcSheetType: action.type, isOpen: true });
        default:
            return __assign({}, initialFBCSheetState$1);
    }
};

var AdtechActionTypes$2;
(function (AdtechActionTypes) {
    AdtechActionTypes["SET_CRITEO_BANNERS"] = "adtech/SET_CRITEO_BANNERS";
    AdtechActionTypes["SET_CRITEO_CAROUSELS"] = "adtech/SET_CRITEO_CAROUSELS";
    AdtechActionTypes["RESET_CRITEO_CAROUSELS"] = "adtech/RESET_CRITEO_CAROUSELS";
    AdtechActionTypes["RESET_ADTECH_REDUCER"] = "adtech/RESET_ADTECH_REDUCER";
    AdtechActionTypes["SET_CRITEO_CAROUSELS_HEADER"] = "adtech/SET_CRITEO_CAROUSELS_HEADER";
})(AdtechActionTypes$2 || (AdtechActionTypes$2 = {}));
var AdtechActionTypes$3 = AdtechActionTypes$2;

var initialAdtechState$1 = {
    criteoBanners: {},
    criteoCarousels: {},
    criteoCarouselsHeader: {},
};
var adtechReducer$1 = function (state, action) {
    if (state === void 0) { state = initialAdtechState$1; }
    switch (action.type) {
        case AdtechActionTypes$3.SET_CRITEO_BANNERS:
            return __assign(__assign({}, state), { criteoBanners: __assign(__assign({}, state === null || state === void 0 ? void 0 : state.criteoBanners), action === null || action === void 0 ? void 0 : action.payload) });
        case AdtechActionTypes$3.SET_CRITEO_CAROUSELS:
            return __assign(__assign({}, state), { criteoCarousels: __assign({}, action === null || action === void 0 ? void 0 : action.payload) });
        case AdtechActionTypes$3.RESET_CRITEO_CAROUSELS:
            return __assign(__assign({}, state), { criteoCarousels: initialAdtechState$1.criteoCarousels });
        case AdtechActionTypes$3.RESET_ADTECH_REDUCER:
            return __assign({}, initialAdtechState$1);
        case AdtechActionTypes$3.SET_CRITEO_CAROUSELS_HEADER:
            return __assign(__assign({}, initialAdtechState$1), { criteoCarouselsHeader: __assign({}, action === null || action === void 0 ? void 0 : action.payload) });
        default:
            return state;
    }
};

var NewAddressType$2;
(function (NewAddressType) {
    NewAddressType["FETCH_CITIES_AND_AREAS"] = "ADDRESS/FETCH_CITIES_AND_AREAS";
    NewAddressType["FETCH_ADDRESS_LAT_LNG"] = "ADDRESS/FETCH_CITIES_AND_AREAS";
    NewAddressType["UPDATE_LOCAION_DATA"] = "ADDRESS/UPDATE_LOCATION_DATA";
    NewAddressType["COUNTRIES_GET"] = "COUNTRIES/GET";
    NewAddressType["COUNTRIES_SET_ERROR"] = "COUNTRIES/SET_ERROR";
})(NewAddressType$2 || (NewAddressType$2 = {}));
var NewAddressType$3 = NewAddressType$2;
var FETCH_CITIES_AND_AREAS_START$1 = "" + NewAddressType$2.FETCH_CITIES_AND_AREAS + EApiActionTypes$3.API_START;
var FETCH_CITIES_AND_AREAS_SUCCESS$1 = "" + NewAddressType$2.FETCH_CITIES_AND_AREAS + EApiActionTypes$3.API_SUCCESS;
var FETCH_CITIES_AND_AREAS_END$1 = "" + NewAddressType$2.FETCH_CITIES_AND_AREAS + EApiActionTypes$3.API_END;

var initialCountriesState$1 = {
    allCountries: [],
};
var countriesReducer$1 = function (state, action) {
    if (state === void 0) { state = initialCountriesState$1; }
    var type = action.type;
    switch (type) {
        case NewAddressType$3.COUNTRIES_GET: {
            return __assign(__assign({}, state), { allCountries: action.payload });
        }
    }
    return state;
};

var initialAppState = {
    api: initialApiState$1,
    area: areaInitialState$1,
    countries: initialCountriesState$1,
    appConfig: initialAppConfigState$1,
    appMenu: initialMenuNavigationState$1,
    miniCart: initialMiniCartState$1,
    productCard: initialProductCardState$1,
    productCardCarousel: initialProductCardCarouselState$1,
    productList: initialProductListState$1,
    searchBox: initialSearchBoxState$1,
    userData: initialUserState$1,
    notification: initialNotificationState$1,
    addToList: initialAddToListState$1,
    cookieBanner: initialCookieVisibilityState$1,
    verifyOTP: initialVerifyOTPState$1,
    headerData: initialHeaderState$1,
    verifyWhatsAppOTP: initialWhatsAppOtpState$1,
    footerData: initialFooterState$1,
    fbcSheet: initialFBCSheetState$1,
    pageStructure: initialPageStructureState$1,
    deliveryTime: initialDeliveryTimeState$1,
    adtech: initialAdtechState$1,
};
var reducers$1 = {
    api: apiReducer$1,
    area: areaReducer$1,
    currency: currencyReducer$1,
    countries: countriesReducer$1,
    appMenu: menuNavigationReducers$1,
    miniCart: miniCartReducer$1,
    productCard: productCardReducer$1,
    productCardCarousel: ProductCardCarouselReducer$1,
    productList: ProductListReducer$1,
    searchBox: SearchBoxReducer$1,
    appConfig: appConfigReducer$1,
    userData: userReducer$1,
    notification: notificationReducer$1,
    addToList: addToListReducer$1,
    cookieBanner: cookieBanner$1,
    verifyOTP: verifyOTPReducer$1,
    verifyOTPSMS: verifyOTPSMSReducer$1,
    headerData: headerReducer$1,
    verifyWhatsAppOTP: whatsAppOTPReducer$1,
    footerData: footerReducer$1,
    fbcSheet: FBCSheetReducers$1,
    pageStructure: PageStructureReducer$1,
    deliveryTime: DeliveryTimeReducer$1,
    adtech: adtechReducer$1,
};
var rootReducer$1 = combineReducers(reducers$1);

function createThunkMiddleware(extraArgument) {
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }
        return next(action);
      };
    };
  };
  return middleware;
}
var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

var apiStart = function (label, payload) {
    if (payload === void 0) { payload = null; }
    return ({
        type: "" + label + EApiActionTypes$3.API_START,
        payload: payload,
    });
};
var apiEnd = function (label, payload) {
    if (payload === void 0) { payload = null; }
    return ({
        type: "" + label + EApiActionTypes$3.API_END,
        payload: payload,
    });
};
var apiSuccess = function (label, payload) {
    if (payload === void 0) { payload = null; }
    return ({
        type: "" + label + EApiActionTypes$3.API_SUCCESS,
        payload: payload,
    });
};
var apiError = function (label, error) { return ({
    type: "" + label + EApiActionTypes$3.API_FAIL,
    payload: error,
}); };
var accessDenied = function (payload) {
    if (payload === void 0) { payload = null; }
    return ({
        type: EApiActionTypes$3.ACCESS_DENIED,
        payload: JSON.stringify(payload),
    });
};

var showNotification$1 = function (payload) { return ({
    type: ENotificationTypes$3.NOTIFICATION_SHOW,
    payload: payload,
}); };
var hideNotification = function () { return ({
    type: ENotificationTypes$3.NOTIFICATION_HIDE,
}); };

var _a$5 = process.env, REACT_APP_API_ENDPOINT_V1$1 = _a$5.REACT_APP_API_ENDPOINT_V1, REACT_APP_API_ENDPOINT$1 = _a$5.REACT_APP_API_ENDPOINT, _b$1 = _a$5.REACT_APP_ID, REACT_APP_ID$1 = _b$1 === void 0 ? 'Reactweb' : _b$1, REACT_APP_ENV$1 = _a$5.REACT_APP_ENV;
var API_CONFIG$1 = {
    baseURL: { v1: REACT_APP_API_ENDPOINT_V1$1, v2: REACT_APP_API_ENDPOINT$1 },
    appId: REACT_APP_ID$1,
};
var API_HEADERS_COMMON_CONFIG$1 = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    userId: getUserEmailFromCookie$1(),
    appId: REACT_APP_ID$1,
    env: REACT_APP_ENV$1,
};

/**
 * This function will replace all static variables with proper values from the configuration
 * @param url URL that contains varibales wrapped with curly braces
 * ex: `/carts/{{StoreId}}/{{language}}/current/
 * @param params object contains the actual value for the matched variables
 * ex: {StoreId: 123, language: 'en'}
 * @returns the modified URL after replacing all variables
 */
var replaceUrlVariables$1 = function (url, params) {
    var latitude = params.latitude, longitude = params.longitude, _a = params.isLocationCXEnable, isLocationCXEnable = _a === void 0 ? false : _a;
    var _b = params.areaCode, areaCode = _b === void 0 ? '' : _b;
    areaCode = areaCode.split('&').join('%26');
    var regex = /[^{{}]+(?=}})/g;
    var matches = url.match(regex);
    var updatedParams = __assign(__assign({}, params), { areaCode: areaCode });
    var modifiedURL = url;
    if (matches) {
        matches.forEach(function (item) {
            var value = updatedParams[item];
            modifiedURL = modifiedURL.replace(new RegExp('{{' + item + '}}'), isExisty$1(value) || value === '' ? value : '');
        });
    }
    // Checking if location cx is enabled or not, if so replace area code to lat long
    // need to check
    // todo need to discuss this With AMIT
    if (isLocationCXEnable || (latitude && longitude)) {
        // escape special characters in area code
        var regExpEscape = function (url) {
            return url.replace(/[-[\]{}()*+!<=:?.\/\\^$|#\s,]/g, '\\$&');
        };
        // this is to handle both all cases of areacode some apis support small areacode and some camelcase
        var areaCodeRegex = new RegExp(regExpEscape('areaCode=' + areaCode), 'ig');
        var lat = getCustomCookie$1('lat');
        var long = getCustomCookie$1('long');
        modifiedURL = modifiedURL.replace(areaCodeRegex, "latitude=" + (lat || latitude) + "&longitude=" + (long || longitude));
    }
    return modifiedURL;
};
var updateURLForGuestSession$1 = function (url, guid) {
    var updatedURL = url;
    updatedURL = updatedURL.replace('current', guid);
    return updatedURL;
};

// process.env-related utility helpers
var isTestNodeEnv = function () { return process.env.NODE_ENV === 'test'; };

var httpAgent$1 = new http.Agent({ keepAlive: true });
var httpsAgent$1 = new https.Agent({ keepAlive: true });
var updateRequestParamURL$1 = function (requestUrl) {
    var guid = getGUID$1();
    if (guid) {
        return updateURLForGuestSession$1(requestUrl, guid);
    }
    return requestUrl;
};
var replaceApigeeBaseUrl$1 = function (requestUrl) {
    var apigeeUrls = ['api-test.retailsso.com', 'api-prod.retailsso.com', 'api-dev.retailsso.com'];
    var isBaseApigeeurl = apigeeUrls.some(function (url) { return requestUrl.includes(url); });
    if (!isServer$1() && isBaseApigeeurl) {
        requestUrl = requestUrl.replace(/api-(test|dev|prod)\.retailsso\.com/, window.location.hostname);
    }
    return requestUrl;
};
var getApiBaseUrl$1 = function (apiVersion) {
    if (apiVersion && isNumber$1(apiVersion)) {
        return "/v" + apiVersion;
    }
    return '/v2';
};
var networkRequest$1 = (function (_a) {
    var requestUrl = _a.requestUrl, _b = _a.isAbsUrl, isAbsUrl = _b === void 0 ? false : _b, apiOptions = _a.apiOptions, _c = _a.apiVersion, apiVersion = _c === void 0 ? 2 : _c, excludeFromDefaultHeaders = _a.excludeFromDefaultHeaders, _d = _a.headers, headers = _d === void 0 ? {} : _d;
    return __awaiter(void 0, void 0, void 0, function () {
        var apiRequestURL, baseUrl, store, appConfig, userCredentials, language, storeId, isPolygonChange, guestAccessToken, _e, _f, authToken, _g, token, _h, userId, userToken, extraHeaders, deliveryAreaHeaders, posInfoConfig_1, deliveryTime, updatedDeliveryInfo, appStage, defaultCommonHeaders, isReplaceApigeeUrlEnabled, _j, data, exception_1;
        var _k, _l, _m, _o;
        return __generator(this, function (_p) {
            switch (_p.label) {
                case 0:
                    apiRequestURL = requestUrl;
                    if (!isAbsUrl) {
                        baseUrl = getApiBaseUrl$1(apiVersion);
                        axios.defaults.baseURL = process.env.STORYBOOK ? "" + process.env.APIGEE_ENDPOINT + baseUrl : baseUrl;
                    }
                    else {
                        axios.defaults.baseURL = '';
                    }
                    store = getStore$1();
                    appConfig = APP_CONFIG$1;
                    if (store) {
                        appConfig = store.getState().appConfig;
                    }
                    userCredentials = appConfig.userCredentials, language = appConfig.language, storeId = appConfig.storeId, isPolygonChange = appConfig.isPolygonChange;
                    guestAccessToken = appConfig.accessToken;
                    _e = userCredentials || {}, _f = _e.authToken, authToken = _f === void 0 ? '' : _f, _g = _e.token, token = _g === void 0 ? '' : _g, _h = _e.userId, userId = _h === void 0 ? '' : _h;
                    userToken = authToken || token;
                    // Below code added in scenario when user is not logged in and he has added some records in cart and after clicking on place order user will redirect on cart screen but there appConfig is not setup
                    userToken = userToken || getUserTokenFromCookie$1();
                    guestAccessToken = guestAccessToken || getGuestSessionToken$1();
                    extraHeaders = {};
                    deliveryAreaHeaders = {};
                    if (isPolygonChange) {
                        posInfoConfig_1 = ((_l = (_k = store.getState()) === null || _k === void 0 ? void 0 : _k.appConfig) === null || _l === void 0 ? void 0 : _l.posInfoConfig) || [''];
                        deliveryTime = (_m = store.getState()) === null || _m === void 0 ? void 0 : _m.deliveryTime;
                        updatedDeliveryInfo = deliveryTime === null || deliveryTime === void 0 ? void 0 : deliveryTime.deliveryAreaInfo.filter(function (item) {
                            return posInfoConfig_1.includes(item === null || item === void 0 ? void 0 : item.serviceType);
                        });
                        deliveryAreaHeaders = setDeliveryAreaInHeaders$1(updatedDeliveryInfo);
                    }
                    if (authToken || getUserTokenFromCookie$1()) {
                        extraHeaders = {
                            token: "Bearer " + (authToken || getUserTokenFromCookie$1()),
                        };
                    }
                    else {
                        // TODO will uncomment when jwt will enable
                        //extraHeaders = { token: userToken || '' };
                        extraHeaders = { token: userToken || guestAccessToken || '' };
                    }
                    appStage = process.env.APP_STAGE;
                    // Sets request "Headers" common attributes
                    axios.defaults.headers.common = __assign(__assign(__assign(__assign(__assign(__assign({}, API_HEADERS_COMMON_CONFIG$1), extraHeaders), { storeId: storeId, langCode: language || '', lang: language || '', userId: decodeStr$1(userId || getUserEmailFromCookie$1() || constants$1.guestUserID.toLowerCase()) }), headers), deliveryAreaHeaders), (appStage ? { 'x-maf-env': appStage } : {}));
                    if (!getUserTokenFromCookie$1()) {
                        apiRequestURL = updateRequestParamURL$1(requestUrl);
                    }
                    defaultCommonHeaders = axios.defaults.headers.common;
                    if (excludeFromDefaultHeaders) {
                        defaultCommonHeaders = Object.assign({}, defaultCommonHeaders);
                        excludeFromDefaultHeaders.forEach(function (key) {
                            delete defaultCommonHeaders[key];
                        });
                    }
                    axios.defaults.headers.common = defaultCommonHeaders;
                    isReplaceApigeeUrlEnabled = ((_o = getGrowthBookFeatureValueViaInstance$1(store.getState(), 'isapigeebaseurlenabled')) === null || _o === void 0 ? void 0 : _o.on) || false;
                    if (isReplaceApigeeUrlEnabled) {
                        apiRequestURL = replaceApigeeBaseUrl$1(apiRequestURL);
                    }
                    _p.label = 1;
                case 1:
                    _p.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.request(__assign({ url: apiRequestURL, timeout: 1000 * 15, // 15 second as hybris is slow.
                            httpAgent: httpAgent$1,
                            httpsAgent: httpsAgent$1 }, apiOptions))];
                case 2:
                    _j = (_p.sent()).data, data = _j === void 0 ? {} : _j;
                    return [2 /*return*/, Promise.resolve({ data: data })];
                case 3:
                    exception_1 = _p.sent();
                    console.error('exception ', exception_1);
                    return [2 /*return*/, Promise.reject(exception_1)];
                case 4: return [2 /*return*/];
            }
        });
    });
});

var GUEST_AUTH_TOKEN$1 = "stores/{{StoreId}}/{{language}}/oauth/token";
var fetchGuestSessionToken$1 = function () { return __awaiter(void 0, void 0, void 0, function () {
    var baseURL, StoreId, language, requestUrl, _a, access_token, expires_in, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                baseURL = API_CONFIG$1.baseURL;
                StoreId = APP_CONFIG$1.storeId, language = APP_CONFIG$1.language;
                requestUrl = replaceUrlVariables$1(GUEST_AUTH_TOKEN$1, { StoreId: StoreId, language: language });
                axios.defaults.baseURL = process.env.STORYBOOK ? "" + process.env.APIGEE_ENDPOINT + baseURL.v2 : baseURL.v2;
                axios.defaults.headers.common = {
                    env: API_HEADERS_COMMON_CONFIG$1.env,
                    appId: API_HEADERS_COMMON_CONFIG$1.appId,
                };
                return [4 /*yield*/, axios.get(requestUrl)];
            case 1:
                _a = (_b.sent()).data, access_token = _a.access_token, expires_in = _a.expires_in;
                setGuestSessionToken$1(access_token, expires_in);
                return [3 /*break*/, 3];
            case 2:
                error_1 = _b.sent();
                return [2 /*return*/];
            case 3: return [2 /*return*/];
        }
    });
}); };
var handleGuestSession$1 = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(!getUserTokenFromCookie$1() && !getGuestSessionToken$1())) return [3 /*break*/, 2];
                return [4 /*yield*/, fetchGuestSessionToken$1()];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };

// This is to avoid dispatching unnecessary action for Notification
var localNotificationDispatchFlag = true;
var apiMiddleware = function (_a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return function (next) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, type, isAbsUrl, url, _a, enableProgress, _b, params, onSuccess, onFinally, _c, apiVersion, _d, isAuthorized, excludeFromDefaultHeaders, restApiOption, restApiConfig, appConfig, _e, language, StoreId, Currency, latitude, longitude, _f, isLocationCXEnable, 
        // foodPos,
        // nonFoodPos,
        expressPos, areaCode, requestUrl, data;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!isObject$1(action) || !isExisty$1(action.type)) {
                        return [2 /*return*/];
                    }
                    next(action);
                    payload = action.payload, type = action.type;
                    if (!payload || !payload.url) {
                        return [2 /*return*/];
                    }
                    isAbsUrl = payload.isAbsUrl, url = payload.url, _a = payload.enableProgress, enableProgress = _a === void 0 ? true : _a, _b = payload.params, params = _b === void 0 ? {} : _b, onSuccess = payload.onSuccess, onFinally = payload.onFinally, _c = payload.apiVersion, apiVersion = _c === void 0 ? 2 : _c, _d = payload.isAuthorized, isAuthorized = _d === void 0 ? true : _d, excludeFromDefaultHeaders = payload.excludeFromDefaultHeaders, restApiOption = __rest(payload, ["isAbsUrl", "url", "enableProgress", "params", "onSuccess", "onFinally", "apiVersion", "isAuthorized", "excludeFromDefaultHeaders"]);
                    if (!isAuthorized) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleGuestSession$1()];
                case 1:
                    _g.sent();
                    _g.label = 2;
                case 2:
                    restApiConfig = __rest(API_CONFIG$1, []);
                    appConfig = getState().appConfig;
                    _e = __assign(__assign({}, APP_CONFIG$1), appConfig), language = _e.language, StoreId = _e.storeId, Currency = _e.currency, latitude = _e.latitude, longitude = _e.longitude, _f = _e.features, isLocationCXEnable = (_f === void 0 ? { isLocationCXEnable: false } : _f).isLocationCXEnable, expressPos = _e.expressPos, areaCode = _e.areaCode;
                    requestUrl = url;
                    if (!isTestNodeEnv()) {
                        // Make sure to replace parameter variables (eg: /{{StoreId}}/{{language}}) in the request URL string
                        // But only for non-test environment!
                        requestUrl = replaceUrlVariables$1(url, __assign(__assign(__assign(__assign({}, restApiConfig), { isLocationCXEnable: isLocationCXEnable,
                            latitude: latitude,
                            longitude: longitude,
                            language: language,
                            StoreId: StoreId,
                            Currency: Currency,
                            // foodPos,
                            // nonFoodPos,
                            expressPos: expressPos,
                            areaCode: areaCode }), params), { lang: language }));
                    }
                    // Dispatch ${type}_START
                    if (enableProgress) {
                        dispatch(apiStart(type));
                    }
                    _g.label = 3;
                case 3:
                    _g.trys.push([3, , 5, 6]);
                    return [4 /*yield*/, networkRequest$1({
                            requestUrl: requestUrl,
                            isAbsUrl: isAbsUrl,
                            apiOptions: restApiOption,
                            apiVersion: apiVersion,
                            excludeFromDefaultHeaders: excludeFromDefaultHeaders,
                        })];
                case 4:
                    data = (_g.sent()).data;
                    if (onSuccess) {
                        dispatch(onSuccess(data));
                    }
                    else {
                        dispatch(apiSuccess(type, data));
                    }
                    // Hide and reset Notification
                    if (localNotificationDispatchFlag) {
                        dispatch(hideNotification());
                        localNotificationDispatchFlag = false;
                    }
                    return [3 /*break*/, 6];
                case 5:
                    if (onFinally) {
                        dispatch(onFinally());
                    }
                    // Dispatch ${type}_END if enableProgress
                    if (enableProgress) {
                        dispatch(apiEnd(type));
                    }
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }; };
};

/**
 * This contains the entire logic related to Urls Cookie + Configuration
 */
var URLS_CONFIG$1 = Object.freeze({
    get urlPrefix() {
        return "/" + APP_CONFIG$1.storeId + "/" + APP_CONFIG$1.language;
    },
});
var MY_ACCOUNT_PAGE = "/my-account";
var COOKIE_BANNER_PRIVACY_POLICY$1 = URLS_CONFIG$1.urlPrefix + "/privacypolicy";
var PROFILE_PAGE$1 = URLS_CONFIG$1.urlPrefix + "/profile";
var LOGIN_PAGE = "/login";
var CART_PAGE$1 = URLS_CONFIG$1.urlPrefix + "/cart";
var MY_ACCOUNT_ORDERS_PAGE = MY_ACCOUNT_PAGE + "/orders";
var MY_ACCOUNT_BUY_AGAIN_PAGE$1 = URLS_CONFIG$1.urlPrefix + "/buyAgain";
// React pages
var NEW_CART_PAGE = '/app/cart';
var NEW_ORDERS_PAGE = '/app/orders';
// React param types
var EUrlParams$1;
(function (EUrlParams) {
    EUrlParams["EXPRESS"] = "express";
})(EUrlParams$1 || (EUrlParams$1 = {}));

var GTMEvents$1;
(function (GTMEvents) {
    GTMEvents["custom_event"] = "custom_event";
    GTMEvents["add_to_cart"] = "add_to_cart";
    GTMEvents["remove_from_cart"] = "remove_from_cart";
    GTMEvents["product_click"] = "product_click";
    GTMEvents["virtual_page_event"] = "virtual_page_event";
    GTMEvents["category_page_event"] = "category_page_event";
    GTMEvents["product_impressions"] = "product_impressions";
    GTMEvents["promotion_click"] = "promotion_click";
    GTMEvents["promotion_impressions"] = "promotion_impressions";
    GTMEvents["product_impression"] = "product_impression";
    GTMEvents["right_click"] = "right_click";
    GTMEvents["select_item"] = "select_item";
    GTMEvents["view_item_list"] = "view_item_list";
    GTMEvents["now_journey_custom_events"] = "now_journey_custom_events";
    GTMEvents["algolia_custom_events"] = "algolia_custom_events";
    GTMEvents["change_the_quantity"] = "change_the_quantity";
    GTMEvents["platform"] = "web";
    GTMEvents["viewed_experiment"] = "viewed_experiment";
})(GTMEvents$1 || (GTMEvents$1 = {}));
var BrazeEvents$1;
(function (BrazeEvents) {
    BrazeEvents["cart_count"] = "cart_count";
    BrazeEvents["add_to_cart"] = "add_to_cart";
    BrazeEvents["pdp_view"] = "pdp_view";
    BrazeEvents["search"] = "search";
    BrazeEvents["search_term"] = "search_term";
    BrazeEvents["search_type"] = "search_type";
    BrazeEvents["search_native"] = "search_native";
    BrazeEvents["trending_search"] = "trending_search";
    BrazeEvents["history_search"] = "history_search";
    BrazeEvents["search_suggested"] = "search_suggested";
    BrazeEvents["category_interaction"] = "category_interaction";
    BrazeEvents["category_id"] = "category_id";
    BrazeEvents["category_name"] = "category_name";
    BrazeEvents["all_categories"] = "All Categories";
    BrazeEvents["search_results"] = "search_results";
})(BrazeEvents$1 || (BrazeEvents$1 = {}));
var PromotionEvents$1;
(function (PromotionEvents) {
    PromotionEvents["promotion_click"] = "promotion_click";
    PromotionEvents["promotion_impressions"] = "promotion_impressions";
    PromotionEvents["view_promotion"] = "view_promotion";
    PromotionEvents["select_promotion"] = "select_promotion";
})(PromotionEvents$1 || (PromotionEvents$1 = {}));
var Events$1;
(function (Events) {
    Events["product_click"] = "product_click";
    Events["add_to_cart"] = "add_to_cart";
    Events["product_impression"] = "product_impression";
    Events["right_click"] = "right_click";
})(Events$1 || (Events$1 = {}));
var GTMEventCategories$1;
(function (GTMEventCategories) {
    GTMEventCategories["user_engagement"] = "user_engagement";
    GTMEventCategories["enhanced_ecommerce"] = "enhanced_ecommerce";
    GTMEventCategories["sign_up"] = "signup_flow";
    GTMEventCategories["user_authentication"] = "user_authentication";
})(GTMEventCategories$1 || (GTMEventCategories$1 = {}));
var GTMEventActions$1;
(function (GTMEventActions) {
    GTMEventActions["search_results"] = "search_results";
    GTMEventActions["search_no_results"] = "search_no_results";
    GTMEventActions["product_gallery_viewed"] = "product_gallery_viewed";
    GTMEventActions["listing_filters"] = "listing_filters";
    GTMEventActions["listing_sort"] = "listing_sort";
    GTMEventActions["reorder_click"] = "reorder_click";
    GTMEventActions["category_interaction"] = "category_interaction";
    GTMEventActions["header_interaction"] = "header_interaction";
    GTMEventActions["announcement_interaction"] = "announcement_interaction";
    GTMEventActions["category_results"] = "category_results";
    GTMEventActions["category_no_results"] = "category_no_results";
    GTMEventActions["component_interaction"] = "component_interaction";
    GTMEventActions["search_facets"] = "search_facets";
    GTMEventActions["category_facets"] = "category_facets";
    GTMEventActions["reorder_search"] = "reorder_search";
    GTMEventActions["reorder_category"] = "reorder_category";
    GTMEventActions["login"] = "login";
    GTMEventActions["inline_filter"] = "inline_filter";
    GTMEventActions["marketing_strip_impression"] = "strip_header_impression";
    GTMEventActions["share_clicked"] = "share_clicked";
    GTMEventActions["product_click_notify_later"] = "product_click_notify_later";
    GTMEventActions["add_to_cart"] = "add_to_cart";
    GTMEventActions["remove_from_cart"] = "remove_from_cart";
    GTMEventActions["product_click"] = "product_click";
    GTMEventActions["product_impressions"] = "product_impressions";
    GTMEventActions["value_proposition_click"] = "value_proposition_click";
    GTMEventActions["got_it_click"] = "got_it_click";
    GTMEventActions["shop_now_click"] = "shop_now_click";
    GTMEventActions["shop_all_items_clicked"] = "shop_all_items_clicked";
    GTMEventActions["search_initiate"] = "search_initiate";
    GTMEventActions["first_user_coupon_banner_clicked"] = "first_user_coupon_banner_clicked";
    GTMEventActions["registration"] = "registration";
    GTMEventActions["fyc_icon_interaction"] = "fyc_icon_interaction";
    GTMEventActions["journey_selection_tab"] = "journey_selection_tab";
    GTMEventActions["address_icon_interaction"] = "address_icon_interaction";
    GTMEventActions["see_all_click"] = "see_all_click";
    GTMEventActions["change_address_done"] = "change_address_done";
    GTMEventActions["authentication"] = "authentication";
    GTMEventActions["email_login_password"] = "email_login_password";
    GTMEventActions["email_login_otp"] = "email_login_otp";
    GTMEventActions["signup"] = "signup";
    GTMEventActions["profile_interaction"] = "profile_interaction";
})(GTMEventActions$1 || (GTMEventActions$1 = {}));
var GTMNowJourneyEventTypes$1;
(function (GTMNowJourneyEventTypes) {
    GTMNowJourneyEventTypes["interaction"] = "interaction";
    GTMNowJourneyEventTypes["non_interaction"] = "non-interaction";
})(GTMNowJourneyEventTypes$1 || (GTMNowJourneyEventTypes$1 = {}));
var GTMEventLabels$1;
(function (GTMEventLabels) {
    GTMEventLabels["change_address_click"] = "change_address_click";
})(GTMEventLabels$1 || (GTMEventLabels$1 = {}));
var GTMBusyStateLabels$1;
(function (GTMBusyStateLabels) {
    GTMBusyStateLabels["busy_state_cta"] = "busy_state_cta";
    GTMBusyStateLabels["offline_state_cta"] = "offline_state_cta";
    GTMBusyStateLabels["busy_state"] = "busy_state";
    GTMBusyStateLabels["offline_state"] = "offline_state";
})(GTMBusyStateLabels$1 || (GTMBusyStateLabels$1 = {}));
var GTMNowJourneyLabels$1;
(function (GTMNowJourneyLabels) {
    GTMNowJourneyLabels["now_delivery"] = "now_delivery";
    GTMNowJourneyLabels["standard_delivery"] = "standard_delivery";
    GTMNowJourneyLabels["all_items"] = "all_items";
    GTMNowJourneyLabels["now_items"] = "now_items";
    GTMNowJourneyLabels["native_search"] = "Native Search";
    GTMNowJourneyLabels["both_tab_shown"] = "both_tab_shown";
    GTMNowJourneyLabels["not_shown"] = "not_shown";
    GTMNowJourneyLabels["new_journey_tab_impression"] = "new_journey_tab_impression";
})(GTMNowJourneyLabels$1 || (GTMNowJourneyLabels$1 = {}));
var LoggedInStatusVariants$1;
(function (LoggedInStatusVariants) {
    LoggedInStatusVariants["true"] = "1";
    LoggedInStatusVariants["false"] = "0";
})(LoggedInStatusVariants$1 || (LoggedInStatusVariants$1 = {}));
var NavigationMenuTypes$1;
(function (NavigationMenuTypes) {
    NavigationMenuTypes["horizontal_menu"] = "horizontal_menu";
    NavigationMenuTypes["all_category_menu"] = "all_category_menu";
})(NavigationMenuTypes$1 || (NavigationMenuTypes$1 = {}));

var debounce$1 = (function (func, wait, immediate) {
    if (immediate === void 0) { immediate = false; }
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // @ts-ignore
        var context = this;
        var later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        // @ts-ignore
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
});

var snakeCaseRegex$1 = /\s+/g;
var productImpressions$1 = {
    uaItemsList: [],
    ga4ItemsList: [],
};
var cachedInViewComponents = [];
var cashedproductImpressions$1 = {
    uaItemsList: [],
    ga4ItemsList: [],
};
var promotionImpressions$1 = {
    uaPromotionItemsList: [],
    ga4PromotionItemsList: [],
};
var cashedPromotionImpressions$1 = {
    uaPromotionItemsList: [],
    ga4PromotionItemsList: [],
};
var previousJourneySelection$1 = '';
var cachedImpressions$1 = [];
var toSnakeCase$2 = function (str) { return str.trim().replace(snakeCaseRegex$1, '_'); };
var gtmSnakeCase$1 = function (data) {
    if (isBoolean$1(data)) {
        if (data) {
            return 1;
        }
        return 0;
    }
    if (!isObject$1(data) && !isString$1(data)) {
        return data;
    }
    if (isString$1(data)) {
        return toSnakeCase$2(data);
    }
    if (data instanceof Array) {
        return data.map(function (obj) { return gtmSnakeCase$1(obj); });
    }
    var snakeCaseObj = {};
    if (data) {
        Object.keys(data).forEach(function (key) {
            var currentValue = data[key];
            if (key === 'currencyCode') {
                snakeCaseObj[key] = currentValue;
            }
            else {
                snakeCaseObj[key] = isString$1(currentValue) ? toSnakeCase$2(currentValue) : gtmSnakeCase$1(currentValue);
            }
        });
    }
    return snakeCaseObj;
};
var gtmAddToCart$1 = function (data, sharedData, ga4) {
    if (ga4 === void 0) { ga4 = false; }
    if (!ga4) {
        dataLayer.push(__assign(__assign({ event: GTMEvents$1.add_to_cart }, sharedData), { ecommerce: {
                add: {
                    actionField: {
                        list: (sharedData === null || sharedData === void 0 ? void 0 : sharedData.screen_type) + "|" + (data === null || data === void 0 ? void 0 : data.dimension103),
                        position: data === null || data === void 0 ? void 0 : data.position,
                    },
                    products: [gtmSnakeCase$1(data)],
                },
            } }));
    }
    else {
        dataLayer.push(__assign(__assign({ event: GTMEvents$1.add_to_cart }, sharedData), { ecommerce: {
                items: [gtmSnakeCase$1(data)],
            } }));
    }
};
var gtmRemoveToCart$1 = function (data, sharedData, ga4) {
    if (ga4 === void 0) { ga4 = false; }
    if (!ga4) {
        dataLayer.push(__assign(__assign({ event: GTMEvents$1.remove_from_cart }, sharedData), { ecommerce: {
                remove: {
                    actionField: {
                        list: (sharedData === null || sharedData === void 0 ? void 0 : sharedData.screen_type) + "|" + (data === null || data === void 0 ? void 0 : data.dimension103),
                        position: data === null || data === void 0 ? void 0 : data.position,
                    },
                    products: [gtmSnakeCase$1(data)],
                },
            } }));
    }
    else {
        dataLayer.push(__assign(__assign({ event: GTMEvents$1.remove_from_cart }, sharedData), { ecommerce: {
                items: [gtmSnakeCase$1(data)],
            } }));
    }
};
var gtmCustomEvent$1 = function (eventCategory, eventAction, eventLabel, extraObj, sharedData, pageData, pos_code, event_type, journey_selection, customEventNonFoodJourneyParams, ga4) {
    if (eventCategory === void 0) { eventCategory = GTMEventCategories$1.user_engagement; }
    dataLayer.push(__assign(__assign(__assign(__assign(__assign(__assign({ event: GTMEvents$1.custom_event, event_category: eventCategory, event_action: eventAction, event_label: eventLabel }, sharedData), gtmSnakeCase$1(extraObj)), pageData), { pos_code: pos_code,
        event_type: event_type,
        journey_selection: journey_selection }), customEventNonFoodJourneyParams), { ga4: ga4 }));
};
var gtmPromotionClick$1 = function (eventType, sharedData, promotionData, ga4) {
    if (ga4) {
        dataLayer.push(__assign(__assign({ event: PromotionEvents$1.select_promotion }, sharedData), { ga4: ga4, ecommerce: {
                items: [
                    __assign({}, promotionData),
                ],
            } }));
    }
    else {
        dataLayer.push(__assign(__assign({ event: eventType }, sharedData), { ga4: ga4, ecommerce: {
                promoView: __assign({}, promotionData),
            } }));
    }
};
var gtmProductClick$1 = function (data, actionField, sharedData, ga4) {
    if (ga4 === void 0) { ga4 = false; }
    if (data && actionField && !ga4) {
        var snakeCaseData = gtmSnakeCase$1(data);
        dataLayer.push(__assign(__assign({ event: GTMEvents$1.product_click }, sharedData), { ecommerce: {
                click: {
                    actionField: __assign(__assign({}, actionField), { list: snakeCaseData === null || snakeCaseData === void 0 ? void 0 : snakeCaseData.list }) || '',
                    products: [snakeCaseData],
                },
            } }));
    }
    else {
        dataLayer.push(__assign(__assign({ event: GTMEvents$1.select_item }, sharedData), { ecommerce: {
                items: [gtmSnakeCase$1(data)],
            } }));
    }
};
var gtmVirtualPage$1 = function (pageTitle, sharedData) {
    dataLayer.push(__assign({ event: GTMEvents$1.virtual_page_event, virtual_page_url: typeof window !== 'undefined' ? window.location.href : '', virtual_page_title: pageTitle || '' }, sharedData));
};
var gtmCategoryPage$1 = function (l1Category, l2Category, l3Category, sharedData) {
    dataLayer.push(__assign({ event: GTMEvents$1.category_page_event, L1_category: l1Category || '', L2_category: l2Category || '', L3_category: l3Category || '' }, sharedData));
};
var gtmPromotionImpression$1 = function (eventType, sharedData, promotionData, ga4) {
    if (promotionData) {
        if (ga4) {
            var passedData = promotionImpressions$1.ga4PromotionItemsList.filter(function (promotion) { return promotion.id === promotionData.id; });
            var cashedData = cashedPromotionImpressions$1.ga4PromotionItemsList.filter(function (promotion) { return promotion.id === promotionData.id; });
            if (passedData.length === 0 && cashedData.length === 0) {
                promotionImpressions$1.ga4PromotionItemsList.push(promotionData);
            }
            pushGAPromotionImpression$1(sharedData);
        }
        else {
            var passedData = promotionImpressions$1.uaPromotionItemsList.filter(function (promotion) { return promotion.id === promotionData.id; });
            var cashedData = cashedPromotionImpressions$1.uaPromotionItemsList.filter(function (promotion) { return promotion.id === promotionData.id; });
            if (passedData.length === 0 && cashedData.length === 0) {
                promotionImpressions$1.uaPromotionItemsList.push(promotionData);
            }
            pushUAPromotionImpression$1(eventType, sharedData);
        }
    }
};
var pushUAPromotionImpression$1 = function (eventType, sharedData) {
    debounce$1(function () {
        var _a;
        while (promotionImpressions$1.uaPromotionItemsList.length > 0) {
            dataLayer.push(__assign(__assign({ event: eventType }, sharedData), { ga4: 'false', ecommerce: {
                    promoView: {
                        promotions: promotionImpressions$1.uaPromotionItemsList.slice(0, 25),
                    },
                } }));
            (_a = cashedPromotionImpressions$1.uaPromotionItemsList).push.apply(_a, __spread(promotionImpressions$1.uaPromotionItemsList.slice(0, 25)));
            promotionImpressions$1.uaPromotionItemsList.splice(0, 25);
        }
    }, 1000)();
};
var pushGAPromotionImpression$1 = function (sharedData) {
    debounce$1(function (sharedData) {
        var _a;
        while (promotionImpressions$1.ga4PromotionItemsList.length > 0) {
            var items = promotionImpressions$1.ga4PromotionItemsList.slice(0, 25).map(function (item) { return ({
                creative_name: item.creative,
                creative_slot: item.position || '',
                index: item.position,
                item_list_name: '',
                promotion_id: item.id,
                promotion_name: item.name,
            }); });
            dataLayer.push(__assign(__assign({ event: PromotionEvents$1.view_promotion, ga4: 'true' }, sharedData), { ecommerce: {
                    items: items,
                } }));
            (_a = cashedPromotionImpressions$1.ga4PromotionItemsList).push.apply(_a, __spread(promotionImpressions$1.ga4PromotionItemsList.slice(0, 25)));
            promotionImpressions$1.ga4PromotionItemsList.splice(0, 25);
        }
    }, 1000)(sharedData);
};
var gtmProductImpression$1 = function (data, sharedData, ga4) {
    if (ga4 === void 0) { ga4 = false; }
    var currentJourneySelection = sharedData && (sharedData === null || sharedData === void 0 ? void 0 : sharedData.journey_selection) ? sharedData.journey_selection : '';
    if (data) {
        if (ga4) {
            var passedData = productImpressions$1.ga4ItemsList.filter(function (product) { return product.item_id === data.item_id; });
            var cashedData = cashedproductImpressions$1.ga4ItemsList.filter(function (product) {
                return product.item_id === data.item_id && previousJourneySelection$1 === currentJourneySelection;
            });
            if (passedData.length === 0 && cashedData.length === 0) {
                productImpressions$1.ga4ItemsList.push(gtmSnakeCase$1(data));
            }
            pushGA4ProductImpression$1(sharedData, currentJourneySelection);
        }
        else {
            var passedData = productImpressions$1.uaItemsList.filter(function (product) { return product.id === data.id; });
            var cashedData = cashedproductImpressions$1.uaItemsList.filter(function (product) { return product.id === data.id && previousJourneySelection$1 === currentJourneySelection; });
            if (passedData.length === 0 && cashedData.length === 0) {
                productImpressions$1.uaItemsList.push(gtmSnakeCase$1(data));
            }
            pushUAProductImpression$1(sharedData, currentJourneySelection);
        }
    }
};
var pushUAProductImpression$1 = function (sharedData, currentJourneySelection) {
    debounce$1(function () {
        while (productImpressions$1.uaItemsList.length > 0) {
            previousJourneySelection$1 = currentJourneySelection;
            dataLayer.push(__assign(__assign({ event: GTMEvents$1.product_impressions }, sharedData), { ecommerce: {
                    impressions: productImpressions$1.uaItemsList.slice(0, 25),
                } }));
            cashedproductImpressions$1.uaItemsList.push(productImpressions$1.uaItemsList.slice(0, 25));
            productImpressions$1.uaItemsList.splice(0, 25);
        }
    }, 1000)();
};
var pushGA4ProductImpression$1 = function (sharedData, currentJourneySelection) {
    debounce$1(function (sharedData) {
        while (productImpressions$1.ga4ItemsList.length > 0) {
            previousJourneySelection$1 = currentJourneySelection;
            dataLayer.push(__assign(__assign({ event: GTMEvents$1.view_item_list }, sharedData), { ecommerce: {
                    items: productImpressions$1.ga4ItemsList.slice(0, 25),
                } }));
            cashedproductImpressions$1.ga4ItemsList.push(productImpressions$1.ga4ItemsList.slice(0, 25));
            productImpressions$1.ga4ItemsList.splice(0, 25);
        }
    }, 1000)(sharedData);
};
var isImpressionTracked$1 = function (productCard) {
    var cachedData = cachedImpressions$1.filter(function (product) { return product.sponsorID === productCard.sponsorID; });
    if (cachedData.length === 0) {
        cachedImpressions$1.push(productCard);
        return false;
    }
    return true;
};
var emptyCachedImpression = function () {
    cachedImpressions$1 = [];
};
var nowJourneyCustomEvents$1 = function (eventCategory, eventAction, eventLabel, event_type, journey_selection, pageData) {
    if (eventCategory === void 0) { eventCategory = GTMEventCategories$1.user_engagement; }
    dataLayer.push(__assign(__assign({}, pageData), { event: GTMEvents$1.custom_event, event_category: eventCategory, event_action: eventAction, event_label: eventLabel, event_type: event_type,
        journey_selection: journey_selection }));
};
var algoliaServiceGAEvent$1 = function (experiment_key, variation_id, pageData) {
    dataLayer.push({
        event: 'viewed_experiment',
        params: {
            experiment_key: experiment_key,
            variation_value: '',
            variation_id: variation_id,
            currency: pageData === null || pageData === void 0 ? void 0 : pageData.currency,
            language: pageData === null || pageData === void 0 ? void 0 : pageData.language,
        },
    });
};
var trackInViewCarousels = function (_a) {
    var component = _a.component, onView = _a.onView;
    var filteredItems = cachedInViewComponents.find(function (item) {
        var _a, _b;
        if (!!item.id)
            return item.id === component.id;
        return ((_a = item === null || item === void 0 ? void 0 : item.main) === null || _a === void 0 ? void 0 : _a.id) === ((_b = component === null || component === void 0 ? void 0 : component.main) === null || _b === void 0 ? void 0 : _b.id);
    });
    if (!filteredItems) {
        cachedInViewComponents.push(component);
        pushOnView(onView);
    }
};
var pushOnView = function (onView) {
    debounce$1(function () {
        if (cachedInViewComponents.length)
            onView(cachedInViewComponents, false);
        cachedInViewComponents = [];
    }, 500)();
};

var getSearchIntent$1 = function (pageIntent, deliveryTime, selectedTabIndex, isSearchPage) {
    var _a, _b, _c, _d;
    if (isSearchPage === void 0) { isSearchPage = false; }
    var intent = '';
    if (pageIntent) {
        var isNowJourney = isBrowser$1() && getNowJourneyCookie$1() === 'true' && !!(deliveryTime === null || deliveryTime === void 0 ? void 0 : deliveryTime.expressSlot);
        var nowSelected = selectedTabIndex === 1 || isNowJourney;
        var isOfflineHours = ((_b = (_a = deliveryTime === null || deliveryTime === void 0 ? void 0 : deliveryTime.expressSlot) === null || _a === void 0 ? void 0 : _a.busyStatus) === null || _b === void 0 ? void 0 : _b.isBusy) ||
            (!((_c = deliveryTime === null || deliveryTime === void 0 ? void 0 : deliveryTime.expressSlot) === null || _c === void 0 ? void 0 : _c.isAvailable) && ((_d = deliveryTime === null || deliveryTime === void 0 ? void 0 : deliveryTime.expressSlot) === null || _d === void 0 ? void 0 : _d.nextAvailableSlot));
        if (nowSelected && (isSearchPage || !isOfflineHours)) {
            intent = 'NOW';
        }
        else {
            intent = 'STANDARD';
        }
    }
    return intent;
};
var extractServiceInfoFromCookie$1 = function () {
    var _a = getSelectedTabData$1(), serviceType = _a.serviceType, productType = _a.productType;
    return { serviceType: serviceType, productType: productType };
};
var extractSelectedTabFromCookie$1 = function () {
    var selectedTabId = getSelectedTabData$1().selectedTabId;
    return Number(selectedTabId) || -1;
};
var isServiceTypeAny$1 = function (pageStructure, selectedTab) {
    if (pageStructure === void 0) { pageStructure = []; }
    if (selectedTab === void 0) { selectedTab = -1; }
    var selectedId = selectedTab;
    if (typeof selectedTab === undefined) {
        selectedId = extractSelectedTabFromCookie$1();
    }
    return pageStructure.some(function (_a) {
        var _b = _a.serviceType, serviceType = _b === void 0 ? '' : _b, id = _a.id;
        return serviceType === IServiceInfo$1.ANY && id === selectedId;
    });
};
var getIntentAndServiceType$1 = function (pageStructure, selectedTab) {
    if (pageStructure === void 0) { pageStructure = []; }
    var intentHeaders = {};
    if (!isBrowser$1() && selectedTab) {
        var _a = (pageStructure === null || pageStructure === void 0 ? void 0 : pageStructure.find(function (navigation) { return navigation.id === selectedTab; })) || (pageStructure === null || pageStructure === void 0 ? void 0 : pageStructure[0]), _b = _a.serviceType, serviceType = _b === void 0 ? '' : _b, _c = _a.productType, productType = _c === void 0 ? '' : _c;
        intentHeaders = { intent: serviceType, productType: productType };
    }
    else {
        var _d = extractServiceInfoFromCookie$1() || pageStructure, serviceType = _d.serviceType, productType = _d.productType;
        intentHeaders = { intent: serviceType, productType: productType };
    }
    return intentHeaders;
};
var getBasketIntentOnCookieBasis$1 = function (isOfflineHours) {
    var isNowJourney = getNowJourneyCookie$1();
    return isNowJourney === 'true' && !isOfflineHours ? 'EXPRESS' : '';
};
var evaluateBasketIntent$1 = function (shouldSendIntent, isOfflineHours) {
    var intent = {};
    if (shouldSendIntent) {
        var intentValue = getBasketIntentOnCookieBasis$1(isOfflineHours);
        intent = intentValue
            ? {
                intent: intentValue,
            }
            : {};
    }
    return intent;
};
var getBasketIntent$1 = function (state, selectedIntent) {
    var _a, _b;
    if (selectedIntent) {
        return { intent: selectedIntent };
    }
    var shouldSendIntent = !!state.appConfig.pageIntent;
    var isOfflineHours = !!((_b = (_a = state === null || state === void 0 ? void 0 : state.deliveryTime) === null || _a === void 0 ? void 0 : _a.expressSlot) === null || _b === void 0 ? void 0 : _b.nextAvailableSlot) || false;
    return evaluateBasketIntent$1(shouldSendIntent, isOfflineHours);
};
var isNewC4Journey$1 = function (state) {
    var _a;
    var newJourney = getGrowthBookFeatureValueViaInstance$1(state, 'new_carrefour_journey');
    return ((_a = newJourney === null || newJourney === void 0 ? void 0 : newJourney.value) === null || _a === void 0 ? void 0 : _a.new_journey) || false;
};
var isAdTechCriteoEnabled$1 = function (state) {
    var adTechCretio = getGrowthBookFeatureValueViaInstance$1(state, GROWTHBOOK_FLAGS$1.adtechCriteo);
    return (adTechCretio === null || adTechCretio === void 0 ? void 0 : adTechCretio.on) || false;
};
var isNonFoodV2Enabled$1 = function (state) {
    var _a;
    var _b = (((_a = getGrowthBookFeatureValueViaInstance$1(state, GROWTHBOOK_FLAGS$1.non_food_v2)) === null || _a === void 0 ? void 0 : _a.value) || {}).pageStructureUid, pageStructureUid = _b === void 0 ? '' : _b;
    return { value: !!pageStructureUid || false, pageStructureUid: pageStructureUid };
};
var isStoreClosureEnabled$1 = function (state) {
    var _a;
    return ((_a = getGrowthBookFeatureValueViaInstance$1(state, GROWTHBOOK_FLAGS$1.store_closure_enabled)) === null || _a === void 0 ? void 0 : _a.on) || false;
};

var newC4Journey_util$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getSearchIntent: getSearchIntent$1,
    extractServiceInfoFromCookie: extractServiceInfoFromCookie$1,
    extractSelectedTabFromCookie: extractSelectedTabFromCookie$1,
    isServiceTypeAny: isServiceTypeAny$1,
    getIntentAndServiceType: getIntentAndServiceType$1,
    getBasketIntent: getBasketIntent$1,
    isNewC4Journey: isNewC4Journey$1,
    isAdTechCriteoEnabled: isAdTechCriteoEnabled$1,
    isNonFoodV2Enabled: isNonFoodV2Enabled$1,
    isStoreClosureEnabled: isStoreClosureEnabled$1
});

var getListName$1 = function (listName, currentPageType, category) {
    var listData = listName === null || listName === void 0 ? void 0 : listName.split('|')[1];
    if (listName === null || listName === void 0 ? void 0 : listName.includes(constants$1.sponsoredListing)) {
        return listName;
    }
    if (currentPageType === constants$1.productSearch) {
        return "productSearch|" + listData;
    }
    if (currentPageType === constants$1.categorySearch) {
        return "category|" + category;
    }
    if (currentPageType === constants$1.home) {
        return (listName === null || listName === void 0 ? void 0 : listName.includes(constants$1.multiLevelCarousel)) ? listName : "carousel|" + listName;
    }
    if (currentPageType === constants$1.productDetails) {
        return "product_details|" + listName;
    }
    if (currentPageType === constants$1.cart) {
        return "cart|" + listName;
    }
    if (currentPageType === constants$1.reOrder) {
        return listName || 'BuyAgain';
    }
    return '';
};
var getJourneySelectionParams$1 = function (journey_selection, prefix) {
    var _a, _b;
    if (journey_selection === void 0) { journey_selection = ''; }
    if (prefix === void 0) { prefix = ''; }
    var _c = extractServiceInfoFromCookie$1(), serviceType = _c.serviceType, productType = _c.productType;
    if (serviceType || productType) {
        return _a = {},
            _a[prefix + "product_type"] = productType.toLowerCase(),
            _a[prefix + "service_type"] = serviceType.toLowerCase(),
            _a[prefix + "journey_selection"] = (serviceType + "_" + productType).toLowerCase(),
            _a;
    }
    else
        return _b = {},
            _b[prefix + "journey_selection"] = journey_selection,
            _b;
};

var cookies$3 = new Cookies();
var GTMDataTransformer$1 = /** @class */ (function () {
    function GTMDataTransformer() {
        this.pageGTMData = function (pageData) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var market = pageData.market, language = pageData.language, currency = pageData.currency, areaCode = pageData.areaCode, selectedCity = pageData.selectedCity, loggedInStatus = pageData.loggedInStatus, 
            // pageType = '',
            userHashedEmail = pageData.userHashedEmail, userLoyaltyPoint = pageData.userLoyaltyPoint, myClubId = pageData.myClubId, email = pageData.email, defaultAddress = pageData.defaultAddress, 
            // userNationalityId,
            userFirstTransaction = pageData.userFirstTransaction, storeId = pageData.storeId;
            var pageType = getPageType$1();
            var pathname = (typeof window !== 'undefined' && window.location.pathname) || '';
            var clpId = pathname.split('/').find(function (ele) { return ele.includes('clp_'); });
            var blpId = pathname.split('/').pop();
            var isLoggedIn = loggedInStatus === LoggedInStatusVariants$1.true;
            var isPdpPlpClpHome = [
                constants$1.home,
                constants$1.categoryLandingPage,
                constants$1.brandLandingPage,
                constants$1.productSearch,
                constants$1.categorySearch,
                constants$1.productDetails,
            ].includes(pageType);
            var pageInfo = {};
            if (pageType === constants$1.categorySearch && isBrowser$1()) {
                var bredCrumb = (_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.__NEXT_DATA__) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.initialState) === null || _c === void 0 ? void 0 : _c.search) === null || _d === void 0 ? void 0 : _d.breadCrumb;
                if (Array.isArray(bredCrumb)) {
                    pageInfo.l1_category = ((_e = bredCrumb[0]) === null || _e === void 0 ? void 0 : _e.name) || '';
                    pageInfo.l2_category = ((_f = bredCrumb[1]) === null || _f === void 0 ? void 0 : _f.name) || '';
                    pageInfo.l3_category = ((_g = bredCrumb[2]) === null || _g === void 0 ? void 0 : _g.name) || '';
                }
            }
            return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ market: market || storeId, language: language,
                currency: currency, business_type: 'B2C', logged_in_status: isLoggedIn ? 'true' : 'false', first_transaction: userFirstTransaction || 'false', delivery_city: selectedCity || ((_h = defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.country) === null || _h === void 0 ? void 0 : _h.name), delivery_area_code: areaCode, page_url: typeof window !== 'undefined' ? window.location.href : '', screen_type: GTMDataTransformer.getPageType(pageType), screen_name: GTMDataTransformer.getScreenName(pageType) }, (isLoggedIn && { my_club_member_id: myClubId || '' })), (isLoggedIn && { loyalty_point: userLoyaltyPoint || '' })), (isLoggedIn && { hashed_email: cookies$3.get(constants$1.rrUserId) || email || userHashedEmail })), (isPdpPlpClpHome && { screen_type_sessionDimension: GTMDataTransformer.getPageType(pageType) })), (pageType === constants$1.home && { home_pageview: 1 })), (pageType === constants$1.categoryLandingPage && { clp_pageview: 1 })), (pageType === constants$1.brandLandingPage && { blp_pageview: 1 })), ((pageType === constants$1.categorySearch || pageType === constants$1.productSearch) && { plp_pageview: 1 })), (pageType === constants$1.productDetails && { pdp_pageview: 1 })), (pageType === constants$1.categoryLandingPage && { clp: clpId })), (pageType === constants$1.brandLandingPage && { blp: blpId })), pageInfo);
        };
        /**
         * transform the final GTM event datalayer based on the eventType
         * @param {GTMEvents} eventType
         * @param {IEventGTMData} eventData - the data which will contain data of product level and event level
         */
        this.getGTMData = function (eventType, eventData) {
            var _a, _b, _c, _d, _e, _f, _g;
            var productState = eventData.productState, otherData = eventData.otherData;
            var countryCode = eventData.otherData.countryCode;
            var _h = __assign(__assign({}, productState), otherData), productId = _h.productId, _j = _h.listName, listName = _j === void 0 ? '' : _j, eventAction = _h.eventAction, searchKeyword = _h.searchKeyword, searchCount = _h.searchCount, categoryId = _h.categoryId, pageTitle = _h.pageTitle, l1Category = _h.l1Category, l2Category = _h.l2Category, l3Category = _h.l3Category, quantity = _h.quantity, sortValue = _h.sortValue, _k = _h.searchType, searchType = _k === void 0 ? '' : _k, filterValue = _h.filterValue, inlineFilterData = _h.inlineFilterData, productTitle = _h.productTitle, listingFilterData = _h.listingFilterData, 
            // cartId,
            superCategory = _h.superCategory, mainCategory = _h.mainCategory, subCategory = _h.subCategory, 
            // menuType,
            componentPosition = _h.componentPosition, componentName = _h.componentName, componentSlot = _h.componentSlot, _l = _h.eventLabel, eventLabel = _l === void 0 ? '' : _l, _m = _h.pageData, pageData = _m === void 0 ? {} : _m, pageType = _h.pageType, posInfo = _h.posInfo, ga4 = _h.ga4, isAvailable = _h.isAvailable, isScalable = _h.isScalable, event_type = _h.event_type, _o = _h.category, category = _o === void 0 ? '' : _o, _p = _h.experiment_key, experiment_key = _p === void 0 ? '' : _p, _q = _h.variation_id, variation_id = _q === void 0 ? '' : _q, _r = _h.discount, discount = _r === void 0 ? '' : _r, _s = _h.value, value = _s === void 0 ? '' : _s, _t = _h.price, price = _t === void 0 ? '' : _t, _u = _h.scalable_weight, scalable_weight = _u === void 0 ? '' : _u;
            var GTMData = {};
            var pageUrl = typeof window !== 'undefined' ? window.location.href : '';
            var searchTypeVals = ['search_suggested', 'trending_search', 'search_history'];
            var search_type_value = searchTypeVals.includes(searchType) ? 'suggested' : 'native';
            var decodeSearchKeyword = decodeStr$1(searchKeyword);
            var _v = __read(APP_CONFIG$1.__cookie__.storeInfoCookieValue, 3), storeid = _v[0], language = _v[1], currency = _v[2];
            var pathname = (typeof window !== 'undefined' && window.location.pathname) || '';
            var clpId = pathname.split('/').find(function (ele) { return ele.includes('clp_'); }) || '';
            var search;
            GTMData.eventData = {};
            GTMData.customEventNonFoodJourneyParams = {};
            if (pageType === 'productsearch' && isBrowser$1()) {
                search = window.localStorage.getItem('searchKeyword') || '';
            }
            var sharedData = __assign(__assign({ market: storeid, page_url: pageUrl, screen_type: GTMDataTransformer.getPageType(pageType || ''), screen_name: GTMDataTransformer.getScreenName(pageType || '') }, (search && {
                search_keyword: JSON.parse(search),
            })), { ga4: ga4 ? 'true' : 'false' });
            if (ga4) {
                GTMData.eventData.stock_status = isAvailable ? 'true' : 'false';
                GTMData.eventData.currency = currency;
                GTMData.eventData.module_name = 'c4_main';
                GTMData.eventData.language = language;
            }
            if (pageType === constants$1.categorySearch && isBrowser$1()) {
                var bredCrumb = (_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.__NEXT_DATA__) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.initialState) === null || _c === void 0 ? void 0 : _c.search) === null || _d === void 0 ? void 0 : _d.breadCrumb;
                if (Array.isArray(bredCrumb)) {
                    GTMData.eventData.l1_category = ((_e = bredCrumb[0]) === null || _e === void 0 ? void 0 : _e.name) || '';
                    GTMData.eventData.l2_category = ((_f = bredCrumb[1]) === null || _f === void 0 ? void 0 : _f.name) || '';
                    GTMData.eventData.l3_category = ((_g = bredCrumb[2]) === null || _g === void 0 ? void 0 : _g.name) || '';
                }
            }
            if (pageType === constants$1.categorySearch) {
                if (l1Category)
                    GTMData.eventData.l1_category = l1Category;
                if (l2Category)
                    GTMData.eventData.l2_category = l2Category;
                if (l3Category)
                    GTMData.eventData.l3_category = l3Category;
            }
            if (decodeSearchKeyword)
                GTMData.eventData.search_keyword = decodeSearchKeyword;
            var new_journey_selection = getNowJourneyCookie$1()
                ? GTMNowJourneyLabels$1.now_items
                : GTMNowJourneyLabels$1.all_items;
            GTMData.eventData.journey_selection = new_journey_selection;
            GTMData.eventData.screen_name = GTMDataTransformer.getScreenName(pageType || '');
            GTMData.eventData.screen_type = GTMDataTransformer.getPageType(pageType || '');
            if (ga4 && eventType !== GTMEvents$1.add_to_cart && eventType !== GTMEvents$1.remove_from_cart) {
                GTMData.eventData.scalable_weights = isScalable ? quantity + "gms" : '';
            }
            switch (eventType) {
                case GTMEvents$1.product_click:
                    if (!ga4) {
                        GTMData.actionField = { list: listName || '', action: 'click' };
                        GTMData.data = GTMDataTransformer.productGTMData(productState, eventType);
                        GTMData.eventData = __assign(__assign(__assign({ event_category: GTMEventCategories$1.enhanced_ecommerce, event_action: GTMEventActions$1.product_click, event_label: listName }, sharedData), GTMData.eventData), { journey_selection: new_journey_selection, event_type: GTMNowJourneyEventTypes$1.interaction });
                    }
                    else {
                        GTMData.data = __assign(__assign({}, GTMDataTransformer.productGTMData(productState, eventType, ga4, countryCode)), { quantity: quantity });
                        GTMData.eventData = __assign(__assign(__assign(__assign({ event_category: GTMEventCategories$1.enhanced_ecommerce, event_action: GTMEventActions$1.product_click, event_label: !ga4 ? productId : productId + "_" + countryCode }, sharedData), GTMData.eventData), getJourneySelectionParams$1(new_journey_selection)), { event_type: GTMNowJourneyEventTypes$1.interaction });
                    }
                    break;
                case GTMEvents$1.product_impressions:
                    if (ga4) {
                        GTMData.data = GTMDataTransformer.productGTMData(productState, eventType, ga4, countryCode);
                        GTMData.eventData = __assign(__assign(__assign(__assign({ event_category: GTMEventCategories$1.enhanced_ecommerce, event_action: GTMEventActions$1.product_impressions, event_label: getListName$1(listName, pageType, category) }, sharedData), GTMData.eventData), getJourneySelectionParams$1(new_journey_selection)), { event_type: GTMNowJourneyEventTypes$1.non_interaction });
                    }
                    else {
                        GTMData.data = GTMDataTransformer.productGTMData(productState, eventType);
                        GTMData.eventData = __assign(__assign(__assign({ event_category: GTMEventCategories$1.enhanced_ecommerce, event_action: GTMEventActions$1.product_impressions, event_label: listName }, sharedData), GTMData.eventData), { journey_selection: new_journey_selection, event_type: GTMNowJourneyEventTypes$1.non_interaction });
                    }
                    break;
                case GTMEvents$1.virtual_page_event:
                    GTMData.pageTitle = pageTitle || '';
                    break;
                case GTMEvents$1.category_page_event:
                    GTMData.l1Category = l1Category || '';
                    GTMData.l2Category = l2Category || '';
                    GTMData.l3Category = l3Category || '';
                    break;
                case GTMEvents$1.add_to_cart:
                    GTMData.data = __assign(__assign({}, GTMDataTransformer.productGTMData(productState, eventType, ga4, countryCode)), { quantity: quantity,
                        discount: discount,
                        price: price,
                        scalable_weight: scalable_weight });
                    GTMData.eventData = __assign(__assign(__assign(__assign({ value: value, event_category: GTMEventCategories$1.enhanced_ecommerce, event_action: GTMEventActions$1.add_to_cart, event_label: !ga4 ? productId : productId + "_" + countryCode }, sharedData), GTMData.eventData), getJourneySelectionParams$1(new_journey_selection)), { currency: currency, event_type: GTMNowJourneyEventTypes$1.interaction });
                    break;
                case GTMEvents$1.remove_from_cart:
                    GTMData.data = __assign(__assign({}, GTMDataTransformer.productGTMData(productState, eventType, ga4, countryCode)), { quantity: quantity,
                        discount: discount,
                        price: price,
                        scalable_weight: scalable_weight });
                    GTMData.eventData = __assign(__assign(__assign(__assign({ event_category: GTMEventCategories$1.enhanced_ecommerce, value: value, event_action: GTMEventActions$1.remove_from_cart, event_label: !ga4 ? productId : productId + "_" + countryCode }, sharedData), GTMData.eventData), getJourneySelectionParams$1(new_journey_selection)), { event_type: GTMNowJourneyEventTypes$1.interaction, currency: currency });
                    break;
                case GTMEvents$1.custom_event:
                    switch (eventAction) {
                        case GTMEventActions$1.search_results:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = decodeSearchKeyword || '';
                            GTMData.customEventNonFoodJourneyParams = getJourneySelectionParams$1(new_journey_selection);
                            GTMData.event_type = GTMNowJourneyEventTypes$1.interaction;
                            GTMData.extraObj = {
                                search_results_count: searchCount,
                                search_results_pageview: 1,
                                search_type: search_type_value,
                                market: storeid,
                                language: language,
                            };
                            GTMData.pageData = {
                                search_keyword: decodeSearchKeyword || '',
                                screen_name: document.title,
                                screen_type: constants$1.productSearch,
                                page_url: pageUrl,
                            };
                            GTMData.posInfo = ((posInfo === null || posInfo === void 0 ? void 0 : posInfo.foodPos) || '0') + " | " + ((posInfo === null || posInfo === void 0 ? void 0 : posInfo.expressPos) || '0') + " | " + ((posInfo === null || posInfo === void 0 ? void 0 : posInfo.nonFoodPos) || '0');
                            break;
                        case GTMEventActions$1.search_no_results:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = decodeSearchKeyword || '';
                            GTMData.customEventNonFoodJourneyParams = getJourneySelectionParams$1(new_journey_selection);
                            GTMData.event_type = GTMNowJourneyEventTypes$1.interaction;
                            GTMData.extraObj = {
                                search_results_count: 0,
                                search_results_pageview: 1,
                                search_type: search_type_value,
                                market: storeid,
                                language: language,
                            };
                            GTMData.pageData = {
                                screen_name: document.title,
                                screen_type: constants$1.productSearch,
                                page_url: pageUrl,
                                search_keyword: decodeSearchKeyword || '',
                            };
                            GTMData.posInfo = ((posInfo === null || posInfo === void 0 ? void 0 : posInfo.foodPos) || '0') + " | " + ((posInfo === null || posInfo === void 0 ? void 0 : posInfo.expressPos) || '0') + " | " + ((posInfo === null || posInfo === void 0 ? void 0 : posInfo.nonFoodPos) || '0');
                            break;
                        case GTMEventActions$1.component_interaction:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = componentPosition;
                            GTMData.extraObj = {
                                component_name: componentName,
                                component_slot: componentSlot,
                                component_position: componentPosition,
                            };
                            break;
                        case GTMEventActions$1.listing_sort:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = sortValue;
                            GTMData.extraObj = {
                                dimension9: searchType || '',
                            };
                            break;
                        case GTMEventActions$1.listing_filters:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = listingFilterData || '';
                            GTMData.pageData = __assign(__assign({ filter_selected: listingFilterData || '', screen_name: document.title, page_url: pageUrl }, (l1Category && { screen_type: constants$1.category })), (searchKeyword && { screen_type: constants$1.productSearch, search_keyword: decodeSearchKeyword || '' }));
                            GTMData.extraObj = __assign(__assign({ filter_events: 1, market: storeid, language: language }, (l1Category && {
                                L1_category: l1Category,
                                L2_category: l2Category || '',
                                L3_category: l3Category || '',
                            })), (searchKeyword && {
                                search_type: search_type_value,
                                // search_results_count: searchCount,
                                search_results_pageview: 1,
                            }));
                            break;
                        case GTMEventActions$1.search_facets:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = filterValue;
                            break;
                        case GTMEventActions$1.category_facets:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = filterValue;
                            break;
                        case GTMEventActions$1.category_interaction:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel =
                                eventLabel ||
                                    (superCategory && "L1_category_" + categoryId) ||
                                    (mainCategory && "L2_category_" + categoryId) ||
                                    "L3_category_" + categoryId;
                            GTMData.extraObj = __assign(__assign(__assign({}, sharedData), { l1_category: superCategory, l2_category: mainCategory || '', l3_category: subCategory || '', nav_type: 'category', category_nav: 1 }), (clpId && { clp: clpId }));
                            break;
                        case GTMEventActions$1.header_interaction:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.eventData = __assign(__assign(__assign(__assign({}, sharedData), GTMData.eventData), { nav_type: 'header', header_nav: 1 }), (clpId && { clp: clpId }));
                            break;
                        case GTMEventActions$1.marketing_strip_impression:
                        case GTMEventActions$1.announcement_interaction:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            break;
                        case GTMEventActions$1.category_results:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = categoryId || '';
                            GTMData.extraObj = {
                                search_count: searchCount,
                            };
                            break;
                        case GTMEventActions$1.category_no_results:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = categoryId || '';
                            GTMData.extraObj = {
                                search_count: 0,
                            };
                            break;
                        case GTMEventActions$1.reorder_search:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = searchKeyword || '';
                            GTMData.extraObj = {
                                search_count: searchCount,
                            };
                            break;
                        case GTMEventActions$1.reorder_category:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = categoryId || '';
                            break;
                        case GTMEventActions$1.login:
                            GTMData.eventCategory = GTMEventCategories$1.sign_up;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel || '';
                            GTMData.pageData = pageData;
                            break;
                        case GTMEventActions$1.inline_filter:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = inlineFilterData || '';
                            GTMData.pageData = __assign(__assign(__assign({ filter_selected: inlineFilterData || '', screen_name: document.title }, (l1Category && { screen_type: constants$1.category })), (searchKeyword && { screen_type: constants$1.productSearch, search_keyword: decodeSearchKeyword || '' })), { page_url: pageUrl });
                            GTMData.extraObj = __assign(__assign({ filter_events: 1, market: storeid, language: language }, (l1Category && {
                                L1_category: l1Category,
                                L2_category: l2Category || '',
                                L3_category: l3Category || '',
                            })), (searchKeyword && {
                                search_type: search_type_value,
                                // search_results_count: searchCount,
                                search_results_pageview: 1,
                            }));
                            break;
                        case GTMEventActions$1.share_clicked:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = productTitle;
                            break;
                        case GTMEventActions$1.product_click_notify_later:
                            GTMData.eventData = GTMDataTransformer.productGTMData(productState);
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            break;
                        case GTMEventActions$1.first_user_coupon_banner_clicked:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.customEventNonFoodJourneyParams = getJourneySelectionParams$1(new_journey_selection);
                            GTMData.event_type = GTMNowJourneyEventTypes$1.interaction;
                            GTMData.extraObj = __assign(__assign({}, pageData), { language: language });
                            break;
                        case GTMEventActions$1.registration:
                            GTMData.eventCategory = GTMEventCategories$1.sign_up;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.pageData = pageData;
                            break;
                        case GTMEventActions$1.shop_all_items_clicked:
                        case GTMEventActions$1.see_all_click:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.pageData = pageData;
                            GTMData.customEventNonFoodJourneyParams = getJourneySelectionParams$1(new_journey_selection);
                            GTMData.event_type = GTMNowJourneyEventTypes$1.interaction;
                            break;
                        case GTMEventActions$1.fyc_icon_interaction:
                        case GTMEventActions$1.journey_selection_tab:
                        case GTMEventActions$1.address_icon_interaction:
                        case GTMEventActions$1.change_address_done:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.event_type = GTMNowJourneyEventTypes$1.interaction;
                            GTMData.customEventNonFoodJourneyParams = getJourneySelectionParams$1(new_journey_selection || '');
                            GTMData.pageData = pageData;
                            break;
                        case GTMEventActions$1.authentication:
                            GTMData.eventCategory = GTMEventCategories$1.user_authentication;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.pageData = pageData;
                            GTMData.journey_selection = new_journey_selection;
                            break;
                        case GTMEventActions$1.email_login_password:
                            GTMData.eventCategory = GTMEventCategories$1.user_authentication;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.pageData = pageData;
                            GTMData.journey_selection = new_journey_selection;
                            break;
                        case GTMEventActions$1.email_login_otp:
                            GTMData.eventCategory = GTMEventCategories$1.user_authentication;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.pageData = pageData;
                            GTMData.journey_selection = new_journey_selection;
                            break;
                        case GTMEventActions$1.signup:
                            GTMData.eventCategory = GTMEventCategories$1.user_authentication;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.pageData = pageData;
                            GTMData.journey_selection = new_journey_selection;
                            break;
                        case GTMEventActions$1.profile_interaction:
                            GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                            GTMData.eventAction = eventAction;
                            GTMData.eventLabel = eventLabel;
                            GTMData.journey_selection = new_journey_selection;
                            GTMData.pageData = {
                                screen_name: constants$1.profile,
                                screen_type: constants$1.profile,
                                page_url: pageUrl,
                            };
                            break;
                    }
                    break;
                case GTMEvents$1.now_journey_custom_events:
                    GTMData.eventCategory = GTMEventCategories$1.user_engagement;
                    GTMData.eventAction = eventAction;
                    GTMData.eventLabel = eventLabel || '';
                    GTMData.pageData = pageData;
                    GTMData.event_type = event_type;
                    GTMData.customEventNonFoodJourneyParams = getJourneySelectionParams$1(new_journey_selection);
                    break;
                case GTMEvents$1.algolia_custom_events:
                    GTMData.experiment_key = experiment_key || '';
                    GTMData.variation_id = variation_id;
                    GTMData.pageData = pageData;
                    break;
            }
            return GTMData;
        };
    }
    /**
     * Transform the product props to a valid GTM data
     * @param {IProductCard} data - the productCard redux state
     */
    GTMDataTransformer.productGTMData = function (data, eventType, ga4, countryCode) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (ga4 === void 0) { ga4 = false; }
        if (countryCode === void 0) { countryCode = ''; }
        if (data) {
            var bulkMessage = data.bulkMessage, name_1 = data.name, productId = data.productId, originalPrice = data.originalPrice, brand = data.brand, _h = data.category, category = _h === void 0 ? '' : _h, position = data.position, _j = data.listName, listName = _j === void 0 ? '' : _j, discount = data.discount, offers = data.offers, isExpress = data.isExpress, isScalable = data.isScalable, _k = data.quantity, quantity = _k === void 0 ? 0 : _k, type = data.type, isAvailable = data.isAvailable, productColor = data.productColor, size = data.size, isWarranty = data.isWarranty, productOrigin = data.productOrigin, foodType = data.foodType, supplier = data.supplier, isMarketPlace = data.isMarketPlace, categories = data.categories, parentID = data.parentID, selectedVariant = data.selectedVariant, isSponsored = data.isSponsored, selectedVariantCode = data.selectedVariantCode, adtechCarouselId = data.adtechCarouselId, campaignId = data.campaignId, campaignName = data.campaignName;
            var itemVariant = '';
            var sellerName = '';
            var offerId = '';
            var l1Category = void 0, l2Category = void 0, l3Category = void 0, l4Category = void 0;
            var _l = __read(APP_CONFIG$1.__cookie__.storeInfoCookieValue, 3), currency = _l[2];
            if (supplier !== 'Carrefour') {
                itemVariant = 'market_place|';
            }
            if (bulkMessage !== '') {
                itemVariant = ''.concat(itemVariant, 'bulk|');
            }
            if ((discount && discount.type !== 'none') || offers) {
                itemVariant = ''.concat(itemVariant, 'online_deals|');
            }
            if (isExpress) {
                itemVariant = ''.concat(itemVariant, 'express|');
            }
            if (offers && offers.length) {
                offerId = offers[0].id || '';
                sellerName = offers[0].sellerName || '';
            }
            itemVariant = itemVariant ? itemVariant.slice(0, -1) : itemVariant;
            var stockStatus = isAvailable ? 'inStock' : 'outOfStock';
            var productPosition = "" + (position || '');
            var id = isMarketPlace && offers && offers.length
                ? getPageType$1() === constants$1.productDetails
                    ? parentID + "_" + offerId
                    : productId + "_" + offerId
                : "" + productId;
            var Productprice = discount && discount.type !== 'none' ? discount.price : originalPrice;
            var offer_type = discount && discount.type !== 'none' ? discount.value + '%_discount' : '';
            var pageType = getPageType$1();
            var isPLP = [constants$1.categorySearch, constants$1.productSearch].includes(pageType);
            if (pageType === constants$1.productSearch && isBrowser$1()) {
                var breadCrumb = (_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.__NEXT_DATA__) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.initialState) === null || _c === void 0 ? void 0 : _c.search) === null || _d === void 0 ? void 0 : _d.breadCrumb;
                if (Array.isArray(breadCrumb)) {
                    l1Category = ((_e = breadCrumb[0]) === null || _e === void 0 ? void 0 : _e.name) || '';
                    l2Category = ((_f = breadCrumb[1]) === null || _f === void 0 ? void 0 : _f.name) || '';
                }
            }
            var categoryEnabledPages = [
                constants$1.categorySearch,
                constants$1.home,
                constants$1.category,
                constants$1.productDetails,
                constants$1.cart,
                constants$1.reOrder,
            ];
            if (categories && categories.length && categoryEnabledPages.includes(getPageType$1())) {
                var labelArray = categories.map(function (labelValue) {
                    return labelValue.name;
                });
                l1Category = labelArray[0];
                l2Category = labelArray[1];
                l3Category = labelArray[2];
                l4Category = labelArray[3];
            }
            var searchKeyword = getPageType$1() === constants$1.productSearch ? listName === null || listName === void 0 ? void 0 : listName.split('|')[1] : '';
            var pathname = (typeof window !== 'undefined' && window.location.pathname) || '';
            var clpId = pathname.split('/').find(function (ele) { return ele.includes('clp_'); }) || '';
            var list = (listName === null || listName === void 0 ? void 0 : listName.split('|')) || [];
            var page = GTMDataTransformer.getPageType(pageType);
            var dimension103 = list[0] + "|" + list[1];
            var trimString = function (str) { return (str === null || str === void 0 ? void 0 : str.substring(0, 100)) || ''; };
            var currentPageType = getPageType$1();
            var new_journey_selection = getNowJourneyCookie$1()
                ? GTMNowJourneyLabels$1.now_items
                : GTMNowJourneyLabels$1.all_items;
            var common = {};
            var productCommon = {};
            var commonData = {};
            if (!ga4) {
                common = __assign(__assign(__assign(__assign(__assign({ name: name_1,
                    id: id, brand: brand || '', category: category, position: productPosition, 
                    // list: listName || '',
                    variant: itemVariant, dimension7: type || '', dimension14: stockStatus || '', dimension23: offers && offers.length ? 'true' : 'false' }, (offer_type && { dimension51: offer_type })), { dimension52: isMarketPlace ? 'true' : 'false' }), (isMarketPlace && { dimension53: supplier })), (isScalable && { dimension96: size })), (clpId && { clp: clpId }));
                productCommon = __assign(__assign({ dimension54: "" + offerId, dimension93: id }, (list && { dimension103: dimension103 })), { dimension108: String(!!isExpress), metric17: originalPrice });
                commonData = {
                    price: Productprice,
                    quantity: quantity,
                };
            }
            else {
                var price = isScalable && originalPrice && quantity ? ((quantity / 1000) * originalPrice).toFixed(2) : originalPrice;
                var discountPrice = discount && discount.type !== 'none' && originalPrice
                    ? parseFloat((originalPrice - discount.price).toFixed(2))
                    : 0;
                var item_list_name = trimString(getListName$1(listName, currentPageType, category));
                var adtechData = {};
                if (currentPageType === constants$1.cart && campaignId) {
                    var listName_1 = gtmSnakeCase$1(item_list_name || '');
                    adtechData = {
                        sponsored_ad_type: 'rail',
                        sponsored_ad_info: "" + adtechCarouselId,
                        sponsored_campaign_info: campaignName + "|" + campaignId,
                        item_list_name: listName_1,
                        item_list_id: listName_1,
                    };
                }
                common = __assign(__assign(__assign({ item_name: name_1 && trimString(name_1), item_id: productId + "_" + countryCode, item_brand: (type === 'FOOD' ? 'Food' : 'NonFood') + "_" + brand, item_category: trimString(l1Category), item_category2: trimString(l2Category), item_category3: trimString(l3Category), item_category4: trimString(l4Category), item_category5: "" + (type === 'FOOD' ? 'food' : 'non_food') }, getJourneySelectionParams$1(new_journey_selection, 'item_level_')), { item_variant: "now=" + (isExpress ? true : false) + "_spon=" + (isSponsored ? true : false) + (selectedVariant ? '_var=' + selectedVariantCode : '') + "_end", item_list_name: item_list_name, item_list_id: item_list_name, index: position, affiliation: isMarketPlace ? trimString(offerId + "|" + sellerName) : 'Carrefour', is_sponsored: isSponsored ? 'true' : 'false' }), adtechData);
                commonData = {
                    price: price,
                    currency: currency,
                    discount: discountPrice,
                    value: discountPrice ? (_g = discount === null || discount === void 0 ? void 0 : discount.price) === null || _g === void 0 ? void 0 : _g.toFixed(2) : price,
                };
            }
            switch (eventType) {
                case GTMEvents$1.product_impressions:
                    if (ga4) {
                        return __assign(__assign(__assign(__assign({}, common), productCommon), commonData), (isMarketPlace && { metric25: '1' }));
                    }
                    return __assign(__assign(__assign(__assign(__assign({}, common), productCommon), commonData), { list: page + "|" + dimension103 }), (isMarketPlace && { metric25: '1' }));
                case GTMEvents$1.product_click:
                    if (!ga4) {
                        return __assign(__assign(__assign(__assign(__assign({}, common), productCommon), { list: page + "| " + dimension103, nav_type: 'product list click' }), (isMarketPlace && { metric41: '1' })), (isPLP && { search_results_click_thru: '1' }));
                    }
                    else {
                        return __assign(__assign({}, common), productCommon);
                    }
                case GTMEvents$1.add_to_cart:
                    return __assign(__assign({}, common), productCommon);
                case GTMEvents$1.remove_from_cart:
                    return __assign(__assign({}, common), productCommon);
            }
            return __assign(__assign(__assign({}, common), commonData), { dimension18: productColor || '', dimension19: productOrigin || '', dimension20: isWarranty ? 'true' : 'false', dimension27: size || '', dimension39: foodType || '', dimension51: offer_type || '', dimension54: offerId, dimension53: sellerName, dimension56: productPosition, dimension89: originalPrice, dimension40: l1Category || '', dimension41: l2Category || '', dimension57: l3Category || '', dimension58: l4Category || '', dimension60: isExpress ? 'express' : 'standard', dimension65: itemVariant || '', dimension81: searchKeyword });
        }
    };
    GTMDataTransformer.getPageType = function (pageType) {
        switch (pageType) {
            case constants$1.home:
                return 'home';
            case constants$1.categoryLandingPage:
                return constants$1.categoryLandingPage;
            case constants$1.productSearch:
                return 'productsearch';
            case constants$1.categorySearch:
                return 'category';
            case constants$1.brandLandingPage:
                return constants$1.brandLandingPage;
            case constants$1.productDetails:
                return constants$1.product_details;
            default:
                return pageType;
        }
    };
    GTMDataTransformer.getScreenName = function (pageType, productName) {
        if (productName === void 0) { productName = ''; }
        var category_name = getCategoryName$1() || constants$1.noName;
        switch (pageType) {
            case constants$1.home:
                return 'home';
            case constants$1.categoryLandingPage:
                return constants$1.categoryLandingPage + "|" + category_name;
            case constants$1.categorySearch:
                return constants$1.category + "|" + category_name;
            case constants$1.brandLandingPage:
                return constants$1.brandLandingPage + "|" + category_name;
            case constants$1.productDetails:
                return constants$1.product_details + "|" + localStorage.getItem('pdpProductName');
            default:
                return productName || pageType;
        }
    };
    return GTMDataTransformer;
}());

var setSearchHistory = function (searchTerm, maxSearchHistoryResult, selectedTabId) {
    var searchHistorykey = selectedTabId ? "searchHistory_" + selectedTabId : 'searchHistory';
    var searchHistory = window.localStorage.getItem(searchHistorykey);
    if (searchHistory) {
        if (searchHistory.indexOf(searchTerm) === -1) {
            var keywordsArr = searchHistory.split('|');
            if (keywordsArr.length >= maxSearchHistoryResult) {
                keywordsArr.shift();
                keywordsArr.push(searchTerm);
            }
            else {
                keywordsArr.push(searchTerm);
            }
            window.localStorage.setItem(searchHistorykey, keywordsArr.join('|'));
        }
    }
    else {
        window.localStorage.setItem(searchHistorykey, searchTerm);
    }
};
var getSearchHistory = function (selectedTabId) {
    var searchHistorykey = selectedTabId ? "searchHistory_" + selectedTabId : 'searchHistory';
    var searchHistory = window.localStorage.getItem(searchHistorykey);
    if (searchHistory) {
        return searchHistory.split('|').reverse();
    }
    return [];
};
var clearSearchHistory = function (selectedTabId) {
    var searchHistorykey = selectedTabId ? "searchHistory_" + selectedTabId : 'searchHistory';
    window.localStorage.removeItem(searchHistorykey);
};
var toSnakeCase$3 = function (str) { return str && str.toLocaleLowerCase().split(' ').join('_'); };
// This function  overrides user-id with maf-session-id  in case of logged out user for algolia
var overridesUserIdHeader$1 = function (mafSessionId) {
    if (mafSessionId === void 0) { mafSessionId = ''; }
    if (!getCustomCookie$1('maf-user-id')) {
        return { userId: mafSessionId };
    }
    return {};
};
var isEqualArray = function (searchHistoryPrevState, searchHistoryCurrentState) {
    return (searchHistoryPrevState.length === searchHistoryCurrentState.length &&
        searchHistoryCurrentState.every(function (element, index) { return element === searchHistoryPrevState[index]; }));
};

var BrazeDataTransformer$1 = /** @class */ (function () {
    function BrazeDataTransformer() {
        /**
         * transform the final GTM event datalayer based on the eventType
         * @param {BrazeEvents} eventType
         * @param {any} eventData - the data which will contain data of product level and event level
         */
        var _this = this;
        this.getOfferType = function (bulkMessage, isExpress, sellerName) {
            var offerType = '';
            if ((sellerName === null || sellerName === void 0 ? void 0 : sellerName.toLowerCase()) !== 'carrefour') {
                offerType = 'market_place|';
            }
            if (bulkMessage !== '') {
                offerType = ''.concat(offerType, 'bulk|');
            }
            if (isExpress) {
                offerType = ''.concat(offerType, 'express|');
            }
            return (offerType === null || offerType === void 0 ? void 0 : offerType.slice(0, -1)) || '';
        };
        this.getBrazeData = function (eventType, eventData) {
            var _a, _b, _c, _d;
            var BrazeData = {};
            var _e = eventData.name, name = _e === void 0 ? '' : _e, _f = eventData.productId, productId = _f === void 0 ? '' : _f, _g = eventData.category, category = _g === void 0 ? '' : _g, _h = eventData.brand, brand = _h === void 0 ? '' : _h, _j = eventData.currency, currency = _j === void 0 ? '' : _j, _k = eventData.quantity, quantity = _k === void 0 ? '' : _k, _l = eventData.quantityType, quantityType = _l === void 0 ? '' : _l, discount = eventData.discount, originalPrice = eventData.originalPrice, isMarketplaceOffer = eventData.isMarketplaceOffer, isMainOffer = eventData.isMainOffer, _m = eventData.offerId, offerId = _m === void 0 ? '' : _m, _o = eventData.shop, shop = _o === void 0 ? '' : _o, _p = eventData.isFBC, isFBC = _p === void 0 ? '' : _p, _q = eventData.deliveryPromise, deliveryPromise = _q === void 0 ? '' : _q, _r = eventData.deliverySolution, deliverySolution = _r === void 0 ? '' : _r, _s = eventData.isMarketPlace, isMarketPlace = _s === void 0 ? '' : _s, _t = eventData.isExpress, isExpress = _t === void 0 ? '' : _t, _u = eventData.bulkMessage, bulkMessage = _u === void 0 ? '' : _u, _v = eventData.offers, offers = _v === void 0 ? '' : _v, _w = eventData.supplier, supplier = _w === void 0 ? '' : _w, _x = eventData.min, min = _x === void 0 ? '' : _x, _y = eventData.isScalable, isScalable = _y === void 0 ? '' : _y;
            switch (eventType) {
                case BrazeEvents$1.add_to_cart:
                    var mkpData_cart = isMarketPlace
                        ? {
                            isMainOffer: ((_a = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _a === void 0 ? void 0 : _a.type) === 'main',
                            offer_id: toSnakeCase$3((_b = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _b === void 0 ? void 0 : _b.id),
                            shop: toSnakeCase$3((_c = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _c === void 0 ? void 0 : _c.sellerName),
                            isFBC: supplier === 'Carrefour',
                            deliveryPromise: toSnakeCase$3(deliveryPromise),
                            deliverySolution: toSnakeCase$3(deliverySolution),
                        }
                        : {};
                    var itemPrice = (discount === null || discount === void 0 ? void 0 : discount.price) > 0 ? discount.price : originalPrice;
                    BrazeData = __assign({ item_name: toSnakeCase$3(name), item_id: toSnakeCase$3(productId), item_category: toSnakeCase$3(category), item_brand: toSnakeCase$3(brand), price: itemPrice, currency: toSnakeCase$3(currency), quantity: min, quantity_type: isScalable ? 'kilo' : 'pieces', offer_type: _this.getOfferType(bulkMessage, isExpress, (_d = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _d === void 0 ? void 0 : _d.sellerName) }, mkpData_cart);
                    break;
                case BrazeEvents$1.pdp_view:
                    var mkpData_pdp = isMarketplaceOffer
                        ? {
                            isMainOffer: isMainOffer,
                            offer_id: offerId,
                            shop: shop,
                            isFBC: isFBC,
                            deliveryPromise: deliveryPromise,
                            deliverySolution: deliverySolution,
                        }
                        : {};
                    var pdpPrice = (discount === null || discount === void 0 ? void 0 : discount.price) > 0 ? discount.price : originalPrice;
                    BrazeData = __assign({ item_name: name, item_id: productId, item_category: category, item_brand: brand, price: pdpPrice, currency: currency, quantity: quantity, quantity_type: quantityType, offer_type: _this.getOfferType(bulkMessage, isExpress, shop) }, mkpData_pdp);
                    break;
                default:
                    BrazeData = eventData;
            }
            return BrazeData;
        };
    }
    return BrazeDataTransformer;
}());

var brazeSetCustomUserAttribute$1 = function (pairs) {
    var appboy = window.appboy;
    Object.entries(pairs).forEach(function (item) {
        appboy && appboy.getUser().setCustomUserAttribute(item[0], item[1]);
    });
};
var brazeLogCustomEvent$1 = function (type, properties) {
    var appboy = window.appboy;
    var transformer = new BrazeDataTransformer$1();
    var BrazeData = transformer.getBrazeData(type, properties);
    appboy && appboy.logCustomEvent(type, BrazeData);
};
var brazeRegisterUser = function (user) {
    var appboy = window.appboy;
    var gender = 'f';
    if (user.title === 'Mr') {
        gender = 'm';
    }
    if (appboy) {
        // Set user properties
        appboy.getUser().setFirstName(user.firstName);
        appboy.getUser().setLastName(user.lastName);
        appboy.getUser().setGender(gender);
        appboy.getUser().setDateOfBirth(user === null || user === void 0 ? void 0 : user.bdayYear, user === null || user === void 0 ? void 0 : user.bdayMonth, user === null || user === void 0 ? void 0 : user.bdayDate);
        appboy.getUser().setPhoneNumber(user.mobileNumber);
        appboy.getUser().setEmail(user.username);
        // Log Custom Event.
        appboy.logCustomEvent('sign_up');
    }
};
var setAppLanguageAndCountry$1 = function (appConfig, appboy) {
    setCustomUserAttribute$1(appboy, {
        app_language: appConfig.language,
        app_country: appConfig.storeId,
    });
};
var brazeLogChangeUser = function (hashedUserId) {
    var _a;
    var appboy = window.appboy;
    if (!appboy) {
        console.warn('Appboy instance not initilized');
        return;
    }
    var _b = ((_a = getStore$1()) === null || _a === void 0 ? void 0 : _a.getState()).appConfig, appConfig = _b === void 0 ? {} : _b;
    appboy.changeUser(hashedUserId);
    setAppLanguageAndCountry$1(appConfig, appboy);
};
var setCustomUserAttribute$1 = function (appboy, pairs) {
    Object.entries(pairs).forEach(function (item) {
        appboy && appboy.getUser().setCustomUserAttribute(item[0], item[1]); // key: item[0], value: item[1]
    });
};
var logoutEvent = function () {
    var appboy = window.appboy;
    appboy.destroy();
};

var BaseService$1 = /** @class */ (function () {
    function BaseService() {
    }
    BaseService.prototype.doGet = function (url, params, isAbsUrl, apiOptions) {
        if (isAbsUrl === void 0) { isAbsUrl = true; }
        if (apiOptions === void 0) { apiOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var requestUrl, headers, storeId, data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestUrl = this.replaceVariables(url, params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        headers = {};
                        storeId = (params || {}).storeId;
                        if (params === null || params === void 0 ? void 0 : params.headers) {
                            headers = params === null || params === void 0 ? void 0 : params.headers;
                        }
                        if (storeId) {
                            headers.storeId = storeId;
                        }
                        return [4 /*yield*/, networkRequest$1(__assign({ requestUrl: requestUrl,
                                isAbsUrl: isAbsUrl, apiOptions: __assign({}, apiOptions), headers: headers }, params))];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 3:
                        err_1 = _a.sent();
                        console.error('DO_GET_ERROR', requestUrl, err_1);
                        console.error('DO_GET_ERROR_PARAMS', requestUrl, params);
                        return [2 /*return*/, { statusCode: 400, err: err_1 }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BaseService.prototype.doSafeGet = function (url, params, isAbsUrl) {
        if (isAbsUrl === void 0) { isAbsUrl = true; }
        return __awaiter(this, void 0, void 0, function () {
            var requestUrl, headers, storeId, data, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestUrl = this.replaceVariables(url, params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        headers = {};
                        storeId = (params || {}).storeId;
                        if (params === null || params === void 0 ? void 0 : params.headers) {
                            headers = params === null || params === void 0 ? void 0 : params.headers;
                        }
                        if (storeId) {
                            headers.storeId = storeId;
                        }
                        return [4 /*yield*/, networkRequest$1({
                                requestUrl: requestUrl,
                                isAbsUrl: isAbsUrl,
                                apiOptions: {},
                                apiVersion: (params === null || params === void 0 ? void 0 : params.apiVersion) || 2,
                                headers: headers,
                            })];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 3:
                        err_2 = _a.sent();
                        console.error('DO_GET_SAFE_ERROR', requestUrl, err_2);
                        console.error('DO_GET_SAFE_ERROR_PARAMS', requestUrl, params);
                        return [2 /*return*/, { statusCode: 400, err: err_2 }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BaseService.prototype.getSessionToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, handleGuestSession$1()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, getUserTokenFromCookie$1() || getGuestSessionToken$1()];
                }
            });
        });
    };
    BaseService.prototype.doPut = function (url, params, isAbsUrl) {
        if (isAbsUrl === void 0) { isAbsUrl = true; }
        return __awaiter(this, void 0, void 0, function () {
            var requestUrl, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestUrl = this.replaceVariables(url, params);
                        return [4 /*yield*/, networkRequest$1({
                                requestUrl: requestUrl,
                                isAbsUrl: isAbsUrl,
                                apiOptions: {
                                    method: 'PUT',
                                },
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    BaseService.prototype.replaceVariables = function (url, params) {
        if (params === void 0) { params = {}; }
        var store = getStore$1();
        var appConfig = store ? store.getState().appConfig : {};
        var _a = __assign(__assign({}, APP_CONFIG$1), appConfig), areaCode = _a.areaCode, 
        // zoneId,
        lang = _a.language, latitude = _a.latitude, longitude = _a.longitude, currency = _a.currency, storeId = _a.storeId, _b = _a.features, isLocationCXEnable = (_b === void 0 ? { isLocationCXEnable: false } : _b).isLocationCXEnable, 
        // foodPos,
        // nonFoodPos,
        expressPos = _a.expressPos;
        return replaceUrlVariables$1(url, __assign({ 
            // zoneId,
            lang: lang, language: lang, latitude: latitude,
            longitude: longitude,
            areaCode: areaCode,
            isLocationCXEnable: isLocationCXEnable,
            storeId: storeId, StoreId: storeId, Currency: params.currency || currency, 
            // foodPos,
            // nonFoodPos,
            expressPos: expressPos }, params));
    };
    return BaseService;
}());

/**
 * contains the data transform mechanism and do the proper action
 * GTM to add to the data layer and RR to call the proper API
 */
var AnalyticsManager$1 = /** @class */ (function () {
    function AnalyticsManager() {
    }
    AnalyticsManager.prototype.getGTMPageData = function (pageData) {
        var transformer = new GTMDataTransformer$1();
        return transformer.pageGTMData(pageData);
    };
    /**
     * This method will get the transformed data and add the details to
     * the proper helper function datalayer
     * @param {GTMEvents} eventType
     * @param {IEventGTMData} eventData
     */
    AnalyticsManager.prototype.trackGTMEvent = function (eventType, eventData) {
        var transformer = new GTMDataTransformer$1();
        var GTMData = transformer.getGTMData(eventType, eventData);
        var ga4 = (eventData.otherData || false).ga4;
        if (GTMData) {
            switch (eventType) {
                case GTMEvents$1.product_click:
                    return gtmProductClick$1(GTMData.data, GTMData.actionField, GTMData.eventData, ga4);
                case GTMEvents$1.product_impressions:
                    return gtmProductImpression$1(GTMData.data, GTMData.eventData, ga4);
                case GTMEvents$1.virtual_page_event:
                    return gtmVirtualPage$1(GTMData.pageTitle, GTMData.eventData);
                case GTMEvents$1.category_page_event:
                    return gtmCategoryPage$1(GTMData.l1Category, GTMData.l2Category, GTMData.l3Category, GTMData.eventData);
                case GTMEvents$1.custom_event:
                    return gtmCustomEvent$1(GTMData.eventCategory, GTMData.eventAction, GTMData.eventLabel, GTMData.extraObj, GTMData.eventData, GTMData.pageData || {}, GTMData.posInfo, GTMData.event_type, GTMData.journey_selection, GTMData.customEventNonFoodJourneyParams, ga4);
                case GTMEvents$1.add_to_cart:
                    return gtmAddToCart$1(GTMData.data, GTMData.eventData, ga4);
                case GTMEvents$1.remove_from_cart:
                    return gtmRemoveToCart$1(GTMData.data, GTMData.eventData, ga4);
                case GTMEvents$1.now_journey_custom_events:
                    return nowJourneyCustomEvents$1(GTMData.eventCategory, GTMData.eventAction, GTMData.eventLabel, GTMData.event_type, GTMData.journey_selection, GTMData.pageData || {});
                case GTMEvents$1.algolia_custom_events:
                    return algoliaServiceGAEvent$1(GTMData.experiment_key, GTMData.variation_id, GTMData.pageData || {});
            }
        }
    };
    /**
     * This method will get the transformed data and add the details to Braze Analytics.
     * the proper helper function datalayer
     * @param {BrazeEvents} eventType
     * @param {any} eventData
     */
    AnalyticsManager.prototype.trackBrazeEvent = function (eventType, eventData) {
        brazeLogCustomEvent$1(eventType, eventData);
    };
    /**
     * This method set the details to Braze nalytics.
     * the proper helper function datalayer
     * @param {attributes} object
     */
    AnalyticsManager.prototype.trackBrazeSetCustomUserAttribute = function (attributes) {
        brazeSetCustomUserAttribute$1(attributes);
    };
    AnalyticsManager.prototype.trackPromotionEvent = function (eventType, sharedData, promotionData, ga4) {
        var GTMData = eventType && sharedData && promotionData;
        if (GTMData) {
            switch (eventType) {
                case PromotionEvents$1.promotion_impressions:
                    return gtmPromotionImpression$1(eventType, sharedData, promotionData, ga4);
                case PromotionEvents$1.promotion_click:
                    return gtmPromotionClick$1(eventType, sharedData, promotionData, ga4);
            }
        }
    };
    /**
     * this will do Restfull API call with no action
     * to RR tracking service
     * @param {string} URI
     */
    AnalyticsManager.prototype.trackEvent = function (URI, useFetch) {
        if (useFetch === void 0) { useFetch = false; }
        if (isBrowser$1()) {
            var bs = new BaseService$1();
            return useFetch
                ? fetch(URI)
                : bs.doGet(URI, {}, true, {
                    headers: {
                        Connection: 'Keep-Alive',
                    },
                });
        }
    };
    return AnalyticsManager;
}());

/**
 * hook which return GTM and RR tracking methods
 */
var useAnalytic$1 = function () {
    var _a, _b;
    var Analytics = useMemo(function () { return new AnalyticsManager$1(); }, []);
    var isNewJouney = ((_b = (_a = useFeature('new_carrefour_journey')) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.new_journey) || false;
    var _c = useSelector(function (state) {
        return __assign(__assign(__assign(__assign({}, state.userData), state.appConfig), state.area), state.miniCart);
    }), currency = _c.currency, areaCode = _c.areaCode, language = _c.language, sessionId = _c.sessionId, storeId = _c.storeId, selectedCity = _c.selectedCity, cardNumber = _c.cardNumber, totalPoints = _c.totalPoints, isLoyaltyFetched = _c.isLoyaltyFetched, _d = _c.userId, userHashedEmail = _d === void 0 ? 'anonymous' : _d, _e = _c.updatedCart, updatedCart = _e === void 0 ? {} : _e, brazeInitialized = _c.brazeInitialized, email = _c.email, defaultAddress = _c.defaultAddress, userCredentials = _c.userCredentials;
    /**
     * memoize the searchType from the cookie
     */
    var searchType = useMemo(function () {
        if (typeof document !== 'undefined') {
            return getSearchTypeCookie$1();
        }
    }, []);
    /**
     * memoize the cart id from the cookie
     */
    var cartId = useMemo(function () {
        if (typeof document !== 'undefined') {
            var token = getUserTokenFromCookie$1();
            if (token) {
                return getUserTokenFromCookie$1();
            }
            return getGUID$1() || (updatedCart ? updatedCart.guid : '');
        }
    }, [updatedCart]);
    var isLoggedIn = useMemo(function () {
        if (typeof document !== 'undefined') {
            var token = getUserTokenFromCookie$1();
            if (token) {
                return true;
            }
            return false;
        }
    }, []);
    var getAreaCode = useCallback(function () {
        try {
            return areaCode && JSON.parse(areaCode);
        }
        catch (error) {
            return areaCode;
        }
    }, [areaCode]);
    var pageType = getPageType$1();
    var getGTMPageData = useCallback(function (pageData) {
        var getData = pageData === null || pageData === void 0 ? void 0 : pageData.getData;
        pageData === null || pageData === void 0 ? true : delete pageData.getData;
        var loggedInStatus = (userCredentials === null || userCredentials === void 0 ? void 0 : userCredentials.authToken) ? '1'
            : '0';
        var areaCodeParsed = getAreaCode();
        var eventData = __assign({ loggedInStatus: loggedInStatus,
            language: language, market: storeId, currency: currency,
            sessionId: sessionId, areaCode: areaCodeParsed, selectedCity: selectedCity || (areaCodeParsed ? areaCodeParsed.split(' - ')[1] : ''), userId: userCredentials === null || userCredentials === void 0 ? void 0 : userCredentials.userId, pageType: pageType,
            userHashedEmail: userHashedEmail,
            email: email,
            defaultAddress: defaultAddress, userLoyaltyPoint: totalPoints || '', myClubId: cardNumber || '' }, pageData);
        if (isLoggedIn && (userCredentials === null || userCredentials === void 0 ? void 0 : userCredentials.authToken) && areaCode) {
            return Analytics.getGTMPageData(eventData);
        }
        else if (!isLoggedIn || getData) {
            return Analytics.getGTMPageData(eventData);
        }
        return null;
    }, [
        getAreaCode,
        language,
        storeId,
        currency,
        sessionId,
        selectedCity,
        pageType,
        userHashedEmail,
        email,
        defaultAddress,
        totalPoints,
        cardNumber,
        isLoggedIn,
        areaCode,
        Analytics,
        userCredentials,
    ]);
    /**
     * transform the data from the other data object and pass the session data to it
     * then call the proper tracker method from the analytics class
     * @param {GTMEvents} eventType
     * @param {IEventParams} otherData - data need to be passed from the component level
     */
    var GTMEventCall = useCallback(function (eventType, otherData) {
        if (otherData === void 0) { otherData = {}; }
        var quantity = otherData.quantity;
        var eventData = __assign(__assign({}, otherData), { pageType: pageType,
            searchType: searchType,
            cartId: cartId,
            isNewJouney: isNewJouney });
        if (storeId && language && currency && pageType && areaCode) {
            var product = otherData.product, position = otherData.position;
            var listName = product ? product.gaListName : '';
            Analytics.trackGTMEvent(eventType, {
                productState: __assign(__assign({}, product), { position: position, listName: listName, quantity: quantity }),
                otherData: eventData,
            });
        }
    }, [Analytics, searchType, storeId, language, currency, cartId, pageType, areaCode, isNewJouney]);
    /**
     * extract the tracking URL from the product feed in redux and
     * make the API call to RR tracking service
     * @param {GTMEvents} eventType
     * @param {string} productId
     */
    var EventCall = useCallback(function (eventType, productDetail) {
        var URIs = [];
        if (productDetail) {
            var _a = productDetail.addToCartTrackingUrl, addToCartTrackingUrl = _a === void 0 ? [] : _a, _b = productDetail.clickTrackingUrl, clickTrackingUrl = _b === void 0 ? [] : _b, _c = productDetail.viewTrackingUrl, viewTrackingUrl = _c === void 0 ? [] : _c, _d = productDetail.rightClickTrackingURL, rightClickTrackingURL = _d === void 0 ? [] : _d, _e = productDetail.updateCartTrackingURL, updateCartTrackingURL = _e === void 0 ? [] : _e;
            switch (eventType) {
                case GTMEvents$1.add_to_cart:
                    URIs = addToCartTrackingUrl.map(function (trackingURL) { return trackingURL + "&quantity=" + (productDetail === null || productDetail === void 0 ? void 0 : productDetail.quantity); });
                    break;
                case GTMEvents$1.change_the_quantity:
                    URIs = updateCartTrackingURL.map(function (trackingURL) { return trackingURL + "&quantity=" + (productDetail === null || productDetail === void 0 ? void 0 : productDetail.quantity); });
                    break;
                case GTMEvents$1.product_click:
                    URIs = clickTrackingUrl;
                    break;
                case GTMEvents$1.product_impression:
                    URIs = viewTrackingUrl;
                    break;
                case GTMEvents$1.right_click:
                    URIs = rightClickTrackingURL;
                    break;
            }
        }
        if (URIs) {
            if (isNonEmptyArray$1(URIs)) {
                URIs.map(function (URI) { return Analytics.trackEvent(URI, true); });
            }
        }
    }, [Analytics]);
    var PromotionEventCall = useCallback(function (eventType, sharedData, promotionData, ga4) {
        sharedData.journey_selection = getNowJourneyCookie$1()
            ? GTMNowJourneyLabels$1.now_items
            : GTMNowJourneyLabels$1.all_items;
        sharedData.event_type = 'non-interaction';
        if ((isLoyaltyFetched || !isLoggedIn) && areaCode) {
            Analytics.trackPromotionEvent(eventType, sharedData, promotionData, ga4);
        }
    }, [Analytics, isLoyaltyFetched, isLoggedIn, areaCode]);
    /**
     * transform the data from the other data object and pass the session data to it
     * then call the proper tracker method from the analytics class
     * @param {BrazeEvents} eventType
     * @param {any} product - data need to be passed from the component level
     */
    var BrazeEventCall = useCallback(function (eventType, product) {
        if (brazeInitialized) {
            Analytics.trackBrazeEvent(eventType, product);
        }
    }, [Analytics, brazeInitialized]);
    /**
     * transform the data from the other data object and pass the session data to it
     * then call the proper tracker method from the analytics class
     * @param {attributes} object
     */
    var BrazeSetCustomUserAttribute = useCallback(function (attributes) {
        Analytics.trackBrazeSetCustomUserAttribute(attributes);
    }, [Analytics]);
    return {
        GTMEventCall: GTMEventCall,
        EventCall: EventCall,
        PromotionEventCall: PromotionEventCall,
        getGTMPageData: getGTMPageData,
        BrazeEventCall: BrazeEventCall,
        BrazeSetCustomUserAttribute: BrazeSetCustomUserAttribute,
    };
};

var refreshToken$2 = function () { return ({
    type: EAppConfigTypes$3.REFRESH_TOKEN,
    payload: {
        data: { refreshToken: getRefreshTokenFromCookie$1() },
        method: EApiMiddlewareMethod$3.POST,
        url: REFRESH_TOKEN_API_URL$1,
        onFailure: function () {
            var lastCallTime = getRefreshTokenCallTime$1() || '0';
            var lastCallDiff = Math.floor((Date.now() - parseInt(lastCallTime)) / 1000); // in seconds
            if (lastCallDiff > 60) {
                // Auto Logout GMT Event log
                var Analytics = new AnalyticsManager$1();
                var loggedInStatus = !!getUserTokenFromCookie$1()
                    ? '1'
                    : '0';
                var pageData = __assign({ selectedCity: (APP_CONFIG$1 === null || APP_CONFIG$1 === void 0 ? void 0 : APP_CONFIG$1.areaCode) ? APP_CONFIG$1 === null || APP_CONFIG$1 === void 0 ? void 0 : APP_CONFIG$1.areaCode.split(' - ')[1] : '', pageType: GTMEventActions$1.login, loggedInStatus: loggedInStatus }, APP_CONFIG$1);
                var gtmPageData = Analytics.getGTMPageData(pageData);
                Analytics.trackGTMEvent(GTMEvents$1.custom_event, {
                    productState: {},
                    otherData: {
                        eventAction: GTMEventActions$1.login,
                        eventLabel: 'logout_success|auto',
                        pageData: gtmPageData,
                    },
                });
                setRefreshTokenCallTime$1();
            }
        },
    },
}); };
var exceptionHandlerMiddleware = (function (handler) {
    if (handler === void 0) { handler = defaultHandler; }
    return function (_a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        return function (next) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
            var error_1, _a, tokenRefreshed, errorResponseStatus, userCredentials, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 9]);
                        return [4 /*yield*/, next(action)];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2:
                        error_1 = _b.sent();
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 7, , 8]);
                        _a = action.payload, tokenRefreshed = (_a === void 0 ? { tokenRefreshed: false } : _a).tokenRefreshed;
                        errorResponseStatus = (error_1.response || {}).status;
                        userCredentials = getState().appConfig.userCredentials;
                        if (!(userCredentials && userCredentials.authToken && errorResponseStatus === 401 && !tokenRefreshed)) return [3 /*break*/, 5];
                        return [4 /*yield*/, dispatch(refreshToken$2())];
                    case 4:
                        _b.sent();
                        dispatch(__assign(__assign({}, action), { payload: __assign(__assign({}, action.payload), { tokenRefreshed: true }) }));
                        return [3 /*break*/, 6];
                    case 5:
                        if (errorResponseStatus === 401) {
                            // backward-compatibility with hybris login to redirect to login page and if still the authorization fails.
                            document.location.replace(LOGIN_PAGE);
                        }
                        else {
                            return [2 /*return*/, handler(error_1, action)(next)];
                        }
                        _b.label = 6;
                    case 6: return [2 /*return*/, error_1];
                    case 7:
                        err_1 = _b.sent();
                        console.log(err_1);
                        return [3 /*break*/, 8];
                    case 8: return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        }); }; };
    };
});
/*
 * A default error handler need to make this more generice for rest of the app
 */
var defaultHandler = function (error, action) { return function (dispatch) {
    var errorResponseStatus = (error.response || {}).status;
    var errorMessage = i18next.t('somethingWentWrong');
    if (/network\serror/gi.test(error)) {
        errorMessage = i18next.t('errorNetwork');
    }
    else if (("" + errorResponseStatus).charAt(0) === '5') {
        dispatch(showNotification$1({
            type: 'error',
            message: errorMessage,
        }));
    }
    else {
        dispatch(showNotification$1({
            type: 'error',
            message: errorMessage,
        }));
        dispatch(accessDenied(action.payload));
    }
    var type = action.type;
    var onFailure = (action.payload || {}).onFailure;
    if (onFailure) {
        dispatch(onFailure(errorMessage || error.message, error));
    }
    else {
        dispatch(apiError(type, error));
    }
}; };

var composeEnhancers$1 = process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    })
    : compose;
var configureStore = function (preloadedState, extraReducers, middlewares) {
    if (preloadedState === void 0) { preloadedState = {}; }
    if (middlewares === void 0) { middlewares = []; }
    var specificMiddleWares = [exceptionHandlerMiddleware(), thunk, apiMiddleware];
    if (typeof middlewares === 'function') {
        var middleWareGenFunction = middlewares;
        specificMiddleWares = middleWareGenFunction({
            exceptionHandlerMiddleware: exceptionHandlerMiddleware(),
            thunk: thunk,
            apiMiddleware: apiMiddleware,
        });
    }
    else {
        specificMiddleWares.concat(middlewares);
    }
    var rootReducer = combineReducers(__assign(__assign({}, reducers$1), extraReducers));
    var store = createStore(rootReducer, __assign(__assign({}, initialAppState), preloadedState), composeEnhancers$1(applyMiddleware.apply(void 0, __spread(specificMiddleWares))));
    setStore(store);
    return store;
};

var EMPTY_LINK$1 = {
    href: '',
    kind: '',
    rel: '',
    type: '',
};
var ProductTransformer$1 = /** @class */ (function () {
    function ProductTransformer(products) {
        this.products = products;
    }
    ProductTransformer.prototype.getTrackingFromLinks = function (links, kind) {
        if (links === void 0) { links = []; }
        var results = links.filter(function (link) { return link.rel === 'tracking' && link.kind === kind; });
        return results.map(function (result) { return result.href; });
    };
    ProductTransformer.prototype.getCurrencyPosition = function (currency) {
        if (currency === void 0) { currency = ''; }
        var curr = currency.toUpperCase();
        return curr === 'USD' || curr === 'LBP' ? 'left' : 'right';
    };
    ProductTransformer.prototype.getProductImage = function (links, altTextFallback) {
        if (links === void 0) { links = []; }
        var results = [];
        if (links.length > 0) {
            links.forEach(function (link) {
                if (link.rel === 'assets' && link.properties) {
                    var _a = link, href = _a.href, _b = _a.properties, altText = _b.altText, format = _b.format;
                    var isPlp = format === 'plpThumbnail';
                    var image = { href: href, altText: altText || altTextFallback };
                    if (isPlp) {
                        results.push(image);
                    }
                }
            });
        }
        return results || [];
    };
    ProductTransformer.prototype.getTrackingUrl = function (id, productsWithTracking, key) {
        if (productsWithTracking) {
            var productWithTracking = productsWithTracking.find(function (product) { return product.id === id; });
            var trackingLink = productWithTracking ? productWithTracking.links.find(function (link) { return link.kind === key; }) : '';
            return trackingLink ? trackingLink.href : EMPTY_LINK$1;
        }
        return '';
    };
    ProductTransformer.prototype.getUnitOfMeasure = function (unitOfMeasure) {
        switch (unitOfMeasure) {
            case 'Kilo':
                return 'KG';
            case 'piece':
            default:
                return '';
        }
    };
    ProductTransformer.prototype.getProductUrl = function (links) {
        var result = links.find(function (link) { return link.rel === 'self'; });
        return result ? result.href : '';
    };
    ProductTransformer.prototype.getProductDiscountPrice = function (originalPrice, discountPrice) {
        return originalPrice === discountPrice ? 0 : discountPrice;
    };
    ProductTransformer.prototype.getProductCards = function (productsWithTracking) {
        var _this = this;
        var productCards = this.products
            .filter(function (p) {
            return Object.keys(p.price).length > 0;
        })
            .map(function (p) {
            var _a = p.availability, isAvailable = _a.isAvailable, max = _a.max, brandName = p.brand.name, bulkMessage = p.bulkMessage, _b = p.category, category = _b === void 0 ? [] : _b, _c = p.categories, categories = _c === void 0 ? [] : _c, extraLoyaltyPointsEarned = p.extraLoyaltyPointsEarned, foodType = p.foodType, id = p.id, isExpress = p.isExpress, isMarketPlace = p.isMarketPlace, isWarranty = p.isWarranty, links = p.links, _d = p.listName, listName = _d === void 0 ? '' : _d, name = p.name, offers = p.offers, _e = p.position, position = _e === void 0 ? null : _e, _f = p.price, currency = _f.currency, _g = _f.discount, discount = _g === void 0 ? { price: 0, type: 'none', value: 0 } : _g, originalPrice = _f.price, productColor = p.productColor, productOrigin = p.productOrigin, _h = p.size, size = _h === void 0 ? '' : _h, supplier = p.supplier, type = p.type, _j = p.unit, unitOfMeasure = _j.unitOfMeasure, incrementBy = _j.incrementBy, itemsPerUnit = _j.itemsPerUnit, min = _j.min, _k = p.variants, variants = _k === void 0 ? [] : _k, _l = p.promoVoucher, promoVoucher = _l === void 0 ? {} : _l, _m = p.isLebanon, isLebanon = _m === void 0 ? false : _m;
            var images = _this.getProductImage(links, name);
            // fallback if we rename the attribute response from category to categories
            var filteredCategory = (category || categories).filter(function (obj) { return obj.name; });
            var categoryName;
            if (filteredCategory && filteredCategory.length > 0) {
                categoryName = filteredCategory[filteredCategory.length - 1].name;
            }
            var clickTrackingUrl = _this.getTrackingFromLinks(links, 'clickTrackingUrl');
            var addToCartTrackingUrl = _this.getTrackingFromLinks(links, 'addToCartTrackingUrl');
            return {
                addToCartTrackingUrl: addToCartTrackingUrl || _this.getTrackingUrl(id, productsWithTracking, 'addToCartTrackingUrl'),
                brand: brandName,
                bulkMessage: bulkMessage,
                category: categoryName,
                clickTrackingUrl: clickTrackingUrl || _this.getTrackingUrl(id, productsWithTracking, 'clickTrackingUrl'),
                currency: currency,
                currencyPosition: _this.getCurrencyPosition(currency),
                discount: {
                    price: _this.getProductDiscountPrice(originalPrice, discount.price),
                    type: discount.type,
                    value: discount.value,
                },
                foodType: foodType,
                image: images[0] || {},
                imageLibrary: images,
                incrementBy: incrementBy,
                isAvailable: isAvailable,
                isExpress: isExpress,
                isLebanon: isLebanon,
                isMarketPlace: isMarketPlace,
                isWarranty: isWarranty,
                itemsPerUnit: itemsPerUnit,
                listName: listName,
                max: max,
                min: min,
                name: name,
                offers: offers,
                originalPrice: originalPrice,
                points: extraLoyaltyPointsEarned ? extraLoyaltyPointsEarned : 0,
                position: position,
                productColor: productColor,
                productId: id,
                productOrigin: productOrigin,
                size: size,
                supplier: supplier,
                type: type,
                unitOfMeasure: _this.getUnitOfMeasure(unitOfMeasure),
                url: _this.getProductUrl(links),
                productVariants: variants,
                promoVoucher: promoVoucher,
            };
        });
        return productCards;
    };
    return ProductTransformer;
}());

var PromoBadges$1 = function (state) { return state; };
var PromoBadgesAreaA$1 = createSelector(PromoBadges$1, function (items) {
    return items.filter(function (_a) {
        var placement = _a.placement;
        return placement === 'AREA-A';
    });
});
var PromoBadgesAreaB$1 = createSelector(PromoBadges$1, function (items) {
    return items.filter(function (_a) {
        var placement = _a.placement;
        return placement === 'AREA-B';
    });
});

var ProductTransformerV2$1 = /** @class */ (function (_super) {
    __extends(ProductTransformerV2, _super);
    function ProductTransformerV2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductTransformerV2.prototype.getTrackingUrl = function (id, productsWithTracking, key) {
        if (productsWithTracking) {
            var productWithTracking = productsWithTracking.find(function (product) { return product.id === id; });
            var trackingLink = productWithTracking
                ? productWithTracking.links.tracking.find(function (link) { return link.kind === key; })
                : '';
            return trackingLink ? trackingLink.href : EMPTY_LINK$1;
        }
        return '';
    };
    ProductTransformerV2.prototype.onLoadTrackingCall = function (links) {
        if (links === void 0) { links = []; }
        links.map(function (link) {
            if (link.rel === 'tracking' && link.kind === 'loadTrackingUrl') {
                fetch(link === null || link === void 0 ? void 0 : link.href);
            }
        });
    };
    ProductTransformerV2.prototype.getApplicablePrice = function (price) {
        var discount = price.discount;
        return (discount === null || discount === void 0 ? void 0 : discount.minBuyingValue) || (discount === null || discount === void 0 ? void 0 : discount.price) || (price === null || price === void 0 ? void 0 : price.minBuyingValue) || (price === null || price === void 0 ? void 0 : price.price);
    };
    ProductTransformerV2.prototype.getProductCards = function (productsWithTracking, adtechCarouselId) {
        var _this = this;
        var productCards = this.products
            .filter(function (p) {
            return Object.keys(p.price || {}).length > 0;
        })
            .map(function (p) {
            var _a, _b, _c, _d;
            var dietary = p.dietary, _e = p.availability, isAvailable = _e.isAvailable, max = _e.max, brandName = p.brand.name, bulkMessage = p.bulkMessage, _f = p.category, category = _f === void 0 ? [] : _f, extraLoyaltyPointsEarned = p.extraLoyaltyPointsEarned, foodType = p.foodType, id = p.id, isExpress = p.isExpress, isMarketPlace = p.isMarketPlace, isWarranty = p.isWarranty, _g = p.links, newProductCardImages = _g.defaultImages, productImages = _g.images, productUrl = _g.productUrl, tracking = _g.tracking, _h = p.listName, listName = _h === void 0 ? '' : _h, name = p.name, offers = p.offers, _j = p.position, position = _j === void 0 ? null : _j, price = p.price, productColor = p.productColor, productOrigin = p.productOrigin, _k = p.size, size = _k === void 0 ? '' : _k, supplier = p.supplier, type = p.type, _l = p.unit, unitOfMeasure = _l.unitOfMeasure, incrementBy = _l.incrementBy, itemsPerUnit = _l.itemsPerUnit, min = _l.min, _m = _l.unitItem, unitItem = _m === void 0 ? '' : _m, variants = p.variants, _o = p.promoVoucher, promoVoucher = _o === void 0 ? {} : _o, _p = p.promoBadges, promoBadges = _p === void 0 ? [] : _p, _q = p.isLebanon, isLebanon = _q === void 0 ? false : _q, _r = p.isSponsored, isSponsored = _r === void 0 ? false : _r, _s = p.sponsorID, sponsorID = _s === void 0 ? '' : _s, _t = p.sponsorId, sponsorId = _t === void 0 ? '' : _t, _u = p.availableVariants, availableVariants = _u === void 0 ? [] : _u, selectedVariant = p.selectedVariant, _v = p.isScalable, isScalable = _v === void 0 ? false : _v, _w = p.preorder, preorder = _w === void 0 ? false : _w, _x = p.isFBC, isFBC = _x === void 0 ? false : _x, _y = p.delivery, delivery = _y === void 0 ? [] : _y, deliveryFees = p.deliveryFees, soldByWeight = p.soldByWeight, _z = p.campaignName, campaignName = _z === void 0 ? '' : _z, _0 = p.campaignId, campaignId = _0 === void 0 ? '' : _0;
            var currency = price.currency, minBuyingValue = price.minBuyingValue, _1 = price.discount, discount = _1 === void 0 ? { price: 0, type: 'none', value: 0, minBuyingValue: '' } : _1, originalPrice = price.price;
            var applicablePrice = _this.getApplicablePrice(price);
            var images = _this.getProductImage(productImages, name);
            // fallback if we rename the attribute response from category to categories
            var filteredCategory = category.filter(function (obj) { return obj.name; });
            var categoryName;
            if (filteredCategory && filteredCategory.length > 0) {
                categoryName = filteredCategory[filteredCategory.length - 1].name;
            }
            var clickTrackingUrl = _this.getTrackingFromLinks(tracking, 'clickTrackingUrl');
            var addToCartTrackingUrl = _this.getTrackingFromLinks(tracking, 'addToCartTrackingUrl');
            var viewTrackingUrl = _this.getTrackingFromLinks(tracking, 'viewTrackingUrl');
            var rightClickTrackingURL = _this.getTrackingFromLinks(tracking, 'rightClickTrackingURL');
            var updateCartTrackingURL = _this.getTrackingFromLinks(tracking, 'updateCartTrackingUrl');
            _this.onLoadTrackingCall(tracking);
            var getSelectedVariant = (_b = (_a = variants === null || variants === void 0 ? void 0 : variants[0]) === null || _a === void 0 ? void 0 : _a.childElements) === null || _b === void 0 ? void 0 : _b.find(function (ele) { return ele.selected; });
            var selectedVariantQualifier = (_c = getSelectedVariant === null || getSelectedVariant === void 0 ? void 0 : getSelectedVariant.variantData) === null || _c === void 0 ? void 0 : _c.variantOptionQualifiers[0];
            var selectedVariantCode = ((_d = getSelectedVariant === null || getSelectedVariant === void 0 ? void 0 : getSelectedVariant.variantData) === null || _d === void 0 ? void 0 : _d.code) || '';
            return {
                addToCartTrackingUrl: addToCartTrackingUrl || _this.getTrackingUrl(id, productsWithTracking, 'addToCartTrackingUrl'),
                brand: brandName,
                bulkMessage: bulkMessage,
                category: categoryName,
                clickTrackingUrl: clickTrackingUrl || _this.getTrackingUrl(id, productsWithTracking, 'clickTrackingUrl'),
                viewTrackingUrl: viewTrackingUrl || _this.getTrackingUrl(id, productsWithTracking, 'viewTrackingUrl'),
                updateCartTrackingURL: updateCartTrackingURL,
                rightClickTrackingURL: rightClickTrackingURL || _this.getTrackingUrl(id, productsWithTracking, 'rightClickTrackingURL'),
                currency: currency,
                currencyPosition: _this.getCurrencyPosition(currency),
                discount: {
                    price: _this.getProductDiscountPrice(originalPrice, discount.price),
                    type: discount.type,
                    value: discount.value,
                    minBuyingValue: discount.minBuyingValue,
                },
                foodType: foodType,
                image: images[0] || {},
                newProductCardImage: newProductCardImages ? newProductCardImages[0] : '',
                imageLibrary: images,
                newProductCardImageLibrary: newProductCardImages,
                incrementBy: incrementBy,
                isAvailable: isAvailable,
                isExpress: isExpress,
                isLebanon: isLebanon,
                isSponsored: isSponsored,
                isMarketPlace: isMarketPlace,
                isWarranty: isWarranty,
                itemsPerUnit: itemsPerUnit,
                listName: listName,
                max: max,
                min: min,
                minBuyingValue: minBuyingValue,
                name: name,
                offers: offers,
                originalPrice: originalPrice,
                applicablePrice: applicablePrice,
                points: extraLoyaltyPointsEarned ? extraLoyaltyPointsEarned : 0,
                position: position,
                productColor: productColor,
                productId: id,
                productOrigin: productOrigin,
                size: size,
                supplier: supplier,
                type: type,
                unitOfMeasure: _this.getUnitOfMeasure(unitOfMeasure),
                url: productUrl.href,
                productVariants: variants || '',
                promoVoucher: promoVoucher,
                promoBadges: promoBadges,
                promoBadgesAreaA: PromoBadgesAreaA$1(promoBadges),
                promoBadgesAreaB: PromoBadgesAreaB$1(promoBadges),
                categories: category,
                sponsorID: sponsorID || sponsorId,
                availableVariants: availableVariants,
                selectedVariant: selectedVariant || selectedVariantQualifier || '',
                unitItem: unitItem,
                isScalable: isScalable,
                selectedVariantCode: selectedVariantCode,
                preorder: preorder,
                isFBC: isFBC,
                delivery: delivery,
                dietary: dietary,
                deliveryFees: deliveryFees,
                soldByWeight: soldByWeight,
                campaignId: campaignId,
                campaignName: campaignName,
                adtechCarouselId: adtechCarouselId,
            };
        });
        return productCards;
    };
    return ProductTransformerV2;
}(ProductTransformer$1));

var ProductServices$2 = /** @class */ (function (_super) {
    __extends(ProductServices, _super);
    function ProductServices() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductServices.prototype.getRelevanceByKeyword = function (keyword, placements) {
        return __awaiter(this, void 0, void 0, function () {
            var relevantProducts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doGet(GET_RELEVANCE_PRODUCTS_KEYWORD$1, {
                            keyword: keyword,
                            placements: placements,
                        })];
                    case 1:
                        relevantProducts = _a.sent();
                        if (relevantProducts && relevantProducts.placements) {
                            return [2 /*return*/, this.getRelevantProductCards(relevantProducts)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductServices.prototype.getRelevanceById = function (id, placements) {
        return __awaiter(this, void 0, void 0, function () {
            var relevantProducts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doGet(GET_RELEVANCE_PRODUCTS_ID$1, {
                            id: id,
                            placements: placements,
                        })];
                    case 1:
                        relevantProducts = _a.sent();
                        if (relevantProducts && relevantProducts.placements) {
                            return [2 /*return*/, this.getRelevantProductCards(relevantProducts)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductServices.prototype.getRelevanceByKeywordV2 = function (keyword, placements) {
        return __awaiter(this, void 0, void 0, function () {
            var store, _a, _b, appConfig, _c, deliveryTime, _d, pageStructure, _e, pageIntent, intent, nonFoodV2GbValue, intentHeaders, relevantProducts;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        store = getStore$1();
                        _a = (store === null || store === void 0 ? void 0 : store.getState()) || {}, _b = _a.appConfig, appConfig = _b === void 0 ? {} : _b, _c = _a.deliveryTime, deliveryTime = _c === void 0 ? {} : _c, _d = _a.pageStructure, pageStructure = _d === void 0 ? [] : _d;
                        _e = appConfig.pageIntent, pageIntent = _e === void 0 ? false : _e;
                        intent = getSearchIntent$1(pageIntent, deliveryTime);
                        nonFoodV2GbValue = isNonFoodV2Enabled$1((store === null || store === void 0 ? void 0 : store.getState()) || {});
                        intentHeaders = {};
                        if (nonFoodV2GbValue.value) {
                            intentHeaders = getIntentAndServiceType$1(pageStructure);
                        }
                        return [4 /*yield*/, this.doGet(GET_RELEVANCE_PRODUCTS_KEYWORD$1, {
                                keyword: keyword,
                                placements: placements,
                                headers: __assign({ intent: intent }, intentHeaders),
                            })];
                    case 1:
                        relevantProducts = _f.sent();
                        return [2 /*return*/, this.mapRelvantProductCards(relevantProducts)];
                }
            });
        });
    };
    ProductServices.prototype.getRelevanceByIdV2 = function (id, placements) {
        return __awaiter(this, void 0, void 0, function () {
            var relevantProducts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doGet(GET_RELEVANCE_PRODUCTS_ID$1, {
                            id: id,
                            placements: placements,
                        })];
                    case 1:
                        relevantProducts = _a.sent();
                        return [2 /*return*/, this.mapRelvantProductCards(relevantProducts)];
                }
            });
        });
    };
    ProductServices.prototype.getProductCardsByIdV2 = function (ids, recommendedProducts) {
        return __awaiter(this, void 0, void 0, function () {
            var store, _a, _b, appConfig, _c, deliveryTime, _d, pageStructure, _e, pageIntent, intent, nonFoodV2GbValue, intentHeaders, _f, products, transformer, formattedProducts;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        store = getStore$1();
                        _a = (store === null || store === void 0 ? void 0 : store.getState()) || {}, _b = _a.appConfig, appConfig = _b === void 0 ? {} : _b, _c = _a.deliveryTime, deliveryTime = _c === void 0 ? {} : _c, _d = _a.pageStructure, pageStructure = _d === void 0 ? [] : _d;
                        _e = appConfig.pageIntent, pageIntent = _e === void 0 ? false : _e;
                        intent = getSearchIntent$1(pageIntent, deliveryTime);
                        nonFoodV2GbValue = isNonFoodV2Enabled$1((store === null || store === void 0 ? void 0 : store.getState()) || {});
                        intentHeaders = {};
                        if (nonFoodV2GbValue.value) {
                            intentHeaders = getIntentAndServiceType$1(pageStructure);
                        }
                        return [4 /*yield*/, this.doGet(GET_PRODUCTS_BY_IDS_V4$1, { ids: ids, headers: __assign({ intent: intent }, intentHeaders) })];
                    case 1:
                        _f = (_g.sent()).products, products = _f === void 0 ? [] : _f;
                        transformer = new ProductTransformerV2$1(products);
                        formattedProducts = transformer.getProductCards(recommendedProducts);
                        return [2 /*return*/, formattedProducts];
                }
            });
        });
    };
    ProductServices.prototype.getProductCardsByFilters = function (productsFilterPayload, recommendedProducts) {
        return __awaiter(this, void 0, void 0, function () {
            var store, _a, _b, appConfig, _c, deliveryTime, _d, pageStructure, _e, pageIntent, _f, latitude, _g, longitude, _h, lang, intent, nonFoodV2GbValue, intentHeaders, transformedProducts, _j, data, transformer, formattedProducts;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        store = getStore$1();
                        _a = (store === null || store === void 0 ? void 0 : store.getState()) || {}, _b = _a.appConfig, appConfig = _b === void 0 ? {} : _b, _c = _a.deliveryTime, deliveryTime = _c === void 0 ? {} : _c, _d = _a.pageStructure, pageStructure = _d === void 0 ? [] : _d;
                        _e = appConfig.pageIntent, pageIntent = _e === void 0 ? false : _e, _f = appConfig.latitude, latitude = _f === void 0 ? '' : _f, _g = appConfig.longitude, longitude = _g === void 0 ? '' : _g, _h = appConfig.language, lang = _h === void 0 ? '' : _h;
                        intent = getSearchIntent$1(pageIntent, deliveryTime);
                        nonFoodV2GbValue = isNonFoodV2Enabled$1((store === null || store === void 0 ? void 0 : store.getState()) || {});
                        intentHeaders = {};
                        if (nonFoodV2GbValue.value) {
                            intentHeaders = getIntentAndServiceType$1(pageStructure);
                        }
                        transformedProducts = productsFilterPayload.map(function (product) { return (__assign({ id: product.productId }, (product.filters && { filters: product.filters }))); });
                        return [4 /*yield*/, this.doGet(GET_PRODUCTS_BY_FILTERS_V4$1, { headers: __assign({ intent: intent }, intentHeaders) }, true, {
                                method: EApiMiddlewareMethod$3.POST,
                                data: {
                                    products: transformedProducts,
                                    locationParams: {
                                        latitude: latitude,
                                        longitude: longitude,
                                    },
                                    lang: lang,
                                },
                            })];
                    case 1:
                        _j = (_k.sent()).data, data = _j === void 0 ? {} : _j;
                        transformer = new ProductTransformerV2$1(data === null || data === void 0 ? void 0 : data.products);
                        formattedProducts = transformer.getProductCards(recommendedProducts);
                        return [2 /*return*/, formattedProducts];
                }
            });
        });
    };
    ProductServices.prototype.getProductCardsWithOffset = function (ids, recommendedProducts, nextPageOffset) {
        if (nextPageOffset === void 0) { nextPageOffset = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, products, nextOffset, transformer, formattedProducts;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.doGet(GET_PRODUCTS_BY_IDS_WITH_OFFSET$1, {
                            ids: ids,
                            nextPageOffset: nextPageOffset,
                        })];
                    case 1:
                        _a = _b.sent(), products = _a.products, nextOffset = _a.nextOffset;
                        transformer = new ProductTransformer$1(products);
                        formattedProducts = transformer.getProductCards(recommendedProducts);
                        return [2 /*return*/, { products: formattedProducts, nextOffset: nextOffset }];
                }
            });
        });
    };
    ProductServices.prototype.mapRelvantProductCards = function (relevantProducts) {
        if (relevantProducts && relevantProducts.placements) {
            return relevantProducts.placements.map(function (placement) {
                var _a = placement.recommendedProducts, recommendedProducts = _a === void 0 ? [] : _a, strategyMessage = placement.strategyMessage, strategyName = placement.strategyName;
                var transformer = new ProductTransformerV2$1(recommendedProducts);
                return {
                    strategyMessage: strategyMessage,
                    strategyName: strategyName,
                    productCards: transformer.getProductCards(),
                };
            });
        }
    };
    ProductServices.prototype.getRelevantProductCards = function (relevantProducts) {
        return __awaiter(this, void 0, void 0, function () {
            var placementData;
            var _this = this;
            return __generator(this, function (_a) {
                placementData = relevantProducts.placements;
                return [2 /*return*/, Promise.all(placementData.map(function (placement) { return __awaiter(_this, void 0, void 0, function () {
                        var ids, productCards;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    ids = placement.recommendedProducts.map(function (product) {
                                        return product.id.toString();
                                    });
                                    return [4 /*yield*/, this.getProductCardsByIdV2(ids, placement.recommendedProducts)];
                                case 1:
                                    productCards = _a.sent();
                                    return [2 /*return*/, {
                                            strategyMessage: placement.strategyMessage,
                                            strategyName: placement.strategyName,
                                            productCards: productCards,
                                        }];
                            }
                        });
                    }); }))];
            });
        });
    };
    ProductServices.prototype.getRelevance = function (_a, isSponsoredFbt, productL1Category) {
        if (isSponsoredFbt === void 0) { isSponsoredFbt = false; }
        if (productL1Category === void 0) { productL1Category = ''; }
        var id = _a.id, keyword = _a.keyword, placements = _a.placements, extraParams = __rest(_a, ["id", "keyword", "placements"]);
        return __awaiter(this, void 0, void 0, function () {
            var store, _b, _c, appConfig, _d, deliveryTime, _e, pageStructure, _f, storeId, _g, pageIntent, API, param, intent, nonFoodV2GbValue, intentHeaders, eParams, relevantProducts;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        store = getStore$1();
                        _b = (store === null || store === void 0 ? void 0 : store.getState()) || {}, _c = _b.appConfig, appConfig = _c === void 0 ? {} : _c, _d = _b.deliveryTime, deliveryTime = _d === void 0 ? {} : _d, _e = _b.pageStructure, pageStructure = _e === void 0 ? [] : _e;
                        _f = appConfig || {}, storeId = _f.storeId, _g = _f.pageIntent, pageIntent = _g === void 0 ? false : _g;
                        API = GET_RELEVANCE_PRODUCTS_KEYWORD$1;
                        param = { keyword: keyword };
                        if (id) {
                            API = isSponsoredFbt
                                ? GET_RELEVANCE_PRODUCTS_ID$1 + "&requireSponsProducts=true&categoryId=" + productL1Category
                                : GET_RELEVANCE_PRODUCTS_ID$1;
                            param = { id: id };
                        }
                        if (storeId === 'mafuae' && placements.includes('home_page')) {
                            API = GET_RELEVANCE_PRODUCTS_KEYWORD_HOME$1;
                        }
                        if (placements.includes('buy_again_alternatives')) {
                            API = GET_RELEVANCE_PRODUCTS_FOR_OOS_ITEM$1;
                        }
                        intent = getSearchIntent$1(pageIntent, deliveryTime);
                        nonFoodV2GbValue = isNonFoodV2Enabled$1((store === null || store === void 0 ? void 0 : store.getState()) || {});
                        intentHeaders = {};
                        if (nonFoodV2GbValue.value) {
                            intentHeaders = getIntentAndServiceType$1(pageStructure);
                        }
                        eParams = __assign(__assign({}, extraParams), { headers: __assign(__assign(__assign({}, extraParams.headers), { intent: intent }), intentHeaders) });
                        return [4 /*yield*/, this.doGet(API, __assign(__assign({ placements: placements }, param), eParams))];
                    case 1:
                        relevantProducts = _h.sent();
                        if (relevantProducts === null || relevantProducts === void 0 ? void 0 : relevantProducts.placements) {
                            return [2 /*return*/, relevantProducts.placements.map(function (placement) {
                                    var _a = placement.recommendedProducts, recommendedProducts = _a === void 0 ? [] : _a;
                                    return __assign(__assign({}, placement), { recommendedProducts: new ProductTransformerV2$1(recommendedProducts).getProductCards() });
                                })];
                        }
                        else {
                            return [2 /*return*/, []];
                        }
                }
            });
        });
    };
    return ProductServices;
}(BaseService$1));
var ProductServices$3 = new ProductServices$2();

var AppConfigService$2 = /** @class */ (function (_super) {
    __extends(AppConfigService, _super);
    function AppConfigService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppConfigService.prototype.getAppCountryConfig = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var isAbsUrl, url;
            return __generator(this, function (_a) {
                isAbsUrl = process.env.APIGEE_ENDPOINT ? true : false;
                url = isAbsUrl ? process.env.APIGEE_ENDPOINT + "/v1/" + GET_USER_COUNTRY_CONFIG$1 : GET_USER_COUNTRY_CONFIG$1;
                return [2 /*return*/, this.doSafeGet(url, __assign(__assign({}, params), { apiVersion: 1 }), isAbsUrl)];
            });
        });
    };
    AppConfigService.prototype.getHeaderDetails = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doGet(GET_HEADER$1, params, true)];
            });
        });
    };
    AppConfigService.prototype.getFeatureDetails = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doSafeGet(FETCH_GROWTHBOOK$1, params, true)];
            });
        });
    };
    AppConfigService.prototype.getAppMenu = function (params) {
        if (params === void 0) { params = {}; }
        return this.doGet(GET_MENU_NAVIGATION$1, params, true);
    };
    AppConfigService.prototype.setAreaCode = function (areaCode, params) {
        return this.doPut(SET_DELIVERY_AREA$1, __assign({ areaCode: areaCode }, params));
    };
    AppConfigService.prototype.getCoachMarkDetails = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doGet(GET_COACHMARK_DETAILS$1, params, true)];
            });
        });
    };
    AppConfigService.prototype.getAppDeliveryMenu = function (areaCode, storeId, language, latitude, longitude, addressId, guid, isStoreClosureEnabled) {
        var apiUrl = isStoreClosureEnabled ? GET_NAVBAR_DELIVERY_NEW$1 : GET_NAVBAR_DELIVERY$1;
        var headers = isStoreClosureEnabled
            ? __assign({ latitude: latitude, longitude: longitude, addressId: addressId, lang: language }, (guid && { guid: guid })) : {};
        if (latitude && longitude) {
            return this.doGet(apiUrl, { areaCode: areaCode, storeId: storeId, language: language, latitude: latitude, longitude: longitude, headers: headers });
        }
        return this.doGet(apiUrl, { areaCode: areaCode, storeId: storeId, language: language, headers: headers }, false);
    };
    AppConfigService.prototype.getCountryConfig = function (params) {
        return this.getAppCountryConfig(params);
    };
    AppConfigService.prototype.getPageStructure = function (storeId, lang, serviceInfo, nonFoodV2GbValue) {
        return __awaiter(this, void 0, void 0, function () {
            var isNonFoodV2Enabled, pageStructureUid;
            return __generator(this, function (_a) {
                isNonFoodV2Enabled = nonFoodV2GbValue.value, pageStructureUid = nonFoodV2GbValue.pageStructureUid;
                return [2 /*return*/, this.doGet(isNonFoodV2Enabled ? GET_PAGE_STRUCTURE_V2$1 : GET_PAGE_STRUCTURE$1, {
                        storeId: storeId,
                        headers: {
                            lang: lang,
                            storeId: storeId,
                            langCode: lang,
                            serviceInfo: serviceInfo,
                        },
                        pageStructureUid: pageStructureUid,
                    }, !isServer$1() ? true : false)];
            });
        });
    };
    AppConfigService.prototype.getCountryDetailsApi = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doGet(GET_COUNTRY_DETAILS_API$1, {}, true)];
            });
        });
    };
    return AppConfigService;
}(BaseService$1));
var AppConfigService$3 = new AppConfigService$2();

var getBusyHourStatus$1 = function (slot) { var _a; return !!((_a = slot === null || slot === void 0 ? void 0 : slot.busyStatus) === null || _a === void 0 ? void 0 : _a.isBusy); };
var getOfflineHourStatus$1 = function (slot) { return !!(!(slot === null || slot === void 0 ? void 0 : slot.isAvailable) && (slot === null || slot === void 0 ? void 0 : slot.nextAvailableSlot)); };
var getNextAvailableSlot$1 = function (slot, isOfflineHour) {
    return isOfflineHour ? slot === null || slot === void 0 ? void 0 : slot.nextAvailableSlot : undefined;
};
var getBusyHourDisclaimer$1 = function (slot, isBusyHour) { var _a, _b; return isBusyHour ? (_b = (_a = slot === null || slot === void 0 ? void 0 : slot.busyStatus) === null || _a === void 0 ? void 0 : _a.disclaimerMessage) !== null && _b !== void 0 ? _b : '' : ''; };

var headTabActions$1 = function () { return function (dispatch, getState, cookies) { return __awaiter(void 0, void 0, void 0, function () {
    var store, appConfig, deliveryTime, _a, areaCode, _b, language, _c, storeId, _d, latitude, _e, longitude, isPolygonChange, lat, long, addressId, token, guid, guidHeader, responsePageStructure, responseDeliveryTime, nonFoodV2GbValue, isStoreClosureEnabled, err_1, _f, _g, standardSlot, _h, expressSlot, _j, qcommSlot, _k, availableServices, serviceInfo, err_2, _l, topNavigations, navigations, expressPos, e_1;
    var _m, _o, _p;
    return __generator(this, function (_q) {
        switch (_q.label) {
            case 0:
                store = getState();
                appConfig = store.appConfig, deliveryTime = store.deliveryTime;
                _a = appConfig.areaCode, areaCode = _a === void 0 ? '' : _a, _b = appConfig.language, language = _b === void 0 ? 'en' : _b, _c = appConfig.storeId, storeId = _c === void 0 ? 'mafuae' : _c, _d = appConfig.latitude, latitude = _d === void 0 ? '' : _d, _e = appConfig.longitude, longitude = _e === void 0 ? '' : _e, isPolygonChange = appConfig.isPolygonChange;
                _q.label = 1;
            case 1:
                _q.trys.push([1, 10, , 11]);
                lat = (cookies === null || cookies === void 0 ? void 0 : cookies.get('lat')) || latitude;
                long = (cookies === null || cookies === void 0 ? void 0 : cookies.get('long')) || longitude;
                addressId = (cookies === null || cookies === void 0 ? void 0 : cookies.get('selectedAddressID')) || '';
                token = (cookies === null || cookies === void 0 ? void 0 : cookies.get('authToken')) || '';
                guid = cookies === null || cookies === void 0 ? void 0 : cookies.get(storeId + "-cart");
                guidHeader = !token && guid ? guid : '';
                responsePageStructure = [];
                responseDeliveryTime = (deliveryTime || {});
                nonFoodV2GbValue = isNonFoodV2Enabled$1(store);
                isStoreClosureEnabled = isStoreClosureEnabled$1(store);
                if (!!isPolygonChange) return [3 /*break*/, 5];
                _q.label = 2;
            case 2:
                _q.trys.push([2, 4, , 5]);
                return [4 /*yield*/, AppConfigService$3.getAppDeliveryMenu(areaCode, storeId, language || 'en', lat, long, addressId, guidHeader, isStoreClosureEnabled)];
            case 3:
                responseDeliveryTime = _q.sent();
                return [3 /*break*/, 5];
            case 4:
                err_1 = _q.sent();
                console.error('deliveryTime API failed', err_1);
                return [3 /*break*/, 5];
            case 5:
                _f = responseDeliveryTime || {}, _g = _f.standardSlot, standardSlot = _g === void 0 ? {} : _g, _h = _f.expressSlot, expressSlot = _h === void 0 ? {} : _h, _j = _f.qcommSlot, qcommSlot = _j === void 0 ? {} : _j, _k = _f.availableServices, availableServices = _k === void 0 ? '' : _k;
                serviceInfo = availableServices;
                if (!availableServices) {
                    console.info('Empty Available service', JSON.stringify({ responseDeliveryTime: responseDeliveryTime, lat: lat, long: long, areaCode: areaCode }));
                }
                _q.label = 6;
            case 6:
                _q.trys.push([6, 8, , 9]);
                return [4 /*yield*/, AppConfigService$3.getPageStructure(storeId, language, serviceInfo, nonFoodV2GbValue)];
            case 7:
                responsePageStructure = _q.sent();
                return [3 /*break*/, 9];
            case 8:
                err_2 = _q.sent();
                console.error('Page Structure API failed', err_2);
                return [3 /*break*/, 9];
            case 9:
                _l = responsePageStructure.topNavigations, topNavigations = _l === void 0 ? [] : _l;
                navigations = responseDeliveryTime
                    ? populatePageStructure$1({
                        deliveryTime: responseDeliveryTime,
                        topNavigations: topNavigations,
                        isNonFoodV2Enabled: (nonFoodV2GbValue === null || nonFoodV2GbValue === void 0 ? void 0 : nonFoodV2GbValue.value) || false,
                    })
                    : topNavigations;
                dispatch({
                    type: EPageSturctureTypes$3.SET_PAGE_STRUCTURE,
                    payload: navigations,
                });
                dispatch({
                    type: EDeliveryTimeTypes$1.SET_DELIVERY_TIME,
                    payload: responseDeliveryTime,
                });
                expressPos = responseDeliveryTime.expressSlot || ((_m = responseDeliveryTime === null || responseDeliveryTime === void 0 ? void 0 : responseDeliveryTime.expressSlot) === null || _m === void 0 ? void 0 : _m.nextAvailableSlot);
                dispatch(init$1({
                    expressPos: expressPos,
                }));
                return [2 /*return*/, {
                        isNowAvailable: (expressSlot === null || expressSlot === void 0 ? void 0 : expressSlot.isAvailable) || (expressSlot === null || expressSlot === void 0 ? void 0 : expressSlot.nextAvailableSlot) ? true : false,
                        isQuickCommerceAvailable: (qcommSlot === null || qcommSlot === void 0 ? void 0 : qcommSlot.isAvailable) || (qcommSlot === null || qcommSlot === void 0 ? void 0 : qcommSlot.nextAvailableSlot),
                        isQuickCommerceNextSlot: (qcommSlot === null || qcommSlot === void 0 ? void 0 : qcommSlot.nextAvailableSlot) ? true : false,
                        isNowNextSlot: (expressSlot === null || expressSlot === void 0 ? void 0 : expressSlot.nextAvailableSlot) ? true : false,
                        isNowBusyHour: (_o = expressSlot === null || expressSlot === void 0 ? void 0 : expressSlot.busyStatus) === null || _o === void 0 ? void 0 : _o.isBusy,
                        isQcommBusyHour: (_p = qcommSlot === null || qcommSlot === void 0 ? void 0 : qcommSlot.busyStatus) === null || _p === void 0 ? void 0 : _p.isBusy,
                        topNavigations: navigations,
                        isStandardAvailable: (standardSlot === null || standardSlot === void 0 ? void 0 : standardSlot.isAvailable) || false,
                    }];
            case 10:
                e_1 = _q.sent();
                console.error(e_1);
                return [2 /*return*/, {
                        isNowAvailable: false,
                        isQuickCommerceAvailable: false,
                        isNowNextSlot: false,
                        isQuickCommerceNextSlot: false,
                        isNowBusyHour: false,
                        isQcommBusyHour: false,
                        topNavigations: [],
                        isStandardAvailable: false,
                    }];
            case 11: return [2 /*return*/];
        }
    });
}); }; };
function populatePageStructure$1(_a) {
    var deliveryTime = _a.deliveryTime, topNavigations = _a.topNavigations, isNonFoodV2Enabled = _a.isNonFoodV2Enabled;
    var _b = deliveryTime.standardSlot, standardSlot = _b === void 0 ? {} : _b, _c = deliveryTime.expressSlot, expressSlot = _c === void 0 ? {} : _c, _d = deliveryTime.dynamicPlaceHolders, dynamicPlaceHolders = _d === void 0 ? {} : _d;
    // [homepage data, now journey data] = topNavigations;
    if (isNonFoodV2Enabled) {
        topNavigations.map(function (navigation) {
            navigation.components.forEach(function (item) {
                var _a;
                if ((item === null || item === void 0 ? void 0 : item.type) !== Constants$1.STATIC) {
                    for (var key in dynamicPlaceHolders) {
                        if (dynamicPlaceHolders[key])
                            item.title = ((_a = item.title) === null || _a === void 0 ? void 0 : _a.replace(new RegExp("{{" + key + "}}", 'g'), dynamicPlaceHolders[key])) || '';
                    }
                    var pattern = /{{[^{}]*}}/;
                    if (pattern.test(item.title)) {
                        item.title = '';
                    }
                }
            });
        });
    }
    else {
        if (topNavigations && topNavigations.length > 1) {
            if (expressSlot) {
                var _e = expressSlot.formattedSlot, formattedSlot_1 = _e === void 0 ? '' : _e, _f = expressSlot.isAvailable, isAvailable = _f === void 0 ? false : _f, nextAvailableSlot_1 = expressSlot.nextAvailableSlot;
                var _g = topNavigations[1].components, components = _g === void 0 ? [] : _g;
                if (components.length > 0) {
                    components.forEach(function (item) {
                        if (item.type !== Constants$1.STATIC) {
                            item.subTitle = formattedSlot_1 || (nextAvailableSlot_1 === null || nextAvailableSlot_1 === void 0 ? void 0 : nextAvailableSlot_1.description) || '';
                        }
                    });
                }
                topNavigations[1].isAvailable = isAvailable;
                topNavigations[1].isHide = nextAvailableSlot_1 || isAvailable ? false : true;
            }
            else {
                topNavigations[1].isAvailable = false;
                topNavigations[1].isHide = true;
            }
        }
        if (topNavigations && topNavigations.length > 0) {
            if (standardSlot) {
                var _h = standardSlot.formattedSlot, formattedSlot_2 = _h === void 0 ? '' : _h, _j = standardSlot.isAvailable, isAvailable = _j === void 0 ? false : _j;
                var _k = topNavigations[0].components, components = _k === void 0 ? [] : _k;
                if (components.length > 0) {
                    components.forEach(function (item) {
                        var _a;
                        if (item.type !== Constants$1.STATIC) {
                            item.subTitle =
                                formattedSlot_2 || (expressSlot === null || expressSlot === void 0 ? void 0 : expressSlot.formattedSlot) || ((_a = expressSlot === null || expressSlot === void 0 ? void 0 : expressSlot.nextAvailableSlot) === null || _a === void 0 ? void 0 : _a.description) || '';
                        }
                    });
                }
                topNavigations[0].isAvailable = isAvailable;
                topNavigations[0].isHide = formattedSlot_2 ? false : true;
            }
            else {
                topNavigations[0].isAvailable = false;
                topNavigations[0].isHide = false;
            }
        }
    }
    return topNavigations;
}
var getDeliveryTime$1 = function () { return function (dispatch, store, cookies, isPolygonChange) { return __awaiter(void 0, void 0, void 0, function () {
    var appConfig, _a, pageStructure, _b, areaCode, _c, language, _d, storeId, latitude, longitude, defaultCountryLat, _e, posInfoConfig, defaultCountryLng, lat, lng, addressId, token, guid, guidHeader, shouldNotFetchCoachMark, isStoreClosureEnabled, responseDeliveryTime, expressPos, nonFoodV2GbValue, pageType, navigations, updatedDeliveryInfo, e_2;
    var _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                appConfig = store.appConfig, _a = store.pageStructure, pageStructure = _a === void 0 ? [] : _a;
                _b = appConfig.areaCode, areaCode = _b === void 0 ? '' : _b, _c = appConfig.language, language = _c === void 0 ? 'en' : _c, _d = appConfig.storeId, storeId = _d === void 0 ? 'mafuae' : _d, latitude = appConfig.latitude, longitude = appConfig.longitude, defaultCountryLat = appConfig.defaultCountryLat, _e = appConfig.posInfoConfig, posInfoConfig = _e === void 0 ? [] : _e, defaultCountryLng = appConfig.defaultCountryLng;
                if (isPolygonChange) {
                    removeDeliveryAreaInfoCookie$1(cookies);
                }
                lat = latitude || (cookies === null || cookies === void 0 ? void 0 : cookies.get('lat')) || defaultCountryLat || '';
                lng = longitude || (cookies === null || cookies === void 0 ? void 0 : cookies.get('long')) || defaultCountryLng || '';
                addressId = (cookies === null || cookies === void 0 ? void 0 : cookies.get('selectedAddressID')) || '';
                token = (cookies === null || cookies === void 0 ? void 0 : cookies.get('authToken')) || '';
                guid = cookies === null || cookies === void 0 ? void 0 : cookies.get(storeId + "-cart");
                guidHeader = !token && guid ? guid : '';
                shouldNotFetchCoachMark = cookies === null || cookies === void 0 ? void 0 : cookies.get('hideCoachMark');
                isStoreClosureEnabled = isStoreClosureEnabled$1(store);
                _g.label = 1;
            case 1:
                _g.trys.push([1, 6, , 7]);
                return [4 /*yield*/, AppConfigService$3.getAppDeliveryMenu(areaCode, storeId, language || 'en', lat, lng, addressId, guidHeader, isStoreClosureEnabled)];
            case 2:
                responseDeliveryTime = _g.sent();
                expressPos = responseDeliveryTime.expressSlot || ((_f = responseDeliveryTime === null || responseDeliveryTime === void 0 ? void 0 : responseDeliveryTime.expressSlot) === null || _f === void 0 ? void 0 : _f.nextAvailableSlot);
                nonFoodV2GbValue = isNonFoodV2Enabled$1(store);
                pageType = (cookies === null || cookies === void 0 ? void 0 : cookies.get('page_type')) || 'home';
                if (pageStructure.length > 0) {
                    navigations = populatePageStructure$1({
                        deliveryTime: responseDeliveryTime,
                        topNavigations: pageStructure,
                        isNonFoodV2Enabled: nonFoodV2GbValue === null || nonFoodV2GbValue === void 0 ? void 0 : nonFoodV2GbValue.value,
                    });
                    dispatch({
                        type: EPageSturctureTypes$3.SET_PAGE_STRUCTURE,
                        payload: navigations,
                    });
                }
                return [4 /*yield*/, dispatch({
                        type: EDeliveryTimeTypes$1.SET_DELIVERY_TIME,
                        payload: responseDeliveryTime,
                    })];
            case 3:
                _g.sent();
                if (!((nonFoodV2GbValue === null || nonFoodV2GbValue === void 0 ? void 0 : nonFoodV2GbValue.value) && !shouldNotFetchCoachMark && pageType === 'home')) return [3 /*break*/, 5];
                return [4 /*yield*/, getCoachMarksDetails$1()(dispatch, store, language, storeId)];
            case 4:
                _g.sent();
                _g.label = 5;
            case 5:
                if (responseDeliveryTime.deliveryAreaInfo && isPolygonChange) {
                    updatedDeliveryInfo = responseDeliveryTime.deliveryAreaInfo.filter(function (item) {
                        return posInfoConfig.includes(item === null || item === void 0 ? void 0 : item.serviceType);
                    });
                    setDeliveryAreaInfo$1(updatedDeliveryInfo, cookies);
                }
                if (!responseDeliveryTime.expressSlot) {
                    removeNowJourneyCookie$1();
                }
                if (appConfig === null || appConfig === void 0 ? void 0 : appConfig.changingLocation) {
                    dispatch(init$1({
                        expressPos: expressPos,
                        changingLocation: false,
                        isPolygonChange: isPolygonChange,
                    }));
                }
                else {
                    dispatch(init$1({
                        expressPos: expressPos,
                        isPolygonChange: isPolygonChange,
                    }));
                }
                return [2 /*return*/, responseDeliveryTime];
            case 6:
                e_2 = _g.sent();
                if (isPolygonChange) {
                    removeDeliveryAreaInfoCookie$1();
                }
                console.error(e_2);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}); }; };
var getCoachMarksDetails$1 = function () { return function (dispatch, store, lang, storeId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b, coachMarksUid, _c, components, e_3;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 3, , 4]);
                _a = ((store === null || store === void 0 ? void 0 : store.appConfig) || { coachMarksUid: '' }).nonFoodUIDs, _b = (_a === void 0 ? {} : _a).coachMarksUid, coachMarksUid = _b === void 0 ? '' : _b;
                return [4 /*yield*/, AppConfigService$3.getCoachMarkDetails({
                        coachMarksUid: coachMarksUid,
                        headers: { storeId: storeId, lang: lang },
                    })];
            case 1:
                _c = (_d.sent()).components, components = _c === void 0 ? [] : _c;
                return [4 /*yield*/, dispatch({
                        type: EDeliveryTimeTypes$1.SET_COACHMARKS,
                        payload: components,
                    })];
            case 2:
                _d.sent();
                return [3 /*break*/, 4];
            case 3:
                e_3 = _d.sent();
                console.error(e_3);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var userJourneyActions$1 = function (dispatch, getState, cookies) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b, pageStructure, deliveryTime, result, tabsResponse;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = getState(), _b = _a.pageStructure, pageStructure = _b === void 0 ? [] : _b, deliveryTime = _a.deliveryTime;
                result = {};
                if (!(pageStructure.length && deliveryTime)) return [3 /*break*/, 1];
                result.isStandardAvailable = ((_c = deliveryTime.standardSlot) === null || _c === void 0 ? void 0 : _c.isAvailable) || false;
                slots$1.forEach(function (_a) {
                    var key = _a.key, busyHourKey = _a.busyHourKey, offlineHourKey = _a.offlineHourKey, nextSlotKey = _a.nextSlotKey, disclaimerKey = _a.disclaimerKey, unavailableHourKey = _a.unavailableHourKey, nextSlot = _a.nextSlot;
                    var slotData = deliveryTime[key];
                    var isBusyHour = getBusyHourStatus$1(slotData);
                    var isOfflineHour = getOfflineHourStatus$1(slotData);
                    result[busyHourKey] = isBusyHour;
                    result[offlineHourKey] = isOfflineHour;
                    result[nextSlotKey] = getNextAvailableSlot$1(slotData, isOfflineHour);
                    result[disclaimerKey] = getBusyHourDisclaimer$1(slotData, isBusyHour);
                    result[unavailableHourKey] = isBusyHour || isOfflineHour;
                    result[nextSlot] = !!slotData.nextAvailableSlot;
                });
                return [2 /*return*/, __assign(__assign({}, result), { topNavigations: pageStructure })];
            case 1: return [4 /*yield*/, headTabActions$1()(dispatch, getState, cookies)];
            case 2:
                tabsResponse = _d.sent();
                return [2 /*return*/, tabsResponse];
        }
    });
}); };

var headTab_actions$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    headTabActions: headTabActions$1,
    getDeliveryTime: getDeliveryTime$1,
    getCoachMarksDetails: getCoachMarksDetails$1,
    userJourneyActions: userJourneyActions$1
});

var addRedirection$1 = function (url, redirection) {
    return url + "?redirect=" + redirection;
};
var updateQueryStringParamter$1 = function (uri, key, value) {
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + encodeURIComponent(value) + '$2');
    }
    else {
        return uri + separator + key + '=' + encodeURIComponent(value);
    }
};

var url_util$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    addRedirection: addRedirection$1,
    updateQueryStringParamter: updateQueryStringParamter$1
});

var getImageUrl$1 = function (product) {
    return product.images && product.images.length > 0 ? product.images[product.images.length - 1].url : '';
};
var updateImageResizeInUrl$1 = function (url, resizeValue) {
    var resizePattern = /\?im=Resize=\d+/; // Regular expression to match ?im=Resize=<any number>
    var match = url.match(resizePattern);
    if (match && resizeValue) {
        return url.replace(resizePattern, "?im=Resize=" + resizeValue);
    }
    else if (!match && resizeValue) {
        // If the resize parameter doesn't exist, append it
        var separator = url.includes('?') ? '&' : '?';
        return "" + url + separator + "im=Resize=" + resizeValue;
    }
    else {
        return url;
    }
};

var image_util$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getImageUrl: getImageUrl$1,
    updateImageResizeInUrl: updateImageResizeInUrl$1
});

var setDisabled$1 = function (state) { return ({
    type: EProductListTypes$3.SET_DISABLED,
    payload: state,
}); };
var setRelevantProductId$1 = function (id) { return ({
    type: EProductListTypes$3.SET_RELEVANT_PRODUCT_ID,
    payload: id,
}); };
var setProducts = function (products, totalProducts) { return ({
    type: EProductListTypes$3.SET_PRODUCTS,
    payload: { products: products, totalProducts: totalProducts },
}); };
var setExpandedQtySelectorProductId$1 = function (productId) {
    if (productId === void 0) { productId = ''; }
    return ({
        type: EProductListTypes$3.SET_EXPANDED_QTY_SELECTOR_PRODUCT_ID,
        payload: productId,
    });
};

var setLoading$1 = function (productId, loading) { return ({
    type: EProductCardTypes$3.SET_LOADING,
    payload: { productId: productId, loading: loading },
}); };
var setError$1 = function (productId, error, errDetail, persistent) {
    if (errDetail === void 0) { errDetail = ''; }
    if (persistent === void 0) { persistent = true; }
    return ({
        type: EProductCardTypes$3.SET_ERROR,
        payload: { productId: productId, error: error, errDetail: errDetail, persistent: persistent },
    });
};
var getAlgoliaUrl$1 = function (url, params) {
    var _a = params.productPositions, productPositions = _a === void 0 ? '' : _a, _b = params.searchQueryID, searchQueryID = _b === void 0 ? '' : _b, _c = params.sortBy, sortBy = _c === void 0 ? '' : _c;
    var urlParams = [];
    if (productPositions) {
        urlParams.push('productPositions=[{{productPositions}}]');
    }
    if (searchQueryID) {
        urlParams.push('searchQueryID={{searchQueryID}}');
    }
    if (sortBy) {
        urlParams.push('sortBy={{sortBy}}');
    }
    if (urlParams.length > 0) {
        url = url + '&';
    }
    url = url + urlParams.join('&');
    return url;
};
var algoliaTracking$1 = function (trackingParams) { return function (dispatch, getState) {
    var _a = getState().appConfig, language = _a.language, _b = _a.sessionId, sessionId = _b === void 0 ? '' : _b;
    var url = getAlgoliaUrl$1(TRACKING_ALGOLIA_URL$1, trackingParams);
    dispatch({
        type: EProductCardTypes$3.SET_TRACKING,
        payload: {
            headers: __assign({}, overridesUserIdHeader$1(sessionId)),
            isAbsUrl: true,
            url: url,
            method: EApiMiddlewareMethod$3.GET,
            params: __assign(__assign({}, trackingParams), { lang: language }),
        },
    });
}; };

var EProductCardBorderType$1;
(function (EProductCardBorderType) {
    EProductCardBorderType["DISCOUNT"] = "DISCOUNT";
    EProductCardBorderType["IN_CART"] = "IN_CART";
    EProductCardBorderType["ORIGINAL"] = "ORIGINAL";
    EProductCardBorderType["SPONSORED_LISTING"] = "SPONSORED_LISTING";
})(EProductCardBorderType$1 || (EProductCardBorderType$1 = {}));
var eventTypeEnum$1;
(function (eventTypeEnum) {
    eventTypeEnum["add_to_cart"] = "add_to_cart";
    eventTypeEnum["remove_from_cart"] = "remove_from_cart";
    eventTypeEnum["change_the_quantity"] = "change_the_quantity";
})(eventTypeEnum$1 || (eventTypeEnum$1 = {}));

var CLICK_EVENT$1 = 'click';
var ATC_EVENT$1 = 'atc';
var STOCK_ALERT$1 = 5;
var QTY_SELECTOR_TIMER$1 = 5000;
var DiscountType$1;
(function (DiscountType) {
    DiscountType["PERCENTAGE"] = "percentage";
})(DiscountType$1 || (DiscountType$1 = {}));
var ATC_EVENTS_TYPE$1;
(function (ATC_EVENTS_TYPE) {
    ATC_EVENTS_TYPE["PDP"] = "PDP";
    ATC_EVENTS_TYPE["PLP"] = "PLP";
})(ATC_EVENTS_TYPE$1 || (ATC_EVENTS_TYPE$1 = {}));
var ProductType$1;
(function (ProductType) {
    ProductType["FOOD"] = "FOOD";
    ProductType["NONFOOD"] = "NONFOOD";
})(ProductType$1 || (ProductType$1 = {}));
var EProductCardVariants$1;
(function (EProductCardVariants) {
    EProductCardVariants["REGULAR"] = "regular";
    EProductCardVariants["REGULAR_WIDE"] = "regular_wide";
    EProductCardVariants["PDP"] = "pdp";
    EProductCardVariants["SIMPLE"] = "simple";
    EProductCardVariants["LIST"] = "list";
    EProductCardVariants["PLP"] = "plp";
    EProductCardVariants["FBT"] = "fbt";
    EProductCardVariants["MINI"] = "mini";
    EProductCardVariants["COMPACT"] = "compact";
})(EProductCardVariants$1 || (EProductCardVariants$1 = {}));

var CustomStyled$1 = customStyled;

var COLORS$1 = {
    ALTO: '#cfcfcf',
    BODY: '#FAFAFA',
    BLUE: '#0e5aa7',
    BROWN: '#31261D',
    DARK_RED: '#dd2326',
    GREEN: '#009688',
    LIGHT_GREEN: '#019840',
    MERCURY: '#e6e6e6',
    MINE_SHAFT: '#252525',
    MYCLUB: '#690A4F',
    RED: '#ee2527',
    THUNDORA: '#4d4d4d',
    SILVER_CHALICE: '#b2b2b2',
    WHITE: '#fff',
    WILD_SAND: '#f5f5f5',
    YELLOW: '#ffdf28',
    BLUE_500: '#0B4C8E',
    TRANSPARENT_BLUE: 'rgba(14,90,167,0.2)',
    LIGHT_BORDER: '#f5f5f5',
    DARK_GREY: '#4D4D4D',
    LIGHT_GRAY: '#EAEAEA',
    ORANGE: '#E3870F',
    CHERRY: '#8F1639',
    LIGHT_SILVER: 'hsla(0, 0%, 69.8%, 0.2)',
    SEARCH_SILVER: 'rgba(178, 178, 178, 0.2)',
    MEDIUM_GRAY: '#666666',
    LIGHT_BLUE: '#f0f5f8',
    PURPLE: '#0a437c',
    DARK_BLUE: '#0a437c',
    ANCHOR_BLUE: '#0E5AA7',
    LAVENDOR: '#e8eef7',
    BLACK: '#000000',
    VENICEBLUE: '#0C4E91',
    LIGHT_GREY: '#F2F5F8',
    TAUPE_GRAY: '#888888',
    CLARET: '#8A1538',
    LIGHT_RED: '#F34041',
    LIGHT_BROWN: '#5B5030',
    GRAYSCALE: '#F4F4F4',
    SLIMY_GREEN: '#29A71A',
    WHITE_GREEN: '#29a',
    GRAY_800: '#141414',
    GRAY_500: '#747474',
    GRAY_700: '#686868',
    GRAY_100: '#dcdcdc',
    BLUE_25: '#F4FBFE',
    BLUE_800: '#F4FBFE',
    LIGHT_OPAC_BLUE: 'rgba(14,90,167,0.05)',
    SILVER: '#C3C3C3',
    COFFEE_BLACK: '#1F1F1F',
    LIGHT_GREY_100: '#FAFAFB',
    GRAY_900: '#979797',
    HIGHLIGHT_COLOR: '#EBF0F5',
    VIDEO_BG_COLOR: '#173d48',
    ERROR_RED_25: '#FDF4F4',
    ERROR_RED_50: '#FBCFCF',
    ERROR_RED_500: '#CE3637',
};

var SPACINGS$1 = {
    2: '2px',
    4: '4px',
    6: '6px',
    8: '8px',
    10: '10px',
    12: '12px',
    14: '14px',
    16: '16px',
    24: '24px',
    32: '32px',
    40: '40px',
};

var TYPOGRAPHY$1 = {
    SIZE: {
        10: '10px',
        11: '11px',
        12: '12px',
        13: '13px',
        14: '14px',
        16: '16px',
        18: '18px',
        20: '20px',
        22: '22px',
        24: '24px',
        32: '32px',
    },
    WEIGHT: {
        400: 400,
        500: 500,
        600: 600,
        700: 700,
    },
};

var ProductCardWrapper$1 = CustomStyled$1(Card)(templateObject_1$14 || (templateObject_1$14 = __makeTemplateObject(["\n  position: relative;\n  box-shadow: none;\n  border: 1px solid #efefef;\n  font-family: Montserrat;\n  ", "\n\n  ", "\n"], ["\n  position: relative;\n  box-shadow: none;\n  border: 1px solid #efefef;\n  font-family: Montserrat;\n  ",
    "\n\n  ",
    "\n"])), function (props) {
    return props.hasProductVariants
        ? "\n      padding-bottom: 32px;\n    "
        : '';
}, function (props) {
    return variant({
        variants: {
            regular: {
                width: props.isSponsoredListing
                    ? ['auto', null, null, 'auto']
                    : ['auto', null, null, props.carousel ? 'auto' : 223],
                height: props.isSponsoredListing
                    ? [283, null, null, 303]
                    : [props.carousel ? 283 : 303, null, null, props.carousel ? 303 : 381],
                padding: props.isSponsoredListing && ['8px', null, null, '8px'],
            },
            mini: {
                width: ['auto', null, null, 147],
                height: 284,
                padding: ['8px', null, null, '6px'],
            },
            list: {
                height: 116,
                display: 'flex',
                alignItems: 'center',
                borderRadius: '4px',
                padding: '4px !important',
            },
            regular_wide: {
                width: 320,
                height: 120,
            },
            compact: {
                height: 168,
                width: 112,
                padding: '4px !important',
            },
        },
    });
});
ProductCardWrapper$1.defaultProps = {
    p: ['8px', null, null, 12],
};
var ProductCardHeaderWrapper$1 = CustomStyled$1(Box)(templateObject_2$U || (templateObject_2$U = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  ", "\n\n  ", "\n  \n  & > span, div {\n    ", "\n  }\n\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  ",
    "\n\n  ",
    "\n  \n  & > span, div {\n    ", "\n  }\n\n"])), variant({
    variants: {
        list: {
            position: 'absolute',
            top: '4px',
            height: '28px !important',
            zIndex: 1,
        },
        compact: {
            position: 'absolute',
            height: '14px !important',
            zIndex: 1,
        },
    },
}), function (props) {
    return props.isSponsored &&
        "\n    left: 28px; \n    @media (min-width: props.theme.breakpoints[3]) {\n      left: 32px;\n    }\n  ";
}, function (props) { return props.isSponsored && "border-radius: 2px 2px 12px;"; });
ProductCardHeaderWrapper$1.defaultProps = {
    height: '28px',
};
var FBCContainer$1 = CustomStyled$1.div(templateObject_3$J || (templateObject_3$J = __makeTemplateObject(["\nmargin-top: 9px;\nimg {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n}\nspan {\n  margin-left: 8px;\n  font-size: 12px;\n  display: inline-block;\n}\n\n@media (max-width: ", ") {\n  span {\n    font-size: 10px;\n  }\n}\n"], ["\nmargin-top: 9px;\nimg {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n}\nspan {\n  margin-left: 8px;\n  font-size: 12px;\n  display: inline-block;\n}\n\n@media (max-width: ", ") {\n  span {\n    font-size: 10px;\n  }\n}\n"])), function (props) { return props.theme.breakpoints[1]; });
var WishlistIconWrapper$1 = CustomStyled$1.button(templateObject_4$C || (templateObject_4$C = __makeTemplateObject(["\n  display: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 18px;\n  padding: 0;\n  border: 0;\n  background: none;\n  z-index: 2;\n  & > svg {\n    height: 18px;\n    width: 20px;\n  }\n"], ["\n  display: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 18px;\n  padding: 0;\n  border: 0;\n  background: none;\n  z-index: 2;\n  & > svg {\n    height: 18px;\n    width: 20px;\n  }\n"])));
var HeaderStickerContainer$1 = CustomStyled$1.div(templateObject_5$t || (templateObject_5$t = __makeTemplateObject(["\n  position: relative;\n  top: -9px;\n  left: -9px;\n\n  @media (min-width: ", ") {\n    top: -13px;\n    left: -13px;\n  }\n"], ["\n  position: relative;\n  top: -9px;\n  left: -9px;\n\n  @media (min-width: ", ") {\n    top: -13px;\n    left: -13px;\n  }\n"])), function (props) { return props.theme.breakpoints[3]; });
var ProductCardNewHeaderSticker$1 = CustomStyled$1(Sticker)(templateObject_6$n || (templateObject_6$n = __makeTemplateObject(["\n  background: none;\n  border: 0.5px solid;\n  border-color: ", ";\n  padding: 0 4px;\n  height:18px;\n  border-radius: 2px;\n  color: ", ";\n  font-family: Montserrat;\n  font-weight: ", ";\n  font-size: ", "px;\n  position: relative;\n  z-index: 1;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  vertical-align: top;\n   ", "\n     \n     ", "\n"], ["\n  background: none;\n  border: 0.5px solid;\n  border-color: ", ";\n  padding: 0 4px;\n  height:18px;\n  border-radius: 2px;\n  color: ", ";\n  font-family: Montserrat;\n  font-weight: ", ";\n  font-size: ", "px;\n  position: relative;\n  z-index: 1;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  vertical-align: top;\n   ",
    "\n     \n     ",
    "\n"])), COLORS$1.RED, COLORS$1.RED, function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.fontSizes[0]; }, function (props) {
    return variant({
        prop: 'type',
        variants: {
            promo: {
                fontWeight: 500,
                background: props.theme.colors.peach,
                padding: '4px 10px',
                borderRadius: '12px 2px',
                color: props.theme.colors.darkRed,
                display: 'block',
                fontSize: props.theme.fontSizes[0] + "px",
                border: 'none',
            },
            discount: {
                border: 0,
            },
            discountThresholdBadge: {
                width: '42px',
                height: '44px',
                fontWeight: 700,
                background: props.theme.colors.peach,
                padding: '10px 5px',
                borderRadius: '12px 2px',
                color: props.theme.colors.darkRed,
                display: 'block',
                fontSize: props.theme.fontSizes[1] + "px",
                border: 'none',
                whiteSpace: 'unset',
            },
        },
    });
}, function (props) {
    return props.dir == 'ltr' &&
        "\n        borderRadius: '2px 12px',\n    ";
});
ProductCardNewHeaderSticker$1.defaultProps = {
    maxWidth: ['110px', null, null, '120px'],
};
var ProductCardHeaderSticker$1 = CustomStyled$1(Sticker)(templateObject_7$l || (templateObject_7$l = __makeTemplateObject(["\n  font-weight: 500;\n  text-align: center;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  padding: 4px 10px;\n  background-color: none;\n  color: #EE2527;\n  border-radius: 12px 2px;\n  z-index: 1;\n  position: relative;\n  min-width: auto;\n  max-width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  display: block;\n  ", "\n  ", "\n\n    ", "\n"], ["\n  font-weight: 500;\n  text-align: center;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  padding: 4px 10px;\n  background-color: none;\n  color: #EE2527;\n  border-radius: 12px 2px;\n  z-index: 1;\n  position: relative;\n  min-width: auto;\n  max-width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  display: block;\n  ",
    "\n  ",
    "\n\n    ",
    "\n"])), variant({
    prop: 'productCardType',
    variants: {
        list: {
            padding: '2px 5px',
            maxWidth: 116,
        },
        compact: {
            marginBottom: 0,
        },
    },
}), function (props) {
    return variant({
        prop: 'type',
        variants: {
            cashback: {
                fontSize: props.productCardType === EProductCardVariants$1.REGULAR ||
                    props.productCardType === EProductCardVariants$1.REGULAR_WIDE
                    ? 2
                    : 1,
            },
            discount: {
                fontSize: [
                    '8px',
                    null,
                    null,
                    props.productCardType === EProductCardVariants$1.REGULAR ||
                        props.productCardType === EProductCardVariants$1.REGULAR_WIDE
                        ? 0
                        : '8px',
                ],
            },
            share: {
                backgroundColor: props.theme.colors.purple,
                borderColor: props.theme.colors.purple,
                borderRadius: 0,
                color: 'white',
                fontSize: 1,
                minWidth: '60%',
            },
            promo: {
                fontSize: [
                    '8px',
                    null,
                    null,
                    props.productCardType === EProductCardVariants$1.REGULAR ||
                        props.productCardType === EProductCardVariants$1.REGULAR_WIDE
                        ? 0
                        : '8px',
                ],
            },
        },
    });
}, function (props) {
    return props.dir == 'ltr' &&
        "\n        borderRadius: '2px 12px',\n    ";
});
ProductCardHeaderSticker$1.defaultProps = {
    maxWidth: ['110px', null, null, '120px'],
};
var ProductCardContentElevation$1 = CustomStyled$1.div(templateObject_8$l || (templateObject_8$l = __makeTemplateObject(["\n  position: relative;\n  ", "\n"], ["\n  position: relative;\n  ",
    "\n"])), variant({
    variants: {
        list: {
            display: 'flex',
        },
        regular_wide: {
            display: 'flex',
            justifyContent: 'space-around',
            height: '100%',
        },
    },
}));
var ProductCardImageWrapper$2 = CustomStyled$1.div(templateObject_9$j || (templateObject_9$j = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var ProductCardImageContainer$2 = CustomStyled$1.div(templateObject_10$i || (templateObject_10$i = __makeTemplateObject(["\n  margin: 0 auto;\n  padding: 0 10px;\n  position: relative;\n  text-align: center;\n\n  @media (min-width: ", ") {\n    padding: 0;\n  }\n\n  ", "\n\n  a {\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    max-width: 100%;\n\n    img {\n      height: auto;\n      max-height: 100%;\n      max-width: 100%;\n      width: auto;\n    }\n  }\n"], ["\n  margin: 0 auto;\n  padding: 0 10px;\n  position: relative;\n  text-align: center;\n\n  @media (min-width: ", ") {\n    padding: 0;\n  }\n\n  ",
    "\n\n  a {\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    max-width: 100%;\n\n    img {\n      height: auto;\n      max-height: 100%;\n      max-width: 100%;\n      width: auto;\n    }\n  }\n"])), function (props) { return props.theme.breakpoints[0]; }, variant({
    variants: {
        mini: {
            height: 91,
            width: 140,
        },
        regular: {
            height: [91, null, null, 144],
            width: [140, null, null, 211],
        },
    },
}));
var ProductCardExpressWrapper$2 = CustomStyled$1.div(templateObject_11$f || (templateObject_11$f = __makeTemplateObject(["\n  bottom: 18px;\n  left: 50%;\n  position: absolute;\n  transform: translateX(-50%);\n  z-index: 1;\n"], ["\n  bottom: 18px;\n  left: 50%;\n  position: absolute;\n  transform: translateX(-50%);\n  z-index: 1;\n"])));
var ProductCardTagSticker$1 = CustomStyled$1(Sticker)(templateObject_12$e || (templateObject_12$e = __makeTemplateObject(["\n  border-width: 1px;\n  bottom: 0;\n  font-size: 11px;\n  left: 50%;\n  padding-top: 5px;\n  position: absolute;\n  text-transform: uppercase;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  z-index: 2;\n\n  ", "\n"], ["\n  border-width: 1px;\n  bottom: 0;\n  font-size: 11px;\n  left: 50%;\n  padding-top: 5px;\n  position: absolute;\n  text-transform: uppercase;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  z-index: 2;\n\n  ",
    "\n"])), function (props) {
    return variant({
        prop: 'type',
        variants: {
            bundlePromo: {
                backgroundColor: props.theme.colors.white,
                borderColor: props.theme.colors.blue,
                color: props.theme.colors.blue,
            },
            clearance: {
                backgroundColor: props.theme.colors.yellow,
                borderColor: props.theme.colors.yellow,
                color: props.theme.colors.red,
            },
            eol: {
                backgroundColor: props.theme.colors.magenta,
                borderColor: props.theme.colors.magenta,
                color: props.theme.colors.alabaster,
            },
            homeDelivery: {
                backgroundColor: props.theme.colors.poloBlue,
                borderColor: props.theme.colors.poloBlue,
                color: props.theme.colors.alabaster,
            },
            new: {
                backgroundColor: props.theme.colors.persiangreen,
                borderColor: props.theme.colors.persiangreen,
                color: props.theme.colors.alabaster,
            },
            onlineExclusive: {
                backgroundColor: props.theme.colors.white,
                borderColor: props.theme.colors.red,
                color: props.theme.colors.red,
                padding: '2px 8px 2px 2px',
            },
            preOrder: {
                backgroundColor: props.theme.colors.deepazure,
                borderColor: props.theme.colors.deepazure,
                color: props.theme.colors.alabaster,
            },
            web: {
                backgroundColor: props.theme.colors.goldenBell,
                borderColor: props.theme.colors.goldenBell,
                color: props.theme.colors.alabaster,
            },
        },
    });
});
var ProductCardName$1 = CustomStyled$1(Box)(templateObject_13$d || (templateObject_13$d = __makeTemplateObject(["\n  ", "\n\n  > a {\n    color: ", ";\n    display: -webkit-box;\n    line-height: normal;\n    overflow: hidden;\n    text-decoration: none;\n    -webkit-box-orient: vertical;\n    font-size: ", "px;\n    line-height: 16px;\n    ", "\n  }\n"], ["\n  ",
    "\n\n  > a {\n    color: ", ";\n    display: -webkit-box;\n    line-height: normal;\n    overflow: hidden;\n    text-decoration: none;\n    -webkit-box-orient: vertical;\n    font-size: ", "px;\n    line-height: 16px;\n    ",
    "\n  }\n"])), variant({
    variants: {
        list: {
            height: ['26px', null, null, '26px'],
            marginTop: 0,
        },
        regular_wide: {
            height: ['32px', null, null, 'auto'],
        },
        compact: {
            height: ['27px', null, null, '27px'],
        },
        regular: {
            height: ['32px', null, null, 'auto'],
        },
    },
}), function (props) { return props.theme.colors.black; }, function (props) { return props.theme.fontSizes[1]; }, function (props) {
    return variant({
        variants: {
            mini: {
                fontSize: 1,
                WebkitLineClamp: 2,
            },
            regular: {
                fontSize: ['12px', null, null, props.isSponsoredListing ? '12px' : '14px'],
                lineHeight: ['16px', null, null, props.isSponsoredListing ? '16px' : '18px'],
                WebkitLineClamp: 2,
            },
            regular_wide: {
                fontSize: '14px',
                lineHeight: '16px',
                WebkitLineClamp: 2,
            },
            list: {
                fontSize: '11px',
                WebkitLineClamp: 2,
                height: ['26px', null, null, '26px'],
                marginTop: 0,
                lineHeight: '13px',
            },
            compact: {
                fontSize: '11px',
                WebkitLineClamp: 2,
            },
        },
    });
});
ProductCardName$1.defaultProps = {
    height: ['32px', null, null, '36px'],
};
var ProductCardNote$1 = CustomStyled$1(Box)(templateObject_14$d || (templateObject_14$d = __makeTemplateObject(["\n  display: -webkit-box;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  ", "\n  @media (screen, min-width: ", ") {\n    font-size: ", "px;\n    height: ", ";\n  }  \n  ", "\n"], ["\n  display: -webkit-box;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  ",
    "\n  @media (screen, min-width: ", ") {\n    font-size: ", "px;\n    height: ", ";\n  }  \n  ",
    "\n"])), variant({
    variants: {
        regular_wide: {
            '-webkit-box-orient': 'horizontal',
            height: '11px',
        },
    },
}), function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.fontSizes[props.isSponsoredListing ? 0 : 1]; }, function (props) { return (props.variant === EProductCardVariants$1.REGULAR_WIDE ? '25px' : '16px'); }, function (props) { return "\n    color: #686868;\n    font-weight: " + props.theme.fontWeights[2] + ";\n  "; });
ProductCardNote$1.defaultProps = {
    fontSize: ['10px', null, null, '12px'],
    marginTop: ['2px', null, null, null],
};
var ProductCardStockIndicator$1 = CustomStyled$1(Box)(templateObject_15$d || (templateObject_15$d = __makeTemplateObject(["\n  font-size: ", "px;\n  line-height: 16px;\n  color: ", ";\n  min-height: 16px;\n"], ["\n  font-size: ", "px;\n  line-height: 16px;\n  color: ", ";\n  min-height: 16px;\n"])), function (props) { return props.theme.fontSizes[1]; }, COLORS$1.LIGHT_RED);
var ProductCardPricesWrapper$1 = CustomStyled$1.div(templateObject_16$a || (templateObject_16$a = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  ",
    "\n"])), variant({
    variants: {
        list: {
            marginTop: '6px',
        },
    },
}));
var ProductCardPrice$1 = CustomStyled$1.div(templateObject_17$a || (templateObject_17$a = __makeTemplateObject(["\n", "\n\n  ", "\n"], ["\n",
    "\n\n  ",
    "\n"])), function (props) {
    return variant({
        variants: {
            mini: {
                fontSize: 1,
            },
            simple: {
                fontSize: props.isSponsoredListing && 1,
            },
            list: {
                fontSize: 1,
            },
            compact: {
                fontSize: 1,
            },
        },
    });
}, function (props) {
    return variant({
        prop: 'type',
        variants: {
            original: {
                color: props.hasDiscount ? "" + COLORS$1.GRAY_700 : props.theme.colors.black,
                fontWeight: props.hasDiscount ? 'normal' : 4,
                fontSize: ['11px', null, null, props.hasDiscount ? props.theme.fontSizes[0] + "px" : '15px'],
                textDecoration: props.hasDiscount && 'line-through',
            },
            discount: {
                color: props.theme.colors.black,
                fontWeight: 4,
            },
        },
    });
});
var ProductCardPriceValueWrapper$1 = CustomStyled$1.div(templateObject_18$8 || (templateObject_18$8 = __makeTemplateObject(["\n    display: inline-block;\n    text-decoration: inherit;\n"], ["\n    display: inline-block;\n    text-decoration: inherit;\n"])));
var ProductCardActionsWrapper$1 = CustomStyled$1.div(templateObject_19$8 || (templateObject_19$8 = __makeTemplateObject(["\n  box-sizing: border-box;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n\n  button {\n    flex-shrink: 0;\n  }\n  ", "\n"], ["\n  box-sizing: border-box;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n\n  button {\n    flex-shrink: 0;\n  }\n  ",
    "\n"])), variant({
    variants: {
        list: {
            width: '100px',
            right: '4px',
            bottom: '4px',
            left: 'auto',
        },
        mini: {
            bottom: '6px',
            left: '6px',
            right: '6px',
        },
        compact: {
            bottom: '4px',
            left: '4px',
            right: '4px',
        },
        regular_wide: {
            width: 160,
            left: 'auto',
        },
        simple: {
            position: 'relative',
            bottom: 'unset',
            left: 'unset',
            right: 'unset',
            alignSelf: 'flex-end',
            paddingTop: '8px',
            paddingBottom: '8px',
            width: '100%',
        },
    },
}));
var ProductCardCurrency$1 = CustomStyled$1.span(templateObject_20$7 || (templateObject_20$7 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) { return props.discount && props.theme.colors.black; });
var ProductCardUnitOfMeasure$1 = CustomStyled$1.span(templateObject_21$6 || (templateObject_21$6 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", "px;\n"], ["\n  color: ", ";\n  font-size: ", "px;\n"])), function (props) { return (props.hasDiscount ? props.theme.colors.red : props.theme.colors.black); }, function (props) { return props.theme.fontSizes[1]; });
var ProductCardSimple$1 = CustomStyled$1(Flex)(templateObject_22$6 || (templateObject_22$6 = __makeTemplateObject(["\n  align-items: center;\n  justify-content: center;\n  border-radius: ", ";\n  background: ", ";\n  padding: ", ";\n  border: 1px solid ", ";\n  \n"], ["\n  align-items: center;\n  justify-content: center;\n  border-radius: ", ";\n  background: ",
    ";\n  padding: ", ";\n  border: 1px solid ",
    ";\n  \n"])), function (props) { return (props.isSponsoredListing ? 'unset' : SPACINGS$1[12]); }, function (props) {
    if (props.isCart) {
        return '#fff';
    }
    return props.theme.colors.white;
}, SPACINGS$1[12], function (props) {
    if (props.isSponsoredListing) {
        return props.theme.colors.whiteSmoke;
    }
    if (props.isCart) {
        return 'rgba(14, 90, 167, 0.15)';
    }
    return props.theme.colors.wildSand;
});
var ProductCardSimpleContent$1 = CustomStyled$1(Flex)(templateObject_23$5 || (templateObject_23$5 = __makeTemplateObject(["\n  flex-direction: column;\n"], ["\n  flex-direction: column;\n"])));
var ProductCardSimpleImageContainer$1 = CustomStyled$1.div(templateObject_24$4 || (templateObject_24$4 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  border-radius: 5px;\n  \n  \n  width: ", ";\n  height: ", ";\n\n  @media (min-width: ", ") {\n    margin: ", ";\n    width: ", ";\n    height: ", ";\n  }\n\n  img {\n    height: auto;\n    max-height: 100%;\n    max-width: 100%;\n    width: auto;\n  }\n  svg {\n    position: absolute;\n    \n    left: '22px';\n    width: ", ";\n    height: ", ";\n\n    @media (min-width: ", ") {\n      top: ", ";\n      left: ", ";\n    }\n    ", ";\n  }\n  @media (min-width: ", ") {\n    svg{\n\n      top: ", ";\n      left: ", ";\n    }  \n  }\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  border-radius: 5px;\n  \n  \n  width: ", ";\n  height: ", ";\n\n  @media (min-width: ", ") {\n    margin: ", ";\n    width: ", ";\n    height: ", ";\n  }\n\n  img {\n    height: auto;\n    max-height: 100%;\n    max-width: 100%;\n    width: auto;\n  }\n  svg {\n    position: absolute;\n    \n    left: '22px';\n    width: ", ";\n    height: ", ";\n\n    @media (min-width: ", ") {\n      top: ", ";\n      left: ", ";\n    }\n    ", ";\n  }\n  @media (min-width: ", ") {\n    svg{\n\n      top: ", ";\n      left: ", ";\n    }  \n  }\n"])), function (props) { return (props.isCart ? '58px' : '56px'); }, function (props) { return (props.isCart ? '64px' : '56px'); }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return (props.isCart ? '0' : '0 auto'); }, function (props) { return (props.isCart ? '58px' : '72px'); }, function (props) { return (props.isCart ? '64px' : '72px'); }, function (props) { return (props.isCart ? '40px' : 'auto'); }, function (props) { return (props.isCart ? '12px' : 'auto'); }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return (props.isCart ? '0' : '60px'); }, function (props) { return (props.isCart ? '0' : '22px'); }, function (props) { return (props.isCart ? 'bottom: 30px' : ''); }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return (props.isCart ? '64px' : '68px'); }, function (props) { return (props.isCart ? '25px' : '12px'); });
var ProductCardSimpleHeader$1 = CustomStyled$1(Box)(templateObject_25$4 || (templateObject_25$4 = __makeTemplateObject(["\n  width: 118px;\n  height: 28px;\n\n  color: ", ";\n  font-size: ", ";\n  letter-spacing: 0;\n  line-height: ", ";\n\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  font-weight: ", ";\n  margin-top: ", "px;\n"], ["\n  width: 118px;\n  height: 28px;\n\n  color: ", ";\n  font-size: ", ";\n  letter-spacing: 0;\n  line-height: ", ";\n\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  font-weight: ", ";\n  margin-top: ", "px;\n"])), function (props) { return (props.isSponsoredListing ? '#444444' : COLORS$1.MINE_SHAFT); }, function (props) { return (props.isSponsoredListing ? TYPOGRAPHY$1.SIZE[10] : TYPOGRAPHY$1.SIZE[12]); }, TYPOGRAPHY$1.SIZE[14], function (props) { return (props.isSponsoredListing ? 500 : 400); }, function (props) { return (props.isSponsoredListing ? 5 : 0); });
var ProductCardSimplePrice$1 = CustomStyled$1(Box)(templateObject_26$4 || (templateObject_26$4 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: ", ";\n  padding-top: ", ";\n"], ["\n  color: ", ";\n  font-size: ", ";\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: ", ";\n  padding-top: ", ";\n"])), COLORS$1.MINE_SHAFT, TYPOGRAPHY$1.SIZE[12], TYPOGRAPHY$1.SIZE[14], SPACINGS$1[6]);
var ProductCardSimpleSeperator$1 = CustomStyled$1(Box)(templateObject_27$4 || (templateObject_27$4 = __makeTemplateObject(["\n  height: 1px;\n  background-color: ", ";\n  margin-top: ", ";\n"], ["\n  height: 1px;\n  background-color: ", ";\n  margin-top: ", ";\n"])), function (props) { return props.theme.colors.wildSand; }, SPACINGS$1[8]);
var productCtaCss$1 = "\n  cursor: pointer;\n  font-size: " + TYPOGRAPHY$1.SIZE[14] + ";\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: " + TYPOGRAPHY$1.SIZE[16] + ";\n  padding-top: " + SPACINGS$1[6] + ";\n  padding-left: 0;\n  border: none;\n  background: none;\n";
var ProductCardSimpleCTA$1 = CustomStyled$1.button(templateObject_28$3 || (templateObject_28$3 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n"], ["\n  color: ", ";\n  ", "\n"])), function (props) { return props.theme.colors.redCta; }, productCtaCss$1);
var ProductCardSimpleCartCTA$1 = CustomStyled$1.button(templateObject_29$2 || (templateObject_29$2 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  font-size: ", ";\n  padding: 0;\n"], ["\n  ", "\n  color: ", ";\n  font-size: ", ";\n  padding: 0;\n"])), productCtaCss$1, function (props) { return props.theme.colors.blue; }, TYPOGRAPHY$1.SIZE[12]);
var SponseredProduct$1 = CustomStyled$1(Flex)(templateObject_30$2 || (templateObject_30$2 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: 400;\n  border-radius: 12px 2px;\n  background-color: ", ";\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px 2px;\n  padding: 4px 10px;\n\n  ", "\n"], ["\n  color: ", ";\n  font-weight: 400;\n  border-radius: 12px 2px;\n  background-color: ", ";\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px 2px;\n  padding: 4px 10px;\n\n  ", "\n"])), COLORS$1.GRAY_500, function (props) { return props.theme.colors.GRAY_100; }, function (props) { return props.isAreaABadge && "border-radius: 12px 2px 2px;"; });
SponseredProduct$1.defaultProps = {
    fontSize: ['7px', null, null, '9px'],
    height: ['18px', null, null, '18px'],
    width: ['fit-content', null, null, 'fit-content'],
};
var BulkSaving$1 = CustomStyled$1.div(templateObject_31$2 || (templateObject_31$2 = __makeTemplateObject(["\n  background-color: #FEF2F2;\n  padding: 4px 6px;\n  display: inline-box;\n "], ["\n  background-color: #FEF2F2;\n  padding: 4px 6px;\n  display: inline-box;\n "])));
var ProductItems$1 = CustomStyled$1.div(templateObject_32$2 || (templateObject_32$2 = __makeTemplateObject(["\n  ", "\n "], ["\n  ",
    "\n "])), variant({
    variants: {
        list: {
            width: '150px',
        },
        regular_wide: {
            width: '210px',
            display: 'flex',
            flexDirection: 'column',
            rowGap: '3px',
            height: '100%',
        },
    },
}));
var FreeDelivery$1 = CustomStyled$1.span(templateObject_33$2 || (templateObject_33$2 = __makeTemplateObject(["\n line-height: 14px;\n font-size: ", "px;\n margin-left: 8px;\n"], ["\n line-height: 14px;\n font-size: ", "px;\n margin-left: 8px;\n"])), function (props) { return props.theme.fontSizes[0]; });
var ProductDeliveryInfo$1 = CustomStyled$1(Box)(templateObject_34$2 || (templateObject_34$2 = __makeTemplateObject(["\n    \n    color: #000;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    color: ", ";\n    ", "\n    @media screen and (min-width: ", ") {\n        font-size: ", "px;\n    }\n "], ["\n    \n    color: #000;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    color: ", ";\n    ",
    "\n    @media screen and (min-width: ", ") {\n        font-size: ", "px;\n    }\n "])), COLORS$1.GRAY_700, variant({
    variants: {
        list: {
            fontSize: '9px',
        },
    },
}), function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.fontSizes[1]; });
ProductDeliveryInfo$1.defaultProps = {
    fontSize: ['9px', null, null, 0],
};
var ProductPriceLeft$1 = CustomStyled$1(Box)(templateObject_35$2 || (templateObject_35$2 = __makeTemplateObject(["\n  font-size: ", "px;\n  line-height: 28px; \n  display: inline-block;\n  font-weight: 700;\n"], ["\n  font-size: ", "px;\n  line-height: 28px; \n  display: inline-block;\n  font-weight: 700;\n"])), function (props) { return props.theme.fontSizes[5]; });
var ProductPriceRight$1 = CustomStyled$1(Box)(templateObject_36$2 || (templateObject_36$2 = __makeTemplateObject(["\n  display: inline-block;\n  margin-left: 4px;\n  vertical-align: top;\n  margin-top: 5px;\n"], ["\n  display: inline-block;\n  margin-left: 4px;\n  vertical-align: top;\n  margin-top: 5px;\n"])));
var ProductPriceDecimal$1 = CustomStyled$1(Box)(templateObject_37$2 || (templateObject_37$2 = __makeTemplateObject(["\n  font-size: 10px;\n  line-height: 10px;\n  font-weight: 700;\n"], ["\n  font-size: 10px;\n  line-height: 10px;\n  font-weight: 700;\n"])));
var ProductPriceCurrency$1 = CustomStyled$1(Box)(templateObject_38$2 || (templateObject_38$2 = __makeTemplateObject(["\n  font-size: 7px;\n  line-height: 7px;\n  font-weight: ", ";\n"], ["\n  font-size: 7px;\n  line-height: 7px;\n  font-weight: ", ";\n"])), function (props) { return props.theme.fontWeights[3]; });
var EmptyDiscountedPrice$1 = CustomStyled$1(Box)(templateObject_39$2 || (templateObject_39$2 = __makeTemplateObject(["\n  min-height: 18px;\n"], ["\n  min-height: 18px;\n"])));
var templateObject_1$14, templateObject_2$U, templateObject_3$J, templateObject_4$C, templateObject_5$t, templateObject_6$n, templateObject_7$l, templateObject_8$l, templateObject_9$j, templateObject_10$i, templateObject_11$f, templateObject_12$e, templateObject_13$d, templateObject_14$d, templateObject_15$d, templateObject_16$a, templateObject_17$a, templateObject_18$8, templateObject_19$8, templateObject_20$7, templateObject_21$6, templateObject_22$6, templateObject_23$5, templateObject_24$4, templateObject_25$4, templateObject_26$4, templateObject_27$4, templateObject_28$3, templateObject_29$2, templateObject_30$2, templateObject_31$2, templateObject_32$2, templateObject_33$2, templateObject_34$2, templateObject_35$2, templateObject_36$2, templateObject_37$2, templateObject_38$2, templateObject_39$2;

var BREAKPOINTS$1 = [576, 768, 992, 1200];
var MQ$1 = BREAKPOINTS$1.map(function (bp) { return "@media (min-width: " + bp + "px)"; });

var SIZES$2 = {
    CONTAINER_SIZE: '1232px',
    BADGE_SIZE: '17px',
    BORDER_RADIUS: '2px',
    BUTTON_SIZE: '40px',
    ICON_SIZE: '27px',
};

var PreorderContainer$1 = CustomStyled$1.div(templateObject_1$15 || (templateObject_1$15 = __makeTemplateObject(["\n    display: inline-block;\n    box-sizing: border-box;\n    margin: 0;\n    min-width: 0;\n    font-size: ", "px;\n    min-width: auto;\n    border-radius: 2px;\n    color: ", ";\n    height:18px;\n    background-color: ", ";\n    padding: 4px 10px;\n    border-radius: 12px 2px;\n\n    ", "\n"], ["\n    display: inline-block;\n    box-sizing: border-box;\n    margin: 0;\n    min-width: 0;\n    font-size: ", "px;\n    min-width: auto;\n    border-radius: 2px;\n    color: ", ";\n    height:18px;\n    background-color: ", ";\n    padding: 4px 10px;\n    border-radius: 12px 2px;\n\n    ",
    "\n"])), function (props) { return props.theme.fontSizes[0]; }, function (props) { return props.theme.colors.blue; }, COLORS$1.BLUE_25, function (props) {
    return props.dir == 'ltr' &&
        "\n       borderRadius: '2px 12px',\n    ";
});
var PreOrderTextContainerNew$1 = CustomStyled$1.span(templateObject_2$V || (templateObject_2$V = __makeTemplateObject(["\nfont-family: Montserrat;\nfont-weight: 700;\n\n"], ["\nfont-family: Montserrat;\nfont-weight: 700;\n\n"])));
var BoldText$1 = CustomStyled$1.span(templateObject_3$K || (templateObject_3$K = __makeTemplateObject(["\n    font-weight: 700;\n"], ["\n    font-weight: 700;\n"])));
var BestSellerContainer$1 = CustomStyled$1(Flex)(templateObject_4$D || (templateObject_4$D = __makeTemplateObject(["\nposition: relative;\nz-index: 1;\n"], ["\nposition: relative;\nz-index: 1;\n"])));
var BestSellerWrapper$1 = CustomStyled$1.span(templateObject_5$u || (templateObject_5$u = __makeTemplateObject(["  \ncolor: ", ";\nbackground-color: ", ";\nborder-radius: 12px 2px;\nmax-width: 150px;\ntext-align: center;\ndisplay: flex;\nalign-items: center;\njustify-content: space-around;\nfont-size: ", "px;\nheight: 18px;\npadding: 4px 10px;\ntext-overflow: ellipsis;\noverflow: hidden;\nwhite-space: nowrap;\n@media (max-width: ", "px) {\n  max-width:110px;\n}\n\n", "\n"], ["  \ncolor: ", ";\nbackground-color: ", ";\nborder-radius: 12px 2px;\nmax-width: 150px;\ntext-align: center;\ndisplay: flex;\nalign-items: center;\njustify-content: space-around;\nfont-size: ", "px;\nheight: 18px;\npadding: 4px 10px;\ntext-overflow: ellipsis;\noverflow: hidden;\nwhite-space: nowrap;\n@media (max-width: ", "px) {\n  max-width:110px;\n}\n\n",
    "\n"])), function (props) { return props.theme.colors.blue; }, COLORS$1.BLUE_25, function (props) { return props.theme.fontSizes[0]; }, BREAKPOINTS$1[1], function (props) {
    return props.dir == 'ltr' &&
        "\n   borderRadius: '2px 12px',\n";
});
var PromoBadgesAreaBBox$1 = CustomStyled$1.div(templateObject_6$o || (templateObject_6$o = __makeTemplateObject(["\nposition: absolute;\nbottom: 5px;\n", "\n    ", " \n"], ["\nposition: absolute;\nbottom: 5px;\n",
    "\n    ",
    " \n"])), function (props) {
    return props.dir == 'ltr'
        ? "\n  left: 0;\n"
        : " right: 0";
}, function () {
    return variant({
        variants: {
            regular_wide: {
                left: '20px',
                bottom: '10px',
            },
        },
    });
});
var PromoBadgesAreaBContainerNew$1 = CustomStyled$1.div(templateObject_7$m || (templateObject_7$m = __makeTemplateObject(["\nborder-radius: 12px 2px;\nfont-size: ", "px;\nheight:18px;\ndisplay: inline-block;\npadding: 4px 10px;\ntext-overflow: ellipsis;\noverflow: hidden;\nwhite-space: nowrap;\nmax-width: 120px;\n@media (max-width: ", "px) {\n  max-width: 80px;\n}\n", "\n\n", "\n\n"], ["\nborder-radius: 12px 2px;\nfont-size: ", "px;\nheight:18px;\ndisplay: inline-block;\npadding: 4px 10px;\ntext-overflow: ellipsis;\noverflow: hidden;\nwhite-space: nowrap;\nmax-width: 120px;\n@media (max-width: ", "px) {\n  max-width: 80px;\n}\n",
    "\n\n",
    "\n\n"])), function (props) { return props.theme.fontSizes[0]; }, BREAKPOINTS$1[1], function (props) {
    return variant({
        prop: 'type',
        variants: {
            Info: {
                background: "" + COLORS$1.BLUE_25,
                color: "" + COLORS$1.BLUE,
            },
            Policy: {
                background: "" + COLORS$1.BLUE_25,
                color: "" + COLORS$1.BLUE,
            },
            Green: {
                background: props.theme.colors.lightGreen,
                color: props.theme.colors.green,
            },
            Highlight: {
                background: props.theme.colors.lightPurple,
                color: props.theme.colors.purple,
            },
        },
    });
}, function (props) {
    return props.dir == 'ltr' &&
        "\n    borderRadius: '2px 12px',\n";
});
var PromoBadgesAreaBTextNew$1 = CustomStyled$1.span(templateObject_8$m || (templateObject_8$m = __makeTemplateObject(["\n  font-family: Montserrat;\n  font-weight: 700;\n  ", "\n"], ["\n  font-family: Montserrat;\n  font-weight: 700;\n  ",
    "\n"])), variant({
    prop: 'type',
    variants: {
        Info: {
            color: '#1A4F9B',
        },
        Policy: {
            fontWeight: 700,
            color: '#1A4F9B',
        },
        Green: {
            color: '#009639',
        },
        Highlight: {
            color: '#A32699',
        },
    },
}));
var PromoBadgesAreaBTextLightNew$1 = CustomStyled$1(PromoBadgesAreaBTextNew$1)(templateObject_9$k || (templateObject_9$k = __makeTemplateObject(["\n  font-weight: 500;\n"], ["\n  font-weight: 500;\n"])));
var PromoBadgesAreaBContainer$1 = CustomStyled$1.div(templateObject_10$j || (templateObject_10$j = __makeTemplateObject(["\n  padding: 2px 4px;\n  background: #EFF3F8;\n  border-radius: 2px;\n  width: auto;\n  display: inline-block;\n}\n"], ["\n  padding: 2px 4px;\n  background: #EFF3F8;\n  border-radius: 2px;\n  width: auto;\n  display: inline-block;\n}\n"])));
var PromoBadgesAreaBText$1 = CustomStyled$1.span(templateObject_11$g || (templateObject_11$g = __makeTemplateObject(["\n  font-family: Montserrat;\n  font-weight: 700;\n  font-size: 8px;\n  /* identical to box height */\n  color: #1A4F9B;\n"], ["\n  font-family: Montserrat;\n  font-weight: 700;\n  font-size: 8px;\n  /* identical to box height */\n  color: #1A4F9B;\n"])));
var PromoBadgesAreaBTextLight$1 = CustomStyled$1(PromoBadgesAreaBText$1)(templateObject_12$f || (templateObject_12$f = __makeTemplateObject(["\n  font-weight: 500;\n  font-size: 10px;\n"], ["\n  font-weight: 500;\n  font-size: 10px;\n"])));
var ProductCardImageWrapper$3 = CustomStyled$1.div(templateObject_13$e || (templateObject_13$e = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var ProductCardImage$1 = CustomStyled$1(Image)(templateObject_14$e || (templateObject_14$e = __makeTemplateObject(["\n  display: ", ";\n  width: auto;\n  ", " \n"], ["\n  display: ", ";\n  width: auto;\n  ",
    " \n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'block' : _b;
    return display;
}, function (props) {
    return variant({
        variants: {
            mini: {
                maxHeight: 91,
                maxWidth: 140,
            },
            regular: {
                maxHeight: props.isSponsoredListing
                    ? [136, null, null, 156]
                    : [props.carousel ? 136 : 156, null, null, props.carousel ? 156 : 220],
                maxWidth: props.isSponsoredListing
                    ? [128, null, null, 156]
                    : [props.carousel ? 128 : 156, null, null, props.carousel ? 156 : 211],
            },
            regular_wide: {
                maxHeight: 56,
                maxWidth: 56,
            },
            list: {
                maxHeight: 60,
                maxWidth: 60,
            },
            compact: {
                maxHeight: 64,
                maxWidth: 64,
            },
        },
    });
});
var Dot$1 = CustomStyled$1.span(templateObject_15$e || (templateObject_15$e = __makeTemplateObject(["\n    display: block;\n    transform: scale(", ");\n    background-color:  ", ";\n    border-radius: 50%;\n    width: 3px;\n    height: 3px;\n    margin: 3px;\n"], ["\n    display: block;\n    transform: scale(", ");\n    background-color:  ", ";\n    border-radius: 50%;\n    width: 3px;\n    height: 3px;\n    margin: 3px;\n"])), function (_a) {
    var selected = _a.selected;
    return (selected ? 2 : 1);
}, function (_a) {
    var selected = _a.selected, theme = _a.theme;
    return (selected ? theme.colors.blue : theme.colors.babyBlue);
});
var ImageSlide$1 = CustomStyled$1.div(templateObject_16$b || (templateObject_16$b = __makeTemplateObject(["\n    flex: 0 0 auto;\n    position: relative;\n    width: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"], ["\n    flex: 0 0 auto;\n    position: relative;\n    width: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"])), function (props) { return props.widthPerSlide; });
var CarousalImage$1 = CustomStyled$1(ProductCardImage$1)(templateObject_17$b || (templateObject_17$b = __makeTemplateObject(["\n  flex: 0 0 auto;\n  position: relative;\n"], ["\n  flex: 0 0 auto;\n  position: relative;\n"])));
CarousalImage$1.defaultProps = {
    display: 'block',
};
var ProductCardImageContainer$3 = CustomStyled$1.div(templateObject_18$9 || (templateObject_18$9 = __makeTemplateObject(["\n  position: relative;\n  text-align: center;\n  ", "\n"], ["\n  position: relative;\n  text-align: center;\n  ",
    "\n"])), variant({
    variants: {
        list: {
            display: 'flex',
            width: '120px',
        },
        regular_wide: {
            width: '85px',
        },
    },
}));
var ProductcardImageContainerInner$1 = customStyled.div(templateObject_19$9 || (templateObject_19$9 = __makeTemplateObject(["\n  margin: 0 auto;\n  ", "\n\n  a {\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    max-width: 100%;\n  }\n"], ["\n  margin: 0 auto;\n  ",
    "\n\n  a {\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    max-width: 100%;\n  }\n"])), function (props) {
    return variant({
        variants: {
            mini: {
                height: 91,
                maxWidth: 140,
            },
            regular: {
                height: !props.isSponsoredListing
                    ? [props.carousel ? 136 : 156, null, null, props.carousel ? 156 : 220]
                    : [136, null, null, 156],
                maxWidth: !props.isSponsoredListing
                    ? [props.carousel ? 128 : 148, null, null, props.carousel ? 148 : 211]
                    : [128, null, null, 148],
            },
            regular_wide: {
                height: 60,
                maxWidth: 56,
            },
        },
    });
});
var ProductCardExpressWrapper$3 = CustomStyled$1(Box)(templateObject_20$8 || (templateObject_20$8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), variant({
    variants: {
        list: {
            position: 'absolute',
            bottom: 0,
        },
        compact: {
            position: 'absolute',
            bottom: 0,
            left: 0,
        },
    },
}));
ProductCardExpressWrapper$3.defaultProps = {
    height: ['auto', null, null, 'auto'],
};
var OutOfStockText$1 = CustomStyled$1.span(templateObject_21$7 || (templateObject_21$7 = __makeTemplateObject(["\n  background-color: #FEF2F2;\n  padding: 2px 6px;\n  border-radius: 2px;\n  color: ", ";\n  font-family: Montserrat;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 12px;\n  text-transform: capitalize;\n"], ["\n  background-color: #FEF2F2;\n  padding: 2px 6px;\n  border-radius: 2px;\n  color: ", ";\n  font-family: Montserrat;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 12px;\n  text-transform: capitalize;\n"])), COLORS$1.RED);
var ProductCardAttributeIcon$1 = CustomStyled$1.div(templateObject_22$7 || (templateObject_22$7 = __makeTemplateObject(["\n.attributeIcon2{\n  height:16px;\n  width:16px;\n  float:right;\n}\n.attributeIcon1{\n  height: 16px;\n  width: 16px;\n  position: absolute;\n  margin-left: 58px;\n}\n"], ["\n.attributeIcon2{\n  height:16px;\n  width:16px;\n  float:right;\n}\n.attributeIcon1{\n  height: 16px;\n  width: 16px;\n  position: absolute;\n  margin-left: 58px;\n}\n"])));
var templateObject_1$15, templateObject_2$V, templateObject_3$K, templateObject_4$D, templateObject_5$u, templateObject_6$o, templateObject_7$m, templateObject_8$m, templateObject_9$k, templateObject_10$j, templateObject_11$g, templateObject_12$f, templateObject_13$e, templateObject_14$e, templateObject_15$e, templateObject_16$b, templateObject_17$b, templateObject_18$9, templateObject_19$9, templateObject_20$8, templateObject_21$7, templateObject_22$7;

/**
 * Render product card header sticker for discount, cash back, and share
 * @param {React.ReactNode} content
 * @param {ProductCardHeaderStickerType} type
 * @param {ProductCardVariant} productCardVariant
 * @param {StickerVariantsType} stickerVariant
 * @param {string} key
 *
 * @example
 *
 *    getHeaderSticker('10% Discount', 'cashback', 'filled', 'regular')
 */
var getHeaderSticker$1 = function (content, type, stickerVariant, productCardVariant, key, isNew) {
    var HeaderSticker = isNew ? ProductCardNewHeaderSticker$1 : ProductCardHeaderSticker$1;
    return (React.createElement(HeaderSticker, { "data-testid": key, productCardType: productCardVariant, key: key, type: type, variant: stickerVariant, isNew: isNew, dir: isNew ? 'ltr' : '' }, content));
};
/**
 * Render header sticker for product card
 * @param headerSticker
 * @param points
 * @param isLebanon
 * @param productCardVariant
 *
 * @example
 *
 *    renderHeaderSticker('10% Discount', 0, false, 'regular')
 */
var getBadges$1 = function (points, productCardVariant, promoVoucher, language, t, badges, bulkMessage, discount, isLebanon, preorder) {
    var _a, _b, _c, _d, _e;
    var isOnlyBadgeB = true;
    var hasPoints = points && points > 0;
    var badgesAB = [];
    var preorderText = 'Pre Order';
    var promoSticker = language === 'en' && promoVoucher.messageEN
        ? promoVoucher.messageEN
        : promoVoucher.messageAR || promoVoucher.messageEN;
    var textPresent = function (boldText, normalText) {
        return !!(boldText.trim() || normalText.trim());
    };
    //preorder
    if (preorder) {
        isOnlyBadgeB = false;
        badgesAB.push(React.createElement(PreorderContainer$1, { dir: "ltr" },
            React.createElement(PreOrderTextContainerNew$1, null, preorderText )));
    }
    var promoStickerValue = React.createElement("span", { dangerouslySetInnerHTML: { __html: "" + promoSticker } });
    //bestseller
    if (badges && (badges === null || badges === void 0 ? void 0 : badges.length) > 0 && ((_a = badges === null || badges === void 0 ? void 0 : badges[0]) === null || _a === void 0 ? void 0 : _a.type) === 'BestSeller') {
        var _f = badges[0].text || {}, _g = _f.boldText, boldText = _g === void 0 ? '' : _g, _h = _f.normalText, normalText = _h === void 0 ? '' : _h;
        if (textPresent(boldText, normalText)) {
            isOnlyBadgeB = false;
            badgesAB.push(React.createElement(BestSellerContainer$1, null,
                React.createElement(BestSellerWrapper$1, { dir: "ltr" }, boldText.trim() && React.createElement(BoldText$1, null, boldText + " " + normalText))));
        }
        badges = badges.slice(1); // in order to handle empty text case
    }
    //promoBadges
    if (badges && badges.length > 0 && ((_b = badges[0]) === null || _b === void 0 ? void 0 : _b.type) === 'promoBadges') {
        var _j = badges[0].text || {}, _k = _j.boldText, boldText_1 = _k === void 0 ? '' : _k, _l = _j.normalText, normalText_1 = _l === void 0 ? '' : _l;
        var promoBadges = function () {
            if (textPresent(boldText_1, normalText_1)) {
                isOnlyBadgeB = false;
                badgesAB.push(getHeaderSticker$1(React.createElement(React.Fragment, null, boldText_1.trim() && React.createElement(BoldText$1, null, boldText_1 + " " + normalText_1)), 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker', true));
            }
            badges = badges === null || badges === void 0 ? void 0 : badges.slice(1);
        };
        promoBadges();
    }
    //cashback offer
    //badgesAB.length === 0
    if (hasPoints && isLebanon) {
        isOnlyBadgeB = false;
        badgesAB.push(getHeaderSticker$1(React.createElement(React.Fragment, null,
            React.createElement(BoldText$1, null, "+ " + points + " " + t('productCard.points'))), 'promo', 'filledPromo', productCardVariant, "promo-sub-header-sticker-" + points, true));
    }
    //buy1get1
    if (badges && (badges === null || badges === void 0 ? void 0 : badges.length) > 0 && ((_c = badges[0]) === null || _c === void 0 ? void 0 : _c.type) === 'BuyOneGetOne') {
        var _m = badges[0].text || {}, _o = _m.boldText, boldText = _o === void 0 ? '' : _o, _p = _m.normalText, normalText = _p === void 0 ? '' : _p;
        if (textPresent(boldText, normalText)) {
            isOnlyBadgeB = false;
            badgesAB.push(getHeaderSticker$1(React.createElement(React.Fragment, null, boldText.trim() && React.createElement(BoldText$1, null, boldText + " " + normalText)), 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker', true));
        }
        badges = badges.slice(1);
    }
    //loyaltypoints-->except Lebanon
    if (!isLebanon && hasPoints) {
        isOnlyBadgeB = false;
        badgesAB.push(getHeaderSticker$1(React.createElement(React.Fragment, null,
            React.createElement(BoldText$1, null, "+ " + points + " " + t('productCard.points'))), 'promo', 'filledPromo', productCardVariant, "promo-sub-header-sticker-" + points, true));
    }
    if (badges && (badges === null || badges === void 0 ? void 0 : badges.length) > 0 && ((_d = badges[0]) === null || _d === void 0 ? void 0 : _d.type) === 'Bundle') {
        var _q = badges[0].text || {}, _r = _q.boldText, boldText = _r === void 0 ? '' : _r, _s = _q.normalText, normalText = _s === void 0 ? '' : _s;
        if (textPresent(boldText, normalText)) {
            isOnlyBadgeB = false;
            badgesAB.push(getHeaderSticker$1(React.createElement(React.Fragment, null, boldText.trim() && React.createElement(BoldText$1, null, boldText + " " + normalText)), 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker', true));
        }
        badges = badges.slice(1);
    }
    //promoVoucher--highest amongst all--automated/manual
    if (promoVoucher === null || promoVoucher === void 0 ? void 0 : promoVoucher.hasPromoVoucher) {
        isOnlyBadgeB = false;
        badgesAB.push(getHeaderSticker$1(promoStickerValue, 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker', true));
    }
    //bulk-highest amongst all
    if (bulkMessage && (!discount || (discount === null || discount === void 0 ? void 0 : discount.value) < 1) && !hasPoints) {
        isOnlyBadgeB = false;
        badgesAB.push(getHeaderSticker$1(React.createElement(React.Fragment, null,
            React.createElement(BoldText$1, null, t('productCard.bulk') + " " + t('productCard.save') + " " + bulkMessage)), 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker', true));
    }
    //timer promo-->out of scope
    if (badges && (badges === null || badges === void 0 ? void 0 : badges.length) > 0 && ((_e = badges[0]) === null || _e === void 0 ? void 0 : _e.type) === 'Campaign') {
        var _t = badges[0].text || {}, _u = _t.boldText, boldText = _u === void 0 ? '' : _u, _v = _t.normalText, normalText = _v === void 0 ? '' : _v;
        if (textPresent(boldText, normalText)) {
            isOnlyBadgeB = false;
            badgesAB.push(getHeaderSticker$1(React.createElement(React.Fragment, null, boldText.trim() && React.createElement(BoldText$1, null, boldText + " " + normalText)), 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker', true));
        }
        badges = badges.slice(1);
    }
    badges === null || badges === void 0 ? void 0 : badges.forEach(function (el) {
        if (badgesAB.length < 3 && ['Info', 'Policy', 'Green', 'Highlight'].includes(el === null || el === void 0 ? void 0 : el.type)) {
            var _a = el || {}, type = _a.type, text = _a.text;
            var _b = text || {}, _c = _b.boldText, boldText = _c === void 0 ? '' : _c, _d = _b.normalText, normalText = _d === void 0 ? '' : _d;
            if (textPresent(boldText, normalText)) {
                badgesAB.push(React.createElement(PromoBadgesAreaBContainerNew$1, { dir: "ltr", type: type }, boldText.trim() && (React.createElement(PromoBadgesAreaBTextNew$1, { type: type }, boldText + " " + normalText))));
            }
        }
    });
    if (isOnlyBadgeB && badgesAB.length === 1) {
        return [, badgesAB[0]];
    }
    return badgesAB;
};
var renderHeaderSticker$1 = function (currency, points, isLebanon, productCardVariant, promoVoucher, language, t, promoBadgesAreaA, bulkMessage) {
    var header;
    var subHeader;
    var promoHeader = null;
    var hasPoints = points && points > 0;
    if (bulkMessage) {
        return (React.createElement(BulkSaving$1, { "data-testid": "bulk-save" },
            React.createElement(Text, { fontSize: 0, fontWeight: 700, color: COLORS$1.RED }, t('productCard.bulkSave') + " " + bulkMessage)));
    }
    var promoSticker = language === 'en' && promoVoucher.messageEN
        ? promoVoucher.messageEN
        : promoVoucher.messageAR || promoVoucher.messageEN;
    var promoStickerValue = React.createElement("div", { dangerouslySetInnerHTML: { __html: "" + promoSticker } });
    if (promoVoucher === null || promoVoucher === void 0 ? void 0 : promoVoucher.hasPromoVoucher) {
        promoHeader = getHeaderSticker$1(promoStickerValue, 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker');
    }
    if (isLebanon && hasPoints) {
        header = getHeaderSticker$1(React.createElement(React.Fragment, null,
            React.createElement(BoldText$1, null, currency + " " + points + " " + t('productCard.cashback') + " ")), 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker');
    }
    else if (promoBadgesAreaA.length > 0) {
        subHeader = getHeaderSticker$1(React.createElement(React.Fragment, null,
            React.createElement(BoldText$1, null, promoBadgesAreaA[0].text.boldText + " " + promoBadgesAreaA[0].text.normalText)), 'promo', 'filledPromo', productCardVariant, 'promo-sub-header-sticker');
        if (promoHeader)
            promoHeader = '';
    }
    else if (!isLebanon && hasPoints) {
        subHeader = getHeaderSticker$1(React.createElement(React.Fragment, null,
            React.createElement(BoldText$1, null, "+ " + points + " " + t('productCard.points'))), 'promo', 'filledPromo', productCardVariant, "promo-sub-header-sticker-" + points);
    }
    return [header, subHeader, promoHeader];
};
/**
 * Specific price formatting for product cards
 * @param {number} price
 * @param {string} currency
 * @param {CurrencyPosition} currencyPos
 * @param {boolean} withCurrencyElement
 * @param {ProductCardPriceType} priceType
 *
 * @example
 *
 *    formatPrice(99.00, 'AED', 'right')
 */
var formatPrice$1 = function (price, currency, currencyPos, withCurrencyElement, priceType, variant, hasDiscount, isNewCarrefourJourney) {
    if (withCurrencyElement === void 0) { withCurrencyElement = false; }
    var formattedPrice = prettifyPrice$1(price);
    var isLeft = currencyPos === 'left';
    var currencyRenderer = withCurrencyElement ? (React.createElement(ProductCardCurrency$1, { hasDiscount: hasDiscount, variant: variant, priceType: priceType, key: priceType }, currency)) : (currency);
    //Removing comma from formatted price for showing discount in Qatar
    var formattedDiscountPrice = formattedPrice.replace(/,/g, '');
    var result = [
        currencyRenderer,
        priceType === 'discount' && !hasDiscount ? parseInt(formattedDiscountPrice) : formattedPrice,
    ];
    var newFormatPrice = result.join('').match(/^(\D*)(\d{1,3}(?:[,]\d{1,3})*)(\.\d+)?/) || [];
    if (isNewCarrefourJourney && newFormatPrice.length > 3) {
        if (variant === EProductCardVariants$1.REGULAR_WIDE || variant === EProductCardVariants$1.REGULAR) {
            if (currency == 'KWD') {
                return (React.createElement(ProductCardPriceValueWrapper$1, { dir: "ltr", key: result.join('') },
                    React.createElement(ProductPriceLeft$1, null, newFormatPrice[2] + newFormatPrice[3]),
                    React.createElement(ProductPriceRight$1, null,
                        React.createElement(ProductPriceCurrency$1, null,
                            React.createElement(ProductCardCurrency$1, { hasDiscount: hasDiscount, variant: variant, priceType: priceType, key: priceType }, currency)))));
            }
            else {
                return (React.createElement(ProductCardPriceValueWrapper$1, { dir: "ltr", key: result.join('') },
                    React.createElement(ProductPriceLeft$1, null, newFormatPrice[2]),
                    React.createElement(ProductPriceRight$1, null,
                        React.createElement(ProductPriceDecimal$1, null, newFormatPrice[3]),
                        React.createElement(ProductPriceCurrency$1, null,
                            React.createElement(ProductCardCurrency$1, { hasDiscount: hasDiscount, variant: variant, priceType: priceType, key: priceType }, currency)))));
            }
        }
    }
    else {
        return (React.createElement(ProductCardPriceValueWrapper$1, { key: result.join('') }, isLeft ? result.reverse() : result));
    }
};
var renderUnitOfMeasure$1 = function (unitOfMeasure, hasDiscount) {
    if (hasDiscount === void 0) { hasDiscount = false; }
    return (React.createElement(ProductCardUnitOfMeasure$1, { hasDiscount: hasDiscount },
        ' ',
        React.createElement("span", null,
            "/",
            unitOfMeasure)));
};
/**
 * Render product price by original or discount price
 *
 * @param {number} price
 * @param {ProductCardPriceType} priceType
 * @param {string} currency
 * @param {CurrencyPosition} currencyPos
 * @param {string} unitOfMeasure
 * @param {boolean} isDiscount
 * @param {ProductCardVariant} variant
 * @param {string} testId
 *
 * @example
 *
 *     renderProductPrice(99.00, 'AED', 'right', 'KG', false, 'regular')
 */
var renderProductPrice$1 = function (price, priceType, currency, currencyPos, unitOfMeasure, isDiscount, variant, t, testId, isSponsoredListing, unitItem, discount, isNewCarrefourJourney) {
    var formattedPrice = formatPrice$1(price, currency, currencyPos, true, priceType, variant, isDiscount, isNewCarrefourJourney);
    var measure = unitOfMeasure === 'KG' ? t("KG_LABEL") : '';
    var measureWithDiscount = priceType === 'discount' && isDiscount && unitOfMeasure;
    var measureWithoutDiscount = !isDiscount && unitOfMeasure;
    return (React.createElement(ProductCardPrice$1, { "data-testid": testId, variant: variant, type: priceType, hasDiscount: isDiscount, isSponsoredListing: isSponsoredListing },
        formattedPrice,
        !isNewCarrefourJourney && (React.createElement(React.Fragment, null,
            measureWithDiscount && renderUnitOfMeasure$1(measure, true),
            measureWithoutDiscount && renderUnitOfMeasure$1(measure),
            unitItem !== undefined && !measure && typeof unitItem === 'number' && !isDiscount && (React.createElement("span", null, unitItem === 0 ? "/" + t('piece') : "/" + t('pack'))))),
        discount &&
            discount.price > 0 &&
            getHeaderSticker$1(discount.type === DiscountType$1.PERCENTAGE ? (discount.value + "% " + t('productCard.discount')) : (React.createElement("span", null,
                React.createElement("span", null, formatPrice$1(discount.value, currency, currencyPos, false, 'discount')),
                " OFF")), 'discount', 'filled', variant, 'headerStickerId', true)));
};
var getProductNote$1 = function (itemsPerUnit, t) {
    if (itemsPerUnit && itemsPerUnit > 0) {
        return t('productCard.approxPerKg', {
            0: itemsPerUnit + " " + (itemsPerUnit > 1 ? t('productCard.pieces') : t('productCard.piece')),
        });
    }
    return null;
};
var getAlgoliaTrackingParams$1 = function (productId, productPosition, sortBy, algoliaQueryID, clickType) {
    var page_type = getPageType$1();
    var productInfo = !(page_type === 'product-details')
        ? {
            searchQueryID: algoliaQueryID,
            pageType: ATC_EVENTS_TYPE$1.PLP,
            products: productId,
            productPositions: algoliaQueryID !== '' ? productPosition : '',
            sortBy: sortBy,
            clickType: clickType,
        }
        : {
            pageType: clickType === ATC_EVENT$1 ? ATC_EVENTS_TYPE$1.PDP : ATC_EVENTS_TYPE$1.PLP,
            products: productId,
            searchQueryID: clickType === ATC_EVENT$1 && window.location.href.includes(productId) ? sessionStorage.getItem('queryId') : '',
            clickType: clickType,
        };
    return productInfo;
};
var clickAlgoliaOperation$1 = function (params, dispatch) {
    if (params === void 0) { params = {}; }
    var productId = params.productId, productPosition = params.productPosition, _a = params.searchQueryID, searchQueryID = _a === void 0 ? '' : _a, sortBy = params.sortBy;
    var algoliaParams = getAlgoliaTrackingParams$1(productId, productPosition, sortBy, searchQueryID, CLICK_EVENT$1);
    dispatch(algoliaTracking$1(algoliaParams));
};
var getProductPosition$1 = function (rowIndex, position, isDesktop, isMobile) {
    var totalProductInRow = 3;
    if (isDesktop || isMobile) {
        totalProductInRow = isDesktop ? 4 : 2;
    }
    return rowIndex * totalProductInRow + position;
};
var getGa4AlgoliaEventsParams$1 = function () {
    return JSON.parse(localStorage.getItem('ga4-algolia-event-data') || '{}');
};
var DisplayDiscountTemplateNew$1 = function (_a) {
    var originalPrice = _a.originalPrice, discount = _a.discount, minBuyingValue = _a.minBuyingValue, variant = _a.variant, currency = _a.currency, currencyPos = _a.currencyPos, unitOfMeasure = _a.unitOfMeasure, isSponsoredListing = _a.isSponsoredListing, unitItem = _a.unitItem, isNewCarrefourJourney = _a.isNewCarrefourJourney;
    var t = useTranslation().t;
    if (discount) {
        return (React.createElement(React.Fragment, null, renderProductPrice$1(minBuyingValue ? parseFloat(minBuyingValue) : originalPrice, 'original', currency, currencyPos, unitOfMeasure, discount.price > 0, variant, t, 'product-card-original-price', isSponsoredListing, unitItem, discount, isNewCarrefourJourney)));
    }
    return React.createElement(React.Fragment, null);
};
var timeOutValue$1;
var timer$1 = function (dispatch) {
    timeOutValue$1 = setTimeout(function () {
        dispatch(setExpandedQtySelectorProductId$1(''));
    }, QTY_SELECTOR_TIMER$1);
};
var setTimerForQTYSeclector$1 = function (dispatch) {
    timer$1(dispatch);
};
var clearTimerForQTYSeclector$1 = function () {
    if (timeOutValue$1) {
        clearTimeout(timeOutValue$1);
    }
};
var formatFoodWeight$1 = function (min, unitOfMeasure) {
    if (min < 1) {
        return min * 1000 + "g";
    }
    else {
        return min + unitOfMeasure;
    }
};
var getCommonGtmData$1 = function (props) {
    var _a, _b;
    var selectedQuantity = props.selectedQuantity, quantity = props.quantity, incrementBy = props.incrementBy, min = props.min, minBuyValue = props.minBuyValue, priceDetails = props.priceDetails, soldByWeight = props.soldByWeight, productDiscount = props.productDiscount;
    var deltaQtyInUnit = convertDeltaQtyInoUnit$1(selectedQuantity, quantity, incrementBy);
    var minQntyInUnits = Number(min / incrementBy);
    var minBuyingValue = ((minBuyValue || ((_a = priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.original) === null || _a === void 0 ? void 0 : _a.minBuyingValue)) / minQntyInUnits).toFixed(2);
    var discountOfMinBuyingValue = (Number((productDiscount === null || productDiscount === void 0 ? void 0 : productDiscount.minBuyingValue) || ((_b = priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.discount) === null || _b === void 0 ? void 0 : _b.minBuyingValue) || '0') / minQntyInUnits).toFixed(2);
    var changedQuantity = Math.abs(Math.floor(deltaQtyInUnit));
    var price = parseFloat(minBuyingValue);
    var discount = parseFloat(discountOfMinBuyingValue);
    var gtmData = {
        price: price,
        value: Number((changedQuantity * price).toFixed(2)),
        discount: discount > 0 ? parseFloat((price - discount).toFixed(2)) : 0,
        quantity: changedQuantity,
    };
    var changedInWeight = Math.abs(selectedQuantity - quantity) * 1000;
    var scalableWeight = Math.round(changedInWeight * 100) / 100;
    scalableWeight = Math.floor(scalableWeight);
    return __assign(__assign({}, gtmData), { scalable_weight: soldByWeight ? scalableWeight + 'g' : 'not_applicable' });
};

var algoliaTrackingOnATC$1 = function (algoliaParams, dispatch) {
    dispatch(algoliaTracking$1(__assign(__assign({}, algoliaParams), { productPositions: '' })));
};
var atcAlgoliaOperations$1 = function (state, algoliaParams, dispatch) {
    if (algoliaParams === void 0) { algoliaParams = {}; }
    var _a = ((state === null || state === void 0 ? void 0 : state.search) || {}).algoliaQueryID, algoliaQueryID = _a === void 0 ? '' : _a;
    var productId = algoliaParams.productId, productPosition = algoliaParams.productPosition, sortBy = algoliaParams.sortBy;
    var trackingParams = getAlgoliaTrackingParams$1(productId, productPosition, sortBy, algoliaQueryID, ATC_EVENT$1);
    algoliaTrackingOnATC$1(trackingParams, dispatch);
};
var convertQtyIntoUnit$1 = function (quantity, incrementBy) { var _a; return (_a = (quantity / incrementBy)) === null || _a === void 0 ? void 0 : _a.toString(); };
var convertDeltaQtyInoUnit$1 = function (updatedQuantity, currentQuantity, incrementBy) {
    return parseInt((convertQtyIntoUnit$1(updatedQuantity, incrementBy) - convertQtyIntoUnit$1(currentQuantity, incrementBy)).toFixed(1));
};

var isUserShareMember$1 = function (store) {
    var _a, _b, _c;
    return !!(((_b = (_a = store === null || store === void 0 ? void 0 : store.appConfig) === null || _a === void 0 ? void 0 : _a.features) === null || _b === void 0 ? void 0 : _b.share) && ((_c = store === null || store === void 0 ? void 0 : store.userData) === null || _c === void 0 ? void 0 : _c.cardNumber));
};

var onCartUpdate$1 = function (productId, state) {
    var areaCode = state.appConfig.areaCode, entries = state.miniCart.entries;
    var productIds = Object.values(entries).map(function (obj) { return obj.entry; });
    productIds.push(productId);
    var analytics = new AnalyticsManager$1();
    var url = UPDATE_CART_RELEVANCE$1 + "&productId=" + productIds.join('|');
    if (areaCode) {
        url += "&areaCode=" + areaCode;
    }
    analytics.trackEvent(url);
};
var setMiniCartData$1 = function (payload) { return ({
    type: EMiniCartTypes$3.MINI_CART_SET_DATA,
    payload: payload,
}); };
var getCartEntries$1 = function (data) {
    var _a = data.shipments, shipments = _a === void 0 ? [] : _a;
    if (shipments && !shipments.length) {
        return data;
    }
    data.entries = shipments.reduce(function (accumulator, item) {
        if (item.entries)
            return __spread(accumulator, item.entries);
        if (item.sellersEntries) {
            var sellerEntry = item.sellersEntries.reduce(function (accum, sellerItem) {
                return __spread(accum, sellerItem.entries);
            }, []);
            return __spread(accumulator, sellerEntry);
        }
        return [];
    }, []);
    return data;
};
var getCartData$1 = function () { return function (dispatch, getState) {
    var guid = getGUID$1();
    var _a = getState().appConfig, areaCode = _a.areaCode, _b = _a.posInfoConfig, posInfoConfig = _b === void 0 ? [] : _b;
    var isLoggedIn = getUserTokenFromCookie$1();
    var nsp = posInfoConfig.join(',');
    if (isLoggedIn) {
        removeGUIDFromCookie$1();
    }
    var paramData = {
        url: guid ? GET_CART_V3$1 + "&guid=" + guid : GET_CART_V3$1,
        getTransformedData: function (cartData) { return getCartEntries$1(cartData); },
        apiVersion: 3,
    };
    var url = paramData.url, getTransformedData = paramData.getTransformedData, apiVersion = paramData.apiVersion;
    if (guid || isLoggedIn) {
        dispatch({
            type: EMiniCartTypes$3.MINI_CART_GET,
            payload: {
                apiVersion: apiVersion,
                url: url,
                method: EApiMiddlewareMethod$3.GET,
                params: {
                    areaCode: areaCode,
                    nsp: nsp,
                },
                onSuccess: function (cartData) {
                    var updatedCart = getTransformedData(cartData);
                    var _a = getEntriesAndOffersEntries$1(updatedCart), productEntries = _a.productEntries, totalProductCount = _a.totalProductCount;
                    dispatch(setMiniCartData$1({ entries: productEntries, totalUnitCount: totalProductCount }));
                },
                onFailure: function () {
                    showNotification$1({
                        type: 'error',
                        message: 'Unable to retrieve cart',
                        variant: 'sticky',
                    });
                },
            },
        });
    }
}; };
var getEntriesAndOffersEntries$1 = function (cart) {
    var entries = cart.entries, totalItems = cart.totalItems;
    var productEntries = {};
    entries &&
        entries.forEach(function (entry) {
            var _a = entry.product, code = _a.code, soldByWeight = _a.soldByWeight, quantity = entry.quantity, serviceEntries = entry.serviceEntries, offerId = entry.offerId, intent = entry.intent;
            var productId = Number(code);
            var offerIdWithOfferText = offerId ? (!offerId.includes('offer') ? "offer_" + offerId : offerId) : null;
            var uniqueEntryId = getUniqueEntryId$1(code, offerIdWithOfferText, intent);
            productEntries[uniqueEntryId] = {
                offerId: offerId,
                entry: productId,
                serviceEntries: serviceEntries,
                quantity: convertQuantityToKG$1(quantity, soldByWeight),
                intent: intent,
            };
        });
    return { productEntries: productEntries, totalProductCount: totalItems };
};
var updateEntryInMiniCart$1 = function (miniCart, params) {
    var _a;
    var _b;
    var productId = params.productId, _c = params.offerId, offerIdWithOfferText = _c === void 0 ? '' : _c, quantity = params.quantity, isSoldByWeight = params.isSoldByWeight, intent = params.intent, serviceProductCode = params.serviceProductCode;
    var entries = miniCart.entries;
    var updatedEntries = entries;
    var uniqueEntryId = getUniqueEntryId$1(productId, offerIdWithOfferText, intent);
    var serviceEntries = ((_b = miniCart.entries[uniqueEntryId]) === null || _b === void 0 ? void 0 : _b.serviceEntries) || [];
    var splittedOfferId = offerIdWithOfferText.split('_');
    if (serviceProductCode) {
        if (serviceEntries.length < 1) {
            serviceEntries.push({ product: { code: serviceProductCode } });
        }
        else {
            serviceEntries[0].product.code = serviceProductCode;
        }
    }
    updatedEntries = __assign(__assign({}, entries), (_a = {}, _a[uniqueEntryId] = {
        offerId: splittedOfferId[1] || splittedOfferId[0],
        entry: productId,
        quantity: convertQuantityToKG$1(quantity, isSoldByWeight),
        intent: intent,
        serviceEntries: serviceEntries,
    }, _a));
    return { productEntries: updatedEntries };
};
var CARREFOUR_SELLER_OFFER_ID$1 = 'offer_carrefour_';
var getUniqueEntryId$1 = function (productId, offerId, serviceType) {
    // If the seller is Carrefour, the offerId might be blank.
    // In such cases, use the default offerId CARREFOUR_SELLER_OFFER_ID.
    var resolvedOfferId = offerId || CARREFOUR_SELLER_OFFER_ID$1;
    return "" + productId + resolvedOfferId + serviceType;
};
var addToCart$1 = function (productId, qty, params, finalCb, productPosition, sortBy) { return function (dispatch, getState) {
    var state = getState();
    var guid = getGUID$1();
    atcAlgoliaOperations$1(state, { productId: productId, productPosition: productPosition, sortBy: sortBy }, dispatch);
    /*
     * We need this when cookies are cleared or for new user visiting the page to
     * prevent them from adding multiple product cards on the same which
     * will not work as we don't have guid until 1 product is added
     */
    if (!guid) {
        dispatch(setDisabled$1(true));
    }
    var gtmCallBack = params.gtmCallBack, brazeAddToCartCB = params.brazeAddToCartCB, _a = params.withRelevantProducts, withRelevantProducts = _a === void 0 ? false : _a, _b = params.isMarketPlace, isMarketPlace = _b === void 0 ? false : _b, offerId = params.offerId, _c = params.serviceProductCode, serviceProductCode = _c === void 0 ? '' : _c, onSuccessCb = params.onSuccessCb, onFailureCb = params.onFailureCb, _d = params.productName, productName = _d === void 0 ? '' : _d, _e = params.isCartRequired, isCartRequired = _e === void 0 ? false : _e, _f = params.shippingIndicator, shippingIndicator = _f === void 0 ? '' : _f, productImageURL = params.productImageURL, intent = params.intent, _g = params.incrementBy, incrementBy = _g === void 0 ? 1 : _g, isSponsored = params.isSponsored, applicablePrice = params.applicablePrice, isV4Basket = params.isV4Basket, basketV4Attributes = __rest(params, ["gtmCallBack", "brazeAddToCartCB", "withRelevantProducts", "isMarketPlace", "offerId", "serviceProductCode", "onSuccessCb", "onFailureCb", "productName", "isCartRequired", "shippingIndicator", "productImageURL", "intent", "incrementBy", "isSponsored", "applicablePrice", "isV4Basket"]);
    dispatch(setLoading$1(offerId || productId, true));
    var isV4BasketApplicable = isV4Basket && !isCartRequired;
    var journeyIntent = shippingIndicator ? { intent: shippingIndicator } : getBasketIntent$1(state, intent);
    var isNewJourney = isNewC4Journey$1(state);
    var areaCode = state.appConfig.areaCode, miniCart = state.miniCart;
    if (withRelevantProducts) {
        dispatch(setRelevantProductId$1(''));
    }
    var isShareMember = isUserShareMember$1(state);
    var basketV4Params = isV4BasketApplicable ? basketV4Attributes : {};
    var paramData = {
        url: guid ? ADD_TO_CART_V3$1 + "&guid=" + guid : ADD_TO_CART_V3$1,
        apiVersion: isV4BasketApplicable ? 4 : 3,
        data: __assign(__assign(__assign({ productId: productId, quantity: qty }, journeyIntent), { serviceProductCode: serviceProductCode ? [serviceProductCode] : [], productName: productName, imageUrl: productImageURL, offerId: isMarketPlace ? offerId : '' }), basketV4Params),
    };
    var growthbook = createGrowthBookInstance$1(__assign({}, state.appConfig.growthBook), state);
    var isCartBundlingEnabled = growthbook.feature('common.cart_bundling.enabled').on;
    var url = paramData.url, apiVersion = paramData.apiVersion, data = paramData.data;
    dispatch({
        type: EMiniCartTypes$3.MINI_CART_ADD_TO_CART,
        payload: {
            headers: { 'content-type': isNewJourney ? 'application/json' : 'application/x-www-form-urlencoded' },
            apiVersion: apiVersion,
            url: url + (isCartBundlingEnabled ? '&cp=true' : ''),
            method: EApiMiddlewareMethod$3.POST,
            params: {
                areaCode: areaCode,
                isCartRequired: isCartRequired,
                lm: isShareMember,
            },
            data: data,
            onSuccess: function (cartResponse) {
                var guid = cartResponse.guid, isSoldByWeight = cartResponse.isSoldByWeight, quantity = cartResponse.quantity, totalUnitCount = cartResponse.totalUnitCount;
                onCartUpdate$1(productId, state);
                var isCriteoEnabled = isAdTechCriteoEnabled$1(state);
                if (isCriteoEnabled && !isSponsored) {
                    var quantityInUnits = convertQtyIntoUnit$1(qty, incrementBy);
                    addToCartTracking$1({ quantity: quantityInUnits, price: applicablePrice, item: productId }, dispatch);
                }
                if (guid) {
                    setGUID$1(guid);
                }
                if (withRelevantProducts) {
                    dispatch(setRelevantProductId$1(productId));
                }
                if (gtmCallBack) {
                    gtmCallBack(qty, eventTypeEnum$1.add_to_cart, productId);
                }
                if (onSuccessCb) {
                    onSuccessCb(cartResponse);
                }
                var productEntries = updateEntryInMiniCart$1(miniCart, {
                    offerId: offerId,
                    productId: productId,
                    quantity: quantity,
                    isSoldByWeight: isSoldByWeight,
                    intent: journeyIntent === null || journeyIntent === void 0 ? void 0 : journeyIntent.intent,
                }).productEntries;
                if (brazeAddToCartCB) {
                    brazeAddToCartCB(totalUnitCount);
                }
                dispatch(setMiniCartData$1({ entries: productEntries, totalUnitCount: totalUnitCount }));
            },
            onFailure: function (_errMessage, _a) {
                var data = (_a === void 0 ? {} : _a).response.data;
                var _b = data.meta, detail = (_b === void 0 ? { detail: '' } : _b).detail;
                if (onFailureCb) {
                    onFailureCb(productName, data);
                }
                dispatch(setError$1(productId, true, detail));
            },
            onFinally: function () {
                dispatch(setLoading$1(offerId || productId, false));
                dispatch(setDisabled$1(false));
                dispatch(setExpandedQtySelectorProductId$1(productId));
                setTimerForQTYSeclector$1(dispatch);
                if (finalCb) {
                    finalCb(productId);
                }
            },
        },
    });
}; };
var updateCart$1 = function (productId, qty, params) {
    if (params === void 0) { params = {}; }
    return function (dispatch, getState) {
        clearTimerForQTYSeclector$1();
        var guid = getGUID$1();
        var state = getState();
        var miniCart = state.miniCart, areaCode = state.appConfig.areaCode;
        var serviceProductCode = params.serviceProductCode, brazeCB = params.brazeCB, gtmCallBack = params.gtmCallBack, offerId = params.offerId, isV4Basket = params.isV4Basket, productName = params.productName, productImageURL = params.productImageURL, onSuccessCb = params.onSuccessCb, _a = params.isCartRequired, isCartRequired = _a === void 0 ? false : _a, _b = params.shippingIndicator, shippingIndicator = _b === void 0 ? '' : _b, basketV4Attributes = __rest(params, ["serviceProductCode", "brazeCB", "gtmCallBack", "offerId", "isV4Basket", "productName", "productImageURL", "onSuccessCb", "isCartRequired", "shippingIndicator"]);
        var isV4BasketApplicable = isV4Basket && !isCartRequired;
        var journeyIntent = shippingIndicator ? { intent: shippingIndicator } : {};
        var isNewJourney = isNewC4Journey$1(state);
        var offerString = offerId ? (!offerId.includes('offer') ? "offer_" + offerId : offerId) : '';
        var basketV4Params = isV4BasketApplicable ? __assign({ productName: productName, imageUrl: productImageURL }, basketV4Attributes) : {};
        var UPDATE_CART = isV4BasketApplicable ? ADD_TO_CART_V3$1 : UPDATE_CART_V3$1;
        var paramData = {
            url: guid ? UPDATE_CART + "&guid=" + guid : UPDATE_CART,
            apiVersion: isV4BasketApplicable ? 4 : 3,
            data: __assign(__assign(__assign({}, journeyIntent), { productId: productId, quantity: qty, serviceProductCode: serviceProductCode ? [serviceProductCode] : null, offerId: offerId ? offerString : '' }), basketV4Params),
        };
        var growthbook = createGrowthBookInstance$1(__assign({}, state.appConfig.growthBook), state);
        var isCartBundlingEnabled = growthbook.feature('common.cart_bundling.enabled').on;
        var url = paramData.url, apiVersion = paramData.apiVersion, data = paramData.data;
        var isShareMember = isUserShareMember$1(state);
        dispatch(setLoading$1(productId, true));
        dispatch({
            type: EMiniCartTypes$3.MINI_CART_UPDATE_CART,
            payload: {
                headers: { 'content-type': isNewJourney ? 'application/json' : 'application/x-www-form-urlencoded' },
                apiVersion: apiVersion,
                url: url + (isCartBundlingEnabled ? '&cp=true' : ''),
                method: isV4BasketApplicable ? EApiMiddlewareMethod$3.POST : EApiMiddlewareMethod$3.PUT,
                params: {
                    areaCode: areaCode,
                    cartEntryNumber: productId,
                    isCartRequired: isCartRequired,
                    lm: isShareMember,
                },
                data: data,
                onSuccess: function (cartResponse) {
                    var isSoldByWeight = cartResponse.isSoldByWeight, quantity = cartResponse.quantity, totalUnitCount = cartResponse.totalUnitCount;
                    var productEntries = updateEntryInMiniCart$1(miniCart, {
                        offerId: offerId,
                        productId: productId,
                        quantity: quantity,
                        isSoldByWeight: isSoldByWeight,
                        intent: journeyIntent.intent,
                        serviceProductCode: serviceProductCode,
                    }).productEntries;
                    if (brazeCB) {
                        brazeCB(totalUnitCount);
                    }
                    if (onSuccessCb) {
                        onSuccessCb(cartResponse);
                    }
                    dispatch(setMiniCartData$1({ entries: productEntries, totalUnitCount: totalUnitCount }));
                },
                onFinally: function () {
                    dispatch(setLoading$1(productId, false));
                    dispatch(setDisabled$1(false));
                    setTimerForQTYSeclector$1(dispatch);
                    if (gtmCallBack) {
                        gtmCallBack(qty, eventTypeEnum$1.change_the_quantity);
                    }
                },
            },
        });
    };
};
var removeFromCart$1 = function (productId, params) {
    if (params === void 0) { params = {}; }
    return function (dispatch, getState) {
        clearTimerForQTYSeclector$1();
        var guid = getGUID$1();
        var state = getState();
        var _a = state.miniCart.entries, entries = _a === void 0 ? {} : _a, _b = state.appConfig, areaCode = _b.areaCode, _c = _b.posInfoConfig, posInfoConfig = _c === void 0 ? [] : _c;
        var nsp = posInfoConfig.join(',');
        var brazeCB = params.brazeCB, gtmCallBack = params.gtmCallBack, offerId = params.offerId, onSuccessCb = params.onSuccessCb, _d = params.isCartRequired, isCartRequired = _d === void 0 ? false : _d, shippingIndicator = params.shippingIndicator;
        var offerString = offerId ? (!offerId.includes('offer') ? "offer_" + offerId : offerId) : '';
        var uniqueEntryId = getUniqueEntryId$1(productId, offerString, shippingIndicator || '');
        var journeyIntent = shippingIndicator ? { intent: shippingIndicator } : {};
        var entry = entries[uniqueEntryId].entry;
        dispatch(setLoading$1(productId, true));
        dispatch(setDisabled$1(true));
        var paramData = {
            apiVersion: 3,
            url: guid ? NEW_REMOVE_FROM_CART$1 + "&guid=" + guid : NEW_REMOVE_FROM_CART$1,
            data: {
                deleteItems: [
                    __assign({ productId: productId, offerId: offerString }, journeyIntent),
                ],
            },
        };
        var url = paramData.url, data = paramData.data, apiVersion = paramData.apiVersion;
        dispatch({
            type: EMiniCartTypes$3.MINI_CART_REMOVE_FROM_CART,
            payload: {
                url: url,
                method: EApiMiddlewareMethod$3.DELETE,
                apiVersion: apiVersion,
                params: {
                    cartEntryNumber: entry,
                    areaCode: areaCode,
                    isCartRequired: isCartRequired,
                    nsp: nsp,
                },
                data: data,
                onSuccess: function (cartResponse) {
                    var totalUnitCount = cartResponse.totalUnitCount;
                    onCartUpdate$1(productId, state);
                    // if its success and cart has a remaining 1 entry
                    // which we will eventually delete
                    if (Object.keys(entries).length === 1) {
                        removeGUIDFromCookie$1();
                    }
                    if (gtmCallBack) {
                        gtmCallBack(0, eventTypeEnum$1.remove_from_cart, productId);
                    }
                    if (brazeCB) {
                        brazeCB(totalUnitCount);
                    }
                    if (onSuccessCb) {
                        onSuccessCb(cartResponse);
                    }
                    dispatch({
                        type: EMiniCartTypes$3.MINI_CART_REMOVE_FROM_ENTRIES,
                        payload: {
                            productId: productId,
                            totalUnitCount: totalUnitCount,
                            offerString: offerString,
                            uniqueEntryId: uniqueEntryId,
                        },
                    });
                },
                onFinally: function () {
                    dispatch(setLoading$1(productId, false));
                    dispatch(setDisabled$1(false));
                    dispatch(setExpandedQtySelectorProductId$1(''));
                },
            },
        });
    };
};
/**
 * Used for fbt to add product one by one
 */
var addToCartTracking$1 = function (trackingParams, dispatch) {
    var userId = getCustomCookie$1(constants$1.rrUserId) || '';
    var visitorId = getCustomCookie$1(constants$1.rrSessionId);
    dispatch({
        type: EMiniCartTypes$3.MINI_CART_ADD_TO_CART_TRACKING,
        payload: {
            headers: { userId: userId, visitorId: visitorId },
            url: ADD_TO_CART_TRACKING$1,
            apiVersion: 1,
            method: EApiMiddlewareMethod$3.POST,
            data: trackingParams,
        },
    });
};
var fbtAddToCart$1 = function (products, cb, isV4Basket, gtmCallBack) { return function (dispatch, getState) {
    dispatch(setDisabled$1(true));
    var state = getState();
    var isNewJourney = isNewC4Journey$1(state);
    products.forEach(function (p) {
        algoliaTrackingOnATC$1({
            clickType: ATC_EVENT$1,
            pageType: 'PDP',
            products: [p.productId],
            searchQueryID: window.location.href.includes(p.productId) ? sessionStorage.getItem('queryId') : '',
        }, dispatch);
    });
    products.forEach(function (p) {
        dispatch(setError$1(p.productId, false));
    });
    var startRequest = function (req) {
        var _a, _b, _c, _d, _e;
        if (req === void 0) { req = 0; }
        if (req <= products.length - 1) {
            var state_1 = getState();
            var guid = getGUID$1();
            var areaCode = state_1.appConfig.areaCode, miniCart_1 = state_1.miniCart;
            var _f = products[req], productId_1 = _f.productId, isMarketPlace = _f.isMarketPlace, min_1 = _f.min, _g = _f.serviceProductCode, serviceProductCode = _g === void 0 ? '' : _g, _h = _f.offers, offers = _h === void 0 ? [] : _h, _j = _f.name, productName = _j === void 0 ? '' : _j, image = _f.image, _k = _f.incrementBy, incrementBy_1 = _k === void 0 ? 1 : _k, _l = _f.originalPrice, originalPrice_1 = _l === void 0 ? 1 : _l, soldByWeight = _f.soldByWeight;
            var basketV4Attributes_1 = {
                pis: ((_b = (_a = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _a === void 0 ? void 0 : _a.purchaseIndicators) === null || _b === void 0 ? void 0 : _b.SHIPPING) || [],
                shippingIndicator: ((_c = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _c === void 0 ? void 0 : _c.shippingIndicator) || '',
                shopId: (_d = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _d === void 0 ? void 0 : _d.shopId,
                shopName: (_e = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _e === void 0 ? void 0 : _e.shop,
                isSoldByWeight: soldByWeight,
            };
            var basketV4Params = isV4Basket ? basketV4Attributes_1 : {};
            var offerId_1 = isMarketPlace && offers.length > 0 ? offers[0].id : undefined;
            var paramData = {
                url: guid ? ADD_TO_CART_V3$1 + "&guid=" + guid : ADD_TO_CART_V3$1,
                apiVersion: isV4Basket ? 4 : 3,
                data: __assign({ productId: productId_1, quantity: min_1, serviceProductCode: serviceProductCode ? [serviceProductCode] : [], productName: productName, imageUrl: (image === null || image === void 0 ? void 0 : image.href) || '', offerId: isMarketPlace ? offerId_1 : '' }, basketV4Params),
            };
            var growthbook = createGrowthBookInstance$1(__assign({}, state_1.appConfig.growthBook), state_1);
            var isCartBundlingEnabled = growthbook.feature('common.cart_bundling.enabled').on;
            var url = paramData.url, apiVersion = paramData.apiVersion, data = paramData.data;
            dispatch(setLoading$1(productId_1, true));
            dispatch({
                type: EMiniCartTypes$3.MINI_CART_ADD_TO_CART,
                payload: {
                    headers: { 'content-type': isNewJourney ? 'application/json' : 'application/x-www-form-urlencoded' },
                    apiVersion: apiVersion,
                    url: url + (isCartBundlingEnabled ? '&cp=true' : ''),
                    method: EApiMiddlewareMethod$3.POST,
                    params: {
                        areaCode: areaCode,
                        isCartRequired: false,
                    },
                    data: data,
                    onSuccess: function (cartResponse) {
                        var guid = cartResponse.guid, isSoldByWeight = cartResponse.isSoldByWeight, quantity = cartResponse.quantity, totalUnitCount = cartResponse.totalUnitCount;
                        var productEntries = updateEntryInMiniCart$1(miniCart_1, {
                            offerId: offerId_1,
                            productId: productId_1,
                            quantity: quantity,
                            intent: basketV4Attributes_1 === null || basketV4Attributes_1 === void 0 ? void 0 : basketV4Attributes_1.shippingIndicator,
                            isSoldByWeight: isSoldByWeight,
                        }).productEntries;
                        onCartUpdate$1(productId_1, state_1);
                        var isCriteoEnabled = isAdTechCriteoEnabled$1(state_1);
                        if (gtmCallBack) {
                            gtmCallBack(products[req]);
                        }
                        if (isCriteoEnabled) {
                            var quantityInUnits = convertQtyIntoUnit$1(min_1, incrementBy_1);
                            addToCartTracking$1({ quantity: quantityInUnits, price: originalPrice_1, item: productId_1 }, dispatch);
                        }
                        if (guid) {
                            setGUID$1(guid);
                        }
                        dispatch(setMiniCartData$1({ entries: productEntries, totalUnitCount: totalUnitCount }));
                    },
                    onFailure: function (_errMessage, _a) {
                        var data = (_a === void 0 ? {} : _a).response.data;
                        var _b = data.meta, _c = _b === void 0 ? { detail: '', message: '' } : _b, detail = _c.detail, message = _c.message;
                        dispatch(setError$1(productId_1, true, detail || message));
                    },
                    onFinally: function () {
                        dispatch(setLoading$1(productId_1, false));
                        startRequest(req + 1);
                    },
                },
            });
        }
        else {
            dispatch(setDisabled$1(false));
            cb && cb();
        }
    };
    startRequest();
}; };

var miniCart_action$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    setMiniCartData: setMiniCartData$1,
    getCartData: getCartData$1,
    getUniqueEntryId: getUniqueEntryId$1,
    addToCart: addToCart$1,
    updateCart: updateCart$1,
    removeFromCart: removeFromCart$1,
    addToCartTracking: addToCartTracking$1,
    fbtAddToCart: fbtAddToCart$1
});

var decodeHtml$1 = function (html) {
    if (isBrowser$1()) {
        var txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }
    return '';
};
var capitalizeFirstLetter$1 = function (text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};

var getUserData = function (authToken, isShareEnabled) {
    if (isShareEnabled === void 0) { isShareEnabled = true; }
    return function (dispatch) {
        if (isShareEnabled) {
            dispatch(getUserLoyaltyData(authToken));
        }
        if (authToken) {
            // IF JWT Enable then only this api get called
            dispatch(getUserProfileData());
            if (!isShareEnabled) {
                dispatch(getUserLoyaltySummary());
            }
            //dispatch<any>(fetchUserAddresses());
        }
    };
};
var getHeaderData = function () { return function (dispatch, getState) {
    var _a = getState().appConfig, storeId = _a.storeId, language = _a.language;
    dispatch({
        type: HeaderTypes$3.HEADER_GET,
        payload: {
            apiVersion: 1,
            isAuthorized: false,
            url: GET_HEADER_CLIENT,
            method: EApiMiddlewareMethod$3.GET,
            isAbsUrl: true,
            params: { storeId: storeId, language: language },
            onFailure: function () {
                showNotification$1({
                    type: 'error',
                    message: 'Unable to retrieve header data',
                    variant: 'sticky',
                });
            },
        },
    });
}; };
var setHeadersDetails = function (payload) {
    if (payload === void 0) { payload = {}; }
    return {
        type: "" + HeaderTypes$3.HEADER_GET + EApiActionTypes$3.API_SUCCESS,
        payload: payload,
    };
};

var UserDataHook = function () {
    var _a, _b;
    var _c = useSelector(function (state) { return state; }), userData = _c.userData, appConfig = _c.appConfig;
    var dispatch = useDispatch();
    var authToken = ((_a = appConfig === null || appConfig === void 0 ? void 0 : appConfig.userCredentials) === null || _a === void 0 ? void 0 : _a.authToken) || getUserTokenFromCookie$1();
    var share = (_b = appConfig === null || appConfig === void 0 ? void 0 : appConfig.features) === null || _b === void 0 ? void 0 : _b.share;
    var fetchDataCallback = useCallback(function () {
        if (authToken) {
            dispatch(getUserData(authToken, share));
        }
    }, [dispatch, authToken, share]);
    useEffect(function () {
        fetchDataCallback();
    }, [fetchDataCallback]);
    return userData;
};

var useAppConfig$1 = function () {
    var dispatch = useDispatch();
    var methods = useRef({
        setArea: function (areaCode) {
            dispatch(setAreaCode$1(areaCode));
        },
        setLanguage: function (languageCode) {
            dispatch(setLanguageCode$1(languageCode));
        },
        setCurrency: function (currency) {
            dispatch(setCurrency$1(currency));
        },
    });
    // const setArea = useCallback(
    //   (areaCode: string) => {
    //     dispatch(setAreaCode(areaCode));
    //   },
    //   [dispatch],
    // );
    // const setLanguage = useCallback(
    //   (languageCode: string) => {
    //     dispatch(setLanguageCode(languageCode));
    //   },
    //   [dispatch],
    // );
    // const setCurrency = useCallback(())
    var appConfigState = useSelector(function (state) { return state.appConfig; });
    // Avoid "Shadowed name: 'areaCode'" error via namespace
    var requestStatus = useMemo(function () {
        var isFailedReq = isExisty$1(appConfigState.statusCode) || isExisty$1(appConfigState.errors);
        return {
            done: isExisty$1(appConfigState.areaCode) || isFailedReq,
            failed: !isExisty$1(appConfigState.areaCode) && isFailedReq,
        };
    }, [appConfigState]);
    var setAppContext = function (url) { return (url ? "/" + appConfigState.storeId + "/" + appConfigState.language + url : '#'); };
    var _a = methods.current, setLanguage = _a.setLanguage, setArea = _a.setArea, setCurrency = _a.setCurrency;
    return [appConfigState, setLanguage, setArea, requestStatus, setAppContext, setCurrency];
};

var useOneTrustUrl = function () {
    var _a = useSelector(function (state) { return state.appConfig; }), countryConfiguration = _a.countryConfiguration, language = _a.language, userCredentials = _a.userCredentials;
    var authToken = (userCredentials === null || userCredentials === void 0 ? void 0 : userCredentials.authToken) || getUserTokenFromCookie$1();
    var oneTrustPrivacyPolicyUrl = (countryConfiguration || { oneTrustPrivacyPolicyUrl: '' }).oneTrustPrivacyPolicyUrl;
    var _b = __read(useAppConfig$1(), 1), countryName = _b[0].countryName;
    var baseUrl = oneTrustPrivacyPolicyUrl + "/" + process.env.REACT_APP_ONE_TRUST_CLIENT_ID;
    var queryParams = new URLSearchParams();
    if (authToken) {
        queryParams.append('access-token', authToken);
    }
    if (language) {
        queryParams.append('lang', language);
    }
    if (countryName) {
        queryParams.append('country', countryName);
    }
    var oneTrustUrl = baseUrl + "?" + queryParams.toString();
    return oneTrustUrl;
};

var ProviderWrapper = function (_a) {
    var children = _a.children, store = _a.store;
    return (React.createElement(Provider, { store: store }, children));
};

var Header$2 = CustomStyled$1(Box)(templateObject_1$16 || (templateObject_1$16 = __makeTemplateObject(["\n  position: sticky;\n  width: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 9;\n  font-family: 'Montserrat';\n  html[dir='rtl'] & {\n    font-family: 'Noto Kufi Arabic';\n  }\n  height: ", ";\n  @media (max-width: ", ") {\n    ", ";\n  }\n"], ["\n  position: sticky;\n  width: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 9;\n  font-family: 'Montserrat';\n  html[dir='rtl'] & {\n    font-family: 'Noto Kufi Arabic';\n  }\n  height: ", ";\n  @media (max-width: ", ") {\n    ", ";\n  }\n"])), function (props) { return (props.isHideNav ? (props.cookieVisibility ? '180px' : '112px') : 'auto'); }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.isHideNav && "box-shadow: none"; });
var Spacer$1 = CustomStyled$1(Box)(templateObject_2$W || (templateObject_2$W = __makeTemplateObject([""], [""])));
Spacer$1.defaultProps = {
    flexGrow: [1, null, 0],
    pl: 3,
};
var PageMaxWidth$1 = CustomStyled$1(Box)(templateObject_3$L || (templateObject_3$L = __makeTemplateObject(["\n  max-width: 1440px;\n  margin: 0 auto;\n"], ["\n  max-width: 1440px;\n  margin: 0 auto;\n"])));
var Container$b = CustomStyled$1(Box)(templateObject_4$E || (templateObject_4$E = __makeTemplateObject([""], [""])));
Container$b.defaultProps = {
    bg: ['blue', null, null, null, 'white'],
    px: [3, 4, null, null, 0],
};
var Divider$1 = CustomStyled$1(Box)(templateObject_5$v || (templateObject_5$v = __makeTemplateObject(["\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n  margin: auto;\n"], ["\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n  margin: auto;\n"])));
Divider$1.defaultProps = {
    as: 'i',
    display: ['none', null, null, null, 'block'],
    height: 23,
};
var HelplineWrapper$1 = CustomStyled$1(Box)(templateObject_6$p || (templateObject_6$p = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n  padding-left: ", "px;\n  a{\n    color: inherit;\n    text-decoration: none;\n  }\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  padding-left: ", "px;\n  a{\n    color: inherit;\n    text-decoration: none;\n  }\n"])), function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.fontWeights[4]; }, function (props) { return props.theme.space[3]; });
var MobileAreaWrapper$1 = CustomStyled$1(Box)(templateObject_7$n || (templateObject_7$n = __makeTemplateObject(["\ndisplay: none;\n@media (max-width: ", ") {\n  display: ", ";\n}\n"], ["\ndisplay: none;\n@media (max-width: ", ") {\n  display: ", ";\n}\n"])), function (props) { return props.theme.breakpoints[3]; }, function (props) { return (props.isHideNav ? 'none' : 'block'); });
var DesktopAreaWrapper$1 = CustomStyled$1(Box)(templateObject_8$n || (templateObject_8$n = __makeTemplateObject(["\ndisplay: block;\n\n@media (max-width: ", ") {\n  display: none;\n}\n@media (min-width: ", ") {\n  ", ""], ["\ndisplay: block;\n\n@media (max-width: ", ") {\n  display: none;\n}\n@media (min-width: ", ") {\n  ",
    ""])), function (props) { return props.theme.breakpoints[3]; }, function (props) { return props.theme.breakpoints[1]; }, function (props) {
    return props.isDesktopHeader &&
        "\n  &:hover {\n    background: " + COLORS$1.BLUE_500 + ";\n    border-radius: 66px;\n  }\n  padding: 4px 12px;\n  ";
});
var HeadTabsWrapper$1 = CustomStyled$1(Box)(templateObject_9$l || (templateObject_9$l = __makeTemplateObject(["\ndisplay: grid;\nplace-items: center;\nbackground: ", ";\n\n@media (max-width: ", ") {\n  display: none;\n}\n"], ["\ndisplay: grid;\nplace-items: center;\nbackground: ", ";\n\n@media (max-width: ", ") {\n  display: none;\n}\n"])), COLORS$1.WHITE, function (props) { return props.theme.breakpoints[1]; });
var HeadTabsWrapperMobile$1 = CustomStyled$1(Box)(templateObject_10$k || (templateObject_10$k = __makeTemplateObject(["\nbackground: ", ";\npadding: 8px 8px 8px 0;\nheight: 53px;\n@media (min-width: ", ") {\n  display: none;\n}\n"], ["\nbackground: ", ";\npadding: 8px 8px 8px 0;\nheight: 53px;\n@media (min-width: ", ") {\n  display: none;\n}\n"])), COLORS$1.WHITE, function (props) { return props.theme.breakpoints[1]; });
var templateObject_1$16, templateObject_2$W, templateObject_3$L, templateObject_4$E, templateObject_5$v, templateObject_6$p, templateObject_7$n, templateObject_8$n, templateObject_9$l, templateObject_10$k;

var setAppMenu = function (payload) {
    return {
        type: EMenuNavigation$3.MENU_SUCCESS,
        payload: payload,
    };
};
var getMenuNavigation = function (params) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: EMenuNavigation$3.MENU_INIT });
                return [4 /*yield*/, AppConfigService$3.getAppMenu(params)];
            case 1:
                response = _a.sent();
                dispatch(setAppMenu({ response: response, isDesktop: params.isDesktop }));
                return [2 /*return*/];
        }
    });
}); }; };

var mafsau = {
    nowButton: {
        url: '/c/clp_now',
    },
};

var mafjor = {
    nowButton: {
        url: '/n/c/clp_jor-carrefournow',
    },
};

var mafegy = {
    nowButton: {
        url: '/n/c/clp_carrefour-now-egy',
    },
};

var mafpak = {
    nowButton: {
        url: '/n/c/clp_carrefour-express-pak',
    },
};

var mafkwt = {
    nowButton: {
        url: '/n/c/clp_now-c4',
    },
};

var storeIds = { mafsau: mafsau, mafjor: mafjor, mafegy: mafegy, mafpak: mafpak, mafkwt: mafkwt };

var DrawerMenuOptionStyle$1;
(function (DrawerMenuOptionStyle) {
    DrawerMenuOptionStyle["Default"] = "__menuoptionstyledefault__";
    DrawerMenuOptionStyle["Bold"] = "__menuoptionstylebold__";
    DrawerMenuOptionStyle["Focussed"] = "__menuoptionstylefocussed__";
    DrawerMenuOptionStyle["Bolder"] = "__menuoptionstylebolder__";
})(DrawerMenuOptionStyle$1 || (DrawerMenuOptionStyle$1 = {}));

var Caption$4 = Text.Caption, Paragraph$4 = Text.Paragraph;
var DrawerMenuContainer$1 = styled(Flex)(templateObject_1$17 || (templateObject_1$17 = __makeTemplateObject(["\n  flex-direction: row;\n  position: relative;\n  align-items: stretch;\n  justify-content: space-between;\n  transition: 0.3s all;\n  transform: ", ";\n  padding-top: 116px;\n"], ["\n  flex-direction: row;\n  position: relative;\n  align-items: stretch;\n  justify-content: space-between;\n  transition: 0.3s all;\n  transform: ", ";\n  padding-top: 116px;\n"])), function (props) { return (props.isSubMenuOpen ? "translateX(-100%)" : "translateX(0)"); });
var DrawerHeaderSeparator$1 = styled(Box)(templateObject_2$X || (templateObject_2$X = __makeTemplateObject(["\n  border-bottom: 8px solid ", ";\n  margin: 0 -", ";\n"], ["\n  border-bottom: 8px solid ", ";\n  margin: 0 -", ";\n"])), COLORS$1.LIGHT_BORDER, SPACINGS$1[16]);
var DrawerFixedHeaderSeparator$1 = styled(Box)(templateObject_3$M || (templateObject_3$M = __makeTemplateObject(["\n  border-bottom: 8px solid ", ";\n"], ["\n  border-bottom: 8px solid ", ";\n"])), COLORS$1.LIGHT_BORDER);
var DrawerItemSeparator$1 = styled(Box)(templateObject_4$F || (templateObject_4$F = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  width: 86%;\n  margin: auto;\n"], ["\n  border-bottom: 1px solid ", ";\n  width: 86%;\n  margin: auto;\n"])), COLORS$1.LIGHT_GRAY);
var DrawerMenuOptionCell$1 = styled(Flex)(templateObject_5$w || (templateObject_5$w = __makeTemplateObject(["\n  border-bottom: ", " solid ", ";\n  padding: 24px 0 20px 0;\n  cursor: pointer;\n"], ["\n  border-bottom: ", " solid ", ";\n  padding: 24px 0 20px 0;\n  cursor: pointer;\n"])), function (props) { return (!props.isLastInList ? '1px' : '0px'); }, COLORS$1.LIGHT_GRAY);
var CaptionText$1 = styled(Caption$4)(templateObject_6$q || (templateObject_6$q = __makeTemplateObject(["\n  text-transform: capitalize;\n"], ["\n  text-transform: capitalize;\n"])));
var DrawerMenuOptionLabel$1 = styled(Paragraph$4)(templateObject_7$o || (templateObject_7$o = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n"], ["\n  color: ", ";\n  font-weight: ", ";\n"])), function (props) { return getColorFor$1(props.optionStyle); }, function (props) { return getFontWeightFor$1(props.optionStyle); });
var getColorFor$1 = function (styleType) {
    if (styleType === void 0) { styleType = DrawerMenuOptionStyle$1.Default; }
    return styleType === DrawerMenuOptionStyle$1.Focussed ? COLORS$1.RED : COLORS$1.THUNDORA;
};
var getFontWeightFor$1 = function (styleType) {
    if (styleType === void 0) { styleType = DrawerMenuOptionStyle$1.Default; }
    return styleType === DrawerMenuOptionStyle$1.Bolder
        ? TYPOGRAPHY$1.WEIGHT[700]
        : DrawerMenuOptionStyle$1.Bold
            ? TYPOGRAPHY$1.WEIGHT[500]
            : TYPOGRAPHY$1.WEIGHT[400];
};
var DrawerNavItem$1 = styled.a(templateObject_8$o || (templateObject_8$o = __makeTemplateObject(["\n  position: relative;\n  display: block;\n  padding: ", ";\n  text-decoration: none;\n"], ["\n  position: relative;\n  display: block;\n  padding: ",
    ";\n  text-decoration: none;\n"])), function (props) {
    return props.quickBuy || props.buyNow ? "15px 16px 18px 24px" : "24px 16px 20px 24px";
});
var DrawerContent$1 = styled(Flex)(templateObject_9$m || (templateObject_9$m = __makeTemplateObject(["\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n"], ["\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n"])));
var DrawerHeader$3 = styled(Flex)(templateObject_10$l || (templateObject_10$l = __makeTemplateObject(["\n  padding: 20px 16px 16px 24px;\n  justify-content: flex-end;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  background: #ffffff;\n  top: 0;\n  ", "\n"], ["\n  padding: 20px 16px 16px 24px;\n  justify-content: flex-end;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  background: #ffffff;\n  top: 0;\n  ",
    "\n"])), variant({
    prop: 'type',
    variants: {
        bodered: {
            borderBottom: "1px solid " + COLORS$1.MERCURY,
            padding: '24px 0px 20px 0px',
            margin: '0px 16px',
            justifyContent: 'space-between',
        },
    },
}));
var DrawerSubHeader$1 = styled(Text)(templateObject_11$h || (templateObject_11$h = __makeTemplateObject(["\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  background: #ffffff;\n  top: 66px;\n"], ["\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  background: #ffffff;\n  top: 66px;\n"])));
var DrawerIconWrapper$1 = styled.span(templateObject_12$g || (templateObject_12$g = __makeTemplateObject(["\n  padding: 0px 10px 0px 0px;\n  margin-top: 6px;\n  position: relative;\n"], ["\n  padding: 0px 10px 0px 0px;\n  margin-top: 6px;\n  position: relative;\n"])));
var AllCategoryContent$1 = styled.div(templateObject_13$f || (templateObject_13$f = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  width: 100%;\n  left: 100%;\n  top: 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  width: 100%;\n  left: 100%;\n  top: 0;\n"])));
var DrawerNavText$1 = styled.div(templateObject_14$f || (templateObject_14$f = __makeTemplateObject(["\n  font-weight: 500;\n  font-size: 14px;\n  color: ", ";\n"], ["\n  font-weight: 500;\n  font-size: 14px;\n  color: ",
    ";\n"])), function (props) {
    return props.isDeal ? "#FF0000" : props.isLogin ? '#0E5AA7' : "#4d4d4d";
});
var DrawerHeaderContent$1 = styled(Flex)(templateObject_15$f || (templateObject_15$f = __makeTemplateObject([""], [""])));
var templateObject_1$17, templateObject_2$X, templateObject_3$M, templateObject_4$F, templateObject_5$w, templateObject_6$q, templateObject_7$o, templateObject_8$o, templateObject_9$m, templateObject_10$l, templateObject_11$h, templateObject_12$g, templateObject_13$f, templateObject_14$f, templateObject_15$f;

var MenuHeader$1 = {
    linksTo: URLS_CONFIG$1.urlPrefix + "/v1/my-account",
    key: '__menu_header_component__',
};
var DrawerMenuNavigations = function (features) {
    var logoutUrl = getCustomCookie$1('loginType') === 'social' ? '/api/auth/logout' : MY_ACCOUNT_PAGE + "/logout";
    var isProfileRevamp = useFeature('flutter.profile_revamp.enabled').on;
    var DrawerMenuOptions = [
        {
            title: (features === null || features === void 0 ? void 0 : features.share) ? 'loyaltyPoints' : 'points',
            pos: 'top',
            key: '__menu_option_my_club__',
            icon: (features === null || features === void 0 ? void 0 : features.share) ? ShareLoyalty : MyClub,
            requiresLogin: true,
            linksTo: MY_ACCOUNT_PAGE + "/loyalty",
        },
        {
            title: isProfileRevamp ? 'profile' : 'myDashboard',
            pos: 'top',
            key: '__menu_option_my_dashboard__',
            requiresLogin: true,
            linksTo: isProfileRevamp ? "" + PROFILE_PAGE$1 : "" + MY_ACCOUNT_PAGE,
        },
        {
            title: 'myOrders',
            pos: 'top',
            requiresLogin: true,
            key: '__menu_option_my_account__',
            linksTo: "" + MY_ACCOUNT_ORDERS_PAGE,
        },
        {
            title: 'myShoppingLists',
            pos: 'top',
            requiresLogin: true,
            key: '__menu_option_wishlist__',
            linksTo: MY_ACCOUNT_PAGE + "/wishlist",
        },
        {
            title: 'logout',
            pos: 'bottom',
            requiresLogin: true,
            key: '__menu_option_log_out__',
            linksTo: logoutUrl,
        },
        {
            title: 'needHelp',
            pos: 'bottom',
            key: '__menu_option_need_help__',
            linksTo: URLS_CONFIG$1.urlPrefix + "/instorefaqs",
        },
    ];
    return DrawerMenuOptions;
};

var IconButton$1 = styled.button(templateObject_1$18 || (templateObject_1$18 = __makeTemplateObject(["\n  ", ";\n  font-style: normal;\n  display: inline-flex;\n  align-items: center;\n  height: ", ";\n  background: 0;\n  border: 0;\n  text-decoration: none;\n  position: relative;\n"], ["\n  ", ";\n  font-style: normal;\n  display: inline-flex;\n  align-items: center;\n  height: ", ";\n  background: 0;\n  border: 0;\n  text-decoration: none;\n  position: relative;\n"])), space, SIZES$2.BUTTON_SIZE);
IconButton$1.Text = styled.span(templateObject_2$Y || (templateObject_2$Y = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  white-space: nowrap;\n  margin-left: 10px;\n\n  html[dir='rtl'] & {\n    font-weight: 600;\n  }\n  display: block;\n\n  @media (max-width: 767px) {\n    display: none;\n  }\n"], ["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  white-space: nowrap;\n  margin-left: 10px;\n\n  html[dir='rtl'] & {\n    font-weight: 600;\n  }\n  display: block;\n\n  @media (max-width: 767px) {\n    display: none;\n  }\n"])), function (props) { return (props.isDesktopHeader ? COLORS$1.WHITE : COLORS$1.ANCHOR_BLUE); }, TYPOGRAPHY$1.SIZE[12], TYPOGRAPHY$1.WEIGHT[500]);
var templateObject_1$18, templateObject_2$Y;

var DrawerLoggedOutHeader = function (_a) {
    var children = _a.children, extraStyleProps = _a.extraStyleProps;
    var _b = __read(useAppConfig$1(), 1), language = _b[0].language;
    return (React.createElement(IconButton$1, { padding: extraStyleProps, as: "a", href: LOGIN_PAGE },
        React.createElement(User, { size: "M" }),
        React.createElement(IconButton$1.Text, { language: language, isMobile: true }, children)));
};

var NowButtonWrapper$1 = CustomStyled$1.a(templateObject_1$19 || (templateObject_1$19 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  text-decoration: none;\n  align-items: center;\n  align-self: stretch;\n  color: ", ";\n  @media (min-width: ", ") {\n    margin-left: 15px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  text-decoration: none;\n  align-items: center;\n  align-self: stretch;\n  color: ", ";\n  @media (min-width: ", ") {\n    margin-left: 15px;\n  }\n"])), COLORS$1.BLUE, function (props) { return props.theme.breakpoints[3]; });
var IconWrapper$7 = CustomStyled$1(Flex)(templateObject_2$Z || (templateObject_2$Z = __makeTemplateObject(["\n  @media (min-width: ", ") {\n    border-left: 1px solid #E6E6E6;\n    padding-left: 12px;\n  } \n  margin-right: 10px;\n"], ["\n  @media (min-width: ", ") {\n    border-left: 1px solid #E6E6E6;\n    padding-left: 12px;\n  } \n  margin-right: 10px;\n"])), function (props) { return props.theme.breakpoints[3]; });
var TextWrapper$4 = CustomStyled$1(Text)(templateObject_3$N || (templateObject_3$N = __makeTemplateObject([""], [""])));
TextWrapper$4.defaultProps = {
    color: COLORS$1.BLUE,
    fontSize: 0,
};
var templateObject_1$19, templateObject_2$Z, templateObject_3$N;

var NowButton = function (_a) {
    var _b;
    var url = _a.url, _c = _a.type, type = _c === void 0 ? 'classic' : _c, GTMHandlerNowButton = _a.GTMHandlerNowButton;
    var t = useTranslation().t;
    var _d = __read(useAppConfig$1(), 5), expressPos = _d[0].expressPos, setAppContext = _d[4];
    var headerInfo = useSelector(function (state) { return state.headerData; }).data;
    // Don't render in case of expressPos=undefined|null|''
    if (!expressPos) {
        removeNowJourneyCookie$1();
        return null;
    }
    var expressDeliverySubTitle = ((_b = expressPos === null || expressPos === void 0 ? void 0 : expressPos.nextAvailableSlot) === null || _b === void 0 ? void 0 : _b.description) || t('expressDeliverySubTitle');
    var nowLinkData = (headerInfo || {}).now_quick_link;
    var _e = nowLinkData || {
        title: t('expressDeliveryTitle'),
        subtitle: expressDeliverySubTitle,
    }, _f = _e.title, title = _f === void 0 ? '' : _f, _g = _e.subtitle, subtitle = _g === void 0 ? '' : _g;
    return (React.createElement(NowButtonWrapper$1, { type: type, rel: "now_link", href: setAppContext(url), onClick: GTMHandlerNowButton, "data-testid": "header_NOW_badge" },
        React.createElement(IconWrapper$7, null,
            React.createElement(ShopNow, { size: "M", fill: "#0E5AA7" })),
        React.createElement(Flex, { flexDirection: "column" },
            React.createElement(TextWrapper$4, { fontWeight: 500 }, subtitle ? subtitle : expressDeliverySubTitle),
            React.createElement(TextWrapper$4, { fontSize: 1, fontWeight: 800 }, title ? title : t('expressDeliveryTitle')))));
};

var headerHeightProp$1 = { height: '56px' };
var Header$4 = CustomStyled$1(Box)(templateObject_1$1a || (templateObject_1$1a = __makeTemplateObject([""], [""])));
Header$4.defaultProps = __assign(__assign({}, headerHeightProp$1), { mt: [0, null, null, null, 2] });
var Search$1 = CustomStyled$1(Box)(templateObject_2$_ || (templateObject_2$_ = __makeTemplateObject(["\n  height: 48px;\n"], ["\n  height: 48px;\n"])));
Search$1.defaultProps = {
    display: [null, null, 'none'],
};
var Area$1 = CustomStyled$1(Box)(templateObject_3$O || (templateObject_3$O = __makeTemplateObject(["\n   ", ";\n\n  align-items: center;\n"], ["\n   ",
    ";\n\n  align-items: center;\n"])), function (props) {
    return !props.static
        ? "\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n   "
        : '';
});
Area$1.defaultProps = {
    bg: 'white',
    display: ['flex', null, null, null, 'none'],
    height: '40px',
    px: [3, 4],
};
var Nav$1 = CustomStyled$1(Box)(templateObject_4$G || (templateObject_4$G = __makeTemplateObject(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
Nav$1.defaultProps = {
    display: ['none', null, null, null, 'flex'],
    height: '50px',
};
var NavItem$1 = CustomStyled$1(Box)(templateObject_5$x || (templateObject_5$x = __makeTemplateObject(["\n  height: 16px;\n  width: 100px;\n"], ["\n  height: 16px;\n  width: 100px;\n"])));
NavItem$1.defaultProps = {
    variant: 'skeletonSquare',
    mx: '12px',
};
var templateObject_1$1a, templateObject_2$_, templateObject_3$O, templateObject_4$G, templateObject_5$x;

var MenuNavigationMainContainer$1 = CustomStyled$1.div(templateObject_1$1b || (templateObject_1$1b = __makeTemplateObject(["\n  background-color: ", ";\n  transition: 0.1s all;\n  position: relative;\n  z-index: 1;\n\n  position: relative;\n  z-index: -1;\n  padding: 0px 16px;\n  @media (min-width: ", ") {\n    min-height: 46px;\n  }\n"], ["\n  background-color: ", ";\n  transition: 0.1s all;\n  position: relative;\n  z-index: 1;\n\n  position: relative;\n  z-index: -1;\n  padding: 0px 16px;\n  @media (min-width: ", ") {\n    min-height: 46px;\n  }\n"])), function (props) { return (props.isDesktopHeader ? COLORS$1.ANCHOR_BLUE : COLORS$1.WHITE); }, function (props) { return props.theme.breakpoints[3]; });
var MenuNavigationWrapper$1 = CustomStyled$1.div(templateObject_2$$ || (templateObject_2$$ = __makeTemplateObject(["\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  overflow-x: auto;\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  // #AHN-1274\n  html[dir=\"rtl\"] & [data-testid=\"trolly-text\"] {\n    font-size: 12px;\n  },\n"], ["\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  overflow-x: auto;\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  // #AHN-1274\n  html[dir=\"rtl\"] & [data-testid=\"trolly-text\"] {\n    font-size: 12px;\n  },\n"])));
var MenuNavigationContainer$1 = CustomStyled$1(Nav$1)(templateObject_3$P || (templateObject_3$P = __makeTemplateObject(["\n  flex-wrap: wrap;\n  height: auto;\n  max-width: 1440px;\n  margin: 0 auto;\n  justify-content: space-between;\n  position: relative;\n  background-color: ", ";\n"], ["\n  flex-wrap: wrap;\n  height: auto;\n  max-width: 1440px;\n  margin: 0 auto;\n  justify-content: space-between;\n  position: relative;\n  background-color: ", ";\n"])), function (props) { return !props.isDesktopHeader && COLORS$1.WHITE; });
var MenuNavigationItem$1 = CustomStyled$1(Flex)(templateObject_4$H || (templateObject_4$H = __makeTemplateObject(["\n  ", ";\n  flex-direction: column;\n  background-color: ", ";\n  transition: all .3s ease;\n  position: relative;\n  min-width: unset;\n  background-color:  ", ";\n\n  :after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    width: ", ";\n    background-color: ", ";\n    transition: .3s;\n    margin: auto;\n  }\n  \n"], ["\n  ", ";\n  flex-direction: column;\n  background-color: ", ";\n  transition: all .3s ease;\n  position: relative;\n  min-width: unset;\n  background-color:  ", ";\n\n  :after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    width: ", ";\n    background-color: ", ";\n    transition: .3s;\n    margin: auto;\n  }\n  \n"])), margin, function (props) { return (props.isHover && !props.isDesktopHeader ? COLORS$1.BODY : COLORS$1.WHITE); }, function (props) { return props.isDesktopHeader && COLORS$1.BLUE; }, function (props) { return (props.isHover ? '100%' : '0px'); }, function (props) { return (props.isDesktopHeader ? COLORS$1.WHITE : COLORS$1.BLUE); });
var MenuNavigationLink$1 = CustomStyled$1.a(templateObject_5$y || (templateObject_5$y = __makeTemplateObject(["\n  ", "\n  cursor: pointer;\n  text-decoration: none;\n  text-transform: capitalize;\n  vertical-align: baseline;\n  display: inherit;\n  background: ", ";\n"], ["\n  ", "\n  cursor: pointer;\n  text-decoration: none;\n  text-transform: capitalize;\n  vertical-align: baseline;\n  display: inherit;\n  background: ", ";\n"])), padding, function (_a) {
    var isHover = _a.isHover, theme = _a.theme;
    return (isHover ? theme.colors.mercury : theme.colors.transparent);
});
var MenuNavigationText$1 = CustomStyled$1(Text)(templateObject_6$r || (templateObject_6$r = __makeTemplateObject(["\n  position: inherit;\n  text-overflow: ellipsis;\n  text-transform: capitalize;\n  font-size: 12px;\n  line-height: 15px;\n  white-space: nowrap;\n  transition: .5s all;\n\n  ", "\n"], ["\n  position: inherit;\n  text-overflow: ellipsis;\n  text-transform: capitalize;\n  font-size: 12px;\n  line-height: 15px;\n  white-space: nowrap;\n  transition: .5s all;\n\n  ",
    "\n"])), variant({
    prop: 'type',
    variants: {
        // START: visible header links
        mainMenu: {
            lineHeight: '15px',
            fontSize: '12px',
        },
        allCategories: {
            fontSize: '12px',
            fontWeight: 700,
        },
        deals: {
            fontSize: '12px',
            fontWeight: 700,
            color: COLORS$1.RED,
        },
        // END: visible header links
        menuTitle: {
            fontWeight: 500,
            padding: '12px 24px',
            // #AHN-1263
            'html[dir="rtl"] &': {
                fontWeight: 600,
            },
        },
        subMenuTitle: {
            padding: '4px 24px',
            maxWidth: '265px',
            ':hover': {
                color: COLORS$1.BLUE,
                fontWeight: 500,
            },
        },
        new: {
            '::after': {
                content: "\"New\"",
                color: COLORS$1.WHITE,
                background: COLORS$1.RED,
                fontSize: '10px',
                fontWeight: 500,
                position: 'absolute',
                padding: '2px 4px',
                top: '2px',
                borderRadius: '4px',
                marginLeft: '4px',
                zIndex: 8,
            },
            fontSize: '14px',
            fontWeight: 500,
            width: '105px',
        },
        allCategory: {
            padding: '8px 12px',
            fontSize: '12px',
            position: 'relative',
            lineHeight: '14px',
        },
    },
}));
var MenuNavigationSlot$1 = CustomStyled$1(Flex)(templateObject_7$p || (templateObject_7$p = __makeTemplateObject(["\n  background-color: ", ";\n  ", ";\n  flex-direction: row;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width:100%;\n  height: 650px;\n\n  :before {\n    content: \"\";\n    display: block;\n    position: fixed;\n    z-index: -1;\n    background: rgba(0,0,0,.5);\n    top: ", ";\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100vh;\n    pointer-events: none;\n    opacity: ", ";\n    transform: ", ";\n    transition-delay: .2s;\n    transition: opacity .3s ease;\n  }\n"], ["\n  background-color: ", ";\n  ", ";\n  flex-direction: row;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width:100%;\n  height: 650px;\n\n  :before {\n    content: \"\";\n    display: block;\n    position: fixed;\n    z-index: -1;\n    background: rgba(0,0,0,.5);\n    top: ", ";\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100vh;\n    pointer-events: none;\n    opacity: ", ";\n    transform: ", ";\n    transition-delay: .2s;\n    transition: opacity .3s ease;\n  }\n"])), COLORS$1.WHITE, background, function (props) { return (props.isDesktopHeader ? '158px' : '119px'); }, function (props) { return (props.isHover ? '1' : '0'); }, function (props) { return (props.isHover ? 'scale(1)' : 'scale(0)'); });
var MenuNavigationSlotItems$1 = CustomStyled$1.ul(templateObject_8$p || (templateObject_8$p = __makeTemplateObject(["\n  background-color: ", ";\n  display: ", ";\n  position: relative;\n  left: 0;\n  opacity: 1;\n  margin-bottom: 18px;\n  z-index: 1;\n  pointer-events: auto;\n  padding: 0;\n  border: 0;\n  flex: 1 1 75%;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  overflow: auto;\n  height: 100%;\n"], ["\n  background-color: ", ";\n  display: ", ";\n  position: relative;\n  left: 0;\n  opacity: 1;\n  margin-bottom: 18px;\n  z-index: 1;\n  pointer-events: auto;\n  padding: 0;\n  border: 0;\n  flex: 1 1 75%;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  overflow: auto;\n  height: 100%;\n"])), COLORS$1.WHITE, function (props) { return (props.isChild ? 'inline' : 'flex'); });
var MenuTextIconWrapper$1 = CustomStyled$1(Flex)(templateObject_9$n || (templateObject_9$n = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var isSeparator = _a.isSeparator;
    return isSeparator &&
        " border-right: 1px solid #E6E6E6;\n      padding-right: 10px;\n    ";
});
var MenuAllCategoriesItem$1 = CustomStyled$1.li(templateObject_10$m || (templateObject_10$m = __makeTemplateObject(["\n  font-size: 12px;\n  position: relative;\n  white-space: nowrap;\n  line-height: 14px;\n  list-style: none;\n  min-width: 230px;\n"], ["\n  font-size: 12px;\n  position: relative;\n  white-space: nowrap;\n  line-height: 14px;\n  list-style: none;\n  min-width: 230px;\n"])));
var MenuNavigationInnerItem$1 = CustomStyled$1.div(templateObject_11$i || (templateObject_11$i = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), COLORS$1.WHITE);
var SubMenuText$1 = CustomStyled$1(Text.Caption)(templateObject_12$h || (templateObject_12$h = __makeTemplateObject(["\n"], ["\n"])));
var AllCategoryWrapper$1 = CustomStyled$1.ul(templateObject_13$g || (templateObject_13$g = __makeTemplateObject(["\n  display: block;\n  background-color: ", ";\n  padding: 10px 0px;\n  flex: 1 1 25%;\n  height: 100%;\n  overflow-y: auto;\n"], ["\n  display: block;\n  background-color: ", ";\n  padding: 10px 0px;\n  flex: 1 1 25%;\n  height: 100%;\n  overflow-y: auto;\n"])), COLORS$1.BODY);
var QuickBuyLink$2 = CustomStyled$1(Flex)(templateObject_14$g || (templateObject_14$g = __makeTemplateObject(["\n  color: #E3870F;\n  align-items: center;\n  text-decoration: none;\n"], ["\n  color: #E3870F;\n  align-items: center;\n  text-decoration: none;\n"])));
QuickBuyLink$2.defaultProps = {
    as: 'a',
};
var IconWrapper$8 = CustomStyled$1(Flex)(templateObject_15$g || (templateObject_15$g = __makeTemplateObject(["\n  border-left: 1px solid #E6E6E6;\n  margin-right: 10px;\n  padding-left: 12px;\n"], ["\n  border-left: 1px solid #E6E6E6;\n  margin-right: 10px;\n  padding-left: 12px;\n"])));
var TextWrapper$5 = CustomStyled$1(Text)(templateObject_16$c || (templateObject_16$c = __makeTemplateObject([""], [""])));
TextWrapper$5.defaultProps = {
    color: '#E3870F',
    fontSize: 0,
    lineHeight: '15px',
};
var QuickLinks$1 = CustomStyled$1(Flex)(templateObject_17$c || (templateObject_17$c = __makeTemplateObject([""], [""])));
var AdBannerContainer$1 = CustomStyled$1.div(templateObject_18$a || (templateObject_18$a = __makeTemplateObject(["\n  padding-top: 10px;\n  padding-right: 10px;\n"], ["\n  padding-top: 10px;\n  padding-right: 10px;\n"])));
var MenuIconWrapper$1 = CustomStyled$1.span(templateObject_19$a || (templateObject_19$a = __makeTemplateObject(["\n  padding-top: 11px;  \n  background: ", ";\n"], ["\n  padding-top: 11px;  \n  background: ", ";\n"])), function (props) { return props.isDesktopHeader && COLORS$1.BLUE; });
var templateObject_1$1b, templateObject_2$$, templateObject_3$P, templateObject_4$H, templateObject_5$y, templateObject_6$r, templateObject_7$p, templateObject_8$p, templateObject_9$n, templateObject_10$m, templateObject_11$i, templateObject_12$h, templateObject_13$g, templateObject_14$g, templateObject_15$g, templateObject_16$c, templateObject_17$c, templateObject_18$a, templateObject_19$a;

var ALL = 'allCategories';
var DEALS = 'deals';
var NOW = 'now';
var mainMenu = 'mainMenu';
var NEW = 'new';
var CATEGORY_MENU = 'CATEGORY_MENU';
var menuTypes = {
    deals: DEALS,
    allCategories: ALL,
    newLabel: NEW,
};
var checkTextType = function (child) {
    return child ? menuTypes[child.styleAttribute] || mainMenu : mainMenu;
};
var isNow = function (child) {
    return child ? child.styleAttribute === NOW : false;
};
var getMenuType = function (child) {
    return isAllCategory(child) ? 'allMenu' : 'subMenu';
};
var isAllCategory = function (child) {
    return child ? child.styleAttribute === ALL : false;
};
var testIds = {
    allcategories: 'all_categories',
    deals: 'header_online_deals',
    bulksavings: 'header_bulk_savings',
};
var getDataTestId = function (linkText) {
    var testIdKey = linkText.replace(/\s/g, '').toLowerCase();
    return testIds[testIdKey] || 'category_level_1';
};
var getCatagoryId = function (url) {
    if (url === void 0) { url = ''; }
    if (!url) {
        return '';
    }
    var splitted = url.split('/');
    var index = splitted.length === 0 ? '' : splitted.length - 1;
    return splitted[index];
};

var AllCategoryMenuItem$1 = styled.div(templateObject_1$1c || (templateObject_1$1c = __makeTemplateObject(["\n  background: ", ";\n  margin: 0 -4%;\n"], ["\n  background: ", ";\n  margin: 0 -4%;\n"])), COLORS$1.BODY);
var AllCategoryLink$1 = styled.a(templateObject_2$10 || (templateObject_2$10 = __makeTemplateObject(["\n  padding: 20px 16px 20px 44px;\n  display: block;\n  text-decoration: none;\n"], ["\n  padding: 20px 16px 20px 44px;\n  display: block;\n  text-decoration: none;\n"])));
var templateObject_1$1c, templateObject_2$10;

// https://mafretail.atlassian.net/browse/AHN-1459
var useCtaUrl = function () {
    var _a = __read(useAppConfig$1(), 5), setAppContext = _a[4];
    return useCallback(function (url, ctaUrl) {
        if (ctaUrl && ctaUrl !== '#') {
            return setAppContext(ctaUrl);
        }
        if (url && url !== '#') {
            return setAppContext(url);
        }
        return url;
    }, [setAppContext]);
};

var AllCategoryMenu = function (_a) {
    var menuItems = _a.menuItems, parentItem = _a.parentItem, _b = _a.isChild, isChild = _b === void 0 ? false : _b, _c = _a.level, level = _c === void 0 ? 1 : _c;
    var getLink = useCtaUrl();
    var headerStyles = isChild ? { padding: '16px 32px' } : { padding: '16px' };
    var dataTestId = "category_level_" + level++;
    return (React.createElement(React.Fragment, null, menuItems.map(function (items, index) {
        var hasChildren = items.children && items.children.length > 0;
        var linkText = items.name || items.title;
        return (React.createElement(React.Fragment, null,
            hasChildren === true && (React.createElement(Accordion, { allowMultiple: true, openCloseIcon: "plus-minus", headerStyles: __assign(__assign({}, headerStyles), { alignItems: 'center', justifyContent: 'space-between' }), containerStyles: { padding: 0 } },
                React.createElement("div", { key: linkText, "data-label": linkText, "data-testid": dataTestId },
                    React.createElement(AllCategoryMenu, { parentItem: items, menuItems: items.children, isChild: true, level: level })))),
            hasChildren === false && (React.createElement(AllCategoryMenuItem$1, null,
                React.createElement(AllCategoryLink$1, { rel: "all-category-item", href: getLink(items.url, items.ctaUrl), "data-testid": dataTestId },
                    React.createElement(Text, { fontWeight: 400 }, linkText)),
                index === menuItems.length - 1 && parentItem && (React.createElement(AllCategoryLink$1, { rel: "all-category-parent-item", href: getLink(parentItem.url, parentItem.ctaUrl) },
                    React.createElement(Text, { color: COLORS$1.BLUE, fontWeight: 400 },
                        "Shop All ",
                        parentItem.name || parentItem.title)))))));
    })));
};

var MenuButton$1 = styled.button(templateObject_1$1d || (templateObject_1$1d = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n\n  background: rgba(255, 255, 255, 0.2);\n  border: 0;\n  padding: 0;\n\n  i {\n    margin: 0 4px;\n    &,\n    &:before,\n    &:after {\n      background: ", ";\n      display: block;\n      height: 2px;\n    }\n\n    &:before,\n    &:after {\n      content: '';\n      margin-top: -1px;\n    }\n\n    &:before {\n      transform: translate3d(0, -6px, 0);\n    }\n\n    &:after {\n      transform: translate3d(0, 5px, 0);\n    }\n  }\n"], ["\n  height: ", ";\n  width: ", ";\n\n  background: rgba(255, 255, 255, 0.2);\n  border: 0;\n  padding: 0;\n\n  i {\n    margin: 0 4px;\n    &,\n    &:before,\n    &:after {\n      background: ", ";\n      display: block;\n      height: 2px;\n    }\n\n    &:before,\n    &:after {\n      content: '';\n      margin-top: -1px;\n    }\n\n    &:before {\n      transform: translate3d(0, -6px, 0);\n    }\n\n    &:after {\n      transform: translate3d(0, 5px, 0);\n    }\n  }\n"])), SIZES$2.ICON_SIZE, SIZES$2.ICON_SIZE, COLORS$1.ANCHOR_BLUE);
var templateObject_1$1d;

var Container$c = CustomStyled$1(Box)(templateObject_1$1e || (templateObject_1$1e = __makeTemplateObject(["\n  flex-shrink: 0;\n"], ["\n  flex-shrink: 0;\n"])));
Container$c.defaultProps = {
    mr: 3,
    display: [null, null, null, null, 'none'],
};
var MenuButton$2 = function (props) { return (React.createElement(Container$c, __assign({}, props),
    React.createElement(MenuButton$1, null,
        React.createElement("i", null)))); };
var templateObject_1$1e;

var DRAWER_WIDTH_RESPONSIVE = [1, 1 / 2];

var FlexWrapper$1 = styled(Flex)(templateObject_1$1f || (templateObject_1$1f = __makeTemplateObject(["\n  cursor: pointer;\n  position: relative;\n  padding: 5px 0;\n"], ["\n  cursor: pointer;\n  position: relative;\n  padding: 5px 0;\n"])));
var Items$1 = styled(Flex)(templateObject_2$11 || (templateObject_2$11 = __makeTemplateObject(["\n  padding: 12px;\n  color: 'black';\n  cursor: pointer;\n\n  ", "\n  &:not(:first-child) {\n    border-top: 1px solid #f5f5f5;\n  }\n\n  > a span {\n    font-weight: 500;\n  }\n  &:hover {\n    span {\n      color: #0e5aa7;\n    }\n  }\n"], ["\n  padding: 12px;\n  color: 'black';\n  cursor: pointer;\n\n  ",
    "\n  &:not(:first-child) {\n    border-top: 1px solid #f5f5f5;\n  }\n\n  > a span {\n    font-weight: 500;\n  }\n  &:hover {\n    span {\n      color: #0e5aa7;\n    }\n  }\n"])), function (props) {
    return (props.active &&
        "\n      background-color: " + COLORS$1.LIGHT_GRAY + ";\n      ");
});
Items$1.defaultProps = {
    as: 'li',
};
var Link$3 = styled(Box)(templateObject_3$Q || (templateObject_3$Q = __makeTemplateObject(["\n  text-decoration: none;\n  padding: 8px;\n"], ["\n  text-decoration: none;\n  padding: 8px;\n"])));
Link$3.defaultProps = {
    as: 'a',
};
var LinkText$2 = styled(Box)(templateObject_4$I || (templateObject_4$I = __makeTemplateObject(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
LinkText$2.defaultProps = {
    as: 'span',
    fontSize: '13px',
    fontWeight: 5,
};
var templateObject_1$1f, templateObject_2$11, templateObject_3$Q, templateObject_4$I;

var SECONDARY_LANG$1 = {
    mafgeo: 'ka',
    mafuzb: 'uz',
    mafarm: 'hy',
};
var LanguageChange$2 = function (_a) {
    var _b = _a.isDrawer, isDrawer = _b === void 0 ? false : _b, isEN = _a.isEN, onLanguageChange = _a.onLanguageChange, rest = __rest(_a, ["isDrawer", "isEN", "onLanguageChange"]);
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _c = __read(useAppConfig$1(), 1), _d = _c[0], _e = _d.storeId, storeId = _e === void 0 ? '' : _e, _f = _d.language, language = _f === void 0 ? EN$1 : _f;
    var ref = useRef({
        languageSelectionPopupOpen: false,
        languageSelectionPopupOpenFn: function () { return null; },
    });
    var tooltipItems = useMemo(function () {
        var multiLang = Object.entries(countries$2[storeId.substring(3)] || []);
        return multiLang.map(function (arr) {
            var _a = __read(arr, 2), lang = _a[0], languageToggle = _a[1].languageToggle;
            return {
                text: languageToggle,
                value: lang,
            };
        });
    }, [storeId]);
    var currentLanguage = useMemo(function () {
        var _a;
        return (_a = tooltipItems.find(function (_a) {
            var value = _a.value;
            return value === language;
        })) === null || _a === void 0 ? void 0 : _a.text;
    }, [tooltipItems, language]);
    var MoreLinks = function () {
        return (React.createElement(React.Fragment, null, tooltipItems.map(function (_a) {
            var text = _a.text, value = _a.value;
            return (React.createElement(Items$1, { key: value, onClick: function () { return onClickHandler(value); }, active: text === currentLanguage },
                React.createElement(Link$3, null,
                    React.createElement(LinkText$2, { color: COLORS$1.BLACK, fontSize: 2 }, text))));
        })));
    };
    var onClickHandler = useCallback(function (value) {
        var language;
        if (value && ref.current.languageSelectionPopupOpen) {
            ref.current.languageSelectionPopupOpenFn(false);
            language = value;
        }
        else {
            language = isEN ? SECONDARY_LANG$1[storeId] || AR$1 : EN$1;
        }
        setStoreInfoCookie$1({ language: language });
        if (onLanguageChange) {
            onLanguageChange(language);
            return;
        }
        dispatch(setLanguageCode$1(language));
    }, [dispatch, isEN, onLanguageChange, storeId]);
    var props = __assign({ color: COLORS$1.ANCHOR_BLUE }, rest);
    return (React.createElement(Flex, { mr: 2, alignItems: "center" },
        tooltipItems.length <= 2 ? (React.createElement(Button$1, __assign({ fontWeight: 700, fontSize: isDrawer ? 2 : 1, onClick: onClickHandler, px: isDrawer ? 0 : 3, testid: "change_language", variant: "link", size: "CUSTOM" }, props), isBrowser$1() && t('language'))) : (React.createElement(Tooltip, { content: React.createElement(MoreLinks, null), cardProps: { style: { minWidth: 200, padding: 0, borderRadius: 5 } }, popupWrapperStyle: { zIndex: 9, right: 0, top: 25 }, 
            // onStateChange={(e) => console.log(e)}
            getCurrentStateMethod: function (value) {
                ref.current.languageSelectionPopupOpen = value;
            }, getChangeStateMethod: function (fn) {
                ref.current.languageSelectionPopupOpenFn = fn;
            }, tipPosition: 'end', tipPositionFromRight: language === 'ar' ? 145 : 0, isHoverDropdown: true, tipWidth: 5 },
            React.createElement(FlexWrapper$1, { alignItems: "center", mx: "2" },
                React.createElement(Box, { fontSize: 1, mx: "1" }, currentLanguage),
                React.createElement(ChevronDown, { size: "XS", fill: COLORS$1.WHITE })))),
        React.createElement(Divider$1, null)));
};
var LanguageChange$3 = memo(LanguageChange$2);

var getCurrencies = function () { return function (dispatch) {
    return dispatch({
        type: ECurrencies$3.GET_CURRENCIES,
        payload: {
            method: EApiMiddlewareMethod$3.GET,
            url: GET_CURRENCIES,
            isAbsUrl: true,
            onSuccess: function (data) {
                var currencies = data.currencies;
                dispatch({ type: ECurrencies$3.SET_CURRENCIES, payload: currencies });
            },
        },
    });
}; };

var ChangeCurrencyMobile$1 = styled(Flex)(templateObject_1$1g || (templateObject_1$1g = __makeTemplateObject(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
var ChangeCurrency$1 = styled(Flex)(templateObject_2$12 || (templateObject_2$12 = __makeTemplateObject(["\n  flex-direction: column;\n"], ["\n  flex-direction: column;\n"])));
ChangeCurrency$1.defaultProps = {};
var TooltipLabel$1 = styled(Box)(templateObject_3$R || (templateObject_3$R = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
TooltipLabel$1.defaultProps = {
    mr: 2,
};
var Label$1 = styled(Box)(templateObject_4$J || (templateObject_4$J = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
Label$1.defaultProps = {
    as: 'span',
    fontSize: 2,
    fontWeight: 4,
    color: 'copy',
    mr: 4,
};
var Item$2 = styled(Box)(templateObject_5$z || (templateObject_5$z = __makeTemplateObject([""], [""])));
Item$2.defaultProps = {
    as: 'span',
    fontSize: 2,
    fontWeight: 4,
    color: 'copy',
    pb: 3,
    mb: 3,
    sx: {
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'wildSand',
        '&:last-child': {
            border: 'none',
            mb: 0,
            pb: 0,
        },
    },
};
var templateObject_1$1g, templateObject_2$12, templateObject_3$R, templateObject_4$J, templateObject_5$z;

var ChangeCurrency$2 = function () {
    var _a = __read(useState(false), 2), isChecked = _a[0], setIsChecked = _a[1];
    var _b = __read(useAppConfig$1(), 6), currency = _b[0].currency, setCurrency = _b[5];
    var _c = __read(useState(currency), 2), selectedCurrency = _c[0], setSelectedCurrency = _c[1];
    var dispatch = useDispatch();
    useEffect(function () {
        dispatch(getCurrencies());
    }, [dispatch]);
    var t = useTranslation().t;
    var currencies = useSelector(function (state) { return state.currency; }).currencies;
    var isDesktop = useBreakpoints().isDesktop;
    var prevCurrency = usePrevious(currency);
    var _d = __read(useState(false), 2), setTooltipOpen = _d[1];
    var handleChange = useCallback(function (_a) {
        var current = _a.current;
        setSelectedCurrency(current.defaultValue);
        setIsChecked(!isChecked);
    }, [isChecked]);
    var onStateChange = function (value) {
        setTooltipOpen(value);
    };
    useEffect(function () {
        if (prevCurrency && prevCurrency !== selectedCurrency) {
            window.location.reload();
        }
    }, [selectedCurrency, prevCurrency]);
    useEffect(function () {
        if (selectedCurrency) {
            setCurrency(selectedCurrency);
            setStoreInfoCookie$1({ currency: selectedCurrency });
        }
    }, [selectedCurrency, setCurrency]);
    var CurrenciesList = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Item$2, null,
                React.createElement(RadioGroup, { onChange: handleChange, title: "", noCollapse: true, stacked: true }, currencies &&
                    currencies.map(function (_a) {
                        var isocode = _a.isocode;
                        return (React.createElement(RadioButton, { variant: "radio", checked: isocode === currency, name: "currency", value: isocode, key: isocode, p: 0 }, isocode));
                    })))));
    };
    return (React.createElement(Flex, { alignItems: "center", mr: [0, null, null, null, 2] },
        isDesktop ? (React.createElement(Tooltip, { content: React.createElement(CurrenciesList, null), cardProps: { style: { minWidth: 172, border: 0 } }, popupWrapperStyle: { zIndex: 9 }, onStateChange: onStateChange, testid: "currencies_list" },
            React.createElement(TooltipLabel$1, null, selectedCurrency))) : (React.createElement(ChangeCurrencyMobile$1, null,
            React.createElement(Label$1, null, t('currency')),
            React.createElement(RadioGroup, { onChange: handleChange, title: "", noCollapse: true, stacked: false }, currencies &&
                currencies.map(function (_a) {
                    var isocode = _a.isocode;
                    return (React.createElement(RadioButton, { variant: "radio", checked: isocode === currency, name: "currency", value: isocode, key: isocode }, isocode));
                })))),
        React.createElement(Divider$1, null)));
};

var QuickBuyLink$3 = CustomStyled$1(Flex)(templateObject_1$1h || (templateObject_1$1h = __makeTemplateObject(["\n  color: #E3870F;\n  align-items: center;\n  text-decoration: none;\n"], ["\n  color: #E3870F;\n  align-items: center;\n  text-decoration: none;\n"])));
QuickBuyLink$3.defaultProps = {
    as: 'a',
};
var IconWrapper$9 = CustomStyled$1(Flex)(templateObject_2$13 || (templateObject_2$13 = __makeTemplateObject(["\n  margin-right: 10px;\n  ", "\n"], ["\n  margin-right: 10px;\n  ",
    "\n"])), function (props) {
    return !props.isMobile &&
        "\n    border-left: 1px solid #E6E6E6;\n     padding-left: 12px;";
});
var TextWrapper$6 = CustomStyled$1(Text)(templateObject_3$S || (templateObject_3$S = __makeTemplateObject([""], [""])));
TextWrapper$6.defaultProps = {
    color: '#E3870F',
    fontSize: 0,
    lineHeight: '15px',
};
var templateObject_1$1h, templateObject_2$13, templateObject_3$S;

var QuickBuy = (function (_a) {
    var quickBuyLink = _a.quickBuyLink, _b = _a.GTMHandlerBuyAgain, GTMHandlerBuyAgain = _b === void 0 ? function () { return null; } : _b, isMobile = _a.isMobile;
    var t = useTranslation().t;
    return (React.createElement(QuickBuyLink$3, { href: quickBuyLink ? quickBuyLink : '/buyAgain', onClick: GTMHandlerBuyAgain },
        React.createElement(IconWrapper$9, { isMobile: isMobile },
            React.createElement(QuickBuy$1, { size: "M", fill: "#E3870F" })),
        React.createElement(Flex, { flexDirection: "column" },
            React.createElement(TextWrapper$6, { fontWeight: 500 }, t('Quick')),
            React.createElement(TextWrapper$6, { fontSize: 1, fontWeight: 800 }, t('buyAgain')))));
});

var DrawerLoggedInHeaderText$1 = styled(Text)(templateObject_1$1i || (templateObject_1$1i = __makeTemplateObject(["\n  font-weight: 400;\n  font-size: 14px;\n  color: #6b6b6b;\n  margin-left: 7px;\n"], ["\n  font-weight: 400;\n  font-size: 14px;\n  color: #6b6b6b;\n  margin-left: 7px;\n"])));
var DrawerLoggedInUserName$1 = styled(Text)(templateObject_2$14 || (templateObject_2$14 = __makeTemplateObject(["\n  font-weight: 500;\n  font-size: 14px;\n  color: #4d4d4d;\n"], ["\n  font-weight: 500;\n  font-size: 14px;\n  color: #4d4d4d;\n"])));
var IconWrapper$a = styled(Text)(templateObject_3$T || (templateObject_3$T = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n"])));
var Points$1 = styled(Text)(templateObject_4$K || (templateObject_4$K = __makeTemplateObject(["\n  font-size: 16px;\n  color: #4d4d4d;\n"], ["\n  font-size: 16px;\n  color: #4d4d4d;\n"])));
var templateObject_1$1i, templateObject_2$14, templateObject_3$T, templateObject_4$K;

var handleMenuOptionClick = function (linksTo, key) {
    if (linksTo instanceof Function) {
        linksTo(key);
    }
    else {
        window.location.assign(linksTo);
    }
};
var generateMenuOptions = function (_a) {
    var config = _a.config, index = _a.index, isUserLoggedIn = _a.isUserLoggedIn, navigations = _a.navigations, _b = _a.isUae, isUae = _b === void 0 ? false : _b, _c = _a.isLbn, isLbn = _c === void 0 ? false : _c, position = _a.position, phoneNo = _a.phoneNo, GTMEventCall = _a.GTMEventCall, totalPoints = _a.totalPoints;
    var key = config.key, styling = config.styling, title = config.title, requiresLogin = config.requiresLogin, linksTo = config.linksTo, icon = config.icon, pos = config.pos;
    if (position !== pos)
        return null;
    var isLastInList = navigations.length - 1 === index && isLbn;
    if (requiresLogin && !isUserLoggedIn) {
        return null;
    }
    var onMenuOptionClick = function () {
        GTMEventCall(GTMEvents$1.custom_event, {
            eventAction: GTMEventActions$1.header_interaction,
            eventLabel: i18next.t(title),
        });
        handleMenuOptionClick(linksTo, key);
    };
    var testID = "__test_" + key;
    var MenuIcon = icon;
    return (React.createElement(DrawerMenuOptionCell$1, { isLastInList: isLastInList, key: key, onClick: onMenuOptionClick, "data-testid": testID }, icon && isUae ? (React.createElement(IconWrapper$a, null,
        React.createElement("i", null,
            React.createElement(MenuIcon, { size: "CUSTOM", width: 74, height: 18 })),
        title === 'loyaltyPoints' && React.createElement(Points$1, null, totalPoints))) : (React.createElement(DrawerMenuOptionLabel$1, { optionStyle: styling },
        i18next.t(title),
        " ",
        title === constants$1.needhelp && phoneNo && "(" + phoneNo + ")"))));
};
var DrawerMenuContent = function (_a) {
    var _b = _a.isUserLoggedIn, isUserLoggedIn = _b === void 0 ? !!getUserTokenFromCookie$1() : _b, isDrawerOpen = _a.isDrawerOpen, setDrawerOpen = _a.setDrawerOpen, isLanguageChange = _a.isLanguageChange, onLanguageChange = _a.onLanguageChange, dealsMenu = _a.dealsMenu, phoneNumber = _a.phoneNumber, shopNowLink = _a.shopNowLink, quickBuyLink = _a.quickBuyLink;
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    var t = useTranslation().t;
    var menuFeed = useSelector(function (state) { return (__assign(__assign({}, state.userData), state.appMenu)); }).menuFeed;
    var _c = __read(useState(false), 2), isSubMenuOpen = _c[0], setSubMenuOpen = _c[1];
    var _d = __read(useState(), 2), selectedMenuItem = _d[0], setSelectedMenuItem = _d[1];
    var closeDrawer = function () { return setDrawerOpen(false); };
    var onBackHandler = function () { return setSubMenuOpen(false); };
    var triggerGTMHeaderInteraction = useCallback(function (title) {
        GTMEventCall(GTMEvents$1.custom_event, {
            eventAction: GTMEventActions$1.header_interaction,
            eventLabel: title,
        });
    }, [GTMEventCall]);
    var triggerGTMCategoryInteraction = useCallback(function (title) {
        GTMEventCall(GTMEvents$1.custom_event, {
            eventAction: GTMEventActions$1.category_interaction,
            eventLabel: title,
        });
    }, [GTMEventCall]);
    var onAllCategoryClick = useCallback(function (allCategory) { return function () {
        triggerGTMCategoryInteraction('allCategory');
        setSelectedMenuItem(allCategory);
        setSubMenuOpen(true);
    }; }, [triggerGTMCategoryInteraction]);
    // const onHeaderClick = (selectedKey: string) => {
    //   const { key, linksTo } = MenuHeader;
    //   if (key === selectedKey) {
    //     handleMenuOptionClick(linksTo, key);
    //   }
    // };
    var _e = __read(useAppConfig$1(), 1), _f = _e[0], expressPos = _f.expressPos, _g = _f.language, language = _g === void 0 ? '' : _g, _h = _f.storeId, storeId = _h === void 0 ? '' : _h, features = _f.features, customerCareNumber = _f.customerCareNumber;
    var _j = useSelector(function (state) { return state.userData; }).totalPoints, totalPoints = _j === void 0 ? '0.0' : _j;
    var navigations = DrawerMenuNavigations(features);
    var _k = __read(useMemo(function () { return [language === EN$1, storeId === 'mafuae']; }, [language, storeId]), 2), isEN = _k[0], isUae = _k[1];
    var anchor = useMemo(function () { return (isEN ? 'left' : 'right'); }, [isEN]);
    var _l = __read(useMemo(function () { return (isEN ? [ArrowLeft, RightArrow$2] : [RightArrow$2, ArrowLeft]); }, [isEN]), 2), backIcon = _l[0], allCategoryIcon = _l[1];
    var getLink = useCtaUrl();
    var BackIcon = backIcon;
    var AllCategoryIcon = allCategoryIcon;
    var phoneNo = phoneNumber || customerCareNumber;
    var userData = UserDataHook();
    var countryConfig = storeIds[storeId];
    return (React.createElement(Drawer, { anchor: anchor, contentStyles: { p: [0] }, isOpen: isDrawerOpen, width: DRAWER_WIDTH_RESPONSIVE },
        React.createElement(DrawerHeader$3, { type: "" + (isSubMenuOpen === true ? 'bodered' : '') },
            isSubMenuOpen === true && (React.createElement(Flex, { alignItems: "center", justifyContent: "space-between", onClick: onBackHandler },
                React.createElement(DrawerIconWrapper$1, { "data-testid": "back-icon" },
                    React.createElement(BackIcon, { size: "M" })),
                selectedMenuItem && React.createElement(Text, null, selectedMenuItem.name || selectedMenuItem.title))),
            isSubMenuOpen === false && (React.createElement(DrawerIconWrapper$1, { "data-testid": "close-icon", onClick: closeDrawer },
                React.createElement(Cross, { size: "M" })))),
        React.createElement(DrawerSubHeader$1, null,
            React.createElement(DrawerLoggedOutHeader, { css: "font-size" + (isEN ? TYPOGRAPHY$1.WEIGHT[500] : TYPOGRAPHY$1.WEIGHT[600]), extraStyleProps: { padding: SPACINGS$1[24] } }, !isUserLoggedIn ? (React.createElement(DrawerNavText$1, { isLogin: true, onClick: function () { return triggerGTMHeaderInteraction('login and register'); }, "data-testid": "__drawer_menu_logged_out_view__" }, t('login&register'))) : (React.createElement(Flex, { "data-testid": "__drawer_menu_logged_in_view__" },
                React.createElement(DrawerLoggedInHeaderText$1, null, t('hello')),
                "\u00A0",
                React.createElement(DrawerLoggedInUserName$1, null,
                    " ",
                    userData && userData.firstName)))),
            React.createElement(DrawerFixedHeaderSeparator$1, null)),
        React.createElement(DrawerMenuContainer$1, { isSubMenuOpen: isSubMenuOpen },
            React.createElement(DrawerContent$1, null,
                React.createElement(Flex, { px: 4, flexDirection: "column" }, navigations.map(function (config, index) {
                    return generateMenuOptions({
                        config: config,
                        index: index,
                        isUserLoggedIn: isUserLoggedIn,
                        navigations: navigations,
                        isUae: isUae,
                        position: 'top',
                        GTMEventCall: GTMEventCall,
                        totalPoints: totalPoints,
                    });
                })),
                isUserLoggedIn && React.createElement(DrawerHeaderSeparator$1, null),
                React.createElement(DrawerNavItem$1, { quickBuy: true, onClick: function () { return triggerGTMHeaderInteraction(constants$1.quickBuy); } },
                    React.createElement(QuickBuy, { quickBuyLink: quickBuyLink || MY_ACCOUNT_BUY_AGAIN_PAGE$1, isMobile: true })),
                React.createElement(DrawerItemSeparator$1, null),
                menuFeed &&
                    menuFeed.map(function (item, index) {
                        var _a;
                        if (!item)
                            return null;
                        var isNOW = isNow(item);
                        var linkText = item.name || item.title;
                        if (isNOW && expressPos) {
                            return (React.createElement(React.Fragment, null,
                                React.createElement(DrawerNavItem$1, { key: index, "data-label": item.name, href: item.url, "data-testid": getDataTestId(linkText), buyNow: true, onClick: function () { return triggerGTMHeaderInteraction(item.name); } },
                                    React.createElement(NowButton, { type: "mobileNav", url: shopNowLink || ((_a = countryConfig === null || countryConfig === void 0 ? void 0 : countryConfig.nowButton) === null || _a === void 0 ? void 0 : _a.url) || (item === null || item === void 0 ? void 0 : item.url) || '' })),
                                React.createElement(DrawerItemSeparator$1, null)));
                        }
                    }), dealsMenu === null || dealsMenu === void 0 ? void 0 :
                dealsMenu.links.map(function (item, index) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(DrawerNavItem$1, { "data-label": item.title, href: item.url, "data-testid": item.title, onClick: function () { return triggerGTMHeaderInteraction(item.title); } },
                            React.createElement(DrawerNavText$1, { isDeal: item.title === constants$1.deals }, item.title)),
                        (dealsMenu === null || dealsMenu === void 0 ? void 0 : dealsMenu.links.length) - 1 !== index && React.createElement(DrawerItemSeparator$1, null)));
                }),
                React.createElement(DrawerHeaderSeparator$1, null),
                (dealsMenu === null || dealsMenu === void 0 ? void 0 : dealsMenu.is_explore_more) &&
                    dealsMenu.more_links.map(function (item, index) {
                        return (React.createElement(React.Fragment, null,
                            React.createElement(DrawerNavItem$1, { "data-label": item.title, href: item.url, "data-testid": item.title, onClick: function () { return triggerGTMHeaderInteraction(item.title); } },
                                React.createElement(DrawerNavText$1, null, item.title)),
                            dealsMenu.more_links.length - 1 !== index ? React.createElement(DrawerItemSeparator$1, null) : React.createElement(DrawerHeaderSeparator$1, null)));
                    }),
                menuFeed &&
                    React.Children.toArray(menuFeed.map(function (item, index) {
                        if (!item)
                            return null;
                        var isNOW = isNow(item);
                        if (isNOW)
                            return null;
                        var textType = checkTextType(item);
                        var isAll = isAllCategory(item);
                        var linkText = item.name || item.title;
                        return (React.createElement(React.Fragment, null,
                            React.createElement(DrawerNavItem$1, { "data-label": item.name, href: getLink(item.url, item.ctaUrl), "data-testid": getDataTestId(linkText) }, isAll ? (React.createElement(Flex, { onClick: onAllCategoryClick(item), justifyContent: "space-between" },
                                React.createElement(Text, { fontWeight: 500 }, linkText),
                                React.createElement(AllCategoryIcon, { size: "XS" }))) : (React.createElement(MenuNavigationText$1, { fontWeight: 500, type: textType, onClick: function () { return triggerGTMCategoryInteraction(linkText); } },
                                React.createElement(DrawerNavText$1, null, linkText)))),
                            menuFeed.length - 1 !== index ? React.createElement(DrawerItemSeparator$1, null) : React.createElement(DrawerHeaderSeparator$1, null),
                            isAll && (React.createElement(AllCategoryContent$1, null,
                                React.createElement(AllCategoryMenu, { menuItems: item.children })))));
                    })),
                React.createElement(Flex, { pb: 50, px: 4, flexDirection: "column" },
                    navigations.map(function (config, index) {
                        return generateMenuOptions({
                            config: config,
                            index: index,
                            isUserLoggedIn: isUserLoggedIn,
                            navigations: navigations,
                            isUae: isUae,
                            position: 'bottom',
                            phoneNo: phoneNo,
                            GTMEventCall: GTMEventCall,
                        });
                    }),
                    storeId === 'maflbn' && (React.createElement(DrawerMenuOptionCell$1, null,
                        React.createElement(ChangeCurrency$2, null))),
                    isLanguageChange && (React.createElement(DrawerMenuOptionCell$1, null,
                        React.createElement(LanguageChange$3, { color: "copy", fontWeight: "500", isDrawer: true, isEN: isEN, onLanguageChange: onLanguageChange }))))))));
};
var DrawerMenu = function (props) {
    var _a = __read(useState(false), 2), isDrawerOpen = _a[0], setDrawerOpen = _a[1];
    var openDrawer = useCallback(function () { return setDrawerOpen(true); }, []);
    // FETCH MENU
    var dispatch = useDispatch();
    var _b = useSelector(function (_a) {
        var appConfig = _a.appConfig;
        return appConfig;
    }), areaCode = _b.areaCode, lang = _b.language;
    var isDesktop = useBreakpoints().isDesktop;
    var _c = getSelectedTabData$1(), _d = _c.selectedTabId, selectedTabId = _d === void 0 ? -1 : _d, serviceType = _c.serviceType, productType = _c.productType;
    useEffect(function () {
        if (isBrowser$1() && areaCode && lang && selectedTabId) {
            var headers = {};
            if (serviceType && productType) {
                headers = { intent: serviceType, productType: productType };
            }
            dispatch(getMenuNavigation({ areaCode: areaCode, lang: lang, isDesktop: isDesktop, headers: headers }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, areaCode, lang, isDesktop]);
    return (React.createElement(React.Fragment, null,
        React.createElement(MenuButton$2, { "data-testid": "drawer-menu-button", onClick: openDrawer }),
        isBrowser$1() && React.createElement(DrawerMenuContent, __assign({ isDrawerOpen: isDrawerOpen, setDrawerOpen: setDrawerOpen }, props))));
};

var Logo$4 = styled(Flex)(templateObject_1$1j || (templateObject_1$1j = __makeTemplateObject(["\n  flex-shrink: 0;\n"], ["\n  flex-shrink: 0;\n"])));
var MobileLogoWrapper$1 = CustomStyled$1(Box)(templateObject_2$15 || (templateObject_2$15 = __makeTemplateObject(["\n    display: none;\n    height: 35px;\n    width: 32px;\n\n    @media (max-width: ", ") {\n      display: block;\n    }\n"], ["\n    display: none;\n    height: 35px;\n    width: 32px;\n\n    @media (max-width: ", ") {\n      display: block;\n    }\n"])), function (props) { return props.theme.breakpoints[2]; });
var DesktopLogoWrapper$1 = CustomStyled$1(Box)(templateObject_3$U || (templateObject_3$U = __makeTemplateObject(["\n    display: block;\n\n    @media (max-width: ", ") {\n      display: none;\n    }\n"], ["\n    display: block;\n\n    @media (max-width: ", ") {\n      display: none;\n    }\n"])), function (props) { return props.theme.breakpoints[2]; });
Logo$4.defaultProps = {
    as: 'a',
    height: [null, null, null, '36px'],
    width: [null, null, null, '142px'],
    mr: [null, null, 4],
    mt: ['-2px', null, null, null],
    sx: {
        svg: {
            height: '100%',
            width: '100%',
        },
    },
};
var templateObject_1$1j, templateObject_2$15, templateObject_3$U;

var Logo$5 = function (_a) {
    var storeId = _a.storeId, _b = _a.fill, fill = _b === void 0 ? '#0e5aa7' : _b, language = _a.language, isNotEnableCache = _a.isNotEnableCache;
    return (React.createElement(Logo$4, { "data-testid": "carrefour_logo", href: isNotEnableCache ? '/' : "/" + storeId + "/" + language + "/" },
        React.createElement(MobileLogoWrapper$1, null,
            React.createElement(CarrefourNewLogoMobile, { storeId: storeId, size: "XL", fill: fill })),
        React.createElement(DesktopLogoWrapper$1, null,
            React.createElement(CarrefourNewLogo, { storeId: storeId, size: "XL", fill: fill }))));
};

var SearchBoxWrapper$1 = CustomStyled$1(Box)(templateObject_1$1k || (templateObject_1$1k = __makeTemplateObject(["\n  position: relative;\n  flex-grow: 1;\n  ", "\n"], ["\n  position: relative;\n  flex-grow: 1;\n  ",
    "\n"])), function (props) {
    return props.isSearchClicked &&
        "\n    margin-top: 8px;\n    margin-bottom: 8px;\n  ";
});
SearchBoxWrapper$1.defaultProps = {};
var SearchInputWrapper$1 = CustomStyled$1(Flex)(templateObject_2$16 || (templateObject_2$16 = __makeTemplateObject(["\n  position: relative;\n  animation: fade-in 0.2s ease-in-out;\n  border-radius: 4px;\n  height: inherit;\n  justify-content: space-between;\n  border-bottom-left-radius: 48px;\n  border-top-left-radius: 48px;\n  border-bottom-right-radius: 48px;\n  border-top-right-radius: 48px;\n  background-color: ", ";\n  align-items: center;\n"], ["\n  position: relative;\n  animation: fade-in 0.2s ease-in-out;\n  border-radius: 4px;\n  height: inherit;\n  justify-content: space-between;\n  border-bottom-left-radius: 48px;\n  border-top-left-radius: 48px;\n  border-bottom-right-radius: 48px;\n  border-top-right-radius: 48px;\n  background-color: ", ";\n  align-items: center;\n"])), function (props) { return props.theme.colors.wildSand; });
var SearchInput$1 = CustomStyled$1(Box)(templateObject_3$V || (templateObject_3$V = __makeTemplateObject(["\n  border: 0;\n  outline: none;\n  margin: 0;\n  padding: 11px 20px;\n  vertical-align: middle;\n  ", "\n  ", "\n  ", "\n  background: transparent;\n  font-size: 12px;\n  color: ", ";\n\n  height: 40px; // [Arabic] firefox & safari box height expanded fix\n  line-height: 26px; // [Arabic] safari text misaligned fix\n"], ["\n  border: 0;\n  outline: none;\n  margin: 0;\n  padding: 11px 20px;\n  vertical-align: middle;\n  ", "\n  ", "\n  ", "\n  background: transparent;\n  font-size: 12px;\n  color: ", ";\n\n  height: 40px; // [Arabic] firefox & safari box height expanded fix\n  line-height: 26px; // [Arabic] safari text misaligned fix\n"])), function (props) { return (props.isCompleteWidth ? 'width: 100%;' : 'width: 0;'); }, function (props) { return (props.isSSPEnabled ? 'cursor:pointer;' : 'cursor:auto;'); }, function (props) { return (props.isSSPEnabled ? 'caret-color:transparent;' : ''); }, function (props) { return props.theme.colors.blue; });
var SearchIconWrapper$1 = CustomStyled$1.a(templateObject_4$L || (templateObject_4$L = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  text-align: center;\n  cursor: pointer;\n  background: transparent;\n  border-bottom-right-radius: 48px;\n  border-top-right-radius: 48px;\n  padding-left: 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  text-align: center;\n  cursor: pointer;\n  background: transparent;\n  border-bottom-right-radius: 48px;\n  border-top-right-radius: 48px;\n  padding-left: 16px;\n"])));
var CloseIconWrapper$2 = CustomStyled$1.span(templateObject_5$A || (templateObject_5$A = __makeTemplateObject(["\n  width: 40px;\n  height: 40px;\n  text-align: center;\n  padding-top: 11px;\n  padding-bottom: 10px;\n  cursor: pointer;\n  position: absolute;\n  right: 10px;\n"], ["\n  width: 40px;\n  height: 40px;\n  text-align: center;\n  padding-top: 11px;\n  padding-bottom: 10px;\n  cursor: pointer;\n  position: absolute;\n  right: 10px;\n"])));
var templateObject_1$1k, templateObject_2$16, templateObject_3$V, templateObject_4$L, templateObject_5$A;

var FlyoutCard$1 = styled(Card)(templateObject_1$1l || (templateObject_1$1l = __makeTemplateObject(["\n  background: ", ";\n  list-style: none;\n  margin: 7px 0px !important;\n  padding: 0px;\n  overflow: auto;\n  z-index: 9;\n  max-height: 650px;\n\n  ", ";\n"], ["\n  background: ", ";\n  list-style: none;\n  margin: 7px 0px !important;\n  padding: 0px;\n  overflow: auto;\n  z-index: 9;\n  max-height: 650px;\n\n  ",
    ";\n"])), COLORS$1.WHITE, variant({
    prop: 'type',
    variants: {
        fullScreen: {
            position: 'fixed',
            width: '100%',
            zIndex: 999,
            margin: 0,
            left: 0,
            right: 0,
            marginTop: 13,
            maxHeight: 'none',
        },
        basic: {
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
        },
    },
}));
var FlyoutItemWrapper$1 = styled.li(templateObject_2$17 || (templateObject_2$17 = __makeTemplateObject(["\n  box-sizing: border-box;\n  padding: 8px 0px 0px 0px;\n"], ["\n  box-sizing: border-box;\n  padding: 8px 0px 0px 0px;\n"])));
var FlyoutItem$1 = styled(Text)(templateObject_3$W || (templateObject_3$W = __makeTemplateObject(["\n  font-weight: ", ";\n  animation: fade-in 0.2s ease-in;\n  background-color: ", ";\n  line-height: ", ";\n  padding: ", ";\n  background-color: ", ";\n  :hover {\n    background-color: rgba(14, 90, 167, 0.2);\n    text-decoration: none;\n    color: #0e5aa7;\n  }\n  strong {\n    font-weight: ", ";\n  }\n  font-size: ", ";\n  border: ", ";\n  border-radius: ", ";\n  margin-left: ", ";\n"], ["\n  font-weight: ", ";\n  animation: fade-in 0.2s ease-in;\n  background-color: ", ";\n  line-height: ", ";\n  padding: ", ";\n  background-color: ", ";\n  :hover {\n    background-color: rgba(14, 90, 167, 0.2);\n    text-decoration: none;\n    color: #0e5aa7;\n  }\n  strong {\n    font-weight: ", ";\n  }\n  font-size: ", ";\n  border: ", ";\n  border-radius: ", ";\n  margin-left: ", ";\n"])), TYPOGRAPHY$1.WEIGHT[400], COLORS$1.WHITE, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '40px' : '');
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '0px 8px' : '11px 32px');
}, function (_a) {
    var selected = _a.selected;
    return (selected ? 'rgba(14, 90, 167, 0.2)' : null);
}, TYPOGRAPHY$1.WEIGHT[600], function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '12px' : '14px');
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '1px solid #E6E6E6' : 'none');
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '6px' : 'none');
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '8px' : '0');
});
var FlyoutHeaderWrapper$1 = styled(Flex)(templateObject_4$M || (templateObject_4$M = __makeTemplateObject(["\n  flex-direction: row;\n  justify-content: space-between;\n"], ["\n  flex-direction: row;\n  justify-content: space-between;\n"])));
var FlyoutHeader$1 = styled(Text)(templateObject_5$B || (templateObject_5$B = __makeTemplateObject(["\n  font-weight: ", ";\n  opacity: ", ";\n  padding: ", ";\n  background-color: ", ";\n  text-transform: ", ";\n  color: ", ";\n"], ["\n  font-weight: ", ";\n  opacity: ", ";\n  padding: ", ";\n  background-color: ", ";\n  text-transform: ", ";\n  color: ", ";\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? TYPOGRAPHY$1.WEIGHT[700] : TYPOGRAPHY$1.WEIGHT[600]);
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 1 : 0.6);
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '16px' : '11px 32px');
}, COLORS$1.WHITE, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 'none' : 'uppercase');
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? COLORS$1.BLACK : COLORS$1.MINE_SHAFT);
});
var FlyoutClearAnchor$1 = styled.a(templateObject_6$s || (templateObject_6$s = __makeTemplateObject(["\n  text-decoration: none;\n  padding: 11px 32px;\n  color: ", ";\n  cursor: pointer;\n"], ["\n  text-decoration: none;\n  padding: 11px 32px;\n  color: ", ";\n  cursor: pointer;\n"])), COLORS$1.ANCHOR_BLUE);
var FlyoutItemAnchor$1 = styled.a(templateObject_7$q || (templateObject_7$q = __makeTemplateObject(["\n  text-decoration: none;\n  display: ", ";\n  margin-bottom: 8px;\n"], ["\n  text-decoration: none;\n  display: ", ";\n  margin-bottom: 8px;\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 'inline-block' : 'inline');
});
var StrongBlue$1 = styled.strong(templateObject_8$q || (templateObject_8$q = __makeTemplateObject(["\n  font-weight: ", ";\n  color: ", ";\n"], ["\n  font-weight: ", ";\n  color: ", ";\n"])), TYPOGRAPHY$1.WEIGHT[500], COLORS$1.BLUE);
var Separator$1 = styled.div(templateObject_9$o || (templateObject_9$o = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n  max-height: 1px;\n  margin-top: 8px;\n"], ["\n  border-top: 1px solid ", ";\n  max-height: 1px;\n  margin-top: 8px;\n"])), COLORS$1.MERCURY);
var VisitStoreBrand$1 = styled.text(templateObject_10$n || (templateObject_10$n = __makeTemplateObject(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: bold;\n  padding: 4px;\n  text-transform: uppercase;\n"], ["\n  color: ", ";\n  font-size: 14px;\n  font-weight: bold;\n  padding: 4px;\n  text-transform: uppercase;\n"])), COLORS$1.DARK_RED);
var FlyoutWrapper$1 = styled.div(templateObject_11$j || (templateObject_11$j = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '0 8px' : '0');
});
var templateObject_1$1l, templateObject_2$17, templateObject_3$W, templateObject_4$M, templateObject_5$B, templateObject_6$s, templateObject_7$q, templateObject_8$q, templateObject_9$o, templateObject_10$n, templateObject_11$j;

var useBaseLink = function () {
    var _a;
    var _b = __read(useAppConfig$1(), 1), _c = _b[0], language = _c.language, storeId = _c.storeId;
    var isNewListingPageEnabled = (_a = useFeature('flutter.listing_page.enabled')) === null || _a === void 0 ? void 0 : _a.on;
    return useMemo(function () { return "/" + storeId + "/" + language + (isNewListingPageEnabled ? '' : '/v4'); }, [
        isNewListingPageEnabled,
        language,
        storeId,
    ]);
};

var trendingSearch = function () {
    return {
        type: ESearchBoxTypes$1.GET_TRENDING_SEARCH,
        payload: {
            method: EApiMiddlewareMethod$3.GET,
            url: GET_TRENDING_SEARCH,
            onSuccess: trendingSearchSuccess,
            onFailure: trendingSearchFailure,
            apiVersion: 1,
            isAuthorized: false,
            isAbsUrl: false,
        },
    };
};
var fetchBannerDetails = function (dispatch) {
    var userId = getCustomCookie$1(constants$1 === null || constants$1 === void 0 ? void 0 : constants$1.rrUserId) || '';
    var visitorId = getCustomCookie$1(constants$1 === null || constants$1 === void 0 ? void 0 : constants$1.rrSessionId);
    return {
        type: ESearchBoxTypes$1.FETCH_BANNER_DETAILS,
        payload: {
            enableProgress: false,
            apiVersion: 1,
            headers: { visitorid: visitorId, userid: userId },
            onSuccess: function (_a) {
                var data = _a.data, meta = _a.meta;
                if ((meta === null || meta === void 0 ? void 0 : meta.statusCode) === 200)
                    dispatch(handleCriteoBannersResponse(data, true));
            },
            url: GET_BANNER_FOR_SNP,
        },
    };
};
var trendingSearchSuccess = function (payload) { return ({
    type: ESearchBoxTypes$1.GET_TRENDING_SEARCH_SUCCESS,
    payload: payload,
}); };
var trendingSearchFailure = function () { return ({
    type: ESearchBoxTypes$1.GET_TRENDING_SEARCH_FAILURE,
}); };
/**
 *
 * @param {string} query - search string need to be
 */
var autocomplete = function (query, params, sessionId, intentHeaders) {
    if (sessionId === void 0) { sessionId = ''; }
    var mafSessionId = overridesUserIdHeader$1(sessionId);
    return {
        type: ESearchBoxTypes$1.GET_AUTOCOMPLETE,
        payload: {
            headers: __assign(__assign({}, mafSessionId), intentHeaders),
            method: EApiMiddlewareMethod$3.GET,
            url: GET_AUTOCOMPLETE,
            onSuccess: autocompleteSuccess,
            onFailure: autocompleteError,
            params: __assign({ query: query }, params),
            // isAbsUrl: true,
            isAuthorized: false,
            apiVersion: 1,
        },
    };
};
var clearAutoComplete = function () { return ({
    type: ESearchBoxTypes$1.CLEAR_AUTOCOMPLETE,
}); };
var autocompleteError = function (error) { return ({
    type: ESearchBoxTypes$1.ERROR_AUTOCOMPLETE,
    payload: error,
}); };
var autocompleteSuccess = function (payload) {
    return {
        type: ESearchBoxTypes$1.SUCCESS_AUTOCOMPLETE,
        payload: payload.data,
    };
};

var FLYOUT_EVENTS = {
    OPEN: 'OPEN',
    CLOSE: 'CLOSE',
    ENTER: 'ENTER',
    UP: 'UP',
    DOWN: 'DOWN',
};
var navActions = {
    DOWN: function (currentIndex, maxIndex) { return (currentIndex >= maxIndex - 1 ? maxIndex - 1 : currentIndex + 1); },
    UP: function (currentIndex) { return (currentIndex !== 0 ? currentIndex - 1 : 0); },
};
var useFlyoutCtrl = function (searchItems, text, action, onAction, maxSearchHistoryResult) {
    var _a = __read(useState(-1), 2), currentIndex = _a[0], setCurrentIndex = _a[1];
    var _b = __read(useState(false), 2), isOpen = _b[0], setOpenState = _b[1];
    var _c = __read(useState(true), 2), shouldFetchBannerDetail = _c[0], setFetchBannerdetail = _c[1];
    var selectedTabId = useSelector(function (state) { return state.appConfig; }).selectedTabId;
    var dispatch = useDispatch();
    useEffect(function () {
        setOpenState(text ? true : false);
    }, [text]);
    var baseLink = useBaseLink();
    var isDesktop = useBreakpoints().isDesktop;
    useEffect(function () {
        var _a;
        var navActionCtrl = navActions[action];
        if (navActionCtrl) {
            var index = navActionCtrl(currentIndex, searchItems.length);
            setCurrentIndex(index);
            if (onAction) {
                onAction(searchItems[index]);
            }
        }
        if (action === FLYOUT_EVENTS.OPEN || action === FLYOUT_EVENTS.DOWN) {
            if (text === '' && shouldFetchBannerDetail && !isDesktop) {
                dispatch(fetchBannerDetails(dispatch));
                setFetchBannerdetail(false);
            }
            setOpenState(true);
        }
        else if (action === FLYOUT_EVENTS.ENTER) {
            if (text.trim().length > 0) {
                var currentItem = searchItems[currentIndex];
                var updatedItem = currentItem
                    ? currentItem.asg_text === text.trim()
                        ? currentItem.asg_text
                        : text.trim()
                    : text.trim();
                setSearchHistory(updatedItem, maxSearchHistoryResult || 5, selectedTabId);
                setSearchTypeCookie$1('search_native');
                var baseSearch = baseLink + "/search";
                var encodedText = escape(updatedItem);
                var updatedCatName = (currentItem && currentItem.asg_text_category && encodeStr$1(currentItem.asg_text_category)) || '';
                var href = currentItem && currentItem.asg_text_category
                    ? baseSearch + "?keyword=" + encodedText + "&catID=" + currentItem.asg_text_category_id + "&catName=" + updatedCatName
                    : baseSearch + "?keyword=" + encodedText;
                var brazeStringify = JSON.stringify({
                    event: BrazeEvents$1.search,
                    data: (_a = {},
                        _a[BrazeEvents$1.search_term] = toSnakeCase$3(text),
                        _a[BrazeEvents$1.search_type] = BrazeEvents$1.search_results,
                        _a),
                });
                localStorage.setItem('brazeData', brazeStringify);
                window.location.href = href;
            }
        }
        else if (action === FLYOUT_EVENTS.CLOSE) {
            setOpenState(false);
        }
        if (onAction && action) {
            onAction();
        }
    }, [
        action,
        searchItems,
        setCurrentIndex,
        currentIndex,
        maxSearchHistoryResult,
        onAction,
        text,
        baseLink,
        dispatch,
        shouldFetchBannerDetail,
        isDesktop,
        selectedTabId,
    ]);
    return {
        currentIndex: currentIndex,
        isOpen: isOpen,
        setOpenState: setOpenState,
    };
};

var AdBannerWrapper$1 = customStyled.div(templateObject_1$1m || (templateObject_1$1m = __makeTemplateObject(["\n    background-color: ", ";\n    ", ";\n"], ["\n    background-color: ", ";\n    ", ";\n"])), function (props) { return props.theme.colors.white; }, space);
var templateObject_1$1m;

var BANNER_TYPE$1;
(function (BANNER_TYPE) {
    BANNER_TYPE["HERO_BANNER"] = "hero-banner";
    BANNER_TYPE["MONETIZATION_BANNER"] = "monetisation-banner";
    BANNER_TYPE["TWO_IN_ONE"] = "2-in-1";
    BANNER_TYPE["SLIM_BANNER"] = "slim-hero-banner";
    BANNER_TYPE["MONETISAION_TWO"] = "monetisation-2";
})(BANNER_TYPE$1 || (BANNER_TYPE$1 = {}));
var ETrackingKind$1;
(function (ETrackingKind) {
    ETrackingKind["VIEW_TRACKING"] = "viewTrackingUrl";
    ETrackingKind["CLICK_TRACKING"] = "clickTrackingUrl";
    ETrackingKind["LOAD_TRACKING"] = "loadTrackingUrl";
})(ETrackingKind$1 || (ETrackingKind$1 = {}));

var _a$6;
var SIZES$3 = (_a$6 = {},
    _a$6[BANNER_TYPE$1.HERO_BANNER] = {
        mobile: [343, 110],
        tablet: [720, 360],
        desktop: [1232, 280],
    },
    _a$6[BANNER_TYPE$1.SLIM_BANNER] = {
        mobile: [343, 110],
        tablet: [720, 360],
        desktop: [1232, 280],
    },
    _a$6[BANNER_TYPE$1.MONETIZATION_BANNER] = {
        mobile: [328, 110],
        tablet: [720, 360],
        desktop: [1232, 196],
    },
    _a$6[BANNER_TYPE$1.TWO_IN_ONE] = {
        mobile: [320, 160],
        tablet: [],
        desktop: [608, 160],
    },
    _a$6[BANNER_TYPE$1.MONETISAION_TWO] = {
        mobile: [328, 110],
        tablet: [720, 360],
        desktop: [1232, 196],
    },
    _a$6);

var CriteoBannerImage$1 = customStyled.a(templateObject_1$1n || (templateObject_1$1n = __makeTemplateObject(["\n  display: flex;\n  position: absolute;\n  z-index: 3;\n  cursor: pointer;\n  ", ";\n  ", "\n  ", "\n"], ["\n  display: flex;\n  position: absolute;\n  z-index: 3;\n  cursor: pointer;\n  ", ";\n  ",
    "\n  ",
    "\n"])), space, function (props) {
    return [BANNER_TYPE$1.MONETIZATION_BANNER, BANNER_TYPE$1.MONETISAION_TWO].includes(props.bannerType) && "position: relative;";
}, function (props) {
    return props.bannerType === BANNER_TYPE$1.TWO_IN_ONE &&
        "\n      img, source {\n      height: " + SIZES$3[BANNER_TYPE$1.TWO_IN_ONE].desktop[1] + "px;\n      }\n    ";
});
var templateObject_1$1n;

var CriteoBanner = function (_a) {
    var _b;
    var bannerType = _a.bannerType, _c = _a.altText, altText = _c === void 0 ? '' : _c, placementId = _a.placementId;
    var bannerInfo = useSelector(function (state) {
        var _a, _b;
        return ((_b = (_a = state === null || state === void 0 ? void 0 : state.adtech) === null || _a === void 0 ? void 0 : _a.criteoBanners) === null || _b === void 0 ? void 0 : _b[placementId]) || {};
    });
    var clickTrackingUrl = bannerInfo.clickTrackingUrl, viewTrackingUrl = bannerInfo.viewTrackingUrl;
    var _d = __read(useInView({
        /* Optional options */
        threshold: 0,
        triggerOnce: true,
    }), 2), ref = _d[0], inView = _d[1];
    useEffect(function () {
        if (inView) {
            fetch(viewTrackingUrl);
        }
    }, [inView, viewTrackingUrl]);
    var handleClick = function () {
        fetch(clickTrackingUrl);
    };
    var size = SIZES$3[bannerType];
    var breakpoint = BREAKPOINTS$1[0];
    if ([BANNER_TYPE$1.MONETIZATION_BANNER].includes(bannerType)) {
        breakpoint = (_b = size === null || size === void 0 ? void 0 : size.mobile) === null || _b === void 0 ? void 0 : _b[0];
    }
    var _e = bannerInfo.desktop_background_image, desktop_background_image = _e === void 0 ? '' : _e, _f = bannerInfo.mobile_background_image, mobile_background_image = _f === void 0 ? '' : _f;
    var isDesktop = useBreakpoints().isDesktop;
    var showBanner = isDesktop ? !!desktop_background_image : !!mobile_background_image;
    return (showBanner && (React.createElement(CriteoBannerImage$1, { ref: ref, "data-testid": "criteo-banner-image-wrapper-" + placementId, key: "" + (isDesktop ? desktop_background_image : mobile_background_image), bannerType: bannerType, isRTL: false, onClick: handleClick, href: bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.redirect_url, target: bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.redirect_target },
        React.createElement("picture", null,
            React.createElement("source", { media: "(min-width: " + breakpoint + "px)", srcSet: desktop_background_image }),
            React.createElement("img", { src: mobile_background_image, alt: altText })))));
};

var SSP_BANNER_TYPE = {
    RECENT_SEARCH: 'recent-search',
    TRENDING_SEARCH: 'trending-search',
    ADS_BANNER: 'ads-banner',
};
var SSP_BANNER_PLACEMENT_ID_POSTFIX = '-ssp';

var defaultSSPConfig = [
    {
        banner_type: SSP_BANNER_TYPE.RECENT_SEARCH,
    },
    {
        banner_type: SSP_BANNER_TYPE.TRENDING_SEARCH,
    },
];
var useSSPConfig = function () { var _a; return ((_a = useFeature('ssp.ui_placements.config')) === null || _a === void 0 ? void 0 : _a.value) || defaultSSPConfig; };

var mapFormattedTerms = function (searchItems, text, t) {
    var isMobile = window.innerWidth < 576;
    var categoryStyle = {
        display: isMobile ? 'block' : 'inline',
        margintop: isMobile ? '6px' : 0,
    };
    return searchItems
        .filter(function (item) { return item.asg_text_type !== 'Brand'; })
        .map(function (item) {
        var updatedText = item.asg_text
            .toLowerCase()
            .split(text.toLowerCase())
            .map(function (el) {
            if (el !== '') {
                return "<strong>" + el + "</strong>";
            }
            else {
                return el;
            }
        })
            .join(text.toLowerCase()) + ' ';
        return __assign(__assign({}, item), { formattedTerms: (React.createElement(React.Fragment, null,
                React.createElement("span", { dangerouslySetInnerHTML: {
                        __html: updatedText,
                    } }),
                item.asg_text_category && (React.createElement("span", { style: categoryStyle },
                    t('searchBox.in'),
                    React.createElement("text", { style: { color: COLORS$1.BLUE, textTransform: 'capitalize' } },
                        "\u00A0",
                        item.asg_text_category))))) });
    });
};
var TrendingSearch = function (_a) {
    var onClickHandler = _a.onClickHandler, trendingSearchResult = _a.trendingSearchResult;
    var t = useTranslation().t;
    var baseLink = useBaseLink();
    var isMobile = window.innerWidth < 576;
    return (React.createElement(React.Fragment, null,
        React.createElement(FlyoutHeader$1, { color: COLORS$1.MINE_SHAFT, isMobile: isMobile }, t('trendingSearch')),
        React.createElement(FlyoutWrapper$1, { isMobile: isMobile }, trendingSearchResult.map(function (trending) {
            var encodedText = escape(trending.searchTerm);
            return (React.createElement(FlyoutItemAnchor$1, { key: trending.searchTerm, "data-testid": "flyout-item-link", rel: "search", href: baseLink + "/search?keyword=" + encodedText, onClick: onClickHandler(encodedText, 'trending_search'), color: COLORS$1.MINE_SHAFT, isMobile: isMobile },
                React.createElement(FlyoutItem$1, { "data-testid": "flyout-item-trending-search", isMobile: isMobile }, trending.searchTerm)));
        }))));
};
var SearchHistory = function (_a) {
    var onClickHandler = _a.onClickHandler, searchHistoryResult = _a.searchHistoryResult, onClearHandler = _a.onClearHandler;
    var t = useTranslation().t;
    var baseLink = useBaseLink();
    var isMobile = window.innerWidth < 576;
    return (React.createElement(React.Fragment, null,
        React.createElement(FlyoutHeaderWrapper$1, null,
            React.createElement(FlyoutHeader$1, { color: COLORS$1.MINE_SHAFT, isMobile: isMobile }, t('searchHistory')),
            React.createElement(FlyoutClearAnchor$1, { onClick: onClearHandler }, t('searchBox.clear'))),
        React.createElement(FlyoutWrapper$1, { isMobile: isMobile }, searchHistoryResult.map(function (searchTerm) {
            var encodedText = escape(searchTerm);
            return (React.createElement(FlyoutItemAnchor$1, { key: searchTerm, "data-testid": "flyout-item-link", rel: "search", href: baseLink + "/search?keyword=" + encodedText, onClick: onClickHandler(searchTerm, 'search_history'), color: COLORS$1.MINE_SHAFT, isMobile: isMobile },
                React.createElement(FlyoutItem$1, { "data-testid": "flyout-item-search-history", isMobile: isMobile }, searchTerm)));
        }))));
};
var FlyoutList = function (_a) {
    var _b = _a.searchItems, searchItems = _b === void 0 ? [] : _b, _c = _a.text, text = _c === void 0 ? '' : _c, _d = _a.action, action = _d === void 0 ? '' : _d, onAction = _a.onAction, onHover = _a.onHover, maxSearchHistoryResult = _a.maxSearchHistoryResult, _e = _a.type, type = _e === void 0 ? 'basic' : _e;
    var isDesktop = useBreakpoints().isDesktop;
    var flyOutRef = useRef(null);
    var t = useTranslation().t;
    var _f = useSelector(function (state) { return state.searchBox; }).trendingSearch, trendingSearch = _f === void 0 ? [] : _f;
    var selectedTabId = useSelector(function (state) { return state.appConfig; }).selectedTabId;
    var SSP_Config = useSSPConfig();
    var searchHistory = getSearchHistory(selectedTabId);
    var _g = __read(useState(searchHistory), 2), searchHistoryResult = _g[0], setSearchHistoryResult = _g[1];
    useEffect(function () {
        if (selectedTabId && !isEqualArray(searchHistory, searchHistoryResult)) {
            setSearchHistoryResult(searchHistory);
        }
    }, [selectedTabId, searchHistory, searchHistoryResult]);
    var onClearHandler = function () {
        setSearchHistoryResult([]);
        clearSearchHistory(selectedTabId);
    };
    var onItemClick = useCallback(function (terms, searchType) {
        if (searchType === void 0) { searchType = BrazeEvents$1.search_results; }
        return function () {
            var _a;
            var brazeStringify = JSON.stringify({
                event: BrazeEvents$1.search,
                data: (_a = {},
                    _a[BrazeEvents$1.search_term] = toSnakeCase$3(terms),
                    _a[BrazeEvents$1.search_type] = searchType === 'search_history' ? BrazeEvents$1.history_search : searchType,
                    _a),
            });
            localStorage.setItem('brazeData', brazeStringify);
            setSearchHistory(terms, maxSearchHistoryResult || 5, selectedTabId);
            setSearchTypeCookie$1(searchType);
        };
    }, [maxSearchHistoryResult, selectedTabId]);
    var formattedSearchItems = useMemo(function () {
        var _a;
        var formatted = mapFormattedTerms(searchItems, text, t);
        var lastAutosuggest = searchItems[searchItems.length - 1];
        var isBrand = lastAutosuggest && ((_a = lastAutosuggest.asg_text_type) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'brand' ? true : false;
        var formattedTerms = searchItems.length > 0 && isBrand ? (React.createElement("span", null,
            t('searchBox.visit'),
            React.createElement(VisitStoreBrand$1, { "data-testid": "visit-store" }, lastAutosuggest.asg_text),
            t('searchBox.store'))) : (React.createElement("span", null,
            t('searchBox.viewAll'),
            " ",
            React.createElement("strong", { style: { color: COLORS$1.BLUE } },
                "\"",
                text,
                "\"")));
        formatted.push({
            formattedTerms: formattedTerms,
            asg_docId: isBrand ? lastAutosuggest.asg_docId : 'ViewAll',
            asg_text: isBrand ? lastAutosuggest.asg_text : text,
            asg_text_type: isBrand ? 'Brand' : '',
            asg_brand_id: isBrand ? lastAutosuggest.asg_brand_id : '',
        });
        return formatted;
    }, [searchItems, text, t]);
    var _h = useFlyoutCtrl(formattedSearchItems, text, action, onAction, maxSearchHistoryResult), currentIndex = _h.currentIndex, isOpen = _h.isOpen, setOpenState = _h.setOpenState;
    var baseLink = useBaseLink();
    var renderFlayoutItem = useCallback(function (item, index) {
        var encodedText = escape(item.asg_text);
        var encodeCatName = (item.asg_text_category && encodeStr$1(item.asg_text_category)) || '';
        return (React.createElement(React.Fragment, null,
            item.asg_text === 'ViewAll' && React.createElement(Separator$1, null),
            React.createElement(FlyoutItemAnchor$1, { "data-testid": "flyout-item-link", key: "" + item.asg_text + index, rel: "search", href: item.asg_text_type === 'Brand'
                    ? baseLink + "/c/" + item.asg_brand_id
                    : item.asg_text_category
                        ? baseLink + "/search?keyword=" + encodedText + "&catID=" + item.asg_text_category_id + "&catName=" + encodeCatName
                        : baseLink + "/search?keyword=" + encodedText, onClick: onItemClick(item.asg_text), onMouseEnter: onHover(item) },
                React.createElement(FlyoutItem$1, { selected: currentIndex === index, "data-testid": "flyout-item-text" }, item.formattedTerms))));
    }, [baseLink, onItemClick, onHover, currentIndex]);
    var getComponentForSSp = function (banner_type, placement_id) {
        switch (banner_type) {
            case SSP_BANNER_TYPE.RECENT_SEARCH:
                if (searchHistoryResult.length > 0)
                    return (React.createElement(SearchHistory, { onClearHandler: onClearHandler, searchHistoryResult: searchHistoryResult, onClickHandler: onItemClick }));
                break;
            case SSP_BANNER_TYPE.TRENDING_SEARCH:
                if ((trendingSearch === null || trendingSearch === void 0 ? void 0 : trendingSearch.length) > 0)
                    return React.createElement(TrendingSearch, { trendingSearchResult: trendingSearch, onClickHandler: onItemClick });
                break;
            case SSP_BANNER_TYPE.ADS_BANNER:
                if (!isDesktop)
                    return (React.createElement(Flex, { my: 16, justifyContent: "center" },
                        React.createElement(AdBannerWrapper$1, null,
                            React.createElement(CriteoBanner, { bannerType: BANNER_TYPE$1.MONETISAION_TWO, placementId: placement_id + SSP_BANNER_PLACEMENT_ID_POSTFIX }))));
                break;
            // do nothing
        }
    };
    useLayoutEffect(function () {
        window.addEventListener('click', function (event) {
            // @ts-ignore
            if (flyOutRef.current && !flyOutRef.current.parentElement.contains(event.target)) {
                setOpenState(false);
            }
            localStorage.removeItem('saved_card');
        });
        return function () {
            window.removeEventListener('click', function () {
                setOpenState(false);
            });
        };
    }, [setOpenState]);
    if (!isOpen) {
        return null;
    }
    return (React.createElement(FlyoutCard$1, { type: type, height: type === 'fullScreen' ? window.innerHeight : 'auto', testid: "flyout-card", ref: flyOutRef, elevation: 1, as: "ul" }, text.trim() === ''
        ? SSP_Config.map(function (_a) {
            var _b = _a.banner_type, banner_type = _b === void 0 ? '' : _b, _c = _a.placement_id, placement_id = _c === void 0 ? '' : _c;
            return getComponentForSSp(banner_type, placement_id);
        })
        : formattedSearchItems.length !== 0 && (React.createElement(FlyoutItemWrapper$1, { "data-testid": "flyout-item-wrapper" }, formattedSearchItems.map(renderFlayoutItem)))));
};

var AnimationWrapper$1 = customStyled.div(templateObject_1$1o || (templateObject_1$1o = __makeTemplateObject(["\n  overflow: hidden;\n  height: 20px;\n  position: relative;\n  width: 100%;\n  margin-left: 10px;\n"], ["\n  overflow: hidden;\n  height: 20px;\n  position: relative;\n  width: 100%;\n  margin-left: 10px;\n"])));
var SearchForText$1 = customStyled.div(templateObject_2$18 || (templateObject_2$18 = __makeTemplateObject(["\n  color: #747474ff;\n  font-size: 14px;\n  line-height: 20px;\n"], ["\n  color: #747474ff;\n  font-size: 14px;\n  line-height: 20px;\n"])));
var ListContainer$1 = customStyled.div(templateObject_3$X || (templateObject_3$X = __makeTemplateObject(["\n  position: absolute;\n  left: ", "px;\n  top: 0;\n"], ["\n  position: absolute;\n  left: ", "px;\n  top: 0;\n"])), function (props) { return (props.language === 'ar' ? 50 : 76); });
var Item$3 = customStyled.div(templateObject_4$N || (templateObject_4$N = __makeTemplateObject(["\n  color: #747474ff;\n  font-size: 14px;\n  line-height: 20px;\n"], ["\n  color: #747474ff;\n  font-size: 14px;\n  line-height: 20px;\n"])));
var templateObject_1$1o, templateObject_2$18, templateObject_3$X, templateObject_4$N;

var AnimatedSearchBar = function (_a) {
    var items = _a.items, _b = _a.animationDuration, animationDuration = _b === void 0 ? 0.74 : _b, _c = _a.displayDuration, displayDuration = _c === void 0 ? 0.8 : _c, _d = _a.prefix, prefix = _d === void 0 ? 'Search for' : _d, onClickHandler = _a.onClickHandler, language = _a.language;
    var delay = animationDuration;
    var duration = displayDuration;
    var totalDuration = (delay + duration) * 1000;
    var extendedItems = __spread(items, [items[0]]);
    var currentIndex = useRef(0);
    var animationFrameId = useRef(null);
    var lastTime = useRef(Date.now());
    var listContainerRef = useRef(null);
    var animate = function () {
        var now = Date.now();
        var deltaTime = now - lastTime.current;
        if (deltaTime >= totalDuration) {
            lastTime.current = now;
            currentIndex.current = (currentIndex.current + 1) % extendedItems.length;
            if (listContainerRef.current) {
                // Update the transition dynamically
                // @ts-ignore
                listContainerRef.current.style.transition = "transform " + (currentIndex.current === 0 ? 0.01 : delay) + "s cubic-bezier(0, 0.72, 0.23, 1.13)";
                // Then apply the transform
                // @ts-ignore
                listContainerRef.current.style.transform = "translateY(-" + currentIndex.current * 20 + "px)";
            }
        }
        // @ts-ignore
        animationFrameId.current = requestAnimationFrame(animate);
    };
    useEffect(function () {
        // @ts-ignore
        animationFrameId.current = requestAnimationFrame(animate);
        return function () {
            // @ts-ignore
            cancelAnimationFrame(animationFrameId.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(AnimationWrapper$1, { onClick: onClickHandler },
        React.createElement(SearchForText$1, null, prefix),
        React.createElement(ListContainer$1, { ref: listContainerRef, language: language }, extendedItems.map(function (item, index) {
            return (React.createElement(Item$3, { key: index },
                React.createElement("span", null,
                    "\"",
                    item,
                    "\"")));
        }))));
};

var callToActions = {
    13: 'ENTER',
    27: 'CLOSE',
    40: 'DOWN',
    38: 'UP',
};
var isFetchedOnce = false;
var SearchBox = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.isHidden, isHidden = _f === void 0 ? false : _f, type = _a.type, onClickHandler = _a.onClickHandler, _g = _a.maxSearchHistoryResult, maxSearchHistoryResult = _g === void 0 ? 5 : _g, isSearchClicked = _a.isSearchClicked, rest = __rest(_a, ["isHidden", "type", "onClickHandler", "maxSearchHistoryResult", "isSearchClicked"]);
    var t = useTranslation().t;
    var SSP_Config = useSSPConfig();
    var _h = __read(useState(''), 2), inputText = _h[0], setInputText = _h[1];
    var _j = __read(useState({ catID: '', catName: '' }), 2), categoryDetails = _j[0], setCategoryDetails = _j[1];
    var _k = __read(useState(''), 2), action = _k[0], setAction = _k[1];
    var _l = __read(useState(false), 2), isClickSearchInput = _l[0], setIsClickSearchInput = _l[1];
    var ref = useRef(null);
    var refInput = useRef(null);
    useOnClickOutside(ref, function () { return setIsClickSearchInput(false); });
    var dispatch = useDispatch();
    var state = useSelector(function (state) { return state; });
    var isNonFoodV2Enabled = useNonFoodV2Journey();
    var searchAnimate = !isNonFoodV2Enabled && ((_b = getGrowthBookFeatureValueViaInstance$1(state, 'search.animatetext.enabled')) === null || _b === void 0 ? void 0 : _b.value);
    var isSSPEnabled = (_c = useFeature('flutter.search_suggestion_page.enabled')) === null || _c === void 0 ? void 0 : _c.on;
    var href = isBrowser$1() ? window.location.href : '';
    var clearState = useCallback(function () {
        setInputText('');
        setCategoryDetails({ catID: '', catName: '' });
    }, [setInputText, setCategoryDetails]);
    var _m = useSelector(function (state) { return (__assign(__assign({}, state.searchBox), state.appConfig)); }), searchItems = _m.searchItems, isLoading = _m.isLoading, language = _m.language, currency = _m.currency, pageName = _m.pageName, _o = _m.sessionId, sessionId = _o === void 0 ? '' : _o, selectedTabId = _m.selectedTabId, storeId = _m.storeId;
    /**
     * Watch the localtion change, persist keyword when found in location or set empty.
     */
    useEffect(function () {
        if (isBrowser$1()) {
            var url = new URL(href);
            var keyword = url.searchParams.get('keyword');
            if (keyword) {
                setInputText(decodeStr$1(keyword));
            }
            else {
                setInputText('');
            }
            setAction('CLOSE');
        }
    }, [setAction, setInputText, href]);
    useEffect(function () {
        var shouldCallForTrendingSearch = SSP_Config.some(function (_a) {
            var banner_type = _a.banner_type;
            return banner_type === 'trending-search';
        });
        if (!isFetchedOnce && language && shouldCallForTrendingSearch) {
            dispatch(trendingSearch());
            isFetchedOnce = true;
        }
        return function () {
            clearState();
            dispatch(clearAutoComplete());
        };
    }, [clearState, dispatch, language, SSP_Config]);
    var intentHeaders = {};
    if (isNonFoodV2Enabled) {
        intentHeaders = getIntentAndServiceType$1((state === null || state === void 0 ? void 0 : state.pageStructure) || []);
    }
    var debounceInputCallback = useCallback(debounce$1(function (value) {
        if (value && language) {
            var _a = getGa4AlgoliaEventsParams$1(), experimentKey = _a.experimentKey, variationId = _a.variationId;
            if (variationId && experimentKey) {
                GTMEventCall(GTMEvents$1.algolia_custom_events, {
                    experiment_key: experimentKey,
                    variation_id: variationId,
                    pageData: { language: language, currency: currency },
                });
            }
            dispatch(autocomplete(encodeStr$1(value), { language: language }, sessionId, intentHeaders));
        }
    }, 250), [language]);
    var setInputCallBack = useCallback(function (event) {
        // because is will redirect to SSP page so we don't need to make it functional here
        if (isSSPEnabled) {
            return;
        }
        var value = event.target.value;
        setInputText(value);
        debounceInputCallback(value.trim());
        if (value.trim().length === 0) {
            dispatch(clearAutoComplete());
        }
    }, [debounceInputCallback, dispatch, isSSPEnabled]);
    var onKeyPressHandler = useCallback(function (event) {
        var keyCode = event.which || event.keyCode;
        if (keyCode) {
            var callAction = callToActions[keyCode];
            if (callAction) {
                event.preventDefault();
                setAction(callAction);
            }
        }
    }, [setAction]);
    /**
     * Runs on every action completion on flyout list.
     */
    var onActionHandler = useCallback(function (val) {
        if (val) {
            setInputText(val.asg_text);
            val.asg_text_category_id &&
                val.asg_text_category &&
                setCategoryDetails({ catID: val.asg_text_category_id, catName: encodeStr$1(val.asg_text_category) });
        }
        setAction('');
    }, [setAction]);
    /**
     * Runs on Search Icon button click event.
     */
    var setHoveredValue = useCallback(function (val) { return function () {
        if (val.asg_docId !== 'ViewAll') {
            setInputText(val.asg_text);
            setCategoryDetails({ catID: val.asg_text_category_id, catName: encodeStr$1(val.asg_text_category) });
        }
    }; }, [setInputText, setCategoryDetails]);
    var _p = useAnalytic$1(), GTMEventCall = _p.GTMEventCall, getGTMPageData = _p.getGTMPageData;
    var baseLink = useBaseLink();
    var onSearchButtonClick = useCallback(function () {
        var _a;
        var inputTextTrimmed = inputText.trim();
        if (isBrowser$1() && inputTextTrimmed.length > 0) {
            setSearchTypeCookie$1('search_native');
            var encodedText = escape(inputTextTrimmed);
            var _b = categoryDetails.catID, catID = _b === void 0 ? '' : _b, _c = categoryDetails.catName, catName = _c === void 0 ? '' : _c;
            var brazeStringify = JSON.stringify({
                event: BrazeEvents$1.search,
                data: (_a = {},
                    _a[BrazeEvents$1.search_term] = toSnakeCase$3(inputTextTrimmed),
                    _a[BrazeEvents$1.search_type] = BrazeEvents$1.search_results,
                    _a),
            });
            try {
                GTMEventCall(GTMEvents$1.now_journey_custom_events, {
                    eventAction: GTMEventActions$1.search_initiate,
                    eventLabel: GTMNowJourneyLabels$1.native_search,
                    event_type: GTMNowJourneyEventTypes$1.interaction,
                    journey_selection: getNowJourneyCookie$1() ? GTMNowJourneyLabels$1.now_items : GTMNowJourneyLabels$1.all_items,
                    pageData: getGTMPageData() || {},
                });
            }
            catch (error) {
                console.error(error);
            }
            localStorage.setItem('brazeData', brazeStringify);
            setSearchHistory(inputTextTrimmed, maxSearchHistoryResult, selectedTabId);
            window.location.href = catID
                ? baseLink + "/search?keyword=" + encodedText + "&catID=" + catID + "&catName=" + catName
                : baseLink + "/search?keyword=" + encodedText;
        }
    }, [inputText, categoryDetails, maxSearchHistoryResult, baseLink, GTMEventCall, getGTMPageData, selectedTabId]);
    var onClickCallback = useCallback(function () {
        var currentUrl = window.location.href;
        if (isSSPEnabled && !currentUrl.endsWith('/search') && !inputText) {
            window.location.href = window.location.origin + "/" + storeId + "/" + language + "/search";
        }
        setAction('OPEN');
        if (refInput === null || refInput === void 0 ? void 0 : refInput.current) {
            refInput.current.focus();
        }
        setIsClickSearchInput(true);
        if (inputText) {
            var _a = getGa4AlgoliaEventsParams$1(), experimentKey = _a.experimentKey, variationId = _a.variationId;
            if (variationId && experimentKey) {
                GTMEventCall(GTMEvents$1.algolia_custom_events, {
                    experiment_key: experimentKey,
                    variation_id: variationId,
                    pageData: { language: language, currency: currency },
                });
            }
            dispatch(autocomplete(inputText, { language: language }, sessionId, intentHeaders));
        }
        if (onClickHandler) {
            onClickHandler();
        }
    }, [
        isSSPEnabled,
        inputText,
        onClickHandler,
        storeId,
        language,
        dispatch,
        sessionId,
        intentHeaders,
        GTMEventCall,
        currency,
    ]);
    if (isHidden) {
        return null;
    }
    return (React.createElement(SearchBoxWrapper$1, __assign({ ref: ref, isSearchClicked: isSearchClicked, "data-testid": "search-box-wrapper" }, rest),
        React.createElement(SearchInputWrapper$1, null,
            React.createElement(SearchIconWrapper$1, { "data-testid": "header_search__button", id: pageName + "_search_btn", onClick: onSearchButtonClick },
                React.createElement(Search$2, { size: "S", fill: COLORS$1.GRAY_500 })),
            ((_d = searchAnimate === null || searchAnimate === void 0 ? void 0 : searchAnimate.categories) === null || _d === void 0 ? void 0 : _d.length) > 0 && !isClickSearchInput && !inputText && (React.createElement(AnimatedSearchBar, { onClickHandler: onClickCallback, items: searchAnimate === null || searchAnimate === void 0 ? void 0 : searchAnimate.categories, displayDuration: searchAnimate === null || searchAnimate === void 0 ? void 0 : searchAnimate.displayDuration, prefix: searchAnimate === null || searchAnimate === void 0 ? void 0 : searchAnimate.prefix, animationDuration: searchAnimate === null || searchAnimate === void 0 ? void 0 : searchAnimate.animationDuration, language: language })),
            React.createElement(SearchInput$1, { as: 'input', isSSPEnabled: isSSPEnabled, disable: isSSPEnabled, isCompleteWidth: ((_e = searchAnimate === null || searchAnimate === void 0 ? void 0 : searchAnimate.categories) === null || _e === void 0 ? void 0 : _e.length) > 0 && !inputText ? isClickSearchInput : true, ref: refInput, name: "inputText", value: inputText, "data-testid": "header_search__inp", id: pageName + "_search_input", isReadOnly: isSSPEnabled, type: "text", placeholder: isClickSearchInput || isNonFoodV2Enabled ? t("searchBox.newPlaceHolder") : '', onChange: setInputCallBack, onKeyDown: onKeyPressHandler, autoComplete: "off", onClick: onClickCallback }),
            inputText && (React.createElement(CloseIconWrapper$2, { "data-testid": "search-cross-icon", onClick: clearState },
                React.createElement(Cross, { size: "M", fill: COLORS$1.BLACK })))),
        isBrowser$1() && isLoading === false && !isSSPEnabled && (React.createElement(FlyoutList, { type: type, action: action, searchItems: searchItems, text: inputText, maxSearchHistoryResult: maxSearchHistoryResult, onAction: onActionHandler, onHover: setHoveredValue }))));
};

var useNonFoodV2Journey = function () {
    var _a;
    var _b = (((_a = useFeature(GROWTHBOOK_FLAGS$1.non_food_v2)) === null || _a === void 0 ? void 0 : _a.value) || {}).pageStructureUid, pageStructureUid = _b === void 0 ? '' : _b;
    return !!pageStructureUid || false;
};

var Container$d = CustomStyled$1(Box)(templateObject_1$1p || (templateObject_1$1p = __makeTemplateObject(["\n  align-items: center;\n  flex-grow: 1;\n\n  ", ";\n"], ["\n  align-items: center;\n  flex-grow: 1;\n\n  ",
    ";\n"])), function (props) {
    return props.isFullscreen
        ? "\n    position: fixed;\n    top: " + (props.isNonFoodV2Enabled ? '52px' : '0px') + ";\n    left: 0;\n    right: 0;\n    z-index: 1;\n    padding: 0 " + props.theme.space[3] + "px;\n    background-color: " + COLORS$1.WHITE + ";\n  "
        : '';
});
var Mobile = function (_a) {
    var _b = _a.isSearchClicked, isSearchClicked = _b === void 0 ? false : _b, _c = _a.isEN, isEN = _c === void 0 ? false : _c, onClickCallback = _a.onClickCallback, _d = _a.display, display = _d === void 0 ? ['flex', null, 'none'] : _d;
    var isNonFoodV2Enabled = useNonFoodV2Journey();
    return (React.createElement(Container$d, { display: display, isFullscreen: isSearchClicked, isNonFoodV2Enabled: isNonFoodV2Enabled },
        isSearchClicked && (React.createElement(Box, { as: "div", "data-testid": "back-arrow", css: "\n            transform: " + (isEN ? 'rotate(0deg)' : 'rotate(180deg)') + ";\n          ", mr: 16, onClick: onClickCallback(false) },
            React.createElement(BackArrow, { size: "M", fill: COLORS$1.ANCHOR_BLUE }))),
        React.createElement(SearchBox, { isSearchClicked: isSearchClicked, onClickHandler: onClickCallback(), type: "fullScreen" })));
};
var NonMobile = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Mobile, __assign({ display: ['none', null, 'flex', null, 'none'] }, props)),
        React.createElement(SearchBox, { onClickHandler: props.onClickCallback(), type: "basic", display: ['none', null, null, null, 'block'] })));
};
var templateObject_1$1p;

var Container$e = styled(Box)(templateObject_1$1q || (templateObject_1$1q = __makeTemplateObject(["\n  :last-of-type {\n    border: 0;\n  }\n  padding: 0px 24px;\n"], ["\n  :last-of-type {\n    border: 0;\n  }\n  padding: 0px 24px;\n"])));
Container$e.defaultProps = {
    as: 'li',
    sx: {
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'wildSand',
    },
};
var Link$4 = styled(Flex)(templateObject_2$19 || (templateObject_2$19 = __makeTemplateObject(["\n  align-items: center;\n  justify-content: space-between;\n  text-decoration: none;\n"], ["\n  align-items: center;\n  justify-content: space-between;\n  text-decoration: none;\n"])));
Link$4.defaultProps = {
    as: 'a',
    color: 'thundora',
    fontSize: 1,
    py: 2,
    sx: {
        '&:hover': {
            color: 'blue',
        },
    },
};
var LinkLoyalty$1 = styled(Link$4)(templateObject_3$Y || (templateObject_3$Y = __makeTemplateObject(["\n  position: relative;\n  color: rgb(37, 37, 37);\n"], ["\n  position: relative;\n  color: rgb(37, 37, 37);\n"])));
LinkLoyalty$1.defaultProps = {
    as: 'a',
    py: 1,
    px: 0,
    sx: {
        '&:hover': {
            color: 'blue',
        },
    },
};
var LoyaltyPoints$1 = styled(Box)(templateObject_4$O || (templateObject_4$O = __makeTemplateObject([""], [""])));
LoyaltyPoints$1.defaultProps = {
    color: 'mineShaft',
    fontSize: 1,
    fontWeight: 4,
    sx: {
        borderRadius: 1,
    },
};
var Caption$5 = styled(Box)(templateObject_5$C || (templateObject_5$C = __makeTemplateObject([""], [""])));
Caption$5.defaultProps = {
    color: 'doveGrey',
    fontSize: 0,
    fontWeight: 4,
    ml: 1,
};
var templateObject_1$1q, templateObject_2$19, templateObject_3$Y, templateObject_4$O, templateObject_5$C;

var LoyaltyPoints$2 = function () {
    var _a;
    // const { t } = useTranslation();
    var _b = __read(useAppConfig$1(), 4), appConfigState = _b[0];
    var _c = useSelector(function (state) { return state.userData; }), isLoyaltyFetched = _c.isLoyaltyFetched, _d = _c.totalPointsValue, totalPointsValue = _d === void 0 ? '0.0' : _d;
    var Icon = ((_a = appConfigState === null || appConfigState === void 0 ? void 0 : appConfigState.features) === null || _a === void 0 ? void 0 : _a.share) ? SharePointsProfile : MyClubLogo;
    return (React.createElement(Container$e, null,
        React.createElement(LinkLoyalty$1, { href: '/my-account/loyalty' },
            React.createElement(Icon, { size: "L", height: 22 }),
            React.createElement(LoyaltyPoints$1, { "data-testid": "loyalty-points" }, totalPointsValue),
            !isLoyaltyFetched && React.createElement(LinearProgress, { "data-testid": "loyalty-loader", position: "bottom", withBlock: false }))));
};

var UserButtonWrapper$1 = styled(Box)(templateObject_1$1r || (templateObject_1$1r = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  ", "\n"], ["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  ",
    "\n"])), function (props) {
    return props.isDesktopHeader &&
        "\n        margin: 4px 12px;\n        padding: 4px 12px !important;\n        height: 100%;\n        &:hover {\n          background: " + COLORS$1.BLUE_500 + ";\n          border-radius: 66px;\n        }\n    ";
});
UserButtonWrapper$1.defaultProps = {
    mb: ['1px', null, null, null, 0],
    // padding: '0 5px 0 8px',
    position: 'relative',
    padding: [null, null, null, '15px 11px 15px 16px'],
    minWidth: [null, null, null, '160px'],
    // mx: [3, null, null, null],
    mr: [3, null, null, null],
};
var UserButton$1 = styled(Flex)(templateObject_2$1a || (templateObject_2$1a = __makeTemplateObject(["\n  align-items: center;\n  margin: ", ";\n"], ["\n  align-items: center;\n  margin: ", ";\n"])), function (props) { return props.isDesktopHeader && '4px 12px'; });
var Wrapper$1 = styled(Flex)(templateObject_3$Z || (templateObject_3$Z = __makeTemplateObject(["\n  font-style: normal;\n"], ["\n  font-style: normal;\n"])));
Wrapper$1.defaultProps = {
    mx: 2,
    flexDirection: ['column', null, null, null, 'row'],
};
var Caption$6 = styled(Box)(templateObject_4$P || (templateObject_4$P = __makeTemplateObject(["\n  color: ", " !important;\n  margin-bottom: ", " !important;\n"], ["\n  color: ", " !important;\n  margin-bottom: ", " !important;\n"])), function (props) { return (props.isDesktopHeader ? COLORS$1.WHITE : COLORS$1.ANCHOR_BLUE); }, function (props) { return (props.isDesktopHeader ? '0' : '4px'); });
Caption$6.defaultProps = {
    as: 'span',
    fontSize: [1, null, null, null, 1],
    fontWeight: [3, null, null, null, 3],
    color: ['copy', null, null, null, COLORS$1.ANCHOR_BLUE],
    mb: [0, null, null, null, 1],
    mr: [1, null, null, null, 0],
};
var Username$1 = styled(Box)(templateObject_5$D || (templateObject_5$D = __makeTemplateObject(["\n  color: ", " !important;\n"], ["\n  color: ", " !important;\n"])), function (props) { return (props.isDesktopHeader ? COLORS$1.WHITE : COLORS$1.ANCHOR_BLUE); });
Username$1.defaultProps = {
    as: 'span',
    fontSize: 1,
    fontWeight: [3, null, null, null, 6],
    color: ['copy', null, null, null, COLORS$1.ANCHOR_BLUE],
};
var UserButtonLink$1 = styled(Box)(templateObject_6$t || (templateObject_6$t = __makeTemplateObject(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
UserButtonLink$1.defaultProps = {
    as: 'a',
    color: 'blue',
    fontSize: 1,
    fontWeight: 4,
    mt: 1,
};
var ListItem$1 = styled(Box)(templateObject_7$r || (templateObject_7$r = __makeTemplateObject(["\n  &:last-of-type {\n    border: none;\n  }\n  &:last-of-type a {\n    padding-bottom: 0;\n  }\n"], ["\n  &:last-of-type {\n    border: none;\n  }\n  &:last-of-type a {\n    padding-bottom: 0;\n  }\n"])));
ListItem$1.defaultProps = {
    as: 'li',
    fontWeight: 500,
    sx: {
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'wildSand',
    },
    py: '12px',
    px: 4,
};
var Link$5 = styled(Box)(templateObject_8$r || (templateObject_8$r = __makeTemplateObject(["\n  text-decoration: none;\n  display: block;\n"], ["\n  text-decoration: none;\n  display: block;\n"])));
Link$5.defaultProps = {
    py: 1,
    as: 'a',
    color: 'mineShaft',
    fontSize: 2,
    sx: {
        '&:hover': {
            color: 'blue',
        },
    },
};
var BadgeText$1 = styled.div(templateObject_9$p || (templateObject_9$p = __makeTemplateObject(["\n  font-family: Montserrat;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 12px;\n  text-align: center;\n  color: #ffffff;\n"], ["\n  font-family: Montserrat;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 12px;\n  text-align: center;\n  color: #ffffff;\n"])));
var UserButtonDiv$1 = styled(Box)(templateObject_10$o || (templateObject_10$o = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) {
    return props.isDesktopHeader &&
        "\n      margin: 4px 12px;\n      padding: 0px 12px;\n      &:hover {\n        background: " + COLORS$1.BLUE_500 + ";\n        border-radius: 66px;\n      }\n  ";
});
var templateObject_1$1r, templateObject_2$1a, templateObject_3$Z, templateObject_4$P, templateObject_5$D, templateObject_6$t, templateObject_7$r, templateObject_8$r, templateObject_9$p, templateObject_10$o;

var UserButtonDropdown = function () {
    var t = useTranslation().t;
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    // const { appboy } = window as any;
    var baseUrl = "/my-account";
    var logoutUrl = getCustomCookie$1('loginType') === 'social' ? '/api/auth/logout' : baseUrl + '/logout';
    var menuItems = function (t) { return [
        { title: t('myDashboard'), path: baseUrl },
        { title: t('myOrders'), path: NEW_ORDERS_PAGE },
        { title: t('buyAgain'), path: '/buyAgain' },
        // { title: t('notificationCenter'), path: baseUrl + '/notification-center' },
        { title: t('logout'), path: logoutUrl },
    ]; };
    var onMenuClick = function (path, title) {
        GTMEventCall(GTMEvents$1.custom_event, {
            eventAction: GTMEventActions$1.header_interaction,
            eventLabel: title,
        });
        // Manual Logout GMT Event log
        if (path.includes('/logout')) {
            try {
                removeNowJourneyCookie$1();
            }
            catch (error) {
                console.error(error);
            }
            var Analytics = new AnalyticsManager$1();
            var loggedInStatus = !!getUserTokenFromCookie$1()
                ? '1'
                : '0';
            var pageData = __assign({ selectedCity: (APP_CONFIG$1 === null || APP_CONFIG$1 === void 0 ? void 0 : APP_CONFIG$1.areaCode) ? APP_CONFIG$1 === null || APP_CONFIG$1 === void 0 ? void 0 : APP_CONFIG$1.areaCode.split(' - ')[1] : '', pageType: GTMEventActions$1.login, loggedInStatus: loggedInStatus }, APP_CONFIG$1);
            var gtmPageData = Analytics.getGTMPageData(pageData);
            Analytics.trackGTMEvent(GTMEvents$1.custom_event, {
                productState: {},
                otherData: {
                    eventAction: GTMEventActions$1.login,
                    eventLabel: 'logout_success|manual',
                    pageData: gtmPageData,
                },
            });
        }
        window.location.href = path;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(LoyaltyPoints$2, null),
        menuItems(t).map(function (_a) {
            var title = _a.title, path = _a.path;
            return (React.createElement(ListItem$1, { key: title },
                React.createElement(Link$5, { href: path, onClick: function () { return onMenuClick(path, title); } }, title)));
        })));
};

var displayProp = { display: ['block', null, null, null, 'block'] };
/* onClick of menuItems we aren't closing popup/toolip beacause of redirection at each item */
var LoggedInButton = function (_a) {
    var iconFill = _a.iconFill;
    var t = useTranslation().t;
    var _b = __read(useState(false), 2), setTooltipOpen = _b[1];
    var isDesktop = useBreakpoints().isDesktop;
    var isNonFoodV2Enabled = useNonFoodV2Journey();
    var isDesktopHeader = isNonFoodV2Enabled && isDesktop;
    var isProfileRevamp = useFeature('flutter.profile_revamp.enabled').on;
    var onStateChange = function (value) {
        setTooltipOpen(value);
    };
    var userData = useSelector(function (state) { return state; }).userData;
    if (!userData || !userData.firstName) {
        return null;
    }
    var onClickHandler = function () {
        window.location.href = isProfileRevamp ? PROFILE_PAGE$1 : '/my-account';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { display: ['none', 'none', 'none', 'block'] }, isProfileRevamp ? (React.createElement(UserButtonWrapper$1, { role: "button", "data-sl": "mask", isDesktopHeader: isDesktopHeader },
            React.createElement(UserButton$1, { onClick: onClickHandler, isDesktopHeader: isDesktopHeader },
                React.createElement(UserInverse, { size: "M", fill: iconFill }),
                isDesktop && (React.createElement(Wrapper$1, null,
                    React.createElement(Flex, { flexDirection: ['row', null, null, null, 'column'] },
                        React.createElement(Caption$6, { isDesktopHeader: isDesktopHeader }, t('welcome')),
                        React.createElement(Username$1, { "data-testid": "loggedIn_user", isDesktopHeader: isDesktopHeader },
                            userData.firstName,
                            " ",
                            userData.lastName))))))) : (React.createElement(Tooltip, { content: React.createElement(UserButtonDropdown, null), placement: APP_CONFIG$1.language === EN$1 ? 'bottom-end' : 'bottom-start', cardProps: { style: { minWidth: 240, padding: 0, paddingBottom: 12, paddingTop: 6, borderRadius: 5 } }, popupWrapperStyle: { zIndex: 99, right: 0, top: 52 }, onStateChange: onStateChange, testid: "myaccount_list", isHoverDropdown: true, closeOnScroll: true },
            React.createElement(UserButtonWrapper$1, { role: "button", "data-sl": "mask", isDesktopHeader: isDesktopHeader },
                React.createElement(UserButton$1, { onClick: onClickHandler, isDesktopHeader: isDesktopHeader },
                    React.createElement(UserInverse, { size: "M", fill: iconFill }),
                    isDesktop && (React.createElement(Wrapper$1, null,
                        React.createElement(Flex, { flexDirection: ['row', null, null, null, 'column'] },
                            React.createElement(Caption$6, { isDesktopHeader: isDesktopHeader }, t('welcome')),
                            React.createElement(Username$1, { "data-testid": "loggedIn_user", isDesktopHeader: isDesktopHeader },
                                userData.firstName,
                                " ",
                                userData.lastName))))))))),
        React.createElement(Box, { display: ['block', 'block', 'block', 'none'] },
            React.createElement(UserButtonWrapper$1, { role: "button", isDesktopHeader: isDesktopHeader },
                React.createElement(UserButton$1, { onClick: onClickHandler, isDesktopHeader: isDesktopHeader },
                    React.createElement(UserInverse, { size: "M", fill: iconFill }),
                    isDesktop && (React.createElement(Wrapper$1, null,
                        React.createElement(Flex, { flexDirection: ['row', null, null, null, 'column'] },
                            React.createElement(Caption$6, { isDesktopHeader: isDesktopHeader }, t('welcome')),
                            React.createElement(Username$1, { "data-testid": "loggedIn_user", isDesktopHeader: isDesktopHeader },
                                userData.firstName,
                                " ",
                                userData.lastName)))))))));
};
var LoginButton = function (_a) {
    var loginRedirection = _a.loginRedirection, onLoginClick = _a.onLoginClick, isSSR = _a.isSSR, isDesktopHeader = _a.isDesktopHeader;
    var t = useTranslation().t;
    var _b = __read(useAppConfig$1(), 1), language = _b[0].language;
    var url = '/login';
    if (!!loginRedirection) {
        url = addRedirection$1(url, loginRedirection);
    }
    var onLoginButtonClicked = function () {
        if (!!onLoginClick) {
            onLoginClick();
        }
    };
    return (React.createElement(UserButtonDiv$1, __assign({ as: "nav" }, displayProp, { "data-testid": "loginRegister", minWidth: ['auto', 'auto', 'auto', '160px'], isDesktopHeader: isDesktopHeader }), !isSSR && (React.createElement(IconButton$1, { as: "a", href: url, px: 3, onClick: onLoginButtonClicked, "data-testid": "header_login_register" },
        React.createElement(UserInverse, { size: "M", fill: isDesktopHeader ? COLORS$1.WHITE : COLORS$1.ANCHOR_BLUE }),
        React.createElement(IconButton$1.Text, { language: language, isDesktopHeader: isDesktopHeader }, t('login&register'))))));
};
var UserButton$2 = function (_a) {
    var _b = _a.isLoggedIn, isLoggedIn = _b === void 0 ? !!getUserTokenFromCookie$1() : _b, loginObj = _a.loginObj, iconFill = _a.iconFill, isSSR = _a.isSSR, isDesktopHeader = _a.isDesktopHeader;
    /* if obtained token to isn't valid user will be redirected to login already handled in middleware */
    return (React.createElement(Box, { as: "div", minWidth: ['auto', 'auto', 'auto', '160px'] }, isLoggedIn && !isSSR ? (React.createElement(LoggedInButton, { iconFill: iconFill })) : (React.createElement(LoginButton, __assign({}, loginObj, { isSSR: isSSR, isDesktopHeader: isDesktopHeader })))));
};

var getWithBadgeProps = function (count) { return (count > 0 ? { style: { position: 'relative' } } : {}); };

var Badge$1 = styled.span(templateObject_1$1s || (templateObject_1$1s = __makeTemplateObject(["\n  animation: ", ";\n  animation-fill-mode: both;\n  background: ", ";\n  border-radius: 50%;\n  color: ", ";\n  font-size: ", ";\n  height: ", ";\n  line-height: ", ";\n  min-width: ", ";\n  padding-left: 1px;\n  position: absolute;\n  /* @noflip */\n  right: -8px;\n  text-align: center;\n  top: 0;\n\n  @keyframes popup {\n    0% {\n      opacity: 0.6;\n      transform: scale3d(0.3, 0.3, 0.3);\n      box-shadow: 0 0 0 0 rgba(243, 64, 65, 0.1);\n    }\n    30% {\n      transform: scale3d(1.1, 1.1, 1.1);\n    }\n    55% {\n      transform: scale3d(0.9, 0.9, 0.9);\n    }\n    90% {\n      opacity: 1;\n      transform: scale3d(1.04, 1.04, 1.04);\n      box-shadow: 0 0 0 10px rgba(243, 64, 65, 0.1);\n    }\n    100% {\n      opacity: 1;\n      transform: scaleX(1);\n      box-shadow: 0 0 0 0 rgba(243, 64, 65, 0.1);\n    }\n  }\n"], ["\n  animation: ", ";\n  animation-fill-mode: both;\n  background: ", ";\n  border-radius: 50%;\n  color: ", ";\n  font-size: ", ";\n  height: ", ";\n  line-height: ", ";\n  min-width: ", ";\n  padding-left: 1px;\n  position: absolute;\n  /* @noflip */\n  right: -8px;\n  text-align: center;\n  top: 0;\n\n  @keyframes popup {\n    0% {\n      opacity: 0.6;\n      transform: scale3d(0.3, 0.3, 0.3);\n      box-shadow: 0 0 0 0 rgba(243, 64, 65, 0.1);\n    }\n    30% {\n      transform: scale3d(1.1, 1.1, 1.1);\n    }\n    55% {\n      transform: scale3d(0.9, 0.9, 0.9);\n    }\n    90% {\n      opacity: 1;\n      transform: scale3d(1.04, 1.04, 1.04);\n      box-shadow: 0 0 0 10px rgba(243, 64, 65, 0.1);\n    }\n    100% {\n      opacity: 1;\n      transform: scaleX(1);\n      box-shadow: 0 0 0 0 rgba(243, 64, 65, 0.1);\n    }\n  }\n"])), function (props) { return (props.isPopUp ? 'popup 0.5s' : 'none'); }, COLORS$1.RED, COLORS$1.WHITE, TYPOGRAPHY$1.SIZE[10], SIZES$2.BADGE_SIZE, SIZES$2.BADGE_SIZE, SIZES$2.BADGE_SIZE);
var templateObject_1$1s;

var Container$f = CustomStyled$1(Box)(templateObject_1$1t || (templateObject_1$1t = __makeTemplateObject(["\n  flex-shrink: 0;\n  position: relative;\n  margin-left: 16px;\n"], ["\n  flex-shrink: 0;\n  position: relative;\n  margin-left: 16px;\n"])));
Container$f.defaultProps = {
    as: 'nav',
};
var MiniCart = (function () {
    var _a;
    var _b = useSelector(function (state) { return (__assign(__assign({}, state.appConfig), state.miniCart)); }), areaCode = _b.areaCode, totalUnitCount = _b.totalUnitCount, storeId = _b.storeId, language = _b.language;
    var dispatch = useDispatch();
    var isDesktop = useBreakpoints().isDesktop;
    var isNonFoodV2Enabled = useNonFoodV2Journey();
    var isDesktopHeader = isNonFoodV2Enabled && isDesktop;
    useEffect(function () {
        var _a;
        if (areaCode && !((_a = window.location.pathname) === null || _a === void 0 ? void 0 : _a.includes('/app/cart'))) {
            dispatch(getCartData$1());
        }
    }, [areaCode, dispatch]);
    var _c = __read(useState(totalUnitCount || 0), 2), count = _c[0], setCount = _c[1];
    var _d = __read(useState(totalUnitCount > 0), 2), isPopUp = _d[0], setPopUp = _d[1];
    useEffect(function () {
        if (totalUnitCount !== count) {
            setCount(totalUnitCount);
        }
    }, [totalUnitCount, setPopUp, setCount, count]);
    useEffect(function () {
        setPopUp(function (isPopUpValue) { return !isPopUpValue; });
        var timer = setTimeout(function () { return setPopUp(function (isPopUpValue) { return !isPopUpValue; }); }, 1000);
        return function () {
            clearTimeout(timer);
        };
    }, [count, setPopUp]);
    var isEnabledCartRevamp = ((_a = useFeature('cart.cart_revamp_flutter.enabled')) === null || _a === void 0 ? void 0 : _a.value) || false;
    var cartPageUrl = isEnabledCartRevamp ? "/" + storeId + "/" + language + NEW_CART_PAGE : NEW_CART_PAGE;
    return (React.createElement(Container$f, { "data-testid": "miniCart" },
        React.createElement(IconButton$1, __assign({ as: "a", href: cartPageUrl }, getWithBadgeProps(totalUnitCount)),
            React.createElement(CartInverse, { size: "M", fill: isDesktopHeader ? COLORS$1.WHITE : COLORS$1.ANCHOR_BLUE }),
            count > 0 ? (React.createElement(Badge$1, { isPopUp: isPopUp, "data-testid": "header_item_cart" }, count)) : null)));
});
var templateObject_1$1t;

var headerHeightProp$2 = headerHeightProp$1;
var HeaderStatic$1 = memo(function (_a) {
    var _b = _a.isMenuNav, isMenuNav = _b === void 0 ? true : _b, _c = _a.isSearchBox, isSearchBox = _c === void 0 ? true : _c;
    var _d = __read(useAppConfig$1(), 4), requestStatus = _d[3];
    return (React.createElement(React.Fragment, null,
        React.createElement(Header$4, { as: "aside" }),
        isSearchBox && React.createElement(Search$1, { as: "aside" }),
        isMenuNav && !requestStatus.failed && React.createElement(Nav$1, { as: "aside" })));
});

var MainPane$1 = customStyled(Box)(templateObject_1$1u || (templateObject_1$1u = __makeTemplateObject(["\n  transition: 0.1s all;\n  @media (min-width: ", ") {\n    min-height: 72px;\n  }\n  @media (max-width: ", ") {\n    ", "\n    position: relative;\n    z-index: -1;\n  }\n  @media (min-width: ", ") {\n    background: ", ";\n  }\n"], ["\n  transition: 0.1s all;\n  @media (min-width: ", ") {\n    min-height: 72px;\n  }\n  @media (max-width: ", ") {\n    ", "\n    position: relative;\n    z-index: -1;\n  }\n  @media (min-width: ", ") {\n    background: ", ";\n  }\n"])), function (props) { return props.theme.breakpoints[3]; }, function (props) { return props.theme.breakpoints[0]; }, function (_a) {
    var isHideNav = _a.isHideNav;
    return isHideNav && "transform: translate(0, -53px);";
}, function (props) { return props.theme.breakpoints[1]; }, function (_a) {
    var isNonFoodV2Enabled = _a.isNonFoodV2Enabled;
    return isNonFoodV2Enabled && COLORS$1.BLUE;
});
MainPane$1.defaultProps = {
    bg: COLORS$1.WHITE,
    py: 2,
    px: 3,
};
var DealsMenuContainer$1 = customStyled(Flex)(templateObject_2$1b || (templateObject_2$1b = __makeTemplateObject(["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), function (props) { return props.theme.breakpoints[3]; });
DealsMenuContainer$1.defaultProps = {
    ml: 10,
};
var DealsMenuSkeltonBox$1 = customStyled(Flex)(templateObject_3$_ || (templateObject_3$_ = __makeTemplateObject(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
var DealsMenuSkeleton$1 = customStyled(Box)(templateObject_4$Q || (templateObject_4$Q = __makeTemplateObject(["\n  background-image: linear-gradient(90deg, #0a437c, #0c4e91, #0a437c);\n"], ["\n  background-image: linear-gradient(90deg, #0a437c, #0c4e91, #0a437c);\n"])));
DealsMenuSkeleton$1.defaultProps = {
    variant: 'skeletonSquare',
    bg: '#0A437C',
};
var templateObject_1$1u, templateObject_2$1b, templateObject_3$_, templateObject_4$Q;

var PolicyAccept$1;
(function (PolicyAccept) {
    PolicyAccept["YES"] = "y";
    PolicyAccept["NO"] = "n";
})(PolicyAccept$1 || (PolicyAccept$1 = {}));

function SingleOTPInputComponent$1(props) {
    var focus = props.focus, autoFocus = props.autoFocus, rest = __rest(props, ["focus", "autoFocus"]);
    var inputRef = useRef(null);
    var prevFocus = usePrevious(!!focus);
    useLayoutEffect(function () {
        if (inputRef.current) {
            if (focus && autoFocus) {
                inputRef.current.focus();
            }
            if (focus && autoFocus && focus !== prevFocus) {
                inputRef.current.focus();
                inputRef.current.select();
            }
        }
    }, [autoFocus, focus, prevFocus]);
    return React.createElement("input", __assign({ ref: inputRef }, rest, { style: { height: '100%', width: '100%', textAlign: 'center' } }));
}
var SingleOTPInput$1 = memo(SingleOTPInputComponent$1);

var OTPInputContainer$1 = styled(Box)(templateObject_1$1v || (templateObject_1$1v = __makeTemplateObject(["\n  margin: 5% auto;\n"], ["\n  margin: 5% auto;\n"])));
var OTPInputStyle$1 = styled(Box)(templateObject_2$1c || (templateObject_2$1c = __makeTemplateObject(["\n  width: ", ";\n  height: 3.5rem;\n  margin-right: 1rem;\n  font-size: 1.5rem;\n  text-align: center !important;\n  border-radius: 4px;\n  justify-content: middle;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n"], ["\n  width: ", ";\n  height: 3.5rem;\n  margin-right: 1rem;\n  font-size: 1.5rem;\n  text-align: center !important;\n  border-radius: 4px;\n  justify-content: middle;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n"])), function (props) { return (props.length === 4 ? '6rem !important' : '4rem !important'); });
var templateObject_1$1v, templateObject_2$1c;

function OTPInputComponent$1(props) {
    var length = props.length, isNumberInput = props.isNumberInput, autoFocus = props.autoFocus, disabled = props.disabled, onChangeOTP = props.onChangeOTP, inputClassName = props.inputClassName, inputStyle = props.inputStyle, isResetInput = props.isResetInput, resetInput = props.resetInput, rest = __rest(props, ["length", "isNumberInput", "autoFocus", "disabled", "onChangeOTP", "inputClassName", "inputStyle", "isResetInput", "resetInput"]);
    var _a = __read(useState(0), 2), activeInput = _a[0], setActiveInput = _a[1];
    var _b = __read(useState(Array(length).fill('')), 2), otpValues = _b[0], setOTPValues = _b[1];
    // Helper to return OTP from inputs
    var handleOtpChange = useCallback(function (otp) {
        var otpValue = otp.join('');
        onChangeOTP(otpValue);
    }, [onChangeOTP]);
    useEffect(function () {
        if (isResetInput) {
            setOTPValues(Array(length).fill(''));
            resetInput();
        }
    }, [isResetInput, resetInput, length]);
    // Helper to return value with the right type: 'text' or 'number'
    var getRightValue = useCallback(function (str) {
        var changedValue = str;
        if (!isNumberInput) {
            return changedValue;
        }
        return !changedValue || /\d/.test(changedValue) ? changedValue : '';
    }, [isNumberInput]);
    // Change OTP value at focussing input
    var changeCodeAtFocus = useCallback(function (str) {
        var updatedOTPValues = __spread(otpValues);
        updatedOTPValues[activeInput] = str[0] || '';
        setOTPValues(updatedOTPValues);
        handleOtpChange(updatedOTPValues);
    }, [activeInput, handleOtpChange, otpValues]);
    // Focus `inputIndex` input
    var focusInput = useCallback(function (inputIndex) {
        var selectedIndex = Math.max(Math.min(length - 1, inputIndex), 0);
        setActiveInput(selectedIndex);
    }, [length]);
    var focusPrevInput = useCallback(function () {
        focusInput(activeInput - 1);
    }, [activeInput, focusInput]);
    var focusNextInput = useCallback(function () {
        focusInput(activeInput + 1);
    }, [activeInput, focusInput]);
    // Handle onFocus input
    var handleOnFocus = useCallback(function (index) { return function () {
        focusInput(index);
    }; }, [focusInput]);
    // Handle onChange value for each input
    var handleOnChange = useCallback(function (e) {
        var val = getRightValue(e.currentTarget.value);
        if (!val) {
            e.preventDefault();
            return;
        }
        changeCodeAtFocus(val);
        focusNextInput();
    }, [changeCodeAtFocus, focusNextInput, getRightValue]);
    // Hanlde onBlur input
    var onBlur = useCallback(function () {
        setActiveInput(-1);
    }, []);
    // Handle onKeyDown input
    var handleOnKeyDown = useCallback(function (e) {
        switch (e.key) {
            case 'Backspace':
            case 'Delete': {
                e.preventDefault();
                if (otpValues[activeInput]) {
                    changeCodeAtFocus('');
                }
                else {
                    focusPrevInput();
                }
                break;
            }
            case 'ArrowLeft': {
                e.preventDefault();
                focusPrevInput();
                break;
            }
            case 'ArrowRight': {
                e.preventDefault();
                focusNextInput();
                break;
            }
            case ' ': {
                e.preventDefault();
                break;
            }
        }
    }, [activeInput, changeCodeAtFocus, focusNextInput, focusPrevInput, otpValues]);
    var handleOnPaste = useCallback(function (e) {
        e.preventDefault();
        var pastedData = e.clipboardData
            .getData('text/plain')
            .trim()
            .slice(0, length - activeInput)
            .split('');
        if (pastedData) {
            var nextFocusIndex_1 = 0;
            var updatedOTPValues_1 = __spread(otpValues);
            updatedOTPValues_1.forEach(function (val, index) {
                if (index >= activeInput) {
                    var changedValue = getRightValue(pastedData.shift() || val);
                    if (changedValue) {
                        updatedOTPValues_1[index] = changedValue;
                        nextFocusIndex_1 = index;
                    }
                }
            });
            setOTPValues(updatedOTPValues_1);
            setActiveInput(Math.min(nextFocusIndex_1 + 1, length - 1));
        }
    }, [activeInput, getRightValue, length, otpValues]);
    return (React.createElement("div", __assign({}, rest),
        React.createElement(OTPInputContainer$1, null,
            React.createElement(Flex, { spacing: 10 }, Array(length)
                .fill('')
                .map(function (_, index) { return (React.createElement(Box, { width: 1 / 4, key: "SingleInputBox-" + index },
                React.createElement(OTPInputStyle$1, null,
                    React.createElement(SingleOTPInput$1, { key: "SingleInput-" + index, focus: activeInput === index, value: otpValues && otpValues[index], autoFocus: autoFocus, onFocus: handleOnFocus(index), onChange: handleOnChange, onKeyDown: handleOnKeyDown, onBlur: onBlur, onPaste: handleOnPaste, style: inputStyle, className: inputClassName, disabled: disabled, placeholder: "-" })))); })))));
}
var OTPInput$1 = memo(OTPInputComponent$1);

var ErrorMessage$3 = customStyled(Box)(templateObject_1$1w || (templateObject_1$1w = __makeTemplateObject(["\n  color: ", ";\n  background-color:", ";\n  padding:20px;\n  text-align:center;\n  margin-bottom: 20px;\n  margin: 0px 10px;\n"], ["\n  color: ", ";\n  background-color:", ";\n  padding:20px;\n  text-align:center;\n  margin-bottom: 20px;\n  margin: 0px 10px;\n"])), COLORS$1.LIGHT_RED, COLORS$1.LIGHT_RED);
var ErrorText$3 = customStyled.span(templateObject_2$1d || (templateObject_2$1d = __makeTemplateObject(["\n  margin-left:20px;\n"], ["\n  margin-left:20px;\n"])));
var CountrySvgContainer$2 = customStyled(Flex)(templateObject_3$$ || (templateObject_3$$ = __makeTemplateObject(["\n  min-width: 15px;\n  max-width: 15px;  \n  align-self: flex-end;\n"], ["\n  min-width: 15px;\n  max-width: 15px;  \n  align-self: flex-end;\n"])));
var OtpHeading$1 = customStyled(Box)(templateObject_4$R || (templateObject_4$R = __makeTemplateObject(["\n  font-size: ", ";\n"], ["\n  font-size: ", ";\n"])), SPACINGS$1[24]);
var templateObject_1$1w, templateObject_2$1d, templateObject_3$$, templateObject_4$R;

var EditPhoneNumber$2 = function (props) {
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var isOpen = props.isOpen, onSuccess = props.onSuccess, onClose = props.onClose;
    var _a = __read(useState(''), 1), updateError = _a[0];
    var _b = useForm({
        mode: 'onSubmit',
    }), register = _b.register, errors = _b.errors, setError = _b.setError, clearErrors = _b.clearErrors, getValues = _b.getValues, handleSubmit = _b.handleSubmit;
    var _c = useSelector(function (state) {
        return __assign({ userData: state.userData }, state.appConfig);
    }), _d = _c.phoneExpression, phoneExpression = _d === void 0 ? '' : _d, _e = _c.phoneCountryCode, phoneCountryCode = _e === void 0 ? '' : _e, _f = _c.countryName, countryName = _f === void 0 ? '' : _f, userData = _c.userData;
    var handleVerifyPhone = function (apiResponse) {
        var _a;
        if ((_a = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.meta) === null || _a === void 0 ? void 0 : _a.errorCode) {
            setError('phone', {
                type: 'phone_exist',
                message: t('verifyOTP.CustomerPhoneConflictError'),
            });
        }
        else {
            clearErrors('phone');
            onSuccess(phoneCountryCode + getValues('phone').replace(/^0/, ''));
        }
    };
    var onFormSubmit = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            updateUserContact$1(formData.phone.replace(/^0/, ''), handleVerifyPhone)(dispatch);
            return [2 /*return*/];
        });
    }); };
    var getIcon = function (countryName) {
        switch (countryName) {
            case 'UAE':
                return React.createElement(UAEFlag, { size: "L" });
            case 'Bahrain':
                return React.createElement(BahrainFlag, { size: "L" });
            case 'Egypt':
                return React.createElement(EgyptFlag, { size: "L" });
            case 'Jordan':
                return React.createElement(JordanFlag, { size: "L" });
            case 'Kuwait':
                return React.createElement(KuwaitFlag, { size: "L" });
            case 'Lebanon':
                return React.createElement(LebanonFlag, { size: "L" });
            case 'Oman':
                return React.createElement(OmanFlag, { size: "L" });
            case 'Pakistan':
                return React.createElement(PakistanFlag, { size: "L" });
            case 'Qatar':
                return React.createElement(QatarFlag, { size: "L" });
            case 'KSA':
                return React.createElement(KSAFlag, { size: "L" });
            case 'Kenya':
                return React.createElement(KenyaFlag, { size: "L" });
            case 'Georgia':
                return React.createElement(GeorgiaFlag, { size: "L" });
            default:
                return countryName;
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { "data-test-id": "edit_profile_phone_number_modal", isOpen: isOpen, title: '   ', onClose: onClose, width: [1, null, null, '428px'], marginBottom: "0", titleStyles: { fontWeight: 'bold' }, p: "24px 0", headerStyles: { paddingX: '24px' } },
            updateError && (React.createElement(ErrorMessage$3, null,
                React.createElement(Warning, { fill: COLORS$1.LIGHT_RED }),
                React.createElement(ErrorText$3, null, updateError))),
            React.createElement(Box, { pl: '80px', pr: '80px' },
                React.createElement(Text.H1, { mt: 2, textAlign: "center" }, t('verifyOTP.changeNumber')),
                React.createElement(Flex, { flexDirection: "column", flex: 1, mt: 16, as: "form", onSubmit: handleSubmit(onFormSubmit), "data-testid": "__phone_number_edit__" },
                    React.createElement(Flex, { justifyContent: "space-between", mt: 20 },
                        React.createElement(Flex, { width: "25%" },
                            React.createElement(CountrySvgContainer$2, { pt: 2 }, countryName && getIcon(countryName)),
                            React.createElement(Box, null,
                                React.createElement(Input, { testid: "country-code-field", defaultValue: phoneCountryCode, disabled: true, backgroundColor: COLORS$1.LIGHT_GREY }))),
                        React.createElement(Box, { width: "75%" },
                            React.createElement(Input, { testid: 'phone-number-field', label: t('address.mobileNumber'), name: "phone", successIcon: true, allowedRegExpChars: "alphanumericCommaPeriod", backgroundColor: COLORS$1.LIGHT_GREY, register: register({
                                    required: t('address.requiredField'),
                                    pattern: {
                                        value: new RegExp(phoneExpression),
                                        message: t('address.invalidPhone'),
                                    },
                                }) }))),
                    errors.phone && (React.createElement(Text.Paragraph, { color: COLORS$1.RED, mt: 1, fontSize: TYPOGRAPHY$1.SIZE[14] }, errors.phone.message)),
                    React.createElement(Flex, { mt: 30 },
                        React.createElement(Button$1, { flex: 1, type: "submit", testid: "phone-submit-button" },
                            t('verifyOTP.saveAndVerify'),
                            userData.isProfileUpdating && React.createElement(LinearProgress, { withBlock: true }))))))));
};
EditPhoneNumber$2.defaultProps = {};
var EditPhoneNumber$3 = React.memo(EditPhoneNumber$2);

var setOTPSuccess$1 = function (otpResponse) { return ({
    type: VerifyOTPTypes$3.SEND_OTP_SUCCESS,
    payload: { otpResponse: otpResponse },
}); };
var setOTPLoading$1 = function (state) { return ({
    type: VerifyOTPTypes$3.SEND_OTP_LOADING,
    payload: state,
}); };
var setOTPError$1 = function (message) { return ({
    type: VerifyOTPTypes$3.SEND_OTP_ERROR,
    payload: message,
}); };
var setOTPVerificationSuccess$1 = function (otpVerificationResponse) { return ({
    type: VerifyOTPTypes$3.OTP_VERIFICATION_SUCCESS,
    payload: { otpVerificationResponse: otpVerificationResponse },
}); };
var setOTPVerificationLoading$1 = function (state) { return ({
    type: VerifyOTPTypes$3.OTP_VERIFICATION_LOADING,
    payload: state,
}); };
var setOTPVerificationError$1 = function (message) { return ({
    type: VerifyOTPTypes$3.OTP_VERIFICATION_ERROR,
    payload: message,
}); };
var sendOTP$1 = function (otpPayload) { return function (dispatch) {
    dispatch(setOTPLoading$1(true));
    dispatch(setOTPError$1(''));
    dispatch(setOTPVerificationError$1(''));
    dispatch(setOTPVerificationSuccess$1(null));
    dispatch({
        type: VerifyOTPTypes$3.SEND_OTP,
        payload: {
            data: otpPayload,
            headers: {
                'Content-Type': 'application/json',
            },
            method: EApiMiddlewareMethod$3.POST,
            onSuccess: function (apiResponse) {
                if (apiResponse.result) {
                    setOTPSuccess$1 && dispatch(setOTPSuccess$1(apiResponse.data));
                }
                else {
                    dispatch(setOTPError$1(i18next.t('errorGeneral')));
                }
            },
            onFailure: function (_errMessage, _a) {
                var data = (_a === void 0 ? {} : _a).response.data;
                var errorCode = data.meta.errorCode;
                var errorMessage = i18next.t("verifyOTP." + errorCode).includes('verifyOTP.')
                    ? i18next.t('errorGeneral')
                    : i18next.t("verifyOTP." + errorCode);
                dispatch(setOTPError$1(errorMessage));
            },
            onFinally: function () {
                dispatch(setOTPLoading$1(false));
            },
            url: otpPayload.mode === 'otp' ? SEND_OTP_API$1 : SEND_PHONE_CALL_OTP_API$1,
        },
    });
}; };
var verifyOTP$1 = function (verifyOTPPayload, onGTMEventCall) {
    if (onGTMEventCall === void 0) { onGTMEventCall = null; }
    return function (dispatch) {
        dispatch(setOTPVerificationLoading$1(true));
        dispatch(setOTPVerificationError$1(''));
        dispatch({
            type: VerifyOTPTypes$3.OTP_VERIFICATION,
            payload: {
                isAbsUrl: true,
                data: {
                    code: verifyOTPPayload.code,
                },
                headers: {
                    'Content-Type': 'application/json',
                },
                method: EApiMiddlewareMethod$3.POST,
                onSuccess: function (apiResponse) {
                    var _a;
                    if (apiResponse.result) {
                        setOTPVerificationSuccess$1 && dispatch(setOTPVerificationSuccess$1(apiResponse.data));
                    }
                    else {
                        dispatch(setOTPVerificationError$1(i18next.t(('verifyOTP.' + ((_a = apiResponse.error) === null || _a === void 0 ? void 0 : _a.code)))));
                    }
                },
                onFailure: function (_errMessage, _a) {
                    var data = (_a === void 0 ? {} : _a).response.data;
                    var _b = data.meta, errorCode = (_b === void 0 ? { errorCode: '' } : _b).errorCode;
                    dispatch(setOTPVerificationError$1(i18next.t("verifyOTP." + errorCode)));
                    onGTMEventCall && onGTMEventCall('error', errorCode);
                },
                onFinally: function () {
                    dispatch(setOTPVerificationLoading$1(false));
                },
                url: OTP_VERIFICATION_API$1 + "/" + verifyOTPPayload.uuid,
            },
        });
    };
};

var useVerifyOTP$1 = function () {
    var _a = useSelector(function (state) {
        return {
            otpVeritification: state.verifyOTP,
            appConfig: state.appConfig,
        };
    }), otpVeritification = _a.otpVeritification, appConfig = _a.appConfig;
    var sendOTPState = otpVeritification.sendOTP, verifyOTPState = otpVeritification.verifyOTP;
    var language = appConfig.language;
    var dispatch = useDispatch();
    var onSendOTP = useCallback(function (action, email, mode, uuid, phoneNumber) {
        if (phoneNumber === void 0) { phoneNumber = ''; }
        var bodyPayload = {
            mode: mode,
            action: action,
            email: email,
        };
        if (phoneNumber) {
            bodyPayload.phoneNumber = phoneNumber;
        }
        if (mode === 'voice') {
            bodyPayload.uuid = uuid || '';
            bodyPayload.locale = language;
        }
        sendOTP$1(bodyPayload)(dispatch);
    }, [dispatch, language]);
    var onVerifyOTP = useCallback(function (code, uuid, onGTMEventCall) {
        if (onGTMEventCall === void 0) { onGTMEventCall = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = { code: code, uuid: uuid };
                        return [4 /*yield*/, verifyOTP$1(payload, onGTMEventCall)(dispatch)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }, [dispatch]);
    return {
        otpData: sendOTPState.otpData,
        verificationData: verifyOTPState.verificationData,
        resendCodeLoading: sendOTPState.isLoading,
        loading: verifyOTPState.isLoading,
        serverError: sendOTPState.error || verifyOTPState.error,
        verifyOTPError: verifyOTPState.error,
        onSendOTP: onSendOTP,
        onVerifyOTP: onVerifyOTP,
    };
};

var InputWrapper$2 = customStyled.div(templateObject_1$1x || (templateObject_1$1x = __makeTemplateObject(["\n  margin: 16px 0;\n"], ["\n  margin: 16px 0;\n"])));
var WarningMessage$2 = customStyled(Box)(templateObject_2$1e || (templateObject_2$1e = __makeTemplateObject(["\n  color:", ";\n  margin-top:10px;\n"], ["\n  color:", ";\n  margin-top:10px;\n"])), function (props) { return props.theme.colors.red; });
var ErrorMessage$4 = customStyled(Box)(templateObject_3$10 || (templateObject_3$10 = __makeTemplateObject(["\n  color: #f34041;\n  background-color:rgba(243,64,65,.05);\n  padding:20px;\n  text-align:center;\n  margin-bottom: 20px;\n"], ["\n  color: #f34041;\n  background-color:rgba(243,64,65,.05);\n  padding:20px;\n  text-align:center;\n  margin-bottom: 20px;\n"])));
var ErrorText$4 = customStyled.span(templateObject_4$S || (templateObject_4$S = __makeTemplateObject(["\n  margin-left:20px;\n"], ["\n  margin-left:20px;\n"])));
var LinkText$3 = customStyled(Box)(templateObject_5$E || (templateObject_5$E = __makeTemplateObject(["\n  cursor: pointer;\n  color: #7d0f34;\n  font-weight:bold;\n"], ["\n  cursor: pointer;\n  color: #7d0f34;\n  font-weight:bold;\n"])));
var InputContainerPadding$2 = customStyled(Box)(templateObject_6$u || (templateObject_6$u = __makeTemplateObject(["\n  padding: 5px;\n"], ["\n  padding: 5px;\n"])));
var HRText$1 = customStyled(Box)(templateObject_7$s || (templateObject_7$s = __makeTemplateObject(["\n  width: 100%; \n  text-align: center; \n  border-bottom: 1px solid #000;\n  opacity:0.5;\n  line-height: 0.1em;\n  margin: 20px 0px;\n  & > span {\n    background:#fff; \n    padding:0 10px; \n  }\n"], ["\n  width: 100%; \n  text-align: center; \n  border-bottom: 1px solid #000;\n  opacity:0.5;\n  line-height: 0.1em;\n  margin: 20px 0px;\n  & > span {\n    background:#fff; \n    padding:0 10px; \n  }\n"])));
var LoaderSpan$2 = customStyled(Box)(templateObject_8$s || (templateObject_8$s = __makeTemplateObject(["\n  display: inline-flex;\n  position: relative;\n  width: 100%;\n  margin:", ";\n"], ["\n  display: inline-flex;\n  position: relative;\n  width: 100%;\n  margin:", ";\n"])), function (props) { return (props.m ? props.m + 'px 0px' : '0px'); });
var AlignCenter$1 = customStyled(Box)(templateObject_9$q || (templateObject_9$q = __makeTemplateObject(["\n  text-align:center;\n"], ["\n  text-align:center;\n"])));
var HighLightPhone$1 = customStyled(Box)(templateObject_10$p || (templateObject_10$p = __makeTemplateObject(["\n  color:#0e5aa7;\n  font-weight:bold;\n  display: inline;\n"], ["\n  color:#0e5aa7;\n  font-weight:bold;\n  display: inline;\n"])));
var Timer$2 = customStyled(Box)(templateObject_11$k || (templateObject_11$k = __makeTemplateObject(["\n  margin: 20px 0px;\n"], ["\n  margin: 20px 0px;\n"])));
var Heading$2 = customStyled(Box)(templateObject_12$i || (templateObject_12$i = __makeTemplateObject(["\n  margin: 20px 0px;\n"], ["\n  margin: 20px 0px;\n"])));
var PageTitle$2 = customStyled(Text.H1)(templateObject_13$h || (templateObject_13$h = __makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
var OTPSentSuccess$1 = customStyled(Box)(templateObject_14$h || (templateObject_14$h = __makeTemplateObject(["\n  width: 170px;\n  height: 21px;\n  margin-top:-10px;\n  font-size: 14px;\n  color: #267949;\n"], ["\n  width: 170px;\n  height: 21px;\n  margin-top:-10px;\n  font-size: 14px;\n  color: #267949;\n"])));
var CopyrightMaxLayout$2 = customStyled(Flex)(templateObject_15$h || (templateObject_15$h = __makeTemplateObject(["\n  align-items: center;\n  margin: 0 auto;\n  max-width: ", "px;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin-top:35px;\n"], ["\n  align-items: center;\n  margin: 0 auto;\n  max-width: ", "px;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin-top:35px;\n"])), function (props) { return props.theme.maxLayoutWidth; });
var Logo$6 = customStyled.a(templateObject_16$d || (templateObject_16$d = __makeTemplateObject(["\n  svg {\n    display: block; {/* Remove space around the element */}\n  }\n  color: '#000000'\n"], ["\n  svg {\n    display: block; {/* Remove space around the element */}\n  }\n  color: '#000000'\n"])));
var PhoneWrapper$1 = customStyled.span(templateObject_17$d || (templateObject_17$d = __makeTemplateObject(["\n  svg {\n    vertical-align: middle;\n  }\n  margin-right:10px;\n"], ["\n  svg {\n    vertical-align: middle;\n  }\n  margin-right:10px;\n"])));
var VerificationCodeSent$1 = customStyled(Text)(templateObject_18$b || (templateObject_18$b = __makeTemplateObject(["\n  font-size: 14px;\n  color: ", ";\n  span {\n    font-weight:bold;\n    margin-right: 5px;\n  }\n"], ["\n  font-size: 14px;\n  color: ", ";\n  span {\n    font-weight:bold;\n    margin-right: 5px;\n  }\n"])), COLORS$1.DARK_GREY);
var VerifyPhoneText$1 = customStyled(Text.H3)(templateObject_19$b || (templateObject_19$b = __makeTemplateObject(["\n  font-size: 16px;\n  margin-top: 8px;\n  font-weight: bold;\n"], ["\n  font-size: 16px;\n  margin-top: 8px;\n  font-weight: bold;\n"])));
var BroughtYouByWrapper$1 = customStyled(Flex)(templateObject_20$9 || (templateObject_20$9 = __makeTemplateObject(["\n  justify-content:center;\n  margin-top:16px;\n  text-align:center;\n"], ["\n  justify-content:center;\n  margin-top:16px;\n  text-align:center;\n"])));
var BroughtToYouBuyStyle$1 = customStyled.span(templateObject_21$8 || (templateObject_21$8 = __makeTemplateObject(["\n  font-size: 9px;\n  font-family: MarselisPro, \"Marselis Pro\";\n  transform: translate(0, 24.46);\n"], ["\n  font-size: 9px;\n  font-family: MarselisPro, \"Marselis Pro\";\n  transform: translate(0, 24.46);\n"])));
var BroughtToYouBuyBox$1 = customStyled(Box)(templateObject_22$8 || (templateObject_22$8 = __makeTemplateObject(["\n  text-align:center;\n  width:100%;\n  margin: '0px 0px -10px -35px'};\n  font-weight:bold;\n"], ["\n  text-align:center;\n  width:100%;\n  margin: '0px 0px -10px -35px'};\n  font-weight:bold;\n"])));
var MafLogoBox$1 = customStyled(Box)(templateObject_23$6 || (templateObject_23$6 = __makeTemplateObject(["\n  text-align:center;\n  width:100%;\n"], ["\n  text-align:center;\n  width:100%;\n"])));
var templateObject_1$1x, templateObject_2$1e, templateObject_3$10, templateObject_4$S, templateObject_5$E, templateObject_6$u, templateObject_7$s, templateObject_8$s, templateObject_9$q, templateObject_10$p, templateObject_11$k, templateObject_12$i, templateObject_13$h, templateObject_14$h, templateObject_15$h, templateObject_16$d, templateObject_17$d, templateObject_18$b, templateObject_19$b, templateObject_20$9, templateObject_21$8, templateObject_22$8, templateObject_23$6;

var WhatsAppButton$1 = styled(Button$1)(templateObject_1$1y || (templateObject_1$1y = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), COLORS$1.SLIMY_GREEN);
var OtpButton$1 = styled(Button$1)(templateObject_2$1f || (templateObject_2$1f = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), COLORS$1.BLUE);
var templateObject_1$1y, templateObject_2$1f;

var setWhatsAppOTPSuccess$1 = function (otpVerificationResponse) { return ({
    type: VerifyWhatsAppTypes$3.WHATSAPP_OTP_SUCCESS,
    payload: { otpVerificationResponse: otpVerificationResponse },
}); };
var setWhatsAppOTPLoading$1 = function (state) { return ({
    type: VerifyWhatsAppTypes$3.WHATSAPP_OTP_LOADING,
    payload: state,
}); };
var setWhatsAppOTPError$1 = function (message) { return ({
    type: VerifyWhatsAppTypes$3.WHATSAPP_OTP_ERROR,
    payload: message,
}); };
var getWhatAppOTP$1 = function (verifyWhatsAppRequestPayload, onGTMEventCall) {
    if (onGTMEventCall === void 0) { onGTMEventCall = null; }
    return function (dispatch) {
        dispatch(setWhatsAppOTPLoading$1(true));
        dispatch(setWhatsAppOTPError$1(''));
        dispatch(setWhatsAppOTPSuccess$1(null));
        dispatch({
            type: VerifyWhatsAppTypes$3.WHATSAPP_OTP_VERIFICATION,
            payload: {
                data: verifyWhatsAppRequestPayload,
                headers: {
                    'Content-Type': 'application/json',
                },
                method: EApiMiddlewareMethod$3.POST,
                onSuccess: function (apiResponse) {
                    var _a;
                    if (apiResponse.result) {
                        setWhatsAppOTPSuccess$1 && dispatch(setWhatsAppOTPSuccess$1(apiResponse.data));
                    }
                    else {
                        dispatch(setWhatsAppOTPError$1(i18next.t(('verifyOTP.' + ((_a = apiResponse.error) === null || _a === void 0 ? void 0 : _a.code)))));
                    }
                },
                onFailure: function (_errMessage, _a) {
                    var data = (_a === void 0 ? {} : _a).response.data;
                    var _b = data.error, code = (_b === void 0 ? { code: '' } : _b).code;
                    dispatch(setWhatsAppOTPError$1(i18next.t('verifyOTP.' + code)));
                    onGTMEventCall && onGTMEventCall('error', code);
                },
                onFinally: function () {
                    dispatch(setWhatsAppOTPLoading$1(false));
                },
                url: GET_WHATSAPP_OTP_API_URL$1,
                apiVersion: 2,
            },
        });
    };
};

var OTP_ENUM$1;
(function (OTP_ENUM) {
    OTP_ENUM["OTP"] = "otp";
})(OTP_ENUM$1 || (OTP_ENUM$1 = {}));
var RequestByWhatsAppOtp$1 = function (props) {
    var t = useTranslation().t;
    var _a = useAnalytic$1(), GTMEventCall = _a.GTMEventCall, getGTMPageData = _a.getGTMPageData;
    var onShowOtp = props.onShowOtp, phoneNumber = props.phoneNumber, isResendCodeEnable = props.isResendCodeEnable, action = props.action;
    var _b = useSelector(function (state) { return state.verifyWhatsAppOTP; }), isWhatAppOtpLoading = _b.isWhatAppOtpLoading, whatsAppOtpSuccess = _b.whatsAppOtpSuccess;
    var dispatch = useDispatch();
    var getWhatsOtp = function () {
        GTMEventCall(GTMEvents$1.custom_event, {
            eventAction: GTMEventActions$1.registration,
            eventLabel: 'request_otp_via_whatsapp',
            pageData: getGTMPageData({ getData: true }) || {},
            ga4: true,
        });
        var email = props.email, locale = props.language;
        dispatch(getWhatAppOTP$1({
            phoneNumber: phoneNumber,
            email: email,
            mode: OTP_ENUM$1.OTP,
            locale: locale,
            action: action,
        }));
    };
    useEffect(function () {
        var _a;
        if ((_a = whatsAppOtpSuccess === null || whatsAppOtpSuccess === void 0 ? void 0 : whatsAppOtpSuccess.otpVerificationResponse) === null || _a === void 0 ? void 0 : _a.uuid) {
            onShowOtp('whatsapp');
        }
    }, [whatsAppOtpSuccess, onShowOtp]);
    return (React.createElement(WhatsAppButton$1, { disabled: !isResendCodeEnable || isWhatAppOtpLoading, width: "100%", mt: 2, mb: 2, onClick: function () { return getWhatsOtp(); } },
        React.createElement(Flex, { flexDirection: "row", alignItems: "space", justifyContent: "center" },
            React.createElement(Box, null,
                React.createElement(WhatsApp, { size: 'M', fill: !isResendCodeEnable || isWhatAppOtpLoading ? COLORS$1.WHITE_GREEN : COLORS$1.WHITE })),
            React.createElement(Box, { alignSelf: "center", ml: 1 }, t('whatsAppOTP.REQUESTOTPByWhatsapp')))));
};

var VerifyWhatsApp$1 = function (props) {
    var t = useTranslation().t;
    var onShowOtp = props.onShowOtp, phoneNumber = props.phoneNumber, email = props.email, language = props.language, action = props.action;
    var whatsAppOtpError = useSelector(function (state) { return state.verifyWhatsAppOTP; }).whatsAppOtpError;
    return (React.createElement(Box, { textAlign: "center" },
        whatsAppOtpError && (React.createElement(ErrorMessage$3, null,
            React.createElement(Warning, { fill: "#f34041" }),
            React.createElement(ErrorText$3, null, whatsAppOtpError))),
        React.createElement(OtpHeading$1, { mt: 3, mb: 5, as: "h2" }, t('whatsAppOTP.PleaseVerifyYourMobileNumber')),
        React.createElement(Box, { mb: 1 }, t('whatsAppOTP.WeWillSendA4DigitCodeTo')),
        React.createElement(Box, { fontWeight: "bold", mb: 1 }, transformPhoneNo$1(phoneNumber, language)),
        React.createElement(Box, { mb: 4 }, t('whatsAppOTP.PleaseSelectOneOfTheMethodsToVerifyYourAccount')),
        React.createElement(Flex, { flexDirection: "column", alignItems: "center" },
            React.createElement(OtpButton$1, { width: "100%", onClick: function () {
                    onShowOtp('otp');
                } }, t('whatsAppOTP.RequestOTPBYSMS')),
            React.createElement(RequestByWhatsAppOtp$1, { onShowOtp: onShowOtp, phoneNumber: phoneNumber, email: email, language: language, isResendCodeEnable: true, action: action }))));
};

var timerObj$1 = null;
var VERiFY_OTP_ENUMS$1;
(function (VERiFY_OTP_ENUMS) {
    VERiFY_OTP_ENUMS["VOICE"] = "voice";
    VERiFY_OTP_ENUMS["OTP"] = "otp";
    VERiFY_OTP_ENUMS["WHATSAPP"] = "whatsapp";
    VERiFY_OTP_ENUMS["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    VERiFY_OTP_ENUMS["PHONE_UPDATE_VERIFICATION"] = "PHONE_UPDATE_VERIFICATION";
})(VERiFY_OTP_ENUMS$1 || (VERiFY_OTP_ENUMS$1 = {}));
var VerifyPassword$1 = function (props) {
    var t = useTranslation().t;
    var isShowShopping = props.isShowShopping, onVerifyAccount = props.onVerifyAccount, onGTMEventCall = props.onGTMEventCall, phoneNumber = props.phoneNumber, email = props.email, action = props.action, modalBackGroundColor = props.modalBackGroundColor, _a = props.showModalClose, showModalClose = _a === void 0 ? true : _a, _b = props.isForceVerify, isForceVerify = _b === void 0 ? false : _b, userName = props.userName, isModal = props.isModal, isShowLogo = props.isShowLogo, isShowCloseButton = props.isShowCloseButton, onCloseModal = props.onCloseModal, trackSmartlookError = props.trackSmartlookError, rest = __rest(props, ["isShowShopping", "onVerifyAccount", "onGTMEventCall", "phoneNumber", "email", "action", "modalBackGroundColor", "showModalClose", "isForceVerify", "userName", "isModal", "isShowLogo", "isShowCloseButton", "onCloseModal", "trackSmartlookError"]);
    var _c = __read(useState(59), 2), timer = _c[0], setTimer = _c[1];
    var _d = __read(useState(0), 2), otpCount = _d[0], setSendOTPCount = _d[1];
    var _e = useSelector(function (state) { return state.appConfig; }), storeId = _e.storeId, language = _e.language, features = _e.features;
    var whatsAppOtpSuccess = useSelector(function (state) { return state.verifyWhatsAppOTP; }).whatsAppOtpSuccess;
    var _f = __read(useState(true), 2), isEmailVerification = _f[0], setIsEmailVerification = _f[1];
    var _g = __read(useState(false), 2), isOTPSent = _g[0], setOTPSent = _g[1];
    var _h = __read(useState(false), 2), showOTPCall = _h[0], setShowOTPCall = _h[1];
    var _j = __read(useState(false), 2), showEditPhoneNumber = _j[0], setShowEditPhoneNumber = _j[1];
    var _k = __read(useState(phoneNumber), 2), otpPhoneNumber = _k[0], setOTPPhoneNumber = _k[1];
    var dispatch = useDispatch();
    var _l = __read(useState(false), 2), isResetInput = _l[0], setResetInput = _l[1];
    var _m = __read(useState(false), 2), isResendCodeEnable = _m[0], toggleResendCode = _m[1];
    var _o = useVerifyOTP$1(), otpData = _o.otpData, verificationData = _o.verificationData, resendCodeLoading = _o.resendCodeLoading, loading = _o.loading, serverError = _o.serverError, onSendOTP = _o.onSendOTP, onVerifyOTP = _o.onVerifyOTP;
    var accountVerificationActions = ['ACCOUNT_VERIFICATION', 'PHONE_VERIFICATION', VERiFY_OTP_ENUMS$1.FORGOT_PASSWORD];
    var _p = __read(useState(!((features === null || features === void 0 ? void 0 : features.isWhatsAppOtpEnabled) && action !== VERiFY_OTP_ENUMS$1.FORGOT_PASSWORD)), 2), showOtpContainer = _p[0], setShowOtpContainer = _p[1];
    var _q = __read(useState(VERiFY_OTP_ENUMS$1.OTP), 2), otpType = _q[0], setOtpType = _q[1];
    var otpSMSSendLimit = 1;
    var _r = useAnalytic$1(), GTMEventCall = _r.GTMEventCall, getGTMPageData = _r.getGTMPageData;
    // start shopping click
    var onStartShoppingClick = function () {
        onGTMEventCall && onGTMEventCall('skipotp');
        window.location.href = '/';
    };
    // On resend code button click
    var onResendCodeClick = function (type) {
        GTMEventCall(GTMEvents$1.custom_event, {
            eventAction: GTMEventActions$1.registration,
            eventLabel: 'request_otp_via_sms',
            pageData: getGTMPageData({ getData: true }) || {},
            ga4: true,
        });
        setOtpType(type);
        onGTMEventCall && onGTMEventCall('resendotp');
        clearInterval(timerObj$1);
        initTimer();
        toggleResendCode(false);
        setResetInput(true);
        onSendOTP(action, email, type, otpData === null || otpData === void 0 ? void 0 : otpData.uuid, otpPhoneNumber);
        setOTPSent(true);
        setSendOTPCount(function (otpCount) { return otpCount + 1; });
    };
    // Activate send call otp
    var onActivateSendCallOTP = useCallback(function () {
        if (otpCount >= otpSMSSendLimit) {
            setResetInput(true);
        }
    }, [otpCount]);
    var changeOTP = function (otp) {
        var _a;
        if (otp.length === 4) {
            onVerifyOTP(otp, otpType === VERiFY_OTP_ENUMS$1.WHATSAPP ? (_a = whatsAppOtpSuccess === null || whatsAppOtpSuccess === void 0 ? void 0 : whatsAppOtpSuccess.otpVerificationResponse) === null || _a === void 0 ? void 0 : _a.uuid : otpData.uuid, onGTMEventCall);
        }
    };
    useEffect(function () {
        if (verificationData) {
            onVerifyAccount(verificationData.uuid, otpPhoneNumber);
            dispatch(setOTPVerificationSuccess$1(null));
        }
    }, [verificationData, otpPhoneNumber, dispatch, onVerifyAccount]);
    useEffect(function () {
        if (serverError && trackSmartlookError) {
            trackSmartlookError();
        }
    }, [serverError, trackSmartlookError]);
    useEffect(function () {
        if (showOtpContainer) {
            clearInterval(timerObj$1);
            initTimer();
            // In case of phone number edit or first time send otp call uuid will not pass
            onSendOTP(action, email, VERiFY_OTP_ENUMS$1.OTP, '', otpPhoneNumber);
            setOTPSent(true);
            setResetInput(true);
            // Reset the otp count if user is updating the phone number or coming first time on this screen
            setShowOTPCall(false);
            setSendOTPCount(1);
            setIsEmailVerification(otpPhoneNumber ? false : true);
        }
    }, [action, email, features, otpPhoneNumber, showOtpContainer, onSendOTP]);
    useEffect(function () {
        if (timer === 0) {
            clearInterval(timerObj$1);
            toggleResendCode(true);
            setOTPSent(false);
            onActivateSendCallOTP();
            if (otpCount >= otpSMSSendLimit && (features === null || features === void 0 ? void 0 : features.isOTPCallEnabled)) {
                setShowOTPCall(true);
            }
        }
    }, [timer, otpCount, onActivateSendCallOTP, features]);
    var initTimer = function () {
        setTimer(59);
        timerObj$1 = setInterval(function () {
            setTimer(function (timer) { return timer - 1; });
        }, 1000);
    };
    var resetInput = function () {
        setResetInput(false);
    };
    var onCloseOTPVerifyModal = function () {
        if (showModalClose) {
            setOTPSuccess$1 && dispatch(setOTPSuccess$1(null));
            onCloseModal && onCloseModal(false);
        }
    };
    var tooglePhoneNumberModal = function () {
        setShowEditPhoneNumber(!showEditPhoneNumber);
    };
    var onPhoneNumberUpdate = function (phoneNumber) {
        clearInterval(timerObj$1);
        initTimer();
        tooglePhoneNumberModal();
        setOTPPhoneNumber(phoneNumber);
    };
    var onShowOtp = useCallback(function (type) {
        setShowOtpContainer(true);
        setOtpType(type);
    }, []);
    var getTimer = function () {
        var minutes = Math.floor(timer / 60);
        var seconds = timer - minutes * 60;
        return ((minutes < 10 ? '0' + minutes : minutes.toString()) + ':' + (seconds < 10 ? '0' + seconds : seconds.toString()));
    };
    var renderData = function () {
        return (React.createElement(React.Fragment, null,
            isShowLogo && (React.createElement(Box, { pb: 3 },
                React.createElement(CarrefourLogo, { size: "CUSTOM", height: 32, width: 128, fill: "#0e5aa7", storeId: storeId }))),
            ' ',
            serverError && (React.createElement(ErrorMessage$4, null,
                React.createElement(Warning, { fill: "#f34041" }),
                React.createElement(ErrorText$4, null, serverError))),
            loading && React.createElement(LinearProgress, { withBlock: true }),
            React.createElement(React.Fragment, null,
                !isForceVerify && otpData && (React.createElement(React.Fragment, null,
                    React.createElement(Flex, { my: "1" },
                        React.createElement(PageTitle$2, null, t('verifyOTP.' +
                            (accountVerificationActions.includes(action) ? 'verifyYourAccount' : 'verifyYourPhone')))),
                    React.createElement(Heading$2, null,
                        t('verifyOTP.fourDigitSecurityCodeSent'),
                        " ",
                        React.createElement(HighLightPhone$1, null, otpData.maskedPhoneNumber),
                        ' ',
                        isEmailVerification ? (React.createElement(React.Fragment, null,
                            t('verifyOTP.and'),
                            " ",
                            React.createElement(HighLightPhone$1, null, otpData.maskedEmail))) : ('')))),
                isForceVerify && (React.createElement(React.Fragment, null,
                    React.createElement(Flex, { my: "1" }, t('verifyOTP.hi') + " " + userName),
                    React.createElement(VerifyPhoneText$1, null, t('verifyOTP.letQuicklyVerifyYourPhone')),
                    React.createElement(VerificationCodeSent$1, { mt: 4, "data-sl": "mask" },
                        t('verifyOTP.verificationCodeSentTo'),
                        " ",
                        React.createElement("span", null, transformPhoneNo$1(otpPhoneNumber, language)),
                        ' ',
                        React.createElement(Button$1, { variant: "link", onClick: function () {
                                tooglePhoneNumberModal();
                            } },
                            React.createElement(Edit, null))))),
                React.createElement(InputContainerPadding$2, null,
                    React.createElement(OTPInput$1, { autoFocus: true, length: 4, className: "otpContainer", inputClassName: "otpInput", onChangeOTP: function (otp) { return changeOTP(otp); }, isResetInput: isResetInput, resetInput: resetInput }),
                    isOTPSent && !showOTPCall && React.createElement(OTPSentSuccess$1, null,
                        " ",
                        t('verifyOTP.otpSentSuccessfully'))),
                React.createElement(AlignCenter$1, null,
                    !showOTPCall && !(features === null || features === void 0 ? void 0 : features.isWhatsAppOtpEnabled) && (React.createElement(React.Fragment, null,
                        React.createElement(LoaderSpan$2, null,
                            React.createElement(Button$1, { onClick: function () { return onResendCodeClick(VERiFY_OTP_ENUMS$1.OTP); }, width: "100%", disabled: !isResendCodeEnable || resendCodeLoading, mb: 2 },
                                t('verifyOTP.resendCode'),
                                resendCodeLoading && React.createElement(LinearProgress, { withBlock: true }))),
                        (features === null || features === void 0 ? void 0 : features.isOTPCallEnabled) && otpCount > 1 && (React.createElement(Heading$2, null, t('verifyOTP.otpHasBeenSent', { otpCount: otpCount, otpSMSSendLimit: otpSMSSendLimit }))))),
                    (features === null || features === void 0 ? void 0 : features.isWhatsAppOtpEnabled) && action !== VERiFY_OTP_ENUMS$1.FORGOT_PASSWORD && (React.createElement(Box, { mb: 2, mt: 2, fontWeight: "bold" }, t('whatsAppOTP.TryAnotherVerificationMethod'))),
                    (showOTPCall || (features === null || features === void 0 ? void 0 : features.isWhatsAppOtpEnabled)) &&
                        (otpType !== VERiFY_OTP_ENUMS$1.VOICE ||
                            action == VERiFY_OTP_ENUMS$1.FORGOT_PASSWORD ||
                            action == VERiFY_OTP_ENUMS$1.PHONE_UPDATE_VERIFICATION) && (React.createElement(React.Fragment, null,
                        React.createElement(LoaderSpan$2, null,
                            React.createElement(Button$1, { onClick: function () { return onResendCodeClick(VERiFY_OTP_ENUMS$1.VOICE); }, width: "100%", disabled: !isResendCodeEnable || resendCodeLoading, mb: 2 },
                                React.createElement(PhoneWrapper$1, null,
                                    React.createElement(Phone, { size: 'M', fill: !isResendCodeEnable || resendCodeLoading ? '#000000' : '#FFFFFF' })),
                                t('verifyOTP.requestOTPBYCall'),
                                resendCodeLoading && React.createElement(LinearProgress, { withBlock: true }))))),
                    !isResendCodeEnable && otpType === VERiFY_OTP_ENUMS$1.VOICE && (React.createElement(Heading$2, null, t('verifyOTP.youWillReceiveCall'))),
                    (features === null || features === void 0 ? void 0 : features.isWhatsAppOtpEnabled) &&
                        action !== VERiFY_OTP_ENUMS$1.FORGOT_PASSWORD &&
                        otpType !== VERiFY_OTP_ENUMS$1.OTP && (React.createElement(Button$1, { onClick: function () { return onResendCodeClick(VERiFY_OTP_ENUMS$1.OTP); }, width: "100%", disabled: !isResendCodeEnable || resendCodeLoading, mb: 2 },
                        t('whatsAppOTP.RequestOTPBYSMS'),
                        resendCodeLoading && React.createElement(LinearProgress, { withBlock: true }))),
                    React.createElement(Box, { style: {
                            display: otpType !== VERiFY_OTP_ENUMS$1.WHATSAPP && (features === null || features === void 0 ? void 0 : features.isWhatsAppOtpEnabled) &&
                                action !== VERiFY_OTP_ENUMS$1.FORGOT_PASSWORD
                                ? 'block'
                                : 'none',
                        } },
                        React.createElement(RequestByWhatsAppOtp$1, { onShowOtp: onShowOtp, phoneNumber: phoneNumber, email: email, language: language, isResendCodeEnable: isResendCodeEnable, action: action })),
                    React.createElement(Timer$2, null, getTimer()),
                    isShowShopping && (React.createElement(Button$1, { onClick: onStartShoppingClick, variant: "link", fontWeight: "bold" }, t('verifyOTP.startShopping'))))),
            isShowLogo && (React.createElement(BroughtYouByWrapper$1, null, language === 'en' || language === 'ka' || language === 'ru' || language === 'uz' ? (React.createElement(MafLogoEn, { fill: COLORS$1.LIGHT_BROWN, size: "CUSTOM", height: 48, width: 164 })) : (React.createElement(MafLogoAr, { fill: COLORS$1.LIGHT_BROWN, size: "CUSTOM", height: 48, width: 164 }))))));
    };
    var bodyRender = function () {
        return !showOtpContainer && (features === null || features === void 0 ? void 0 : features.isWhatsAppOtpEnabled) && action !== VERiFY_OTP_ENUMS$1.FORGOT_PASSWORD ? (React.createElement(VerifyWhatsApp$1, { onShowOtp: onShowOtp, email: email, phoneNumber: phoneNumber, language: language, action: action })) : (renderData());
    };
    return (React.createElement(React.Fragment, null,
        isModal ? (React.createElement(Modal, __assign({ isOpen: true, title: isShowCloseButton ? '   ' : '', onClose: function () { return onCloseOTPVerifyModal(); }, backgroundColor: modalBackGroundColor, showClose: showModalClose }, rest), bodyRender())) : (bodyRender()),
        showEditPhoneNumber && (React.createElement(EditPhoneNumber$3, { isOpen: showEditPhoneNumber, onSuccess: onPhoneNumberUpdate, onClose: tooglePhoneNumberModal }))));
};
VerifyPassword$1.defaultProps = {
    isShowShopping: true,
    isModal: true,
    isShowLogo: false,
    isShowCloseButton: true,
};

var InputWrapper$3 = customStyled.div(templateObject_1$1z || (templateObject_1$1z = __makeTemplateObject(["\n  margin: 16px 0;\n"], ["\n  margin: 16px 0;\n"])));
var WarningMessage$3 = customStyled(Box)(templateObject_2$1g || (templateObject_2$1g = __makeTemplateObject(["\n  color:", ";\n  margin-top:10px;\n"], ["\n  color:", ";\n  margin-top:10px;\n"])), function (props) { return props.theme.colors.red; });
var ErrorMessage$5 = customStyled(Box)(templateObject_3$11 || (templateObject_3$11 = __makeTemplateObject(["\n  color: #f34041;\n  background-color:rgba(243,64,65,.05);\n  padding:20px;\n  text-align:center;\n  margin-bottom: 20px;\n"], ["\n  color: #f34041;\n  background-color:rgba(243,64,65,.05);\n  padding:20px;\n  text-align:center;\n  margin-bottom: 20px;\n"])));
var ErrorText$5 = customStyled.span(templateObject_4$T || (templateObject_4$T = __makeTemplateObject(["\n  margin-left:20px;\n"], ["\n  margin-left:20px;\n"])));
var LoaderSpan$3 = customStyled(Box)(templateObject_5$F || (templateObject_5$F = __makeTemplateObject(["\n  display: inline-flex;\n  position: relative;\n  width: 100%;\n  margin:", ";\n"], ["\n  display: inline-flex;\n  position: relative;\n  width: 100%;\n  margin:", ";\n"])), function (props) { return (props.m ? props.m + 'px 0px' : '0px'); });
var PageTitle$3 = customStyled(Text.H1)(templateObject_6$v || (templateObject_6$v = __makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
var SmallInputBox$1 = customStyled.div(templateObject_7$t || (templateObject_7$t = __makeTemplateObject(["\n  margin: 5px;\n  width: 30%;\n"], ["\n  margin: 5px;\n  width: 30%;\n"])));
var MidInputBox$1 = customStyled.div(templateObject_8$t || (templateObject_8$t = __makeTemplateObject(["\n  margin: 5px;\n  width: 65%;\n"], ["\n  margin: 5px;\n  width: 65%;\n"])));
var InputContainerPadding$3 = customStyled(Box)(templateObject_9$r || (templateObject_9$r = __makeTemplateObject(["\n  padding: 5px;\n  margin-bottom: 10px;\n  line-height: 20px;\n"], ["\n  padding: 5px;\n  margin-bottom: 10px;\n  line-height: 20px;\n"])));
var RadioButtonStyle$3 = customStyled(Box)(templateObject_10$q || (templateObject_10$q = __makeTemplateObject(["\n  margin: 5px;\n"], ["\n  margin: 5px;\n"])));
var IconStyle$1 = customStyled(Box)(templateObject_11$l || (templateObject_11$l = __makeTemplateObject(["\n  margin-right: 10px;\n  verticle-align:middle;\n"], ["\n  margin-right: 10px;\n  verticle-align:middle;\n"])));
var AccountIconStyle$1 = customStyled(Box)(templateObject_12$j || (templateObject_12$j = __makeTemplateObject(["\n  verticle-align:middle;\n  margin-top: 10px;\n"], ["\n  verticle-align:middle;\n  margin-top: 10px;\n"])));
var PhoneStyle$1 = customStyled(Box)(templateObject_13$i || (templateObject_13$i = __makeTemplateObject(["\n  padding-top: 3px;\n  margin-left:2px;\n"], ["\n  padding-top: 3px;\n  margin-left:2px;\n"])));
var FormContainer$2 = customStyled(Box)(templateObject_14$i || (templateObject_14$i = __makeTemplateObject(["\n  margin-top:20px;\n"], ["\n  margin-top:20px;\n"])));
var TermAndCondition$1 = customStyled(Box)(templateObject_15$i || (templateObject_15$i = __makeTemplateObject(["\n  margin:10px 0px;\n  padding-left:2px;\n  line-height:20px;\n"], ["\n  margin:10px 0px;\n  padding-left:2px;\n  line-height:20px;\n"])));
var DOBLabel$1 = customStyled(Box)(templateObject_16$e || (templateObject_16$e = __makeTemplateObject(["\n  margin: 16px 0px 0px 5px;\n  line-height: 1.8;\n  font-size: 16px;\n"], ["\n  margin: 16px 0px 0px 5px;\n  line-height: 1.8;\n  font-size: 16px;\n"])));
var CompleteProfileTitle$1 = customStyled(Text.H1)(templateObject_17$e || (templateObject_17$e = __makeTemplateObject(["\nfont-weight: bold;\ntext-align: center;\n"], ["\nfont-weight: bold;\ntext-align: center;\n"])));
CompleteProfileTitle$1.defaultProps = {
    my: 1,
};
var templateObject_1$1z, templateObject_2$1g, templateObject_3$11, templateObject_4$T, templateObject_5$F, templateObject_6$v, templateObject_7$t, templateObject_8$t, templateObject_9$r, templateObject_10$q, templateObject_11$l, templateObject_12$j, templateObject_13$i, templateObject_14$i, templateObject_15$i, templateObject_16$e, templateObject_17$e;

var STATIC_PAGE_LINKS$1 = {
    SHARE_TERM_AND_CONDITION: 'https://www.sharerewards.com/en/terms-and-conditions',
    TERM_AND_CONDITION: '/termsandconditions',
    UPDATE_PRIVACY_POLICY: '/updatePrivacyPolicy',
    PRIVACY_POLICY: '/privacypolicy',
};
var yearArr$1 = [];
for (var i$2 = new Date().getFullYear() - 18; i$2 >= 1915; i$2--) {
    yearArr$1.push({ id: i$2, label: i$2, value: i$2 });
}
var years$1 = yearArr$1;
var countries$3 = {
    en: [
        {
            value: 'TTO',
            label: 'Trinidad and Tobago',
        },
        {
            value: 'DMA',
            label: 'Dominica',
        },
        {
            value: 'KNA',
            label: 'Saint Kitts and Nevis',
        },
        {
            value: 'GNQ',
            label: 'Equatorial Guinea',
        },
        {
            value: 'ATG',
            label: 'Antigua and Barbuda',
        },
        {
            value: 'PNG',
            label: 'Papua New Guinea',
        },
        {
            value: 'VCT',
            label: 'Saint Vincent and the Grenadines',
        },
        {
            value: 'SLB',
            label: 'Solomon Islands',
        },
        {
            value: 'CAF',
            label: 'Central African Republic',
        },
        {
            value: 'COG',
            label: 'Republic of the Congo',
        },
        {
            value: 'GNB',
            label: 'Guinea-Bissau',
        },
        {
            value: 'LIE',
            label: 'Liechtenstein',
        },
        {
            value: 'COD',
            label: 'Democratic Republic of the Congo',
        },
        {
            value: 'DOM',
            label: 'Dominican Republic',
        },
        {
            value: 'SLE',
            label: 'Sierra Leone',
        },
        {
            value: 'SSD',
            label: 'South Sudan',
        },
        {
            value: 'NZL',
            label: 'New Zealand',
        },
        {
            value: 'ZAF',
            label: 'South Africa',
        },
        {
            value: 'CPV',
            label: 'Cape Verde',
        },
        {
            value: 'KOR',
            label: 'South Korea',
        },
        {
            value: 'LCA',
            label: 'Saint Lucia',
        },
        {
            value: 'LUX',
            label: 'Luxembourg',
        },
        {
            value: 'PRK',
            label: 'North Korea',
        },
        {
            value: 'SMR',
            label: 'San Marino',
        },
        {
            value: 'ARG',
            label: 'Argentina',
        },
        {
            value: 'AZE',
            label: 'Azerbaijan',
        },
        {
            value: 'BGD',
            label: 'Bangladesh',
        },
        {
            value: 'CMR',
            label: 'Cameroon',
        },
        {
            value: 'CRI',
            label: 'Costa Rica',
        },
        {
            value: 'FSM',
            label: 'Micronesia',
        },
        {
            value: 'KAZ',
            label: 'Kazakhstan',
        },
        {
            value: 'MHL',
            label: 'Marshall Islands',
        },
        {
            value: 'MNE',
            label: 'Montenegro',
        },
        {
            value: 'MRT',
            label: 'Mauritania',
        },
        {
            value: 'SGP',
            label: 'Singapore',
        },
        {
            value: 'SYC',
            label: 'Seychelles',
        },
        {
            value: 'UZB',
            label: 'Uzbekistan',
        },
        {
            value: 'VNM',
            label: 'Vietnam',
        },
        {
            value: 'AUS',
            label: 'Australia',
        },
        {
            value: 'BLR',
            label: 'Belarus',
        },
        {
            value: 'ECU',
            label: 'Ecuador',
        },
        {
            value: 'GTM',
            label: 'Guatemala',
        },
        {
            value: 'IDN',
            label: 'Indonesia',
        },
        {
            value: 'KIR',
            label: 'Kiribati',
        },
        {
            value: 'LKA',
            label: 'Sri Lanka',
        },
        {
            value: 'LTU',
            label: 'Lithuania',
        },
        {
            value: 'MKD',
            label: 'Macedonia',
        },
        {
            value: 'MOZ',
            label: 'Mozambique',
        },
        {
            value: 'NIC',
            label: 'Nicaragua',
        },
        {
            value: 'PAN',
            label: 'Panama',
        },
        {
            value: 'PRT',
            label: 'Portugal',
        },
        {
            value: 'PRY',
            label: 'Paraguay',
        },
        {
            value: 'SEN',
            label: 'Senegal',
        },
        {
            value: 'SLV',
            label: 'El Salvador',
        },
        {
            value: 'STP',
            label: 'Sao Tome and Principe',
        },
        {
            value: 'TZA',
            label: 'Tanzania',
        },
        {
            value: 'VEN',
            label: 'Venezuela',
        },
        {
            value: 'ZWE',
            label: 'Zimbabwe',
        },
        {
            value: 'BDI',
            label: 'Burundi',
        },
        {
            value: 'BFA',
            label: 'Burkina Faso',
        },
        {
            value: 'BGR',
            label: 'Bulgaria',
        },
        {
            value: 'BHS',
            label: 'Bahamas',
        },
        {
            value: 'BRA',
            label: 'Brazil',
        },
        {
            value: 'BRB',
            label: 'Barbados',
        },
        {
            value: 'BRN',
            label: 'Brunei',
        },
        {
            value: 'BTN',
            label: 'Bhutan',
        },
        {
            value: 'COL',
            label: 'Colombia',
        },
        {
            value: 'ETH',
            label: 'Ethiopia',
        },
        {
            value: 'GRD',
            label: 'Grenada',
        },
        {
            value: 'HUN',
            label: 'Hungary',
        },
        {
            value: 'ISL',
            label: 'Iceland',
        },
        {
            value: 'JOR',
            label: 'Jordan',
        },
        {
            value: 'KHM',
            label: 'Cambodia',
        },
        {
            value: 'MDA',
            label: 'Moldova',
        },
        {
            value: 'MNG',
            label: 'Mongolia',
        },
        {
            value: 'MUS',
            label: 'Mauritius',
        },
        {
            value: 'MYS',
            label: 'Malaysia',
        },
        {
            value: 'NOR',
            label: 'Norway',
        },
        {
            value: 'PAK',
            label: 'Pakistan',
        },
        {
            value: 'PHL',
            label: 'Philippines',
        },
        {
            value: 'SUR',
            label: 'Suriname',
        },
        {
            value: 'SVK',
            label: 'Slovakia',
        },
        {
            value: 'SVN',
            label: 'Slovenia',
        },
        {
            value: 'UKR',
            label: 'Ukraine',
        },
        {
            value: 'URY',
            label: 'Uruguay',
        },
        {
            value: 'VUT',
            label: 'Vanuatu',
        },
        {
            value: 'ALB',
            label: 'Albania',
        },
        {
            value: 'AND',
            label: 'Andorra',
        },
        {
            value: 'ARM',
            label: 'Armenia',
        },
        {
            value: 'AUT',
            label: 'Austria',
        },
        {
            value: 'BEN',
            label: 'Benin',
        },
        {
            value: 'BHR',
            label: 'Bahrain',
        },
        {
            value: 'BLZ',
            label: 'Belize',
        },
        {
            value: 'BOL',
            label: 'Bolivia',
        },
        {
            value: 'BWA',
            label: 'Botswana',
        },
        {
            value: 'CAN',
            label: 'Canada',
        },
        {
            value: 'DJI',
            label: 'Djibouti',
        },
        {
            value: 'DZA',
            label: 'Algeria',
        },
        {
            value: 'EGY',
            label: 'Egypt',
        },
        {
            value: 'ERI',
            label: 'Eritrea',
        },
        {
            value: 'EST',
            label: 'Estonia',
        },
        {
            value: 'GAB',
            label: 'Gabon',
        },
        {
            value: 'GEO',
            label: 'Georgia',
        },
        {
            value: 'GHA',
            label: 'Ghana',
        },
        {
            value: 'GUY',
            label: 'Guyana',
        },
        {
            value: 'HND',
            label: 'Honduras',
        },
        {
            value: 'HRV',
            label: 'Croatia',
        },
        {
            value: 'JAM',
            label: 'Jamaica',
        },
        {
            value: 'JPN',
            label: 'Japan',
        },
        {
            value: 'LBN',
            label: 'Lebanon',
        },
        {
            value: 'LBR',
            label: 'Liberia',
        },
        {
            value: 'MAR',
            label: 'Morocco',
        },
        {
            value: 'MDG',
            label: 'Madagascar',
        },
        {
            value: 'MDV',
            label: 'Maldives',
        },
        {
            value: 'MMR',
            label: 'Myanmar',
        },
        {
            value: 'MWI',
            label: 'Malawi',
        },
        {
            value: 'NAM',
            label: 'Namibia',
        },
        {
            value: 'NER',
            label: 'Niger',
        },
        {
            value: 'NGA',
            label: 'Nigeria',
        },
        {
            value: 'NPL',
            label: 'Nepal',
        },
        {
            value: 'PER',
            label: 'Peru',
        },
        {
            value: 'ROU',
            label: 'Romania',
        },
        {
            value: 'SDN',
            label: 'Sudan',
        },
        {
            value: 'TGO',
            label: 'Togo',
        },
        {
            value: 'TLS',
            label: 'East Timor',
        },
        {
            value: 'TUN',
            label: 'Tunisia',
        },
        {
            value: 'TUV',
            label: 'Tuvalu',
        },
        {
            value: 'USA',
            label: 'United States of America',
        },
        {
            value: 'AGO',
            label: 'Angola',
        },
        {
            value: 'ARE',
            label: 'United Arab Emirates',
        },
        {
            value: 'BEL',
            label: 'Belgium',
        },
        {
            value: 'BIH',
            label: 'Bosnia and Herzegovina',
        },
        {
            value: 'CHL',
            label: 'Chile',
        },
        {
            value: 'CHN',
            label: 'China',
        },
        {
            value: 'CIV',
            label: 'Ivory Coast',
        },
        {
            value: 'COM',
            label: 'Comoros',
        },
        {
            value: 'CYP',
            label: 'Cyprus',
        },
        {
            value: 'ESP',
            label: 'Spain',
        },
        {
            value: 'FIN',
            label: 'Finland',
        },
        {
            value: 'GBR',
            label: 'United Kingdom',
        },
        {
            value: 'GIN',
            label: 'Guinea',
        },
        {
            value: 'GMB',
            label: 'Gambia',
        },
        {
            value: 'HTI',
            label: 'Haiti',
        },
        {
            value: 'ITA',
            label: 'Italy',
        },
        {
            value: 'KWT',
            label: 'Kuwait',
        },
        {
            value: 'LSO',
            label: 'Lesotho',
        },
        {
            value: 'LVA',
            label: 'Latvia',
        },
        {
            value: 'MCO',
            label: 'Monaco',
        },
        {
            value: 'MEX',
            label: 'Mexico',
        },
        {
            value: 'MLT',
            label: 'Malta',
        },
        {
            value: 'NRU',
            label: 'Nauru',
        },
        {
            value: 'PLW',
            label: 'Palau',
        },
        {
            value: 'RUS',
            label: 'Russia',
        },
        {
            value: 'RWA',
            label: 'Rwanda',
        },
        {
            value: 'SRB',
            label: 'Serbia',
        },
        {
            value: 'SWE',
            label: 'Sweden',
        },
        {
            value: 'TCD',
            label: 'Chad',
        },
        {
            value: 'TKM',
            label: 'Turkmenistan',
        },
        {
            value: 'TUR',
            label: 'Turkey',
        },
        {
            value: 'UGA',
            label: 'Uganda',
        },
        {
            value: 'ZMB',
            label: 'Zambia',
        },
        {
            value: 'AFG',
            label: 'Afghanistan',
        },
        {
            value: 'DEU',
            label: 'Germany',
        },
        {
            value: 'DNK',
            label: 'Denmark',
        },
        {
            value: 'FJI',
            label: 'Fiji',
        },
        {
            value: 'FRA',
            label: 'France',
        },
        {
            value: 'IND',
            label: 'India',
        },
        {
            value: 'KEN',
            label: 'Kenya',
        },
        {
            value: 'KGZ',
            label: 'Kyrgyzstan',
        },
        {
            value: 'LBY',
            label: 'Libya',
        },
        {
            value: 'MLI',
            label: 'Mali',
        },
        {
            value: 'POL',
            label: 'Poland',
        },
        {
            value: 'SOM',
            label: 'Somalia',
        },
        {
            value: 'SYR',
            label: 'Syria',
        },
        {
            value: 'TON',
            label: 'Tonga',
        },
        {
            value: 'WSM',
            label: 'Samoa',
        },
        {
            value: 'YEM',
            label: 'Yemen',
        },
        {
            value: 'CHE',
            label: 'Switzerland',
        },
        {
            value: 'CUB',
            label: 'Cuba',
        },
        {
            value: 'CZE',
            label: 'Czech Republic',
        },
        {
            value: 'GRC',
            label: 'Greece',
        },
        {
            value: 'IRL',
            label: 'Ireland',
        },
        {
            value: 'IRQ',
            label: 'Iraq',
        },
        {
            value: 'NLD',
            label: 'Netherlands',
        },
        {
            value: 'OMN',
            label: 'Oman',
        },
        {
            value: 'SAU',
            label: 'Saudi Arabia',
        },
        {
            value: 'SWZ',
            label: 'Eswatini',
        },
        {
            value: 'TJK',
            label: 'Tajikistan',
        },
        {
            value: 'THA',
            label: 'Thailand',
        },
        {
            value: 'LAO',
            label: 'Laos',
        },
        {
            value: 'QAT',
            label: 'Qatar',
        },
        {
            value: 'IRN',
            label: 'Iran',
        },
        {
            value: 'PSE',
            label: 'Palestine',
        },
    ],
    ar: [
        {
            value: 'TTO',
            label: 'ترينيداد وتوباغو',
        },
        {
            value: 'DMA',
            label: 'دومينيكا',
        },
        {
            value: 'KNA',
            label: 'سانت كيتس ونيفس',
        },
        {
            value: 'GNQ',
            label: 'غينيا الاستوائي',
        },
        {
            value: 'ATG',
            label: 'أنتيغوا وبربودا',
        },
        {
            value: 'PNG',
            label: 'بابوا غينيا الجديدة',
        },
        {
            value: 'VCT',
            label: 'سانت فنسنت وجزر غرينادين',
        },
        {
            value: 'SLB',
            label: 'جزر سليمان',
        },
        {
            value: 'CAF',
            label: 'جمهورية أفريقيا الوسطى',
        },
        {
            value: 'COG',
            label: 'جمهورية الكونغو',
        },
        {
            value: 'GNB',
            label: 'غينيا-بيساو',
        },
        {
            value: 'LIE',
            label: 'ليختنشتين',
        },
        {
            value: 'COD',
            label: 'جمهورية الكونغو الديمقراطية',
        },
        {
            value: 'DOM',
            label: 'الجمهورية الدومينيكية',
        },
        {
            value: 'SLE',
            label: 'سيراليون',
        },
        {
            value: 'SSD',
            label: 'جنوب السودان',
        },
        {
            value: 'NZL',
            label: 'نيوزيلندا',
        },
        {
            value: 'ZAF',
            label: 'جنوب أفريقيا',
        },
        {
            value: 'CPV',
            label: 'الرأس الأخضر',
        },
        {
            value: 'KOR',
            label: 'كوريا الجنوبية',
        },
        {
            value: 'LCA',
            label: 'سانت لوسيا',
        },
        {
            value: 'LUX',
            label: 'لوكسمبورغ',
        },
        {
            value: 'PRK',
            label: 'كوريا الشمالية',
        },
        {
            value: 'SMR',
            label: 'سان مارينو',
        },
        {
            value: 'ARG',
            label: 'الأرجنتين',
        },
        {
            value: 'AZE',
            label: 'أذربيجان',
        },
        {
            value: 'BGD',
            label: 'بنغلاديش',
        },
        {
            value: 'CMR',
            label: 'كاميرون',
        },
        {
            value: 'CRI',
            label: 'كوستاريكا',
        },
        {
            value: 'FSM',
            label: 'ولايات ميكرونيسيا المتحدة',
        },
        {
            value: 'KAZ',
            label: 'كازاخستان',
        },
        {
            value: 'MHL',
            label: 'جزر مارشال',
        },
        {
            value: 'MNE',
            label: 'الجبل الأسو',
        },
        {
            value: 'MRT',
            label: 'موريتانيا',
        },
        {
            value: 'SGP',
            label: 'سنغافورة',
        },
        {
            value: 'SYC',
            label: 'سيشيل',
        },
        {
            value: 'UZB',
            label: 'أوزباكستان',
        },
        {
            value: 'VNM',
            label: 'فيتنام',
        },
        {
            value: 'AUS',
            label: 'أستراليا',
        },
        {
            value: 'BLR',
            label: 'روسيا البيضاء',
        },
        {
            value: 'ECU',
            label: 'إكوادور',
        },
        {
            value: 'GTM',
            label: 'غواتيمال',
        },
        {
            value: 'IDN',
            label: 'أندونيسيا',
        },
        {
            value: 'KIR',
            label: 'كيريباتي',
        },
        {
            value: 'LKA',
            label: 'سريلانكا',
        },
        {
            value: 'LTU',
            label: 'لتوانيا',
        },
        {
            value: 'MKD',
            label: 'جمهورية مقدونيا',
        },
        {
            value: 'MOZ',
            label: 'موزمبيق',
        },
        {
            value: 'NIC',
            label: 'نيكاراجوا',
        },
        {
            value: 'PAN',
            label: 'بنما',
        },
        {
            value: 'PRT',
            label: 'البرتغال',
        },
        {
            value: 'PRY',
            label: 'باراغواي',
        },
        {
            value: 'SEN',
            label: 'السنغال',
        },
        {
            value: 'SLV',
            label: 'إلسلفادور',
        },
        {
            value: 'STP',
            label: 'ساو تومي وبرينسيبي',
        },
        {
            value: 'TZA',
            label: 'تنزانيا',
        },
        {
            value: 'VEN',
            label: 'فنزويلا',
        },
        {
            value: 'ZWE',
            label: 'زمبابوي',
        },
        {
            value: 'BDI',
            label: 'بوروندي',
        },
        {
            value: 'BFA',
            label: 'بوركينا فاسو',
        },
        {
            value: 'BGR',
            label: 'بلغاريا',
        },
        {
            value: 'BHS',
            label: 'الباهاماس',
        },
        {
            value: 'BRA',
            label: 'البرازيل',
        },
        {
            value: 'BRB',
            label: 'بربادوس',
        },
        {
            value: 'BRN',
            label: 'بروناي',
        },
        {
            value: 'BTN',
            label: 'بوتان',
        },
        {
            value: 'COL',
            label: 'كولومبيا',
        },
        {
            value: 'ETH',
            label: 'أثيوبيا',
        },
        {
            value: 'GRD',
            label: 'غرينادا',
        },
        {
            value: 'HUN',
            label: 'المجر',
        },
        {
            value: 'ISL',
            label: 'آيسلندا',
        },
        {
            value: 'JOR',
            label: 'الأردن',
        },
        {
            value: 'KHM',
            label: 'كمبوديا',
        },
        {
            value: 'MDA',
            label: 'مولدافيا',
        },
        {
            value: 'MNG',
            label: 'منغوليا',
        },
        {
            value: 'MUS',
            label: 'موريشيوس',
        },
        {
            value: 'MYS',
            label: 'ماليزيا',
        },
        {
            value: 'NOR',
            label: 'النرويج',
        },
        {
            value: 'PAK',
            label: 'باكستان',
        },
        {
            value: 'PHL',
            label: 'الفليبين',
        },
        {
            value: 'SUR',
            label: 'سورينام',
        },
        {
            value: 'SVK',
            label: 'سلوفاكيا',
        },
        {
            value: 'SVN',
            label: 'سلوفينيا',
        },
        {
            value: 'UKR',
            label: 'أوكرانيا',
        },
        {
            value: 'URY',
            label: 'أورغواي',
        },
        {
            value: 'VUT',
            label: 'فانواتو',
        },
        {
            value: 'ALB',
            label: 'ألبانيا',
        },
        {
            value: 'AND',
            label: 'أندورا',
        },
        {
            value: 'ARM',
            label: 'أرمينيا',
        },
        {
            value: 'AUT',
            label: 'النمسا',
        },
        {
            value: 'BEN',
            label: 'بنين',
        },
        {
            value: 'BHR',
            label: 'البحرين',
        },
        {
            value: 'BLZ',
            label: 'بيليز',
        },
        {
            value: 'BOL',
            label: 'بوليفيا',
        },
        {
            value: 'BWA',
            label: 'بوتسوانا',
        },
        {
            value: 'CAN',
            label: 'كندا',
        },
        {
            value: 'DJI',
            label: 'جيبوتي',
        },
        {
            value: 'DZA',
            label: 'الجزائر',
        },
        {
            value: 'EGY',
            label: 'مصر',
        },
        {
            value: 'ERI',
            label: 'إريتريا',
        },
        {
            value: 'EST',
            label: 'استونيا',
        },
        {
            value: 'GAB',
            label: 'الغابون',
        },
        {
            value: 'GEO',
            label: 'جيورجيا',
        },
        {
            value: 'GHA',
            label: 'غانا',
        },
        {
            value: 'GUY',
            label: 'غيانا',
        },
        {
            value: 'HND',
            label: 'هندوراس',
        },
        {
            value: 'HRV',
            label: 'كرواتيا',
        },
        {
            value: 'JAM',
            label: 'جمايكا',
        },
        {
            value: 'JPN',
            label: 'اليابان',
        },
        {
            value: 'LBN',
            label: 'لبنان',
        },
        {
            value: 'LBR',
            label: 'ليبيريا',
        },
        {
            value: 'MAR',
            label: 'المغرب',
        },
        {
            value: 'MDG',
            label: 'مدغشقر',
        },
        {
            value: 'MDV',
            label: 'المالديف',
        },
        {
            value: 'MMR',
            label: 'ميانمار',
        },
        {
            value: 'MWI',
            label: 'مالاوي',
        },
        {
            value: 'NAM',
            label: 'ناميبيا',
        },
        {
            value: 'NER',
            label: 'النيجر',
        },
        {
            value: 'NGA',
            label: 'نيجيريا',
        },
        {
            value: 'NPL',
            label: 'نيبال',
        },
        {
            value: 'PER',
            label: 'بيرو',
        },
        {
            value: 'ROU',
            label: 'رومانيا',
        },
        {
            value: 'SDN',
            label: 'السودان',
        },
        {
            value: 'TGO',
            label: 'توغو',
        },
        {
            value: 'TLS',
            label: 'تيمور الشرقية',
        },
        {
            value: 'TUN',
            label: 'تونس',
        },
        {
            value: 'TUV',
            label: 'توفالو',
        },
        {
            value: 'USA',
            label: 'الولايات المتحدة',
        },
        {
            value: 'AGO',
            label: 'أنغولا',
        },
        {
            value: 'ARE',
            label: 'الإمارات العربية المتحدة',
        },
        {
            value: 'BEL',
            label: 'بلجيكا',
        },
        {
            value: 'BIH',
            label: 'البوسنة و الهرسك',
        },
        {
            value: 'CHL',
            label: 'تشيلي',
        },
        {
            value: 'CHN',
            label: 'جمهورية الصين الشعبية',
        },
        {
            value: 'CIV',
            label: 'ساحل العاج',
        },
        {
            value: 'COM',
            label: 'جزر القمر',
        },
        {
            value: 'CYP',
            label: 'قبرص',
        },
        {
            value: 'ESP',
            label: 'إسبانيا',
        },
        {
            value: 'FIN',
            label: 'فنلندا',
        },
        {
            value: 'GBR',
            label: 'المملكة المتحدة',
        },
        {
            value: 'GIN',
            label: 'غينيا',
        },
        {
            value: 'GMB',
            label: 'غامبيا',
        },
        {
            value: 'HTI',
            label: 'هايتي',
        },
        {
            value: 'ITA',
            label: 'إيطاليا',
        },
        {
            value: 'KWT',
            label: 'الكويت',
        },
        {
            value: 'LSO',
            label: 'ليسوتو',
        },
        {
            value: 'LVA',
            label: 'لاتفيا',
        },
        {
            value: 'MCO',
            label: 'موناكو',
        },
        {
            value: 'MEX',
            label: 'المكسيك',
        },
        {
            value: 'MLT',
            label: 'مالطا',
        },
        {
            value: 'NRU',
            label: 'ناورو',
        },
        {
            value: 'PLW',
            label: 'بالاو',
        },
        {
            value: 'RUS',
            label: 'روسيا',
        },
        {
            value: 'RWA',
            label: 'رواندا',
        },
        {
            value: 'SRB',
            label: 'جمهورية صربيا',
        },
        {
            value: 'SWE',
            label: 'السويد',
        },
        {
            value: 'TCD',
            label: 'تشاد',
        },
        {
            value: 'TKM',
            label: 'تركمانستان',
        },
        {
            value: 'TUR',
            label: 'تركيا',
        },
        {
            value: 'UGA',
            label: 'أوغندا',
        },
        {
            value: 'ZMB',
            label: 'زامبيا',
        },
        {
            value: 'AFG',
            label: 'أفغانستان',
        },
        {
            value: 'DEU',
            label: 'ألمانيا',
        },
        {
            value: 'DNK',
            label: 'الدانمارك',
        },
        {
            value: 'FJI',
            label: 'فيجي',
        },
        {
            value: 'FRA',
            label: 'فرنسا',
        },
        {
            value: 'IND',
            label: 'الهند',
        },
        {
            value: 'KEN',
            label: 'كينيا',
        },
        {
            value: 'KGZ',
            label: 'قيرغيزستان',
        },
        {
            value: 'LBY',
            label: 'ليبيا',
        },
        {
            value: 'MLI',
            label: 'مالي',
        },
        {
            value: 'POL',
            label: 'بولندا',
        },
        {
            value: 'SOM',
            label: 'الصومال',
        },
        {
            value: 'SYR',
            label: 'سوريا',
        },
        {
            value: 'TON',
            label: 'تونغا',
        },
        {
            value: 'WSM',
            label: 'ساموا',
        },
        {
            value: 'YEM',
            label: 'اليمن',
        },
        {
            value: 'CHE',
            label: 'سويسرا',
        },
        {
            value: 'CUB',
            label: 'كوبا',
        },
        {
            value: 'CZE',
            label: 'الجمهورية التشيكية',
        },
        {
            value: 'GRC',
            label: 'اليونان',
        },
        {
            value: 'IRL',
            label: 'جمهورية أيرلندا',
        },
        {
            value: 'IRQ',
            label: 'العراق',
        },
        {
            value: 'NLD',
            label: 'هولندا',
        },
        {
            value: 'OMN',
            label: 'عُمان',
        },
        {
            value: 'SAU',
            label: 'المملكة العربية السعودية',
        },
        {
            value: 'SWZ',
            label: 'مملكة إسواتيني',
        },
        {
            value: 'TJK',
            label: 'طاجيكستان',
        },
        {
            value: 'THA',
            label: 'تايلندا',
        },
        {
            value: 'LAO',
            label: 'لائوس',
        },
        {
            value: 'QAT',
            label: 'قطر',
        },
        {
            value: 'IRN',
            label: 'إيران',
        },
        {
            value: 'PSE',
            label: 'فلسطين',
        },
    ],
    ka: [
        {
            value: 'TTO',
            label: 'Trinidad and Tobago',
        },
        {
            value: 'DMA',
            label: 'Dominica',
        },
        {
            value: 'KNA',
            label: 'Saint Kitts and Nevis',
        },
        {
            value: 'GNQ',
            label: 'Equatorial Guinea',
        },
        {
            value: 'ATG',
            label: 'Antigua and Barbuda',
        },
        {
            value: 'PNG',
            label: 'Papua New Guinea',
        },
        {
            value: 'VCT',
            label: 'Saint Vincent and the Grenadines',
        },
        {
            value: 'SLB',
            label: 'Solomon Islands',
        },
        {
            value: 'CAF',
            label: 'Central African Republic',
        },
        {
            value: 'COG',
            label: 'Republic of the Congo',
        },
        {
            value: 'GNB',
            label: 'Guinea-Bissau',
        },
        {
            value: 'LIE',
            label: 'Liechtenstein',
        },
        {
            value: 'COD',
            label: 'Democratic Republic of the Congo',
        },
        {
            value: 'DOM',
            label: 'Dominican Republic',
        },
        {
            value: 'SLE',
            label: 'Sierra Leone',
        },
        {
            value: 'SSD',
            label: 'South Sudan',
        },
        {
            value: 'NZL',
            label: 'New Zealand',
        },
        {
            value: 'ZAF',
            label: 'South Africa',
        },
        {
            value: 'CPV',
            label: 'Cape Verde',
        },
        {
            value: 'KOR',
            label: 'South Korea',
        },
        {
            value: 'LCA',
            label: 'Saint Lucia',
        },
        {
            value: 'LUX',
            label: 'Luxembourg',
        },
        {
            value: 'PRK',
            label: 'North Korea',
        },
        {
            value: 'SMR',
            label: 'San Marino',
        },
        {
            value: 'ARG',
            label: 'Argentina',
        },
        {
            value: 'AZE',
            label: 'Azerbaijan',
        },
        {
            value: 'BGD',
            label: 'Bangladesh',
        },
        {
            value: 'CMR',
            label: 'Cameroon',
        },
        {
            value: 'CRI',
            label: 'Costa Rica',
        },
        {
            value: 'FSM',
            label: 'Micronesia',
        },
        {
            value: 'KAZ',
            label: 'Kazakhstan',
        },
        {
            value: 'MHL',
            label: 'Marshall Islands',
        },
        {
            value: 'MNE',
            label: 'Montenegro',
        },
        {
            value: 'MRT',
            label: 'Mauritania',
        },
        {
            value: 'SGP',
            label: 'Singapore',
        },
        {
            value: 'SYC',
            label: 'Seychelles',
        },
        {
            value: 'UZB',
            label: 'Uzbekistan',
        },
        {
            value: 'VNM',
            label: 'Vietnam',
        },
        {
            value: 'AUS',
            label: 'Australia',
        },
        {
            value: 'BLR',
            label: 'Belarus',
        },
        {
            value: 'ECU',
            label: 'Ecuador',
        },
        {
            value: 'GTM',
            label: 'Guatemala',
        },
        {
            value: 'IDN',
            label: 'Indonesia',
        },
        {
            value: 'KIR',
            label: 'Kiribati',
        },
        {
            value: 'LKA',
            label: 'Sri Lanka',
        },
        {
            value: 'LTU',
            label: 'Lithuania',
        },
        {
            value: 'MKD',
            label: 'Macedonia',
        },
        {
            value: 'MOZ',
            label: 'Mozambique',
        },
        {
            value: 'NIC',
            label: 'Nicaragua',
        },
        {
            value: 'PAN',
            label: 'Panama',
        },
        {
            value: 'PRT',
            label: 'Portugal',
        },
        {
            value: 'PRY',
            label: 'Paraguay',
        },
        {
            value: 'SEN',
            label: 'Senegal',
        },
        {
            value: 'SLV',
            label: 'El Salvador',
        },
        {
            value: 'STP',
            label: 'Sao Tome and Principe',
        },
        {
            value: 'TZA',
            label: 'Tanzania',
        },
        {
            value: 'VEN',
            label: 'Venezuela',
        },
        {
            value: 'ZWE',
            label: 'Zimbabwe',
        },
        {
            value: 'BDI',
            label: 'Burundi',
        },
        {
            value: 'BFA',
            label: 'Burkina Faso',
        },
        {
            value: 'BGR',
            label: 'Bulgaria',
        },
        {
            value: 'BHS',
            label: 'Bahamas',
        },
        {
            value: 'BRA',
            label: 'Brazil',
        },
        {
            value: 'BRB',
            label: 'Barbados',
        },
        {
            value: 'BRN',
            label: 'Brunei',
        },
        {
            value: 'BTN',
            label: 'Bhutan',
        },
        {
            value: 'COL',
            label: 'Colombia',
        },
        {
            value: 'ETH',
            label: 'Ethiopia',
        },
        {
            value: 'GRD',
            label: 'Grenada',
        },
        {
            value: 'HUN',
            label: 'Hungary',
        },
        {
            value: 'ISL',
            label: 'Iceland',
        },
        {
            value: 'JOR',
            label: 'Jordan',
        },
        {
            value: 'KHM',
            label: 'Cambodia',
        },
        {
            value: 'MDA',
            label: 'Moldova',
        },
        {
            value: 'MNG',
            label: 'Mongolia',
        },
        {
            value: 'MUS',
            label: 'Mauritius',
        },
        {
            value: 'MYS',
            label: 'Malaysia',
        },
        {
            value: 'NOR',
            label: 'Norway',
        },
        {
            value: 'PAK',
            label: 'Pakistan',
        },
        {
            value: 'PHL',
            label: 'Philippines',
        },
        {
            value: 'SUR',
            label: 'Suriname',
        },
        {
            value: 'SVK',
            label: 'Slovakia',
        },
        {
            value: 'SVN',
            label: 'Slovenia',
        },
        {
            value: 'UKR',
            label: 'Ukraine',
        },
        {
            value: 'URY',
            label: 'Uruguay',
        },
        {
            value: 'VUT',
            label: 'Vanuatu',
        },
        {
            value: 'ALB',
            label: 'Albania',
        },
        {
            value: 'AND',
            label: 'Andorra',
        },
        {
            value: 'ARM',
            label: 'Armenia',
        },
        {
            value: 'AUT',
            label: 'Austria',
        },
        {
            value: 'BEN',
            label: 'Benin',
        },
        {
            value: 'BHR',
            label: 'Bahrain',
        },
        {
            value: 'BLZ',
            label: 'Belize',
        },
        {
            value: 'BOL',
            label: 'Bolivia',
        },
        {
            value: 'BWA',
            label: 'Botswana',
        },
        {
            value: 'CAN',
            label: 'Canada',
        },
        {
            value: 'DJI',
            label: 'Djibouti',
        },
        {
            value: 'DZA',
            label: 'Algeria',
        },
        {
            value: 'EGY',
            label: 'Egypt',
        },
        {
            value: 'ERI',
            label: 'Eritrea',
        },
        {
            value: 'EST',
            label: 'Estonia',
        },
        {
            value: 'GAB',
            label: 'Gabon',
        },
        {
            value: 'GEO',
            label: 'Georgia',
        },
        {
            value: 'GHA',
            label: 'Ghana',
        },
        {
            value: 'GUY',
            label: 'Guyana',
        },
        {
            value: 'HND',
            label: 'Honduras',
        },
        {
            value: 'HRV',
            label: 'Croatia',
        },
        {
            value: 'JAM',
            label: 'Jamaica',
        },
        {
            value: 'JPN',
            label: 'Japan',
        },
        {
            value: 'LBN',
            label: 'Lebanon',
        },
        {
            value: 'LBR',
            label: 'Liberia',
        },
        {
            value: 'MAR',
            label: 'Morocco',
        },
        {
            value: 'MDG',
            label: 'Madagascar',
        },
        {
            value: 'MDV',
            label: 'Maldives',
        },
        {
            value: 'MMR',
            label: 'Myanmar',
        },
        {
            value: 'MWI',
            label: 'Malawi',
        },
        {
            value: 'NAM',
            label: 'Namibia',
        },
        {
            value: 'NER',
            label: 'Niger',
        },
        {
            value: 'NGA',
            label: 'Nigeria',
        },
        {
            value: 'NPL',
            label: 'Nepal',
        },
        {
            value: 'PER',
            label: 'Peru',
        },
        {
            value: 'ROU',
            label: 'Romania',
        },
        {
            value: 'SDN',
            label: 'Sudan',
        },
        {
            value: 'TGO',
            label: 'Togo',
        },
        {
            value: 'TLS',
            label: 'East Timor',
        },
        {
            value: 'TUN',
            label: 'Tunisia',
        },
        {
            value: 'TUV',
            label: 'Tuvalu',
        },
        {
            value: 'USA',
            label: 'United States of America',
        },
        {
            value: 'AGO',
            label: 'Angola',
        },
        {
            value: 'ARE',
            label: 'United Arab Emirates',
        },
        {
            value: 'BEL',
            label: 'Belgium',
        },
        {
            value: 'BIH',
            label: 'Bosnia and Herzegovina',
        },
        {
            value: 'CHL',
            label: 'Chile',
        },
        {
            value: 'CHN',
            label: 'China',
        },
        {
            value: 'CIV',
            label: 'Ivory Coast',
        },
        {
            value: 'COM',
            label: 'Comoros',
        },
        {
            value: 'CYP',
            label: 'Cyprus',
        },
        {
            value: 'ESP',
            label: 'Spain',
        },
        {
            value: 'FIN',
            label: 'Finland',
        },
        {
            value: 'GBR',
            label: 'United Kingdom',
        },
        {
            value: 'GIN',
            label: 'Guinea',
        },
        {
            value: 'GMB',
            label: 'Gambia',
        },
        {
            value: 'HTI',
            label: 'Haiti',
        },
        {
            value: 'ITA',
            label: 'Italy',
        },
        {
            value: 'KWT',
            label: 'Kuwait',
        },
        {
            value: 'LSO',
            label: 'Lesotho',
        },
        {
            value: 'LVA',
            label: 'Latvia',
        },
        {
            value: 'MCO',
            label: 'Monaco',
        },
        {
            value: 'MEX',
            label: 'Mexico',
        },
        {
            value: 'MLT',
            label: 'Malta',
        },
        {
            value: 'NRU',
            label: 'Nauru',
        },
        {
            value: 'PLW',
            label: 'Palau',
        },
        {
            value: 'RUS',
            label: 'Russia',
        },
        {
            value: 'RWA',
            label: 'Rwanda',
        },
        {
            value: 'SRB',
            label: 'Serbia',
        },
        {
            value: 'SWE',
            label: 'Sweden',
        },
        {
            value: 'TCD',
            label: 'Chad',
        },
        {
            value: 'TKM',
            label: 'Turkmenistan',
        },
        {
            value: 'TUR',
            label: 'Turkey',
        },
        {
            value: 'UGA',
            label: 'Uganda',
        },
        {
            value: 'ZMB',
            label: 'Zambia',
        },
        {
            value: 'AFG',
            label: 'Afghanistan',
        },
        {
            value: 'DEU',
            label: 'Germany',
        },
        {
            value: 'DNK',
            label: 'Denmark',
        },
        {
            value: 'FJI',
            label: 'Fiji',
        },
        {
            value: 'FRA',
            label: 'France',
        },
        {
            value: 'IND',
            label: 'India',
        },
        {
            value: 'KEN',
            label: 'Kenya',
        },
        {
            value: 'KGZ',
            label: 'Kyrgyzstan',
        },
        {
            value: 'LBY',
            label: 'Libya',
        },
        {
            value: 'MLI',
            label: 'Mali',
        },
        {
            value: 'POL',
            label: 'Poland',
        },
        {
            value: 'SOM',
            label: 'Somalia',
        },
        {
            value: 'SYR',
            label: 'Syria',
        },
        {
            value: 'TON',
            label: 'Tonga',
        },
        {
            value: 'WSM',
            label: 'Samoa',
        },
        {
            value: 'YEM',
            label: 'Yemen',
        },
        {
            value: 'CHE',
            label: 'Switzerland',
        },
        {
            value: 'CUB',
            label: 'Cuba',
        },
        {
            value: 'CZE',
            label: 'Czech Republic',
        },
        {
            value: 'GRC',
            label: 'Greece',
        },
        {
            value: 'IRL',
            label: 'Ireland',
        },
        {
            value: 'IRQ',
            label: 'Iraq',
        },
        {
            value: 'NLD',
            label: 'Netherlands',
        },
        {
            value: 'OMN',
            label: 'Oman',
        },
        {
            value: 'SAU',
            label: 'Saudi Arabia',
        },
        {
            value: 'SWZ',
            label: 'Eswatini',
        },
        {
            value: 'TJK',
            label: 'Tajikistan',
        },
        {
            value: 'THA',
            label: 'Thailand',
        },
        {
            value: 'LAO',
            label: 'Laos',
        },
        {
            value: 'QAT',
            label: 'Qatar',
        },
        {
            value: 'IRN',
            label: 'Iran',
        },
        {
            value: 'PSE',
            label: 'Palestine',
        },
    ],
    ru: [
        {
            value: 'TTO',
            label: 'Тринидад и Тобаго',
        },
        {
            value: 'DMA',
            label: 'Доминика',
        },
        {
            value: 'KNA',
            label: 'Сент-Китс и Невис',
        },
        {
            value: 'GNQ',
            label: 'Экваториальная Гвинея',
        },
        {
            value: 'ATG',
            label: 'Антигуа и Барбуда',
        },
        {
            value: 'PNG',
            label: 'Папуа-Новая Гвинея',
        },
        {
            value: 'VCT',
            label: 'Святой Винсент и Гренадины',
        },
        {
            value: 'SLB',
            label: 'Соломоновы острова',
        },
        {
            value: 'CAF',
            label: 'Центрально-Африканская Республика',
        },
        {
            value: 'COG',
            label: 'Республика Конго',
        },
        {
            value: 'GNB',
            label: 'Гвинея-Бисау',
        },
        {
            value: 'LIE',
            label: 'Лихтенштейн',
        },
        {
            value: 'COD',
            label: 'Демократическая Республика Конго',
        },
        {
            value: 'DOM',
            label: 'Доминиканская Республика',
        },
        {
            value: 'SLE',
            label: 'Сьерра-Леоне',
        },
        {
            value: 'SSD',
            label: 'Южный Судан',
        },
        {
            value: 'NZL',
            label: 'Новая Зеландия',
        },
        {
            value: 'ZAF',
            label: 'Южная Африка',
        },
        {
            value: 'CPV',
            label: 'Кабо-Верде',
        },
        {
            value: 'KOR',
            label: 'Южная Корея',
        },
        {
            value: 'LCA',
            label: 'Санет-Люсия',
        },
        {
            value: 'LUX',
            label: 'Люксембург',
        },
        {
            value: 'PRK',
            label: 'Северная Корея',
        },
        {
            value: 'SMR',
            label: 'Сан-Марино',
        },
        {
            value: 'ARG',
            label: 'Аргентина',
        },
        {
            value: 'AZE',
            label: 'Азербайджан',
        },
        {
            value: 'BGD',
            label: 'Бангладеш',
        },
        {
            value: 'CMR',
            label: 'Камерун',
        },
        {
            value: 'CRI',
            label: 'Коста-Рика',
        },
        {
            value: 'FSM',
            label: 'Микронезия',
        },
        {
            value: 'KAZ',
            label: 'Казахстан',
        },
        {
            value: 'MHL',
            label: 'Маршалловы острова',
        },
        {
            value: 'MNE',
            label: 'Черногория',
        },
        {
            value: 'MRT',
            label: 'Мавритания',
        },
        {
            value: 'SGP',
            label: 'Сингапур',
        },
        {
            value: 'SYC',
            label: 'Сейшельские острова',
        },
        {
            value: 'UZB',
            label: 'Узбекистан',
        },
        {
            value: 'VNM',
            label: 'Вьетнам',
        },
        {
            value: 'AUS',
            label: 'Австралия',
        },
        {
            value: 'BLR',
            label: 'Беларусь',
        },
        {
            value: 'ECU',
            label: 'Эквадор',
        },
        {
            value: 'GTM',
            label: 'Гватемала',
        },
        {
            value: 'IDN',
            label: 'Индонезия',
        },
        {
            value: 'KIR',
            label: 'Кирибати',
        },
        {
            value: 'LKA',
            label: 'Шри-Ланка',
        },
        {
            value: 'LTU',
            label: 'Литва',
        },
        {
            value: 'MKD',
            label: 'Македония',
        },
        {
            value: 'MOZ',
            label: 'Мозамбик',
        },
        {
            value: 'NIC',
            label: 'Никарагуа',
        },
        {
            value: 'PAN',
            label: 'Панама',
        },
        {
            value: 'PRT',
            label: 'Португалия',
        },
        {
            value: 'PRY',
            label: 'Парагвай',
        },
        {
            value: 'SEN',
            label: 'Сенегал',
        },
        {
            value: 'SLV',
            label: 'Сальвадор',
        },
        {
            value: 'STP',
            label: 'Сан-Томе и Принсипи',
        },
        {
            value: 'TZA',
            label: 'Танзания',
        },
        {
            value: 'VEN',
            label: 'Венесуэла',
        },
        {
            value: 'ZWE',
            label: 'Зимбабве',
        },
        {
            value: 'BDI',
            label: 'Бурунди',
        },
        {
            value: 'BFA',
            label: 'Буркина-Фасо',
        },
        {
            value: 'BGR',
            label: 'Болгария',
        },
        {
            value: 'BHS',
            label: 'Багамы',
        },
        {
            value: 'BRA',
            label: 'Бразилия',
        },
        {
            value: 'BRB',
            label: 'Барбадос',
        },
        {
            value: 'BRN',
            label: 'Бруней',
        },
        {
            value: 'BTN',
            label: 'Бутан',
        },
        {
            value: 'COL',
            label: 'Колумбия',
        },
        {
            value: 'ETH',
            label: 'Эфиопия',
        },
        {
            value: 'GRD',
            label: 'Гренада',
        },
        {
            value: 'HUN',
            label: 'Венгрия',
        },
        {
            value: 'ISL',
            label: 'Исландия',
        },
        {
            value: 'JOR',
            label: 'Иордания',
        },
        {
            value: 'KHM',
            label: 'Камбоджа',
        },
        {
            value: 'MDA',
            label: 'Молдова',
        },
        {
            value: 'MNG',
            label: 'Монголия',
        },
        {
            value: 'MUS',
            label: 'Маврикий',
        },
        {
            value: 'MYS',
            label: 'Малайзия',
        },
        {
            value: 'NOR',
            label: 'Норвегия',
        },
        {
            value: 'PAK',
            label: 'Пакистан',
        },
        {
            value: 'PHL',
            label: 'Филиппины',
        },
        {
            value: 'SUR',
            label: 'Суринам',
        },
        {
            value: 'SVK',
            label: 'Словакия',
        },
        {
            value: 'SVN',
            label: 'Словения',
        },
        {
            value: 'UKR',
            label: 'Украина',
        },
        {
            value: 'URY',
            label: 'Уругвай',
        },
        {
            value: 'VUT',
            label: 'Вануату',
        },
        {
            value: 'ALB',
            label: 'Албания',
        },
        {
            value: 'AND',
            label: 'Андорра',
        },
        {
            value: 'ARM',
            label: 'Армения',
        },
        {
            value: 'AUT',
            label: 'Австрия',
        },
        {
            value: 'BEN',
            label: 'Бенин',
        },
        {
            value: 'BHR',
            label: 'Бахрейн',
        },
        {
            value: 'BLZ',
            label: 'Белиз',
        },
        {
            value: 'BOL',
            label: 'Боливия',
        },
        {
            value: 'BWA',
            label: 'Ботсвана',
        },
        {
            value: 'CAN',
            label: 'Канада',
        },
        {
            value: 'DJI',
            label: 'Джибути',
        },
        {
            value: 'DZA',
            label: 'Алжир',
        },
        {
            value: 'EGY',
            label: 'Египет',
        },
        {
            value: 'ERI',
            label: 'Эритрея',
        },
        {
            value: 'EST',
            label: 'Эстония',
        },
        {
            value: 'GAB',
            label: 'Габон',
        },
        {
            value: 'GEO',
            label: 'Грузия',
        },
        {
            value: 'GHA',
            label: 'Гана',
        },
        {
            value: 'GUY',
            label: 'Гайана',
        },
        {
            value: 'HND',
            label: 'Гондурас',
        },
        {
            value: 'HRV',
            label: 'Хорватия',
        },
        {
            value: 'JAM',
            label: 'Ямайка',
        },
        {
            value: 'JPN',
            label: 'Япония',
        },
        {
            value: 'LBN',
            label: 'Ливан',
        },
        {
            value: 'LBR',
            label: 'Либерия',
        },
        {
            value: 'MAR',
            label: 'Марокко',
        },
        {
            value: 'MDG',
            label: 'Мадагаскар',
        },
        {
            value: 'MDV',
            label: 'Мальдивы',
        },
        {
            value: 'MMR',
            label: 'Мьянма',
        },
        {
            value: 'MWI',
            label: 'Малави',
        },
        {
            value: 'NAM',
            label: 'Намибия',
        },
        {
            value: 'NER',
            label: 'Нигер',
        },
        {
            value: 'NGA',
            label: 'Нигерия',
        },
        {
            value: 'NPL',
            label: 'Непал',
        },
        {
            value: 'PER',
            label: 'Перу',
        },
        {
            value: 'ROU',
            label: 'Румыния',
        },
        {
            value: 'SDN',
            label: 'Судан',
        },
        {
            value: 'TGO',
            label: 'Того',
        },
        {
            value: 'TLS',
            label: 'Восточный Тимор',
        },
        {
            value: 'TUN',
            label: 'Тунис',
        },
        {
            value: 'TUV',
            label: 'Тувалу',
        },
        {
            value: 'USA',
            label: 'Соединенные Штаты Америки',
        },
        {
            value: 'AGO',
            label: 'Ангола',
        },
        {
            value: 'ARE',
            label: 'Объединенные Арабские Эмираты',
        },
        {
            value: 'BEL',
            label: 'Бельгия',
        },
        {
            value: 'BIH',
            label: 'Босния и Герцеговина',
        },
        {
            value: 'CHL',
            label: 'Чили',
        },
        {
            value: 'CHN',
            label: 'Китай',
        },
        {
            value: 'CIV',
            label: 'Кот-д’Ивуар',
        },
        {
            value: 'COM',
            label: 'Коморские острова',
        },
        {
            value: 'CYP',
            label: 'Кипр',
        },
        {
            value: 'ESP',
            label: 'Испания',
        },
        {
            value: 'FIN',
            label: 'Финляндия',
        },
        {
            value: 'GBR',
            label: 'Великобритания',
        },
        {
            value: 'GIN',
            label: 'Гвинея',
        },
        {
            value: 'GMB',
            label: 'Гамбия',
        },
        {
            value: 'HTI',
            label: 'Гаити',
        },
        {
            value: 'ITA',
            label: 'Италия',
        },
        {
            value: 'KWT',
            label: 'Кувейт',
        },
        {
            value: 'LSO',
            label: 'Лесото',
        },
        {
            value: 'LVA',
            label: 'Латвия',
        },
        {
            value: 'MCO',
            label: 'Монако',
        },
        {
            value: 'MEX',
            label: 'Мексика',
        },
        {
            value: 'MLT',
            label: 'Мальта',
        },
        {
            value: 'NRU',
            label: 'Науру',
        },
        {
            value: 'PLW',
            label: 'Палау',
        },
        {
            value: 'RUS',
            label: 'Россия',
        },
        {
            value: 'RWA',
            label: 'Руанда',
        },
        {
            value: 'SRB',
            label: 'Сербия',
        },
        {
            value: 'SWE',
            label: 'Швеция',
        },
        {
            value: 'TCD',
            label: 'Чад',
        },
        {
            value: 'TKM',
            label: 'Туркменистан',
        },
        {
            value: 'TUR',
            label: 'Турция',
        },
        {
            value: 'UGA',
            label: 'Уганда',
        },
        {
            value: 'ZMB',
            label: 'Замбия',
        },
        {
            value: 'AFG',
            label: 'Афганистан',
        },
        {
            value: 'DEU',
            label: 'Германия',
        },
        {
            value: 'DNK',
            label: 'Дания',
        },
        {
            value: 'FJI',
            label: 'Фиджи',
        },
        {
            value: 'FRA',
            label: 'Франция',
        },
        {
            value: 'IND',
            label: 'Индия',
        },
        {
            value: 'KEN',
            label: 'Кения',
        },
        {
            value: 'KGZ',
            label: 'Кыргызстан',
        },
        {
            value: 'LBY',
            label: 'Ливия',
        },
        {
            value: 'MLI',
            label: 'Мали',
        },
        {
            value: 'POL',
            label: 'Польша',
        },
        {
            value: 'SOM',
            label: 'Сомали',
        },
        {
            value: 'SYR',
            label: 'Сирия',
        },
        {
            value: 'TON',
            label: 'Тонга',
        },
        {
            value: 'WSM',
            label: 'Самоа',
        },
        {
            value: 'YEM',
            label: 'Йемен',
        },
        {
            value: 'CHE',
            label: 'Швейцария',
        },
        {
            value: 'CUB',
            label: 'Куба',
        },
        {
            value: 'CZE',
            label: 'Чехия',
        },
        {
            value: 'GRC',
            label: 'Греция',
        },
        {
            value: 'IRL',
            label: 'Ирландия',
        },
        {
            value: 'IRQ',
            label: 'Ирак',
        },
        {
            value: 'NLD',
            label: 'Нидерланды',
        },
        {
            value: 'OMN',
            label: 'Оман',
        },
        {
            value: 'SAU',
            label: 'Саудовская Аравия',
        },
        {
            value: 'SWZ',
            label: 'Эсватини',
        },
        {
            value: 'TJK',
            label: 'Таджикистан',
        },
        {
            value: 'THA',
            label: 'Таиланд',
        },
        {
            value: 'LAO',
            label: 'Лаос',
        },
        {
            value: 'QAT',
            label: 'Катар',
        },
        {
            value: 'IRN',
            label: 'Иран',
        },
        {
            value: 'PSE',
            label: 'Палестина',
        },
    ],
    uz: [
        {
            value: 'TTO',
            label: 'Trinidad va Tobago',
        },
        {
            value: 'DMA',
            label: 'Dominika',
        },
        {
            value: 'KNA',
            label: 'Sent Kits va Nevis',
        },
        {
            value: 'GNQ',
            label: 'Ekvatorial Gvineya',
        },
        {
            value: 'ATG',
            label: 'Antigua va Berbuda',
        },
        {
            value: 'PNG',
            label: 'Papua Yangi Gvineya',
        },
        {
            value: 'VCT',
            label: 'Sent Vinsent va Grinada',
        },
        {
            value: 'SLB',
            label: 'Solomon Orollari',
        },
        {
            value: 'CAF',
            label: 'Markaziy Afrika Respublikasi',
        },
        {
            value: 'COG',
            label: 'Kongo Respublikasi',
        },
        {
            value: 'GNB',
            label: 'Gvineya-Bisau',
        },
        {
            value: 'LIE',
            label: 'Lixtenshteyn',
        },
        {
            value: 'COD',
            label: 'Kongo Demokratik Respublikasi',
        },
        {
            value: 'DOM',
            label: 'Dominika Respublikasi',
        },
        {
            value: 'SLE',
            label: 'Sierra-Leone',
        },
        {
            value: 'SSD',
            label: 'Janubiy Sudan',
        },
        {
            value: 'NZL',
            label: 'Yangi Zalandiya',
        },
        {
            value: 'ZAF',
            label: 'Janibiy Afrika',
        },
        {
            value: 'CPV',
            label: 'Kabo-Verde',
        },
        {
            value: 'KOR',
            label: 'Janubiy Korea',
        },
        {
            value: 'LCA',
            label: 'Sanet-Lyusiya',
        },
        {
            value: 'LUX',
            label: 'Lyuksemburg',
        },
        {
            value: 'PRK',
            label: 'Shimoliy Korea',
        },
        {
            value: 'SMR',
            label: 'San-Marino',
        },
        {
            value: 'ARG',
            label: 'Argentina',
        },
        {
            value: 'AZE',
            label: 'Ozarbayjon',
        },
        {
            value: 'BGD',
            label: 'Bangladesh',
        },
        {
            value: 'CMR',
            label: 'Kamerun',
        },
        {
            value: 'CRI',
            label: 'Kosta Rika',
        },
        {
            value: 'FSM',
            label: 'Mikroneziya',
        },
        {
            value: 'KAZ',
            label: 'Qozog’iston',
        },
        {
            value: 'MHL',
            label: 'Marshal Orollari',
        },
        {
            value: 'MNE',
            label: 'Chernogoriya',
        },
        {
            value: 'MRT',
            label: 'Mavritaniya',
        },
        {
            value: 'SGP',
            label: 'Singapur',
        },
        {
            value: 'SYC',
            label: 'Seyshel orollari',
        },
        {
            value: 'UZB',
            label: 'O’zbekiston',
        },
        {
            value: 'VNM',
            label: 'Vietnam',
        },
        {
            value: 'AUS',
            label: 'Avstraliya',
        },
        {
            value: 'BLR',
            label: 'Belorusiya',
        },
        {
            value: 'ECU',
            label: 'Ekvador',
        },
        {
            value: 'GTM',
            label: 'Gvatemala',
        },
        {
            value: 'IDN',
            label: 'Indoneziya',
        },
        {
            value: 'KIR',
            label: 'Kiribati',
        },
        {
            value: 'LKA',
            label: 'Shri Lanka',
        },
        {
            value: 'LTU',
            label: 'Litva',
        },
        {
            value: 'MKD',
            label: 'Makedoniya',
        },
        {
            value: 'MOZ',
            label: 'Mozambik',
        },
        {
            value: 'NIC',
            label: 'Nikaragua',
        },
        {
            value: 'PAN',
            label: 'Panama',
        },
        {
            value: 'PRT',
            label: 'Portugaliya',
        },
        {
            value: 'PRY',
            label: 'Paragvay',
        },
        {
            value: 'SEN',
            label: 'Senegal',
        },
        {
            value: 'SLV',
            label: 'Salvador',
        },
        {
            value: 'STP',
            label: 'San Tome va Prinsipi',
        },
        {
            value: 'TZA',
            label: 'Tanzaniya',
        },
        {
            value: 'VEN',
            label: 'Venesuela',
        },
        {
            value: 'ZWE',
            label: 'Zimbabve',
        },
        {
            value: 'BDI',
            label: 'Burundi',
        },
        {
            value: 'BFA',
            label: 'Burkina Faso',
        },
        {
            value: 'BGR',
            label: 'Bolgariya',
        },
        {
            value: 'BHS',
            label: 'Bogama orollari',
        },
        {
            value: 'BRA',
            label: 'Braziliya',
        },
        {
            value: 'BRB',
            label: 'Barbados',
        },
        {
            value: 'BRN',
            label: 'Bruney',
        },
        {
            value: 'BTN',
            label: 'Butan',
        },
        {
            value: 'COL',
            label: 'Kolumbiya',
        },
        {
            value: 'ETH',
            label: 'Efiyopiya',
        },
        {
            value: 'GRD',
            label: 'Grenada',
        },
        {
            value: 'HUN',
            label: 'Vengriya',
        },
        {
            value: 'ISL',
            label: 'Islandiya',
        },
        {
            value: 'JOR',
            label: 'Yordaniya',
        },
        {
            value: 'KHM',
            label: 'Kombodja',
        },
        {
            value: 'MDA',
            label: 'Moldova',
        },
        {
            value: 'MNG',
            label: 'Mongoliya',
        },
        {
            value: 'MUS',
            label: 'Mavrikiy',
        },
        {
            value: 'MYS',
            label: 'Malayziya',
        },
        {
            value: 'NOR',
            label: 'Norvegiya',
        },
        {
            value: 'PAK',
            label: 'Pokiston',
        },
        {
            value: 'PHL',
            label: 'Filipin',
        },
        {
            value: 'SUR',
            label: 'Suriname',
        },
        {
            value: 'SVK',
            label: 'Slovakiya',
        },
        {
            value: 'SVN',
            label: 'Sloveniya',
        },
        {
            value: 'UKR',
            label: 'Ukraina',
        },
        {
            value: 'URY',
            label: 'Urugvay',
        },
        {
            value: 'VUT',
            label: 'Vanuatu',
        },
        {
            value: 'ALB',
            label: 'Albaniya',
        },
        {
            value: 'AND',
            label: 'Andorra',
        },
        {
            value: 'ARM',
            label: 'Armaniston',
        },
        {
            value: 'AUT',
            label: 'Avstriya',
        },
        {
            value: 'BEN',
            label: 'Benin',
        },
        {
            value: 'BHR',
            label: 'Bahrayn',
        },
        {
            value: 'BLZ',
            label: 'Beliz',
        },
        {
            value: 'BOL',
            label: 'Boliviya',
        },
        {
            value: 'BWA',
            label: 'Botsvana',
        },
        {
            value: 'CAN',
            label: 'Kanada',
        },
        {
            value: 'DJI',
            label: 'Djibuti',
        },
        {
            value: 'DZA',
            label: 'Jazoyir',
        },
        {
            value: 'EGY',
            label: 'Misr',
        },
        {
            value: 'ERI',
            label: 'Eritriya',
        },
        {
            value: 'EST',
            label: 'Estoniya',
        },
        {
            value: 'GAB',
            label: 'Gabon',
        },
        {
            value: 'GEO',
            label: 'Gruziya',
        },
        {
            value: 'GHA',
            label: 'Gana',
        },
        {
            value: 'GUY',
            label: 'Gayana',
        },
        {
            value: 'HND',
            label: 'Gonduras',
        },
        {
            value: 'HRV',
            label: 'Horvatiya',
        },
        {
            value: 'JAM',
            label: 'Yamayka',
        },
        {
            value: 'JPN',
            label: 'Yaponiya',
        },
        {
            value: 'LBN',
            label: 'Livan',
        },
        {
            value: 'LBR',
            label: 'Liberiya',
        },
        {
            value: 'MAR',
            label: 'Marokash',
        },
        {
            value: 'MDG',
            label: 'Madagaskar',
        },
        {
            value: 'MDV',
            label: 'Maldiv orollari',
        },
        {
            value: 'MMR',
            label: 'Myanmar',
        },
        {
            value: 'MWI',
            label: 'Malavi',
        },
        {
            value: 'NAM',
            label: 'Namibiya',
        },
        {
            value: 'NER',
            label: 'Niger',
        },
        {
            value: 'NGA',
            label: 'Nigeriya',
        },
        {
            value: 'NPL',
            label: 'Nepal',
        },
        {
            value: 'PER',
            label: 'Peru',
        },
        {
            value: 'ROU',
            label: 'Ruminiya',
        },
        {
            value: 'SDN',
            label: 'Sudan',
        },
        {
            value: 'TGO',
            label: 'Togo',
        },
        {
            value: 'TLS',
            label: 'Sharqiy Timor',
        },
        {
            value: 'TUN',
            label: 'Tunisiya',
        },
        {
            value: 'TUV',
            label: 'Tuvalu',
        },
        {
            value: 'USA',
            label: 'Amerika Qo’shma Shtatlari',
        },
        {
            value: 'AGO',
            label: 'Angola',
        },
        {
            value: 'ARE',
            label: 'Birlashgan Arab Amirliklari',
        },
        {
            value: 'BEL',
            label: 'Belgiya',
        },
        {
            value: 'BIH',
            label: 'Bosniya va Gertsogavina',
        },
        {
            value: 'CHL',
            label: 'Chili',
        },
        {
            value: 'CHN',
            label: 'Xitoy',
        },
        {
            value: 'CIV',
            label: 'Kote d’Iuvar',
        },
        {
            value: 'COM',
            label: 'Komor Orollari',
        },
        {
            value: 'CYP',
            label: 'Kipr',
        },
        {
            value: 'ESP',
            label: 'Ispaniya',
        },
        {
            value: 'FIN',
            label: 'Finlandiya',
        },
        {
            value: 'GBR',
            label: 'Buyuk Britaniya',
        },
        {
            value: 'GIN',
            label: 'Gvineya',
        },
        {
            value: 'GMB',
            label: 'Gambiya',
        },
        {
            value: 'HTI',
            label: 'Gaiti',
        },
        {
            value: 'ITA',
            label: 'Italya',
        },
        {
            value: 'KWT',
            label: 'Qavayt',
        },
        {
            value: 'LSO',
            label: 'Leseto',
        },
        {
            value: 'LVA',
            label: 'Latviya',
        },
        {
            value: 'MCO',
            label: 'Monako',
        },
        {
            value: 'MEX',
            label: 'Meksika',
        },
        {
            value: 'MLT',
            label: 'Malta',
        },
        {
            value: 'NRU',
            label: 'Nauri',
        },
        {
            value: 'PLW',
            label: 'Palau',
        },
        {
            value: 'RUS',
            label: 'Rossiya',
        },
        {
            value: 'RWA',
            label: 'Ruanda',
        },
        {
            value: 'SRB',
            label: 'Serbiya',
        },
        {
            value: 'SWE',
            label: 'Shvetsiya',
        },
        {
            value: 'TCD',
            label: 'Chad',
        },
        {
            value: 'TKM',
            label: 'Turkmaniston',
        },
        {
            value: 'TUR',
            label: 'Turkiya',
        },
        {
            value: 'UGA',
            label: 'Uganda',
        },
        {
            value: 'ZMB',
            label: 'Zambiya',
        },
        {
            value: 'AFG',
            label: 'Afg’oniston',
        },
        {
            value: 'DEU',
            label: 'Germaniya',
        },
        {
            value: 'DNK',
            label: 'Daniya',
        },
        {
            value: 'FJI',
            label: 'Fiji',
        },
        {
            value: 'FRA',
            label: 'Fransiya',
        },
        {
            value: 'IND',
            label: 'Hindiston',
        },
        {
            value: 'KEN',
            label: 'Keniya',
        },
        {
            value: 'KGZ',
            label: 'Qirg’iziston',
        },
        {
            value: 'LBY',
            label: 'Liviya',
        },
        {
            value: 'MLI',
            label: 'Mali',
        },
        {
            value: 'POL',
            label: 'Polsha',
        },
        {
            value: 'SOM',
            label: 'Somaliya',
        },
        {
            value: 'SYR',
            label: 'Suriya',
        },
        {
            value: 'TON',
            label: 'Tongo',
        },
        {
            value: 'WSM',
            label: 'Samoa',
        },
        {
            value: 'YEM',
            label: 'Yaman',
        },
        {
            value: 'CHE',
            label: 'Shveytsariya',
        },
        {
            value: 'CUB',
            label: 'Kuba',
        },
        {
            value: 'CZE',
            label: 'Chexiya',
        },
        {
            value: 'GRC',
            label: 'Gretsiya',
        },
        {
            value: 'IRL',
            label: 'Irlandiya',
        },
        {
            value: 'IRQ',
            label: 'Iroq',
        },
        {
            value: 'NLD',
            label: 'Gollandiya',
        },
        {
            value: 'OMN',
            label: 'Ummon',
        },
        {
            value: 'SAU',
            label: 'Saudiya Arabistoni',
        },
        {
            value: 'SWZ',
            label: 'Esvatini',
        },
        {
            value: 'TJK',
            label: 'Tojikiston',
        },
        {
            value: 'THA',
            label: 'Tailand',
        },
        {
            value: 'LAO',
            label: 'Laos',
        },
        {
            value: 'QAT',
            label: 'Qatar',
        },
        {
            value: 'IRN',
            label: 'Eron',
        },
        {
            value: 'PSE',
            label: 'Falastin',
        },
    ],
};
function compare$1(a, b) {
    var labelA = a.label;
    var labelB = b.label;
    return labelA.localeCompare(labelB);
}
countries$3.en && countries$3.en.sort(compare$1);
countries$3.ar && countries$3.ar.sort(compare$1);
countries$3.ka && countries$3.ka.sort(compare$1);
var daysArr$1 = [];
for (var i$2 = 1; i$2 <= 31; i$2++) {
    daysArr$1.push({ id: i$2, label: i$2, value: i$2 });
}
var days$1 = daysArr$1;
var months$1 = {
    en: [
        { id: 1, label: 'January', value: 1 },
        { id: 2, label: 'Febuary', value: 2 },
        { id: 3, label: 'March', value: 3 },
        { id: 4, label: 'April', value: 4 },
        { id: 5, label: 'May', value: 5 },
        { id: 6, label: 'June', value: 6 },
        { id: 7, label: 'July', value: 7 },
        { id: 8, label: 'August', value: 8 },
        { id: 9, label: 'September', value: 9 },
        { id: 10, label: 'October', value: 10 },
        { id: 11, label: 'November', value: 11 },
        { id: 12, label: 'December', value: 12 },
    ],
    ar: [
        { id: 1, label: 'يناير', value: 1 },
        { id: 2, label: 'فبراير', value: 2 },
        { id: 3, label: 'مارس', value: 3 },
        { id: 4, label: 'أبريل', value: 4 },
        { id: 5, label: 'مايو', value: 5 },
        { id: 6, label: 'يونيو', value: 6 },
        { id: 7, label: 'يوليو', value: 7 },
        { id: 8, label: 'أغسطس', value: 8 },
        { id: 9, label: 'سبتمبر', value: 9 },
        { id: 10, label: 'أكتوبر', value: 10 },
        { id: 11, label: 'نوفمبر', value: 11 },
        { id: 12, label: 'ديسمبر', value: 12 },
    ],
    // georgia
    ka: [
        { id: 1, label: 'იანვარი', value: 1 },
        { id: 2, label: 'თებერვალი', value: 2 },
        { id: 3, label: 'მარტი', value: 3 },
        { id: 4, label: 'აპრილი', value: 4 },
        { id: 5, label: 'მაისი', value: 5 },
        { id: 6, label: 'ივნისი', value: 6 },
        { id: 7, label: 'ივლისი', value: 7 },
        { id: 8, label: 'აგვისტო', value: 8 },
        { id: 9, label: 'სექტემბერი', value: 9 },
        { id: 10, label: 'ოქტომბერი', value: 10 },
        { id: 11, label: 'ნოემბერი', value: 11 },
        { id: 12, label: 'დეკემბერი', value: 12 },
    ],
    // uzbakistan
    uz: [
        { id: 1, label: 'yanvar', value: 1 },
        { id: 2, label: 'fevral', value: 2 },
        { id: 3, label: 'mart', value: 3 },
        { id: 4, label: 'aprel', value: 4 },
        { id: 5, label: 'may', value: 5 },
        { id: 6, label: 'iyun', value: 6 },
        { id: 7, label: 'iyul', value: 7 },
        { id: 8, label: 'avgust', value: 8 },
        { id: 9, label: 'sentabr', value: 9 },
        { id: 10, label: 'oktabr', value: 10 },
        { id: 11, label: 'noyabr', value: 11 },
        { id: 12, label: 'dekabr', value: 12 },
    ],
    ru: [
        { id: 1, label: 'январь', value: 1 },
        { id: 2, label: 'февраль', value: 2 },
        { id: 3, label: 'март', value: 3 },
        { id: 4, label: 'апрель', value: 4 },
        { id: 5, label: 'май', value: 5 },
        { id: 6, label: 'июнь', value: 6 },
        { id: 7, label: 'июль', value: 7 },
        { id: 8, label: 'август', value: 8 },
        { id: 9, label: 'сентябрь', value: 9 },
        { id: 10, label: 'октябрь', value: 10 },
        { id: 11, label: 'ноябрь', value: 11 },
        { id: 12, label: 'декабрь', value: 12 },
    ],
    // armenia
    hy: [
        { id: 1, label: 'Յունուար', value: 1 },
        { id: 2, label: 'Փետրուար', value: 2 },
        { id: 3, label: 'Մարտ', value: 3 },
        { id: 4, label: 'Ապրիլ', value: 4 },
        { id: 5, label: 'Մայիս', value: 5 },
        { id: 6, label: 'Յունիս', value: 6 },
        { id: 7, label: 'Յուլիս', value: 7 },
        { id: 8, label: 'Օգոստոս', value: 8 },
        { id: 9, label: 'Սեպտեմբեր', value: 9 },
        { id: 10, label: 'Հոկտեմբեր', value: 10 },
        { id: 11, label: 'Նոյեմբեր', value: 11 },
        { id: 12, label: 'Դեկտեմբեր', value: 12 },
    ],
};

var CompleteYourProfile$2 = function (_a) {
    var t = _a.t, onSuccess = _a.onSuccess;
    var _b = __read(useState(PolicyAccept$1.YES), 2), policyAccept = _b[0], setSubscribe = _b[1];
    var _c = __read(useState(true), 2), showModal = _c[0], setShowModal = _c[1];
    var _d = __read(useState(), 2), updateProfilePayload = _d[0], setUpdateProfilePayload = _d[1];
    var dispatch = useDispatch();
    var _e = __read(useState(false), 2), isVerifyPhoneModalOpen = _e[0], setVerifyPhoneModalOpen = _e[1];
    var _f = __read(useState(false), 2), phoneNumberExist = _f[0], setPhoneNumberExist = _f[1];
    var selectFormElements = [
        { field_name: 'nationality' },
        { field_name: 'birth_date' },
        { field_name: 'birth_month' },
        { field_name: 'birth_year' },
    ];
    var _g = useSelector(function (state) { return (__assign({}, __assign(__assign(__assign({}, state.userData), state.appConfig), { isLoading: state.userData.isLoading }))); }), email = _g.email, isLoading = _g.isLoading, _h = _g.language, language = _h === void 0 ? 'en' : _h, phoneCountryCode = _g.phoneCountryCode, phoneExpression = _g.phoneExpression, storeId = _g.storeId, code = _g.code, features = _g.features;
    var _j = useForm({
        mode: 'onChange',
    }), register = _j.register, handleSubmit = _j.handleSubmit, errors = _j.errors, control = _j.control, setError = _j.setError, clearErrors = _j.clearErrors, getValues = _j.getValues;
    var onPhoneChange = function (phoneNumber) {
        if (phoneNumber) {
            verifyUserPhoneNumber$1(formatPhoneNo(phoneNumber), function (apiResponse) {
                var _a;
                handlePhoneExist((_a = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.data) === null || _a === void 0 ? void 0 : _a.customerExist);
            })(dispatch);
        }
    };
    // On Change subscribe/unscribe
    var onChangeSubscribe = function () {
        var policyAcc = policyAccept === PolicyAccept$1.NO ? PolicyAccept$1.YES : PolicyAccept$1.NO;
        setSubscribe(policyAcc);
    };
    var onClickSubmit = function (data) {
        handleSubmit(onSubmit, function () {
            isValidAllSelectBoxItems(getValues(), selectFormElements);
        })(data);
    };
    var isValidAllSelectBoxItems = function (data, fieldNames) {
        var isValid = true;
        fieldNames.map(function (fieldData) {
            var _a;
            if (!((_a = data[fieldData.field_name]) === null || _a === void 0 ? void 0 : _a.value) && policyAccept === PolicyAccept$1.YES) {
                setError(fieldData.field_name, {
                    type: 'required',
                });
                isValid = false;
            }
            else {
                clearErrors(fieldData.field_name);
            }
            return fieldData;
        });
        return isValid;
    };
    var handlePhoneExist = function (phoneExist) {
        if (phoneExist) {
            setError('phone_no', {
                type: 'phone_exist',
                message: t('verifyOTP.CustomerPhoneConflictError'),
            });
            setPhoneNumberExist(true);
        }
        else {
            clearErrors('phone_no');
            setPhoneNumberExist(false);
        }
    };
    var addLeadingZero = function (value) { return (value < 10 ? "0" + value : value.toString()); };
    var formatBirthDate = function (year, month, day) {
        return year + "-" + addLeadingZero(month) + "-" + addLeadingZero(day);
    };
    var formatPhoneNo = function (phoneNumber) { return "" + +(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/^0/, '')); };
    // Update user profile
    var onSubmit = function (data) {
        var _a, _b, _c, _d;
        handlePhoneExist(phoneNumberExist);
        if ((isValidAllSelectBoxItems(data, selectFormElements) === true || policyAccept !== PolicyAccept$1.YES) &&
            !phoneNumberExist) {
            var profileUpdateData = {
                birthday: policyAccept === PolicyAccept$1.YES
                    ? formatBirthDate((_a = data.birth_year) === null || _a === void 0 ? void 0 : _a.value, (_b = data.birth_month) === null || _b === void 0 ? void 0 : _b.value, (_c = data.birth_date) === null || _c === void 0 ? void 0 : _c.value)
                    : '',
                mobileNumberType: 'mobile',
                nationality: (_d = data.nationality) === null || _d === void 0 ? void 0 : _d.value,
                newEmail: email,
                newMobileNumber: "" + phoneCountryCode + formatPhoneNo(data.phone_no),
                oldEmail: email,
                title: data.title,
                isPhoneVerified: true,
            };
            setUpdateProfilePayload(profileUpdateData);
            setVerifyPhoneModalOpen(true);
        }
    };
    // On Verify OTP
    var onVerifyAccount = function (uuid) {
        var payload = __assign(__assign({}, updateProfilePayload), { uuid: uuid });
        userProfileUpdate$1(payload, function (res) {
            if (res.meta.statusCode === 200) {
                localStorage.removeItem('userLoggedIn');
                localStorage.setItem('userRegistered', '1');
                localStorage.setItem('userLoggedIn', '1');
                if (((features === null || features === void 0 ? void 0 : features.share) && policyAccept === PolicyAccept$1.YES) || !(features === null || features === void 0 ? void 0 : features.share)) {
                    var loyaltyPayload = (features === null || features === void 0 ? void 0 : features.share) ? { type: 'share' }
                        : {
                            cardNumber: '',
                            country: code,
                            secretQuestion: 'What is your mobile number?',
                            secretAnswer: updateProfilePayload === null || updateProfilePayload === void 0 ? void 0 : updateProfilePayload.newMobileNumber,
                            type: 'address',
                            title: updateProfilePayload === null || updateProfilePayload === void 0 ? void 0 : updateProfilePayload.title,
                            mobileNumber: updateProfilePayload === null || updateProfilePayload === void 0 ? void 0 : updateProfilePayload.newMobileNumber,
                            preferredLanguage: language,
                        };
                    var type = (features === null || features === void 0 ? void 0 : features.share) ? 'share' : 'myclub';
                    createLoyaltyAccount$1(loyaltyPayload, type)(dispatch);
                }
                refreshToken$1(onSuccess)(dispatch);
                // Update user state after updating
                // Comment this for future use if we don't need to make user and loyalty api call
                /*const userStateParams = {
                  birthday: payload.birthday,
                  nationality: payload.nationality,
                  title: payload.title,
                  contact_number: [{"type":"mobile","number":payload.newMobileNumber}],
                  phone: payload.newMobileNumber,
                  isPhoneVerified: true
                }
                dispatch(setUserDataUpdateSuccess(userStateParams));*/
                //dispatch(getUserData(userCredentials?.authToken)); // Comment this code as we need to refresh the screen
                setVerifyPhoneModalOpen(!isVerifyPhoneModalOpen);
                setShowModal(false);
                //onSuccess && onSuccess();
            }
        })(dispatch);
    };
    useEffect(function () {
        if (!isLoading) {
            setVerifyPhoneModalOpen(false);
        }
    }, [isLoading]);
    var toggleSetVerifyPhoneModalOpen = useCallback(function () {
        setVerifyPhoneModalOpen(!isVerifyPhoneModalOpen);
    }, [isVerifyPhoneModalOpen]);
    var renderData = function () {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement(CompleteProfileTitle$1, null, t('completeYourProfile.screenTitle')),
            React.createElement(FormContainer$2, { "data-testid": "__complete_your_profile__" },
                React.createElement(Text.H3, null, t('completeYourProfile.titleText')),
                React.createElement(Flex, { justifyContent: "space-between" },
                    React.createElement(RadioButtonStyle$3, null,
                        React.createElement("input", { type: "radio", name: "title", ref: register({ required: true }), value: "Mr" }),
                        " \u00A0",
                        React.createElement("span", null, t('completeYourProfile.mr'))),
                    React.createElement(RadioButtonStyle$3, null,
                        React.createElement("input", { type: "radio", name: "title", ref: register({ required: true }), value: "Mrs" }),
                        "\u00A0",
                        React.createElement("label", null, t('completeYourProfile.mrs'))),
                    storeId !== EStoreID$1.MAFGEO && (React.createElement(RadioButtonStyle$3, null,
                        React.createElement("input", { type: "radio", name: "title", ref: register({ required: true }), value: "Ms" }),
                        "\u00A0",
                        React.createElement("label", null, t('completeYourProfile.ms'))))),
                errors.title && React.createElement(WarningMessage$3, { ml: 1 }, t('completeYourProfile.titleRequired')),
                React.createElement(Flex, { justifyContent: "space-between" },
                    React.createElement(SmallInputBox$1, null,
                        React.createElement(Input, { defaultValue: phoneCountryCode, name: "country_code", variant: errors.country_code ? 'error' : 'primary', register: register({}), disabled: true }),
                        errors.country_code && React.createElement(WarningMessage$3, null, errors.country_code.message)),
                    React.createElement(MidInputBox$1, null,
                        React.createElement(Input, { label: t('completeYourProfile.mobileNumber'), defaultValue: "", name: "phone_no", variant: errors.phone_no ? 'error' : 'primary', onBlur: function (e) { return !errors.phone_no && onPhoneChange(e.target.value); }, register: register({
                                required: t('completeYourProfile.mobileNumberRequired'),
                                pattern: {
                                    value: RegExp(phoneExpression),
                                    message: t('completeYourProfile.invalidMobileNumber'),
                                },
                            }), "data-testid": "__phone_no__" }),
                        errors.phone_no && React.createElement(WarningMessage$3, null, errors.phone_no.message))),
                React.createElement(InputContainerPadding$3, null, t('completeYourProfile.weWillOnlyCallYou')),
                policyAccept === PolicyAccept$1.YES ? (React.createElement(React.Fragment, null,
                    React.createElement(DOBLabel$1, null, t('completeYourProfile.dobFullText')),
                    React.createElement(Flex, { justifyContent: "space-between", width: "98%" },
                        React.createElement(SmallInputBox$1, null,
                            React.createElement(Controller, { control: control, as: Select, options: days$1, label: t('completeYourProfile.date'), name: "birth_date", defaultValue: null, style: { border: '0.5px solid black' }, variant: errors.birth_date ? 'error' : 'primary', register: policyAccept === PolicyAccept$1.YES ? register({}) : register, isLabelSeletionNull: true, m: 0, mt: 2, "data-testid": "__dob_date__" })),
                        React.createElement(SmallInputBox$1, null,
                            React.createElement(Controller, { control: control, as: Select, label: t('completeYourProfile.month'), options: months$1[language], defaultValue: null, name: "birth_month", style: { border: '0.5px solid black' }, variant: errors.birth_month ? 'error' : 'primary', register: policyAccept === PolicyAccept$1.YES ? register({}) : register, isLabelSeletionNull: true, m: 0, mt: 2, "data-testid": "__dob_month__" })),
                        React.createElement(SmallInputBox$1, null,
                            React.createElement(Controller, { control: control, as: Select, label: t('completeYourProfile.year'), options: years$1, defaultValue: null, name: "birth_year", style: { border: '0.5px solid black' }, variant: errors.birth_year ? 'error' : 'primary', register: policyAccept === PolicyAccept$1.YES ? register({}) : register, isLabelSeletionNull: true, m: 0, mt: 2, "data-testid": "__dob_year__" }))),
                    (errors.birth_date || errors.birth_year || errors.birth_month) && (React.createElement(WarningMessage$3, { ml: 1 }, t('completeYourProfile.dobRequired'))),
                    React.createElement(Flex, null, React.createElement(Controller, { control: control, as: Select, options: countries$3[language], label: t('completeYourProfile.nationality'), key: "code", defaultValue: null, name: "nationality", style: { border: '1px solid black' }, variant: errors.nationality ? 'error' : 'primary', ref: register({}), isLabelSeletionNull: true, "data-testid": "__dob_nationality__" })),
                    errors.nationality && (React.createElement(WarningMessage$3, { ml: 1 }, t('completeYourProfile.nationalityRequired'))))) : (''),
                storeId === 'mafuae' && (React.createElement(InputContainerPadding$3, null,
                    React.createElement(Checkbox, { size: 18, checkedBackground: '#000000', checkMarkTint: 'white', onChangeCheckbox: onChangeSubscribe, checked: policyAccept === PolicyAccept$1.YES }),
                    "\u00A0",
                    t('completeYourProfile.subscribeForLoyalty'),
                    " ",
                    t('completeYourProfile.read'),
                    ' ',
                    React.createElement(Button$1, { variant: "link", fontWeight: "bold", href: STATIC_PAGE_LINKS$1.SHARE_TERM_AND_CONDITION }, t('completeYourProfile.termAndConditions')))),
                React.createElement(LoaderSpan$3, null,
                    React.createElement(Button$1, { onClick: onClickSubmit, width: "100%", fontWeight: "bold" }, t('completeYourProfile.continue'))),
                React.createElement(TermAndCondition$1, null,
                    t('completeYourProfile.termConditionTxt'),
                    "\u00A0",
                    React.createElement(Button$1, { variant: "link", fontWeight: "bold", href: STATIC_PAGE_LINKS$1.TERM_AND_CONDITION }, t('completeYourProfile.termAndConditions')),
                    ' ',
                    t('completeYourProfile.and'),
                    ' ',
                    React.createElement(Button$1, { variant: "link", fontWeight: "bold", href: STATIC_PAGE_LINKS$1.UPDATE_PRIVACY_POLICY },
                        t('completeYourProfile.privacyPolicy'),
                        "."))),
            isBrowser$1() && isVerifyPhoneModalOpen && (React.createElement(VerifyPassword$1, { isShowShopping: false, email: email || '', phoneNumber: "" + phoneCountryCode + ((_a = getValues('phone_no')) === null || _a === void 0 ? void 0 : _a.replace(/^0/, '')), onVerifyAccount: function (uuid) { return onVerifyAccount(uuid); }, isShowCloseButton: true, action: "PHONE_UPDATE_VERIFICATION", modalBackGroundColor: "#0E5AA7", onCloseModal: toggleSetVerifyPhoneModalOpen }))));
    };
    return (React.createElement(Modal, { isOpen: showModal, title: '   ', showClose: false, backgroundColor: "#0E5AA7" }, renderData()));
};
var CompleteYourProfile$3 = withTranslation()(CompleteYourProfile$2);

var useFetchUserAddresses = function () {
    var dispatch = useDispatch();
    var selectUserAddresses = createSelector(function (state) { return state.userData; }, function (userData) { return userData.addresses; });
    var userAddresses = useSelector(selectUserAddresses);
    var _a = __read(useAppConfig$1(), 1), userCredentials = _a[0].userCredentials;
    var fetchUserAddresses = useCallback(function () { return dispatch(fetchUserAddresses$1()); }, [dispatch]);
    useEffect(function () {
        if (userCredentials && (userCredentials.authToken || userCredentials.token)) {
            fetchUserAddresses();
        }
    }, [fetchUserAddresses, userCredentials]);
    return userAddresses;
};

var getSelectedArea$1 = function (regions) {
    var areaCode = APP_CONFIG$1.areaCode;
    var selectedArea;
    if (areaCode) {
        selectedArea = regions
            .filter(function (region) { return region.areas; })
            .flatMap(function (_a) {
            var areas = _a.areas;
            return areas;
        })
            .find(function (_a) {
            var code = _a.code;
            return code === areaCode;
        });
    }
    return selectedArea;
};
var getSelectedCity$1 = function (regions) {
    var areaCode = APP_CONFIG$1.areaCode;
    if (areaCode) {
        var selectedCity = (regions.filter(function (region) { return region.areas; }).find(function (_a) {
            var areas = _a.areas;
            return areas.find(function (_a) {
                var code = _a.code;
                return code === areaCode;
            });
        }) || {}).name;
        return selectedCity;
    }
};
var setAreas$1 = function (regions, selectedArea, selectedCity) {
    return {
        type: EArea$3.FETCH_AREAS_SET,
        payload: { regions: regions, selectedArea: selectedArea, selectedCity: selectedCity },
    };
};
var setAddressAreas$1 = function (areas) {
    return {
        type: EArea$3.FETCH_AREAS_SET_QATAR,
        payload: areas,
    };
};
var toggleAddressList = function (payload) {
    return {
        type: TOGGLE_ADDRESS_LIST$1,
        payload: payload,
    };
};
var fetchAreas$1 = function () { return function (dispatch) {
    dispatch({
        type: EArea$3.FETCH_AREAS_GET,
        payload: {
            method: EApiMiddlewareMethod$3.GET,
            url: GET_DELIVERY_AREAS$1,
            onSuccess: function (data) {
                var regions = data.regions;
                var selectedArea = getSelectedArea$1(regions);
                var selectedCity = getSelectedCity$1(regions) || '';
                dispatch(setAreas$1(regions, selectedArea, selectedCity));
            },
        },
    });
}; };
var updateSelectedArea = function (areaCode) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var language;
    return __generator(this, function (_a) {
        language = getState().appConfig.language;
        // setAreaCode()
        dispatch({
            type: EArea$3.SET_AREA,
            payload: {
                method: EApiMiddlewareMethod$3.PUT,
                url: SET_DELIVERY_AREA$1,
                params: {
                    areaCode: areaCode,
                    lang: language,
                },
                onSuccess: function () {
                    setDeliveryArea$1(areaCode);
                    window.location.reload();
                    // dispatch(setAreaCode(areaCode));
                },
                isAbsUrl: true,
            },
        });
        return [2 /*return*/];
    });
}); }; };
var fetchAddressCitiesAndAreasAction$1 = function () { return function (dispatch, getState) {
    var code = getState().appConfig.code;
    dispatch({
        type: EArea$3.FETCH_AREAS_GET_QATAR,
        payload: {
            method: EApiMiddlewareMethod$3.GET,
            url: GET_ADDRESS_CITIES_ZONE_AREAS$1,
            params: { code: code },
            onSuccess: function (data) {
                dispatch(setAddressAreas$1(data.data));
            },
            apiVersion: 1,
        },
    });
}; };

var useFetchAreas$1 = function (areaCode, language) {
    var dispatch = useDispatch();
    var areaState = useSelector(function (state) {
        return {
            areaState: state.area,
        };
    }).areaState;
    var _a = __read(useAppConfig$1(), 1), _b = _a[0].features, features = _b === void 0 ? {} : _b;
    useEffect(function () {
        if (areaCode && language && (features === null || features === void 0 ? void 0 : features.isLocationCXEnable) === false) {
            // && sessionId As discussed this is not in use not so removed it  for now
            dispatch(fetchAreas$1());
        }
    }, [areaCode, dispatch, language, features]);
    return areaState;
};

var ChangeAreaList$1;
(function (ChangeAreaList) {
    ChangeAreaList["CITY"] = "CITY";
    ChangeAreaList["AREA"] = "AREA";
})(ChangeAreaList$1 || (ChangeAreaList$1 = {}));
var ChangeAreaView$1;
(function (ChangeAreaView) {
    ChangeAreaView["DEFAULT"] = "ChangeArea/Default";
    ChangeAreaView["USER_ADDRESSES"] = "ChangeArea/USER_ADDRESSES";
})(ChangeAreaView$1 || (ChangeAreaView$1 = {}));

var CitySelectedContainer$1 = styled(Flex)({
    background: COLORS$1.WILD_SAND,
    padding: '12px 16px',
    marginBottom: '16px',
    width: '100%',
    justifyContent: 'space-between',
});
var ParentContainer$1 = customStyled(Flex)(templateObject_1$1A || (templateObject_1$1A = __makeTemplateObject(["\n  flex-direction: column;\n  align-items: center;\n  justify-content: 'space-between';\n  ", "\n"], ["\n  flex-direction: column;\n  align-items: center;\n  justify-content: 'space-between';\n  ",
    "\n"])), function (props) {
    return props.currentView === ChangeAreaView$1.USER_ADDRESSES
        ? "\n      height: 84vh;\n      overflow-x: auto;\n      padding: 0 24px;\n\n      @media (min-width: " + props.theme.breakpoints[2] + ") {\n        height: 488px;\n      }\n    "
        : "\n      padding: 0 24px;\n    ";
});
var SelectNewAreaContainer$1 = styled.div({
    left: 0,
    display: 'block',
    position: 'fixed',
    bottom: 0,
    height: '40px',
    width: '100%',
    backgroundColor: COLORS$1.WHITE,
    margin: '15px 0px',
    'box-shadow': '0 14px 0 0 #fff, 0 3px 16px 0 rgba(0,0,0,.2)',
});
var SelectNewAreaCTAContainer$1 = styled.div({
    display: 'block',
    position: 'absolute',
    bottom: 0,
    right: 16,
    backgroundColor: COLORS$1.WHITE,
});
var CityAreaSelectionContainer$1 = styled.div({ width: '100%' });
var NewAreaText$1 = styled.div({
    color: COLORS$1.BLUE,
    display: 'inline',
    'padding-right': '10px',
    'font-weight': 500,
    cursor: 'pointer',
});
var City$1 = styled.div({ fontWeight: TYPOGRAPHY$1.WEIGHT[400], display: 'inline' });
var ChangeCity$1 = styled.div({
    cursor: 'pointer',
    color: COLORS$1.BLUE,
    fontWeight: TYPOGRAPHY$1.WEIGHT[500],
    fontSize: '14px',
});
var Title$6 = styled.div({ margin: '16px 0', fontWeight: TYPOGRAPHY$1.WEIGHT[500] });
var templateObject_1$1A;

var getCityList = function (citiesAndAreaList) { return citiesAndAreaList.regions; };
var getAreaList = function (citiesAndAreaList, currentCity) {
    var e_1, _a;
    try {
        for (var _b = __values(citiesAndAreaList.regions), _c = _b.next(); !_c.done; _c = _b.next()) {
            var region = _c.value;
            if (region.name === currentCity || currentCity.includes(region.name)) {
                return region.areas || [];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
var getTitle = function (list) {
    return list === ChangeAreaList$1.AREA ? i18next.t('selectArea') : i18next.t('selectCity');
};
var getList = function (list, citiesAndAreaList, currentCity) {
    return list === ChangeAreaList$1.AREA ? getAreaList(citiesAndAreaList, currentCity) : getCityList(citiesAndAreaList);
};

var getFormattedFullAddress$1 = function (address) {
    var _a = address || {}, landmark = _a.landmark, streetName = _a.streetName, deliveryArea = _a.deliveryArea, town = _a.town;
    /**
     * handling issue if the user address breaks the page,
     * when delivery area is undefined.
     */
    if (!deliveryArea) {
        return '';
    }
    return __spread((landmark ? [landmark] : []), [streetName, deliveryArea.name, town]).join(', ').substr(0, 150);
};
var getExtraProps$1 = function (address, isAddressActive, display) { return (__assign({ isAddressActive: isAddressActive(address) }, (display ? { m: 0, width: 'calc(50% - 8px)' } : { mb: [2, '12px'] }))); };
var AddressList$4 = function (_a) {
    var addresses = _a.addresses, isAddressActive = _a.isAddressActive, onValidateCartEntries = _a.onValidateCartEntries, rest = __rest(_a, ["addresses", "isAddressActive", "onValidateCartEntries"]);
    var selectedAddress = useSelector(function (state) { return state.userData; }).selectedAddress; // use user data hook instead
    return (React.createElement(ButtonGroup, __assign({ onChange: onValidateCartEntries }, rest), addresses.map(function (address) {
        var firstName = address.firstName, phone = address.phone, defaultAddress = address.defaultAddress;
        var fullSelectedAddress = selectedAddress ? getFormattedFullAddress$1(selectedAddress) : '';
        var fullAddress = getFormattedFullAddress$1(address);
        var isSelected = fullSelectedAddress === fullAddress;
        var bgColor = isSelected ? COLORS$1.LAVENDOR : COLORS$1.WHITE;
        return (React.createElement(ButtonGroupItem, __assign({ bg: bgColor, boxShadow: "0 1px 1px 0 rgba(0, 0, 0, .2)", key: address.id, fontSize: 2, p: 3, lineHeight: 1.3, value: address, testid: "address-button" }, getExtraProps$1(address, isAddressActive, rest.display)),
            React.createElement(Flex, { justifyContent: "space-between" },
                React.createElement(Flex, { flexDirection: "column" },
                    firstName && (React.createElement(Text, { mb: SPACINGS$1[8], fontWeight: 4, "data-testid": "__checkout_delivery_address_receiver_name__", color: COLORS$1.THUNDURA }, firstName)),
                    phone && (React.createElement(Text, { fontWeight: 3, color: COLORS$1.THUNDURA, "data-testid": "__checkout_delivery_address_receiver_phone__" }, phone)),
                    fullAddress && (React.createElement(Text, { fontWeight: 3, color: COLORS$1.THUNDURA, "data-testid": "__checkout_delivery_address_receiver_address__" }, fullAddress))),
                defaultAddress === true && React.createElement(Star, { size: "CUSTOM", height: 24, width: 24, fill: COLORS$1.BLUE }))));
    })));
};
var AddressList$5 = memo(AddressList$4, function (prev, next) { return prev.addresses === next.addresses; });

var UserAddresses = function (_a) {
    var userAddresses = _a.userAddresses, _b = _a.onUserAddressSelectionHandler, onUserAddressSelectionHandler = _b === void 0 ? function () { return false; } : _b, _c = _a.isAddressActive, isAddressActive = _c === void 0 ? function () { return false; } : _c, _d = _a.onSelectNewArea, onSelectNewArea = _d === void 0 ? function () { return null; } : _d;
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        userAddresses.list && userAddresses.list.length > 0 && (React.createElement(AddressList$5, { width: '100%', addresses: userAddresses.list, onValidateCartEntries: onUserAddressSelectionHandler, isAddressActive: isAddressActive, "data-testid": "user-addresses-view-list" })),
        React.createElement(SelectNewAreaContainer$1, null,
            React.createElement(SelectNewAreaCTAContainer$1, null,
                t('or'),
                React.createElement(NewAreaText$1, { onClick: onSelectNewArea, "data-testid": "select-new-area-text" },
                    ' ',
                    t('selectNewArea'))))));
};

var ChangeAreaModal = function (_a) {
    var isOpen = _a.isOpen, toggleModalState = _a.toggleModalState, onSelection = _a.onSelection, userAddresses = _a.userAddresses, areaState = _a.areaState;
    var selectedCity = areaState.selectedCity;
    var t = useTranslation().t;
    var isLoggedIn = !!getUserTokenFromCookie$1();
    var _b = __read(useState(selectedCity), 2), city = _b[0], updateCity = _b[1];
    var dispatch = useDispatch();
    var findAppropriateList = function () { return (city ? ChangeAreaList$1.AREA : ChangeAreaList$1.CITY); };
    var _c = __read(useState(findAppropriateList()), 2), appropriateList = _c[0], setAppropriateList = _c[1];
    var _d = __read(useState(isLoggedIn && userAddresses.list.length > 0 ? ChangeAreaView$1.USER_ADDRESSES : ChangeAreaView$1.DEFAULT), 2), currentView = _d[0], setCurrentView = _d[1];
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    var onCloseModal = function () {
        toggleModalState(false);
        updateCity(selectedCity);
        setAppropriateList(findAppropriateList());
        // Always reset the view to user addresses
        // when closing the modal when user is logged in
        if (isLoggedIn) {
            setCurrentView(ChangeAreaView$1.USER_ADDRESSES);
        }
    };
    var onChangeCity = function () {
        setAppropriateList(ChangeAreaList$1.CITY);
    };
    // Select handler of list from default view
    var onSelectFromDefaultView = useCallback(function (item) {
        if (appropriateList === ChangeAreaList$1.CITY) {
            updateCity(item.name);
            setAppropriateList(ChangeAreaList$1.AREA);
        }
        else {
            GTMEventCall(GTMEvents$1.custom_event, {
                eventAction: 'header_interaction - address_change',
                eventLabel: item.name,
            });
            toggleModalState(false);
            // update handler area should be here
            dispatch(updateSelectedArea(item.code));
        }
    }, [appropriateList, toggleModalState, dispatch, GTMEventCall]);
    var defaultViewEntries = useMemo(function () { return getList(appropriateList, areaState, city) || []; }, [
        appropriateList,
        areaState,
        city,
    ]);
    var defaultViewListHeight = useMemo(function () {
        var isChangeCity = appropriateList === ChangeAreaList$1.CITY;
        return [
            // not the best solution but couldn't restructure due to its complexity
            // 206/246px is equivalent to the space on top of the scrollable list
            "calc(100vh - " + (isChangeCity ? 206 : 246) + "px)",
            null,
            null,
            isChangeCity ? '412px' : '374px',
        ];
    }, [appropriateList]);
    // Default view for city and area selection
    var defaultView = useCallback(function () {
        if (areaState.isLoading) {
            return React.createElement("div", { "data-testid": "default-view-list-loading" }, t('loadingAddress'));
        }
        else if (areaState.error) {
            return React.createElement("div", { "data-testid": "default-view-list-error" }, t('somethingWentWrong'));
        }
        var title = getTitle(appropriateList);
        return (React.createElement(CityAreaSelectionContainer$1, null,
            !!city && appropriateList === ChangeAreaList$1.AREA && (React.createElement(CitySelectedContainer$1, null,
                React.createElement("div", null,
                    t('citySelected'),
                    ": ",
                    React.createElement(City$1, null, city)),
                React.createElement(ChangeCity$1, { onClick: onChangeCity, "data-testid": "change-city-text" }, t('change')))),
            React.createElement(Title$6, null, title),
            React.createElement(SearchableListView, { searchPlaceHolder: title, entries: defaultViewEntries, icon: React.createElement(MagnifyGlass, { size: "M" }), listStyles: { height: defaultViewListHeight, marginTop: '16px' }, onItemSelect: onSelectFromDefaultView, "data-testid": "default-view-list" })));
    }, [
        appropriateList,
        areaState.error,
        areaState.isLoading,
        city,
        defaultViewEntries,
        defaultViewListHeight,
        onSelectFromDefaultView,
        t,
    ]);
    var onUserAddressSelectionHandler = useCallback(function (address) {
        GTMEventCall(GTMEvents$1.custom_event, {
            eventAction: 'header_interaction - address_change',
            eventLabel: address.deliveryArea.code,
        });
        onSelection && onSelection(address);
    }, [onSelection, GTMEventCall]);
    var onSelectNewArea = function () {
        setCurrentView(ChangeAreaView$1.DEFAULT);
    };
    var isAddressActive = function () { return false; };
    var userAddressesView = useCallback(function () {
        if (userAddresses.isLoading) {
            return React.createElement("div", { "data-testid": "user-addresses-view-list-loading" }, t('userAddresses.loading'));
        }
        else if (userAddresses.error) {
            return React.createElement("div", { "data-testid": "user-addresses-view-list-error" }, t('userAddresses.error'));
        }
        return (React.createElement(UserAddresses, { onUserAddressSelectionHandler: onUserAddressSelectionHandler, userAddresses: userAddresses, isAddressActive: isAddressActive, onSelectNewArea: onSelectNewArea }));
    }, [onUserAddressSelectionHandler, t, userAddresses]);
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onCloseModal, width: [1, null, null, '400px'], height: ['100vh', null, null, '616px'], title: t('chooseDeliveryLocation'), marginBottom: "0", titleStyles: { fontWeight: 'bold' }, p: "24px 0", headerStyles: { paddingX: '24px' } },
        React.createElement(ParentContainer$1, { currentView: currentView, "data-testid": currentView === ChangeAreaView$1.DEFAULT ? 'default-view' : 'user-addresses-view' }, currentView === ChangeAreaView$1.DEFAULT || !userAddresses.list ? defaultView() : userAddressesView())));
};

var AreaChangeContainer$1 = customStyled(Flex)(templateObject_1$1B || (templateObject_1$1B = __makeTemplateObject(["\n  align-items: center;\n  justify-content: space-between;\n  min-height: 24px;\n  margin: 4px 12px;\n  transform: translate(0px, 0px);\n  @media (max-width: ", ") {\n    padding: 15px 0px 7px;\n    margin: 0px;\n    width: 100%;\n    transform: ", "\n    background-color: #fff;\n  }\n  \n"], ["\n  align-items: center;\n  justify-content: space-between;\n  min-height: 24px;\n  margin: 4px 12px;\n  transform: translate(0px, 0px);\n  @media (max-width: ", ") {\n    padding: 15px 0px 7px;\n    margin: 0px;\n    width: 100%;\n    transform: ", "\n    background-color: #fff;\n  }\n  \n"])), function (props) { return props.theme.breakpoints[3]; }, function (props) { return (props.isHideNav ? 'translate(0px, -155px);' : 'translate(0px, 0px);'); });
AreaChangeContainer$1.defaultProps = {
    as: 'div',
};
var AreaChangeCommonContainer$1 = styled(Flex)(templateObject_2$1h || (templateObject_2$1h = __makeTemplateObject(["\n  flex-direction: row;\n  align-items: center;\n"], ["\n  flex-direction: row;\n  align-items: center;\n"])));
var DeliverToText$1 = styled(Flex)(templateObject_3$12 || (templateObject_3$12 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), function (props) { return (props.isDesktopHeader ? '2px' : '4px'); });
var DeliverTimeText$1 = customStyled(Box)(templateObject_4$U || (templateObject_4$U = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 250px;\n  flex: 1;\n  font-weight: ", ";\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 250px;\n  flex: 1;\n  font-weight: ", ";\n"])), function (props) { return props.theme.fontWeights[3]; });
var AreaChangeTextWrapper$1 = customStyled(Box)(templateObject_5$G || (templateObject_5$G = __makeTemplateObject(["\n  white-space: nowrap;\n  align-items: center;\n  cursor: pointer;\n  color: ", ";\n  @media (min-width: ", ") {\n    font-weight: ", ";\n  }\n\n  @media (max-width: ", ") {\n    font-weight: ", ";\n  }\n"], ["\n  white-space: nowrap;\n  align-items: center;\n  cursor: pointer;\n  color: ", ";\n  @media (min-width: ", ") {\n    font-weight: ", ";\n  }\n\n  @media (max-width: ", ") {\n    font-weight: ", ";\n  }\n"])), function (props) { return (props.isDesktopHeader ? COLORS$1.WHITE : COLORS$1.ANCHOR_BLUE); }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.fontWeights[4]; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.theme.fontWeights[6]; });
AreaChangeTextWrapper$1.defaultProps = {
    fontSize: [1, null, null, null, 1],
};
var DeliveryAreaText$1 = customStyled(Box)(templateObject_6$w || (templateObject_6$w = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-left: 1px;\n  max-width: 150px;\n  ", "\n  color: ", ";\n  @media (min-width: ", ") {\n    font-weight: ", ";\n  }\n  @media (max-width: ", ") {\n    height: 15px;\n    font-weight: ", ";\n  }\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-left: 1px;\n  max-width: 150px;\n  ", "\n  color: ", ";\n  @media (min-width: ", ") {\n    font-weight: ", ";\n  }\n  @media (max-width: ", ") {\n    height: 15px;\n    font-weight: ", ";\n  }\n"])), function (props) { return (props === null || props === void 0 ? void 0 : props.isShowFullArea) && "max-width: 109px;"; }, function (props) { return (props.isDesktopHeader ? COLORS$1.WHITE : COLORS$1.ANCHOR_BLUE); }, function (props) { return props.theme.breakpoints[3]; }, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.breakpoints[3]; }, function (props) { return props.theme.fontWeights[4]; });
var ChangeAreaCTA$1 = customStyled(Box)(templateObject_7$u || (templateObject_7$u = __makeTemplateObject(["\n  margin-left: 10px;\n  @media (min-width: ", ") {\n    color: ", ";\n  }\n  font-weight: ", ";\n  ", "\n\n"], ["\n  margin-left: 10px;\n  @media (min-width: ", ") {\n    color: ", ";\n  }\n  font-weight: ", ";\n  ",
    "\n\n"])), function (props) { return props.theme.breakpoints[1]; }, COLORS$1.ANCHOR_BLUE, function (props) { return props.theme.fontWeights[6]; }, function (props) {
    return variant({
        prop: 'language',
        variants: {
            en: {
                fontWeight: props.theme.fontWeights[6],
            },
            ar: {
                fontWeight: props.theme.fontWeights[6],
            },
        },
    });
});
ChangeAreaCTA$1.defaultProps = {
    display: ['none', 'none', 'none', 'none', 'block'],
};
var MChangeArea$1 = customStyled(Box)(templateObject_8$u || (templateObject_8$u = __makeTemplateObject(["\n  cursor: pointer;\n  font-size: 12px;\n  margin-left: 10px;\n  min-width: 50px;\n  margin-right: 0px;\n  font-weight: 700;\n"], ["\n  cursor: pointer;\n  font-size: 12px;\n  margin-left: 10px;\n  min-width: 50px;\n  margin-right: 0px;\n  font-weight: 700;\n"])));
MChangeArea$1.defaultProps = {
    color: [COLORS$1.ANCHOR_BLUE, null, null, null, 'mineShaft'],
    display: ['block', null, null, null, 'none'],
};
var templateObject_1$1B, templateObject_2$1h, templateObject_3$12, templateObject_4$U, templateObject_5$G, templateObject_6$w, templateObject_7$u, templateObject_8$u;

var SelectAddressLocation$2 = React.lazy(function () {
    return Promise.resolve().then(function () { return index$7; }).then(function (module) { return ({ default: module.SelectAddressLocation }); });
});
var LoggedOutJourney = function (_a) {
    var isCarrefourRevamp = _a.isCarrefourRevamp, showOldAddressJourney = _a.showOldAddressJourney, isShowLocationScreen = _a.isShowLocationScreen, appConfig = _a.appConfig, data = _a.data, setShowLocationMapScreen = _a.setShowLocationMapScreen;
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, null, isCarrefourRevamp && !showOldAddressJourney ? (React.createElement(AddressMap, { t: t, open: isShowLocationScreen, storeId: appConfig.storeId || '', setShowMap: function () { return setShowLocationMapScreen(false); }, configStore: data })) : (React.createElement(SelectAddressLocation$2, { closeDrawer: function () { return setShowLocationMapScreen(false); } })))));
};

var AddAddress$2 = React.lazy(function () { return Promise.resolve().then(function () { return index$7; }).then(function (module) { return ({ default: module.AddAddress }); }); });
var AddressList$6 = React.lazy(function () { return Promise.resolve().then(function () { return index$7; }).then(function (module) { return ({ default: module.AddressList }); }); });
var ChangeArea = (function (_a) {
    var _b, _c;
    var _d = _a.ssr, ssr = _d === void 0 ? false : _d, _e = _a.isShowFullArea, isShowFullArea = _e === void 0 ? false : _e, _f = _a.isHideNav, isHideNav = _f === void 0 ? false : _f, _g = _a.showDesktop, showDesktop = _g === void 0 ? false : _g, _h = _a.isDesktopHeader, isDesktopHeader = _h === void 0 ? false : _h;
    var _j = useSelector(function (state) { return (__assign({}, __assign(__assign(__assign({}, state.userData), state.appConfig), { isLoading: state.userData.isLoading, showAddressList: state.area.showAddressList }))); }), selectedAddress = _j.selectedAddress, addresses = _j.addresses, appConfigAreacCode = _j.areaCode, longitude = _j.longitude, latitude = _j.latitude, userId = _j.userId, defaultAreaCode = _j.defaultAreaCode, birthday = _j.birthday, firstName = _j.firstName, lastName = _j.lastName, contact_number = _j.contact_number, nationality = _j.nationality, email = _j.email, title = _j.title, isPhoneVerified = _j.isPhoneVerified, isNewUser = _j.isNewUser, fullName = _j.fullName, phone = _j.phone, isLoading = _j.isLoading, showAddressList = _j.showAddressList, pageName = _j.pageName, selectedTabId = _j.selectedTabId;
    var countryConfiguration = useSelector(function (state) { return state.appConfig; }).countryConfiguration;
    var _k = countryConfiguration || {}, countryNameEn = _k.countryNameEn, countryNameAr = _k.countryNameAr, countryOfOperationID = _k.countryOfOperationID, defaultLatitude = _k.defaultLatitude, defaultLongitude = _k.defaultLongitude, phoneCountryCode = _k.phoneCountryCode;
    useEffect(function () {
        var areaCode = userId ? appConfigAreacCode : defaultAreaCode;
        brazeSetCustomUserAttribute$1({
            area_code: latitude && longitude ? null : areaCode,
            latitude: (longitude && latitude) || null,
            longitude: (latitude && longitude) || null,
        });
    }, [appConfigAreacCode, longitude, latitude, userId, defaultAreaCode]);
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var isSSR = ssr || !isBrowser$1();
    var _l = __read(useAppConfig$1(), 3), _m = _l[0], _o = _m.areaCode, areaCode = _o === void 0 ? '' : _o, language = _m.language, features = _m.features;
    var _p = __read(useState(false), 2), showCloseButton = _p[0], setShowCloseButton = _p[1];
    var _q = __read(useState(false), 2), isShowAddressScreen = _q[0], setShowNewAddressScreen = _q[1];
    var _r = __read(useState(), 2), newAddressEditInfo = _r[0], setNewAddressEditInfo = _r[1];
    var _s = __read(useState(false), 2), isShowLocationScreen = _s[0], setShowLocationMapScreen = _s[1];
    var isNonFoodV2Enabled = useNonFoodV2Journey();
    var _t = __read(useState(false), 2), isOpen = _t[0], toggleModalState = _t[1];
    var showAreaChangeModal = useCallback(function () { return toggleModalState(true); }, []);
    var userAddresses = useFetchUserAddresses();
    var isLoggedIn = !!getUserTokenFromCookie$1();
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    var _u = __read(useState(false), 2), showMap = _u[0], setShowMap = _u[1];
    var _v = __read(useState(false), 2), showForm = _v[0], setShowForm = _v[1];
    var _w = __read(useState(), 2), unverifiedAddress = _w[0], setUnverifiedAddress = _w[1];
    var _x = __read(useState(false), 2), isSelected = _x[0], setIsSelected = _x[1];
    var _y = __read(useState(false), 2), isTyping = _y[0], setIsTyping = _y[1];
    var _z = __read(useState(unverifiedAddress), 2), addressForMapScreen = _z[0], setAddressForMapScreen = _z[1];
    var _0 = __read(useState(), 2), editInfo = _0[0], setEditInfo = _0[1];
    var state = useSelector(function (state) { return state; });
    var setShowAddressList = useCallback(function (payload) { return dispatch(toggleAddressList(payload)); }, [dispatch]);
    var appConfig = useSelector(function (state) { return state.appConfig; });
    var pageStructure = useSelector(function (state) { return state.pageStructure; });
    var onAddressSelection = useCallback(function (selectedAddress, type) { return __awaiter(void 0, void 0, void 0, function () {
        var isPolygonChange, store;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (features === null || features === void 0 ? void 0 : features.isLocationCXEnable) {
                        if (isNaN(parseFloat(String(selectedAddress.latitude))) ||
                            isNaN(parseFloat(String(selectedAddress.longitude)))) {
                            //dispatch(userSetSelectedAddress(selectedAddress));
                            setNewAddressEditInfo(selectedAddress);
                            setShowNewAddressScreen(true);
                            setShowCloseButton(true);
                        }
                        else {
                            setSelectedAddressID$1(selectedAddress.id);
                            setSelectedAddressIDCookie$1(selectedAddress.id);
                            dispatch(setLocationCXDetail$1(selectedAddress));
                        }
                    }
                    else {
                        dispatch(updateSelectedArea(selectedAddress.deliveryArea.code));
                    }
                    isPolygonChange = (_a = getGrowthBookFeatureValueViaInstance$1(state, 'is_polygon_cached')) === null || _a === void 0 ? void 0 : _a.on;
                    type === 'new-address-view' ? setShowAddressList(false) : toggleModalState(false);
                    if (!isPolygonChange) return [3 /*break*/, 2];
                    store = { appConfig: appConfig, pageStructure: pageStructure };
                    return [4 /*yield*/, getDeliveryTime$1()(dispatch, store, undefined, isPolygonChange)];
                case 1:
                    _b.sent();
                    window.location.reload();
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [dispatch, features, setShowAddressList, appConfig, pageStructure, state]);
    var onAddressListClose = useCallback(function () {
        setShowAddressList(false);
    }, [setShowAddressList]);
    var onHeaderActionPress = useCallback(function () {
        //setShowAddAddress(true);
        setNewAddressEditInfo(true);
        setShowNewAddressScreen(true);
        setShowCloseButton(true);
    }, []);
    var areaState = useFetchAreas$1(areaCode, language);
    var selectedArea = useMemo(function () { return (areaState ? areaState : {}); }, [
        areaState,
    ]).selectedArea /*, selectedLocationCXArea*/;
    // const appConfigLoaded = usePrevious(requestStatus.done); // catches up the toggling of "isLoading=true"
    /*if ((!selectedArea || !selectedArea.name) && !selectedLocationCXArea) {
      return null;
    }*/
    var onChangeArea = function () {
        GTMEventCall(GTMEvents$1.custom_event, {
            eventAction: GTMEventActions$1.header_interaction,
            eventLabel: 'address change',
        });
        if (isNonFoodV2Enabled) {
            GTMEventCall(GTMEvents$1.custom_event, {
                eventAction: GTMEventActions$1.address_icon_interaction,
                eventLabel: GTMEventLabels$1.change_address_click,
                ga4: true,
            });
        }
        if (features === null || features === void 0 ? void 0 : features.isLocationCXEnable) {
            if (isLoggedIn) {
                if (addresses.list.length > 0) {
                    setShowAddressList(true);
                }
                else {
                    setShowCloseButton(true);
                    setShowMap(!showMap);
                    setShowNewAddressScreen(true);
                }
            }
            else {
                setShowLocationMapScreen(true);
            }
        }
        else {
            showAreaChangeModal();
        }
    };
    var onAddressSuccess = function (addressData) {
        // !addressData?.defaultAddress  condition added because for defaultaddress case its already calling setLocationCXDetail(addressData)(dispatch) when adding address
        !(addressData === null || addressData === void 0 ? void 0 : addressData.defaultAddress) && dispatch(setLocationCXDetail$1(addressData));
        setShowNewAddressScreen(false);
    };
    var onVerifyAccount = function (uuid, phoneNumber) {
        var _a;
        var params = {
            birthday: birthday,
            firstName: firstName,
            lastName: lastName,
            mobileNumberType: contact_number ? (_a = contact_number[0]) === null || _a === void 0 ? void 0 : _a.type : '',
            nationality: nationality,
            newEmail: email,
            newMobileNumber: phoneNumber,
            oldEmail: email,
            title: title,
            isPhoneVerified: true,
            uuid: uuid,
        };
        dispatch(setUserDataUpdateSuccess({ phone: phoneNumber, isPhoneVerified: true }));
        userProfileUpdate$1(params)(dispatch);
    };
    var selectedNavigation = pageStructure.find(function (obj) { return obj.id === selectedTabId; }) || {};
    var DeliveryTimeTitle = ((_c = (_b = selectedNavigation === null || selectedNavigation === void 0 ? void 0 : selectedNavigation.components) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.title) || '';
    useEffect(function () {
        if (!isNull$1(selectedAddress) &&
            !isEmptyObject$1(selectedAddress) &&
            isNaN(Number(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.latitude)) &&
            isNaN(Number(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.longitude))) {
            setShowNewAddressScreen(true);
            setNewAddressEditInfo(selectedAddress);
        }
    }, [selectedAddress]);
    var deliveryAreaText = (features === null || features === void 0 ? void 0 : features.isLocationCXEnable) ? getDeliveryArea$1() || decodeStr$1(areaCode)
        : selectedArea
            ? language === EN$1
                ? selectedArea.code
                : selectedArea.name
            : '';
    var isCarrefourRevamp = useFeature('flutter.address_revamp.enabled').on;
    var data = {
        countryNameEn: countryNameEn,
        countryNameAr: countryNameAr,
        countryOfOperationID: countryOfOperationID,
        profile: {
            contact_number: contact_number
                ? contact_number
                : [
                    {
                        type: '',
                        number: '',
                    },
                ],
            first_name: firstName || '',
        },
        defaultCountryCode: phoneCountryCode !== null && phoneCountryCode !== void 0 ? phoneCountryCode : '',
        defaultLatitude: defaultLatitude,
        defaultLongitude: defaultLongitude,
    };
    var handleUnverifiedAddressFlow = function (addressId) {
        var foundAddress = Array.isArray(addresses.list)
            ? addresses.list.find(function (address) { return address.id === addressId; })
            : null;
        if (!foundAddress)
            return;
        setUnverifiedAddress(__assign(__assign({}, foundAddress), { defaultCountryCode: phoneCountryCode }));
        setEditInfo({
            id: addressId,
            coordinates: { lat: foundAddress.latitude, lng: foundAddress.longitude },
        });
        setShowAddressList(false);
        setShowForm(true);
    };
    var handleMapAddress = function (value) {
        setAddressForMapScreen(value);
    };
    var coordinates = parseLocationCoordinates((editInfo === null || editInfo === void 0 ? void 0 : editInfo.coordinates) ? {
        lat: editInfo.coordinates.lat || defaultLatitude,
        lng: editInfo.coordinates.lng || defaultLongitude,
    }
        : { lat: defaultLatitude, lng: defaultLongitude });
    var EStoreIds;
    (function (EStoreIds) {
        EStoreIds["MAFUAE"] = "mafuae";
        EStoreIds["MAFSAU"] = "mafsau";
        EStoreIds["MAFEGY"] = "mafegy";
        EStoreIds["MAFKWT"] = "mafkwt";
        EStoreIds["MAFQAT"] = "mafqat";
        EStoreIds["MAFPAK"] = "mafpak";
        EStoreIds["MAFLBN"] = "maflbn";
        EStoreIds["MAFJOR"] = "mafjor";
        EStoreIds["MAFKEN"] = "mafken";
    })(EStoreIds || (EStoreIds = {}));
    var storeId = appConfig.storeId || '';
    var showOldAddressJourney = shouldAlwaysShowOlderAddressJourney$1();
    return (React.createElement(React.Fragment, null,
        showDesktop ? (React.createElement(Box, { id: pageName + "_address_change", "data-sl": "mask", className: "desktop-area-section", display: ['none', null, null, 'block'], onClick: onChangeArea },
            React.createElement(AreaChangeContainer$1, { "data-testid": "delivery_city_area", "data-sl": "mask", isHideNav: isHideNav },
                React.createElement(AreaChangeCommonContainer$1, null, isSSR || areaState.isLoading ? null : (React.createElement(React.Fragment, null,
                    React.createElement(AreaChangeLocationNew, { size: "M", fill: isDesktopHeader ? COLORS$1.WHITE : COLORS$1.BLUE }),
                    React.createElement(Flex, { ml: "15px" },
                        React.createElement(AreaChangeTextWrapper$1, { isDesktopHeader: isDesktopHeader },
                            React.createElement(DeliverToText$1, { isDesktopHeader: isDesktopHeader },
                                React.createElement(DeliverTimeText$1, null, DeliveryTimeTitle || t('deliverTo'))),
                            React.createElement(DeliveryAreaText$1, { isShowFullArea: isShowFullArea, "data-testid": "header_default_area", title: deliveryAreaText, isDesktopHeader: isDesktopHeader }, deliveryAreaText))))))))) : (React.createElement(Flex, { className: "mobile-area-section", id: pageName + "_address_change", "data-sl": "mask" },
            React.createElement(AreaChangeContainer$1, { "data-testid": "delivery_city_area", "data-sl": "mask", isHideNav: isHideNav },
                React.createElement(AreaChangeCommonContainer$1, null, isSSR || areaState.isLoading ? null : (React.createElement(React.Fragment, null,
                    React.createElement(AreaChangeLocationNew, { size: "M" }),
                    React.createElement(Flex, { ml: "15px" },
                        React.createElement(AreaChangeTextWrapper$1, { display: "flex" },
                            React.createElement(Box, { as: "span", mr: "5px", fontWeight: "700", display: "table" },
                                t('deliverTo'),
                                ":",
                                ' '),
                            React.createElement(DeliveryAreaText$1, { isShowFullArea: isShowFullArea, "data-testid": "header_default_area", title: deliveryAreaText }, deliveryAreaText)))))),
                React.createElement(MChangeArea$1, { onClick: onChangeArea }, t('change'))))),
        isBrowser$1() && isLoggedIn && (features === null || features === void 0 ? void 0 : features.isLocationCXEnable) && addresses.list.length > 0 && showAddressList && (React.createElement(Suspense, { fallback: true }, isCarrefourRevamp && !showOldAddressJourney ? (React.createElement(DeliveryLocationSheet, { open: showAddressList, onOpenChange: function () { return setShowAddressList(false); }, addresses: addresses.list || [], currentAddress: (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.id) || '', t: t, storeId: storeId, configStore: data, showMap: showMap, toggleMap: setShowMap, onUpdateUnverifiedAddress: handleUnverifiedAddressFlow })) : (React.createElement(AddressList$6, { isOpen: showAddressList, onHeaderActionPress: onHeaderActionPress, onSelection: function (selectedAddress) { return onAddressSelection(selectedAddress, 'new-address-view'); }, onClose: onAddressListClose })))),
        unverifiedAddress ? (React.createElement(AddressForm, { address: unverifiedAddress, coordinates: coordinates, editInfo: editInfo, handleMapAddress: handleMapAddress, openForm: showForm, setIsSelected: setIsSelected, setIsTyping: setIsTyping, setShowMap: setShowMap, storeId: storeId, t: t, toggleForm: setShowForm })) : null,
        React.createElement(AddressMap, { address: addressForMapScreen, configStore: data, coordinate: coordinates, id: editInfo === null || editInfo === void 0 ? void 0 : editInfo.id, editInfo: editInfo, open: showMap, selected: isSelected, setShowMap: setShowMap, storeId: storeId, t: t, typing: isTyping }),
        isBrowser$1() && !(features === null || features === void 0 ? void 0 : features.isLocationCXEnable) && (React.createElement(ChangeAreaModal, { isOpen: isOpen, toggleModalState: toggleModalState, onSelection: function (selectedAddress) { return onAddressSelection(selectedAddress, 'default-view'); }, areaCode: areaCode, userAddresses: userAddresses, areaState: areaState })),
        isBrowser$1() && !addresses.isLoading && (features === null || features === void 0 ? void 0 : features.isLocationCXEnable) && isShowAddressScreen && (React.createElement(Suspense, { fallback: true }, isCarrefourRevamp && !showOldAddressJourney ? (React.createElement(AddressMap, { address: addressForMapScreen, configStore: data, coordinate: coordinates, id: editInfo === null || editInfo === void 0 ? void 0 : editInfo.id, editInfo: editInfo, open: showMap, selected: isSelected, setShowMap: setShowMap, storeId: storeId, t: t, typing: isTyping })) : (React.createElement(AddAddress$2, { editInfo: newAddressEditInfo, isShowCloseButton: showCloseButton, isGoogleMapVisible: features === null || features === void 0 ? void 0 : features.isLocationCXEnable, onSuccess: function (addressData) { return onAddressSuccess(addressData); }, onClose: function () { return setShowNewAddressScreen(false); }, onBack: function () {
                setShowAddressList(true);
                setShowNewAddressScreen(false);
            } })))),
        isBrowser$1() && isShowLocationScreen && (React.createElement(LoggedOutJourney, { isCarrefourRevamp: isCarrefourRevamp, showOldAddressJourney: showOldAddressJourney, isShowLocationScreen: isShowLocationScreen, appConfig: appConfig, data: data, setShowLocationMapScreen: setShowLocationMapScreen })),
        isBrowser$1() && phone && !isPhoneVerified && isNewUser && (features === null || features === void 0 ? void 0 : features.isForcePhoneNumberValidation) && (React.createElement(VerifyPassword$1, { "data-testid": "verify_otp_force_profile_update", isShowShopping: false, email: email || '', phoneNumber: phone, onVerifyAccount: function (uuid, phoneNumber) {
                onVerifyAccount(uuid || '', phoneNumber || '');
            }, action: "PHONE_VERIFICATION", modalBackGroundColor: COLORS$1.ANCHOR_BLUE, showModalClose: false, isForceVerify: true, isShowLogo: true, userName: fullName, width: [1, null, '650px'], contentStyles: { paddingLeft: '10%', paddingRight: '10%' }, isShowCloseButton: false })),
        isBrowser$1() &&
            !isLoading &&
            !phone &&
            isLoggedIn &&
            fullName &&
            window.location.pathname.indexOf('/authcallback') === -1 && (React.createElement(CompleteYourProfile$3, { "data-testid": "complete-your-profile", onSuccess: function () { return window.location.reload(); } }))));
});

var Container$g = customStyled(Flex)(templateObject_1$1C || (templateObject_1$1C = __makeTemplateObject(["\n  input[type='radio'] {\n    width: 18px;\n    height: 18px;\n  }\n  border-top: 1px solid ", ";\n  &:nth-last-of-type(2){\n    border-bottom: 1px solid ", ";\n  }\n  \n  background-color: ", ";\n"], ["\n  input[type='radio'] {\n    width: 18px;\n    height: 18px;\n  }\n  border-top: 1px solid ", ";\n  &:nth-last-of-type(2){\n    border-bottom: 1px solid ", ";\n  }\n  \n  background-color: ", ";\n"])), COLORS$1.LIGHT_GRAY, COLORS$1.LIGHT_GRAY, function (props) { return (props.isChecked ? COLORS$1.LIGHT_GREY_100 : COLORS$1.WHITE); });
var ImageWrapper$4 = styled(Flex)(templateObject_2$1i || (templateObject_2$1i = __makeTemplateObject(["\n  flex: 1;\n  height: 16px;\n  gap: ", ";\n  width: auto;\n  cursor: pointer;\n"], ["\n  flex: 1;\n  height: 16px;\n  gap: ", ";\n  width: auto;\n  cursor: pointer;\n"])), function (props) { return props.isDesktopHeader && '8px'; });
var CountryLabel$2 = customStyled(Flex)(templateObject_3$13 || (templateObject_3$13 = __makeTemplateObject(["\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  flex: 3;\n  text-align: left;\n\n  height: 16px;\n    font-weight: ", ";\n    line-height: 16px;\n"], ["\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  flex: 3;\n  text-align: left;\n\n  height: 16px;\n    font-weight: ", ";\n    line-height: 16px;\n"])), function (props) { return (props.isChecked ? '700' : '400'); });
var CallingCodeLabel$2 = styled(Flex)(templateObject_4$V || (templateObject_4$V = __makeTemplateObject(["\n  flex:1\n  justify-content: flex-end;\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-size: 12px;\n  font-weight: bold;\n"], ["\n  flex:1\n  justify-content: flex-end;\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-size: 12px;\n  font-weight: bold;\n"])));
var CountrySelectorWrapper$1 = styled(Box)(templateObject_5$H || (templateObject_5$H = __makeTemplateObject(["\n  cursor: pointer;\n  ", ";\n\n  @media (max-width: 300px) {\n    margin: 5px !important;\n  }\n"], ["\n  cursor: pointer;\n  ",
    ";\n\n  @media (max-width: 300px) {\n    margin: 5px !important;\n  }\n"])), function (props) {
    return props.isDesktopHeader &&
        " padding: 8px;\n      border-radius:4px;\n      background: " + COLORS$1.BLUE_500 + ";\n      ";
});
var TabWrapper$2 = styled(Flex)(templateObject_6$x || (templateObject_6$x = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 5px;\n  padding: 5px;\n  width: 100%;\n"], ["\n  background-color: ", ";\n  border-radius: 5px;\n  padding: 5px;\n  width: 100%;\n"])), COLORS$1.GRAYSCALE);
var Tab$1 = customStyled(Box)(templateObject_7$v || (templateObject_7$v = __makeTemplateObject(["\n  width: 162px;\n  height: 36px;\n  line-height: 36px;\n  border-radius: 4px;\n  transition: .2s all;\n  text-align: center;\n  font-weight: ", ";\n  background-color: ", ";\n  cursor: pointer;\n"], ["\n  width: 162px;\n  height: 36px;\n  line-height: 36px;\n  border-radius: 4px;\n  transition: .2s all;\n  text-align: center;\n  font-weight: ", ";\n  background-color: ", ";\n  cursor: pointer;\n"])), function (props) { return (props.isChecked ? '700' : '400'); }, function (props) { return (props.isChecked ? COLORS$1.WHITE : COLORS$1.GRAYSCALE); });
var LabelWrapper$1 = styled.label(templateObject_8$v || (templateObject_8$v = __makeTemplateObject(["\n  display: inline-flex;\n  cursor: pointer;\n  height: 16px;\n\n  img {\n    margin-left: 20px;\n  }\n"], ["\n  display: inline-flex;\n  cursor: pointer;\n  height: 16px;\n\n  img {\n    margin-left: 20px;\n  }\n"])));
var LanguageSelectorWrapper$1 = customStyled(Box)(templateObject_9$s || (templateObject_9$s = __makeTemplateObject(["\n  height: 0px;\n  overflow: hidden;\n  ", "\n"], ["\n  height: 0px;\n  overflow: hidden;\n  ",
    "\n"])), function (props) {
    if (props.isChecked) {
        return "\n          transition: .2s all;\n          height: 105px;\n      ";
    }
});
var ButtonSection$1 = styled.div(templateObject_10$r || (templateObject_10$r = __makeTemplateObject(["\n  position: fixed;\n  bottom: 0px;\n  background-color: ", ";\n  box-shadow: 0px -2px 5px rgb(0 0 0 / 10%);\n  width: 100%;\n  padding: 16px 0px;\n  text-align: center;\n\n  button {\n    width: 150px;\n    border-radius: 12px;\n    background-color: ", ";\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n    &:first-of-type {\n      background-color: ", ";\n      margin-right: 20px;\n      color: ", ";\n    }\n\n    @media (max-width: 992px) {\n      height: 40px;\n    }\n  }\n"], ["\n  position: fixed;\n  bottom: 0px;\n  background-color: ", ";\n  box-shadow: 0px -2px 5px rgb(0 0 0 / 10%);\n  width: 100%;\n  padding: 16px 0px;\n  text-align: center;\n\n  button {\n    width: 150px;\n    border-radius: 12px;\n    background-color: ", ";\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n    &:first-of-type {\n      background-color: ", ";\n      margin-right: 20px;\n      color: ", ";\n    }\n\n    @media (max-width: 992px) {\n      height: 40px;\n    }\n  }\n"])), COLORS$1.WHITE, COLORS$1.ANCHOR_BLUE, COLORS$1.WHITE, COLORS$1.ANCHOR_BLUE, COLORS$1.WHITE, COLORS$1.ANCHOR_BLUE);
var templateObject_1$1C, templateObject_2$1i, templateObject_3$13, templateObject_4$V, templateObject_5$H, templateObject_6$x, templateObject_7$v, templateObject_8$v, templateObject_9$s, templateObject_10$r;

var getRedirectionUrl$1 = function (newCountry, languageRef) {
    var redirectionLink = '';
    var currentHost = window.location.host;
    var name = newCountry.name, countryDomain = newCountry.countryDomain;
    if (currentHost.includes('localhost')) {
        redirectionLink = window.location.protocol + "//" + window.location.host + "/" + name + "/" + languageRef.current.value;
    }
    else if (currentHost.includes('uat')) {
        var domainPrefix = currentHost.split('.')[0]; // uat1, uat2
        redirectionLink = window.location.protocol + "//" + domainPrefix + "." + countryDomain + "/" + name + "/" + languageRef.current.value;
    }
    else {
        redirectionLink = window.location.protocol + "//www." + countryDomain + "/" + name + "/" + languageRef.current.value;
    }
    return redirectionLink + "/";
};
var loadPageWithUpdatedLang$1 = function (lan, currentStoreId) {
    var asPath = window.location.pathname;
    var pathResources = asPath.split('/');
    var _a = __read(pathResources), storeId = _a[1], queryLang = _a[2], rest = _a.slice(3);
    var baseUrl = asPath;
    var appboy = window.appboy;
    setAppLanguageAndCountry$1({ language: lan, storeId: currentStoreId }, appboy);
    if (storeId.indexOf('maf') > -1 && ['ar', 'en', 'ka'].indexOf(queryLang) > -1) {
        baseUrl = storeId + "/" + lan + "/" + rest.join('/');
        var finalPathName = storeId && queryLang ? baseUrl : currentStoreId + "/" + lan + baseUrl;
        window.location.href = "https://" + window.location.hostname + "/" + finalPathName + window.location.search;
    }
    else {
        window.location.reload();
    }
};

var CountryListElement$2 = function (_a) {
    var code = _a.code, countryName = _a.name, countryStoreId = _a.countryStoreId, isChecked = _a.isChecked, onCountrySelector = _a.onCountrySelector, language = _a.language, onLanguageSelector = _a.onLanguageSelector, key = _a.key, supportedLanguages = _a.supportedLanguages, media = _a.media;
    var t = useTranslation().t;
    var _b = __read(useState(''), 2), selectedLanguage = _b[0], setLanguage = _b[1];
    useEffect(function () {
        setLanguage(language);
    }, [language]);
    var onLangChange = function (event) {
        var _a, _b;
        setLanguage((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.dataset.value);
        onLanguageSelector((_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.dataset.value);
    };
    return (React.createElement(Container$g, { flexDirection: "column", p: 3, ml: ['0px', '0px', '0px', '20px'], isChecked: isChecked, key: key, "data-testid": key },
        React.createElement(Box, null,
            React.createElement(LabelWrapper$1, { htmlFor: countryName },
                React.createElement("input", { type: "radio", name: "country", id: countryName, value: countryStoreId, onChange: onCountrySelector, checked: isChecked }),
                React.createElement("img", { src: media, alt: code + ".png" }),
                React.createElement(CountryLabel$2, { pl: "10px", isChecked: isChecked }, countryName))),
        supportedLanguages.length > 1 ? (React.createElement(LanguageSelectorWrapper$1, { ml: "40px", isChecked: isChecked },
            React.createElement(Box, { as: "p", textAlign: "left", my: "20px" }, t('selectLanguageText')),
            React.createElement(TabWrapper$2, null, supportedLanguages.map(function (lang, index) { return (React.createElement(Tab$1, { key: lang.code + "_" + index, isChecked: selectedLanguage === lang.code, "data-value": lang.code, onClick: onLangChange }, lang.name)); })))) : null));
};
var Heading$4 = function (_a) {
    var headingTitle = _a.headingTitle;
    return (React.createElement(Box, { fontWeight: [5, 6], fontSize: [3, 4], textAlign: ['center', 'left'], display: "block", sx: {
            fontFamily: 'Montserrat',
        }, mt: [null, null, '-10px'], ml: "10px", py: 3 }, headingTitle));
};
var LocalisationSettingsDrawer$1 = function (props) {
    var t = useTranslation().t;
    var closeHandler = props.closeHandler, isOpen = props.isOpen, _a = props.contents, contents = _a === void 0 ? [] : _a, language = props.language, storeId = props.storeId;
    var _b = __read(useState(''), 2), selectedCountry = _b[0], setCountry = _b[1];
    var languageRef = useRef({
        value: language,
    });
    useEffect(function () {
        setCountry(storeId);
    }, [language, storeId]);
    var onSubmit = function () {
        var _a;
        // If only switching language for same country
        if (selectedCountry === storeId) {
            setStoreInfoCookie$1({ language: languageRef.current.value });
            return loadPageWithUpdatedLang$1(languageRef.current.value, storeId);
        }
        var newCountry = contents.find(function (item) {
            if (item.name === selectedCountry) {
                return item;
            }
        });
        var languageIndex = newCountry === null || newCountry === void 0 ? void 0 : newCountry.languages.findIndex(function (item) { return item.code === languageRef.current.value; });
        // If language not exist for that country use its default language
        if (languageIndex === -1) {
            var defaultLanguage = (_a = newCountry === null || newCountry === void 0 ? void 0 : newCountry.languages.find(function (item) { return item.isDefault; })) === null || _a === void 0 ? void 0 : _a.code;
            languageRef.current.value = defaultLanguage || languageRef.current.value;
        }
        window.location.href = getRedirectionUrl$1(newCountry, languageRef);
    };
    var onLanguageSelector = function (val) {
        languageRef.current.value = val;
    };
    var onCountrySelector = function (event) {
        setCountry(event.target.value);
        languageRef.current.value = language;
    };
    return (React.createElement("div", null,
        React.createElement(Drawer, { onClose: closeHandler, isOpen: isOpen, width: ['100%', '400px', '450px'], anchor: ['bottom', null, 'right'], contentStyles: { p: [0], height: '100%', display: 'flex', flexDirection: 'column', fontFamily: 'Montserrat' }, variant: "float", title: React.createElement(Heading$4, { headingTitle: t('localisationSettingsText') }), "data-testid": "localization-settings-drawer", isTitleBorder: false, isRtl: language === AR$1 },
            React.createElement(Box, { p: 3, pt: [0, 0, 0, 3] },
                React.createElement(Box, { as: "h3", px: ['0px', '0px', '0px', '10px'], mb: "15px", ml: ['0px', '0px', '0px', '10px'], fontWeight: "bold" }, t('chooseCountry')),
                contents.map(function (item, index) {
                    return item && item.code ? (React.createElement(CountryListElement$2, { name: item.displayName, code: item.code, countryStoreId: item.name, isChecked: selectedCountry === item.name, onCountrySelector: onCountrySelector, supportedLanguages: item.languages, language: language, key: item.name + "_" + index, onLanguageSelector: onLanguageSelector, media: item.media })) : null;
                }),
                React.createElement(Box, { height: "72px" })),
            React.createElement(ButtonSection$1, null,
                React.createElement(Button$1, { "data-testid": "country-selector-cancel-icon", onClick: closeHandler, fontSize: 2, fontWeight: 6, height: "48px", preventTextTransform: true },
                    React.createElement(Box, { sx: {
                            whiteSpace: 'nowrap',
                        } }, t('completeYourProfile.cancel'))),
                React.createElement(Button$1, { "data-testid": "country-selector-confirm-icon", variant: "primary", onClick: onSubmit, fontSize: 2, fontWeight: 6, height: "48px", preventTextTransform: true },
                    React.createElement(Box, { sx: {
                            whiteSpace: 'nowrap',
                        } }, t('address.confirm')))))));
};

var CountrySelector$2 = function (_a) {
    var countryOfOperationID = _a.countryOfOperationID, isDesktop = _a.isDesktop, language = _a.language, storeId = _a.storeId, isDesktopHeader = _a.isDesktopHeader;
    var _b = __read(useState(false), 2), openCountrySelector = _b[0], setOpenCountrySelector = _b[1];
    var _c = __read(useState([]), 2), countryDetails = _c[0], setCountryDetails = _c[1];
    var _d = __read(useState({}), 2), preSelectedCountry = _d[0], setPreSelectedCountry = _d[1];
    var getCountryDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, currentCountry, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, AppConfigService$3.getCountryDetailsApi()];
                case 1:
                    response = _a.sent();
                    setCountryDetails(response.data);
                    currentCountry = response.data.find(function (item) { return item.code === countryOfOperationID; });
                    setPreSelectedCountry(currentCountry || {});
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error('country details: ', e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getCountryDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var showCountrySelector = function () {
        setOpenCountrySelector(true);
    };
    var hideCountrySelector = function () {
        setOpenCountrySelector(false);
    };
    var _e = preSelectedCountry.media, media = _e === void 0 ? '' : _e, _f = preSelectedCountry.code, code = _f === void 0 ? '' : _f;
    return (React.createElement(React.Fragment, null,
        openCountrySelector && (React.createElement(LocalisationSettingsDrawer$1, { contents: countryDetails, isOpen: openCountrySelector, closeHandler: hideCountrySelector, language: language, storeId: storeId })),
        React.createElement(CountrySelectorWrapper$1, { id: "country_change", mx: [3, null, null, null], onClick: showCountrySelector, isDesktopHeader: isDesktopHeader },
            React.createElement(ImageWrapper$4, { isDesktopHeader: isDesktopHeader },
                React.createElement(Image, { url: media, name: code, height: "16px", width: "auto", useAltFallback: true }),
                isDesktop ? React.createElement(ChevronDown, { size: "S", fill: isDesktopHeader ? COLORS$1.WHITE : COLORS$1.ANCHOR_BLUE }) : null))));
};
var CountrySelector$3 = React.memo(CountrySelector$2);

var MainPane$2 = (function (_a) {
    var _b = _a.isLanguageChangeEnabled, isLanguageChangeEnabled = _b === void 0 ? true : _b, _c = _a.isMiniCart, isMiniCart = _c === void 0 ? true : _c, _d = _a.isSearchBox, isSearchBox = _d === void 0 ? true : _d, _e = _a.ssr, ssr = _e === void 0 ? false : _e, _f = _a.isLogin, isLogin = _f === void 0 ? true : _f, _g = _a.isHideNav, isHideNav = _g === void 0 ? false : _g, loginObj = _a.loginObj, onLanguageChange = _a.onLanguageChange, dealsMenu = _a.dealsMenu, phoneNumber = _a.phoneNumber, quickBuyLink = _a.quickBuyLink, isShowFullArea = _a.isShowFullArea, _h = _a.countryOfOperationID, countryOfOperationID = _h === void 0 ? '' : _h;
    var isSSR = ssr || !isBrowser$1();
    // LANG SWITCHER
    var _j = __read(useAppConfig$1(), 1), _k = _j[0], _l = _k.language, language = _l === void 0 ? 'en' : _l, _m = _k.storeId, storeId = _m === void 0 ? '' : _m;
    var _o = __read(useMemo(function () { return [language === EN$1]; }, [language]), 1), isEN = _o[0];
    // GLOBAL SEARCH
    var _p = __read(useState(false), 2), isSearchClicked = _p[0], setSearchClicked = _p[1];
    var onClickCallback = useCallback(function (checked) {
        if (checked === void 0) { checked = true; }
        return function () { return setSearchClicked(checked); };
    }, [setSearchClicked]);
    var isDesktop = useBreakpoints().isDesktop;
    var isNonFoodV2Enabled = useNonFoodV2Journey();
    var isDesktopHeader = isNonFoodV2Enabled && isDesktop;
    return (React.createElement(MainPane$1, { isDesktopHeader: isDesktopHeader, isHideNav: isHideNav, "data-testid": "main-pane", isNonFoodV2Enabled: isNonFoodV2Enabled },
        React.createElement(PageMaxWidth$1, __assign({ display: "flex", alignItems: "center" }, headerHeightProp$2),
            React.createElement(DrawerMenu, { isLanguageChange: isLanguageChangeEnabled, onLanguageChange: onLanguageChange, dealsMenu: dealsMenu, phoneNumber: phoneNumber, quickBuyLink: quickBuyLink }),
            React.createElement(Logo$5, { language: language, storeId: storeId, fill: isDesktopHeader ? COLORS$1.WHITE : COLORS$1.BLUE }),
            isSearchBox ? (React.createElement(NonMobile, { isSearchClicked: isSearchClicked, isEN: isEN, onClickCallback: onClickCallback })) : (React.createElement(Box, { flexGrow: "1" })),
            React.createElement(Spacer$1, null),
            isDesktop && (React.createElement(DesktopAreaWrapper$1, { isDesktopHeader: isDesktopHeader },
                React.createElement(ChangeArea, { isShowFullArea: !!isShowFullArea, showDesktop: true, isDesktopHeader: isDesktopHeader }))),
            isLogin && (React.createElement(UserButton$2, { loginObj: loginObj, isSSR: isSSR, isDesktopHeader: isDesktopHeader, iconFill: isDesktopHeader ? COLORS$1.WHITE : COLORS$1.BLUE })),
            React.createElement(CountrySelector$3, { countryOfOperationID: countryOfOperationID, isDesktop: isDesktop, language: language, storeId: storeId, isDesktopHeader: isDesktopHeader }),
            isMiniCart && React.createElement(MiniCart, null)),
        React.createElement(PageMaxWidth$1, null, isSearchBox && (React.createElement(React.Fragment, null,
            React.createElement(Mobile, { isSearchClicked: isSearchClicked, isEN: isEN, onClickCallback: onClickCallback })))),
        !isSearchClicked && !isDesktop && (React.createElement(MobileAreaWrapper$1, { isHideNav: isHideNav },
            React.createElement(ChangeArea, { isShowFullArea: !!isShowFullArea, isHideNav: isHideNav, showDesktop: false })))));
});

var SubCategoryItems = function (_a) {
    var items = _a.items, _b = _a.isChild, isChild = _b === void 0 ? false : _b, _c = _a.isSub, isSub = _c === void 0 ? false : _c, superCategory = _a.superCategory, _d = _a.mainCategory, mainCategory = _d === void 0 ? '' : _d, menuType = _a.menuType;
    var titleVariant = isChild ? 'subMenuTitle' : 'menuTitle';
    var _e = useAnalytic$1(), GTMEventCall = _e.GTMEventCall, BrazeEventCall = _e.BrazeEventCall;
    var getLink = useCtaUrl();
    var onClickHandler = useCallback(function (url, categoryName) { return function (event) {
        var _a;
        event.preventDefault();
        BrazeEventCall(BrazeEvents$1.category_interaction, (_a = {},
            _a[BrazeEvents$1.category_id] = getCatagoryId(url),
            _a));
        var urls = url === null || url === void 0 ? void 0 : url.split('/');
        var eventLabel = urls.length > 0
            ? isSub
                ? 'l3_category-' + urls[urls.length - 1]
                : 'l2_category-' + urls[urls.length - 1]
            : '';
        var eventData = {
            eventAction: GTMEventActions$1.category_interaction,
            menuType: menuType,
            superCategory: superCategory,
            mainCategory: mainCategory,
            subCategory: '',
            eventLabel: eventLabel,
        };
        if (isSub) {
            eventData.subCategory = categoryName;
        }
        else {
            eventData.mainCategory = categoryName;
        }
        GTMEventCall(GTMEvents$1.custom_event, eventData);
        if (url || url !== '#') {
            window.location.href = url;
        }
    }; }, [GTMEventCall, BrazeEventCall, menuType, mainCategory, superCategory, isSub]);
    return (React.createElement(MenuNavigationSlotItems$1, { isChild: isChild }, items &&
        items.map(function (item, idx) {
            var linkText = item.name || item.title;
            return (React.createElement(MenuAllCategoriesItem$1, { key: item.name + "-" + idx },
                React.createElement(MenuNavigationLink$1, { rel: item.title },
                    React.createElement(MenuNavigationText$1, { type: titleVariant, onClick: onClickHandler(getLink(item.url, item.ctaUrl), linkText), "data-testid": "category_level_" + (isSub ? 3 : 2) }, linkText),
                    item.children && (React.createElement(MenuNavigationInnerItem$1, null,
                        React.createElement(SubCategoryItems, { items: item.children, isChild: true, isSub: true, superCategory: superCategory, mainCategory: item.name, menuType: menuType }))))));
        })));
};

var AllCategories = function (_a) {
    var items = _a.items, getVCategoryId = _a.getVCategoryId;
    var _b = __read(useState(items[0]), 2), selectedItem = _b[0], setSelectedItem = _b[1];
    var _c = __read(useState(), 2), timer = _c[0], setTimeoutState = _c[1];
    var getLink = useCtaUrl();
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    var onMouseEnterCallback = useCallback(function (item) { return function () {
        if (item.children) {
            var timer_1 = setTimeout(function () {
                setSelectedItem(item);
                getVCategoryId(getCatagoryId(item.url));
            }, 60);
            setTimeoutState(timer_1);
        }
    }; }, [setSelectedItem, getVCategoryId]);
    var onMouseLeave = function () {
        if (timer) {
            clearTimeout(timer);
        }
    };
    var GTMHandler = useCallback(function (url, superCategory) { return function (event) {
        event.preventDefault();
        var urls = url === null || url === void 0 ? void 0 : url.split('/');
        var eventLabel = urls.length > 0 ? 'l1_category-' + urls[urls.length - 1] : '';
        var eventData = {
            eventAction: GTMEventActions$1.category_interaction,
            superCategory: superCategory,
            mainCategory: '',
            menuType: NavigationMenuTypes$1.all_category_menu,
            eventLabel: eventLabel,
        };
        GTMEventCall(GTMEvents$1.custom_event, eventData);
        if (url || url !== '#') {
            window.location.href = url;
        }
    }; }, [GTMEventCall]);
    return (React.createElement(React.Fragment, null,
        React.createElement(AllCategoryWrapper$1, null, items.map(function (item, idx) {
            var isHover = selectedItem && selectedItem.title === item.title;
            var fontWeight = isHover ? 'bold' : 'normal';
            var linkText = item.name || item.title;
            return (React.createElement(MenuAllCategoriesItem$1, { onMouseEnter: onMouseEnterCallback(item), onMouseLeave: onMouseLeave, key: item.title + "-" + idx },
                React.createElement(MenuNavigationLink$1, { rel: item.title, onClick: GTMHandler(getLink(item.url, item.ctaUrl), linkText), isHover: isHover, "data-testid": "category_level_1" },
                    React.createElement(MenuNavigationText$1, { type: "allCategory", fontWeight: fontWeight }, linkText))));
        })),
        selectedItem && selectedItem.children.length > 0 && (React.createElement(SubCategoryItems, { superCategory: selectedItem.name, items: selectedItem.children, isChild: false, menuType: NavigationMenuTypes$1.all_category_menu }))));
};

var sharedData$1 = {
    event_category: GTMEventCategories$1.enhanced_ecommerce,
    position: 'monetisation',
};
var detectIframeClick$1 = function (PromotionEventCall, _a, storeId, position) {
    var promotionData = __rest(_a, []);
    var iframeConfig = {
        isIframeClicked: false,
    };
    var iframeContainer = document.getElementById(promotionData.id);
    var trackOnClick = function () {
        if (iframeConfig.isIframeClicked) {
            PromotionEventCall(PromotionEvents$1.promotion_click, __assign(__assign({}, sharedData$1), { event_action: PromotionEvents$1.promotion_click, event_label: promotionData.id, market: storeId, page_url: typeof window !== 'undefined' ? window.location.href : '', 
                // screen_name: typeof window !== 'undefined' ? document.title : '',
                screen_type: getPageType$1() }), __assign({}, promotionData), false);
            PromotionEventCall(PromotionEvents$1.promotion_click, __assign(__assign({}, sharedData$1), { event_action: PromotionEvents$1.promotion_click, event_label: promotionData.id, market: storeId, page_url: typeof window !== 'undefined' ? window.location.href : '', 
                // screen_name: typeof window !== 'undefined' ? document.title : '',
                screen_type: getPageType$1() }), {
                creative_name: promotionData.creative,
                creative_slot: position,
                index: position,
                item_list_name: '',
                promotion_id: promotionData.id,
                promotion_name: promotionData.name,
            }, true);
        }
    };
    if (typeof window !== 'undefined') {
        window.addEventListener('blur', trackOnClick);
    }
    iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.addEventListener('mouseover', function () {
        iframeConfig.isIframeClicked = true;
        window.focus();
    });
    iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.addEventListener('mouseout', function () {
        iframeConfig.isIframeClicked = false;
    });
    return function () {
        window.removeEventListener('blur', trackOnClick);
    };
};

var AdBanner$2 = function (props) {
    var id = props.id, fallbackEmptyContent = props.fallbackEmptyContent, position = props.position, rest = __rest(props, ["id", "fallbackEmptyContent", "position"]);
    var _a = __read(useAppConfig$1(), 1), _b = _a[0], language = _b.language, storeId = _b.storeId;
    var PromotionEventCall = useAnalytic$1().PromotionEventCall;
    var _c = __read(useInView(), 2), inViewRef = _c[0], inView = _c[1];
    var promotionData = useMemo(function () { return ({
        id: id,
        name: rest.path,
        creative: rest.gtmCreative ? rest.gtmCreative : '',
        position: position,
    }); }, [id, rest.path, rest.gtmCreative, position]);
    useEffect(function () {
        var handleIframeClick = detectIframeClick$1(PromotionEventCall, promotionData, storeId, position);
        return function () { return handleIframeClick(); };
    }, [PromotionEventCall, promotionData, storeId, position]);
    useEffect(function () {
        if (inView) {
            PromotionEventCall(PromotionEvents$1.promotion_impressions, __assign(__assign({}, sharedData$1), { event_action: PromotionEvents$1.promotion_impressions, event_label: id + "|" + position, market: storeId, page_url: typeof window !== 'undefined' ? window.location.href : '', 
                // screen_name: typeof window !== 'undefined' ? document.title : '',
                screen_type: getPageType$1() }), __assign({}, promotionData), false);
            PromotionEventCall(PromotionEvents$1.promotion_impressions, __assign(__assign({}, sharedData$1), { event_action: PromotionEvents$1.promotion_impressions, event_label: id + "|" + position, market: storeId, page_url: typeof window !== 'undefined' ? window.location.href : '', 
                // screen_name: typeof window !== 'undefined' ? document.title : '',
                screen_type: getPageType$1() }), __assign({}, promotionData), true);
        }
    }, [inView, PromotionEventCall, promotionData, id, storeId, position]);
    var slotInfo = useDfpSlot(__assign(__assign({}, props), { lang: language })).slotInfo;
    var slotId = slotInfo.slotId, isEmpty = slotInfo.isEmpty;
    useEffect(function () {
        if (fallbackEmptyContent) {
            fallbackEmptyContent({ slotId: slotId, isEmpty: isEmpty });
        }
    }, [fallbackEmptyContent, slotId, isEmpty]);
    return React.createElement(AdBannerWrapper$1, __assign({ id: id, ref: inViewRef }, rest));
};
var AdBanner$3 = React.memo(AdBanner$2, function (prevProps, nextProps) {
    var _a, _b;
    return (prevProps.id === nextProps.id && ((_a = prevProps === null || prevProps === void 0 ? void 0 : prevProps.targets) === null || _a === void 0 ? void 0 : _a.hybris_categoryid) === ((_b = nextProps === null || nextProps === void 0 ? void 0 : nextProps.targets) === null || _b === void 0 ? void 0 : _b.hybris_categoryid));
});

var SubCategories = function (_a) {
    var items = _a.items, _b = _a.categoryType, categoryType = _b === void 0 ? 'subMenu' : _b, superCategory = _a.superCategory, h_categoryId = _a.h_categoryId, isDesktopHeader = _a.isDesktopHeader;
    var gamConfigDetails = (useSelector(function (state) { return state.appConfig; }) || {}).gamConfigDetails;
    var MenuItems = categoryType === 'subMenu' ? SubCategoryItems : AllCategories;
    var _c = __read(useState(''), 2), v_categoryId = _c[0], setVCategoryId = _c[1];
    var getVCategoryId = function (cid) { return setVCategoryId(cid); };
    var AdBannerMemo = useMemo(function () {
        var _a, _b, _c, _d;
        return (React.createElement(AdBannerContainer$1, null,
            React.createElement(AdBanner$3, { id: (_b = (_a = gamConfigDetails === null || gamConfigDetails === void 0 ? void 0 : gamConfigDetails.categories) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.gptId, path: (_d = (_c = gamConfigDetails === null || gamConfigDetails === void 0 ? void 0 : gamConfigDetails.categories) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.adUnitId, sizes: {
                    mobile: [],
                    tablet: [],
                    desktop: [
                        [300, 600],
                        [205, 430],
                        [390, 352],
                    ],
                }, targets: { hybris_categoryid: categoryType !== 'subMenu' ? v_categoryId : h_categoryId }, type: CATEGORY_MENU })));
    }, [v_categoryId, h_categoryId, categoryType, gamConfigDetails]);
    return (React.createElement(MenuNavigationSlot$1, { isHover: true, isDesktopHeader: isDesktopHeader },
        items && (React.createElement(MenuItems, { items: items, superCategory: superCategory, getVCategoryId: categoryType !== 'subMenu' ? getVCategoryId : null, menuType: categoryType === 'subMenu' ? NavigationMenuTypes$1.horizontal_menu : NavigationMenuTypes$1.all_category_menu })),
        AdBannerMemo));
};

var useHoverCtrl = function () {
    var _a = __read(useState(), 2), selectedChild = _a[0], setSelectedChild = _a[1];
    var onHoverHandler = useCallback(function (child) {
        // const { children } = child;
        // if (children) {
        setSelectedChild(child);
        // }
    }, [setSelectedChild]);
    var onMouseLeaveHandler = useCallback(function () {
        setSelectedChild(undefined);
    }, [setSelectedChild]);
    return [selectedChild, setSelectedChild, onHoverHandler, onMouseLeaveHandler];
};

var MenuNavigation = function () {
    var _a = __read(useHoverCtrl(), 4), selectedChild = _a[0], onHoverHandler = _a[2], onMouseLeaveHandler = _a[3];
    var _b = useSelector(function (_a) {
        var appMenu = _a.appMenu;
        return (__assign({}, appMenu));
    }), menuFeed = _b.menuFeed, isLoading = _b.isLoading;
    var isDesktop = useBreakpoints().isDesktop;
    var isNonFoodV2Enabled = useNonFoodV2Journey();
    var isDesktopHeader = isNonFoodV2Enabled && isDesktop;
    var timer = useRef(null);
    var getLink = useCtaUrl();
    var _c = useAnalytic$1(), GTMEventCall = _c.GTMEventCall, BrazeEventCall = _c.BrazeEventCall;
    // const [timeout, setTimeoutState] = useState<NodeJS.Timeout | undefined>();
    var GTMHandler = useCallback(function (menuType, superCategory, innerChild) { return function () {
        var _a;
        if (superCategory !== BrazeEvents$1.all_categories) {
            BrazeEventCall(BrazeEvents$1.category_interaction, (_a = {},
                _a[BrazeEvents$1.category_id] = getCatagoryId(innerChild.url),
                _a));
        }
        GTMEventCall(GTMEvents$1.custom_event, {
            eventAction: 'category_interaction',
            l1Category: superCategory,
            superCategory: superCategory,
            menuType: menuType,
            categoryId: innerChild.id,
        });
    }; }, [GTMEventCall, BrazeEventCall]);
    var isChildExist = useMemo(function () {
        return selectedChild && selectedChild.children && selectedChild.children.length > 0;
    }, [selectedChild]);
    var onHover = useCallback(function (innerChild) { return function () {
        if (timer.current) {
            clearTimeout(timer.current);
            timer.current = setTimeout(function () {
                onHoverHandler(innerChild);
            }, 0);
        }
        else {
            timer.current = setTimeout(function () {
                onHoverHandler(innerChild);
            }, 250);
        }
    }; }, [onHoverHandler /*setTimeoutState*/]);
    var onMouseLeave = useCallback(function () {
        if (timer.current) {
            clearTimeout(timer.current);
            timer.current = null;
        }
        onMouseLeaveHandler();
    }, [onMouseLeaveHandler /*timeout, setTimeoutState*/]);
    var _d = __read(useAppConfig$1(), 4), _e = _d[0], requestStatus = _d[3];
    var appConfigLoaded = usePrevious(requestStatus.done); // catches up the toggling of "isLoading=true"
    var donotShowMenu = isLoading || (!appConfigLoaded && !requestStatus.failed);
    var nowChild;
    return (React.createElement(MenuNavigationMainContainer$1, { isDesktopHeader: isDesktopHeader }, !donotShowMenu && (React.createElement(MenuNavigationContainer$1, { as: "nav", onMouseLeave: onMouseLeave, "data-testid": "header_categories", isDesktopHeader: isDesktopHeader },
        React.createElement(MenuNavigationWrapper$1, null,
            React.createElement(MenuIconWrapper$1, { isDesktopHeader: isDesktopHeader },
                React.createElement(FourSquares, { fill: COLORS$1.WHITE })),
            menuFeed &&
                menuFeed.map(function (innerChild, index) {
                    if (!innerChild) {
                        return null;
                    }
                    var isHover = selectedChild && innerChild.title === selectedChild.title;
                    var textType = checkTextType(innerChild);
                    nowChild = isNow(innerChild) ? innerChild : false;
                    var linkText = innerChild.name || innerChild.title;
                    return (React.createElement(MenuNavigationItem$1, { isHover: isHover, key: innerChild.title, marginLeft: "" + (!!nowChild ? 'auto' : null), onMouseEnter: onHover(innerChild), isDesktopHeader: isDesktopHeader }, !nowChild && (React.createElement(MenuNavigationLink$1, { padding: "16px 20px 15px", paddingLeft: index === 0 ? '16px' : '30px', rel: "menu", "data-testid": getDataTestId(linkText), href: getLink(innerChild.url, innerChild.ctaUrl), onClick: GTMHandler(NavigationMenuTypes$1.horizontal_menu, linkText, innerChild) },
                        React.createElement(MenuTextIconWrapper$1, null,
                            React.createElement(MenuNavigationText$1, { type: textType, fontWeight: 700, color: isDesktopHeader ? COLORS$1.WHITE : COLORS$1.ANCHOR_BLUE }, linkText))))));
                })),
        selectedChild && isChildExist && (React.createElement(SubCategories, { categoryType: getMenuType(selectedChild), items: selectedChild.children, isDesktopHeader: isDesktopHeader, superCategory: selectedChild.name || selectedChild.title, h_categoryId: getCatagoryId(selectedChild.url) }))))));
};

var InnerWrapper$1 = styled('div')(templateObject_1$1D || (templateObject_1$1D = __makeTemplateObject([""], [""])));
var WrapperSection$1 = styled('div')(templateObject_2$1j || (templateObject_2$1j = __makeTemplateObject(["\n  .smartbanner-top {\n    position: relative;\n    height: 78px;\n  }\n  .smartbanner-container {\n    top: 0;\n    left: 0;\n    overflow-x: hidden;\n    width: 100%;\n    background: ", ";\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding: 0 8px;\n    position: absolute;\n    z-index: 1;\n    font-family: Roboto;\n  }\n  .smartbanner-close {\n    display: block;\n    margin: 0;\n    width: 12px;\n    height: 12px;\n    text-align: center;\n    background: none;\n    border: none;\n    box-shadow: none;\n    text-shadow: none;\n    color: ", ";\n    font-family: inherit;\n    height: 16px;\n    line-height: 16px;\n  }\n  .smartbanner-icon {\n    background-size: 48px 48px;\n    width: 48px;\n    height: 48px;\n    margin: 0 8px;\n    border-radius: 15px;\n    background-image: url(", ") !important;\n  }\n  .smartbanner-title,\n  .smartbanner-author {\n    color: ", ";\n\n    text-shadow: none;\n    font-size: 14px;\n  }\n  .smartbanner-title {\n    font-weight: 500;\n    margin-bottom: 3px;\n  }\n  .smartbanner-android .smartbanner-title {\n    color: ", ";\n  }\n  .smartbanner-author {\n    font-weight: normal;\n  }\n  .smartbanner-button {\n    z-index: 1;\n    display: block;\n    min-width: 10%;\n    text-align: center;\n    background: ", ";\n    color: ", ";\n    font-size: 12px;\n    font-weight: 500;\n    border-radius: 2px;\n    position: static;\n    margin-left: auto;\n    border: none;\n    box-shadow: none;\n    height: auto;\n    padding: 0;\n  }\n  .smartbanner-wrapper {\n    margin-left: auto;\n    width: auto;\n  }\n  .smartbanner-button-text {\n    background: none;\n    padding: 10px;\n    display: inline-block;\n    line-height: 1.3;\n    text-shadow: none;\n  }\n  .smartbanner-description {\n    display: none;\n  }\n  .smartbanner-info {\n    width: calc(99% - 145px);\n  }\n"], ["\n  .smartbanner-top {\n    position: relative;\n    height: 78px;\n  }\n  .smartbanner-container {\n    top: 0;\n    left: 0;\n    overflow-x: hidden;\n    width: 100%;\n    background: ", ";\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding: 0 8px;\n    position: absolute;\n    z-index: 1;\n    font-family: Roboto;\n  }\n  .smartbanner-close {\n    display: block;\n    margin: 0;\n    width: 12px;\n    height: 12px;\n    text-align: center;\n    background: none;\n    border: none;\n    box-shadow: none;\n    text-shadow: none;\n    color: ", ";\n    font-family: inherit;\n    height: 16px;\n    line-height: 16px;\n  }\n  .smartbanner-icon {\n    background-size: 48px 48px;\n    width: 48px;\n    height: 48px;\n    margin: 0 8px;\n    border-radius: 15px;\n    background-image: url(", ") !important;\n  }\n  .smartbanner-title,\n  .smartbanner-author {\n    color: ", ";\n\n    text-shadow: none;\n    font-size: 14px;\n  }\n  .smartbanner-title {\n    font-weight: 500;\n    margin-bottom: 3px;\n  }\n  .smartbanner-android .smartbanner-title {\n    color: ", ";\n  }\n  .smartbanner-author {\n    font-weight: normal;\n  }\n  .smartbanner-button {\n    z-index: 1;\n    display: block;\n    min-width: 10%;\n    text-align: center;\n    background: ", ";\n    color: ", ";\n    font-size: 12px;\n    font-weight: 500;\n    border-radius: 2px;\n    position: static;\n    margin-left: auto;\n    border: none;\n    box-shadow: none;\n    height: auto;\n    padding: 0;\n  }\n  .smartbanner-wrapper {\n    margin-left: auto;\n    width: auto;\n  }\n  .smartbanner-button-text {\n    background: none;\n    padding: 10px;\n    display: inline-block;\n    line-height: 1.3;\n    text-shadow: none;\n  }\n  .smartbanner-description {\n    display: none;\n  }\n  .smartbanner-info {\n    width: calc(99% - 145px);\n  }\n"])), function (props) { var _a; return (_a = props.theme.colors) === null || _a === void 0 ? void 0 : _a.alabaster; }, function (props) { var _a; return (_a = props.theme.colors) === null || _a === void 0 ? void 0 : _a.silverChalice; }, function (props) { return props.logoPath; }, function (props) { var _a; return (_a = props.theme.colors) === null || _a === void 0 ? void 0 : _a.copy; }, function (props) { var _a; return (_a = props.theme.colors) === null || _a === void 0 ? void 0 : _a.copy; }, function (props) { var _a; return (_a = props.theme.colors) === null || _a === void 0 ? void 0 : _a.redCta; }, function (props) { var _a; return (_a = props.theme.colors) === null || _a === void 0 ? void 0 : _a.white; });
var templateObject_1$1D, templateObject_2$1j;

var useSmartBanner = function (appendedPath) {
    var androidURL = "https://eud4.adj.st/my/path?adjust_t=i5br335&adjust_deep_link=carrefour://" + appendedPath;
    var iosURL = "https://eud4.adj.st/my/path?adjust_t=i5br335&adjust_deep_link=carrefour://" + appendedPath;
    return [androidURL, iosURL];
};

var CustomSmartBannerComponent = function (_a) {
    var _b = _a.appendedPath, appendedPath = _b === void 0 ? '' : _b, bannerText = _a.bannerText;
    var t = useTranslation().t;
    var _c = __read(useState(false), 2), setclose = _c[1];
    var _d = bannerText || t('smartBannerText', { returnObjects: true }) || {}, commonTitle = _d.title, commonSubtitle = _d.subtitle, buttonText = _d.buttonText, discountTitle = _d.discountTitle, discountValue = _d.discountValue, subtitle1 = _d.subtitle1, subtitle2 = _d.subtitle2, subtitle3 = _d.subtitle3, discCode = _d.discCode, code = _d.code;
    var mainTitle = React.createElement("b", null, discountTitle && discountValue ? discountValue + " " + discountTitle : commonTitle);
    var subtitle = (React.createElement(React.Fragment, null, code && subtitle1 && subtitle2 ? (React.createElement(React.Fragment, null,
        subtitle1,
        " ",
        React.createElement("b", null, code),
        subtitle2,
        subtitle3,
        discCode)) : (commonSubtitle)));
    var _e = __read(useSmartBanner(appendedPath), 2), iosURL = _e[0], androidURL = _e[1];
    return (React.createElement(WrapperSection$1, { "data-testid": "__smartbanner__", logoPath: "/images/applogo-blue.svg" },
        React.createElement("meta", { name: "apple-itunes-app", content: "app-id=626805470, affiliate-data=myAffiliateData, app-argument='https://itunes.apple.com/app/carrefour-uae/id626805470'" }),
        React.createElement("meta", { name: "google-play-app", content: "app-id=com.aswat.carrefouruae" }),
        React.createElement("link", { rel: "apple-touch-icon", href: "https://cdnst.mafretailproxy.com/cdn-cgi/image/format=auto,onerror=redirect/sys-master-uat1/content/applogo-blue.svg" }),
        React.createElement("link", { rel: "android-touch-icon", href: "https://cdnst.mafretailproxy.com/cdn-cgi/image/format=auto,onerror=redirect/sys-master-uat1/content/applogo-blue.svg" }),
        React.createElement(InnerWrapper$1, null,
            React.createElement(SmartBanner, { title: mainTitle || '', author: subtitle || '', button: buttonText || '', daysReminder: 10, daysHidden: 10, url: { ios: iosURL, android: androidURL }, onClose: function () { return setclose(true); } }))));
};

var CustomSmartBanner = CustomSmartBannerComponent;

var MarketingStripWrapper$1 = CustomStyled$1.div(templateObject_1$1E || (templateObject_1$1E = __makeTemplateObject(["    \n  transition: 0.1s all;\n  transform: ", ";\n  @media (min-width: ", "){\n    ", ";\n  }\n  @media (max-width: ", "){\n    ", ";\n  }\n  @media (min-width: ", ") and (max-width: ", ") {\n    padding: 0 15px;\n  }\n  position: relative;\n  z-index: -2;\n  @media (max-width: ", ") {\n      transform: ", ";\n  }\n  @media (min-width: ", ") {\n    min-height: 52px;\n  }\n"], ["    \n  transition: 0.1s all;\n  transform: ", ";\n  @media (min-width: ", "){\n    ",
    ";\n  }\n  @media (max-width: ", "){\n    ",
    ";\n  }\n  @media (min-width: ", ") and (max-width: ",
    ") {\n    padding: 0 15px;\n  }\n  position: relative;\n  z-index: -2;\n  @media (max-width: ", ") {\n      transform: ", ";\n  }\n  @media (min-width: ", ") {\n    min-height: 52px;\n  }\n"])), function (props) { return (props.isHideNav ? 'translate(0, -125px);' : 'translate(0, 0);'); }, function (props) { return props.theme.breakpoints[1]; }, function (props) {
    var _a, _b;
    return ((_a = props === null || props === void 0 ? void 0 : props.styles) === null || _a === void 0 ? void 0 : _a.background_image_web) ? "background-image: url(" + props.styles.background_image_web + ");\n            background-position: center; /* Center the image */\n            background-repeat: no-repeat; /* Do not repeat the image */\n            background-size: cover"
        : "background-color: " + ((_b = props === null || props === void 0 ? void 0 : props.styles) === null || _b === void 0 ? void 0 : _b.background_color);
}, function (props) { return props.theme.breakpoints[1]; }, function (props) {
    var _a, _b;
    return ((_a = props === null || props === void 0 ? void 0 : props.styles) === null || _a === void 0 ? void 0 : _a.background_image_mobile) ? "background-image: url(" + props.styles.background_image_mobile + ");\n            background-position: center; /* Center the image */\n            background-repeat: no-repeat; /* Do not repeat the image */\n            background-size: cover"
        : "background-color: " + ((_b = props === null || props === void 0 ? void 0 : props.styles) === null || _b === void 0 ? void 0 : _b.background_color);
}, function (props) { return props.theme.breakpoints[1]; }, function (props) {
    return props.theme.breakpoints[3];
}, function (props) { return props.theme.breakpoints[2]; }, function (props) { return (props.isHideNav ? 'translate(0, -150px);' : 'translate(0, 0);'); }, function (props) { return props.theme.breakpoints[3]; });
var MarketingStripText$1 = CustomStyled$1(Flex)(templateObject_2$1k || (templateObject_2$1k = __makeTemplateObject(["\n    margin: 0 auto;\n    max-width: 1232px;\n    ", ";\n    ", ";\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n"], ["\n    margin: 0 auto;\n    max-width: 1232px;\n    ", ";\n    ", ";\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n"])), function (props) { return (props.isBambuser ? 'padding: 0;' : 'padding: 10px 0'); }, function (props) { return props.isTimer && "padding-bottom: 2px"; });
var TextWrapper$7 = CustomStyled$1(Flex)(templateObject_3$14 || (templateObject_3$14 = __makeTemplateObject(["\n    align-items: center;\n    min-width: 18px;\n    text-decoration: none;\n    ", "\n\n    ", "\n"], ["\n    align-items: center;\n    min-width: 18px;\n    text-decoration: none;\n    ",
    "\n\n    ",
    "\n"])), function (props) {
    return props.isMobile &&
        "\n      display: block;\n      margin-left: 15px;\n    ";
}, function (props) {
    return props.isTopCloseIcon &&
        "\n      position: relative;\n      margin: 0 15px 0 5px;\n     ";
});
TextWrapper$7.defaultProps = {
    as: 'a',
};
var BambuserContainer$1 = CustomStyled$1(TextWrapper$7)(templateObject_4$W || (templateObject_4$W = __makeTemplateObject(["\n  background-color: transparent;\n  border: none;\n  flex: auto;\n"], ["\n  background-color: transparent;\n  border: none;\n  flex: auto;\n"])));
var IconWrapper$b = CustomStyled$1(Box)(templateObject_5$I || (templateObject_5$I = __makeTemplateObject(["\n  position: relative;\n  ", "\n"], ["\n  position: relative;\n  ", "\n"])), function (props) { return (props.isBambuser ? 'height: 52px;' : 'height: 14px;'); });
IconWrapper$b.defaultProps = {
    as: 'img',
    mr: 2,
};
var BambuserThumbnailWrapper$1 = CustomStyled$1(Flex)(templateObject_6$y || (templateObject_6$y = __makeTemplateObject(["\n  position: relative;\n  height: 52px;\n  align-items: center;\n"], ["\n  position: relative;\n  height: 52px;\n  align-items: center;\n"])));
var LiveIcon$1 = CustomStyled$1(Box)(templateObject_7$w || (templateObject_7$w = __makeTemplateObject(["\n  color: ", ";\n  padding: 8px 10px 8px 20px;\n  margin-left: 4px;\n  margin-right: 4px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  border-radius: 2px;\n  font-family: Roboto;\n\n  @media (max-width: ", "){\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  @media (min-width: ", "){\n    position: relative;\n  }\n\n  :: before {\n    content: \"\";\n    width: 8px;\n    height: 8px;\n    top: 50%;\n    left: 10px;\n    transform: translate(-50%,-50%);\n    background-color: white;\n    border-radius: 50%;\n    position: absolute;\n  }\n"], ["\n  color: ", ";\n  padding: 8px 10px 8px 20px;\n  margin-left: 4px;\n  margin-right: 4px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  border-radius: 2px;\n  font-family: Roboto;\n\n  @media (max-width: ", "){\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  @media (min-width: ", "){\n    position: relative;\n  }\n\n  :: before {\n    content: \"\";\n    width: 8px;\n    height: 8px;\n    top: 50%;\n    left: 10px;\n    transform: translate(-50%,-50%);\n    background-color: white;\n    border-radius: 50%;\n    position: absolute;\n  }\n"])), COLORS$1.WHITE, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.breakpoints[2]; });
var Title$7 = CustomStyled$1(Text)(templateObject_8$w || (templateObject_8$w = __makeTemplateObject(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (props) { return props.styles.color; });
Title$7.defaultProps = {
    fontSize: 1,
    fontWeight: 'bold',
};
var SubTitle$1 = CustomStyled$1(Text)(templateObject_9$t || (templateObject_9$t = __makeTemplateObject(["\n  color: ", ";\n  @media (max-width: ", ") {\n    margin-left: 0;\n  }\n  ", "\n \n  overflow: hidden;\n   html[dir='rtl'] & {\n    overflow: ", ";\n  }\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* number of lines to show */\n  -webkit-box-orient: vertical;   \n  flex:1\n"], ["\n  color: ", ";\n  @media (max-width: ", ") {\n    margin-left: 0;\n  }\n  ",
    "\n \n  overflow: hidden;\n   html[dir='rtl'] & {\n    overflow: ",
    ";\n  }\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* number of lines to show */\n  -webkit-box-orient: vertical;   \n  flex:1\n"])), function (props) { var _a; return (_a = props === null || props === void 0 ? void 0 : props.styles) === null || _a === void 0 ? void 0 : _a.color; }, function (props) { return props.theme.breakpoints[1]; }, function (props) {
    return props.isTitle &&
        props.isMobile &&
        "\n      margin-top: 8px;\n  ";
}, function (props) {
    return props.children && props.children.length > 50 ? "hidden" : "visible";
});
SubTitle$1.defaultProps = {
    fontSize: 1,
    marginLeft: '5px',
};
var BambuserTitle$1 = CustomStyled$1(SubTitle$1)(templateObject_10$s || (templateObject_10$s = __makeTemplateObject(["\n  padding: 8px;\n  max-width: 70%;\n"], ["\n  padding: 8px;\n  max-width: 70%;\n"])));
var CloseIconWrapper$3 = memo(CustomStyled$1(Flex)(templateObject_11$m || (templateObject_11$m = __makeTemplateObject(["\n", "\n  \n  cursor: pointer;\n"], ["\n",
    "\n  \n  cursor: pointer;\n"])), function (props) {
    return props.isTimer &&
        "position: relative;\n  top: -5px;";
}));
var MarketingStripTitle$1 = memo(CustomStyled$1(Flex)(templateObject_12$k || (templateObject_12$k = __makeTemplateObject(["\n  align-items: center;\n"], ["\n  align-items: center;\n"]))));
var MarketingStripSubTitle$1 = CustomStyled$1(MarketingStripTitle$1)(templateObject_13$j || (templateObject_13$j = __makeTemplateObject(["\n align-items: flex-start;\n"], ["\n align-items: flex-start;\n"])));
var BambuserStripWrapper$1 = CustomStyled$1(Flex)(templateObject_14$j || (templateObject_14$j = __makeTemplateObject(["\n flex: 1;\n align-items: center;\n @media (max-width : ", "){\n  flex-direction: row-reverse;\n  flex: 1;\n}\n"], ["\n flex: 1;\n align-items: center;\n @media (max-width : ", "){\n  flex-direction: row-reverse;\n  flex: 1;\n}\n"])), function (props) { return props.theme.breakpoints[2]; });
// timer Style start
var TimerWrapper$1 = CustomStyled$1(Flex)(templateObject_15$j || (templateObject_15$j = __makeTemplateObject(["\n  text-decoration: none;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items:center;\n  @media (max-width : ", "){\n    justify-content: flex-end;\n    align-items: center;\n    margin-right: 1vw;\n  }\n"], ["\n  text-decoration: none;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items:center;\n  @media (max-width : ", "){\n    justify-content: flex-end;\n    align-items: center;\n    margin-right: 1vw;\n  }\n"])), function (props) { return props.theme.breakpoints[1]; });
TimerWrapper$1.defaultProps = {
    as: 'a',
};
var TitleTimer$1 = CustomStyled$1(Title$7)(templateObject_16$f || (templateObject_16$f = __makeTemplateObject(["\n  margin-right: 8px;\n  height: 24px;\n"], ["\n  margin-right: 8px;\n  height: 24px;\n"])));
var TitleTimerMobile$1 = CustomStyled$1(TitleTimer$1)(templateObject_17$f || (templateObject_17$f = __makeTemplateObject(["\n  height: auto;\n"], ["\n  height: auto;\n"])));
var TimerWapperText$1 = memo(CustomStyled$1(Flex)(templateObject_18$c || (templateObject_18$c = __makeTemplateObject(["\n  justify-content: center;\n  align-items:center;\n  \n"], ["\n  justify-content: center;\n  align-items:center;\n  \n"]))));
var TimerWapperTextMobile$1 = CustomStyled$1(TimerWapperText$1)(templateObject_19$c || (templateObject_19$c = __makeTemplateObject(["\n  flex: ", ";\n  min-width: fit-content;\n"], ["\n  flex: ", ";\n  min-width: fit-content;\n"])), function (props) { var _a; return (props.isMobile && ((_a = props.styles) === null || _a === void 0 ? void 0 : _a.background_image_mobile) ? '0' : '1 1 0%'); });
var CountdownWrapper$1 = CustomStyled$1(Flex)(templateObject_20$a || (templateObject_20$a = __makeTemplateObject(["\n  flex-direction: column; \n  justify-content: center; \n  align-items: center;\n  font-family: 'Montserrat';\n"], ["\n  flex-direction: column; \n  justify-content: center; \n  align-items: center;\n  font-family: 'Montserrat';\n"])));
var SubTitleTimer$1 = memo(CustomStyled$1(SubTitle$1)(templateObject_21$9 || (templateObject_21$9 = __makeTemplateObject(["\n  flex:0;\n  height: ", ";\n  ", ";\n\n"], ["\n  flex:0;\n  height: ", ";\n  ", ";\n\n"])), function (props) { return (props.isMobile ? 'auto' : '24px'); }, function (props) { return props.isMobile && "padding: 5px 0"; }));
var CountDownNumberWrapper$1 = memo(CustomStyled$1(Flex)(templateObject_22$9 || (templateObject_22$9 = __makeTemplateObject(["\n\n  width: 23px;\n  height: 24px;\n  font-weight: 600;\n  font-size: 16px;\n  border-radius: 2px;\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  background: ", ";\n  color: ", ";\n  font-family: 'Montserrat';\n  @media (max-width : ", "){\n    width: 20px;\n    height: 20px;\n    font-weight: 600;\n    font-size: 14px;\n  }\n"], ["\n\n  width: 23px;\n  height: 24px;\n  font-weight: 600;\n  font-size: 16px;\n  border-radius: 2px;\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  background: ",
    ";\n  color: ", ";\n  font-family: 'Montserrat';\n  @media (max-width : ", "){\n    width: 20px;\n    height: 20px;\n    font-weight: 600;\n    font-size: 14px;\n  }\n"])), function (props) {
    return props.background_color;
}, function (props) { return props.timer_digits_color; }, function (props) { return props.theme.breakpoints[1]; }));
var CountDownNumberWrapperRigth$1 = memo(CustomStyled$1(CountDownNumberWrapper$1)(templateObject_23$7 || (templateObject_23$7 = __makeTemplateObject(["\n  html[dir='ltr'] & {margin-left: 2px};\n  html[dir='rtl'] & {margin-right 2px};\n"], ["\n  html[dir='ltr'] & {margin-left: 2px};\n  html[dir='rtl'] & {margin-right 2px};\n"]))));
var CountDownNumberWrapperLeft$1 = memo(CustomStyled$1(CountDownNumberWrapper$1)(templateObject_24$5 || (templateObject_24$5 = __makeTemplateObject(["\n  html[dir='ltr'] & {margin-right: 2px};\n  html[dir='rtl'] & {margin-left 2px};\n\n"], ["\n  html[dir='ltr'] & {margin-right: 2px};\n  html[dir='rtl'] & {margin-left 2px};\n\n"]))));
var CountDownNumberSeperator$1 = memo(CustomStyled$1(Flex)(templateObject_25$5 || (templateObject_25$5 = __makeTemplateObject(["\n  height: 24px;\n  font-size: 20px;\n  color: ", ";\n  visibility: ", ";\n  padding: 0 8px;\n  line-height: 6px;\n  padding: 0 5px;\n  @media (max-width : ", "){\n    padding: 0 2px;\n  }\n  \n"], ["\n  height: 24px;\n  font-size: 20px;\n  color: ", ";\n  visibility: ", ";\n  padding: 0 8px;\n  line-height: 6px;\n  padding: 0 5px;\n  @media (max-width : ", "){\n    padding: 0 2px;\n  }\n  \n"])), function (props) { return props.font_color; }, function (props) { return (props.toogleSeprator ? "hidden" : 'visible'); }, function (props) { return props.theme.breakpoints[1]; }));
var CountdownText$1 = memo(CustomStyled$1(Flex)(templateObject_26$5 || (templateObject_26$5 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px;\n"], ["\n  color: ", ";\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px;\n"])), function (props) { return props.timer_text_color; }));
var TimerWrapperBox$1 = CustomStyled$1.div(templateObject_27$5 || (templateObject_27$5 = __makeTemplateObject(["\n    margin-right: auto;\n    margin-left: 15px;\n"], ["\n    margin-right: auto;\n    margin-left: 15px;\n"])));
var templateObject_1$1E, templateObject_2$1k, templateObject_3$14, templateObject_4$W, templateObject_5$I, templateObject_6$y, templateObject_7$w, templateObject_8$w, templateObject_9$t, templateObject_10$s, templateObject_11$m, templateObject_12$k, templateObject_13$j, templateObject_14$j, templateObject_15$j, templateObject_16$f, templateObject_17$f, templateObject_18$c, templateObject_19$c, templateObject_20$a, templateObject_21$9, templateObject_22$9, templateObject_23$7, templateObject_24$5, templateObject_25$5, templateObject_26$5, templateObject_27$5;

var DefaultStrip$1 = function (_a) {
    var isMobile = _a.isMobile, url = _a.url, marketingInfo = _a.marketingInfo, GTMHandler = _a.GTMHandler;
    var href = url && url !== '#' && { href: url };
    return (React.createElement(TextWrapper$7, __assign({ isMobile: isMobile }, href, { onClick: function () { return GTMHandler('click', (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.title) || (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.name)); } }), (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.title) ? (React.createElement(React.Fragment, null,
        React.createElement(MarketingStripTitle$1, null,
            (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.icon) && React.createElement(IconWrapper$b, { src: marketingInfo.icon }),
            React.createElement(Title$7, { styles: marketingInfo.styles }, marketingInfo.title)),
        React.createElement(SubTitle$1, { isMobile: isMobile, styles: marketingInfo.styles, isTitle: marketingInfo.title }, marketingInfo.subtitle))) : (React.createElement(MarketingStripSubTitle$1, null,
        (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.icon) && React.createElement(IconWrapper$b, { src: marketingInfo.icon }),
        React.createElement(SubTitle$1, { styles: marketingInfo.styles }, marketingInfo.subtitle)))));
};

var BambuserStrip$1 = function (_a) {
    var isMobile = _a.isMobile, _b = _a.bambuserData, _c = _b.thumbnail, thumbnail = _c === void 0 ? '' : _c, _d = _b.live_icon_title, live_icon_title = _d === void 0 ? '' : _d, _e = _b.live_icon_background_color, live_icon_background_color = _e === void 0 ? COLORS$1.RED : _e, _f = _b.title, title = _f === void 0 ? '' : _f, _g = _b.show_id, show_id = _g === void 0 ? '' : _g, _h = _b.mobile_viewport_title, mobile_viewport_title = _h === void 0 ? '' : _h, _j = _b.mobile_deep_link, mobile_deep_link = _j === void 0 ? '' : _j, styles = _a.styles, isBambuserMobileAppDisabled = _a.isBambuserMobileAppDisabled;
    var bambuserMobileAppDisabled = isBambuserMobileAppDisabled && isMobile;
    useBambuser(bambuserMobileAppDisabled ? '' : show_id, 'liveshopping');
    return (React.createElement(BambuserContainer$1, { isMobile: isMobile, id: "liveshopping", as: bambuserMobileAppDisabled ? 'a' : 'button', href: bambuserMobileAppDisabled ? mobile_deep_link : '' },
        React.createElement(BambuserStripWrapper$1, null,
            React.createElement(BambuserThumbnailWrapper$1, null,
                thumbnail && React.createElement(IconWrapper$b, { isBambuser: true, src: thumbnail }),
                live_icon_title && React.createElement(LiveIcon$1, { backgroundColor: live_icon_background_color }, live_icon_title)),
            !bambuserMobileAppDisabled && title && React.createElement(BambuserTitle$1, { styles: styles }, title),
            bambuserMobileAppDisabled && mobile_viewport_title && (React.createElement(BambuserTitle$1, { styles: styles }, mobile_viewport_title)))));
};

var Timer$3 = memo(function Timer(_a) {
    var marketingInfo = _a.marketingInfo, onClick = _a.onClick, onTimerExpire = _a.onTimerExpire;
    var prefixZero = function (deg) {
        return ('0' + deg).slice(-2);
    };
    var calculateTimeLeft = useCallback(function () {
        var endTime = marketingInfo.timer.end_at;
        var difference = +new Date(endTime) - +new Date();
        var timeLeft = {};
        if (difference >= 0) {
            timeLeft = {
                Days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                Hrs: Math.floor((difference / (1000 * 60 * 60)) % 24),
                Mins: Math.floor((difference / 1000 / 60) % 60),
                Secs: Math.floor((difference / 1000) % 60),
            };
        }
        else {
            onTimerExpire(true);
        }
        return timeLeft;
    }, [marketingInfo, onTimerExpire]);
    var _b = __read(useState(calculateTimeLeft()), 2), timeLeft = _b[0], setTimeLeft = _b[1];
    var _c = __read(useState(false), 2), toogleSeprator = _c[0], setToogleSeprator = _c[1];
    var isMobile = useBreakpoints().isMobile;
    useEffect(function () {
        var timer = setTimeout(function () {
            setTimeLeft(calculateTimeLeft());
            setToogleSeprator(!toogleSeprator);
        }, 1000);
        return function () { return clearTimeout(timer); };
    });
    var timerComponents = [];
    Object.keys(timeLeft).forEach(function (interval, index) {
        if (interval === 'Days' && !timeLeft[interval]) {
            return null;
        }
        if (interval === 'Hrs' && !timeLeft[interval] && !timeLeft['Days'])
            return null;
        if (interval === 'Days' && timeLeft[interval]) {
            delete timeLeft.Sec;
        }
        if (timeLeft[interval] === undefined)
            return null;
        var ele = prefixZero(timeLeft[interval]).split('');
        timerComponents.push(React.createElement(CountdownWrapper$1, { key: interval },
            React.createElement("div", { style: { display: 'flex', flexDirection: 'row' } },
                React.createElement(CountDownNumberWrapperLeft$1, __assign({}, marketingInfo.timer), ele[0]),
                React.createElement(CountDownNumberWrapperRigth$1, __assign({}, marketingInfo.timer), ele[1])),
            React.createElement(CountdownText$1, __assign({}, marketingInfo.timer), timeLeft[interval] === 1 ? interval.substr(0, interval.length - 1) : interval)));
        if (index !== Object.keys(timeLeft).length - 1)
            timerComponents.push(React.createElement(CountDownNumberSeperator$1, __assign({ toogleSeprator: toogleSeprator }, marketingInfo.timer), ":"));
    });
    var href = (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.cta_url) && { href: marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.cta_url };
    if (isMobile) {
        return (React.createElement(TimerWrapper$1, __assign({ onClick: onClick }, href),
            React.createElement(TimerWrapperBox$1, null,
                React.createElement(TitleTimerMobile$1, { styles: marketingInfo.styles }, marketingInfo.title),
                React.createElement(SubTitleTimer$1, { as: "span", styles: marketingInfo.styles, isMobile: isMobile }, marketingInfo.subtitle)),
            React.createElement(TimerWapperTextMobile$1, __assign({ dir: "ltr" }, marketingInfo, { isMobile: isMobile }), timerComponents)));
    }
    return (React.createElement(TimerWrapper$1, __assign({ onClick: onClick }, href),
        React.createElement(TitleTimer$1, { styles: marketingInfo.styles }, marketingInfo.title),
        React.createElement(TimerWapperText$1, { dir: "ltr" }, timerComponents),
        React.createElement(SubTitleTimer$1, { as: "span", styles: marketingInfo.styles }, marketingInfo.subtitle)));
});

var MarketingStrip$2 = function (_a) {
    var _b, _c, _d;
    var isHideNav = _a.isHideNav, marketingInfo = _a.marketingInfo, loading = _a.loading;
    var _e = __read(useAppConfig$1(), 5), appConfigState = _e[0], setAppContext = _e[4];
    var _f = __read(useState(false), 2), isHide = _f[0], setIsHide = _f[1];
    var _g = __read(useState(false), 2), isTimerExpired = _g[0], setTimeExpired = _g[1];
    var _h = useBreakpoints(), isDesktop = _h.isDesktop, isMobile = _h.isMobile;
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    var onClose = function () {
        isBrowser$1() && sessionStorage.setItem('isHideMarketingStrip', 'true');
        setIsHide(true);
    };
    var GTMHandler = useCallback(function (eventAction, eventLabel) {
        GTMEventCall(GTMEvents$1.custom_event, {
            eventAction: eventAction,
            eventLabel: eventLabel,
        });
    }, [GTMEventCall]);
    useEffect(function () {
        if (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.name) ;
    }, [GTMHandler, marketingInfo]);
    if (loading || !marketingInfo || isEmptyObject$1(marketingInfo))
        return null;
    if (isHide)
        return null;
    var _j = marketingInfo.type, type = _j === void 0 ? 'CLASSIC' : _j, bambuser = marketingInfo.bambuser, styles = marketingInfo.styles;
    var getStrip = function () {
        var _a;
        switch (type) {
            case 'BAMBUSER':
                return (React.createElement(BambuserStrip$1, { isMobile: isMobile, bambuserData: bambuser, styles: styles, isBambuserMobileAppDisabled: !!((_a = appConfigState === null || appConfigState === void 0 ? void 0 : appConfigState.features) === null || _a === void 0 ? void 0 : _a.isBambuserMobileAppDisabled) }));
            case 'CLASSIC':
            default:
                return React.createElement(DefaultStrip$1, { isMobile: isMobile, url: url, marketingInfo: marketingInfo, GTMHandler: GTMHandler });
        }
    };
    var onTimerExpire = function () {
        setTimeExpired(true);
    };
    var url = setAppContext(marketingInfo.cta_url);
    var isStart = ((_b = marketingInfo.timer) === null || _b === void 0 ? void 0 : _b.start_at) && +new Date(marketingInfo.timer.start_at) < Date.now();
    var isEnd = ((_c = marketingInfo.timer) === null || _c === void 0 ? void 0 : _c.start_at) && +new Date(marketingInfo.timer.end_at) > Date.now();
    var isTimer = !isTimerExpired &&
        marketingInfo.timer &&
        marketingInfo.timer.start_at &&
        marketingInfo.timer.end_at &&
        isStart &&
        isEnd;
    var isBambuser = type === 'BAMBUSER';
    return (React.createElement(MarketingStripWrapper$1, { isHideNav: isHideNav, styles: marketingInfo.styles, "data-testid": "marketing-strip" },
        React.createElement(MarketingStripText$1, { isTimer: isTimer, isBambuser: !isTimer && isBambuser },
            isTimer ? (React.createElement(Timer$3, { marketingInfo: marketingInfo, onClick: function () { return GTMHandler('click', (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.title) || (marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.name)); }, onTimerExpire: onTimerExpire })) : (getStrip()),
            React.createElement(TextWrapper$7, { isTopCloseIcon: isMobile },
                isDesktop && marketingInfo.date && !marketingInfo.timer && (React.createElement(Title$7, { styles: marketingInfo.styles, fontSize: 1, marginRight: "15px" }, marketingInfo.date)),
                React.createElement(CloseIconWrapper$3, { onClick: onClose, isTimer: isTimer },
                    React.createElement(CloseIcon, { size: "S", fill: (_d = marketingInfo === null || marketingInfo === void 0 ? void 0 : marketingInfo.styles) === null || _d === void 0 ? void 0 : _d.color }))))));
};
var MarketingStrip$3 = memo(MarketingStrip$2);

var headTabsDataShaper = function (pageStructure, coachMarks) {
    var labels = pageStructure.map(function (component) { return component.title; });
    var icons = pageStructure.map(function (component) { return ({
        mediaActive: component.mediaActive || '',
        mediaInactive: component.mediaInactive || '',
    }); });
    var idMap = new Map();
    coachMarks.forEach(function (item) {
        idMap.set(item.page_navigation, item);
    });
    var coachMarkData = pageStructure
        .map(function (item) { return idMap.get(item.id); })
        .filter(function (item) { return !!item; });
    return { labels: labels, icons: icons, coachMarkData: coachMarkData };
};
var setPageStructureDataCookie = function (_a) {
    var id = _a.id, _b = _a.serviceType, serviceType = _b === void 0 ? '' : _b, _c = _a.productType, productType = _c === void 0 ? '' : _c;
    setSelectedTabData$1(JSON.stringify({
        selectedTabId: id,
        serviceType: serviceType,
        productType: productType,
    }));
};

var HeadTabs = function () {
    var store = useSelector(function (state) { return state; });
    var _a = store.pageStructure, pageStructure = _a === void 0 ? [] : _a, appConfig = store.appConfig;
    var selectedTabId = appConfig.selectedTabId;
    var selectedIndex = pageStructure.findIndex(function (obj) { return obj.id === selectedTabId; });
    var dispatch = useDispatch();
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    var _b = useSelector(function (state) {
        var _a, _b;
        return {
            lang: (_a = state === null || state === void 0 ? void 0 : state.appConfig) === null || _a === void 0 ? void 0 : _a.language,
            coachMarks: (_b = state === null || state === void 0 ? void 0 : state.deliveryTime) === null || _b === void 0 ? void 0 : _b.coachMarks,
        };
    }), _c = _b.lang, lang = _c === void 0 ? 'en' : _c, _d = _b.coachMarks, coachMarks = _d === void 0 ? [] : _d;
    var _e = headTabsDataShaper(pageStructure, coachMarks), labels = _e.labels, icons = _e.icons, _f = _e.coachMarkData, coachMarkData = _f === void 0 ? [] : _f;
    useEffect(function () {
        if (selectedTabId && selectedTabId == -1 && pageStructure.length) {
            setPageStructureDataCookie(pageStructure[0]);
        }
    }, [selectedTabId, pageStructure]);
    var onTabClick = function (index) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, id, serviceType, productType;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = pageStructure[index], id = _a.id, serviceType = _a.serviceType, productType = _a.productType;
                    setPageStructureDataCookie(pageStructure[index]);
                    return [4 /*yield*/, dispatch(setSelectedTabId(id))];
                case 1:
                    _b.sent();
                    GTMEventCall(GTMEvents$1.custom_event, {
                        eventAction: GTMEventActions$1.journey_selection_tab,
                        eventLabel: serviceType + "_" + productType,
                        ga4: true,
                    });
                    window.location.href = '/';
                    return [2 /*return*/];
            }
        });
    }); };
    return labels.length > 1 ? (React.createElement(React.Fragment, null,
        React.createElement(HeadTabsWrapper$1, { display: ['none', null, null, 'grid'] },
            React.createElement(Tabs, { labels: labels, variant: Types.TAB_VARIANTS.COMPACT, icons: icons, selectedIndex: selectedIndex === -1 ? 0 : selectedIndex, onLabelClick: onTabClick, lang: lang, coachMarks: coachMarkData, i18n: i18next },
                React.createElement(React.Fragment, null))),
        React.createElement(HeadTabsWrapperMobile$1, { display: ['block', null, null, 'none'] },
            React.createElement(Pills, { labels: labels, icons: icons, selectedIndex: selectedIndex === -1 ? 0 : selectedIndex, onLabelClick: onTabClick, coachMarks: coachMarkData, i18n: i18next, lang: lang })))) : (React.createElement(React.Fragment, null));
};

var Header$5 = (function (_a) {
    var _b, _c, _d;
    var _e = _a.cloneHeight, cloneHeight = _e === void 0 ? false : _e, _f = _a.isMenuNav, isMenuNav = _f === void 0 ? true : _f, _g = _a.isMarketingStrip, isMarketingStrip = _g === void 0 ? true : _g, _h = _a.isSmartBanner, isSmartBanner = _h === void 0 ? true : _h, _j = _a.isFixedHeaderOnscroll, isFixedHeaderOnscroll = _j === void 0 ? false : _j, smartBannerText = _a.smartBannerText, _k = _a.smartBannerPath, smartBannerPath = _k === void 0 ? '' : _k, _l = _a.isHeaderApiCall, isHeaderApiCall = _l === void 0 ? true : _l, rest = __rest(_a, ["cloneHeight", "isMenuNav", "isMarketingStrip", "isSmartBanner", "isFixedHeaderOnscroll", "smartBannerText", "smartBannerPath", "isHeaderApiCall"]);
    var dispatch = useDispatch();
    var _m = __read(useState(false), 2), isHideNav = _m[0], setHideNav = _m[1];
    var _o = useSelector(function (state) { return state.headerData; }), headerInfo = _o.data, loading = _o.loading;
    var store = useSelector(function (state) { return state; });
    var _p = __read(useState({}), 2), delivery = _p[0], setDelivery = _p[1];
    var _q = __read(useAppConfig$1(), 1), _r = _q[0].changingLocation, changingLocation = _r === void 0 ? false : _r;
    var _s = useSelector(function (state) { return state.appConfig; }).features, oneTrustScript = _s.oneTrustScript, _t = _s.isExtraOneTrustScript, isExtraOneTrustScript = _t === void 0 ? false : _t;
    var getDeliveryRef = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getDeliveryTime$1()(dispatch, store)];
                case 1:
                    response = _a.sent();
                    setDelivery(response);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Delivery Time api Failed in header', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var oneTrustScriptEnabled = ((_b = useFeature('one_trust_script_enabled')) === null || _b === void 0 ? void 0 : _b.value) || false;
    var isPolygonChangeEnabled = ((_c = useFeature('is_polygon_cached')) === null || _c === void 0 ? void 0 : _c.value) || false;
    var isNonFoodV2Enabled = useNonFoodV2Journey();
    useCookieConsentScript(oneTrustScript, isExtraOneTrustScript, oneTrustScriptEnabled);
    useEffect(function () {
        if (!isNonFoodV2Enabled) {
            removeSelectedTabData$1();
        }
    }, [isNonFoodV2Enabled]);
    useEffect(function () {
        if (!isPolygonChangeEnabled) {
            getDeliveryRef();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPolygonChangeEnabled]);
    useEffect(function () {
        if (changingLocation) {
            getDeliveryRef();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [changingLocation]);
    useEffect(function () {
        if (!headerInfo && isHeaderApiCall) {
            dispatch(getHeaderData());
        }
    }, [dispatch, headerInfo, isHeaderApiCall]);
    useEffect(function () {
        var handleScroll = debounce$1(function () {
            var currentScrollPos = window.pageYOffset;
            if (currentScrollPos === 0) {
                setHideNav(false);
            }
            else if (currentScrollPos > 0) {
                setHideNav(true);
            }
        }, 15);
        !isFixedHeaderOnscroll && window.addEventListener('scroll', handleScroll);
        return function () { return window.removeEventListener('scroll', handleScroll); };
    }, [isFixedHeaderOnscroll]);
    var isHomePage = isBrowser$1() && getPageType$1() === constants$1.home;
    var isDev = process.env.NODE_ENV === 'development';
    var isHideMarketingStrip = isBrowser$1() && Boolean(sessionStorage.getItem('isHideMarketingStrip'));
    var countryConfiguration = useSelector(function (state) { return state.appConfig; }).countryConfiguration;
    var _u = countryConfiguration || {}, _v = _u.SmartBanner, SmartBanner = _v === void 0 ? false : _v, _w = _u.countryOfOperationID, countryOfOperationID = _w === void 0 ? '' : _w;
    var isShowFullArea = ((delivery === null || delivery === void 0 ? void 0 : delivery.expressSlot) && (delivery === null || delivery === void 0 ? void 0 : delivery.standardSlot) && (delivery === null || delivery === void 0 ? void 0 : delivery.clickCollectSlot)) || false;
    return (React.createElement(React.Fragment, null,
        React.createElement(Header$2, { isHideNav: isHideNav },
            isSmartBanner && SmartBanner && (React.createElement(Box, null,
                React.createElement(CustomSmartBanner, { appendedPath: smartBannerPath, bannerText: smartBannerText }))),
            isNonFoodV2Enabled && React.createElement(HeadTabs, null),
            React.createElement(MainPane$2, __assign({}, rest, { isHideNav: isHideNav, dealsMenu: headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.navbar_deals, loading: loading, phoneNumber: headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.phone_number, quickBuyLink: (_d = headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.buy_quick_link) === null || _d === void 0 ? void 0 : _d.cta_url_web, countryOfOperationID: countryOfOperationID, isShowFullArea: isShowFullArea })),
            isMenuNav && React.createElement(MenuNavigation, null),
            isMarketingStrip && (isHomePage || isDev) && !isHideMarketingStrip && (React.createElement(MarketingStrip$3, { marketingInfo: headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.marketing_strip, loading: loading, isHideNav: isHideNav }))),
        cloneHeight && React.createElement(HeaderStatic$1, __assign({}, rest))));
});

var classCallCheck$1 = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var inherits$1 = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var possibleConstructorReturn$1 = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var slicedToArray$1 = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var windowObject$1 = void 0;
if (typeof window !== 'undefined') {
  windowObject$1 = window;
} else if (typeof self !== 'undefined') {
  windowObject$1 = self;
} else {
  windowObject$1 = global;
}
var cancelFrame$1 = null;
var requestFrame$1 = null;
var TIMEOUT_DURATION$1 = 20;
var clearTimeoutFn$1 = windowObject$1.clearTimeout;
var setTimeoutFn$1 = windowObject$1.setTimeout;
var cancelAnimationFrameFn$1 = windowObject$1.cancelAnimationFrame || windowObject$1.mozCancelAnimationFrame || windowObject$1.webkitCancelAnimationFrame;
var requestAnimationFrameFn$1 = windowObject$1.requestAnimationFrame || windowObject$1.mozRequestAnimationFrame || windowObject$1.webkitRequestAnimationFrame;
if (cancelAnimationFrameFn$1 == null || requestAnimationFrameFn$1 == null) {
  cancelFrame$1 = clearTimeoutFn$1;
  requestFrame$1 = function requestAnimationFrameViaSetTimeout(callback) {
    return setTimeoutFn$1(callback, TIMEOUT_DURATION$1);
  };
} else {
  cancelFrame$1 = function cancelFrame(_ref) {
    var _ref2 = slicedToArray$1(_ref, 2),
        animationFrameID = _ref2[0],
        timeoutID = _ref2[1];
    cancelAnimationFrameFn$1(animationFrameID);
    clearTimeoutFn$1(timeoutID);
  };
  requestFrame$1 = function requestAnimationFrameWithSetTimeoutFallback(callback) {
    var animationFrameID = requestAnimationFrameFn$1(function animationFrameCallback() {
      clearTimeoutFn$1(timeoutID);
      callback();
    });
    var timeoutID = setTimeoutFn$1(function timeoutCallback() {
      cancelAnimationFrameFn$1(animationFrameID);
      callback();
    }, TIMEOUT_DURATION$1);
    return [animationFrameID, timeoutID];
  };
}
function createDetectElementResize$1(nonce) {
  var animationKeyframes = void 0;
  var animationName = void 0;
  var animationStartEvent = void 0;
  var animationStyle = void 0;
  var checkTriggers = void 0;
  var resetTriggers = void 0;
  var scrollListener = void 0;
  var attachEvent = typeof document !== 'undefined' && document.attachEvent;
  if (!attachEvent) {
    resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };
    checkTriggers = function checkTriggers(element) {
      return element.offsetWidth !== element.__resizeLast__.width || element.offsetHeight !== element.__resizeLast__.height;
    };
    scrollListener = function scrollListener(e) {
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }
      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame$1(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame$1(function animationFrame() {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function forEachResizeListener(fn) {
            fn.call(element, e);
          });
        }
      });
    };
    var animation = false;
    var keyframeprefix = '';
    animationStartEvent = 'animationstart';
    var domPrefixes = 'Webkit Moz O ms'.split(' ');
    var startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' ');
    var pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }
      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationStartEvent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }
    animationName = 'resizeanim';
    animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }
  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');
      style.id = 'detectElementResize';
      style.type = 'text/css';
      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }
      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }
      head.appendChild(style);
    }
  };
  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = windowObject$1.getComputedStyle(element);
        if (elementStyle && elementStyle.position === 'static') {
          element.style.position = 'relative';
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        var expandTrigger = doc.createElement('div');
        expandTrigger.className = 'expand-trigger';
        expandTrigger.appendChild(doc.createElement('div'));
        var contractTrigger = doc.createElement('div');
        contractTrigger.className = 'contract-trigger';
        element.__resizeTriggers__.appendChild(expandTrigger);
        element.__resizeTriggers__.appendChild(contractTrigger);
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);
        if (animationStartEvent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName === animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationStartEvent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };
  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationStartEvent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
        }
      }
    }
  };
  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
var AutoSizer$1 = function (_React$PureComponent) {
  inherits$1(AutoSizer, _React$PureComponent);
  function AutoSizer() {
    var _ref;
    var _temp, _this, _ret;
    classCallCheck$1(this, AutoSizer);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = possibleConstructorReturn$1(this, (_ref = AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    }, _this._onResize = function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;
      if (_this._parentNode) {
        var _height = _this._parentNode.offsetHeight || 0;
        var _width = _this._parentNode.offsetWidth || 0;
        var _style = window.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;
        var newHeight = _height - paddingTop - paddingBottom;
        var newWidth = _width - paddingLeft - paddingRight;
        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: _height - paddingTop - paddingBottom,
            width: _width - paddingLeft - paddingRight
          });
          onResize({ height: _height, width: _width });
        }
      }
    }, _this._setRef = function (autoSizer) {
      _this._autoSizer = autoSizer;
    }, _temp), possibleConstructorReturn$1(_this, _ret);
  }
  createClass$1(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;
      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        this._parentNode = this._autoSizer.parentNode;
        this._detectElementResize = createDetectElementResize$1(nonce);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
        this._onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          width = _state.width;
      var outerStyle = { overflow: 'visible' };
      var childParams = {};
      var bailoutOnChildren = false;
      if (!disableHeight) {
        if (height === 0) {
          bailoutOnChildren = true;
        }
        outerStyle.height = 0;
        childParams.height = height;
      }
      if (!disableWidth) {
        if (width === 0) {
          bailoutOnChildren = true;
        }
        outerStyle.width = 0;
        childParams.width = width;
      }
      return createElement(
        'div',
        {
          className: className,
          ref: this._setRef,
          style: _extends$1({}, outerStyle, style)
        },
        !bailoutOnChildren && children(childParams)
      );
    }
  }]);
  return AutoSizer;
}(PureComponent);
AutoSizer$1.defaultProps = {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
};

var QuantitySelectorWrapper$2 = CustomStyled$1.div(templateObject_1$1F || (templateObject_1$1F = __makeTemplateObject(["\n  width: 100%;\n  display: inline-block;\n  ", ";\n  ", "\n"], ["\n  width: 100%;\n  display: inline-block;\n  ", ";\n  ",
    "\n"])), space, function (props) {
    return variant({
        prop: 'variant',
        variants: {
            pdp: {
                height: 37,
                border: props.inCart ? 'none' : "1px solid " + props.theme.colors.mercury,
                padding: '4px 4px',
                textAlign: 'center',
                background: props.inCart ? 'transparent' : "" + props.theme.colors.white,
                width: props.inCart ? [68, 157] : [100, 51],
                minWidth: '100%',
                borderRadius: '4px',
                svg: {
                    height: 10,
                    width: 10,
                    marginLeft: 1,
                    marginRight: 1,
                },
            },
            fbt: {
                svg: {
                    height: 12,
                    width: 12,
                    marginLeft: 2,
                },
            },
            regular: {
                height: props.open ? 28 : 30,
            },
        },
    });
});
var SelectBox$1 = CustomStyled$1(Flex)(templateObject_2$1l || (templateObject_2$1l = __makeTemplateObject(["\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  color: #4d4d4d;\n  cursor: pointer;\n  background: none;\n  height: 32px;\n  border-radius: 2px;\n\n  &::after {\n    background: grey;\n    position: absolute;\n    top: 12px;\n    left: 8px;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #fff;\n    width: 0;\n    height: 0;\n  }\n\n  span:first-of-type, svg > path:first-of-type {\n    transition: color 0.25s ease, stroke 0.25s ease;\n  }\n\n  ", "\n\n  ", "\n \n  ", "\n  \n  ", "\n  \n  ", "\n"], ["\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  color: #4d4d4d;\n  cursor: pointer;\n  background: none;\n  height: 32px;\n  border-radius: 2px;\n\n  &::after {\n    background: grey;\n    position: absolute;\n    top: 12px;\n    left: 8px;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #fff;\n    width: 0;\n    height: 0;\n  }\n\n  span:first-of-type, svg > path:first-of-type {\n    transition: color 0.25s ease, stroke 0.25s ease;\n  }\n\n  ",
    "\n\n  ",
    "\n \n  ",
    "\n  \n  ",
    "\n  \n  ",
    "\n"])), function (props) {
    return props.isLoading &&
        "\n    cursor: default;\n\n    span:first-of-type {\n      color: " + props.theme.colors.mercury + ";\n\n      + div {\n        cursor: default;\n      }\n    }\n\n\n    svg > path:first-of-type {\n      stroke: " + props.theme.colors.mercury + ";\n    }\n  ";
}, function (props) {
    return !props.expandQtySelector &&
        "\n    position: absolute;\n    bottom: 0;\n  ";
}, function (props) {
    return props.dir == 'rtl'
        ? "\n    left: 0;\n  "
        : "right: 0;";
}, function (props) {
    return props.expandQtySelector &&
        "\n    position: static;\n  ";
}, function (props) {
    return variant({
        variants: {
            fbt: {
                width: '82px',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 0,
                margin: '0 12px',
                svg: {
                    height: '12px',
                    width: '12px',
                },
            },
            pdp: {
                padding: 0,
                height: 27,
                background: 'transparent',
                justifyContent: 'center',
            },
            regular: {
                width: props.soldByWeight ? 'auto' : '32px',
                minWidth: props.soldByWeight && '32px',
                height: '32px',
                background: 'rgb(14, 90, 167)',
                borderRadius: '16px',
                placeContent: 'center',
                padding: props.soldByWeight ? '6px 12px' : '0',
            },
            regular_wide: {
                width: props.soldByWeight ? 'auto' : '32px',
                minWidth: props.soldByWeight && '32px',
                height: '32px',
                borderRadius: '16px',
                placeContent: 'center',
                color: props.theme.colors.black,
                padding: props.soldByWeight ? '6px 12px' : '0',
            },
            list: {
                size: 23,
            },
            compact: {
                height: 23,
                width: 40,
            },
            mini: {
                height: 23,
            },
        },
    });
});
var SelectBoxLabel$1 = CustomStyled$1.span(templateObject_3$15 || (templateObject_3$15 = __makeTemplateObject(["\n  color: ", ";\n  overflow: hidden;\n  line-height: normal;\n  @media only screen and (max-width: 1264px) {\n    text-overflow: ellipsis;\n  };\n  white-space: nowrap;\n\n\n  ", "\n\n  ", "\n"], ["\n  color: ", ";\n  overflow: hidden;\n  line-height: normal;\n  @media only screen and (max-width: 1264px) {\n    text-overflow: ellipsis;\n  };\n  white-space: nowrap;\n\n\n  ",
    "\n\n  ",
    "\n"])), function (props) { return props.theme.colors.copy; }, function (props) {
    return variant({
        prop: 'productCardVariant',
        variants: {
            mini: {
                fontSize: props.theme.fontSizes[props.inCart ? 1 : 2] + "px",
                // maxWidth: 32,
                paddingRight: 4,
            },
            simple: {
                paddingRight: 1,
            },
        },
    });
}, function (props) {
    return variant({
        prop: 'variant',
        variants: {
            pdp: {
                width: props.inCart ? 'auto' : '',
                fontSize: '12px',
                fontWeight: 700,
            },
            regular: {
                color: props.theme.colors.white,
                fontWeight: 700,
            },
            regular_wide: {
                color: props.theme.colors.black,
                fontWeight: 700,
                background: 'transparent !important',
            },
            list: {
                color: props.theme.colors.blue,
                fontWeight: 700,
                marginRight: '3px',
            },
            compact: {
                color: props.theme.colors.blue,
                fontWeight: 700,
                marginRight: '3px',
            },
        },
    });
});
var SelectOption$1 = CustomStyled$1.li(templateObject_4$X || (templateObject_4$X = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #4d4d4d;\n  cursor: pointer;\n  text-align: center;\n\n  ", "\n  span {\n    color: rgba(77, 77, 77, 0.7);\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #4d4d4d;\n  cursor: pointer;\n  text-align: center;\n\n  ",
    "\n  span {\n    color: rgba(77, 77, 77, 0.7);\n  }\n"])), function (props) {
    var selected = props.selected;
    if (selected) {
        return "\n      ";
    }
});
var SelectOptionsHeader$1 = CustomStyled$1.h4(templateObject_5$J || (templateObject_5$J = __makeTemplateObject(["\n  width: 100%;\n  top: 0;\n  padding: 12px;\n  color: ", ";\n  border-bottom: 1px solid ", ";\n  display: flex;\n  justify-content: space-between;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px 0px;\n"], ["\n  width: 100%;\n  top: 0;\n  padding: 12px;\n  color: ", ";\n  border-bottom: 1px solid ", ";\n  display: flex;\n  justify-content: space-between;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px 0px;\n"])), function (props) { return props.theme.colors.blacks[6]; }, function (props) { return props.theme.colors.blacks[3]; });
var SelectOptionQuantity$1 = CustomStyled$1(Flex)(templateObject_6$z || (templateObject_6$z = __makeTemplateObject(["\n  padding-left: 28px;\n  position: relative;\n  font-weight: 500;\n  color: ", ";\n::before{\n  content:\"\";\n  width: 19px;\n  height: 19px;\n  border-radius: 100%;\n  border: 2px solid ", ";\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n::after{\n  content:\"\";\n  width: 11px;\n  height: 11px;\n  border-radius: 100%;\n  position: absolute;\n  left: 4px;\n  top: 4px;\n  background: #4D4D4D;\n  opacity: 0;\n    ", "\n}\n"], ["\n  padding-left: 28px;\n  position: relative;\n  font-weight: 500;\n  color: ", ";\n::before{\n  content:\"\";\n  width: 19px;\n  height: 19px;\n  border-radius: 100%;\n  border: 2px solid ", ";\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n::after{\n  content:\"\";\n  width: 11px;\n  height: 11px;\n  border-radius: 100%;\n  position: absolute;\n  left: 4px;\n  top: 4px;\n  background: #4D4D4D;\n  opacity: 0;\n    ",
    "\n}\n"])), function (props) { return ((props === null || props === void 0 ? void 0 : props.selected) ? props.theme.colors.black : props.theme.colors.black); }, function (props) { return ((props === null || props === void 0 ? void 0 : props.selected) ? '#4D4D4D' : '#969696'); }, function (props) {
    var selected = props.selected;
    if (selected) {
        return "opacity: 1";
    }
});
var SelectOptionPrice$1 = CustomStyled$1(Flex)(templateObject_7$x || (templateObject_7$x = __makeTemplateObject(["\ncolor: ", ";\n "], ["\ncolor: ", ";\n "])), function (props) { return ((props === null || props === void 0 ? void 0 : props.selected) ? props.theme.colors.black : props.theme.colors.black); });
var SelecOptionWrapper$1 = CustomStyled$1(Flex)(templateObject_8$x || (templateObject_8$x = __makeTemplateObject(["\npadding: 0  ", "px;\nwidth: 100%;\njustify-content: space-between;\nfont-weight: 700;\nheight: 19px;\nline-height: 19px;\n&:hover{\n  color: ", ";\n}\n\n", "\n"], ["\npadding: 0  ", "px;\nwidth: 100%;\njustify-content: space-between;\nfont-weight: 700;\nheight: 19px;\nline-height: 19px;\n&:hover{\n  color: ", ";\n}\n\n",
    "\n"])), function (props) { return props.theme.space[4]; }, function (props) { return props.theme.colors.blue; }, variant({
    variants: {
        mini: {
            padding: '0 12px',
        },
    },
}));
var SelectOptionsContainer$1 = CustomStyled$1.div(templateObject_9$u || (templateObject_9$u = __makeTemplateObject(["\n  position: absolute;\n  overflow-x: hidden;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background-color: ", ";\n  ", "\n  z-index: 3;\n    ", "\n"], ["\n  position: absolute;\n  overflow-x: hidden;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background-color: ", ";\n  ",
    "\n  z-index: 3;\n    ",
    "\n"])), function (props) { return props.theme.colors.white; }, function (props) {
    return props.isMobile &&
        "\n      position: fixed;\n      bottom: 0;\n      top: auto;\n      height: 150px;\n  ";
}, function (props) {
    return variant({
        prop: 'variant',
        variants: {
            pdp: {
                overflowY: props.isSticky ? ['hidden', 'visible'] : 'visible',
                position: props.isSticky ? ['fixed', 'absolute'] : 'absolute',
                height: (props === null || props === void 0 ? void 0 : props.selectHeight) ? (props === null || props === void 0 ? void 0 : props.selectHeight) + 20 : ['30%', 215],
                paddingTop: [10, '7px'],
                paddingBottom: [10, '5px'],
                maxHeight: props.isSticky ? ['55%', 225] : 225,
                minHeight: [84, 'unset'],
                marginTop: [1],
                bottom: 0,
                top: props.isSticky ? ['auto', '40px'] : '40px',
                width: ['100%', props.inCart ? 157 : '100%'],
                minWidth: '100%',
                zIndex: '3',
                boxShadow: '0px 4px 4px rgb(0 0 0 / 15%)',
                borderRadius: "4px",
            },
            regular: {
                height: 143,
                bottom: '-12px',
                left: '-12px',
                right: '-12px',
                width: 'auto',
                top: 'auto',
                zIndex: '3',
                boxShadow: '0px -2px 6px rgba(0, 0, 0, 0.25)',
                borderRadius: "6px",
            },
            mini: {
                height: 143,
                bottom: '-8px',
                left: '-8px',
                right: '-8px',
                width: 'auto',
                top: 'auto',
                zIndex: '3',
                boxShadow: '0px -2px 6px rgba(0, 0, 0, 0.25)',
                borderRadius: "6px",
                fontSize: '10px',
            },
            fbt: {
                overflowY: props.isSticky ? ['hidden', 'visible'] : 'visible',
                position: props.isSticky ? ['fixed', 'absolute'] : 'absolute',
                height: props.isSticky ? ['75%', 215] : 215,
                top: props.isSticky ? ['auto', 0] : [0],
                bottom: 0,
            },
        },
    });
});
var StyledIconContainer$1 = CustomStyled$1.div(templateObject_10$t || (templateObject_10$t = __makeTemplateObject(["\n  cursor: pointer;\n  transform: rotate(90deg);\n  ", "\n"], ["\n  cursor: pointer;\n  transform: rotate(90deg);\n  ",
    "\n"])), variant({
    prop: 'variant',
    variants: {
        pdp: {
            transform: 'rotate(360deg)',
            marginBottom: '3px',
        },
    },
}));
var SelectorProductDetails$1 = styled(Box)(templateObject_11$n || (templateObject_11$n = __makeTemplateObject(["\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n"], ["\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n"])));
SelectorProductDetails$1.defaultProps = {
    display: ['inline-block', 'none'],
    padding: ['16px', 0],
    width: '100%',
    mb: '4px',
};
var SelectorProductImage$1 = customStyled.figure(templateObject_12$l || (templateObject_12$l = __makeTemplateObject(["\n  width: 100px;\n  height: 100px;\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0;\n"], ["\n  width: 100px;\n  height: 100px;\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0;\n"])));
var SelectorProductTitle$1 = customStyled.span(templateObject_13$k || (templateObject_13$k = __makeTemplateObject(["\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 500;\n  margin-left: 16px;\n  vertical-align: middle;\n  white-space: normal;\n  color: #4d4d4d;\n  max-width: calc(100% - 120px);\n"], ["\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 500;\n  margin-left: 16px;\n  vertical-align: middle;\n  white-space: normal;\n  color: #4d4d4d;\n  max-width: calc(100% - 120px);\n"])));
var SelectorPdpBackgound$1 = styled(Box)(templateObject_14$k || (templateObject_14$k = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  background-color: rgba(0, 0, 0, 0.5);\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  background-color: rgba(0, 0, 0, 0.5);\n"])));
SelectorPdpBackgound$1.defaultProps = {
    display: ['block', 'none'],
};
var CloseText$1 = styled(Box)(templateObject_15$k || (templateObject_15$k = __makeTemplateObject(["\n  text-align: right;\n  margin-top: 5px;\n  font-size: 9px;\n  color: #000408;\n  cursor: pointer;\n"], ["\n  text-align: right;\n  margin-top: 5px;\n  font-size: 9px;\n  color: #000408;\n  cursor: pointer;\n"])));
CloseText$1.defaultProps = {
    mr: ['25px', null, null, '5px'],
};
var templateObject_1$1F, templateObject_2$1l, templateObject_3$15, templateObject_4$X, templateObject_5$J, templateObject_6$z, templateObject_7$x, templateObject_8$x, templateObject_9$u, templateObject_10$t, templateObject_11$n, templateObject_12$l, templateObject_13$k, templateObject_14$k, templateObject_15$k;

/**
 * Apply virtualization for the quantity list
 * to improve performance if we have large quantities
 * of products
 */
var QuantityOption$1 = memo(function (_a) {
    var data = _a.data, index = _a.index, style = _a.style;
    var options = data.options, onSelectOptionHandle = data.onSelectOptionHandle, selected = data.selected;
    var option = options[index];
    return (React.createElement(SelectOption$1, { key: index, onClick: onSelectOptionHandle(option), selected: selected === option, style: style }, option.label));
}, areEqual);
var QuantityOptionPDP$1 = memo(function (_a) {
    var data = _a.data, index = _a.index, style = _a.style;
    var options = data.options, onSelectOptionHandle = data.onSelectOptionHandle, selected = data.selected, currency = data.currency, variant = data.variant;
    var option = options[index];
    return (React.createElement(SelectOption$1, { key: index, onClick: onSelectOptionHandle(option), selected: selected === option, style: style },
        React.createElement(SelecOptionWrapper$1, { variant: variant },
            React.createElement(SelectOptionQuantity$1, { selected: selected === option }, option.label),
            React.createElement(SelectOptionPrice$1, { selected: selected === option },
                currency,
                " ",
                option.price))));
}, areEqual);

var createItemData$1 = memoize(function (options, selected, onSelectOptionHandle, currency) { return ({
    options: options,
    selected: selected,
    onSelectOptionHandle: onSelectOptionHandle,
    currency: currency,
}); });
var QuantitySelector$1 = function (props) {
    var _a;
    var _b = props.inCart, inCart = _b === void 0 ? false : _b, _c = props.isLoading, isLoading = _c === void 0 ? false : _c, _d = props.isOpen, isOpen = _d === void 0 ? false : _d, onSelectHandler = props.onSelectHandler, _e = props.options, options = _e === void 0 ? [] : _e, _f = props.productCardVariant, productCardVariant = _f === void 0 ? EProductCardVariants$1.REGULAR : _f, selectOnChange = props.selectOnChange, selectedValue = props.selectedValue, soldByWeight = props.soldByWeight, productImage = props.productImage, onlineName = props.onlineName, _g = props.isSticky, isSticky = _g === void 0 ? false : _g, _h = props.variant, variant = _h === void 0 ? 'plp' : _h, _j = props.currency, currency = _j === void 0 ? '' : _j, isNewCarrefourJourney = props.isNewCarrefourJourney, expandQtySelector = props.expandQtySelector, dir = props.dir, productId = props.productId;
    var _k = __read(useState(false), 2), open = _k[0], setOpen = _k[1];
    var t = useTranslation().t;
    var _l = __read(useState(options[0]), 2), selected = _l[0], setSelected = _l[1];
    var selectHeaderRef = useRef();
    var detailsRef = useRef();
    var isMobile = useBreakpoints().isMobile;
    useEffect(function () {
        setOpen(isOpen);
    }, [isOpen]);
    useEffect(function () {
        if (!selectedValue) {
            setSelected(options[0]);
        }
        else {
            var selectedOption = options.filter(function (option) { return option.value === selectedValue; })[0];
            setSelected(selectedOption);
        }
    }, [options, selectedValue]);
    var onHeaderCloseHandler = function () {
        setOpen(false);
        if (onSelectHandler) {
            onSelectHandler(false);
        }
    };
    var onSelectOptionHandle = function (option) { return function () {
        var state = !open;
        setOpen(state);
        if (selectOnChange) {
            selectOnChange(option);
        }
        else {
            setSelected(option);
        }
        if (onSelectHandler) {
            onSelectHandler(state);
        }
    }; };
    var dispatch = useDispatch();
    var onSelectBox = function () {
        if (!isNewCarrefourJourney) {
            var state_1 = !isLoading && !open;
            setOpen(state_1);
            setTimeout(function () {
                if (onSelectHandler) {
                    onSelectHandler(state_1);
                }
            });
        }
        else {
            dispatch(setExpandedQtySelectorProductId$1(productId));
        }
    };
    var onClose = function () {
        setOpen(false);
    };
    var itemData = createItemData$1(options, selected, onSelectOptionHandle, currency);
    itemData.variant = variant;
    return (React.createElement(React.Fragment, null,
        React.createElement(QuantitySelectorWrapper$2, { variant: variant, inCart: inCart, open: open }, (!open || variant === EProductCardVariants$1.FBT || variant === EProductCardVariants$1.PDP) && (React.createElement(SelectBox$1, { expandQtySelector: !isNewCarrefourJourney ? true : expandQtySelector, variant: variant, isLoading: isLoading, open: variant === EProductCardVariants$1.REGULAR_WIDE ? true : open, onClick: onSelectBox, "data-testid": "select-box", dir: dir, soldByWeight: soldByWeight },
            React.createElement(SelectBoxLabel$1, { "data-testid": "select-label", inCart: inCart, productCardVariant: productCardVariant, variant: variant },
                selected &&
                    (isNewCarrefourJourney && soldByWeight
                        ? formatPriceForScalablePrducts$1(selected.value)
                        : selected.label),
                inCart &&
                    (variant === EProductCardVariants$1.FBT || variant === EProductCardVariants$1.PDP) &&
                    "(" + currency + " " + selected.price + ")",
                React.createElement("span", null)),
            variant !== EProductCardVariants$1.REGULAR_WIDE && (React.createElement(StyledIconContainer$1, { variant: variant }, variant === EProductCardVariants$1.PDP ? (React.createElement(ArrowDown, { size: "XS", fill: "#4d4d4d" })) : ((!isNewC4Journey$1 ||
                (variant !== EProductCardVariants$1.REGULAR && variant !== EProductCardVariants$1.REGULAR_WIDE)) && (React.createElement(ArrowDark, { size: "CUSTOM", height: "14px", width: "9px", fill: "#0E5AA7" })))))))),
        open && (React.createElement(React.Fragment, null,
            (variant === EProductCardVariants$1.PDP || variant === EProductCardVariants$1.FBT) && isSticky && (React.createElement(SelectorPdpBackgound$1, null)),
            React.createElement(SelectOptionsContainer$1, { key: "select-options-container", variant: variant, isSticky: isSticky, selectHeight: ((_a = itemData === null || itemData === void 0 ? void 0 : itemData.options) === null || _a === void 0 ? void 0 : _a.length) * 42 || 0, isMobile: isMobile },
                variant !== EProductCardVariants$1.PDP &&
                    variant !== EProductCardVariants$1.REGULAR &&
                    variant !== EProductCardVariants$1.REGULAR_WIDE &&
                    variant !== EProductCardVariants$1.MINI &&
                    variant !== EProductCardVariants$1.COMPACT &&
                    variant !== EProductCardVariants$1.LIST ? (React.createElement(SelectOptionsHeader$1, { "data-testid": "select-header", ref: selectHeaderRef },
                    "- ",
                    soldByWeight ? t('productCard.selectWeight') : t('productCard.selectQuantity'),
                    "-",
                    ' ',
                    React.createElement(StyledIconContainer$1, { "data-testid": "select-header-close", onClick: onHeaderCloseHandler, variant: variant },
                        "- \u2715 -",
                        ' '),
                    "-",
                    ' ')) : null,
                variant === EProductCardVariants$1.FBT && isSticky && (React.createElement(SelectorProductDetails$1, { ref: detailsRef },
                    React.createElement(SelectorProductImage$1, null,
                        React.createElement(Image, { url: productImage, name: onlineName })),
                    React.createElement(SelectorProductTitle$1, { dangerouslySetInnerHTML: { __html: onlineName } }))),
                (variant === EProductCardVariants$1.REGULAR ||
                    variant === EProductCardVariants$1.REGULAR_WIDE ||
                    variant === EProductCardVariants$1.MINI ||
                    variant === EProductCardVariants$1.COMPACT ||
                    variant === EProductCardVariants$1.LIST) && (React.createElement(CloseText$1, { onClick: onClose }, t('productCard.close'))),
                React.createElement(AutoSizer$1, null, function (_a) {
                    var _b, _c;
                    var height = _a.height, width = _a.width;
                    return (React.createElement(FixedSizeList, { height: variant === EProductCardVariants$1.PDP ||
                            variant === EProductCardVariants$1.REGULAR ||
                            variant === EProductCardVariants$1.REGULAR_WIDE ||
                            variant === EProductCardVariants$1.MINI ||
                            variant === EProductCardVariants$1.COMPACT ||
                            variant === EProductCardVariants$1.LIST
                            ? height - (((_b = detailsRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0)
                            : height -
                                -selectHeaderRef.current.offsetHeight -
                                -(((_c = detailsRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight) || 0), itemCount: options.length, itemData: itemData, itemSize: 42, ref: function (el) { return el && el.scrollToItem(options.indexOf(selected), 'start'); }, width: width, "data-testid": "product_qnty_picker" }, variant === EProductCardVariants$1.PDP ||
                        variant === EProductCardVariants$1.REGULAR ||
                        variant === EProductCardVariants$1.REGULAR_WIDE ||
                        variant === EProductCardVariants$1.MINI ||
                        variant === EProductCardVariants$1.COMPACT ||
                        variant === EProductCardVariants$1.LIST
                        ? QuantityOptionPDP$1
                        : QuantityOption$1));
                }))))));
};
var formatPriceForScalablePrducts$1 = function (price) {
    return price < 1 ? price * 1000 + 'g' : price + 'kg';
};

var useProductCard$1 = function (productId) {
    var productCardSelector = function (state) { return state.productCard; };
    var selectProductCard = createSelector(productCardSelector, function (productCard) { return productCard; });
    var makeSelectProductCardState = function () {
        return createSelector(selectProductCard, function (_, productId) { return productId; }, function (state, productId) {
            var product = state[productId];
            if (product) {
                return {
                    error: product.error,
                    errDetail: product.errDetail,
                    loading: product.loading,
                };
            }
            else {
                return {
                    error: false,
                    errDetail: '',
                    loading: false,
                };
            }
        });
    };
    var selectProductCardState = useMemo(makeSelectProductCardState, []);
    var productCardState = useSelector(function (state) { return selectProductCardState(state, productId); });
    return productCardState;
};

var hasReachedQtyMinLimit$1 = function (qty, min) { return qty <= min; };
var hasReachedQtyMaxLimit$1 = function (qty, max) { return qty >= max; };
var isQtyOnlyOne$1 = function (min, max) { return min === max; };

var getDecreaseButtonProps$1 = function (_a) {
    var quantity = _a.quantity, min = _a.min, onDecrementHandler = _a.onDecrementHandler, onRemoveHandler = _a.onRemoveHandler, soldByWeight = _a.soldByWeight, variant = _a.variant, setQuantitySelector = _a.setQuantitySelector, isNewCarrefourJourney = _a.isNewCarrefourJourney;
    var defaultDecreaseButtonProps = {
        children: variant === EProductCardVariants$1.PDP
            ? '-'
            : createElement(MinusAlt, {
                size: 'S',
                fill: variant === EProductCardVariants$1.REGULAR_WIDE ? COLORS$1.BLUE : COLORS$1.WHITE,
            }),
        onClick: onDecrementHandler,
    };
    var isDelete = hasReachedQtyMinLimit$1(quantity, parseFloat(formatQuantityKG$1(min, soldByWeight)));
    var DeleteIconProps = {
        size: 'S',
        fill: variant === EProductCardVariants$1.REGULAR_WIDE ? COLORS$1.BLUE : COLORS$1.WHITE,
    };
    quantity === 0 && setQuantitySelector(false);
    var checkIsNewCarrefour = function (condition) { return (condition ? Minus : Trash); };
    return __assign(__assign({}, defaultDecreaseButtonProps), (isDelete
        ? {
            children: createElement(variant === EProductCardVariants$1.FBT
                ? TrashAlt
                : quantity > 1
                    ? Minus
                    : checkIsNewCarrefour(isNewCarrefourJourney), DeleteIconProps),
            onClick: onRemoveHandler,
        }
        : {}));
};

var QuantitySelectorWrapper$3 = CustomStyled$1(Box)(templateObject_1$1G || (templateObject_1$1G = __makeTemplateObject(["\n    ", "\n"], ["\n    ",
    "\n"])), function (props) {
    return variant({
        variants: {
            pdp: {
                display: props.isBuyNow ? 'none' : '',
                position: 'static',
                margin: props.inCart ? '0' : '0 0 0 0',
                flex: props.inCart ? 1 : 'none',
                height: 37,
                width: props.inCart ? [100, 157] : props.isSticky ? '33%' : [100, 51],
            },
        },
    });
});
var CartButtonWrapper$1 = CustomStyled$1(Box)(templateObject_2$1m || (templateObject_2$1m = __makeTemplateObject(["\n      ", "\n         button {\n           ", "\n           }\n"], ["\n      ",
    "\n         button {\n           ",
    "\n           }\n"])), function (props) {
    return variant({
        variants: {
            pdp: {
                maxWidth: props.isBuyNow ? '100%' : ['100%', '262px'],
                width: '64%',
                height: 37,
                lineHeight: '37px',
            },
        },
    });
}, function (props) {
    return variant({
        variants: {
            pdp: {
                width: '100%',
                height: '100%',
                cursor: 'pointer',
                backgroundColor: props.theme.colors.blue,
                borderRadius: props.theme.radii[1],
                fontSize: [16, 16, 16, 16, 14],
                fontWeight: props.theme.fontWeights[6],
                lineHeight: '37px',
                padding: '0px 10px',
                '&:hover': {
                    backgroundColor: props.theme.colors.blue,
                },
            },
            regular: {
                backgroundColor: props.theme.colors.blue,
            },
        },
    });
});
var CartActionsWrapper$1 = CustomStyled$1(Flex)(templateObject_3$16 || (templateObject_3$16 = __makeTemplateObject(["\n  flex-grow: 1;\n  justify-content: space-between;\n  border-radius: 18px;\n  color: ", ";\n  ", "\n  button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ", "\n}\n     button[data-testid=\"btn-decrement\"]{\n      ", "\n             ", "\n      }\n      \n      button[data-testid=\"btn-increment\"]{\n        ", "\n        ", "\n      }\n\n"], ["\n  flex-grow: 1;\n  justify-content: space-between;\n  border-radius: 18px;\n  color: ", ";\n  ",
    "\n  button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ",
    "\n}\n     button[data-testid=\"btn-decrement\"]{\n      ",
    "\n             ",
    "\n      }\n      \n      button[data-testid=\"btn-increment\"]{\n        ",
    "\n        ",
    "\n      }\n\n"])), function (props) { return props.theme.colors.white; }, function (props) {
    return variant({
        variants: {
            regular: {
                backgroundColor: props.theme.colors.blue,
            },
        },
    });
}, function (props) {
    return variant({
        variants: {
            fbt: {
                backgroundColor: props.theme.colors.blue,
                svg: {
                    height: '16px',
                    width: '14px',
                    fill: props.isMin ? props.theme.colors.white : props.theme.colors.blue,
                },
                ':disabled': {
                    opacity: 0.5,
                },
                ':first-of-type': {
                    backgroundColor: props.isMin ? 'rgba(14, 90, 167, 0.3)' : props.theme.colors.blue,
                },
            },
            pdp: {
                backgroundColor: props.theme.colors.blue,
                borderRadius: props.theme.radii[1],
                lineHeight: '26px',
                '&:hover': {
                    backgroundColor: props.theme.colors.blue,
                },
            },
            regular: {
                lineHeight: '26px',
                '&:hover': {
                    backgroundColor: props.theme.colors.blue,
                },
            },
            regular_wide: {
                lineHeight: '26px',
            },
            mini: {
                borderRadius: props.theme.radii[1],
                lineHeight: '26px',
                '&:hover': {
                    backgroundColor: props.theme.colors.blue,
                },
            },
        },
    });
}, function (props) {
    return props.disabled &&
        "\n        background-color: transparent !important;\n        opacity: 0.5;\n      ";
}, function (props) {
    return variant({
        variants: {
            pdp: {
                backgroundColor: props.theme.colors.blue,
            },
            regular: { color: COLORS$1.BODY, borderRadius: '18px' },
            regular_wide: {
                color: COLORS$1.BODY,
                borderRadius: '18px',
                backgroundColor: props.theme.colors.alabaster + " !important",
            },
        },
    });
}, function (props) {
    return props.disabled &&
        "\n          background-color: transparent !important;\n          opacity: 0.5;\n        ";
}, function (props) {
    return variant({
        variants: {
            pdp: {
                color: props.theme.colors.alabaster,
            },
            regular: {
                color: props.theme.colors.alabaster,
                borderRadius: '18px',
                '&:hover': {
                    background: 'rgb(14, 90, 167) !important',
                },
            },
            regular_wide: {
                color: props.theme.colors.alabaster,
                borderRadius: '18px',
                backgroundColor: props.theme.colors.alabaster + " !important",
            },
        },
    });
});
var DisclaimerButtonWrapper$1 = CustomStyled$1(Flex)(templateObject_4$Y || (templateObject_4$Y = __makeTemplateObject(["\nflex-direction: column;\njustify-content: space-between"], ["\nflex-direction: column;\njustify-content: space-between"])));
var CancelText$1 = CustomStyled$1(Box)(templateObject_5$K || (templateObject_5$K = __makeTemplateObject(["\nfont-size: 14px;\nfont-weight: bold;\npadding: 16px 24px;\ntext-transform: uppercase;\ntext-align: center;\n"], ["\nfont-size: 14px;\nfont-weight: bold;\npadding: 16px 24px;\ntext-transform: uppercase;\ntext-align: center;\n"])));
var MessageText$1 = CustomStyled$1(Box)(templateObject_6$A || (templateObject_6$A = __makeTemplateObject(["\npadding-top: 16px;\npadding-bottom: 16px;"], ["\npadding-top: 16px;\npadding-bottom: 16px;"])));
var Title$8 = CustomStyled$1(Box)(templateObject_7$y || (templateObject_7$y = __makeTemplateObject(["\nfont-size: 20px;\nfont-weight: bold"], ["\nfont-size: 20px;\nfont-weight: bold"])));
var ModalContainer$1 = CustomStyled$1(Box)(templateObject_8$y || (templateObject_8$y = __makeTemplateObject(["\ntext-align: center;"], ["\ntext-align: center;"])));
var CloseButtonWrapper$1 = CustomStyled$1(Flex)(templateObject_9$v || (templateObject_9$v = __makeTemplateObject(["\nfloat: right;"], ["\nfloat: right;"])));
var ModalContainet$1 = CustomStyled$1(Box)(templateObject_10$u || (templateObject_10$u = __makeTemplateObject(["\npadding-top: 16px;\nmargin: auto;"], ["\npadding-top: 16px;\nmargin: auto;"])));
ModalContainet$1.defaultProps = {
    width: ['70%', '50%', '50%'],
};
var NotifyButton$1 = CustomStyled$1(Button$1)(templateObject_11$o || (templateObject_11$o = __makeTemplateObject(["\n  height: 30px;\n  width: 48px;\n  padding: 0px;\n  border-color: ", ";\n  &:hover {\n    border-color: ", ";\n  }\n"], ["\n  height: 30px;\n  width: 48px;\n  padding: 0px;\n  border-color: ", ";\n  &:hover {\n    border-color: ", ";\n  }\n"])), function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.colors.blue; });
var ViewSimilarButton$1 = CustomStyled$1(Button$1)(templateObject_12$m || (templateObject_12$m = __makeTemplateObject(["\n  flex: 1;\n  height: 30px;\n  padding: 0px;\n  margin-left: 8px;\n  font-size: 12px;\n"], ["\n  flex: 1;\n  height: 30px;\n  padding: 0px;\n  margin-left: 8px;\n  font-size: 12px;\n"])));
var CartButton$1 = CustomStyled$1(Button$1)(templateObject_13$l || (templateObject_13$l = __makeTemplateObject(["\n  height: 36px;\n  width: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: ", "px;\n  background-color: ", ";\n  ", "\n  ", "\n\n  ", "\n  ", "\n"], ["\n  height: 36px;\n  width: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: ", "px;\n  background-color: ", ";\n  ",
    "\n  ",
    "\n\n  ",
    "\n  ",
    "\n"])), function (props) { return props.theme.radii[2]; }, function (props) { return props.theme.colors.blue; }, function (props) {
    return props.isMobile &&
        "\n    background-color: " + props.theme.colors.blue + " !important;\n  ";
}, function (props) {
    return props.disabled &&
        "\n    background-color: " + props.theme.colors.mercury + " !important;\n    opacity: 0.5;\n  ";
}, function (props) {
    return props.disabled &&
        props.cardVariant === 'regular' &&
        "\n     background-color: " + props.theme.colors.blue + " !important;\n     opacity: 0.5;\n  ";
}, function () {
    return variant({
        prop: 'cardVariant',
        variants: {
            regular: {
                height: '32px',
                width: '32px',
                borderRadius: '50%',
                backgroundColor: COLORS$1.ANCHOR_BLUE + " !important",
                '&:hover': {
                    backgroundColor: COLORS$1.ANCHOR_BLUE,
                },
            },
            regular_wide: {
                height: '32px',
                width: '32px',
                borderRadius: '50%',
            },
            list: {
                size: '23px',
                fontSize: '10px',
            },
            mini: {
                size: '23px',
                fontSize: '10px',
            },
            compact: {
                size: '23px',
            },
            pdp: {
                size: '37px',
                fontSize: '35px',
            },
            simple: {
                height: '24px',
                width: '24px',
            },
        },
    });
});
CartButton$1.defaultProps = {
    p: 0,
};
var MaxLimitContainer$1 = CustomStyled$1(Box)(templateObject_14$l || (templateObject_14$l = __makeTemplateObject(["\n  background-color: #FEF2F2;\n  margin-bottom: 10px;\n  padding-left: 13px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: 12px;\n  color: #EE2527;\n  line-height: 14px;\n\n  ", "\n"], ["\n  background-color: #FEF2F2;\n  margin-bottom: 10px;\n  padding-left: 13px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: 12px;\n  color: #EE2527;\n  line-height: 14px;\n\n  ",
    "\n"])), variant({
    variants: {
        compact: {
            marginBottom: '3px',
            fontSize: '9px',
        },
        list: {
            display: 'inline-flex',
            padding: '5px',
            marginTop: '8px',
            marginBottom: 0,
        },
    },
}));
var MaxLimitContainerNew$1 = CustomStyled$1(Box)(templateObject_15$l || (templateObject_15$l = __makeTemplateObject(["\n  background-color: ", ";\n  margin: 0 auto 10px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: ", "px;\n  color: ", ";\n  line-height: 14px;\n  width: 103px;\n  border-radius: 50px;\n  font-weight: ", ";\n\n  ", "\n"], ["\n  background-color: ", ";\n  margin: 0 auto 10px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: ", "px;\n  color: ", ";\n  line-height: 14px;\n  width: 103px;\n  border-radius: 50px;\n  font-weight: ", ";\n\n  ",
    "\n"])), function (props) { return props.theme.colors.peach; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.colors.darkRed; }, function (props) { return props.theme.fontWeights[6]; }, variant({
    variants: {
        compact: {
            marginBottom: '3px',
            fontSize: '9px',
        },
        list: {
            display: 'inline-flex',
            padding: '5px',
            marginTop: '8px',
            marginBottom: 0,
        },
    },
}));
var templateObject_1$1G, templateObject_2$1m, templateObject_3$16, templateObject_4$Y, templateObject_5$K, templateObject_6$A, templateObject_7$y, templateObject_8$y, templateObject_9$v, templateObject_10$u, templateObject_11$o, templateObject_12$m, templateObject_13$l, templateObject_14$l, templateObject_15$l;

var CartElements$1 = function (props) {
    var t = useTranslation().t;
    var _a = props.disabled, disabled = _a === void 0 ? false : _a, max = props.max, min = props.min, inCart = props.inCart, incrementBy = props.incrementBy, isOpen = props.isOpen, isLoading = props.isLoading, onAddHandler = props.onAddHandler, onDecrementHandler = props.onDecrementHandler, onIncrementHandler = props.onIncrementHandler, onRemoveHandler = props.onRemoveHandler, onSelectHandler = props.onSelectHandler, productCardVariant = props.productCardVariant, _b = props.quantity, quantity = _b === void 0 ? 1 : _b, selectOnChange = props.selectOnChange, _c = props.soldByWeight, soldByWeight = _c === void 0 ? false : _c, _d = props.variant, variant = _d === void 0 ? EProductCardVariants$1.PLP : _d, onlineName = props.onlineName, productImage = props.productImage, _e = props.isSticky, isSticky = _e === void 0 ? false : _e, _f = props.isBuyNow, isBuyNow = _f === void 0 ? false : _f, price = props.price, currency = props.currency, showAgeDisclaimer = props.showAgeDisclaimer, productId = props.productId, isNewCarrefourJourney = props.isNewCarrefourJourney, dir = props.dir;
    var isMobile = useBreakpoints().isMobile;
    var _g = __read(useAppConfig$1(), 1), _h = _g[0], currencyDecimal = _h.currencyDecimal, pageName = _h.pageName;
    var quantityList = useMemo(function () {
        var currencyDecimalValue = variant === EProductCardVariants$1.PDP ? currencyDecimal : undefined;
        return generateQuantityList$1({
            incrementBy: incrementBy,
            soldByWeight: soldByWeight,
            max: max,
            min: min,
            price: price,
            currencyDecimal: currencyDecimalValue,
        });
    }, [incrementBy, max, min, soldByWeight, price, currencyDecimal, variant]);
    var _j = __read(useState(variant === EProductCardVariants$1.PDP), 2), showQuantitySelector = _j[0], setQuantitySelector = _j[1];
    var _k = useMemo(function () {
        return getDecreaseButtonProps$1({
            quantity: quantity,
            min: min,
            onDecrementHandler: onDecrementHandler,
            onRemoveHandler: onRemoveHandler,
            soldByWeight: soldByWeight,
            variant: variant,
            setQuantitySelector: setQuantitySelector,
            isNewCarrefourJourney: isNewCarrefourJourney,
        });
    }, [quantity, min, onDecrementHandler, onRemoveHandler, soldByWeight, variant, isNewCarrefourJourney]), children = _k.children, restDecreaseProps = __rest(_k, ["children"]);
    var productsData = useSelector(function (state) { return state.productList; });
    var isExpandQtySelector = productsData.expandedQtySelectorProductId == productId ? true : false;
    var _l = __read(useState(false), 2), popUp = _l[0], setPopUp = _l[1];
    var _m = __read(useState(isExpandQtySelector), 2), expandQtySelector = _m[0], setExpandQtySelector = _m[1];
    useEffect(function () {
        setExpandQtySelector(isExpandQtySelector);
    }, [isExpandQtySelector]);
    var onAddDisclaimerEnabled = function () {
        if (!showQuantitySelector) {
            setQuantitySelector(true);
        }
        if (showAgeDisclaimer) {
            setPopUp(true);
        }
        else {
            onAddHandler && onAddHandler();
            setExpandQtySelector(true);
        }
    };
    var onSelectDisclaimerHandler = function (option) {
        if (showAgeDisclaimer) {
            setPopUp(true);
        }
        else {
            selectOnChange && selectOnChange(option);
        }
    };
    var hideDisclaimerPopup = function () {
        setPopUp(false);
    };
    var addToCartHandler = function () {
        onAddHandler && onAddHandler();
        if (popUp) {
            setPopUp(false);
        }
    };
    var Display = variant === EProductCardVariants$1.PDP || !inCart ? Flex : Box;
    var isReachedQtyMaxLimit = hasReachedQtyMaxLimit$1(quantity, max);
    return (React.createElement(Display, { sx: { position: "" + (variant === EProductCardVariants$1.PDP ? 'relative' : 'auto') }, justifyContent: "space-between", alignItems: "center", h: "32px", w: 1, "data-testid": "product_qnty_dropdown" },
        isReachedQtyMaxLimit &&
            variant !== EProductCardVariants$1.PDP &&
            variant !== EProductCardVariants$1.LIST &&
            (isNewCarrefourJourney ? (React.createElement(MaxLimitContainerNew$1, { expandQtySelector: expandQtySelector, variant: variant },
                React.createElement("div", null, t('productCard.maxLimitC4Journey')))) : (React.createElement(MaxLimitContainer$1, { variant: variant },
                React.createElement("div", null, t('productCard.maxLimit'))))),
        React.createElement(React.Fragment, null,
            !inCart && (React.createElement(React.Fragment, null,
                React.createElement(QuantitySelectorWrapper$3, { flexGrow: 1, variant: variant, isSticky: isSticky, isBuyNow: isBuyNow }, (variant === EProductCardVariants$1.PDP || showQuantitySelector) && !isLoading && (React.createElement(QuantitySelector$1, { isLoading: isLoading || disabled, inCart: inCart, isOpen: isOpen, onSelectHandler: onSelectHandler, options: quantityList, productCardVariant: productCardVariant, selectOnChange: onSelectDisclaimerHandler, soldByWeight: soldByWeight, variant: variant, onlineName: onlineName, productImage: productImage, isSticky: isSticky, isBuyNow: isBuyNow, currency: currency, expandQtySelector: expandQtySelector }))),
                React.createElement(CartButtonWrapper$1, { variant: variant, isBuyNow: isBuyNow }, variant === EProductCardVariants$1.PDP ? (React.createElement(Button$1, { height: "100%", minWidth: 63.61, fontSize: 2, paddingY: 1, paddingX: 3, className: pageName + "_add_to_cart", onClick: onAddDisclaimerEnabled, "data-testid": "add_to_cart_button", disabled: isLoading || disabled }, variant === EProductCardVariants$1.PDP && (isSticky || !isMobile) ? t('addToCart') : t('add'))) : (React.createElement(CartButton$1, { onClick: onAddDisclaimerEnabled, "data-testid": "add_to_cart_button", disabled: isLoading || disabled, className: pageName + "_add_to_cart", cardVariant: variant === EProductCardVariants$1.REGULAR_WIDE ? EProductCardVariants$1.REGULAR : variant, isMobile: isMobile },
                    React.createElement(Plus, { stroke: COLORS$1.WHITE })))),
                popUp && (React.createElement(Modal, { isOpen: true, width: [1, null, '500px'], height: ['auto'], variant: isMobile ? 'bottomStickyMobile' : 'bottomSticky' },
                    React.createElement(ModalContainer$1, null,
                        React.createElement(CloseButtonWrapper$1, null,
                            React.createElement(Button$1, { variant: "naked", "aria-label": "Close", onClick: hideDisclaimerPopup },
                                React.createElement(Cross, { size: "M" }))),
                        React.createElement(ModalContainet$1, null,
                            React.createElement(Title$8, null, t('disclaimer.disclaimerTitle')),
                            React.createElement(MessageText$1, null, t('disclaimer.disclaimerMessage')),
                            React.createElement(DisclaimerButtonWrapper$1, null,
                                React.createElement(Button$1, { variant: "secondary", fontWeight: "bold", onClick: addToCartHandler }, t('disclaimer.aboveAgeText')),
                                React.createElement(CancelText$1, { onClick: hideDisclaimerPopup }, t('disclaimer.belowAgeText'))))))))),
            inCart &&
                (!isNewCarrefourJourney || expandQtySelector || variant === EProductCardVariants$1.REGULAR_WIDE ? (React.createElement(CartActionsWrapper$1, { variant: variant, isMin: quantity === min },
                    React.createElement(CartButton$1, __assign({}, restDecreaseProps, { "data-testid": "btn-decrement", disabled: (disabled && !isLoading) || isLoading, className: quantity === min ? pageName + "_remove_from_cart" : '', round: variant === EProductCardVariants$1.PDP ? true : false, cardVariant: variant, isMobile: isMobile }), children),
                    React.createElement(QuantitySelectorWrapper$3, { variant: variant, inCart: inCart },
                        React.createElement(QuantitySelector$1, { inCart: inCart, isLoading: isLoading || disabled, isOpen: isOpen, onSelectHandler: onSelectHandler, options: quantityList, productCardVariant: productCardVariant, selectOnChange: selectOnChange, selectedValue: quantity, soldByWeight: soldByWeight, variant: variant, onlineName: onlineName, productImage: productImage, isSticky: isSticky, currency: currency, isNewCarrefourJourney: isNewCarrefourJourney, expandQtySelector: variant === EProductCardVariants$1.REGULAR_WIDE ? true : expandQtySelector })),
                    React.createElement(CartButton$1, { onClick: onIncrementHandler, disabled: isReachedQtyMaxLimit || isQtyOnlyOne$1(min, max) || disabled || isLoading, "data-testid": "btn-increment", cardVariant: variant, className: pageName + "_add_to_cart", variant: "primary", isMobile: isMobile }, variant === EProductCardVariants$1.PDP || variant === EProductCardVariants$1.SIMPLE ? ('+') : (React.createElement(Plus, { stroke: variant === EProductCardVariants$1.REGULAR_WIDE ? COLORS$1.ANCHOR_BLUE : COLORS$1.WHITE }))))) : (React.createElement(QuantitySelector$1, { inCart: inCart, isLoading: isLoading || disabled, isOpen: isOpen, onSelectHandler: onSelectHandler, options: quantityList, productCardVariant: productCardVariant, selectOnChange: selectOnChange, selectedValue: quantity, soldByWeight: soldByWeight, variant: variant, onlineName: onlineName, productImage: productImage, isSticky: isSticky, currency: currency, isNewCarrefourJourney: isNewCarrefourJourney, expandQtySelector: variant === EProductCardVariants$1.REGULAR_WIDE ? true : expandQtySelector, dir: dir, productId: productId }))))));
};

var OutOfStockOptions$1 = function (_a) {
    var onNotificationHandler = _a.onNotificationHandler, onViewSimilarHandler = _a.onViewSimilarHandler;
    var t = useTranslation().t;
    return (React.createElement(CartActionsWrapper$1, null,
        React.createElement(NotifyButton$1, { variant: "outlined", onClick: onNotificationHandler },
            React.createElement(Bell, { fill: COLORS$1.RED })),
        React.createElement(ViewSimilarButton$1, { onClick: onViewSimilarHandler }, t('viewSimilar'))));
};

var useProductCardHandlers$1 = function (props, isV4Basket) {
    var _a, _b, _c, _d, _e;
    if (isV4Basket === void 0) { isV4Basket = false; }
    var dispatch = useDispatch();
    var incrementBy = props.incrementBy, max = props.max, min = props.min, productId = props.productId, position = props.position, _f = props.quantity, quantity = _f === void 0 ? 0 : _f, unitOfMeasure = props.unitOfMeasure, _g = props.withRelevantProducts, withRelevantProducts = _g === void 0 ? false : _g, _h = props.isMarketPlace, isMarketPlace = _h === void 0 ? false : _h, _j = props.offers, offers = _j === void 0 ? [] : _j, _k = props.serviceProductCode, serviceProductCode = _k === void 0 ? '' : _k, onSuccessCb = props.onSuccessCb, onFailureCb = props.onFailureCb, intent = props.intent, _l = props.rowIndex, rowIndex = _l === void 0 ? 0 : _l, _m = props.isSponsored, isSponsored = _m === void 0 ? false : _m, soldByWeight = props.soldByWeight, _o = props.minBuyingValue, minBuyValue = _o === void 0 ? '' : _o, _p = props.priceDetails, priceDetails = _p === void 0 ? {} : _p, _q = props.originalPrice, originalPrice = _q === void 0 ? 0 : _q, _r = props.discount, productDiscount = _r === void 0 ? {} : _r, currency = props.currency, isSponsoredListing = props.isSponsoredListing, _s = props.isCart, isCart = _s === void 0 ? false : _s, sid = props.sid;
    var appConfig = useSelector(function (state) { return ({
        appConfig: state.appConfig,
        pageStructure: state.pageStructure,
    }); }).appConfig;
    var pisValue = (_b = (_a = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _a === void 0 ? void 0 : _a.purchaseIndicators) === null || _b === void 0 ? void 0 : _b.SHIPPING;
    var shippingIndicator = sid || ((_c = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _c === void 0 ? void 0 : _c.shippingIndicator) || '';
    var basketV4Attributes = {
        pis: pisValue || [],
        shopId: (_d = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _d === void 0 ? void 0 : _d.shopId,
        shopName: (_e = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _e === void 0 ? void 0 : _e.shop,
        isSoldByWeight: soldByWeight,
        isV4Basket: isV4Basket,
    };
    var _t = useBreakpoints(), isDesktop = _t.isDesktop, isMobile = _t.isMobile;
    var _u = __read(useMemo(function () {
        var incValue = quantity + incrementBy;
        var decValue = quantity - incrementBy;
        if (incValue > max) {
            incValue = max;
        }
        if (quantity && quantity >= max) {
            var quantityOptionList = generateQuantityList$1({
                incrementBy: incrementBy,
                soldByWeight: unitOfMeasure === KG_LABEL$1,
                max: max,
                min: min,
            });
            if (quantityOptionList.length > 1) {
                decValue = quantityOptionList[quantityOptionList.length - 2].value;
            }
        }
        var inc = parseFloat(setDecimalPoint$1(incValue));
        var dec = parseFloat(setDecimalPoint$1(decValue));
        return [inc, dec];
    }, [incrementBy, quantity, max, min, unitOfMeasure]), 2), increment = _u[0], decrement = _u[1];
    var sortBy = useSelector(function (state) {
        var _a, _b;
        return {
            sortBy: (_b = (_a = state === null || state === void 0 ? void 0 : state.search) === null || _a === void 0 ? void 0 : _a.query) === null || _b === void 0 ? void 0 : _b.sortBy,
        };
    }).sortBy;
    var _v = useAnalytic$1(), GTMEventCall = _v.GTMEventCall, EventCall = _v.EventCall, BrazeEventCall = _v.BrazeEventCall, BrazeSetCustomUserAttribute = _v.BrazeSetCustomUserAttribute;
    var gtmCallBack = useCallback(function (selectedQuantity, eventType) {
        var deltaQtyInUnit = convertDeltaQtyInoUnit$1(selectedQuantity, quantity, incrementBy);
        var gtmCommonData = getCommonGtmData$1({
            selectedQuantity: selectedQuantity,
            quantity: quantity,
            incrementBy: incrementBy,
            min: min,
            minBuyValue: minBuyValue,
            priceDetails: priceDetails,
            originalPrice: originalPrice,
            soldByWeight: soldByWeight,
            productDiscount: productDiscount,
        });
        switch (eventType) {
            case eventTypeEnum$1.add_to_cart:
                GTMEventCall(GTMEvents$1.add_to_cart, __assign(__assign({ product: props, position: position }, gtmCommonData), { ga4: false }));
                GTMEventCall(GTMEvents$1.add_to_cart, __assign(__assign({ product: props, position: position }, gtmCommonData), { ga4: true, currency: currency, countryCode: appConfig === null || appConfig === void 0 ? void 0 : appConfig.code }));
                EventCall(GTMEvents$1.add_to_cart, __assign(__assign({}, props), { quantity: selectedQuantity }));
                if (isSponsored)
                    EventCall(GTMEvents$1.change_the_quantity, __assign(__assign({}, props), { quantity: deltaQtyInUnit }));
                break;
            case eventTypeEnum$1.change_the_quantity:
                if (deltaQtyInUnit > 0) {
                    GTMEventCall(GTMEvents$1.add_to_cart, __assign(__assign({ product: props, position: position }, gtmCommonData), { ga4: true, currency: currency, countryCode: appConfig === null || appConfig === void 0 ? void 0 : appConfig.code }));
                }
                else {
                    GTMEventCall(GTMEvents$1.remove_from_cart, __assign(__assign({ product: props, position: position }, gtmCommonData), { ga4: true, currency: currency, countryCode: appConfig === null || appConfig === void 0 ? void 0 : appConfig.code }));
                }
                EventCall(GTMEvents$1.change_the_quantity, __assign(__assign({}, props), { quantity: deltaQtyInUnit }));
                break;
            case eventTypeEnum$1.remove_from_cart:
                GTMEventCall(GTMEvents$1.remove_from_cart, { product: props, position: position, ga4: false });
                GTMEventCall(GTMEvents$1.remove_from_cart, __assign(__assign({ product: props, position: position }, gtmCommonData), { ga4: true, currency: currency, countryCode: appConfig === null || appConfig === void 0 ? void 0 : appConfig.code }));
                EventCall(GTMEvents$1.change_the_quantity, __assign(__assign({}, props), { quantity: convertDeltaQtyInoUnit$1(selectedQuantity, quantity, incrementBy) }));
                break;
        }
    }, [
        GTMEventCall,
        currency,
        EventCall,
        position,
        props,
        appConfig,
        incrementBy,
        quantity,
        isSponsored,
        min,
        minBuyValue,
        priceDetails,
        soldByWeight,
        originalPrice,
        productDiscount,
    ]);
    var brazeCB = useCallback(function (totalUnitCount) {
        var _a;
        if (totalUnitCount === 0)
            BrazeSetCustomUserAttribute((_a = {}, _a[BrazeEvents$1.cart_count] = false, _a));
    }, [BrazeSetCustomUserAttribute]);
    var brazeAddToCartCB = useCallback(function (totalUnitCount) {
        var _a;
        var _b;
        if (!((_b = appConfig === null || appConfig === void 0 ? void 0 : appConfig.userCredentials) === null || _b === void 0 ? void 0 : _b.userId) && !(appConfig === null || appConfig === void 0 ? void 0 : appConfig.brazeInitialized)) {
            var storage = initStorageManager$1(function () { return localStorage; });
            var data = storage.getItem('initBrazeAnonymousUserWithData') || [];
            data.push(props);
            storage.setItem('initBrazeAnonymousUserWithData', data);
        }
        else {
            BrazeEventCall(BrazeEvents$1.add_to_cart, props);
            if (totalUnitCount === 1)
                BrazeSetCustomUserAttribute((_a = {}, _a[BrazeEvents$1.cart_count] = true, _a));
        }
    }, [BrazeEventCall, BrazeSetCustomUserAttribute, props, appConfig]);
    var offerId = useMemo(function () {
        return isMarketPlace && offers.length > 0 ? offers[0].id : undefined;
    }, [isMarketPlace, offers]);
    var onAddHandler = useCallback(function () {
        var _a;
        var convertedMin = parseFloat(formatQuantityKG$1(min, unitOfMeasure === KG_LABEL$1));
        var productId = props.productId, _b = props.position, position = _b === void 0 ? 0 : _b;
        var productPosition = getProductPosition$1(rowIndex, position, isDesktop, isMobile);
        var hasCart = window.location.href.indexOf('/cart') !== -1;
        var _c = getGa4AlgoliaEventsParams$1(), experimentKey = _c.experimentKey, variationId = _c.variationId;
        var _d = appConfig.language, language = _d === void 0 ? '' : _d, _e = appConfig.currency, currency = _e === void 0 ? '' : _e;
        if (variationId && experimentKey) {
            GTMEventCall(GTMEvents$1.algolia_custom_events, {
                experiment_key: experimentKey,
                variation_id: variationId,
                pageData: { language: language, currency: currency },
            });
        }
        dispatch(addToCart$1(productId, convertedMin, __assign({ isMarketPlace: isMarketPlace,
            withRelevantProducts: withRelevantProducts,
            gtmCallBack: gtmCallBack,
            onSuccessCb: onSuccessCb,
            onFailureCb: onFailureCb,
            offerId: offerId,
            serviceProductCode: serviceProductCode, productName: props.name, brazeAddToCartCB: brazeAddToCartCB, isCartRequired: hasCart ? true : false, productImageURL: (_a = props === null || props === void 0 ? void 0 : props.image) === null || _a === void 0 ? void 0 : _a.href, intent: intent,
            incrementBy: incrementBy,
            isSponsored: isSponsored, applicablePrice: props.applicablePrice, shippingIndicator: shippingIndicator }, basketV4Attributes), function () {
            return;
        }, productPosition, sortBy));
    }, [
        min,
        unitOfMeasure,
        props,
        rowIndex,
        isDesktop,
        isMobile,
        appConfig,
        dispatch,
        isMarketPlace,
        withRelevantProducts,
        gtmCallBack,
        onSuccessCb,
        onFailureCb,
        offerId,
        serviceProductCode,
        brazeAddToCartCB,
        intent,
        incrementBy,
        isSponsored,
        shippingIndicator,
        basketV4Attributes,
        sortBy,
        GTMEventCall,
    ]);
    var isAdtechCartCarousel = isSponsoredListing && isCart;
    var onDecrementHandler = useCallback(function () {
        var _a;
        if (quantity > min) {
            dispatch(updateCart$1(productId, decrement, __assign({ isCartRequired: isAdtechCartCarousel, onSuccessCb: onSuccessCb,
                intent: intent,
                offerId: offerId,
                gtmCallBack: gtmCallBack,
                incrementBy: incrementBy, currentQuantity: quantity, productName: props.name, productImageURL: (_a = props === null || props === void 0 ? void 0 : props.image) === null || _a === void 0 ? void 0 : _a.href, shippingIndicator: shippingIndicator }, basketV4Attributes)));
            GTMEventCall(GTMEvents$1.add_to_cart, { quantity: decrement });
        }
    }, [
        quantity,
        min,
        dispatch,
        productId,
        decrement,
        isAdtechCartCarousel,
        onSuccessCb,
        intent,
        offerId,
        gtmCallBack,
        incrementBy,
        props,
        shippingIndicator,
        basketV4Attributes,
        GTMEventCall,
    ]);
    var onIncrementHandler = useCallback(function () {
        var _a;
        if (quantity < max) {
            dispatch(updateCart$1(productId, increment, __assign({ isCartRequired: isAdtechCartCarousel, intent: intent,
                offerId: offerId,
                gtmCallBack: gtmCallBack,
                incrementBy: incrementBy, currentQuantity: quantity, shippingIndicator: shippingIndicator, productName: props.name, productImageURL: (_a = props === null || props === void 0 ? void 0 : props.image) === null || _a === void 0 ? void 0 : _a.href, onSuccessCb: onSuccessCb }, basketV4Attributes)));
        }
    }, [
        quantity,
        max,
        dispatch,
        productId,
        increment,
        isAdtechCartCarousel,
        intent,
        offerId,
        gtmCallBack,
        incrementBy,
        shippingIndicator,
        props,
        onSuccessCb,
        basketV4Attributes,
    ]);
    var onRemoveHandler = useCallback(function () {
        dispatch(removeFromCart$1(productId, {
            brazeCB: brazeCB,
            gtmCallBack: gtmCallBack,
            offerId: offerId,
            intent: intent,
            incrementBy: incrementBy,
            currentQuantity: quantity,
            shippingIndicator: shippingIndicator,
            isCartRequired: isAdtechCartCarousel,
            onSuccessCb: onSuccessCb,
        }));
    }, [
        dispatch,
        productId,
        brazeCB,
        gtmCallBack,
        offerId,
        intent,
        incrementBy,
        quantity,
        shippingIndicator,
        isAdtechCartCarousel,
        onSuccessCb,
    ]);
    return [onAddHandler, onDecrementHandler, onIncrementHandler, onRemoveHandler];
};

var ECartNotificationType$1;
(function (ECartNotificationType) {
    ECartNotificationType["ERROR"] = "ERROR";
    ECartNotificationType["OUT_OF_STOCK"] = "OUT_OF_STOCK";
    ECartNotificationType["SUCCESS"] = "SUCCESS";
    ECartNotificationType["NULL"] = "";
})(ECartNotificationType$1 || (ECartNotificationType$1 = {}));
var ECartAPINotification$1;
(function (ECartAPINotification) {
    ECartAPINotification["OUT_OF_STOCK"] = "noStock";
})(ECartAPINotification$1 || (ECartAPINotification$1 = {}));

var CartNotificationWrapper$1 = CustomStyled$1(Flex)(templateObject_1$1H || (templateObject_1$1H = __makeTemplateObject(["\n    align-items: center;\n    background-color: ", ";\n    bottom: 0;\n    color: ", ";\n    flex-direction: column;\n    font-size: ", "px;\n    justify-content: center;\n    line-height: normal;\n    min-height: 45px;\n    opacity: ", ";\n    padding: ", "px;\n    position: absolute;\n    text-align: center;\n    text-transform: ", ";\n    width: 100%;\n    z-index: 2;\n"], ["\n    align-items: center;\n    background-color: ",
    ";\n    bottom: 0;\n    color: ", ";\n    flex-direction: column;\n    font-size: ", "px;\n    justify-content: center;\n    line-height: normal;\n    min-height: 45px;\n    opacity: ", ";\n    padding: ", "px;\n    position: absolute;\n    text-align: center;\n    text-transform: ", ";\n    width: 100%;\n    z-index: 2;\n"])), function (props) {
    switch (props.type) {
        case ECartNotificationType$1.SUCCESS:
            return props.theme.colors.persiangreen;
        case ECartNotificationType$1.ERROR:
            return props.theme.colors.red;
        default:
            return props.theme.colors.doveGrey;
    }
}, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.type === ECartNotificationType$1.ERROR && 0.7; }, function (props) { return props.theme.space[2]; }, function (props) { return (props.type === ECartNotificationType$1.OUT_OF_STOCK ? 'uppercase' : 'unset'); });
var CartNotificationQtyWrapper$1 = CustomStyled$1(Flex)(templateObject_2$1n || (templateObject_2$1n = __makeTemplateObject(["\n    font-size: ", "px;\n    font-weight: ", ";\n"], ["\n    font-size: ", "px;\n    font-weight: ", ";\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.fontWeights[6]; });
var templateObject_1$1H, templateObject_2$1n;

var CartNotification$1 = function (_a) {
    var currency = _a.currency, currencyPosition = _a.currencyPosition, discount = _a.discount, originalPrice = _a.originalPrice, notification = _a.notification, _b = _a.quantity, quantity = _b === void 0 ? 1 : _b, unitOfMeasure = _a.unitOfMeasure, errDetail = _a.errDetail;
    var t = useTranslation().t;
    var soldByWeight = unitOfMeasure === KG_LABEL$1;
    var price = useMemo(function () {
        if (notification === ECartNotificationType$1.SUCCESS) {
            var dc = discount ? discount.price : 0;
            var op = originalPrice;
            var curr = currency;
            var currPos = currencyPosition;
            return dc > 0 ? formatPrice$1(dc * quantity, curr, currPos) : formatPrice$1(op * quantity, curr, currPos);
        }
        else {
            return 0;
        }
    }, [notification, discount, originalPrice, currency, currencyPosition, quantity]);
    var renderErrMsg = useCallback(function () {
        switch (errDetail) {
            case ECartAPINotification$1.OUT_OF_STOCK:
                return t('productCard.outOfStock');
            default:
                return t('somethingWentWrong');
        }
    }, [errDetail, t]);
    return (React.createElement(CartNotificationWrapper$1, { "data-testid": "cart-notification", type: notification },
        notification === ECartNotificationType$1.ERROR && React.createElement(Flex, null, renderErrMsg()),
        notification === ECartNotificationType$1.OUT_OF_STOCK && React.createElement(Flex, null, t('outOfStockLabel')),
        notification === ECartNotificationType$1.SUCCESS && (React.createElement(React.Fragment, null,
            React.createElement(CartNotificationQtyWrapper$1, { "data-testid": "quantity" }, soldByWeight ? addKGLabel$1(formatQuantityKG$1(quantity, soldByWeight)) : quantity),
            React.createElement(Flex, { "data-testid": "price" },
                "(",
                price,
                ") ",
                t('productCard.inCart'))))));
};

var Dots$1 = function (_a) {
    var size = _a.size, selectedIndex = _a.selectedIndex;
    return (React.createElement(Flex, { "data-testid": "image_carousel_dots", alignItems: "center", flexDirection: "row", margin: "auto", height: "5%" }, Array.from({ length: size }).map(function (__value, index) { return (React.createElement(Dot$1, { selected: selectedIndex === index, key: index })); })));
};

var ImageCarousel$1 = function (_a) {
    var imageLibrary = _a.imageLibrary, newProductCardImageLibrary = _a.newProductCardImageLibrary, title = _a.title, variant = _a.variant, _b = _a.isSponsoredListing, isSponsoredListing = _b === void 0 ? false : _b, _c = _a.carousel, carousel = _c === void 0 ? false : _c, productCardImageResizeString = _a.productCardImageResizeString;
    var _d = __read(useState(0), 2), index = _d[0], setIndex = _d[1];
    var images = useMemo(function () {
        return newProductCardImageLibrary.map(function (href, i) {
            return (React.createElement(ImageSlide$1, { key: href + "-" + i, widthPerSlide: variant === 'regular2' ? '56px' : '100%', gaps: "10" },
                React.createElement(CarousalImage$1, { isSponsoredListing: isSponsoredListing, carousel: carousel, variant: variant, url: updateImageResizeInUrl$1(href, productCardImageResizeString), name: title, testId: "product_image_carousel_" + i })));
        });
    }, [newProductCardImageLibrary, title, variant, isSponsoredListing, carousel, productCardImageResizeString]);
    var onSlideChange = useCallback(function (index) {
        setIndex(index);
    }, [setIndex]);
    var isNavEnabled = variant !== 'mini';
    if (newProductCardImageLibrary.length > 1) {
        return (React.createElement(Flex, { flexDirection: "column", "data-testid": "image_carousel_wrapper" },
            React.createElement(Flex, { height: "98%" },
                React.createElement(Carousel, { onSlideEnd: onSlideChange, autoPlay: 1400 }, images)),
            isNavEnabled && React.createElement(Dots$1, { size: imageLibrary.length, selectedIndex: index })));
    }
    else {
        return null;
    }
};

var NowJourneyIcon$1 = function (_a) {
    var _b, _c;
    var nowIconProps = _a.nowIconProps, iconProps = _a.iconProps, variant = _a.variant;
    var isNewJourney = ((_c = (_b = useFeature('new_carrefour_journey')) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.new_journey) || false;
    if (isNewJourney) {
        return React.createElement(NowExpressIconEn, __assign({}, nowIconProps));
    }
    else if (variant === 'old')
        return React.createElement(ExpressNow, __assign({}, iconProps));
    else
        return React.createElement(ExpressNowNew, __assign({}, iconProps));
};

var ProductImage$1 = function (props) {
    var variant = props.variant, url = props.url, onProductClickHandler = props.onProductClickHandler, isAvailable = props.isAvailable, name = props.name, isExpressProduct = props.isExpressProduct, _a = props.isHover, isHover = _a === void 0 ? false : _a, _b = props.imageLibrary, imageLibrary = _b === void 0 ? [] : _b, _c = props.newProductCardImageLibrary, newProductCardImageLibrary = _c === void 0 ? [] : _c, _d = props.newProductCardImage, newProductCardImage = _d === void 0 ? '' : _d, inCart = props.inCart, error = props.error, errDetail = props.errDetail, onRightClickHandler = props.onRightClickHandler, promoBadgesAreaB = props.promoBadgesAreaB, isSponsoredListing = props.isSponsoredListing, showNewPromoBadges = props.showNewPromoBadges, showFoodNutrition = props.showFoodNutrition, dietary = props.dietary, isNewPromoBadges = props.isNewPromoBadges, promoBadgesAreaBEle = props.promoBadgesAreaBEle, renderProductCardActions = props.renderProductCardActions, isSponsored = props.isSponsored, promoBadgesAreaAEle = props.promoBadgesAreaAEle, renderHeaderSticker = props.renderHeaderSticker, isNewCarrefourJourney = props.isNewCarrefourJourney, carousel = props.carousel, expressHeight = props.expressHeight, expressWidth = props.expressWidth, dir = props.dir, discountBadgePercentageThreshold = props.discountBadgePercentageThreshold;
    var productCardImageResizeString = '400';
    var t = useTranslation().t;
    var hasImages = newProductCardImageLibrary.length > 1;
    var title = useMemo(function () { return decodeHtml$1(name); }, [name]);
    var hasNotification = useMemo(function () {
        if (error) {
            return ECartNotificationType$1.ERROR;
        }
        return ECartNotificationType$1.NULL;
    }, [error]);
    var showCarousel = useMemo(function () { return isHover && hasImages && !inCart; }, [isHover, hasImages, inCart]);
    var text = ((promoBadgesAreaB === null || promoBadgesAreaB === void 0 ? void 0 : promoBadgesAreaB[0]) || {}).text;
    var _e = text || {}, normalText = _e.normalText, boldText = _e.boldText;
    var dietaryPreferences = (dietary === null || dietary === void 0 ? void 0 : dietary.dietaryPreferences) || [];
    return (React.createElement(React.Fragment, null,
        React.createElement(ProductCardImageContainer$3, { variant: variant, "data-testid": "product_card_image_container" },
            React.createElement(HeaderStickerContainer$1, { isSponsored: isSponsored && !isSponsoredListing },
                isSponsored && !isSponsoredListing && (React.createElement(SponseredProduct$1, { "data-testid": "sponsored_label", variant: variant, isAreaABadge: promoBadgesAreaAEle ? true : false }, "Ad")),
                !isSponsoredListing && (React.createElement(ProductCardHeaderWrapper$1, { "data-testid": "product_discount_badge", variant: variant, isSponsored: isSponsored }, showNewPromoBadges || isNewPromoBadges ? promoBadgesAreaAEle : renderHeaderSticker)),
                !promoBadgesAreaAEle && !isSponsoredListing && discountBadgePercentageThreshold && (React.createElement(ProductCardHeaderWrapper$1, { "data-testid": "product_discount_badge", variant: variant, isSponsored: isSponsored },
                    React.createElement(ProductCardNewHeaderSticker$1, { type: "discountThresholdBadge" }, discountBadgePercentageThreshold + '% ' + t('frequentlyBoughtTogether.off'))))),
            React.createElement(ProductcardImageContainerInner$1, { "data-testid": "product_card_image", variant: variant, isSponsoredListing: isSponsoredListing, carousel: carousel },
                React.createElement("a", { href: url, title: title, onClick: onProductClickHandler(url), onContextMenu: onRightClickHandler },
                    isAvailable && showCarousel && (React.createElement(ImageCarousel$1, { title: title, imageLibrary: imageLibrary, newProductCardImageLibrary: newProductCardImageLibrary, variant: variant, isSponsoredListing: isSponsoredListing, carousel: carousel, productCardImageResizeString: productCardImageResizeString })),
                    React.createElement(ProductCardImage$1, { display: isAvailable && showCarousel ? 'none' : 'block', key: "main-image", url: updateImageResizeInUrl$1(newProductCardImage, productCardImageResizeString), name: title, "data-testid": "product_image_main", variant: variant, carousel: carousel, isSponsoredListing: isSponsoredListing })),
                variant !== EProductCardVariants$1.REGULAR_WIDE && renderProductCardActions,
                React.createElement(PromoBadgesAreaBBox$1, { dir: dir, variant: variant },
                    isAvailable && isExpressProduct ? (React.createElement(NowJourneyIcon$1, { variant: "old", iconProps: { size: 'CUSTOM', height: expressHeight, width: expressWidth } })) : (isAvailable &&
                        (showNewPromoBadges || isNewPromoBadges
                            ? promoBadgesAreaBEle
                            : (promoBadgesAreaB === null || promoBadgesAreaB === void 0 ? void 0 : promoBadgesAreaB.length) > 0 &&
                                !isExpressProduct && (React.createElement(PromoBadgesAreaBContainer$1, { dir: "ltr" },
                                React.createElement(PromoBadgesAreaBText$1, null, boldText),
                                React.createElement(PromoBadgesAreaBTextLight$1, null, ' ' + normalText))))),
                    variant === EProductCardVariants$1.REGULAR_WIDE && !isAvailable && (React.createElement(OutOfStockText$1, null, t('outOfStockLabel')))),
                !isNewCarrefourJourney && (React.createElement("a", { dir: "ltr", href: url, title: title, onClick: onProductClickHandler(url), onContextMenu: onRightClickHandler }, variant === EProductCardVariants$1.COMPACT && (React.createElement(ProductCardExpressWrapper$3, { variant: variant, "data-testid": "product_now_badge" },
                    React.createElement(ProductCardAttributeIcon$1, { "data-testid": "product_now_foodicon" }, showFoodNutrition &&
                        dietaryPreferences
                            .slice(0, 1)
                            .map(function (_a) {
                            var attributeCode = _a.attributeCode;
                            return (React.createElement("img", { key: attributeCode, src: "https://cdnst.mafretailproxy.com/assets/images/dietconf/" + attributeCode + ".png", className: "attributeIcon1" }));
                        }))))))),
            hasNotification && React.createElement(CartNotification$1, __assign({ notification: hasNotification, errDetail: errDetail }, props))),
        variant !== EProductCardVariants$1.REGULAR_WIDE && (React.createElement(ProductCardExpressWrapper$3, { variant: variant, "data-testid": "product_now_badge" },
            !isNewCarrefourJourney && variant !== EProductCardVariants$1.COMPACT && (React.createElement(ProductCardAttributeIcon$1, { "data-testid": "product_now_foodicon" }, showFoodNutrition &&
                variant != 'list' &&
                dietaryPreferences
                    .slice(0, 2)
                    .map(function (_a) {
                    var attributeCode = _a.attributeCode;
                    return (React.createElement("img", { key: attributeCode, src: "https://cdnst.mafretailproxy.com/assets/images/dietconf/" + attributeCode + ".png", className: "attributeIcon2" }));
                }))),
            !isAvailable && React.createElement(OutOfStockText$1, null, t('outOfStockLabel'))))));
};

var fullfilledByCarreFourProductInfo$1 = function (_a) {
    var _b;
    var _c = _a.isFBC, isFBC = _c === void 0 ? false : _c, _d = _a.supplier, supplier = _d === void 0 ? '' : _d, _e = _a.delivery, delivery = _e === void 0 ? [] : _e, t = _a.t;
    var isCarrefourDelivery = false;
    var deliveryPartner = delivery && delivery.length > 0 ? supplier : '';
    if (delivery && ((_b = delivery[0]) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes('carrefour'))) {
        isCarrefourDelivery = true;
        deliveryPartner = 'Carrefour';
    }
    if (isFBC) {
        return t('productCard.fbc.fc');
    }
    if (supplier && deliveryPartner != '' && supplier.toLowerCase() != deliveryPartner.toLowerCase()) {
        return t('productCard.fbc.ss_dp', { supplier: supplier, deliveryPartner: deliveryPartner });
    }
    if (supplier && deliveryPartner != '' && !isCarrefourDelivery) {
        return t('productCard.fbc.s_ds', { supplier: supplier });
    }
    if (supplier && deliveryPartner != '' && isCarrefourDelivery) {
        return t('productCard.fbc.s_dc');
    }
    // fallback case if deliveryPartner is not present
    return t('productCard.soldBy') + " " + supplier;
};

var useFbcFeature$1 = function () {
    var _a;
    var fbcConfig = (_a = useFeature('fbc')) === null || _a === void 0 ? void 0 : _a.value;
    var isFbcSupported = !!(fbcConfig === null || fbcConfig === void 0 ? void 0 : fbcConfig.enabled);
    var fbcIconUrl = fbcConfig === null || fbcConfig === void 0 ? void 0 : fbcConfig.icon;
    return {
        isFbcSupported: isFbcSupported,
        fbcIconUrl: fbcIconUrl,
    };
};

var ERR_TIMEOUT$1 = 5000;
var ProductCard$2 = function (props) {
    var _a, _b, _c, _d, _e;
    var dispatch = useDispatch();
    var _f = useProductCard$1(props.productId), error = _f.error, errDetail = _f.errDetail, loading = _f.loading;
    var _g = useAnalytic$1(), GTMEventCall = _g.GTMEventCall, EventCall = _g.EventCall;
    var _h = useBreakpoints(), isMobile = _h.isMobile, isDesktop = _h.isDesktop;
    var isBasketV4 = useFeature('basket_v4_global').on;
    var _j = __read(useProductCardHandlers$1(props, isBasketV4), 4), onAddHandler = _j[0], onDecrementHandler = _j[1], onIncrementHandler = _j[2], onRemoveHandler = _j[3];
    var _k = useSelector(function (state) { return state.appConfig; }), language = _k.language, storeId = _k.storeId, code = _k.code;
    var sortBy = useSelector(function (state) {
        var _a, _b;
        return {
            sortBy: (_b = (_a = state === null || state === void 0 ? void 0 : state.search) === null || _a === void 0 ? void 0 : _a.query) === null || _b === void 0 ? void 0 : _b.sortBy,
        };
    }).sortBy;
    var expressHeight = '17px';
    var expressWidth = '51px';
    if (isMobile) {
        expressWidth = '42px';
        expressHeight = '14px';
    }
    var dir = useMemo(function () { return ((language ? language : EN$1) === AR$1 ? 'rtl' : 'ltr'); }, [language]);
    var _l = (useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.search; }) || {}).algoliaQueryID, algoliaQueryID = _l === void 0 ? '' : _l;
    var t = useTranslation().t;
    var showNewPromoBadges = !((_a = useFeature('old_promo_badges')) === null || _a === void 0 ? void 0 : _a.on);
    var showFoodNutrition = (_b = useFeature('product_card_food_nutrition')) === null || _b === void 0 ? void 0 : _b.on;
    var dietary = props.dietary, _m = props.bulkMessage, bulkMessage = _m === void 0 ? '' : _m, currency = props.currency, _o = props.currencyPosition, currencyPosition = _o === void 0 ? 'right' : _o, disabled = props.disabled, _p = props.discount, discount = _p === void 0 ? {
        type: 'none',
        value: 0,
        price: 0,
        minBuyingValue: '',
    } : _p, image = props.image, newProductCardImage = props.newProductCardImage, inCart = props.inCart, incrementBy = props.incrementBy, isAvailable = props.isAvailable, isExpress = props.isExpress, _q = props.isLebanon, isLebanon = _q === void 0 ? false : _q, _r = props.isSponsored, isSponsored = _r === void 0 ? false : _r, _s = props.isCart, isCart = _s === void 0 ? false : _s, _t = props.promoVoucher, promoVoucher = _t === void 0 ? {} : _t, isOpen = props.isOpen, itemsPerUnit = props.itemsPerUnit, max = props.max, min = props.min, minBuyingValue = props.minBuyingValue, name = props.name, _u = props.originalPrice, originalPrice = _u === void 0 ? 0 : _u, _v = props.points, points = _v === void 0 ? 0 : _v, productId = props.productId, _w = props.productVariants, productVariants = _w === void 0 ? [] : _w, _x = props.quantity, quantity = _x === void 0 ? 1 : _x, _y = props.size, size = _y === void 0 ? '' : _y, _z = props.testId, testId = _z === void 0 ? '' : _z, unitOfMeasure = props.unitOfMeasure, unitItem = props.unitItem, _0 = props.position, position = _0 === void 0 ? 0 : _0, url = props.url, _1 = props.withProductVariants, withProductVariants = _1 === void 0 ? false : _1, imageLibrary = props.imageLibrary, newProductCardImageLibrary = props.newProductCardImageLibrary, showAgeDisclaimer = props.showAgeDisclaimer, isSponsoredListing = props.isSponsoredListing, productOrigin = props.productOrigin, supplier = props.supplier, isFBC = props.isFBC, type = props.type, _2 = props.isFoodCategory, isFoodCategory = _2 === void 0 ? false : _2, onNotificationHandler = props.onNotificationHandler, onViewSimilarHandler = props.onViewSimilarHandler, promoBadges = props.promoBadges, _3 = props.promoBadgesAreaA, promoBadgesAreaA = _3 === void 0 ? [] : _3, _4 = props.promoBadgesAreaB, promoBadgesAreaB = _4 === void 0 ? [] : _4, isNewPromoBadges = props.isNewPromoBadges, offers = props.offers, preorder = props.preorder, _5 = props.delivery, delivery = _5 === void 0 ? [] : _5, _6 = props.rowIndex, rowIndex = _6 === void 0 ? 0 : _6, carousel = props.carousel, rest = __rest(props, ["dietary", "bulkMessage", "currency", "currencyPosition", "disabled", "discount", "image", "newProductCardImage", "inCart", "incrementBy", "isAvailable", "isExpress", "isLebanon", "isSponsored", "isCart", "promoVoucher", "isOpen", "itemsPerUnit", "max", "min", "minBuyingValue", "name", "originalPrice", "points", "productId", "productVariants", "quantity", "size", "testId", "unitOfMeasure", "unitItem", "position", "url", "withProductVariants", "imageLibrary", "newProductCardImageLibrary", "showAgeDisclaimer", "isSponsoredListing", "productOrigin", "supplier", "isFBC", "type", "isFoodCategory", "onNotificationHandler", "onViewSimilarHandler", "promoBadges", "promoBadgesAreaA", "promoBadgesAreaB", "isNewPromoBadges", "offers", "preorder", "delivery", "rowIndex", "carousel"]);
    var _7 = __read(useInView({
        /* Optional options */
        threshold: 0,
    }), 2), ref = _7[0], inView = _7[1];
    var isNewCarrefourJourney = ((_d = (_c = useFeature('new_carrefour_journey')) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.new_journey) || false;
    var discountBadgePercentageThreshold = ((_e = useFeature('discount_badge_percentage_threshold')) === null || _e === void 0 ? void 0 : _e.value) || null;
    var _8 = useFbcFeature$1(), isFbcSupported = _8.isFbcSupported, fbcIconUrl = _8.fbcIconUrl;
    var isDiscountBadgePercentageThreshold = discountBadgePercentageThreshold
        ? discount.value > discountBadgePercentageThreshold
        : false;
    var isLBN = isLebanon || storeId === EStoreID$1.MAFLBN;
    var variant = props.variant || EProductCardVariants$1.REGULAR;
    var isCompactView = isFoodCategory && isMobile;
    useEffect(function () {
        if (inView) {
            var productPosition = getProductPosition$1(rowIndex, position, isDesktop, isMobile);
            GTMEventCall(GTMEvents$1.product_impressions, { product: props, position: productPosition, ga4: false });
            GTMEventCall(GTMEvents$1.product_impressions, {
                product: props,
                position: productPosition,
                ga4: true,
                countryCode: code,
            });
            if (props.isSponsored) {
                if (!isImpressionTracked$1(props)) {
                    Promise.resolve(EventCall(GTMEvents$1.product_impression, props));
                }
            }
        }
    }, [inView, GTMEventCall, EventCall, productId, position, props, code, isDesktop, isMobile, rowIndex]);
    useEffect(function () {
        var timer;
        if (error) {
            timer = setTimeout(function () { return dispatch(setError$1(productId, false, '', false)); }, ERR_TIMEOUT$1);
        }
        return function () { return timer && clearTimeout(timer); };
    }, [dispatch, error, productId]);
    var borderType = useMemo(function () {
        if (isSponsoredListing) {
            return EProductCardBorderType$1.SPONSORED_LISTING;
        }
        else if (isOpen || (isLBN && points > 0)) {
            return EProductCardBorderType$1.ORIGINAL;
        }
        else if (inCart) {
            return EProductCardBorderType$1.IN_CART;
        }
        else if (discount.price > 0) {
            return EProductCardBorderType$1.DISCOUNT;
        }
        return EProductCardBorderType$1.ORIGINAL;
    }, [discount.price, inCart, isLBN, isOpen, points, isSponsoredListing]);
    var onProductClickHandler = useCallback(function (url) { return function (event) {
        event.preventDefault();
        if (isSponsoredListing && isCart) {
            // sponsored cart carousel products are not supposed to redirect to pdp when clicked
            return;
        }
        var updatedUrl = url;
        if (rest.gaListName) {
            updatedUrl = updateQueryStringParamter$1(updatedUrl, 'list_name', gtmSnakeCase$1(rest.gaListName));
        }
        var offerId = offers && offers.length > 0 ? offers[0].id : '';
        if (offerId) {
            updatedUrl = updateQueryStringParamter$1(updatedUrl, 'offer', offerId);
        }
        var sid = offers && offers.length > 0 ? offers[0].shippingIndicator : '';
        updatedUrl = updateQueryStringParamter$1(updatedUrl, 'sid', sid);
        var productPosition = getProductPosition$1(rowIndex, position, isDesktop, isMobile);
        sessionStorage.setItem('queryId', algoliaQueryID);
        Promise.resolve(clickAlgoliaOperation$1({ searchQueryID: algoliaQueryID, productId: props.productId, productPosition: productPosition, sortBy: sortBy }, dispatch));
        var _a = getGa4AlgoliaEventsParams$1(), experimentKey = _a.experimentKey, variationId = _a.variationId;
        if (variationId && experimentKey) {
            GTMEventCall(GTMEvents$1.algolia_custom_events, {
                experiment_key: experimentKey,
                variation_id: variationId,
                pageData: { language: language, currency: currency },
            });
        }
        GTMEventCall(GTMEvents$1.product_click, { product: props, position: position, ga4: false });
        GTMEventCall(GTMEvents$1.product_click, { product: props, position: position, ga4: true, countryCode: code });
        Promise.resolve(EventCall(GTMEvents$1.product_click, props));
        window.location.href = "" + updatedUrl;
    }; }, [
        rest.gaListName,
        rowIndex,
        position,
        isDesktop,
        isMobile,
        algoliaQueryID,
        props,
        sortBy,
        dispatch,
        GTMEventCall,
        code,
        EventCall,
        currency,
        language,
        offers,
        isSponsoredListing,
        isCart,
    ]);
    var onRightClickHandler = useCallback(function () {
        if (props.isSponsored) {
            Promise.resolve(EventCall(GTMEvents$1.right_click, props));
        }
    }, [props, EventCall]);
    var productNote = useMemo(function () {
        return getProductNote$1(itemsPerUnit, t);
    }, [itemsPerUnit, t]);
    var hasVariants = useMemo(function () { return productVariants.length > 0 && withProductVariants; }, [
        productVariants.length,
        withProductVariants,
    ]);
    var showOOSOptions = useMemo(function () { return !!(onNotificationHandler || onViewSimilarHandler); }, [
        onNotificationHandler,
        onViewSimilarHandler,
    ]);
    var isExpressProduct = useMemo(function () {
        if (variant === EProductCardVariants$1.REGULAR_WIDE || !isSponsoredListing)
            return !!isExpress;
        if (variant === EProductCardVariants$1.REGULAR && isSponsoredListing)
            return !!isExpress;
        return false;
    }, [isExpress, isSponsoredListing, variant]);
    var _9 = __read(useState(false), 2), mouseHover = _9[0], setMouseHover = _9[1];
    var onMouseHover = useCallback(function (hovering) { return function () { return setMouseHover(hovering); }; }, [setMouseHover]);
    var getSimplePrice = useCallback(function (price, type) {
        return formatPrice$1(price, currency, currencyPosition, false, type);
    }, [currency, currencyPosition]);
    var onNotifyMeCb = useCallback(function () {
        if (onNotificationHandler) {
            onNotificationHandler(__assign({}, props));
        }
    }, [props, onNotificationHandler]);
    var onViewSimilarCb = useCallback(function () {
        if (onViewSimilarHandler) {
            var isMarketPlace = rest.isMarketPlace;
            var product = {
                name: name,
                productId: productId,
                image: image,
                size: size,
                unitOfMeasure: unitOfMeasure,
                isMarketPlace: isMarketPlace,
                type: type,
                price: getSimplePrice(originalPrice, 'original'),
            };
            onViewSimilarHandler(product);
        }
    }, [productId, name, getSimplePrice, image, size, unitOfMeasure, originalPrice, onViewSimilarHandler, rest, type]);
    var ProductPriceWrapper = function () {
        if (variant === EProductCardVariants$1.COMPACT ||
            variant === EProductCardVariants$1.LIST ||
            variant === EProductCardVariants$1.MINI) {
            return (React.createElement(ProductCardPricesWrapper$1, { variant: variant, "data-testid": "product_price" }, discount.price > 0
                ? renderProductPrice$1(discount.price, 'discount', currency, currencyPosition, unitOfMeasure, true, variant, t, 'product-card-discount-price', isSponsoredListing)
                : originalPrice > 0 &&
                    renderProductPrice$1(originalPrice, 'original', currency, currencyPosition, unitOfMeasure, discount.price > 0, variant, t, 'product-card-original-price', isSponsoredListing)));
        }
        else {
            return (React.createElement(ProductCardPricesWrapper$1, { variant: variant, "data-testid": "product_price" },
                discount.price > 0 &&
                    renderProductPrice$1(discount.minBuyingValue && type === ProductType$1.FOOD
                        ? parseFloat(discount.minBuyingValue)
                        : discount.price, 'discount', currency, currencyPosition, unitOfMeasure, true, variant, t, 'product-card-discount-price', isSponsoredListing, unitItem, undefined, isNewCarrefourJourney),
                originalPrice > 0 &&
                    discount.price == 0 &&
                    renderProductPrice$1(minBuyingValue ? parseFloat(minBuyingValue) : originalPrice, 'original', currency, currencyPosition, unitOfMeasure, discount.price > 0, variant, t, 'product-card-original-price', isSponsoredListing, unitItem, discount, isNewCarrefourJourney)));
        }
    };
    var isTopHeaderSticker = (promoVoucher === null || promoVoucher === void 0 ? void 0 : promoVoucher.hasPromoVoucher) || (discount === null || discount === void 0 ? void 0 : discount.value) > 0 || bulkMessage.length > 0 || points > 0;
    var cardWidth = ['115px', '115px', '222px', '222px'];
    var cardHeight = ['141px', '129px', '96px', '96px'];
    if (variant === 'simple') {
        if (isSponsoredListing) {
            cardHeight = '100px';
            cardWidth = '222px';
        }
        if (isCart) {
            cardHeight = '112px';
            cardWidth = '90px';
        }
    }
    var isReachedQtyMaxLimit = hasReachedQtyMaxLimit$1(quantity, max);
    var renderProductCardActions = (React.createElement(ProductCardActionsWrapper$1, { dir: "ltr", "data-testid": "product-card-actions", variant: variant, inCart: inCart }, isAvailable ? (React.createElement(CartElements$1, __assign({}, rest, { disabled: disabled || !isAvailable, inCart: inCart, incrementBy: incrementBy, isOpen: isOpen, isLoading: loading, max: max, min: min, onAddHandler: onAddHandler, onDecrementHandler: onDecrementHandler, onIncrementHandler: onIncrementHandler, onRemoveHandler: onRemoveHandler, productCardVariant: variant, variant: variant, quantity: quantity, soldByWeight: unitOfMeasure === KG_LABEL$1, showAgeDisclaimer: showAgeDisclaimer, currency: currency, productId: productId, price: discount.price > 0 ? discount.price : originalPrice, isNewCarrefourJourney: isNewCarrefourJourney, dir: dir }))) : (showOOSOptions && (React.createElement(OutOfStockOptions$1, { onNotificationHandler: onNotifyMeCb, onViewSimilarHandler: onViewSimilarCb })))));
    var params1 = [currency, points];
    var params2 = [variant, promoVoucher, language, t, promoBadgesAreaA, bulkMessage];
    var params = __spread(params1, [isLBN], params2);
    var _10 = __read(useMemo(function () {
        if (showNewPromoBadges || isNewPromoBadges) {
            var badges = promoBadges === null || promoBadges === void 0 ? void 0 : promoBadges.filter(function (ele) {
                var _a, _b, _c;
                var seller = (_a = ele === null || ele === void 0 ? void 0 : ele.seller) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                var sellerName = (_c = (_b = offers === null || offers === void 0 ? void 0 : offers[0]) === null || _b === void 0 ? void 0 : _b.sellerName) === null || _c === void 0 ? void 0 : _c.toLowerCase();
                if (!seller ||
                    seller === 'both' ||
                    (seller === 'carrefour' && sellerName === 'carrefour') ||
                    (seller !== 'both' && seller !== 'carrefour' && sellerName !== 'carrefour'))
                    return true;
            }).sort(function (a, b) { return a.priority - b.priority; });
            return getBadges$1(points, variant, promoVoucher, language, t, badges, bulkMessage, discount, isLebanon, preorder);
        }
        return [];
    }, [
        bulkMessage,
        isNewPromoBadges,
        language,
        offers,
        points,
        promoBadges,
        promoVoucher,
        showNewPromoBadges,
        t,
        variant,
        discount,
        isLebanon,
        preorder,
    ]), 2), promoBadgesAreaAEle = _10[0], promoBadgesAreaBEle = _10[1];
    return variant !== 'simple' ? (React.createElement("div", null,
        React.createElement(ProductCardWrapper$1, { ref: ref, "data-testid": testId, variant: variant, hasProductVariants: hasVariants, borderType: borderType, dir: dir, onMouseEnter: onMouseHover(true), onMouseLeave: onMouseHover(false), isSponsoredListing: isSponsoredListing, borderRadius: 4, carousel: carousel },
            React.createElement(ProductCardContentElevation$1, { isSponsoredListing: isSponsoredListing, variant: variant },
                React.createElement(ProductImage$1, { dietary: dietary, onProductClickHandler: onProductClickHandler, inCart: inCart, isHover: mouseHover, isExpressProduct: isExpressProduct, currency: currency, currencyPosition: currencyPosition, discount: discount, originalPrice: originalPrice, quantity: quantity, unitOfMeasure: unitOfMeasure, image: image, newProductCardImage: newProductCardImage, errDetail: errDetail, error: error, name: name, url: url, isAvailable: isAvailable, imageLibrary: imageLibrary, newProductCardImageLibrary: newProductCardImageLibrary, variant: variant, onRightClickHandler: onRightClickHandler, isTopHeaderSticker: isTopHeaderSticker, promoBadgesAreaB: promoBadgesAreaB, isSponsoredListing: isSponsoredListing, showFoodNutrition: showFoodNutrition, showNewPromoBadges: showNewPromoBadges, isNewPromoBadges: isNewPromoBadges, promoBadgesAreaBEle: promoBadgesAreaBEle, renderProductCardActions: renderProductCardActions, isSponsored: isSponsored, promoBadgesAreaAEle: promoBadgesAreaAEle, renderHeaderSticker: renderHeaderSticker$1.apply(void 0, __spread(params)), isNewCarrefourJourney: isNewCarrefourJourney, carousel: carousel, expressHeight: expressHeight, expressWidth: expressWidth, dir: dir, discountBadgePercentageThreshold: isDiscountBadgePercentageThreshold ? discount.value : undefined }),
                React.createElement(ProductItems$1, { variant: variant },
                    variant !== EProductCardVariants$1.REGULAR_WIDE && (React.createElement(React.Fragment, null,
                        React.createElement(ProductPriceWrapper, null),
                        discount.price > 0 && points < 1 ? (React.createElement(DisplayDiscountTemplateNew$1, { originalPrice: originalPrice, discount: discount, minBuyingValue: minBuyingValue, variant: variant, currency: currency, currencyPos: 'right', unitOfMeasure: unitOfMeasure, isSponsoredListing: isSponsoredListing, unitItem: unitItem })) : (React.createElement(EmptyDiscountedPrice$1, null)))),
                    React.createElement(ProductCardName$1, { variant: variant, isSponsoredListing: isSponsoredListing },
                        React.createElement("a", { href: url, title: decodeHtml$1(name), dangerouslySetInnerHTML: { __html: name }, onClick: onProductClickHandler(url), onContextMenu: onRightClickHandler, "data-testid": "product_name" })),
                    !isNewCarrefourJourney && variant !== EProductCardVariants$1.COMPACT && (React.createElement(GetProductDeliveryInfo$1, { productOrigin: productOrigin, supplier: supplier, type: type, variant: variant, isFBC: isFBC, delivery: delivery, unitOfMeasure: unitOfMeasure, size: size, min: min })),
                    ((variant === EProductCardVariants$1.REGULAR && !isSponsoredListing && !isCompactView) ||
                        variant === EProductCardVariants$1.REGULAR_WIDE) && (React.createElement(ProductCardNote$1, { isSponsoredListing: isSponsoredListing, variant: variant },
                        productNote && (size ? size + " " + unitOfMeasure + " - " : formatFoodWeight$1(min, unitOfMeasure) + " - "),
                        productNote)),
                    variant !== EProductCardVariants$1.REGULAR_WIDE && (React.createElement(ProductCardStockIndicator$1, null, max <= STOCK_ALERT$1 && type === ProductType$1.NONFOOD ? t('productCard.onlyQtyLeft', { qty: max }) : '')),
                    type === ProductType$1.NONFOOD && isFBC && isFbcSupported && variant !== EProductCardVariants$1.REGULAR_WIDE && (React.createElement(FBCContainer$1, null,
                        !!fbcIconUrl && React.createElement("img", { src: fbcIconUrl }),
                        React.createElement("span", null, t('productCard.fbc.fc')))),
                    isReachedQtyMaxLimit && variant === EProductCardVariants$1.LIST && (React.createElement(MaxLimitContainer$1, { variant: variant },
                        React.createElement("div", null, t('productCard.maxLimit')))),
                    variant === EProductCardVariants$1.REGULAR_WIDE && (React.createElement(React.Fragment, null,
                        React.createElement(ProductPriceWrapper, null),
                        renderProductCardActions,
                        discount.price > 0 && points < 1 ? (React.createElement(DisplayDiscountTemplateNew$1, { originalPrice: originalPrice, discount: discount, minBuyingValue: minBuyingValue, variant: variant, currency: currency, currencyPos: 'right', unitOfMeasure: unitOfMeasure, isSponsoredListing: isSponsoredListing, unitItem: unitItem })) : (React.createElement(EmptyDiscountedPrice$1, null))))))))) : (React.createElement(ProductCardSimple$1, { flexDirection: "column", height: cardHeight, width: cardWidth, dir: dir, ref: ref, isSponsoredListing: isSponsoredListing, isCart: isCart },
        React.createElement(ProductCardSimpleImageContainer$1, { onClick: onProductClickHandler(url), isCart: isCart },
            React.createElement(Image, { url: image.href, name: image.altText }),
            isExpress && !isSponsoredListing && isBrowser$1() && React.createElement(NowJourneyIcon$1, { variant: isCart ? 'new' : 'old' })),
        React.createElement(ProductCardSimpleContent$1, { mt: [2, 2, 0, 0], alignItems: isSponsoredListing ? 'flex-start' : ['center', 'center', 'flex-start', 'flex-start'] },
            isCart ? null : (React.createElement(React.Fragment, null,
                React.createElement(ProductCardSimpleHeader$1, { isSponsoredListing: isSponsoredListing, display: isSponsoredListing ? '-webkit-box' : ['none', 'none', '-webkit-box', '-webkit-box'] }, name),
                !isSponsoredListing ? (React.createElement(ProductCardSimplePrice$1, { "data-testid": "product-card-simple-price" }, discount.price > 0
                    ? getSimplePrice(discount.price, 'discount')
                    : getSimplePrice(originalPrice, 'original'))) : (ProductPriceWrapper),
                isMobile && !isSponsoredListing && (React.createElement(ProductCardSimpleSeperator$1, { width: ['115px', '115px', '222px', '222px'] })))),
            !isSponsoredListing && !isCart && (React.createElement(ProductCardSimpleCTA$1, { disabled: loading, onClick: onAddHandler }, t(loading ? 'adding' : 'add'))),
            !isSponsoredListing && isCart && (React.createElement(ProductCardSimpleCartCTA$1, { disabled: loading, onClick: onAddHandler }, t("" + (loading ? 'adding' : 'add')))),
            isSponsoredListing && renderProductCardActions)));
};
var GetProductDeliveryInfo$1 = function (_a) {
    var variant = _a.variant, type = _a.type, productOrigin = _a.productOrigin, supplier = _a.supplier, _b = _a.isFBC, isFBC = _b === void 0 ? false : _b, _c = _a.delivery, delivery = _c === void 0 ? [] : _c, unitOfMeasure = _a.unitOfMeasure, size = _a.size, min = _a.min;
    var info = React.createElement("br", null);
    var t = useTranslation().t;
    if (productOrigin && type === ProductType$1.FOOD) {
        size
            ? (info = size + " " + unitOfMeasure + " - " + productOrigin)
            : (info = formatFoodWeight$1(min, unitOfMeasure) + " - " + productOrigin);
    }
    else if (type === ProductType$1.NONFOOD) {
        info = fullfilledByCarreFourProductInfo$1({ isFBC: isFBC, supplier: supplier, delivery: delivery, t: t });
    }
    return (React.createElement(Flex, { alignItems: "center", height: "20", mt: 2 },
        React.createElement(ProductDeliveryInfo$1, { ml: isFBC ? 1 : 0, variant: variant }, info)));
};
var ProductCard$3 = React.memo(ProductCard$2);

var FbtWrapper$1 = customStyled.div(templateObject_1$1I || (templateObject_1$1I = __makeTemplateObject(["\n  display: inline-block;\n  font-family: ", ";\n  width: 100%;\n  ", ";\n\n  a {\n    text-decoration: none;\n  }\n"], ["\n  display: inline-block;\n  font-family: ", ";\n  width: 100%;\n  ", ";\n\n  a {\n    text-decoration: none;\n  }\n"])), function (props) { return props.theme.fonts.montserrat; }, space);
var FbtWrappperInner$1 = customStyled.div(templateObject_2$1o || (templateObject_2$1o = __makeTemplateObject(["\n  @media (min-width: ", ") {\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 8px;\n    padding: ", "px;\n    position: relative;\n  }\n"], ["\n  @media (min-width: ", ") {\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 8px;\n    padding: ", "px;\n    position: relative;\n  }\n"])), function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.colors.mercury; }, function (props) { return props.theme.space[3]; });
var FbtHeader$1 = customStyled(Flex)(templateObject_3$17 || (templateObject_3$17 = __makeTemplateObject(["\n  justify-content: space-between;\n  margin-bottom: 12px;\n\n  p {\n    color: ", ";\n    font-size: ", "px;\n    font-weight: ", ";\n  }\n\n  @media (min-width: ", ") {\n    height: 40px;\n\n    p {\n      font-size: ", "px;\n    }\n  }\n"], ["\n  justify-content: space-between;\n  margin-bottom: 12px;\n\n  p {\n    color: ", ";\n    font-size: ", "px;\n    font-weight: ", ";\n  }\n\n  @media (min-width: ", ") {\n    height: 40px;\n\n    p {\n      font-size: ", "px;\n    }\n  }\n"])), function (props) { return props.theme.colors.black; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.fontWeights[5]; }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.fontSizes[3]; });
var FbtCTA$1 = customStyled(Button$1)(templateObject_4$Z || (templateObject_4$Z = __makeTemplateObject(["\n  border-radius: 4px;\n  font-size: ", "px;\n  font-weight: ", ";\n  margin-top: ", "px;\n  width: 100%;\n  background-color: ", ";\n\n  @media (min-width: ", ") {\n    margin-top: 0;\n    html[dir='ltr'] && position: absolute;\n    html[dir='ltr'] && right: ", "px;\n    html[dir='ltr'] && top: ", "px;\n    width: auto;\n  }\n"], ["\n  border-radius: 4px;\n  font-size: ", "px;\n  font-weight: ", ";\n  margin-top: ", "px;\n  width: 100%;\n  background-color: ", ";\n\n  @media (min-width: ", ") {\n    margin-top: 0;\n    html[dir='ltr'] && position: absolute;\n    html[dir='ltr'] && right: ", "px;\n    html[dir='ltr'] && top: ", "px;\n    width: auto;\n  }\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.space[3]; }, function (props) { return props.theme.colors.ctaRed; }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.space[3]; }, function (props) { return props.theme.space[3]; });
FbtCTA$1.defaultProps = {
    paddingBottom: '12px',
    paddingLeft: '18px',
    paddingRight: '18px',
    paddingTop: '12px',
};
var FbtCTALoader$1 = customStyled.div(templateObject_5$L || (templateObject_5$L = __makeTemplateObject(["\n  border: 4px solid ", ";\n  border-radius: 50%;\n  border-top: 4px solid ", ";\n  width: 18px;\n  height: 18px;\n  -webkit-animation: spin 1s linear infinite; /* Safari */\n  animation: spin 1s linear infinite;\n\n  /* Safari */\n  @-webkit-keyframes spin {\n    0% { -webkit-transform: rotate(0deg); }\n    100% { -webkit-transform: rotate(360deg); }\n  }\n\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n"], ["\n  border: 4px solid ", ";\n  border-radius: 50%;\n  border-top: 4px solid ", ";\n  width: 18px;\n  height: 18px;\n  -webkit-animation: spin 1s linear infinite; /* Safari */\n  animation: spin 1s linear infinite;\n\n  /* Safari */\n  @-webkit-keyframes spin {\n    0% { -webkit-transform: rotate(0deg); }\n    100% { -webkit-transform: rotate(360deg); }\n  }\n\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n"])), function (props) { return (props.color ? props.color : '#f1f1f1'); }, function (props) { return props.theme.colors.white; });
var FbtProductList$1 = customStyled.div(templateObject_6$B || (templateObject_6$B = __makeTemplateObject(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  padding: ", "px;\n\n  @media (min-width: ", ") {\n    background-color: transparent;\n    border: 0;\n    border-radius: 0;\n    display: grid;\n    grid-gap: 20px;\n    grid-template-columns: repeat(", ", 1fr);\n    margin-top: ", "px;\n    padding: 0;\n  }\n"], ["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  padding: ", "px;\n\n  @media (min-width: ", ") {\n    background-color: transparent;\n    border: 0;\n    border-radius: 0;\n    display: grid;\n    grid-gap: 20px;\n    grid-template-columns: repeat(", ", 1fr);\n    margin-top: ", "px;\n    padding: 0;\n  }\n"])), function (props) { return props.theme.colors.white; }, function (props) { return props.theme.colors.mercury; }, function (props) { return props.theme.space[3]; }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.productLen; }, function (props) { return props.theme.space[3]; });
var FbtProduct$1 = customStyled.div(templateObject_7$z || (templateObject_7$z = __makeTemplateObject(["\n  display: grid;\n  border-bottom: 1px solid ", ";\n  grid-template-columns: 76px 1fr;\n  grid-gap: 12px;\n  padding: ", "px 0;\n\n  &:first-of-type {\n    padding-top: 0;\n  }\n\n  &:last-of-type {\n    border: 0;\n    padding-bottom: 0;\n  }\n\n  @media (min-width: ", ") {\n    display: flex;\n    border-bottom: 0;\n    flex-direction: column;\n    grid-gap: 0;\n    padding: 0;\n  }\n"], ["\n  display: grid;\n  border-bottom: 1px solid ", ";\n  grid-template-columns: 76px 1fr;\n  grid-gap: 12px;\n  padding: ", "px 0;\n\n  &:first-of-type {\n    padding-top: 0;\n  }\n\n  &:last-of-type {\n    border: 0;\n    padding-bottom: 0;\n  }\n\n  @media (min-width: ", ") {\n    display: flex;\n    border-bottom: 0;\n    flex-direction: column;\n    grid-gap: 0;\n    padding: 0;\n  }\n"])), function (props) { return props.theme.colors.mercury; }, function (props) { return props.theme.space[3]; }, function (props) { return props.theme.breakpoints[2]; });
var FbtProductHeading$1 = customStyled(Flex)(templateObject_8$z || (templateObject_8$z = __makeTemplateObject(["\n  align-items: center;\n  \n\n  @media (min-width: ", ") {\n    margin-bottom: ", "px;\n  }\n"], ["\n  align-items: center;\n  \n\n  @media (min-width: ", ") {\n    margin-bottom: ", "px;\n  }\n"])), function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.space[2]; });
var FbtCheckbox$1 = customStyled(Checkbox)(templateObject_9$w || (templateObject_9$w = __makeTemplateObject(["\nhtml[dir='ltr'] & {margin-right: ", "px};\nhtml[dir='rtl'] & {margin-left: ", "px};\n\n  input + div {\n    opacity: 1;\n    transition: opacity 0.25s ease;\n    cursor: pointer;\n  }\n\n  input[disabled] + div {\n    opacity 0.4;\n    cursor: not-allowed;\n  }\n"], ["\nhtml[dir='ltr'] & {margin-right: ", "px};\nhtml[dir='rtl'] & {margin-left: ", "px};\n\n  input + div {\n    opacity: 1;\n    transition: opacity 0.25s ease;\n    cursor: pointer;\n  }\n\n  input[disabled] + div {\n    opacity 0.4;\n    cursor: not-allowed;\n  }\n"])), function (props) { return props.theme.space[2]; }, function (props) { return props.theme.space[2]; });
var FbtWarningWrapper$1 = customStyled.div(templateObject_10$v || (templateObject_10$v = __makeTemplateObject(["\n  left: -3px;\n  margin-right: ", "px;\n  position: relative;\n  width: 18px;\n\n  &:hover + span {\n    opacity: 1;\n  }\n"], ["\n  left: -3px;\n  margin-right: ", "px;\n  position: relative;\n  width: 18px;\n\n  &:hover + span {\n    opacity: 1;\n  }\n"])), function (props) { return props.theme.space[2]; });
var FbtProductDiscountSticker$1 = customStyled.div(templateObject_11$p || (templateObject_11$p = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  font-size: 6px;\n  font-weight: ", ";\n  left: 0;\n  padding: 2px;\n  position: absolute;\n  text-align: center;\n  text-transform: uppercase;\n  top: 0;\n  width: 100%;\n  z-index: 2;\n"], ["\n  background-color: ", ";\n  color: ", ";\n  font-size: 6px;\n  font-weight: ", ";\n  left: 0;\n  padding: 2px;\n  position: absolute;\n  text-align: center;\n  text-transform: uppercase;\n  top: 0;\n  width: 100%;\n  z-index: 2;\n"])), function (props) { return props.theme.colors.yellow; }, function (props) { return props.theme.colors.red; }, function (props) { return props.theme.fontWeights[5]; });
var FbtProductImage$1 = customStyled.div(templateObject_12$n || (templateObject_12$n = __makeTemplateObject(["\n  height: 50px;\n  position: relative;\n  min-width: 50px;\n\n  img {\n    bottom: 0;\n    height: auto;\n    left: 0;\n    margin: auto;\n    max-height: 100%;\n    position: absolute;\n    max-width: 100%;\n    right: 0;\n    top: 0;\n    width: auto;\n  }\n"], ["\n  height: 50px;\n  position: relative;\n  min-width: 50px;\n\n  img {\n    bottom: 0;\n    height: auto;\n    left: 0;\n    margin: auto;\n    max-height: 100%;\n    position: absolute;\n    max-width: 100%;\n    right: 0;\n    top: 0;\n    width: auto;\n  }\n"])));
var FbtProductDetails$1 = customStyled(Flex)(templateObject_13$m || (templateObject_13$m = __makeTemplateObject(["\n  flex-direction: column;\n  justify-content: space-around;\n"], ["\n  flex-direction: column;\n  justify-content: space-around;\n"])));
var FbtProductName$1 = customStyled.a(templateObject_14$m || (templateObject_14$m = __makeTemplateObject(["\n  color: ", ";\n  display: -webkit-box;\n  font-size: ", "px;\n  margin-bottom: 2px;\n  overflow: hidden;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n\n  @media (min-width: ", ") {\n    -webkit-line-clamp: 1;\n  }\n"], ["\n  color: ", ";\n  display: -webkit-box;\n  font-size: ", "px;\n  margin-bottom: 2px;\n  overflow: hidden;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n\n  @media (min-width: ", ") {\n    -webkit-line-clamp: 1;\n  }\n"])), function (props) { return props.color; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.breakpoints[2]; });
var FbtPriceWrapper$1 = customStyled(Flex)(templateObject_15$m || (templateObject_15$m = __makeTemplateObject(["\n  color: ", " !important;\n  align-items: center;\n  margin-top: 2px;\n"], ["\n  color: ", " !important;\n  align-items: center;\n  margin-top: 2px;\n"])), function (props) { return props.color; });
var FbtPriceOriginal$1 = customStyled.div(templateObject_16$g || (templateObject_16$g = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n\n  ", "\n"], ["\n  align-items: center;\n  display: flex;\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n\n  ",
    "\n"])), function (props) { return (props.isError ? 'red' : 'black'); }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.fontWeights[5]; }, function (props) {
    return props.hasDiscount
        ? "\n      color: " + (props.isError ? props.theme.colors.red : props.theme.colors.silverChalice) + ";\n      font-size: " + props.theme.fontSizes[0] + "px;\n      font-weight: normal;\n      margin-left: " + props.theme.space[1] + "px;\n      text-decoration: line-through;\n    "
        : '';
});
var FbtPriceDiscount$1 = customStyled(FbtPriceOriginal$1)(templateObject_17$g || (templateObject_17$g = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) { return props.theme.colors.red; });
var FbtProductWeight$1 = customStyled.div(templateObject_18$d || (templateObject_18$d = __makeTemplateObject(["\n  color: ", ";\n  display: inline-block;\n  font-size: ", "px;\n  margin-left: ", "px;\n  vertical-align: middle;\n"], ["\n  color: ", ";\n  display: inline-block;\n  font-size: ", "px;\n  margin-left: ", "px;\n  vertical-align: middle;\n"])), function (props) { return (props.isError ? props.theme.colors.red : props.theme.colors.silverChalice); }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.space[1]; });
var FbtProductErrorDetail$1 = customStyled(Text)(templateObject_19$d || (templateObject_19$d = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", "px;\n    grid-column-start: 1;\n    grid-column-end: 3;\n    margin-bottom: 0;\n\n    @media (min-width: ", ") {\n      margin-top: 12px;\n    }\n"], ["\n    color: ", ";\n    font-size: ", "px;\n    grid-column-start: 1;\n    grid-column-end: 3;\n    margin-bottom: 0;\n\n    @media (min-width: ", ") {\n      margin-top: 12px;\n    }\n"])), function (props) { return props.theme.colors.red; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.breakpoints[2]; });
var FbtCartElementsWrapper$1 = customStyled(Flex)(templateObject_20$b || (templateObject_20$b = __makeTemplateObject(["\n  align-items: center;\n  grid-column-start: 1;\n  grid-column-end: 3;\n  justify-content: flex-end;\n  margin-top: 12px;\n\n  @media (min-width: ", ") {\n    justify-content: flex-start;\n  }\n"], ["\n  align-items: center;\n  grid-column-start: 1;\n  grid-column-end: 3;\n  justify-content: flex-end;\n  margin-top: 12px;\n\n  @media (min-width: ", ") {\n    justify-content: flex-start;\n  }\n"])), function (props) { return props.theme.breakpoints[2]; });
var FbtCartElementsLoaderWrapper$1 = customStyled(Flex)(templateObject_21$a || (templateObject_21$a = __makeTemplateObject(["\n  justify-content: center;\n  min-width: 106px;\n  padding: 0 12px;\n"], ["\n  justify-content: center;\n  min-width: 106px;\n  padding: 0 12px;\n"])));
var FbtCartElementsBtn$1 = customStyled(Button$1)(templateObject_22$a || (templateObject_22$a = __makeTemplateObject(["\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  fill: ", ";\n  rect {\n    fill: ", ";\n  }\n\n  ", "\n"], ["\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  fill: ", ";\n  rect {\n    fill: ", ";\n  }\n\n  ",
    "\n"])), function (props) { return props.theme.colors.white; }, function (props) { return props.theme.colors.white; }, function (props) {
    return props.decrement
        ? "\n    &:not([disabled]) {\n      background-color: #ff5a57;\n    }\n\n    &:disabled path {\n      fill: " + props.theme.colors.white + ";\n    }\n  "
        : '';
});
FbtCartElementsBtn$1.defaultProps = {
    round: true,
    size: '30px',
    padding: 0,
};
var FbtQuantitySelect$1 = customStyled(Select)(templateObject_23$8 || (templateObject_23$8 = __makeTemplateObject(["\n  width: auto;\n  margin: 0;\n\n &[disabled] {\n   cursor: not-allowed;\n   opacity: 0.5;\n   pointer-events: none;\n }\n\n  > div {\n    height: 30px;\n    margin: 0;\n    padding-bottom: 0;\n    padding-top: 0;\n\n    > div {\n      width: 82px;\n      justify-content: center;\n      font-weight: ", ";\n\n      > span {\n        font-size: 12px;\n        margin-right: ", "px;\n        width: auto;\n        text-align: center;\n      }\n    }\n  }\n"], ["\n  width: auto;\n  margin: 0;\n\n &[disabled] {\n   cursor: not-allowed;\n   opacity: 0.5;\n   pointer-events: none;\n }\n\n  > div {\n    height: 30px;\n    margin: 0;\n    padding-bottom: 0;\n    padding-top: 0;\n\n    > div {\n      width: 82px;\n      justify-content: center;\n      font-weight: ", ";\n\n      > span {\n        font-size: 12px;\n        margin-right: ", "px;\n        width: auto;\n        text-align: center;\n      }\n    }\n  }\n"])), function (props) { return props.theme.fontWeights[5]; }, function (props) { return props.theme.space[2]; });
var FbtErrorList$1 = customStyled.ul(templateObject_24$6 || (templateObject_24$6 = __makeTemplateObject(["\n  list-style-type: ", ";\n  margin-left: ", ";\n\n  li {\n    color: ", ";\n    font-weight: ", ";\n\n    &:not(:first-of-type) {\n      margin-top: ", "px;\n    }\n  }\n"], ["\n  list-style-type: ", ";\n  margin-left: ", ";\n\n  li {\n    color: ", ";\n    font-weight: ", ";\n\n    &:not(:first-of-type) {\n      margin-top: ", "px;\n    }\n  }\n"])), function (props) { return (props.hasBullet ? 'disc' : 'none'); }, function (props) { return (props.hasBullet ? '16px' : 0); }, function (props) { return props.theme.colors.red; }, function (props) { return props.theme.fontWeights[5]; }, function (props) { return props.theme.space[1]; });
var RetryText$1 = customStyled(Text)(templateObject_25$6 || (templateObject_25$6 = __makeTemplateObject(["\n  color: ", ";\n  cursor: pointer;\n  font-weight: ", ";\n  text-transform: capitalize;\n"], ["\n  color: ", ";\n  cursor: pointer;\n  font-weight: ", ";\n  text-transform: capitalize;\n"])), function (props) { return props.theme.colors.copy; }, function (props) { return props.theme.fontWeights[6]; });
var FbtMobileElements$1 = customStyled.div(templateObject_26$6 || (templateObject_26$6 = __makeTemplateObject(["\n    font-size: ", "px;\n    font-weight: ", ";\n    width: auto;\n    text-align: center;\n"], ["\n    font-size: ", "px;\n    font-weight: ", ";\n    width: auto;\n    text-align: center;\n"])), function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.fontWeights[5]; });
var FbtTextSection$1 = customStyled(Flex)(templateObject_27$6 || (templateObject_27$6 = __makeTemplateObject(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
var SponsoredText$1 = customStyled.div(templateObject_28$4 || (templateObject_28$4 = __makeTemplateObject(["\n    font-weight: ", ";\n    margin-left:  ", "px;\n    border-radius: ", "px;\n    font-size: 13px;\n    color: #20B0E6;\n    padding: 4px 6px;\n    background: #EFF3F8;\n"], ["\n    font-weight: ", ";\n    margin-left:  ", "px;\n    border-radius: ", "px;\n    font-size: 13px;\n    color: #20B0E6;\n    padding: 4px 6px;\n    background: #EFF3F8;\n"])), function (props) { return props.theme.fontWeights[4]; }, function (props) { return props.theme.space[2]; }, function (props) { return props.theme.radii[1]; });
var templateObject_1$1I, templateObject_2$1o, templateObject_3$17, templateObject_4$Z, templateObject_5$L, templateObject_6$B, templateObject_7$z, templateObject_8$z, templateObject_9$w, templateObject_10$v, templateObject_11$p, templateObject_12$n, templateObject_13$m, templateObject_14$m, templateObject_15$m, templateObject_16$g, templateObject_17$g, templateObject_18$d, templateObject_19$d, templateObject_20$b, templateObject_21$a, templateObject_22$a, templateObject_23$8, templateObject_24$6, templateObject_25$6, templateObject_26$6, templateObject_27$6, templateObject_28$4;

function unwrapExports$1 (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule$1(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable$1 = Object.prototype.propertyIsEnumerable;
function toObject$1(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}
	return Object(val);
}
function shouldUseNative$1() {
	try {
		if (!Object.assign) {
			return false;
		}
		var test1 = new String('abc');
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}
		return true;
	} catch (err) {
		return false;
	}
}
var objectAssign$1 = shouldUseNative$1() ? Object.assign : function (target, source) {
	var from;
	var to = toObject$1(target);
	var symbols;
	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);
		for (var key in from) {
			if (hasOwnProperty$1.call(from, key)) {
				to[key] = from[key];
			}
		}
		if (getOwnPropertySymbols$1) {
			symbols = getOwnPropertySymbols$1(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable$1.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}
	return to;
};

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1$1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$2 = function() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$3 = ReactPropTypesSecret_1$1;
  var loggedTypeFailures$1 = {};
  var has$3 = has$2;
  printWarning$2 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {  }
  };
}
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$3(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$3);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$2(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures$1)) {
          loggedTypeFailures$1[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$2(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures$1 = {};
  }
};
var checkPropTypes_1$1 = checkPropTypes$1;

var printWarning$3 = function() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$3 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull$1() {
  return null;
}
var factoryWithTypeCheckers$1 = function(isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1$1) {
        if (throwOnDirectAccess) {
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            manualPropTypeWarningCount < 3
          ) {
            printWarning$3(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull$1);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$3(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$3('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull$1;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$2(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$3('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull$1;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$3(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull$1;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$2(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = objectAssign$1({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$2(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1$1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1$1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction$1() {}
function emptyFunctionWithReset$1() {}
emptyFunctionWithReset$1.resetWarningCache = emptyFunction$1;
var factoryWithThrowingShims$1 = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1$1) {
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset$1,
    resetWarningCache: emptyFunction$1
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes$1 = createCommonjsModule$1(function (module) {
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers$1(ReactIs.isElement, throwOnDirectAccess);
} else {
  module.exports = factoryWithThrowingShims$1();
}
});

var rng$1 = function nodeRNG() {
  return crypto.randomBytes(16);
};

var byteToHex$1 = [];
for (var i$3 = 0; i$3 < 256; ++i$3) {
  byteToHex$1[i$3] = (i$3 + 0x100).toString(16).substr(1);
}
function bytesToUuid$1(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex$1;
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}
var bytesToUuid_1$1 = bytesToUuid$1;

var _nodeId$1;
var _clockseq$1;
var _lastMSecs$1 = 0;
var _lastNSecs$1 = 0;
function v1$1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];
  options = options || {};
  var node = options.node || _nodeId$1;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq$1;
  if (node == null || clockseq == null) {
    var seedBytes = rng$1();
    if (node == null) {
      node = _nodeId$1 = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      clockseq = _clockseq$1 = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs$1 + 1;
  var dt = (msecs - _lastMSecs$1) + (nsecs - _lastNSecs$1)/10000;
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }
  if ((dt < 0 || msecs > _lastMSecs$1) && options.nsecs === undefined) {
    nsecs = 0;
  }
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }
  _lastMSecs$1 = msecs;
  _lastNSecs$1 = nsecs;
  _clockseq$1 = clockseq;
  msecs += 12219292800000;
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;
  b[i++] = tmh >>> 24 & 0xf | 0x10;
  b[i++] = tmh >>> 16 & 0xff;
  b[i++] = clockseq >>> 8 | 0x80;
  b[i++] = clockseq & 0xff;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }
  return buf ? buf : bytesToUuid_1$1(b);
}
var v1_1$1 = v1$1;

function v4$1(options, buf, offset) {
  var i = buf && offset || 0;
  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};
  var rnds = options.random || (options.rng || rng$1)();
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }
  return buf || bytesToUuid_1$1(rnds);
}
var v4_1$1 = v4$1;

var uuid$1 = v4_1$1;
uuid$1.v1 = v1_1$1;
uuid$1.v4 = v4_1$1;
var uuid_1$1 = uuid$1;

var State_1$1 = createCommonjsModule$1(function (module, exports) {
exports.__esModule = true;
var _react2 = _interopRequireDefault(React);
var _propTypes2 = _interopRequireDefault(propTypes$1);
var _uuid2 = _interopRequireDefault(uuid_1$1);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var State = function (_Component) {
  _inherits(State, _Component);
  function State(props) {
    _classCallCheck(this, State);
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
    _this.stateStore = _this.props.store;
    _this.state = _this.stateStore.state;
    return _this;
  }
  State.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;
    this.subscription = this.stateStore.subscribe(function (state) {
      return _this2.setState(state);
    });
  };
  State.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stateStore.unSubscribe(this.subscription);
  };
  State.prototype.render = function render() {
    var state = this.props.parseState ? this.props.parseState(this.state) : this.state;
    if (!this.props.children) {
      throw new Error("Please add at least one child element.");
    }
    if (typeof this.props.children === "function") {
      return this.props.children(state);
    }
    if (Array.isArray(this.props.children)) {
      return this.props.children.map(function (child) {
        return (0, React.cloneElement)(child, state);
      });
    }
    return (0, React.cloneElement)(this.props.children, state);
  };
  return State;
}(React.Component);
exports.default = State;
});
unwrapExports$1(State_1$1);

var Store_1$1 = createCommonjsModule$1(function (module, exports) {
exports.__esModule = true;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
var _uuid2 = _interopRequireDefault(uuid_1$1);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var Store = function () {
  function Store(state) {
    _classCallCheck(this, Store);
    this.state = {};
    this.callbacks = [];
    this.state = _extends({}, state);
  }
  Store.prototype.set = function set(newState) {
    var _this = this;
    this.state = _extends({}, this.state, newState);
    this.callbacks.forEach(function (callback) {
      return callback.callback(_this.state);
    });
  };
  Store.prototype.get = function get(key) {
    if (key) {
      return this.state[key];
    }
    return this.state;
  };
  Store.prototype.subscribe = function subscribe(callback) {
    var subscription = (0, _uuid2.default)();
    this.callbacks.push({ subscription: subscription, callback: callback });
    return subscription;
  };
  Store.prototype.unSubscribe = function unSubscribe(subscription) {
    var _this2 = this;
    this.callbacks.forEach(function (callback, index) {
      if (callback.subscription === subscription) {
        _this2.callbacks.splice(index, 1);
      }
    });
  };
  return Store;
}();
exports.default = Store;
});
unwrapExports$1(Store_1$1);

var StateDecorator_1$1 = createCommonjsModule$1(function (module, exports) {
exports.__esModule = true;
var _react2 = _interopRequireDefault(React);
var _State2 = _interopRequireDefault(State_1$1);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var StateDecorator = function StateDecorator(store) {
  var parseState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
    return state;
  };
  return function (storyFn) {
    return _react2.default.createElement(
      _State2.default,
      { store: store, parseState: parseState },
      storyFn()
    );
  };
};
exports.default = StateDecorator;
});
unwrapExports$1(StateDecorator_1$1);

var dist$1 = createCommonjsModule$1(function (module, exports) {
exports.__esModule = true;
exports.StateDecorator = exports.Store = exports.State = undefined;
var _State3 = _interopRequireDefault(State_1$1);
var _Store3 = _interopRequireDefault(Store_1$1);
var _StateDecorator3 = _interopRequireDefault(StateDecorator_1$1);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.State = _State3.default;
exports.Store = _Store3.default;
exports.StateDecorator = _StateDecorator3.default;
});
unwrapExports$1(dist$1);
var dist_1$1 = dist$1.StateDecorator;
var dist_2$1 = dist$1.Store;
var dist_3$1 = dist$1.State;

var initialState$3 = {
    quantity: 1,
    max: 1000,
    min: 1,
    loading: false,
    inCart: false,
    delta: 1,
};
var store$1 = new dist_2$1(initialState$3);
var getProductIdAsPerOffer = function (product) {
    var productId = product.productId, _a = product.offers, offers = _a === void 0 ? [] : _a;
    var firstOffer = (offers && offers.length && offers[0]) || null;
    var id = productId;
    if (firstOffer && (firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.sellerName) !== 'Carrefour') {
        id = firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.id;
    }
    return id;
};

var FbtCartElements = function (_a) {
    var _b;
    var product = _a.product, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d, _e = _a.inCartQty, inCartQty = _e === void 0 ? 0 : _e;
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    var _f = useSelector(function (state) { return (__assign(__assign({}, state.appConfig), { miniCart: state.miniCart })); }), miniCart = _f.miniCart, code = _f.code;
    var dispatch = useDispatch();
    var _g = __read(useState(false), 2), showMobileElement = _g[0], setShowMobileElement = _g[1];
    var isV4Basket = (_b = useFeature('basket_v4_fbt')) === null || _b === void 0 ? void 0 : _b.on;
    var incrementBy = product.incrementBy, max = product.max, min = product.min, unitOfMeasure = product.unitOfMeasure, isScalable = product.isScalable, discount = product.discount, minBuyValue = product.minBuyingValue, originalPrice = product.originalPrice, _h = product.offers, offers = _h === void 0 ? [] : _h;
    var offerId = '';
    var firstOffer = (offers && offers.length && offers[0]) || null;
    if (firstOffer && (firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.sellerName) !== 'Carrefour') {
        offerId = firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.id;
    }
    var uniqueEntryId = getUniqueEntryId$1(product.productId, offerId, (firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.shippingIndicator) || '');
    var handleResize = useCallback(function () {
        if (window.innerWidth < 576) {
            setShowMobileElement(true);
        }
        else {
            setShowMobileElement(false);
        }
    }, []);
    useEffect(function () {
        if (!isBrowser$1())
            return;
        window.addEventListener('resize', handleResize);
        window.dispatchEvent(new Event('resize'));
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);
    var quantityList = useMemo(function () {
        return generateQuantityList$1({ incrementBy: incrementBy, soldByWeight: unitOfMeasure === KG_LABEL$1, max: max, min: min });
    }, [incrementBy, max, min, unitOfMeasure]);
    var gtmCallBack = useCallback(function (selectedQuantity, eventType) {
        var _a;
        var gtmCommonData = getCommonGtmData$1({
            selectedQuantity: selectedQuantity,
            quantity: (_a = miniCart === null || miniCart === void 0 ? void 0 : miniCart.entries[uniqueEntryId]) === null || _a === void 0 ? void 0 : _a.quantity,
            incrementBy: incrementBy,
            minBuyValue: minBuyValue,
            originalPrice: originalPrice,
            productDiscount: discount,
            soldByWeight: isScalable,
            min: min,
        });
        if (eventType === GTMEvents$1.add_to_cart) {
            GTMEventCall(GTMEvents$1.add_to_cart, __assign(__assign({ product: product, position: product === null || product === void 0 ? void 0 : product.position, ga4: true }, gtmCommonData), { countryCode: code }));
        }
        else {
            GTMEventCall(GTMEvents$1.remove_from_cart, __assign(__assign({ product: product, position: product === null || product === void 0 ? void 0 : product.position, ga4: true }, gtmCommonData), { countryCode: code }));
        }
    }, [
        miniCart,
        GTMEventCall,
        incrementBy,
        code,
        discount,
        isScalable,
        product,
        originalPrice,
        minBuyValue,
        min,
        uniqueEntryId,
    ]);
    var onChange = useCallback(function (quantity) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var currentQuantity = (_b = (_a = miniCart === null || miniCart === void 0 ? void 0 : miniCart.entries) === null || _a === void 0 ? void 0 : _a[uniqueEntryId]) === null || _b === void 0 ? void 0 : _b.quantity;
        if (quantity.value !== inCartQty) {
            var offerId_1 = getProductIdAsPerOffer(product);
            dispatch(updateCart$1(product.productId, quantity.value, {
                offerId: offerId_1,
                productName: product.name,
                productImageURL: (_c = product === null || product === void 0 ? void 0 : product.image) === null || _c === void 0 ? void 0 : _c.href,
                pis: ((_f = (_e = (_d = product.offers) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.purchaseIndicators) === null || _f === void 0 ? void 0 : _f.SHIPPING) || [],
                shippingIndicator: ((_h = (_g = product.offers) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.shippingIndicator) || '',
                shopId: (_k = (_j = product.offers) === null || _j === void 0 ? void 0 : _j[0]) === null || _k === void 0 ? void 0 : _k.shopId,
                shopName: (_m = (_l = product.offers) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.shop,
                isSoldByWeight: product.soldByWeight,
                isV4Basket: isV4Basket,
                gtmCallBack: function () {
                    return gtmCallBack(quantity.value, quantity.value > currentQuantity ? GTMEvents$1.add_to_cart : GTMEvents$1.remove_from_cart);
                },
            }));
        }
    }, [dispatch, inCartQty, product, isV4Basket, gtmCallBack, miniCart, uniqueEntryId]);
    var _j = __read(useProductCardHandlers$1(__assign(__assign({}, product), { quantity: inCartQty }), isV4Basket), 4), onDecrement = _j[1], onIncrement = _j[2], onRemove = _j[3];
    var isMin = useMemo(function () { return inCartQty === product.min; }, [inCartQty, product.min]);
    var actionsDisabled = disabled || isLoading;
    return (React.createElement(FbtCartElementsWrapper$1, null, showMobileElement && !isLoading ? (React.createElement(FbtMobileElements$1, null,
        React.createElement(CartElements$1, { disabled: disabled, isLoading: isLoading, incrementBy: product.incrementBy, inCart: true, max: max, min: min, quantity: inCartQty, soldByWeight: product.unitOfMeasure === KG_LABEL$1, onDecrementHandler: onDecrement, onIncrementHandler: onIncrement, onRemoveHandler: onRemove, selectOnChange: onChange, productImage: product.image.href, onlineName: product.name, variant: "fbt", isSticky: true }))) : (React.createElement(React.Fragment, null,
        React.createElement(FbtCartElementsBtn$1, { decrement: isMin, onClick: isMin ? onRemove : onDecrement, disabled: actionsDisabled }, isMin ? React.createElement(Trash, null) : React.createElement(MinusAlt, null)),
        !isLoading ? (React.createElement(FbtQuantitySelect$1, { disabled: actionsDisabled, value: inCartQty, onChange: onChange, options: quantityList })) : (React.createElement(FbtCartElementsLoaderWrapper$1, null,
            React.createElement(FbtCTALoader$1, { color: "red" }))),
        React.createElement(FbtCartElementsBtn$1, { onClick: onIncrement, disabled: actionsDisabled || inCartQty === product.max },
            React.createElement(PlusAlt, null))))));
};

var Fbt = function (_a) {
    var _b;
    var relevantId = _a.relevantId, mainGaListName = _a.mainGaListName, onError = _a.onError, passedInRef = _a.passedInRef, productL1Category = _a.productL1Category, rest = __rest(_a, ["relevantId", "mainGaListName", "onError", "passedInRef", "productL1Category"]);
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _c = useAnalytic$1(), GTMEventCall = _c.GTMEventCall, EventCall = _c.EventCall;
    var _d = useSelector(function (state) { return (__assign(__assign({}, state.appConfig), { miniCart: state.miniCart, productCard: state.productCard, productList: state.productList })); }), miniCart = _d.miniCart, productCard = _d.productCard, productList = _d.productList, features = _d.features, code = _d.code, language = _d.language, currency = _d.currency, pageName = _d.pageName;
    var _e = __read(useState([]), 2), products = _e[0], setProducts = _e[1];
    var _f = __read(useState(false), 2), isSponsoredFbt = _f[0], setIsSponsoredFbt = _f[1];
    var _g = __read(useState([]), 2), selected = _g[0], setSelected = _g[1];
    var _h = __read(useState(false), 2), isReq = _h[0], setIsReq = _h[1];
    var _j = __read(useState(false), 2), reqDone = _j[0], setReqDone = _j[1];
    var _k = __read(useInView$1({ threshold: 0 }), 2), inViewRef = _k[0], inView = _k[1];
    var device = useBreakpoints();
    var isV4Basket = (_b = useFeature('basket_v4_fbt')) === null || _b === void 0 ? void 0 : _b.on;
    var isMobile = device.isMobile;
    var sponsoredStrategyName = 'SponsoredProducts';
    useEffect(function () {
        function getProducts() {
            return __awaiter(this, void 0, void 0, function () {
                var relevance, _a, _b, mainProducts, relevantProducts, _c, _d, recommendedProducts, strategyName_1, _e, _f, sponsoredProducts, sponsoredProdStrategyName_1, transformedProducts, finalProducts;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0: return [4 /*yield*/, ProductServices$3.getRelevance({
                                id: relevantId,
                                placements: 'personal_page.echo_seed|item_page.frequently_bought_together_web',
                            }, features === null || features === void 0 ? void 0 : features.isSponsoredFbtEnabled, productL1Category)];
                        case 1:
                            relevance = _g.sent();
                            if (relevance === null || relevance === void 0 ? void 0 : relevance.length) {
                                _a = __read(relevance, 2), _b = _a[0].recommendedProducts, mainProducts = _b === void 0 ? [] : _b, relevantProducts = _a[1];
                                _c = relevantProducts || {}, _d = _c.recommendedProducts, recommendedProducts = _d === void 0 ? [] : _d, strategyName_1 = _c.strategyName;
                                _e = relevance[0], _f = _e.recommendedProducts, sponsoredProducts = _f === void 0 ? [] : _f, sponsoredProdStrategyName_1 = _e.strategyName;
                                if ((relevance === null || relevance === void 0 ? void 0 : relevance.length) === 1 && sponsoredProdStrategyName_1 === sponsoredStrategyName) {
                                    setIsSponsoredFbt(true);
                                }
                                if (recommendedProducts.length > 0 || sponsoredProdStrategyName_1 === sponsoredStrategyName) {
                                    transformedProducts = (sponsoredProdStrategyName_1 !== sponsoredStrategyName
                                        ? recommendedProducts
                                        : sponsoredProducts)
                                        .slice(0, sponsoredProdStrategyName_1 !== sponsoredStrategyName ? 2 : 3)
                                        .filter(function (p) { return p.isAvailable; })
                                        .map(function (p, index) {
                                        return __assign(__assign({}, p), { position: index + 1, gaListName: "fbt|" + gtmSnakeCase$1(t('frequentlyBoughtTogether.title')).toLocaleLowerCase() + "|" + (sponsoredProdStrategyName_1 !== sponsoredStrategyName
                                                ? strategyName_1
                                                : sponsoredProdStrategyName_1).toLocaleLowerCase() });
                                    });
                                    if (mainProducts === null || mainProducts === void 0 ? void 0 : mainProducts.length)
                                        mainProducts[0].gaListName = mainGaListName;
                                    finalProducts = sponsoredProdStrategyName_1 !== sponsoredStrategyName
                                        ? __spread(mainProducts, transformedProducts) : __spread(transformedProducts);
                                    setSelected(new Array(finalProducts.length).fill(true));
                                    setProducts(finalProducts);
                                }
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        // if (zoneId) {
        getProducts();
        //  }
    }, [mainGaListName, relevantId, t, features, productL1Category]);
    /**
     * GTM Handlers
     */
    var onProductClickHandler = useCallback(function (p) { return function (evt) {
        evt.preventDefault();
        var _a = getGa4AlgoliaEventsParams$1(), experimentKey = _a.experimentKey, variationId = _a.variationId;
        if (variationId && experimentKey) {
            GTMEventCall(GTMEvents$1.algolia_custom_events, {
                experiment_key: experimentKey,
                variation_id: variationId,
                pageData: { language: language, currency: currency },
            });
        }
        Promise.resolve(clickAlgoliaOperation$1({ searchQueryID: '', productId: p.productId, productPosition: '', sortBy: '' }, dispatch));
        GTMEventCall(GTMEvents$1.product_click, { product: p, position: p.position, ga4: false });
        GTMEventCall(GTMEvents$1.product_click, { product: p, position: p.position, ga4: true, countryCode: code });
        Promise.resolve(EventCall(GTMEvents$1.product_click, p));
        window.location.href = p.url;
    }; }, [dispatch, GTMEventCall, code, EventCall, currency, language]);
    var onRightClickHandler = useCallback(function (p) { return function (event) {
        event.stopPropagation();
        if (p.isSponsored) {
            Promise.resolve(EventCall(GTMEvents$1.right_click, p));
        }
    }; }, [EventCall]);
    /**
     * Product impressions
     */
    useEffect(function () {
        if (inView && products.length > 0) {
            products.forEach(function (p) {
                GTMEventCall(GTMEvents$1.product_impressions, { product: p, position: p.position, ga4: false });
                GTMEventCall(GTMEvents$1.product_impressions, { product: p, position: p.position, ga4: true });
                if (!isImpressionTracked$1(p) && p.isSponsored) {
                    Promise.resolve(EventCall(GTMEvents$1.product_impression, p));
                }
            });
        }
    }, [GTMEventCall, EventCall, inView, products, products.length]);
    // Main product loading
    var mainProductLoading = useMemo(function () { var _a, _b; return (_b = productCard[(_a = products[0]) === null || _a === void 0 ? void 0 : _a.productId]) === null || _b === void 0 ? void 0 : _b.loading; }, [productCard, products]);
    // Render KG
    var renderWeight = useCallback(function (kg, min, isError) {
        return kg === KG_LABEL$1 && (React.createElement(FbtProductWeight$1, { "data-testid": "weight", isError: isError },
            "(",
            min,
            " ",
            kg,
            ")"));
    }, []);
    /**
     * Render original and discounted price
     */
    var renderPrice = useCallback(function (p, isError) {
        var _a;
        var currency = p.currency, currencyPosition = p.currencyPosition, discount = p.discount, min = p.min, originalPrice = p.originalPrice, unitOfMeasure = p.unitOfMeasure;
        var isDiscounted = ((_a = p.discount) === null || _a === void 0 ? void 0 : _a.type) !== 'none';
        var isFoodProduct = unitOfMeasure === KG_LABEL$1;
        var origPrice = isFoodProduct ? originalPrice * min : originalPrice;
        var discountedPrice = isDiscounted ? discount === null || discount === void 0 ? void 0 : discount.price : 0;
        if (isFoodProduct) {
            discountedPrice = discountedPrice * min;
        }
        return (React.createElement(React.Fragment, null,
            isDiscounted && discount && (React.createElement(FbtPriceDiscount$1, { "data-testid": "discount" },
                formatPrice$1(Math.round(discountedPrice * 100) / 100, currency, currencyPosition),
                renderWeight(p.unitOfMeasure, min, isError))),
            React.createElement(FbtPriceOriginal$1, { isError: isError, hasDiscount: isDiscounted },
                formatPrice$1(Math.round(origPrice * 100) / 100, currency, currencyPosition),
                !isDiscounted && renderWeight(p.unitOfMeasure, min, isError))));
    }, [renderWeight]);
    var onChangeCheckbox = useCallback(function (i) { return function () {
        var arr = __spread(selected);
        arr[i] = !arr[i];
        setSelected(arr);
    }; }, [selected]);
    /**
     * Normalize error messages
     */
    var normalizeErrMsg = useCallback(function (msg, productName) {
        switch (msg) {
            case ECartAPINotification$1.OUT_OF_STOCK:
                return t('frequentlyBoughtTogether.error.oos', { productName: productName });
            default:
                return t('frequentlyBoughtTogether.error.defaultMessage', { productName: productName });
        }
    }, [t]);
    /**
     * Get ids of fbt products existing in mini cart
     */
    var inCartIds = useMemo(function () {
        var ids = [];
        products.forEach(function (p) {
            var productId = p.productId, _a = p.offers, offers = _a === void 0 ? [] : _a;
            var offerId = '';
            var firstOffer = (offers && offers.length && offers[0]) || null;
            if (firstOffer && (firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.sellerName) !== 'Carrefour') {
                offerId = firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.id;
            }
            var uniqueEntryId = getUniqueEntryId$1(productId, offerId, (firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.shippingIndicator) || '');
            var inCart = !isUndefined$1(miniCart.entries[uniqueEntryId]);
            if (inCart) {
                ids.push(productId);
            }
        });
        return ids;
    }, [miniCart.entries, products]);
    /**
     * Get error products
     */
    var errorProducts = useMemo(function () {
        return products.filter(function (product) {
            var _a;
            var productId = product.productId;
            var _b = (((_a = productCard[productId]) === null || _a === void 0 ? void 0 : _a.persistentError) || {}).error, error = _b === void 0 ? false : _b;
            return error;
        });
    }, [productCard, products]);
    /**
     * Array of generic error messages
     */
    var genericErrMsg = useMemo(function () {
        return errorProducts
            .filter(function (p) {
            var _a;
            var _b = (((_a = productCard[p.productId]) === null || _a === void 0 ? void 0 : _a.persistentError) || {}).errDetail, errDetail = _b === void 0 ? '' : _b;
            return errDetail !== ECartAPINotification$1.OUT_OF_STOCK;
        })
            .map(function (p) {
            var _a;
            var name = p.name, productId = p.productId;
            var _b = (((_a = productCard[productId]) === null || _a === void 0 ? void 0 : _a.persistentError) || {}).errDetail, errDetail = _b === void 0 ? '' : _b;
            return normalizeErrMsg(errDetail, name);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productList.disabled]);
    /**
     * Get error product ids
     */
    var errorProductIds = useMemo(function () { return errorProducts.map(function (p) { return p.productId; }); }, [errorProducts]);
    /**
     * Get selected products without errors and not in cart
     */
    var selectedProducts = useMemo(function () {
        if (products.length > 0) {
            var arr_1 = [];
            products.forEach(function (p, i) {
                var productId = p.productId, _a = p.offers, offers = _a === void 0 ? [] : _a;
                var offerId = '';
                var firstOffer = (offers && offers.length && offers[0]) || null;
                if (firstOffer && (firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.sellerName) !== 'Carrefour') {
                    offerId = firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.id;
                }
                var uniqueEntryId = getUniqueEntryId$1(productId, offerId, (firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.shippingIndicator) || '');
                var inCart = !isUndefined$1(miniCart.entries[uniqueEntryId]);
                var hasError = errorProductIds.indexOf(productId) > -1;
                if (!inCart && !hasError && selected[i]) {
                    arr_1.push(p);
                }
            });
            return arr_1;
        }
        else {
            return [];
        }
    }, [errorProductIds, miniCart.entries, products, selected]);
    /**
     * Get text depending on selected length
     */
    var getSelectedText = useCallback(function () {
        switch (selectedProducts.length) {
            case 0:
                return t('addToCart');
            case 1:
                return t('frequentlyBoughtTogether.addThisToCart');
            case 2:
                return t('frequentlyBoughtTogether.addBothToCart');
            default:
                return t('frequentlyBoughtTogether.addAllToCart');
        }
    }, [selectedProducts.length, t]);
    /**
     * Only compute total price
     * - if not in cart from miniCart state
     * - if not error from productCard state
     * - If its selected
     */
    var getTotalPrice = useCallback(function () {
        if (products.length > 0) {
            var totalPrice_1 = 0;
            var formattedPrice_1;
            selected.forEach(function (b, i) {
                var _a = products[i], currency = _a.currency, currencyPosition = _a.currencyPosition, discount = _a.discount, min = _a.min, originalPrice = _a.originalPrice, productId = _a.productId, unitOfMeasure = _a.unitOfMeasure, _b = _a.offers, offers = _b === void 0 ? [] : _b;
                var offerId = '';
                var firstOffer = (offers && offers.length && offers[0]) || null;
                if (firstOffer && (firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.sellerName) !== 'Carrefour') {
                    offerId = firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.id;
                }
                var uniqueEntryId = getUniqueEntryId$1(productId, offerId, (firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.shippingIndicator) || '');
                var inCart = !isUndefined$1(miniCart.entries[uniqueEntryId]);
                var hasError = errorProductIds.indexOf(productId) > -1;
                var hasDiscount = (discount === null || discount === void 0 ? void 0 : discount.type) !== 'none';
                var isFoodProduct = unitOfMeasure === KG_LABEL$1;
                var origPrice = isFoodProduct ? originalPrice * min : originalPrice;
                var discountedPrice = hasDiscount ? discount === null || discount === void 0 ? void 0 : discount.price : 0;
                if (isFoodProduct) {
                    discountedPrice = discountedPrice * min;
                }
                if (!inCart && !hasError && b) {
                    totalPrice_1 += hasDiscount ? +discountedPrice.toFixed(2) : +origPrice.toFixed(2);
                }
                if (i === products.length - 1) {
                    formattedPrice_1 = formatPrice$1(totalPrice_1, currency, currencyPosition);
                }
            });
            return totalPrice_1 > 0 ? ['(', formattedPrice_1, ')'] : null;
        }
    }, [errorProductIds, miniCart.entries, products, selected]);
    /**
     * Render CTA content
     */
    var renderCTAContent = useCallback(function () {
        if (isReq) {
            return (React.createElement(Flex, { alignItems: "center", justifyContent: "center" },
                React.createElement(FbtCTALoader$1, null)));
        }
        return (React.createElement(React.Fragment, null,
            getSelectedText(),
            " ",
            getTotalPrice()));
    }, [getSelectedText, getTotalPrice, isReq]);
    /**
     * Remove CTA button by the following scenario:
     * - If everything is in cart, error
     * - If everything is error
     * - If everything is mix with in cart or error
     */
    var isVisibleCTA = useMemo(function () {
        var totalCount = inCartIds.length + errorProductIds.length;
        if (totalCount === products.length) {
            return false;
        }
        else {
            return true;
        }
    }, [errorProductIds.length, inCartIds.length, products.length]);
    /**
     * Add to cart callback when all of the request
     * are finished
     */
    var onReqEnd = useCallback(function () {
        setIsReq(false);
        setReqDone(true);
    }, []);
    /**
     * Trigger this only when adding via main button
     * GTM for decrement, increment, or selector will
     * be handled from FbtCartElements
     */
    useEffect(function () {
        if (inCartIds.length > 0 && reqDone) {
            products.forEach(function (p) {
                var _a = p.offers, offers = _a === void 0 ? [] : _a, productId = p.productId;
                var offerId = '';
                var firstOffer = (offers && offers.length && offers[0]) || null;
                if (firstOffer && (firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.sellerName) !== 'Carrefour') {
                    offerId = firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.id;
                }
                var uniqueEntryId = getUniqueEntryId$1(productId, offerId, (firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.shippingIndicator) || '');
                var inCart = !isUndefined$1(miniCart.entries[uniqueEntryId]);
                if (inCart) {
                    GTMEventCall(GTMEvents$1.add_to_cart, {
                        product: p,
                        quantity: miniCart.entries[uniqueEntryId].quantity,
                        position: p.position,
                        ga4: false,
                    });
                    GTMEventCall(GTMEvents$1.product_click, {
                        product: p,
                        position: p.position,
                    });
                    if (p.addToCartTrackingUrl) {
                        EventCall(GTMEvents$1.add_to_cart, p);
                    }
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [GTMEventCall, EventCall, reqDone]);
    var gtmCallBack = useCallback(function (props) {
        var min = props.min, incrementBy = props.incrementBy, position = props.position, soldByWeight = props.soldByWeight, minBuyValue = props.minBuyingValue, originalPrice = props.originalPrice;
        var gtmCommonData = getCommonGtmData$1({
            selectedQuantity: min,
            quantity: 0,
            incrementBy: incrementBy,
            min: min,
            minBuyValue: minBuyValue,
            originalPrice: originalPrice,
            productDiscount: props === null || props === void 0 ? void 0 : props.discount,
            soldByWeight: soldByWeight,
        });
        GTMEventCall(GTMEvents$1.add_to_cart, __assign(__assign({ product: props, position: position }, gtmCommonData), { currency: props === null || props === void 0 ? void 0 : props.currency, ga4: true, countryCode: code }));
    }, [code, GTMEventCall]);
    /**
     * Add to cart func
     */
    var onAddToCart = useCallback(function () {
        var _a = getGa4AlgoliaEventsParams$1(), experimentKey = _a.experimentKey, variationId = _a.variationId;
        if (variationId && experimentKey) {
            GTMEventCall(GTMEvents$1.algolia_custom_events, {
                experiment_key: experimentKey,
                variation_id: variationId,
                pageData: { language: language, currency: currency },
            });
        }
        setIsReq(true);
        setReqDone(false);
        dispatch(fbtAddToCart$1(selectedProducts, onReqEnd, isV4Basket, gtmCallBack));
    }, [dispatch, onReqEnd, selectedProducts, GTMEventCall, currency, language, isV4Basket, gtmCallBack]);
    var renderRetry = useCallback(function () {
        return React.createElement(RetryText$1, null, t('frequentlyBoughtTogether.retry'));
    }, [t]);
    var retryErrors = useCallback(function () {
        var _a = getGa4AlgoliaEventsParams$1(), experimentKey = _a.experimentKey, variationId = _a.variationId;
        if (variationId && experimentKey) {
            GTMEventCall(GTMEvents$1.algolia_custom_events, {
                experiment_key: experimentKey,
                variation_id: variationId,
                pageData: { language: language, currency: currency },
            });
        }
        setIsReq(true);
        setReqDone(false);
        dispatch(fbtAddToCart$1(errorProducts, onReqEnd, isV4Basket, gtmCallBack));
    }, [dispatch, errorProducts, onReqEnd, GTMEventCall, currency, language, isV4Basket, gtmCallBack]);
    useImperativeHandle(passedInRef, function () { return ({
        renderRetry: renderRetry,
        retryErrors: retryErrors,
    }); });
    /**
     * Run this only when genericErrMsg length changes
     * and when we pass onError func
     */
    useEffect(function () {
        if (genericErrMsg.length > 0 && onError) {
            onError(React.createElement(FbtErrorList$1, { hasBullet: genericErrMsg.length > 1 }, genericErrMsg.map(function (msg, i) { return (React.createElement("li", { key: "fbt-error-" + i }, msg)); })));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [genericErrMsg.length, onError, window.innerWidth]);
    useEffect(function () {
        // disable whole list of fbt if mainProduct is loading
        // this way fbt states are in sync
        if (mainProductLoading) {
            dispatch(setDisabled$1(true));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, mainProductLoading]);
    /**
     * Should render checkbox by the ff.
     * - Show only if there are no errors and if not in cart
     * - But only re-render if all three req are done or productList changes
     */
    var canRenderCheckbox = useCallback(function (id) {
        if (inCartIds.indexOf(id) > -1 || errorProductIds.indexOf(id) > -1) {
            return false;
        }
        return true;
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [productList.disabled]);
    var canRenderError = useCallback(function (id) {
        return errorProductIds.indexOf(id) > -1;
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [productList.disabled]);
    return (React.createElement(FbtWrapper$1, __assign({ "data-testid": "fbt-cmp", ref: inViewRef }, rest), products.length > 0 && (React.createElement(FbtWrappperInner$1, null,
        React.createElement(FbtHeader$1, null,
            React.createElement(FbtTextSection$1, null,
                React.createElement(Text, null, !isSponsoredFbt ? t('frequentlyBoughtTogether.title') : t('frequentlyBoughtTogether.recommended')),
                isSponsoredFbt && React.createElement(SponsoredText$1, null,
                    " ",
                    t('sponsored'))),
            isVisibleCTA && !isMobile && (React.createElement(FbtCTA$1, { testid: "add-to-cart", disabled: mainProductLoading || selectedProducts.length < 1 || productList.disabled, onClick: onAddToCart, id: pageName + "_fbt_add_to_cart" }, renderCTAContent()))),
        React.createElement(FbtProductList$1, { "data-testid": "product-list", productLen: products.length },
            products.map(function (p, i) {
                var _a, _b;
                var min = p.min, productId = p.productId, name = p.name, url = p.url, _c = p.image.href, href = _c === void 0 ? '' : _c, _d = p.offers, offers = _d === void 0 ? [] : _d;
                var hasError = errorProductIds.indexOf(productId) > -1;
                var isLoading = (_a = productCard[productId]) === null || _a === void 0 ? void 0 : _a.loading;
                var offerId = '';
                var firstOffer = (offers && offers.length && offers[0]) || null;
                if (firstOffer && (firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.sellerName) !== 'Carrefour') {
                    offerId = firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.id;
                }
                var uniqueEntryId = getUniqueEntryId$1(productId, offerId, (firstOffer === null || firstOffer === void 0 ? void 0 : firstOffer.shippingIndicator) || '');
                var inCart = isReq ? false : !isUndefined$1(miniCart.entries[uniqueEntryId]);
                var inCartQty = inCart ? miniCart.entries[uniqueEntryId].quantity : min;
                var _e = (((_b = productCard[productId]) === null || _b === void 0 ? void 0 : _b.persistentError) || {}).errDetail, errDetail = _e === void 0 ? '' : _e;
                return (React.createElement(FbtProduct$1, { "data-testid": "product", key: p.productId + "-" + i },
                    React.createElement(FbtProductHeading$1, null,
                        canRenderCheckbox(productId) && !inCart && (React.createElement(FbtCheckbox$1, { disabled: mainProductLoading || isLoading || productList.disabled, checked: selected[i], size: 18, onChangeCheckbox: onChangeCheckbox(i) })),
                        canRenderError(productId) && hasError && (React.createElement(FbtWarningWrapper$1, null,
                            React.createElement(WarningAlt, { size: "M" }))),
                        React.createElement(FbtProductImage$1, null,
                            React.createElement("a", { "data-testid": "product-image", href: url, title: name, onClick: onProductClickHandler(p), onContextMenu: onRightClickHandler(p) },
                                React.createElement(Image, { name: name, url: href })))),
                    React.createElement(FbtProductDetails$1, null,
                        React.createElement(FbtProductName$1, { color: canRenderError(productId) && hasError ? 'red' : 'black', "data-testid": "product-name", href: p.url, title: p.name, onClick: onProductClickHandler(p), onContextMenu: onRightClickHandler(p) },
                            React.createElement("span", { dangerouslySetInnerHTML: { __html: name } })),
                        React.createElement(FbtPriceWrapper$1, null, renderPrice(p, canRenderError(productId) && hasError))),
                    canRenderError(productId) && hasError && errDetail === ECartAPINotification$1.OUT_OF_STOCK && (React.createElement(FbtProductErrorDetail$1, null,
                        React.createElement("span", { dangerouslySetInnerHTML: { __html: normalizeErrMsg(errDetail, name) } }))),
                    (inCart || (!canRenderCheckbox(productId) && !canRenderError(productId))) && (React.createElement(FbtCartElements, { "data-testid": "cart-elements", disabled: productList.disabled, inCartQty: inCartQty, isLoading: isLoading, product: p }))));
            }),
            isVisibleCTA && isMobile && (React.createElement(FbtCTA$1, { testid: "add-to-cart", disabled: mainProductLoading || selectedProducts.length < 1 || productList.disabled, variant: "secondary", onClick: onAddToCart }, renderCTAContent())))))));
};

var useProductList$1 = function (isRelevanceCarousel, gaListName) {
    if (isRelevanceCarousel === void 0) { isRelevanceCarousel = true; }
    var dispatch = useDispatch();
    var miniCartSelector = function (state) { return state.miniCart; };
    var productListSelector = function (state) { return state.productList; };
    var selectMiniCartEntries = createSelector(miniCartSelector, function (miniCart) {
        return miniCart.entries;
    });
    var selectProductList = createSelector(productListSelector, function (productList) { return productList; });
    var _a = __read(useState(''), 2), openQty = _a[0], setOpenQty = _a[1];
    var cartEntries = useSelector(selectMiniCartEntries) || {};
    var productList = useSelector(selectProductList);
    var appConfig = useSelector(function (state) { return state.appConfig; });
    var closeAllQty = useCallback(function () {
        if (openQty !== '') {
            setOpenQty('');
        }
    }, [openQty]);
    var _b = useAnalytic$1(), GTMEventCall = _b.GTMEventCall, EventCall = _b.EventCall, BrazeSetCustomUserAttribute = _b.BrazeSetCustomUserAttribute, BrazeEventCall = _b.BrazeEventCall;
    var gtmCallBack = useCallback(function (quantity, eventType, productId, position, product) {
        var selectedProduct = productList.products.find(function (product) { return product.productId === productId; }) || product;
        if (selectedProduct && isObject$1(selectedProduct) && !(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.gaListName)) {
            selectedProduct.gaListName = gaListName;
        }
        switch (eventType) {
            case eventTypeEnum$1.add_to_cart:
                GTMEventCall(GTMEvents$1.add_to_cart, { product: selectedProduct, quantity: quantity, position: position });
                EventCall(GTMEvents$1.add_to_cart, selectedProduct);
                break;
            case eventTypeEnum$1.remove_from_cart:
                GTMEventCall(GTMEvents$1.remove_from_cart, { product: selectedProduct, position: position });
                break;
        }
    }, [GTMEventCall, EventCall, productList.products, gaListName]);
    useEffect(function () {
        document.addEventListener('click', closeAllQty, false);
        return function () {
            document.removeEventListener('click', closeAllQty, false);
        };
    }, [closeAllQty]);
    var onSelectHandler = useCallback(function (productId) { return function (state) {
        if (state) {
            setOpenQty(productId);
        }
    }; }, []);
    var brazeAddToCartCB = useCallback(function (totalUnitCount, product) {
        var _a;
        var _b;
        if (!((_b = appConfig === null || appConfig === void 0 ? void 0 : appConfig.userCredentials) === null || _b === void 0 ? void 0 : _b.userId) && !(appConfig === null || appConfig === void 0 ? void 0 : appConfig.brazeInitialized)) {
            var storage = initStorageManager$1(function () { return localStorage; });
            var data = storage.getItem('initBrazeAnonymousUserWithData') || [];
            data.push(product);
            storage.setItem('initBrazeAnonymousUserWithData', data);
        }
        else {
            BrazeEventCall(BrazeEvents$1.add_to_cart, product);
            if (totalUnitCount === 1)
                BrazeSetCustomUserAttribute((_a = {}, _a[BrazeEvents$1.cart_count] = true, _a));
        }
    }, [BrazeEventCall, BrazeSetCustomUserAttribute, appConfig]);
    var selectOnChange = useCallback(function (product, inCart, quantity, position, intent) { return function (_a) {
        var value = _a.value;
        if (quantity !== value) {
            var productId_1 = product.productId, _b = product.isMarketPlace, isMarketPlace = _b === void 0 ? false : _b, _c = product.offers, offers = _c === void 0 ? [] : _c, _d = product.incrementBy, incrementBy = _d === void 0 ? 1 : _d;
            var offerId = offers.length > 0 ? offers[0].id : undefined;
            var shippingIndicator = offers[0].shippingIndicator || '';
            if (!inCart) {
                dispatch(addToCart$1(productId_1, value, {
                    gtmCallBack: function () {
                        return gtmCallBack(quantity, value > quantity ? eventTypeEnum$1.add_to_cart : eventTypeEnum$1.remove_from_cart, productId_1, position, product);
                    },
                    isMarketPlace: isMarketPlace,
                    shippingIndicator: shippingIndicator,
                    withRelevantProducts: isRelevanceCarousel,
                    offerId: offerId,
                    brazeAddToCartCB: function (totalUnitCount) {
                        return brazeAddToCartCB(totalUnitCount, product);
                    },
                    intent: intent,
                    displayPrice: product.displayPrice,
                }));
            }
            else {
                dispatch(updateCart$1(productId_1, value, {
                    intent: intent,
                    shippingIndicator: shippingIndicator,
                    currentQuantity: quantity,
                    incrementBy: incrementBy,
                    offerId: offerId,
                }));
            }
        }
        else {
            setOpenQty('');
        }
    }; }, [brazeAddToCartCB, dispatch, gtmCallBack, isRelevanceCarousel]);
    return [cartEntries, productList, openQty, onSelectHandler, selectOnChange];
};

var ProductListWrapper$1 = customStyled(Flex)(templateObject_1$1J || (templateObject_1$1J = __makeTemplateObject(["\n  flex: 1 auto;\n  flex-flow: column wrap;\n  justify-content: space-between;\n  margin: 6px -6px;\n\n  &:after {\n    content: '';\n    flex: auto;\n  }\n"], ["\n  flex: 1 auto;\n  flex-flow: column wrap;\n  justify-content: space-between;\n  margin: 6px -6px;\n\n  &:after {\n    content: '';\n    flex: auto;\n  }\n"])));
var ProductListItemWrapper$1 = customStyled(Flex)(templateObject_2$1p || (templateObject_2$1p = __makeTemplateObject(["\n  > div {\n    width: 100%;\n  }\n  margin: 6px;\n  width: ", ";\n  ", "\n  > ul {\n    width: 100%;\n  }\n  @media (min-width: ", ") {\n    display: block;\n    width: calc(", "% - 12px);\n  }\n  @media (min-width: ", ") {\n    width: calc(", "% - 12px);\n  }\n"], ["\n  > div {\n    width: 100%;\n  }\n  margin: 6px;\n  width: ", ";\n  ",
    "\n  > ul {\n    width: 100%;\n  }\n  @media (min-width: ", ") {\n    display: block;\n    width: calc(", "% - 12px);\n  }\n  @media (min-width: ", ") {\n    width: calc(", "% - 12px);\n  }\n"])), function (props) { return (props.variant === 'list' ? '100%' : "calc(" + 100 / props.offsets[2] + "% - 12px)"); }, function (props) {
    return props.variant === 'list' &&
        "\n    display: block;\n    margin: 0;\n    margin-bottom: 6px;\n  ";
}, function (props) { return props.theme.breakpoints[1]; }, function (props) { return 100 / props.offsets[1]; }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return 100 / props.offsets[0]; });
var ProductListCarouselWrapper$1 = customStyled(animated.div)(templateObject_3$18 || (templateObject_3$18 = __makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var templateObject_1$1J, templateObject_2$1p, templateObject_3$18;

var ProductCardCarouselWrapper$1 = customStyled(Flex)(templateObject_1$1K || (templateObject_1$1K = __makeTemplateObject(["\n    flex-direction: column;\n    width: 100%;\n    font-family: ", ";\n    @media screen and (max-width: 576px) {\n      .is-open {\n        will-change: unset;\n        transform: none !important;\n      }\n    }\n"], ["\n    flex-direction: column;\n    width: 100%;\n    font-family: ", ";\n    @media screen and (max-width: 576px) {\n      .is-open {\n        will-change: unset;\n        transform: none !important;\n      }\n    }\n"])), function (props) { return (props.isCart ? ' Montserrat' : 'default'); });
var ProductCardCarouselHeader$1 = customStyled.div(templateObject_2$1q || (templateObject_2$1q = __makeTemplateObject(["\n    font-size: ", "px;\n    font-weight: ", ";\n    margin-bottom: ", "px;\n    text-transform: capitalize;\n"], ["\n    font-size: ", "px;\n    font-weight: ", ";\n    margin-bottom: ",
    "px;\n    text-transform: capitalize;\n"])), function (props) { return props.theme.fontSizes[3]; }, function (props) { return props.theme.fontWeights[5]; }, function (props) {
    return props.variant === EProductCardVariants$1.REGULAR || props.variant === EProductCardVariants$1.REGULAR_WIDE
        ? props.theme.space[3]
        : props.theme.space[2];
});
var Slide$1 = customStyled.div(templateObject_3$19 || (templateObject_3$19 = __makeTemplateObject(["\n    box-sizing: border-box;\n    flex: 0 0 auto;\n    position: relative;\n    // padding: ", "px\n    > ul {\n        width: 100%;\n    }\n    ", "\n"], ["\n    box-sizing: border-box;\n    flex: 0 0 auto;\n    position: relative;\n    // padding: ", "px\n    > ul {\n        width: 100%;\n    }\n    ",
    "\n"])), function (props) { return (props.isCart || props.isSponsoredListing ? '0' : '4'); }, function (props) {
    return variant({
        variants: {
            regular: {
                width: 178,
            },
            regular_wide: {
                marginRight: '8px',
            },
            mini: {
                width: 148,
            },
            simple: {
                width: [props.isSponsoredListing ? 206 : props.isCart ? 95 : 130, null, props.isCart ? 95 : 240],
            },
        },
    });
});
var templateObject_1$1K, templateObject_2$1q, templateObject_3$19;

var setEmptyList$1 = function (key) { return ({
    type: EProductCardCarouselTypes$3.SET_PRODUCTS,
    payload: { key: key, products: [{ productCards: [] }] },
}); };
var setProducts$2 = function (key, products) { return ({
    type: EProductCardCarouselTypes$3.SET_PRODUCTS,
    payload: { key: key, products: products },
}); };
var getProductsByIds$1 = function (ids, listName, recommendedProducts, isManualV2Enabled, productsFilterPayload) {
    if (ids === void 0) { ids = []; }
    if (recommendedProducts === void 0) { recommendedProducts = []; }
    if (isManualV2Enabled === void 0) { isManualV2Enabled = false; }
    if (productsFilterPayload === void 0) { productsFilterPayload = []; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var productCards;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: EProductCardCarouselTypes$3.GET_PRODUCTS, payload: listName });
                    if (!(isManualV2Enabled && productsFilterPayload.length)) return [3 /*break*/, 2];
                    return [4 /*yield*/, ProductServices$3.getProductCardsByFilters(productsFilterPayload, recommendedProducts)];
                case 1:
                    productCards = _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, ProductServices$3.getProductCardsByIdV2(ids, recommendedProducts)];
                case 3:
                    productCards = _a.sent();
                    _a.label = 4;
                case 4:
                    if (productCards) {
                        dispatch(setProducts$2(listName, [{ productCards: productCards }]));
                    }
                    else {
                        dispatch(setEmptyList$1(listName));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
};

var Skeleton$1 = customStyled(Box)(templateObject_1$1L || (templateObject_1$1L = __makeTemplateObject([""], [""])));
Skeleton$1.defaultProps = {
    variant: 'skeletonSquare',
};
var SkeletonBox$1 = customStyled(Box)(templateObject_2$1r || (templateObject_2$1r = __makeTemplateObject(["\n  flex-shrink: 0;\n\n  ", "\n"], ["\n  flex-shrink: 0;\n\n  ", "\n"])), margin);
SkeletonBox$1.defaultProps = {
    variant: 'skeletonBoxSquare',
};
var SkeletonAction$1 = customStyled(SkeletonBox$1)(templateObject_3$1a || (templateObject_3$1a = __makeTemplateObject(["\n  border-width: 1px 0 0;\n"], ["\n  border-width: 1px 0 0;\n"])));
var templateObject_1$1L, templateObject_2$1r, templateObject_3$1a;

var ProductCardLoader$1 = function (_a) {
    var _b = _a.mr, mr = _b === void 0 ? 2 : _b, _c = _a.width, width = _c === void 0 ? ['155px', null, '182px'] : _c, _d = _a.variant, variant = _d === void 0 ? 'regular' : _d, rest = __rest(_a, ["mr", "width", "variant"]);
    return (React.createElement(SkeletonBox$1, __assign({ mr: mr, px: "12px", pt: "32px", width: width }, rest),
        React.createElement(Skeleton$1, { height: variant === EProductCardVariants$1.REGULAR || variant === EProductCardVariants$1.REGULAR_WIDE ? 156 : 122 }),
        React.createElement(Box, { height: variant === EProductCardVariants$1.REGULAR || variant === EProductCardVariants$1.REGULAR_WIDE ? 87 : 43, mt: 2 },
            React.createElement(Skeleton$1, { height: 12 }),
            React.createElement(Skeleton$1, { height: 12, mt: "5px", width: "80%" })),
        React.createElement(Skeleton$1, { height: 16, width: 74 }),
        React.createElement(SkeletonAction$1, { display: "flex", alignItems: "center", justifyContent: "space-between", m: (variant === EProductCardVariants$1.REGULAR || variant === EProductCardVariants$1.REGULAR_WIDE ? '32px' : '22px') + " -12px 0", p: 2 },
            React.createElement(Skeleton$1, { height: 12, width: "48%" }),
            React.createElement(Skeleton$1, { height: 32, width: 64 }))));
};

var ProductCardCarouselLoader$1 = function (_a) {
    var _b = _a.numOfProduct, numOfProduct = _b === void 0 ? 3 : _b, JSXTitle = _a.JSXTitle, _c = _a.variant, variant = _c === void 0 ? 'regular' : _c;
    return (React.createElement(React.Fragment, null,
        JSXTitle && JSXTitle,
        React.createElement(Flex, { overflow: "hidden" }, __spread(Array(numOfProduct).keys()).map(function (i) { return (React.createElement(ProductCardLoader$1, { key: i, width: variant === EProductCardVariants$1.REGULAR || variant === EProductCardVariants$1.REGULAR_WIDE ? 194 : 144, mr: "5px", variant: variant })); }))));
};

var UPPER_LIMIT$1 = 7;
var LOWER_LIMIT$1 = 6;
var selectProductCarousel$1 = createSelector(function (state) { return state.productCardCarousel; }, function (productCardCarousel) { return productCardCarousel; });
var ProductCardCarousel$2 = function (_a) {
    var _b;
    var productsFromProps = _a.products, productIds = _a.productIds, productsFilterPayload = _a.productsFilterPayload, listName = _a.listName, _c = _a.gaListName, gaListName = _c === void 0 ? '' : _c, _d = _a.variant, variant = _d === void 0 ? EProductCardVariants$1.REGULAR : _d, _e = _a.title, title = _e === void 0 ? '' : _e, JSXTitle = _a.JSXTitle, _f = _a.containerStyleProps, containerStyleProps = _f === void 0 ? {} : _f, _g = _a.carouselOptions, carouselOptions = _g === void 0 ? {
        hideNavMaxWidth: 768,
    } : _g, _h = _a.withLoader, withLoader = _h === void 0 ? true : _h, _j = _a.isRelevantCarousel, isRelevantCarousel = _j === void 0 ? true : _j, _k = _a.recommendedProducts, recommendedProducts = _k === void 0 ? [] : _k, onSuccessCb = _a.onSuccessCb, onFailureCb = _a.onFailureCb, isSponsoredListing = _a.isSponsoredListing, isCart = _a.isCart;
    var _l = __read(useProductList$1(isRelevantCarousel, gaListName), 5), cartEntries = _l[0], productList = _l[1], openQty = _l[2], onSelectHandler = _l[3], selectOnChange = _l[4];
    var dispatch = useDispatch();
    var _m = __read(useAppConfig$1(), 1), _o = _m[0], areaCode = _o.areaCode, gtmInitialized = _o.gtmInitialized;
    var isManualV2Enabled = ((_b = useFeature('home.manual_carousel_v2.enabled')) === null || _b === void 0 ? void 0 : _b.on) || false;
    var getProducts = useRef(function () {
        if ((productIds || productsFilterPayload) && !productsFromProps) {
            dispatch(getProductsByIds$1(productIds, listName, recommendedProducts, isManualV2Enabled, productsFilterPayload));
        }
    });
    useEffect(function () {
        if (areaCode && gtmInitialized) {
            getProducts.current();
        }
    }, [areaCode, gtmInitialized]);
    var strategy = useSelector(selectProductCarousel$1).strategy;
    var _p = __read(useMemo(function () {
        if (productsFromProps) {
            return [productsFromProps, false];
        }
        else {
            var _a = strategy[listName] || {}, data = _a.data, isLoadingProp = _a.isLoading;
            if (!isLoadingProp) {
                var productData = data ? data[0].productCards : [];
                return [productData, false];
            }
            return [[], isLoadingProp];
        }
    }, [productsFromProps, strategy, listName]), 2), products = _p[0], isLoading = _p[1];
    var availableProducts = useMemo(function () {
        return products.filter(function (productCard) { return productCard.isAvailable; });
    }, [products]);
    var limit = useMemo(function () {
        switch (variant) {
            case EProductCardVariants$1.REGULAR || EProductCardVariants$1.REGULAR_WIDE:
                return !isSponsoredListing ? UPPER_LIMIT$1 : 5;
            case EProductCardVariants$1.MINI:
                return LOWER_LIMIT$1;
            default:
                return availableProducts.length;
        }
    }, [availableProducts.length, variant, isSponsoredListing]);
    var isVisible = availableProducts.length > 0 && availableProducts.length >= limit;
    var _q = __read(useState(__assign({ arrows: variant, rtl: isRTL$1() }, carouselOptions)), 2), carouselProp = _q[0], setCarouselProp = _q[1];
    var onLanguageChanged = useCallback(function () {
        setCarouselProp(__assign(__assign({}, carouselProp), { rtl: isRTL$1() }));
    }, [carouselProp]);
    var renderTitle = useCallback(function () {
        return title ? (React.createElement(ProductCardCarouselHeader$1, { variant: variant }, title)) : JSXTitle ? (JSXTitle) : null;
    }, [JSXTitle, title, variant]);
    // const height = useMemo(() => {
    //   if (typeof animateHeight !== 'undefined' && !isLoading && isVisible) {
    //     return animateHeight;
    //   } else if (!isLoading && isVisible) {
    //     return 'auto';
    //   } else {
    //     return 0;
    //   }
    // }, [animateHeight, isLoading, isVisible]);
    // const heightProps = useSpring({ height });
    useEffect(function () {
        i18next.on('languageChanged', onLanguageChanged);
        return function () {
            i18next.off('languageChanged', onLanguageChanged);
        };
    }, [carouselProp, onLanguageChanged]);
    if (isLoading && withLoader) {
        return (React.createElement(Flex, __assign({}, containerStyleProps, { flexDirection: "column" }),
            renderTitle(),
            React.createElement(ProductCardCarouselLoader$1, { variant: variant })));
    }
    var MAIN_OFFER_TYPE = 'main';
    return isVisible ? (
    // remove temporarily <animated.div style={{ ...heightProps }}>
    React.createElement(ProductCardCarouselWrapper$1, __assign({}, containerStyleProps, { isCart: isCart }),
        renderTitle(),
        React.createElement(Carousel, __assign({}, carouselProp, { isNewButton: true, className: openQty ? 'is-open' : '' }), availableProducts.map(function (product, index) {
            var _a = product.offers, offers = _a === void 0 ? [] : _a;
            var applicableOffer = offers.find(function (offer) { return offer.type === MAIN_OFFER_TYPE; }) || {
                id: '',
                shippingIndicator: '',
            };
            var offerId = applicableOffer.id;
            var shippingIndicator = applicableOffer.shippingIndicator || '';
            offerId = offerId && !offerId.includes('offer') ? "offer_" + offerId : offerId;
            var uniqueEntryId = getUniqueEntryId$1(product.productId, offerId, shippingIndicator);
            var cartEntry = cartEntries[uniqueEntryId];
            var inCart = !!cartEntry;
            var quantity = 0;
            var intent;
            if (inCart) {
                quantity = cartEntry.quantity;
                intent = cartEntry.intent;
            }
            return (React.createElement(Slide$1, { key: product.productId + "-" + index, variant: variant, isCart: isCart, isSponsoredListing: isSponsoredListing },
                React.createElement(ProductCard$3, __assign({ "data-testid": "product-card" }, product, { disabled: productList.disabled, inCart: inCart, isOpen: openQty === product.productId, listName: listName, gaListName: isSponsoredListing && isCart ? gaListName : gaListName.toLowerCase(), onSelectHandler: onSelectHandler(product.productId), position: index + 1, quantity: quantity, selectOnChange: selectOnChange(product, inCart, quantity, index + 1, intent), variant: variant, onSuccessCb: onSuccessCb, onFailureCb: onFailureCb, isSponsoredListing: isSponsoredListing, isCart: isCart, intent: intent, productId: product.productId, carousel: true }))));
        })))) : // <animated.div>
        null;
};
var ProductCardCarousel$3 = memo(ProductCardCarousel$2);

var Section$1 = customStyled(Box)(templateObject_1$1M || (templateObject_1$1M = __makeTemplateObject(["\n  [data-testid='carousel-container'] > div {\n    padding: 0;\n  }\n\n  @media screen and (max-width: ", ") {\n    [data-testid='carousel-container'] > div {\n      padding: 4px;\n      width: 168px;\n    }\n\n  ", "\n\n  [data-testid='prev-button'],\n  [data-testid='next-button'] {\n    border-color: ", ";\n    cursor: pointer;\n\n    svg > path:first-of-type {\n      stroke: ", ";\n    }\n\n    :disabled {\n      display: none;\n    }\n  }\n"], ["\n  [data-testid='carousel-container'] > div {\n    padding: 0;\n  }\n\n  @media screen and (max-width: ", ") {\n    [data-testid='carousel-container'] > div {\n      padding: 4px;\n      width: 168px;\n    }\n\n  ",
    "\n\n  [data-testid='prev-button'],\n  [data-testid='next-button'] {\n    border-color: ", ";\n    cursor: pointer;\n\n    svg > path:first-of-type {\n      stroke: ", ";\n    }\n\n    :disabled {\n      display: none;\n    }\n  }\n"])), function (props) { return props.theme.breakpoints[1]; }, function (props) {
    return props.isNewHomePage &&
        "[data-testid='relevant-product-carousel'] > div {\n      margin-bottom: 12px;\n      > p {\n        font-size: 24px;\n        font-family: Teshrin AR LT;\n        font-weight: 700;\n        color: #2d2d2d;\n      }\n\n      @media (max-width: 768px) {\n        > p {\n          font-size: 16px;\n        }\n      }\n    }\n  ";
}, function (props) { return props.theme.colors.silverChalice; }, function (props) { return props.theme.colors.silverChalice; });
Section$1.defaultProps = {
    as: 'section',
    sx: {
        "[data-testid='prev-button'], [data-testid='next-button']": {
            display: ['none', null, null, null, 'block'],
        },
    },
    mx: [3, 4, null, '40px', 0],
    mt: [4, null, null, 5],
};
var SponsoredProductsTitle$1 = customStyled(Box)(templateObject_2$1s || (templateObject_2$1s = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  font-size: ", "px;\n  margin: 8px;\n  @media (min-width: ", ") {\n    font-size: ", "px;\n    margin: 12px;\n    margin-left: 0;\n  }\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  font-size: ", "px;\n  margin: 8px;\n  @media (min-width: ", ") {\n    font-size: ", "px;\n    margin: 12px;\n    margin-left: 0;\n  }\n"])), COLORS$1.BLACK, function (props) { return props.theme.fontWeights[4]; }, function (props) { return (props.isRTL ? 'Noto Kufi Arabic' : props.theme.fonts.montserrat); }, function (props) { return props.theme.fontSizes[0]; }, function (props) { return props.theme.breakpoints[0]; }, function (props) { return props.theme.fontSizes[1]; });
var templateObject_1$1M, templateObject_2$1s;

var SponsoredCarousel$1 = function (props) {
    var _a = props.header, header = _a === void 0 ? '' : _a, _b = props.placementId, placementId = _b === void 0 ? '' : _b, _c = props.page, page = _c === void 0 ? constants$1.home : _c;
    var _d = __read(useState([]), 2), productCards = _d[0], setProductCards = _d[1];
    var _e = __read(useInView({
        threshold: 0,
        triggerOnce: true,
    }), 2), ref = _e[0], inView = _e[1];
    var products = useSelector(function (state) {
        var _a, _b;
        return ((_b = (_a = state === null || state === void 0 ? void 0 : state.adtech) === null || _a === void 0 ? void 0 : _a.criteoCarousels) === null || _b === void 0 ? void 0 : _b[placementId]) || [];
    });
    useEffect(function () {
        if (inView) {
            var productCards_1 = new ProductTransformerV2$1(products).getProductCards();
            setProductCards(productCards_1);
        }
    }, [inView, products]);
    return products.length < UPPER_LIMIT$1 ? null : (React.createElement(Section$1, { ref: ref }, inView ? (React.createElement(ProductCardCarousel$3, { carouselOptions: {
            arrows: 'solid',
        }, listName: "sponsored_carousel_pc|" + page, gaListName: "sponsored_carousel_pc|" + page, JSXTitle: React.createElement(SponsoredProductsTitle$1, { isRTL: isRTL$1() },
            " ",
            header,
            " "), products: __spread(productCards), isSponsoredListing: true, variant: "regular" })) : (React.createElement(ProductCardCarouselLoader$1, null))));
};
var index$2 = memo(SponsoredCarousel$1);

var useUser$1 = function () {
    var firstName = useSelector(function (_a) {
        var userData = _a.userData;
        return userData;
    }).firstName;
    var isLoggedIn = isExisty$1(firstName);
    return [isLoggedIn];
};

var CarouselHeading$1 = customStyled(Flex)(templateObject_1$1N || (templateObject_1$1N = __makeTemplateObject(["\n  align-items: center;\n  font-weight: normal;\n  justify-content: space-between;\n  line-height: 1.75em;\n  ", ";\n\n  a {\n    align-items: center;\n    color: ", ";\n    display: flex;\n    font-weight: ", ";\n    text-decoration: none;\n\n    svg {\n      height: 12px;\n      margin-left: ", "px;\n      width: 12px;\n    }\n  }\n"], ["\n  align-items: center;\n  font-weight: normal;\n  justify-content: space-between;\n  line-height: 1.75em;\n  ", ";\n\n  a {\n    align-items: center;\n    color: ", ";\n    display: flex;\n    font-weight: ", ";\n    text-decoration: none;\n\n    svg {\n      height: 12px;\n      margin-left: ", "px;\n      width: 12px;\n    }\n  }\n"])), space, function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.fontWeights[4]; }, function (props) { return props.theme.space[2]; });
var CarouselCapsulesWrapper$1 = customStyled(Flex)(templateObject_2$1t || (templateObject_2$1t = __makeTemplateObject(["\n    font-size: ", "px;\n    margin-bottom: 8px;\n    overflow: auto;\n\n    > div {\n      white-space: nowrap;\n      min-width: auto;\n    }\n    > div:not(:first-of-type) {\n      margin-left: ", "px;\n    }\n"], ["\n    font-size: ", "px;\n    margin-bottom: 8px;\n    overflow: auto;\n\n    > div {\n      white-space: nowrap;\n      min-width: auto;\n    }\n    > div:not(:first-of-type) {\n      margin-left: ", "px;\n    }\n"])), function (_a) {
    var isMobile = _a.isMobile, theme = _a.theme;
    return (isMobile ? theme.fontSizes[1] : theme.fontSizes[2]);
}, function (props) { return props.theme.space[2]; });
var templateObject_1$1N, templateObject_2$1t;

var BUY_AGAIN_STRATEGY$1 = 'DSW_FPP_6';
var useRelevantCarousel$1 = function (_a) {
    var _b = _a.isLazy, isLazy = _b === void 0 ? false : _b, keyword = _a.keyword, productId = _a.productId, _c = _a.placements, placements = _c === void 0 ? '' : _c, _d = _a.testId, testId = _d === void 0 ? 'relevant-product-carousel' : _d, _e = _a.variant, variant = _e === void 0 ? 'regular' : _e, _f = _a.asCard, asCard = _f === void 0 ? false : _f, _g = _a.carouselOptions, carouselOptions = _g === void 0 ? {} : _g, _h = _a.headingStyles, headingStyles = _h === void 0 ? { mb: 20 } : _h, _j = _a.titleStyles, titleStyles = _j === void 0 ? {} : _j, JSXHeader = _a.JSXHeader, _k = _a.isNonFoodV1Header, isNonFoodV1Header = _k === void 0 ? false : _k, _l = _a.withLoader, withLoader = _l === void 0 ? true : _l, animateHeight = _a.animateHeight, onSuccessCb = _a.onSuccessCb, onFailureCb = _a.onFailureCb, isCart = _a.isCart, gaListName = _a.gaListName;
    var _m = __read(useAppConfig$1(), 4), requestStatus = _m[3];
    var decodedPlacements = decodeURIComponent(placements).split('|');
    var _o = __read(useState(), 2), placementsArr = _o[0], setPlacementsArr = _o[1];
    useEffect(function () {
        // RR apis requires `zoneId`
        if (!placements)
            return;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var placementsArrData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ProductServices$3.getRelevance(productId ? { id: productId, placements: placements } : { keyword: keyword, placements: placements })];
                    case 1:
                        placementsArrData = _a.sent();
                        setPlacementsArr(placementsArrData);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [keyword, placements, productId]);
    return useMemo(function () {
        if (!placements || requestStatus.failed)
            return [null];
        return getCarousels$1({
            isLazy: isLazy,
            decodedPlacements: decodedPlacements,
            placementsArr: placementsArr,
            testId: testId,
            variant: variant,
            isNonFoodV1Header: isNonFoodV1Header,
            asCard: asCard,
            carouselOptions: carouselOptions,
            headingStyles: headingStyles,
            titleStyles: titleStyles,
            JSXHeader: JSXHeader,
            withLoader: withLoader,
            animateHeight: animateHeight,
            onFailureCb: onFailureCb,
            onSuccessCb: onSuccessCb,
            isCart: isCart,
            gaListName: gaListName,
        });
    }, [
        placements,
        requestStatus.failed,
        isLazy,
        isNonFoodV1Header,
        decodedPlacements,
        placementsArr,
        testId,
        variant,
        asCard,
        carouselOptions,
        headingStyles,
        titleStyles,
        JSXHeader,
        withLoader,
        animateHeight,
        onFailureCb,
        onSuccessCb,
        isCart,
        gaListName,
    ]);
};
var getCarousels$1 = function (_a) {
    var isLazy = _a.isLazy, decodedPlacements = _a.decodedPlacements, placementsArr = _a.placementsArr, testId = _a.testId, variant = _a.variant, asCard = _a.asCard, carouselOptions = _a.carouselOptions, isNonFoodV1Header = _a.isNonFoodV1Header, headingStyles = _a.headingStyles, titleStyles = _a.titleStyles, JSXHeader = _a.JSXHeader, withLoader = _a.withLoader, animateHeight = _a.animateHeight, onSuccessCb = _a.onSuccessCb, onFailureCb = _a.onFailureCb, isCart = _a.isCart, gaListName = _a.gaListName;
    // Show loader until we get the data for rendering the carousels
    if (!placementsArr) {
        return withLoader ? [getLoadingCarousels$1(decodedPlacements, JSXHeader), true] : [null, false];
        // return the carousels along with their corresponding placement
    }
    else if (placementsArr.length) {
        return [
            placementsArr.reduce(function (obj, _a, i) {
                var _b;
                var recommendedProducts = _a.recommendedProducts, strategyName = _a.strategyName, strategyMessage = _a.strategyMessage;
                var isBuyAgain = strategyName === BUY_AGAIN_STRATEGY$1;
                var listMessage = strategyMessage.split(' ').join('_').toLowerCase() || '';
                var listName = listMessage;
                return __assign(__assign({}, obj), (_b = {}, _b[placementsArr[i].placement] = (React.createElement(CarouselProvider$1, { isBuyAgain: isBuyAgain, listName: strategyMessage, gaListName: gaListName || listName, testId: testId, isNonFoodV1Header: isNonFoodV1Header, asCard: asCard, headingStyles: headingStyles, titleStyles: titleStyles, JSXHeader: JSXHeader, key: listName + "-" + i }, isLazy ? (React.createElement(LazyCarousel$1, { products: recommendedProducts, gaListName: gaListName || listName, listName: strategyMessage, variant: variant, JSXHeader: JSXHeader, withLoader: withLoader, animateHeight: animateHeight, recommendedProducts: recommendedProducts, onSuccessCb: onSuccessCb, onFailureCb: onFailureCb, isCart: isCart })) : (React.createElement(NonLazyCarousel$1, { products: recommendedProducts, carouselOptions: carouselOptions, listName: strategyMessage, variant: variant, gaListName: gaListName || listName, withLoader: withLoader, animateHeight: animateHeight, recommendedProducts: recommendedProducts, onSuccessCb: onSuccessCb, onFailureCb: onFailureCb, isCart: isCart })))), _b));
            }, {}),
        ];
    }
    return [null];
};
var CarouselContext$1 = createContext({});
var CarouselProvider$1 = function (_a) {
    var isBuyAgain = _a.isBuyAgain, listName = _a.listName, testId = _a.testId, asCard = _a.asCard, headingStyles = _a.headingStyles, titleStyles = _a.titleStyles, isNonFoodV1Header = _a.isNonFoodV1Header, JSXHeader = _a.JSXHeader, rest = __rest(_a, ["isBuyAgain", "listName", "testId", "asCard", "headingStyles", "titleStyles", "isNonFoodV1Header", "JSXHeader"]);
    var theme = useTheme();
    var t = useTranslation().t;
    var _b = __read(useUser$1(), 1), isLoggedIn = _b[0];
    var _c = __read(useAppConfig$1(), 5), setAppContext = _c[4];
    var buyAgainLink = setAppContext('/buyAgain');
    var seeMoreText = capitalizeFirstLetter$1(t('seeMore').toLowerCase());
    var value = useMemo(function () { return ({
        containerProps: {
            containerStyleProps: __assign({ 'data-testid': testId }, (asCard
                ? {
                    backgroundColor: theme.colors.white,
                    px: 3,
                    py: 2,
                    mx: '6px',
                    sx: {
                        boxShadow: theme.elevation(1),
                    },
                }
                : {})),
        },
        renderTitle: function () {
            if (listName && !isNonFoodV1Header) {
                if (JSXHeader) {
                    return (React.createElement(JSXHeader
                    // Show "See more" link for "Buy Again" carousel
                    , { 
                        // Show "See more" link for "Buy Again" carousel
                        seeMoreLink: isBuyAgain ? buyAgainLink : '', seeMoreText: seeMoreText }, listName));
                }
                else {
                    var Icon = isRTL$1() ? ArrowLeft : RightArrow$2;
                    return (React.createElement(CarouselHeading$1, __assign({}, headingStyles),
                        listName && (React.createElement(Text, __assign({ fontSize: "1.25em" }, titleStyles), listName)),
                        isBuyAgain && (React.createElement("a", { href: buyAgainLink, "data-testid": "see-more-link" },
                            seeMoreText,
                            React.createElement(Icon, { fill: theme.colors.blue })))));
                }
            }
            return null;
        },
    }); }, [
        testId,
        asCard,
        theme,
        listName,
        isNonFoodV1Header,
        JSXHeader,
        isBuyAgain,
        buyAgainLink,
        seeMoreText,
        headingStyles,
        titleStyles,
    ]);
    // "Buy Again" carousel is meant for logged in users only
    if (isBuyAgain && !isLoggedIn)
        return null;
    return React.createElement(CarouselContext$1.Provider, __assign({ value: value }, rest));
};
var useCarouselContext$1 = function () { return useContext(CarouselContext$1); };
var LazyCarousel$1 = function (_a) {
    var JSXHeader = _a.JSXHeader, rest = __rest(_a, ["JSXHeader"]);
    var _b = useCarouselContext$1(), containerProps = _b.containerProps, renderTitle = _b.renderTitle;
    var _c = useInView$2({
        unobserveOnEnter: true,
        rootMargin: '300px 0px',
    }), ref = _c.ref, inView = _c.inView;
    return (React.createElement("div", { "data-testid": "lazy-relevant-carousel", ref: ref }, inView ? (React.createElement(ProductCardCarousel$3, __assign({}, containerProps, rest, { JSXTitle: renderTitle(), isRelevantCarousel: false }))) : (React.createElement(ProductCardCarouselLoader$1, { JSXTitle: JSXHeader ? React.createElement(JSXHeader, null, "\u00A0") : null }))));
};
var NonLazyCarousel$1 = function (_a) {
    var rest = __rest(_a, []);
    var _b = useCarouselContext$1(), containerProps = _b.containerProps, renderTitle = _b.renderTitle;
    return React.createElement(ProductCardCarousel$3, __assign({}, containerProps, rest, { JSXTitle: renderTitle(), isRelevantCarousel: false }));
};
var getLoadingCarousels$1 = function (decodedPlacements, JSXHeader) {
    return decodedPlacements.reduce(function (obj, key) {
        var _a;
        return (__assign(__assign({}, obj), (_a = {}, _a[key] = React.createElement(ProductCardCarouselLoader$1, { JSXTitle: JSXHeader ? React.createElement(JSXHeader, null, "\u00A0") : null }), _a)));
    }, {});
};

var RelevantProductCarousel$2 = function (props) {
    var _a = __read(useRelevantCarousel$1(props), 2), carousels = _a[0], isLoading = _a[1];
    var theme = useTheme();
    var cardProps = useMemo(function () {
        return props.asCard
            ? {
                backgroundColor: COLORS$1.WHITE,
                px: 3,
                py: 2,
                mx: '6px',
                sx: {
                    boxShadow: theme.elevation(1),
                },
            }
            : {};
    }, [props.asCard, theme]);
    if (isLoading) {
        return (React.createElement(Flex, __assign({}, cardProps, { flexDirection: "column" }),
            React.createElement(ProductCardCarouselLoader$1, { variant: props.variant })));
    }
    if (carousels) {
        return React.createElement(React.Fragment, null, Object.keys(carousels).map(function (key) { return carousels[key]; }));
    }
    return null;
};
var RelevantProductCarousel$3 = memo(RelevantProductCarousel$2);

var useMultiCarousels = function (_a) {
    var keyword = _a.keyword, productId = _a.productId, _b = _a.listName, listName = _b === void 0 ? '' : _b, _c = _a.placements, placements = _c === void 0 ? '' : _c, _d = _a.variant, variant = _d === void 0 ? 'regular' : _d, _e = _a.headingStyles, headingStyles = _e === void 0 ? { mb: 12 } : _e, _f = _a.titleStyles, titleStyles = _f === void 0 ? {} : _f, _g = _a.isNonFoodV1Header, isNonFoodV1Header = _g === void 0 ? false : _g, props = __rest(_a, ["keyword", "productId", "listName", "placements", "variant", "headingStyles", "titleStyles", "isNonFoodV1Header"]);
    var _h = __read(useAppConfig$1(), 4), requestStatus = _h[3];
    var _j = __read(useState(), 2), placementsArr = _j[0], setPlacementsArr = _j[1];
    var _k = __read(useState(), 2), selected = _k[0], selectPlacement = _k[1];
    var onPlacementSelect = useCallback(function (placement) { return function () {
        if (placement)
            selectPlacement(placement);
    }; }, [selectPlacement]);
    var renderCapsules = useMemo(function () {
        return (placementsArr === null || placementsArr === void 0 ? void 0 : placementsArr.length) ? (React.createElement(React.Fragment, null,
            listName && !isNonFoodV1Header ? (React.createElement(CarouselHeading$1, __assign({}, headingStyles),
                React.createElement(Text, __assign({ fontSize: "1.25em" }, titleStyles), listName))) : null,
            React.createElement(CarouselCapsulesWrapper$1, null, placementsArr.map(function (_a) {
                var placement = _a.placement, strategyMessage = _a.strategyMessage;
                return (React.createElement(Capsule, __assign({ key: placement, value: strategyMessage, withPointer: true, onClick: onPlacementSelect(placement) }, { borderRadius: '6px' }, (selected === placement ? { fontWeight: 600, borderColor: COLORS$1.TAUPE_GRAY } : {}))));
            })))) : null;
    }, [placementsArr, listName, isNonFoodV1Header, headingStyles, titleStyles, onPlacementSelect, selected]);
    useEffect(function () {
        if (!placements)
            return;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var placementsArrData, _a, _b, firstPlacement;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, ProductServices$3.getRelevance(productId ? { id: productId, placements: placements } : { keyword: keyword, placements: placements })];
                    case 1:
                        placementsArrData = _c.sent();
                        setPlacementsArr(placementsArrData);
                        _a = __read(placementsArrData, 1), _b = _a[0], firstPlacement = _b === void 0 ? {} : _b;
                        selectPlacement(firstPlacement.placement);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [keyword, placements, productId]);
    return useMemo(function () {
        if (!placements || !placementsArr || requestStatus.failed)
            return [null];
        var _a = placementsArr.find(function (_a) {
            var placement = _a.placement;
            return placement === selected;
        }) || {}, recommendedProducts = _a.recommendedProducts, strategyMessage = _a.strategyMessage;
        var listMessage = (strategyMessage === null || strategyMessage === void 0 ? void 0 : strategyMessage.split(' ').join('_').toLowerCase()) || '';
        var listTitle = (listName === null || listName === void 0 ? void 0 : listName.split(' ').join('_').toLowerCase()) || '';
        var newListName = "multi_level_carousel|" + listTitle + "|" + listMessage;
        return [
            React.createElement(ProductCardCarousel$3, __assign({ key: newListName, products: recommendedProducts, gaListName: newListName, listName: newListName, variant: variant, JSXTitle: renderCapsules, recommendedProducts: recommendedProducts }, props)),
        ];
    }, [renderCapsules, placements, requestStatus.failed, placementsArr, variant, selected, props, listName]);
};

var RECOMMENDATION_PLACEMENT$1 = 'add_to_cart_page.web_from-list';
var carouselOptions$1 = {
    arrows: 'mini',
    hideNavMaxWidth: BREAKPOINTS$1[3],
};
var staticProps$1 = {
    headingStyles: {
        marginY: '5px',
    },
    titleStyles: {
        fontSize: 16,
        lineHeight: 1.6,
        fontWeight: 500,
    },
};
var ProductListRowCarousel$2 = function (_a) {
    var relevantProductId = _a.relevantProductId, rowIndex = _a.rowIndex, selectedRow = _a.selectedRow;
    return selectedRow === rowIndex && relevantProductId !== '' ? (React.createElement(RelevantProductCarousel$3, __assign({ carouselOptions: carouselOptions$1, asCard: true, testId: "relevance-carousel-card", placements: RECOMMENDATION_PLACEMENT$1, productId: relevantProductId, variant: "regular", withLoader: false, animateHeight: 354 }, staticProps$1))) : null;
};
var ProductListRowCarousel$3 = React.memo(ProductListRowCarousel$2);

var MAIN_OFFER_TYPE$1 = 'main';
var ProductListRow$2 = function (_a) {
    var cartEntries = _a.cartEntries, disabled = _a.disabled, isRelevanceCarousel = _a.isRelevanceCarousel, offsets = _a.offsets, onRelevantHandler = _a.onRelevantHandler, onSelectHandler = _a.onSelectHandler, onNotificationHandler = _a.onNotificationHandler, onViewSimilarHandler = _a.onViewSimilarHandler, openQty = _a.openQty, products = _a.products, relevantProductId = _a.relevantProductId, rowIndex = _a.rowIndex, selectedRow = _a.selectedRow, selectOnChange = _a.selectOnChange, withProductVariants = _a.withProductVariants, gaListName = _a.gaListName, isFoodCategory = _a.isFoodCategory, _b = _a.variant, variant = _b === void 0 ? 'regular' : _b;
    var _c = __read(useState(''), 2), keyword = _c[0], setKeyword = _c[1];
    var href = isBrowser$1() ? window.location.href : '';
    useEffect(function () {
        if (isBrowser$1()) {
            var url = new URL(href);
            var searchKeyword = url.searchParams.get('keyword');
            if (searchKeyword) {
                setKeyword(decodeStr$1(searchKeyword));
            }
        }
    }, [href]);
    var isMobile = useBreakpoints().isMobile;
    var Display = Flex;
    if (isMobile && isFoodCategory && variant !== 'compact' && variant === 'list') {
        Display = Box;
    }
    return (React.createElement(Flex, { w: 1, flexDirection: "column" },
        React.createElement(Display, { width: "100%", flexWrap: "wrap", alignItems: "flex-end" }, products.map(function (card, index) {
            var _a = card.offers, offers = _a === void 0 ? [] : _a;
            var applicableOffer = offers.find(function (offer) { return offer.type === MAIN_OFFER_TYPE$1; }) || {
                id: '',
                shippingIndicator: '',
            };
            var offerId = applicableOffer.id;
            var shippingIndicator = applicableOffer.shippingIndicator || '';
            offerId = offerId && !offerId.includes('offer') ? "offer_" + offerId : offerId;
            var uniqueEntryId = getUniqueEntryId$1(card.productId, offerId, shippingIndicator);
            var cartEntry = cartEntries[uniqueEntryId];
            var inCart = cartEntry !== undefined;
            var quantity = 0;
            var intent;
            if (inCart) {
                quantity = cartEntry.quantity;
                intent = cartEntry.intent;
            }
            var gaListNameUpdated = card.isSponsored && keyword
                ? "sponsored_listing|" + keyword
                : card.isSponsored && gaListName && gaListName.includes('category')
                    ? gaListName.replace('category', 'sponsored_listing')
                    : gaListName;
            if (relevantProductId === card.productId) {
                onRelevantHandler(rowIndex);
            }
            return (React.createElement(ProductListItemWrapper$1, { variant: variant, key: card.productId + "-" + index, offsets: offsets },
                React.createElement(ProductCard$3, __assign({}, card, { disabled: disabled, rowIndex: rowIndex, inCart: inCart, isOpen: openQty === card.productId, gaListName: gaListNameUpdated || '', onSelectHandler: onSelectHandler(card.productId), onNotificationHandler: onNotificationHandler, onViewSimilarHandler: onViewSimilarHandler, position: index + 1, quantity: quantity, selectOnChange: selectOnChange(card, inCart, quantity, index + 1, intent), withProductVariants: withProductVariants, withRelevantProducts: isRelevanceCarousel, isFoodCategory: isFoodCategory, variant: variant, intent: intent }))));
        })),
        isRelevanceCarousel && (React.createElement(ProductListRowCarousel$3, { relevantProductId: relevantProductId, rowIndex: rowIndex, selectedRow: selectedRow }))));
};
var ProductListRow$3 = React.memo(ProductListRow$2);

var ProductList = function (_a) {
    var _b = _a.hasMore, hasMore = _b === void 0 ? true : _b, _c = _a.isRelevanceCarousel, isRelevanceCarousel = _c === void 0 ? true : _c, _d = _a.offsets, offsets = _d === void 0 ? [] : _d, onScrollEndHandler = _a.onScrollEndHandler, onNotificationHandler = _a.onNotificationHandler, onViewSimilarHandler = _a.onViewSimilarHandler, productCards = _a.productCards, totalProducts = _a.totalProducts, _e = _a.withProductVariants, withProductVariants = _e === void 0 ? false : _e, _f = _a.gaListName, gaListName = _f === void 0 ? '' : _f, _g = _a.showScrollCount, showScrollCount = _g === void 0 ? false : _g, _h = _a.showAfterProducts, showAfterProducts = _h === void 0 ? 1 : _h, children = _a.children, _j = _a.isFoodCategory, isFoodCategory = _j === void 0 ? false : _j, _k = _a.variant, variant = _k === void 0 ? 'regular' : _k, _l = _a.adtechCompObj, adtechCompObj = _l === void 0 ? {} : _l;
    var _m = __read(useState(-1), 2), selectedRow = _m[0], setSelectedRow = _m[1];
    var breakpoints = useBreakpoints();
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var translatedText = t('backToTop').toLowerCase();
    useEffect(function () {
        dispatch(setProducts(productCards, totalProducts));
    }, [dispatch, productCards, totalProducts]);
    useEffect(function () {
        emptyCachedImpression();
    }, []);
    var _o = __read(useProductList$1(isRelevanceCarousel, gaListName), 5), cartEntries = _o[0], productList = _o[1], openQty = _o[2], onSelectHandler = _o[3], selectOnChange = _o[4];
    var _p = __read(useMemo(function () {
        var _a = __read(offsets, 3), _b = _a[0], desktop = _b === void 0 ? 4 : _b, _c = _a[1], tablet = _c === void 0 ? 3 : _c, _d = _a[2], mobile = _d === void 0 ? 2 : _d;
        var productOffset = breakpoints.isDesktop ? desktop : breakpoints.isMobile ? mobile : tablet;
        return [productOffset];
    }, [breakpoints.isDesktop, breakpoints.isMobile, offsets]), 1), offset = _p[0];
    var sets = useMemo(function () { return subsets$1(productCards, offset); }, [productCards, offset]);
    var onRelevantHandler = useCallback(function (rowIndex) {
        if (selectedRow !== rowIndex) {
            setSelectedRow(rowIndex);
        }
    }, [selectedRow]);
    var showCounter = breakpoints.isMobile && showScrollCount;
    return (React.createElement(ProductListWrapper$1, null,
        React.createElement(ScrollableListView, { hasMore: hasMore, onScrollEndHandler: onScrollEndHandler, showCounter: showCounter, countMultiplier: 2, displayAfterProducts: 9, backToTopText: translatedText }, sets.map(function (products, rowIndex) {
            return (React.createElement(React.Fragment, null,
                adtechCompObj[rowIndex],
                React.createElement(ProductListRow$3, { cartEntries: cartEntries, disabled: productList.disabled, isRelevanceCarousel: isRelevanceCarousel, key: rowIndex, offset: offset, offsets: offsets, onRelevantHandler: onRelevantHandler, onSelectHandler: onSelectHandler, onNotificationHandler: onNotificationHandler, onViewSimilarHandler: onViewSimilarHandler, openQty: openQty, products: products, relevantProductId: productList.relevantProductId, rowIndex: rowIndex, selectedRow: selectedRow, selectOnChange: selectOnChange, withProductVariants: withProductVariants, gaListName: gaListName, isFoodCategory: isFoodCategory, variant: variant }),
                showAfterProducts === (rowIndex + 1) * 2 && totalProducts > showAfterProducts && children));
        }))));
};

var PaginationControlWrapper$1 = CustomStyled$1.ul(templateObject_1$1O || (templateObject_1$1O = __makeTemplateObject(["\n  display: flex;\n  list-style: none;\n  align-items: center;\n  li{\n    margin: 0px 6px;\n    text-align: center;\n    &:first-of-type{\n      margin-left: 0px;\n    }\n    &:last-of-type{\n      margin-right: 0px;\n    } \n  }\n"], ["\n  display: flex;\n  list-style: none;\n  align-items: center;\n  li{\n    margin: 0px 6px;\n    text-align: center;\n    &:first-of-type{\n      margin-left: 0px;\n    }\n    &:last-of-type{\n      margin-right: 0px;\n    } \n  }\n"])));
var templateObject_1$1O;

var LinkWrapper$3 = CustomStyled$1.li(templateObject_1$1P || (templateObject_1$1P = __makeTemplateObject(["\n    opacity: ", ";\n"], ["\n    opacity: ", ";\n"])), function (props) { return (props.disabled ? '0.5' : '1'); });
var StyledLink$1 = CustomStyled$1.a(templateObject_2$1u || (templateObject_2$1u = __makeTemplateObject(["\n    color: ", ";\n    text-decoration: none;\n    font-size: ", "px;\n    cursor: ", ";\n"], ["\n    color: ", ";\n    text-decoration: none;\n    font-size: ", "px;\n    cursor: ", ";\n"])), function (props) { return props.theme.colors.copy; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return (props.disabled ? 'unset' : 'pointer'); });
var IconWrapper$c = CustomStyled$1.div(templateObject_3$1b || (templateObject_3$1b = __makeTemplateObject(["\n  margin: 0px ", "px;  \n"], ["\n  margin: 0px ", "px;  \n"])), function (props) { return props.theme.space[2]; });
var LeftArrow$1 = CustomStyled$1(IconWrapper$c)(templateObject_4$_ || (templateObject_4$_ = __makeTemplateObject(["\n  transform: rotate(90deg);\n\n  html[dir=\"rtl\"] & {\n    transform: rotate(-90deg);\n  }\n"], ["\n  transform: rotate(90deg);\n\n  html[dir=\"rtl\"] & {\n    transform: rotate(-90deg);\n  }\n"])));
var RightArrow$1 = CustomStyled$1(IconWrapper$c)(templateObject_5$M || (templateObject_5$M = __makeTemplateObject(["\n  transform: rotate(-90deg);\n\n  html[dir=\"rtl\"] & {\n    transform: rotate(90deg);\n  }\n"], ["\n  transform: rotate(-90deg);\n\n  html[dir=\"rtl\"] & {\n    transform: rotate(90deg);\n  }\n"])));
var LinkDescription$1 = CustomStyled$1.p(templateObject_6$C || (templateObject_6$C = __makeTemplateObject(["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), function (props) { return props.theme.breakpoints[0]; });
var templateObject_1$1P, templateObject_2$1u, templateObject_3$1b, templateObject_4$_, templateObject_5$M, templateObject_6$C;

var Arrow = function (props) {
    var disabled = props.disabled, direction = props.direction, onClick = props.onClick;
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    var t = useTranslation().t;
    var onArrowClick = function (e) {
        if (disabled) {
            return;
        }
        else {
            onClick(e);
            GTMEventCall(GTMEvents$1.virtual_page_event, { pageTitle: document.title });
        }
    };
    var renderContent = function () {
        var FlexProps = {
            alignItems: 'center',
            'data-testid': 'component-direction-flex',
        };
        if (direction === 'left') {
            return (React.createElement(Flex, __assign({}, FlexProps),
                React.createElement(LeftArrow$1, null,
                    React.createElement(ArrowDown, { size: "XS" })),
                React.createElement(LinkDescription$1, null, t("previous"))));
        }
        else {
            return (React.createElement(Flex, __assign({}, FlexProps),
                React.createElement(LinkDescription$1, null, t("next")),
                React.createElement(RightArrow$1, null,
                    React.createElement(ArrowDown, { size: "XS" }))));
        }
    };
    return (React.createElement(LinkWrapper$3, { disabled: disabled, "data-testid": "component-direction-linkwrapper" },
        React.createElement(StyledLink$1, { onClick: onArrowClick, disabled: disabled, "data-testid": "component-direction-" + direction }, renderContent())));
};

var StyledButton$1 = CustomStyled$1(Button$1)(templateObject_1$1Q || (templateObject_1$1Q = __makeTemplateObject(["\n    ", ";\n    border-width: 1px;\n    border-style: solid;\n    font-size: ", "px;\n    box-shadow: none;\n    width: 50px;\n    height: 50px;\n    padding: 12px 5px;\n    transition-property: box-shadow, background-color;\n    transition-duration: 0s;\n    &:hover{\n        color: ", ";\n        border-width: 1px;\n        border-color: ", ";\n        background-color: ", ";\n        box-shadow: none;\n    }\n"], ["\n    ",
    ";\n    border-width: 1px;\n    border-style: solid;\n    font-size: ", "px;\n    box-shadow: none;\n    width: 50px;\n    height: 50px;\n    padding: 12px 5px;\n    transition-property: box-shadow, background-color;\n    transition-duration: 0s;\n    &:hover{\n        color: ", ";\n        border-width: 1px;\n        border-color: ", ";\n        background-color: ", ";\n        box-shadow: none;\n    }\n"])), function (props) {
    return variant({
        variants: {
            primary: {
                color: props.theme.colors.copy,
                borderColor: props.theme.colors.copy,
                backgroundColor: props.theme.colors.white,
            },
            secondary: {
                color: props.theme.colors.white,
                backgroundColor: props.theme.colors.blue,
                borderColor: props.theme.colors.blue,
            },
        },
    });
}, function (props) { return props.theme.fontSizes[5]; }, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.colors.blue; });
var templateObject_1$1Q;

var Button = function (_a) {
    var selected = _a.selected, pageNumber = _a.pageNumber, onClick = _a.onClick, testid = _a.testid;
    var onClickHandler = function () {
        onClick(pageNumber);
    };
    return (React.createElement(StyledButton$1, { variant: selected ? 'secondary' : 'primary', onClick: onClickHandler, testid: testid }, pageNumber));
};

var getPagesNumbers = function (current, total, isMobile, _a) {
    var _b = (_a === void 0 ? {} : _a).min, min = _b === void 0 ? 2 : _b;
    if (total > 1) {
        var length_1;
        if (!isMobile) {
            length_1 = 3;
        }
        else {
            length_1 = 1;
        }
        var totalPages = total - 2;
        if (length_1 > totalPages) {
            length_1 = totalPages;
        }
        var start = current - Math.floor((length_1 - 1) / 2);
        start = Math.max(start, min);
        start = Math.min(start, min + totalPages - length_1);
        var arr = new Array(length_1);
        for (var i = 0; i < length_1; i++) {
            arr.push(i + start);
        }
        return arr;
    }
};
var shouldShowCollapse = function (direction, totalPages, currentPage, isMobile) {
    var numberOfBlocks;
    if (!isMobile) {
        numberOfBlocks = 3;
    }
    else {
        numberOfBlocks = 1;
    }
    if (totalPages > 5) {
        if (direction === 'left') {
            return (currentPage > 3 && numberOfBlocks > 2) || (currentPage >= 3 && numberOfBlocks <= 2);
        }
        else {
            return ((currentPage < totalPages - 2 && numberOfBlocks > 2) || (currentPage < totalPages - 1 && numberOfBlocks <= 2));
        }
    }
    else if (totalPages > 3) {
        if (isMobile) {
            return (currentPage > 2 && direction === 'left') || (currentPage < totalPages - 1 && direction === 'right');
        }
    }
};

var PaginationControl = function (_a) {
    var totalPages = _a.totalPages, currentPage = _a.currentPage, onNextClick = _a.onNextClick, onBackClick = _a.onBackClick, onPageNumberClick = _a.onPageNumberClick;
    var _b = __read(useState(), 2), pagesButtons = _b[0], setPagesButtons = _b[1];
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    var isMobile = useBreakpoints().isMobile;
    var pagesNumbers = useMemo(function () { return getPagesNumbers(currentPage, totalPages, isMobile); }, [
        currentPage,
        totalPages,
        isMobile,
    ]);
    var onBtnClick = useCallback(function (btnNumber) {
        if (currentPage !== btnNumber) {
            GTMEventCall(GTMEvents$1.virtual_page_event, { pageTitle: document.title });
            onPageNumberClick(btnNumber);
        }
        else {
            return;
        }
    }, [currentPage, onPageNumberClick, GTMEventCall]);
    var renderButtons = useCallback(function () {
        if (pagesNumbers) {
            setPagesButtons(pagesNumbers.map(function (pageNumber) {
                return (React.createElement("li", { key: pageNumber },
                    React.createElement(Button, { selected: pageNumber === currentPage, onClick: onBtnClick, pageNumber: pageNumber, testid: "pagination-button-" + pageNumber })));
            }));
        }
    }, [pagesNumbers, currentPage, onBtnClick]);
    useEffect(function () {
        renderButtons();
    }, [renderButtons]);
    return (React.createElement(React.Fragment, null, totalPages > 1 && (React.createElement(PaginationControlWrapper$1, null,
        React.createElement(Arrow, { onClick: onBackClick, disabled: currentPage === 1, direction: "left" }),
        React.createElement("li", null,
            React.createElement(Button, { selected: currentPage === 1, onClick: onBtnClick, pageNumber: 1, testid: "pagination-button-1" })),
        shouldShowCollapse('left', totalPages, currentPage, isMobile) && (React.createElement("li", { "data-testid": "pagination-collapse-left" }, "...")),
        pagesButtons,
        shouldShowCollapse('right', totalPages, currentPage, isMobile) && (React.createElement("li", { "data-testid": "pagination-collapse-right" }, "...")),
        React.createElement("li", null,
            React.createElement(Button, { selected: currentPage === totalPages, onClick: onBtnClick, pageNumber: totalPages, testid: "pagination-button-" + totalPages })),
        React.createElement(Arrow, { onClick: onNextClick, disabled: currentPage === totalPages, direction: "right" })))));
};
PaginationControl.defaultProps = {
    currentPage: 1,
};

var textColor$1 = style({
    prop: 'textColor',
    cssProperty: 'color',
    key: 'colors',
});
var ContentWrapper$3 = styled.div(templateObject_1$1R || (templateObject_1$1R = __makeTemplateObject(["\n  color: ", ";\n  display: flex;\n  ", "\n  ", "\n  ", "\n  margin-top: 0;\n  h1 {\n    direction: ltr;\n    font-size: ", "px;\n    margin-bottom: ", "px;\n  }\n  p {\n    direction: ltr;\n    font-size: 0.583333em;\n  }\n"], ["\n  color: ", ";\n  display: flex;\n  ", "\n  ", "\n  ", "\n  margin-top: 0;\n  h1 {\n    direction: ltr;\n    font-size: ", "px;\n    margin-bottom: ", "px;\n  }\n  p {\n    direction: ltr;\n    font-size: 0.583333em;\n  }\n"])), function (props) { return props.theme.colors.copy; }, typography, space, textColor$1, function (props) { return props.theme.fontSizes[6]; }, function (props) { return props.theme.space[1]; });
var Container$h = styled(Flex)(templateObject_2$1v || (templateObject_2$1v = __makeTemplateObject(["\n  flex-direction: column;\n"], ["\n  flex-direction: column;\n"])));
var PageInfoContent$1 = styled.div(templateObject_3$1c || (templateObject_3$1c = __makeTemplateObject(["\n  > p,\n  > span,\n  > div {\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 8px;\n  }\n  white-space: nowrap;\n  overflow-x: scroll;\n"], ["\n  > p,\n  > span,\n  > div {\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 8px;\n  }\n  white-space: nowrap;\n  overflow-x: scroll;\n"])));
var QuickFilters$1 = styled.div(templateObject_4$$ || (templateObject_4$$ = __makeTemplateObject(["\n  color: ", ";\n  font-family: Montserrat;\n  font-size: 14px;\n  line-height: 18px;\n  display: inline-block;\n  font-weight: 700;\n  padding: 7px 16px;\n  background: ", ";\n  border: solid 1px ", ";\n  border-radius: 48px;\n  cursor: pointer;\n"], ["\n  color: ", ";\n  font-family: Montserrat;\n  font-size: 14px;\n  line-height: 18px;\n  display: inline-block;\n  font-weight: 700;\n  padding: 7px 16px;\n  background: ", ";\n  border: solid 1px ", ";\n  border-radius: 48px;\n  cursor: pointer;\n"])), function (_a) {
    var selected = _a.selected;
    return (selected ? COLORS$1.BLUE : COLORS$1.BLACK);
}, function (_a) {
    var selected = _a.selected;
    return (selected ? '#0E5AA70d' : COLORS$1.WHITE);
}, function (_a) {
    var selected = _a.selected;
    return (selected ? COLORS$1.BLUE : COLORS$1.GRAY_100);
});
var templateObject_1$1R, templateObject_2$1v, templateObject_3$1c, templateObject_4$$;

var PageInfoText = function (props) {
    var _a;
    var contentText = props.contentText, headerText = props.headerText, bulkArray = props.bulkArray, dealsArray = props.dealsArray, fbcArray = props.fbcArray, facetValueCb = props.facetValueCb, rest = __rest(props, ["contentText", "headerText", "bulkArray", "dealsArray", "fbcArray", "facetValueCb"]);
    var isMobile = useBreakpoints().isMobile;
    var fbcIconUrl = useFbcFeature$1().fbcIconUrl;
    var isFbcEnabled = ((_a = useFeature('catl.fbc_quick_filter.enabled')) === null || _a === void 0 ? void 0 : _a.on) || false;
    return (React.createElement(ContentWrapper$3, __assign({ "data-testid": "page-info-wrapper" }, rest),
        React.createElement(Container$h, null,
            !isMobile && React.createElement("h1", { "data-testid": "page-info-header", dangerouslySetInnerHTML: { __html: headerText } }),
            React.createElement(PageInfoContent$1, null,
                React.createElement("p", { "data-testid": "page-info-content" }, contentText),
                isFbcEnabled && (fbcArray === null || fbcArray === void 0 ? void 0 : fbcArray.map(function (value) { return (React.createElement(QuickFilters$1, { key: value.name, selected: value.selected, onClick: facetValueCb('isFbc', value.name), "data-testid": "fbc-quick-filter" },
                    fbcIconUrl && React.createElement(Image, { url: fbcIconUrl, name: "fbcIcon", width: "24px", marginRight: 1 }),
                    value.name)); })), bulkArray === null || bulkArray === void 0 ? void 0 :
                bulkArray.map(function (value) { return (React.createElement(QuickFilters$1, { key: value.name, selected: value.selected, onClick: facetValueCb('is_bulk', value.name) }, value.name)); }), dealsArray === null || dealsArray === void 0 ? void 0 :
                dealsArray.map(function (value) { return (React.createElement(QuickFilters$1, { key: value.name, selected: value.selected, "data-testid": value, onClick: facetValueCb('deal', value.name) }, value.name)); })))));
};

var setWrapper = function (type) { return ({
    type: type,
}); };

var FBCInformation = function (_a) {
    var msg = _a.msg, setPopup = _a.setPopup;
    return (React.createElement(React.Fragment, null,
        React.createElement(Flex, { flexDirection: "column" },
            React.createElement("text", { fontSize: "16px", fontWeight: "700" }, msg),
            React.createElement(Button$1, { height: '40px', mt: 2, mb: [2, 1], onClick: setPopup }, i18next.t('FBC.gotIt')))));
};

var getFBCSheetContent = function (fbcSheetType, fulfilled) {
    switch (fbcSheetType) {
        case E_SOLD_BY_MESSAGE_TYPE$1.SFC:
            return {
                heading: i18next.t('FBC.sfcHeading'),
                msg: i18next.t('FBC.sfcMsg'),
            };
        case E_SOLD_BY_MESSAGE_TYPE$1.SSDC:
            return {
                heading: i18next.t('FBC.ssfcHeading'),
                msg: i18next.t('FBC.ssfcMsg'),
            };
        case E_SOLD_BY_MESSAGE_TYPE$1.SSFBC:
            return {
                heading: (fulfilled === null || fulfilled === void 0 ? void 0 : fulfilled.title) || '',
                msg: (fulfilled === null || fulfilled === void 0 ? void 0 : fulfilled.staticDesc) || '',
            };
        default:
            return {
                heading: i18next.t('FBC.ssfsHeading'),
                msg: i18next.t('FBC.ssfsMsg'),
            };
    }
};
var FBCModal = function () {
    var isMobile = useBreakpoints().isMobile;
    var fbcSheet = useSelector(function (state) { return state.fbcSheet; });
    var fbc = useSelector(function (state) { return state.appConfig.countryConfiguration; }).fbc;
    var fulfilled = (fbc || { fulfilled: {} }).fulfilled;
    var isOpen = fbcSheet.isOpen, fbcSheetType = fbcSheet.fbcSheetType;
    var _a = getFBCSheetContent(fbcSheetType, fulfilled), heading = _a.heading, msg = _a.msg;
    var dispatch = useDispatch();
    var setPopup = function () {
        dispatch(setWrapper(E_TRIGGER_TYPE$1.CLOSE));
    };
    return (React.createElement(React.Fragment, null, isMobile ? (React.createElement(Drawer, { anchor: ['bottom', null, 'right'], isOpen: isOpen, onClose: setPopup, title: React.createElement(Box, { sx: {
                fontFamily: 'Montserrat',
            }, fontWeight: 6, color: COLORS.BLACK, fontSize: 2 }, heading), width: [null, null, '522px'], contentStyles: { pt: 1, borderRadius: '20px', fontFamily: 'Montserrat' }, variant: "compact", containerStyles: {
            borderTopLeftRadius: [4, null, null, 0],
            borderTopRightRadius: [4, null, null, 0],
        } },
        React.createElement(FBCInformation, { msg: msg, setPopup: setPopup }))) : (React.createElement(Modal, { isOpen: isOpen, onClose: setPopup, width: "422px", titleStyles: { fontWeight: 'bold', borderRadius: '20px', marginTop: '9px', fontFamily: 'Montserrat' }, title: heading },
        React.createElement(Box, { fontFamily: "Montserrat" },
            React.createElement(FBCInformation, { msg: msg, setPopup: setPopup }))))));
};

var SoldByComponent = function (_a) {
    var isFBC = _a.isFBC, fullfilledText = _a.fullfilledText, msgType = _a.msgType, _b = _a.showIcon, showIcon = _b === void 0 ? true : _b;
    var dispatch = useDispatch();
    var fbcIconUrl = useFbcFeature$1().fbcIconUrl;
    var setPopup = function () {
        dispatch(setWrapper(msgType));
    };
    return (React.createElement(React.Fragment, null, isFBC !== undefined && (React.createElement(React.Fragment, null,
        React.createElement(Flex, { "data-testId": "fbc-info", width: "100%", alignItems: "center", justifyContent: ['space-between', 'flex-start'] },
            React.createElement(Flex, { alignItems: "center" },
                isFBC && !!fbcIconUrl && React.createElement(Image, { url: fbcIconUrl, name: "fbcIcon", width: "24px" }),
                React.createElement(Box, { ml: isFBC ? '2px' : '', as: "span" }, fullfilledText)),
            showIcon && (React.createElement(Button$1, { alignItems: 'center', height: "auto", ml: 2, mr: '-2px', pt: 1, variant: "link", onClick: setPopup },
                React.createElement(Information, { fill: COLORS$1.BLUE }))))))));
};

// TODO: move this to somewhere safer and globally available
var GTM_KEYS$1 = {
    uat: {
        mafuae: '',
        mafegy: '',
        mafsau: '',
        mafjor: '',
        mafqat: '',
        maflbn: '',
        mafpak: '',
        mafbhr: '',
        mafkwt: '',
        mafomn: '',
        mafken: '',
        mafgeo: '',
        mafuzb: '',
        mafarm: '',
        mafuga: '',
        mafirq: '',
        unified: process.env.REACT_APP_GTM_KEY,
    },
    prod: {
        mafuae: '',
        mafegy: '',
        mafsau: '',
        mafjor: '',
        mafqat: '',
        maflbn: '',
        mafpak: '',
        mafbhr: '',
        mafkwt: '',
        mafomn: '',
        mafken: '',
        mafgeo: '',
        mafuzb: '',
        mafarm: '',
        mafuga: '',
        mafirq: '',
        unified: process.env.REACT_APP_GTM_KEY,
    },
};
var initGTM = function (storeId, pageData) {
    var _a;
    var gtmId = process.env.REACT_APP_GTM_KEY; // fallback to not break existing apps
    if (storeId) {
        var currentEnv = process.env.REACT_APP_ENV;
        gtmId = (GTM_KEYS$1[currentEnv] || GTM_KEYS$1.uat)[storeId];
    }
    var store = getStore$1();
    var isFLagshipEnabled = (_a = getGrowthBookFeatureValueViaInstance$1(store === null || store === void 0 ? void 0 : store.getState(), GROWTHBOOK_FLAGS$1.flagshipEnabled)) === null || _a === void 0 ? void 0 : _a.on;
    var dataLayer;
    if (isFLagshipEnabled) {
        var flagshipId = getCustomCookie$1(constants$1.rrUserId) || getCustomCookie$1(constants$1.rrSessionId);
        dataLayer = { flagship_visitor_id: flagshipId };
    }
    if (pageData) {
        dataLayer = __assign(__assign({}, dataLayer), pageData);
    }
    var tagManagerArgs = {
        gtmId: gtmId,
    };
    tagManagerArgs.dataLayer = dataLayer;
    if (gtmId) {
        TagManager.initialize(tagManagerArgs);
        store.dispatch(setGTMInitialized(true));
    }
};

var pushFlagsDataInGTM = function (visitorId, flagsData) {
    var map = new Map();
    flagsData.forEach(function (_a) {
        var _b = _a.campaignId, campaignId = _b === void 0 ? '' : _b, _c = _a.campaignType, campaignType = _c === void 0 ? '' : _c, _d = _a.variationGroupId, variationGroupId = _d === void 0 ? '' : _d, _e = _a.variationId, variationId = _e === void 0 ? '' : _e, _f = _a.campaignName, campaignName = _f === void 0 ? '' : _f, _g = _a.variationName, variationName = _g === void 0 ? '' : _g, _h = _a.isReference, isReference = _h === void 0 ? false : _h;
        if (!map.has(campaignId)) {
            map.set(campaignId, true);
            dataLayer.push({
                event: GTMEvents$1.viewed_experiment,
                experiment_key: campaignName,
                flagship_visitor_id: visitorId,
                flagship_campaign_id: campaignId,
                flagship_variation_name: variationName,
                flagship_campaign_name: campaignName,
                variation_id: isReference ? 0 : 1,
                flagship_campaign_type: campaignType,
                flagship_variation_group_id: variationGroupId,
                flagship_variation_id: variationId,
                flagship_platform: GTMEvents$1.platform,
            });
        }
    });
};

var ConsumerLogoContainer$1 = customStyled(Flex)(templateObject_1$1S || (templateObject_1$1S = __makeTemplateObject(["\n  --direction: column;\n  flex-direction: var(--direction);\n  gap: 10px;\n  @media only screen and (max-width: ", " ) {\n    --direction: row;\n  }\n"], ["\n  --direction: column;\n  flex-direction: var(--direction);\n  gap: 10px;\n  @media only screen and (max-width: ", " ) {\n    --direction: row;\n  }\n"])), function (props) { return props.theme.breakpoints[3]; });
var FooterBrandLogoContainer$1 = customStyled(Flex)(templateObject_2$1w || (templateObject_2$1w = __makeTemplateObject(["\n  --direction: column;\n  flex-direction: var(--direction);\n  gap: 10px;\n  @media only screen and (max-width: ", " ) {\n    --direction: row;\n  }\n"], ["\n  --direction: column;\n  flex-direction: var(--direction);\n  gap: 10px;\n  @media only screen and (max-width: ", " ) {\n    --direction: row;\n  }\n"])), function (props) { return props.theme.breakpoints[3]; });
var FooterBrandLogo$1 = customStyled.img(templateObject_3$1d || (templateObject_3$1d = __makeTemplateObject(["\n  max-inline-size: 100%;\n  block-size: auto;\n  max-width: 100%;\n"], ["\n  max-inline-size: 100%;\n  block-size: auto;\n  max-width: 100%;\n"])));
var SocialIconWrapper$1 = customStyled.div(templateObject_4$10 || (templateObject_4$10 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  max-width: 200px; \n  margin-top: 5px;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  max-width: 200px; \n  margin-top: 5px;\n"])));
var FooterTop$1 = customStyled.div(templateObject_5$N || (templateObject_5$N = __makeTemplateObject(["\n  background: ", ";\n  padding: 24px 0;\n\n  p,\n  a,\n  h4 {\n    color: ", ";\n  }\n\n  li {\n    list-style: none;\n    a {\n      text-decoration: none;\n      font-size: 12px;\n      line-height: 16px;\n      display: block;\n    }\n  }\n  ", "\n"], ["\n  background: ", ";\n  padding: 24px 0;\n\n  p,\n  a,\n  h4 {\n    color: ", ";\n  }\n\n  li {\n    list-style: none;\n    a {\n      text-decoration: none;\n      font-size: 12px;\n      line-height: 16px;\n      display: block;\n    }\n  }\n  ", "\n"])), function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.colors.white; }, padding);
var FooterContainer$1 = customStyled(Flex)(templateObject_6$D || (templateObject_6$D = __makeTemplateObject(["\n  margin: 0 auto;\n  max-width: ", "px;\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  margin: 0 auto;\n  max-width: ", "px;\n  display: flex;\n  flex-wrap: wrap;\n"])), function (props) { return props.theme.maxLayoutWidth; });
var FooterBranding$1 = styled(Flex)(templateObject_7$A || (templateObject_7$A = __makeTemplateObject(["\n  flex-basis: 20%;\n"], ["\n  flex-basis: 20%;\n"])));
FooterBranding$1.defaultProps = {
    flexDirection: ['column', 'row', null, null, 'column'],
    justifyContent: ['space-between', null, null, null, 'start'],
};
var SocialIcons$1 = styled(Flex)(templateObject_8$A || (templateObject_8$A = __makeTemplateObject([""], [""])));
SocialIcons$1.defaultProps = {
    alignItems: ['center', null, null, null, 'start'],
    flexDirection: [null, null, null, null, 'column'],
    mt: ['12px', 0, null, null, 30],
};
var ConsumerRights$1 = styled(Box)(templateObject_9$x || (templateObject_9$x = __makeTemplateObject(["\n  max-width: 74px;\n  margin-top: 30px;\n"], ["\n  max-width: 74px;\n  margin-top: 30px;\n"])));
ConsumerRights$1.defaultProps = {
    as: 'img',
    display: ['none', null, null, null, 'block'],
};
var FooterSiteNav$1 = customStyled.div(templateObject_10$w || (templateObject_10$w = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1;\n  justify-content: space-between;\n  li {\n    margin-bottom: 8px;\n  }\n  a:hover {\n    text-decoration: underline;\n  }\n  gap: 20px;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1;\n  justify-content: space-between;\n  li {\n    margin-bottom: 8px;\n  }\n  a:hover {\n    text-decoration: underline;\n  }\n  gap: 20px;\n"])));
var Column$1 = styled(Flex)(templateObject_11$q || (templateObject_11$q = __makeTemplateObject(["\n  flex-basis: 23%;\n  flex-direction: column;\n"], ["\n  flex-basis: 23%;\n  flex-direction: column;\n"])));
var Title$9 = styled(Box)(templateObject_12$o || (templateObject_12$o = __makeTemplateObject([""], [""])));
Title$9.defaultProps = {
    color: 'white',
    fontSize: 2,
    mb: 3,
};
var AppLogo$1 = styled.a(templateObject_13$n || (templateObject_13$n = __makeTemplateObject(["\n  img {\n    width: 100px;\n    height: auto;\n    padding-left: 16px;\n  }\n"], ["\n  img {\n    width: 100px;\n    height: auto;\n    padding-left: 16px;\n  }\n"])));
var FooterContactUs$1 = styled(Flex)(templateObject_14$n || (templateObject_14$n = __makeTemplateObject(["\n  flex-basis: 100%;\n  justify-content: flex-end;\n"], ["\n  flex-basis: 100%;\n  justify-content: flex-end;\n"])));
FooterContactUs$1.defaultProps = {
    mt: 3,
};
var FooterApps$1 = styled(Flex)(templateObject_15$n || (templateObject_15$n = __makeTemplateObject(["\n  align-items: center;\n  flex-basis: 100%;\n  justify-content: var(--justifyContent, flex-end);\n  margin-top: 16px;\n  gap: 10px;\n  @media (max-width: ", "px) {\n    --justifyContent: space-evenly;\n  }\n"], ["\n  align-items: center;\n  flex-basis: 100%;\n  justify-content: var(--justifyContent, flex-end);\n  margin-top: 16px;\n  gap: 10px;\n  @media (max-width: ", "px) {\n    --justifyContent: space-evenly;\n  }\n"])), BREAKPOINTS$1[1]);
var FooterAccordion$1 = customStyled(Accordion)(templateObject_16$h || (templateObject_16$h = __makeTemplateObject(["\n  background-color: ", ";\n  justify-content: space-between;\n"], ["\n  background-color: ", ";\n  justify-content: space-between;\n"])), function (props) { return props.theme.colors.blue; });
var List$1 = styled.ul(templateObject_17$h || (templateObject_17$h = __makeTemplateObject(["\n  background-color: ", ";\n  max-height: 500px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  ", "\n"], ["\n  background-color: ", ";\n  max-height: 500px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  ", "\n"])), COLORS$1.PURPLE, padding);
var ContactUsWrapper$1 = styled(Flex)(templateObject_18$e || (templateObject_18$e = __makeTemplateObject(["\n  background: ", ";\n  justify-content: space-between;\n  color: ", ";\n"], ["\n  background: ", ";\n  justify-content: space-between;\n  color: ", ";\n"])), COLORS$1.PURPLE, COLORS$1.WHITE);
var ContactUsLink$1 = styled(Box)(templateObject_19$e || (templateObject_19$e = __makeTemplateObject(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
ContactUsLink$1.defaultProps = {
    as: 'a',
    fontSize: [25, 30],
    ml: 2,
};
var Container$i = styled(Flex)(templateObject_20$c || (templateObject_20$c = __makeTemplateObject(["\n  flex-direction: column;\n  color: ", ";\n  margin-top: 40px;\n  gap: 10px;\n"], ["\n  flex-direction: column;\n  color: ", ";\n  margin-top: 40px;\n  gap: 10px;\n"])), COLORS$1.WHITE);
var templateObject_1$1S, templateObject_2$1w, templateObject_3$1d, templateObject_4$10, templateObject_5$N, templateObject_6$D, templateObject_7$A, templateObject_8$A, templateObject_9$x, templateObject_10$w, templateObject_11$q, templateObject_12$o, templateObject_13$n, templateObject_14$n, templateObject_15$n, templateObject_16$h, templateObject_17$h, templateObject_18$e, templateObject_19$e, templateObject_20$c;

var selectfooterData$1 = createSelector(function (state) { return state.footerData; }, function (state) { return state === null || state === void 0 ? void 0 : state.data; });
var getLinks$1 = createSelector(selectfooterData$1, function (state) {
    var _a;
    return (_a = state === null || state === void 0 ? void 0 : state.list_link) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
        var title = _a.title, text_link = _a.text_link;
        return ({
            label: title || '',
            links: text_link.map(function (_a) {
                var title = _a.title, cta_url_web = _a.cta_url_web, ctaUrlWebExternal = _a.ctaUrlWebExternal;
                return ({
                    name: title,
                    href: cta_url_web,
                    externalLink: ctaUrlWebExternal,
                });
            }) || [],
        });
    });
});

var FooterImageLinkWrapper$1 = function (props) {
    var data = props.data, rest = __rest(props, ["data"]);
    return data.map(function (ele, index) { return React.createElement(FooterImageLink$1, __assign({}, rest, ele, { key: index })); });
};
var FooterImageLink$1 = function (props) {
    var media_mobile = props.media_mobile, media_web = props.media_web, alt_text = props.alt_text, width = props.width, height = props.height, cta_url_web = props.cta_url_web, target = props.target;
    return (React.createElement("a", { href: cta_url_web, target: target },
        React.createElement("picture", null,
            React.createElement("source", { srcSet: media_mobile, media: "(max-width: " + BREAKPOINTS$1[0] + "px)" }),
            React.createElement(FooterBrandLogo$1, { src: media_web, alt: alt_text, width: width, height: height, loading: "lazy", decoding: "async" }))));
};

var currentYear$1 = new Date().getFullYear();
var Copyright$1 = customStyled.div(templateObject_1$1T || (templateObject_1$1T = __makeTemplateObject(["\n  background: ", ";\n  ", ";\n"], ["\n  background: ", ";\n  ", ";\n"])), function (props) { return props.theme.colors.brown; }, padding);
var CopyrightMaxLayout$3 = customStyled(Flex)(templateObject_2$1x || (templateObject_2$1x = __makeTemplateObject(["\n  align-items: center;\n  margin: 0 auto;\n  max-width: ", "px;\n  flex-wrap: wrap;\n  justify-content: space-around;\n"], ["\n  align-items: center;\n  margin: 0 auto;\n  max-width: ", "px;\n  flex-wrap: wrap;\n  justify-content: space-around;\n"])), function (props) { return props.theme.maxLayoutWidth; });
var CopyrightText$1 = customStyled(Box)(templateObject_3$1e || (templateObject_3$1e = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", "px;\n  margin-bottom: -4px;\n"], ["\n  color: ", ";\n  font-size: ", "px;\n  margin-bottom: -4px;\n"])), function (props) { return props.theme.colors.white; }, function (props) { return props.theme.fontSizes[1]; });
var Logo$7 = customStyled.a(templateObject_4$11 || (templateObject_4$11 = __makeTemplateObject(["\n  svg {\n    display: block; {/* Remove space around the element */}\n  }\n  color: ", "\n"], ["\n  svg {\n    display: block; {/* Remove space around the element */}\n  }\n  color: ", "\n"])), COLORS$1.WHITE);
var companyTextResponsive = {
    en: {
        SX: {
            textAlign: ['center', 'left'],
            ml: 3,
        },
    },
    ar: {
        SX: {
            textAlign: ['center', 'right'],
            mr: 3,
        },
    },
    ka: {
        SX: {
            textAlign: ['center', 'left'],
            mr: 3,
        },
    },
    uz: {
        SX: {
            textAlign: ['center', 'left'],
            mr: 3,
        },
    },
    ru: {
        SX: {
            textAlign: ['center', 'left'],
            mr: 3,
        },
    },
};
var Copyright$2 = (function () {
    var _a = __read(useAppConfig$1(), 1), _b = _a[0], _c = _b.language, language = _c === void 0 ? '' : _c, storeId = _b.storeId;
    var t = useTranslation().t;
    var copyright = useCallback(function () { return t('footer.copyright', { year: currentYear$1 }); }, [t]);
    var copyright_info = (useSelector(selectfooterData$1) || {}).copyright_info;
    var _d = copyright_info || {}, copyright_text = _d.copyright_text, logo_media = _d.logo_media;
    if (!language) {
        return null;
    }
    var copyrightText = copyright_text || React.createElement("span", { dangerouslySetInnerHTML: { __html: copyright() } });
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { py: 2, color: COLORS$1.BLACK, fontSize: "11px", textAlign: "center", display: ['block', 'none'] }, copyrightText),
        React.createElement(Copyright$1, { py: [14, null, null, null, 18], px: [3, 4] },
            React.createElement(CopyrightMaxLayout$3, null,
                logo_media && logo_media > 0 ? (React.createElement(FooterImageLinkWrapper$1, { data: logo_media, width: 120 })) : (storeId !== 'mafqat' && (React.createElement(Logo$7, { href: "//www.majidalfuttaim.com", target: "_blank" }, language === 'en' || language === 'ka' || language === 'ru' || language === 'uz' ? (React.createElement(MafLogoEn, { fill: "#fff", size: "CUSTOM", height: 48, width: 164 })) : (React.createElement(MafLogoAr, { fill: "#fff", size: "CUSTOM", height: 48, width: 164 }))))),
                React.createElement(CopyrightText$1, { sx: companyTextResponsive[language].SX, pt: [1, 0], flexGrow: 1 }),
                React.createElement(CopyrightText$1, { display: ['none', 'block'] }, copyrightText)))));
});
var templateObject_1$1T, templateObject_2$1x, templateObject_3$1e, templateObject_4$11;

var SocialMedia$1;
(function (SocialMedia) {
    SocialMedia["FACEBOOK"] = "Facebook";
    SocialMedia["TWITTER"] = "Twitter";
    SocialMedia["INSTAGRAM"] = "Instagram";
    SocialMedia["YOUTUBE"] = "YouTube";
})(SocialMedia$1 || (SocialMedia$1 = {}));

var SocialIconList$1 = memo(function (props) {
    var name = props.name;
    var params = { height: 24, width: 24, size: 'CUSTOM' };
    switch (name) {
        case SocialMedia$1.FACEBOOK:
            return React.createElement(Facebook, __assign({}, params));
        case SocialMedia$1.TWITTER:
            return React.createElement(Twitter, __assign({}, params));
        case SocialMedia$1.INSTAGRAM:
            return React.createElement(Instagram, __assign({}, params));
        case SocialMedia$1.YOUTUBE:
            return React.createElement(YouTube, __assign({}, params));
        default:
            return null;
    }
});

var SOCIAL_MEDIA_LINKS$1 = {
    mafuae: {
        Facebook: 'carrefouruae',
        Twitter: 'carrefouruae',
        Instagram: 'carrefouruae',
        YouTube: 'CarrefourUAE',
    },
    mafgeo: {
        Facebook: 'carrefourgeorgia',
        Twitter: 'carrefourge',
        Instagram: 'carrefour_georgia',
        YouTube: 'channel/UCQ7aPJ3odUD15oPgBrqhEtA/search',
    },
    mafegy: {
        Facebook: 'carrefouregypt',
        Twitter: 'CarrefourEgypt',
        Instagram: 'carrefouregypt',
        YouTube: 'user/CarrefourEgypt',
    },
    mafsau: {
        Facebook: 'Carrefoursaudi',
        Twitter: 'carrefoursaudi',
        Instagram: 'carrefoursaudi',
        YouTube: 'user/CarrefourSaudi',
    },
    mafjor: {
        Facebook: 'CarrefourJordanOfficialPage',
        Twitter: 'carrefourjo',
        Instagram: 'carrefourjo',
        YouTube: 'channel/UChnMFQor7LVKK_GuUF2BVCw',
    },
    maflbn: {
        Facebook: 'carrefourlebanon',
        Twitter: 'carrefourleb',
        Instagram: 'carrefourlebanon',
        YouTube: 'user/carrefourlebanon',
    },
    mafqat: {
        Facebook: 'CarrefourQatar',
        Twitter: 'carrefour_qa',
        Instagram: 'carrefour_qa',
        YouTube: 'channel/UCecXe3Tymp1QC8Cmx6pXjVQ',
    },
    mafpak: {
        Facebook: 'OfficialCarrefourPakistan',
        Twitter: 'carrefour_pak',
        Instagram: 'carrefourpak',
        YouTube: 'channel/UCQYs-5-kFHRVIyefzZ6oyCQ',
    },
    mafuzb: {
        Facebook: 'carrefouruzbekistan',
        Twitter: 'majidalfuttaim',
        Instagram: 'carrefouruzbekistan',
        YouTube: 'user/majidalfuttaim/',
    },
    mafuga: {
        Facebook: 'UgCarrefour',
        Twitter: 'CarrefourUG',
        Instagram: 'carrefouruganda',
        YouTube: 'user/majidalfuttaim/',
    },
    mafirq: {
        Facebook: 'Carrefour.Iraq',
        Twitter: 'Carrefour_Iraq',
        Instagram: 'carrefour_iraq',
        YouTube: 'CarrefourIraq',
    },
};
var SOCIAL_MEDIA_DOMAINS$1 = {
    Facebook: 'facebook.com',
    Twitter: 'twitter.com',
    Instagram: 'instagram.com',
    YouTube: 'youtube.com',
};
var SocialIcon$1 = memo(function () {
    var t = useTranslation().t;
    var _a = __read(useAppConfig$1(), 1), storeId = _a[0].storeId;
    var stay_in_touch = (useSelector(selectfooterData$1) || {}).stay_in_touch;
    var _b = stay_in_touch || {}, image_link = _b.image_link, title = _b.title;
    var socialMediaLinks = useMemo(function () { return SOCIAL_MEDIA_LINKS$1[storeId]; }, [storeId]);
    var isFromStrapi = image_link && (image_link === null || image_link === void 0 ? void 0 : image_link.length) > 0;
    return (React.createElement(SocialIcons$1, { "data-testid": "social-media" },
        React.createElement(Box, { color: "white", mr: 3, my: 2 }, title || t('footer.stayInTouch')),
        !isFromStrapi ? (React.createElement(Flex, { mt: 1 }, socialMediaLinks &&
            Object.keys(socialMediaLinks).map(function (socialMedia, i) {
                var link = socialMediaLinks[socialMedia];
                return link ? (React.createElement(Box, { key: socialMedia, ml: i ? 3 : 0, as: "a", height: 24, width: 24, href: "https://" + SOCIAL_MEDIA_DOMAINS$1[socialMedia] + "/" + link, target: "_blank" },
                    React.createElement(SocialIconList$1, { name: socialMedia }))) : null;
            }))) : (React.createElement(SocialIconWrapper$1, null,
            React.createElement(FooterImageLinkWrapper$1, { data: image_link, width: 24, target: "_blank" })))));
});
var Branding$2 = function (props) {
    var _a;
    var t = useTranslation().t;
    var _b = __read(useAppConfig$1(), 1), _c = _b[0], storeId = _c.storeId, _d = _c.language, language = _d === void 0 ? 'en' : _d; // ENABLE_CACHE_HOME
    var _e = useSelector(selectfooterData$1) || {}, _f = _e.consumer_right_logo, consumer_right_logo = _f === void 0 ? [] : _f, _g = _e.logo_media, logo_media = _g === void 0 ? [] : _g;
    var shouldShowQR = ((_a = useFeature('footer.should_show_qr_code.enabled')) === null || _a === void 0 ? void 0 : _a.on) || false;
    var newLogo = (React.createElement(ConsumerLogoContainer$1, { mt: 20 },
        React.createElement(FooterImageLinkWrapper$1, { data: consumer_right_logo, width: 74, target: "_blank" })));
    return (React.createElement(FooterBranding$1, __assign({}, props),
        logo_media.length > 0 ? (React.createElement(FooterBrandLogoContainer$1, null,
            React.createElement(FooterImageLinkWrapper$1, { data: logo_media, width: 142 }))) : (React.createElement(Logo$5, { language: language, storeId: storeId, fill: COLORS$1.WHITE })),
        React.createElement(SocialIcon$1, null),
        consumer_right_logo.length > 0 ? newLogo : null,
        EStoreID$1.MAFSAU === storeId && (React.createElement(Container$i, null,
            React.createElement("div", null,
                React.createElement("span", { dir: "ltr" }, t('ksaCr'))),
            React.createElement("div", null,
                React.createElement("span", { dir: "ltr" }, t('ksaVat'))),
            shouldShowQR && (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement("span", { dir: "ltr" }, t('authenticationCode'))),
                React.createElement(Box, { as: "div", width: 120 },
                    React.createElement(Image, { url: process.env.REACT_APP_CDN_URL + "/assets/images/" + storeId + "_qrcode.png", name: "qr_code" }))))))));
};
var Branding$3 = React.memo(Branding$2);

var CUSTOMER_SERVICE_LINKS$1 = [
    {
        name: 'serviceWarranty',
        href: '/servicewarranty',
    },
    {
        name: 'returnExchange',
        href: '/returnandexchange',
    },
    {
        name: 'securedOnlinePayments',
        href: '/onlinepayments',
    },
    {
        name: 'cashOnDelivery',
        href: '/cashondelivery',
    },
    {
        name: 'shippingDelivery',
        href: '/shippingdelivery',
    },
    {
        name: 'valetTrolley',
        href: '/valet-trolley-home-delivery',
    },
];
var HELP_AND_SUPPORT_LINKS$1 = [
    {
        name: 'sitemap',
        href: '/sitemap',
    },
    {
        name: 'privacyPolicy',
        href: '/privacypolicy',
    },
    {
        name: 'disclaimer',
        href: 'https://www.majidalfuttaim.com/en/anti-fraud-disclaimer',
    },
    {
        name: 'disclosure',
        href: 'https://www.majidalfuttaim.com/en/responsible-disclosure-policy',
    },
    {
        name: 'termsConditions',
        href: '/termsandconditions',
    },
    {
        name: 'contactUs',
        href: '/contact-us',
    },
    {
        name: 'faqs',
        href: '/instorefaqs',
    },
    {
        name: 'findStore',
        href: '/store-finder',
    },
];
var HELP_AND_SUPPORT$1 = {
    mafuae: [
        {
            name: 'privacyPolicy',
            href: '/helpcenter/articles/service/18?article=21',
        },
        {
            name: 'disclaimer',
            href: 'https://www.majidalfuttaim.com/en/anti-fraud-disclaimer',
        },
        {
            name: 'disclosure',
            href: 'https://www.majidalfuttaim.com/en/responsible-disclosure-policy',
        },
        {
            name: 'termsConditions',
            href: '/helpcenter/articles/service/18?article=23',
        },
        {
            name: 'contactUs',
            href: '/contact-us',
        },
        {
            name: 'faqs',
            href: '/helpcenter/',
        },
        {
            name: 'findStore',
            href: '/store-finder',
        },
    ],
    mafegy: __spread(HELP_AND_SUPPORT_LINKS$1),
    mafsau: __spread(HELP_AND_SUPPORT_LINKS$1),
    mafjor: __spread(HELP_AND_SUPPORT_LINKS$1),
    mafkwt: __spread(HELP_AND_SUPPORT_LINKS$1),
    maflbn: __spread(HELP_AND_SUPPORT_LINKS$1),
    mafgeo: __spread(HELP_AND_SUPPORT_LINKS$1.filter(function (ele) { return ele.name !== 'sitemap'; })),
    mafpak: __spread(HELP_AND_SUPPORT_LINKS$1),
    mafken: __spread(HELP_AND_SUPPORT_LINKS$1),
    mafqat: __spread(HELP_AND_SUPPORT_LINKS$1),
    mafuzb: __spread(HELP_AND_SUPPORT_LINKS$1),
    mafuga: __spread(HELP_AND_SUPPORT_LINKS$1),
    mafirq: __spread(HELP_AND_SUPPORT_LINKS$1),
};
var HELPING_YOU_SAVE = {
    mafuae: [
        {
            name: 'extendedWarrantyRetail',
            href: '/helpcenter/articles/service/3-Service-and-Warranty?topic=3-Service-and-Warranty&type=service',
        },
        {
            name: 'easyPaymentPlan',
            href: '/helpcenter/articles/service/10?article=19',
        },
        {
            name: 'shareRewards',
            href: '/helpcenter/articles/topic/18-SHARE',
        },
    ],
    mafegy: [
        {
            name: 'extendedWarrantyRetail',
            href: '/extendedwarranty',
        },
        {
            name: 'giftCard',
            href: '/giftcard',
        },
        {
            name: 'whatIsMyClub',
            href: '/myclub',
        },
        {
            name: 'myClubOffers',
            href: '/myclub-offers/c/MyCLUB-deals',
        },
        {
            name: 'carnivalOffers',
            href: '/storespromotions',
        },
    ],
    mafsau: [
        {
            name: 'giftCard',
            href: '/giftcard',
        },
        {
            name: 'myClub',
            href: '/myclub',
        },
        {
            name: 'blogsRecipesTips',
            href: '/blog',
        },
    ],
    mafjor: [
        {
            name: 'ourWeeklyCatalogue',
            href: '/storespromotions',
        },
        {
            name: 'installmentProgram',
            href: '/installmentprogram',
        },
        {
            name: 'products',
            href: '/carrefourproducts',
        },
        {
            name: 'news',
            href: '/lowest-price',
        },
        {
            name: 'myClub',
            href: '/myclub',
        },
    ],
    mafkwt: [
        {
            name: 'ourWeeklyCatalogue',
            href: '/storespromotions',
        },
        {
            name: 'installmentProgram',
            href: '/installmentprogram',
        },
        {
            name: 'products',
            href: '/carrefourproducts',
        },
        {
            name: 'news',
            href: '/lowest-price',
        },
        {
            name: 'myClub',
            href: '/myclub',
        },
    ],
    maflbn: [
        {
            name: 'myClubCashback',
            href: '/myclubcashback',
        },
        {
            name: 'installmentProgram',
            href: '/installmentprogram',
        },
        {
            name: 'top10MyClub',
            href: '/Top10MyCLUB',
        },
        {
            name: 'products',
            href: '/carrefourproducts',
        },
        {
            name: 'num1Products',
            href: '/number1products',
        },
        {
            name: 'deliveryCallConnect',
            href: '/HomeDelivery',
        },
    ],
    mafqat: [
        {
            name: 'extendedWarrantyRetail',
            href: '/extendedwarranty',
        },
        {
            name: 'extendedWarrantyTc',
            href: '/termsextendedwarranty',
        },
        {
            name: 'giftCard',
            href: '/giftcard',
        },
        {
            name: 'myClub',
            href: '/myclub',
        },
        {
            name: 'reusableBags',
            href: '/reusablebags',
        },
        {
            name: 'products',
            href: '/carrefourproducts',
        },
    ],
    mafgeo: [
        {
            name: 'extendedWarrantyRetail',
            href: '/extendedwarranty',
        },
    ],
    mafuzb: [
        {
            name: 'extendedWarrantyRetail',
            href: '/extendedwarranty',
        },
    ],
    mafuga: [
        {
            name: 'extendedWarrantyRetail',
            href: '/extendedwarranty',
        },
    ],
    mafirq: [
        {
            name: 'extendedWarrantyRetail',
            href: '/extendedwarranty',
        },
    ],
};
var CUSTOMER_SERVICE$1 = {
    mafuae: [
        {
            name: 'serviceWarranty',
            href: '/helpcenter/articles/service/3-Service%20and%20Warranty',
        },
        {
            name: 'returnExchange',
            href: '/helpcenter/articles/service/4-Return-%20and%20Exchange-',
        },
        {
            name: 'securedOnlinePayments',
            href: '/helpcenter/articles/service/10-Payment-',
        },
        {
            name: 'cashOnDelivery',
            href: '/helpcenter/articles/service/10?article=10',
        },
        {
            name: 'shippingDelivery',
            href: '/helpcenter/articles/topic/21-Shipping%20&%20Delivery',
        },
        {
            name: 'valetTrolley',
            href: '/helpcenter/articles/topic/19-Valet%20trolley',
        },
    ],
    mafegy: __spread(CUSTOMER_SERVICE_LINKS$1),
    mafsau: __spread(CUSTOMER_SERVICE_LINKS$1),
    mafjor: __spread(CUSTOMER_SERVICE_LINKS$1),
    mafkwt: __spread(CUSTOMER_SERVICE_LINKS$1),
    maflbn: __spread(CUSTOMER_SERVICE_LINKS$1),
    mafgeo: [
        {
            name: 'serviceWarranty',
            href: '/servicewarranty',
        },
        {
            name: 'returnExchange',
            href: '/returnandexchange',
        },
        {
            name: 'securedOnlinePayments',
            href: '/securepayment',
        },
        {
            name: 'cashOnDelivery',
            href: '/cashondelivery',
        },
        {
            name: 'shippingDelivery',
            href: '/shippingdelivery',
        },
    ],
    mafpak: [
        {
            name: 'serviceWarranty',
            href: '/servicewarranty',
        },
        {
            name: 'returnExchange',
            href: '/returnandexchange',
        },
        {
            name: 'securedOnlinePayments',
            href: '/onlinepayments',
        },
        {
            name: 'cashOnDelivery',
            href: '/cashondelivery',
        },
        {
            name: 'shippingDelivery',
            href: '/shippingdelivery',
        },
    ],
    mafken: [
        {
            name: 'serviceWarranty',
            href: '/servicewarranty',
        },
        {
            name: 'returnExchange',
            href: '/returnandexchange',
        },
        {
            name: 'securedOnlinePayments',
            href: '/onlinepayments',
        },
        {
            name: 'cashOnDelivery',
            href: '/cashondelivery',
        },
        {
            name: 'shippingDelivery',
            href: '/shippingdelivery',
        },
    ],
    mafqat: [
        {
            name: 'serviceWarranty',
            href: '/servicewarranty',
        },
        {
            name: 'returnExchange',
            href: '/returnandexchange',
        },
        {
            name: 'securedOnlinePayments',
            href: '/onlinepayments',
        },
        {
            name: 'shippingDelivery',
            href: '/shippingdelivery',
        },
        {
            name: 'deliveryZones',
            href: '/deliveryzones',
        },
        {
            name: 'carrefourAppFAQs',
            href: '/appfaq',
        },
    ],
    mafuzb: __spread(CUSTOMER_SERVICE_LINKS$1),
    mafuga: __spread(CUSTOMER_SERVICE_LINKS$1),
    mafirq: __spread(CUSTOMER_SERVICE_LINKS$1),
};
var feedItems = [
    {
        label: 'customerService',
        links: [],
    },
    {
        label: 'aboutUs',
        links: [],
    },
    {
        label: 'helpingYouSave',
        links: [],
    },
    {
        label: 'helpSupport',
        links: [],
    },
];
var getCountrySpecificLinks = function (_a) {
    var defLinks = _a.defLinks, label = _a.label, storeId = _a.storeId, language = _a.language;
    var ABOUT_US_LINKS = [
        {
            name: 'aboutMAF',
            href: "https://www.majidalfuttaim.com/" + language,
        },
        {
            name: 'aboutCarrefour',
            href: '/aboutcarrefour',
        },
        {
            name: 'aboutSociety',
            href: '/carrefourandsociety',
        },
        {
            name: 'brands',
            href: '/carrefourbrand',
        },
        {
            name: 'newsletter',
            href: '/newsletter',
        },
        {
            name: 'newsReleases',
            href: '/newspress',
        },
    ];
    var ABOUT_US = {
        mafuae: [
            {
                name: 'aboutMAF',
                href: "https://www.majidalfuttaim.com/" + language,
            },
            {
                name: 'aboutCarrefour',
                href: '/helpcenter/articles/service/16?article=13',
            },
            {
                name: 'aboutSociety',
                href: '/helpcenter/articles/service/16?article=14',
            },
            {
                name: 'brands',
                href: '/helpcenter/articles/service/16?article=15',
            },
            {
                name: 'newsletter',
                href: '/newsletter',
            },
            {
                name: 'newsReleases',
                href: '/newspress',
            },
            {
                name: 'waysToShop',
                href: '/ways-to-shop',
            },
            {
                name: 'sellWithUs',
                href: '/seller',
            },
            {
                name: 'advertiseWithUs',
                href: '/advertisewithus',
            },
        ],
        mafegy: __spread(ABOUT_US_LINKS),
        mafsau: __spread(ABOUT_US_LINKS),
        mafjor: __spread(ABOUT_US_LINKS),
        mafkwt: __spread(ABOUT_US_LINKS),
        maflbn: __spread(ABOUT_US_LINKS),
        mafgeo: [
            {
                name: 'aboutMAF',
                href: "https://www.majidalfuttaim.com/en",
            },
            {
                name: 'aboutCarrefour',
                href: '/aboutmafretail',
            },
            {
                name: 'aboutSociety',
                href: '/carrefourandsociety',
            },
            {
                name: 'brands',
                href: '/carrefourbrand',
            },
            {
                name: 'newsletter',
                href: '/newsletter',
            },
            {
                name: 'newsReleases',
                href: '/newspress',
            },
        ],
        mafpak: [
            {
                name: 'aboutMAF',
                href: "https://www.majidalfuttaim.com/" + language,
            },
            {
                name: 'aboutCarrefour',
                href: '/aboutcarrefour',
            },
            {
                name: 'aboutSociety',
                href: '/carrefourandsociety',
            },
            {
                name: 'newsletter',
                href: '/newsletter',
            },
            {
                name: 'newsReleases',
                href: '/newspress',
            },
        ],
        mafken: [
            {
                name: 'aboutMAF',
                href: "https://www.majidalfuttaim.com/" + language,
            },
            {
                name: 'aboutCarrefour',
                href: '/aboutcarrefour',
            },
            {
                name: 'aboutSociety',
                href: '/carrefourandsociety',
            },
            {
                name: 'newsletter',
                href: '/newsletter',
            },
            {
                name: 'newsReleases',
                href: '/newspress',
            },
        ],
        mafqat: [
            {
                name: 'aboutCarrefour',
                href: '/carrefourandsociety',
            },
            {
                name: 'brands',
                href: '/carrefourbrand',
            },
            {
                name: 'careers',
                href: 'https://careers.majidalfuttaim.com/',
            },
            {
                name: 'newsletter',
                href: '/newsletter',
            },
            {
                name: 'newsReleases',
                href: '/newspress',
            },
        ],
        mafuzb: __spread(ABOUT_US_LINKS),
        mafuga: __spread(ABOUT_US_LINKS),
        mafirq: __spread(ABOUT_US_LINKS),
    };
    var COUNTRY_SPECIFIC_LINKS = {
        helpingYouSave: HELPING_YOU_SAVE,
        aboutUs: ABOUT_US,
        customerService: CUSTOMER_SERVICE$1,
        helpSupport: HELP_AND_SUPPORT$1,
    };
    var countrySpecificLinks = COUNTRY_SPECIFIC_LINKS[label];
    if (countrySpecificLinks) {
        return __spread((defLinks || []), (countrySpecificLinks[storeId] || []));
    }
    return defLinks;
};

var STORE_CONTACTS = {
    mafuae: '800-732-32',
    mafegy: '16061',
    mafsau: '920000282',
    mafjor: '06-5000015',
    maflbn: '1548',
    mafqat: '800-7323',
    mafpak: '080049737',
    mafgeo: '0322177070',
    mafkwt: '1800432',
    mafken: '800221322',
};
var ContactUs = function () {
    var t = useTranslation().t;
    var _a = __read(useAppConfig$1(), 1), storeId = _a[0].storeId;
    var storeContact = useMemo(function () { return STORE_CONTACTS[storeId]; }, [storeId]);
    return (React.createElement(ContactUsWrapper$1, { px: [3, 4], py: 14 },
        React.createElement(Text, { lineHeight: 1.5 },
            t('footer.haveQuestion'),
            " ",
            React.createElement("br", null),
            " ",
            t('footer.hereToHelp')),
        React.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
            React.createElement(Telephone, { size: "CUSTOM", height: 24, width: 24, fill: COLORS$1.WHITE }),
            React.createElement(ContactUsLink$1, { href: "tel:" + storeContact }, storeContact))));
};

var DownloadApp$2 = function () {
    var download_app = (useSelector(selectfooterData$1) || {}).download_app;
    var _a = download_app || {}, ios_app = _a.ios_app, android_app = _a.android_app, huawei_app = _a.huawei_app;
    return (React.createElement(React.Fragment, null,
        ios_app && React.createElement(FooterImageLink$1, __assign({}, ios_app, { width: 100 })),
        android_app && React.createElement(FooterImageLink$1, __assign({}, android_app, { width: 100 })),
        huawei_app && React.createElement(FooterImageLink$1, __assign({}, huawei_app, { width: 100 }))));
};
var DownloadApp$3 = memo(DownloadApp$2);

var convertToTestId = function (str) { return str === null || str === void 0 ? void 0 : str.replace(/\s/g, '_').replace(/[\&\,\.\'\/]/g, '').toLowerCase(); };
var getHref = function (href, storeId, language) {
    return (href === null || href === void 0 ? void 0 : href.includes('www')) ? "" + href : "/" + storeId + "/" + language + href;
};
var Footer = function () {
    var _a;
    var ut = useTranslation().t;
    var t = useCallback(function (key) { return ut("footer." + key); }, [ut]);
    var _b = __read(useAppConfig$1(), 1), _c = _b[0], language = _c.language, storeId = _c.storeId;
    var oneTrustScriptEnabled = ((_a = useFeature('one_trust_script_enabled')) === null || _a === void 0 ? void 0 : _a.value) || false;
    var download_app = (useSelector(selectfooterData$1) || {}).download_app;
    var title = (download_app || {}).title;
    var list_link = useSelector(getLinks$1) || [];
    var links = (list_link === null || list_link === void 0 ? void 0 : list_link.length) > 0 ? list_link : feedItems;
    var userCredentials = useSelector(function (state) { return state.appConfig; }).userCredentials;
    var authToken = (userCredentials === null || userCredentials === void 0 ? void 0 : userCredentials.authToken) || getUserTokenFromCookie$1();
    return (React.createElement("footer", { "data-testid": "footer" },
        React.createElement(FooterTop$1, null,
            React.createElement(FooterContainer$1, null,
                React.createElement(Branding$3, null),
                React.createElement(FooterSiteNav$1, { "data-testid": "bottom-links" }, links.map(function (_a, index) {
                    var label = _a.label, links = _a.links;
                    var linksArr = getCountrySpecificLinks({
                        defLinks: links,
                        label: label,
                        storeId: storeId,
                        language: language,
                    });
                    if (!linksArr || !linksArr.length)
                        return null;
                    return (React.createElement(Column$1, { key: label },
                        React.createElement(Title$9, { fontWeight: language === EN$1 ? 500 : 600 }, (list_link === null || list_link === void 0 ? void 0 : list_link.length) > 0 ? label : t(label)),
                        React.createElement("ul", null, linksArr.map(function (_a) {
                            var name = _a.name, _b = _a.href, href = _b === void 0 ? '' : _b, externalLink = _a.externalLink;
                            var linkText = (list_link === null || list_link === void 0 ? void 0 : list_link.length) > 0 ? name : t(name);
                            var hasLink = href || externalLink || '';
                            if (hasLink === null || hasLink === void 0 ? void 0 : hasLink.includes('privacy-center')) {
                                hasLink = hasLink.replace('{{access-token}}', authToken || '');
                            }
                            return hasLink ? (React.createElement("li", { key: name },
                                React.createElement("a", { href: hasLink, title: linkText, "data-testid": convertToTestId(linkText) }, linkText))) : null;
                        })),
                        oneTrustScriptEnabled && index === 0 && (React.createElement("button", { id: "ot-sdk-btn", className: "ot-sdk-show-settings" }, t('cookieSettings')))));
                })),
                storeId === 'mafqat' && (React.createElement(FooterContactUs$1, null,
                    React.createElement(ContactUs, null))),
                React.createElement(FooterApps$1, { "data-testid": "download-app" },
                    React.createElement("h4", null, title || t('downloadApp')),
                    React.createElement(DownloadApp$3, null)))),
        React.createElement(Copyright$2, null)));
};

var PX = [3, 4];
var staticProps$2 = {
    headerStyles: {
        background: COLORS$1.BLUE,
        py: 14,
        px: PX,
        color: COLORS$1.WHITE,
        fontWeight: 400,
        borderTop: '1px solid #fff',
    },
    containerStyles: {
        background: COLORS$1.DARK_BLUE,
        border: 'none',
        fontSize: 14,
        lineHeight: 1,
        padding: 0,
    },
    actionIconStyles: { fill: '#fff' },
};
var MobileFooter = function () {
    var _a;
    var t = useTranslation().t;
    var _b = __read(useAppConfig$1(), 1), _c = _b[0], language = _c.language, storeId = _c.storeId;
    var oneTrustScriptEnabled = ((_a = useFeature('one_trust_script_enabled')) === null || _a === void 0 ? void 0 : _a.value) || false;
    var list_link = useSelector(getLinks$1) || [];
    var links = (list_link === null || list_link === void 0 ? void 0 : list_link.length) > 0 ? list_link : feedItems;
    return (React.createElement(React.Fragment, null,
        React.createElement(FooterTop$1, { padding: 0 },
            React.createElement(FooterContainer$1, { flexDirection: "column" },
                React.createElement(Branding$3, { py: "12px", px: PX }),
                React.createElement(FooterAccordion$1, __assign({}, staticProps$2),
                    links.map(function (_a, index) {
                        var label = _a.label, links = _a.links;
                        var linksArr = getCountrySpecificLinks({
                            defLinks: links,
                            label: label,
                            storeId: storeId,
                            language: language,
                        });
                        if (!linksArr || !linksArr.length)
                            return null;
                        return (React.createElement("div", { key: label, "data-label": (list_link === null || list_link === void 0 ? void 0 : list_link.length) > 0 ? label : t(label) },
                            React.createElement(List$1, null,
                                linksArr.map(function (_a) {
                                    var name = _a.name, _b = _a.href, href = _b === void 0 ? '' : _b, externalLink = _a.externalLink;
                                    var linkText = (list_link === null || list_link === void 0 ? void 0 : list_link.length) > 0 ? name : t("footer." + name);
                                    var hasLink = href || externalLink;
                                    if (!hasLink || !linkText)
                                        return null;
                                    return (React.createElement(Box, { as: "li", py: 1, px: PX, key: name },
                                        React.createElement("a", { href: externalLink || getHref(href, storeId, language), title: linkText }, linkText)));
                                }),
                                oneTrustScriptEnabled && index === 0 && (React.createElement(Box, { py: 1, px: PX },
                                    React.createElement("button", { id: "ot-sdk-btn", className: "ot-sdk-show-settings" }, t('cookieSettings')))))));
                    }),
                    React.createElement("div", { "data-label": t('footer.downloadApp') },
                        React.createElement(List$1, { px: 40 },
                            React.createElement(Text, { color: COLORS$1.WHITE, py: 12 }, t('footer.yourLoyality')),
                            React.createElement(FooterApps$1, null,
                                React.createElement(DownloadApp$3, null))))),
                React.createElement(ContactUs, null))),
        React.createElement(Copyright$2, null)));
};

var getFooterData = function () { return function (dispatch, getState) {
    var errorMessage = i18next.t('somethingWentWrong');
    var _a = getState().appConfig, storeId = _a.storeId, language = _a.language;
    dispatch({
        type: FooterTypes$3.FOOTER_GET,
        payload: {
            apiVersion: 1,
            isAuthorized: false,
            url: GET_FOOTER_CLIENT,
            method: EApiMiddlewareMethod$3.GET,
            isAbsUrl: true,
            params: { storeId: storeId, language: language },
            onFailure: function () {
                showNotification$1({
                    type: 'error',
                    message: errorMessage,
                    variant: 'sticky',
                });
            },
        },
    });
}; };

function index$5 () {
    var device = useBreakpoints(BREAKPOINTS$1);
    var dispatch = useDispatch();
    useEffect(function () {
        dispatch(getFooterData());
    }, [dispatch]);
    var FooterComponent = useMemo(function () { return (device.isDesktop === true ? Footer : MobileFooter); }, [device]);
    return (React.createElement(Box, { fontSize: 1 },
        React.createElement(FooterComponent, null)));
}

var transformCategories = function (categories) {
    var subcategories = categories.subcategories;
    var shapedCategories = subcategories
        ? categories.subcategories.slice(0, 7).map(function (category) {
            var subcategories = category.subcategories, name = category.name, linkUrl = category.linkUrl, bgColor = category.bgColor;
            var firstCategory = subcategories && subcategories.length > 0 ? subcategories[0] : {};
            var thumbnail = firstCategory.thumbnail;
            return {
                altText: name,
                backgroundColor: bgColor,
                imagePath: thumbnail && thumbnail.url ? thumbnail.url : '',
                link: linkUrl,
                title: name,
            };
        })
        : [];
    return shapedCategories;
};

var useTopCategories = function (parentCategory) {
    var appConfig = useSelector(function (state) { return ({
        appConfig: state.appConfig,
    }); }).appConfig;
    var _a = __read(useState([]), 2), topCategories = _a[0], setTopCategories = _a[1];
    var _b = __read(useState(false), 2), isError = _b[0], setisError = _b[1];
    var _c = __read(useState(true), 2), isLoading = _c[0], setisLoading = _c[1];
    var language = appConfig.language, storeId = appConfig.storeId, areaCode = appConfig.areaCode;
    useEffect(function () {
        var data = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!appConfig.areaCode) return [3 /*break*/, 2];
                        return [4 /*yield*/, ProductServices$3.doGet(GET_TOP_CATEGORIES, {
                                parentCategory: parentCategory,
                                areaCode: areaCode,
                                storeId: storeId,
                                language: language,
                            }, true).catch(function (error) {
                                setisLoading(false);
                                setisError(true);
                                return {
                                    error: error,
                                };
                            })];
                    case 1:
                        response = _a.sent();
                        setisError(false);
                        setisLoading(false);
                        setTopCategories(transformCategories(response));
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        data();
    }, [appConfig.areaCode, areaCode, language, parentCategory, storeId]);
    return { topCategories: topCategories, isError: isError, isLoading: isLoading } || {};
};

var ErrorPageWrapper$1 = customStyled(Flex)(templateObject_1$1U || (templateObject_1$1U = __makeTemplateObject(["\n    align-items: center;\n    flex-direction: column;\n    font-weight: ", ";\n    justify-content: center;\n    //margin: 0 auto;\n    position: relative;\n    h2 {\n        color: ", ";\n        font-size: 18px;\n        font-weight: ", ";\n        margin-top: ", "px;\n        text-align: center;\n    }\n    h4{\n        margin-bottom: ", "px;\n        a {\n        color: ", ";\n        font-weight: ", ";\n        text-decoration: none;\n        }\n    }\n\n    div[data-testid=relevant-product-carousel]{\n        margin-bottom: 32px;\n        > div > p[data-testid=trolly-text]{\n    font-weight: 700;\n    font-size: 24px;\n    font-family: Montserrat;\n    }\n    }\n    @media (max-width: ", ") {\n        padding-top: 28px;\n    }\n"], ["\n    align-items: center;\n    flex-direction: column;\n    font-weight: ", ";\n    justify-content: center;\n    //margin: 0 auto;\n    position: relative;\n    h2 {\n        color: ", ";\n        font-size: 18px;\n        font-weight: ", ";\n        margin-top: ", "px;\n        text-align: center;\n    }\n    h4{\n        margin-bottom: ", "px;\n        a {\n        color: ", ";\n        font-weight: ", ";\n        text-decoration: none;\n        }\n    }\n\n    div[data-testid=relevant-product-carousel]{\n        margin-bottom: 32px;\n        > div > p[data-testid=trolly-text]{\n    font-weight: 700;\n    font-size: 24px;\n    font-family: Montserrat;\n    }\n    }\n    @media (max-width: ", ") {\n        padding-top: 28px;\n    }\n"])), function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.colors.thundora; }, function (props) { return (props.rtl ? props.theme.fontWeights[5] : props.theme.fontWeights[4]); }, function (props) { return props.theme.space[3]; }, function (props) { return props.theme.space[5]; }, function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.fontWeights[4]; }, function (props) { return props.theme.breakpoints[1]; });
var ErrorPageImageWrapper$1 = customStyled.div(templateObject_2$1y || (templateObject_2$1y = __makeTemplateObject(["\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 240px;\n    svg{\n        width: 100%;\n        height: 100%;\n    }\n    @media (max-width: ", ") {\n    width: 130px;\n    height: 198px;\n    }\n"], ["\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 240px;\n    svg{\n        width: 100%;\n        height: 100%;\n    }\n    @media (max-width: ", ") {\n    width: 130px;\n    height: 198px;\n    }\n"])), function (props) { return props.theme.breakpoints[0]; });
var ErrorPageDescription$1 = customStyled.div(templateObject_3$1f || (templateObject_3$1f = __makeTemplateObject(["\n    font-size: ", "px;\n    font-weight: ", ";\n    margin-top: ", "px;\n\n    p {\n        color: ", ";\n        line-height: 1.5;\n        text-align: center;\n    }\n"], ["\n    font-size: ", "px;\n    font-weight: ", ";\n    margin-top: ", "px;\n\n    p {\n        color: ", ";\n        line-height: 1.5;\n        text-align: center;\n    }\n"])), function (props) { return (props.rtl ? 15 : props.theme.fontSizes[3]); }, function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.space[3]; }, function (props) { return props.theme.colors.thundora; });
var ErrorPageLinks$1 = customStyled.div(templateObject_4$12 || (templateObject_4$12 = __makeTemplateObject(["\n    margin-top: ", "px;\n    width: 100%;\n\n    @media (min-width: ", ") {\n        display: grid;\n        grid-column-gap: ", "px;\n        grid-template-columns: repeat(2, 1fr);\n    }\n"], ["\n    margin-top: ", "px;\n    width: 100%;\n\n    @media (min-width: ", ") {\n        display: grid;\n        grid-column-gap: ", "px;\n        grid-template-columns: repeat(2, 1fr);\n    }\n"])), function (props) { return props.theme.space[4]; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.theme.space[3]; });
var ErrorPageLinksCard$1 = customStyled(Card)(templateObject_5$O || (templateObject_5$O = __makeTemplateObject(["\n    padding: ", "px;\n\n    h3 {\n        color: ", ";\n        font-size: ", "px;\n        font-weight: ", ";\n    }\n\n    &:not(:first-of-type) {\n        margin-top: ", "px;\n\n        @media (min-width: ", ") {\n            margin-top: 0;\n        }\n    }\n\n    ul {\n        margin-top: 22px;\n\n        li {\n            display: block;\n\n            &:not(:first-of-type) {\n                margin-top: 22px;\n            }\n\n            > a {\n                font-size: ", "px;\n                font-weight: ", ";\n            }\n        }\n    }\n"], ["\n    padding: ", "px;\n\n    h3 {\n        color: ", ";\n        font-size: ", "px;\n        font-weight: ", ";\n    }\n\n    &:not(:first-of-type) {\n        margin-top: ", "px;\n\n        @media (min-width: ", ") {\n            margin-top: 0;\n        }\n    }\n\n    ul {\n        margin-top: 22px;\n\n        li {\n            display: block;\n\n            &:not(:first-of-type) {\n                margin-top: 22px;\n            }\n\n            > a {\n                font-size: ", "px;\n                font-weight: ", ";\n            }\n        }\n    }\n"])), function (props) { return props.theme.space[4]; }, function (props) { return props.theme.colors.copy; }, function (props) { return (props.rtl ? props.theme.fontSizes[2] : props.theme.fontSizes[3]); }, function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.space[3]; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return (props.rtl ? props.theme.fontSizes[1] : props.theme.fontSizes[2]); }, function (props) { return (props.rtl ? props.theme.fontWeights[5] : props.theme.fontWeights[4]); });
var TopTitle$1 = customStyled.div(templateObject_6$E || (templateObject_6$E = __makeTemplateObject(["\n    padding-top: ", "px;\n\n"], ["\n    padding-top: ", "px;\n\n"])), function (props) { return props.theme.space[5]; });
var TopTitleText$1 = customStyled(Box)(templateObject_7$B || (templateObject_7$B = __makeTemplateObject(["\n    font-size: 100px;\n    color: ", ";\n    font-weight: 200;\n    font-style: normal;\n    margin-bottom: ", "px;\n     @media (max-width: ", ") {\n        font-size: 80px;\n    }\n"], ["\n    font-size: 100px;\n    color: ", ";\n    font-weight: 200;\n    font-style: normal;\n    margin-bottom: ", "px;\n     @media (max-width: ", ") {\n        font-size: 80px;\n    }\n"])), function (props) { return props.theme.colors.lightBlue; }, function (props) { return props.theme.space[5]; }, function (props) { return props.theme.breakpoints[1]; });
var SmallTexts$1 = customStyled.div(templateObject_8$B || (templateObject_8$B = __makeTemplateObject(["\nfont-weight: ", ";\ncolor: ", ";\nmargin-bottom: ", "px;\nletter-spacing: 0.8px;\nfont-size: ", "px;\nh2{\nfont-weight: ", ";\nmargin-bottom: ", "px;\ntext-align: left;\nfont-size: 32px;\ncolor: ", ";\n@media (max-width: ", ") {\n        font-size: 24px;\n        padding-right: 100px\n}\n}\nspan{\n    max-width: 480px;\n    display: inline-block;\n    line-height: 30px;\n@media (max-width: ", ") {\n    line-height: 24px;\n    font-size: 20px;\n            padding-right: 100px\n\n    }\n}\n"], ["\nfont-weight: ", ";\ncolor: ", ";\nmargin-bottom: ", "px;\nletter-spacing: 0.8px;\nfont-size: ", "px;\nh2{\nfont-weight: ", ";\nmargin-bottom: ", "px;\ntext-align: left;\nfont-size: 32px;\ncolor: ", ";\n@media (max-width: ", ") {\n        font-size: 24px;\n        padding-right: 100px\n}\n}\nspan{\n    max-width: 480px;\n    display: inline-block;\n    line-height: 30px;\n@media (max-width: ", ") {\n    line-height: 24px;\n    font-size: 20px;\n            padding-right: 100px\n\n    }\n}\n"])), function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.space[5]; }, function (props) { return props.theme.fontSizes[6]; }, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.space[2]; }, function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.theme.breakpoints[1]; });
var TopWrapper$1 = styled(Flex)(templateObject_9$y || (templateObject_9$y = __makeTemplateObject(["\n  width: 100%;\n  font-family: Montserrat;\n"], ["\n  width: 100%;\n  font-family: Montserrat;\n"])));
TopWrapper$1.defaultProps = {
    flexDirection: ['row'],
    justifyContent: 'space-between',
    mb: 6,
};
var SmallPara$1 = customStyled.div(templateObject_10$x || (templateObject_10$x = __makeTemplateObject(["\nh4, h4 a{\n    font-weight: ", ";\n    line-height: 20px;\n}\n"], ["\nh4, h4 a{\n    font-weight: ", ";\n    line-height: 20px;\n}\n"])), function (props) { return props.theme.fontWeights[6]; });
var ColoredBackground$1 = customStyled.div(templateObject_11$r || (templateObject_11$r = __makeTemplateObject(["\nposition: absolute;\nright: 0;\ntop: 0;\n"], ["\nposition: absolute;\nright: 0;\ntop: 0;\n"])));
var MovingObjectWrapper$1 = customStyled.div(templateObject_12$p || (templateObject_12$p = __makeTemplateObject(["\nposition: absolute;\nleft: -45px;\ntop: 120px;\nwidth: 180px;\ntransform: translatey(0px);\nanimation: float 3s ease-in-out infinite 2s, land 2s ease-in-out;\n@keyframes float {\n\t0% {\n\t\ttransform: translatey(0px);\n\t}\n\t50% {\n        transform: translatey(-20px);\n\t}\n    100% {\n        transform: translatey(0px);\n\t}\n}\n@keyframes land {\n\t0% {\n        transform: translatey(-100px);\n\t}\n    100% {\n\t\ttransform: translatey(0px);\n\t}\n}\n@media (max-width: ", ") {\n    width: 100px;\n    right: 15px;\n    left: auto;\n    top: 80px;\n    }\n"], ["\nposition: absolute;\nleft: -45px;\ntop: 120px;\nwidth: 180px;\ntransform: translatey(0px);\nanimation: float 3s ease-in-out infinite 2s, land 2s ease-in-out;\n@keyframes float {\n\t0% {\n\t\ttransform: translatey(0px);\n\t}\n\t50% {\n        transform: translatey(-20px);\n\t}\n    100% {\n        transform: translatey(0px);\n\t}\n}\n@keyframes land {\n\t0% {\n        transform: translatey(-100px);\n\t}\n    100% {\n\t\ttransform: translatey(0px);\n\t}\n}\n@media (max-width: ", ") {\n    width: 100px;\n    right: 15px;\n    left: auto;\n    top: 80px;\n    }\n"])), function (props) { return props.theme.breakpoints[1]; });
var ReasonsList$1 = customStyled.div(templateObject_13$o || (templateObject_13$o = __makeTemplateObject(["\nmax-width: 350px;\nlist-style: none;\nmargin-bottom: ", "px;\nli{\n    position: relative;\n    padding-left: 10px;\n    margin-bottom: 10px;\n    &::before{\n        content:\"\";\n        width: 4px;\n        height: 4px;\n        background: ", ";\n        position: absolute;\n        left: 0;\n        top: 6px;\n        -webkit-border-radius: 100%;\n        border-radius: 100%;\n    }\n}\n"], ["\nmax-width: 350px;\nlist-style: none;\nmargin-bottom: ", "px;\nli{\n    position: relative;\n    padding-left: 10px;\n    margin-bottom: 10px;\n    &::before{\n        content:\"\";\n        width: 4px;\n        height: 4px;\n        background: ", ";\n        position: absolute;\n        left: 0;\n        top: 6px;\n        -webkit-border-radius: 100%;\n        border-radius: 100%;\n    }\n}\n"])), function (props) { return props.theme.space[5]; }, function (props) { return props.theme.colors.thundora; });
var PageContainer$1 = customStyled.div(templateObject_14$o || (templateObject_14$o = __makeTemplateObject(["\n    width: 1232px;\n    max-width: 90%;\n"], ["\n    width: 1232px;\n    max-width: 90%;\n"])));
var CategoriesWrapper$1 = styled(Flex)(templateObject_15$o || (templateObject_15$o = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
CategoriesWrapper$1.defaultProps = {
    py: 5,
};
var ButtonWrapper$3 = customStyled.a(templateObject_16$i || (templateObject_16$i = __makeTemplateObject(["\n    color: ", ";\n    text-decoration: none;\n    font-family: Montserrat;\n    font-weight: ", ";\n    &:hover {\n        button {\n            background-color: ", ";\n            color:#FFF;\n        }\n    }\n"], ["\n    color: ", ";\n    text-decoration: none;\n    font-family: Montserrat;\n    font-weight: ", ";\n    &:hover {\n        button {\n            background-color: ", ";\n            color:#FFF;\n        }\n    }\n"])), function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.fontWeights[4]; }, function (props) { return props.theme.colors.blue; });
var ComponentTitle$1 = customStyled.h3(templateObject_17$i || (templateObject_17$i = __makeTemplateObject(["\n    color: ", ";\n    font-family: 'Montserrat';\n    font-weight: ", ";\n    font-size: ", "px;\n    margin-bottom: 16px;\n"], ["\n    color: ", ";\n    font-family: 'Montserrat';\n    font-weight: ", ";\n    font-size: ", "px;\n    margin-bottom: 16px;\n"])), function (props) { return props.theme.colors.black; }, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.fontSizes[6]; });
var templateObject_1$1U, templateObject_2$1y, templateObject_3$1f, templateObject_4$12, templateObject_5$O, templateObject_6$E, templateObject_7$B, templateObject_8$B, templateObject_9$y, templateObject_10$x, templateObject_11$r, templateObject_12$p, templateObject_13$o, templateObject_14$o, templateObject_15$o, templateObject_16$i, templateObject_17$i;

/**
 * Allows two animation frames to complete to allow other components to update
 * and re-render before mounting and rendering an expensive Component.
 */
var useDefer = function () {
    var _a = __read(useState(global.deferGlobal || false), 2), shouldRender = _a[0], setRender = _a[1];
    useEffect(function () {
        raf(function () { return raf(function () { return setRender(true); }); });
    }, [setRender]);
    return shouldRender;
};

var CategoryListLoader = function () {
    return (React.createElement(ContentLoader, { speed: 2, width: "100%", height: 70, viewBox: "0 0 400 70", primaryColor: "#DFDFDF", secondaryColor: "#F5F5F5" },
        React.createElement("circle", { cx: "25", cy: "25", r: "22" }),
        React.createElement("circle", { cx: "75", cy: "25", r: "22" }),
        React.createElement("circle", { cx: "125", cy: "25", r: "22" }),
        React.createElement("circle", { cx: "175", cy: "25", r: "22" }),
        React.createElement("circle", { cx: "225", cy: "25", r: "22" }),
        React.createElement("circle", { cx: "275", cy: "25", r: "22" }),
        React.createElement("circle", { cx: "325", cy: "25", r: "22" }),
        React.createElement("circle", { cx: "375", cy: "25", r: "22" }),
        React.createElement("circle", { cx: "425", cy: "25", r: "22" })));
};

var CategoryList = function (_a) {
    var _b = _a.parentCategory, parentCategory = _b === void 0 ? '' : _b, _c = _a.categoriesTitle, categoriesTitle = _c === void 0 ? '' : _c;
    var shouldRender = useDefer();
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    var _d = useTopCategories(parentCategory), topCategories = _d.topCategories, isError = _d.isError, isLoading = _d.isLoading;
    var onTriggerTracking = useCallback(function (imageName, componentSlot) { return function () {
        GTMEventCall(GTMEvents$1.custom_event, {
            eventAction: GTMEventActions$1.component_interaction,
            componentSlot: componentSlot,
            componentName: imageName,
            componentPosition: '3',
        });
    }; }, [GTMEventCall]);
    if (isLoading || !shouldRender) {
        return React.createElement(CategoryListLoader, null);
    }
    if (topCategories.length === 0 || isError) {
        return null;
    }
    return (React.createElement(Flex, { flexDirection: "column", width: "100%" },
        React.createElement(ComponentTitle$1, null, categoriesTitle),
        topCategories && (React.createElement(ImageCircleContainer, { isCarousel: false, list: topCategories, onClickHandler: onTriggerTracking }))));
};

var getCategoryByStoreId = function (storeId, code) {
    switch (storeId) {
        case EStoreID$1.MAFUAE:
            return code || 'F1600000';
        case EStoreID$1.MAFEGY:
            return code || 'FEGY1600000';
        case EStoreID$1.MAFJOR:
            return code || 'FJOR1600000';
        case EStoreID$1.MAFLBN:
            return code || 'FLEB1600000';
        case EStoreID$1.MAFQAT:
            return code || 'FQAT1600000';
        case EStoreID$1.MAFSAU:
            return code || 'FKSA1600000';
        case EStoreID$1.MAFPAK:
            return code || 'FPAK1600000';
        default:
            return '';
    }
};

var placements = 'error_page.web_rank1%7Cerror_page.web_rank2';
var ErrorPage = function (_a) {
    var type = _a.type, _b = _a.parentCategory, parentCategory = _b === void 0 ? '' : _b;
    var _c = __read(useAppConfig$1(), 1), _d = _c[0], _e = _d.language, language = _e === void 0 ? '' : _e, _f = _d.storeId, storeId = _f === void 0 ? '' : _f;
    var _g = __read(useState(parentCategory), 2), category = _g[0], setCategory = _g[1];
    // Parent Category comes from here by default, if there's a need to override it should be passed as property
    useEffect(function () {
        setCategory(getCategoryByStoreId(storeId, parentCategory));
    }, [storeId, parentCategory]);
    var t = useTranslation().t;
    var errorMessage = useCallback(function () {
        switch (type) {
            case '500':
                return React.createElement("div", { dangerouslySetInnerHTML: { __html: t('errorPage.serverError') } });
            default:
                return React.createElement("div", { dangerouslySetInnerHTML: { __html: t('errorPage.notFound') } });
        }
    }, [t, type]);
    var isRTL = useMemo(function () { return language === 'ar'; }, [language]);
    return (React.createElement(ErrorPageWrapper$1, { "data-testid": "error-boundary", rtl: isRTL },
        React.createElement(PageContainer$1, null,
            React.createElement(TopWrapper$1, null,
                React.createElement(TopTitle$1, null,
                    React.createElement(SmallTexts$1, null, errorMessage()),
                    React.createElement(SmallPara$1, null,
                        React.createElement("h4", { dangerouslySetInnerHTML: {
                                __html: t('errorPage.contactUsMessage', {
                                    contactUs: t('errorPage.contactUs'),
                                }),
                            } }),
                        React.createElement(ButtonWrapper$3, { href: "/" },
                            React.createElement(Button$1, { variant: "outlined" }, t('errorPage.homepageButton')))))),
            React.createElement(RelevantProductCarousel$3, { placements: placements }),
            React.createElement(CategoriesWrapper$1, null,
                React.createElement(CategoryList, { parentCategory: category, categoriesTitle: t('errorPage.categoriesTitle') })))));
};

var ADD_TO_LIST_API_BASE$1 = 'wishlists/{{StoreId}}/{{language}}';
var FETCH_LIST_API$1 = ADD_TO_LIST_API_BASE$1;
var ADD_PRODUCT_ONLY_API$1 = ADD_TO_LIST_API_BASE$1 + "/product";
var ADD_PRODUCT_AND_NEW_LIST_API$1 = ADD_TO_LIST_API_BASE$1;

var toggleLoading$1 = function (loading) { return ({
    type: EAddToListTypes$3.ADD_TO_LIST_TOGGLE_LOADING,
    payload: loading,
}); };
var clearErrorAndSuccess$1 = function () { return ({
    type: EAddToListTypes$3.ADD_TO_LIST_CLEAR_ERROR_AND_SUCCESS,
}); };
var fetchList$1 = function () { return function (dispatch) {
    dispatch({
        type: EAddToListTypes$3.ADD_TO_LIST_FETCH_LIST,
        payload: {
            enableProgress: false,
            onSuccess: function (data) {
                dispatch({
                    type: EAddToListTypes$3.ADD_TO_LIST_FETCH_LIST_SUCCESS,
                    payload: data,
                });
            },
            onFailure: function (error) {
                return dispatch({
                    type: EAddToListTypes$3.ADD_TO_LIST_SET_ERROR,
                    payload: error,
                });
            },
            url: FETCH_LIST_API$1,
        },
    });
}; };
var addProductAndNewList$1 = function (dispatch, _a) {
    var newListName = _a.newListName, productCode = _a.productCode;
    dispatch({
        type: EAddToListTypes$3.ADD_PRODUCT_AND_NEW_LIST,
        payload: {
            data: {
                wishlistName: newListName,
                wishlistDesc: newListName,
                productCode: productCode,
                quantity: 1,
            },
            enableProgress: false,
            method: EApiMiddlewareMethod$3.POST,
            onSuccess: function (_a) {
                var error = _a.error, message = _a.message;
                if (error) {
                    dispatch({
                        type: EAddToListTypes$3.ADD_TO_LIST_SET_ERROR,
                        payload: message,
                    });
                    dispatch(toggleLoading$1(false));
                    return;
                }
                addProductOnly$1(dispatch, { selectedList: newListName, productCode: productCode });
            },
            url: ADD_PRODUCT_AND_NEW_LIST_API$1,
        },
    });
};
var addProductOnly$1 = function (dispatch, _a) {
    var selectedList = _a.selectedList, productCode = _a.productCode;
    dispatch({
        type: EAddToListTypes$3.ADD_PRODUCT_ONLY,
        payload: {
            data: {
                wishlistName: selectedList,
                productCode: productCode,
                userId: getUserEmailFromCookie$1(),
            },
            enableProgress: false,
            method: EApiMiddlewareMethod$3.POST,
            onSuccess: function (_a) {
                var error = _a.error, message = _a.message;
                if (error) {
                    dispatch({
                        type: EAddToListTypes$3.ADD_TO_LIST_SET_ERROR,
                        payload: message,
                    });
                    return;
                }
                dispatch({
                    type: EAddToListTypes$3.ADD_TO_LIST_SET_SUCCESS,
                    payload: selectedList,
                });
            },
            onFailure: function (error) {
                return dispatch({
                    type: EAddToListTypes$3.ADD_TO_LIST_SET_ERROR,
                    payload: error,
                });
            },
            onFinally: function () { return dispatch(toggleLoading$1(false)); },
            url: ADD_PRODUCT_ONLY_API$1,
        },
    });
};
var addProductToList$1 = function (params) { return function (dispatch) {
    dispatch(toggleLoading$1(true));
    dispatch(clearErrorAndSuccess$1());
    // If "selectedList" is provided then add product to existing list;
    // Otherwise, add the product and the "newListName" at the same time
    params.selectedList ? addProductOnly$1(dispatch, params) : addProductAndNewList$1(dispatch, params);
}; };

// type IAddToListParam = (productCode?: string) => any;
var useAddToList$1 = function () {
    var dispatch = useDispatch();
    var _a = __read(useState(false), 2), visible = _a[0], setVisible = _a[1];
    useEffect(function () {
        if (visible) {
            dispatch(fetchList$1());
        }
    }, [dispatch, visible]);
    var clearErrorAndSuccess = useCallback(function () { return dispatch(clearErrorAndSuccess$1()); }, [dispatch]);
    var hideAddToList = function () {
        setVisible(false);
        setTimeout(clearErrorAndSuccess, 500);
    };
    // const addToList = (productCode: IAddToListParam) => {
    //   setVisible(true);
    //   // Store product code if present; probably a call from multiple action
    //   if (productCode) {
    //     setCode(productCode);
    //   }
    // };
    var addToList = function () { return setVisible(true); };
    return [visible, { hideAddToList: hideAddToList, addToList: addToList }];
};

var AddToListPopupSuccess$2 = styled(Flex)(templateObject_1$1V || (templateObject_1$1V = __makeTemplateObject(["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  height: 100%;\n"], ["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  height: 100%;\n"])));
var AddToListPopupSucessCheck$1 = styled(Box)(templateObject_2$1z || (templateObject_2$1z = __makeTemplateObject(["\n  border: solid ", ";\n  border-width: 0 0 3px 3px;\n  transform: rotate3d(0, 0, 1, -45deg);\n  display: inline-block;\n  height: 25px;\n  width: 45px;\n"], ["\n  border: solid ", ";\n  border-width: 0 0 3px 3px;\n  transform: rotate3d(0, 0, 1, -45deg);\n  display: inline-block;\n  height: 25px;\n  width: 45px;\n"])), COLORS$1.LIGHT_GREEN);
var templateObject_1$1V, templateObject_2$1z;

var Paragraph$5 = Text.Paragraph;
var AddToListPopupSuccess$3 = function (_a) {
    var hideAddToList = _a.hideAddToList, list = _a.list;
    var t = useTranslation().t;
    return (React.createElement(AddToListPopupSuccess$2, { flexDirection: "column", alignItems: "center", justifyContent: "center" },
        React.createElement(AddToListPopupSucessCheck$1, { as: "i" }),
        React.createElement(Paragraph$5, { fontSize: 4, my: 5 },
            t('itemAddedTo'),
            " ",
            React.createElement("strong", null, list)),
        React.createElement(Button$1, { onClick: hideAddToList, width: 1 }, t('continueShopping').toUpperCase())));
};

// const useAddToListPopup = (addProductToList: (...arg: any[]) => void): any[] => {
var useAddToListPopup$1 = function (code) {
    var dispatch = useDispatch();
    var addToListState = useSelector(function (_a) {
        var addToList = _a.addToList;
        return addToList;
    });
    var list = addToListState.list;
    var _a = __read(useState(''), 2), selectedList = _a[0], setSelectedList = _a[1];
    var _b = __read(useState(''), 2), newListName = _b[0], setNewListName = _b[1];
    var hasSelectedList = isExisty$1(selectedList);
    var hasNewListName = isExisty$1(newListName);
    var setSelectedListHandler = function (_a) {
        var value = _a.value;
        return setSelectedList(value);
    };
    var setNewListNameHandler = function (_a) {
        var target = _a.target;
        return setNewListName(target.value);
    };
    var submitHandler = useCallback(function () {
        // Don't submit if no List name is provided!
        if (!hasSelectedList && !hasNewListName) {
            return;
        }
        dispatch(addProductToList$1({ selectedList: selectedList, newListName: newListName, productCode: code }));
    }, [code, dispatch, newListName, selectedList, hasSelectedList, hasNewListName]);
    var keyPressHandler = useCallback(function (_a) {
        var key = _a.key;
        if (key === 'Enter') {
            submitHandler();
        }
    }, [submitHandler]);
    useEffect(function () {
        if (isNonEmptyArray$1(list)) {
            setSelectedList(list[0].name);
        }
    }, [list]);
    return [
        addToListState,
        newListName,
        selectedList,
        { setSelectedListHandler: setSelectedListHandler, setNewListNameHandler: setNewListNameHandler, submitHandler: submitHandler, keyPressHandler: keyPressHandler },
        { hasSelectedList: hasSelectedList, hasNewListName: hasNewListName },
    ];
};

var listDefaultOption$1 = (function (t) { return [
    {
        id: 'list-create',
        label: t('createNewList'),
        value: '',
    },
]; });

var generateListOptions$1 = function (list, t) {
    var options = listDefaultOption$1(t);
    // any[] is used to match "isNonEmptyArray" argument type
    if (isNonEmptyArray$1(list)) {
        return {
            options: options.concat(list.map(function (_a) {
                var pk = _a.pk, name = _a.name;
                return ({
                    id: "list-" + pk,
                    label: name,
                    value: name,
                });
            })),
            value: list[0].name,
        };
    }
    return {
        options: options,
    };
};

var AddToListPopup$3 = styled(Box)(templateObject_1$1W || (templateObject_1$1W = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var success = _a.success;
    return (success ? 'overflow: hidden' : '');
});
var AddToListPopupAnimator$1 = styled(Box)(templateObject_2$1A || (templateObject_2$1A = __makeTemplateObject(["\n  position: relative;\n  transition: transform 0.3s ease-in-out;\n  ", ";\n"], ["\n  position: relative;\n  transition: transform 0.3s ease-in-out;\n  ", ";\n"])), function (_a) {
    var success = _a.success;
    return (success ? 'transform: translate3d(0, -100%, 0)' : '');
});
var AddToListPopupContent$1 = styled(Flex)(templateObject_3$1g || (templateObject_3$1g = __makeTemplateObject(["\n  transition: opacity 0.3s, transform 0.5s ease-in-out;\n  ", ";\n"], ["\n  transition: opacity 0.3s, transform 0.5s ease-in-out;\n  ", ";\n"])), function (_a) {
    var success = _a.success;
    return (success ? 'opacity: 0; transform: scale3d(0, 0, 0);' : '');
});
var AddToListPopupSelect$1 = styled(Box)(templateObject_4$13 || (templateObject_4$13 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  position: relative;\n"], ["\n  border: 1px solid ", ";\n  position: relative;\n"])), COLORS$1.MERCURY);
var AddToListPopupTextbox$1 = styled(Box)(templateObject_5$P || (templateObject_5$P = __makeTemplateObject(["\n  border: 1px solid ", ";\n"], ["\n  border: 1px solid ", ";\n"])), COLORS$1.MERCURY);
var templateObject_1$1W, templateObject_2$1A, templateObject_3$1g, templateObject_4$13, templateObject_5$P;

var Caption$7 = Text.Caption;
var AddToListPopup$4 = function (_a) {
    var code = _a.code, hideAddToList = _a.hideAddToList;
    var t = useTranslation().t;
    var _b = __read(useAddToListPopup$1(code), 5), addToList = _b[0], newListName = _b[1], selectedList = _b[2], _c = _b[3], setSelectedListHandler = _c.setSelectedListHandler, setNewListNameHandler = _c.setNewListNameHandler, submitHandler = _c.submitHandler, keyPressHandler = _c.keyPressHandler, _d = _b[4], hasSelectedList = _d.hasSelectedList, hasNewListName = _d.hasNewListName;
    var error = addToList.error, list = addToList.list, loading = addToList.loading, success = addToList.success;
    var listOptions = generateListOptions$1(list, t);
    var isFetchingList = !isExisty$1(list) && !error;
    return (React.createElement(AddToListPopup$3, { success: success },
        React.createElement(AddToListPopupAnimator$1, { success: success },
            React.createElement(AddToListPopupContent$1, { flexDirection: "column", success: success },
                error && React.createElement(Notification, { mb: 3 }, error),
                React.createElement(AddToListPopupSelect$1, { sx: {
                        '> div:first-of-type': {
                            display: 'block',
                        },
                    } },
                    React.createElement(Select
                    // Alternative solution: Trolly Select is not able to update itself automatically when "options" prop gets updated
                    , __assign({ 
                        // Alternative solution: Trolly Select is not able to update itself automatically when "options" prop gets updated
                        key: "length-" + listOptions.options.length }, listOptions, { onChange: setSelectedListHandler, m: 0 })),
                    isFetchingList && React.createElement(LinearProgress, { withBlock: false })),
                !hasSelectedList && (React.createElement(AddToListPopupTextbox$1, { as: "input", mt: 2, p: 3, onChange: setNewListNameHandler, onKeyPress: keyPressHandler, placeholder: t('newList'), type: "text", value: newListName })),
                React.createElement(Box, { mt: 2, sx: { position: 'relative' } },
                    React.createElement(Button$1, { disabled: (!hasSelectedList && !hasNewListName) || loading, onClick: submitHandler, width: 1 }, loading ? t('addToExistingList', { list: selectedList || newListName }) : t('addToShoppingList')),
                    loading && React.createElement(LinearProgress, { withBlock: false })),
                React.createElement(Button$1, { mt: 2, onClick: hideAddToList, variant: "outlined" }, t('cancel')),
                React.createElement(Caption$7, { mt: 3 }, t('selectCreateList'))),
            success && React.createElement(AddToListPopupSuccess$3, { list: success, hideAddToList: hideAddToList }))));
};
var AddToListPopup$5 = memo(AddToListPopup$4);

var Login$2 = function (_a) {
    var t = _a.t;
    return (React.createElement(Box, null,
        t('loginWishlist.please'),
        ' ',
        React.createElement(Button$1, { href: '/login', variant: "link" }, t('loginWishlist.login')),
        ' ',
        t('loginWishlist.wishlist')));
};
var Login$3 = withTranslation()(Login$2);

var AddToList$1 = function (_a) {
    var children = _a.children, productCode = _a.productCode;
    var _b = __read(useUser$1(), 1), isLoggedIn = _b[0];
    var _c = __read(useAddToList$1(), 2), visible = _c[0], _d = _c[1], hideAddToList = _d.hideAddToList, addToList = _d.addToList;
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        children(addToList),
        isBrowser$1() && (React.createElement(Modal, { isOpen: visible, onClose: hideAddToList, title: t('addToList') }, isLoggedIn ? React.createElement(AddToListPopup$5, { code: productCode, hideAddToList: hideAddToList }) : React.createElement(Login$3, null)))));
};
var index$6 = memo(AddToList$1);

var sharedStyle$1 = css(templateObject_1$1X || (templateObject_1$1X = __makeTemplateObject(["\n  font-family: 'Montserrat';\n  font-style: normal;\n"], ["\n  font-family: 'Montserrat';\n  font-style: normal;\n"])));
var SearchInputBox$1 = styled.input(templateObject_2$1B || (templateObject_2$1B = __makeTemplateObject(["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-bottom: ", " solid ", ";\n  width: 100%;\n  padding: 10px 44px 10px 42px;\n  margin-bottom: 12px;\n  transition: all 0.3s;\n  ", "\n  @media (max-width: ", "px) {\n    font-size: ", ";\n  }\n"], ["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-bottom: ", " solid ", ";\n  width: 100%;\n  padding: 10px 44px 10px 42px;\n  margin-bottom: 12px;\n  transition: all 0.3s;\n  ", "\n  @media (max-width: ", "px) {\n    font-size: ", ";\n  }\n"])), sharedStyle$1, TYPOGRAPHY$1.WEIGHT[400], TYPOGRAPHY$1.SIZE[16], TYPOGRAPHY$1.SIZE[20], COLORS$1.GRAY_500, COLORS$1.WHITE, function (props) { return (props.error ? '3px' : '0px'); }, COLORS$1.LIGHT_GRAY, function (props) { return ({ ...props.moreStyle }); }, BREAKPOINTS$1[1], function (props) { return props.theme.fontSizes[2]; });
var SearchMessage$1 = styled.div(templateObject_3$1h || (templateObject_3$1h = __makeTemplateObject(["\n  background: ", ";\n  backdrop-filter: blur(15px);\n  border-radius: 12px 12px 0px 0px;\n  position: relative;\n  width: 90%;\n  height: 27px;\n  padding-top: 8px;\n  padding-left: 12px;\n"], ["\n  background: ", ";\n  backdrop-filter: blur(15px);\n  border-radius: 12px 12px 0px 0px;\n  position: relative;\n  width: 90%;\n  height: 27px;\n  padding-top: 8px;\n  padding-left: 12px;\n"])), COLORS$1.LIGHT_GREY_100);
var SearchErrorMessage$1 = styled.div(templateObject_4$14 || (templateObject_4$14 = __makeTemplateObject(["\n  display: flex;\n  margin-top: -14px;\n  background: ", ";\n  border-radius: 0px 0px 12px 12px;\n  position: relative;\n  width: 90%;\n  height: 37px;\n  padding-top: 9px;\n  padding-left: 13px;\n"], ["\n  display: flex;\n  margin-top: -14px;\n  background: ", ";\n  border-radius: 0px 0px 12px 12px;\n  position: relative;\n  width: 90%;\n  height: 37px;\n  padding-top: 9px;\n  padding-left: 13px;\n"])), COLORS$1.WHITE);
var SearchLabel$1 = styled.span(templateObject_5$Q || (templateObject_5$Q = __makeTemplateObject(["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"], ["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"])), sharedStyle$1, function (props) { return props.theme.fontWeights[2]; }, TYPOGRAPHY$1.SIZE[12], TYPOGRAPHY$1.SIZE[16], COLORS$1.BLACK);
var SearchErrorLabel$1 = styled.span(templateObject_6$F || (templateObject_6$F = __makeTemplateObject(["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin-left: 8px;\n  margin-top: 5px;\n"], ["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin-left: 8px;\n  margin-top: 5px;\n"])), sharedStyle$1, TYPOGRAPHY$1.WEIGHT[400], TYPOGRAPHY$1.SIZE[12], TYPOGRAPHY$1.SIZE[16], COLORS$1.LIGHT_RED);
var SearchWrapper$1 = styled.div(templateObject_7$C || (templateObject_7$C = __makeTemplateObject(["\n  position: relative;\n  width: 90%;\n  height: 100%;\n"], ["\n  position: relative;\n  width: 90%;\n  height: 100%;\n"])));
var LocationSearchError$1 = styled.div(templateObject_8$C || (templateObject_8$C = __makeTemplateObject(["\n  color: ", ";\n  margin-bottom: 12px;\n  margin-top: -7px;\n  padding-left: 8px;\n  font-size: ", ";\n"], ["\n  color: ", ";\n  margin-bottom: 12px;\n  margin-top: -7px;\n  padding-left: 8px;\n  font-size: ", ";\n"])), COLORS$1.RED, TYPOGRAPHY$1.SIZE[12]);
var SearchIconContainer$1 = styled(Box)(templateObject_9$z || (templateObject_9$z = __makeTemplateObject(["\n  position: absolute;\n  top: 12px;\n  left: 12px;\n"], ["\n  position: absolute;\n  top: 12px;\n  left: 12px;\n"])));
var ClearSearchContainer$1 = styled(Box)(templateObject_10$y || (templateObject_10$y = __makeTemplateObject(["\n  position: absolute;\n  top: 12px;\n  right: 10px;\n"], ["\n  position: absolute;\n  top: 12px;\n  right: 10px;\n"])));
var LabelContainer$1 = styled(Flex)(templateObject_11$s || (templateObject_11$s = __makeTemplateObject(["\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: 9px 11px;\n  font-size: ", ";\n  margin-left: ", ";\n  background-color: ", ";\n  color: ", ";\n  align-items: center;\n  text-transform: capitalize;\n"], ["\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: 9px 11px;\n  font-size: ", ";\n  margin-left: ", ";\n  background-color: ", ";\n  color: ", ";\n  align-items: center;\n  text-transform: capitalize;\n"])), COLORS$1.MERCURY, TYPOGRAPHY$1.SIZE[16], TYPOGRAPHY$1.SIZE[12], function (props) { return (props.index ? '8px' : '0px'); }, function (props) { return (props.isSelected ? COLORS$1.BLUE : 'transparent'); }, function (props) { return (props.isSelected ? COLORS$1.WHITE : COLORS$1.THUNDORA); });
var ButtonWrapper$4 = styled(Flex)(templateObject_12$q || (templateObject_12$q = __makeTemplateObject(["\n  flex-direction: row;\n  justify-content: space-evenly;\n  @media (max-width: ", "px) {\n    justify-content: center;\n  }\n"], ["\n  flex-direction: row;\n  justify-content: space-evenly;\n  @media (max-width: ", "px) {\n    justify-content: center;\n  }\n"])), BREAKPOINTS$1[1]);
var LabelHeading$1 = styled(Text)(templateObject_13$p || (templateObject_13$p = __makeTemplateObject(["\n  ", "\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: ", ";\n"], ["\n  ", "\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: ", ";\n"])), sharedStyle$1, COLORS$1.BLACK);
var FormFooter$1 = styled(Flex)(templateObject_14$p || (templateObject_14$p = __makeTemplateObject(["\n  flex-direction: column;\n  bottom: 0px;\n  position: relative;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);\n  width: 118%;\n  height: 80px;\n  margin-left: -37px;\n  margin-top: 37px;\n"], ["\n  flex-direction: column;\n  bottom: 0px;\n  position: relative;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);\n  width: 118%;\n  height: 80px;\n  margin-left: -37px;\n  margin-top: 37px;\n"])));
var MarkerBox$1 = styled.div(templateObject_15$p || (templateObject_15$p = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-left: -24px;\n  margin-top: -48px;\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-left: -24px;\n  margin-top: -48px;\n"])));
var BackDrop$1 = styled.div(templateObject_16$j || (templateObject_16$j = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1041;\n  background-color: rgba(0, 0, 0, 0.5);\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1041;\n  background-color: rgba(0, 0, 0, 0.5);\n"])));
var MapOverlayWapper$1 = styled.div(templateObject_17$j || (templateObject_17$j = __makeTemplateObject(["\n  display: flex;\n  position: absolute;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  top: 30%;\n  left: 4%;\n  @media (max-width: ", "px) {\n    top: 30%;\n    left: -6%;\n  }\n"], ["\n  display: flex;\n  position: absolute;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  top: 30%;\n  left: 4%;\n  @media (max-width: ", "px) {\n    top: 30%;\n    left: -6%;\n  }\n"])), BREAKPOINTS$1[1]);
var AddressInfoCard$1 = styled(Flex)(templateObject_18$f || (templateObject_18$f = __makeTemplateObject(["\n  @media (max-width: ", "px) {\n    width: 230px;\n    height: ", ";\n    top: 28%;\n  }\n  width: 240px;\n  height: ", ";\n  align-items: center;\n  padding-top: 9px;\n  background: ", ";\n  border-radius: 8px;\n  z-index: 1042;\n  position: absolute;\n  top: ", ";\n  left: 50%;\n  transform: translateX(-50%);\n  flex-direction: column;\n"], ["\n  @media (max-width: ", "px) {\n    width: 230px;\n    height: ", ";\n    top: 28%;\n  }\n  width: 240px;\n  height: ", ";\n  align-items: center;\n  padding-top: 9px;\n  background: ", ";\n  border-radius: 8px;\n  z-index: 1042;\n  position: absolute;\n  top: ", ";\n  left: 50%;\n  transform: translateX(-50%);\n  flex-direction: column;\n"])), BREAKPOINTS$1[1], function (props) { return (props.isAreaNotSupported ? '68px' : "57px"); }, function (props) { return (props.isAreaNotSupported ? '76px' : "60px"); }, function (props) { return (props.isAreaNotSupported ? COLORS$1.LIGHT_RED : COLORS$1.COFFEE_BLACK); }, function (props) { return (props.isAreaNotSupported ? '31%' : '33%'); });
var AddressInfoLabel$1 = styled.label(templateObject_19$f || (templateObject_19$f = __makeTemplateObject(["\n  text-align: center;\n  color: ", ";\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  text-align: center;\n  color: ", ";\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n"])), COLORS$1.WHITE, sharedStyle$1, TYPOGRAPHY$1.WEIGHT[700], TYPOGRAPHY$1.SIZE[12], TYPOGRAPHY$1.SIZE[16]);
var AddressInfoText$1 = styled.span(templateObject_20$d || (templateObject_20$d = __makeTemplateObject(["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin-top: 5px;\n"], ["\n  ", "\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin-top: 5px;\n"])), sharedStyle$1, TYPOGRAPHY$1.WEIGHT[400], TYPOGRAPHY$1.SIZE[12], TYPOGRAPHY$1.SIZE[16], COLORS$1.WHITE);
var CancelIconContainer$1 = styled(Box)(templateObject_21$b || (templateObject_21$b = __makeTemplateObject(["\n  background-color: ", ";\n  height: 14px;\n  width: 14px;\n  border-radius: 7px;\n"], ["\n  background-color: ", ";\n  height: 14px;\n  width: 14px;\n  border-radius: 7px;\n"])), COLORS$1.WHITE);
var RadioButtonStyle$4 = customStyled(Box)(templateObject_22$b || (templateObject_22$b = __makeTemplateObject(["\n  input[type='radio'] {\n    accent-color: ", ";\n    width: 15px;\n    height: 15px;\n    vertical-align: -webkit-baseline-middle;\n    position: relative;\n    margin: 0 10px 0 0;\n  }\n  span {\n    ", "\n    font-weight: ", ";\n    font-size: ", " ;\n    line-height: ", ";\n    color: ", ";\n    text-transform: capitalize;\n"], ["\n  input[type='radio'] {\n    accent-color: ", ";\n    width: 15px;\n    height: 15px;\n    vertical-align: -webkit-baseline-middle;\n    position: relative;\n    margin: 0 10px 0 0;\n  }\n  span {\n    ", "\n    font-weight: ", ";\n    font-size: ", " ;\n    line-height: ", ";\n    color: ", ";\n    text-transform: capitalize;\n"])), COLORS$1.BLUE, sharedStyle$1, function (props) { return props.theme.fontWeights[4]; }, function (props) { return props.theme.fontSizes[3]; }, TYPOGRAPHY$1.SIZE[24], COLORS$1.BLACK);
var AddressInfo$1 = styled(Box)(templateObject_23$9 || (templateObject_23$9 = __makeTemplateObject(["\n  border-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  border-top-width: 0;\n  border-color: #b2b2b2;\n  border-style: solid;\n"], ["\n  border-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  border-top-width: 0;\n  border-color: #b2b2b2;\n  border-style: solid;\n"])));
var CurrentlySelectedContainer$1 = styled(Box)(templateObject_24$7 || (templateObject_24$7 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 16px;\n  left: 25px;\n  right: 25px;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  bottom: 16px;\n  left: 25px;\n  right: 25px;\n  background-color: ", ";\n"])), COLORS$1.WHITE);
var CurrentlySelectedLabel$1 = customStyled.div(templateObject_25$7 || (templateObject_25$7 = __makeTemplateObject(["\n  ", "\n  font-weight: ", "; \n  font-size: ", ";  \n  line-height: ", ";\n  color: ", ";\n"], ["\n  ", "\n  font-weight: ", "; \n  font-size: ", ";  \n  line-height: ", ";\n  color: ", ";\n"])), sharedStyle$1, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.fontSizes[2]; }, TYPOGRAPHY$1.SIZE[20], COLORS$1.BLACK);
var OutofServiceLabel$1 = styled.div(templateObject_26$7 || (templateObject_26$7 = __makeTemplateObject(["\n  ", "\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"], ["\n  ", "\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"])), sharedStyle$1, TYPOGRAPHY$1.SIZE[14], TYPOGRAPHY$1.SIZE[20], COLORS$1.BLACK);
var DrawerContainer$1 = styled(Flex)(templateObject_27$7 || (templateObject_27$7 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transition: 0.3s all;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transition: 0.3s all;\n"])));
DrawerContainer$1.defaultProps = {
    px: 16,
};
var MapContainer$1 = styled(DrawerContainer$1)(templateObject_28$5 || (templateObject_28$5 = __makeTemplateObject(["\n  transform: ", ";\n"], ["\n  transform: ", ";\n"])), function (props) { return (props.open ? "translateX(0)" : "translateX(-100%)"); });
var FormContainer$3 = styled(DrawerContainer$1)(templateObject_29$3 || (templateObject_29$3 = __makeTemplateObject(["\n  transform: ", ";\n"], ["\n  transform: ", ";\n"])), function (props) { return (props.open ? "translateX(0)" : "translateX(100%)"); });
var DrawerHeader$4 = styled(Box)(templateObject_30$3 || (templateObject_30$3 = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), TYPOGRAPHY$1.SIZE[16]);
var DrawerIconContainer$1 = styled(Button$1)(templateObject_31$3 || (templateObject_31$3 = __makeTemplateObject(["\n  padding: 0px;\n  position: absolute;\n  left: -18px;\n  height: 38px;\n  width: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  border-radius: 50%;\n  top: 33px;\n  transform: translateY(-50%);\n\n  @media (max-width: ", ") {\n    left: unset;\n    right: 20px;\n    top: -2px;\n  }\n"], ["\n  padding: 0px;\n  position: absolute;\n  left: -18px;\n  height: 38px;\n  width: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  border-radius: 50%;\n  top: 33px;\n  transform: translateY(-50%);\n\n  @media (max-width: ", ") {\n    left: unset;\n    right: 20px;\n    top: -2px;\n  }\n"])), function (props) { return props.theme.colors.white; }, function (props) { return props.theme.breakpoints[1]; });
var HeaderTitle$2 = customStyled(Flex)(templateObject_32$3 || (templateObject_32$3 = __makeTemplateObject(["\n  width: 332px;\n  height: 32px;\n  ", "\n  font-weight: ", "; \n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  position: relative;\n  left: 13px;\n  @media (max-width: ", "px) {\n    font-size: ", ";\n    left: 53px;\n  }\n"], ["\n  width: 332px;\n  height: 32px;\n  ", "\n  font-weight: ", "; \n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  position: relative;\n  left: 13px;\n  @media (max-width: ", "px) {\n    font-size: ", ";\n    left: 53px;\n  }\n"])), sharedStyle$1, function (props) { return props.theme.fontWeights[5]; }, TYPOGRAPHY$1.SIZE[22], TYPOGRAPHY$1.SIZE[32], COLORS$1.BLACK, BREAKPOINTS$1[1], TYPOGRAPHY$1.SIZE[18]);
var LoginLinkText$1 = styled(Box)(templateObject_33$3 || (templateObject_33$3 = __makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  font-weight: ", ";\n"], ["\n  font-size: ", ";\n  color: ", ";\n  font-weight: ", ";\n"])), TYPOGRAPHY$1.SIZE[16], function (props) { return (props.isLink ? COLORS$1.BLUE : COLORS$1.THUNDORA); }, function (props) { return (props.isLink ? '500' : '400'); });
var FlagIcon$1 = styled.img(templateObject_34$3 || (templateObject_34$3 = __makeTemplateObject(["\n  min-height: ", ";\n  max-height: ", ";\n  min-width: ", ";\n  max-width: ", ";\n"], ["\n  min-height: ", ";\n  max-height: ", ";\n  min-width: ", ";\n  max-width: ", ";\n"])), TYPOGRAPHY$1.SIZE[16], TYPOGRAPHY$1.SIZE[16], TYPOGRAPHY$1.SIZE[16], TYPOGRAPHY$1.SIZE[16]);
var GoogleMapBox$1 = styled(Box)(templateObject_35$3 || (templateObject_35$3 = __makeTemplateObject(["\n  position: relative;\n  flex: 1;\n"], ["\n  position: relative;\n  flex: 1;\n"])));
var GoogleMapFlex$1 = styled(Flex)(templateObject_36$3 || (templateObject_36$3 = __makeTemplateObject(["\n  position: relative;\n  height: ", ";\n"], ["\n  position: relative;\n  height: ", ";\n"])), function (props) { return (props.isMobile ? '100%' : '350'); });
var LeftBox$1 = styled(Box)(templateObject_37$3 || (templateObject_37$3 = __makeTemplateObject(["\n  width: 35%;\n"], ["\n  width: 35%;\n"])));
var RightBox$1 = styled(Box)(templateObject_38$3 || (templateObject_38$3 = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), function (props) { return (props.fullWidth ? '100%' : '63%'); });
var Verified$1 = styled(Box)(templateObject_39$3 || (templateObject_39$3 = __makeTemplateObject(["\n  color: ", ";\n  min-width: 140px;\n  text-align: right;\n"], ["\n  color: ", ";\n  min-width: 140px;\n  text-align: right;\n"])), COLORS$1.GREEN);
var Verify$1 = styled(Button$1)(templateObject_40$1 || (templateObject_40$1 = __makeTemplateObject(["\n  padding: 8px;\n  margin-bottom: 2px;\n"], ["\n  padding: 8px;\n  margin-bottom: 2px;\n"])));
var CountrySvgContainer$3 = styled(Flex)(templateObject_41$1 || (templateObject_41$1 = __makeTemplateObject(["\n  min-width: 20px;\n  max-width: 20px;\n  margin-bottom: -15px;\n  align-self: center;\n"], ["\n  min-width: 20px;\n  max-width: 20px;\n  margin-bottom: -15px;\n  align-self: center;\n"])));
var StreetNameBox$1 = styled(Box)(templateObject_42$1 || (templateObject_42$1 = __makeTemplateObject(["\n  display: ", ";\n"], ["\n  display: ", ";\n"])), function (props) { return (props.isDisplay ? 'block' : 'none'); });
var DeliverTo$1 = styled(Button$1)(templateObject_43$1 || (templateObject_43$1 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n  height: 48px;\n  width: ", ";\n  @media (max-width: ", "px) {\n    width: 262px;\n    margin-left: 3%;\n  }\n  font-family: Montserrat;\n  border-radius: 8px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-top: 13px;\n  line-height: 20px;\n  border-color: ", ";\n  background-color: ", ";\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  height: 48px;\n  width: ", ";\n  @media (max-width: ", "px) {\n    width: 262px;\n    margin-left: 3%;\n  }\n  font-family: Montserrat;\n  border-radius: 8px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-top: 13px;\n  line-height: 20px;\n  border-color: ", ";\n  background-color: ", ";\n"])), COLORS$1.WHITE, TYPOGRAPHY$1.WEIGHT[700], function (props) { return props.width; }, BREAKPOINTS$1[1], COLORS$1.WHITE, COLORS$1.BLUE);
var Back$1 = customStyled(Button$1)(templateObject_44$1 || (templateObject_44$1 = __makeTemplateObject(["\n  font-weight: ", "; \n  padding: 25px;\n  ", "\n  font-size: ", ";\n  margin-top: 2%;\n"], ["\n  font-weight: ", "; \n  padding: 25px;\n  ", "\n  font-size: ", ";\n  margin-top: 2%;\n"])), function (props) { return props.theme.fontWeights[5]; }, sharedStyle$1, function (props) { return props.theme.fontSizes[2]; });
var SelectedLocationWrapper$1 = styled.div(templateObject_45$1 || (templateObject_45$1 = __makeTemplateObject(["\n  padding-right: 10px;\n"], ["\n  padding-right: 10px;\n"])));
var SelectedLocationContainer$1 = styled(Flex)(templateObject_46$1 || (templateObject_46$1 = __makeTemplateObject(["\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  align-items: center;\n  justify-content: space-between;\n"])));
var SelectedLocation$1 = customStyled.div(templateObject_47$1 || (templateObject_47$1 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n  ", "\n  font-size: ", ";\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  ", "\n  font-size: ", ";\n"])), COLORS$1.BLACK, function (props) { return props.theme.fontWeights[6]; }, sharedStyle$1, function (props) { return props.theme.fontSizes[2]; });
var SelectedLocationLabel$1 = customStyled.div(templateObject_48$1 || (templateObject_48$1 = __makeTemplateObject(["\n  margin-top: 3%;\n  color: ", ";\n  font-size: ", "; \n  ", "\n"], ["\n  margin-top: 3%;\n  color: ", ";\n  font-size: ", "; \n  ", "\n"])), COLORS$1.BLACK, function (props) { return props.theme.fontSizes[2]; }, sharedStyle$1);
var ChangeLocation$1 = customStyled(Button$1)(templateObject_49$1 || (templateObject_49$1 = __makeTemplateObject(["\n  width:108px\n  height:40px\n  ", "\n  border-radius: 12px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  font-weight: ", "; \n  line-height: 20px;\n  border-color: ", ";\n  color: ", ";\n"], ["\n  width:108px\n  height:40px\n  ", "\n  border-radius: 12px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  font-weight: ", "; \n  line-height: 20px;\n  border-color: ", ";\n  color: ", ";\n"])), sharedStyle$1, function (props) { return props.theme.fontWeights[5]; }, COLORS$1.WHITE, COLORS$1.BLUE);
var RequiredField$1 = styled(Flex)(templateObject_50$1 || (templateObject_50$1 = __makeTemplateObject(["\n  flex-direction: column;\n  align-items: flex-end;\n"], ["\n  flex-direction: column;\n  align-items: flex-end;\n"])));
var RequiredFieldText$1 = styled.span(templateObject_51$1 || (templateObject_51$1 = __makeTemplateObject(["\n  ", "\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 3%;\n  margin-right: -3%;\n"], ["\n  ", "\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 3%;\n  margin-right: -3%;\n"])), sharedStyle$1);
var HintText$1 = styled(Text)(templateObject_52$1 || (templateObject_52$1 = __makeTemplateObject(["\n  ", "\n  padding-left: 5px;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #ce3637;\n"], ["\n  ", "\n  padding-left: 5px;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #ce3637;\n"])), sharedStyle$1);
var HintWrapper$1 = styled(Flex)(templateObject_53$1 || (templateObject_53$1 = __makeTemplateObject(["\n  flex-direction: row;\n  margin-top:4px;\n  margin-left 2px;\n"], ["\n  flex-direction: row;\n  margin-top:4px;\n  margin-left 2px;\n"])));
var templateObject_1$1X, templateObject_2$1B, templateObject_3$1h, templateObject_4$14, templateObject_5$Q, templateObject_6$F, templateObject_7$C, templateObject_8$C, templateObject_9$z, templateObject_10$y, templateObject_11$s, templateObject_12$q, templateObject_13$p, templateObject_14$p, templateObject_15$p, templateObject_16$j, templateObject_17$j, templateObject_18$f, templateObject_19$f, templateObject_20$d, templateObject_21$b, templateObject_22$b, templateObject_23$9, templateObject_24$7, templateObject_25$7, templateObject_26$7, templateObject_27$7, templateObject_28$5, templateObject_29$3, templateObject_30$3, templateObject_31$3, templateObject_32$3, templateObject_33$3, templateObject_34$3, templateObject_35$3, templateObject_36$3, templateObject_37$3, templateObject_38$3, templateObject_39$3, templateObject_40$1, templateObject_41$1, templateObject_42$1, templateObject_43$1, templateObject_44$1, templateObject_45$1, templateObject_46$1, templateObject_47$1, templateObject_48$1, templateObject_49$1, templateObject_50$1, templateObject_51$1, templateObject_52$1, templateObject_53$1;

var rearrangeAddressList$1 = function (addressList, selectedAddress) {
    var e_1, _a;
    var newRearrangedAddressList = [];
    try {
        for (var addressList_1 = __values(addressList), addressList_1_1 = addressList_1.next(); !addressList_1_1.done; addressList_1_1 = addressList_1.next()) {
            var address = addressList_1_1.value;
            if (selectedAddress.id === address.id) {
                newRearrangedAddressList.unshift(selectedAddress);
                continue;
            }
            newRearrangedAddressList.push(address);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (addressList_1_1 && !addressList_1_1.done && (_a = addressList_1.return)) _a.call(addressList_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return newRearrangedAddressList;
};
var getSubLocalityAsTown$1 = function (result) {
    var e_2, _a;
    var addressComponents = result.address_components || [];
    var town = '', sublocality, neighborhood, locality, administrativeArea;
    try {
        for (var addressComponents_1 = __values(addressComponents), addressComponents_1_1 = addressComponents_1.next(); !addressComponents_1_1.done; addressComponents_1_1 = addressComponents_1.next()) {
            var addressComponent = addressComponents_1_1.value;
            var types = addressComponent.types || [];
            sublocality = types.includes('sublocality') ? addressComponent.long_name : sublocality;
            neighborhood = types.includes('neighborhood') ? addressComponent.long_name : neighborhood;
            administrativeArea = types.includes('administrative_area') ? addressComponent.long_name : administrativeArea;
            locality = types.includes('locality') ? addressComponent.long_name : locality;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (addressComponents_1_1 && !addressComponents_1_1.done && (_a = addressComponents_1.return)) _a.call(addressComponents_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    town = sublocality || neighborhood || administrativeArea || locality;
    return town;
};
var getCountryCodeFromGoogleReponse$1 = function (result) {
    var e_3, _a;
    var addressComponents = result.address_components || [];
    var country = '';
    try {
        for (var addressComponents_2 = __values(addressComponents), addressComponents_2_1 = addressComponents_2.next(); !addressComponents_2_1.done; addressComponents_2_1 = addressComponents_2.next()) {
            var addressComponent = addressComponents_2_1.value;
            var types = addressComponent.types || [];
            if (types.indexOf('country') !== -1) {
                country = addressComponent.short_name;
                break;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (addressComponents_2_1 && !addressComponents_2_1.done && (_a = addressComponents_2.return)) _a.call(addressComponents_2);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return country;
};
var extractEmirateFromGoogleResponse$1 = function (result) {
    var e_4, _a;
    var addressComponents = (result === null || result === void 0 ? void 0 : result.address_components) || [];
    var administrativeArea, locality;
    try {
        for (var addressComponents_3 = __values(addressComponents), addressComponents_3_1 = addressComponents_3.next(); !addressComponents_3_1.done; addressComponents_3_1 = addressComponents_3.next()) {
            var addressComponent = addressComponents_3_1.value;
            var types = addressComponent.types || [];
            administrativeArea = types.includes('administrative_area_level_1')
                ? addressComponent.long_name
                : administrativeArea;
            locality = types.includes('locality') ? addressComponent.long_name : locality;
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (addressComponents_3_1 && !addressComponents_3_1.done && (_a = addressComponents_3.return)) _a.call(addressComponents_3);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return administrativeArea || locality || '';
};
var formattedGoogleAddressDescription$1 = function (address, alternativeAddress, country) {
    if (address === void 0) { address = ''; }
    if (alternativeAddress === void 0) { alternativeAddress = ''; }
    if (country === void 0) { country = ''; }
    var addressDescriptionComponents = address ? address.split(' - ') : [];
    var filteredComponents = addressDescriptionComponents.filter(function (component) {
        var _a;
        var comp = component.toLowerCase();
        return !(comp.includes('+') ||
            comp.includes('untitled') ||
            comp.includes('unknown') ||
            comp.includes('unnamed') ||
            comp.includes((_a = country === null || country === void 0 ? void 0 : country.toLowerCase()) !== null && _a !== void 0 ? _a : ''));
    });
    if (!filteredComponents.length) {
        return [alternativeAddress || '', country || ''].join(', ');
    }
    return filteredComponents.join(', ');
};

var mapStyles$1 = function (isMobile, isSelected) { return ({
    width: '100%',
    height: isMobile ? 'inherit' : '',
    opacity: isSelected ? '1' : '0.1',
    zIndex: isSelected ? '0' : '-2',
}); };
var Address$1 = function (_a) {
    var isAreaNotSupported = _a.isAreaNotSupported;
    var t = useTranslation().t;
    return (React.createElement(AddressInfoCard$1, { isAreaNotSupported: isAreaNotSupported },
        React.createElement(AddressInfoLabel$1, null, isAreaNotSupported ? t('address.notServiceable') : t('address.deliverTo')),
        React.createElement(AddressInfoText$1, null, isAreaNotSupported ? t('address.otherLocation') : t('address.movePin'))));
};
var GoogleMapBase$1 = function (props) {
    var location = props.location, google = props.google, fetchMapCoordinates = props.fetchMapCoordinates, 
    // fetchLocation,
    flatNo = props.flatNo, building = props.building, landmark = props.landmark, 
    // isDefaultLocation,
    checkCoverageArea = props.checkCoverageArea, countryConfig = props.countryConfig, isMobile = props.isMobile, setAddressInfo = props.setAddressInfo, setTown = props.setTown, setLatLng = props.setLatLng, setCountry = props.setCountry, addressInfo = props.addressInfo, setEmirate = props.setEmirate, isSelected = props.isSelected, setIsSelected = props.setIsSelected, setZoom = props.setZoom, hideFlatNo = props.hideFlatNo, isAreaNotSupported = props.isAreaNotSupported, editInfo = props.editInfo;
    var countryOfOperationID = countryConfig.countryOfOperationID;
    var _a = __read(useState(), 2), mapInstance = _a[0], setMapInstance = _a[1];
    var _b = __read(useState(function () {
        var lat = Number(getCustomCookie$1('lat'));
        var lng = Number(getCustomCookie$1('long'));
        return isNaN(lat) || isNaN(lng) ? location : { lat: lat, lng: lng };
    }), 2), updatedLocation = _b[0], setUpdatedLocation = _b[1];
    var geocoder = useMemo(function () { return new google.maps.Geocoder(); }, [google]);
    var options = countryOfOperationID
        ? {
            componentRestrictions: { country: countryOfOperationID },
        }
        : {};
    var storage = initStorageManager$1(function () { return localStorage; });
    var setFormattedAddress = useCallback(function (_a, forceUpdate) {
        var _b, _c;
        var lat = _a.lat, lng = _a.lng;
        var storedResults = storage.getItem('geocode_results');
        if (!storedResults || (storedResults.lat !== lat && storedResults.lng !== lng) || forceUpdate) {
            geocoder.geocode({ location: { lat: lat, lng: lng } }, function (results, status) {
                var _a, _b;
                if (status === 'OK') {
                    if (results === null || results === void 0 ? void 0 : results.length) {
                        setAddressInfo && setAddressInfo(((_a = results[1]) === null || _a === void 0 ? void 0 : _a.formatted_address) || ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.formatted_address));
                        setTown && setTown(getSubLocalityAsTown$1(results[0]));
                        setCountry && setCountry(getCountryCodeFromGoogleReponse$1(results[0]));
                        setEmirate && setEmirate(extractEmirateFromGoogleResponse$1(results[0]));
                        setIsSelected(true);
                        setLatLng && setLatLng({ latitude: lat, longitude: lng });
                        storage.setItem('geocode_results', { results: results, lat: lat, lng: lng });
                    }
                    else {
                        console.error('No results found');
                    }
                }
                else {
                    console.error('Geocoder failed due to: ' + status);
                }
            });
        }
        else {
            var _d = storedResults.results, results = _d === void 0 ? [] : _d;
            setAddressInfo && setAddressInfo(((_b = results[1]) === null || _b === void 0 ? void 0 : _b.formatted_address) || ((_c = results[0]) === null || _c === void 0 ? void 0 : _c.formatted_address));
            setTown && setTown(getSubLocalityAsTown$1(results[0]));
            setCountry && setCountry(getCountryCodeFromGoogleReponse$1(results[0]));
            setEmirate && setEmirate(extractEmirateFromGoogleResponse$1(results[0]));
            setLatLng && setLatLng({ latitude: updatedLocation.lat, longitude: updatedLocation.lng });
        }
    }, [geocoder, setAddressInfo, setTown, setCountry, setLatLng, updatedLocation]);
    var clearAutoComplete = function () {
        var autocompInp = document.getElementById('pac-input-add-address');
        if (autocompInp) {
            autocompInp.value = '';
        }
    };
    useEffect(function () {
        if (mapInstance) {
            mapInstance.panTo(updatedLocation);
            mapInstance.setZoom(16);
        }
    }, [updatedLocation.lat, updatedLocation.lng, mapInstance]);
    useEffect(function () {
        setUpdatedLocation({ lat: location === null || location === void 0 ? void 0 : location.lat, lng: location === null || location === void 0 ? void 0 : location.lng });
        if (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) {
            setFormattedAddress({ lat: location === null || location === void 0 ? void 0 : location.lat, lng: location === null || location === void 0 ? void 0 : location.lng }, false);
        }
    }, [editInfo === null || editInfo === void 0 ? void 0 : editInfo.id]);
    var onReady = useCallback(function (_a, map) {
        var google = _a.google;
        var autocomplete = new google.maps.places.Autocomplete(document.getElementById('pac-input-add-address'), __assign(__assign({}, options), { fields: ['geometry', 'place_id', 'formatted_address'], types: ['establishment'] }));
        autocomplete.bindTo('bounds', map);
        // Todo remove listener
        autocomplete.addListener('place_changed', function () {
            var _a, _b;
            var place = autocomplete.getPlace();
            if (!(((_a = place === null || place === void 0 ? void 0 : place.geometry) === null || _a === void 0 ? void 0 : _a.viewport) || ((_b = place === null || place === void 0 ? void 0 : place.geometry) === null || _b === void 0 ? void 0 : _b.location)))
                return;
            if (place.geometry.viewport) {
                map.fitBounds(place.geometry.viewport);
            }
            var _c = place.geometry.location, location = _c === void 0 ? null : _c;
            var lat = location && location.lat();
            var lng = location && location.lng();
            if (lat && lng) {
                fetchMapCoordinates({ latitude: lat, longitude: lng });
                setUpdatedLocation({ lat: lat, lng: lng });
                setFormattedAddress({ lat: lat, lng: lng }, true);
            }
        });
        setMapInstance(map);
    }, [options]);
    var onCenterChanged = function (_mapProps, map) {
        var centerLat = map.getCenter().lat();
        var centerLng = map.getCenter().lng();
        var latLngChanged = updatedLocation.lat !== centerLat || updatedLocation.lng !== centerLng;
        if (latLngChanged) {
            setUpdatedLocation({ lat: centerLat, lng: centerLng });
            setFormattedAddress({ lat: centerLat, lng: centerLng }, true);
        }
        else {
            setFormattedAddress({ lat: centerLat, lng: centerLng }, false);
        }
        setZoom && setZoom(map.getZoom());
        checkCoverageArea({ lat: centerLat, lng: centerLng });
    };
    var onZoomChanged = function (_mapProps, map) {
        var lat = updatedLocation.lat, lng = updatedLocation.lng;
        setZoom && setZoom(map.getZoom());
        checkCoverageArea({ lat: lat, lng: lng });
    };
    var onDragStart = function () {
        setAddressInfo && setAddressInfo('');
        setTown && setTown('');
        setCountry && setCountry('');
        clearAutoComplete();
    };
    return (React.createElement(Box, { style: { height: isMobile ? 'inherit' : 350 } },
        React.createElement(Map$1, { onReady: onReady, onDragend: onCenterChanged, onDragstart: onDragStart, onZoomChanged: onZoomChanged, google: google, style: mapStyles$1(isMobile, isSelected), initialCenter: updatedLocation, 
            /*
              // @ts-ignore */
            mapTypeControl: false, streetViewControl: false, fullscreenControl: false, zoomControl: !isMobile, zoomControlOptions: { position: google.maps.ControlPosition.LEFT_BOTTOM } }),
        isSelected && (React.createElement(Address$1, { isAreaNotSupported: isAreaNotSupported, addressInfo: addressInfo, flatNo: flatNo, building: building, landmark: landmark, hideFlatNo: hideFlatNo }))));
};
var GoogleMap$1 = GoogleApiWrapper(function (props) { return ({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    language: props.appConfig.language,
}); })(GoogleMapBase$1);
var StaticMapBase$1 = function (_a) {
    var google = _a.google, location = _a.location, restProps = __rest(_a, ["google", "location"]);
    return (React.createElement(Map$1, __assign({ google: google, initialCenter: location, mapTypeControl: false, streetViewControl: false, fullscreenControl: false, zoomControl: false, draggable: false }, restProps)));
};
var StaticMap$1 = GoogleApiWrapper({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
})(StaticMapBase$1);

var customLabel$1 = function (t) { return t('address.other'); };
var AddressLabels$1 = function (t) { return [t('address.home'), t('address.office'), t('address.other')]; };
var CustomLabel$1 = customLabel$1;
var isNumberValid$1 = function (phoneNumber, countryCode) {
    try {
        var phoneUtil = PhoneNumberUtil.getInstance();
        var number = phoneUtil.parseAndKeepRawInput(phoneNumber, countryCode);
        var regionCode = phoneUtil.getRegionCodeForNumber(number);
        var isValidNumber = phoneUtil.isValidNumberForRegion(number, regionCode || countryCode);
        return isValidNumber;
    }
    catch (error) {
        console.error('error', error);
        return false;
    }
};
var countryCodeShaper$1 = function (phone) {
    var phoneUtil = PhoneNumberUtil.getInstance();
    try {
        var phoneNumber = phoneUtil.parse(phone);
        var countryCode = phoneNumber.getCountryCode();
        return "+" + countryCode;
    }
    catch (e) {
        console.error('Invalid phone number:', e);
    }
};

var Paragraph$6 = Text.Paragraph;
var AddressLabel$3 = function (_a) {
    var setAddressLabel = _a.setAddressLabel, register = _a.register, errors = _a.errors, t = _a.t, defaultAddressLabel = _a.defaultAddressLabel, backgroundColor = _a.backgroundColor, addressLabels = _a.addressLabels, isShowCustomField = _a.isShowCustomField;
    var defaultAddresslbl = defaultAddressLabel
        ? addressLabels(t).indexOf(defaultAddressLabel) === -1
            ? CustomLabel$1(t)
            : defaultAddressLabel
        : '';
    var _b = __read(useState(defaultAddresslbl), 2), selectedLabel = _b[0], setSelectedLabel = _b[1];
    var onLabelSelection = function (label) { return function () {
        if (selectedLabel === label) {
            setSelectedLabel('');
            setAddressLabel('');
        }
        else {
            setSelectedLabel(label);
            setAddressLabel(label.toLowerCase());
        }
    }; };
    var isCustomSelected = selectedLabel === CustomLabel$1(t);
    return (React.createElement(Box, { mt: 16 },
        React.createElement(LabelHeading$1, null, t('address.addressLabel')),
        React.createElement(Flex, { mt: 12 }, addressLabels(t).map(function (label, index) { return (React.createElement(Flex, { "data-testid": label + "-label", key: index + "__address_label", flexDirection: "row", style: {
                padding: '12px',
                textTransform: 'capitalize',
            } },
            React.createElement(RadioButtonStyle$4, null,
                React.createElement(Flex, { alignItems: "center" },
                    React.createElement("input", { type: "radio", name: "address-label", value: label, defaultChecked: selectedLabel === label, onChange: onLabelSelection(label) }),
                    label)))); })),
        isCustomSelected && isShowCustomField && (React.createElement(React.Fragment, null,
            React.createElement(Input, { mui: true, testid: 'custom-label-field', defaultValue: defaultAddressLabel, label: t('address.nickname'), color: COLORS$1.BLUE, name: "addressLabel", register: register({
                    required: t('address.requiredField'),
                    minLength: 1,
                    maxLength: 255,
                }), backgroundColor: backgroundColor }),
            errors.addressLabel && (React.createElement(Paragraph$6, { color: COLORS$1.RED, mt: 1, fontSize: TYPOGRAPHY$1.SIZE[10] }, errors.addressLabel.message))))));
};
AddressLabel$3.defaultProps = {
    backgroundColor: COLORS$1.WHITE,
    addressLabels: AddressLabels$1,
    isShowCustomField: true,
};
var AddressLabel$4 = withTranslation()(AddressLabel$3);

// TODO: Re-evaluate this later
var setCountryPhoneCodesData$1 = function (countryPhoneCodesData) {
    return {
        type: NewAddressType$3.COUNTRIES_GET,
        payload: countryPhoneCodesData,
    };
};
var setCountryPhoneCodesError$1 = function (_a) {
    return {
        type: NewAddressType$3.COUNTRIES_SET_ERROR,
        payload: [],
    };
};
var fetchCitiesAndAreasAction$1 = function () {
    return {
        type: NewAddressType$3.FETCH_CITIES_AND_AREAS,
        payload: {
            method: EApiMiddlewareMethod$3.GET,
            url: GET_DELIVERY_AREAS$1,
        },
    };
};
var fetchCountriesAction$1 = function () { return function (dispatch) {
    dispatch({
        type: NewAddressType$3.COUNTRIES_GET,
        payload: {
            apiVersion: 1,
            method: EApiMiddlewareMethod$3.GET,
            url: GET_COUNTRIES_API$1,
            onSuccess: function (data) {
                dispatch(setCountryPhoneCodesData$1(data.data));
            },
            onFailure: function (_a) {
                dispatch(setCountryPhoneCodesError$1());
            },
        },
    });
}; };
var updateLocation$1 = function (cityData) {
    return {
        type: NewAddressType$3.UPDATE_LOCAION_DATA,
        payload: cityData,
    };
};

var useAddress$1 = function (t) {
    // Use for address area form
    var _a = useSelector(function (state) {
        var _a;
        return {
            citiesAndAreaState: state.userData.addresses.deliveryAreas,
            qatarCitiesAndAreaState: state.area,
            userProfile: state.userData,
            addressList: state.userData.addresses.list,
            error: state.userData.addresses.error,
            appConfig: state.appConfig,
            isAddressProcessing: state.userData.addresses.showLoader,
            countryPhoneCodesData: (_a = state.countries) === null || _a === void 0 ? void 0 : _a.allCountries,
        };
    }), citiesAndAreaState = _a.citiesAndAreaState, qatarCitiesAndAreaState = _a.qatarCitiesAndAreaState, error = _a.error, userProfile = _a.userProfile, addressList = _a.addressList, appConfig = _a.appConfig, isAddressProcessing = _a.isAddressProcessing, countryPhoneCodesData = _a.countryPhoneCodesData;
    var dispatch = useDispatch();
    var addNEditAddress = useCallback(function (formData, editInfo, setIsSubmitBtnDisabled) {
        userAddNEditAddress$1(formData, editInfo, setIsSubmitBtnDisabled)(dispatch);
        dispatch(init$1({
            changingLocation: true,
        }));
    }, [dispatch]);
    var addNEditAddressWithArea = useCallback(function (formData, editInfo) {
        userAddNEditAddressWithArea$1(__assign({}, formData), editInfo)(dispatch);
        dispatch(init$1({
            changingLocation: true,
        }));
    }, [dispatch]);
    var fetchCitiesAndAreas = useCallback(function () { return dispatch(fetchCitiesAndAreasAction$1()); }, [dispatch]);
    var fetchCitiesZonesAndAreas = useCallback(function () { return dispatch(fetchAddressCitiesAndAreasAction$1()); }, [dispatch]);
    var fetchCountries = useCallback(function () { return dispatch(fetchCountriesAction$1()); }, [dispatch]);
    var isCityAvailableInList = useCallback(function (value) {
        var isValidCityName = false;
        isValidCityName = citiesAndAreaState && citiesAndAreaState.find(function (_a) {
            var name = _a.name;
            return isLocaleStrEqual$1(name, value);
        });
        return isValidCityName;
    }, [citiesAndAreaState]);
    var isQatarCityAvailableInList = useCallback(function (value) {
        var isValidCityName = false;
        var qatarCities = qatarCitiesAndAreaState.qatarCities;
        isValidCityName =
            qatarCities &&
                qatarCities.cities &&
                qatarCities.cities.find(function (_a) {
                    var cityNameEN = _a.cityNameEN, cityNameAR = _a.cityNameAR;
                    return isLocaleStrEqual$1(cityNameEN, value) || isLocaleStrEqual$1(cityNameAR, value);
                });
        return isValidCityName;
    }, [qatarCitiesAndAreaState]);
    var validateCity = useCallback(function (value) { return isCityAvailableInList(value) || t('errorForm.validCity'); }, [
        isCityAvailableInList,
        t,
    ]);
    var validateCityQatar = useCallback(function (value) { return isQatarCityAvailableInList(value) || t('errorForm.validCity'); }, [isQatarCityAvailableInList, t]);
    var validateArea = useCallback(function (areas, value) {
        return areas.find(function (item) { return isLocaleStrEqual$1(item.name, value); }) || t('errorForm.validArea');
    }, [t]);
    var validateQatarZone = useCallback(function (zones, value) {
        return zones.find(function (item) { return isLocaleStrEqual$1(item.zoneNo, value); }) || t('errorForm.validArea');
    }, [t]);
    var validateQatarArea = useCallback(function (areas, value) {
        return (areas.find(function (item) { return isLocaleStrEqual$1(item.areaNameEN, value) || isLocaleStrEqual$1(item.areaNameAR, value); }) || t('errorForm.validArea'));
    }, [t]);
    var isPhoneVerified = function (phoneNumber, callback) {
        var isPhoneVerified = false;
        if ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone) === phoneNumber && (userProfile === null || userProfile === void 0 ? void 0 : userProfile.isPhoneVerified)) {
            isPhoneVerified = true;
        }
        isPhoneVerified = !isPhoneVerified
            ? addressList.some(function (address) {
                return address.phone === phoneNumber && address.isPhoneVerified === true;
            })
            : isPhoneVerified;
        if (!isPhoneVerified) {
            userAddressPhoneVerify$1(phoneNumber, function (res) {
                var _a;
                isPhoneVerified = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.isPhoneVerified) === true;
                callback(isPhoneVerified);
            })(dispatch);
        }
        else {
            callback(isPhoneVerified);
        }
    };
    var phoneNumberShaper = function (phone, isInternationalNumberFeature) {
        var countryCodeResult = (appConfig === null || appConfig === void 0 ? void 0 : appConfig.phoneCountryCode) || '';
        if (isInternationalNumberFeature) {
            countryCodeResult = countryCodeShaper$1(phone) || '';
        }
        var countryCode = (countryCodeResult === null || countryCodeResult === void 0 ? void 0 : countryCodeResult.replace('+', '')) || '';
        var countryRegex = new RegExp(String(appConfig === null || appConfig === void 0 ? void 0 : appConfig.phoneExpression), 'ig');
        var modifiedPhone = (phone === null || phone === void 0 ? void 0 : phone.trim().replace('+', '')) || '';
        modifiedPhone = modifiedPhone.startsWith(countryCode) ? modifiedPhone.replace(countryCode, '') : modifiedPhone;
        if (!isInternationalNumberFeature) {
            modifiedPhone = modifiedPhone.match(countryRegex) ? modifiedPhone : '';
        }
        return modifiedPhone;
    };
    /*useEffect(() => {
      dispatch(fetchUserAddresses());
    }, [dispatch]);*/
    var result = {
        addNEditAddress: addNEditAddress,
        addNEditAddressWithArea: addNEditAddressWithArea,
        fetchCitiesAndAreas: fetchCitiesAndAreas,
        fetchCitiesZonesAndAreas: fetchCitiesZonesAndAreas,
        fetchCountries: fetchCountries,
        error: error,
        citiesAndAreaState: citiesAndAreaState,
        qatarCitiesAndAreaState: qatarCitiesAndAreaState,
        validateCity: validateCity,
        validateCityQatar: validateCityQatar,
        validateArea: validateArea,
        validateQatarArea: validateQatarArea,
        validateQatarZone: validateQatarZone,
        isCityAvailableInList: isCityAvailableInList,
        isQatarCityAvailableInList: isQatarCityAvailableInList,
        userProfile: userProfile,
        isPhoneVerified: isPhoneVerified,
        addressList: addressList,
        phoneNumberShaper: phoneNumberShaper,
        isAddressProcessing: isAddressProcessing,
        countryPhoneCodesData: countryPhoneCodesData,
    };
    return result;
};

var CustomSelect$1 = customStyled(Select)(templateObject_1$1Y || (templateObject_1$1Y = __makeTemplateObject(["\n&[data-testid='trolly-select']{\n  border: 1px solid ", ";\n  top: 15px;\n  height: 52px;\n  border-radius: 4px;\n}\n\n[data-testid='select-box']{\n  padding: 10px 12px 1px;\n}\nul{min-width:250px; top:60px;} \nul>li {\n  border-bottom:0.5px solid ", ";\n  padding:16px 14px;\n}\n"], ["\n&[data-testid='trolly-select']{\n  border: 1px solid ", ";\n  top: 15px;\n  height: 52px;\n  border-radius: 4px;\n}\n\n[data-testid='select-box']{\n  padding: 10px 12px 1px;\n}\nul{min-width:250px; top:60px;} \nul>li {\n  border-bottom:0.5px solid ", ";\n  padding:16px 14px;\n}\n"])), COLORS$1.GRAY_500, COLORS$1.GRAY_100);
var Container$j = styled(Flex)(templateObject_2$1C || (templateObject_2$1C = __makeTemplateObject(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
var ImageWrapper$5 = styled(Flex)(templateObject_3$1i || (templateObject_3$1i = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var CountryLabel$3 = customStyled(Flex)(templateObject_4$15 || (templateObject_4$15 = __makeTemplateObject(["\n  font-family: ", ";\n  font-style: normal;\n  font-weight: ", ";\n  font-size: ", "px;\n  flex: 3;\n  text-align: left;\n"], ["\n  font-family: ", ";\n  font-style: normal;\n  font-weight: ", ";\n  font-size: ", "px;\n  flex: 3;\n  text-align: left;\n"])), function (props) { return props.theme.fonts.montserrat; }, function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.fontSizes[1]; });
var CallingCodeLabel$3 = customStyled(Flex)(templateObject_5$R || (templateObject_5$R = __makeTemplateObject(["\n  flex:1\n  justify-content: flex-end;\n  font-family: ", ";\n  font-style: normal;\n  font-size:", "px;\n  font-weight: ", ";\n"], ["\n  flex:1\n  justify-content: flex-end;\n  font-family: ", ";\n  font-style: normal;\n  font-size:", "px;\n  font-weight: ", ";\n"])), function (props) { return props.theme.fonts.montserrat; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.fontWeights[7]; });
var templateObject_1$1Y, templateObject_2$1C, templateObject_3$1i, templateObject_4$15, templateObject_5$R;

var nonSpaceAlphabetsOnlyRegEx$1 = /^\S[a-zA-Z '.,\u0621-\u064A]+$/;
var addressInputRegex$1 = /^\S[a-zA-Z0-9\s,'-.\u0621-\u064A]*$/;
var numericExpression$1 = /^\d+$/;
var alphanumericCommaPeriodArabic$1 = /[^A-Za-z0-9 ,.ء-ي٠-٩]+/gi;

var AutocompleteContainer$1 = styled(Flex)(templateObject_1$1Z || (templateObject_1$1Z = __makeTemplateObject(["\n  flex-direction: column;\n"], ["\n  flex-direction: column;\n"])));
var ReferenceElm$1 = styled.div(templateObject_2$1D || (templateObject_2$1D = __makeTemplateObject(["\n  height: 0;\n  width: 100%;\n"], ["\n  height: 0;\n  width: 100%;\n"])));
var ContentWrapper$4 = styled(Flex)(templateObject_3$1j || (templateObject_3$1j = __makeTemplateObject(["\n  padding: ", ";\n  :hover {\n    background-color: ", ";\n  }\n"], ["\n  padding: ", ";\n  :hover {\n    background-color: ", ";\n  }\n"])), SPACINGS$1[14], COLORS$1.TRANSPARENT_BLUE);
var DisplayContainer$1 = styled.div(templateObject_4$16 || (templateObject_4$16 = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), SPACINGS$1[14]);
var templateObject_1$1Z, templateObject_2$1D, templateObject_3$1j, templateObject_4$16;

// Todo move to trolly with input component
var defaultProps$1 = {
    label: '',
    onFocus: function () { return void 0; },
    onBlur: function () { return void 0; },
    onSelection: function () { return void 0; },
    values: [],
    value: '',
};
var Autocomplete$1 = function (props) {
    var onFocus = props.onFocus, onBlur = props.onBlur, onSelection = props.onSelection, _a = props.values, values = _a === void 0 ? [] : _a, value = props.value, isLoading = props.isLoading, label = props.label, variant = props.variant, name = props.name, register = props.register, successIcon = props.successIcon, testid = props.testid, used = props.used, defaultValue = props.defaultValue, onChange = props.onChange, rest = __rest(props, ["onFocus", "onBlur", "onSelection", "values", "value", "isLoading", "label", "variant", "name", "register", "successIcon", "testid", "used", "defaultValue", "onChange"]);
    var t = useTranslation().t;
    var _b = __read(useState(), 2), changeTooltipState = _b[0], setChangeTooltipState = _b[1];
    var _c = __read(useState(value), 2), valueLoc = _c[0], onValueChange = _c[1];
    var _d = __read(useState(React.createElement(DisplayContainer$1, null, t('address.notFound'))), 2), contentToShow = _d[0], setContentToShow = _d[1];
    // update local state valueLoc on value prop change
    useEffect(function () {
        onValueChange(value);
    }, [value]);
    var getChangeStateMethod = useCallback(function (onOpenHandle) {
        setChangeTooltipState(function () { return onOpenHandle; });
    }, [setChangeTooltipState]);
    var onChangeText = useCallback(function (e) {
        onChange && onChange(e);
        onValueChange(e.target.value);
        if (e.target.value === '') {
            // Bluring should enable error
            e.currentTarget.blur();
            // Also focus should be re-gained to the current input
            e.currentTarget.focus();
        }
    }, [onValueChange, onChange]);
    var onFocusHandle = useCallback(function (e) {
        changeTooltipState(true);
        if (onFocus) {
            onFocus(e);
        }
    }, [changeTooltipState, onFocus]);
    var onBlurHandle = useCallback(function (e) {
        changeTooltipState(false);
        if (onBlur) {
            onBlur(e);
        }
    }, [changeTooltipState, onBlur]);
    var onSelectionHandle = useCallback(function (item) { return function () {
        if (item) {
            onValueChange(item.displayName);
            changeTooltipState(false);
            if (onSelection) {
                onSelection(item.value);
            }
        }
        else {
            onValueChange('');
        }
    }; }, [onValueChange, changeTooltipState, onSelection]);
    useEffect(function () {
        if (values && values.length > 0) {
            var content = values
                .filter(function (item) {
                if (!valueLoc) {
                    return true;
                }
                var regEx;
                try {
                    regEx = new RegExp(valueLoc, 'i');
                }
                catch (e) {
                    regEx = new RegExp('');
                }
                return regEx.test(item.displayName);
            })
                .map(function (item) {
                return (React.createElement(ContentWrapper$4, { as: "i", key: item.displayName + "__autocomplete", onClick: onSelectionHandle(item), "data-testid": "add_address_autocomplete_option" }, item.displayName));
            });
            var loading = React.createElement(DisplayContainer$1, null, t('address.loading'));
            var notFound = React.createElement(DisplayContainer$1, null, t('address.notFound'));
            var contentOption = content.length < 1 ? notFound : content;
            setContentToShow(isLoading ? loading : contentOption);
        }
    }, [values, isLoading, valueLoc, t, onSelectionHandle]);
    return (React.createElement(AutocompleteContainer$1, null,
        React.createElement(Input, __assign({ mui: true, onChange: onChangeText, onFocus: onFocusHandle, onBlur: onBlurHandle, autoComplete: "nofill", label: label, variant: variant, name: name, register: register, successIcon: successIcon, "data-testid": testid, overrideInternalOptions: { used: !!valueLoc || used }, defaultValue: defaultValue }, rest)),
        React.createElement(Tooltip, { content: contentToShow, getChangeStateMethod: getChangeStateMethod, popupWrapperStyle: { left: 0, zIndex: 9, marginTop: 0, marginLeft: 1, marginRight: 1 }, cardProps: { maxHeight: 200, overflow: 'auto' } },
            React.createElement(ReferenceElm$1, null))));
};
Autocomplete$1.defaultProps = defaultProps$1;

var ELocationKey$1;
(function (ELocationKey) {
    ELocationKey["city"] = "cityName";
    ELocationKey["area"] = "areaName";
})(ELocationKey$1 || (ELocationKey$1 = {}));
var EFormState$1;
(function (EFormState) {
    EFormState["success"] = "success";
    EFormState["primary"] = "primary";
})(EFormState$1 || (EFormState$1 = {}));
var EFormKey$1;
(function (EFormKey) {
    EFormKey["city"] = "city";
    EFormKey["area"] = "area";
    EFormKey["zone"] = "zone";
    EFormKey["street"] = "street";
})(EFormKey$1 || (EFormKey$1 = {}));

var getCitiesValue$1 = function (values) {
    var validCities = values.filter(function (item) { return item.areas; });
    return validCities.map(function (item) {
        return {
            displayName: item.name,
            value: item,
        };
    });
};
var getAreaValue$1 = function (values) {
    var validAreas = values.filter(function (item) { return item.name; });
    return validAreas.map(function (item) {
        return {
            displayName: item.name,
            value: item,
        };
    });
};
var getSelectedDeliveryArea$1 = function (deliveryAreas, selectedArea) {
    var selectedDeliveryArea = {
        city: null,
        area: null,
    };
    deliveryAreas.map(function (cityData) {
        cityData.areas.map(function (area) {
            if (isLocaleStrEqual$1((selectedArea === null || selectedArea === void 0 ? void 0 : selectedArea.areaNameEN) || '', area.name) ||
                isLocaleStrEqual$1((selectedArea === null || selectedArea === void 0 ? void 0 : selectedArea.areaNameAR) || '', area.name)) {
                selectedDeliveryArea = {
                    area: {
                        code: area.code,
                        name: area.name,
                        foodDeliveryStore: area.foodDeliveryStore,
                        isSlotsAvailable: area.isSlotsAvailable,
                    },
                    city: {
                        countryIso: cityData.countryIso,
                        isocode: cityData.isocode,
                        name: cityData.name,
                    },
                };
            }
        });
    });
    return selectedDeliveryArea;
};
var getLocationDataByLang$1 = function (language, data, key) {
    var KEY = "" + key + (language === null || language === void 0 ? void 0 : language.toUpperCase()) || key + "AR";
    return data[KEY];
};
var getQatarAreaValue$1 = function (values, language) {
    var validAreas = values.filter(function (item) { return item.areaNameEN && item.areaNameAR; });
    return validAreas.map(function (item) {
        return {
            displayName: getLocationDataByLang$1(language, item, ELocationKey$1.area),
            value: item,
        };
    });
};

var _a$7;
var FormErrorTypes$1;
(function (FormErrorTypes) {
    FormErrorTypes["required"] = "required";
    FormErrorTypes["pattern"] = "pattern";
    FormErrorTypes["minLength"] = "minLength";
    FormErrorTypes["maxLength"] = "maxLength";
})(FormErrorTypes$1 || (FormErrorTypes$1 = {}));
var errorMessages$1 = (_a$7 = {},
    _a$7[FormErrorTypes$1.required] = function (param, t) { return t('errorForm.required', { param: param }); },
    _a$7[FormErrorTypes$1.pattern] = function (param, t) { return t('errorForm.valid', { param: param }); },
    _a$7[FormErrorTypes$1.minLength] = function (param, t) { return t('errorForm.minimum', { param: param }); },
    _a$7[FormErrorTypes$1.maxLength] = function (param, t) { return t('errorForm.maximum', { param: param }); },
    _a$7);
var getErrorMsg$1 = function (type, t, errObj) {
    return errorMessages$1[type](errObj, t);
};

var initialLocationState$1 = {
    city: '',
    area: '',
    zone: '',
    street: '',
};
var newAddressReducer$1 = function (state, action) {
    if (state === void 0) { state = initialLocationState$1; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case NewAddressType$3.UPDATE_LOCAION_DATA:
            return Object.assign({}, __assign(__assign({}, state), payload));
    }
    return state;
};

var ErrorLabel$1 = function (props) {
    var message = props.message;
    return (React.createElement(HintWrapper$1, null,
        React.createElement(HintIcon, { height: 20, width: 20, fill: BASE_THEME.colors.red100 }),
        React.createElement(HintText$1, null,
            " ",
            message)));
};

var CountryListElement$3 = function (_a) {
    var code = _a.code, name = _a.name, callingCode = _a.callingCode;
    return (React.createElement(Container$j, null,
        React.createElement(ImageWrapper$5, null,
            React.createElement(Image, { url: "https://mafretailblobstorage.blob.core.windows.net/countryimages/" + code + ".png", name: code + ".png", height: "16px", width: "auto" })),
        React.createElement(CountryLabel$3, null, name),
        React.createElement(CallingCodeLabel$3, null, callingCode)));
};

var AddressLabel$5 = styled.label(templateObject_1$1_ || (templateObject_1$1_ = __makeTemplateObject(["\n  font-weight: bold;\n  font-size: 12px;\n"], ["\n  font-weight: bold;\n  font-size: 12px;\n"])));
var ButtonWrapper$5 = styled(Flex)(templateObject_2$1E || (templateObject_2$1E = __makeTemplateObject(["\n  position: fixed;\n  top: 91%;\n  align-items: center;\n  flex-direction: row;\n"], ["\n  position: fixed;\n  top: 91%;\n  align-items: center;\n  flex-direction: row;\n"])));
var FullAddress$1 = styled.div(templateObject_3$1k || (templateObject_3$1k = __makeTemplateObject(["\n  margin-left: 25px;\n  max-width: 305px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"], ["\n  margin-left: 25px;\n  max-width: 305px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"])));
var FullAddressLabel$1 = styled.label(templateObject_4$17 || (templateObject_4$17 = __makeTemplateObject(["\n  font-family: Montserrat;\n  font-style: normal;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"], ["\n  font-family: Montserrat;\n  font-style: normal;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"])), TYPOGRAPHY$1.SIZE[13], TYPOGRAPHY$1.SIZE[20], COLORS$1.BLACK);
var AddressCardContainer$1 = styled(Box)(templateObject_5$S || (templateObject_5$S = __makeTemplateObject(["\n  padding: ", ";\n  border-radius: 3px;\n  border: 1px solid;\n  background-color: ", ";\n  color: ", ";\n  border-color: rgba(26,79,155,0.2);\n  font-size:", "};\n  margin-top: 8px;\n  margin-bottom: 8px;\n  &:hover {\n    background-color: rgba(26,79,155,0.1);\n    color:", "\n  }\n"], ["\n  padding: ", ";\n  border-radius: 3px;\n  border: 1px solid;\n  background-color: ", ";\n  color: ", ";\n  border-color: rgba(26,79,155,0.2);\n  font-size:", "};\n  margin-top: 8px;\n  margin-bottom: 8px;\n  &:hover {\n    background-color: rgba(26,79,155,0.1);\n    color:", "\n  }\n"])), TYPOGRAPHY$1.SIZE[12], function (props) { return (props.selected ? 'rgba(26,79,155,0.1)' : COLORS$1.WHITE); }, function (props) { return (props.selected ? COLORS$1.ANCHOR_BLUE : 'inherit'); }, TYPOGRAPHY$1.SIZE[12], COLORS$1.ANCHOR_BLUE);
var RadioButtonStyle$5 = styled(Box)(templateObject_6$G || (templateObject_6$G = __makeTemplateObject(["\n  input[type='radio'] {\n    accent-color: ", ";\n    width: 15px;\n    height: 15px;\n    vertical-align: -webkit-baseline-middle;\n    position: relative;\n    margin: 0 10px 0 0;\n  }\n  span {\n    font-family: Montserrat;\n    font-style: normal;\n    font-weight: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n  }\n"], ["\n  input[type='radio'] {\n    accent-color: ", ";\n    width: 15px;\n    height: 15px;\n    vertical-align: -webkit-baseline-middle;\n    position: relative;\n    margin: 0 10px 0 0;\n  }\n  span {\n    font-family: Montserrat;\n    font-style: normal;\n    font-weight: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n  }\n"])), COLORS$1.BLUE, TYPOGRAPHY$1.WEIGHT[500], TYPOGRAPHY$1.SIZE[16], TYPOGRAPHY$1.SIZE[24], COLORS$1.BLACK);
var AddLocation$1 = styled(Button$1)(templateObject_7$D || (templateObject_7$D = __makeTemplateObject(["\n  height: 48px;\n  width: 340px;\n  font-family: Montserrat;\n  border-radius: 8px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  font-weight: ", ";\n  margin-left: 31px;\n  margin-top: 13px;\n  line-height: 20px;\n  border-color: ", ";\n  color: ", ";\n"], ["\n  height: 48px;\n  width: 340px;\n  font-family: Montserrat;\n  border-radius: 8px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  font-weight: ", ";\n  margin-left: 31px;\n  margin-top: 13px;\n  line-height: 20px;\n  border-color: ", ";\n  color: ", ";\n"])), TYPOGRAPHY$1.WEIGHT[600], COLORS$1.WHITE, COLORS$1.BLUE);
var HeaderTitle$3 = styled.div(templateObject_8$D || (templateObject_8$D = __makeTemplateObject(["\n  width: 332px;\n  height: 32px;\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  @media (max-width: ", "px) {\n    font-size: ", ";\n    margin-left: 90px;\n  }\n"], ["\n  width: 332px;\n  height: 32px;\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  @media (max-width: ", "px) {\n    font-size: ", ";\n    margin-left: 90px;\n  }\n"])), TYPOGRAPHY$1.WEIGHT[700], TYPOGRAPHY$1.SIZE[24], TYPOGRAPHY$1.SIZE[32], COLORS$1.BLACK, BREAKPOINTS$1[1], TYPOGRAPHY$1.SIZE[18]);
var HeaderAction$1 = styled.a(templateObject_9$A || (templateObject_9$A = __makeTemplateObject(["\n  color: ", ";\n  display: block;\n  margin-top: 15px;\n  cursor: pointer;\n"], ["\n  color: ", ";\n  display: block;\n  margin-top: 15px;\n  cursor: pointer;\n"])), COLORS$1.BLUE);
var TickBox$1 = styled(Flex)(templateObject_10$z || (templateObject_10$z = __makeTemplateObject(["\n  height: 16px;\n  width: 16px;\n  background-color: ", ";\n  border-radius: 8px;\n  align-items: center;\n  justify-content: center;\n"], ["\n  height: 16px;\n  width: 16px;\n  background-color: ", ";\n  border-radius: 8px;\n  align-items: center;\n  justify-content: center;\n"])), function (props) { return (props.selected ? COLORS$1.WHITE : 'transparent'); });
var Save$1 = styled(Button$1)(templateObject_11$t || (templateObject_11$t = __makeTemplateObject(["\n  color: ", ";\n  position: relative;\n  left: 42%;\n  font-weight: ", ";\n  height: 48px;\n  width: 217.5px;\n  font-family: Montserrat;\n  border-radius: 8px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-top: 13px;\n  line-height: 20px;\n  border-color: ", ";\n  background-color: ", ";\n"], ["\n  color: ", ";\n  position: relative;\n  left: 42%;\n  font-weight: ", ";\n  height: 48px;\n  width: 217.5px;\n  font-family: Montserrat;\n  border-radius: 8px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-top: 13px;\n  line-height: 20px;\n  border-color: ", ";\n  background-color: ", ";\n"])), COLORS$1.WHITE, TYPOGRAPHY$1.WEIGHT[700], COLORS$1.WHITE, COLORS$1.BLUE);
var Cancel$1 = styled(Button$1)(templateObject_12$r || (templateObject_12$r = __makeTemplateObject(["\n  position: relative;\n  left: 15%;\n  font-weight: ", ";\n  padding: 25px;\n  font-family: Montserrat;\n  font-size: ", ";\n  margin-top: 2%;\n"], ["\n  position: relative;\n  left: 15%;\n  font-weight: ", ";\n  padding: 25px;\n  font-family: Montserrat;\n  font-size: ", ";\n  margin-top: 2%;\n"])), TYPOGRAPHY$1.WEIGHT[600], TYPOGRAPHY$1.SIZE[14]);
var templateObject_1$1_, templateObject_2$1E, templateObject_3$1k, templateObject_4$17, templateObject_5$S, templateObject_6$G, templateObject_7$D, templateObject_8$D, templateObject_9$A, templateObject_10$z, templateObject_11$t, templateObject_12$r;

var getIcon$2 = function (countryName) {
    switch (countryName) {
        case 'UAE':
            return React.createElement(UAEFlag, { size: "M" });
        case 'Bahrain':
            return React.createElement(BahrainFlag, { size: "M" });
        case 'Egypt':
            return React.createElement(EgyptFlag, { size: "M" });
        case 'Jordan':
            return React.createElement(JordanFlag, { size: "M" });
        case 'Kuwait':
            return React.createElement(KuwaitFlag, { size: "M" });
        case 'Lebanon':
            return React.createElement(LebanonFlag, { size: "M" });
        case 'Oman':
            return React.createElement(OmanFlag, { size: "M" });
        case 'Pakistan':
            return React.createElement(PakistanFlag, { size: "M" });
        case 'Qatar':
            return React.createElement(QatarFlag, { size: "M" });
        case 'KSA':
            return React.createElement(KSAFlag, { size: "M" });
        case 'Kenya':
            return React.createElement(KenyaFlag, { size: "M" });
        case 'Georgia':
            return React.createElement(GeorgiaFlag, { size: "M" });
        default:
            return countryName;
    }
};
var countrySelectShaper$1 = function (countryPhoneCodesList) {
    var allTopics = countryPhoneCodesList === null || countryPhoneCodesList === void 0 ? void 0 : countryPhoneCodesList.map(function (e) {
        return {
            value: e.code,
            label: e.callingCode,
            labelDropdown: React.createElement(CountryListElement$3, { key: e.callingCode, code: e.code, name: e.name, callingCode: e.callingCode }),
        };
    });
    return allTopics || [];
};
var AddAddressForm$2 = function (_a) {
    var showMobileAddressForm = _a.showMobileAddressForm, closeAddressFormDrawer = _a.closeAddressFormDrawer, onSelectedLocationChange = _a.onSelectedLocationChange, showAddressForm = _a.showAddressForm, setFlatNo = _a.setFlatNo, setBuildingName = _a.setBuildingName, setLandmark = _a.setLandmark, onAddressSuccess = _a.onAddressSuccess, countryConfig = _a.countryConfig, t = _a.t, updatedLocation = _a.updatedLocation, addressInfo = _a.addressInfo, town = _a.town, country = _a.country, emirate = _a.emirate, _b = _a.editInfo, editInfo = _b === void 0 ? {} : _b, isHidden = _a.isHidden, userProfile = _a.userProfile, isSetSelectedAddress = _a.isSetSelectedAddress, block = _a.block, building = _a.building, isStreeNameChange = _a.isStreeNameChange, setIsStreetNameChange = _a.setIsStreetNameChange, isCityAreaNameChange = _a.isCityAreaNameChange, setIsCityAreaNameChange = _a.setIsCityAreaNameChange;
    var appartment = editInfo.appartment, landmark = editInfo.landmark, firstName = editInfo.firstName, phone = editInfo.phone, defaultAddress = editInfo.defaultAddress, deliveryInstructions = editInfo.deliveryInstructions, defaultAddressLabel = editInfo.addressLabel;
    var _c = countryConfig || '', phoneCountryCode = _c.phoneCountryCode, countryOfOperationID = _c.countryOfOperationID;
    var _d = useForm({
        mode: 'onChange',
    }), register = _d.register, errors = _d.errors, handleSubmit = _d.handleSubmit, getValues = _d.getValues, setValue = _d.setValue, control = _d.control, clearErrors = _d.clearErrors, setError = _d.setError, formState = _d.formState, trigger = _d.trigger, reset = _d.reset, _e = _d.formState, isDirty = _e.isDirty, isValid = _e.isValid;
    var _f = __read(useAppConfig$1(), 1), _g = _f[0], countryName = _g.countryName, code = _g.code, _h = _g.areaCode, areaCode = _h === void 0 ? '' : _h, language = _g.language;
    var countryConfiguration = useSelector(function (state) { return state.appConfig; }).countryConfiguration;
    var _j = countryConfiguration || {}, countryNameEn = _j.countryNameEn, countryNameAr = _j.countryNameAr;
    var _k = useAddress$1(t), addNEditAddress = _k.addNEditAddress, isPhoneVerified = _k.isPhoneVerified, addressList = _k.addressList, error = _k.error, phoneNumberShaper = _k.phoneNumberShaper, validateCity = _k.validateCity, validateCityQatar = _k.validateCityQatar, validateArea = _k.validateArea, validateQatarArea = _k.validateQatarArea, validateQatarZone = _k.validateQatarZone, fetchCitiesZonesAndAreas = _k.fetchCitiesZonesAndAreas, fetchCountries = _k.fetchCountries, countryPhoneCodesData = _k.countryPhoneCodesData;
    var _l = __read(useState(!isExisty$1(defaultAddress) || !(addressList === null || addressList === void 0 ? void 0 : addressList.length) ? true : defaultAddress), 2), isDefaultAddress = _l[0], setIsDefaultAddress = _l[1];
    var countriesList = useMemo(function () {
        if ((countryPhoneCodesData === null || countryPhoneCodesData === void 0 ? void 0 : countryPhoneCodesData.length) > 0) {
            return countrySelectShaper$1(countryPhoneCodesData);
        }
        return [];
    }, [countryPhoneCodesData]);
    var _m = __read(useState(), 2), formData = _m[0], setFormData = _m[1];
    var _o = __read(useState(false), 2), isVerifyOTPOpen = _o[0], setIsVerifyOTPOpen = _o[1];
    var _p = __read(useState(defaultAddressLabel || ''), 2), addressLabel = _p[0], setAddressLabel = _p[1];
    var _q = __read(useState(''), 2), warningMsg = _q[0], setWarningMsg = _q[1];
    var _r = __read(useState(false), 2), phoneVerified = _r[0], setPhoneVerified = _r[1];
    var _s = __read(useState(''), 2), streetName = _s[0], setstreetName = _s[1];
    var _t = __read(useState(''), 2), appartmentName = _t[0], setAppartmentName = _t[1];
    var _u = __read(useState(''), 2), floorName = _u[0], setFloorName = _u[1];
    var _v = __read(useState(false), 2), dropDownClicked = _v[0], setDropDownClicked = _v[1];
    var _w = __read(useReducer(newAddressReducer$1, initialLocationState$1), 2), newAddressState = _w[0], dispatch = _w[1];
    var city = newAddressState.city, area = newAddressState.area, zone = newAddressState.zone, street = newAddressState.street;
    var _x = __read(useState([]), 2), areaList = _x[0], setAreaList = _x[1];
    var _y = __read(useState([]), 2), zoneList = _y[0], setZoneList = _y[1];
    var didRecordInteractionWithAreaField = useRef(false);
    var didRecordInteractionWithZoneField = useRef(false);
    var _z = useAddress$1(t), citiesAndAreaState = _z.citiesAndAreaState, qatarCitiesAndAreaState = _z.qatarCitiesAndAreaState;
    var device = useBreakpoints();
    var _0 = __read(useState(false), 2), isSubmitBtnDisabled = _0[0], setIsSubmitBtnDisabled = _0[1];
    var isInternationalPhoneNumberEnabled = useFeature('international_number_support').on;
    var isUserDefinedCity = useFeature('user_defined_city').on;
    var isUserDefinedFloor = useFeature('user_defined_floor').on;
    var isQatarAddressFields = useFeature('qatar_address_fields').on;
    var isUAEAddressFields = useFeature('user_defined_city_area').on;
    useFetchAreas$1(areaCode, language);
    var isEditableStreetAddress = useFeature('editable_street_address').on;
    var isBlockAddressFields = useFeature('block_address_field').on;
    var updateAreaInteractionFlags = useCallback(function () {
        didRecordInteractionWithAreaField.current = true;
    }, [didRecordInteractionWithAreaField]);
    var updateZoneInteractionFlags = useCallback(function () {
        didRecordInteractionWithZoneField.current = true;
    }, [didRecordInteractionWithZoneField]);
    var isMobile = device.isMobile;
    var resetAreaField = useCallback(function (listArray) {
        if (listArray === void 0) { listArray = []; }
        setValue(EFormKey$1.area, '');
        setAreaList(listArray);
        dispatch(updateLocation$1({ area: '' }));
        clearErrors(EFormKey$1.area);
        trigger(EFormKey$1.area);
        didRecordInteractionWithAreaField.current = false;
    }, [clearErrors, setValue, trigger, didRecordInteractionWithAreaField]);
    var resetZoneField = useCallback(function (listArray) {
        if (listArray === void 0) { listArray = []; }
        setZoneList(listArray);
        setValue(EFormKey$1.zone, '');
        dispatch(updateLocation$1({ zone: '' }));
        clearErrors(EFormKey$1.zone);
        trigger(EFormKey$1.zone);
        didRecordInteractionWithAreaField.current = false;
    }, [clearErrors, setValue, didRecordInteractionWithAreaField, trigger]);
    var autocompleteCityValues = useMemo(function () {
        var _a;
        if (isQatarAddressFields || isUAEAddressFields) {
            return ((_a = qatarCitiesAndAreaState === null || qatarCitiesAndAreaState === void 0 ? void 0 : qatarCitiesAndAreaState.qatarCities) === null || _a === void 0 ? void 0 : _a.cities) ? qatarCitiesAndAreaState.qatarCities.cities.map(function (item) {
                var city = getLocationDataByLang$1(language, item, ELocationKey$1.city);
                return {
                    displayName: city,
                    value: item,
                };
            })
                : [];
        }
        else {
            return citiesAndAreaState ? getCitiesValue$1(citiesAndAreaState) : [];
        }
    }, [citiesAndAreaState, language, isQatarAddressFields, isUAEAddressFields, qatarCitiesAndAreaState]);
    var getVariant = useCallback(function (key) {
        if (!didRecordInteractionWithAreaField.current &&
            key === EFormKey$1.area &&
            (areaList.length === 0 || (getValues(EFormKey$1.area) || '').length === 0)) {
            return EFormState$1.primary;
        }
        var formStateTouched = formState.touched[key] ? EFormState$1.success : EFormState$1.primary;
        return errors[key] ? 'error' : formStateTouched;
    }, [errors, formState, areaList.length, getValues]);
    var autocompleteAreaValues = useMemo(function () {
        return isQatarAddressFields || isUAEAddressFields ? getQatarAreaValue$1(areaList, language) : getAreaValue$1(areaList);
    }, [areaList, language, isQatarAddressFields, isUAEAddressFields]);
    var autoCompleteZoneValues = useMemo(function () {
        return (zoneList === null || zoneList === void 0 ? void 0 : zoneList.map(function (zone) {
            return { displayName: zone.zoneNo, value: zone };
        })) || [];
    }, [zoneList]);
    var onCitySelection = useCallback(function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var zones, restValue, areas, restValue;
        return __generator(this, function (_a) {
            if (isQatarAddressFields || isUAEAddressFields) {
                zones = value.zones, restValue = __rest(value, ["zones"]);
                dispatch(updateLocation$1({ city: getLocationDataByLang$1(language, restValue, ELocationKey$1.city), zone: '', area: '' }));
                resetZoneField(zones);
                if (isQatarAddressFields) {
                    resetAreaField([]);
                }
                if (isUAEAddressFields) {
                    resetAreaField(zones[0].areas);
                }
                setValue(EFormKey$1.city, getLocationDataByLang$1(language, restValue, ELocationKey$1.city));
                trigger(EFormKey$1.city);
            }
            else {
                areas = value.areas, restValue = __rest(value, ["areas"]);
                dispatch(updateLocation$1({ city: restValue, zone: '', area: '' }));
                resetAreaField(areas);
                setValue(EFormKey$1.city, restValue.name);
                trigger(EFormKey$1.city);
            }
            return [2 /*return*/];
        });
    }); }, [resetAreaField, resetZoneField, trigger, language, isQatarAddressFields, setValue, isUAEAddressFields]);
    var onAreaSelection = useCallback(function (value) {
        var name = isQatarAddressFields || isUAEAddressFields
            ? getLocationDataByLang$1(language, value, ELocationKey$1.area)
            : value.name;
        dispatch(updateLocation$1({ area: name }));
        setValue(EFormKey$1.area, name);
        trigger(EFormKey$1.area);
    }, [trigger, language, isQatarAddressFields, isUAEAddressFields, setValue]);
    var onZoneSelection = useCallback(function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var areas;
        return __generator(this, function (_a) {
            areas = value.areas;
            dispatch(updateLocation$1({ zone: value.zoneNo, area: '' }));
            resetAreaField(__spread(areas));
            setValue(EFormKey$1.zone, value.zoneNo);
            trigger(EFormKey$1.zone);
            return [2 /*return*/];
        });
    }); }, [trigger, resetAreaField, setValue]);
    useEffect(function () {
        if (isQatarAddressFields || isUAEAddressFields) {
            fetchCitiesZonesAndAreas();
        }
    }, [fetchCitiesZonesAndAreas, isUAEAddressFields, isQatarAddressFields]);
    useEffect(function () {
        if (isInternationalPhoneNumberEnabled) {
            fetchCountries();
        }
    }, [fetchCountries, isInternationalPhoneNumberEnabled]);
    useEffect(function () {
        if (appartment) {
            if (isUserDefinedFloor) {
                var data = getFloorApartment$1(appartment, FLOOR_KEY$1, FLAT_KEY$1);
                if (data) {
                    var _a = __read(data, 2), floor = _a[0], appart = _a[1];
                    setAppartmentName(appart);
                    setFloorName(floor);
                    setValue('appartment', appart);
                    setValue('floor', floor);
                }
            }
            else {
                setAppartmentName(appartment);
                setValue('appartment', appartment);
            }
        }
    }, [appartment, isUserDefinedFloor, setValue]);
    var onSuccess = useCallback(function (res) {
        onAddressSuccess && onAddressSuccess(res);
    }, [onAddressSuccess]);
    var onFormDataSave = function (formData, uuid) {
        if (formData) {
            var ssoType = editInfo.ssoType, id = editInfo.id;
            var data = __assign(__assign({ defaultAddress: isDefaultAddress, addressLabel: addressLabel }, formData), { onSuccess: onSuccess, latitude: countObjectProperties$1(updatedLocation) > 0 ? updatedLocation.lat : editInfo === null || editInfo === void 0 ? void 0 : editInfo.latitude, longitude: countObjectProperties$1(updatedLocation) > 0 ? updatedLocation.lng : editInfo === null || editInfo === void 0 ? void 0 : editInfo.longitude, town: isUserDefinedCity && !(formData.cityArea || '').isEmptyObject ? formData.cityArea : town, streetName: formData.streetName || '', country: country || countryOfOperationID, emirate: APP_CONFIG$1.storeId === EStoreID$1.MAFUAE ? (!(editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) ? emirate : editInfo === null || editInfo === void 0 ? void 0 : editInfo.emirate) : '', isSetSelectedAddress: isSetSelectedAddress });
            if (isQatarAddressFields) {
                var makani = "Zone#" + formData.zone + " | Area:" + formData.area + " | City:" + formData.city + " | Street#" + formData.street;
                var phone_1 = getPhoneNumber(formData);
                data = __assign(__assign({}, data), { makani: makani, town: town, phone: phone_1, isQatarAddressFields: isQatarAddressFields });
            }
            if (isUAEAddressFields) {
                var makani = formData.city;
                var town_1 = formData.area;
                data = __assign(__assign({}, data), { makani: makani, town: town_1, isUAEAddressFields: isUAEAddressFields });
            }
            if (uuid) {
                data = __assign(__assign({}, data), { addressVerificationRefId: uuid });
            }
            var editInformation = void 0;
            if (id && ssoType) {
                editInformation = { id: id, ssoType: ssoType };
            }
            addNEditAddress(data, editInformation, setIsSubmitBtnDisabled);
        }
    };
    var onFormSubmit = function (formData) {
        setIsSubmitBtnDisabled(true);
        if (isBlockAddressFields) {
            formData.building = formData.building + "|Block#" + formData.block;
        }
        if (isUserDefinedFloor) {
            formData.appartment = "" + FLOOR_KEY$1 + formData.floor + FLAT_KEY$1 + formData.appartment;
        }
        formData.phone = formData.phone.replace(/^0/, '');
        if (!phoneVerified) {
            setFormData(formData);
            setIsVerifyOTPOpen(true);
        }
        else {
            onFormDataSave(formData, '');
        }
    };
    var validatePhoneNumber = function () {
        var _a;
        var phoneNumber = (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) ? phone : userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone;
        var intPhoneNumber = getValues('phone');
        var intPhoneCountryCode = (_a = getValues('phoneCountryCode')) === null || _a === void 0 ? void 0 : _a.label;
        if (phoneNumber) {
            isPhoneVerified((isInternationalPhoneNumberEnabled && dropDownClicked ? intPhoneCountryCode : '') +
                (isInternationalPhoneNumberEnabled && dropDownClicked ? intPhoneNumber : phoneNumber), function (isPhoneVerified) {
                setPhoneVerified(isPhoneVerified);
            });
        }
        else {
            setPhoneVerified(false);
        }
    };
    var handleControllerClick = function () {
        var phoneCodeValue = getValues().phoneCountryCode;
        var phoneNumber = getValues().phone;
        var isValid = isNumberValid$1(((phoneCodeValue === null || phoneCodeValue === void 0 ? void 0 : phoneCodeValue.label) || phoneCodeValue) + phoneNumber, phoneCodeValue === null || phoneCodeValue === void 0 ? void 0 : phoneCodeValue.value);
        isValid
            ? clearErrors('phone')
            : setError('phone', {
                type: 'phone_expression',
                message: t('address.invalidPhone'),
            });
    };
    useEffect(function () {
        if (phone || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone)) {
            validatePhoneNumber();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [phone, userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone]);
    useEffect(function () {
        if ((editInfo === null || editInfo === void 0 ? void 0 : editInfo.streetName) && !isStreeNameChange) {
            setValue('streetName', editInfo.streetName);
            setstreetName(editInfo.streetName);
            setIsStreetNameChange(true);
        }
        if ((editInfo === null || editInfo === void 0 ? void 0 : editInfo.town) && !isCityAreaNameChange) {
            setTimeout(function () {
                setValue('cityArea', editInfo.town);
                setIsCityAreaNameChange(true);
            }, 1000);
        }
    }, [
        showAddressForm,
        editInfo,
        isStreeNameChange,
        isCityAreaNameChange,
        setValue,
        setIsStreetNameChange,
        setIsCityAreaNameChange,
        trigger,
    ]);
    useEffect(function () {
        var _a, _b;
        var _c, _d, _e;
        if ((editInfo === null || editInfo === void 0 ? void 0 : editInfo.makani) && (isQatarAddressFields || isUAEAddressFields)) {
            var makani = editInfo.makani, town_2 = editInfo.town, streetName_1 = editInfo.streetName;
            var city_1, zone_1, area_1, street_1;
            if (isQatarAddressFields) {
                var makaniData = makani
                    .replace('Zone#', '')
                    .replace('City:', '')
                    .replace('Area:', '')
                    .replace('Street#', '')
                    .split(' | ');
                _a = __read(makaniData, 4), zone_1 = _a[0], area_1 = _a[1], city_1 = _a[2], street_1 = _a[3];
            }
            if (isUAEAddressFields) {
                city_1 = makani;
                area_1 = town_2;
                street_1 = streetName_1;
            }
            dispatch(updateLocation$1({ city: city_1, area: area_1, zone: zone_1, street: street_1 }));
            var formValues = getValues();
            reset(__assign(__assign({}, formValues), (_b = {}, _b[EFormKey$1.city] = city_1, _b[EFormKey$1.area] = area_1, _b[EFormKey$1.zone] = zone_1, _b[EFormKey$1.street] = street_1, _b)));
            trigger([EFormKey$1.city, EFormKey$1.zone, EFormKey$1.area, EFormKey$1.street]);
            var filtererCities = ((_d = (_c = qatarCitiesAndAreaState === null || qatarCitiesAndAreaState === void 0 ? void 0 : qatarCitiesAndAreaState.qatarCities) === null || _c === void 0 ? void 0 : _c.cities) === null || _d === void 0 ? void 0 : _d.filter(function (item) {
                var cityLocal = getLocationDataByLang$1(language, item, ELocationKey$1.city);
                return city_1 === cityLocal;
            })) || [];
            if (filtererCities.length > 0) {
                var zones = filtererCities[0].zones;
                setZoneList(zones);
                var zoneIndex = zones.findIndex(function (x) { return x.zoneNo === zone_1; });
                if (isUAEAddressFields) {
                    setAreaList(zones[0].areas);
                }
                if (zoneIndex > -1) {
                    setAreaList((_e = zones[zoneIndex]) === null || _e === void 0 ? void 0 : _e.areas);
                }
            }
        }
    }, [
        editInfo,
        isQatarAddressFields,
        isUAEAddressFields,
        qatarCitiesAndAreaState,
        language,
        trigger,
        setValue,
        reset,
        getValues,
    ]);
    useEffect(function () {
        var sharedConfig = countryConfig.sharedConfig;
        if (addressInfo) {
            if (isEditableStreetAddress && !isQatarAddressFields) {
                var unSupportedStreetAddressKeywords = sharedConfig.unSupportedStreetAddressKeywords;
                var isKeywordExist_1 = false;
                unSupportedStreetAddressKeywords.forEach(function (keyword) {
                    if (!isKeywordExist_1) {
                        var i = addressInfo.indexOf(keyword);
                        if (i > -1) {
                            isKeywordExist_1 = true;
                        }
                    }
                });
                setValue('streetName', formattedGoogleAddressDescription$1(addressInfo, emirate, countryNameEn || countryNameAr));
                setstreetName(formattedGoogleAddressDescription$1(addressInfo, emirate, countryNameEn || countryNameAr));
            }
            else {
                setValue('streetName', addressInfo);
                setstreetName(formattedGoogleAddressDescription$1(addressInfo, emirate, countryNameEn || countryNameAr));
            }
        }
    }, [
        addressInfo,
        setValue,
        countryConfig,
        isQatarAddressFields,
        emirate,
        countryNameEn,
        countryNameAr,
        isEditableStreetAddress,
    ]);
    useEffect(function () {
        if (town) {
            setValue('cityArea', town);
        }
    }, [town, setValue]);
    var onChangeSwitchHandle = function () {
        var value = !isDefaultAddress;
        setIsDefaultAddress(value);
    };
    var onCloseOTPVerifyModal = function () {
        setIsVerifyOTPOpen(false);
        var warningMsg = phone
            ? t('verifyOTP.verifyYourMobileNumberToUpdateAddress')
            : t('verifyOTP.verifyYourMobileNumberToAddAddress');
        setWarningMsg(warningMsg);
    };
    var validateInput = function (fieldName) {
        if (fieldName === 'streetName') {
            setValue(fieldName, getValues(fieldName));
        }
        else {
            setValue(fieldName, getValues(fieldName).replace(alphanumericCommaPeriodArabic$1, ''));
        }
    };
    var onFlatNumberChange = useCallback(function () {
        setFlatNo(getValues('appartment'));
    }, [setFlatNo, getValues]);
    var onBuildingNameChange = useCallback(function () {
        setBuildingName(getValues('building'));
    }, [setBuildingName, getValues]);
    var onLandmarkChange = useCallback(function () {
        setLandmark(getValues('landmark'));
    }, [setLandmark, getValues]);
    var notificationMessage = useMemo(function () {
        return (warningMsg || error) && React.createElement(Notification, { my: 2 }, warningMsg || (error && t('errorGeneral')));
    }, [error, warningMsg, t]);
    var isNumberKey = function (evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
            return false;
        }
        return true;
    };
    var onChangeLocation = useCallback(function (e, key) {
        var _a;
        var value = e.target.value;
        dispatch(updateLocation$1((_a = {}, _a[key] = value, _a)));
        setValue(key, e.target.value);
        trigger(key);
        if (key === EFormKey$1.city) {
            resetZoneField([]);
            resetAreaField([]);
        }
        else if (key === EFormKey$1.zone) {
            resetAreaField([]);
        }
    }, [setValue, trigger, resetZoneField, resetAreaField]);
    var defaultSelectValue = (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) && isInternationalPhoneNumberEnabled ? countryCodeShaper$1(editInfo.phone) : phoneCountryCode;
    var getPhoneNumber = function (formData) {
        var _a;
        var phoneNumber = (isInternationalPhoneNumberEnabled
            ? !dropDownClicked
                ? formData === null || formData === void 0 ? void 0 : formData.phoneCountryCode : (_a = formData === null || formData === void 0 ? void 0 : formData.phoneCountryCode) === null || _a === void 0 ? void 0 : _a.label
            : phoneCountryCode) + (formData === null || formData === void 0 ? void 0 : formData.phone);
        return phoneNumber;
    };
    return (React.createElement(Drawer, { preventCloseOnClickOutside: true, onClose: closeAddressFormDrawer, isOpen: showAddressForm || showMobileAddressForm, width: ['100%', '400px', '500px'], anchor: ['bottom', null, 'right'], contentStyles: { p: [0], height: '100%', display: 'flex', flexDirection: 'column', fontFamily: 'Montserrat' }, variant: "float", title: React.createElement(HeaderTitle$3, null, editInfo.id ? t('address.editAddress') : t('address.completeDetails')), "data-testid": "address-form-drawer", isTitleBorder: false },
        isVerifyOTPOpen && (React.createElement(VerifyPassword$1, { isShowShopping: false, email: getUserEmailFromCookie$1(), phoneNumber: getPhoneNumber(formData), onVerifyAccount: function (uuid) { return onFormDataSave(formData, uuid); }, onCloseModal: function () { return onCloseOTPVerifyModal(); }, action: "ADDRESS_PHONE_VERIFICATION" })),
        React.createElement(Flex, { flexDirection: "column", flex: 1, mt: 16, pr: 30, pl: 38, as: "form", onSubmit: handleSubmit(onFormSubmit), style: { display: isHidden ? 'none' : 'flex' }, "data-testid": "__location-cx-address__" },
            React.createElement(SelectedLocationContainer$1, null,
                React.createElement(SelectedLocationWrapper$1, null,
                    React.createElement(SelectedLocation$1, null, t('address.selectedLocation')),
                    React.createElement(SelectedLocationLabel$1, null, streetName)),
                React.createElement(ChangeLocation$1, { onClick: onSelectedLocationChange, variant: "custom", preventTextTransform: true, backgroundColor: "rgba(14, 90, 167, 0.05)" }, t('change'))),
            React.createElement(RequiredField$1, null,
                React.createElement(RequiredFieldText$1, null, t('address.requiredFieldNew'))),
            React.createElement(Box, null,
                notificationMessage,
                (isQatarAddressFields || isUAEAddressFields) && (React.createElement(React.Fragment, null,
                    React.createElement(Autocomplete$1, { value: city, label: t('address.city'), values: autocompleteCityValues, defaultValue: city, variant: getVariant(EFormKey$1.city), onSelection: onCitySelection, register: register({
                            required: getErrorMsg$1(FormErrorTypes$1.required, t),
                            validate: isQatarAddressFields || isUAEAddressFields ? validateCityQatar : validateCity,
                        }), name: "city", successIcon: false, testid: "appartment-number-field", onBlur: function (e) { return onChangeLocation(e, EFormKey$1.city); }, allowedRegExpChars: isRTL$1() ? undefined : 'alphanumericCommaPeriod', backgroundColor: COLORS$1.WHITE, onChange: function (e) { return onChangeLocation(e, EFormKey$1.city); } }),
                    errors.city && React.createElement(ErrorLabel$1, { message: errors.city.message }),
                    React.createElement(Flex, null,
                        isQatarAddressFields && (React.createElement(LeftBox$1, { mr: 2 },
                            React.createElement(Autocomplete$1, { value: zone, label: t('address.zone'), onSelection: onZoneSelection, defaultValue: zone, values: autoCompleteZoneValues, successIcon: false, name: "zone", register: register({
                                    required: getErrorMsg$1(FormErrorTypes$1.required, t),
                                    validate: function (value) { return validateQatarZone(zoneList, value); },
                                }), disabled: autoCompleteZoneValues.length < 1, variant: getVariant(EFormKey$1.zone), testid: "zone-field", onFocus: updateZoneInteractionFlags, allowedRegExpChars: isRTL$1() ? undefined : 'alphanumericCommaPeriod', backgroundColor: COLORS$1.WHITE, onChange: function (e) { return onChangeLocation(e, EFormKey$1.zone); } }),
                            errors.zone && (zoneList.length !== 0 || didRecordInteractionWithZoneField.current) && (React.createElement(ErrorLabel$1, { message: errors.zone.message })))),
                        React.createElement(RightBox$1, { fullWidth: true },
                            React.createElement(Autocomplete$1, { value: area, label: t('address.area'), onSelection: onAreaSelection, defaultValue: area, values: autocompleteAreaValues, successIcon: false, name: "area", register: register({
                                    required: getErrorMsg$1(FormErrorTypes$1.required, t),
                                    validate: function (value) {
                                        return isQatarAddressFields || isUAEAddressFields
                                            ? validateQatarArea(areaList, value)
                                            : validateArea(areaList, value);
                                    },
                                }), disabled: autocompleteAreaValues.length < 1, variant: getVariant(EFormKey$1.area), testid: "area-field", onFocus: updateAreaInteractionFlags, allowedRegExpChars: isRTL$1() ? undefined : 'alphanumericCommaPeriod', backgroundColor: COLORS$1.WHITE, onChange: function (e) { return onChangeLocation(e, EFormKey$1.area); } }),
                            errors.area && (areaList.length !== 0 || didRecordInteractionWithAreaField.current) && (React.createElement(ErrorLabel$1, { message: errors.area.message })))))),
                !isQatarAddressFields && (React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.appartment ? 'error' : 'primary', testid: 'appartment-number-field', defaultValue: appartmentName, label: t('address.apartmentNumber'), color: COLORS$1.BLUE, name: "appartment", onChange: function () {
                            validateInput('appartment');
                            onFlatNumberChange();
                        }, register: register({
                            required: t('address.requiredField'),
                            minLength: 1,
                            maxLength: 255,
                            pattern: {
                                value: isQatarAddressFields ? numericExpression$1 : addressInputRegex$1,
                                message: getErrorMsg$1(FormErrorTypes$1.pattern, t, t('address.apartment').toLowerCase()),
                            },
                        }), onKeyPress: function (e) { return isQatarAddressFields && isNumberKey(e); } }),
                    errors.appartment && React.createElement(ErrorLabel$1, { message: t('address.numberError') }))),
                isQatarAddressFields && (React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.street ? 'error' : 'primary', defaultValue: street, label: t('address.streetNumber'), color: COLORS$1.BLUE, name: "street", 
                        // allowedRegExpChars="alphanumericCommaPeriodArabic"
                        onChange: function () {
                            validateInput(EFormKey$1.street);
                        }, onKeyPress: function (ev) { return isNumberKey(ev); }, register: register({
                            required: getErrorMsg$1(FormErrorTypes$1.required, t),
                            maxLength: {
                                value: 255,
                                message: getErrorMsg$1(FormErrorTypes$1.maxLength, t, 255),
                            },
                            pattern: {
                                value: numericExpression$1,
                                message: getErrorMsg$1(FormErrorTypes$1.pattern, t, t('address.street')),
                            },
                        }) }),
                    errors.street && React.createElement(ErrorLabel$1, { message: t('address.streetError') }))),
                isUserDefinedFloor && (React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.floor ? 'error' : 'primary', defaultValue: floorName, label: t('address.floor'), color: COLORS$1.BLUE, name: "floor", onChange: function () {
                            validateInput('floor');
                        }, register: register({
                            required: getErrorMsg$1(FormErrorTypes$1.required, t),
                            maxLength: {
                                value: 255,
                                message: getErrorMsg$1(FormErrorTypes$1.maxLength, t, 255),
                            },
                        }) }),
                    errors.floor && React.createElement(ErrorLabel$1, { message: errors.floor.message }))),
                React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.building ? 'error' : 'primary', testid: 'building-field', defaultValue: building, label: isQatarAddressFields ? t('address.buildingOrCompound') : t('address.building'), color: COLORS$1.BLUE, name: "building", onChange: function () {
                            validateInput('building');
                            onBuildingNameChange();
                        }, register: register({
                            required: t('address.requiredField'),
                            maxLength: 255,
                            pattern: {
                                value: isQatarAddressFields ? numericExpression$1 : addressInputRegex$1,
                                message: getErrorMsg$1(FormErrorTypes$1.pattern, t, isQatarAddressFields
                                    ? t('address.buildingOrCompound').toLowerCase()
                                    : t('address.buildingName').toLowerCase()),
                            },
                        }), onKeyPress: function (ev) { return isQatarAddressFields && isNumberKey(ev); } }),
                    errors.building && React.createElement(ErrorLabel$1, { message: t('address.buildingError') })),
                isQatarAddressFields && (React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.appartment ? 'error' : 'primary', testid: 'appartment-number-field', defaultValue: appartmentName, label: t('address.apartment'), color: COLORS$1.BLUE, name: "appartment", onChange: function () {
                            validateInput('appartment');
                            onFlatNumberChange();
                        }, register: register({
                            required: t('address.requiredField'),
                            minLength: 1,
                            maxLength: 255,
                            pattern: {
                                value: isQatarAddressFields ? numericExpression$1 : addressInputRegex$1,
                                message: getErrorMsg$1(FormErrorTypes$1.pattern, t, t('address.apartment').toLowerCase()),
                            },
                        }), onKeyPress: function (ev) { return isQatarAddressFields && isNumberKey(ev); } }),
                    errors.appartment && React.createElement(ErrorLabel$1, { message: t('address.apartmentError') }))),
                isEditableStreetAddress && (React.createElement(StreetNameBox$1, { isDisplay: !isQatarAddressFields, paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.streetName ? 'error' : 'primary', defaultValue: streetName, label: t('address.street'), color: COLORS$1.BLUE, name: "streetName", allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () {
                            validateInput('streetName');
                        }, register: register({
                            required: t('address.requiredField'),
                        }) }),
                    errors.streetName && React.createElement(ErrorLabel$1, { message: t('address.streetError') }))),
                isBlockAddressFields && (React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.block ? 'error' : 'primary', label: t('address.block'), successIcon: true, name: "block", defaultValue: block, color: COLORS$1.BLUE, register: register({
                            required: getErrorMsg$1(FormErrorTypes$1.required, t),
                            min: 1,
                            pattern: {
                                value: numericExpression$1,
                                message: getErrorMsg$1(FormErrorTypes$1.pattern, t, t('address.block').toLowerCase()),
                            },
                            maxLength: {
                                value: 255,
                                message: getErrorMsg$1(FormErrorTypes$1.maxLength, t, 255),
                            },
                        }), "data-testid": "block-number-field", onChange: function () { return validateInput('block'); }, onKeyPress: function (ev) { return isNumberKey(ev); } }),
                    parseInt(getValues('block')) === 0 && React.createElement(ErrorLabel$1, { message: t('address.blockValueGreaterThanZero') }),
                    parseInt(getValues('block')) !== 0 && errors.block && React.createElement(ErrorLabel$1, { message: errors.block.message }))),
                !isQatarAddressFields && (React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, disabled: true, testid: 'area-field', defaultValue: (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) ? editInfo === null || editInfo === void 0 ? void 0 : editInfo.emirate : emirate, label: t('address.area'), color: COLORS$1.BLUE, name: "area" }))),
                React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, variant: errors.landmark ? 'error' : 'primary', testid: 'landmark-field', defaultValue: landmark, label: t('address.closestLandmark'), color: COLORS$1.BLUE, name: "landmark", allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () {
                            validateInput('landmark');
                            onLandmarkChange();
                        }, register: register({
                            maxLength: 255,
                        }) }),
                    errors.landmark && React.createElement(ErrorLabel$1, { message: errors.landmark.message })),
                React.createElement(Box, { paddingTop: "20px" },
                    React.createElement(Input, { mui: true, testid: 'delivery-instructions-field', defaultValue: deliveryInstructions, label: t('address.deliveryInstructions'), color: COLORS$1.BLUE, name: "deliveryInstructions", allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () { return validateInput('deliveryInstructions'); }, register: register({
                            minLength: 1,
                            maxLength: 255,
                        }) }))),
            React.createElement(AddressLabel$4, { setAddressLabel: setAddressLabel, register: register, errors: errors, defaultAddressLabel: defaultAddressLabel, isShowCustomField: (defaultAddressLabel && firstName) || !firstName ? true : false }),
            React.createElement(Box, { mt: 16 },
                React.createElement(LabelHeading$1, null, t('address.receiverInformation')),
                React.createElement(Input, { mui: true, variant: errors.fullName ? 'error' : 'primary', testid: 'receiver-name-field', defaultValue: firstName || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.fullName), label: t('address.receiverName'), color: COLORS$1.BLUE, name: "fullName", onChange: function () { return validateInput('fullName'); }, register: register({
                        required: t('address.requiredField'),
                        minLength: 1,
                        maxLength: 255,
                    }) }),
                errors.fullName && React.createElement(ErrorLabel$1, { message: errors.fullName.message }),
                React.createElement(Flex, { justifyContent: "space-between" },
                    React.createElement(Flex, { width: isMobile ? '29%' : '25%' }, isInternationalPhoneNumberEnabled ? (React.createElement(Controller, { control: control, as: CustomSelect$1, options: countriesList, defaultValue: defaultSelectValue, name: "phoneCountryCode", variant: errors.country_code ? 'error' : 'primary', register: register({}), isLabelSeletionNull: false, m: 0, onClick: function () {
                            setDropDownClicked(true);
                            handleControllerClick();
                            validatePhoneNumber();
                        } })) : (React.createElement(React.Fragment, null,
                        React.createElement(Input, { mui: true, label: t('address.country'), icon: countryName && getIcon$2(countryName), testid: "country-code-field", value: phoneCountryCode, disabled: true })))),
                    React.createElement(Box, { width: isMobile ? '68%' : '70%' },
                        React.createElement(Input, { mui: true, variant: errors.phone ? 'error' : 'primary', testid: 'phone-number-field', defaultValue: phoneNumberShaper(phone || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone), isInternationalPhoneNumberEnabled), label: t('address.mobileNumber'), name: "phone", successIcon: true, onChange: function (e) {
                                validatePhoneNumber();
                                var phoneCodeValue = getValues().phoneCountryCode;
                                if (!(phoneCodeValue === null || phoneCodeValue === void 0 ? void 0 : phoneCodeValue.label)) {
                                    phoneCodeValue = {
                                        label: phoneCountryCode,
                                        value: code,
                                    };
                                }
                                var isValid = isNumberValid$1((phoneCodeValue === null || phoneCodeValue === void 0 ? void 0 : phoneCodeValue.label) + e.target.value, phoneCodeValue === null || phoneCodeValue === void 0 ? void 0 : phoneCodeValue.value);
                                isValid
                                    ? clearErrors('phone')
                                    : setError('phone', {
                                        type: 'phone_expression',
                                        message: t('address.invalidPhone'),
                                    });
                            }, allowedRegExpChars: "alphanumericCommaPeriod", autoComplete: "tel", color: COLORS$1.BLUE, register: register({}), iconRight: phoneVerified &&
                                phoneNumberShaper(phone || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone)) && (React.createElement(Check, { size: "M", fill: COLORS$1.GREEN, stroke: COLORS$1.GREEN })) }))),
                errors.phone && React.createElement(ErrorLabel$1, { message: errors.phone.message }),
                (addressList === null || addressList === void 0 ? void 0 : addressList.length) && !defaultAddress ? (React.createElement(Flex, { justifyContent: "space-between", mt: 30, alignItems: "center", style: { position: 'relative' } },
                    React.createElement(Text, null, t('address.setAsDefault')),
                    React.createElement(Switch, { checked: isDefaultAddress, onChange: onChangeSwitchHandle, disabled: defaultAddress }))) : (''),
                React.createElement(FormFooter$1, null,
                    React.createElement(ButtonWrapper$4, null,
                        React.createElement(Back$1, { variant: "link" }, t('back')),
                        React.createElement(DeliverTo$1, { width: "202px", testid: "address-submit-button", type: "submit", variant: "custom", preventTextTransform: true, disabledNewUI: editInfo.id ? false : !isDirty || !isValid, disabled: isSubmitBtnDisabled }, editInfo.id ? t('address.updateAddress') : t('address.save'))))))));
};
var AddAddressForm$3 = withTranslation()(AddAddressForm$2);

var H3$2 = Text.H3, Paragraph$7 = Text.Paragraph;
var getIcon$3 = function (countryName) {
    switch (countryName) {
        case 'UAE':
            return React.createElement(UAEFlag, { size: "L" });
        case 'Bahrain':
            return React.createElement(BahrainFlag, { size: "L" });
        case 'Egypt':
            return React.createElement(EgyptFlag, { size: "L" });
        case 'Jordan':
            return React.createElement(JordanFlag, { size: "L" });
        case 'Kuwait':
            return React.createElement(KuwaitFlag, { size: "L" });
        case 'Lebanon':
            return React.createElement(LebanonFlag, { size: "L" });
        case 'Oman':
            return React.createElement(OmanFlag, { size: "L" });
        case 'Pakistan':
            return React.createElement(PakistanFlag, { size: "L" });
        case 'Qatar':
            return React.createElement(QatarFlag, { size: "L" });
        case 'KSA':
            return React.createElement(KSAFlag, { size: "L" });
        case 'Kenya':
            return React.createElement(KenyaFlag, { size: "L" });
        case 'Georgia':
            return React.createElement(GeorgiaFlag, { size: "L" });
        default:
            return countryName;
    }
};
var AddAddressFormWithArea$2 = function (_a) {
    var _b;
    var onAddressSuccess = _a.onAddressSuccess, countryConfig = _a.countryConfig, t = _a.t, _c = _a.editInfo, editInfo = _c === void 0 ? {} : _c, isHidden = _a.isHidden, userProfile = _a.userProfile, isSetSelectedAddress = _a.isSetSelectedAddress, block = _a.block, building = _a.building;
    var streetName = editInfo.streetName, landmark = editInfo.landmark, firstName = editInfo.firstName, phone = editInfo.phone, defaultAddress = editInfo.defaultAddress, region = editInfo.region, deliveryArea = editInfo.deliveryArea, defaultAddressLabel = editInfo.addressLabel, deliveryInstructions = editInfo.deliveryInstructions, appartment = editInfo.appartment, makani = editInfo.makani;
    var phoneCountryCode = countryConfig.phoneCountryCode, _d = countryConfig.phoneExpression, phoneExpression = _d === void 0 ? '' : _d;
    var _e = __read(useState(defaultAddressLabel), 2), addressLabel = _e[0], setAddressLabel = _e[1];
    var _f = useForm({
        mode: 'onBlur',
    }), register = _f.register, errors = _f.errors, handleSubmit = _f.handleSubmit, trigger = _f.trigger, 
    // watch,
    setValue = _f.setValue, clearErrors = _f.clearErrors, getValues = _f.getValues, formState = _f.formState;
    var dispatch = useDispatch();
    var _g = useAddress$1(t), validateCity = _g.validateCity, validateCityQatar = _g.validateCityQatar, validateArea = _g.validateArea, validateQatarArea = _g.validateQatarArea, validateQatarZone = _g.validateQatarZone, isCityAvailableInList = _g.isCityAvailableInList, isQatarCityAvailableInList = _g.isQatarCityAvailableInList, fetchCitiesZonesAndAreasQatar = _g.fetchCitiesZonesAndAreasQatar, isPhoneVerified = _g.isPhoneVerified, error = _g.error, addressList = _g.addressList, phoneNumberShaper = _g.phoneNumberShaper;
    var _h = __read(useState(!isExisty$1(defaultAddress) || !(addressList === null || addressList === void 0 ? void 0 : addressList.length) ? true : defaultAddress), 2), isDefaultAddress = _h[0], setIsDefaultAddress = _h[1];
    var _j = __read(useState(), 2), formData = _j[0], setFormData = _j[1];
    var _k = __read(useState(false), 2), isVerifyOTPOpen = _k[0], setIsVerifyOTPOpen = _k[1];
    var _l = __read(useState(''), 2), warningMsg = _l[0], setWarningMsg = _l[1];
    var _m = __read(useState(false), 2), phoneVerified = _m[0], setPhoneVerified = _m[1];
    var _o = __read(useState(false), 2), isEditPopulated = _o[0], setEditPopulated = _o[1];
    var _p = useAddress$1(t), addNEditAddressWithArea = _p.addNEditAddressWithArea, citiesAndAreaState = _p.citiesAndAreaState, qatarCitiesAndAreaState = _p.qatarCitiesAndAreaState;
    var _q = __read(useState(), 2), city = _q[0], setCity = _q[1];
    var _r = __read(useState(), 2), zone = _r[0], setZone = _r[1];
    var _s = __read(useState(), 2), area = _s[0], setArea = _s[1];
    var _t = __read(useState([]), 2), areaList = _t[0], setAreaList = _t[1];
    var _u = __read(useState([]), 2), zoneList = _u[0], setZoneList = _u[1];
    var didRecordInteractionWithAreaField = useRef(false);
    var didRecordInteractionWithZoneField = useRef(false);
    var _v = __read(useAppConfig$1(), 1), _w = _v[0], _x = _w.areaCode, areaCode = _x === void 0 ? '' : _x, language = _w.language, countryName = _w.countryName;
    useFetchAreas$1(areaCode, language);
    var isQatarCountry = APP_CONFIG$1.storeId === EStoreID$1.MAFQAT;
    var isEngLanguage = language === 'en';
    var isBlockAddressFields = ((_b = useFeature('BLOCK_ADDRESS_FIELD')) === null || _b === void 0 ? void 0 : _b.on) || false;
    var updateInteractionFlags = useCallback(function () {
        didRecordInteractionWithAreaField.current = true;
    }, [didRecordInteractionWithAreaField]);
    var updateZoneInteractionFlags = useCallback(function () {
        didRecordInteractionWithZoneField.current = true;
    }, [didRecordInteractionWithZoneField]);
    var resetAreaField = useCallback(function (listArray) {
        if (listArray === void 0) { listArray = []; }
        setAreaList(listArray);
        setValue('area', '');
        setArea(undefined);
        clearErrors('area');
        didRecordInteractionWithAreaField.current = false;
    }, [clearErrors, setValue]);
    var resetZoneField = useCallback(function (listArray) {
        if (listArray === void 0) { listArray = []; }
        setZoneList(listArray);
        setValue('zone', '');
        setZone(undefined);
        clearErrors('zone');
        didRecordInteractionWithAreaField.current = false;
    }, [clearErrors, setValue]);
    var autocompleteCityValues = useMemo(function () {
        var _a;
        if (isQatarCountry) {
            return ((_a = qatarCitiesAndAreaState === null || qatarCitiesAndAreaState === void 0 ? void 0 : qatarCitiesAndAreaState.qatarCities) === null || _a === void 0 ? void 0 : _a.cities) ? qatarCitiesAndAreaState.qatarCities.cities.map(function (item) {
                return {
                    displayName: isEngLanguage ? item.cityNameEN : item.cityNameAR,
                    value: item,
                };
            })
                : [];
        }
        else {
            return citiesAndAreaState ? getCitiesValue$1(citiesAndAreaState) : [];
        }
    }, [citiesAndAreaState, isEngLanguage, isQatarCountry, qatarCitiesAndAreaState]);
    var getVariant = useCallback(function (key) {
        if (!didRecordInteractionWithAreaField.current &&
            key === 'area' &&
            (areaList.length === 0 || (getValues('area') || '').length === 0)) {
            return 'primary';
        }
        return errors[key] ? 'error' : formState.touched[key] ? 'success' : 'primary';
    }, [errors, formState, areaList.length, getValues]);
    var autocompleteAreaValues = useMemo(function () {
        if (isQatarCountry)
            return getQatarAreaValue$1(areaList, isEngLanguage);
        return getAreaValue$1(areaList);
    }, [areaList, isEngLanguage, isQatarCountry]);
    var autoCompleteZoneValues = useMemo(function () { return zoneList === null || zoneList === void 0 ? void 0 : zoneList.map(function (zone) {
        return { displayName: zone.zoneNo, value: zone };
    }); }, [zoneList]);
    var validateInput = function (fieldName) {
        setValue(fieldName, getValues(fieldName).replace(alphanumericCommaPeriodArabic$1, ''));
    };
    var onSuccess = useCallback(function (res) {
        onAddressSuccess && onAddressSuccess(res);
    }, [onAddressSuccess]);
    var onCitySelection = useCallback(function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var zones, restValue, areas, restValue;
        return __generator(this, function (_a) {
            if (isQatarCountry) {
                zones = value.zones, restValue = __rest(value, ["zones"]);
                setCity(restValue);
                resetZoneField(zones);
                resetAreaField([]);
                setValue('city', isEngLanguage ? restValue.cityNameEN : restValue.cityNameAR);
                trigger('city');
            }
            else {
                areas = value.areas, restValue = __rest(value, ["areas"]);
                setCity(restValue);
                resetAreaField(areas);
                setValue('city', restValue.name);
                trigger('city');
            }
            return [2 /*return*/];
        });
    }); }, [resetAreaField, resetZoneField, trigger, isEngLanguage, isQatarCountry, setValue]);
    var onAreaSelection = useCallback(function (value) {
        setArea(value);
        setValue('area', isQatarCountry ? (isEngLanguage ? value.areaNameEN : value.areaNameAR) : value.name);
        trigger('area');
    }, [trigger, isEngLanguage, isQatarCountry, setValue]);
    var onZoneSelection = useCallback(function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var areas, restValue;
        return __generator(this, function (_a) {
            areas = value.areas, restValue = __rest(value, ["areas"]);
            setZone(restValue);
            resetAreaField(areas);
            setValue('zone', value.zoneNo);
            trigger('zone');
            return [2 /*return*/];
        });
    }); }, [trigger, resetAreaField, setValue]);
    var onFormDataSave = function (formData, uuid) {
        var _a, _b;
        if (formData) {
            var ssoType = editInfo.ssoType, id = editInfo.id;
            var address = addressLabel === CustomLabel$1(t) ? formData.addressLabel : addressLabel;
            var qatarCityAreaData = isQatarCountry
                ? getSelectedDeliveryArea$1(citiesAndAreaState, area)
                : { city: city, area: area };
            var data = __assign(__assign({}, formData), { city: qatarCityAreaData.city, area: qatarCityAreaData.area, addressLabel: address, defaultAddress: isDefaultAddress, isSetSelectedAddress: isSetSelectedAddress, zone: zone, isQatarCountry: isQatarCountry,
                onSuccess: onSuccess });
            if (uuid) {
                data = __assign(__assign({}, data), { addressVerificationRefId: uuid });
            }
            if ((data === null || data === void 0 ? void 0 : data.area) && (data === null || data === void 0 ? void 0 : data.defaultAddress)) {
                setDeliveryArea$1((_a = data === null || data === void 0 ? void 0 : data.area) === null || _a === void 0 ? void 0 : _a.code);
                dispatch(setAreaCode$1((_b = data === null || data === void 0 ? void 0 : data.area) === null || _b === void 0 ? void 0 : _b.code));
                dispatch(fetchAreas$1());
            }
            var editInformation = void 0;
            if (id && ssoType) {
                editInformation = { id: id, ssoType: ssoType };
            }
            addNEditAddressWithArea(data, editInformation);
            setIsVerifyOTPOpen(false);
        }
    };
    var onFormSubmit = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isBlockAddressFields) {
                formData.building = formData.building + "|Block#" + formData.block;
            }
            formData.phone = formData.phone.replace(/^0/, '');
            if (!phoneVerified) {
                setFormData(formData);
                setIsVerifyOTPOpen(true);
            }
            else {
                onFormDataSave(formData, '');
            }
            return [2 /*return*/];
        });
    }); };
    var validatePhoneNumber = function () {
        var _a;
        var phoneRegex = new RegExp(phoneExpression);
        var phoneNumber = (_a = getValues('phone')) === null || _a === void 0 ? void 0 : _a.replace(/^0/, '');
        if (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.match(phoneRegex)) {
            isPhoneVerified(phoneCountryCode + phoneNumber, function (isPhoneVerified) {
                setPhoneVerified(isPhoneVerified);
            });
        }
        else {
            setPhoneVerified(false);
        }
    };
    useEffect(function () {
        if (phone || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone)) {
            validatePhoneNumber();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [phone, userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone]);
    var onChangeSwitchHandle = function () {
        var value = !isDefaultAddress;
        setIsDefaultAddress(value);
    };
    var onCloseOTPVerifyModal = function () {
        setIsVerifyOTPOpen(false);
        var warningMsg = phone
            ? t('verifyOTP.verifyYourMobileNumberToUpdateAddress')
            : t('verifyOTP.verifyYourMobileNumberToAddAddress');
        setWarningMsg(warningMsg);
    };
    useEffect(function () {
        if (region && !zone && !isEditPopulated) {
            var isAValidCityName = isQatarCountry
                ? isQatarCityAvailableInList(region.name)
                : isCityAvailableInList(region.name);
            if (isAValidCityName) {
                onCitySelection(isAValidCityName);
            }
        }
    }, [
        region,
        isQatarCountry,
        isEditPopulated,
        zone,
        onCitySelection,
        isCityAvailableInList,
        isQatarCityAvailableInList,
    ]);
    useEffect(function () {
        if (makani && zoneList && zoneList.length && !isEditPopulated) {
            setEditPopulated(true);
            var qatarZone = isQatarCountry && validateQatarZone(zoneList, makani);
            isQatarCountry && onZoneSelection(qatarZone);
        }
    }, [isEditPopulated, zoneList, makani, isQatarCountry, onZoneSelection, validateQatarZone]);
    useEffect(function () {
        if (deliveryArea && areaList && areaList.length) {
            var isAValidAreaName = isQatarCountry
                ? validateQatarArea(areaList, deliveryArea.name)
                : validateArea(areaList, deliveryArea.name);
            onAreaSelection(isAValidAreaName);
        }
    }, [areaList, deliveryArea, isQatarCountry, onAreaSelection, validateArea, validateQatarArea]);
    useEffect(function () {
        if (isQatarCountry) {
            fetchCitiesZonesAndAreasQatar();
        }
    }, [fetchCitiesZonesAndAreasQatar, isQatarCountry]);
    var notificationMessage = useMemo(function () {
        return (warningMsg || error) && React.createElement(Notification, { my: 2 }, warningMsg || (error && t('errorGeneral')));
    }, [error, warningMsg, t]);
    var isNumberKey = function (evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
            return false;
        }
        return true;
    };
    return (React.createElement(React.Fragment, null,
        isVerifyOTPOpen && (React.createElement(VerifyPassword$1, { isShowShopping: false, email: getUserEmailFromCookie$1(), phoneNumber: phoneCountryCode + (formData === null || formData === void 0 ? void 0 : formData.phone), onVerifyAccount: function (uuid) { return onFormDataSave(formData, uuid); }, onCloseModal: function () { return onCloseOTPVerifyModal(); }, action: "ADDRESS_PHONE_VERIFICATION" })),
        React.createElement(Flex, { flexDirection: "column", flex: 1, mt: 16, as: "form", onSubmit: handleSubmit(onFormSubmit), style: { display: isHidden ? 'none' : 'flex' }, "data-testid": "__non-location-cx-address__" },
            React.createElement(Box, null,
                notificationMessage,
                React.createElement(H3$2, null, t('address.addressInformation')),
                React.createElement(Autocomplete$1, { used: city, label: t('address.city'), values: autocompleteCityValues, defaultValue: region === null || region === void 0 ? void 0 : region.name, variant: getVariant('city'), onSelection: onCitySelection, register: register({
                        required: getErrorMsg$1(FormErrorTypes$1.required, t),
                        validate: isQatarCountry ? validateCityQatar : validateCity,
                    }), name: "city", successIcon: true, testid: "appartment-number-field", allowedRegExpChars: isRTL$1() ? undefined : 'alphanumericCommaPeriod', backgroundColor: COLORS$1.LIGHT_GREY }),
                errors.city && (React.createElement(Paragraph$7, { color: COLORS$1.RED, mt: 1, fontSize: TYPOGRAPHY$1.SIZE[10] }, errors.city.message)),
                React.createElement(Flex, null,
                    isQatarCountry && (React.createElement(LeftBox$1, { mr: 2 },
                        React.createElement(Autocomplete$1, { used: zone, label: t('address.zone'), onSelection: onZoneSelection, defaultValue: makani, values: autoCompleteZoneValues, successIcon: true, name: "zone", register: register({
                                required: getErrorMsg$1(FormErrorTypes$1.required, t),
                                validate: function (value) { return validateQatarZone(zoneList, value); },
                            }), disabled: autoCompleteZoneValues.length < 1, variant: getVariant('zone'), testid: "zone-field", onFocus: updateZoneInteractionFlags, allowedRegExpChars: isRTL$1() ? undefined : 'alphanumericCommaPeriod', backgroundColor: COLORS$1.LIGHT_GREY }),
                        errors.zone && (zoneList.length !== 0 || didRecordInteractionWithZoneField.current) && (React.createElement(Paragraph$7, { color: COLORS$1.RED, mt: 1, fontSize: TYPOGRAPHY$1.SIZE[10] }, errors.zone.message)))),
                    React.createElement(Box, { style: { width: isQatarCountry ? '63%' : '100%' } },
                        React.createElement(Autocomplete$1, { used: area, label: t('address.area'), onSelection: onAreaSelection, defaultValue: deliveryArea === null || deliveryArea === void 0 ? void 0 : deliveryArea.name, values: autocompleteAreaValues, successIcon: true, name: "area", register: register({
                                required: getErrorMsg$1(FormErrorTypes$1.required, t),
                                validate: function (value) {
                                    return isQatarCountry ? validateQatarArea(areaList, value) : validateArea(areaList, value);
                                },
                            }), disabled: autocompleteAreaValues.length < 1, variant: getVariant('area'), testid: "area-field", onFocus: updateInteractionFlags, allowedRegExpChars: isRTL$1() ? undefined : 'alphanumericCommaPeriod', backgroundColor: COLORS$1.LIGHT_GREY }),
                        errors.area && (areaList.length !== 0 || didRecordInteractionWithAreaField.current) && (React.createElement(Paragraph$7, { color: COLORS$1.RED, mt: 1, fontSize: TYPOGRAPHY$1.SIZE[10] }, errors.area.message)))),
                React.createElement(Flex, null,
                    React.createElement(LeftBox$1, { mr: 2 },
                        React.createElement(Input, { label: isQatarCountry ? t('address.street') : t('address.streetName'), successIcon: true, name: "streetName", defaultValue: streetName, register: register({
                                required: getErrorMsg$1(FormErrorTypes$1.required, t),
                                maxLength: {
                                    value: 255,
                                    message: getErrorMsg$1(FormErrorTypes$1.maxLength, t, 255),
                                },
                                pattern: {
                                    value: isQatarCountry ? numericExpression$1 : addressInputRegex$1,
                                    message: getErrorMsg$1(FormErrorTypes$1.pattern, t, (isQatarCountry ? t('address.street') : t('address.streetName')).toLowerCase()),
                                },
                            }), variant: getVariant('streetName'), "data-testid": "street-field", allowedRegExpChars: "alphanumericCommaPeriodArabic", autoComplete: "streetName", backgroundColor: COLORS$1.LIGHT_GREY, onChange: function () { return validateInput('streetName'); } }),
                        errors.streetName && (React.createElement(Paragraph$7, { color: COLORS$1.RED, mt: 1, fontSize: TYPOGRAPHY$1.SIZE[10] }, errors.streetName.message))),
                    React.createElement(RightBox$1, null,
                        React.createElement(Input, { label: isQatarCountry ? t('address.buildingOrCompound') : t('address.buildingName'), successIcon: true, name: "building", defaultValue: building, register: register({
                                required: getErrorMsg$1(FormErrorTypes$1.required, t),
                                maxLength: {
                                    value: 255,
                                    message: getErrorMsg$1(FormErrorTypes$1.maxLength, t, 255),
                                },
                                pattern: {
                                    value: isQatarCountry ? numericExpression$1 : addressInputRegex$1,
                                    message: getErrorMsg$1(FormErrorTypes$1.pattern, t, (isQatarCountry ? t('address.buildingOrCompound') : t('address.buildingName')).toLowerCase()),
                                },
                            }), variant: getVariant('building'), "data-testid": "building-field", autoComplete: "building", allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () { return validateInput('building'); }, backgroundColor: COLORS$1.LIGHT_GREY }),
                        errors.building && (React.createElement(Paragraph$7, { color: COLORS$1.RED, mt: 1, fontSize: TYPOGRAPHY$1.SIZE[10] }, errors.building.message)))),
                isBlockAddressFields && (React.createElement(React.Fragment, null,
                    React.createElement(Input, { label: t('address.block'), successIcon: true, name: "block", defaultValue: block, register: register({
                            required: getErrorMsg$1(FormErrorTypes$1.required, t),
                            min: 1,
                            pattern: {
                                value: numericExpression$1,
                                message: getErrorMsg$1(FormErrorTypes$1.pattern, t, t('address.block').toLowerCase()),
                            },
                            maxLength: {
                                value: 255,
                                message: getErrorMsg$1(FormErrorTypes$1.maxLength, t, 255),
                            },
                        }), variant: getVariant('block'), "data-testid": "block-number-field", onChange: function () { return validateInput('block'); }, autoComplete: "block", backgroundColor: COLORS$1.LIGHT_GREY, onKeyPress: function (ev) { return isNumberKey(ev); } }),
                    parseInt(getValues('block')) === 0 && (React.createElement(Paragraph$7, { color: COLORS$1.RED, mt: 1, fontSize: TYPOGRAPHY$1.SIZE[10] }, t('address.blockValueGreaterThanZero'))),
                    parseInt(getValues('block')) !== 0 && errors.block && (React.createElement(Paragraph$7, { color: COLORS$1.RED, mt: 1, fontSize: TYPOGRAPHY$1.SIZE[10] }, errors.block.message)))),
                React.createElement(Input, { label: t('address.apartment'), successIcon: true, name: "appartment", defaultValue: appartment, register: register({
                        required: getErrorMsg$1(FormErrorTypes$1.required, t),
                        maxLength: {
                            value: 255,
                            message: getErrorMsg$1(FormErrorTypes$1.maxLength, t, 255),
                        },
                        pattern: {
                            value: addressInputRegex$1,
                            message: getErrorMsg$1(FormErrorTypes$1.pattern, t, t('address.apartment').toLowerCase()),
                        },
                    }), variant: getVariant('appartment'), "data-testid": "appartment-number-field", allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () { return validateInput('appartment'); }, autoComplete: "appartment", backgroundColor: COLORS$1.LIGHT_GREY }),
                errors.appartment && (React.createElement(Paragraph$7, { color: COLORS$1.RED, mt: 1, fontSize: TYPOGRAPHY$1.SIZE[10] }, errors.appartment.message)),
                !isQatarCountry && (React.createElement(React.Fragment, null,
                    React.createElement(Input, { testid: 'landmark-field', defaultValue: landmark, label: t('address.landmarkOptional'), color: COLORS$1.BLUE, name: "landmark", variant: getVariant('landmark'), successIcon: true, allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () { return validateInput('landmark'); }, register: register({
                            maxLength: {
                                value: 255,
                                message: getErrorMsg$1(FormErrorTypes$1.maxLength, t, 255),
                            },
                            pattern: {
                                value: addressInputRegex$1,
                                message: getErrorMsg$1(FormErrorTypes$1.pattern, t, t('address.landmark').toLowerCase()),
                            },
                        }), backgroundColor: COLORS$1.LIGHT_GREY }),
                    React.createElement(Paragraph$7, { color: COLORS$1.SILVER_CHALICE, mt: 2, fontSize: TYPOGRAPHY$1.SIZE[10] }, t('address.lHint')),
                    errors.landmark && (React.createElement(Paragraph$7, { color: COLORS$1.RED, mt: 1, fontSize: TYPOGRAPHY$1.SIZE[10] }, errors.landmark.message)))),
                React.createElement(Input, { testid: 'delivery-instructions-field', defaultValue: deliveryInstructions, label: t('address.di'), color: COLORS$1.BLUE, name: "deliveryInstructions", allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () { return validateInput('deliveryInstructions'); }, variant: getVariant('deliveryInstructions'), register: register({}), backgroundColor: COLORS$1.LIGHT_GREY }),
                React.createElement(Paragraph$7, { color: COLORS$1.SILVER_CHALICE, mt: 2, fontSize: TYPOGRAPHY$1.SIZE[10] }, t('address.diHint'))),
            React.createElement(AddressLabel$4, { setAddressLabel: setAddressLabel, register: register, errors: errors, defaultAddressLabel: defaultAddressLabel, backgroundColor: COLORS$1.LIGHT_GREY, addressLabels: function (t) { return [t('address.home'), t('address.office')]; }, isShowCustomField: false }),
            React.createElement(Box, { mt: 16 },
                React.createElement(H3$2, null, t('address.receiverInformation')),
                React.createElement(Input, { testid: 'receiver-name-field', defaultValue: firstName || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.fullName), label: t('address.receiverName'), color: COLORS$1.BLUE, name: "fullName", successIcon: true, variant: getVariant('fullName'), allowedRegExpChars: "alphanumericCommaPeriodArabic", onChange: function () { return validateInput('fullName'); }, register: register({
                        required: getErrorMsg$1(FormErrorTypes$1.required, t),
                        maxLength: {
                            value: 255,
                            message: getErrorMsg$1(FormErrorTypes$1.maxLength, t, 255),
                        },
                        pattern: {
                            value: nonSpaceAlphabetsOnlyRegEx$1,
                            message: getErrorMsg$1(FormErrorTypes$1.pattern, t, t('address.name')),
                        },
                    }), backgroundColor: COLORS$1.LIGHT_GREY }),
                errors.fullName && (React.createElement(Paragraph$7, { color: COLORS$1.RED, mt: 1, fontSize: TYPOGRAPHY$1.SIZE[10] }, errors.fullName.message)),
                React.createElement(Flex, { justifyContent: "space-between" },
                    React.createElement(Flex, { width: "25%" },
                        React.createElement(Flex, { alignSelf: "flex-end" }, countryName && getIcon$3(countryName)),
                        React.createElement(Input, { testid: "country-code-field", label: phoneCountryCode, disabled: true, backgroundColor: COLORS$1.LIGHT_GREY })),
                    React.createElement(Box, { width: "75%" },
                        React.createElement(Input, { testid: 'phone-number-field', defaultValue: phoneNumberShaper(phone || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone)), label: t('address.mobileNumber'), name: "phone", variant: getVariant('phone'), successIcon: true, onChange: validatePhoneNumber, allowedRegExpChars: "alphanumericCommaPeriod", autoComplete: "tel", color: COLORS$1.BLUE, register: register({
                                required: getErrorMsg$1(FormErrorTypes$1.required, t),
                                pattern: {
                                    value: new RegExp(phoneExpression),
                                    message: getErrorMsg$1(FormErrorTypes$1.pattern, t, t('address.mobileNumber').toLowerCase()),
                                },
                            }), icon: phoneVerified ? React.createElement(Verified$1, null, t('address.verified')) : React.createElement(Verify$1, null, t('address.verify')), backgroundColor: COLORS$1.LIGHT_GREY }))),
                errors.phone && (React.createElement(Paragraph$7, { color: COLORS$1.RED, mt: 1, fontSize: TYPOGRAPHY$1.SIZE[10] }, errors.phone.message))),
            React.createElement(Box, { mt: 16 },
                (addressList === null || addressList === void 0 ? void 0 : addressList.length) && !defaultAddress ? (React.createElement(Flex, { justifyContent: "space-between", mt: 14, alignItems: "center", style: { position: 'relative' } },
                    React.createElement(Text, null, t('address.setAsDefault')),
                    React.createElement(Switch, { checked: isDefaultAddress, onChange: onChangeSwitchHandle, disabled: defaultAddress }))) : (''),
                React.createElement(Flex, { my: 20 },
                    React.createElement(Button$1, { flex: 1, type: "submit", testid: "address-submit-button" }, editInfo.id ? t('address.updateAddress') : t('address.addAddress')))))));
};
var AddAddressFormWithArea$3 = withTranslation()(AddAddressFormWithArea$2);

var SearchBox$2 = function () {
    var _a = __read(useState(false), 2), error = _a[0], setError = _a[1];
    var _b = __read(useState(false), 2), showCloseIcon = _b[0], setShowCloseIcon = _b[1];
    var inputRef = useRef();
    var t = useTranslation().t;
    var clearSearch = function () {
        inputRef.current.value = '';
        setShowCloseIcon(false);
    };
    var onChangeInput = function () {
        setShowCloseIcon(true);
        if (inputRef.current.value === '') {
            setShowCloseIcon(false);
        }
        setTimeout(function () {
            var pacItem = document.getElementsByClassName('pac-item');
            if (pacItem.length === 0) {
                setError(true);
            }
            else {
                setError(false);
            }
        }, 500);
    };
    var searchText = {
        mafuae: ["" + t('address.searchMessage')],
        mafqat: ["" + t('address.qatarSearchMessage')],
        mafkwt: ["" + t('address.kuwaitSearchMessage')],
    };
    return (React.createElement(Box, { width: "100%", style: {
            position: 'absolute',
            zIndex: '2',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingTop: '12px',
            alignItems: 'center',
        } },
        React.createElement(SearchMessage$1, null,
            React.createElement(SearchLabel$1, null, searchText[APP_CONFIG$1.storeId])),
        React.createElement(SearchWrapper$1, null,
            React.createElement(SearchInputBox$1, { error: error, ref: inputRef, type: "text", placeholder: t('address.searchPlaceholder'), id: "pac-input-add-address", onChange: onChangeInput }),
            React.createElement(SearchIconContainer$1, null,
                React.createElement(Search$2, { size: "S", fill: COLORS$1.GRAY_500 })),
            showCloseIcon && (React.createElement(ClearSearchContainer$1, { onClick: function () { return clearSearch(); } },
                React.createElement(CancelDark, { size: "S", fill: COLORS$1.GRAY_900 })))),
        error && (React.createElement(SearchErrorMessage$1, null,
            React.createElement(WarningOctagon, { size: "M", width: "22px", height: "22px", fill: "#F34041" }),
            React.createElement(SearchErrorLabel$1, null, t('address.searchErrorMessage'))))));
};

var getLocation$1 = function (defaultLat, defaultLng) { return __awaiter(void 0, void 0, void 0, function () {
    var resolve, onSuccess, onError, options;
    return __generator(this, function (_a) {
        onSuccess = function (pos) {
            var crd = pos.coords;
            resolve({ lat: crd.latitude, lng: crd.longitude });
        };
        onError = function () {
            resolve({ lat: Number(defaultLat), lng: Number(defaultLng), isDefaultLocation: true });
        };
        if (window.navigator.geolocation) {
            options = { enableHighAccuracy: true, timeout: 10000 };
            window.navigator.geolocation.getCurrentPosition(onSuccess, onError, options);
            return [2 /*return*/, new Promise(function (res) {
                    resolve = res;
                })];
        }
        return [2 /*return*/];
    });
}); };
// Get lat long using address
var getLatLong$1 = function (editInfo) { return __awaiter(void 0, void 0, void 0, function () {
    var latLong, searchAddress, response, _a, lat, lng;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                latLong = null;
                if (!process.env.REACT_APP_GOOGLE_MAP_API_KEY) return [3 /*break*/, 2];
                Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAP_API_KEY);
                searchAddress = (editInfo === null || editInfo === void 0 ? void 0 : editInfo.deliveryArea) ? editInfo.line1 + " " + editInfo.town + " " + ((_b = editInfo === null || editInfo === void 0 ? void 0 : editInfo.region) === null || _b === void 0 ? void 0 : _b.name)
                    : editInfo === null || editInfo === void 0 ? void 0 : editInfo.town;
                return [4 /*yield*/, Geocode.fromAddress(searchAddress).catch(function () {
                        latLong = null;
                    })];
            case 1:
                response = _c.sent();
                if ((response === null || response === void 0 ? void 0 : response.results) && response.results[0]) {
                    _a = response.results[0].geometry.location, lat = _a.lat, lng = _a.lng;
                    latLong = { lat: lat, lng: lng };
                }
                _c.label = 2;
            case 2: return [2 /*return*/, latLong];
        }
    });
}); };
var useGetLocation$1 = function () {
    var _a = __read(useState(), 2), location = _a[0], setLocation = _a[1];
    var dispatch = useDispatch();
    var countryConfig = useSelector(function (state) { return state.userData.countryConfig; }) || {};
    var appConfig = useSelector(function (state) { return state.appConfig; }) || {};
    useEffect(function () {
        var _a;
        fetchUserCountryConfig$1()(dispatch);
        if (!((_a = appConfig.features) === null || _a === void 0 ? void 0 : _a.isLocationCXEnable)) {
            fetchUserDeliveryAreas$1()(dispatch);
        }
    }, [dispatch, appConfig.features]);
    var fetchLocation = useCallback(function (editInfo, isSetDefaultCountryLocation, isSelectedLatLong) {
        if (isSetDefaultCountryLocation === void 0) { isSetDefaultCountryLocation = false; }
        if (isSelectedLatLong === void 0) { isSelectedLatLong = true; }
        return __awaiter(void 0, void 0, void 0, function () {
            var latitude, longitude, latLngFromAddress, res, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        latitude = Number(appConfig.latitude);
                        longitude = Number(appConfig.longitude);
                        if (!(editInfo && editInfo !== true)) return [3 /*break*/, 4];
                        if (!(isNaN(editInfo.latitude) || isNaN(editInfo.longitude))) return [3 /*break*/, 2];
                        return [4 /*yield*/, getLatLong$1(editInfo)];
                    case 1:
                        latLngFromAddress = _a.sent();
                        if (latLngFromAddress) {
                            setLocation({ lat: latLngFromAddress.lat, lng: latLngFromAddress.lng });
                        }
                        else {
                            setLocation({ lat: latitude, lng: longitude });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        setLocation({ lat: Number(editInfo.latitude), lng: Number(editInfo.longitude) });
                        _a.label = 3;
                    case 3: return [3 /*break*/, 10];
                    case 4:
                        _a.trys.push([4, 9, , 10]);
                        if (!(latitude && longitude)) return [3 /*break*/, 8];
                        res = {
                            lat: latitude,
                            lng: longitude,
                            isDefaultLocation: true,
                        };
                        if (!(isSelectedLatLong && latitude && longitude)) return [3 /*break*/, 5];
                        res = {
                            lat: latitude,
                            lng: longitude,
                            isDefaultLocation: false,
                        };
                        return [3 /*break*/, 7];
                    case 5:
                        if (!!isSetDefaultCountryLocation) return [3 /*break*/, 7];
                        return [4 /*yield*/, getLocation$1(latitude, longitude)];
                    case 6:
                        res = (_a.sent());
                        _a.label = 7;
                    case 7:
                        setLocation(res);
                        _a.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    }, [appConfig]);
    return [location, fetchLocation, countryConfig, appConfig];
};

var CurrentlySelected$2 = function (_a) {
    var _b = _a.mt, mt = _b === void 0 ? 12 : _b, t = _a.t, isVisible = _a.isVisible, addressInfo = _a.addressInfo, isAreaNotSupported = _a.isAreaNotSupported, formattedGoogleAddressDescription = _a.formattedGoogleAddressDescription, emirate = _a.emirate;
    var countryConfiguration = useSelector(function (state) { return state.appConfig; }).countryConfiguration;
    var _c = countryConfiguration || {}, countryNameEn = _c.countryNameEn, countryNameAr = _c.countryNameAr;
    return (React.createElement(Flex, { p: 12, mt: mt, style: { display: isVisible ? 'flex' : 'none', flexDirection: 'column' } },
        React.createElement(CurrentlySelectedLabel$1, null, t('address.currentlySelected')),
        React.createElement(OutofServiceLabel$1, null, isAreaNotSupported
            ? t('address.notServiceable')
            : formattedGoogleAddressDescription(addressInfo, emirate, countryNameEn || countryNameAr))));
};
var CurrentlySelected$3 = withTranslation()(CurrentlySelected$2);

var useCheckAreaIfSupported$1 = function () {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return state.userData.addresses; }), coverageArea = _a.coverageArea, showLoader = _a.showLoader;
    var _b = __read(useState({}), 2), updatedLocation = _b[0], setUpdatedLocation = _b[1];
    var checkCoverageArea = useCallback(function (_a) {
        var lat = _a.lat, lng = _a.lng;
        // api call will not be made for same location
        if (lat === updatedLocation.lat && lng === updatedLocation.lng) {
            return;
        }
        checkUserCoverageAreaSupport$1(String(lat), String(lng))(dispatch);
        setUpdatedLocation({ lat: lat, lng: lng });
    }, [dispatch, updatedLocation.lat, updatedLocation.lng]);
    return [checkCoverageArea, coverageArea, updatedLocation, showLoader];
};

var LOGIN_PAGE$2 = '/login';

var LoginLink$1 = function (_a) {
    var loginRedirection = _a.loginRedirection;
    var t = useTranslation().t;
    var url = LOGIN_PAGE$2;
    if (!!loginRedirection) {
        url = addRedirection$1(url, loginRedirection);
    }
    return (React.createElement(Flex, { my: 16, justifyContent: "center", as: "nav" },
        React.createElement(LoginLinkText$1, { as: "a", href: url, isLink: true }, t('address.loginSignup')),
        React.createElement(LoginLinkText$1, null,
            "\u00A0",
            t('address.loginSignupInfo'))));
};
var MobileAddressForm$1 = function (props) {
    var closeAddressFormDrawer = props.closeAddressFormDrawer, setShowMobileAddressForm = props.setShowMobileAddressForm, setShowAddressForm = props.setShowAddressForm, emirate = props.emirate, showAddressForm = props.showAddressForm, updatedLocation = props.updatedLocation, addressInfo = props.addressInfo, building = props.building, setFlatNo = props.setFlatNo, setBuildingName = props.setBuildingName, setLandmark = props.setLandmark, onSuccess = props.onSuccess, countryConfig = props.countryConfig, editInfo = props.editInfo, town = props.town, country = props.country, userProfile = props.userProfile, isSetSelectedAddress = props.isSetSelectedAddress, block = props.block, isStreeNameChange = props.isStreeNameChange, setIsStreetNameChange = props.setIsStreetNameChange, isCityAreaNameChange = props.isCityAreaNameChange, setIsCityAreaNameChange = props.setIsCityAreaNameChange, showMobileAddressForm = props.showMobileAddressForm, onSelectedLocationChange = props.onSelectedLocationChange;
    return (React.createElement(Box, { flex: 1 },
        React.createElement(AddAddressForm$3, { showAddressForm: showAddressForm, onSelectedLocationChange: onSelectedLocationChange, showMobileAddressForm: showMobileAddressForm, closeAddressFormDrawer: closeAddressFormDrawer, setShowMobileAddressForm: setShowMobileAddressForm, setShowAddressForm: setShowAddressForm, emirate: emirate, editInfo: editInfo, setFlatNo: setFlatNo, setBuildingName: setBuildingName, setLandmark: setLandmark, onAddressSuccess: onSuccess, countryConfig: countryConfig, updatedLocation: updatedLocation, addressInfo: addressInfo, town: town, country: country, userProfile: userProfile, isSetSelectedAddress: isSetSelectedAddress, block: block, building: building, isStreeNameChange: isStreeNameChange, setIsStreetNameChange: setIsStreetNameChange, isCityAreaNameChange: isCityAreaNameChange, setIsCityAreaNameChange: setIsCityAreaNameChange })));
};
var AddAddress$3 = function (props) {
    var isOpen = props.isOpen, isShowCloseButton = props.isShowCloseButton, isGoogleMapVisible = props.isGoogleMapVisible, onClose = props.onClose, onBack = props.onBack, 
    // width,
    onSuccess = props.onSuccess, loginRedirection = props.loginRedirection, 
    // onLocationConfirmation,
    editInfo = props.editInfo, isSetSelectedAddress = props.isSetSelectedAddress;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _a = __read(useGetLocation$1(), 4), location = _a[0], fetchLocation = _a[1], _b = _a[2], countryConfig = _b === void 0 ? {} : _b, appConfig = _a[3];
    var _c = __read(useCheckAreaIfSupported$1(), 3), checkCoverageArea = _c[0], coverageArea = _c[1], updatedLocation = _c[2];
    var _d = __read(useState(editInfo ? editInfo.appartment : ''), 2), flatNo = _d[0], setFlatNo = _d[1];
    var _e = __read(useState(editInfo ? editInfo.building : ''), 2), building = _e[0], setBuildingName = _e[1];
    var _f = __read(useState(editInfo ? editInfo.landmark : ''), 2), landmark = _f[0], setLandmark = _f[1];
    var _g = __read(useState(''), 2), addressInfo = _g[0], setAddressInfo = _g[1];
    var _h = __read(useState(''), 2), town = _h[0], setTown = _h[1];
    var _j = __read(useState(''), 2), country = _j[0], setCountry = _j[1];
    var _k = __read(useState(''), 2), emirate = _k[0], setEmirate = _k[1];
    var _l = __read(useState(false), 2), isSelected = _l[0], setIsSelected = _l[1];
    var _m = __read(useState(''), 2), block = _m[0], setBlock = _m[1];
    var _o = __read(useState(17), 2), zoom = _o[0], setZoom = _o[1];
    var _p = __read(useState(false), 2), isStreeNameChange = _p[0], setIsStreetNameChange = _p[1];
    var _q = __read(useState(false), 2), isCityAreaNameChange = _q[0], setIsCityAreaNameChange = _q[1];
    var device = useBreakpoints();
    var userProfile = useAddress$1(t).userProfile;
    var _r = __read(useState(false), 2), isCoordsChanged = _r[0], setIsCoordsChanged = _r[1];
    var _s = __read(useState(false), 2), showSearchRequiredError = _s[0], setShowSearchRequiredError = _s[1];
    // This need to keep as commented if any case of check phone number scenario will fail then will have to enable it.
    //useGetUserAddress();
    var isBlockAddressField = useFeature('block_address_field').on;
    useEffect(function () {
        if (editInfo && editInfo.building) {
            var block_1 = editInfo.building.split('|Block#');
            if (isBlockAddressField && block_1.length > 1) {
                setBlock(block_1[1]);
                setBuildingName(block_1[0]);
            }
        }
    }, [editInfo, countryConfig, isBlockAddressField]);
    useEffect(function () {
        if (!location && isOpen && isGoogleMapVisible) {
            fetchLocation(editInfo);
        }
    }, [fetchLocation, isOpen, location, editInfo, isGoogleMapVisible]);
    var isMobile = device.isMobile;
    var isLoggedIn = !!getUserTokenFromCookie$1();
    var extraProps = {};
    if (isMobile) {
        extraProps.style = { height: '100%', borderRadius: '24px 24px 0px 0px' };
    }
    var _t = __read(useState(false), 2), showMobileAddressForm = _t[0], setShowMobileAddressForm = _t[1];
    var _u = __read(useState(true), 2), showMapDrawer = _u[0], setShowMapDrawer = _u[1];
    var onBackToMap = function () {
        setShowMobileAddressForm(false);
    };
    var isAreaNotSupported = location && !(coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isChecking) && !(coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isSupported);
    var _v = __read(useState(false), 2), showAddressForm = _v[0], setShowAddressForm = _v[1];
    useEffect(function () {
        if (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id) {
            setShowAddressForm(true);
        }
    }, [editInfo]);
    var closeDrawer = function (e) {
        if (isGoogleMapVisible) {
            var pacContainer = document.getElementsByClassName('pac-container');
            // to avoid close on place selection from google autocomplete
            if (pacContainer && !pacContainer[pacContainer.length - 1].contains(e.target)) {
                onClose && onClose();
            }
        }
        else {
            onClose && onClose();
        }
    };
    var headerTitle = function () {
        var headerTitle = '';
        if (!isGoogleMapVisible || !isMobile) {
            headerTitle = editInfo && editInfo.id ? t('address.existingAddress') : t('address.addDeliveryLocation');
        }
        else {
            if (isMobile && showMobileAddressForm) {
                headerTitle = editInfo && editInfo.id ? t('address.existingAddress') : t('address.addDeliveryLocation');
            }
            else if (isMobile && !showMobileAddressForm) {
                headerTitle = t('address.chooseLocation');
            }
        }
        return headerTitle;
    };
    useEffect(function () {
        dispatch(userSetAddressesError$1(false));
    }, [dispatch]);
    useEffect(function () {
        if ((location === null || location === void 0 ? void 0 : location.lat) !== updatedLocation.lat && (location === null || location === void 0 ? void 0 : location.lng) !== updatedLocation.lng && !isCoordsChanged) {
            setIsCoordsChanged(true);
            setShowSearchRequiredError(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updatedLocation]);
    // TODO support drawer stack - Faheem Ahamd
    var onDeliverToLocation = function () {
        if (isMobile) {
            setShowMobileAddressForm(true);
        }
        else {
            setShowAddressForm(true);
        }
    };
    var backToAddressList = function () {
        onBack && onBack();
    };
    var closeAddressFormDrawer = function () {
        setShowMobileAddressForm(false);
        setShowAddressForm(false);
        setShowMapDrawer(false);
        onClose && onClose();
    };
    var onSelectedLocationChange = function () {
        if (isMobile) {
            setShowMobileAddressForm(false);
        }
        setShowAddressForm(false);
        setShowMapDrawer(true);
    };
    return (React.createElement(React.Fragment, null,
        !showAddressForm && showMapDrawer && (React.createElement(Drawer, __assign({ variant: "float", isOpen: isOpen && (userProfile === null || userProfile === void 0 ? void 0 : userProfile.fullName), width: ['100%', '400px', '500px'], anchor: ['bottom', null, 'right'], contentStyles: { p: [0], height: '100%', display: 'flex', flexDirection: 'column', fontFamily: 'Montserrat' }, "data-testid": "map-drawer" }, extraProps),
            React.createElement(DrawerHeader$4, { "data-testid": "drawer-header" },
                React.createElement(Flex, { alignItems: "center", justifyContent: "space-between" },
                    isMobile && showMobileAddressForm && (React.createElement(DrawerIconContainer$1, { "data-testid": "back-icon", onClick: onBackToMap },
                        React.createElement(ArrowLeft, { size: "M" }))),
                    React.createElement(HeaderTitle$2, { flex: 1 }, headerTitle()),
                    (!isMobile || !showMobileAddressForm) && isShowCloseButton && (React.createElement(DrawerIconContainer$1, { onClick: closeDrawer, variant: "naked" },
                        React.createElement(DrawerCloseIcon, null))))),
            !isGoogleMapVisible && isLoggedIn && (React.createElement(GoogleMapBox$1, { "data-sl": "mask" },
                React.createElement(MapContainer$1, { flexDirection: "column", height: isMobile ? '100%' : 'auto', open: !isMobile || !showMobileAddressForm, "data-testid": "non-location-cx-address" },
                    React.createElement(Flex, { style: {
                            position: 'relative',
                            height: isMobile ? 'inherit' : 400,
                            minHeight: isMobile ? 'inherit' : 400,
                        }, flexDirection: "column" },
                        React.createElement(AddAddressFormWithArea$3, { editInfo: editInfo, onAddressSuccess: onSuccess, countryConfig: countryConfig, updatedLocation: updatedLocation, addressInfo: addressInfo, town: town, userProfile: userProfile, isSetSelectedAddress: isSetSelectedAddress, block: block, building: building }))))),
            location
                ? isGoogleMapVisible && (React.createElement(GoogleMapBox$1, { "data-sl": "mask" },
                    React.createElement(MapContainer$1, { flexDirection: "column", height: isMobile ? '100%' : 'auto', open: !isMobile || !showMobileAddressForm },
                        React.createElement(Flex, { style: {
                                position: 'relative',
                                height: isMobile ? 'inherit' : 992,
                                minHeight: isMobile ? 'inherit' : 400,
                            }, flexDirection: "column" }, !!location && (React.createElement(React.Fragment, null,
                            React.createElement(SearchBox$2, null),
                            !isSelected && (React.createElement(MapOverlayWapper$1, null,
                                React.createElement(MapOverlay, null))),
                            showSearchRequiredError && (React.createElement(LocationSearchError$1, null, t('address.selectLocationRequired'))),
                            React.createElement(GoogleMapFlex$1, { isMobile: true, flexDirection: "column", "data-testid": "google-map-wrapper" },
                                React.createElement(GoogleMap$1, { isAreaNotSupported: isAreaNotSupported, editInfo: editInfo, isMobile: isMobile, location: location, style: { width: '100%' }, fetchMapCoordinates: fetchLocation, fetchLocation: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, fetchLocation(false, false, false)];
                                            case 1: return [2 /*return*/, _a.sent()];
                                        }
                                    }); }); }, flatNo: flatNo, building: building, landmark: landmark, isDefaultLocation: location.isDefaultLocation, checkCoverageArea: checkCoverageArea, countryConfig: countryConfig, setAddressInfo: setAddressInfo, setTown: setTown, setCountry: setCountry, setEmirate: setEmirate, isSelected: isSelected, setIsSelected: setIsSelected, addressInfo: addressInfo, appConfig: appConfig, setZoom: setZoom, hideFlatNo: isAreaNotSupported || (coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isChecking) }),
                                (isSelected || (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id)) && (React.createElement(MarkerBox$1, null,
                                    React.createElement(PonPin, { size: 'L', fill: "#F45C5D" }))),
                                (coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isChecking) && React.createElement(LinearProgress, { position: "bottom" })),
                            React.createElement(Flex, { flexDirection: "column" },
                                React.createElement(CurrentlySelected$3, { emirate: emirate, formattedGoogleAddressDescription: formattedGoogleAddressDescription$1, isVisible: isSelected || isAreaNotSupported || (editInfo === null || editInfo === void 0 ? void 0 : editInfo.id), addressInfo: addressInfo, isAreaNotSupported: isAreaNotSupported }))))),
                        React.createElement(Flex, { flexDirection: "column", style: {
                                boxShadow: isCoordsChanged ? 'none' : '0px 4px 15px rgba(0, 0, 0, 0.15)',
                                width: '108%',
                                height: '80px',
                                marginLeft: '-15px',
                                marginTop: '2px',
                            } },
                            React.createElement(ButtonWrapper$4, null,
                                React.createElement(Back$1, { onClick: backToAddressList, variant: "link" }, t('back')),
                                React.createElement(DeliverTo$1, { width: "303px", onClick: onDeliverToLocation, variant: "custom", preventTextTransform: true, disabledNewUI: !isSelected || isAreaNotSupported }, t('address.deliverToLocation')))),
                        !isLoggedIn && React.createElement(LoginLink$1, { loginRedirection: loginRedirection }))))
                : isGoogleMapVisible && React.createElement(BackDrop$1, null))),
        React.createElement(Flex, { "data-testid": "non-location-cx-address" },
            !isMobile && (React.createElement(React.Fragment, null,
                React.createElement(AddAddressForm$3, { closeAddressFormDrawer: closeAddressFormDrawer, showAddressForm: showAddressForm, setShowAddressForm: setShowAddressForm, onSelectedLocationChange: onSelectedLocationChange, 
                    // isHidden={isAreaNotSupported || coverageArea?.isChecking}
                    editInfo: editInfo, setFlatNo: setFlatNo, setBuildingName: setBuildingName, setLandmark: setLandmark, onAddressSuccess: onSuccess, countryConfig: countryConfig, updatedLocation: updatedLocation, addressInfo: addressInfo, town: town, country: country, emirate: emirate, userProfile: userProfile, isSetSelectedAddress: isSetSelectedAddress, block: block, building: building, isStreeNameChange: isStreeNameChange, setIsStreetNameChange: setIsStreetNameChange, isCityAreaNameChange: isCityAreaNameChange, setIsCityAreaNameChange: setIsCityAreaNameChange, setShowSearchRequiredError: setShowSearchRequiredError, isCoordsChanged: isCoordsChanged }))),
            React.createElement(React.Fragment, null,
                React.createElement(FormContainer$3, { open: isMobile && showMobileAddressForm },
                    React.createElement(MobileAddressForm$1, { closeAddressFormDrawer: closeAddressFormDrawer, onSelectedLocationChange: onSelectedLocationChange, emirate: emirate, showMobileAddressForm: showMobileAddressForm, editInfo: editInfo, onBackToMap: onBackToMap, updatedLocation: updatedLocation, flatNo: flatNo, addressInfo: addressInfo, town: town, country: country, building: building, landmark: landmark, setFlatNo: setFlatNo, setBuildingName: setBuildingName, setLandmark: setLandmark, onSuccess: onSuccess, countryConfig: countryConfig, zoom: zoom, userProfile: userProfile, isSetSelectedAddress: isSetSelectedAddress, block: block, isStreeNameChange: isStreeNameChange, setIsStreetNameChange: setIsStreetNameChange, isCityAreaNameChange: isCityAreaNameChange, setIsCityAreaNameChange: setIsCityAreaNameChange }))))));
};
AddAddress$3.defaultProps = {
    width: '480px',
    isOpen: true,
    isAddFormVisible: true,
    isShowCloseButton: true,
    isGoogleMapVisible: false,
    isSetSelectedAddress: true,
};

var useGetUserAddress$1 = function () {
    var userData = useSelector(function (state) { return state.userData; });
    var countryConfig = userData.countryConfig || {};
    var _a = userData.addresses, error = _a.error, isAddressLoading = _a.isLoading, list = _a.list;
    var selectedAddress = userData.selectedAddress;
    var dispatch = useDispatch();
    var setSelectedAddress = useCallback(function (address) {
        dispatch(userSetSelectedAddress$1(address));
    }, [dispatch]);
    useEffect(function () {
        /* this call will be removed from here after ensuring country config in redux and storage after successful login */
        if (countryConfig.phoneCountryCode) {
            dispatch(fetchUserAddresses$1());
        }
        else {
            fetchUserCountryConfig$1()(dispatch);
        }
    }, [dispatch, countryConfig.phoneCountryCode]);
    var isLoading = isAddressLoading || countryConfig.isLoading;
    return [error, isLoading, list, selectedAddress, setSelectedAddress, countryConfig.phoneCountryCode];
};

var AddressAppartment$1 = function (_a) {
    var appartment = _a.appartment;
    return React.createElement(React.Fragment, null, getFloorFlat$1(appartment, FLOOR_KEY$1, FLAT_KEY$1));
};

var H3$3 = Text.H3;
var AddressCard$1 = function (_a) {
    var data = _a.data, onAddressSelection = _a.onAddressSelection, selectedId = _a.selectedId, index = _a.index, phoneCountryCode = _a.phoneCountryCode, testId = _a.testId;
    var t = useTranslation().t;
    var isMobile = useBreakpoints().isMobile;
    var fullName = data.firstName + (data.lastName ? ' ' + data.lastName : '');
    var isSelected = data.id === selectedId;
    var isInternationalPhoneNumberEnabled = useFeature('international_number_support').on;
    return (React.createElement(AddressCardContainer$1, { "data-testid": testId, "data-sl": "mask", selected: isSelected, onClick: onAddressSelection(data), minWidth: ['80%', '80%', '100%'], width: '100%', ml: isMobile ? index && 3 : 0 },
        React.createElement(Flex, null,
            React.createElement(AddressLabel$5, null,
                data.addressLabel || t('address.noLabel'),
                " ", "" + (data.defaultAddress ? "(" + t('address.default') + ")" : '')),
            React.createElement(Flex, { justifyContent: "flex-end", alignItems: "center", flex: 1 },
                React.createElement(TickBox$1, { selected: isSelected }, isSelected && React.createElement(Check, { size: "CUSTOM", fill: "#0059AD", height: 10, width: 12 })))),
        React.createElement(Box, { mt: 2, lineHeight: 1.2 },
            React.createElement(Box, null, fullName),
            React.createElement(Box, null,
                isInternationalPhoneNumberEnabled ? '' : phoneCountryCode,
                " ",
                data.phone),
            React.createElement(Box, null,
                data.appartment ? React.createElement(AddressAppartment$1, { appartment: data.appartment }) : '',
                ' ',
                data.building ? data.building + "," : '',
                " ",
                decodeStr$1(data.streetName) || ''),
            React.createElement(Box, null,
                data.landmark ? data.landmark + "," : '',
                " ", "" + (decodeStr$1(data.town) || '')))));
};
AddressCard$1.defaultProps = {
    testId: 'address-list-card',
};
var DrawerHeader$5 = function (_a) {
    var onHeaderActionPress = _a.onHeaderActionPress, testId = _a.testId;
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, null, t('address.selectAddress')),
        React.createElement(HeaderAction$1, { as: "a", onClick: onHeaderActionPress, "data-testid": testId, id: "add _address_popup" }, t('address.addNewAddress'))));
};
DrawerHeader$5.defaultProps = {
    testId: 'add-new-address-action',
};
var AddressList$7 = function (props) {
    var isOpen = props.isOpen, onClose = props.onClose, _a = props.width, width = _a === void 0 ? 480 : _a, onHeaderActionPress = props.onHeaderActionPress, onSelection = props.onSelection, onDataChange = props.onDataChange, headerActionTestId = props.headerActionTestId, cardTestId = props.cardTestId;
    var _b = __read(useGetUserAddress$1(), 6), error = _b[0], isLoading = _b[1], list = _b[2], selectedAddress = _b[3], setSelectedAddress = _b[4], phoneCountryCode = _b[5];
    var _c = __read(useState([]), 2), addressList = _c[0], setAddressList = _c[1];
    var t = useTranslation().t;
    var selectedId = selectedAddress ? selectedAddress.id : '';
    useEffect(function () {
        if (list && isNonEmptyArray$1(list) && list.length !== addressList.length) {
            setAddressList(rearrangeAddressList$1(list, selectedAddress));
        }
    }, [addressList, list, onDataChange, selectedAddress]);
    onDataChange && onDataChange(addressList);
    var dispatch = useDispatch();
    var onAddressSelection = useCallback(function (selectedAddress) { return function () {
        if (!isNaN(Number(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.latitude)) && !isNaN(Number(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.longitude))) {
            setSelectedAddress(selectedAddress);
            setSelectedAddressID$1(selectedAddress.id);
            setSelectedAddressIDCookie$1(selectedAddress.id);
            setAddressList(rearrangeAddressList$1(list, selectedAddress));
            dispatch(init$1({
                changingLocation: true,
            }));
        }
        onSelection && onSelection(selectedAddress);
    }; }, [list, onSelection, setSelectedAddress, dispatch]);
    return (React.createElement(Drawer, { isOpen: isOpen, onClose: onClose, width: [null, null, width], anchor: ['bottom', null, 'right'], title: React.createElement(DrawerHeader$5, { onHeaderActionPress: onHeaderActionPress, testId: headerActionTestId }), showLoader: Boolean(isLoading) },
        error && React.createElement(Notification, { my: 2 }, error),
        React.createElement(Box, null,
            React.createElement(H3$3, null,
                t('address.existingAddress'),
                " (",
                addressList.length,
                ")")),
        React.createElement(Flex, { flexDirection: ['row', 'row', 'column'], overflow: "auto" }, addressList.map(function (data, index) { return (React.createElement(AddressCard$1, { data: data, index: index, key: index + "__address_card", onAddressSelection: onAddressSelection, selectedId: selectedId, t: t, phoneCountryCode: phoneCountryCode, testId: cardTestId })); }))));
};
AddressList$7.defaultProps = {
    width: '480px',
    isOpen: true,
};

var SelectAddressLocation$3 = function (props) {
    var t = useTranslation().t;
    var closeDrawer = props.closeDrawer, _a = props.width, width = _a === void 0 ? 500 : _a, testId = props.testId;
    var isMobile = useBreakpoints().isMobile;
    var _b = __read(useGetLocation$1(), 4), location = _b[0], fetchLocation = _b[1], _c = _b[2], countryConfig = _c === void 0 ? {} : _c, appConfig = _b[3];
    var _d = __read(useState(false), 2), isSelected = _d[0], setIsSelected = _d[1];
    var _e = __read(useState(''), 2), emirate = _e[0], setEmirate = _e[1];
    var _f = __read(useCheckAreaIfSupported$1(), 4), checkCoverageArea = _f[0], coverageArea = _f[1], showLoader = _f[3];
    var _g = __read(useState(''), 2), addressInfo = _g[0], setAddressInfo = _g[1];
    var _h = __read(useState({
        latitude: location === null || location === void 0 ? void 0 : location.lat,
        longitude: location === null || location === void 0 ? void 0 : location.lng,
    }), 2), latLng = _h[0], setLatLng = _h[1];
    var _j = __read(useState(false), 2), isCoordsChanged = _j[0], setIsCoordsChanged = _j[1];
    var pageStructure = useSelector(function (state) { return state.pageStructure; });
    var state = useSelector(function (state) { return state; });
    var isAreaNotSupported = location && !(coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isChecking) && !(coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isSupported);
    var extraProps = {};
    var isLoading = countryConfig.isLoading;
    if (isMobile) {
        extraProps.style = { height: '100%', borderRadius: '24px 24px 0px 0px' };
    }
    useEffect(function () {
        if (!location) {
            fetchLocation(false, false);
        }
    }, [fetchLocation, location]);
    var dispatch = useDispatch();
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    var confirmLocation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isPolygonChange, store;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch(updateGeoArea$1(addressInfo, latLng === null || latLng === void 0 ? void 0 : latLng.latitude, latLng === null || latLng === void 0 ? void 0 : latLng.longitude));
                    dispatch(init$1({
                        changingLocation: true,
                    }));
                    GTMEventCall(GTMEvents$1.custom_event, {
                        eventAction: GTMEventActions$1.change_address_done,
                        eventLabel: addressInfo,
                        ga4: true,
                    });
                    closeDrawer && closeDrawer();
                    isPolygonChange = (_a = getGrowthBookFeatureValueViaInstance$1(state, 'is_polygon_cached')) === null || _a === void 0 ? void 0 : _a.on;
                    if (!isPolygonChange) return [3 /*break*/, 2];
                    store = { appConfig: appConfig, pageStructure: pageStructure };
                    return [4 /*yield*/, getDeliveryTime$1()(dispatch, store, undefined, isPolygonChange)];
                case 1:
                    _b.sent();
                    window.location.reload();
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if ((location === null || location === void 0 ? void 0 : location.lat) !== latLng.latitude && (location === null || location === void 0 ? void 0 : location.lng) !== latLng.longitude && !isCoordsChanged) {
            setIsCoordsChanged(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [latLng]);
    return (React.createElement(Drawer, __assign({ variant: "float", isOpen: true, width: [null, null, width], anchor: ['bottom', null, 'right'], contentStyles: { p: [0], height: '100%', display: 'flex', flexDirection: 'column' }, "data-testid": testId, showLoader: isLoading || showLoader }, extraProps),
        React.createElement(DrawerHeader$4, { "data-testid": "drawer-header" },
            React.createElement(Flex, { alignItems: "center", justifyContent: "space-between" },
                React.createElement(HeaderTitle$2, { flex: 1 }, isMobile ? i18next.t('address.chooseLocation') : i18next.t('address.addDeliveryLocation')),
                React.createElement(DrawerIconContainer$1, { onClick: closeDrawer, variant: "naked" },
                    React.createElement(DrawerCloseIcon, null)))),
        location && (React.createElement(Box, { style: { position: 'relative', flex: 1 }, "data-sl": "mask" },
            React.createElement(MapContainer$1, { flexDirection: "column", height: isMobile ? '100%' : 'auto', open: true },
                React.createElement(Flex, { style: {
                        position: 'relative',
                        height: isMobile ? 'inherit' : 992,
                        minHeight: isMobile ? 'inherit' : 400,
                    }, flexDirection: "column" }, !!location && (React.createElement(React.Fragment, null,
                    React.createElement(SearchBox$2, null),
                    !isSelected && (React.createElement(MapOverlayWapper$1, null,
                        React.createElement(MapOverlay, null))),
                    React.createElement(Flex, { style: { position: 'relative', height: '100%' }, flexDirection: "column", "data-testid": "google-map-section" },
                        React.createElement(GoogleMap$1, { isAreaNotSupported: isAreaNotSupported, isMobile: isMobile, location: location, style: { width: '100%' }, fetchLocation: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, fetchLocation(false, false, false)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            }); }); }, fetchMapCoordinates: fetchLocation, isDefaultLocation: location.isDefaultLocation, checkCoverageArea: checkCoverageArea, countryConfig: countryConfig, setAddressInfo: setAddressInfo, setLatLng: setLatLng, setEmirate: setEmirate, isSelected: isSelected, setIsSelected: setIsSelected, addressInfo: isCoordsChanged ? addressInfo : '', appConfig: appConfig, hideFlatNo: isAreaNotSupported || (coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isChecking) }),
                        isSelected && (React.createElement(MarkerBox$1, null,
                            React.createElement(PonPin, { size: 'L', fill: "#F45C5D" }))),
                        (coverageArea === null || coverageArea === void 0 ? void 0 : coverageArea.isChecking) && React.createElement(LinearProgress, { position: "bottom" })),
                    React.createElement(Flex, { flexDirection: "column", mb: isMobile ? '-30px' : '0px' },
                        React.createElement(CurrentlySelected$3, { emirate: emirate, formattedGoogleAddressDescription: formattedGoogleAddressDescription$1, isVisible: isAreaNotSupported || isSelected, addressInfo: addressInfo, isAreaNotSupported: isAreaNotSupported }))))),
                React.createElement(Flex, { flexDirection: "column", style: {
                        boxShadow: isCoordsChanged ? 'none' : '0px 4px 15px rgba(0, 0, 0, 0.15)',
                        width: '484px',
                        height: '80px',
                        marginLeft: '-15px',
                        marginTop: '34px',
                    } },
                    React.createElement(ButtonWrapper$4, null,
                        React.createElement(Back$1, { onClick: closeDrawer, variant: "link" }, t('address.back')),
                        React.createElement(DeliverTo$1, { width: "303px", onClick: confirmLocation, variant: "custom", preventTextTransform: true, disabledNewUI: !isSelected || !location || isAreaNotSupported }, t('address.deliverToLocation')))))))));
};
SelectAddressLocation$3.defaultProps = {
    width: '480px',
    testId: 'search-location-test-id',
};



var index$7 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AddAddress: AddAddress$3,
    AddressList: AddressList$7,
    SelectAddressLocation: SelectAddressLocation$3,
    AddAddressForm: AddAddressForm$3
});

var RadioButtonCta$1 = function (props) {
    var clickAction = props.clickAction, text = props.text, _a = props.variantType, variantType = _a === void 0 ? 'primary' : _a;
    return (React.createElement(Button$1, { variant: variantType, onClick: clickAction, height: "48px", width: "100%", "data-testid": "radio-cancel-button", preventTextTransform: true },
        React.createElement(Box, { sx: {
                whiteSpace: 'nowrap',
            }, fontSize: [2, 3], fontWeight: [5, 6] }, text)));
};
var RadioButtonList$2 = function (props) {
    var listItem = props.listItem, btnTxt = props.btnTxt, _a = props.isCancel, isCancel = _a === void 0 ? false : _a, _b = props.cancelTxt, cancelTxt = _b === void 0 ? '' : _b, close = props.close;
    var _c = __read(listItem.filter(function (item) { return item.isSelected; }), 1), selectedItem = _c[0];
    var _d = selectedItem.heading, heading = _d === void 0 ? '' : _d, action = selectedItem.action, _e = selectedItem.label, label = _e === void 0 ? '' : _e, _f = selectedItem.subHeading, subHeading = _f === void 0 ? '' : _f;
    var _g = __read(useState({
        heading: heading,
        action: action,
        label: label,
        subHeading: subHeading,
    }), 2), selectedBtnAction = _g[0], updateBtnAction = _g[1];
    var btnAction = function (actionDetails) { return function () {
        var _a = actionDetails.heading, heading = _a === void 0 ? '' : _a, action = actionDetails.action, _b = actionDetails.label, label = _b === void 0 ? '' : _b, _c = actionDetails.subHeading, subHeading = _c === void 0 ? '' : _c;
        updateBtnAction({
            heading: heading,
            action: action,
            label: label,
            subHeading: subHeading,
        });
    }; };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, null, listItem.map(function (btnDetails) {
            var isRadioSelected = selectedBtnAction.label === btnDetails.label;
            return (React.createElement(Button$1, { variant: "link", minHeight: "32px", "data-testid": "radio-label-" + btnDetails.label, key: btnDetails.heading, onClick: btnAction(btnDetails), mb: 3 },
                React.createElement(Box, { display: "flex", color: COLORS$1.GRAY_800, minHeight: "32px", mb: 3 },
                    React.createElement(Box, { as: "span", sx: {
                            height: '16px',
                            minWidth: '16px',
                            borderRadius: '50%',
                            border: "2px solid " + (isRadioSelected ? COLORS$1.BLUE : COLORS$1.GRAY_500),
                            mr: 2,
                        } }, isRadioSelected && (React.createElement(Box, { bg: COLORS$1.BLUE, sx: {
                            margin: '1px',
                            height: '10px',
                            width: '10px',
                            borderRadius: '50%',
                        } }))),
                    React.createElement(Box, { as: "span" },
                        React.createElement(Box, { as: "span", fontSize: 2, display: "block", fontWeight: 6, mb: 2, color: isRadioSelected ? COLORS$1.BLUE : COLORS$1.BLACK }, btnDetails.heading),
                        (btnDetails === null || btnDetails === void 0 ? void 0 : btnDetails.subHeading) && (React.createElement(Box, { as: "span", fontSize: 2, display: "block", width: ['auto', '300px', '330px'], lineHeight: "20px" }, btnDetails === null || btnDetails === void 0 ? void 0 : btnDetails.subHeading))))));
        })),
        React.createElement(Flex, null,
            !!(isCancel && cancelTxt && close) && (React.createElement(Box, { mr: 2, width: "100%" },
                ' ',
                React.createElement(RadioButtonCta$1, { text: cancelTxt, clickAction: close, variantType: "outlined" }))),
            React.createElement(RadioButtonCta$1, { text: btnTxt, clickAction: selectedBtnAction.action, variantType: "secondary" }))));
};
var RadioButtonList$3 = memo(RadioButtonList$2);

var Title$a = function () {
    var t = useTranslation().t;
    return (React.createElement(Box, { as: "span", fontWeight: [5, 6], fontSize: [3, 4], sx: {
            fontFamily: 'Montserrat',
        } }, t('plasticBagConsentDrawer.title')));
};
var UserConsent$1 = function (props) {
    var _a = props.isOpen, isOpen = _a === void 0 ? true : _a, _b = props.isFormVisible, isFormVisible = _b === void 0 ? false : _b, callBack = props.callBack, close = props.close, _c = props.isUpdateConsent, isUpdateConsent = _c === void 0 ? false : _c;
    var t = useTranslation().t;
    var selectedDelivery = getPackageFreeDelivery$1() || 'true';
    var listItem = [
        {
            heading: t('plasticBagConsentDrawer.packageFreeHead'),
            action: function () {
                if (callBack) {
                    callBack(true);
                    setPackageFreeDelivery$1(true);
                    close && close();
                }
            },
            isSelected: selectedDelivery === 'true',
            label: 'package_free',
            subHeading: t('plasticBagConsentDrawer.packageFreeSub'),
        },
        {
            heading: t('plasticBagConsentDrawer.acceptBagHead'),
            action: function () {
                if (callBack) {
                    callBack(false);
                    setPackageFreeDelivery$1(false);
                    close && close();
                }
            },
            isSelected: selectedDelivery === 'false',
            label: 'with_bag',
            subHeading: t('plasticBagConsentDrawer.acceptBagSub'),
        },
    ];
    return (React.createElement(Drawer, { onClose: close, isOpen: isOpen, width: [null, null, '500px'], anchor: ['bottom', null, 'right'], contentStyles: { p: [0], height: '100%', display: 'flex', flexDirection: 'column', fontFamily: 'Montserrat' }, variant: "float", title: React.createElement(Title$a, null) },
        React.createElement(Box, { p: 3 }, isFormVisible ? (React.createElement(RadioButtonList$3, { listItem: listItem, btnTxt: isUpdateConsent ? t('plasticBagConsentDrawer.update') : t('plasticBagConsentDrawer.saveText'), isCancel: isUpdateConsent, close: close, cancelTxt: t('plasticBagConsentDrawer.cancel') })) : (React.createElement(Button$1, { variant: "primary", onClick: close, fontSize: 3, fontWeight: 6, height: "48px", width: "100%", preventTextTransform: true },
            React.createElement(Box, { sx: {
                    whiteSpace: 'nowrap',
                } }, t('plasticBagConsentDrawer.btnText')))))));
};

var NoLink$1 = customStyled(Button$1)(templateObject_1$1$ || (templateObject_1$1$ = __makeTemplateObject(["\n  text-decoration: none;\n  letter-spacing: 0.5px;\n  display: flex;\n  padding: 10px;\n  border-top: 1px solid ", ";\n  align-items: center;\n  color: ", ";\n  @media (min-width: ", ") {\n    padding: 20px 24px;\n  }\n  cursor: pointer;\n  text-transform: uppercase;\n  @media (min-width: ", ") {\n    text-transform: none;\n  }\n"], ["\n  text-decoration: none;\n  letter-spacing: 0.5px;\n  display: flex;\n  padding: 10px;\n  border-top: 1px solid ", ";\n  align-items: center;\n  color: ", ";\n  @media (min-width: ", ") {\n    padding: 20px 24px;\n  }\n  cursor: pointer;\n  text-transform: uppercase;\n  @media (min-width: ", ") {\n    text-transform: none;\n  }\n"])), COLORS$1.MERCURY, COLORS$1.THUNDORA, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.breakpoints[2]; });
var templateObject_1$1$;

var EPlasticBagActions$1;
(function (EPlasticBagActions) {
    EPlasticBagActions["FETCH_USER_CONSENT"] = "UserData/FETCH_USER_CONSENT";
    EPlasticBagActions["SET_USER_CONSENT"] = "UserData/SET_USER_CONSENT";
})(EPlasticBagActions$1 || (EPlasticBagActions$1 = {}));

var fetchPlasticBagUserConsent = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                res = '';
                return [4 /*yield*/, dispatch({
                        type: EPlasticBagActions$1.FETCH_USER_CONSENT,
                        payload: {
                            url: GET_PLASTIC_BAG_CONSENT,
                            isAbsUrl: true,
                            method: EApiMiddlewareMethod$3.GET,
                            onSuccess: function (response) {
                                res = response.data.singleUseBagOpted !== null ? response.data.singleUseBagOpted : 'true';
                                return response;
                            },
                        },
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/, res];
        }
    });
}); }; };
var setPlasticBagUserConsent = function (flag) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dispatch({
                    type: EPlasticBagActions$1.SET_USER_CONSENT,
                    payload: {
                        url: SET_PLASTIC_BAG_CONSENT,
                        isAbsUrl: true,
                        method: EApiMiddlewareMethod$3.PATCH,
                        data: {
                            singleUseBagOpted: flag,
                        },
                    },
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); }; };

var UserConsentLink = function () {
    var dispatch = useDispatch();
    var _a = __read(useState(false), 2), isConsentFormOpen = _a[0], toggleConsentForm = _a[1];
    var getConsentFormStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(fetchPlasticBagUserConsent())];
                case 1:
                    res = _a.sent();
                    CookieUtils.setPackageFreeDelivery(res);
                    updateConsentForm(true)();
                    return [2 /*return*/];
            }
        });
    }); };
    var setConsentFormStatus = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(setPlasticBagUserConsent(data))];
                case 1:
                    _a.sent();
                    CookieUtils.setPackageFreeDelivery(data);
                    updateConsentForm(false)();
                    return [2 /*return*/];
            }
        });
    }); };
    var updateConsentForm = function (flag) { return function () {
        toggleConsentForm(flag);
    }; };
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement(NoLink$1, { variant: "link", onClick: getConsentFormStatus },
            React.createElement(Box, { mr: 3, display: ['none', null, null, 'inline-block'] },
                React.createElement(SingleUsageIcon, { width: "24" })),
            t('singleUsePackageFeesLink')),
        isConsentFormOpen && (React.createElement(UserConsent, { isOpen: isConsentFormOpen, isFormVisible: true, callBack: setConsentFormStatus, close: updateConsentForm(false), isShowCloseButton: true, isUpdateConsent: true }))));
};

var smartlookErrorLabels = {
    nowClosed: 'error_now_closed',
    itemNotAvailable: 'error_item_not_available',
    promoCodeFailure: 'error_promocode_failure',
    sharePointsPayFailure: 'error_sharepoints_pay_failure',
    loginFailure: 'error_login_failure',
    otpFailure: 'error_otp_failure',
    registrationFailureEmail: 'error_existing_email_failure',
    registrationFailureMobile: 'error_existing_mobile_failure',
    accountBlockedFailure: 'error_multiple_attempts_blocked_failure',
};

var CookieBannerResponsiveDimensions = [140, 100, 86, 68];

var CookieResponsiveDimensions = CookieBannerResponsiveDimensions;

var verifySMSOTP = function (loyaltyCardNumber, smsToken) { return function (dispatch) {
    dispatch({
        type: VerifyOTPSMSTypes$3.VERIFY_SMS_OTP,
        payload: {
            data: {
                loyaltyCardNumber: loyaltyCardNumber,
                smsToken: smsToken,
            },
            headers: {
                'Content-Type': 'application/json',
            },
            method: EApiMiddlewareMethod$3.POST,
            onSuccess: function (apiResponse) {
                if (apiResponse) {
                    dispatch({ type: VerifyOTPSMSTypes$3.SUCCESS_SMS_OTP, payload: apiResponse });
                }
            },
            onFailure: function (_a) {
                var _b = (_a === void 0 ? {} : _a).response;
                dispatch({ type: VerifyOTPSMSTypes$3.ERROR_SMS_OTP, payload: i18next.t("verifyOTP.verifyOtpSMSError") });
            },
            url: VERIFY_SMS_API,
        },
    });
}; };

var timerObj$2 = null;
var VerifySMS = function (_a) {
    var cardNumber = _a.cardNumber, mobileNumber = _a.mobileNumber;
    var t = useTranslation().t;
    var _b = __read(useState(false), 2), resetInput = _b[0], setResetInput = _b[1];
    var _c = __read(useState('59'), 2), timer = _c[0], setTimer = _c[1];
    var _d = __read(useState(''), 2), smsToken = _d[0], setSMSToken = _d[1];
    var _e = __read(useState(true), 2), isModalOpen = _e[0], setIsModalOpen = _e[1];
    var _f = __read(useState(false), 2), ResendCodeEnabled = _f[0], setResendCodeEnabled = _f[1];
    var resendCodeLoading = useVerifyOTP$1().resendCodeLoading;
    var verifySMSState = useSelector(function (state) { return state.verifyOTPSMS; });
    var dispatch = useDispatch();
    useEffect(function () { return initTimer.current(); }, []);
    var initTimer = useRef(function () {
        var increment = 59;
        timerObj$2 = setInterval(function () {
            increment = increment - 1;
            if (increment === 0) {
                clearInterval(timerObj$2);
                setResendCodeEnabled(true);
            }
            setTimer(increment < 10 ? '0' + increment : increment.toString());
        }, 1000);
    });
    var handleResendCode = useCallback(function () {
        clearInterval(timerObj$2);
        initTimer.current();
        setResendCodeEnabled(false);
        setResetInput(true);
        dispatch(verifySMSOTP(cardNumber, smsToken));
    }, [smsToken, cardNumber, dispatch]);
    useEffect(function () {
        if (verifySMSState === null || verifySMSState === void 0 ? void 0 : verifySMSState.errorMessage) {
            clearInterval(timerObj$2);
            setResendCodeEnabled(true);
        }
    }, [verifySMSState]);
    var changeOTP = useCallback(function (otp) {
        if (otp.length === 6) {
            setSMSToken(otp);
            dispatch(verifySMSOTP(cardNumber, otp));
        }
    }, [cardNumber, dispatch]);
    useEffect(function () {
        if (verifySMSState === null || verifySMSState === void 0 ? void 0 : verifySMSState.response) {
            setIsModalOpen(false);
            setResetInput(true);
            setResendCodeEnabled(true);
            clearInterval(timerObj$2);
        }
    }, [verifySMSState]);
    var handleResetInput = useCallback(function () { return setResetInput(false); }, []);
    var handleCloseModal = useCallback(function () {
        setResetInput(true);
        setIsModalOpen(false);
    }, []);
    return (React.createElement(Modal, { isOpen: isModalOpen, onClose: handleCloseModal, title: t('verifyOTP.enterOTP') },
        (verifySMSState === null || verifySMSState === void 0 ? void 0 : verifySMSState.errorMessage) && React.createElement(Notification, { mb: 3 }, verifySMSState === null || verifySMSState === void 0 ? void 0 : verifySMSState.errorMessage),
        React.createElement(Box, { as: "span" },
            t('verifyOTP.weSentAsecurityCode'),
            " ",
            mobileNumber),
        React.createElement(OTPInput$1, { autoFocus: true, length: 6, className: "otpContainer", inputClassName: "otpInput", onChangeOTP: function (otp) { return changeOTP(otp); }, isResetInput: resetInput, resetInput: handleResetInput }),
        React.createElement(Flex, { flexDirection: "column", alignItems: "center" },
            React.createElement(LoaderSpan$2, null,
                React.createElement(Button$1, { onClick: handleResendCode, width: "100%", disabled: !ResendCodeEnabled || resendCodeLoading },
                    t('verifyOTP.resendCode'),
                    resendCodeLoading && React.createElement(LinearProgress, { withBlock: true }))),
            React.createElement(Timer$2, null,
                "00:",
                timer))));
};

var ComponentTypes$1;
(function (ComponentTypes) {
    ComponentTypes["V1"] = "V1";
    ComponentTypes["V2"] = "V2";
})(ComponentTypes$1 || (ComponentTypes$1 = {}));

var QuickNavigationWrapper$1 = customStyled.div(templateObject_1$20 || (templateObject_1$20 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    > div {\n      direction: inherit !important;\n    }\n  "], ["\n    display: flex;\n    width: 100%;\n    > div {\n      direction: inherit !important;\n    }\n  "])));
var CustomizedCardWrapper$1 = customStyled.a(templateObject_2$1F || (templateObject_2$1F = __makeTemplateObject(["\n  flex: 1;\n  text-align: left;\n  font-family: 'Montserrat';\n  color: ", ";\n  text-decoration: none;\n  width: ", ";\n\n  &:first-of-type{\n    margin-left: 0px;\n  }\n\n  &:last-of-type{\n    margin-right: 0px;\n  }\n"], ["\n  flex: 1;\n  text-align: left;\n  font-family: 'Montserrat';\n  color: ", ";\n  text-decoration: none;\n  width: ", ";\n\n  &:first-of-type{\n    margin-left: 0px;\n  }\n\n  &:last-of-type{\n    margin-right: 0px;\n  }\n"])), COLORS$1.BLACK, function (_a) {
    var width = _a.width;
    return width;
});
var CustomizedCardContent$1 = customStyled(Box)(templateObject_3$1l || (templateObject_3$1l = __makeTemplateObject(["\n  background-color: ", ";\n  width: 100%;\n  height: fit-content;\n  align-items: center;\n  justify-content: ", ";\n  border-radius: 8px;\n  padding: 9px 8px 8px;\n  min-height: 68px;\n  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);\n  display: flex;\n  align-items: center;\n\n  @media (max-width: ", ") {\n    min-height: 88px;\n    border-radius: 12px;\n    ", "\n  }\n"], ["\n  background-color: ", ";\n  width: 100%;\n  height: fit-content;\n  align-items: center;\n  justify-content: ", ";\n  border-radius: 8px;\n  padding: 9px 8px 8px;\n  min-height: 68px;\n  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);\n  display: flex;\n  align-items: center;\n\n  @media (max-width: ", ") {\n    min-height: 88px;\n    border-radius: 12px;\n    ",
    "\n  }\n"])), function (_a) {
    var bgColor = _a.bgColor;
    return bgColor || COLORS$1.WHITE;
}, function (_a) {
    var isV2TypeComponent = _a.isV2TypeComponent;
    return (isV2TypeComponent ? 'space-between' : 'center');
}, function (props) { return props.theme.breakpoints[1]; }, function (props) {
    return props.isV2TypeComponent &&
        "\n        min-height: 48px;\n        border-radius: 8px;\n        min-width: 130px;\n        width: max-content;\n        padding: 8px 12px;\n      ";
});
var ImageSection$1 = customStyled(Box)(templateObject_4$18 || (templateObject_4$18 = __makeTemplateObject(["\n  justify-content: space-between;\n  display: flex;\n  gap: ", ";\n  margin-bottom: ", ";\n\n  & img{\n    align-self: center;\n  }\n"], ["\n  justify-content: space-between;\n  display: flex;\n  gap: ", ";\n  margin-bottom: ", ";\n\n  & img{\n    align-self: center;\n  }\n"])), function (props) { return (props.isV2TypeComponent ? '8px' : ''); }, function (props) { return (props.isV2TypeComponent ? '' : '15px'); });
var Gap$1 = customStyled(Box)(templateObject_5$T || (templateObject_5$T = __makeTemplateObject(["\n  min-width: ", "\n"], ["\n  min-width: ", "\n"])), function (props) { return (props.isV2TypeComponent ? '8px' : '20px'); });
var ImageWrapper$6 = customStyled(Box)(templateObject_6$H || (templateObject_6$H = __makeTemplateObject(["\n  height: 24px;\n  width: auto;\n\n  @media (max-width: ", ") {\n    height: ", ";\n    width: ", ";\n    margin-top: ", "\n  }\n"], ["\n  height: 24px;\n  width: auto;\n\n  @media (max-width: ", ") {\n    height: ", ";\n    width: ", ";\n    margin-top: ", "\n  }\n"])), function (props) { return props.theme.breakpoints[1]; }, function (props) { return (props.isV2TypeComponent ? '24px' : '20px'); }, function (props) { return (props.isV2TypeComponent ? '24px' : 'auto'); }, function (props) { return (props.isV2TypeComponent ? '4px' : ''); });
var templateObject_1$20, templateObject_2$1F, templateObject_3$1l, templateObject_4$18, templateObject_5$T, templateObject_6$H;

var QuickNavigationSlide = function (_a) {
    var component = _a.component, index = _a.index, width = _a.width, isV2TypeComponent = _a.isV2TypeComponent, onView = _a.onView, onClick = _a.onClick;
    var _b = __read(useInView({
        /* Optional options */
        threshold: 0,
    }), 2), ref = _b[0], inView = _b[1];
    useEffect(function () {
        if (inView) {
            trackInViewCarousels({ component: component, onView: onView });
        }
    }, [component, inView, onView]);
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    var GtmEventHandler = function (item) {
        var _a, _b, _c;
        var eventLabel = (_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.name) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.replace(/\s+/g, '_')) === null || _c === void 0 ? void 0 : _c.concat('_clicked');
        var eventData = {
            eventAction: GTMEventActions$1.fyc_icon_interaction,
            ga4: true,
            eventLabel: eventLabel,
        };
        GTMEventCall(GTMEvents$1.custom_event, eventData);
    };
    var linkClickHandler = function (e, index, item) {
        GtmEventHandler(item);
        onClick(e, Number(index) + 1, item);
    };
    var _c = component.background_color, background_color = _c === void 0 ? '' : _c, _d = component.cta_url_web, cta_url_web = _d === void 0 ? '#' : _d, _e = component.media, media = _e === void 0 ? '' : _e, _f = component.title, title = _f === void 0 ? '' : _f, _g = component.subtitle, subtitle = _g === void 0 ? '' : _g, _h = component.sub_media, sub_media = _h === void 0 ? '' : _h, id = component.id, componentName = component.__component;
    return (React.createElement(CustomizedCardWrapper$1, { ref: ref, key: title + "_" + index, href: cta_url_web, onClick: function (e) { return linkClickHandler(e, index, component); }, id: componentName + "_" + id },
        React.createElement(CustomizedCardContent$1, { bgColor: background_color, minWidth: ['100px', width], isV2TypeComponent: isV2TypeComponent },
            React.createElement(Box, { display: ['block', null, null, 'none'] },
                React.createElement(ImageSection$1, { isV2TypeComponent: isV2TypeComponent },
                    media && (React.createElement(ImageWrapper$6, { isV2TypeComponent: isV2TypeComponent },
                        React.createElement(Image, { url: media, width: "auto", height: "100%", name: title }))),
                    isV2TypeComponent && (React.createElement(Box, null,
                        React.createElement(Box, { fontWeight: 3, fontSize: "12px", lineHeight: "16px" }, title),
                        React.createElement(Box, { fontWeight: 5, fontSize: "12px", lineHeight: "16px" }, subtitle))),
                    sub_media && (React.createElement(ImageWrapper$6, { isV2TypeComponent: isV2TypeComponent },
                        React.createElement(Image, { url: sub_media, width: "auto", height: "100%", name: title })))),
                !isV2TypeComponent && (React.createElement(React.Fragment, null,
                    React.createElement(Box, { fontWeight: 3, fontSize: "12px", lineHeight: "16px" }, title),
                    React.createElement(Box, { fontWeight: 5, fontSize: "12px", lineHeight: "16px" }, subtitle)))),
            React.createElement(Box, { display: ['none', null, null, 'block'], width: "100%" },
                React.createElement(Flex, { alignItems: "center", padding: "8px", width: "100%" },
                    media && (React.createElement(ImageWrapper$6, null,
                        React.createElement(Image, { url: media, width: "auto", height: "100%", name: title }))),
                    React.createElement(Flex, { justifyContent: "space-between", alignItems: "center", width: "100%" },
                        React.createElement(Flex, { flexDirection: "column", alignItems: "start", justifyContent: "center", px: "16px" },
                            React.createElement(Box, { fontWeight: 3, fontSize: "12px", lineHeight: "16px" }, title),
                            React.createElement(Box, { fontWeight: 5, fontSize: "14px", lineHeight: "20px" }, subtitle)),
                        sub_media && (React.createElement(ImageWrapper$6, null,
                            React.createElement(Image, { url: sub_media, width: "auto", height: "100%", name: title })))))))));
};

var QuickNavigation = function (_a) {
    var _b = _a.navigationLinks, navigationLinks = _b === void 0 ? [] : _b, _c = _a.position, position = _c === void 0 ? '' : _c, componentType = _a.componentType, onView = _a.onView, onClick = _a.onClick;
    var _d = useSelector(function (state) { return state; }), _e = _d.userData, _f = _e.totalPointsValue, totalPointsValue = _f === void 0 ? '0.00' : _f, _g = _e.totalPoints, totalPoints = _g === void 0 ? '0.00' : _g, _h = _e.cardNumber, cardNumber = _h === void 0 ? '' : _h, _j = _e.firstName, firstName = _j === void 0 ? '' : _j, _k = _d.appConfig, _l = _k.currency, currency = _l === void 0 ? '' : _l, _m = _k.features.share, share = _m === void 0 ? false : _m;
    var _o = __read(React.useState('0.00'), 2), sharePoints = _o[0], setSharePoints = _o[1];
    var _p = __read(React.useState('0.00'), 2), sharePointsValue = _p[0], setSharePointsValue = _p[1];
    var isV2TypeComponent = componentType === ComponentTypes$1.V2;
    var isLoggedIn = !!firstName;
    var t = useTranslation().t;
    var width = 100 / navigationLinks.length + "%";
    useEffect(function () {
        if (isLoggedIn) {
            setSharePoints(totalPoints.toString());
            setSharePointsValue(totalPointsValue.toString());
        }
    }, [isLoggedIn, totalPoints, totalPointsValue, currency]);
    return (React.createElement(QuickNavigationWrapper$1, { key: position, id: "quick-navigation" },
        React.createElement(Carousel, null, navigationLinks.map(function (item, index) {
            var itemObj = __assign({}, item);
            if (item.type === 'SHARE_POINTS') {
                itemObj.subtitle = isLoggedIn
                    ? !!cardNumber
                        ? currency + " " + sharePointsValue
                        : t('subscribe')
                    : t('guestQLink', {
                        loyalty: share ? t('shareQLink') : t('myClubQLink'),
                    });
                itemObj.title = isLoggedIn && !!cardNumber ? sharePoints + " " + t('pointsQLink') : item.title;
            }
            else {
                itemObj.title = isLoggedIn ? item.titleLoggedIn || item.title : item.title;
            }
            return (React.createElement(Fragment, { key: itemObj.title + "_" + index },
                React.createElement(QuickNavigationSlide, { component: itemObj, width: width, onClick: onClick, onView: onView, index: index, isV2TypeComponent: isV2TypeComponent }),
                index < navigationLinks.length - 1 && React.createElement(Gap$1, { isV2TypeComponent: isV2TypeComponent })));
        }))));
};

var setCriteoBanners = function (banners) { return ({
    type: AdtechActionTypes$3.SET_CRITEO_BANNERS,
    payload: banners,
}); };
var setCriteoCarouselsHeaders = function (carouselHeaders) { return ({
    type: AdtechActionTypes$3.SET_CRITEO_CAROUSELS_HEADER,
    payload: carouselHeaders,
}); };
var setCriteoCarousels = function (carousels) { return ({
    type: AdtechActionTypes$3.SET_CRITEO_CAROUSELS,
    payload: carousels,
}); };
var resetAdtechReducer = function () { return ({
    type: AdtechActionTypes$3.RESET_ADTECH_REDUCER,
}); };
var handleCriteoBannersResponse = function (bannerRespArr, isSSPPage) {
    if (bannerRespArr === void 0) { bannerRespArr = []; }
    if (isSSPPage === void 0) { isSSPPage = false; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var criteoBanners_1;
        return __generator(this, function (_a) {
            try {
                criteoBanners_1 = {};
                bannerRespArr.forEach(function (bannerResponse) {
                    var placement_id = bannerResponse.placement_id, desktop_background_image = bannerResponse.desktop_background_image, tablet_backgroud_image = bannerResponse.tablet_backgroud_image, mobile_background_image = bannerResponse.mobile_background_image, redirect_url = bannerResponse.redirect_url, redirect_target = bannerResponse.redirect_target, _a = bannerResponse.tracking, tracking = _a === void 0 ? [] : _a;
                    var trackingUrls = {};
                    tracking.forEach(function (trackingObj) {
                        var href = trackingObj.href, kind = trackingObj.kind;
                        trackingUrls[kind] = href;
                        if (kind === ETrackingKind$1.LOAD_TRACKING) {
                            // as soon as we get criteo banner api response, need to fire onLoad breacons hope-1990
                            // https://mafretail.atlassian.net/browse/HOPE-1990
                            href && fetch(href);
                        }
                    });
                    criteoBanners_1[placement_id + ("" + (isSSPPage ? SSP_BANNER_PLACEMENT_ID_POSTFIX : ''))] = __assign({ desktop_background_image: desktop_background_image,
                        tablet_backgroud_image: tablet_backgroud_image,
                        mobile_background_image: mobile_background_image,
                        redirect_url: redirect_url,
                        redirect_target: redirect_target }, trackingUrls);
                });
                if (!isEmptyObject$1(criteoBanners_1)) {
                    dispatch(setCriteoBanners(criteoBanners_1));
                }
            }
            catch (error) {
                console.log('error in handling criteo banner response', error);
            }
            return [2 /*return*/];
        });
    }); };
};
var handleCriteoCarouselResponse = function (carouselResp) {
    if (carouselResp === void 0) { carouselResp = {}; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var criteoCarousels_1, carouselsHeader_1;
        return __generator(this, function (_a) {
            try {
                criteoCarousels_1 = {};
                carouselsHeader_1 = {};
                Object.keys(carouselResp).forEach(function (key) {
                    var _a, _b;
                    criteoCarousels_1[key] = carouselResp[key].products;
                    carouselsHeader_1[key] = (_b = (_a = carouselResp[key].headerKey) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.headerName;
                });
                if (!isEmptyObject$1(carouselsHeader_1)) {
                    dispatch(setCriteoCarouselsHeaders(carouselsHeader_1));
                }
                dispatch(setCriteoCarousels(criteoCarousels_1));
            }
            catch (error) {
                console.log('error in handling criteo carousel response', error);
            }
            return [2 /*return*/];
        });
    }); };
};

var BundleIcon = function () {
    return (React.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M0.75 4.875L6 7.875L11.25 4.875L6 1.875L0.75 4.875Z", stroke: "white", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M0.75 6.75L6 9.75L11.25 6.75", stroke: "white", strokeLinecap: "round", strokeLinejoin: "round" })));
};

var BundleContainer$1 = customStyled(Flex)(function () { return ({
    flexFlow: 'column',
    flexShrink: 0,
}); });
var BundleHeader$1 = customStyled(Box)(function (_a) {
    var theme = _a.theme, isDisabled = _a.isDisabled;
    return (__assign({ backgroundColor: COLORS$1.ERROR_RED_500, fontSize: theme.fontSizes[0], fontWeight: theme.fontWeights[6], color: theme.colors.white, padding: '4px 10px', width: '74px', borderRadius: '12px 2px', display: 'inline-flex', columnGap: '0.25rem' }, (isDisabled ? { opacity: 0.5 } : {})));
});
var CardContainer$1 = customStyled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        borderRadius: '12px',
        borderTopLeftRadius: '0',
        backgroundColor: theme.colors.error,
        display: 'inline-flex',
        justifyContent: 'space-around',
        padding: '0.25rem 1rem',
        columnGap: '0.25rem',
    });
});
var DetailsContainer$1 = customStyled(Flex)(function (_a) {
    var theme = _a.theme, isDisabled = _a.isDisabled;
    return ({
        border: "1px solid " + (isDisabled ? theme.colors.error : COLORS$1.ERROR_RED_50),
        borderRadius: theme.space[2],
        borderTopLeftRadius: 0,
        padding: '16px',
        paddingBottom: 0,
        flexDirection: 'column',
        columnGap: '0.5rem',
        display: 'inline-flex',
    });
});

var ShipmentBundle = function (_a) {
    var children = _a.children, isShowDetail = _a.isShowDetail, isDisabled = _a.isDisabled;
    var t = useTranslation().t;
    return (React.createElement(BundleContainer$1, { mr: isShowDetail ? 0 : 2, mb: isShowDetail ? '16px' : 0 },
        React.createElement(BundleHeader$1, { isDisabled: isDisabled },
            React.createElement(BundleIcon, null),
            t('bundle.bundleText')),
        isShowDetail ? (React.createElement(DetailsContainer$1, { isDisabled: isDisabled },
            " ",
            children,
            " ")) : (React.createElement(CardContainer$1, null,
            " ",
            children,
            " "))));
};

var MarqueeContent$1 = customStyled.div(templateObject_1$21 || (templateObject_1$21 = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  display: block;\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  display: block;\n"])));
var AnimatedText$1 = customStyled.div(templateObject_2$1G || (templateObject_2$1G = __makeTemplateObject(["\n  display: inline-block;\n  padding-left: 100%;\n  animation: marquee 10s linear infinite;\n\n  @keyframes marquee {\n    from {\n      transform: translateX(0);\n    }\n    to {\n      transform: translateX(-100%);\n    }\n  }\n"], ["\n  display: inline-block;\n  padding-left: 100%;\n  animation: marquee 10s linear infinite;\n\n  @keyframes marquee {\n    from {\n      transform: translateX(0);\n    }\n    to {\n      transform: translateX(-100%);\n    }\n  }\n"])));
var MarqueeTextWrapper$1 = customStyled(Box)(function (_a) {
    var theme = _a.theme, isNotLongText = _a.isNotLongText;
    return (__assign({ backgroundColor: COLORS$1.ERROR_RED_500, fontSize: theme.fontSizes[0], fontWeight: theme.fontWeights[6], color: theme.colors.white, padding: '4px 10px', maxWidth: '136px', borderRadius: '12px 2px' }, (isNotLongText && { display: 'inline-block' })));
});
var SavedText$1 = customStyled(Flex)(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: COLORS$1.ERROR_RED_25,
        fontSize: theme.fontSizes[1],
        fontWeight: theme.fontWeights[6],
        color: COLORS$1.ERROR_RED_500,
        padding: theme.space[2],
        maxWidth: '311px',
        borderRadius: '12px 2px',
        margin: '0 auto',
        justifyContent: 'center',
        alignItems: 'center',
    });
});
var BundleText$1 = customStyled(Flex)(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: COLORS$1.ERROR_RED_25,
        fontSize: theme.fontSizes[1],
        fontWeight: theme.fontWeights[6],
        color: COLORS$1.ERROR_RED_500,
        padding: theme.space[2],
        maxWidth: '136px',
        borderRadius: '12px 2px',
        justifyContent: 'center',
        alignItems: 'center',
    });
});
var Marquee = function (_a) {
    var text = _a.text;
    return (React.createElement(MarqueeContent$1, null,
        React.createElement(AnimatedText$1, null, text)));
};
var templateObject_1$21, templateObject_2$1G;

var Heading$5 = function (_a) {
    var headingTitle = _a.headingTitle;
    return (React.createElement(Box, { fontWeight: [5, 6], fontSize: [3, 4], textAlign: ['center', 'left'], display: "block", sx: {
            fontFamily: 'Montserrat',
        }, mt: [null, null, '-10px'], py: 3 }, headingTitle));
};
var DeliveryPromises = function (props) {
    var _a = props.isOpen, isOpen = _a === void 0 ? false : _a, _b = props.contents, contents = _b === void 0 ? [] : _b, closeHandler = props.closeHandler, _c = props.popUpTitle, popUpTitle = _c === void 0 ? 'Our delivery promises' : _c, _d = props.popUpButtonTitle, popUpButtonTitle = _d === void 0 ? 'Got It!' : _d;
    return (React.createElement(Drawer, { onClose: closeHandler, isOpen: isOpen, width: ['100%', '400px', '500px'], anchor: ['bottom', null, 'right'], contentStyles: { p: [0], height: '100%', display: 'flex', flexDirection: 'column', fontFamily: 'Montserrat' }, variant: "float", title: React.createElement(Heading$5, { headingTitle: popUpTitle }), "data-testid": "delivery-promises-drawer", isTitleBorder: false, isRtl: isRTL$1() },
        React.createElement(Box, { p: 3 },
            contents.map(function (item, index) { return (React.createElement(Box, { p: 3, textAlign: "center", key: item.title + "_" + index, "data-testid": item.title + "_" + index },
                React.createElement(Image, { name: item.title, height: "100px", width: "auto", url: item.media, margin: "0px auto", "data-testid": "image_" + index }),
                React.createElement(Box, { as: "h3", lineHeight: "20px", fontWeight: 5, fontSize: 2, pt: 3, color: COLORS$1.BLACK, "data-testid": "title_" + index }, item.title),
                React.createElement(Box, { as: "p", fontWeight: 3, fontSize: 2, lineHeight: "20px", pb: 3, color: COLORS$1.BLACK, "data-testid": "subtitle_" + index }, item.subtitle))); }),
            React.createElement(Button$1, { "data-testid": "delivery-promise-close-icon", variant: "secondary", onClick: closeHandler, fontSize: 3, fontWeight: 6, height: "48px", width: "85%", preventTextTransform: true, borderRadius: "12px", margin: "0 auto", display: "block" },
                React.createElement(Box, { sx: {
                        whiteSpace: 'nowrap',
                    } }, popUpButtonTitle)))));
};

var InfoIcon$1 = function (_a) {
    var _b = _a.isMobile, isMobile = _b === void 0 ? false : _b, _c = _a.display, display = _c === void 0 ? 'initial' : _c;
    return (React.createElement(Flex, { justifyContent: "center", alignItems: "center", minWidth: "24px", ml: [null, null, null, 1], display: display },
        React.createElement(InformationDark, { testid: "information-icon", size: "XS", fill: isMobile ? COLORS$1.SILVER : COLORS$1.ANCHOR_BLUE })));
};

var Container$k = CustomStyled$1(Flex)(templateObject_1$22 || (templateObject_1$22 = __makeTemplateObject(["\n    background-color: ", ";\n    font-family: ", ";\n    border-radius: 12px;\n    padding: 4px;\n\n    @media (max-width: ", ") {\n      margin: 0 16px 20px;\n      justify-content: center;\n  }\n"], ["\n    background-color: ", ";\n    font-family: ", ";\n    border-radius: 12px;\n    padding: 4px;\n\n    @media (max-width: ", ") {\n      margin: 0 16px 20px;\n      justify-content: center;\n  }\n"])), COLORS$1.LIGHT_OPAC_BLUE, function (props) { return props.theme.fonts.montserrat; }, function (props) { return props.theme.breakpoints[3]; });
var TabWrapper$3 = CustomStyled$1(Flex)(templateObject_2$1H || (templateObject_2$1H = __makeTemplateObject(["\n    font-family: ", ";\n    padding: 8px 12px 8px 16px;\n    cursor:  ", ";\n    border-radius: 8px;\n    align-items: center;\n    width: ", ";\n    justify-content: space-between;\n    \n    &:first-of-type {\n      margin-right: 20px;\n    }\n    \n    background: ", ";\n\n    @media (min-width: ", "px) {\n        padding: ", ";\n        height: 80px;\n        \n        filter: ", "; \n        backdrop-filter: ", ";\n        justify-content: space-between;\n    }\n    \n    @media (max-width: ", ") {\n      &:first-of-type {\n        margin-right: 0px;\n      }\n      justify-content: center;\n    }\n\n"], ["\n    font-family: ", ";\n    padding: 8px 12px 8px 16px;\n    cursor:  ", ";\n    border-radius: 8px;\n    align-items: center;\n    width: ", ";\n    justify-content: space-between;\n    \n    &:first-of-type {\n      margin-right: 20px;\n    }\n    \n    background: ",
    ";\n\n    @media (min-width: ", "px) {\n        padding: ", ";\n        height: 80px;\n        \n        filter: ",
    "; \n        backdrop-filter: ",
    ";\n        justify-content: space-between;\n    }\n    \n    @media (max-width: ", ") {\n      &:first-of-type {\n        margin-right: 0px;\n      }\n      justify-content: center;\n    }\n\n"])), function (props) { return props.theme.fonts.montserrat; }, function (props) { return (props.isFullWidth ? 'auto' : 'pointer'); }, function (props) { return (props.isFullWidth ? '100%' : '50%'); }, function (props) {
    if (props.isActive) {
        return COLORS$1.WHITE;
    }
    return 'transparent';
}, MQ$1[2], function (props) { return (props.isFullWidth ? '0' : ' 16px 32px '); }, function (props) {
    return props.isActive ? 'drop-shadow(0px 4px 48px rgba(0, 0, 0, 0.08))' : '';
}, function (props) {
    return props.isActive ? 'blur(24px)' : 'blur(0)';
}, function (props) { return props.theme.breakpoints[1]; });
var Title$b = CustomStyled$1(Box)(templateObject_3$1m || (templateObject_3$1m = __makeTemplateObject(["\n    white-space: nowrap;\n    font-family: ", ";\n    font-style: normal;\n    font-size: ", ";\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    font-weight: ", ";\n    color:", ";\n\n    @media (min-width: ", "px) {\n        font-weight: ", ";\n        color:", "; \n    }\n"], ["\n    white-space: nowrap;\n    font-family: ", ";\n    font-style: normal;\n    font-size: ", ";\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    font-weight: ", ";\n    color:", ";\n\n    @media (min-width: ", "px) {\n        font-weight: ", ";\n        color:", "; \n    }\n"])), function (props) { return props.theme.fonts.montserrat; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.fontWeights[6]; }, COLORS$1.ANCHOR_BLUE, MQ$1[2], function (props) { return props.theme.fontWeights[6]; }, function (props) { return (props.isActive ? COLORS$1.DARK_BLUE : COLORS$1.BLACK); });
var IconWrapper$d = CustomStyled$1(Box)(templateObject_4$19 || (templateObject_4$19 = __makeTemplateObject(["\n    width: 48px;\n    height: 48px;  \n    border-radius: 50%;\n    align-items: center;\n    transform: ", ";\n    justify-content: ", ";\n\n    @media (max-width: ", ") {\n      width: 32px;\n      height: 32px;\n      background: unset;\n  }\n"], ["\n    width: 48px;\n    height: 48px;  \n    border-radius: 50%;\n    align-items: center;\n    transform: ", ";\n    justify-content: ", ";\n\n    @media (max-width: ", ") {\n      width: 32px;\n      height: 32px;\n      background: unset;\n  }\n"])), function (props) { return (props.isRTL ? 'rotateY(180deg);' : 'unset;'); }, function (props) { return (props.isRTL ? 'flex-end' : ''); }, function (props) { return props.theme.breakpoints[1]; });
var InformationWrapper$1 = CustomStyled$1(Box)(templateObject_5$U || (templateObject_5$U = __makeTemplateObject(["\n    white-space: nowrap;\n    width: 110px;\n    font-family: ", ";\n    color: ", ";\n    text-align: center;\n    .title {\n        font-weight: ", ";\n        font-size: ", "px;\n        line-height: 16px;\n        margin-right: ", ";\n        text-overflow: ellipsis;\n        overflow: hidden;\n        margin-bottom: 1px;\n    }\n    .sub-title {\n        font-weight: ", ";\n        font-size: ", "px;\n        line-height: 16px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n    }\n\n    @media (min-width: ", "px) {\n      text-align: start;\n    }\n\n    @media (max-width: ", ") {\n      flex-grow: 1;\n      color: ", ";\n    }\n"], ["\n    white-space: nowrap;\n    width: 110px;\n    font-family: ", ";\n    color: ", ";\n    text-align: center;\n    .title {\n        font-weight: ", ";\n        font-size: ", "px;\n        line-height: 16px;\n        margin-right: ", ";\n        text-overflow: ellipsis;\n        overflow: hidden;\n        margin-bottom: 1px;\n    }\n    .sub-title {\n        font-weight: ", ";\n        font-size: ", "px;\n        line-height: 16px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n    }\n\n    @media (min-width: ", "px) {\n      text-align: start;\n    }\n\n    @media (max-width: ", ") {\n      flex-grow: 1;\n      color: ", ";\n    }\n"])), function (props) { return props.theme.fonts.montserrat; }, COLORS$1.ANCHOR_BLUE, function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return (props.isInlineBlock ? '12px' : 0); }, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.fontSizes[1]; }, MQ$1[2], function (props) { return props.theme.breakpoints[1]; }, COLORS$1.BLACK);
var ValuePropositionWrapper$1 = CustomStyled$1(Flex)(templateObject_6$I || (templateObject_6$I = __makeTemplateObject(["\n    cursor: pointer;\n    justify-content: end;\n    position: relative;\n    \n    @media (max-width: ", ") {\n      justify-content: ", ";\n      margin: 16px 16px 0px;\n    }\n"], ["\n    cursor: pointer;\n    justify-content: end;\n    position: relative;\n    \n    @media (max-width: ", ") {\n      justify-content: ", ";\n      margin: 16px 16px 0px;\n    }\n"])), function (props) { return props.theme.breakpoints[1]; }, function (props) { return (props.totalLength === 1 ? 'center' : 'start'); });
var TabCoachMarkDescWrapper$1 = CustomStyled$1(Flex)(templateObject_7$E || (templateObject_7$E = __makeTemplateObject(["\n    flex-direction: column;\n    min-height: 190px;\n    svg.up-left-arrow{\n      position: relative;\n      left: 50px;\n      transform: ", "\n      width: fit-content;\n    }\n\n    svg.up-right-arrow{\n      position: relative;\n      left: 50%;\n      transform: ", "\n      width: fit-content;\n    }\n"], ["\n    flex-direction: column;\n    min-height: 190px;\n    svg.up-left-arrow{\n      position: relative;\n      left: 50px;\n      transform: ", "\n      width: fit-content;\n    }\n\n    svg.up-right-arrow{\n      position: relative;\n      left: 50%;\n      transform: ", "\n      width: fit-content;\n    }\n"])), function (props) { return (props.isRTL ? 'rotateY(180deg);' : 'unset;'); }, function (props) { return (props.isRTL ? 'rotateY(180deg);' : 'unset;'); });
var ValuePropDivider$1 = CustomStyled$1(Box)(templateObject_8$E || (templateObject_8$E = __makeTemplateObject(["\n    width: 1px;\n    height: inherit;\n    background-color: ", ";\n\n    @media (min-width: ", ") {\n      display: none;\n    }\n"], ["\n    width: 1px;\n    height: inherit;\n    background-color: ", ";\n\n    @media (min-width: ", ") {\n      display: none;\n    }\n"])), COLORS$1.GRAY_100, function (props) { return props.theme.breakpoints[3]; });
var templateObject_1$22, templateObject_2$1H, templateObject_3$1m, templateObject_4$19, templateObject_5$U, templateObject_6$I, templateObject_7$E, templateObject_8$E;

var InformationTemplate$1 = function (props) {
    var id = props.id, _a = props.subTitle, subTitle = _a === void 0 ? '' : _a, _b = props.title, title = _b === void 0 ? '' : _b, _c = props.isInlineBlock, isInlineBlock = _c === void 0 ? false : _c, totalLength = props.totalLength, index = props.index;
    if (title === '' || subTitle === '') {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Fragment, { key: id + "_" + index },
        React.createElement(InformationWrapper$1, { key: id, isInlineBlock: isInlineBlock },
            React.createElement(Box, { className: "title", display: isInlineBlock ? 'inline-block' : 'block' }, title),
            React.createElement(Box, { className: "sub-title", display: isInlineBlock ? 'inline-block' : 'block' }, subTitle)),
        totalLength === 2 && index === 0 && React.createElement(ValuePropDivider$1, null)));
};
var ValueProposition$2 = function (props) {
    var isMobile = useBreakpoints().isMobile;
    var componentsArray = props.componentsArray, onClick = props.onClick, display = props.display, className = props.className;
    var totalLength = componentsArray.length;
    return (React.createElement(React.Fragment, null,
        React.createElement(ValuePropositionWrapper$1, { onClick: onClick, display: display, totalLength: totalLength, className: className },
            totalLength === 1 ? (React.createElement(Box, { className: "title", display: "inline-flex", justifyContent: ['center', 'center', 'center', 'end'], flexGrow: "1", color: [COLORS$1.BLACK, COLORS$1.BLACK, COLORS$1.BLACK, COLORS$1.ANCHOR_BLUE] },
                React.createElement(Box, { as: "span", pr: "20px" },
                    componentsArray[0].title,
                    " ",
                    componentsArray[0].subTitle),
                isMobile && React.createElement(InfoIcon$1, { isMobile: isMobile, display: display }))) : (componentsArray.map(function (component, index) {
                return (React.createElement(InformationTemplate$1, { key: component.id, id: component.id, subTitle: component.subTitle, title: component.title, totalLength: totalLength, index: index }));
            })),
            (totalLength !== 1 || !isMobile) && React.createElement(InfoIcon$1, { isMobile: isMobile, display: display }))));
};
var ValueProposition$3 = React.memo(ValueProposition$2);

var StandardTabCoachMarkContent$2 = function (props) {
    var t = useTranslation().t;
    return (React.createElement(TabCoachMarkDescWrapper$1, { isRTL: props.isRTL },
        React.createElement(UpLeftArrow, { size: "CUSTOM", width: "81", height: "65", fill: COLORS$1.WHITE, className: "up-left-arrow" }),
        React.createElement(Box, { as: "h2", my: 3, fontSize: "16px" }, t('standardTabCoachMark.heading')),
        React.createElement(Box, { as: "p", mb: 2, fontSize: "14px", fontWeight: "bold" },
            React.createElement("b", null, t('standardTabCoachMark.subHeading'))),
        React.createElement(Box, { as: "p", fontWeight: "lighter", fontSize: "14px", lineHeight: "17px" }, t('standardTabCoachMark.description'))));
};
var StandardTabCoachMarkContent$3 = memo(StandardTabCoachMarkContent$2);

var NowTabCoachMarkContent$2 = function (props) {
    var t = useTranslation().t;
    return (React.createElement(TabCoachMarkDescWrapper$1, { isRTL: props.isRTL },
        React.createElement(UpRightArrow, { size: "CUSTOM", width: "81", height: "65", fill: COLORS$1.WHITE, className: "up-right-arrow" }),
        React.createElement(Box, { as: "h2", my: 3, fontSize: "16px" }, t('nowTabCoachMark.heading')),
        React.createElement(Box, { as: "p", mb: 2, fontSize: "14px", fontWeight: "bold" },
            React.createElement("b", null, t('nowTabCoachMark.subHeading'))),
        React.createElement(Box, { as: "p", fontWeight: "lighter", fontSize: "14px", lineHeight: "17px" }, t('nowTabCoachMark.description'))));
};
var NowTabCoachMarkContent$3 = memo(NowTabCoachMarkContent$2);

var getGALabelsNowJourney = function (nowFlag, labelType) {
    switch (labelType) {
        case 'toggle_tabs':
            return nowFlag ? GTMEventActions$1.shop_now_click : GTMEventActions$1.shop_all_items_clicked;
        case 'event_label':
            return nowFlag ? GTMNowJourneyLabels$1.now_delivery : GTMNowJourneyLabels$1.standard_delivery;
        case 'journey_selection':
            return nowFlag ? GTMNowJourneyLabels$1.now_items : GTMNowJourneyLabels$1.all_items;
    }
    return '';
};
var HeadTabs$1 = (function (props) {
    var _a, _b;
    var onLabelClick = props.onLabelClick, _c = props.activeIndex, activeIndex = _c === void 0 ? 0 : _c, _d = props.hideProposition, hideProposition = _d === void 0 ? false : _d, _e = props.isSearchPage, isSearchPage = _e === void 0 ? false : _e;
    var t = useTranslation().t;
    var store = useSelector(function (state) { return state; });
    var _f = useAnalytic$1(), GTMEventCall = _f.GTMEventCall, getGTMPageData = _f.getGTMPageData;
    var _g = store.pageStructure, pageStructure = _g === void 0 ? [] : _g, _h = store.deliveryTime, deliveryTime = _h === void 0 ? {} : _h;
    var _j = deliveryTime.expressSlot, expressSlot = _j === void 0 ? {} : _j, _k = deliveryTime.standardSlot, standardSlot = _k === void 0 ? {} : _k;
    var isNowAvailable = (expressSlot === null || expressSlot === void 0 ? void 0 : expressSlot.isAvailable) || (expressSlot === null || expressSlot === void 0 ? void 0 : expressSlot.nextAvailableSlot) ? true : false;
    var isStandardAvailable = (standardSlot === null || standardSlot === void 0 ? void 0 : standardSlot.isAvailable) ? true : false;
    var _l = __read(useState(activeIndex), 2), selectedIndex = _l[0], setSelectedIndex = _l[1];
    var _m = __read(useState(false), 2), isDPDrawerOpen = _m[0], setIsDrawerOpen = _m[1];
    var _o = __read(useState(false), 2), shouldShowCoachMark = _o[0], setShouldShowCoachMark = _o[1];
    var isHomePage = isBrowser$1() && getPageType$1() === constants$1.home;
    var isRTL = ((_a = store === null || store === void 0 ? void 0 : store.appConfig) === null || _a === void 0 ? void 0 : _a.language) === 'ar';
    var hideCoachMarkValue = isBrowser$1() && getCustomCookie$1('hideCoachMark');
    var pageName = (_b = store === null || store === void 0 ? void 0 : store.appConfig) === null || _b === void 0 ? void 0 : _b.pageName;
    useEffect(function () {
        setShouldShowCoachMark(hideCoachMarkValue !== 'true' && isHomePage);
    }, [hideCoachMarkValue, isHomePage]);
    useEffect(function () {
        var _a = (pageStructure[selectedIndex] || {}).pageType, pageType = _a === void 0 ? '' : _a;
        var isNowSelected = (pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase()) === TAB_CONST.now;
        var pageData = getGTMPageData() || {};
        try {
            GTMEventCall(GTMEvents$1.now_journey_custom_events, {
                pageData: pageData,
                eventAction: GTMNowJourneyLabels$1.new_journey_tab_impression,
                eventLabel: isNowAvailable ? GTMNowJourneyLabels$1.both_tab_shown : GTMNowJourneyLabels$1.not_shown,
                event_type: GTMNowJourneyEventTypes$1.non_interaction,
                journey_selection: getGALabelsNowJourney(isNowSelected, 'journey_selection'),
            });
        }
        catch (error) {
            console.log(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isNowAvailable]);
    useEffect(function () {
        setSelectedIndex(activeIndex);
    }, [activeIndex]);
    var onClickDrawerOpener = useCallback(function () {
        setIsDrawerOpen(!isDPDrawerOpen);
        if (!isDPDrawerOpen) {
            try {
                GTMEventCall(GTMEvents$1.now_journey_custom_events, {
                    eventAction: GTMEventActions$1.value_proposition_click,
                    eventLabel: getGALabelsNowJourney(getNowJourneyCookie$1(), 'event_label'),
                    event_type: GTMNowJourneyEventTypes$1.interaction,
                    journey_selection: getGALabelsNowJourney(getNowJourneyCookie$1(), 'journey_selection'),
                    pageData: getGTMPageData() || {},
                });
            }
            catch (error) {
                console.log(error);
            }
        }
    }, [isDPDrawerOpen, setIsDrawerOpen, getGTMPageData, GTMEventCall]);
    var onClickHandler = useCallback(function (index) { return function () {
        if (index === selectedIndex) {
            onClickDrawerOpener();
            return;
        }
        setSelectedIndex(index);
        var pageType = pageStructure[index].pageType;
        switch (pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase()) {
            case TAB_CONST.now:
                setNowJourneyCookie$1();
                break;
            case TAB_CONST.homepage:
                removeNowJourneyCookie$1();
                break;
        }
        if (onLabelClick) {
            onLabelClick(index, pageType);
        }
        var isNowSelected = (pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase()) === TAB_CONST.now;
        var pageData = getGTMPageData() || {};
        if (!isEmptyObject$1(expressSlot) && !isEmptyObject$1(standardSlot)) {
            try {
                GTMEventCall(GTMEvents$1.now_journey_custom_events, {
                    eventAction: getGALabelsNowJourney(isNowSelected, 'toggle_tabs'),
                    eventLabel: pageData.screen_type,
                    event_type: GTMNowJourneyEventTypes$1.interaction,
                    journey_selection: getGALabelsNowJourney(isNowSelected, 'journey_selection'),
                    pageData: pageData,
                });
            }
            catch (error) {
                console.log(error);
            }
        }
    }; }, [
        selectedIndex,
        pageStructure,
        onLabelClick,
        expressSlot,
        standardSlot,
        onClickDrawerOpener,
        GTMEventCall,
        getGTMPageData,
    ]);
    var deliveryPromiseCloseHandler = function () {
        setIsDrawerOpen(false);
        try {
            GTMEventCall(GTMEvents$1.now_journey_custom_events, {
                eventAction: GTMEventActions$1.got_it_click,
                eventLabel: getGALabelsNowJourney(getNowJourneyCookie$1(), 'event_label'),
                event_type: GTMNowJourneyEventTypes$1.interaction,
                journey_selection: getGALabelsNowJourney(getNowJourneyCookie$1(), 'journey_selection'),
                pageData: getGTMPageData() || {},
            });
        }
        catch (error) {
            console.log(error);
        }
    };
    var hideCoachMarkHandler = function () {
        if (isBrowser$1()) {
            setCustomCookie$1('hideCoachMark', 'true', 2600000000);
            setShouldShowCoachMark(false);
        }
    };
    var isHideScheduledTabDisabled = useFeature('habcap.disable_scheduled_tab.enabled').on;
    useEffect(function () {
        if (isHideScheduledTabDisabled && !isStandardAvailable && isNowAvailable) {
            setNowJourneyCookie$1();
        }
        if (isHideScheduledTabDisabled && isStandardAvailable && !isNowAvailable) {
            removeNowJourneyCookie$1();
        }
    }, [isHideScheduledTabDisabled, isNowAvailable, isStandardAvailable]);
    if (pageStructure.length === 0)
        return null;
    if ((!isHideScheduledTabDisabled && isSearchPage && !isNowAvailable) ||
        (isHideScheduledTabDisabled && (!isStandardAvailable || !isNowAvailable))) {
        return React.createElement(React.Fragment, null);
    }
    if (!isNowAvailable && !isHideScheduledTabDisabled) {
        var el = pageStructure[0];
        return (React.createElement(React.Fragment, null,
            el.popUpBody && isDPDrawerOpen && (React.createElement(DeliveryPromises, { isOpen: isDPDrawerOpen, closeHandler: deliveryPromiseCloseHandler, isShowCloseButton: true, contents: el.popUpBody || [], popUpTitle: el.popUpTitle || '', popUpButtonTitle: el.popUpButtonTitle || '' })),
            React.createElement(Container$k, { "data-testid": "head-tabs", id: pageName + "-head-tabs", sx: {
                    display: ['none !important', null, null, 'flex !important'],
                }, isTransBackground: true },
                React.createElement(TabWrapper$3, { totalTabs: pageStructure.length, isFullWidth: true, isTransBackground: true, id: pageName + "_head_tabs_" + el.id },
                    React.createElement(Flex, { alignItems: "center" },
                        React.createElement(IconWrapper$d, { as: "span", display: ['none', 'none', null, 'flex'], isRTL: isRTL },
                            React.createElement(StandardTabIcon, { size: "M" })),
                        React.createElement(Title$b, { as: "span" }, el.title)),
                    React.createElement(ValueProposition$3, { componentsArray: el.components, className: "info-template-desktop", display: ['none !important', null, null, 'flex !important'], onClick: onClickDrawerOpener }))),
            !hideProposition && (React.createElement(ValueProposition$3, { componentsArray: el.components, className: "info-template-mobile", display: ['flex', null, null, 'none'], onClick: onClickDrawerOpener }))));
    }
    return (React.createElement(React.Fragment, null,
        pageStructure[selectedIndex].popUpBody && isDPDrawerOpen && (React.createElement(DeliveryPromises, { isOpen: isDPDrawerOpen, closeHandler: deliveryPromiseCloseHandler, isShowCloseButton: true, contents: pageStructure[selectedIndex].popUpBody || [], popUpTitle: pageStructure[selectedIndex].popUpTitle || '', popUpButtonTitle: pageStructure[selectedIndex].popUpButtonTitle || '' })),
        React.createElement(CoachMarkList, { "data-testid": "__coach_mark_head_tabs", visible: shouldShowCoachMark, noteList: [
                { id: 0, component: React.createElement(StandardTabCoachMarkContent$3, { isRTL: isRTL }), isDefault: true },
                { id: 1, component: React.createElement(NowTabCoachMarkContent$3, { isRTL: isRTL }), isDefault: false },
            ], width: [1, null, 'auto'], notePosition: "bottom", nextLink: t('next'), closeLink: t('close'), backLink: t('back'), gotItLink: t('gotIt'), onHide: hideCoachMarkHandler, rtl: isRTL },
            React.createElement(Container$k, { "data-testid": "head-tabs", id: pageName + "-head-tabs", mb: [null, null, null, isSearchPage ? '50px' : null], mx: [3, 0, 0, 0] }, pageStructure.map(function (el, index) {
                var isActive = selectedIndex === index;
                return (React.createElement(React.Fragment, { key: el.id },
                    React.createElement(TabWrapper$3, { isActive: isActive, totalTabs: pageStructure.length, onClick: onClickHandler(index), id: pageName + "_head_tabs_" + el.id, "data-testid": "head_tabs_click" },
                        React.createElement(Flex, { alignItems: "center" },
                            React.createElement(IconWrapper$d, { as: "span", isActive: isActive, isRTL: isRTL, display: ['flex'], mr: ['5px', '5px', '0px', '0px'] },
                                el.pageType.toLowerCase() === TAB_CONST.homepage && (React.createElement(StandardTabIcon, { size: "custom", width: '24px', fill: COLORS$1.ANCHOR_BLUE })),
                                el.pageType.toLowerCase() === TAB_CONST.now && (React.createElement(NowTabIcon, { size: "custom", width: '24px', fill: COLORS$1.ANCHOR_BLUE }))),
                            React.createElement(Title$b, { as: "span", isActive: isActive }, el.title)),
                        React.createElement(ValueProposition$3, { componentsArray: el.components, className: "info-template-desktop", display: ['none!important', null, null, 'flex!important'] }))));
            }))),
        pageStructure[selectedIndex] && !hideProposition && (React.createElement(ValueProposition$3, { componentsArray: pageStructure[selectedIndex].components, className: "info-template-mobile", display: ['flex', null, 'none', 'none'], onClick: onClickDrawerOpener }))));
});

var ButtonStyle$1 = CustomStyled$1(Button$1)(templateObject_1$23 || (templateObject_1$23 = __makeTemplateObject(["\n  height: 40px;\n  text-transform: inherit;\n  margin: 4px 0;\n"], ["\n  height: 40px;\n  text-transform: inherit;\n  margin: 4px 0;\n"])));
var UserJourneyNoDelivery = (function (props) {
    var _a, _b, _c;
    var onHandleClick = props.onHandleClick, logSmartlookError = props.logSmartlookError;
    var t = useTranslation().t;
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    var _d = useSelector(function (_a) {
        var _b = _a.deliveryTime, deliveryTime = _b === void 0 ? {} : _b, _c = _a.pageStructure, pageStructure = _c === void 0 ? [] : _c, _d = _a.appConfig, appConfig = _d === void 0 ? {} : _d;
        return { deliveryTime: deliveryTime, pageStructure: pageStructure, appConfig: appConfig };
    }), deliveryTime = _d.deliveryTime, pageStructure = _d.pageStructure, appConfig = _d.appConfig;
    var isNonFoodV2Journey = useNonFoodV2Journey();
    var selectedIndex = pageStructure.findIndex(function (obj) { return obj.id === appConfig.selectedTabId; }) || 0;
    var deliverySlot = ((_a = pageStructure === null || pageStructure === void 0 ? void 0 : pageStructure[selectedIndex]) === null || _a === void 0 ? void 0 : _a.serviceType) === IServiceInfo$1.EXPRESS
        ? deliveryTime === null || deliveryTime === void 0 ? void 0 : deliveryTime.expressSlot : deliveryTime === null || deliveryTime === void 0 ? void 0 : deliveryTime.qcommSlot;
    var _e = getMessagesForBusyOrOfflineScreen$1(deliverySlot || {}), _f = _e.offlineTitle, offlineTitle = _f === void 0 ? '' : _f, _g = _e.offlineSubtitle, offlineSubtitle = _g === void 0 ? '' : _g, _h = _e.busyTitle, busyTitle = _h === void 0 ? '' : _h, _j = _e.busySubtitle, busySubtitle = _j === void 0 ? '' : _j, _k = _e.isBusyState, isBusyState = _k === void 0 ? false : _k;
    var isStandardAvailable = (_b = deliveryTime === null || deliveryTime === void 0 ? void 0 : deliveryTime.standardSlot) === null || _b === void 0 ? void 0 : _b.isAvailable;
    var isHideScheduledTabDisabled = useFeature('habcap.disable_scheduled_tab.enabled').on;
    var _l = (((_c = useFeature('common.remote_localization.config')) === null || _c === void 0 ? void 0 : _c.value) || {}).offline_other_tabs_text, offline_other_tabs_text = _l === void 0 ? '' : _l;
    var checkShowBtn = !isHideScheduledTabDisabled || isStandardAvailable;
    var subTitleText = t('offlineHrs.subtitle');
    var isOnlyNowWithUnavailability = false;
    var servicesUnavailable = false;
    if (isNonFoodV2Journey) {
        checkShowBtn = false;
        if (!(pageStructure === null || pageStructure === void 0 ? void 0 : pageStructure.length)) {
            servicesUnavailable = true;
            subTitleText = t('serviceUnavailable.subtitle');
        }
        else if (pageStructure.length !== 1) {
            isOnlyNowWithUnavailability = true;
            subTitleText = t('offlineScreen.subtitle');
        }
    }
    var showMessage = checkShowBtn || isOnlyNowWithUnavailability || servicesUnavailable;
    var standardTab = pageStructure && pageStructure.length ? pageStructure[0] : { title: t('offlineHrs.btnText') };
    var otherTabsText = offline_other_tabs_text === null || offline_other_tabs_text === void 0 ? void 0 : offline_other_tabs_text.replace('{{otherTabs}}', renderOtherTabsText$1(pageStructure, appConfig === null || appConfig === void 0 ? void 0 : appConfig.selectedTabId, t) || '');
    var pageType = (CookieUtils$1 === null || CookieUtils$1 === void 0 ? void 0 : getPageType$1()) === 'home' ? 'home' : 'search';
    var onHandleClickCTA = function () {
        GTMEventCall(GTMEvents$1.custom_event, {
            eventAction: GTMEventActions$1.shop_all_items_clicked,
            eventLabel: pageType + "_" + (isBusyState ? GTMBusyStateLabels$1.busy_state_cta : GTMBusyStateLabels$1.offline_state_cta),
            pageData: {
                screen_type: isBusyState ? GTMBusyStateLabels$1.busy_state : GTMBusyStateLabels$1.offline_state,
            },
        });
        if (onHandleClick)
            onHandleClick();
    };
    useMount(function () {
        if (logSmartlookError)
            logSmartlookError();
    });
    return (React.createElement(Box, { textAlign: "center", fontFamily: "Montserrat" },
        React.createElement(Box, null, servicesUnavailable ? React.createElement(MapOverlay, null) : isBusyState ? React.createElement(BusyHour, null) : React.createElement(NoDelivery, null)),
        React.createElement(Box, { sx: {
                fontSize: ['16px'],
                fontWeight: '700',
                lineHeight: ['20px'],
                margin: '12px 0 0 0',
                color: COLORS$1.BLACK,
            } }, isBusyState ? busyTitle : offlineTitle),
        React.createElement(Box, { sx: {
                fontSize: '14px',
                fontWeight: '700',
                lineHeight: '20px',
                margin: '12px 0',
                color: COLORS$1.BLACK,
            } }, isBusyState ? busySubtitle : offlineSubtitle),
        ((isNonFoodV2Journey && offline_other_tabs_text) || showMessage) && (React.createElement(React.Fragment, null,
            React.createElement(Box, { sx: {
                    fontSize: '14px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    margin: '12px auto',
                    color: COLORS$1.BLACK,
                    width: '60%',
                } }, otherTabsText || subTitleText),
            !isNonFoodV2Journey && checkShowBtn && (React.createElement(ButtonStyle$1, { variant: "tabStyle", fontWeight: "700", fontSize: "14px", lineHeight: "20px", onClick: onHandleClickCTA },
                React.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
                    React.createElement(StandardTabIcon, { size: "M", fill: COLORS$1.BLUE }),
                    React.createElement(Box, { sx: {
                            fontSize: '14px',
                            fonstWeight: '700',
                            lineHeight: '20px',
                            marginLeft: '8px',
                        } }, standardTab.title))))))));
});
var templateObject_1$23;

var CollectionCardWrapper$1 = customStyled(Box)(templateObject_1$24 || (templateObject_1$24 = __makeTemplateObject(["\n    min-width: 296px;\n    max-width: 296px;\n    min-height: 320px;\n    padding-right: 20px!important;    \n\tcolor: ", ";\n    font-family: ", ";\n"], ["\n    min-width: 296px;\n    max-width: 296px;\n    min-height: 320px;\n    padding-right: 20px!important;    \n\tcolor: ", ";\n    font-family: ", ";\n"])), COLORS$1.BLACK, function (props) { return props.theme.fonts.montserrat; });
var ContentWrapper$5 = customStyled(Box)(templateObject_2$1I || (templateObject_2$1I = __makeTemplateObject(["\n    background: ", ";\n    padding: 16px!important;\n    border-radius: 12px;\n    text-decoration: none;\n    text-align:left;\n    box-shadow: 0 0 16px -12px ", ";\n"], ["\n    background: ", ";\n    padding: 16px!important;\n    border-radius: 12px;\n    text-decoration: none;\n    text-align:left;\n    box-shadow: 0 0 16px -12px ", ";\n"])), COLORS$1.WHITE, COLORS$1.BLACK);
var Heading$6 = customStyled(Box)(templateObject_3$1n || (templateObject_3$1n = __makeTemplateObject(["\n    font-size: ", "px;\n    text-decoration: none;\n    font-weight: ", ";\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    direction: ltr;\n"], ["\n    font-size: ", "px;\n    text-decoration: none;\n    font-weight: ", ";\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    direction: ltr;\n"])), function (props) { return props.theme.fontSizes[3]; }, function (props) { return props.theme.fontWeights[6]; });
var ItemContent$1 = customStyled(Box)(templateObject_4$1a || (templateObject_4$1a = __makeTemplateObject(["\n    width: 120px;\n    font-size: 12px;\n    line-height: 16px;\n    text-align: center;\n    display: inline-block;\n    margin-bottom: 16px;\n\n    img{\n        width: 85%;\n        margin: 0 auto;\n    }\n"], ["\n    width: 120px;\n    font-size: 12px;\n    line-height: 16px;\n    text-align: center;\n    display: inline-block;\n    margin-bottom: 16px;\n\n    img{\n        width: 85%;\n        margin: 0 auto;\n    }\n"])));
var LinkWrapper$4 = customStyled('a')(templateObject_5$V || (templateObject_5$V = __makeTemplateObject(["\t\n    text-decoration: none;\n\tcolor:inherit;\n    :active, :focus, :visited{\n        outline: none !important;\n        text-decoration: none;\n\t}\n"], ["\t\n    text-decoration: none;\n\tcolor:inherit;\n    :active, :focus, :visited{\n        outline: none !important;\n        text-decoration: none;\n\t}\n"])));
var ViewContentWrapper$1 = customStyled(Box)(templateObject_6$J || (templateObject_6$J = __makeTemplateObject(["\n    color: ", ";\n    font-weight: ", ";\n    text-decoration: none;\n    align-items: center;\n    text-align: left;\n\n    svg{\n        margin-left: 5px;\n        top: 3px;\n        position: relative;\n        transform: rotate(-90deg);\n    }\n"], ["\n    color: ", ";\n    font-weight: ", ";\n    text-decoration: none;\n    align-items: center;\n    text-align: left;\n\n    svg{\n        margin-left: 5px;\n        top: 3px;\n        position: relative;\n        transform: rotate(-90deg);\n    }\n"])), COLORS$1.ANCHOR_BLUE, function (props) { return props.theme.fontWeights[6]; });
var NameWrapper$1 = customStyled(Box)(templateObject_7$F || (templateObject_7$F = __makeTemplateObject(["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-align: left;\n"], ["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-align: left;\n"])));
var PriceText$1 = customStyled(NameWrapper$1)(templateObject_8$F || (templateObject_8$F = __makeTemplateObject(["\n    text-align: center;\n    font-weight: ", ";\n    margin-top: 4px;\n    font-size:  ", "px;\n"], ["\n    text-align: center;\n    font-weight: ", ";\n    margin-top: 4px;\n    font-size:  ", "px;\n"])), function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.fontSizes[1]; });
var PriceSecondary$1 = customStyled(NameWrapper$1)(templateObject_9$B || (templateObject_9$B = __makeTemplateObject(["\n    font-weight: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-decoration: line-through;\n    text-align: center;\n    visibility: ", "\n"], ["\n    font-weight: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-decoration: line-through;\n    text-align: center;\n    visibility: ", "\n"])), function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.fontSizes[0]; }, COLORS$1.GRAY_500, function (props) { return (props.isDiscountAvailable ? '' : 'hidden'); });
var templateObject_1$24, templateObject_2$1I, templateObject_3$1n, templateObject_4$1a, templateObject_5$V, templateObject_6$J, templateObject_7$F, templateObject_8$F, templateObject_9$B;

var CollectionCard = function (_a) {
    var contents = _a.contents, heading = _a.heading, redirectionUrl = _a.redirectionUrl, key = _a.key, redirectionText = _a.redirectionText;
    return (React.createElement(CollectionCardWrapper$1, { className: "collection-card", key: key },
        React.createElement(ContentWrapper$5, null,
            React.createElement(Heading$6, { mb: 3 }, heading),
            contents.map(function (item, index) {
                var _a, _b;
                var _c = item.discount, discountPrice = _c.price, discountMinBuyingValue = _c.minBuyingValue, minBuyingValue = item.minBuyingValue, originalPrice = item.originalPrice, currency = item.currency;
                var isDiscountAvailable = item.discount && discountPrice > 0;
                var itemOriginalPrice = prettifyPrice$1(parseFloat(minBuyingValue || originalPrice));
                return (React.createElement(ItemContent$1, { className: item.name + "_" + index, mb: index < 2 ? 4 : 0, key: "" + item.name },
                    React.createElement(LinkWrapper$4, { href: item.url, title: decodeHtml$1(item.name), "data-testid": "content_name" },
                        React.createElement(Image, { url: ((_a = item === null || item === void 0 ? void 0 : item.image) === null || _a === void 0 ? void 0 : _a.href) || '', useAltFallback: true, name: ((_b = item === null || item === void 0 ? void 0 : item.image) === null || _b === void 0 ? void 0 : _b.altText) || '' }),
                        React.createElement(NameWrapper$1, { as: "p", my: 2, display: "none" }, item.name)),
                    React.createElement(PriceText$1, { "data-testid": "price_text" },
                        currency + ' ',
                        isDiscountAvailable
                            ? prettifyPrice$1(parseFloat(discountMinBuyingValue || discountPrice))
                            : itemOriginalPrice),
                    React.createElement(PriceSecondary$1, { isDiscountAvailable: isDiscountAvailable },
                        currency,
                        " ",
                        itemOriginalPrice)));
            }),
            React.createElement(ViewContentWrapper$1, { "data-testid": "view_content" },
                React.createElement(LinkWrapper$4, { href: redirectionUrl, dangerouslySetInnerHTML: { __html: redirectionText } })))));
};

var CollectionCarouselLoader = function () {
    var arr = [1, 2, 3, 4, 5, 6];
    return (React.createElement(Flex, null,
        React.createElement(Carousel, null, arr.map(function (item) { return (React.createElement(Box, { variant: "skeleton", key: item, height: "320px", minWidth: "316px", mr: "20px", flexShrink: ['0', '1'] })); }))));
};

var CollectionCarousel = function (_a) {
    var componentPosition = _a.componentPosition, baseParams = _a.baseParams;
    var _b = __read(useState(true), 2), isLoading = _b[0], setIsLoading = _b[1];
    var _c = __read(useState([]), 2), placementsArr = _c[0], setPlacementsArr = _c[1];
    var isDesktop = useBreakpoints().isDesktop;
    var _d = baseParams || {}, _e = _d.placements, placements = _e === void 0 ? '' : _e, _f = _d.keyword, keyword = _f === void 0 ? '*' : _f, _g = _d.redirectionUrlArr, redirectionUrlArr = _g === void 0 ? [] : _g, _h = _d.redirectionTextArr, redirectionTextArr = _h === void 0 ? [] : _h;
    useEffect(function () {
        try {
            if (!placements)
                return;
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var resp;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductServices$3.getRelevance({ keyword: keyword, placements: placements })];
                        case 1:
                            resp = _a.sent();
                            if (resp.length > 0) {
                                setPlacementsArr(resp);
                                setIsLoading(false);
                            }
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
        catch (e) {
            console.error('Collection Carousel Error: ', e);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(Box, null, isLoading ? (React.createElement(CollectionCarouselLoader, null)) : (React.createElement(Carousel, { arrows: isDesktop ? 'regular' : '', rtl: isRTL$1() }, placementsArr.map(function (_a, index) {
        var _b = _a.recommendedProducts, recommendedProducts = _b === void 0 ? [] : _b, strategyMessage = _a.strategyMessage;
        if (recommendedProducts.length > 3) {
            return (React.createElement(CollectionCard, { contents: recommendedProducts.slice(0, 4), heading: strategyMessage || '', redirectionUrl: redirectionUrlArr[index] || '', redirectionText: redirectionTextArr[index] || '', key: componentPosition + "_" + (index + 1) }));
        }
        return null;
    })))));
};

var TitleContainer$1 = customStyled(Box)(templateObject_1$25 || (templateObject_1$25 = __makeTemplateObject(["\n    margin-bottom: 12px;\n    font-family: ", ";\n    font-size: ", "px;\n    font-weight: 700;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    white-space: nowrap;\n    color: ", ";\n\n    @media (min-width: ", ") {\n        font-size: ", "px;\n    }\n"], ["\n    margin-bottom: 12px;\n    font-family: ", ";\n    font-size: ", "px;\n    font-weight: 700;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    white-space: nowrap;\n    color: ", ";\n\n    @media (min-width: ", ") {\n        font-size: ", "px;\n    }\n"])), function (props) { return props.theme.fonts.montserrat; }, function (props) { return props.theme.fontSizes[6]; }, function (props) { return props.theme.colors.black; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.theme.fontSizes[6]; });
var LinkWrapper$5 = customStyled('a')(templateObject_2$1J || (templateObject_2$1J = __makeTemplateObject(["\t\n    text-decoration: none;\n    color: ", ";\n    font-size: ", "px;\n    font-weight: 700;\n    line-height: 20px;\n    :active, :focus, :visited{\n        outline: none !important;\n        text-decoration: none;\n\t}\n"], ["\t\n    text-decoration: none;\n    color: ", ";\n    font-size: ", "px;\n    font-weight: 700;\n    line-height: 20px;\n    :active, :focus, :visited{\n        outline: none !important;\n        text-decoration: none;\n\t}\n"])), function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.fontSizes[3]; });
var SpanText$1 = customStyled('span')(templateObject_3$1o || (templateObject_3$1o = __makeTemplateObject(["\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"], ["\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"])));
var Header$6 = customStyled(Flex)(templateObject_4$1b || (templateObject_4$1b = __makeTemplateObject(["\n  align-items: center;\n  gap: 8px;\n"], ["\n  align-items: center;\n  gap: 8px;\n"])));
var templateObject_1$25, templateObject_2$1J, templateObject_3$1o, templateObject_4$1b;

var useFsFlag$1 = require('@flagship.io/react-sdk').useFsFlag;
var Title$c = function (_a) {
    var _b, _c;
    var _d = _a.type, type = _d === void 0 ? '' : _d, header = _a.header, _e = _a.viewAll, viewAll = _e === void 0 ? '' : _e, _f = _a.viewAllCta, viewAllCta = _f === void 0 ? '' : _f, _g = _a.titleIcon, titleIcon = _g === void 0 ? '' : _g;
    var _h = ((_b = useFeature('home.segmentation.experiment')) === null || _b === void 0 ? void 0 : _b.value) || {}, _j = _h.abTastyKey, abTastyKey = _j === void 0 ? '' : _j, _k = _h.value, value = _k === void 0 ? false : _k;
    var shouldShowViewAllCTA = (_c = useFsFlag$1(abTastyKey, value)) === null || _c === void 0 ? void 0 : _c.getValue();
    var GTMEventCall = useAnalytic$1().GTMEventCall;
    var GTMEventTrack = function () {
        GTMEventCall(GTMEvents$1.custom_event, {
            eventAction: GTMEventActions$1.see_all_click,
            eventLabel: type + "|" + header,
            ga4: true,
        });
    };
    return header ? (React.createElement(TitleContainer$1, null,
        React.createElement(Header$6, null,
            shouldShowViewAllCTA && titleIcon && React.createElement(Image, { url: titleIcon, name: "header-icon", width: 32 }),
            React.createElement(SpanText$1, null, header)),
        shouldShowViewAllCTA && viewAllCta && (React.createElement(LinkWrapper$5, { href: viewAllCta, onClick: GTMEventTrack }, viewAll)))) : null;
};

var RichCategoryCardWrapper$1 = customStyled('a')(templateObject_1$26 || (templateObject_1$26 = __makeTemplateObject(["\n    min-width: 260px;\n    max-width: 260px;\n    height: 392px;\n    position: relative;\n    padding-right: 20px;\n    display: inline-block;\n    border-radius: 12px;\n    color: ", ";\n    text-decoration: none;\n\n    :active, :focus, :visited{\n        outline: none!important;\n        text-decoration: none;\n    }\n\n    ", "\n    \n"], ["\n    min-width: 260px;\n    max-width: 260px;\n    height: 392px;\n    position: relative;\n    padding-right: 20px;\n    display: inline-block;\n    border-radius: 12px;\n    color: ", ";\n    text-decoration: none;\n\n    :active, :focus, :visited{\n        outline: none!important;\n        text-decoration: none;\n    }\n\n    ",
    "\n    \n"])), function (props) { return props.theme.colors.black; }, function (props) {
    if (props.rtl) {
        return ":first-of-type{\n                min-width: 240px;\n                max-width: 240px;\n                padding-right: 0px;\n            }";
    }
    return ":last-of-type{\n            min-width: 240px;\n            max-width: 240px;\n            padding-right: 0px;\n        }";
});
var ImageWrapper$7 = customStyled(Box)(templateObject_2$1K || (templateObject_2$1K = __makeTemplateObject(["\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100% 100%;\n    width: 100%;\n    height: 100%;\n    border-radius: 12px;\n    box-shadow: 0 0 16px -12px #000;\n"], ["\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100% 100%;\n    width: 100%;\n    height: 100%;\n    border-radius: 12px;\n    box-shadow: 0 0 16px -12px #000;\n"])), function (props) { return props.bgImage; });
var TextContentWrapper$1 = customStyled(Box)(templateObject_3$1p || (templateObject_3$1p = __makeTemplateObject(["\n    padding: 20px 16px 0px;\n\n    & > * {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-align: left;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        line-height: 1.2;\n        max-height: 38px;\n        direction: ltr;\n    }\n\n    h3{\n        font-size: ", "px;\n        font-weight: ", ";\n        color: ", ";\n        margin-bottom: 4px;\n    }\n\n    p{\n        font-size: ", "px;\n    }\n"], ["\n    padding: 20px 16px 0px;\n\n    & > * {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-align: left;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        line-height: 1.2;\n        max-height: 38px;\n        direction: ltr;\n    }\n\n    h3{\n        font-size: ", "px;\n        font-weight: ", ";\n        color: ", ";\n        margin-bottom: 4px;\n    }\n\n    p{\n        font-size: ", "px;\n    }\n"])), function (props) { return props.theme.fontSizes[3]; }, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.color || props.theme.colors.black; }, function (props) { return props.theme.fontSizes[2]; });
var templateObject_1$26, templateObject_2$1K, templateObject_3$1p;

var RichCategoryCard = function (_a) {
    var item = _a.item, onClick = _a.onClick, key = _a.key, rtl = _a.rtl, onView = _a.onView;
    var _b = item.title, title = _b === void 0 ? '' : _b, _c = item.subtitle, subtitle = _c === void 0 ? '' : _c, _d = item.mediaWeb, mediaWeb = _d === void 0 ? '' : _d, _e = item.ctaUrlWeb, ctaUrlWeb = _e === void 0 ? '' : _e, fontColor = item.fontColor;
    var _f = __read(useAppConfig$1(), 1), _g = _f[0], language = _g.language, storeId = _g.storeId;
    var _h = useInView({
        threshold: 0,
    }), ref = _h.ref, inView = _h.inView;
    useEffect(function () {
        if (inView && onView) {
            trackInViewCarousels({ component: item, onView: onView });
        }
    }, [item, inView, onView]);
    return (React.createElement(RichCategoryCardWrapper$1, { ref: ref, href: "/" + storeId + "/" + language + ctaUrlWeb, key: key, className: key, rtl: rtl, onClick: function (e) { return onClick && onClick(e, Number(key) + 1, item); } },
        React.createElement(ImageWrapper$7, { bgImage: mediaWeb },
            React.createElement(TextContentWrapper$1, { color: fontColor },
                React.createElement(Box, { as: "h3", title: title }, title),
                React.createElement(Box, { as: "p", title: subtitle }, subtitle)))));
};

var RichCategoryCardCarousel = function (_a) {
    var componentPosition = _a.componentPosition, title = _a.title, typeOfBanner = _a.typeOfBanner, titleIcon = _a.titleIcon, viewAll = _a.viewAll, viewAllCta = _a.viewAllCta, rtl = _a.rtl, _b = _a.data, data = _b === void 0 ? [] : _b, onClick = _a.onClick, onView = _a.onView;
    var isDesktop = useBreakpoints().isDesktop;
    return (React.createElement(Box, { as: "section", id: "rich-card-carousel-" + componentPosition, mt: 5 },
        title && (React.createElement(Title$c, { header: title, type: typeOfBanner, viewAll: viewAll, viewAllCta: viewAllCta, titleIcon: titleIcon })),
        data.length > 1 && (React.createElement(Carousel, { arrows: isDesktop ? "regular" : '', rtl: rtl }, data.map(function (item, index) {
            return (React.createElement(RichCategoryCard, { item: item, key: item.title + "_" + index, onClick: onClick, rtl: rtl, onView: onView }));
        })))));
};

var Container$l = styled(Box)(templateObject_1$27 || (templateObject_1$27 = __makeTemplateObject(["\n  position: relative;\n  video {\n    width: 100%;\n    height: 193px;\n    background: ", ";\n    @media (min-width: ", ") {\n      height: 692px;\n    }\n  }\n"], ["\n  position: relative;\n  video {\n    width: 100%;\n    height: 193px;\n    background: ", ";\n    @media (min-width: ", ") {\n      height: 692px;\n    }\n  }\n"])), COLORS$1.VIDEO_BG_COLOR, function (props) { return props.theme.breakpoints[1]; });
var PlayButtons$1 = styled(Box)(templateObject_2$1L || (templateObject_2$1L = __makeTemplateObject(["\n  height: 128px;\n  left: 50%;\n  margin: -64px 0 0 -64px;\n  position: absolute;\n  top: 50%;\n  width: 128px;\n  z-index: 1;\n"], ["\n  height: 128px;\n  left: 50%;\n  margin: -64px 0 0 -64px;\n  position: absolute;\n  top: 50%;\n  width: 128px;\n  z-index: 1;\n"])));
var templateObject_1$27, templateObject_2$1L;

var VideoComponent = function (_a) {
    var _b = _a.details, details = _b === void 0 ? [] : _b;
    var videoRef = useRef(null);
    var _c = __read(useState(true), 2), showPlayButton = _c[0], setShowPlayButton = _c[1];
    var handlePlayButton = function () {
        videoRef.current.play();
        setShowPlayButton(false);
    };
    return (React.createElement(Container$l, { "data-testid": "div-container" },
        React.createElement("video", { ref: videoRef, controls: true, poster: details[0].media, onClick: function () { return setShowPlayButton(false); } },
            React.createElement("source", { src: details[0].media_video, type: "video/mp4" })),
        showPlayButton && (React.createElement(PlayButtons$1, { onClick: handlePlayButton, "data-testid": "play-btn" },
            React.createElement(PlayIcon, null)))));
};

var useDeliveryHours = function () {
    var deliveryTimeState = useSelector(function (_a) {
        var _b = _a.deliveryTime, deliveryTime = _b === void 0 ? {} : _b;
        return deliveryTime;
    });
    var result = {};
    slots$1.forEach(function (_a) {
        var key = _a.key, busyHourKey = _a.busyHourKey, offlineHourKey = _a.offlineHourKey, nextSlotKey = _a.nextSlotKey, disclaimerKey = _a.disclaimerKey, unavailableHourKey = _a.unavailableHourKey, available = _a.available, nextSlot = _a.nextSlot;
        var slotData = deliveryTimeState[key];
        var isBusyHour = getBusyHourStatus$1(slotData);
        var isOfflineHour = getOfflineHourStatus$1(slotData);
        result[busyHourKey] = isBusyHour;
        result[offlineHourKey] = isOfflineHour;
        result[nextSlotKey] = getNextAvailableSlot$1(slotData, isOfflineHour);
        result[disclaimerKey] = getBusyHourDisclaimer$1(slotData, isBusyHour);
        result[unavailableHourKey] = isBusyHour || isOfflineHour;
        result[available] = !isBusyHour && !isOfflineHour;
        result[nextSlot] = !isBusyHour && !isOfflineHour;
    });
    return result;
};

var useCriteoAdEnabled = function () {
    var _a;
    return ((_a = useFeature(GROWTHBOOK_FLAGS$1.adtechCriteo)) === null || _a === void 0 ? void 0 : _a.on) || false;
};
var useCriteo2ndPhaseAdEnabled = function () {
    var _a;
    return ((_a = useFeature(GROWTHBOOK_FLAGS$1.adtechCriteo2ndPhase)) === null || _a === void 0 ? void 0 : _a.on) || false;
};

export { AdBanner$3 as AdBanner, AddAddress$3 as AddAddress, AddAddressForm$3 as AddAddressForm, index$6 as AddToList, AddressList$7 as AddressList, AppConfigService$3 as AppConfigService, MQ$1 as BREAKPOINTS, BundleText$1 as BundleText, COLORS$1 as COLORS, CartElements$1 as CartElements, CollectionCarousel, Title$c as ComponentTitle, constants$1 as Constants, CookieResponsiveDimensions, CookieUtils$1 as CookieUtils, CriteoBanner, CustomSmartBanner, E_SOLD_BY_MESSAGE_TYPE$2 as E_SOLD_BY_MESSAGE_TYPE, ErrorPage, FBCModal, FLAGSHIP_KEYS$1 as FLAGSHIP_KEYS, FLAT_KEY$1 as FLAT_KEY, FLOOR_KEY$1 as FLOOR_KEY, Fbt, index$5 as Footer, GROWTHBOOK_FLAGS$1 as GROWTHBOOK_FLAGS, GTMBusyStateLabels$1 as GTMBusyStateLabels, GTMEventActions$1 as GTMEventActions, GTMEventCategories$1 as GTMEventCategories, GTMEvents$1 as GTMEvents, GTMNowJourneyEventTypes$1 as GTMNowJourneyEventTypes, GTMNowJourneyLabels$1 as GTMNowJourneyLabels, growthbook_util$1 as GrowthBookUtils, headTab_actions$1 as HeadTabActions, HeadTabs$1 as HeadTabs, Header$5 as HeaderNewJourney, helpers_util$1 as HelpersUtil, IServiceInfo$1 as IServiceInfo, image_util$1 as ImageUtil, LOGIN_PAGE$2 as LOGIN_PAGE, Marquee, MarqueeTextWrapper$1 as MarqueeTextWrapper, miniCart_action$1 as MiniCartActions, newC4Journey_util$1 as NewC4JourneyUtils, NowJourneyIcon$1 as NowJourneyIcon, PageInfoText, PaginationControl, price_util$1 as PriceUtil, ProductCard$3 as ProductCard, ProductCardCarousel$3 as ProductCardCarousel, ProductCardCarouselLoader$1 as ProductCardCarouselLoader, ProductCardLoader$1 as ProductCardLoader, ProductList, ProductServices$3 as ProductServices, ProductTransformer$1 as ProductTransformer, ProductTransformerV2$1 as ProductTransformerV2, PromotionEvents$1 as PromotionEvents, ProviderWrapper, QuantitySelector$1 as QuantitySelector, quantity_util$1 as QuantityUtil, QuickNavigation, RelevantProductCarousel$3 as RelevantCarousel, RichCategoryCardCarousel, SIZES$2 as SIZES, SPACINGS$1 as SPACING, SavedText$1 as SavedText, ShipmentBundle, SoldByComponent, index$2 as SponsoredCarousel, TYPOGRAPHY$1 as TYPOGRAPHY, index as Types, url_util$1 as UrlUtil, UserConsent$1 as UserConsentBags, UserConsentLink as UserConsentBagsLink, UserDataHook, UserJourneyNoDelivery, VerifyPassword$1 as VerifyOTP, VerifySMS, VideoComponent, WHITELISTED_DEFAULT_VALUE, algoliaTracking$1 as algoliaTracking, brazeLogChangeUser, brazeLogCustomEvent$1 as brazeLogCustomEvent, brazeRegisterUser, brazeSetCustomUserAttribute$1 as brazeSetCustomUserAttribute, configureStore, convertDeltaQtyInoUnit$1 as convertDeltaQtyInoUnit, customStorage_util$1 as customStorageUtil, debounce$1 as debounce, decodeHtml$1 as decodeHtml, fetchAreas$1 as fetchAreas, fetchUserAddresses$1 as fetchUserAddresses, fetchUserCountryConfig$1 as fetchUserCountryConfig, formatPriceForScalablePrducts$1 as formatPriceForScalablePrducts, getCommonGtmData$1 as getCommonGtmData, getJourneySelectionParams$1 as getJourneySelectionParams, getStore$1 as getStore, handleCriteoBannersResponse, handleCriteoCarouselResponse, i18next as i18n, init$1 as init, initApp$1 as initApp, initGTM, initialAppState, isUserShareMember$1 as isUserShareMember, logoutEvent, pushFlagsDataInGTM, reducers$1 as reducers, replaceApigeeBaseUrl$1 as replaceApigeeBaseUrl, resetAdtechReducer, setAppLanguageAndCountry$1 as setAppLanguageAndCountry, setAreaCode$1 as setAreaCode, setBrazeInitialized, setCountryConfig, setCriteoBanners, setFlagShip, setGrowthBook, setHeadersDetails, setLanguage$1 as setLanguage, setLocationCXDetail$1 as setLocationCXDetail, setPageIntent, setPageName, setSelectedTabId, smartlookErrorLabels, toggleAddressList, trackInViewCarousels, updateGeoArea$1 as updateGeoArea, updateSelectedArea, useAnalytic$1 as useAnalytic, useCriteo2ndPhaseAdEnabled, useCriteoAdEnabled, useDeliveryHours, useFbcFeature$1 as useFbcFeature, useMultiCarousels, useNonFoodV2Journey, useOneTrustUrl, useProductCardHandlers$1 as useProductCardHandlers, useRelevantCarousel$1 as useRelevantCarousel, userSetAddressesSuccess$1 as userSetAddressesSuccess, userSetSelectedAddress$1 as userSetSelectedAddress, withLocalData, withRemoteData, withSsrLocaleData };
